/*! instantsearch.js 1.11.2 | © Algolia Inc. and other contributors; Licensed MIT | github.com/algolia/instantsearch.js */ (function webpackUniversalModuleDefinition(
    root,
    factory
) {
    if (typeof exports === "object" && typeof module === "object")
        module.exports = factory();
    else if (typeof define === "function" && define.amd) define([], factory);
    else if (typeof exports === "object") exports["instantsearch"] = factory();
    else root["instantsearch"] = factory();
})(this, function () {
    return /******/ (function (modules) {
        // webpackBootstrap
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/
        /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId])
                /******/ return installedModules[moduleId].exports;
            /******/
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = (installedModules[moduleId] = {
                /******/ exports: {},
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/
            });
            /******/
            /******/ // Execute the module function
            /******/ modules[moduleId].call(
                module.exports,
                module,
                module.exports,
                __webpack_require__
            );
            /******/
            /******/ // Flag the module as loaded
            /******/ module.loaded = true;
            /******/
            /******/ // Return the exports of the module
            /******/ return module.exports;
            /******/
        }
        /******/
        /******/
        /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/
        /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/
        /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(0);
        /******/
    })(
        /************************************************************************/
        /******/ [
            /* 0 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var _main = __webpack_require__(1);

                var _main2 = _interopRequireDefault(_main);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                module.exports = _main2.default; // we need to export using commonjs for ease of usage in all
                // JavaScript environments

                /* eslint-disable import/no-commonjs */

                /***/
            },
            /* 1 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                __webpack_require__(2);

                __webpack_require__(3);

                var _toFactory = __webpack_require__(4);

                var _toFactory2 = _interopRequireDefault(_toFactory);

                var _InstantSearch = __webpack_require__(5);

                var _InstantSearch2 = _interopRequireDefault(_InstantSearch);

                var _algoliasearchHelper = __webpack_require__(38);

                var _algoliasearchHelper2 =
                    _interopRequireDefault(_algoliasearchHelper);

                var _clearAll = __webpack_require__(347);

                var _clearAll2 = _interopRequireDefault(_clearAll);

                var _currentRefinedValues = __webpack_require__(527);

                var _currentRefinedValues2 = _interopRequireDefault(
                    _currentRefinedValues
                );

                var _hierarchicalMenu = __webpack_require__(531);

                var _hierarchicalMenu2 =
                    _interopRequireDefault(_hierarchicalMenu);

                var _hits = __webpack_require__(536);

                var _hits2 = _interopRequireDefault(_hits);

                var _hitsPerPageSelector = __webpack_require__(541);

                var _hitsPerPageSelector2 =
                    _interopRequireDefault(_hitsPerPageSelector);

                var _infiniteHits = __webpack_require__(545);

                var _infiniteHits2 = _interopRequireDefault(_infiniteHits);

                var _menu = __webpack_require__(548);

                var _menu2 = _interopRequireDefault(_menu);

                var _refinementList = __webpack_require__(552);

                var _refinementList2 = _interopRequireDefault(_refinementList);

                var _numericRefinementList = __webpack_require__(554);

                var _numericRefinementList2 = _interopRequireDefault(
                    _numericRefinementList
                );

                var _numericSelector = __webpack_require__(556);

                var _numericSelector2 =
                    _interopRequireDefault(_numericSelector);

                var _pagination = __webpack_require__(557);

                var _pagination2 = _interopRequireDefault(_pagination);

                var _priceRanges = __webpack_require__(566);

                var _priceRanges2 = _interopRequireDefault(_priceRanges);

                var _searchBox = __webpack_require__(571);

                var _searchBox2 = _interopRequireDefault(_searchBox);

                var _rangeSlider = __webpack_require__(573);

                var _rangeSlider2 = _interopRequireDefault(_rangeSlider);

                var _sortBySelector = __webpack_require__(577);

                var _sortBySelector2 = _interopRequireDefault(_sortBySelector);

                var _starRating = __webpack_require__(578);

                var _starRating2 = _interopRequireDefault(_starRating);

                var _stats = __webpack_require__(581);

                var _stats2 = _interopRequireDefault(_stats);

                var _toggle = __webpack_require__(584);

                var _toggle2 = _interopRequireDefault(_toggle);

                var _analytics = __webpack_require__(588);

                var _analytics2 = _interopRequireDefault(_analytics);

                var _version = __webpack_require__(344);

                var _version2 = _interopRequireDefault(_version);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                // required for IE <= 10 since move to babel6
                var instantsearch = (0, _toFactory2.default)(
                    _InstantSearch2.default
                ); // required for browsers not supporting Object.freeze (helper requirement)

                instantsearch.widgets = {
                    analytics: _analytics2.default,
                    clearAll: _clearAll2.default,
                    currentRefinedValues: _currentRefinedValues2.default,
                    hierarchicalMenu: _hierarchicalMenu2.default,
                    hits: _hits2.default,
                    hitsPerPageSelector: _hitsPerPageSelector2.default,
                    infiniteHits: _infiniteHits2.default,
                    menu: _menu2.default,
                    refinementList: _refinementList2.default,
                    numericRefinementList: _numericRefinementList2.default,
                    numericSelector: _numericSelector2.default,
                    pagination: _pagination2.default,
                    priceRanges: _priceRanges2.default,
                    searchBox: _searchBox2.default,
                    rangeSlider: _rangeSlider2.default,
                    sortBySelector: _sortBySelector2.default,
                    starRating: _starRating2.default,
                    stats: _stats2.default,
                    toggle: _toggle2.default,
                };
                instantsearch.version = _version2.default;
                instantsearch.createQueryString =
                    _algoliasearchHelper2.default.url.getQueryStringFromState;

                exports.default = instantsearch;

                /***/
            },
            /* 2 */
            /***/ function (module, exports) {
                "use strict";

                // https://github.com/es-shims/es5-shim/blob/bf48788c724f255275a801a371c4a3adc304b34c/es5-sham.js#L473
                // Object.freeze is used in various places in our code and is not polyfilled by
                // polyfill.io (because not doable): https://github.com/Financial-Times/polyfill-service/issues/232
                // So we "sham" it, which means that the API is here but it just returns the object.
                if (!Object.freeze) {
                    Object.freeze = function freeze(object) {
                        if (Object(object) !== object) {
                            throw new TypeError(
                                "Object.freeze can only be called on Objects."
                            );
                        }
                        // this is misleading and breaks feature-detection, but
                        // allows "securable" code to "gracefully" degrade to working
                        // but insecure code.
                        return object;
                    };
                }

                /***/
            },
            /* 3 */
            /***/ function (module, exports) {
                "use strict";

                /* eslint-disable */

                // FIX IE <= 10 babel6:
                // - https://phabricator.babeljs.io/T3041
                // - https://phabricator.babeljs.io/T3041#70671
                var testObject = {};

                if (!(Object.setPrototypeOf || testObject.__proto__)) {
                    (function () {
                        var nativeGetPrototypeOf = Object.getPrototypeOf;

                        Object.getPrototypeOf = function (object) {
                            if (object.__proto__) {
                                return object.__proto__;
                            } else {
                                return nativeGetPrototypeOf.call(
                                    Object,
                                    object
                                );
                            }
                        };
                    })();
                }

                /***/
            },
            /* 4 */
            /***/ function (module, exports) {
                "use strict";

                var _bind = Function.prototype.bind;
                function toFactory(Class) {
                    var Factory = function Factory() {
                        for (
                            var _len = arguments.length,
                                args = Array(_len),
                                _key = 0;
                            _key < _len;
                            _key++
                        ) {
                            args[_key] = arguments[_key];
                        }

                        return new (_bind.apply(Class, [null].concat(args)))();
                    };
                    Factory.__proto__ = Class;
                    Factory.prototype = Class.prototype;
                    return Factory;
                }

                module.exports = toFactory;

                /***/
            },
            /* 5 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _algoliasearchLite = __webpack_require__(6);

                var _algoliasearchLite2 =
                    _interopRequireDefault(_algoliasearchLite);

                var _algoliasearchHelper = __webpack_require__(38);

                var _algoliasearchHelper2 =
                    _interopRequireDefault(_algoliasearchHelper);

                var _forEach = __webpack_require__(129);

                var _forEach2 = _interopRequireDefault(_forEach);

                var _mergeWith = __webpack_require__(338);

                var _mergeWith2 = _interopRequireDefault(_mergeWith);

                var _union = __webpack_require__(339);

                var _union2 = _interopRequireDefault(_union);

                var _clone = __webpack_require__(342);

                var _clone2 = _interopRequireDefault(_clone);

                var _isPlainObject = __webpack_require__(225);

                var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

                var _events = __webpack_require__(320);

                var _urlSync = __webpack_require__(343);

                var _urlSync2 = _interopRequireDefault(_urlSync);

                var _version = __webpack_require__(344);

                var _version2 = _interopRequireDefault(_version);

                var _createHelpers = __webpack_require__(346);

                var _createHelpers2 = _interopRequireDefault(_createHelpers);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                } // we use the fullpath to the lite build to solve a meteor.js issue:
                // https://github.com/algolia/instantsearch.js/issues/1024#issuecomment-221618284

                function defaultCreateURL() {
                    return "#";
                }
                var defaultCreateAlgoliaClient =
                    function defaultCreateAlgoliaClient(
                        defaultAlgoliasearch,
                        appId,
                        apiKey
                    ) {
                        return defaultAlgoliasearch(appId, apiKey);
                    };

                /**
                 * @function instantsearch
                 * @param  {string} options.appId The Algolia application ID
                 * @param  {string} options.apiKey The Algolia search-only API key
                 * @param  {string} options.indexName The name of the main index
                 * @param  {string} [options.numberLocale] The locale used to display numbers. This will be passed
                 * to Number.prototype.toLocaleString()
                 * @param  {function} [options.searchFunction] A hook that will be called each time a search needs to be done, with the
                 * helper as a parameter. It's your responsibility to call helper.search(). This option allows you to avoid doing
                 * searches at page load for example.
                 * @param   {function} [options.createAlgoliaClient] Allows you to provide your own algolia client instead of
                 * the one instantiated internally by instantsearch.js. Useful in situations where you need
                 * to setup complex options on the client or if you need to share it easily.
                 * Usage:
                 * `createAlgoliaClient: function(algoliasearch, appId, apiKey) { return anyCustomClient; }`
                 * We forward `algoliasearch` which is the original algoliasearch module imported inside instantsearch.js
                 * @param  {Object} [options.searchParameters] Additional parameters to pass to
                 * the Algolia API.
                 * [Full documentation](https://community.algolia.com/algoliasearch-helper-js/reference.html#searchparameters)
                 * @param  {Object|boolean} [options.urlSync] Url synchronization configuration.
                 * Setting to `true` will synchronize the needed search parameters with the browser url.
                 * @param  {Object} [options.urlSync.mapping] Object used to define replacement query
                 * parameter to use in place of another. Keys are current query parameters
                 * and value the new value, e.g. `{ q: 'query' }`.
                 * @param  {number} [options.urlSync.threshold] Idle time in ms after which a new
                 * state is created in the browser history. The default value is 700. The url is always updated at each keystroke
                 * but we only create a "previous search state" (activated when click on back button) every 700ms of idle time.
                 * @param  {string[]} [options.urlSync.trackedParameters] Parameters that will
                 * be synchronized in the URL. Default value is `['query', 'attribute:*',
                 * 'index', 'page', 'hitsPerPage']`. `attribute:*` means all the faceting attributes will be tracked. You
                 * can track only some of them by using [..., 'attribute:color', 'attribute:categories']. All other possible
                 * values are all the [attributes of the Helper SearchParameters](https://community.algolia.com/algoliasearch-helper-js/reference.html#searchparameters).
                 *
                 * There's a special `is_v` parameter that will get added everytime, it tracks the version of instantsearch.js
                 * linked to the url.
                 * @param  {boolean} [options.urlSync.useHash] If set to true, the url will be
                 * hash based. Otherwise, it'll use the query parameters using the modern
                 * history API.
                 * @param  {function} [options.urlSync.getHistoryState] Pass this function to override the
                 * default history API state we set to `null`. For example this could be used to force passing
                 * {turbolinks: true} to the history API every time we update it.
                 * @return {Object} the instantsearch instance
                 */

                var InstantSearch = (function (_EventEmitter) {
                    _inherits(InstantSearch, _EventEmitter);

                    function InstantSearch(_ref) {
                        var _ref$appId = _ref.appId,
                            appId =
                                _ref$appId === undefined ? null : _ref$appId,
                            _ref$apiKey = _ref.apiKey,
                            apiKey =
                                _ref$apiKey === undefined ? null : _ref$apiKey,
                            _ref$indexName = _ref.indexName,
                            indexName =
                                _ref$indexName === undefined
                                    ? null
                                    : _ref$indexName,
                            numberLocale = _ref.numberLocale,
                            _ref$searchParameters = _ref.searchParameters,
                            searchParameters =
                                _ref$searchParameters === undefined
                                    ? {}
                                    : _ref$searchParameters,
                            _ref$urlSync = _ref.urlSync,
                            urlSync =
                                _ref$urlSync === undefined
                                    ? null
                                    : _ref$urlSync,
                            searchFunction = _ref.searchFunction,
                            _ref$createAlgoliaCli = _ref.createAlgoliaClient,
                            createAlgoliaClient =
                                _ref$createAlgoliaCli === undefined
                                    ? defaultCreateAlgoliaClient
                                    : _ref$createAlgoliaCli;

                        _classCallCheck(this, InstantSearch);

                        var _this = _possibleConstructorReturn(
                            this,
                            (
                                InstantSearch.__proto__ ||
                                Object.getPrototypeOf(InstantSearch)
                            ).call(this)
                        );

                        if (
                            appId === null ||
                            apiKey === null ||
                            indexName === null
                        ) {
                            var usage =
                                "\nUsage: instantsearch({\n  appId: 'my_application_id',\n  apiKey: 'my_search_api_key',\n  indexName: 'my_index_name'\n});";
                            throw new Error(usage);
                        }

                        var client = createAlgoliaClient(
                            _algoliasearchLite2.default,
                            appId,
                            apiKey
                        );
                        client.addAlgoliaAgent(
                            "instantsearch.js " + _version2.default
                        );

                        _this.client = client;
                        _this.helper = null;
                        _this.indexName = indexName;
                        _this.searchParameters = _extends(
                            {},
                            searchParameters,
                            { index: indexName }
                        );
                        _this.widgets = [];
                        _this.templatesConfig = {
                            helpers: (0, _createHelpers2.default)({
                                numberLocale: numberLocale,
                            }),
                            compileOptions: {},
                        };

                        if (searchFunction) {
                            _this._searchFunction = searchFunction;
                        }

                        _this.urlSync = urlSync === true ? {} : urlSync;
                        return _this;
                    }

                    /**
                     * Add a widget
                     * @param  {Object} [widget] The widget to add
                     * @param  {function} [widget.render] Called after each search response has been received
                     * @param  {function} [widget.getConfiguration] Let the widget update the configuration
                     * of the search with new parameters
                     * @param  {function} [widget.init] Called once before the first search
                     * @return {Object} the added widget
                     */

                    _createClass(InstantSearch, [
                        {
                            key: "addWidget",
                            value: function addWidget(widget) {
                                // Add the widget to the list of widget
                                if (
                                    widget.render === undefined &&
                                    widget.init === undefined
                                ) {
                                    throw new Error(
                                        "Widget definition missing render or init method"
                                    );
                                }

                                this.widgets.push(widget);
                            },
                        },
                        {
                            key: "start",
                            value: function start() {
                                var _this2 = this;

                                if (!this.widgets)
                                    throw new Error(
                                        "No widgets were added to instantsearch.js"
                                    );

                                var searchParametersFromUrl = void 0;

                                if (this.urlSync) {
                                    var syncWidget = (0, _urlSync2.default)(
                                        this.urlSync
                                    );
                                    this._createURL =
                                        syncWidget.createURL.bind(syncWidget);
                                    this._createAbsoluteURL = function (
                                        relative
                                    ) {
                                        return _this2._createURL(relative, {
                                            absolute: true,
                                        });
                                    };
                                    this._onHistoryChange =
                                        syncWidget.onHistoryChange.bind(
                                            syncWidget
                                        );
                                    this.widgets.push(syncWidget);
                                    searchParametersFromUrl =
                                        syncWidget.searchParametersFromUrl;
                                } else {
                                    this._createURL = defaultCreateURL;
                                    this._createAbsoluteURL = defaultCreateURL;
                                    this._onHistoryChange = function () {};
                                }

                                this.searchParameters = this.widgets.reduce(
                                    enhanceConfiguration(
                                        searchParametersFromUrl
                                    ),
                                    this.searchParameters
                                );

                                var helper = (0, _algoliasearchHelper2.default)(
                                    this.client,
                                    this.searchParameters.index ||
                                        this.indexName,
                                    this.searchParameters
                                );

                                if (this._searchFunction) {
                                    this._originalHelperSearch =
                                        helper.search.bind(helper);
                                    helper.search =
                                        this._wrappedSearch.bind(this);
                                }

                                this.helper = helper;

                                this._init(helper.state, helper);

                                helper.on(
                                    "result",
                                    this._render.bind(this, helper)
                                );
                                helper.search();
                            },
                        },
                        {
                            key: "_wrappedSearch",
                            value: function _wrappedSearch() {
                                var helper = (0, _clone2.default)(this.helper);
                                helper.search = this._originalHelperSearch;
                                this._searchFunction(helper);
                                return;
                            },
                        },
                        {
                            key: "createURL",
                            value: function createURL(params) {
                                if (!this._createURL) {
                                    throw new Error(
                                        "You need to call start() before calling createURL()"
                                    );
                                }
                                return this._createURL(
                                    this.helper.state.setQueryParameters(params)
                                );
                            },
                        },
                        {
                            key: "_render",
                            value: function _render(helper, results, state) {
                                var _this3 = this;

                                (0, _forEach2.default)(
                                    this.widgets,
                                    function (widget) {
                                        if (!widget.render) {
                                            return;
                                        }
                                        widget.render({
                                            templatesConfig:
                                                _this3.templatesConfig,
                                            results: results,
                                            state: state,
                                            helper: helper,
                                            createURL:
                                                _this3._createAbsoluteURL,
                                        });
                                    }
                                );
                                this.emit("render");
                            },
                        },
                        {
                            key: "_init",
                            value: function _init(state, helper) {
                                var _this4 = this;

                                (0, _forEach2.default)(
                                    this.widgets,
                                    function (widget) {
                                        if (widget.init) {
                                            widget.init({
                                                state: state,
                                                helper: helper,
                                                templatesConfig:
                                                    _this4.templatesConfig,
                                                createURL:
                                                    _this4._createAbsoluteURL,
                                                onHistoryChange:
                                                    _this4._onHistoryChange,
                                            });
                                        }
                                    }
                                );
                            },
                        },
                    ]);

                    return InstantSearch;
                })(_events.EventEmitter);

                function enhanceConfiguration(searchParametersFromUrl) {
                    return function (configuration, widgetDefinition) {
                        if (!widgetDefinition.getConfiguration)
                            return configuration;

                        // Get the relevant partial configuration asked by the widget
                        var partialConfiguration =
                            widgetDefinition.getConfiguration(
                                configuration,
                                searchParametersFromUrl
                            );

                        var customizer = function customizer(a, b) {
                            // always create a unified array for facets refinements
                            if (Array.isArray(a)) {
                                return (0, _union2.default)(a, b);
                            }

                            // avoid mutating objects
                            if ((0, _isPlainObject2.default)(a)) {
                                return (0, _mergeWith2.default)(
                                    {},
                                    a,
                                    b,
                                    customizer
                                );
                            }

                            return undefined;
                        };

                        return (0, _mergeWith2.default)(
                            {},
                            configuration,
                            partialConfiguration,
                            customizer
                        );
                    };
                }

                exports.default = InstantSearch;

                /***/
            },
            /* 6 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var AlgoliaSearchCore = __webpack_require__(7);
                var createAlgoliasearch = __webpack_require__(28);

                module.exports = createAlgoliasearch(
                    AlgoliaSearchCore,
                    "(lite) "
                );

                /***/
            },
            /* 7 */
            /***/ function (module, exports, __webpack_require__) {
                module.exports = AlgoliaSearchCore;

                var errors = __webpack_require__(8);
                var exitPromise = __webpack_require__(11);
                var IndexCore = __webpack_require__(12);
                var store = __webpack_require__(23);

                // We will always put the API KEY in the JSON body in case of too long API KEY,
                // to avoid query string being too long and failing in various conditions (our server limit, browser limit,
                // proxies limit)
                var MAX_API_KEY_LENGTH = 500;
                var RESET_APP_DATA_TIMER =
                    ({ NODE_ENV: "production" }.RESET_APP_DATA_TIMER &&
                        parseInt(
                            { NODE_ENV: "production" }.RESET_APP_DATA_TIMER,
                            10
                        )) ||
                    60 * 2 * 1000; // after 2 minutes reset to first host

                /*
                 * Algolia Search library initialization
                 * https://www.algolia.com/
                 *
                 * @param {string} applicationID - Your applicationID, found in your dashboard
                 * @param {string} apiKey - Your API key, found in your dashboard
                 * @param {Object} [opts]
                 * @param {number} [opts.timeout=2000] - The request timeout set in milliseconds,
                 * another request will be issued after this timeout
                 * @param {string} [opts.protocol='http:'] - The protocol used to query Algolia Search API.
                 *                                        Set to 'https:' to force using https.
                 *                                        Default to document.location.protocol in browsers
                 * @param {Object|Array} [opts.hosts={
                 *           read: [this.applicationID + '-dsn.algolia.net'].concat([
                 *             this.applicationID + '-1.algolianet.com',
                 *             this.applicationID + '-2.algolianet.com',
                 *             this.applicationID + '-3.algolianet.com']
                 *           ]),
                 *           write: [this.applicationID + '.algolia.net'].concat([
                 *             this.applicationID + '-1.algolianet.com',
                 *             this.applicationID + '-2.algolianet.com',
                 *             this.applicationID + '-3.algolianet.com']
                 *           ]) - The hosts to use for Algolia Search API.
                 *           If you provide them, you will less benefit from our HA implementation
                 */
                function AlgoliaSearchCore(applicationID, apiKey, opts) {
                    var debug = __webpack_require__(24)("algoliasearch");

                    var clone = __webpack_require__(17);
                    var isArray = __webpack_require__(21);
                    var map = __webpack_require__(22);

                    var usage =
                        "Usage: algoliasearch(applicationID, apiKey, opts)";

                    if (
                        opts._allowEmptyCredentials !== true &&
                        !applicationID
                    ) {
                        throw new errors.AlgoliaSearchError(
                            "Please provide an application ID. " + usage
                        );
                    }

                    if (opts._allowEmptyCredentials !== true && !apiKey) {
                        throw new errors.AlgoliaSearchError(
                            "Please provide an API key. " + usage
                        );
                    }

                    this.applicationID = applicationID;
                    this.apiKey = apiKey;

                    this.hosts = {
                        read: [],
                        write: [],
                    };

                    opts = opts || {};

                    var protocol = opts.protocol || "https:";
                    this._timeouts = opts.timeouts || {
                        connect: 2 * 6000, // 500ms connect is GPRS latency
                        read: 2 * 15000,
                        write: 30 * 1000,
                    };

                    // backward compat, if opts.timeout is passed, we use it to configure all timeouts like before
                    if (opts.timeout) {
                        this._timeouts.connect =
                            this._timeouts.read =
                            this._timeouts.write =
                                opts.timeout;
                    }

                    // while we advocate for colon-at-the-end values: 'http:' for `opts.protocol`
                    // we also accept `http` and `https`. It's a common error.
                    if (!/:$/.test(protocol)) {
                        protocol = protocol + ":";
                    }

                    if (
                        opts.protocol !== "http:" &&
                        opts.protocol !== "https:"
                    ) {
                        throw new errors.AlgoliaSearchError(
                            "protocol must be `http:` or `https:` (was `" +
                                opts.protocol +
                                "`)"
                        );
                    }

                    this._checkAppIdData();

                    /* BC aanpassing 
	  if (!opts.hosts) {
	    var defaultHosts = map(this._shuffleResult, function(hostNumber) {
	      return applicationID + '-' + hostNumber + '.algolianet.com';
	    });
	
	    // no hosts given, compute defaults
	    var mainSuffix = (opts.dsn === false ? '' : '-dsn') + '.algolia.net';
	    this.hosts.read = [this.applicationID + mainSuffix].concat(defaultHosts);
	    this.hosts.write = [this.applicationID + '.algolia.net'].concat(defaultHosts);
	  }
	  */
                    if (!opts.hosts) {
                        var defaultHosts =
                            document.querySelector("#hits").dataset.indexsrc;

                        // no hosts given, compute defaults
                        var mainSuffix = "-";
                        this.hosts.read = [defaultHosts];
                        this.hosts.write = [defaultHosts];
                    } else if (isArray(opts.hosts)) {
                        // when passing custom hosts, we need to have a different host index if the number
                        // of write/read hosts are different.
                        this.hosts.read = clone(opts.hosts);
                        this.hosts.write = clone(opts.hosts);
                    } else {
                        this.hosts.read = clone(opts.hosts.read);
                        this.hosts.write = clone(opts.hosts.write);
                    }

                    // add protocol and lowercase hosts
                    this.hosts.read = map(
                        this.hosts.read,
                        prepareHost(protocol)
                    );
                    this.hosts.write = map(
                        this.hosts.write,
                        prepareHost(protocol)
                    );

                    this.extraHeaders = [];

                    // In some situations you might want to warm the cache
                    this.cache = opts._cache || {};

                    this._ua = opts._ua;
                    this._useCache =
                        opts._useCache === undefined || opts._cache
                            ? true
                            : opts._useCache;
                    this._useFallback =
                        opts.useFallback === undefined
                            ? true
                            : opts.useFallback;

                    this._setTimeout = opts._setTimeout;

                    debug("init done, %j", this);
                }

                /*
                 * Get the index object initialized
                 *
                 * @param indexName the name of index
                 * @param callback the result callback with one argument (the Index instance)
                 */
                AlgoliaSearchCore.prototype.initIndex = function (indexName) {
                    return new IndexCore(this, indexName);
                };

                /**
                 * Add an extra field to the HTTP request
                 *
                 * @param name the header field name
                 * @param value the header field value
                 */
                AlgoliaSearchCore.prototype.setExtraHeader = function (
                    name,
                    value
                ) {
                    this.extraHeaders.push({
                        name: name.toLowerCase(),
                        value: value,
                    });
                };

                /**
                 * Augment sent x-algolia-agent with more data, each agent part
                 * is automatically separated from the others by a semicolon;
                 *
                 * @param algoliaAgent the agent to add
                 */
                AlgoliaSearchCore.prototype.addAlgoliaAgent = function (
                    algoliaAgent
                ) {
                    if (this._ua.indexOf(";" + algoliaAgent) === -1) {
                        this._ua += ";" + algoliaAgent;
                    }
                };

                /*
                 * Wrapper that try all hosts to maximize the quality of service
                 */
                AlgoliaSearchCore.prototype._jsonRequest = function (
                    initialOpts
                ) {
                    this._checkAppIdData();

                    var requestDebug = __webpack_require__(24)(
                        "algoliasearch:" + initialOpts.url
                    );

                    var body;
                    var additionalUA = initialOpts.additionalUA || "";
                    var cache = initialOpts.cache;
                    var client = this;
                    var tries = 0;
                    var usingFallback = false;
                    var hasFallback =
                        client._useFallback &&
                        client._request.fallback &&
                        initialOpts.fallback;
                    var headers;

                    if (
                        this.apiKey.length > MAX_API_KEY_LENGTH &&
                        initialOpts.body !== undefined &&
                        (initialOpts.body.params !== undefined || // index.search()
                            initialOpts.body.requests !== undefined) // client.search()
                    ) {
                        initialOpts.body.apiKey = this.apiKey;
                        headers = this._computeRequestHeaders(
                            additionalUA,
                            false
                        );
                    } else {
                        headers = this._computeRequestHeaders(additionalUA);
                    }

                    if (initialOpts.body !== undefined) {
                        body = safeJSONStringify(initialOpts.body);
                    }

                    requestDebug("request start");
                    var debugData = [];

                    function doRequest(requester, reqOpts) {
                        client._checkAppIdData();

                        var startTime = new Date();
                        var cacheID;

                        if (client._useCache) {
                            cacheID = initialOpts.url;
                        }

                        // as we sometime use POST requests to pass parameters (like query='aa'),
                        // the cacheID must also include the body to be different between calls
                        if (client._useCache && body) {
                            cacheID += "_body_" + reqOpts.body;
                        }

                        // handle cache existence
                        if (
                            client._useCache &&
                            cache &&
                            cache[cacheID] !== undefined
                        ) {
                            requestDebug("serving response from cache");
                            return client._promise.resolve(
                                JSON.parse(cache[cacheID])
                            );
                        }

                        // if we reached max tries
                        if (
                            tries >= client.hosts[initialOpts.hostType].length
                        ) {
                            if (!hasFallback || usingFallback) {
                                requestDebug("could not get any response");
                                // then stop
                                return client._promise.reject(
                                    new errors.AlgoliaSearchError(
                                        "Cannot connect to the AlgoliaSearch API." +
                                            " Send an email to support@algolia.com to report and resolve the issue." +
                                            " Application id was: " +
                                            client.applicationID,
                                        { debugData: debugData }
                                    )
                                );
                            }

                            requestDebug("switching to fallback");

                            // let's try the fallback starting from here
                            tries = 0;

                            // method, url and body are fallback dependent
                            reqOpts.method = initialOpts.fallback.method;
                            reqOpts.url = initialOpts.fallback.url;
                            reqOpts.jsonBody = initialOpts.fallback.body;
                            if (reqOpts.jsonBody) {
                                reqOpts.body = safeJSONStringify(
                                    reqOpts.jsonBody
                                );
                            }
                            // re-compute headers, they could be omitting the API KEY
                            headers =
                                client._computeRequestHeaders(additionalUA);

                            reqOpts.timeouts = client._getTimeoutsForRequest(
                                initialOpts.hostType
                            );
                            client._setHostIndexByType(0, initialOpts.hostType);
                            usingFallback = true; // the current request is now using fallback
                            return doRequest(client._request.fallback, reqOpts);
                        }

                        var currentHost = client._getHostByType(
                            initialOpts.hostType
                        );

                        var url = currentHost;
                        var options = {
                            body: reqOpts.body,
                            jsonBody: reqOpts.jsonBody,
                            method: reqOpts.method,
                            headers: headers,
                            timeouts: reqOpts.timeouts,
                            debug: requestDebug,
                        };

                        requestDebug(
                            "method: %s, url: %s, headers: %j, timeouts: %d",
                            options.method,
                            url,
                            options.headers,
                            options.timeouts
                        );

                        if (requester === client._request.fallback) {
                            requestDebug("using fallback");
                        }

                        // `requester` is any of this._request or this._request.fallback
                        // thus it needs to be called using the client as context
                        return requester
                            .call(client, url, options)
                            .then(success, tryFallback);

                        function success(httpResponse) {
                            // compute the status of the response,
                            //
                            // When in browser mode, using XDR or JSONP, we have no statusCode available
                            // So we rely on our API response `status` property.
                            // But `waitTask` can set a `status` property which is not the statusCode (it's the task status)
                            // So we check if there's a `message` along `status` and it means it's an error
                            //
                            // That's the only case where we have a response.status that's not the http statusCode
                            var status =
                                (httpResponse &&
                                    httpResponse.body &&
                                    httpResponse.body.message &&
                                    httpResponse.body.status) ||
                                // this is important to check the request statusCode AFTER the body eventual
                                // statusCode because some implementations (jQuery XDomainRequest transport) may
                                // send statusCode 200 while we had an error
                                httpResponse.statusCode ||
                                // When in browser mode, using XDR or JSONP
                                // we default to success when no error (no response.status && response.message)
                                // If there was a JSON.parse() error then body is null and it fails
                                (httpResponse && httpResponse.body && 200);

                            requestDebug(
                                "received response: statusCode: %s, computed statusCode: %d, headers: %j",
                                httpResponse.statusCode,
                                status,
                                httpResponse.headers
                            );

                            var httpResponseOk = Math.floor(status / 100) === 2;

                            var endTime = new Date();
                            debugData.push({
                                currentHost: currentHost,
                                headers: removeCredentials(headers),
                                content: body || null,
                                contentLength:
                                    body !== undefined ? body.length : null,
                                method: reqOpts.method,
                                timeouts: reqOpts.timeouts,
                                url: reqOpts.url,
                                startTime: startTime,
                                endTime: endTime,
                                duration: endTime - startTime,
                                statusCode: status,
                            });

                            if (httpResponseOk) {
                                if (client._useCache && cache) {
                                    cache[cacheID] = httpResponse.responseText;
                                }

                                return httpResponse.body;
                            }

                            var shouldRetry = Math.floor(status / 100) !== 4;

                            if (shouldRetry) {
                                tries += 1;
                                return retryRequest();
                            }

                            requestDebug("unrecoverable error");

                            // no success and no retry => fail
                            var unrecoverableError =
                                new errors.AlgoliaSearchError(
                                    httpResponse.body &&
                                        httpResponse.body.message,
                                    { debugData: debugData, statusCode: status }
                                );

                            return client._promise.reject(unrecoverableError);
                        }

                        function tryFallback(err) {
                            // error cases:
                            //  While not in fallback mode:
                            //    - CORS not supported
                            //    - network error
                            //  While in fallback mode:
                            //    - timeout
                            //    - network error
                            //    - badly formatted JSONP (script loaded, did not call our callback)
                            //  In both cases:
                            //    - uncaught exception occurs (TypeError)
                            requestDebug(
                                "error: %s, stack: %s",
                                err.message,
                                err.stack
                            );

                            var endTime = new Date();
                            debugData.push({
                                currentHost: currentHost,
                                headers: removeCredentials(headers),
                                content: body || null,
                                contentLength:
                                    body !== undefined ? body.length : null,
                                method: reqOpts.method,
                                timeouts: reqOpts.timeouts,
                                url: reqOpts.url,
                                startTime: startTime,
                                endTime: endTime,
                                duration: endTime - startTime,
                            });

                            if (!(err instanceof errors.AlgoliaSearchError)) {
                                err = new errors.Unknown(
                                    err && err.message,
                                    err
                                );
                            }

                            tries += 1;

                            // stop the request implementation when:
                            if (
                                // we did not generate this error,
                                // it comes from a throw in some other piece of code
                                err instanceof errors.Unknown ||
                                // server sent unparsable JSON
                                err instanceof errors.UnparsableJSON ||
                                // max tries and already using fallback or no fallback
                                (tries >=
                                    client.hosts[initialOpts.hostType].length &&
                                    (usingFallback || !hasFallback))
                            ) {
                                // stop request implementation for this command
                                err.debugData = debugData;
                                return client._promise.reject(err);
                            }

                            // When a timeout occured, retry by raising timeout
                            if (err instanceof errors.RequestTimeout) {
                                return retryRequestWithHigherTimeout();
                            }

                            return retryRequest();
                        }

                        function retryRequest() {
                            requestDebug("retrying request");
                            client._incrementHostIndex(initialOpts.hostType);
                            return doRequest(requester, reqOpts);
                        }

                        function retryRequestWithHigherTimeout() {
                            requestDebug(
                                "retrying request with higher timeout"
                            );
                            client._incrementHostIndex(initialOpts.hostType);
                            client._incrementTimeoutMultipler();
                            reqOpts.timeouts = client._getTimeoutsForRequest(
                                initialOpts.hostType
                            );
                            return doRequest(requester, reqOpts);
                        }
                    }

                    var promise = doRequest(client._request, {
                        url: initialOpts.url,
                        method: initialOpts.method,
                        body: body,
                        jsonBody: initialOpts.body,
                        timeouts: client._getTimeoutsForRequest(
                            initialOpts.hostType
                        ),
                    });

                    // either we have a callback
                    // either we are using promises
                    if (initialOpts.callback) {
                        promise.then(
                            function okCb(content) {
                                exitPromise(function () {
                                    initialOpts.callback(null, content);
                                }, client._setTimeout || setTimeout);
                            },
                            function nookCb(err) {
                                exitPromise(function () {
                                    initialOpts.callback(err);
                                }, client._setTimeout || setTimeout);
                            }
                        );
                    } else {
                        return promise;
                    }
                };

                /*
                 * Transform search param object in query string
                 * @param {object} args arguments to add to the current query string
                 * @param {string} params current query string
                 * @return {string} the final query string
                 */
                AlgoliaSearchCore.prototype._getSearchParams = function (
                    args,
                    params
                ) {
                    if (args === undefined || args === null) {
                        return params;
                    }
                    for (var key in args) {
                        if (
                            key !== null &&
                            args[key] !== undefined &&
                            args.hasOwnProperty(key)
                        ) {
                            params += params === "" ? "" : "&";
                            params +=
                                key +
                                "=" +
                                encodeURIComponent(
                                    Object.prototype.toString.call(
                                        args[key]
                                    ) === "[object Array]"
                                        ? safeJSONStringify(args[key])
                                        : args[key]
                                );
                        }
                    }
                    return params;
                };

                AlgoliaSearchCore.prototype._computeRequestHeaders = function (
                    additionalUA,
                    withAPIKey
                ) {
                    var forEach = __webpack_require__(10);

                    var ua = additionalUA
                        ? this._ua + ";" + additionalUA
                        : this._ua;
                    /* BC aanpassing 
	  var requestHeaders = {
	    'x-algolia-agent': ua,
	    'x-algolia-application-id': this.applicationID
	  };
	
	  // browser will inline headers in the url, node.js will use http headers
	  // but in some situations, the API KEY will be too long (big secured API keys)
	  // so if the request is a POST and the KEY is very long, we will be asked to not put
	  // it into headers but in the JSON body
	  if (withAPIKey !== false) {
	    requestHeaders['x-algolia-api-key'] = this.apiKey;
	  }
	
	  if (this.userToken) {
	    requestHeaders['x-algolia-usertoken'] = this.userToken;
	  }
	
	  if (this.securityTags) {
	    requestHeaders['x-algolia-tagfilters'] = this.securityTags;
	  }
	  */

                    var requestHeaders = {};

                    if (
                        typeof maintransl != "undefined" &&
                        typeof maintransl["sids"] != "undefined" &&
                        typeof maintransl["sids"]["s1"] != "undefined"
                    ) {
                        requestHeaders["sids"] = maintransl["sids"]["s1"];
                    }

                    if (this.extraHeaders) {
                        forEach(
                            this.extraHeaders,
                            function addToRequestHeaders(header) {
                                requestHeaders[header.name] = header.value;
                            }
                        );
                    }

                    return requestHeaders;
                };

                /**
                 * Search through multiple indices at the same time
                 * @param  {Object[]}   queries  An array of queries you want to run.
                 * @param {string} queries[].indexName The index name you want to target
                 * @param {string} [queries[].query] The query to issue on this index. Can also be passed into `params`
                 * @param {Object} queries[].params Any search param like hitsPerPage, ..
                 * @param  {Function} callback Callback to be called
                 * @return {Promise|undefined} Returns a promise if no callback given
                 */
                AlgoliaSearchCore.prototype.search = function (
                    queries,
                    opts,
                    callback
                ) {
                    var isArray = __webpack_require__(21);
                    var map = __webpack_require__(22);

                    var usage =
                        "Usage: client.search(arrayOfQueries[, callback])";

                    if (!isArray(queries)) {
                        throw new Error(usage);
                    }

                    if (typeof opts === "function") {
                        callback = opts;
                        opts = {};
                    } else if (opts === undefined) {
                        opts = {};
                    }

                    var client = this;

                    var postObj = {
                        requests: map(queries, function prepareRequest(query) {
                            var params = "";

                            // allow query.query
                            // so we are mimicing the index.search(query, params) method
                            // {indexName:, query:, params:}
                            if (query.query !== undefined) {
                                params +=
                                    "query=" + encodeURIComponent(query.query);
                            }

                            return {
                                indexName: query.indexName,
                                params: client._getSearchParams(
                                    query.params,
                                    params
                                ),
                            };
                        }),
                    };

                    var JSONPParams = map(
                        postObj.requests,
                        function prepareJSONPParams(request, requestId) {
                            return (
                                requestId +
                                "=" +
                                encodeURIComponent(
                                    "/1/indexes/" +
                                        encodeURIComponent(request.indexName) +
                                        "?" +
                                        request.params
                                )
                            );
                        }
                    ).join("&");

                    var url = "/1/indexes/*/queries";

                    if (opts.strategy !== undefined) {
                        url += "?strategy=" + opts.strategy;
                    }

                    return this._jsonRequest({
                        cache: this.cache,
                        method: "POST",
                        url: url,
                        body: postObj,
                        hostType: "read",
                        fallback: {
                            method: "GET",
                            url: "/1/indexes/*",
                            body: {
                                params: JSONPParams,
                            },
                        },
                        callback: callback,
                    });
                };

                /**
                 * Set the extra security tagFilters header
                 * @param {string|array} tags The list of tags defining the current security filters
                 */
                AlgoliaSearchCore.prototype.setSecurityTags = function (tags) {
                    if (
                        Object.prototype.toString.call(tags) ===
                        "[object Array]"
                    ) {
                        var strTags = [];
                        for (var i = 0; i < tags.length; ++i) {
                            if (
                                Object.prototype.toString.call(tags[i]) ===
                                "[object Array]"
                            ) {
                                var oredTags = [];
                                for (var j = 0; j < tags[i].length; ++j) {
                                    oredTags.push(tags[i][j]);
                                }
                                strTags.push("(" + oredTags.join(",") + ")");
                            } else {
                                strTags.push(tags[i]);
                            }
                        }
                        tags = strTags.join(",");
                    }

                    this.securityTags = tags;
                };

                /**
                 * Set the extra user token header
                 * @param {string} userToken The token identifying a uniq user (used to apply rate limits)
                 */
                AlgoliaSearchCore.prototype.setUserToken = function (
                    userToken
                ) {
                    this.userToken = userToken;
                };

                /**
                 * Clear all queries in client's cache
                 * @return undefined
                 */
                AlgoliaSearchCore.prototype.clearCache = function () {
                    this.cache = {};
                };

                /**
                 * Set the number of milliseconds a request can take before automatically being terminated.
                 * @deprecated
                 * @param {Number} milliseconds
                 */
                AlgoliaSearchCore.prototype.setRequestTimeout = function (
                    milliseconds
                ) {
                    if (milliseconds) {
                        this._timeouts.connect =
                            this._timeouts.read =
                            this._timeouts.write =
                                milliseconds;
                    }
                };

                /**
                 * Set the three different (connect, read, write) timeouts to be used when requesting
                 * @param {Object} timeouts
                 */
                AlgoliaSearchCore.prototype.setTimeouts = function (timeouts) {
                    this._timeouts = timeouts;
                };

                /**
                 * Get the three different (connect, read, write) timeouts to be used when requesting
                 * @param {Object} timeouts
                 */
                AlgoliaSearchCore.prototype.getTimeouts = function () {
                    return this._timeouts;
                };

                AlgoliaSearchCore.prototype._getAppIdData = function () {
                    var data = store.get(this.applicationID);
                    if (data !== null) this._cacheAppIdData(data);
                    return data;
                };

                AlgoliaSearchCore.prototype._setAppIdData = function (data) {
                    data.lastChange = new Date().getTime();
                    this._cacheAppIdData(data);
                    return store.set(this.applicationID, data);
                };

                AlgoliaSearchCore.prototype._checkAppIdData = function () {
                    var data = this._getAppIdData();
                    var now = new Date().getTime();
                    if (
                        data === null ||
                        now - data.lastChange > RESET_APP_DATA_TIMER
                    ) {
                        return this._resetInitialAppIdData(data);
                    }

                    return data;
                };

                AlgoliaSearchCore.prototype._resetInitialAppIdData = function (
                    data
                ) {
                    var newData = data || {};
                    newData.hostIndexes = { read: 0, write: 0 };
                    newData.timeoutMultiplier = 1;
                    newData.shuffleResult =
                        newData.shuffleResult || shuffle([1, 2, 3]);
                    return this._setAppIdData(newData);
                };

                AlgoliaSearchCore.prototype._cacheAppIdData = function (data) {
                    this._hostIndexes = data.hostIndexes;
                    this._timeoutMultiplier = data.timeoutMultiplier;
                    this._shuffleResult = data.shuffleResult;
                };

                AlgoliaSearchCore.prototype._partialAppIdDataUpdate = function (
                    newData
                ) {
                    var foreach = __webpack_require__(10);
                    var currentData = this._getAppIdData();
                    foreach(newData, function (value, key) {
                        currentData[key] = value;
                    });

                    return this._setAppIdData(currentData);
                };

                AlgoliaSearchCore.prototype._getHostByType = function (
                    hostType
                ) {
                    return this.hosts[hostType][
                        this._getHostIndexByType(hostType)
                    ];
                };

                AlgoliaSearchCore.prototype._getTimeoutMultiplier =
                    function () {
                        return this._timeoutMultiplier;
                    };

                AlgoliaSearchCore.prototype._getHostIndexByType = function (
                    hostType
                ) {
                    return this._hostIndexes[hostType];
                };

                AlgoliaSearchCore.prototype._setHostIndexByType = function (
                    hostIndex,
                    hostType
                ) {
                    var clone = __webpack_require__(17);
                    var newHostIndexes = clone(this._hostIndexes);
                    newHostIndexes[hostType] = hostIndex;
                    this._partialAppIdDataUpdate({
                        hostIndexes: newHostIndexes,
                    });
                    return hostIndex;
                };

                AlgoliaSearchCore.prototype._incrementHostIndex = function (
                    hostType
                ) {
                    return this._setHostIndexByType(
                        (this._getHostIndexByType(hostType) + 1) %
                            this.hosts[hostType].length,
                        hostType
                    );
                };

                AlgoliaSearchCore.prototype._incrementTimeoutMultipler =
                    function () {
                        var timeoutMultiplier = Math.max(
                            this._timeoutMultiplier + 1,
                            4
                        );
                        return this._partialAppIdDataUpdate({
                            timeoutMultiplier: timeoutMultiplier,
                        });
                    };

                AlgoliaSearchCore.prototype._getTimeoutsForRequest = function (
                    hostType
                ) {
                    return {
                        connect:
                            this._timeouts.connect * this._timeoutMultiplier,
                        complete:
                            this._timeouts[hostType] * this._timeoutMultiplier,
                    };
                };

                function prepareHost(protocol) {
                    return function prepare(host) {
                        return protocol + "//" + host.toLowerCase();
                    };
                }

                // Prototype.js < 1.7, a widely used library, defines a weird
                // Array.prototype.toJSON function that will fail to stringify our content
                // appropriately
                // refs:
                //   - https://groups.google.com/forum/#!topic/prototype-core/E-SAVvV_V9Q
                //   - https://github.com/sstephenson/prototype/commit/038a2985a70593c1a86c230fadbdfe2e4898a48c
                //   - http://stackoverflow.com/a/3148441/147079
                function safeJSONStringify(obj) {
                    /* eslint no-extend-native:0 */

                    if (Array.prototype.toJSON === undefined) {
                        return JSON.stringify(obj);
                    }

                    var toJSON = Array.prototype.toJSON;
                    delete Array.prototype.toJSON;
                    var out = JSON.stringify(obj);
                    Array.prototype.toJSON = toJSON;

                    return out;
                }

                function shuffle(array) {
                    var currentIndex = array.length;
                    var temporaryValue;
                    var randomIndex;

                    // While there remain elements to shuffle...
                    while (currentIndex !== 0) {
                        // Pick a remaining element...
                        randomIndex = Math.floor(Math.random() * currentIndex);
                        currentIndex -= 1;

                        // And swap it with the current element.
                        temporaryValue = array[currentIndex];
                        array[currentIndex] = array[randomIndex];
                        array[randomIndex] = temporaryValue;
                    }

                    return array;
                }

                function removeCredentials(headers) {
                    var newHeaders = {};

                    for (var headerName in headers) {
                        if (
                            Object.prototype.hasOwnProperty.call(
                                headers,
                                headerName
                            )
                        ) {
                            var value;

                            if (
                                headerName === "x-algolia-api-key" ||
                                headerName === "x-algolia-application-id"
                            ) {
                                value = "**hidden for security purposes**";
                            } else {
                                value = headers[headerName];
                            }

                            newHeaders[headerName] = value;
                        }
                    }

                    return newHeaders;
                }

                /***/
            },
            /* 8 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                // This file hosts our error definitions
                // We use custom error "types" so that we can act on them when we need it
                // e.g.: if error instanceof errors.UnparsableJSON then..

                var inherits = __webpack_require__(9);

                function AlgoliaSearchError(message, extraProperties) {
                    var forEach = __webpack_require__(10);

                    var error = this;

                    // try to get a stacktrace
                    if (typeof Error.captureStackTrace === "function") {
                        Error.captureStackTrace(this, this.constructor);
                    } else {
                        error.stack =
                            new Error().stack ||
                            "Cannot get a stacktrace, browser is too old";
                    }

                    this.name = "AlgoliaSearchError";
                    this.message = message || "Unknown error";

                    if (extraProperties) {
                        forEach(
                            extraProperties,
                            function addToErrorObject(value, key) {
                                error[key] = value;
                            }
                        );
                    }
                }

                inherits(AlgoliaSearchError, Error);

                function createCustomError(name, message) {
                    function AlgoliaSearchCustomError() {
                        var args = Array.prototype.slice.call(arguments, 0);

                        // custom message not set, use default
                        if (typeof args[0] !== "string") {
                            args.unshift(message);
                        }

                        AlgoliaSearchError.apply(this, args);
                        this.name = "AlgoliaSearch" + name + "Error";
                    }

                    inherits(AlgoliaSearchCustomError, AlgoliaSearchError);

                    return AlgoliaSearchCustomError;
                }

                // late exports to let various fn defs and inherits take place
                module.exports = {
                    AlgoliaSearchError: AlgoliaSearchError,
                    UnparsableJSON: createCustomError(
                        "UnparsableJSON",
                        "Could not parse the incoming response as JSON, see err.more for details"
                    ),
                    RequestTimeout: createCustomError(
                        "RequestTimeout",
                        "Request timedout before getting a response"
                    ),
                    Network: createCustomError(
                        "Network",
                        "Network issue, see err.more for details"
                    ),
                    JSONPScriptFail: createCustomError(
                        "JSONPScriptFail",
                        "<script> was loaded but did not call our provided callback"
                    ),
                    JSONPScriptError: createCustomError(
                        "JSONPScriptError",
                        "<script> unable to load due to an `error` event on it"
                    ),
                    Unknown: createCustomError(
                        "Unknown",
                        "Unknown error occured"
                    ),
                };

                /***/
            },
            /* 9 */
            /***/ function (module, exports) {
                if (typeof Object.create === "function") {
                    // implementation from standard node.js 'util' module
                    module.exports = function inherits(ctor, superCtor) {
                        ctor.super_ = superCtor;
                        ctor.prototype = Object.create(superCtor.prototype, {
                            constructor: {
                                value: ctor,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        });
                    };
                } else {
                    // old school shim for old browsers
                    module.exports = function inherits(ctor, superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function () {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    };
                }

                /***/
            },
            /* 10 */
            /***/ function (module, exports) {
                var hasOwn = Object.prototype.hasOwnProperty;
                var toString = Object.prototype.toString;

                module.exports = function forEach(obj, fn, ctx) {
                    if (toString.call(fn) !== "[object Function]") {
                        throw new TypeError("iterator must be a function");
                    }
                    var l = obj.length;
                    if (l === +l) {
                        for (var i = 0; i < l; i++) {
                            fn.call(ctx, obj[i], i, obj);
                        }
                    } else {
                        for (var k in obj) {
                            if (hasOwn.call(obj, k)) {
                                fn.call(ctx, obj[k], k, obj);
                            }
                        }
                    }
                };

                /***/
            },
            /* 11 */
            /***/ function (module, exports) {
                // Parse cloud does not supports setTimeout
                // We do not store a setTimeout reference in the client everytime
                // We only fallback to a fake setTimeout when not available
                // setTimeout cannot be override globally sadly
                module.exports = function exitPromise(fn, _setTimeout) {
                    _setTimeout(fn, 0);
                };

                /***/
            },
            /* 12 */
            /***/ function (module, exports, __webpack_require__) {
                var buildSearchMethod = __webpack_require__(13);
                var deprecate = __webpack_require__(14);
                var deprecatedMessage = __webpack_require__(15);

                module.exports = IndexCore;

                /*
                 * Index class constructor.
                 * You should not use this method directly but use initIndex() function
                 */
                function IndexCore(algoliasearch, indexName) {
                    this.indexName = indexName;
                    this.as = algoliasearch;
                    this.typeAheadArgs = null;
                    this.typeAheadValueOption = null;

                    // make sure every index instance has it's own cache
                    this.cache = {};
                }

                /*
                 * Clear all queries in cache
                 */
                IndexCore.prototype.clearCache = function () {
                    this.cache = {};
                };

                /*
                 * Search inside the index using XMLHttpRequest request (Using a POST query to
                 * minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
                 *
                 * @param {string} [query] the full text query
                 * @param {object} [args] (optional) if set, contains an object with query parameters:
                 * - page: (integer) Pagination parameter used to select the page to retrieve.
                 *                   Page is zero-based and defaults to 0. Thus,
                 *                   to retrieve the 10th page you need to set page=9
                 * - hitsPerPage: (integer) Pagination parameter used to select the number of hits per page. Defaults to 20.
                 * - attributesToRetrieve: a string that contains the list of object attributes
                 * you want to retrieve (let you minimize the answer size).
                 *   Attributes are separated with a comma (for example "name,address").
                 *   You can also use an array (for example ["name","address"]).
                 *   By default, all attributes are retrieved. You can also use '*' to retrieve all
                 *   values when an attributesToRetrieve setting is specified for your index.
                 * - attributesToHighlight: a string that contains the list of attributes you
                 *   want to highlight according to the query.
                 *   Attributes are separated by a comma. You can also use an array (for example ["name","address"]).
                 *   If an attribute has no match for the query, the raw value is returned.
                 *   By default all indexed text attributes are highlighted.
                 *   You can use `*` if you want to highlight all textual attributes.
                 *   Numerical attributes are not highlighted.
                 *   A matchLevel is returned for each highlighted attribute and can contain:
                 *      - full: if all the query terms were found in the attribute,
                 *      - partial: if only some of the query terms were found,
                 *      - none: if none of the query terms were found.
                 * - attributesToSnippet: a string that contains the list of attributes to snippet alongside
                 * the number of words to return (syntax is `attributeName:nbWords`).
                 *    Attributes are separated by a comma (Example: attributesToSnippet=name:10,content:10).
                 *    You can also use an array (Example: attributesToSnippet: ['name:10','content:10']).
                 *    By default no snippet is computed.
                 * - minWordSizefor1Typo: the minimum number of characters in a query word to accept one typo in this word.
                 * Defaults to 3.
                 * - minWordSizefor2Typos: the minimum number of characters in a query word
                 * to accept two typos in this word. Defaults to 7.
                 * - getRankingInfo: if set to 1, the result hits will contain ranking
                 * information in _rankingInfo attribute.
                 * - aroundLatLng: search for entries around a given
                 * latitude/longitude (specified as two floats separated by a comma).
                 *   For example aroundLatLng=47.316669,5.016670).
                 *   You can specify the maximum distance in meters with the aroundRadius parameter (in meters)
                 *   and the precision for ranking with aroundPrecision
                 *   (for example if you set aroundPrecision=100, two objects that are distant of
                 *   less than 100m will be considered as identical for "geo" ranking parameter).
                 *   At indexing, you should specify geoloc of an object with the _geoloc attribute
                 *   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
                 * - insideBoundingBox: search entries inside a given area defined by the two extreme points
                 * of a rectangle (defined by 4 floats: p1Lat,p1Lng,p2Lat,p2Lng).
                 *   For example insideBoundingBox=47.3165,4.9665,47.3424,5.0201).
                 *   At indexing, you should specify geoloc of an object with the _geoloc attribute
                 *   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
                 * - numericFilters: a string that contains the list of numeric filters you want to
                 * apply separated by a comma.
                 *   The syntax of one filter is `attributeName` followed by `operand` followed by `value`.
                 *   Supported operands are `<`, `<=`, `=`, `>` and `>=`.
                 *   You can have multiple conditions on one attribute like for example numericFilters=price>100,price<1000.
                 *   You can also use an array (for example numericFilters: ["price>100","price<1000"]).
                 * - tagFilters: filter the query by a set of tags. You can AND tags by separating them by commas.
                 *   To OR tags, you must add parentheses. For example, tags=tag1,(tag2,tag3) means tag1 AND (tag2 OR tag3).
                 *   You can also use an array, for example tagFilters: ["tag1",["tag2","tag3"]]
                 *   means tag1 AND (tag2 OR tag3).
                 *   At indexing, tags should be added in the _tags** attribute
                 *   of objects (for example {"_tags":["tag1","tag2"]}).
                 * - facetFilters: filter the query by a list of facets.
                 *   Facets are separated by commas and each facet is encoded as `attributeName:value`.
                 *   For example: `facetFilters=category:Book,author:John%20Doe`.
                 *   You can also use an array (for example `["category:Book","author:John%20Doe"]`).
                 * - facets: List of object attributes that you want to use for faceting.
                 *   Comma separated list: `"category,author"` or array `['category','author']`
                 *   Only attributes that have been added in **attributesForFaceting** index setting
                 *   can be used in this parameter.
                 *   You can also use `*` to perform faceting on all attributes specified in **attributesForFaceting**.
                 * - queryType: select how the query words are interpreted, it can be one of the following value:
                 *    - prefixAll: all query words are interpreted as prefixes,
                 *    - prefixLast: only the last word is interpreted as a prefix (default behavior),
                 *    - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
                 * - optionalWords: a string that contains the list of words that should
                 * be considered as optional when found in the query.
                 *   Comma separated and array are accepted.
                 * - distinct: If set to 1, enable the distinct feature (disabled by default)
                 * if the attributeForDistinct index setting is set.
                 *   This feature is similar to the SQL "distinct" keyword: when enabled
                 *   in a query with the distinct=1 parameter,
                 *   all hits containing a duplicate value for the attributeForDistinct attribute are removed from results.
                 *   For example, if the chosen attribute is show_name and several hits have
                 *   the same value for show_name, then only the best
                 *   one is kept and others are removed.
                 * - restrictSearchableAttributes: List of attributes you want to use for
                 * textual search (must be a subset of the attributesToIndex index setting)
                 * either comma separated or as an array
                 * @param {function} [callback] the result callback called with two arguments:
                 *  error: null or Error('message'). If false, the content contains the error.
                 *  content: the server answer that contains the list of results.
                 */
                IndexCore.prototype.search = buildSearchMethod("query");

                /*
                 * -- BETA --
                 * Search a record similar to the query inside the index using XMLHttpRequest request (Using a POST query to
                 * minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
                 *
                 * @param {string} [query] the similar query
                 * @param {object} [args] (optional) if set, contains an object with query parameters.
                 *   All search parameters are supported (see search function), restrictSearchableAttributes and facetFilters
                 *   are the two most useful to restrict the similar results and get more relevant content
                 */
                IndexCore.prototype.similarSearch =
                    buildSearchMethod("similarQuery");

                /*
                 * Browse index content. The response content will have a `cursor` property that you can use
                 * to browse subsequent pages for this query. Use `index.browseFrom(cursor)` when you want.
                 *
                 * @param {string} query - The full text query
                 * @param {Object} [queryParameters] - Any search query parameter
                 * @param {Function} [callback] - The result callback called with two arguments
                 *   error: null or Error('message')
                 *   content: the server answer with the browse result
                 * @return {Promise|undefined} Returns a promise if no callback given
                 * @example
                 * index.browse('cool songs', {
                 *   tagFilters: 'public,comments',
                 *   hitsPerPage: 500
                 * }, callback);
                 * @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
                 */
                IndexCore.prototype.browse = function (
                    query,
                    queryParameters,
                    callback
                ) {
                    var merge = __webpack_require__(16);

                    var indexObj = this;

                    var page;
                    var hitsPerPage;

                    // we check variadic calls that are not the one defined
                    // .browse()/.browse(fn)
                    // => page = 0
                    if (
                        arguments.length === 0 ||
                        (arguments.length === 1 &&
                            typeof arguments[0] === "function")
                    ) {
                        page = 0;
                        callback = arguments[0];
                        query = undefined;
                    } else if (typeof arguments[0] === "number") {
                        // .browse(2)/.browse(2, 10)/.browse(2, fn)/.browse(2, 10, fn)
                        page = arguments[0];
                        if (typeof arguments[1] === "number") {
                            hitsPerPage = arguments[1];
                        } else if (typeof arguments[1] === "function") {
                            callback = arguments[1];
                            hitsPerPage = undefined;
                        }
                        query = undefined;
                        queryParameters = undefined;
                    } else if (typeof arguments[0] === "object") {
                        // .browse(queryParameters)/.browse(queryParameters, cb)
                        if (typeof arguments[1] === "function") {
                            callback = arguments[1];
                        }
                        queryParameters = arguments[0];
                        query = undefined;
                    } else if (
                        typeof arguments[0] === "string" &&
                        typeof arguments[1] === "function"
                    ) {
                        // .browse(query, cb)
                        callback = arguments[1];
                        queryParameters = undefined;
                    }

                    // otherwise it's a .browse(query)/.browse(query, queryParameters)/.browse(query, queryParameters, cb)

                    // get search query parameters combining various possible calls
                    // to .browse();
                    queryParameters = merge({}, queryParameters || {}, {
                        page: page,
                        hitsPerPage: hitsPerPage,
                        query: query,
                    });

                    var params = this.as._getSearchParams(queryParameters, "");

                    return this.as._jsonRequest({
                        method: "POST",
                        url:
                            "/1/indexes/" +
                            encodeURIComponent(indexObj.indexName) +
                            "/browse",
                        body: { params: params },
                        hostType: "read",
                        callback: callback,
                    });
                };

                /*
                 * Continue browsing from a previous position (cursor), obtained via a call to `.browse()`.
                 *
                 * @param {string} query - The full text query
                 * @param {Object} [queryParameters] - Any search query parameter
                 * @param {Function} [callback] - The result callback called with two arguments
                 *   error: null or Error('message')
                 *   content: the server answer with the browse result
                 * @return {Promise|undefined} Returns a promise if no callback given
                 * @example
                 * index.browseFrom('14lkfsakl32', callback);
                 * @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
                 */
                IndexCore.prototype.browseFrom = function (cursor, callback) {
                    return this.as._jsonRequest({
                        method: "POST",
                        url:
                            "/1/indexes/" +
                            encodeURIComponent(this.indexName) +
                            "/browse",
                        body: { cursor: cursor },
                        hostType: "read",
                        callback: callback,
                    });
                };

                /*
                 * Search for facet values
                 * https://www.algolia.com/doc/rest-api/search#search-for-facet-values
                 *
                 * @param {string} params.facetName Facet name, name of the attribute to search for values in.
                 * Must be declared as a facet
                 * @param {string} params.facetQuery Query for the facet search
                 * @param {string} [params.*] Any search parameter of Algolia,
                 * see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
                 * Pagination is not supported. The page and hitsPerPage parameters will be ignored.
                 * @param callback (optional)
                 */
                IndexCore.prototype.searchForFacetValues = function (
                    params,
                    callback
                ) {
                    var clone = __webpack_require__(17);
                    var omit = __webpack_require__(18);
                    var usage =
                        "Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])";

                    if (
                        params.facetName === undefined ||
                        params.facetQuery === undefined
                    ) {
                        throw new Error(usage);
                    }

                    var facetName = params.facetName;
                    var filteredParams = omit(
                        clone(params),
                        function (keyName) {
                            return keyName === "facetName";
                        }
                    );
                    var searchParameters = this.as._getSearchParams(
                        filteredParams,
                        ""
                    );

                    return this.as._jsonRequest({
                        method: "POST",
                        url:
                            "/1/indexes/" +
                            encodeURIComponent(this.indexName) +
                            "/facets/" +
                            encodeURIComponent(facetName) +
                            "/query",
                        hostType: "read",
                        body: { params: searchParameters },
                        callback: callback,
                    });
                };

                IndexCore.prototype.searchFacet = deprecate(function (
                    params,
                    callback
                ) {
                    return this.searchForFacetValues(params, callback);
                },
                deprecatedMessage("index.searchFacet(params[, callback])", "index.searchForFacetValues(params[, callback])"));

                IndexCore.prototype._search = function (
                    params,
                    url,
                    callback,
                    additionalUA
                ) {
                    return this.as._jsonRequest({
                        cache: this.cache,
                        method: "POST",
                        url:
                            url ||
                            "/1/indexes/" +
                                encodeURIComponent(this.indexName) +
                                "/query",
                        body: { params: params },
                        hostType: "read",
                        fallback: {
                            method: "GET",
                            url:
                                "/1/indexes/" +
                                encodeURIComponent(this.indexName),
                            body: { params: params },
                        },
                        callback: callback,
                        additionalUA: additionalUA,
                    });
                };

                /*
                 * Get an object from this index
                 *
                 * @param objectID the unique identifier of the object to retrieve
                 * @param attrs (optional) if set, contains the array of attribute names to retrieve
                 * @param callback (optional) the result callback called with two arguments
                 *  error: null or Error('message')
                 *  content: the object to retrieve or the error message if a failure occured
                 */
                IndexCore.prototype.getObject = function (
                    objectID,
                    attrs,
                    callback
                ) {
                    var indexObj = this;

                    if (arguments.length === 1 || typeof attrs === "function") {
                        callback = attrs;
                        attrs = undefined;
                    }

                    var params = "";
                    if (attrs !== undefined) {
                        params = "?attributes=";
                        for (var i = 0; i < attrs.length; ++i) {
                            if (i !== 0) {
                                params += ",";
                            }
                            params += attrs[i];
                        }
                    }

                    return this.as._jsonRequest({
                        method: "GET",
                        url:
                            "/1/indexes/" +
                            encodeURIComponent(indexObj.indexName) +
                            "/" +
                            encodeURIComponent(objectID) +
                            params,
                        hostType: "read",
                        callback: callback,
                    });
                };

                /*
                 * Get several objects from this index
                 *
                 * @param objectIDs the array of unique identifier of objects to retrieve
                 */
                IndexCore.prototype.getObjects = function (
                    objectIDs,
                    attributesToRetrieve,
                    callback
                ) {
                    var isArray = __webpack_require__(21);
                    var map = __webpack_require__(22);

                    var usage =
                        "Usage: index.getObjects(arrayOfObjectIDs[, callback])";

                    if (!isArray(objectIDs)) {
                        throw new Error(usage);
                    }

                    var indexObj = this;

                    if (
                        arguments.length === 1 ||
                        typeof attributesToRetrieve === "function"
                    ) {
                        callback = attributesToRetrieve;
                        attributesToRetrieve = undefined;
                    }

                    var body = {
                        requests: map(
                            objectIDs,
                            function prepareRequest(objectID) {
                                var request = {
                                    indexName: indexObj.indexName,
                                    objectID: objectID,
                                };

                                if (attributesToRetrieve) {
                                    request.attributesToRetrieve =
                                        attributesToRetrieve.join(",");
                                }

                                return request;
                            }
                        ),
                    };

                    return this.as._jsonRequest({
                        method: "POST",
                        url: "/1/indexes/*/objects",
                        hostType: "read",
                        body: body,
                        callback: callback,
                    });
                };

                IndexCore.prototype.as = null;
                IndexCore.prototype.indexName = null;
                IndexCore.prototype.typeAheadArgs = null;
                IndexCore.prototype.typeAheadValueOption = null;

                /***/
            },
            /* 13 */
            /***/ function (module, exports, __webpack_require__) {
                module.exports = buildSearchMethod;

                var errors = __webpack_require__(8);

                /**
                 * Creates a search method to be used in clients
                 * @param {string} queryParam the name of the attribute used for the query
                 * @param {string} url the url
                 * @return {function} the search method
                 */
                function buildSearchMethod(queryParam, url) {
                    /**
                     * The search method. Prepares the data and send the query to Algolia.
                     * @param {string} query the string used for query search
                     * @param {object} args additional parameters to send with the search
                     * @param {function} [callback] the callback to be called with the client gets the answer
                     * @return {undefined|Promise} If the callback is not provided then this methods returns a Promise
                     */
                    return function search(query, args, callback) {
                        // warn V2 users on how to search
                        if (
                            (typeof query === "function" &&
                                typeof args === "object") ||
                            typeof callback === "object"
                        ) {
                            // .search(query, params, cb)
                            // .search(cb, params)
                            throw new errors.AlgoliaSearchError(
                                "index.search usage is index.search(query, params, cb)"
                            );
                        }

                        // Normalizing the function signature
                        if (
                            arguments.length === 0 ||
                            typeof query === "function"
                        ) {
                            // Usage : .search(), .search(cb)
                            callback = query;
                            query = "";
                        } else if (
                            arguments.length === 1 ||
                            typeof args === "function"
                        ) {
                            // Usage : .search(query/args), .search(query, cb)
                            callback = args;
                            args = undefined;
                        }
                        // At this point we have 3 arguments with values

                        // Usage : .search(args) // careful: typeof null === 'object'
                        if (typeof query === "object" && query !== null) {
                            args = query;
                            query = undefined;
                        } else if (query === undefined || query === null) {
                            // .search(undefined/null)
                            query = "";
                        }

                        var params = "";

                        if (query !== undefined) {
                            params +=
                                queryParam + "=" + encodeURIComponent(query);
                        }

                        var additionalUA;
                        if (args !== undefined) {
                            if (args.additionalUA) {
                                additionalUA = args.additionalUA;
                                delete args.additionalUA;
                            }
                            // `_getSearchParams` will augment params, do not be fooled by the = versus += from previous if
                            params = this.as._getSearchParams(args, params);
                        }

                        return this._search(
                            params,
                            url,
                            callback,
                            additionalUA
                        );
                    };
                }

                /***/
            },
            /* 14 */
            /***/ function (module, exports) {
                module.exports = function deprecate(fn, message) {
                    var warned = false;

                    function deprecated() {
                        if (!warned) {
                            /* eslint no-console:0 */
                            console.log(message);
                            warned = true;
                        }

                        return fn.apply(this, arguments);
                    }

                    return deprecated;
                };

                /***/
            },
            /* 15 */
            /***/ function (module, exports) {
                module.exports = function deprecatedMessage(
                    previousUsage,
                    newUsage
                ) {
                    var githubAnchorLink = previousUsage
                        .toLowerCase()
                        .replace(".", "")
                        .replace("()", "");

                    return (
                        "algoliasearch: `" +
                        previousUsage +
                        "` was replaced by `" +
                        newUsage +
                        "`. Please see https://github.com/algolia/algoliasearch-client-js/wiki/Deprecated#" +
                        githubAnchorLink
                    );
                };

                /***/
            },
            /* 16 */
            /***/ function (module, exports, __webpack_require__) {
                var foreach = __webpack_require__(10);

                module.exports = function merge(destination /* , sources */) {
                    var sources = Array.prototype.slice.call(arguments);

                    foreach(sources, function (source) {
                        for (var keyName in source) {
                            if (source.hasOwnProperty(keyName)) {
                                if (
                                    typeof destination[keyName] === "object" &&
                                    typeof source[keyName] === "object"
                                ) {
                                    destination[keyName] = merge(
                                        {},
                                        destination[keyName],
                                        source[keyName]
                                    );
                                } else if (source[keyName] !== undefined) {
                                    destination[keyName] = source[keyName];
                                }
                            }
                        }
                    });

                    return destination;
                };

                /***/
            },
            /* 17 */
            /***/ function (module, exports) {
                module.exports = function clone(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };

                /***/
            },
            /* 18 */
            /***/ function (module, exports, __webpack_require__) {
                module.exports = function omit(obj, test) {
                    var keys = __webpack_require__(19);
                    var foreach = __webpack_require__(10);

                    var filtered = {};

                    foreach(keys(obj), function doFilter(keyName) {
                        if (test(keyName) !== true) {
                            filtered[keyName] = obj[keyName];
                        }
                    });

                    return filtered;
                };

                /***/
            },
            /* 19 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                // modified from https://github.com/es-shims/es5-shim
                var has = Object.prototype.hasOwnProperty;
                var toStr = Object.prototype.toString;
                var slice = Array.prototype.slice;
                var isArgs = __webpack_require__(20);
                var isEnumerable = Object.prototype.propertyIsEnumerable;
                var hasDontEnumBug = !isEnumerable.call(
                    { toString: null },
                    "toString"
                );
                var hasProtoEnumBug = isEnumerable.call(function () {},
                "prototype");
                var dontEnums = [
                    "toString",
                    "toLocaleString",
                    "valueOf",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "constructor",
                ];
                var equalsConstructorPrototype = function (o) {
                    var ctor = o.constructor;
                    return ctor && ctor.prototype === o;
                };
                var excludedKeys = {
                    $console: true,
                    $external: true,
                    $frame: true,
                    $frameElement: true,
                    $frames: true,
                    $innerHeight: true,
                    $innerWidth: true,
                    $outerHeight: true,
                    $outerWidth: true,
                    $pageXOffset: true,
                    $pageYOffset: true,
                    $parent: true,
                    $scrollLeft: true,
                    $scrollTop: true,
                    $scrollX: true,
                    $scrollY: true,
                    $self: true,
                    $webkitIndexedDB: true,
                    $webkitStorageInfo: true,
                    $window: true,
                };
                var hasAutomationEqualityBug = (function () {
                    /* global window */
                    if (typeof window === "undefined") {
                        return false;
                    }
                    for (var k in window) {
                        try {
                            if (
                                !excludedKeys["$" + k] &&
                                has.call(window, k) &&
                                window[k] !== null &&
                                typeof window[k] === "object"
                            ) {
                                try {
                                    equalsConstructorPrototype(window[k]);
                                } catch (e) {
                                    return true;
                                }
                            }
                        } catch (e) {
                            return true;
                        }
                    }
                    return false;
                })();
                var equalsConstructorPrototypeIfNotBuggy = function (o) {
                    /* global window */
                    if (
                        typeof window === "undefined" ||
                        !hasAutomationEqualityBug
                    ) {
                        return equalsConstructorPrototype(o);
                    }
                    try {
                        return equalsConstructorPrototype(o);
                    } catch (e) {
                        return false;
                    }
                };

                var keysShim = function keys(object) {
                    var isObject =
                        object !== null && typeof object === "object";
                    var isFunction = toStr.call(object) === "[object Function]";
                    var isArguments = isArgs(object);
                    var isString =
                        isObject && toStr.call(object) === "[object String]";
                    var theKeys = [];

                    if (!isObject && !isFunction && !isArguments) {
                        throw new TypeError(
                            "Object.keys called on a non-object"
                        );
                    }

                    var skipProto = hasProtoEnumBug && isFunction;
                    if (isString && object.length > 0 && !has.call(object, 0)) {
                        for (var i = 0; i < object.length; ++i) {
                            theKeys.push(String(i));
                        }
                    }

                    if (isArguments && object.length > 0) {
                        for (var j = 0; j < object.length; ++j) {
                            theKeys.push(String(j));
                        }
                    } else {
                        for (var name in object) {
                            if (
                                !(skipProto && name === "prototype") &&
                                has.call(object, name)
                            ) {
                                theKeys.push(String(name));
                            }
                        }
                    }

                    if (hasDontEnumBug) {
                        var skipConstructor =
                            equalsConstructorPrototypeIfNotBuggy(object);

                        for (var k = 0; k < dontEnums.length; ++k) {
                            if (
                                !(
                                    skipConstructor &&
                                    dontEnums[k] === "constructor"
                                ) &&
                                has.call(object, dontEnums[k])
                            ) {
                                theKeys.push(dontEnums[k]);
                            }
                        }
                    }
                    return theKeys;
                };

                keysShim.shim = function shimObjectKeys() {
                    if (Object.keys) {
                        var keysWorksWithArguments = (function () {
                            // Safari 5.0 bug
                            return (Object.keys(arguments) || "").length === 2;
                        })(1, 2);
                        if (!keysWorksWithArguments) {
                            var originalKeys = Object.keys;
                            Object.keys = function keys(object) {
                                if (isArgs(object)) {
                                    return originalKeys(slice.call(object));
                                } else {
                                    return originalKeys(object);
                                }
                            };
                        }
                    } else {
                        Object.keys = keysShim;
                    }
                    return Object.keys || keysShim;
                };

                module.exports = keysShim;

                /***/
            },
            /* 20 */
            /***/ function (module, exports) {
                "use strict";

                var toStr = Object.prototype.toString;

                module.exports = function isArguments(value) {
                    var str = toStr.call(value);
                    var isArgs = str === "[object Arguments]";
                    if (!isArgs) {
                        isArgs =
                            str !== "[object Array]" &&
                            value !== null &&
                            typeof value === "object" &&
                            typeof value.length === "number" &&
                            value.length >= 0 &&
                            toStr.call(value.callee) === "[object Function]";
                    }
                    return isArgs;
                };

                /***/
            },
            /* 21 */
            /***/ function (module, exports) {
                var toString = {}.toString;

                module.exports =
                    Array.isArray ||
                    function (arr) {
                        return toString.call(arr) == "[object Array]";
                    };

                /***/
            },
            /* 22 */
            /***/ function (module, exports, __webpack_require__) {
                var foreach = __webpack_require__(10);

                module.exports = function map(arr, fn) {
                    var newArr = [];
                    foreach(arr, function (item, itemIndex) {
                        newArr.push(fn(item, itemIndex, arr));
                    });
                    return newArr;
                };

                /***/
            },
            /* 23 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (global) {
                    var debug = __webpack_require__(24)(
                        "algoliasearch:src/hostIndexState.js"
                    );
                    var localStorageNamespace = "algoliasearch-client-js";

                    var store;
                    var moduleStore = {
                        state: {},
                        set: function (key, data) {
                            this.state[key] = data;
                            return this.state[key];
                        },
                        get: function (key) {
                            return this.state[key] || null;
                        },
                    };

                    var localStorageStore = {
                        set: function (key, data) {
                            moduleStore.set(key, data); // always replicate localStorageStore to moduleStore in case of failure

                            try {
                                var namespace = JSON.parse(
                                    global.localStorage[localStorageNamespace]
                                );
                                namespace[key] = data;
                                global.localStorage[localStorageNamespace] =
                                    JSON.stringify(namespace);
                                return namespace[key];
                            } catch (e) {
                                return localStorageFailure(key, e);
                            }
                        },
                        get: function (key) {
                            try {
                                return (
                                    JSON.parse(
                                        global.localStorage[
                                            localStorageNamespace
                                        ]
                                    )[key] || null
                                );
                            } catch (e) {
                                return localStorageFailure(key, e);
                            }
                        },
                    };

                    function localStorageFailure(key, e) {
                        debug("localStorage failed with", e);
                        cleanup();
                        store = moduleStore;
                        return store.get(key);
                    }

                    store = supportsLocalStorage()
                        ? localStorageStore
                        : moduleStore;

                    module.exports = {
                        get: getOrSet,
                        set: getOrSet,
                        supportsLocalStorage: supportsLocalStorage,
                    };

                    function getOrSet(key, data) {
                        if (arguments.length === 1) {
                            return store.get(key);
                        }

                        return store.set(key, data);
                    }

                    function supportsLocalStorage() {
                        try {
                            if (
                                "localStorage" in global &&
                                global.localStorage !== null
                            ) {
                                if (
                                    !global.localStorage[localStorageNamespace]
                                ) {
                                    // actual creation of the namespace
                                    global.localStorage.setItem(
                                        localStorageNamespace,
                                        JSON.stringify({})
                                    );
                                }
                                return true;
                            }

                            return false;
                        } catch (_) {
                            return false;
                        }
                    }

                    // In case of any error on localStorage, we clean our own namespace, this should handle
                    // quota errors when a lot of keys + data are used
                    function cleanup() {
                        try {
                            global.localStorage.removeItem(
                                localStorageNamespace
                            );
                        } catch (_) {
                            // nothing to do
                        }
                    }

                    /* WEBPACK VAR INJECTION */
                }.call(
                    exports,
                    (function () {
                        return this;
                    })()
                ));

                /***/
            },
            /* 24 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (process) {
                    /**
                     * This is the web browser implementation of `debug()`.
                     *
                     * Expose `debug()` as the module.
                     */

                    exports = module.exports = __webpack_require__(26);
                    exports.log = log;
                    exports.formatArgs = formatArgs;
                    exports.save = save;
                    exports.load = load;
                    exports.useColors = useColors;
                    exports.storage =
                        "undefined" != typeof chrome &&
                        "undefined" != typeof chrome.storage
                            ? chrome.storage.local
                            : localstorage();

                    /**
                     * Colors.
                     */

                    exports.colors = [
                        "lightseagreen",
                        "forestgreen",
                        "goldenrod",
                        "dodgerblue",
                        "darkorchid",
                        "crimson",
                    ];

                    /**
                     * Currently only WebKit-based Web Inspectors, Firefox >= v31,
                     * and the Firebug extension (any Firefox version) are known
                     * to support "%c" CSS customizations.
                     *
                     * TODO: add a `localStorage` variable to explicitly enable/disable colors
                     */

                    function useColors() {
                        // is webkit? http://stackoverflow.com/a/16459606/376773
                        // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
                        return (
                            (typeof document !== "undefined" &&
                                "WebkitAppearance" in
                                    document.documentElement.style) ||
                            // is firebug? http://stackoverflow.com/a/398120/376773
                            (window.console &&
                                (console.firebug ||
                                    (console.exception && console.table))) ||
                            // is firefox >= v31?
                            // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
                            (navigator.userAgent
                                .toLowerCase()
                                .match(/firefox\/(\d+)/) &&
                                parseInt(RegExp.$1, 10) >= 31)
                        );
                    }

                    /**
                     * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
                     */

                    exports.formatters.j = function (v) {
                        try {
                            return JSON.stringify(v);
                        } catch (err) {
                            return "[UnexpectedJSONParseError]: " + err.message;
                        }
                    };

                    /**
                     * Colorize log arguments if enabled.
                     *
                     * @api public
                     */

                    function formatArgs() {
                        var args = arguments;
                        var useColors = this.useColors;

                        args[0] =
                            (useColors ? "%c" : "") +
                            this.namespace +
                            (useColors ? " %c" : " ") +
                            args[0] +
                            (useColors ? "%c " : " ") +
                            "+" +
                            exports.humanize(this.diff);

                        if (!useColors) return args;

                        var c = "color: " + this.color;
                        args = [args[0], c, "color: inherit"].concat(
                            Array.prototype.slice.call(args, 1)
                        );

                        // the final "%c" is somewhat tricky, because there could be other
                        // arguments passed either before or after the %c, so we need to
                        // figure out the correct index to insert the CSS into
                        var index = 0;
                        var lastC = 0;
                        args[0].replace(/%[a-z%]/g, function (match) {
                            if ("%%" === match) return;
                            index++;
                            if ("%c" === match) {
                                // we only are interested in the *last* %c
                                // (the user may have provided their own)
                                lastC = index;
                            }
                        });

                        args.splice(lastC, 0, c);
                        return args;
                    }

                    /**
                     * Invokes `console.log()` when available.
                     * No-op when `console.log` is not a "function".
                     *
                     * @api public
                     */

                    function log() {
                        // this hackery is required for IE8/9, where
                        // the `console.log` function doesn't have 'apply'
                        return (
                            "object" === typeof console &&
                            console.log &&
                            Function.prototype.apply.call(
                                console.log,
                                console,
                                arguments
                            )
                        );
                    }

                    /**
                     * Save `namespaces`.
                     *
                     * @param {String} namespaces
                     * @api private
                     */

                    function save(namespaces) {
                        try {
                            if (null == namespaces) {
                                exports.storage.removeItem("debug");
                            } else {
                                exports.storage.debug = namespaces;
                            }
                        } catch (e) {}
                    }

                    /**
                     * Load `namespaces`.
                     *
                     * @return {String} returns the previously persisted debug modes
                     * @api private
                     */

                    function load() {
                        var r;
                        try {
                            return exports.storage.debug;
                        } catch (e) {}

                        // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
                        if (
                            typeof process !== "undefined" &&
                            "env" in process
                        ) {
                            return { NODE_ENV: "production" }.DEBUG;
                        }
                    }

                    /**
                     * Enable namespaces listed in `localStorage.debug` initially.
                     */

                    exports.enable(load());

                    /**
                     * Localstorage attempts to return the localstorage.
                     *
                     * This is necessary because safari throws
                     * when a user disables cookies/localstorage
                     * and you attempt to access it.
                     *
                     * @return {LocalStorage}
                     * @api private
                     */

                    function localstorage() {
                        try {
                            return window.localStorage;
                        } catch (e) {}
                    }

                    /* WEBPACK VAR INJECTION */
                }.call(exports, __webpack_require__(25)));

                /***/
            },
            /* 25 */
            /***/ function (module, exports) {
                // shim for using process in browser
                var process = (module.exports = {});

                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.

                var cachedSetTimeout;
                var cachedClearTimeout;

                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function () {
                    try {
                        if (typeof setTimeout === "function") {
                            cachedSetTimeout = setTimeout;
                        } else {
                            cachedSetTimeout = defaultSetTimout;
                        }
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") {
                            cachedClearTimeout = clearTimeout;
                        } else {
                            cachedClearTimeout = defaultClearTimeout;
                        }
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) {
                        //normal enviroments in sane situations
                        return setTimeout(fun, 0);
                    }
                    // if setTimeout wasn't available but was latter defined
                    if (
                        (cachedSetTimeout === defaultSetTimout ||
                            !cachedSetTimeout) &&
                        setTimeout
                    ) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) {
                        //normal enviroments in sane situations
                        return clearTimeout(marker);
                    }
                    // if clearTimeout wasn't available but was latter defined
                    if (
                        (cachedClearTimeout === defaultClearTimeout ||
                            !cachedClearTimeout) &&
                        clearTimeout
                    ) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;

                function cleanUpNextTick() {
                    if (!draining || !currentQueue) {
                        return;
                    }
                    draining = false;
                    if (currentQueue.length) {
                        queue = currentQueue.concat(queue);
                    } else {
                        queueIndex = -1;
                    }
                    if (queue.length) {
                        drainQueue();
                    }
                }

                function drainQueue() {
                    if (draining) {
                        return;
                    }
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;

                    var len = queue.length;
                    while (len) {
                        currentQueue = queue;
                        queue = [];
                        while (++queueIndex < len) {
                            if (currentQueue) {
                                currentQueue[queueIndex].run();
                            }
                        }
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }

                process.nextTick = function (fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) {
                        for (var i = 1; i < arguments.length; i++) {
                            args[i - 1] = arguments[i];
                        }
                    }
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) {
                        runTimeout(drainQueue);
                    }
                };

                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function () {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};

                function noop() {}

                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;

                process.binding = function (name) {
                    throw new Error("process.binding is not supported");
                };

                process.cwd = function () {
                    return "/";
                };
                process.chdir = function (dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function () {
                    return 0;
                };

                /***/
            },
            /* 26 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * This is the common logic for both the Node.js and web browser
                 * implementations of `debug()`.
                 *
                 * Expose `debug()` as the module.
                 */

                exports = module.exports = debug.debug = debug;
                exports.coerce = coerce;
                exports.disable = disable;
                exports.enable = enable;
                exports.enabled = enabled;
                exports.humanize = __webpack_require__(27);

                /**
                 * The currently active debug mode names, and names to skip.
                 */

                exports.names = [];
                exports.skips = [];

                /**
                 * Map of special "%n" handling functions, for the debug "format" argument.
                 *
                 * Valid key names are a single, lowercased letter, i.e. "n".
                 */

                exports.formatters = {};

                /**
                 * Previously assigned color.
                 */

                var prevColor = 0;

                /**
                 * Previous log timestamp.
                 */

                var prevTime;

                /**
                 * Select a color.
                 *
                 * @return {Number}
                 * @api private
                 */

                function selectColor() {
                    return exports.colors[prevColor++ % exports.colors.length];
                }

                /**
                 * Create a debugger with the given `namespace`.
                 *
                 * @param {String} namespace
                 * @return {Function}
                 * @api public
                 */

                function debug(namespace) {
                    // define the `disabled` version
                    function disabled() {}
                    disabled.enabled = false;

                    // define the `enabled` version
                    function enabled() {
                        var self = enabled;

                        // set `diff` timestamp
                        var curr = +new Date();
                        var ms = curr - (prevTime || curr);
                        self.diff = ms;
                        self.prev = prevTime;
                        self.curr = curr;
                        prevTime = curr;

                        // add the `color` if not set
                        if (null == self.useColors)
                            self.useColors = exports.useColors();
                        if (null == self.color && self.useColors)
                            self.color = selectColor();

                        var args = new Array(arguments.length);
                        for (var i = 0; i < args.length; i++) {
                            args[i] = arguments[i];
                        }

                        args[0] = exports.coerce(args[0]);

                        if ("string" !== typeof args[0]) {
                            // anything else let's inspect with %o
                            args = ["%o"].concat(args);
                        }

                        // apply any `formatters` transformations
                        var index = 0;
                        args[0] = args[0].replace(
                            /%([a-z%])/g,
                            function (match, format) {
                                // if we encounter an escaped % then don't increase the array index
                                if (match === "%%") return match;
                                index++;
                                var formatter = exports.formatters[format];
                                if ("function" === typeof formatter) {
                                    var val = args[index];
                                    match = formatter.call(self, val);

                                    // now we need to remove `args[index]` since it's inlined in the `format`
                                    args.splice(index, 1);
                                    index--;
                                }
                                return match;
                            }
                        );

                        // apply env-specific formatting
                        args = exports.formatArgs.apply(self, args);

                        var logFn =
                            enabled.log ||
                            exports.log ||
                            console.log.bind(console);
                        logFn.apply(self, args);
                    }
                    enabled.enabled = true;

                    var fn = exports.enabled(namespace) ? enabled : disabled;

                    fn.namespace = namespace;

                    return fn;
                }

                /**
                 * Enables a debug mode by namespaces. This can include modes
                 * separated by a colon and wildcards.
                 *
                 * @param {String} namespaces
                 * @api public
                 */

                function enable(namespaces) {
                    exports.save(namespaces);

                    var split = (namespaces || "").split(/[\s,]+/);
                    var len = split.length;

                    for (var i = 0; i < len; i++) {
                        if (!split[i]) continue; // ignore empty strings
                        namespaces = split[i]
                            .replace(/[\\^$+?.()|[\]{}]/g, "\\$&")
                            .replace(/\*/g, ".*?");
                        if (namespaces[0] === "-") {
                            exports.skips.push(
                                new RegExp("^" + namespaces.substr(1) + "$")
                            );
                        } else {
                            exports.names.push(
                                new RegExp("^" + namespaces + "$")
                            );
                        }
                    }
                }

                /**
                 * Disable debug output.
                 *
                 * @api public
                 */

                function disable() {
                    exports.enable("");
                }

                /**
                 * Returns true if the given mode name is enabled, false otherwise.
                 *
                 * @param {String} name
                 * @return {Boolean}
                 * @api public
                 */

                function enabled(name) {
                    var i, len;
                    for (i = 0, len = exports.skips.length; i < len; i++) {
                        if (exports.skips[i].test(name)) {
                            return false;
                        }
                    }
                    for (i = 0, len = exports.names.length; i < len; i++) {
                        if (exports.names[i].test(name)) {
                            return true;
                        }
                    }
                    return false;
                }

                /**
                 * Coerce `val`.
                 *
                 * @param {Mixed} val
                 * @return {Mixed}
                 * @api private
                 */

                function coerce(val) {
                    if (val instanceof Error) return val.stack || val.message;
                    return val;
                }

                /***/
            },
            /* 27 */
            /***/ function (module, exports) {
                /**
                 * Helpers.
                 */

                var s = 1000;
                var m = s * 60;
                var h = m * 60;
                var d = h * 24;
                var y = d * 365.25;

                /**
                 * Parse or format the given `val`.
                 *
                 * Options:
                 *
                 *  - `long` verbose formatting [false]
                 *
                 * @param {String|Number} val
                 * @param {Object} options
                 * @throws {Error} throw an error if val is not a non-empty string or a number
                 * @return {String|Number}
                 * @api public
                 */

                module.exports = function (val, options) {
                    options = options || {};
                    var type = typeof val;
                    if (type === "string" && val.length > 0) {
                        return parse(val);
                    } else if (type === "number" && isNaN(val) === false) {
                        return options.long ? fmtLong(val) : fmtShort(val);
                    }
                    throw new Error(
                        "val is not a non-empty string or a valid number. val=" +
                            JSON.stringify(val)
                    );
                };

                /**
                 * Parse the given `str` and return milliseconds.
                 *
                 * @param {String} str
                 * @return {Number}
                 * @api private
                 */

                function parse(str) {
                    str = String(str);
                    if (str.length > 10000) {
                        return;
                    }
                    var match =
                        /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
                            str
                        );
                    if (!match) {
                        return;
                    }
                    var n = parseFloat(match[1]);
                    var type = (match[2] || "ms").toLowerCase();
                    switch (type) {
                        case "years":
                        case "year":
                        case "yrs":
                        case "yr":
                        case "y":
                            return n * y;
                        case "days":
                        case "day":
                        case "d":
                            return n * d;
                        case "hours":
                        case "hour":
                        case "hrs":
                        case "hr":
                        case "h":
                            return n * h;
                        case "minutes":
                        case "minute":
                        case "mins":
                        case "min":
                        case "m":
                            return n * m;
                        case "seconds":
                        case "second":
                        case "secs":
                        case "sec":
                        case "s":
                            return n * s;
                        case "milliseconds":
                        case "millisecond":
                        case "msecs":
                        case "msec":
                        case "ms":
                            return n;
                        default:
                            return undefined;
                    }
                }

                /**
                 * Short format for `ms`.
                 *
                 * @param {Number} ms
                 * @return {String}
                 * @api private
                 */

                function fmtShort(ms) {
                    if (ms >= d) {
                        return Math.round(ms / d) + "d";
                    }
                    if (ms >= h) {
                        return Math.round(ms / h) + "h";
                    }
                    if (ms >= m) {
                        return Math.round(ms / m) + "m";
                    }
                    if (ms >= s) {
                        return Math.round(ms / s) + "s";
                    }
                    return ms + "ms";
                }

                /**
                 * Long format for `ms`.
                 *
                 * @param {Number} ms
                 * @return {String}
                 * @api private
                 */

                function fmtLong(ms) {
                    return (
                        plural(ms, d, "day") ||
                        plural(ms, h, "hour") ||
                        plural(ms, m, "minute") ||
                        plural(ms, s, "second") ||
                        ms + " ms"
                    );
                }

                /**
                 * Pluralization helper.
                 */

                function plural(ms, n, name) {
                    if (ms < n) {
                        return;
                    }
                    if (ms < n * 1.5) {
                        return Math.floor(ms / n) + " " + name;
                    }
                    return Math.ceil(ms / n) + " " + name + "s";
                }

                /***/
            },
            /* 28 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var global = __webpack_require__(29);
                var Promise = global.Promise || __webpack_require__(30).Promise;

                // This is the standalone browser build entry point
                // Browser implementation of the Algolia Search JavaScript client,
                // using XMLHttpRequest, XDomainRequest and JSONP as fallback
                module.exports = function createAlgoliasearch(
                    AlgoliaSearch,
                    uaSuffix
                ) {
                    var inherits = __webpack_require__(9);
                    var errors = __webpack_require__(8);
                    var inlineHeaders = __webpack_require__(32);
                    var jsonpRequest = __webpack_require__(34);
                    var places = __webpack_require__(35);
                    uaSuffix = uaSuffix || "";

                    if (false) {
                        require("debug").enable("algoliasearch*");
                    }

                    function algoliasearch(applicationID, apiKey, opts) {
                        var cloneDeep = __webpack_require__(17);

                        var getDocumentProtocol = __webpack_require__(36);

                        opts = cloneDeep(opts || {});

                        if (opts.protocol === undefined) {
                            opts.protocol = getDocumentProtocol();
                        }

                        opts._ua = opts._ua || algoliasearch.ua;

                        return new AlgoliaSearchBrowser(
                            applicationID,
                            apiKey,
                            opts
                        );
                    }

                    algoliasearch.version = __webpack_require__(37);
                    algoliasearch.ua =
                        "Algolia for vanilla JavaScript " +
                        uaSuffix +
                        algoliasearch.version;
                    algoliasearch.initPlaces = places(algoliasearch);

                    // we expose into window no matter how we are used, this will allow
                    // us to easily debug any website running algolia
                    global.__algolia = {
                        debug: __webpack_require__(24),
                        algoliasearch: algoliasearch,
                    };

                    var support = {
                        hasXMLHttpRequest: "XMLHttpRequest" in global,
                        hasXDomainRequest: "XDomainRequest" in global,
                    };

                    if (support.hasXMLHttpRequest) {
                        support.cors =
                            "withCredentials" in new XMLHttpRequest();
                    }

                    function AlgoliaSearchBrowser() {
                        // call AlgoliaSearch constructor
                        AlgoliaSearch.apply(this, arguments);
                    }

                    inherits(AlgoliaSearchBrowser, AlgoliaSearch);

                    AlgoliaSearchBrowser.prototype._request = function request(
                        url,
                        opts
                    ) {
                        return new Promise(function wrapRequest(
                            resolve,
                            reject
                        ) {
                            // no cors or XDomainRequest, no request
                            if (!support.cors && !support.hasXDomainRequest) {
                                // very old browser, not supported
                                reject(
                                    new errors.Network("CORS not supported")
                                );
                                return;
                            }

                            url = inlineHeaders(url, opts.headers);

                            var body = opts.body;
                            var req = support.cors
                                ? new XMLHttpRequest()
                                : new XDomainRequest();
                            var reqTimeout;
                            var timedOut;
                            var connected = false;

                            reqTimeout = setTimeout(
                                onTimeout,
                                opts.timeouts.connect
                            );
                            // we set an empty onprogress listener
                            // so that XDomainRequest on IE9 is not aborted
                            // refs:
                            //  - https://github.com/algolia/algoliasearch-client-js/issues/76
                            //  - https://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
                            req.onprogress = onProgress;
                            if ("onreadystatechange" in req)
                                req.onreadystatechange = onReadyStateChange;
                            req.onload = onLoad;
                            req.onerror = onError;

                            // do not rely on default XHR async flag, as some analytics code like hotjar
                            // breaks it and set it to false by default
                            if (req instanceof XMLHttpRequest) {
                                req.open(opts.method, url, true);
                            } else {
                                req.open(opts.method, url);
                            }

                            // headers are meant to be sent after open
                            if (support.cors) {
                                if (body) {
                                    if (opts.method === "POST") {
                                        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
                                        req.setRequestHeader(
                                            "content-type",
                                            "application/x-www-form-urlencoded"
                                        );
                                    } else {
                                        req.setRequestHeader(
                                            "content-type",
                                            "application/json"
                                        );
                                    }
                                }
                                req.setRequestHeader(
                                    "accept",
                                    "application/json"
                                );
                            }

                            req.send(body);

                            // event object not received in IE8, at least
                            // but we do not use it, still important to note
                            function onLoad(/* event */) {
                                // When browser does not supports req.timeout, we can
                                // have both a load and timeout event, since handled by a dumb setTimeout
                                if (timedOut) {
                                    return;
                                }

                                clearTimeout(reqTimeout);

                                var out;

                                try {
                                    out = {
                                        body: JSON.parse(req.responseText),
                                        responseText: req.responseText,
                                        statusCode: req.status,
                                        // XDomainRequest does not have any response headers
                                        headers:
                                            (req.getAllResponseHeaders &&
                                                req.getAllResponseHeaders()) ||
                                            {},
                                    };
                                } catch (e) {
                                    out = new errors.UnparsableJSON({
                                        more: req.responseText,
                                    });
                                }

                                if (out instanceof errors.UnparsableJSON) {
                                    reject(out);
                                } else {
                                    resolve(out);
                                }
                            }

                            function onError(event) {
                                if (timedOut) {
                                    return;
                                }

                                clearTimeout(reqTimeout);

                                // error event is trigerred both with XDR/XHR on:
                                //   - DNS error
                                //   - unallowed cross domain request
                                reject(
                                    new errors.Network({
                                        more: event,
                                    })
                                );
                            }

                            function onTimeout() {
                                timedOut = true;
                                req.abort();

                                reject(new errors.RequestTimeout());
                            }

                            function onConnect() {
                                connected = true;
                                clearTimeout(reqTimeout);
                                reqTimeout = setTimeout(
                                    onTimeout,
                                    opts.timeouts.complete
                                );
                            }

                            function onProgress() {
                                if (!connected) onConnect();
                            }

                            function onReadyStateChange() {
                                if (!connected && req.readyState > 1)
                                    onConnect();
                            }
                        });
                    };

                    AlgoliaSearchBrowser.prototype._request.fallback =
                        function requestFallback(url, opts) {
                            url = inlineHeaders(url, opts.headers);

                            return new Promise(function wrapJsonpRequest(
                                resolve,
                                reject
                            ) {
                                jsonpRequest(
                                    url,
                                    opts,
                                    function jsonpRequestDone(err, content) {
                                        if (err) {
                                            reject(err);
                                            return;
                                        }

                                        resolve(content);
                                    }
                                );
                            });
                        };

                    AlgoliaSearchBrowser.prototype._promise = {
                        reject: function rejectPromise(val) {
                            return Promise.reject(val);
                        },
                        resolve: function resolvePromise(val) {
                            return Promise.resolve(val);
                        },
                        delay: function delayPromise(ms) {
                            return new Promise(function resolveOnTimeout(
                                resolve /* , reject*/
                            ) {
                                setTimeout(resolve, ms);
                            });
                        },
                    };

                    return algoliasearch;
                };

                /***/
            },
            /* 29 */
            /***/ function (module, exports) {
                /* WEBPACK VAR INJECTION */ (function (global) {
                    if (typeof window !== "undefined") {
                        module.exports = window;
                    } else if (typeof global !== "undefined") {
                        module.exports = global;
                    } else if (typeof self !== "undefined") {
                        module.exports = self;
                    } else {
                        module.exports = {};
                    }

                    /* WEBPACK VAR INJECTION */
                }.call(
                    exports,
                    (function () {
                        return this;
                    })()
                ));

                /***/
            },
            /* 30 */
            /***/ function (module, exports, __webpack_require__) {
                var require;
                /* WEBPACK VAR INJECTION */ (function (process, global) {
                    /*!
                     * @overview es6-promise - a tiny implementation of Promises/A+.
                     * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
                     * @license   Licensed under MIT license
                     *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
                     * @version   4.0.5
                     */

                    (function (global, factory) {
                        true
                            ? (module.exports = factory())
                            : typeof define === "function" && define.amd
                            ? define(factory)
                            : (global.ES6Promise = factory());
                    })(this, function () {
                        "use strict";

                        function objectOrFunction(x) {
                            return (
                                typeof x === "function" ||
                                (typeof x === "object" && x !== null)
                            );
                        }

                        function isFunction(x) {
                            return typeof x === "function";
                        }

                        var _isArray = undefined;
                        if (!Array.isArray) {
                            _isArray = function (x) {
                                return (
                                    Object.prototype.toString.call(x) ===
                                    "[object Array]"
                                );
                            };
                        } else {
                            _isArray = Array.isArray;
                        }

                        var isArray = _isArray;

                        var len = 0;
                        var vertxNext = undefined;
                        var customSchedulerFn = undefined;

                        var asap = function asap(callback, arg) {
                            queue[len] = callback;
                            queue[len + 1] = arg;
                            len += 2;
                            if (len === 2) {
                                // If len is 2, that means that we need to schedule an async flush.
                                // If additional callbacks are queued before the queue is flushed, they
                                // will be processed by this flush that we are scheduling.
                                if (customSchedulerFn) {
                                    customSchedulerFn(flush);
                                } else {
                                    scheduleFlush();
                                }
                            }
                        };

                        function setScheduler(scheduleFn) {
                            customSchedulerFn = scheduleFn;
                        }

                        function setAsap(asapFn) {
                            asap = asapFn;
                        }

                        var browserWindow =
                            typeof window !== "undefined" ? window : undefined;
                        var browserGlobal = browserWindow || {};
                        var BrowserMutationObserver =
                            browserGlobal.MutationObserver ||
                            browserGlobal.WebKitMutationObserver;
                        var isNode =
                            typeof self === "undefined" &&
                            typeof process !== "undefined" &&
                            {}.toString.call(process) === "[object process]";

                        // test for web worker but not in IE10
                        var isWorker =
                            typeof Uint8ClampedArray !== "undefined" &&
                            typeof importScripts !== "undefined" &&
                            typeof MessageChannel !== "undefined";

                        // node
                        function useNextTick() {
                            // node version 0.10.x displays a deprecation warning when nextTick is used recursively
                            // see https://github.com/cujojs/when/issues/410 for details
                            return function () {
                                return process.nextTick(flush);
                            };
                        }

                        // vertx
                        function useVertxTimer() {
                            if (typeof vertxNext !== "undefined") {
                                return function () {
                                    vertxNext(flush);
                                };
                            }

                            return useSetTimeout();
                        }

                        function useMutationObserver() {
                            var iterations = 0;
                            var observer = new BrowserMutationObserver(flush);
                            var node = document.createTextNode("");
                            observer.observe(node, { characterData: true });

                            return function () {
                                node.data = iterations = ++iterations % 2;
                            };
                        }

                        // web worker
                        function useMessageChannel() {
                            var channel = new MessageChannel();
                            channel.port1.onmessage = flush;
                            return function () {
                                return channel.port2.postMessage(0);
                            };
                        }

                        function useSetTimeout() {
                            // Store setTimeout reference so es6-promise will be unaffected by
                            // other code modifying setTimeout (like sinon.useFakeTimers())
                            var globalSetTimeout = setTimeout;
                            return function () {
                                return globalSetTimeout(flush, 1);
                            };
                        }

                        var queue = new Array(1000);
                        function flush() {
                            for (var i = 0; i < len; i += 2) {
                                var callback = queue[i];
                                var arg = queue[i + 1];

                                callback(arg);

                                queue[i] = undefined;
                                queue[i + 1] = undefined;
                            }

                            len = 0;
                        }

                        function attemptVertx() {
                            try {
                                var r = require;
                                var vertx = __webpack_require__(31);
                                vertxNext =
                                    vertx.runOnLoop || vertx.runOnContext;
                                return useVertxTimer();
                            } catch (e) {
                                return useSetTimeout();
                            }
                        }

                        var scheduleFlush = undefined;
                        // Decide what async method to use to triggering processing of queued callbacks:
                        if (isNode) {
                            scheduleFlush = useNextTick();
                        } else if (BrowserMutationObserver) {
                            scheduleFlush = useMutationObserver();
                        } else if (isWorker) {
                            scheduleFlush = useMessageChannel();
                        } else if (
                            browserWindow === undefined &&
                            "function" === "function"
                        ) {
                            scheduleFlush = attemptVertx();
                        } else {
                            scheduleFlush = useSetTimeout();
                        }

                        function then(onFulfillment, onRejection) {
                            var _arguments = arguments;

                            var parent = this;

                            var child = new this.constructor(noop);

                            if (child[PROMISE_ID] === undefined) {
                                makePromise(child);
                            }

                            var _state = parent._state;

                            if (_state) {
                                (function () {
                                    var callback = _arguments[_state - 1];
                                    asap(function () {
                                        return invokeCallback(
                                            _state,
                                            child,
                                            callback,
                                            parent._result
                                        );
                                    });
                                })();
                            } else {
                                subscribe(
                                    parent,
                                    child,
                                    onFulfillment,
                                    onRejection
                                );
                            }

                            return child;
                        }

                        /**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
                        function resolve(object) {
                            /*jshint validthis:true */
                            var Constructor = this;

                            if (
                                object &&
                                typeof object === "object" &&
                                object.constructor === Constructor
                            ) {
                                return object;
                            }

                            var promise = new Constructor(noop);
                            _resolve(promise, object);
                            return promise;
                        }

                        var PROMISE_ID = Math.random()
                            .toString(36)
                            .substring(16);

                        function noop() {}

                        var PENDING = void 0;
                        var FULFILLED = 1;
                        var REJECTED = 2;

                        var GET_THEN_ERROR = new ErrorObject();

                        function selfFulfillment() {
                            return new TypeError(
                                "You cannot resolve a promise with itself"
                            );
                        }

                        function cannotReturnOwn() {
                            return new TypeError(
                                "A promises callback cannot return that same promise."
                            );
                        }

                        function getThen(promise) {
                            try {
                                return promise.then;
                            } catch (error) {
                                GET_THEN_ERROR.error = error;
                                return GET_THEN_ERROR;
                            }
                        }

                        function tryThen(
                            then,
                            value,
                            fulfillmentHandler,
                            rejectionHandler
                        ) {
                            try {
                                then.call(
                                    value,
                                    fulfillmentHandler,
                                    rejectionHandler
                                );
                            } catch (e) {
                                return e;
                            }
                        }

                        function handleForeignThenable(
                            promise,
                            thenable,
                            then
                        ) {
                            asap(function (promise) {
                                var sealed = false;
                                var error = tryThen(
                                    then,
                                    thenable,
                                    function (value) {
                                        if (sealed) {
                                            return;
                                        }
                                        sealed = true;
                                        if (thenable !== value) {
                                            _resolve(promise, value);
                                        } else {
                                            fulfill(promise, value);
                                        }
                                    },
                                    function (reason) {
                                        if (sealed) {
                                            return;
                                        }
                                        sealed = true;

                                        _reject(promise, reason);
                                    },
                                    "Settle: " +
                                        (promise._label || " unknown promise")
                                );

                                if (!sealed && error) {
                                    sealed = true;
                                    _reject(promise, error);
                                }
                            }, promise);
                        }

                        function handleOwnThenable(promise, thenable) {
                            if (thenable._state === FULFILLED) {
                                fulfill(promise, thenable._result);
                            } else if (thenable._state === REJECTED) {
                                _reject(promise, thenable._result);
                            } else {
                                subscribe(
                                    thenable,
                                    undefined,
                                    function (value) {
                                        return _resolve(promise, value);
                                    },
                                    function (reason) {
                                        return _reject(promise, reason);
                                    }
                                );
                            }
                        }

                        function handleMaybeThenable(
                            promise,
                            maybeThenable,
                            then$$
                        ) {
                            if (
                                maybeThenable.constructor ===
                                    promise.constructor &&
                                then$$ === then &&
                                maybeThenable.constructor.resolve === resolve
                            ) {
                                handleOwnThenable(promise, maybeThenable);
                            } else {
                                if (then$$ === GET_THEN_ERROR) {
                                    _reject(promise, GET_THEN_ERROR.error);
                                } else if (then$$ === undefined) {
                                    fulfill(promise, maybeThenable);
                                } else if (isFunction(then$$)) {
                                    handleForeignThenable(
                                        promise,
                                        maybeThenable,
                                        then$$
                                    );
                                } else {
                                    fulfill(promise, maybeThenable);
                                }
                            }
                        }

                        function _resolve(promise, value) {
                            if (promise === value) {
                                _reject(promise, selfFulfillment());
                            } else if (objectOrFunction(value)) {
                                handleMaybeThenable(
                                    promise,
                                    value,
                                    getThen(value)
                                );
                            } else {
                                fulfill(promise, value);
                            }
                        }

                        function publishRejection(promise) {
                            if (promise._onerror) {
                                promise._onerror(promise._result);
                            }

                            publish(promise);
                        }

                        function fulfill(promise, value) {
                            if (promise._state !== PENDING) {
                                return;
                            }

                            promise._result = value;
                            promise._state = FULFILLED;

                            if (promise._subscribers.length !== 0) {
                                asap(publish, promise);
                            }
                        }

                        function _reject(promise, reason) {
                            if (promise._state !== PENDING) {
                                return;
                            }
                            promise._state = REJECTED;
                            promise._result = reason;

                            asap(publishRejection, promise);
                        }

                        function subscribe(
                            parent,
                            child,
                            onFulfillment,
                            onRejection
                        ) {
                            var _subscribers = parent._subscribers;
                            var length = _subscribers.length;

                            parent._onerror = null;

                            _subscribers[length] = child;
                            _subscribers[length + FULFILLED] = onFulfillment;
                            _subscribers[length + REJECTED] = onRejection;

                            if (length === 0 && parent._state) {
                                asap(publish, parent);
                            }
                        }

                        function publish(promise) {
                            var subscribers = promise._subscribers;
                            var settled = promise._state;

                            if (subscribers.length === 0) {
                                return;
                            }

                            var child = undefined,
                                callback = undefined,
                                detail = promise._result;

                            for (var i = 0; i < subscribers.length; i += 3) {
                                child = subscribers[i];
                                callback = subscribers[i + settled];

                                if (child) {
                                    invokeCallback(
                                        settled,
                                        child,
                                        callback,
                                        detail
                                    );
                                } else {
                                    callback(detail);
                                }
                            }

                            promise._subscribers.length = 0;
                        }

                        function ErrorObject() {
                            this.error = null;
                        }

                        var TRY_CATCH_ERROR = new ErrorObject();

                        function tryCatch(callback, detail) {
                            try {
                                return callback(detail);
                            } catch (e) {
                                TRY_CATCH_ERROR.error = e;
                                return TRY_CATCH_ERROR;
                            }
                        }

                        function invokeCallback(
                            settled,
                            promise,
                            callback,
                            detail
                        ) {
                            var hasCallback = isFunction(callback),
                                value = undefined,
                                error = undefined,
                                succeeded = undefined,
                                failed = undefined;

                            if (hasCallback) {
                                value = tryCatch(callback, detail);

                                if (value === TRY_CATCH_ERROR) {
                                    failed = true;
                                    error = value.error;
                                    value = null;
                                } else {
                                    succeeded = true;
                                }

                                if (promise === value) {
                                    _reject(promise, cannotReturnOwn());
                                    return;
                                }
                            } else {
                                value = detail;
                                succeeded = true;
                            }

                            if (promise._state !== PENDING) {
                                // noop
                            } else if (hasCallback && succeeded) {
                                _resolve(promise, value);
                            } else if (failed) {
                                _reject(promise, error);
                            } else if (settled === FULFILLED) {
                                fulfill(promise, value);
                            } else if (settled === REJECTED) {
                                _reject(promise, value);
                            }
                        }

                        function initializePromise(promise, resolver) {
                            try {
                                resolver(
                                    function resolvePromise(value) {
                                        _resolve(promise, value);
                                    },
                                    function rejectPromise(reason) {
                                        _reject(promise, reason);
                                    }
                                );
                            } catch (e) {
                                _reject(promise, e);
                            }
                        }

                        var id = 0;
                        function nextId() {
                            return id++;
                        }

                        function makePromise(promise) {
                            promise[PROMISE_ID] = id++;
                            promise._state = undefined;
                            promise._result = undefined;
                            promise._subscribers = [];
                        }

                        function Enumerator(Constructor, input) {
                            this._instanceConstructor = Constructor;
                            this.promise = new Constructor(noop);

                            if (!this.promise[PROMISE_ID]) {
                                makePromise(this.promise);
                            }

                            if (isArray(input)) {
                                this._input = input;
                                this.length = input.length;
                                this._remaining = input.length;

                                this._result = new Array(this.length);

                                if (this.length === 0) {
                                    fulfill(this.promise, this._result);
                                } else {
                                    this.length = this.length || 0;
                                    this._enumerate();
                                    if (this._remaining === 0) {
                                        fulfill(this.promise, this._result);
                                    }
                                }
                            } else {
                                _reject(this.promise, validationError());
                            }
                        }

                        function validationError() {
                            return new Error(
                                "Array Methods must be provided an Array"
                            );
                        }

                        Enumerator.prototype._enumerate = function () {
                            var length = this.length;
                            var _input = this._input;

                            for (
                                var i = 0;
                                this._state === PENDING && i < length;
                                i++
                            ) {
                                this._eachEntry(_input[i], i);
                            }
                        };

                        Enumerator.prototype._eachEntry = function (entry, i) {
                            var c = this._instanceConstructor;
                            var resolve$$ = c.resolve;

                            if (resolve$$ === resolve) {
                                var _then = getThen(entry);

                                if (
                                    _then === then &&
                                    entry._state !== PENDING
                                ) {
                                    this._settledAt(
                                        entry._state,
                                        i,
                                        entry._result
                                    );
                                } else if (typeof _then !== "function") {
                                    this._remaining--;
                                    this._result[i] = entry;
                                } else if (c === Promise) {
                                    var promise = new c(noop);
                                    handleMaybeThenable(promise, entry, _then);
                                    this._willSettleAt(promise, i);
                                } else {
                                    this._willSettleAt(
                                        new c(function (resolve$$) {
                                            return resolve$$(entry);
                                        }),
                                        i
                                    );
                                }
                            } else {
                                this._willSettleAt(resolve$$(entry), i);
                            }
                        };

                        Enumerator.prototype._settledAt = function (
                            state,
                            i,
                            value
                        ) {
                            var promise = this.promise;

                            if (promise._state === PENDING) {
                                this._remaining--;

                                if (state === REJECTED) {
                                    _reject(promise, value);
                                } else {
                                    this._result[i] = value;
                                }
                            }

                            if (this._remaining === 0) {
                                fulfill(promise, this._result);
                            }
                        };

                        Enumerator.prototype._willSettleAt = function (
                            promise,
                            i
                        ) {
                            var enumerator = this;

                            subscribe(
                                promise,
                                undefined,
                                function (value) {
                                    return enumerator._settledAt(
                                        FULFILLED,
                                        i,
                                        value
                                    );
                                },
                                function (reason) {
                                    return enumerator._settledAt(
                                        REJECTED,
                                        i,
                                        reason
                                    );
                                }
                            );
                        };

                        /**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
                        function all(entries) {
                            return new Enumerator(this, entries).promise;
                        }

                        /**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
                        function race(entries) {
                            /*jshint validthis:true */
                            var Constructor = this;

                            if (!isArray(entries)) {
                                return new Constructor(function (_, reject) {
                                    return reject(
                                        new TypeError(
                                            "You must pass an array to race."
                                        )
                                    );
                                });
                            } else {
                                return new Constructor(function (
                                    resolve,
                                    reject
                                ) {
                                    var length = entries.length;
                                    for (var i = 0; i < length; i++) {
                                        Constructor.resolve(entries[i]).then(
                                            resolve,
                                            reject
                                        );
                                    }
                                });
                            }
                        }

                        /**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
                        function reject(reason) {
                            /*jshint validthis:true */
                            var Constructor = this;
                            var promise = new Constructor(noop);
                            _reject(promise, reason);
                            return promise;
                        }

                        function needsResolver() {
                            throw new TypeError(
                                "You must pass a resolver function as the first argument to the promise constructor"
                            );
                        }

                        function needsNew() {
                            throw new TypeError(
                                "Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function."
                            );
                        }

                        /**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
                        function Promise(resolver) {
                            this[PROMISE_ID] = nextId();
                            this._result = this._state = undefined;
                            this._subscribers = [];

                            if (noop !== resolver) {
                                typeof resolver !== "function" &&
                                    needsResolver();
                                this instanceof Promise
                                    ? initializePromise(this, resolver)
                                    : needsNew();
                            }
                        }

                        Promise.all = all;
                        Promise.race = race;
                        Promise.resolve = resolve;
                        Promise.reject = reject;
                        Promise._setScheduler = setScheduler;
                        Promise._setAsap = setAsap;
                        Promise._asap = asap;

                        Promise.prototype = {
                            constructor: Promise,

                            /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
                            then: then,

                            /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
                            catch: function _catch(onRejection) {
                                return this.then(null, onRejection);
                            },
                        };

                        function polyfill() {
                            var local = undefined;

                            if (typeof global !== "undefined") {
                                local = global;
                            } else if (typeof self !== "undefined") {
                                local = self;
                            } else {
                                try {
                                    local = Function("return this")();
                                } catch (e) {
                                    throw new Error(
                                        "polyfill failed because global object is unavailable in this environment"
                                    );
                                }
                            }

                            var P = local.Promise;

                            if (P) {
                                var promiseToString = null;
                                try {
                                    promiseToString =
                                        Object.prototype.toString.call(
                                            P.resolve()
                                        );
                                } catch (e) {
                                    // silently ignored
                                }

                                if (
                                    promiseToString === "[object Promise]" &&
                                    !P.cast
                                ) {
                                    return;
                                }
                            }

                            local.Promise = Promise;
                        }

                        // Strange compat..
                        Promise.polyfill = polyfill;
                        Promise.Promise = Promise;

                        return Promise;
                    });
                    //# sourceMappingURL=es6-promise.map
                    /* WEBPACK VAR INJECTION */
                }.call(
                    exports,
                    __webpack_require__(25),
                    (function () {
                        return this;
                    })()
                ));

                /***/
            },
            /* 31 */
            /***/ function (module, exports) {
                /* (ignored) */
                /***/
            },
            /* 32 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                module.exports = inlineHeaders;

                var encode = __webpack_require__(33);

                function inlineHeaders(url, headers) {
                    if (/\?/.test(url)) {
                        url += "&";
                    } else {
                        url += "?";
                    }

                    return url + encode(headers);
                }

                /***/
            },
            /* 33 */
            /***/ function (module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.

                "use strict";

                var stringifyPrimitive = function (v) {
                    switch (typeof v) {
                        case "string":
                            return v;

                        case "boolean":
                            return v ? "true" : "false";

                        case "number":
                            return isFinite(v) ? v : "";

                        default:
                            return "";
                    }
                };

                module.exports = function (obj, sep, eq, name) {
                    sep = sep || "&";
                    eq = eq || "=";
                    if (obj === null) {
                        obj = undefined;
                    }

                    if (typeof obj === "object") {
                        return map(objectKeys(obj), function (k) {
                            var ks =
                                encodeURIComponent(stringifyPrimitive(k)) + eq;
                            if (isArray(obj[k])) {
                                return map(obj[k], function (v) {
                                    return (
                                        ks +
                                        encodeURIComponent(
                                            stringifyPrimitive(v)
                                        )
                                    );
                                }).join(sep);
                            } else {
                                return (
                                    ks +
                                    encodeURIComponent(
                                        stringifyPrimitive(obj[k])
                                    )
                                );
                            }
                        }).join(sep);
                    }

                    if (!name) return "";
                    return (
                        encodeURIComponent(stringifyPrimitive(name)) +
                        eq +
                        encodeURIComponent(stringifyPrimitive(obj))
                    );
                };

                var isArray =
                    Array.isArray ||
                    function (xs) {
                        return (
                            Object.prototype.toString.call(xs) ===
                            "[object Array]"
                        );
                    };

                function map(xs, f) {
                    if (xs.map) return xs.map(f);
                    var res = [];
                    for (var i = 0; i < xs.length; i++) {
                        res.push(f(xs[i], i));
                    }
                    return res;
                }

                var objectKeys =
                    Object.keys ||
                    function (obj) {
                        var res = [];
                        for (var key in obj) {
                            if (Object.prototype.hasOwnProperty.call(obj, key))
                                res.push(key);
                        }
                        return res;
                    };

                /***/
            },
            /* 34 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                module.exports = jsonpRequest;

                var errors = __webpack_require__(8);

                var JSONPCounter = 0;

                function jsonpRequest(url, opts, cb) {
                    if (opts.method !== "GET") {
                        cb(
                            new Error(
                                "Method " +
                                    opts.method +
                                    " " +
                                    url +
                                    " is not supported by JSONP."
                            )
                        );
                        return;
                    }

                    opts.debug("JSONP: start");

                    var cbCalled = false;
                    var timedOut = false;

                    JSONPCounter += 1;
                    var head = document.getElementsByTagName("head")[0];
                    var script = document.createElement("script");
                    var cbName = "algoliaJSONP_" + JSONPCounter;
                    var done = false;

                    window[cbName] = function (data) {
                        removeGlobals();

                        if (timedOut) {
                            opts.debug("JSONP: Late answer, ignoring");
                            return;
                        }

                        cbCalled = true;

                        clean();

                        cb(null, {
                            body: data /* ,
	      // We do not send the statusCode, there's no statusCode in JSONP, it will be
	      // computed using data.status && data.message like with XDR
	      statusCode*/,
                        });
                    };

                    // add callback by hand
                    url += "&callback=" + cbName;

                    // add body params manually
                    if (opts.jsonBody && opts.jsonBody.params) {
                        url += "&" + opts.jsonBody.params;
                    }

                    var ontimeout = setTimeout(timeout, opts.timeouts.complete);

                    // script onreadystatechange needed only for
                    // <= IE8
                    // https://github.com/angular/angular.js/issues/4523
                    script.onreadystatechange = readystatechange;
                    script.onload = success;
                    script.onerror = error;

                    script.async = true;
                    script.defer = true;
                    script.src = url;
                    head.appendChild(script);

                    function success() {
                        opts.debug("JSONP: success");

                        if (done || timedOut) {
                            return;
                        }

                        done = true;

                        // script loaded but did not call the fn => script loading error
                        if (!cbCalled) {
                            opts.debug(
                                "JSONP: Fail. Script loaded but did not call the callback"
                            );
                            clean();
                            cb(new errors.JSONPScriptFail());
                        }
                    }

                    function readystatechange() {
                        if (
                            this.readyState === "loaded" ||
                            this.readyState === "complete"
                        ) {
                            success();
                        }
                    }

                    function clean() {
                        clearTimeout(ontimeout);
                        script.onload = null;
                        script.onreadystatechange = null;
                        script.onerror = null;
                        head.removeChild(script);
                    }

                    function removeGlobals() {
                        try {
                            delete window[cbName];
                            delete window[cbName + "_loaded"];
                        } catch (e) {
                            window[cbName] = window[cbName + "_loaded"] =
                                undefined;
                        }
                    }

                    function timeout() {
                        opts.debug("JSONP: Script timeout");
                        timedOut = true;
                        clean();
                        cb(new errors.RequestTimeout());
                    }

                    function error() {
                        opts.debug("JSONP: Script error");

                        if (done || timedOut) {
                            return;
                        }

                        clean();
                        cb(new errors.JSONPScriptError());
                    }
                }

                /***/
            },
            /* 35 */
            /***/ function (module, exports, __webpack_require__) {
                module.exports = createPlacesClient;

                var buildSearchMethod = __webpack_require__(13);

                function createPlacesClient(algoliasearch) {
                    return function places(appID, apiKey, opts) {
                        var cloneDeep = __webpack_require__(17);

                        /* BC aanpassing 
	
	    opts = opts && cloneDeep(opts) || {};
	    opts.hosts = opts.hosts || [
	      'places-dsn.algolia.net',
	      'places-1.algolianet.com',
	      'places-2.algolianet.com',
	      'places-3.algolianet.com'
	    ];
	*/

                        opts = (opts && cloneDeep(opts)) || {};
                        opts.hosts = [
                            document.querySelector("#hits").dataset.indexsrc,
                        ];

                        // allow initPlaces() no arguments => community rate limited
                        if (
                            arguments.length === 0 ||
                            typeof appID === "object" ||
                            appID === undefined
                        ) {
                            appID = "";
                            apiKey = "";
                            opts._allowEmptyCredentials = true;
                        }

                        var client = algoliasearch(appID, apiKey, opts);
                        var index = client.initIndex("places");
                        index.search = buildSearchMethod(
                            "query",
                            "/1/places/query"
                        );
                        return index;
                    };
                }

                /***/
            },
            /* 36 */
            /***/ function (module, exports) {
                "use strict";

                module.exports = getDocumentProtocol;

                function getDocumentProtocol() {
                    var protocol = window.document.location.protocol;

                    // when in `file:` mode (local html file), default to `http:`
                    if (protocol !== "http:" && protocol !== "https:") {
                        protocol = "http:";
                    }

                    return protocol;
                }

                /***/
            },
            /* 37 */
            /***/ function (module, exports) {
                "use strict";

                module.exports = "3.21.1";

                /***/
            },
            /* 38 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var AlgoliaSearchHelper = __webpack_require__(39);

                var SearchParameters = __webpack_require__(40);
                var SearchResults = __webpack_require__(264);

                /**
                 * The algoliasearchHelper module is the function that will let its
                 * contains everything needed to use the Algoliasearch
                 * Helper. It is a also a function that instanciate the helper.
                 * To use the helper, you also need the Algolia JS client v3.
                 * @example
                 * //using the UMD build
                 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
                 * var helper = algoliasearchHelper(client, 'bestbuy', {
                 *   facets: ['shipping'],
                 *   disjunctiveFacets: ['category']
                 * });
                 * helper.on('result', function(result) {
                 *   console.log(result);
                 * });
                 * helper.toggleRefine('Movies & TV Shows')
                 *       .toggleRefine('Free shipping')
                 *       .search();
                 * @example
                 * // The helper is an event emitter using the node API
                 * helper.on('result', updateTheResults);
                 * helper.once('result', updateTheResults);
                 * helper.removeListener('result', updateTheResults);
                 * helper.removeAllListeners('result');
                 * @module algoliasearchHelper
                 * @param  {AlgoliaSearch} client an AlgoliaSearch client
                 * @param  {string} index the name of the index to query
                 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
                 * @return {AlgoliaSearchHelper}
                 */
                function algoliasearchHelper(client, index, opts) {
                    return new AlgoliaSearchHelper(client, index, opts);
                }

                /**
                 * The version currently used
                 * @member module:algoliasearchHelper.version
                 * @type {number}
                 */
                algoliasearchHelper.version = __webpack_require__(337);

                /**
                 * Constructor for the Helper.
                 * @member module:algoliasearchHelper.AlgoliaSearchHelper
                 * @type {AlgoliaSearchHelper}
                 */
                algoliasearchHelper.AlgoliaSearchHelper = AlgoliaSearchHelper;

                /**
                 * Constructor for the object containing all the parameters of the search.
                 * @member module:algoliasearchHelper.SearchParameters
                 * @type {SearchParameters}
                 */
                algoliasearchHelper.SearchParameters = SearchParameters;

                /**
                 * Constructor for the object containing the results of the search.
                 * @member module:algoliasearchHelper.SearchResults
                 * @type {SearchResults}
                 */
                algoliasearchHelper.SearchResults = SearchResults;

                /**
                 * URL tools to generate query string and parse them from/into
                 * SearchParameters
                 * @member module:algoliasearchHelper.url
                 * @type {object} {@link url}
                 *
                 */
                algoliasearchHelper.url = __webpack_require__(322);

                module.exports = algoliasearchHelper;

                /***/
            },
            /* 39 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var SearchParameters = __webpack_require__(40);
                var SearchResults = __webpack_require__(264);
                var DerivedHelper = __webpack_require__(316);
                var requestBuilder = __webpack_require__(321);

                var util = __webpack_require__(317);
                var events = __webpack_require__(320);

                var flatten = __webpack_require__(227);
                var forEach = __webpack_require__(129);
                var isEmpty = __webpack_require__(236);
                var map = __webpack_require__(185);

                var url = __webpack_require__(322);
                var version = __webpack_require__(337);

                /**
                 * Event triggered when a parameter is set or updated
                 * @event AlgoliaSearchHelper#event:change
                 * @property {SearchParameters} state the current parameters with the latest changes applied
                 * @property {SearchResults} lastResults the previous results received from Algolia. `null` before
                 * the first request
                 * @example
                 * helper.on('change', function(state, lastResults) {
                 *   console.log('The parameters have changed');
                 * });
                 */

                /**
                 * Event triggered when the search is sent to Algolia
                 * @event AlgoliaSearchHelper#event:search
                 * @property {SearchParameters} state the parameters used for this search
                 * @property {SearchResults} lastResults the results from the previous search. `null` if
                 * it is the first search.
                 * @example
                 * helper.on('search', function(state, lastResults) {
                 *   console.log('Search sent');
                 * });
                 */

                /**
                 * Event triggered when the results are retrieved from Algolia
                 * @event AlgoliaSearchHelper#event:result
                 * @property {SearchResults} results the results received from Algolia
                 * @property {SearchParameters} state the parameters used to query Algolia. Those might
                 * be different from the one in the helper instance (for example if the network is unreliable).
                 * @example
                 * helper.on('result', function(results, state) {
                 *   console.log('Search results received');
                 * });
                 */

                /**
                 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
                 * used, the error can be caught using this event.
                 * @event AlgoliaSearchHelper#event:error
                 * @property {Error} error the error returned by the Algolia.
                 * @example
                 * helper.on('error', function(error) {
                 *   console.log('Houston we got a problem.');
                 * });
                 */

                /**
                 * Initialize a new AlgoliaSearchHelper
                 * @class
                 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
                 * search. It provides an event based interface for search callbacks:
                 *  - change: when the internal search state is changed.
                 *    This event contains a {@link SearchParameters} object and the
                 *    {@link SearchResults} of the last result if any.
                 *  - search: when a search is triggered using the `search()` method.
                 *  - result: when the response is retrieved from Algolia and is processed.
                 *    This event contains a {@link SearchResults} object and the
                 *    {@link SearchParameters} corresponding to this answer.
                 *  - error: when the response is an error. This event contains the error returned by the server.
                 * @param  {AlgoliaSearch} client an AlgoliaSearch client
                 * @param  {string} index the index name to query
                 * @param  {SearchParameters | object} options an object defining the initial
                 * config of the search. It doesn't have to be a {SearchParameters},
                 * just an object containing the properties you need from it.
                 */
                function AlgoliaSearchHelper(client, index, options) {
                    if (!client.addAlgoliaAgent)
                        console.log(
                            "Please upgrade to the newest version of the JS Client."
                        );
                    // eslint-disable-line
                    else if (!doesClientAgentContainsHelper(client))
                        client.addAlgoliaAgent("JS Helper " + version);

                    this.setClient(client);
                    var opts = options || {};
                    opts.index = index;
                    this.state = SearchParameters.make(opts);
                    this.lastResults = null;
                    this._queryId = 0;
                    this._lastQueryIdReceived = -1;
                    this.derivedHelpers = [];
                }

                util.inherits(AlgoliaSearchHelper, events.EventEmitter);

                /**
                 * Start the search with the parameters set in the state. When the
                 * method is called, it triggers a `search` event. The results will
                 * be available through the `result` event. If an error occcurs, an
                 * `error` will be fired instead.
                 * @return {AlgoliaSearchHelper}
                 * @fires search
                 * @fires result
                 * @fires error
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.search = function () {
                    this._search();
                    return this;
                };

                /**
                 * Gets the search query parameters that would be sent to the Algolia Client
                 * for the hits
                 * @return {object} Query Parameters
                 */
                AlgoliaSearchHelper.prototype.getQuery = function () {
                    var state = this.state;
                    return requestBuilder._getHitsSearchParams(state);
                };

                /**
                 * Start a search using a modified version of the current state. This method does
                 * not trigger the helper lifecycle and does not modify the state kept internally
                 * by the helper. This second aspect means that the next search call will be the
                 * same as a search call before calling searchOnce.
                 * @param {object} options can contain all the parameters that can be set to SearchParameters
                 * plus the index
                 * @param {function} [callback] optional callback executed when the response from the
                 * server is back.
                 * @return {promise|undefined} if a callback is passed the method returns undefined
                 * otherwise it returns a promise containing an object with two keys :
                 *  - content with a SearchResults
                 *  - state with the state used for the query as a SearchParameters
                 * @example
                 * // Changing the number of records returned per page to 1
                 * // This example uses the callback API
                 * var state = helper.searchOnce({hitsPerPage: 1},
                 *   function(error, content, state) {
                 *     // if an error occured it will be passed in error, otherwise its value is null
                 *     // content contains the results formatted as a SearchResults
                 *     // state is the instance of SearchParameters used for this search
                 *   });
                 * @example
                 * // Changing the number of records returned per page to 1
                 * // This example uses the promise API
                 * var state1 = helper.searchOnce({hitsPerPage: 1})
                 *                 .then(promiseHandler);
                 *
                 * function promiseHandler(res) {
                 *   // res contains
                 *   // {
                 *   //   content : SearchResults
                 *   //   state   : SearchParameters (the one used for this specific search)
                 *   // }
                 * }
                 */
                AlgoliaSearchHelper.prototype.searchOnce = function (
                    options,
                    cb
                ) {
                    var tempState = !options
                        ? this.state
                        : this.state.setQueryParameters(options);
                    var queries = requestBuilder._getQueries(
                        tempState.index,
                        tempState
                    );
                    if (cb) {
                        return this.client.search(
                            queries,
                            function (err, content) {
                                if (err) cb(err, null, tempState);
                                else
                                    cb(
                                        err,
                                        new SearchResults(
                                            tempState,
                                            content.results
                                        ),
                                        tempState
                                    );
                            }
                        );
                    }

                    return this.client.search(queries).then(function (content) {
                        return {
                            content: new SearchResults(
                                tempState,
                                content.results
                            ),
                            state: tempState,
                            _originalResponse: content,
                        };
                    });
                };

                /**
                 * Structure of each result when using
                 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
                 * @typedef FacetSearchHit
                 * @type {object}
                 * @property {string} value the facet value
                 * @property {string} highlighted the facet value highlighted with the query string
                 * @property {number} count number of occurence of this facet value
                 * @property {boolean} isRefined true if the value is already refined
                 */

                /**
                 * Structure of the data resolved by the
                 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
                 * promise.
                 * @typedef FacetSearchResult
                 * @type {objet}
                 * @property {FacetSearchHit} facetHits the results for this search for facet values
                 * @property {number} processingTimeMS time taken by the query insde the engine
                 */

                /**
                 * Search for facet values based on an query and the name of a facetted attribute. This
                 * triggers a search and will retrun a promise. On top of using the query, it also sends
                 * the parameters from the state so that the search is narrowed to only the possible values.
                 *
                 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
                 * @param {string} query the string query for the search
                 * @param {string} facet the name of the facetted attribute
                 * @return {promise<FacetSearchResult>} the results of the search
                 */
                AlgoliaSearchHelper.prototype.searchForFacetValues = function (
                    facet,
                    query
                ) {
                    var state = this.state;
                    var index = this.client.initIndex(this.state.index);
                    var isDisjunctive = state.isDisjunctiveFacet(facet);
                    var algoliaQuery = requestBuilder.getSearchForFacetQuery(
                        facet,
                        query,
                        this.state
                    );
                    return index
                        .searchForFacetValues(algoliaQuery)
                        .then(function addIsRefined(content) {
                            content.facetHits = forEach(
                                content.facetHits,
                                function (f) {
                                    f.isRefined = isDisjunctive
                                        ? state.isDisjunctiveFacetRefined(
                                              facet,
                                              f.value
                                          )
                                        : state.isFacetRefined(facet, f.value);
                                }
                            );

                            return content;
                        });
                };

                /**
                 * Sets the text query used for the search.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} q the user query
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.setQuery = function (q) {
                    this.state = this.state.setPage(0).setQuery(q);
                    this._change();
                    return this;
                };

                /**
                 * Remove all the types of refinements except tags. A string can be provided to remove
                 * only the refinements of a specific attribute. For more advanced use case, you can
                 * provide a function instead. This function should follow the
                 * [clearCallback definition](#SearchParameters.clearCallback).
                 *
                 * This method resets the current page to 0.
                 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 * @example
                 * // Removing all the refinements
                 * helper.clearRefinements().search();
                 * @example
                 * // Removing all the filters on a the category attribute.
                 * helper.clearRefinements('category').search();
                 * @example
                 * // Removing only the exclude filters on the category facet.
                 * helper.clearRefinements(function(value, attribute, type) {
                 *   return type === 'exclude' && attribute === 'category';
                 * }).search();
                 */
                AlgoliaSearchHelper.prototype.clearRefinements = function (
                    name
                ) {
                    this.state = this.state.setPage(0).clearRefinements(name);
                    this._change();
                    return this;
                };

                /**
                 * Remove all the tag filters.
                 *
                 * This method resets the current page to 0.
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.clearTags = function () {
                    this.state = this.state.setPage(0).clearTags();
                    this._change();
                    return this;
                };

                /**
                 * Adds a disjunctive filter to a facetted attribute with the `value` provided. If the
                 * filter is already set, it doesn't change the filters.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} value the associated value (will be converted to string)
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement =
                    function (facet, value) {
                        this.state = this.state
                            .setPage(0)
                            .addDisjunctiveFacetRefinement(facet, value);
                        this._change();
                        return this;
                    };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
                 */
                AlgoliaSearchHelper.prototype.addDisjunctiveRefine =
                    function () {
                        return this.addDisjunctiveFacetRefinement.apply(
                            this,
                            arguments
                        );
                    };

                /**
                 * Adds a refinement on a hierarchical facet. It will throw
                 * an exception if the facet is not defined or if the facet
                 * is already refined.
                 *
                 * This method resets the current page to 0.
                 * @param {string} facet the facet name
                 * @param {string} path the hierarchical facet path
                 * @return {AlgoliaSearchHelper}
                 * @throws Error if the facet is not defined or if the facet is refined
                 * @chainable
                 * @fires change
                 */
                AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement =
                    function (facet, value) {
                        this.state = this.state
                            .setPage(0)
                            .addHierarchicalFacetRefinement(facet, value);
                        this._change();
                        return this;
                    };

                /**
                 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
                 * filter is already set, it doesn't change the filters.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} attribute the attribute on which the numeric filter applies
                 * @param  {string} operator the operator of the filter
                 * @param  {number} value the value of the filter
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.addNumericRefinement = function (
                    attribute,
                    operator,
                    value
                ) {
                    this.state = this.state
                        .setPage(0)
                        .addNumericRefinement(attribute, operator, value);
                    this._change();
                    return this;
                };

                /**
                 * Adds a filter to a facetted attribute with the `value` provided. If the
                 * filter is already set, it doesn't change the filters.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} value the associated value (will be converted to string)
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.addFacetRefinement = function (
                    facet,
                    value
                ) {
                    this.state = this.state
                        .setPage(0)
                        .addFacetRefinement(facet, value);
                    this._change();
                    return this;
                };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
                 */
                AlgoliaSearchHelper.prototype.addRefine = function () {
                    return this.addFacetRefinement.apply(this, arguments);
                };

                /**
                 * Adds a an exclusion filter to a facetted attribute with the `value` provided. If the
                 * filter is already set, it doesn't change the filters.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} value the associated value (will be converted to string)
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.addFacetExclusion = function (
                    facet,
                    value
                ) {
                    this.state = this.state
                        .setPage(0)
                        .addExcludeRefinement(facet, value);
                    this._change();
                    return this;
                };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
                 */
                AlgoliaSearchHelper.prototype.addExclude = function () {
                    return this.addFacetExclusion.apply(this, arguments);
                };

                /**
                 * Adds a tag filter with the `tag` provided. If the
                 * filter is already set, it doesn't change the filters.
                 *
                 * This method resets the current page to 0.
                 * @param {string} tag the tag to add to the filter
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.addTag = function (tag) {
                    this.state = this.state.setPage(0).addTagRefinement(tag);
                    this._change();
                    return this;
                };

                /**
                 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
                 * filter is not set, it doesn't change the filters.
                 *
                 * Some parameters are optionnals, triggering different behaviors:
                 *  - if the value is not provided, then all the numeric value will be removed for the
                 *  specified attribute/operator couple.
                 *  - if the operator is not provided either, then all the numeric filter on this attribute
                 *  will be removed.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} attribute the attribute on which the numeric filter applies
                 * @param  {string} [operator] the operator of the filter
                 * @param  {number} [value] the value of the filter
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.removeNumericRefinement =
                    function (attribute, operator, value) {
                        this.state = this.state
                            .setPage(0)
                            .removeNumericRefinement(
                                attribute,
                                operator,
                                value
                            );
                        this._change();
                        return this;
                    };

                /**
                 * Removes a disjunctive filter to a facetted attribute with the `value` provided. If the
                 * filter is not set, it doesn't change the filters.
                 *
                 * If the value is omitted, then this method will remove all the filters for the
                 * attribute.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} [value] the associated value
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement =
                    function (facet, value) {
                        this.state = this.state
                            .setPage(0)
                            .removeDisjunctiveFacetRefinement(facet, value);
                        this._change();
                        return this;
                    };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
                 */
                AlgoliaSearchHelper.prototype.removeDisjunctiveRefine =
                    function () {
                        return this.removeDisjunctiveFacetRefinement.apply(
                            this,
                            arguments
                        );
                    };

                /**
                 * Removes the refinement set on a hierarchical facet.
                 * @param {string} facet the facet name
                 * @return {AlgoliaSearchHelper}
                 * @throws Error if the facet is not defined or if the facet is not refined
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement =
                    function (facet) {
                        this.state = this.state
                            .setPage(0)
                            .removeHierarchicalFacetRefinement(facet);
                        this._change();

                        return this;
                    };

                /**
                 * Removes a filter to a facetted attribute with the `value` provided. If the
                 * filter is not set, it doesn't change the filters.
                 *
                 * If the value is omitted, then this method will remove all the filters for the
                 * attribute.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} [value] the associated value
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.removeFacetRefinement = function (
                    facet,
                    value
                ) {
                    this.state = this.state
                        .setPage(0)
                        .removeFacetRefinement(facet, value);
                    this._change();
                    return this;
                };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
                 */
                AlgoliaSearchHelper.prototype.removeRefine = function () {
                    return this.removeFacetRefinement.apply(this, arguments);
                };

                /**
                 * Removes an exclusion filter to a facetted attribute with the `value` provided. If the
                 * filter is not set, it doesn't change the filters.
                 *
                 * If the value is omitted, then this method will remove all the filters for the
                 * attribute.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} [value] the associated value
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.removeFacetExclusion = function (
                    facet,
                    value
                ) {
                    this.state = this.state
                        .setPage(0)
                        .removeExcludeRefinement(facet, value);
                    this._change();
                    return this;
                };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
                 */
                AlgoliaSearchHelper.prototype.removeExclude = function () {
                    return this.removeFacetExclusion.apply(this, arguments);
                };

                /**
                 * Removes a tag filter with the `tag` provided. If the
                 * filter is not set, it doesn't change the filters.
                 *
                 * This method resets the current page to 0.
                 * @param {string} tag tag to remove from the filter
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.removeTag = function (tag) {
                    this.state = this.state.setPage(0).removeTagRefinement(tag);
                    this._change();
                    return this;
                };

                /**
                 * Adds or removes an exclusion filter to a facetted attribute with the `value` provided. If
                 * the value is set then it removes it, otherwise it adds the filter.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} value the associated value
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.toggleFacetExclusion = function (
                    facet,
                    value
                ) {
                    this.state = this.state
                        .setPage(0)
                        .toggleExcludeFacetRefinement(facet, value);
                    this._change();
                    return this;
                };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
                 */
                AlgoliaSearchHelper.prototype.toggleExclude = function () {
                    return this.toggleFacetExclusion.apply(this, arguments);
                };

                /**
                 * Adds or removes a filter to a facetted attribute with the `value` provided. If
                 * the value is set then it removes it, otherwise it adds the filter.
                 *
                 * This method can be used for conjunctive, disjunctive and hierarchical filters.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} value the associated value
                 * @return {AlgoliaSearchHelper}
                 * @throws Error will throw an error if the facet is not declared in the settings of the helper
                 * @fires change
                 * @chainable
                 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
                 */
                AlgoliaSearchHelper.prototype.toggleRefinement = function (
                    facet,
                    value
                ) {
                    return this.toggleFacetRefinement(facet, value);
                };

                /**
                 * Adds or removes a filter to a facetted attribute with the `value` provided. If
                 * the value is set then it removes it, otherwise it adds the filter.
                 *
                 * This method can be used for conjunctive, disjunctive and hierarchical filters.
                 *
                 * This method resets the current page to 0.
                 * @param  {string} facet the facet to refine
                 * @param  {string} value the associated value
                 * @return {AlgoliaSearchHelper}
                 * @throws Error will throw an error if the facet is not declared in the settings of the helper
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.toggleFacetRefinement = function (
                    facet,
                    value
                ) {
                    this.state = this.state
                        .setPage(0)
                        .toggleFacetRefinement(facet, value);

                    this._change();
                    return this;
                };

                /**
                 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
                 */
                AlgoliaSearchHelper.prototype.toggleRefine = function () {
                    return this.toggleFacetRefinement.apply(this, arguments);
                };

                /**
                 * Adds or removes a tag filter with the `value` provided. If
                 * the value is set then it removes it, otherwise it adds the filter.
                 *
                 * This method resets the current page to 0.
                 * @param {string} tag tag to remove or add
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.toggleTag = function (tag) {
                    this.state = this.state.setPage(0).toggleTagRefinement(tag);
                    this._change();
                    return this;
                };

                /**
                 * Increments the page number by one.
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 * @example
                 * helper.setPage(0).nextPage().getPage();
                 * // returns 1
                 */
                AlgoliaSearchHelper.prototype.nextPage = function () {
                    return this.setPage(this.state.page + 1);
                };

                /**
                 * Decrements the page number by one.
                 * @fires change
                 * @return {AlgoliaSearchHelper}
                 * @chainable
                 * @example
                 * helper.setPage(1).previousPage().getPage();
                 * // returns 0
                 */
                AlgoliaSearchHelper.prototype.previousPage = function () {
                    return this.setPage(this.state.page - 1);
                };

                /**
                 * @private
                 */
                function setCurrentPage(page) {
                    if (page < 0) throw new Error("Page requested below 0.");

                    this.state = this.state.setPage(page);
                    this._change();
                    return this;
                }

                /**
                 * Change the current page
                 * @deprecated
                 * @param  {number} page The page number
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.setCurrentPage = setCurrentPage;

                /**
                 * Updates the current page.
                 * @function
                 * @param  {number} page The page number
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.setPage = setCurrentPage;

                /**
                 * Updates the name of the index that will be targeted by the query.
                 *
                 * This method resets the current page to 0.
                 * @param {string} name the index name
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.setIndex = function (name) {
                    this.state = this.state.setPage(0).setIndex(name);
                    this._change();
                    return this;
                };

                /**
                 * Update a parameter of the search. This method reset the page
                 *
                 * The complete list of parameters is available on the
                 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
                 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
                 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
                 *
                 * This method resets the current page to 0.
                 * @param {string} parameter name of the parameter to update
                 * @param {any} value new value of the parameter
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 * @example
                 * helper.setQueryParameter('hitsPerPage', 20).search();
                 */
                AlgoliaSearchHelper.prototype.setQueryParameter = function (
                    parameter,
                    value
                ) {
                    var newState = this.state
                        .setPage(0)
                        .setQueryParameter(parameter, value);

                    if (this.state === newState) return this;

                    this.state = newState;
                    this._change();
                    return this;
                };

                /**
                 * Set the whole state (warning: will erase previous state)
                 * @param {SearchParameters} newState the whole new state
                 * @return {AlgoliaSearchHelper}
                 * @fires change
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.setState = function (newState) {
                    this.state = new SearchParameters(newState);
                    this._change();
                    return this;
                };

                /**
                 * Get the current search state stored in the helper. This object is immutable.
                 * @param {string[]} [filters] optionnal filters to retrieve only a subset of the state
                 * @return {SearchParameters|object} if filters is specified a plain object is
                 * returned containing only the requested fields, otherwise return the unfiltered
                 * state
                 * @example
                 * // Get the complete state as stored in the helper
                 * helper.getState();
                 * @example
                 * // Get a part of the state with all the refinements on attributes and the query
                 * helper.getState(['query', 'attribute:category']);
                 */
                AlgoliaSearchHelper.prototype.getState = function (filters) {
                    if (filters === undefined) return this.state;
                    return this.state.filter(filters);
                };

                /**
                 * DEPRECATED Get part of the state as a query string. By default, the output keys will not
                 * be prefixed and will only take the applied refinements and the query.
                 * @deprecated
                 * @param {object} [options] May contain the following parameters :
                 *
                 * **filters** : possible values are all the keys of the [SearchParameters](#searchparameters), `index` for
                 * the index, all the refinements with `attribute:*` or for some specific attributes with
                 * `attribute:theAttribute`
                 *
                 * **prefix** : prefix in front of the keys
                 *
                 * **moreAttributes** : more values to be added in the query string. Those values
                 *    won't be prefixed.
                 * @return {string} the query string
                 */
                AlgoliaSearchHelper.prototype.getStateAsQueryString =
                    function getStateAsQueryString(options) {
                        var filters = (options && options.filters) || [
                            "query",
                            "attribute:*",
                        ];
                        var partialState = this.getState(filters);

                        return url.getQueryStringFromState(
                            partialState,
                            options
                        );
                    };

                /**
                 * DEPRECATED Read a query string and return an object containing the state. Use
                 * url module.
                 * @deprecated
                 * @static
                 * @param {string} queryString the query string that will be decoded
                 * @param {object} options accepted options :
                 *   - prefix : the prefix used for the saved attributes, you have to provide the
                 *     same that was used for serialization
                 * @return {object} partial search parameters object (same properties than in the
                 * SearchParameters but not exhaustive)
                 * @see {@link url#getStateFromQueryString}
                 */
                AlgoliaSearchHelper.getConfigurationFromQueryString =
                    url.getStateFromQueryString;

                /**
                 * DEPRECATED Retrieve an object of all the properties that are not understandable as helper
                 * parameters. Use url module.
                 * @deprecated
                 * @static
                 * @param {string} queryString the query string to read
                 * @param {object} options the options
                 *   - prefixForParameters : prefix used for the helper configuration keys
                 * @return {object} the object containing the parsed configuration that doesn't
                 * to the helper
                 */
                AlgoliaSearchHelper.getForeignConfigurationInQueryString =
                    url.getUnrecognizedParametersInQueryString;

                /**
                 * DEPRECATED Overrides part of the state with the properties stored in the provided query
                 * string.
                 * @deprecated
                 * @param {string} queryString the query string containing the informations to url the state
                 * @param {object} options optionnal parameters :
                 *  - prefix : prefix used for the algolia parameters
                 *  - triggerChange : if set to true the state update will trigger a change event
                 */
                AlgoliaSearchHelper.prototype.setStateFromQueryString =
                    function (queryString, options) {
                        var triggerChange =
                            (options && options.triggerChange) || false;
                        var configuration = url.getStateFromQueryString(
                            queryString,
                            options
                        );
                        var updatedState =
                            this.state.setQueryParameters(configuration);

                        if (triggerChange) this.setState(updatedState);
                        else
                            this.overrideStateWithoutTriggeringChangeEvent(
                                updatedState
                            );
                    };

                /**
                 * Override the current state without triggering a change event.
                 * Do not use this method unless you know what you are doing. (see the example
                 * for a legit use case)
                 * @param {SearchParameters} newState the whole new state
                 * @return {AlgoliaSearchHelper}
                 * @example
                 *  helper.on('change', function(state){
                 *    // In this function you might want to find a way to store the state in the url/history
                 *    updateYourURL(state)
                 *  })
                 *  window.onpopstate = function(event){
                 *    // This is naive though as you should check if the state is really defined etc.
                 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
                 *  }
                 * @chainable
                 */
                AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent =
                    function (newState) {
                        this.state = new SearchParameters(newState);
                        return this;
                    };

                /**
                 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
                 */
                AlgoliaSearchHelper.prototype.isRefined = function (
                    facet,
                    value
                ) {
                    if (this.state.isConjunctiveFacet(facet)) {
                        return this.state.isFacetRefined(facet, value);
                    } else if (this.state.isDisjunctiveFacet(facet)) {
                        return this.state.isDisjunctiveFacetRefined(
                            facet,
                            value
                        );
                    }

                    throw new Error(
                        facet +
                            " is not properly defined in this helper configuration" +
                            "(use the facets or disjunctiveFacets keys to configure it)"
                    );
                };

                /**
                 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
                 * @param {string} attribute the name of the attribute
                 * @return {boolean} true if the attribute is filtered by at least one value
                 * @example
                 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
                 * helper.hasRefinements('price'); // false
                 * helper.addNumericRefinement('price', '>', 100);
                 * helper.hasRefinements('price'); // true
                 *
                 * helper.hasRefinements('color'); // false
                 * helper.addFacetRefinement('color', 'blue');
                 * helper.hasRefinements('color'); // true
                 *
                 * helper.hasRefinements('material'); // false
                 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
                 * helper.hasRefinements('material'); // true
                 *
                 * helper.hasRefinements('categories'); // false
                 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
                 * helper.hasRefinements('categories'); // true
                 *
                 */
                AlgoliaSearchHelper.prototype.hasRefinements = function (
                    attribute
                ) {
                    if (!isEmpty(this.state.getNumericRefinements(attribute))) {
                        return true;
                    } else if (this.state.isConjunctiveFacet(attribute)) {
                        return this.state.isFacetRefined(attribute);
                    } else if (this.state.isDisjunctiveFacet(attribute)) {
                        return this.state.isDisjunctiveFacetRefined(attribute);
                    } else if (this.state.isHierarchicalFacet(attribute)) {
                        return this.state.isHierarchicalFacetRefined(attribute);
                    }

                    // there's currently no way to know that the user did call `addNumericRefinement` at some point
                    // thus we cannot distinguish if there once was a numeric refinement that was cleared
                    // so we will return false in every other situations to be consistent
                    // while what we should do here is throw because we did not find the attribute in any type
                    // of refinement
                    return false;
                };

                /**
                 * Check if a value is excluded for a specific facetted attribute. If the value
                 * is omitted then the function checks if there is any excluding refinements.
                 *
                 * @param  {string}  facet name of the attribute for used for facetting
                 * @param  {string}  [value] optionnal value. If passed will test that this value
                 * is filtering the given facet.
                 * @return {boolean} true if refined
                 * @example
                 * helper.isExcludeRefined('color'); // false
                 * helper.isExcludeRefined('color', 'blue') // false
                 * helper.isExcludeRefined('color', 'red') // false
                 *
                 * helper.addFacetExclusion('color', 'red');
                 *
                 * helper.isExcludeRefined('color'); // true
                 * helper.isExcludeRefined('color', 'blue') // false
                 * helper.isExcludeRefined('color', 'red') // true
                 */
                AlgoliaSearchHelper.prototype.isExcluded = function (
                    facet,
                    value
                ) {
                    return this.state.isExcludeRefined(facet, value);
                };

                /**
                 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
                 */
                AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function (
                    facet,
                    value
                ) {
                    return this.state.isDisjunctiveFacetRefined(facet, value);
                };

                /**
                 * Check if the string is a currently filtering tag.
                 * @param {string} tag tag to check
                 * @return {boolean}
                 */
                AlgoliaSearchHelper.prototype.hasTag = function (tag) {
                    return this.state.isTagRefined(tag);
                };

                /**
                 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
                 */
                AlgoliaSearchHelper.prototype.isTagRefined = function () {
                    return this.hasTagRefinements.apply(this, arguments);
                };

                /**
                 * Get the name of the currently used index.
                 * @return {string}
                 * @example
                 * helper.setIndex('highestPrice_products').getIndex();
                 * // returns 'highestPrice_products'
                 */
                AlgoliaSearchHelper.prototype.getIndex = function () {
                    return this.state.index;
                };

                function getCurrentPage() {
                    return this.state.page;
                }

                /**
                 * Get the currently selected page
                 * @deprecated
                 * @return {number} the current page
                 */
                AlgoliaSearchHelper.prototype.getCurrentPage = getCurrentPage;
                /**
                 * Get the currently selected page
                 * @function
                 * @return {number} the current page
                 */
                AlgoliaSearchHelper.prototype.getPage = getCurrentPage;

                /**
                 * Get all the tags currently set to filters the results.
                 *
                 * @return {string[]} The list of tags currently set.
                 */
                AlgoliaSearchHelper.prototype.getTags = function () {
                    return this.state.tagRefinements;
                };

                /**
                 * Get a parameter of the search by its name. It is possible that a parameter is directly
                 * defined in the index dashboard, but it will be undefined using this method.
                 *
                 * The complete list of parameters is
                 * available on the
                 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
                 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
                 * or benefit from higher-level APIs (all the kind of filters have their own API)
                 * @param {string} parameterName the parameter name
                 * @return {any} the parameter value
                 * @example
                 * var hitsPerPage = helper.getQueryParameter('hitsPerPage');
                 */
                AlgoliaSearchHelper.prototype.getQueryParameter = function (
                    parameterName
                ) {
                    return this.state.getQueryParameter(parameterName);
                };

                /**
                 * Get the list of refinements for a given attribute. This method works with
                 * conjunctive, disjunctive, excluding and numerical filters.
                 *
                 * See also SearchResults#getRefinements
                 *
                 * @param {string} facetName attribute name used for facetting
                 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
                 * a type. Numeric also contains an operator.
                 * @example
                 * helper.addNumericRefinement('price', '>', 100);
                 * helper.getRefinements('price');
                 * // [
                 * //   {
                 * //     "value": [
                 * //       100
                 * //     ],
                 * //     "operator": ">",
                 * //     "type": "numeric"
                 * //   }
                 * // ]
                 * @example
                 * helper.addFacetRefinement('color', 'blue');
                 * helper.addFacetExclusion('color', 'red');
                 * helper.getRefinements('color');
                 * // [
                 * //   {
                 * //     "value": "blue",
                 * //     "type": "conjunctive"
                 * //   },
                 * //   {
                 * //     "value": "red",
                 * //     "type": "exclude"
                 * //   }
                 * // ]
                 * @example
                 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
                 * // [
                 * //   {
                 * //     "value": "plastic",
                 * //     "type": "disjunctive"
                 * //   }
                 * // ]
                 */
                AlgoliaSearchHelper.prototype.getRefinements = function (
                    facetName
                ) {
                    var refinements = [];

                    if (this.state.isConjunctiveFacet(facetName)) {
                        var conjRefinements =
                            this.state.getConjunctiveRefinements(facetName);

                        forEach(conjRefinements, function (r) {
                            refinements.push({
                                value: r,
                                type: "conjunctive",
                            });
                        });

                        var excludeRefinements =
                            this.state.getExcludeRefinements(facetName);

                        forEach(excludeRefinements, function (r) {
                            refinements.push({
                                value: r,
                                type: "exclude",
                            });
                        });
                    } else if (this.state.isDisjunctiveFacet(facetName)) {
                        var disjRefinements =
                            this.state.getDisjunctiveRefinements(facetName);

                        forEach(disjRefinements, function (r) {
                            refinements.push({
                                value: r,
                                type: "disjunctive",
                            });
                        });
                    }

                    var numericRefinements =
                        this.state.getNumericRefinements(facetName);

                    forEach(numericRefinements, function (value, operator) {
                        refinements.push({
                            value: value,
                            operator: operator,
                            type: "numeric",
                        });
                    });

                    return refinements;
                };

                /**
                 * Return the current refinement for the (attribute, operator)
                 * @param {string} attribute of the record
                 * @param {string} operator applied
                 * @return {number} value of the refinement
                 */
                AlgoliaSearchHelper.prototype.getNumericRefinement = function (
                    attribute,
                    operator
                ) {
                    return this.state.getNumericRefinement(attribute, operator);
                };

                /**
                 * Get the current breadcrumb for a hierarchical facet, as an array
                 * @param  {string} facetName Hierarchical facet name
                 * @return {array.<string>} the path as an array of string
                 */
                AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb =
                    function (facetName) {
                        return this.state.getHierarchicalFacetBreadcrumb(
                            facetName
                        );
                    };

                // /////////// PRIVATE

                /**
                 * Perform the underlying queries
                 * @private
                 * @return {undefined}
                 * @fires search
                 * @fires result
                 * @fires error
                 */
                AlgoliaSearchHelper.prototype._search = function () {
                    var state = this.state;
                    var mainQueries = requestBuilder._getQueries(
                        state.index,
                        state
                    );

                    var states = [
                        {
                            state: state,
                            queriesCount: mainQueries.length,
                            helper: this,
                        },
                    ];

                    this.emit("search", state, this.lastResults);

                    var derivedQueries = map(
                        this.derivedHelpers,
                        function (derivedHelper) {
                            var derivedState =
                                derivedHelper.getModifiedState(state);
                            var queries = requestBuilder._getQueries(
                                derivedState.index,
                                derivedState
                            );
                            states.push({
                                state: derivedState,
                                queriesCount: queries.length,
                                helper: derivedHelper,
                            });
                            derivedHelper.emit(
                                "search",
                                derivedState,
                                derivedHelper.lastResults
                            );
                            return queries;
                        }
                    );

                    var queries = mainQueries.concat(flatten(derivedQueries));
                    var queryId = this._queryId++;

                    this.client.search(
                        queries,
                        this._dispatchAlgoliaResponse.bind(
                            this,
                            states,
                            queryId
                        )
                    );
                };

                /**
                 * Transform the responses as sent by the server and transform them into a user
                 * usable objet that merge the results of all the batch requests. It will dispatch
                 * over the different helper + derived helpers (when there are some).
                 * @private
                 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>}
                 *  state state used for to generate the request
                 * @param {number} queryId id of the current request
                 * @param {Error} err error if any, null otherwise
                 * @param {object} content content of the response
                 * @return {undefined}
                 */
                AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse =
                    function (states, queryId, err, content) {
                        if (queryId < this._lastQueryIdReceived) {
                            // Outdated answer
                            return;
                        }

                        this._lastQueryIdReceived = queryId;

                        if (err) {
                            this.emit("error", err);
                            return;
                        }

                        var results = content.results;
                        forEach(states, function (s) {
                            var state = s.state;
                            var queriesCount = s.queriesCount;
                            var helper = s.helper;

                            helper.ogContent = content;
                            helper.sizeOptions = content.size_options;
                            helper.additionalResults =
                                content.additional_results;

                            var specificResults = results.splice(
                                0,
                                queriesCount
                            );

                            var formattedResponse = (helper.lastResults =
                                new SearchResults(state, specificResults));
                            helper.emit("result", formattedResponse, state);
                        });
                    };

                AlgoliaSearchHelper.prototype.containsRefinement = function (
                    query,
                    facetFilters,
                    numericFilters,
                    tagFilters
                ) {
                    return (
                        query ||
                        facetFilters.length !== 0 ||
                        numericFilters.length !== 0 ||
                        tagFilters.length !== 0
                    );
                };

                /**
                 * Test if there are some disjunctive refinements on the facet
                 * @private
                 * @param {string} facet the attribute to test
                 * @return {boolean}
                 */
                AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements =
                    function (facet) {
                        return (
                            this.state.disjunctiveRefinements[facet] &&
                            this.state.disjunctiveRefinements[facet].length > 0
                        );
                    };

                AlgoliaSearchHelper.prototype._change = function () {
                    this.emit("change", this.state, this.lastResults);
                };

                /**
                 * Clears the cache of the underlying Algolia client.
                 * @return {AlgoliaSearchHelper}
                 */
                AlgoliaSearchHelper.prototype.clearCache = function () {
                    this.client.clearCache();
                    return this;
                };

                /**
                 * Updates the internal client instance. If the reference of the clients
                 * are equal then no update is actually done.
                 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
                 * @return {AlgoliaSearchHelper}
                 */
                AlgoliaSearchHelper.prototype.setClient = function (newClient) {
                    if (this.client === newClient) return this;

                    if (
                        newClient.addAlgoliaAgent &&
                        !doesClientAgentContainsHelper(newClient)
                    )
                        newClient.addAlgoliaAgent("JS Helper " + version);
                    this.client = newClient;

                    return this;
                };

                /**
                 * Gets the instance of the currently used client.
                 * @return {AlgoliaSearch}
                 */
                AlgoliaSearchHelper.prototype.getClient = function () {
                    return this.client;
                };

                /**
                 * Creates an derived instance of the Helper. A derived helper
                 * is a way to request other indices synchronised with the lifecycle
                 * of the main Helper. This mechanism uses the multiqueries feature
                 * of Algolia to aggregate all the requests in a single network call.
                 *
                 * This method takes a function that is used to create a new SearchParameter
                 * that will be used to create requests to Algolia. Those new requests
                 * are created just before the `search` event. The signature of the function
                 * is `SearchParameters -> SearchParameters`.
                 *
                 * This method returns a new DerivedHelper which is an EventEmitter
                 * that fires the same `search`, `results` and `error` events. Those
                 * events, however, will receive data specific to this DerivedHelper
                 * and the SearchParameters that is returned by the call of the
                 * parameter function.
                 * @param {function} fn SearchParameters -> SearchParameters
                 * @return {DerivedHelper}
                 */
                AlgoliaSearchHelper.prototype.derive = function (fn) {
                    var derivedHelper = new DerivedHelper(this, fn);
                    this.derivedHelpers.push(derivedHelper);
                    return derivedHelper;
                };

                /**
                 * This method detaches a derived Helper from the main one. Prefer using the one from the
                 * derived helper itself, to remove the event listeners too.
                 * @private
                 * @return {undefined}
                 * @throws Error
                 */
                AlgoliaSearchHelper.prototype.detachDerivedHelper = function (
                    derivedHelper
                ) {
                    var pos = this.derivedHelpers.indexOf(derivedHelper);
                    if (pos === -1)
                        throw new Error("Derived helper already detached");
                    this.derivedHelpers.splice(pos, 1);
                };

                /**
                 * @typedef AlgoliaSearchHelper.NumericRefinement
                 * @type {object}
                 * @property {number[]} value the numbers that are used for filtering this attribute with
                 * the operator specified.
                 * @property {string} operator the facetting data: value, number of entries
                 * @property {string} type will be 'numeric'
                 */

                /**
                 * @typedef AlgoliaSearchHelper.FacetRefinement
                 * @type {object}
                 * @property {string} value the string use to filter the attribute
                 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
                 */

                /*
                 * This function tests if the _ua parameter of the client
                 * already contains the JS Helper UA
                 */
                function doesClientAgentContainsHelper(client) {
                    // this relies on JS Client internal variable, this might break if implementation changes
                    var currentAgent = client._ua;
                    return !currentAgent
                        ? false
                        : currentAgent.indexOf("JS Helper") !== -1;
                }

                module.exports = AlgoliaSearchHelper;

                /***/
            },
            /* 40 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var keys = __webpack_require__(41);
                var intersection = __webpack_require__(70);
                var forOwn = __webpack_require__(124);
                var forEach = __webpack_require__(129);
                var filter = __webpack_require__(133);
                var map = __webpack_require__(185);
                var reduce = __webpack_require__(187);
                var omit = __webpack_require__(190);
                var indexOf = __webpack_require__(230);
                var isNaN = __webpack_require__(234);
                var isArray = __webpack_require__(53);
                var isEmpty = __webpack_require__(236);
                var isEqual = __webpack_require__(237);
                var isUndefined = __webpack_require__(238);
                var isString = __webpack_require__(239);
                var isFunction = __webpack_require__(68);
                var find = __webpack_require__(240);
                var trim = __webpack_require__(243);

                var defaults = __webpack_require__(251);
                var merge = __webpack_require__(256);

                var valToNumber = __webpack_require__(261);

                var filterState = __webpack_require__(262);

                var RefinementList = __webpack_require__(263);

                /**
                 * like _.find but using _.isEqual to be able to use it
                 * to find arrays.
                 * @private
                 * @param {any[]} array array to search into
                 * @param {any} searchedValue the value we're looking for
                 * @return {any} the searched value or undefined
                 */
                function findArray(array, searchedValue) {
                    return find(array, function (currentValue) {
                        return isEqual(currentValue, searchedValue);
                    });
                }

                /**
                 * The facet list is the structure used to store the list of values used to
                 * filter a single attribute.
                 * @typedef {string[]} SearchParameters.FacetList
                 */

                /**
                 * Structure to store numeric filters with the operator as the key. The supported operators
                 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
                 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
                 */

                /**
	 * SearchParameters is the data structure that contains all the information
	 * usable for making a search to Algolia API. It doesn't do the search itself,
	 * nor does it contains logic about the parameters.
	 * It is an immutable object, therefore it has been created in a way that each
	 * changes does not change the object itself but returns a copy with the
	 * modification.
	 * This object should probably not be instantiated outside of the helper. It will
	 * be provided when needed. This object is documented for reference as you'll
	 * get it from events generated by the {@link AlgoliaSearchHelper}.
	 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
	 * @constructor
	 * @classdesc contains all the parameters of a search
	 * @param {object|SearchParameters} newParameters existing parameters or partial object
	 * for the properties of a new SearchParameters
	 * @see SearchParameters.make
	 * @example <caption>SearchParameters of the first query in
	 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
	{
	   "query": "",
	   "disjunctiveFacets": [
	      "customerReviewCount",
	      "category",
	      "salePrice_range",
	      "manufacturer"
	  ],
	   "maxValuesPerFacet": 30,
	   "page": 0,
	   "hitsPerPage": 10,
	   "facets": [
	      "type",
	      "shipping"
	  ]
	}
	 */
                function SearchParameters(newParameters) {
                    var params = newParameters
                        ? SearchParameters._parseNumbers(newParameters)
                        : {};

                    /**
                     * Targeted index. This parameter is mandatory.
                     * @member {string}
                     */
                    this.index = params.index || "";

                    // Query
                    /**
                     * Query string of the instant search. The empty string is a valid query.
                     * @member {string}
                     * @see https://www.algolia.com/doc/rest#param-query
                     */
                    this.query = params.query || "";

                    // Facets
                    /**
                     * This attribute contains the list of all the conjunctive facets
                     * used. This list will be added to requested facets in the
                     * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
                     * @member {string[]}
                     */
                    this.facets = params.facets || [];
                    /**
                     * This attribute contains the list of all the disjunctive facets
                     * used. This list will be added to requested facets in the
                     * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
                     * @member {string[]}
                     */
                    this.disjunctiveFacets = params.disjunctiveFacets || [];
                    /**
                     * This attribute contains the list of all the hierarchical facets
                     * used. This list will be added to requested facets in the
                     * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
                     * Hierarchical facets are a sub type of disjunctive facets that
                     * let you filter faceted attributes hierarchically.
                     * @member {string[]|object[]}
                     */
                    this.hierarchicalFacets = params.hierarchicalFacets || [];

                    // Refinements
                    /**
                     * This attribute contains all the filters that need to be
                     * applied on the conjunctive facets. Each facet must be properly
                     * defined in the `facets` attribute.
                     *
                     * The key is the name of the facet, and the `FacetList` contains all
                     * filters selected for the associated facet name.
                     *
                     * When querying algolia, the values stored in this attribute will
                     * be translated into the `facetFiters` attribute.
                     * @member {Object.<string, SearchParameters.FacetList>}
                     */
                    this.facetsRefinements = params.facetsRefinements || {};
                    /**
                     * This attribute contains all the filters that need to be
                     * excluded from the conjunctive facets. Each facet must be properly
                     * defined in the `facets` attribute.
                     *
                     * The key is the name of the facet, and the `FacetList` contains all
                     * filters excluded for the associated facet name.
                     *
                     * When querying algolia, the values stored in this attribute will
                     * be translated into the `facetFiters` attribute.
                     * @member {Object.<string, SearchParameters.FacetList>}
                     */
                    this.facetsExcludes = params.facetsExcludes || {};
                    /**
                     * This attribute contains all the filters that need to be
                     * applied on the disjunctive facets. Each facet must be properly
                     * defined in the `disjunctiveFacets` attribute.
                     *
                     * The key is the name of the facet, and the `FacetList` contains all
                     * filters selected for the associated facet name.
                     *
                     * When querying algolia, the values stored in this attribute will
                     * be translated into the `facetFiters` attribute.
                     * @member {Object.<string, SearchParameters.FacetList>}
                     */
                    this.disjunctiveFacetsRefinements =
                        params.disjunctiveFacetsRefinements || {};
                    /**
                     * This attribute contains all the filters that need to be
                     * applied on the numeric attributes.
                     *
                     * The key is the name of the attribute, and the value is the
                     * filters to apply to this attribute.
                     *
                     * When querying algolia, the values stored in this attribute will
                     * be translated into the `numericFilters` attribute.
                     * @member {Object.<string, SearchParameters.OperatorList>}
                     */
                    this.numericRefinements = params.numericRefinements || {};
                    /**
                     * This attribute contains all the tags used to refine the query.
                     *
                     * When querying algolia, the values stored in this attribute will
                     * be translated into the `tagFilters` attribute.
                     * @member {string[]}
                     */
                    this.tagRefinements = params.tagRefinements || [];
                    /**
                     * This attribute contains all the filters that need to be
                     * applied on the hierarchical facets. Each facet must be properly
                     * defined in the `hierarchicalFacets` attribute.
                     *
                     * The key is the name of the facet, and the `FacetList` contains all
                     * filters selected for the associated facet name. The FacetList values
                     * are structured as a string that contain the values for each level
                     * seperated by the configured separator.
                     *
                     * When querying algolia, the values stored in this attribute will
                     * be translated into the `facetFiters` attribute.
                     * @member {Object.<string, SearchParameters.FacetList>}
                     */
                    this.hierarchicalFacetsRefinements =
                        params.hierarchicalFacetsRefinements || {};

                    /**
                     * Contains the numeric filters in the raw format of the Algolia API. Setting
                     * this parameter is not compatible with the usage of numeric filters methods.
                     * @see https://www.algolia.com/doc/javascript#numericFilters
                     * @member {string}
                     */
                    this.numericFilters = params.numericFilters;

                    /**
                     * Contains the tag filters in the raw format of the Algolia API. Setting this
                     * parameter is not compatible with the of the add/remove/toggle methods of the
                     * tag api.
                     * @see https://www.algolia.com/doc/rest#param-tagFilters
                     * @member {string}
                     */
                    this.tagFilters = params.tagFilters;

                    /**
                     * Contains the optional tag filters in the raw format of the Algolia API.
                     * @see https://www.algolia.com/doc/rest#param-tagFilters
                     * @member {string}
                     */
                    this.optionalTagFilters = params.optionalTagFilters;

                    /**
                     * Contains the optional facet filters in the raw format of the Algolia API.
                     * @see https://www.algolia.com/doc/rest#param-tagFilters
                     * @member {string}
                     */
                    this.optionalFacetFilters = params.optionalFacetFilters;

                    // Misc. parameters
                    /**
                     * Number of hits to be returned by the search API
                     * @member {number}
                     * @see https://www.algolia.com/doc/rest#param-hitsPerPage
                     */
                    this.hitsPerPage = params.hitsPerPage;
                    /**
                     * Number of values for each facetted attribute
                     * @member {number}
                     * @see https://www.algolia.com/doc/rest#param-maxValuesPerFacet
                     */
                    this.maxValuesPerFacet = params.maxValuesPerFacet;
                    /**
                     * The current page number
                     * @member {number}
                     * @see https://www.algolia.com/doc/rest#param-page
                     */
                    this.page = params.page || 0;
                    /**
                     * How the query should be treated by the search engine.
                     * Possible values: prefixAll, prefixLast, prefixNone
                     * @see https://www.algolia.com/doc/rest#param-queryType
                     * @member {string}
                     */
                    this.queryType = params.queryType;
                    /**
                     * How the typo tolerance behave in the search engine.
                     * Possible values: true, false, min, strict
                     * @see https://www.algolia.com/doc/rest#param-typoTolerance
                     * @member {string}
                     */
                    this.typoTolerance = params.typoTolerance;

                    /**
                     * Number of characters to wait before doing one character replacement.
                     * @see https://www.algolia.com/doc/rest#param-minWordSizefor1Typo
                     * @member {number}
                     */
                    this.minWordSizefor1Typo = params.minWordSizefor1Typo;
                    /**
                     * Number of characters to wait before doing a second character replacement.
                     * @see https://www.algolia.com/doc/rest#param-minWordSizefor2Typos
                     * @member {number}
                     */
                    this.minWordSizefor2Typos = params.minWordSizefor2Typos;
                    /**
                     * Configure the precision of the proximity ranking criterion
                     * @see https://www.algolia.com/doc/rest#param-minProximity
                     */
                    this.minProximity = params.minProximity;
                    /**
                     * Should the engine allow typos on numerics.
                     * @see https://www.algolia.com/doc/rest#param-allowTyposOnNumericTokens
                     * @member {boolean}
                     */
                    this.allowTyposOnNumericTokens =
                        params.allowTyposOnNumericTokens;
                    /**
                     * Should the plurals be ignored
                     * @see https://www.algolia.com/doc/rest#param-ignorePlurals
                     * @member {boolean}
                     */
                    this.ignorePlurals = params.ignorePlurals;
                    /**
                     * Restrict which attribute is searched.
                     * @see https://www.algolia.com/doc/rest#param-restrictSearchableAttributes
                     * @member {string}
                     */
                    this.restrictSearchableAttributes =
                        params.restrictSearchableAttributes;
                    /**
                     * Enable the advanced syntax.
                     * @see https://www.algolia.com/doc/rest#param-advancedSyntax
                     * @member {boolean}
                     */
                    this.advancedSyntax = params.advancedSyntax;
                    /**
                     * Enable the analytics
                     * @see https://www.algolia.com/doc/rest#param-analytics
                     * @member {boolean}
                     */
                    this.analytics = params.analytics;
                    /**
                     * Tag of the query in the analytics.
                     * @see https://www.algolia.com/doc/rest#param-analyticsTags
                     * @member {string}
                     */
                    this.analyticsTags = params.analyticsTags;
                    /**
                     * Enable the synonyms
                     * @see https://www.algolia.com/doc/rest#param-synonyms
                     * @member {boolean}
                     */
                    this.synonyms = params.synonyms;
                    /**
                     * Should the engine replace the synonyms in the highlighted results.
                     * @see https://www.algolia.com/doc/rest#param-replaceSynonymsInHighlight
                     * @member {boolean}
                     */
                    this.replaceSynonymsInHighlight =
                        params.replaceSynonymsInHighlight;
                    /**
                     * Add some optional words to those defined in the dashboard
                     * @see https://www.algolia.com/doc/rest#param-optionalWords
                     * @member {string}
                     */
                    this.optionalWords = params.optionalWords;
                    /**
                     * Possible values are "lastWords" "firstWords" "allOptional" "none" (default)
                     * @see https://www.algolia.com/doc/rest#param-removeWordsIfNoResults
                     * @member {string}
                     */
                    this.removeWordsIfNoResults = params.removeWordsIfNoResults;
                    /**
                     * List of attributes to retrieve
                     * @see https://www.algolia.com/doc/rest#param-attributesToRetrieve
                     * @member {string}
                     */
                    this.attributesToRetrieve = params.attributesToRetrieve;
                    /**
                     * List of attributes to highlight
                     * @see https://www.algolia.com/doc/rest#param-attributesToHighlight
                     * @member {string}
                     */
                    this.attributesToHighlight = params.attributesToHighlight;
                    /**
                     * Code to be embedded on the left part of the highlighted results
                     * @see https://www.algolia.com/doc/rest#param-highlightPreTag
                     * @member {string}
                     */
                    this.highlightPreTag = params.highlightPreTag;
                    /**
                     * Code to be embedded on the right part of the highlighted results
                     * @see https://www.algolia.com/doc/rest#param-highlightPostTag
                     * @member {string}
                     */
                    this.highlightPostTag = params.highlightPostTag;
                    /**
                     * List of attributes to snippet
                     * @see https://www.algolia.com/doc/rest#param-attributesToSnippet
                     * @member {string}
                     */
                    this.attributesToSnippet = params.attributesToSnippet;
                    /**
                     * Enable the ranking informations in the response, set to 1 to activate
                     * @see https://www.algolia.com/doc/rest#param-getRankingInfo
                     * @member {number}
                     */
                    this.getRankingInfo = params.getRankingInfo;
                    /**
                     * Remove duplicates based on the index setting attributeForDistinct
                     * @see https://www.algolia.com/doc/rest#param-distinct
                     * @member {boolean|number}
                     */
                    this.distinct = params.distinct;
                    /**
                     * Center of the geo search.
                     * @see https://www.algolia.com/doc/rest#param-aroundLatLng
                     * @member {string}
                     */
                    this.aroundLatLng = params.aroundLatLng;
                    /**
                     * Center of the search, retrieve from the user IP.
                     * @see https://www.algolia.com/doc/rest#param-aroundLatLngViaIP
                     * @member {boolean}
                     */
                    this.aroundLatLngViaIP = params.aroundLatLngViaIP;
                    /**
                     * Radius of the geo search.
                     * @see https://www.algolia.com/doc/rest#param-aroundRadius
                     * @member {number}
                     */
                    this.aroundRadius = params.aroundRadius;
                    /**
                     * Precision of the geo search.
                     * @see https://www.algolia.com/doc/rest#param-aroundPrecision
                     * @member {number}
                     */
                    this.minimumAroundRadius = params.minimumAroundRadius;
                    /**
                     * Precision of the geo search.
                     * @see https://www.algolia.com/doc/rest#param-minimumAroundRadius
                     * @member {number}
                     */
                    this.aroundPrecision = params.aroundPrecision;
                    /**
                     * Geo search inside a box.
                     * @see https://www.algolia.com/doc/rest#param-insideBoundingBox
                     * @member {string}
                     */
                    this.insideBoundingBox = params.insideBoundingBox;
                    /**
                     * Geo search inside a polygon.
                     * @see https://www.algolia.com/doc/rest#param-insidePolygon
                     * @member {string}
                     */
                    this.insidePolygon = params.insidePolygon;
                    /**
                     * Allows to specify an ellipsis character for the snippet when we truncate the text
                     * (added before and after if truncated).
                     * The default value is an empty string and we recommend to set it to "…"
                     * @see https://www.algolia.com/doc/rest#param-insidePolygon
                     * @member {string}
                     */
                    this.snippetEllipsisText = params.snippetEllipsisText;
                    /**
                     * Allows to specify some attributes name on which exact won't be applied.
                     * Attributes are separated with a comma (for example "name,address" ), you can also use a
                     * JSON string array encoding (for example encodeURIComponent('["name","address"]') ).
                     * By default the list is empty.
                     * @see https://www.algolia.com/doc/rest#param-disableExactOnAttributes
                     * @member {string|string[]}
                     */
                    this.disableExactOnAttributes =
                        params.disableExactOnAttributes;
                    /**
                     * Applies 'exact' on single word queries if the word contains at least 3 characters
                     * and is not a stop word.
                     * Can take two values: true or false.
                     * By default, its set to false.
                     * @see https://www.algolia.com/doc/rest#param-enableExactOnSingleWordQuery
                     * @member {boolean}
                     */
                    this.enableExactOnSingleWordQuery =
                        params.enableExactOnSingleWordQuery;

                    // Undocumented parameters, still needed otherwise we fail
                    this.offset = params.offset;
                    this.length = params.length;

                    var self = this;
                    forOwn(
                        params,
                        function checkForUnknownParameter(
                            paramValue,
                            paramName
                        ) {
                            if (
                                SearchParameters.PARAMETERS.indexOf(
                                    paramName
                                ) === -1
                            ) {
                                self[paramName] = paramValue;
                            }
                        }
                    );
                }

                /**
                 * List all the properties in SearchParameters and therefore all the known Algolia properties
                 * This doesn't contain any beta/hidden features.
                 * @private
                 */
                SearchParameters.PARAMETERS = keys(new SearchParameters());

                /**
                 * @private
                 * @param {object} partialState full or part of a state
                 * @return {object} a new object with the number keys as number
                 */
                SearchParameters._parseNumbers = function (partialState) {
                    // Do not reparse numbers in SearchParameters, they ought to be parsed already
                    if (partialState instanceof SearchParameters)
                        return partialState;

                    var numbers = {};

                    var numberKeys = [
                        "aroundPrecision",
                        "aroundRadius",
                        "getRankingInfo",
                        "minWordSizefor2Typos",
                        "minWordSizefor1Typo",
                        "page",
                        "maxValuesPerFacet",
                        "distinct",
                        "minimumAroundRadius",
                        "hitsPerPage",
                        "minProximity",
                    ];

                    forEach(numberKeys, function (k) {
                        var value = partialState[k];
                        if (isString(value)) {
                            var parsedValue = parseFloat(value);
                            numbers[k] = isNaN(parsedValue)
                                ? value
                                : parsedValue;
                        }
                    });

                    if (partialState.numericRefinements) {
                        var numericRefinements = {};
                        forEach(
                            partialState.numericRefinements,
                            function (operators, attribute) {
                                numericRefinements[attribute] = {};
                                forEach(operators, function (values, operator) {
                                    var parsedValues = map(
                                        values,
                                        function (v) {
                                            if (isArray(v)) {
                                                return map(
                                                    v,
                                                    function (vPrime) {
                                                        if (isString(vPrime)) {
                                                            return parseFloat(
                                                                vPrime
                                                            );
                                                        }
                                                        return vPrime;
                                                    }
                                                );
                                            } else if (isString(v)) {
                                                return parseFloat(v);
                                            }
                                            return v;
                                        }
                                    );
                                    numericRefinements[attribute][operator] =
                                        parsedValues;
                                });
                            }
                        );
                        numbers.numericRefinements = numericRefinements;
                    }

                    return merge({}, partialState, numbers);
                };

                /**
                 * Factory for SearchParameters
                 * @param {object|SearchParameters} newParameters existing parameters or partial
                 * object for the properties of a new SearchParameters
                 * @return {SearchParameters} frozen instance of SearchParameters
                 */
                SearchParameters.make = function makeSearchParameters(
                    newParameters
                ) {
                    var instance = new SearchParameters(newParameters);

                    forEach(newParameters.hierarchicalFacets, function (facet) {
                        if (facet.rootPath) {
                            var currentRefinement =
                                instance.getHierarchicalRefinement(facet.name);

                            if (
                                currentRefinement.length > 0 &&
                                currentRefinement[0].indexOf(facet.rootPath) !==
                                    0
                            ) {
                                instance = instance.clearRefinements(
                                    facet.name
                                );
                            }

                            // get it again in case it has been cleared
                            currentRefinement =
                                instance.getHierarchicalRefinement(facet.name);
                            if (currentRefinement.length === 0) {
                                instance =
                                    instance.toggleHierarchicalFacetRefinement(
                                        facet.name,
                                        facet.rootPath
                                    );
                            }
                        }
                    });

                    return instance;
                };

                /**
                 * Validates the new parameters based on the previous state
                 * @param {SearchParameters} currentState the current state
                 * @param {object|SearchParameters} parameters the new parameters to set
                 * @return {Error|null} Error if the modification is invalid, null otherwise
                 */
                SearchParameters.validate = function (
                    currentState,
                    parameters
                ) {
                    var params = parameters || {};

                    if (
                        currentState.tagFilters &&
                        params.tagRefinements &&
                        params.tagRefinements.length > 0
                    ) {
                        return new Error(
                            "[Tags] Cannot switch from the managed tag API to the advanced API. It is probably " +
                                "an error, if it is really what you want, you should first clear the tags with clearTags method."
                        );
                    }

                    if (
                        currentState.tagRefinements.length > 0 &&
                        params.tagFilters
                    ) {
                        return new Error(
                            "[Tags] Cannot switch from the advanced tag API to the managed API. It is probably " +
                                "an error, if it is not, you should first clear the tags with clearTags method."
                        );
                    }

                    if (
                        currentState.numericFilters &&
                        params.numericRefinements &&
                        !isEmpty(params.numericRefinements)
                    ) {
                        return new Error(
                            "[Numeric filters] Can't switch from the advanced to the managed API. It" +
                                " is probably an error, if this is really what you want, you have to first" +
                                " clear the numeric filters."
                        );
                    }

                    if (
                        !isEmpty(currentState.numericRefinements) &&
                        params.numericFilters
                    ) {
                        return new Error(
                            "[Numeric filters] Can't switch from the managed API to the advanced. It" +
                                " is probably an error, if this is really what you want, you have to first" +
                                " clear the numeric filters."
                        );
                    }

                    return null;
                };

                SearchParameters.prototype = {
                    constructor: SearchParameters,

                    /**
                     * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
                     * @method
                     * @param {undefined|string|SearchParameters.clearCallback} [attribute] optionnal string or function
                     * - If not given, means to clear all the filters.
                     * - If `string`, means to clear all refinements for the `attribute` named filter.
                     * - If `function`, means to clear all the refinements that return truthy values.
                     * @return {SearchParameters}
                     */
                    clearRefinements: function clearRefinements(attribute) {
                        var clear = RefinementList.clearRefinement;
                        return this.setQueryParameters({
                            numericRefinements:
                                this._clearNumericRefinements(attribute),
                            facetsRefinements: clear(
                                this.facetsRefinements,
                                attribute,
                                "conjunctiveFacet"
                            ),
                            facetsExcludes: clear(
                                this.facetsExcludes,
                                attribute,
                                "exclude"
                            ),
                            disjunctiveFacetsRefinements: clear(
                                this.disjunctiveFacetsRefinements,
                                attribute,
                                "disjunctiveFacet"
                            ),
                            hierarchicalFacetsRefinements: clear(
                                this.hierarchicalFacetsRefinements,
                                attribute,
                                "hierarchicalFacet"
                            ),
                        });
                    },
                    /**
                     * Remove all the refined tags from the SearchParameters
                     * @method
                     * @return {SearchParameters}
                     */
                    clearTags: function clearTags() {
                        if (
                            this.tagFilters === undefined &&
                            this.tagRefinements.length === 0
                        )
                            return this;

                        return this.setQueryParameters({
                            tagFilters: undefined,
                            tagRefinements: [],
                        });
                    },
                    /**
                     * Set the index.
                     * @method
                     * @param {string} index the index name
                     * @return {SearchParameters}
                     */
                    setIndex: function setIndex(index) {
                        if (index === this.index) return this;

                        return this.setQueryParameters({
                            index: index,
                        });
                    },
                    /**
                     * Query setter
                     * @method
                     * @param {string} newQuery value for the new query
                     * @return {SearchParameters}
                     */
                    setQuery: function setQuery(newQuery) {
                        if (newQuery === this.query) return this;

                        return this.setQueryParameters({
                            query: newQuery,
                        });
                    },
                    /**
                     * Page setter
                     * @method
                     * @param {number} newPage new page number
                     * @return {SearchParameters}
                     */
                    setPage: function setPage(newPage) {
                        if (newPage === this.page) return this;

                        return this.setQueryParameters({
                            page: newPage,
                        });
                    },
                    /**
                     * Facets setter
                     * The facets are the simple facets, used for conjunctive (and) facetting.
                     * @method
                     * @param {string[]} facets all the attributes of the algolia records used for conjunctive facetting
                     * @return {SearchParameters}
                     */
                    setFacets: function setFacets(facets) {
                        return this.setQueryParameters({
                            facets: facets,
                        });
                    },
                    /**
                     * Disjunctive facets setter
                     * Change the list of disjunctive (or) facets the helper chan handle.
                     * @method
                     * @param {string[]} facets all the attributes of the algolia records used for disjunctive facetting
                     * @return {SearchParameters}
                     */
                    setDisjunctiveFacets: function setDisjunctiveFacets(
                        facets
                    ) {
                        return this.setQueryParameters({
                            disjunctiveFacets: facets,
                        });
                    },
                    /**
                     * HitsPerPage setter
                     * Hits per page represents the number of hits retrieved for this query
                     * @method
                     * @param {number} n number of hits retrieved per page of results
                     * @return {SearchParameters}
                     */
                    setHitsPerPage: function setHitsPerPage(n) {
                        if (this.hitsPerPage === n) return this;

                        return this.setQueryParameters({
                            hitsPerPage: n,
                        });
                    },
                    /**
                     * typoTolerance setter
                     * Set the value of typoTolerance
                     * @method
                     * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
                     * @return {SearchParameters}
                     */
                    setTypoTolerance: function setTypoTolerance(typoTolerance) {
                        if (this.typoTolerance === typoTolerance) return this;

                        return this.setQueryParameters({
                            typoTolerance: typoTolerance,
                        });
                    },
                    /**
                     * Add a numeric filter for a given attribute
                     * When value is an array, they are combined with OR
                     * When value is a single value, it will combined with AND
                     * @method
                     * @param {string} attribute attribute to set the filter on
                     * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
                     * @param {number | number[]} value value of the filter
                     * @return {SearchParameters}
                     * @example
                     * // for price = 50 or 40
                     * searchparameter.addNumericRefinement('price', '=', [50, 40]);
                     * @example
                     * // for size = 38 and 40
                     * searchparameter.addNumericRefinement('size', '=', 38);
                     * searchparameter.addNumericRefinement('size', '=', 40);
                     */
                    addNumericRefinement: function (attribute, operator, v) {
                        var value = valToNumber(v);

                        if (this.isNumericRefined(attribute, operator, value))
                            return this;

                        var mod = merge({}, this.numericRefinements);

                        mod[attribute] = merge({}, mod[attribute]);

                        if (mod[attribute][operator]) {
                            // Array copy
                            mod[attribute][operator] =
                                mod[attribute][operator].slice();
                            // Add the element. Concat can't be used here because value can be an array.
                            mod[attribute][operator].push(value);
                        } else {
                            mod[attribute][operator] = [value];
                        }

                        return this.setQueryParameters({
                            numericRefinements: mod,
                        });
                    },
                    /**
                     * Get the list of conjunctive refinements for a single facet
                     * @param {string} facetName name of the attribute used for facetting
                     * @return {string[]} list of refinements
                     */
                    getConjunctiveRefinements: function (facetName) {
                        if (!this.isConjunctiveFacet(facetName)) {
                            throw new Error(
                                facetName +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        return this.facetsRefinements[facetName] || [];
                    },
                    /**
                     * Get the list of disjunctive refinements for a single facet
                     * @param {string} facetName name of the attribute used for facetting
                     * @return {string[]} list of refinements
                     */
                    getDisjunctiveRefinements: function (facetName) {
                        if (!this.isDisjunctiveFacet(facetName)) {
                            throw new Error(
                                facetName +
                                    " is not defined in the disjunctiveFacets attribute of the helper configuration"
                            );
                        }
                        return (
                            this.disjunctiveFacetsRefinements[facetName] || []
                        );
                    },
                    /**
                     * Get the list of hierarchical refinements for a single facet
                     * @param {string} facetName name of the attribute used for facetting
                     * @return {string[]} list of refinements
                     */
                    getHierarchicalRefinement: function (facetName) {
                        // we send an array but we currently do not support multiple
                        // hierarchicalRefinements for a hierarchicalFacet
                        return (
                            this.hierarchicalFacetsRefinements[facetName] || []
                        );
                    },
                    /**
                     * Get the list of exclude refinements for a single facet
                     * @param {string} facetName name of the attribute used for facetting
                     * @return {string[]} list of refinements
                     */
                    getExcludeRefinements: function (facetName) {
                        if (!this.isConjunctiveFacet(facetName)) {
                            throw new Error(
                                facetName +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        return this.facetsExcludes[facetName] || [];
                    },

                    /**
                     * Remove all the numeric filter for a given (attribute, operator)
                     * @method
                     * @param {string} attribute attribute to set the filter on
                     * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
                     * @param {number} [number] the value to be removed
                     * @return {SearchParameters}
                     */
                    removeNumericRefinement: function (
                        attribute,
                        operator,
                        paramValue
                    ) {
                        if (paramValue !== undefined) {
                            var paramValueAsNumber = valToNumber(paramValue);
                            if (
                                !this.isNumericRefined(
                                    attribute,
                                    operator,
                                    paramValueAsNumber
                                )
                            )
                                return this;
                            return this.setQueryParameters({
                                numericRefinements:
                                    this._clearNumericRefinements(function (
                                        value,
                                        key
                                    ) {
                                        return (
                                            key === attribute &&
                                            value.op === operator &&
                                            isEqual(
                                                value.val,
                                                paramValueAsNumber
                                            )
                                        );
                                    }),
                            });
                        } else if (operator !== undefined) {
                            if (!this.isNumericRefined(attribute, operator))
                                return this;
                            return this.setQueryParameters({
                                numericRefinements:
                                    this._clearNumericRefinements(function (
                                        value,
                                        key
                                    ) {
                                        return (
                                            key === attribute &&
                                            value.op === operator
                                        );
                                    }),
                            });
                        }

                        if (!this.isNumericRefined(attribute)) return this;
                        return this.setQueryParameters({
                            numericRefinements: this._clearNumericRefinements(
                                function (value, key) {
                                    return key === attribute;
                                }
                            ),
                        });
                    },
                    /**
                     * Get the list of numeric refinements for a single facet
                     * @param {string} facetName name of the attribute used for facetting
                     * @return {SearchParameters.OperatorList[]} list of refinements
                     */
                    getNumericRefinements: function (facetName) {
                        return this.numericRefinements[facetName] || {};
                    },
                    /**
                     * Return the current refinement for the (attribute, operator)
                     * @param {string} attribute of the record
                     * @param {string} operator applied
                     * @return {number} value of the refinement
                     */
                    getNumericRefinement: function (attribute, operator) {
                        return (
                            this.numericRefinements[attribute] &&
                            this.numericRefinements[attribute][operator]
                        );
                    },
                    /**
                     * Clear numeric filters.
                     * @method
                     * @private
                     * @param {string|SearchParameters.clearCallback} [attribute] optionnal string or function
                     * - If not given, means to clear all the filters.
                     * - If `string`, means to clear all refinements for the `attribute` named filter.
                     * - If `function`, means to clear all the refinements that return truthy values.
                     * @return {Object.<string, OperatorList>}
                     */
                    _clearNumericRefinements: function _clearNumericRefinements(
                        attribute
                    ) {
                        if (isUndefined(attribute)) {
                            return {};
                        } else if (isString(attribute)) {
                            return omit(this.numericRefinements, attribute);
                        } else if (isFunction(attribute)) {
                            return reduce(
                                this.numericRefinements,
                                function (memo, operators, key) {
                                    var operatorList = {};

                                    forEach(
                                        operators,
                                        function (values, operator) {
                                            var outValues = [];
                                            forEach(values, function (value) {
                                                var predicateResult = attribute(
                                                    {
                                                        val: value,
                                                        op: operator,
                                                    },
                                                    key,
                                                    "numeric"
                                                );
                                                if (!predicateResult)
                                                    outValues.push(value);
                                            });
                                            if (!isEmpty(outValues))
                                                operatorList[operator] =
                                                    outValues;
                                        }
                                    );

                                    if (!isEmpty(operatorList))
                                        memo[key] = operatorList;

                                    return memo;
                                },
                                {}
                            );
                        }
                    },
                    /**
                     * Add a facet to the facets attribute of the helper configuration, if it
                     * isn't already present.
                     * @method
                     * @param {string} facet facet name to add
                     * @return {SearchParameters}
                     */
                    addFacet: function addFacet(facet) {
                        if (this.isConjunctiveFacet(facet)) {
                            return this;
                        }

                        return this.setQueryParameters({
                            facets: this.facets.concat([facet]),
                        });
                    },
                    /**
                     * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
                     * configuration, if it isn't already present.
                     * @method
                     * @param {string} facet disjunctive facet name to add
                     * @return {SearchParameters}
                     */
                    addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
                        if (this.isDisjunctiveFacet(facet)) {
                            return this;
                        }

                        return this.setQueryParameters({
                            disjunctiveFacets: this.disjunctiveFacets.concat([
                                facet,
                            ]),
                        });
                    },
                    /**
                     * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
                     * configuration.
                     * @method
                     * @param {object} hierarchicalFacet hierarchical facet to add
                     * @return {SearchParameters}
                     * @throws will throw an error if a hierarchical facet with the same name was already declared
                     */
                    addHierarchicalFacet: function addHierarchicalFacet(
                        hierarchicalFacet
                    ) {
                        if (this.isHierarchicalFacet(hierarchicalFacet.name)) {
                            throw new Error(
                                "Cannot declare two hierarchical facets with the same name: `" +
                                    hierarchicalFacet.name +
                                    "`"
                            );
                        }

                        return this.setQueryParameters({
                            hierarchicalFacets: this.hierarchicalFacets.concat([
                                hierarchicalFacet,
                            ]),
                        });
                    },
                    /**
                     * Add a refinement on a "normal" facet
                     * @method
                     * @param {string} facet attribute to apply the facetting on
                     * @param {string} value value of the attribute (will be converted to string)
                     * @return {SearchParameters}
                     */
                    addFacetRefinement: function addFacetRefinement(
                        facet,
                        value
                    ) {
                        if (!this.isConjunctiveFacet(facet)) {
                            throw new Error(
                                facet +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        if (
                            RefinementList.isRefined(
                                this.facetsRefinements,
                                facet,
                                value
                            )
                        )
                            return this;

                        return this.setQueryParameters({
                            facetsRefinements: RefinementList.addRefinement(
                                this.facetsRefinements,
                                facet,
                                value
                            ),
                        });
                    },
                    /**
                     * Exclude a value from a "normal" facet
                     * @method
                     * @param {string} facet attribute to apply the exclusion on
                     * @param {string} value value of the attribute (will be converted to string)
                     * @return {SearchParameters}
                     */
                    addExcludeRefinement: function addExcludeRefinement(
                        facet,
                        value
                    ) {
                        if (!this.isConjunctiveFacet(facet)) {
                            throw new Error(
                                facet +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        if (
                            RefinementList.isRefined(
                                this.facetsExcludes,
                                facet,
                                value
                            )
                        )
                            return this;

                        return this.setQueryParameters({
                            facetsExcludes: RefinementList.addRefinement(
                                this.facetsExcludes,
                                facet,
                                value
                            ),
                        });
                    },
                    /**
                     * Adds a refinement on a disjunctive facet.
                     * @method
                     * @param {string} facet attribute to apply the facetting on
                     * @param {string} value value of the attribute (will be converted to string)
                     * @return {SearchParameters}
                     */
                    addDisjunctiveFacetRefinement:
                        function addDisjunctiveFacetRefinement(facet, value) {
                            if (!this.isDisjunctiveFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the disjunctiveFacets attribute of the helper configuration"
                                );
                            }

                            if (
                                RefinementList.isRefined(
                                    this.disjunctiveFacetsRefinements,
                                    facet,
                                    value
                                )
                            )
                                return this;

                            return this.setQueryParameters({
                                disjunctiveFacetsRefinements:
                                    RefinementList.addRefinement(
                                        this.disjunctiveFacetsRefinements,
                                        facet,
                                        value
                                    ),
                            });
                        },
                    /**
                     * addTagRefinement adds a tag to the list used to filter the results
                     * @param {string} tag tag to be added
                     * @return {SearchParameters}
                     */
                    addTagRefinement: function addTagRefinement(tag) {
                        if (this.isTagRefined(tag)) return this;

                        var modification = {
                            tagRefinements: this.tagRefinements.concat(tag),
                        };

                        return this.setQueryParameters(modification);
                    },
                    /**
                     * Remove a facet from the facets attribute of the helper configuration, if it
                     * is present.
                     * @method
                     * @param {string} facet facet name to remove
                     * @return {SearchParameters}
                     */
                    removeFacet: function removeFacet(facet) {
                        if (!this.isConjunctiveFacet(facet)) {
                            return this;
                        }

                        return this.clearRefinements(facet).setQueryParameters({
                            facets: filter(this.facets, function (f) {
                                return f !== facet;
                            }),
                        });
                    },
                    /**
                     * Remove a disjunctive facet from the disjunctiveFacets attribute of the
                     * helper configuration, if it is present.
                     * @method
                     * @param {string} facet disjunctive facet name to remove
                     * @return {SearchParameters}
                     */
                    removeDisjunctiveFacet: function removeDisjunctiveFacet(
                        facet
                    ) {
                        if (!this.isDisjunctiveFacet(facet)) {
                            return this;
                        }

                        return this.clearRefinements(facet).setQueryParameters({
                            disjunctiveFacets: filter(
                                this.disjunctiveFacets,
                                function (f) {
                                    return f !== facet;
                                }
                            ),
                        });
                    },
                    /**
                     * Remove a hierarchical facet from the hierarchicalFacets attribute of the
                     * helper configuration, if it is present.
                     * @method
                     * @param {string} facet hierarchical facet name to remove
                     * @return {SearchParameters}
                     */
                    removeHierarchicalFacet: function removeHierarchicalFacet(
                        facet
                    ) {
                        if (!this.isHierarchicalFacet(facet)) {
                            return this;
                        }

                        return this.clearRefinements(facet).setQueryParameters({
                            hierarchicalFacets: filter(
                                this.hierarchicalFacets,
                                function (f) {
                                    return f.name !== facet;
                                }
                            ),
                        });
                    },
                    /**
                     * Remove a refinement set on facet. If a value is provided, it will clear the
                     * refinement for the given value, otherwise it will clear all the refinement
                     * values for the facetted attribute.
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {string} [value] value used to filter
                     * @return {SearchParameters}
                     */
                    removeFacetRefinement: function removeFacetRefinement(
                        facet,
                        value
                    ) {
                        if (!this.isConjunctiveFacet(facet)) {
                            throw new Error(
                                facet +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        if (
                            !RefinementList.isRefined(
                                this.facetsRefinements,
                                facet,
                                value
                            )
                        )
                            return this;

                        return this.setQueryParameters({
                            facetsRefinements: RefinementList.removeRefinement(
                                this.facetsRefinements,
                                facet,
                                value
                            ),
                        });
                    },
                    /**
                     * Remove a negative refinement on a facet
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {string} value value used to filter
                     * @return {SearchParameters}
                     */
                    removeExcludeRefinement: function removeExcludeRefinement(
                        facet,
                        value
                    ) {
                        if (!this.isConjunctiveFacet(facet)) {
                            throw new Error(
                                facet +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        if (
                            !RefinementList.isRefined(
                                this.facetsExcludes,
                                facet,
                                value
                            )
                        )
                            return this;

                        return this.setQueryParameters({
                            facetsExcludes: RefinementList.removeRefinement(
                                this.facetsExcludes,
                                facet,
                                value
                            ),
                        });
                    },
                    /**
                     * Remove a refinement on a disjunctive facet
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {string} value value used to filter
                     * @return {SearchParameters}
                     */
                    removeDisjunctiveFacetRefinement:
                        function removeDisjunctiveFacetRefinement(
                            facet,
                            value
                        ) {
                            if (!this.isDisjunctiveFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the disjunctiveFacets attribute of the helper configuration"
                                );
                            }
                            if (
                                !RefinementList.isRefined(
                                    this.disjunctiveFacetsRefinements,
                                    facet,
                                    value
                                )
                            )
                                return this;

                            return this.setQueryParameters({
                                disjunctiveFacetsRefinements:
                                    RefinementList.removeRefinement(
                                        this.disjunctiveFacetsRefinements,
                                        facet,
                                        value
                                    ),
                            });
                        },
                    /**
                     * Remove a tag from the list of tag refinements
                     * @method
                     * @param {string} tag the tag to remove
                     * @return {SearchParameters}
                     */
                    removeTagRefinement: function removeTagRefinement(tag) {
                        if (!this.isTagRefined(tag)) return this;

                        var modification = {
                            tagRefinements: filter(
                                this.tagRefinements,
                                function (t) {
                                    return t !== tag;
                                }
                            ),
                        };

                        return this.setQueryParameters(modification);
                    },
                    /**
                     * Generic toggle refinement method to use with facet, disjunctive facets
                     * and hierarchical facets
                     * @param  {string} facet the facet to refine
                     * @param  {string} value the associated value
                     * @return {SearchParameters}
                     * @throws will throw an error if the facet is not declared in the settings of the helper
                     * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
                     */
                    toggleRefinement: function toggleRefinement(facet, value) {
                        return this.toggleFacetRefinement(facet, value);
                    },
                    /**
                     * Generic toggle refinement method to use with facet, disjunctive facets
                     * and hierarchical facets
                     * @param  {string} facet the facet to refine
                     * @param  {string} value the associated value
                     * @return {SearchParameters}
                     * @throws will throw an error if the facet is not declared in the settings of the helper
                     */
                    toggleFacetRefinement: function toggleFacetRefinement(
                        facet,
                        value
                    ) {
                        if (this.isHierarchicalFacet(facet)) {
                            return this.toggleHierarchicalFacetRefinement(
                                facet,
                                value
                            );
                        } else if (this.isConjunctiveFacet(facet)) {
                            return this.toggleConjunctiveFacetRefinement(
                                facet,
                                value
                            );
                        } else if (this.isDisjunctiveFacet(facet)) {
                            return this.toggleDisjunctiveFacetRefinement(
                                facet,
                                value
                            );
                        }

                        throw new Error(
                            "Cannot refine the undeclared facet " +
                                facet +
                                "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets"
                        );
                    },
                    /**
                     * Switch the refinement applied over a facet/value
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {value} value value used for filtering
                     * @return {SearchParameters}
                     */
                    toggleConjunctiveFacetRefinement:
                        function toggleConjunctiveFacetRefinement(
                            facet,
                            value
                        ) {
                            if (!this.isConjunctiveFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the facets attribute of the helper configuration"
                                );
                            }

                            return this.setQueryParameters({
                                facetsRefinements:
                                    RefinementList.toggleRefinement(
                                        this.facetsRefinements,
                                        facet,
                                        value
                                    ),
                            });
                        },
                    /**
                     * Switch the refinement applied over a facet/value
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {value} value value used for filtering
                     * @return {SearchParameters}
                     */
                    toggleExcludeFacetRefinement:
                        function toggleExcludeFacetRefinement(facet, value) {
                            if (!this.isConjunctiveFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the facets attribute of the helper configuration"
                                );
                            }

                            return this.setQueryParameters({
                                facetsExcludes: RefinementList.toggleRefinement(
                                    this.facetsExcludes,
                                    facet,
                                    value
                                ),
                            });
                        },
                    /**
                     * Switch the refinement applied over a facet/value
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {value} value value used for filtering
                     * @return {SearchParameters}
                     */
                    toggleDisjunctiveFacetRefinement:
                        function toggleDisjunctiveFacetRefinement(
                            facet,
                            value
                        ) {
                            if (!this.isDisjunctiveFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the disjunctiveFacets attribute of the helper configuration"
                                );
                            }

                            return this.setQueryParameters({
                                disjunctiveFacetsRefinements:
                                    RefinementList.toggleRefinement(
                                        this.disjunctiveFacetsRefinements,
                                        facet,
                                        value
                                    ),
                            });
                        },
                    /**
                     * Switch the refinement applied over a facet/value
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {value} value value used for filtering
                     * @return {SearchParameters}
                     */
                    toggleHierarchicalFacetRefinement:
                        function toggleHierarchicalFacetRefinement(
                            facet,
                            value
                        ) {
                            if (!this.isHierarchicalFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the hierarchicalFacets attribute of the helper configuration"
                                );
                            }

                            var separator = this._getHierarchicalFacetSeparator(
                                this.getHierarchicalFacetByName(facet)
                            );

                            var mod = {};

                            var upOneOrMultipleLevel =
                                this.hierarchicalFacetsRefinements[facet] !==
                                    undefined &&
                                this.hierarchicalFacetsRefinements[facet]
                                    .length > 0 &&
                                // remove current refinement:
                                // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
                                (this.hierarchicalFacetsRefinements[
                                    facet
                                ][0] === value ||
                                    // remove a parent refinement of the current refinement:
                                    //  - refinement was 'beer > IPA > Flying dog'
                                    //  - call is toggleRefine('beer > IPA')
                                    //  - refinement should be `beer`
                                    this.hierarchicalFacetsRefinements[
                                        facet
                                    ][0].indexOf(value + separator) === 0);

                            if (upOneOrMultipleLevel) {
                                if (value.indexOf(separator) === -1) {
                                    // go back to root level
                                    mod[facet] = [];
                                } else {
                                    mod[facet] = [
                                        value.slice(
                                            0,
                                            value.lastIndexOf(separator)
                                        ),
                                    ];
                                }
                            } else {
                                mod[facet] = [value];
                            }

                            return this.setQueryParameters({
                                hierarchicalFacetsRefinements: defaults(
                                    {},
                                    mod,
                                    this.hierarchicalFacetsRefinements
                                ),
                            });
                        },

                    /**
                     * Adds a refinement on a hierarchical facet.
                     * @param {string} facet the facet name
                     * @param {string} path the hierarchical facet path
                     * @return {SearchParameter} the new state
                     * @throws Error if the facet is not defined or if the facet is refined
                     */
                    addHierarchicalFacetRefinement: function (facet, path) {
                        if (this.isHierarchicalFacetRefined(facet)) {
                            throw new Error(facet + " is already refined.");
                        }
                        var mod = {};
                        mod[facet] = [path];
                        return this.setQueryParameters({
                            hierarchicalFacetsRefinements: defaults(
                                {},
                                mod,
                                this.hierarchicalFacetsRefinements
                            ),
                        });
                    },

                    /**
                     * Removes the refinement set on a hierarchical facet.
                     * @param {string} facet the facet name
                     * @return {SearchParameter} the new state
                     * @throws Error if the facet is not defined or if the facet is not refined
                     */
                    removeHierarchicalFacetRefinement: function (facet) {
                        if (!this.isHierarchicalFacetRefined(facet)) {
                            throw new Error(facet + " is not refined.");
                        }
                        var mod = {};
                        mod[facet] = [];
                        return this.setQueryParameters({
                            hierarchicalFacetsRefinements: defaults(
                                {},
                                mod,
                                this.hierarchicalFacetsRefinements
                            ),
                        });
                    },
                    /**
                     * Switch the tag refinement
                     * @method
                     * @param {string} tag the tag to remove or add
                     * @return {SearchParameters}
                     */
                    toggleTagRefinement: function toggleTagRefinement(tag) {
                        if (this.isTagRefined(tag)) {
                            return this.removeTagRefinement(tag);
                        }

                        return this.addTagRefinement(tag);
                    },
                    /**
                     * Test if the facet name is from one of the disjunctive facets
                     * @method
                     * @param {string} facet facet name to test
                     * @return {boolean}
                     */
                    isDisjunctiveFacet: function (facet) {
                        return indexOf(this.disjunctiveFacets, facet) > -1;
                    },
                    /**
                     * Test if the facet name is from one of the hierarchical facets
                     * @method
                     * @param {string} facetName facet name to test
                     * @return {boolean}
                     */
                    isHierarchicalFacet: function (facetName) {
                        return (
                            this.getHierarchicalFacetByName(facetName) !==
                            undefined
                        );
                    },
                    /**
                     * Test if the facet name is from one of the conjunctive/normal facets
                     * @method
                     * @param {string} facet facet name to test
                     * @return {boolean}
                     */
                    isConjunctiveFacet: function (facet) {
                        return indexOf(this.facets, facet) > -1;
                    },
                    /**
                     * Returns true if the facet is refined, either for a specific value or in
                     * general.
                     * @method
                     * @param {string} facet name of the attribute for used for facetting
                     * @param {string} value, optionnal value. If passed will test that this value
                     * is filtering the given facet.
                     * @return {boolean} returns true if refined
                     */
                    isFacetRefined: function isFacetRefined(facet, value) {
                        if (!this.isConjunctiveFacet(facet)) {
                            throw new Error(
                                facet +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        return RefinementList.isRefined(
                            this.facetsRefinements,
                            facet,
                            value
                        );
                    },
                    /**
                     * Returns true if the facet contains exclusions or if a specific value is
                     * excluded.
                     *
                     * @method
                     * @param {string} facet name of the attribute for used for facetting
                     * @param {string} [value] optionnal value. If passed will test that this value
                     * is filtering the given facet.
                     * @return {boolean} returns true if refined
                     */
                    isExcludeRefined: function isExcludeRefined(facet, value) {
                        if (!this.isConjunctiveFacet(facet)) {
                            throw new Error(
                                facet +
                                    " is not defined in the facets attribute of the helper configuration"
                            );
                        }
                        return RefinementList.isRefined(
                            this.facetsExcludes,
                            facet,
                            value
                        );
                    },
                    /**
                     * Returns true if the facet contains a refinement, or if a value passed is a
                     * refinement for the facet.
                     * @method
                     * @param {string} facet name of the attribute for used for facetting
                     * @param {string} value optionnal, will test if the value is used for refinement
                     * if there is one, otherwise will test if the facet contains any refinement
                     * @return {boolean}
                     */
                    isDisjunctiveFacetRefined:
                        function isDisjunctiveFacetRefined(facet, value) {
                            if (!this.isDisjunctiveFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the disjunctiveFacets attribute of the helper configuration"
                                );
                            }
                            return RefinementList.isRefined(
                                this.disjunctiveFacetsRefinements,
                                facet,
                                value
                            );
                        },
                    /**
                     * Returns true if the facet contains a refinement, or if a value passed is a
                     * refinement for the facet.
                     * @method
                     * @param {string} facet name of the attribute for used for facetting
                     * @param {string} value optionnal, will test if the value is used for refinement
                     * if there is one, otherwise will test if the facet contains any refinement
                     * @return {boolean}
                     */
                    isHierarchicalFacetRefined:
                        function isHierarchicalFacetRefined(facet, value) {
                            if (!this.isHierarchicalFacet(facet)) {
                                throw new Error(
                                    facet +
                                        " is not defined in the hierarchicalFacets attribute of the helper configuration"
                                );
                            }

                            var refinements =
                                this.getHierarchicalRefinement(facet);

                            if (!value) {
                                return refinements.length > 0;
                            }

                            return indexOf(refinements, value) !== -1;
                        },
                    /**
                     * Test if the triple (attribute, operator, value) is already refined.
                     * If only the attribute and the operator are provided, it tests if the
                     * contains any refinement value.
                     * @method
                     * @param {string} attribute attribute for which the refinement is applied
                     * @param {string} [operator] operator of the refinement
                     * @param {string} [value] value of the refinement
                     * @return {boolean} true if it is refined
                     */
                    isNumericRefined: function isNumericRefined(
                        attribute,
                        operator,
                        value
                    ) {
                        if (isUndefined(value) && isUndefined(operator)) {
                            return !!this.numericRefinements[attribute];
                        }

                        var isOperatorDefined =
                            this.numericRefinements[attribute] &&
                            !isUndefined(
                                this.numericRefinements[attribute][operator]
                            );

                        if (isUndefined(value) || !isOperatorDefined) {
                            return isOperatorDefined;
                        }

                        var parsedValue = valToNumber(value);
                        var isAttributeValueDefined = !isUndefined(
                            findArray(
                                this.numericRefinements[attribute][operator],
                                parsedValue
                            )
                        );

                        return isOperatorDefined && isAttributeValueDefined;
                    },
                    /**
                     * Returns true if the tag refined, false otherwise
                     * @method
                     * @param {string} tag the tag to check
                     * @return {boolean}
                     */
                    isTagRefined: function isTagRefined(tag) {
                        return indexOf(this.tagRefinements, tag) !== -1;
                    },
                    /**
                     * Returns the list of all disjunctive facets refined
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {value} value value used for filtering
                     * @return {string[]}
                     */
                    getRefinedDisjunctiveFacets:
                        function getRefinedDisjunctiveFacets() {
                            // attributes used for numeric filter can also be disjunctive
                            var disjunctiveNumericRefinedFacets = intersection(
                                keys(this.numericRefinements),
                                this.disjunctiveFacets
                            );

                            return keys(this.disjunctiveFacetsRefinements)
                                .concat(disjunctiveNumericRefinedFacets)
                                .concat(this.getRefinedHierarchicalFacets());
                        },
                    /**
                     * Returns the list of all disjunctive facets refined
                     * @method
                     * @param {string} facet name of the attribute used for facetting
                     * @param {value} value value used for filtering
                     * @return {string[]}
                     */
                    getRefinedHierarchicalFacets:
                        function getRefinedHierarchicalFacets() {
                            return intersection(
                                // enforce the order between the two arrays,
                                // so that refinement name index === hierarchical facet index
                                map(this.hierarchicalFacets, "name"),
                                keys(this.hierarchicalFacetsRefinements)
                            );
                        },
                    /**
                     * Returned the list of all disjunctive facets not refined
                     * @method
                     * @return {string[]}
                     */
                    getUnrefinedDisjunctiveFacets: function () {
                        var refinedFacets = this.getRefinedDisjunctiveFacets();

                        return filter(this.disjunctiveFacets, function (f) {
                            return indexOf(refinedFacets, f) === -1;
                        });
                    },

                    managedParameters: [
                        "index",
                        "facets",
                        "disjunctiveFacets",
                        "facetsRefinements",
                        "facetsExcludes",
                        "disjunctiveFacetsRefinements",
                        "numericRefinements",
                        "tagRefinements",
                        "hierarchicalFacets",
                        "hierarchicalFacetsRefinements",
                    ],
                    getQueryParams: function getQueryParams() {
                        var managedParameters = this.managedParameters;

                        var queryParams = {};

                        forOwn(this, function (paramValue, paramName) {
                            if (
                                indexOf(managedParameters, paramName) === -1 &&
                                paramValue !== undefined
                            ) {
                                queryParams[paramName] = paramValue;
                            }
                        });

                        return queryParams;
                    },
                    /**
                     * Let the user retrieve any parameter value from the SearchParameters
                     * @param {string} paramName name of the parameter
                     * @return {any} the value of the parameter
                     */
                    getQueryParameter: function getQueryParameter(paramName) {
                        if (!this.hasOwnProperty(paramName)) {
                            throw new Error(
                                "Parameter '" +
                                    paramName +
                                    "' is not an attribute of SearchParameters " +
                                    "(http://algolia.github.io/algoliasearch-helper-js/docs/SearchParameters.html)"
                            );
                        }

                        return this[paramName];
                    },
                    /**
                     * Let the user set a specific value for a given parameter. Will return the
                     * same instance if the parameter is invalid or if the value is the same as the
                     * previous one.
                     * @method
                     * @param {string} parameter the parameter name
                     * @param {any} value the value to be set, must be compliant with the definition
                     * of the attribute on the object
                     * @return {SearchParameters} the updated state
                     */
                    setQueryParameter: function setParameter(parameter, value) {
                        if (this[parameter] === value) return this;

                        var modification = {};

                        modification[parameter] = value;

                        return this.setQueryParameters(modification);
                    },
                    /**
                     * Let the user set any of the parameters with a plain object.
                     * @method
                     * @param {object} params all the keys and the values to be updated
                     * @return {SearchParameters} a new updated instance
                     */
                    setQueryParameters: function setQueryParameters(params) {
                        if (!params) return this;

                        var error = SearchParameters.validate(this, params);

                        if (error) {
                            throw error;
                        }

                        var parsedParams =
                            SearchParameters._parseNumbers(params);

                        return this.mutateMe(function mergeWith(newInstance) {
                            var ks = keys(params);

                            forEach(ks, function (k) {
                                newInstance[k] = parsedParams[k];
                            });

                            return newInstance;
                        });
                    },

                    /**
                     * Returns an object with only the selected attributes.
                     * @param {string[]} filters filters to retrieve only a subset of the state. It
                     * accepts strings that can be either attributes of the SearchParameters (e.g. hitsPerPage)
                     * or attributes of the index with the notation 'attribute:nameOfMyAttribute'
                     * @return {object}
                     */
                    filter: function (filters) {
                        return filterState(this, filters);
                    },
                    /**
                     * Helper function to make it easier to build new instances from a mutating
                     * function
                     * @private
                     * @param {function} fn newMutableState -> previousState -> () function that will
                     * change the value of the newMutable to the desired state
                     * @return {SearchParameters} a new instance with the specified modifications applied
                     */
                    mutateMe: function mutateMe(fn) {
                        var newState = new this.constructor(this);

                        fn(newState, this);
                        return newState;
                    },

                    /**
                     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
                     * @param  {object} hierarchicalFacet
                     * @return {string} returns the hierarchicalFacet.separator or `>` as default
                     */
                    _getHierarchicalFacetSortBy: function (hierarchicalFacet) {
                        return (
                            hierarchicalFacet.sortBy || [
                                "isRefined:desc",
                                "name:asc",
                            ]
                        );
                    },

                    /**
                     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
                     * @private
                     * @param  {object} hierarchicalFacet
                     * @return {string} returns the hierarchicalFacet.separator or `>` as default
                     */
                    _getHierarchicalFacetSeparator: function (
                        hierarchicalFacet
                    ) {
                        return hierarchicalFacet.separator || " > ";
                    },

                    /**
                     * Helper function to get the hierarchicalFacet prefix path or null
                     * @private
                     * @param  {object} hierarchicalFacet
                     * @return {string} returns the hierarchicalFacet.rootPath or null as default
                     */
                    _getHierarchicalRootPath: function (hierarchicalFacet) {
                        return hierarchicalFacet.rootPath || null;
                    },

                    /**
                     * Helper function to check if we show the parent level of the hierarchicalFacet
                     * @private
                     * @param  {object} hierarchicalFacet
                     * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
                     */
                    _getHierarchicalShowParentLevel: function (
                        hierarchicalFacet
                    ) {
                        if (
                            typeof hierarchicalFacet.showParentLevel ===
                            "boolean"
                        ) {
                            return hierarchicalFacet.showParentLevel;
                        }
                        return true;
                    },

                    /**
                     * Helper function to get the hierarchicalFacet by it's name
                     * @param  {string} hierarchicalFacetName
                     * @return {object} a hierarchicalFacet
                     */
                    getHierarchicalFacetByName: function (
                        hierarchicalFacetName
                    ) {
                        return find(this.hierarchicalFacets, {
                            name: hierarchicalFacetName,
                        });
                    },

                    /**
                     * Get the current breadcrumb for a hierarchical facet, as an array
                     * @param  {string} facetName Hierarchical facet name
                     * @return {array.<string>} the path as an array of string
                     */
                    getHierarchicalFacetBreadcrumb: function (facetName) {
                        if (!this.isHierarchicalFacet(facetName)) {
                            throw new Error(
                                "Cannot get the breadcrumb of an unknown hierarchical facet: `" +
                                    facetName +
                                    "`"
                            );
                        }

                        var refinement =
                            this.getHierarchicalRefinement(facetName)[0];
                        if (!refinement) return [];

                        var separator = this._getHierarchicalFacetSeparator(
                            this.getHierarchicalFacetByName(facetName)
                        );
                        var path = refinement.split(separator);
                        return map(path, trim);
                    },
                };

                /**
                 * Callback used for clearRefinement method
                 * @callback SearchParameters.clearCallback
                 * @param {OperatorList|FacetList} value the value of the filter
                 * @param {string} key the current attribute name
                 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
                 * depending on the type of facet
                 * @return {boolean} `true` if the element should be removed. `false` otherwise.
                 */
                module.exports = SearchParameters;

                /***/
            },
            /* 41 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayLikeKeys = __webpack_require__(42),
                    baseKeys = __webpack_require__(63),
                    isArrayLike = __webpack_require__(67);

                /**
                 * Creates an array of the own enumerable property names of `object`.
                 *
                 * **Note:** Non-object values are coerced to objects. See the
                 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                 * for more details.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.keys(new Foo);
                 * // => ['a', 'b'] (iteration order is not guaranteed)
                 *
                 * _.keys('hi');
                 * // => ['0', '1']
                 */
                function keys(object) {
                    return isArrayLike(object)
                        ? arrayLikeKeys(object)
                        : baseKeys(object);
                }

                module.exports = keys;

                /***/
            },
            /* 42 */
            /***/ function (module, exports, __webpack_require__) {
                var baseTimes = __webpack_require__(43),
                    isArguments = __webpack_require__(44),
                    isArray = __webpack_require__(53),
                    isBuffer = __webpack_require__(54),
                    isIndex = __webpack_require__(57),
                    isTypedArray = __webpack_require__(58);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Creates an array of the enumerable property names of the array-like `value`.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @param {boolean} inherited Specify returning inherited property names.
                 * @returns {Array} Returns the array of property names.
                 */
                function arrayLikeKeys(value, inherited) {
                    var isArr = isArray(value),
                        isArg = !isArr && isArguments(value),
                        isBuff = !isArr && !isArg && isBuffer(value),
                        isType =
                            !isArr && !isArg && !isBuff && isTypedArray(value),
                        skipIndexes = isArr || isArg || isBuff || isType,
                        result = skipIndexes
                            ? baseTimes(value.length, String)
                            : [],
                        length = result.length;

                    for (var key in value) {
                        if (
                            (inherited || hasOwnProperty.call(value, key)) &&
                            !(
                                skipIndexes &&
                                // Safari 9 has enumerable `arguments.length` in strict mode.
                                (key == "length" ||
                                    // Node.js 0.10 has enumerable non-index properties on buffers.
                                    (isBuff &&
                                        (key == "offset" || key == "parent")) ||
                                    // PhantomJS 2 has enumerable non-index properties on typed arrays.
                                    (isType &&
                                        (key == "buffer" ||
                                            key == "byteLength" ||
                                            key == "byteOffset")) ||
                                    // Skip index properties.
                                    isIndex(key, length))
                            )
                        ) {
                            result.push(key);
                        }
                    }
                    return result;
                }

                module.exports = arrayLikeKeys;

                /***/
            },
            /* 43 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.times` without support for iteratee shorthands
                 * or max array length checks.
                 *
                 * @private
                 * @param {number} n The number of times to invoke `iteratee`.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns the array of results.
                 */
                function baseTimes(n, iteratee) {
                    var index = -1,
                        result = Array(n);

                    while (++index < n) {
                        result[index] = iteratee(index);
                    }
                    return result;
                }

                module.exports = baseTimes;

                /***/
            },
            /* 44 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIsArguments = __webpack_require__(45),
                    isObjectLike = __webpack_require__(52);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /** Built-in value references. */
                var propertyIsEnumerable = objectProto.propertyIsEnumerable;

                /**
                 * Checks if `value` is likely an `arguments` object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                 *  else `false`.
                 * @example
                 *
                 * _.isArguments(function() { return arguments; }());
                 * // => true
                 *
                 * _.isArguments([1, 2, 3]);
                 * // => false
                 */
                var isArguments = baseIsArguments(
                    (function () {
                        return arguments;
                    })()
                )
                    ? baseIsArguments
                    : function (value) {
                          return (
                              isObjectLike(value) &&
                              hasOwnProperty.call(value, "callee") &&
                              !propertyIsEnumerable.call(value, "callee")
                          );
                      };

                module.exports = isArguments;

                /***/
            },
            /* 45 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    isObjectLike = __webpack_require__(52);

                /** `Object#toString` result references. */
                var argsTag = "[object Arguments]";

                /**
                 * The base implementation of `_.isArguments`.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                 */
                function baseIsArguments(value) {
                    return isObjectLike(value) && baseGetTag(value) == argsTag;
                }

                module.exports = baseIsArguments;

                /***/
            },
            /* 46 */
            /***/ function (module, exports, __webpack_require__) {
                var Symbol = __webpack_require__(47),
                    getRawTag = __webpack_require__(50),
                    objectToString = __webpack_require__(51);

                /** `Object#toString` result references. */
                var nullTag = "[object Null]",
                    undefinedTag = "[object Undefined]";

                /** Built-in value references. */
                var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

                /**
                 * The base implementation of `getTag` without fallbacks for buggy environments.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @returns {string} Returns the `toStringTag`.
                 */
                function baseGetTag(value) {
                    if (value == null) {
                        return value === undefined ? undefinedTag : nullTag;
                    }
                    return symToStringTag && symToStringTag in Object(value)
                        ? getRawTag(value)
                        : objectToString(value);
                }

                module.exports = baseGetTag;

                /***/
            },
            /* 47 */
            /***/ function (module, exports, __webpack_require__) {
                var root = __webpack_require__(48);

                /** Built-in value references. */
                var Symbol = root.Symbol;

                module.exports = Symbol;

                /***/
            },
            /* 48 */
            /***/ function (module, exports, __webpack_require__) {
                var freeGlobal = __webpack_require__(49);

                /** Detect free variable `self`. */
                var freeSelf =
                    typeof self == "object" &&
                    self &&
                    self.Object === Object &&
                    self;

                /** Used as a reference to the global object. */
                var root = freeGlobal || freeSelf || Function("return this")();

                module.exports = root;

                /***/
            },
            /* 49 */
            /***/ function (module, exports) {
                /* WEBPACK VAR INJECTION */ (function (global) {
                    /** Detect free variable `global` from Node.js. */
                    var freeGlobal =
                        typeof global == "object" &&
                        global &&
                        global.Object === Object &&
                        global;

                    module.exports = freeGlobal;

                    /* WEBPACK VAR INJECTION */
                }.call(
                    exports,
                    (function () {
                        return this;
                    })()
                ));

                /***/
            },
            /* 50 */
            /***/ function (module, exports, __webpack_require__) {
                var Symbol = __webpack_require__(47);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Used to resolve the
                 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                 * of values.
                 */
                var nativeObjectToString = objectProto.toString;

                /** Built-in value references. */
                var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

                /**
                 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @returns {string} Returns the raw `toStringTag`.
                 */
                function getRawTag(value) {
                    var isOwn = hasOwnProperty.call(value, symToStringTag),
                        tag = value[symToStringTag];

                    try {
                        value[symToStringTag] = undefined;
                        var unmasked = true;
                    } catch (e) {}

                    var result = nativeObjectToString.call(value);
                    if (unmasked) {
                        if (isOwn) {
                            value[symToStringTag] = tag;
                        } else {
                            delete value[symToStringTag];
                        }
                    }
                    return result;
                }

                module.exports = getRawTag;

                /***/
            },
            /* 51 */
            /***/ function (module, exports) {
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /**
                 * Used to resolve the
                 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                 * of values.
                 */
                var nativeObjectToString = objectProto.toString;

                /**
                 * Converts `value` to a string using `Object.prototype.toString`.
                 *
                 * @private
                 * @param {*} value The value to convert.
                 * @returns {string} Returns the converted string.
                 */
                function objectToString(value) {
                    return nativeObjectToString.call(value);
                }

                module.exports = objectToString;

                /***/
            },
            /* 52 */
            /***/ function (module, exports) {
                /**
                 * Checks if `value` is object-like. A value is object-like if it's not `null`
                 * and has a `typeof` result of "object".
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
                 * @example
                 *
                 * _.isObjectLike({});
                 * // => true
                 *
                 * _.isObjectLike([1, 2, 3]);
                 * // => true
                 *
                 * _.isObjectLike(_.noop);
                 * // => false
                 *
                 * _.isObjectLike(null);
                 * // => false
                 */
                function isObjectLike(value) {
                    return value != null && typeof value == "object";
                }

                module.exports = isObjectLike;

                /***/
            },
            /* 53 */
            /***/ function (module, exports) {
                /**
                 * Checks if `value` is classified as an `Array` object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
                 * @example
                 *
                 * _.isArray([1, 2, 3]);
                 * // => true
                 *
                 * _.isArray(document.body.children);
                 * // => false
                 *
                 * _.isArray('abc');
                 * // => false
                 *
                 * _.isArray(_.noop);
                 * // => false
                 */
                var isArray = Array.isArray;

                module.exports = isArray;

                /***/
            },
            /* 54 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (module) {
                    var root = __webpack_require__(48),
                        stubFalse = __webpack_require__(56);

                    /** Detect free variable `exports`. */
                    var freeExports =
                        typeof exports == "object" &&
                        exports &&
                        !exports.nodeType &&
                        exports;

                    /** Detect free variable `module`. */
                    var freeModule =
                        freeExports &&
                        typeof module == "object" &&
                        module &&
                        !module.nodeType &&
                        module;

                    /** Detect the popular CommonJS extension `module.exports`. */
                    var moduleExports =
                        freeModule && freeModule.exports === freeExports;

                    /** Built-in value references. */
                    var Buffer = moduleExports ? root.Buffer : undefined;

                    /* Built-in method references for those with the same name as other `lodash` methods. */
                    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

                    /**
                     * Checks if `value` is a buffer.
                     *
                     * @static
                     * @memberOf _
                     * @since 4.3.0
                     * @category Lang
                     * @param {*} value The value to check.
                     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
                     * @example
                     *
                     * _.isBuffer(new Buffer(2));
                     * // => true
                     *
                     * _.isBuffer(new Uint8Array(2));
                     * // => false
                     */
                    var isBuffer = nativeIsBuffer || stubFalse;

                    module.exports = isBuffer;

                    /* WEBPACK VAR INJECTION */
                }.call(exports, __webpack_require__(55)(module)));

                /***/
            },
            /* 55 */
            /***/ function (module, exports) {
                module.exports = function (module) {
                    if (!module.webpackPolyfill) {
                        module.deprecate = function () {};
                        module.paths = [];
                        // module.parent = undefined by default
                        module.children = [];
                        module.webpackPolyfill = 1;
                    }
                    return module;
                };

                /***/
            },
            /* 56 */
            /***/ function (module, exports) {
                /**
                 * This method returns `false`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.13.0
                 * @category Util
                 * @returns {boolean} Returns `false`.
                 * @example
                 *
                 * _.times(2, _.stubFalse);
                 * // => [false, false]
                 */
                function stubFalse() {
                    return false;
                }

                module.exports = stubFalse;

                /***/
            },
            /* 57 */
            /***/ function (module, exports) {
                /** Used as references for various `Number` constants. */
                var MAX_SAFE_INTEGER = 9007199254740991;

                /** Used to detect unsigned integer values. */
                var reIsUint = /^(?:0|[1-9]\d*)$/;

                /**
                 * Checks if `value` is a valid array-like index.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
                 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
                 */
                function isIndex(value, length) {
                    length = length == null ? MAX_SAFE_INTEGER : length;
                    return (
                        !!length &&
                        (typeof value == "number" || reIsUint.test(value)) &&
                        value > -1 &&
                        value % 1 == 0 &&
                        value < length
                    );
                }

                module.exports = isIndex;

                /***/
            },
            /* 58 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIsTypedArray = __webpack_require__(59),
                    baseUnary = __webpack_require__(61),
                    nodeUtil = __webpack_require__(62);

                /* Node.js helper references. */
                var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

                /**
                 * Checks if `value` is classified as a typed array.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                 * @example
                 *
                 * _.isTypedArray(new Uint8Array);
                 * // => true
                 *
                 * _.isTypedArray([]);
                 * // => false
                 */
                var isTypedArray = nodeIsTypedArray
                    ? baseUnary(nodeIsTypedArray)
                    : baseIsTypedArray;

                module.exports = isTypedArray;

                /***/
            },
            /* 59 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    isLength = __webpack_require__(60),
                    isObjectLike = __webpack_require__(52);

                /** `Object#toString` result references. */
                var argsTag = "[object Arguments]",
                    arrayTag = "[object Array]",
                    boolTag = "[object Boolean]",
                    dateTag = "[object Date]",
                    errorTag = "[object Error]",
                    funcTag = "[object Function]",
                    mapTag = "[object Map]",
                    numberTag = "[object Number]",
                    objectTag = "[object Object]",
                    regexpTag = "[object RegExp]",
                    setTag = "[object Set]",
                    stringTag = "[object String]",
                    weakMapTag = "[object WeakMap]";

                var arrayBufferTag = "[object ArrayBuffer]",
                    dataViewTag = "[object DataView]",
                    float32Tag = "[object Float32Array]",
                    float64Tag = "[object Float64Array]",
                    int8Tag = "[object Int8Array]",
                    int16Tag = "[object Int16Array]",
                    int32Tag = "[object Int32Array]",
                    uint8Tag = "[object Uint8Array]",
                    uint8ClampedTag = "[object Uint8ClampedArray]",
                    uint16Tag = "[object Uint16Array]",
                    uint32Tag = "[object Uint32Array]";

                /** Used to identify `toStringTag` values of typed arrays. */
                var typedArrayTags = {};
                typedArrayTags[float32Tag] =
                    typedArrayTags[float64Tag] =
                    typedArrayTags[int8Tag] =
                    typedArrayTags[int16Tag] =
                    typedArrayTags[int32Tag] =
                    typedArrayTags[uint8Tag] =
                    typedArrayTags[uint8ClampedTag] =
                    typedArrayTags[uint16Tag] =
                    typedArrayTags[uint32Tag] =
                        true;
                typedArrayTags[argsTag] =
                    typedArrayTags[arrayTag] =
                    typedArrayTags[arrayBufferTag] =
                    typedArrayTags[boolTag] =
                    typedArrayTags[dataViewTag] =
                    typedArrayTags[dateTag] =
                    typedArrayTags[errorTag] =
                    typedArrayTags[funcTag] =
                    typedArrayTags[mapTag] =
                    typedArrayTags[numberTag] =
                    typedArrayTags[objectTag] =
                    typedArrayTags[regexpTag] =
                    typedArrayTags[setTag] =
                    typedArrayTags[stringTag] =
                    typedArrayTags[weakMapTag] =
                        false;

                /**
                 * The base implementation of `_.isTypedArray` without Node.js optimizations.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                 */
                function baseIsTypedArray(value) {
                    return (
                        isObjectLike(value) &&
                        isLength(value.length) &&
                        !!typedArrayTags[baseGetTag(value)]
                    );
                }

                module.exports = baseIsTypedArray;

                /***/
            },
            /* 60 */
            /***/ function (module, exports) {
                /** Used as references for various `Number` constants. */
                var MAX_SAFE_INTEGER = 9007199254740991;

                /**
                 * Checks if `value` is a valid array-like length.
                 *
                 * **Note:** This method is loosely based on
                 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
                 * @example
                 *
                 * _.isLength(3);
                 * // => true
                 *
                 * _.isLength(Number.MIN_VALUE);
                 * // => false
                 *
                 * _.isLength(Infinity);
                 * // => false
                 *
                 * _.isLength('3');
                 * // => false
                 */
                function isLength(value) {
                    return (
                        typeof value == "number" &&
                        value > -1 &&
                        value % 1 == 0 &&
                        value <= MAX_SAFE_INTEGER
                    );
                }

                module.exports = isLength;

                /***/
            },
            /* 61 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.unary` without support for storing metadata.
                 *
                 * @private
                 * @param {Function} func The function to cap arguments for.
                 * @returns {Function} Returns the new capped function.
                 */
                function baseUnary(func) {
                    return function (value) {
                        return func(value);
                    };
                }

                module.exports = baseUnary;

                /***/
            },
            /* 62 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (module) {
                    var freeGlobal = __webpack_require__(49);

                    /** Detect free variable `exports`. */
                    var freeExports =
                        typeof exports == "object" &&
                        exports &&
                        !exports.nodeType &&
                        exports;

                    /** Detect free variable `module`. */
                    var freeModule =
                        freeExports &&
                        typeof module == "object" &&
                        module &&
                        !module.nodeType &&
                        module;

                    /** Detect the popular CommonJS extension `module.exports`. */
                    var moduleExports =
                        freeModule && freeModule.exports === freeExports;

                    /** Detect free variable `process` from Node.js. */
                    var freeProcess = moduleExports && freeGlobal.process;

                    /** Used to access faster Node.js helpers. */
                    var nodeUtil = (function () {
                        try {
                            return (
                                freeProcess &&
                                freeProcess.binding &&
                                freeProcess.binding("util")
                            );
                        } catch (e) {}
                    })();

                    module.exports = nodeUtil;

                    /* WEBPACK VAR INJECTION */
                }.call(exports, __webpack_require__(55)(module)));

                /***/
            },
            /* 63 */
            /***/ function (module, exports, __webpack_require__) {
                var isPrototype = __webpack_require__(64),
                    nativeKeys = __webpack_require__(65);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 */
                function baseKeys(object) {
                    if (!isPrototype(object)) {
                        return nativeKeys(object);
                    }
                    var result = [];
                    for (var key in Object(object)) {
                        if (
                            hasOwnProperty.call(object, key) &&
                            key != "constructor"
                        ) {
                            result.push(key);
                        }
                    }
                    return result;
                }

                module.exports = baseKeys;

                /***/
            },
            /* 64 */
            /***/ function (module, exports) {
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /**
                 * Checks if `value` is likely a prototype object.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
                 */
                function isPrototype(value) {
                    var Ctor = value && value.constructor,
                        proto =
                            (typeof Ctor == "function" && Ctor.prototype) ||
                            objectProto;

                    return value === proto;
                }

                module.exports = isPrototype;

                /***/
            },
            /* 65 */
            /***/ function (module, exports, __webpack_require__) {
                var overArg = __webpack_require__(66);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeKeys = overArg(Object.keys, Object);

                module.exports = nativeKeys;

                /***/
            },
            /* 66 */
            /***/ function (module, exports) {
                /**
                 * Creates a unary function that invokes `func` with its argument transformed.
                 *
                 * @private
                 * @param {Function} func The function to wrap.
                 * @param {Function} transform The argument transform.
                 * @returns {Function} Returns the new function.
                 */
                function overArg(func, transform) {
                    return function (arg) {
                        return func(transform(arg));
                    };
                }

                module.exports = overArg;

                /***/
            },
            /* 67 */
            /***/ function (module, exports, __webpack_require__) {
                var isFunction = __webpack_require__(68),
                    isLength = __webpack_require__(60);

                /**
                 * Checks if `value` is array-like. A value is considered array-like if it's
                 * not a function and has a `value.length` that's an integer greater than or
                 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
                 * @example
                 *
                 * _.isArrayLike([1, 2, 3]);
                 * // => true
                 *
                 * _.isArrayLike(document.body.children);
                 * // => true
                 *
                 * _.isArrayLike('abc');
                 * // => true
                 *
                 * _.isArrayLike(_.noop);
                 * // => false
                 */
                function isArrayLike(value) {
                    return (
                        value != null &&
                        isLength(value.length) &&
                        !isFunction(value)
                    );
                }

                module.exports = isArrayLike;

                /***/
            },
            /* 68 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    isObject = __webpack_require__(69);

                /** `Object#toString` result references. */
                var asyncTag = "[object AsyncFunction]",
                    funcTag = "[object Function]",
                    genTag = "[object GeneratorFunction]",
                    proxyTag = "[object Proxy]";

                /**
                 * Checks if `value` is classified as a `Function` object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
                 * @example
                 *
                 * _.isFunction(_);
                 * // => true
                 *
                 * _.isFunction(/abc/);
                 * // => false
                 */
                function isFunction(value) {
                    if (!isObject(value)) {
                        return false;
                    }
                    // The use of `Object#toString` avoids issues with the `typeof` operator
                    // in Safari 9 which returns 'object' for typed arrays and other constructors.
                    var tag = baseGetTag(value);
                    return (
                        tag == funcTag ||
                        tag == genTag ||
                        tag == asyncTag ||
                        tag == proxyTag
                    );
                }

                module.exports = isFunction;

                /***/
            },
            /* 69 */
            /***/ function (module, exports) {
                /**
                 * Checks if `value` is the
                 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
                 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
                 * @example
                 *
                 * _.isObject({});
                 * // => true
                 *
                 * _.isObject([1, 2, 3]);
                 * // => true
                 *
                 * _.isObject(_.noop);
                 * // => true
                 *
                 * _.isObject(null);
                 * // => false
                 */
                function isObject(value) {
                    var type = typeof value;
                    return (
                        value != null &&
                        (type == "object" || type == "function")
                    );
                }

                module.exports = isObject;

                /***/
            },
            /* 70 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayMap = __webpack_require__(71),
                    baseIntersection = __webpack_require__(72),
                    baseRest = __webpack_require__(113),
                    castArrayLikeObject = __webpack_require__(122);

                /**
                 * Creates an array of unique values that are included in all given arrays
                 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons. The order and references of result values are
                 * determined by the first array.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {...Array} [arrays] The arrays to inspect.
                 * @returns {Array} Returns the new array of intersecting values.
                 * @example
                 *
                 * _.intersection([2, 1], [2, 3]);
                 * // => [2]
                 */
                var intersection = baseRest(function (arrays) {
                    var mapped = arrayMap(arrays, castArrayLikeObject);
                    return mapped.length && mapped[0] === arrays[0]
                        ? baseIntersection(mapped)
                        : [];
                });

                module.exports = intersection;

                /***/
            },
            /* 71 */
            /***/ function (module, exports) {
                /**
                 * A specialized version of `_.map` for arrays without support for iteratee
                 * shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns the new mapped array.
                 */
                function arrayMap(array, iteratee) {
                    var index = -1,
                        length = array == null ? 0 : array.length,
                        result = Array(length);

                    while (++index < length) {
                        result[index] = iteratee(array[index], index, array);
                    }
                    return result;
                }

                module.exports = arrayMap;

                /***/
            },
            /* 72 */
            /***/ function (module, exports, __webpack_require__) {
                var SetCache = __webpack_require__(73),
                    arrayIncludes = __webpack_require__(106),
                    arrayIncludesWith = __webpack_require__(111),
                    arrayMap = __webpack_require__(71),
                    baseUnary = __webpack_require__(61),
                    cacheHas = __webpack_require__(112);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMin = Math.min;

                /**
                 * The base implementation of methods like `_.intersection`, without support
                 * for iteratee shorthands, that accepts an array of arrays to inspect.
                 *
                 * @private
                 * @param {Array} arrays The arrays to inspect.
                 * @param {Function} [iteratee] The iteratee invoked per element.
                 * @param {Function} [comparator] The comparator invoked per element.
                 * @returns {Array} Returns the new array of shared values.
                 */
                function baseIntersection(arrays, iteratee, comparator) {
                    var includes = comparator
                            ? arrayIncludesWith
                            : arrayIncludes,
                        length = arrays[0].length,
                        othLength = arrays.length,
                        othIndex = othLength,
                        caches = Array(othLength),
                        maxLength = Infinity,
                        result = [];

                    while (othIndex--) {
                        var array = arrays[othIndex];
                        if (othIndex && iteratee) {
                            array = arrayMap(array, baseUnary(iteratee));
                        }
                        maxLength = nativeMin(array.length, maxLength);
                        caches[othIndex] =
                            !comparator &&
                            (iteratee || (length >= 120 && array.length >= 120))
                                ? new SetCache(othIndex && array)
                                : undefined;
                    }
                    array = arrays[0];

                    var index = -1,
                        seen = caches[0];

                    outer: while (
                        ++index < length &&
                        result.length < maxLength
                    ) {
                        var value = array[index],
                            computed = iteratee ? iteratee(value) : value;

                        value = comparator || value !== 0 ? value : 0;
                        if (
                            !(seen
                                ? cacheHas(seen, computed)
                                : includes(result, computed, comparator))
                        ) {
                            othIndex = othLength;
                            while (--othIndex) {
                                var cache = caches[othIndex];
                                if (
                                    !(cache
                                        ? cacheHas(cache, computed)
                                        : includes(
                                              arrays[othIndex],
                                              computed,
                                              comparator
                                          ))
                                ) {
                                    continue outer;
                                }
                            }
                            if (seen) {
                                seen.push(computed);
                            }
                            result.push(value);
                        }
                    }
                    return result;
                }

                module.exports = baseIntersection;

                /***/
            },
            /* 73 */
            /***/ function (module, exports, __webpack_require__) {
                var MapCache = __webpack_require__(74),
                    setCacheAdd = __webpack_require__(104),
                    setCacheHas = __webpack_require__(105);

                /**
                 *
                 * Creates an array cache object to store unique values.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [values] The values to cache.
                 */
                function SetCache(values) {
                    var index = -1,
                        length = values == null ? 0 : values.length;

                    this.__data__ = new MapCache();
                    while (++index < length) {
                        this.add(values[index]);
                    }
                }

                // Add methods to `SetCache`.
                SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
                SetCache.prototype.has = setCacheHas;

                module.exports = SetCache;

                /***/
            },
            /* 74 */
            /***/ function (module, exports, __webpack_require__) {
                var mapCacheClear = __webpack_require__(75),
                    mapCacheDelete = __webpack_require__(98),
                    mapCacheGet = __webpack_require__(101),
                    mapCacheHas = __webpack_require__(102),
                    mapCacheSet = __webpack_require__(103);

                /**
                 * Creates a map cache object to store key-value pairs.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function MapCache(entries) {
                    var index = -1,
                        length = entries == null ? 0 : entries.length;

                    this.clear();
                    while (++index < length) {
                        var entry = entries[index];
                        this.set(entry[0], entry[1]);
                    }
                }

                // Add methods to `MapCache`.
                MapCache.prototype.clear = mapCacheClear;
                MapCache.prototype["delete"] = mapCacheDelete;
                MapCache.prototype.get = mapCacheGet;
                MapCache.prototype.has = mapCacheHas;
                MapCache.prototype.set = mapCacheSet;

                module.exports = MapCache;

                /***/
            },
            /* 75 */
            /***/ function (module, exports, __webpack_require__) {
                var Hash = __webpack_require__(76),
                    ListCache = __webpack_require__(89),
                    Map = __webpack_require__(97);

                /**
                 * Removes all key-value entries from the map.
                 *
                 * @private
                 * @name clear
                 * @memberOf MapCache
                 */
                function mapCacheClear() {
                    this.size = 0;
                    this.__data__ = {
                        hash: new Hash(),
                        map: new (Map || ListCache)(),
                        string: new Hash(),
                    };
                }

                module.exports = mapCacheClear;

                /***/
            },
            /* 76 */
            /***/ function (module, exports, __webpack_require__) {
                var hashClear = __webpack_require__(77),
                    hashDelete = __webpack_require__(85),
                    hashGet = __webpack_require__(86),
                    hashHas = __webpack_require__(87),
                    hashSet = __webpack_require__(88);

                /**
                 * Creates a hash object.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function Hash(entries) {
                    var index = -1,
                        length = entries == null ? 0 : entries.length;

                    this.clear();
                    while (++index < length) {
                        var entry = entries[index];
                        this.set(entry[0], entry[1]);
                    }
                }

                // Add methods to `Hash`.
                Hash.prototype.clear = hashClear;
                Hash.prototype["delete"] = hashDelete;
                Hash.prototype.get = hashGet;
                Hash.prototype.has = hashHas;
                Hash.prototype.set = hashSet;

                module.exports = Hash;

                /***/
            },
            /* 77 */
            /***/ function (module, exports, __webpack_require__) {
                var nativeCreate = __webpack_require__(78);

                /**
                 * Removes all key-value entries from the hash.
                 *
                 * @private
                 * @name clear
                 * @memberOf Hash
                 */
                function hashClear() {
                    this.__data__ = nativeCreate ? nativeCreate(null) : {};
                    this.size = 0;
                }

                module.exports = hashClear;

                /***/
            },
            /* 78 */
            /***/ function (module, exports, __webpack_require__) {
                var getNative = __webpack_require__(79);

                /* Built-in method references that are verified to be native. */
                var nativeCreate = getNative(Object, "create");

                module.exports = nativeCreate;

                /***/
            },
            /* 79 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIsNative = __webpack_require__(80),
                    getValue = __webpack_require__(84);

                /**
                 * Gets the native function at `key` of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {string} key The key of the method to get.
                 * @returns {*} Returns the function if it's native, else `undefined`.
                 */
                function getNative(object, key) {
                    var value = getValue(object, key);
                    return baseIsNative(value) ? value : undefined;
                }

                module.exports = getNative;

                /***/
            },
            /* 80 */
            /***/ function (module, exports, __webpack_require__) {
                var isFunction = __webpack_require__(68),
                    isMasked = __webpack_require__(81),
                    isObject = __webpack_require__(69),
                    toSource = __webpack_require__(83);

                /**
                 * Used to match `RegExp`
                 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
                 */
                var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

                /** Used to detect host constructors (Safari). */
                var reIsHostCtor = /^\[object .+?Constructor\]$/;

                /** Used for built-in method references. */
                var funcProto = Function.prototype,
                    objectProto = Object.prototype;

                /** Used to resolve the decompiled source of functions. */
                var funcToString = funcProto.toString;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /** Used to detect if a method is native. */
                var reIsNative = RegExp(
                    "^" +
                        funcToString
                            .call(hasOwnProperty)
                            .replace(reRegExpChar, "\\$&")
                            .replace(
                                /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                                "$1.*?"
                            ) +
                        "$"
                );

                /**
                 * The base implementation of `_.isNative` without bad shim checks.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a native function,
                 *  else `false`.
                 */
                function baseIsNative(value) {
                    if (!isObject(value) || isMasked(value)) {
                        return false;
                    }
                    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                    return pattern.test(toSource(value));
                }

                module.exports = baseIsNative;

                /***/
            },
            /* 81 */
            /***/ function (module, exports, __webpack_require__) {
                var coreJsData = __webpack_require__(82);

                /** Used to detect methods masquerading as native. */
                var maskSrcKey = (function () {
                    var uid = /[^.]+$/.exec(
                        (coreJsData &&
                            coreJsData.keys &&
                            coreJsData.keys.IE_PROTO) ||
                            ""
                    );
                    return uid ? "Symbol(src)_1." + uid : "";
                })();

                /**
                 * Checks if `func` has its source masked.
                 *
                 * @private
                 * @param {Function} func The function to check.
                 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
                 */
                function isMasked(func) {
                    return !!maskSrcKey && maskSrcKey in func;
                }

                module.exports = isMasked;

                /***/
            },
            /* 82 */
            /***/ function (module, exports, __webpack_require__) {
                var root = __webpack_require__(48);

                /** Used to detect overreaching core-js shims. */
                var coreJsData = root["__core-js_shared__"];

                module.exports = coreJsData;

                /***/
            },
            /* 83 */
            /***/ function (module, exports) {
                /** Used for built-in method references. */
                var funcProto = Function.prototype;

                /** Used to resolve the decompiled source of functions. */
                var funcToString = funcProto.toString;

                /**
                 * Converts `func` to its source code.
                 *
                 * @private
                 * @param {Function} func The function to convert.
                 * @returns {string} Returns the source code.
                 */
                function toSource(func) {
                    if (func != null) {
                        try {
                            return funcToString.call(func);
                        } catch (e) {}
                        try {
                            return func + "";
                        } catch (e) {}
                    }
                    return "";
                }

                module.exports = toSource;

                /***/
            },
            /* 84 */
            /***/ function (module, exports) {
                /**
                 * Gets the value at `key` of `object`.
                 *
                 * @private
                 * @param {Object} [object] The object to query.
                 * @param {string} key The key of the property to get.
                 * @returns {*} Returns the property value.
                 */
                function getValue(object, key) {
                    return object == null ? undefined : object[key];
                }

                module.exports = getValue;

                /***/
            },
            /* 85 */
            /***/ function (module, exports) {
                /**
                 * Removes `key` and its value from the hash.
                 *
                 * @private
                 * @name delete
                 * @memberOf Hash
                 * @param {Object} hash The hash to modify.
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function hashDelete(key) {
                    var result = this.has(key) && delete this.__data__[key];
                    this.size -= result ? 1 : 0;
                    return result;
                }

                module.exports = hashDelete;

                /***/
            },
            /* 86 */
            /***/ function (module, exports, __webpack_require__) {
                var nativeCreate = __webpack_require__(78);

                /** Used to stand-in for `undefined` hash values. */
                var HASH_UNDEFINED = "__lodash_hash_undefined__";

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Gets the hash value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf Hash
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function hashGet(key) {
                    var data = this.__data__;
                    if (nativeCreate) {
                        var result = data[key];
                        return result === HASH_UNDEFINED ? undefined : result;
                    }
                    return hasOwnProperty.call(data, key)
                        ? data[key]
                        : undefined;
                }

                module.exports = hashGet;

                /***/
            },
            /* 87 */
            /***/ function (module, exports, __webpack_require__) {
                var nativeCreate = __webpack_require__(78);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Checks if a hash value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf Hash
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function hashHas(key) {
                    var data = this.__data__;
                    return nativeCreate
                        ? data[key] !== undefined
                        : hasOwnProperty.call(data, key);
                }

                module.exports = hashHas;

                /***/
            },
            /* 88 */
            /***/ function (module, exports, __webpack_require__) {
                var nativeCreate = __webpack_require__(78);

                /** Used to stand-in for `undefined` hash values. */
                var HASH_UNDEFINED = "__lodash_hash_undefined__";

                /**
                 * Sets the hash `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf Hash
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the hash instance.
                 */
                function hashSet(key, value) {
                    var data = this.__data__;
                    this.size += this.has(key) ? 0 : 1;
                    data[key] =
                        nativeCreate && value === undefined
                            ? HASH_UNDEFINED
                            : value;
                    return this;
                }

                module.exports = hashSet;

                /***/
            },
            /* 89 */
            /***/ function (module, exports, __webpack_require__) {
                var listCacheClear = __webpack_require__(90),
                    listCacheDelete = __webpack_require__(91),
                    listCacheGet = __webpack_require__(94),
                    listCacheHas = __webpack_require__(95),
                    listCacheSet = __webpack_require__(96);

                /**
                 * Creates an list cache object.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function ListCache(entries) {
                    var index = -1,
                        length = entries == null ? 0 : entries.length;

                    this.clear();
                    while (++index < length) {
                        var entry = entries[index];
                        this.set(entry[0], entry[1]);
                    }
                }

                // Add methods to `ListCache`.
                ListCache.prototype.clear = listCacheClear;
                ListCache.prototype["delete"] = listCacheDelete;
                ListCache.prototype.get = listCacheGet;
                ListCache.prototype.has = listCacheHas;
                ListCache.prototype.set = listCacheSet;

                module.exports = ListCache;

                /***/
            },
            /* 90 */
            /***/ function (module, exports) {
                /**
                 * Removes all key-value entries from the list cache.
                 *
                 * @private
                 * @name clear
                 * @memberOf ListCache
                 */
                function listCacheClear() {
                    this.__data__ = [];
                    this.size = 0;
                }

                module.exports = listCacheClear;

                /***/
            },
            /* 91 */
            /***/ function (module, exports, __webpack_require__) {
                var assocIndexOf = __webpack_require__(92);

                /** Used for built-in method references. */
                var arrayProto = Array.prototype;

                /** Built-in value references. */
                var splice = arrayProto.splice;

                /**
                 * Removes `key` and its value from the list cache.
                 *
                 * @private
                 * @name delete
                 * @memberOf ListCache
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function listCacheDelete(key) {
                    var data = this.__data__,
                        index = assocIndexOf(data, key);

                    if (index < 0) {
                        return false;
                    }
                    var lastIndex = data.length - 1;
                    if (index == lastIndex) {
                        data.pop();
                    } else {
                        splice.call(data, index, 1);
                    }
                    --this.size;
                    return true;
                }

                module.exports = listCacheDelete;

                /***/
            },
            /* 92 */
            /***/ function (module, exports, __webpack_require__) {
                var eq = __webpack_require__(93);

                /**
                 * Gets the index at which the `key` is found in `array` of key-value pairs.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {*} key The key to search for.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function assocIndexOf(array, key) {
                    var length = array.length;
                    while (length--) {
                        if (eq(array[length][0], key)) {
                            return length;
                        }
                    }
                    return -1;
                }

                module.exports = assocIndexOf;

                /***/
            },
            /* 93 */
            /***/ function (module, exports) {
                /**
                 * Performs a
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * comparison between two values to determine if they are equivalent.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to compare.
                 * @param {*} other The other value to compare.
                 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                 * @example
                 *
                 * var object = { 'a': 1 };
                 * var other = { 'a': 1 };
                 *
                 * _.eq(object, object);
                 * // => true
                 *
                 * _.eq(object, other);
                 * // => false
                 *
                 * _.eq('a', 'a');
                 * // => true
                 *
                 * _.eq('a', Object('a'));
                 * // => false
                 *
                 * _.eq(NaN, NaN);
                 * // => true
                 */
                function eq(value, other) {
                    return (
                        value === other || (value !== value && other !== other)
                    );
                }

                module.exports = eq;

                /***/
            },
            /* 94 */
            /***/ function (module, exports, __webpack_require__) {
                var assocIndexOf = __webpack_require__(92);

                /**
                 * Gets the list cache value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf ListCache
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function listCacheGet(key) {
                    var data = this.__data__,
                        index = assocIndexOf(data, key);

                    return index < 0 ? undefined : data[index][1];
                }

                module.exports = listCacheGet;

                /***/
            },
            /* 95 */
            /***/ function (module, exports, __webpack_require__) {
                var assocIndexOf = __webpack_require__(92);

                /**
                 * Checks if a list cache value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf ListCache
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function listCacheHas(key) {
                    return assocIndexOf(this.__data__, key) > -1;
                }

                module.exports = listCacheHas;

                /***/
            },
            /* 96 */
            /***/ function (module, exports, __webpack_require__) {
                var assocIndexOf = __webpack_require__(92);

                /**
                 * Sets the list cache `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf ListCache
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the list cache instance.
                 */
                function listCacheSet(key, value) {
                    var data = this.__data__,
                        index = assocIndexOf(data, key);

                    if (index < 0) {
                        ++this.size;
                        data.push([key, value]);
                    } else {
                        data[index][1] = value;
                    }
                    return this;
                }

                module.exports = listCacheSet;

                /***/
            },
            /* 97 */
            /***/ function (module, exports, __webpack_require__) {
                var getNative = __webpack_require__(79),
                    root = __webpack_require__(48);

                /* Built-in method references that are verified to be native. */
                var Map = getNative(root, "Map");

                module.exports = Map;

                /***/
            },
            /* 98 */
            /***/ function (module, exports, __webpack_require__) {
                var getMapData = __webpack_require__(99);

                /**
                 * Removes `key` and its value from the map.
                 *
                 * @private
                 * @name delete
                 * @memberOf MapCache
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function mapCacheDelete(key) {
                    var result = getMapData(this, key)["delete"](key);
                    this.size -= result ? 1 : 0;
                    return result;
                }

                module.exports = mapCacheDelete;

                /***/
            },
            /* 99 */
            /***/ function (module, exports, __webpack_require__) {
                var isKeyable = __webpack_require__(100);

                /**
                 * Gets the data for `map`.
                 *
                 * @private
                 * @param {Object} map The map to query.
                 * @param {string} key The reference key.
                 * @returns {*} Returns the map data.
                 */
                function getMapData(map, key) {
                    var data = map.__data__;
                    return isKeyable(key)
                        ? data[typeof key == "string" ? "string" : "hash"]
                        : data.map;
                }

                module.exports = getMapData;

                /***/
            },
            /* 100 */
            /***/ function (module, exports) {
                /**
                 * Checks if `value` is suitable for use as unique object key.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
                 */
                function isKeyable(value) {
                    var type = typeof value;
                    return type == "string" ||
                        type == "number" ||
                        type == "symbol" ||
                        type == "boolean"
                        ? value !== "__proto__"
                        : value === null;
                }

                module.exports = isKeyable;

                /***/
            },
            /* 101 */
            /***/ function (module, exports, __webpack_require__) {
                var getMapData = __webpack_require__(99);

                /**
                 * Gets the map value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf MapCache
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function mapCacheGet(key) {
                    return getMapData(this, key).get(key);
                }

                module.exports = mapCacheGet;

                /***/
            },
            /* 102 */
            /***/ function (module, exports, __webpack_require__) {
                var getMapData = __webpack_require__(99);

                /**
                 * Checks if a map value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf MapCache
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function mapCacheHas(key) {
                    return getMapData(this, key).has(key);
                }

                module.exports = mapCacheHas;

                /***/
            },
            /* 103 */
            /***/ function (module, exports, __webpack_require__) {
                var getMapData = __webpack_require__(99);

                /**
                 * Sets the map `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf MapCache
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the map cache instance.
                 */
                function mapCacheSet(key, value) {
                    var data = getMapData(this, key),
                        size = data.size;

                    data.set(key, value);
                    this.size += data.size == size ? 0 : 1;
                    return this;
                }

                module.exports = mapCacheSet;

                /***/
            },
            /* 104 */
            /***/ function (module, exports) {
                /** Used to stand-in for `undefined` hash values. */
                var HASH_UNDEFINED = "__lodash_hash_undefined__";

                /**
                 * Adds `value` to the array cache.
                 *
                 * @private
                 * @name add
                 * @memberOf SetCache
                 * @alias push
                 * @param {*} value The value to cache.
                 * @returns {Object} Returns the cache instance.
                 */
                function setCacheAdd(value) {
                    this.__data__.set(value, HASH_UNDEFINED);
                    return this;
                }

                module.exports = setCacheAdd;

                /***/
            },
            /* 105 */
            /***/ function (module, exports) {
                /**
                 * Checks if `value` is in the array cache.
                 *
                 * @private
                 * @name has
                 * @memberOf SetCache
                 * @param {*} value The value to search for.
                 * @returns {number} Returns `true` if `value` is found, else `false`.
                 */
                function setCacheHas(value) {
                    return this.__data__.has(value);
                }

                module.exports = setCacheHas;

                /***/
            },
            /* 106 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIndexOf = __webpack_require__(107);

                /**
                 * A specialized version of `_.includes` for arrays without support for
                 * specifying an index to search from.
                 *
                 * @private
                 * @param {Array} [array] The array to inspect.
                 * @param {*} target The value to search for.
                 * @returns {boolean} Returns `true` if `target` is found, else `false`.
                 */
                function arrayIncludes(array, value) {
                    var length = array == null ? 0 : array.length;
                    return !!length && baseIndexOf(array, value, 0) > -1;
                }

                module.exports = arrayIncludes;

                /***/
            },
            /* 107 */
            /***/ function (module, exports, __webpack_require__) {
                var baseFindIndex = __webpack_require__(108),
                    baseIsNaN = __webpack_require__(109),
                    strictIndexOf = __webpack_require__(110);

                /**
                 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} fromIndex The index to search from.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function baseIndexOf(array, value, fromIndex) {
                    return value === value
                        ? strictIndexOf(array, value, fromIndex)
                        : baseFindIndex(array, baseIsNaN, fromIndex);
                }

                module.exports = baseIndexOf;

                /***/
            },
            /* 108 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.findIndex` and `_.findLastIndex` without
                 * support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {Function} predicate The function invoked per iteration.
                 * @param {number} fromIndex The index to search from.
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function baseFindIndex(array, predicate, fromIndex, fromRight) {
                    var length = array.length,
                        index = fromIndex + (fromRight ? 1 : -1);

                    while (fromRight ? index-- : ++index < length) {
                        if (predicate(array[index], index, array)) {
                            return index;
                        }
                    }
                    return -1;
                }

                module.exports = baseFindIndex;

                /***/
            },
            /* 109 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.isNaN` without support for number objects.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                 */
                function baseIsNaN(value) {
                    return value !== value;
                }

                module.exports = baseIsNaN;

                /***/
            },
            /* 110 */
            /***/ function (module, exports) {
                /**
                 * A specialized version of `_.indexOf` which performs strict equality
                 * comparisons of values, i.e. `===`.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} fromIndex The index to search from.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function strictIndexOf(array, value, fromIndex) {
                    var index = fromIndex - 1,
                        length = array.length;

                    while (++index < length) {
                        if (array[index] === value) {
                            return index;
                        }
                    }
                    return -1;
                }

                module.exports = strictIndexOf;

                /***/
            },
            /* 111 */
            /***/ function (module, exports) {
                /**
                 * This function is like `arrayIncludes` except that it accepts a comparator.
                 *
                 * @private
                 * @param {Array} [array] The array to inspect.
                 * @param {*} target The value to search for.
                 * @param {Function} comparator The comparator invoked per element.
                 * @returns {boolean} Returns `true` if `target` is found, else `false`.
                 */
                function arrayIncludesWith(array, value, comparator) {
                    var index = -1,
                        length = array == null ? 0 : array.length;

                    while (++index < length) {
                        if (comparator(value, array[index])) {
                            return true;
                        }
                    }
                    return false;
                }

                module.exports = arrayIncludesWith;

                /***/
            },
            /* 112 */
            /***/ function (module, exports) {
                /**
                 * Checks if a `cache` value for `key` exists.
                 *
                 * @private
                 * @param {Object} cache The cache to query.
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function cacheHas(cache, key) {
                    return cache.has(key);
                }

                module.exports = cacheHas;

                /***/
            },
            /* 113 */
            /***/ function (module, exports, __webpack_require__) {
                var identity = __webpack_require__(114),
                    overRest = __webpack_require__(115),
                    setToString = __webpack_require__(117);

                /**
                 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
                 *
                 * @private
                 * @param {Function} func The function to apply a rest parameter to.
                 * @param {number} [start=func.length-1] The start position of the rest parameter.
                 * @returns {Function} Returns the new function.
                 */
                function baseRest(func, start) {
                    return setToString(
                        overRest(func, start, identity),
                        func + ""
                    );
                }

                module.exports = baseRest;

                /***/
            },
            /* 114 */
            /***/ function (module, exports) {
                /**
                 * This method returns the first argument it receives.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Util
                 * @param {*} value Any value.
                 * @returns {*} Returns `value`.
                 * @example
                 *
                 * var object = { 'a': 1 };
                 *
                 * console.log(_.identity(object) === object);
                 * // => true
                 */
                function identity(value) {
                    return value;
                }

                module.exports = identity;

                /***/
            },
            /* 115 */
            /***/ function (module, exports, __webpack_require__) {
                var apply = __webpack_require__(116);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * A specialized version of `baseRest` which transforms the rest array.
                 *
                 * @private
                 * @param {Function} func The function to apply a rest parameter to.
                 * @param {number} [start=func.length-1] The start position of the rest parameter.
                 * @param {Function} transform The rest array transform.
                 * @returns {Function} Returns the new function.
                 */
                function overRest(func, start, transform) {
                    start = nativeMax(
                        start === undefined ? func.length - 1 : start,
                        0
                    );
                    return function () {
                        var args = arguments,
                            index = -1,
                            length = nativeMax(args.length - start, 0),
                            array = Array(length);

                        while (++index < length) {
                            array[index] = args[start + index];
                        }
                        index = -1;
                        var otherArgs = Array(start + 1);
                        while (++index < start) {
                            otherArgs[index] = args[index];
                        }
                        otherArgs[start] = transform(array);
                        return apply(func, this, otherArgs);
                    };
                }

                module.exports = overRest;

                /***/
            },
            /* 116 */
            /***/ function (module, exports) {
                /**
                 * A faster alternative to `Function#apply`, this function invokes `func`
                 * with the `this` binding of `thisArg` and the arguments of `args`.
                 *
                 * @private
                 * @param {Function} func The function to invoke.
                 * @param {*} thisArg The `this` binding of `func`.
                 * @param {Array} args The arguments to invoke `func` with.
                 * @returns {*} Returns the result of `func`.
                 */
                function apply(func, thisArg, args) {
                    switch (args.length) {
                        case 0:
                            return func.call(thisArg);
                        case 1:
                            return func.call(thisArg, args[0]);
                        case 2:
                            return func.call(thisArg, args[0], args[1]);
                        case 3:
                            return func.call(
                                thisArg,
                                args[0],
                                args[1],
                                args[2]
                            );
                    }
                    return func.apply(thisArg, args);
                }

                module.exports = apply;

                /***/
            },
            /* 117 */
            /***/ function (module, exports, __webpack_require__) {
                var baseSetToString = __webpack_require__(118),
                    shortOut = __webpack_require__(121);

                /**
                 * Sets the `toString` method of `func` to return `string`.
                 *
                 * @private
                 * @param {Function} func The function to modify.
                 * @param {Function} string The `toString` result.
                 * @returns {Function} Returns `func`.
                 */
                var setToString = shortOut(baseSetToString);

                module.exports = setToString;

                /***/
            },
            /* 118 */
            /***/ function (module, exports, __webpack_require__) {
                var constant = __webpack_require__(119),
                    defineProperty = __webpack_require__(120),
                    identity = __webpack_require__(114);

                /**
                 * The base implementation of `setToString` without support for hot loop shorting.
                 *
                 * @private
                 * @param {Function} func The function to modify.
                 * @param {Function} string The `toString` result.
                 * @returns {Function} Returns `func`.
                 */
                var baseSetToString = !defineProperty
                    ? identity
                    : function (func, string) {
                          return defineProperty(func, "toString", {
                              configurable: true,
                              enumerable: false,
                              value: constant(string),
                              writable: true,
                          });
                      };

                module.exports = baseSetToString;

                /***/
            },
            /* 119 */
            /***/ function (module, exports) {
                /**
                 * Creates a function that returns `value`.
                 *
                 * @static
                 * @memberOf _
                 * @since 2.4.0
                 * @category Util
                 * @param {*} value The value to return from the new function.
                 * @returns {Function} Returns the new constant function.
                 * @example
                 *
                 * var objects = _.times(2, _.constant({ 'a': 1 }));
                 *
                 * console.log(objects);
                 * // => [{ 'a': 1 }, { 'a': 1 }]
                 *
                 * console.log(objects[0] === objects[1]);
                 * // => true
                 */
                function constant(value) {
                    return function () {
                        return value;
                    };
                }

                module.exports = constant;

                /***/
            },
            /* 120 */
            /***/ function (module, exports, __webpack_require__) {
                var getNative = __webpack_require__(79);

                var defineProperty = (function () {
                    try {
                        var func = getNative(Object, "defineProperty");
                        func({}, "", {});
                        return func;
                    } catch (e) {}
                })();

                module.exports = defineProperty;

                /***/
            },
            /* 121 */
            /***/ function (module, exports) {
                /** Used to detect hot functions by number of calls within a span of milliseconds. */
                var HOT_COUNT = 800,
                    HOT_SPAN = 16;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeNow = Date.now;

                /**
                 * Creates a function that'll short out and invoke `identity` instead
                 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
                 * milliseconds.
                 *
                 * @private
                 * @param {Function} func The function to restrict.
                 * @returns {Function} Returns the new shortable function.
                 */
                function shortOut(func) {
                    var count = 0,
                        lastCalled = 0;

                    return function () {
                        var stamp = nativeNow(),
                            remaining = HOT_SPAN - (stamp - lastCalled);

                        lastCalled = stamp;
                        if (remaining > 0) {
                            if (++count >= HOT_COUNT) {
                                return arguments[0];
                            }
                        } else {
                            count = 0;
                        }
                        return func.apply(undefined, arguments);
                    };
                }

                module.exports = shortOut;

                /***/
            },
            /* 122 */
            /***/ function (module, exports, __webpack_require__) {
                var isArrayLikeObject = __webpack_require__(123);

                /**
                 * Casts `value` to an empty array if it's not an array like object.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @returns {Array|Object} Returns the cast array-like object.
                 */
                function castArrayLikeObject(value) {
                    return isArrayLikeObject(value) ? value : [];
                }

                module.exports = castArrayLikeObject;

                /***/
            },
            /* 123 */
            /***/ function (module, exports, __webpack_require__) {
                var isArrayLike = __webpack_require__(67),
                    isObjectLike = __webpack_require__(52);

                /**
                 * This method is like `_.isArrayLike` except that it also checks if `value`
                 * is an object.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an array-like object,
                 *  else `false`.
                 * @example
                 *
                 * _.isArrayLikeObject([1, 2, 3]);
                 * // => true
                 *
                 * _.isArrayLikeObject(document.body.children);
                 * // => true
                 *
                 * _.isArrayLikeObject('abc');
                 * // => false
                 *
                 * _.isArrayLikeObject(_.noop);
                 * // => false
                 */
                function isArrayLikeObject(value) {
                    return isObjectLike(value) && isArrayLike(value);
                }

                module.exports = isArrayLikeObject;

                /***/
            },
            /* 124 */
            /***/ function (module, exports, __webpack_require__) {
                var baseForOwn = __webpack_require__(125),
                    castFunction = __webpack_require__(128);

                /**
                 * Iterates over own enumerable string keyed properties of an object and
                 * invokes `iteratee` for each property. The iteratee is invoked with three
                 * arguments: (value, key, object). Iteratee functions may exit iteration
                 * early by explicitly returning `false`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.3.0
                 * @category Object
                 * @param {Object} object The object to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Object} Returns `object`.
                 * @see _.forOwnRight
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.forOwn(new Foo, function(value, key) {
                 *   console.log(key);
                 * });
                 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                 */
                function forOwn(object, iteratee) {
                    return object && baseForOwn(object, castFunction(iteratee));
                }

                module.exports = forOwn;

                /***/
            },
            /* 125 */
            /***/ function (module, exports, __webpack_require__) {
                var baseFor = __webpack_require__(126),
                    keys = __webpack_require__(41);

                /**
                 * The base implementation of `_.forOwn` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Object} object The object to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Object} Returns `object`.
                 */
                function baseForOwn(object, iteratee) {
                    return object && baseFor(object, iteratee, keys);
                }

                module.exports = baseForOwn;

                /***/
            },
            /* 126 */
            /***/ function (module, exports, __webpack_require__) {
                var createBaseFor = __webpack_require__(127);

                /**
                 * The base implementation of `baseForOwn` which iterates over `object`
                 * properties returned by `keysFunc` and invokes `iteratee` for each property.
                 * Iteratee functions may exit iteration early by explicitly returning `false`.
                 *
                 * @private
                 * @param {Object} object The object to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @param {Function} keysFunc The function to get the keys of `object`.
                 * @returns {Object} Returns `object`.
                 */
                var baseFor = createBaseFor();

                module.exports = baseFor;

                /***/
            },
            /* 127 */
            /***/ function (module, exports) {
                /**
                 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
                 *
                 * @private
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Function} Returns the new base function.
                 */
                function createBaseFor(fromRight) {
                    return function (object, iteratee, keysFunc) {
                        var index = -1,
                            iterable = Object(object),
                            props = keysFunc(object),
                            length = props.length;

                        while (length--) {
                            var key = props[fromRight ? length : ++index];
                            if (
                                iteratee(iterable[key], key, iterable) === false
                            ) {
                                break;
                            }
                        }
                        return object;
                    };
                }

                module.exports = createBaseFor;

                /***/
            },
            /* 128 */
            /***/ function (module, exports, __webpack_require__) {
                var identity = __webpack_require__(114);

                /**
                 * Casts `value` to `identity` if it's not a function.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @returns {Function} Returns cast function.
                 */
                function castFunction(value) {
                    return typeof value == "function" ? value : identity;
                }

                module.exports = castFunction;

                /***/
            },
            /* 129 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayEach = __webpack_require__(130),
                    baseEach = __webpack_require__(131),
                    castFunction = __webpack_require__(128),
                    isArray = __webpack_require__(53);

                /**
                 * Iterates over elements of `collection` and invokes `iteratee` for each element.
                 * The iteratee is invoked with three arguments: (value, index|key, collection).
                 * Iteratee functions may exit iteration early by explicitly returning `false`.
                 *
                 * **Note:** As with other "Collections" methods, objects with a "length"
                 * property are iterated like arrays. To avoid this behavior use `_.forIn`
                 * or `_.forOwn` for object iteration.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @alias each
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Array|Object} Returns `collection`.
                 * @see _.forEachRight
                 * @example
                 *
                 * _.forEach([1, 2], function(value) {
                 *   console.log(value);
                 * });
                 * // => Logs `1` then `2`.
                 *
                 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
                 *   console.log(key);
                 * });
                 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                 */
                function forEach(collection, iteratee) {
                    var func = isArray(collection) ? arrayEach : baseEach;
                    return func(collection, castFunction(iteratee));
                }

                module.exports = forEach;

                /***/
            },
            /* 130 */
            /***/ function (module, exports) {
                /**
                 * A specialized version of `_.forEach` for arrays without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns `array`.
                 */
                function arrayEach(array, iteratee) {
                    var index = -1,
                        length = array == null ? 0 : array.length;

                    while (++index < length) {
                        if (iteratee(array[index], index, array) === false) {
                            break;
                        }
                    }
                    return array;
                }

                module.exports = arrayEach;

                /***/
            },
            /* 131 */
            /***/ function (module, exports, __webpack_require__) {
                var baseForOwn = __webpack_require__(125),
                    createBaseEach = __webpack_require__(132);

                /**
                 * The base implementation of `_.forEach` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array|Object} Returns `collection`.
                 */
                var baseEach = createBaseEach(baseForOwn);

                module.exports = baseEach;

                /***/
            },
            /* 132 */
            /***/ function (module, exports, __webpack_require__) {
                var isArrayLike = __webpack_require__(67);

                /**
                 * Creates a `baseEach` or `baseEachRight` function.
                 *
                 * @private
                 * @param {Function} eachFunc The function to iterate over a collection.
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Function} Returns the new base function.
                 */
                function createBaseEach(eachFunc, fromRight) {
                    return function (collection, iteratee) {
                        if (collection == null) {
                            return collection;
                        }
                        if (!isArrayLike(collection)) {
                            return eachFunc(collection, iteratee);
                        }
                        var length = collection.length,
                            index = fromRight ? length : -1,
                            iterable = Object(collection);

                        while (fromRight ? index-- : ++index < length) {
                            if (
                                iteratee(iterable[index], index, iterable) ===
                                false
                            ) {
                                break;
                            }
                        }
                        return collection;
                    };
                }

                module.exports = createBaseEach;

                /***/
            },
            /* 133 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayFilter = __webpack_require__(134),
                    baseFilter = __webpack_require__(135),
                    baseIteratee = __webpack_require__(136),
                    isArray = __webpack_require__(53);

                /**
                 * Iterates over elements of `collection`, returning an array of all elements
                 * `predicate` returns truthy for. The predicate is invoked with three
                 * arguments: (value, index|key, collection).
                 *
                 * **Note:** Unlike `_.remove`, this method returns a new array.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @returns {Array} Returns the new filtered array.
                 * @see _.reject
                 * @example
                 *
                 * var users = [
                 *   { 'user': 'barney', 'age': 36, 'active': true },
                 *   { 'user': 'fred',   'age': 40, 'active': false }
                 * ];
                 *
                 * _.filter(users, function(o) { return !o.active; });
                 * // => objects for ['fred']
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.filter(users, { 'age': 36, 'active': true });
                 * // => objects for ['barney']
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.filter(users, ['active', false]);
                 * // => objects for ['fred']
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.filter(users, 'active');
                 * // => objects for ['barney']
                 */
                function filter(collection, predicate) {
                    var func = isArray(collection) ? arrayFilter : baseFilter;
                    return func(collection, baseIteratee(predicate, 3));
                }

                module.exports = filter;

                /***/
            },
            /* 134 */
            /***/ function (module, exports) {
                /**
                 * A specialized version of `_.filter` for arrays without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {Array} Returns the new filtered array.
                 */
                function arrayFilter(array, predicate) {
                    var index = -1,
                        length = array == null ? 0 : array.length,
                        resIndex = 0,
                        result = [];

                    while (++index < length) {
                        var value = array[index];
                        if (predicate(value, index, array)) {
                            result[resIndex++] = value;
                        }
                    }
                    return result;
                }

                module.exports = arrayFilter;

                /***/
            },
            /* 135 */
            /***/ function (module, exports, __webpack_require__) {
                var baseEach = __webpack_require__(131);

                /**
                 * The base implementation of `_.filter` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {Array} Returns the new filtered array.
                 */
                function baseFilter(collection, predicate) {
                    var result = [];
                    baseEach(collection, function (value, index, collection) {
                        if (predicate(value, index, collection)) {
                            result.push(value);
                        }
                    });
                    return result;
                }

                module.exports = baseFilter;

                /***/
            },
            /* 136 */
            /***/ function (module, exports, __webpack_require__) {
                var baseMatches = __webpack_require__(137),
                    baseMatchesProperty = __webpack_require__(167),
                    identity = __webpack_require__(114),
                    isArray = __webpack_require__(53),
                    property = __webpack_require__(182);

                /**
                 * The base implementation of `_.iteratee`.
                 *
                 * @private
                 * @param {*} [value=_.identity] The value to convert to an iteratee.
                 * @returns {Function} Returns the iteratee.
                 */
                function baseIteratee(value) {
                    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
                    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
                    if (typeof value == "function") {
                        return value;
                    }
                    if (value == null) {
                        return identity;
                    }
                    if (typeof value == "object") {
                        return isArray(value)
                            ? baseMatchesProperty(value[0], value[1])
                            : baseMatches(value);
                    }
                    return property(value);
                }

                module.exports = baseIteratee;

                /***/
            },
            /* 137 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIsMatch = __webpack_require__(138),
                    getMatchData = __webpack_require__(164),
                    matchesStrictComparable = __webpack_require__(166);

                /**
                 * The base implementation of `_.matches` which doesn't clone `source`.
                 *
                 * @private
                 * @param {Object} source The object of property values to match.
                 * @returns {Function} Returns the new spec function.
                 */
                function baseMatches(source) {
                    var matchData = getMatchData(source);
                    if (matchData.length == 1 && matchData[0][2]) {
                        return matchesStrictComparable(
                            matchData[0][0],
                            matchData[0][1]
                        );
                    }
                    return function (object) {
                        return (
                            object === source ||
                            baseIsMatch(object, source, matchData)
                        );
                    };
                }

                module.exports = baseMatches;

                /***/
            },
            /* 138 */
            /***/ function (module, exports, __webpack_require__) {
                var Stack = __webpack_require__(139),
                    baseIsEqual = __webpack_require__(145);

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /**
                 * The base implementation of `_.isMatch` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Object} object The object to inspect.
                 * @param {Object} source The object of property values to match.
                 * @param {Array} matchData The property names, values, and compare flags to match.
                 * @param {Function} [customizer] The function to customize comparisons.
                 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                 */
                function baseIsMatch(object, source, matchData, customizer) {
                    var index = matchData.length,
                        length = index,
                        noCustomizer = !customizer;

                    if (object == null) {
                        return !length;
                    }
                    object = Object(object);
                    while (index--) {
                        var data = matchData[index];
                        if (
                            noCustomizer && data[2]
                                ? data[1] !== object[data[0]]
                                : !(data[0] in object)
                        ) {
                            return false;
                        }
                    }
                    while (++index < length) {
                        data = matchData[index];
                        var key = data[0],
                            objValue = object[key],
                            srcValue = data[1];

                        if (noCustomizer && data[2]) {
                            if (objValue === undefined && !(key in object)) {
                                return false;
                            }
                        } else {
                            var stack = new Stack();
                            if (customizer) {
                                var result = customizer(
                                    objValue,
                                    srcValue,
                                    key,
                                    object,
                                    source,
                                    stack
                                );
                            }
                            if (
                                !(result === undefined
                                    ? baseIsEqual(
                                          srcValue,
                                          objValue,
                                          COMPARE_PARTIAL_FLAG |
                                              COMPARE_UNORDERED_FLAG,
                                          customizer,
                                          stack
                                      )
                                    : result)
                            ) {
                                return false;
                            }
                        }
                    }
                    return true;
                }

                module.exports = baseIsMatch;

                /***/
            },
            /* 139 */
            /***/ function (module, exports, __webpack_require__) {
                var ListCache = __webpack_require__(89),
                    stackClear = __webpack_require__(140),
                    stackDelete = __webpack_require__(141),
                    stackGet = __webpack_require__(142),
                    stackHas = __webpack_require__(143),
                    stackSet = __webpack_require__(144);

                /**
                 * Creates a stack cache object to store key-value pairs.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function Stack(entries) {
                    var data = (this.__data__ = new ListCache(entries));
                    this.size = data.size;
                }

                // Add methods to `Stack`.
                Stack.prototype.clear = stackClear;
                Stack.prototype["delete"] = stackDelete;
                Stack.prototype.get = stackGet;
                Stack.prototype.has = stackHas;
                Stack.prototype.set = stackSet;

                module.exports = Stack;

                /***/
            },
            /* 140 */
            /***/ function (module, exports, __webpack_require__) {
                var ListCache = __webpack_require__(89);

                /**
                 * Removes all key-value entries from the stack.
                 *
                 * @private
                 * @name clear
                 * @memberOf Stack
                 */
                function stackClear() {
                    this.__data__ = new ListCache();
                    this.size = 0;
                }

                module.exports = stackClear;

                /***/
            },
            /* 141 */
            /***/ function (module, exports) {
                /**
                 * Removes `key` and its value from the stack.
                 *
                 * @private
                 * @name delete
                 * @memberOf Stack
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function stackDelete(key) {
                    var data = this.__data__,
                        result = data["delete"](key);

                    this.size = data.size;
                    return result;
                }

                module.exports = stackDelete;

                /***/
            },
            /* 142 */
            /***/ function (module, exports) {
                /**
                 * Gets the stack value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf Stack
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function stackGet(key) {
                    return this.__data__.get(key);
                }

                module.exports = stackGet;

                /***/
            },
            /* 143 */
            /***/ function (module, exports) {
                /**
                 * Checks if a stack value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf Stack
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function stackHas(key) {
                    return this.__data__.has(key);
                }

                module.exports = stackHas;

                /***/
            },
            /* 144 */
            /***/ function (module, exports, __webpack_require__) {
                var ListCache = __webpack_require__(89),
                    Map = __webpack_require__(97),
                    MapCache = __webpack_require__(74);

                /** Used as the size to enable large array optimizations. */
                var LARGE_ARRAY_SIZE = 200;

                /**
                 * Sets the stack `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf Stack
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the stack cache instance.
                 */
                function stackSet(key, value) {
                    var data = this.__data__;
                    if (data instanceof ListCache) {
                        var pairs = data.__data__;
                        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                            pairs.push([key, value]);
                            this.size = ++data.size;
                            return this;
                        }
                        data = this.__data__ = new MapCache(pairs);
                    }
                    data.set(key, value);
                    this.size = data.size;
                    return this;
                }

                module.exports = stackSet;

                /***/
            },
            /* 145 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIsEqualDeep = __webpack_require__(146),
                    isObjectLike = __webpack_require__(52);

                /**
                 * The base implementation of `_.isEqual` which supports partial comparisons
                 * and tracks traversed objects.
                 *
                 * @private
                 * @param {*} value The value to compare.
                 * @param {*} other The other value to compare.
                 * @param {boolean} bitmask The bitmask flags.
                 *  1 - Unordered comparison
                 *  2 - Partial comparison
                 * @param {Function} [customizer] The function to customize comparisons.
                 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
                 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                 */
                function baseIsEqual(value, other, bitmask, customizer, stack) {
                    if (value === other) {
                        return true;
                    }
                    if (
                        value == null ||
                        other == null ||
                        (!isObjectLike(value) && !isObjectLike(other))
                    ) {
                        return value !== value && other !== other;
                    }
                    return baseIsEqualDeep(
                        value,
                        other,
                        bitmask,
                        customizer,
                        baseIsEqual,
                        stack
                    );
                }

                module.exports = baseIsEqual;

                /***/
            },
            /* 146 */
            /***/ function (module, exports, __webpack_require__) {
                var Stack = __webpack_require__(139),
                    equalArrays = __webpack_require__(147),
                    equalByTag = __webpack_require__(149),
                    equalObjects = __webpack_require__(153),
                    getTag = __webpack_require__(159),
                    isArray = __webpack_require__(53),
                    isBuffer = __webpack_require__(54),
                    isTypedArray = __webpack_require__(58);

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1;

                /** `Object#toString` result references. */
                var argsTag = "[object Arguments]",
                    arrayTag = "[object Array]",
                    objectTag = "[object Object]";

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * A specialized version of `baseIsEqual` for arrays and objects which performs
                 * deep comparisons and tracks traversed objects enabling objects with circular
                 * references to be compared.
                 *
                 * @private
                 * @param {Object} object The object to compare.
                 * @param {Object} other The other object to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                 */
                function baseIsEqualDeep(
                    object,
                    other,
                    bitmask,
                    customizer,
                    equalFunc,
                    stack
                ) {
                    var objIsArr = isArray(object),
                        othIsArr = isArray(other),
                        objTag = objIsArr ? arrayTag : getTag(object),
                        othTag = othIsArr ? arrayTag : getTag(other);

                    objTag = objTag == argsTag ? objectTag : objTag;
                    othTag = othTag == argsTag ? objectTag : othTag;

                    var objIsObj = objTag == objectTag,
                        othIsObj = othTag == objectTag,
                        isSameTag = objTag == othTag;

                    if (isSameTag && isBuffer(object)) {
                        if (!isBuffer(other)) {
                            return false;
                        }
                        objIsArr = true;
                        objIsObj = false;
                    }
                    if (isSameTag && !objIsObj) {
                        stack || (stack = new Stack());
                        return objIsArr || isTypedArray(object)
                            ? equalArrays(
                                  object,
                                  other,
                                  bitmask,
                                  customizer,
                                  equalFunc,
                                  stack
                              )
                            : equalByTag(
                                  object,
                                  other,
                                  objTag,
                                  bitmask,
                                  customizer,
                                  equalFunc,
                                  stack
                              );
                    }
                    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                        var objIsWrapped =
                                objIsObj &&
                                hasOwnProperty.call(object, "__wrapped__"),
                            othIsWrapped =
                                othIsObj &&
                                hasOwnProperty.call(other, "__wrapped__");

                        if (objIsWrapped || othIsWrapped) {
                            var objUnwrapped = objIsWrapped
                                    ? object.value()
                                    : object,
                                othUnwrapped = othIsWrapped
                                    ? other.value()
                                    : other;

                            stack || (stack = new Stack());
                            return equalFunc(
                                objUnwrapped,
                                othUnwrapped,
                                bitmask,
                                customizer,
                                stack
                            );
                        }
                    }
                    if (!isSameTag) {
                        return false;
                    }
                    stack || (stack = new Stack());
                    return equalObjects(
                        object,
                        other,
                        bitmask,
                        customizer,
                        equalFunc,
                        stack
                    );
                }

                module.exports = baseIsEqualDeep;

                /***/
            },
            /* 147 */
            /***/ function (module, exports, __webpack_require__) {
                var SetCache = __webpack_require__(73),
                    arraySome = __webpack_require__(148),
                    cacheHas = __webpack_require__(112);

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /**
                 * A specialized version of `baseIsEqualDeep` for arrays with support for
                 * partial deep comparisons.
                 *
                 * @private
                 * @param {Array} array The array to compare.
                 * @param {Array} other The other array to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} stack Tracks traversed `array` and `other` objects.
                 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
                 */
                function equalArrays(
                    array,
                    other,
                    bitmask,
                    customizer,
                    equalFunc,
                    stack
                ) {
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                        arrLength = array.length,
                        othLength = other.length;

                    if (
                        arrLength != othLength &&
                        !(isPartial && othLength > arrLength)
                    ) {
                        return false;
                    }
                    // Assume cyclic values are equal.
                    var stacked = stack.get(array);
                    if (stacked && stack.get(other)) {
                        return stacked == other;
                    }
                    var index = -1,
                        result = true,
                        seen =
                            bitmask & COMPARE_UNORDERED_FLAG
                                ? new SetCache()
                                : undefined;

                    stack.set(array, other);
                    stack.set(other, array);

                    // Ignore non-index properties.
                    while (++index < arrLength) {
                        var arrValue = array[index],
                            othValue = other[index];

                        if (customizer) {
                            var compared = isPartial
                                ? customizer(
                                      othValue,
                                      arrValue,
                                      index,
                                      other,
                                      array,
                                      stack
                                  )
                                : customizer(
                                      arrValue,
                                      othValue,
                                      index,
                                      array,
                                      other,
                                      stack
                                  );
                        }
                        if (compared !== undefined) {
                            if (compared) {
                                continue;
                            }
                            result = false;
                            break;
                        }
                        // Recursively compare arrays (susceptible to call stack limits).
                        if (seen) {
                            if (
                                !arraySome(
                                    other,
                                    function (othValue, othIndex) {
                                        if (
                                            !cacheHas(seen, othIndex) &&
                                            (arrValue === othValue ||
                                                equalFunc(
                                                    arrValue,
                                                    othValue,
                                                    bitmask,
                                                    customizer,
                                                    stack
                                                ))
                                        ) {
                                            return seen.push(othIndex);
                                        }
                                    }
                                )
                            ) {
                                result = false;
                                break;
                            }
                        } else if (
                            !(
                                arrValue === othValue ||
                                equalFunc(
                                    arrValue,
                                    othValue,
                                    bitmask,
                                    customizer,
                                    stack
                                )
                            )
                        ) {
                            result = false;
                            break;
                        }
                    }
                    stack["delete"](array);
                    stack["delete"](other);
                    return result;
                }

                module.exports = equalArrays;

                /***/
            },
            /* 148 */
            /***/ function (module, exports) {
                /**
                 * A specialized version of `_.some` for arrays without support for iteratee
                 * shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {boolean} Returns `true` if any element passes the predicate check,
                 *  else `false`.
                 */
                function arraySome(array, predicate) {
                    var index = -1,
                        length = array == null ? 0 : array.length;

                    while (++index < length) {
                        if (predicate(array[index], index, array)) {
                            return true;
                        }
                    }
                    return false;
                }

                module.exports = arraySome;

                /***/
            },
            /* 149 */
            /***/ function (module, exports, __webpack_require__) {
                var Symbol = __webpack_require__(47),
                    Uint8Array = __webpack_require__(150),
                    eq = __webpack_require__(93),
                    equalArrays = __webpack_require__(147),
                    mapToArray = __webpack_require__(151),
                    setToArray = __webpack_require__(152);

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /** `Object#toString` result references. */
                var boolTag = "[object Boolean]",
                    dateTag = "[object Date]",
                    errorTag = "[object Error]",
                    mapTag = "[object Map]",
                    numberTag = "[object Number]",
                    regexpTag = "[object RegExp]",
                    setTag = "[object Set]",
                    stringTag = "[object String]",
                    symbolTag = "[object Symbol]";

                var arrayBufferTag = "[object ArrayBuffer]",
                    dataViewTag = "[object DataView]";

                /** Used to convert symbols to primitives and strings. */
                var symbolProto = Symbol ? Symbol.prototype : undefined,
                    symbolValueOf = symbolProto
                        ? symbolProto.valueOf
                        : undefined;

                /**
                 * A specialized version of `baseIsEqualDeep` for comparing objects of
                 * the same `toStringTag`.
                 *
                 * **Note:** This function only supports comparing values with tags of
                 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
                 *
                 * @private
                 * @param {Object} object The object to compare.
                 * @param {Object} other The other object to compare.
                 * @param {string} tag The `toStringTag` of the objects to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} stack Tracks traversed `object` and `other` objects.
                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                 */
                function equalByTag(
                    object,
                    other,
                    tag,
                    bitmask,
                    customizer,
                    equalFunc,
                    stack
                ) {
                    switch (tag) {
                        case dataViewTag:
                            if (
                                object.byteLength != other.byteLength ||
                                object.byteOffset != other.byteOffset
                            ) {
                                return false;
                            }
                            object = object.buffer;
                            other = other.buffer;

                        case arrayBufferTag:
                            if (
                                object.byteLength != other.byteLength ||
                                !equalFunc(
                                    new Uint8Array(object),
                                    new Uint8Array(other)
                                )
                            ) {
                                return false;
                            }
                            return true;

                        case boolTag:
                        case dateTag:
                        case numberTag:
                            // Coerce booleans to `1` or `0` and dates to milliseconds.
                            // Invalid dates are coerced to `NaN`.
                            return eq(+object, +other);

                        case errorTag:
                            return (
                                object.name == other.name &&
                                object.message == other.message
                            );

                        case regexpTag:
                        case stringTag:
                            // Coerce regexes to strings and treat strings, primitives and objects,
                            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                            // for more details.
                            return object == other + "";

                        case mapTag:
                            var convert = mapToArray;

                        case setTag:
                            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                            convert || (convert = setToArray);

                            if (object.size != other.size && !isPartial) {
                                return false;
                            }
                            // Assume cyclic values are equal.
                            var stacked = stack.get(object);
                            if (stacked) {
                                return stacked == other;
                            }
                            bitmask |= COMPARE_UNORDERED_FLAG;

                            // Recursively compare objects (susceptible to call stack limits).
                            stack.set(object, other);
                            var result = equalArrays(
                                convert(object),
                                convert(other),
                                bitmask,
                                customizer,
                                equalFunc,
                                stack
                            );
                            stack["delete"](object);
                            return result;

                        case symbolTag:
                            if (symbolValueOf) {
                                return (
                                    symbolValueOf.call(object) ==
                                    symbolValueOf.call(other)
                                );
                            }
                    }
                    return false;
                }

                module.exports = equalByTag;

                /***/
            },
            /* 150 */
            /***/ function (module, exports, __webpack_require__) {
                var root = __webpack_require__(48);

                /** Built-in value references. */
                var Uint8Array = root.Uint8Array;

                module.exports = Uint8Array;

                /***/
            },
            /* 151 */
            /***/ function (module, exports) {
                /**
                 * Converts `map` to its key-value pairs.
                 *
                 * @private
                 * @param {Object} map The map to convert.
                 * @returns {Array} Returns the key-value pairs.
                 */
                function mapToArray(map) {
                    var index = -1,
                        result = Array(map.size);

                    map.forEach(function (value, key) {
                        result[++index] = [key, value];
                    });
                    return result;
                }

                module.exports = mapToArray;

                /***/
            },
            /* 152 */
            /***/ function (module, exports) {
                /**
                 * Converts `set` to an array of its values.
                 *
                 * @private
                 * @param {Object} set The set to convert.
                 * @returns {Array} Returns the values.
                 */
                function setToArray(set) {
                    var index = -1,
                        result = Array(set.size);

                    set.forEach(function (value) {
                        result[++index] = value;
                    });
                    return result;
                }

                module.exports = setToArray;

                /***/
            },
            /* 153 */
            /***/ function (module, exports, __webpack_require__) {
                var getAllKeys = __webpack_require__(154);

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1;

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * A specialized version of `baseIsEqualDeep` for objects with support for
                 * partial deep comparisons.
                 *
                 * @private
                 * @param {Object} object The object to compare.
                 * @param {Object} other The other object to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} stack Tracks traversed `object` and `other` objects.
                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                 */
                function equalObjects(
                    object,
                    other,
                    bitmask,
                    customizer,
                    equalFunc,
                    stack
                ) {
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                        objProps = getAllKeys(object),
                        objLength = objProps.length,
                        othProps = getAllKeys(other),
                        othLength = othProps.length;

                    if (objLength != othLength && !isPartial) {
                        return false;
                    }
                    var index = objLength;
                    while (index--) {
                        var key = objProps[index];
                        if (
                            !(isPartial
                                ? key in other
                                : hasOwnProperty.call(other, key))
                        ) {
                            return false;
                        }
                    }
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked && stack.get(other)) {
                        return stacked == other;
                    }
                    var result = true;
                    stack.set(object, other);
                    stack.set(other, object);

                    var skipCtor = isPartial;
                    while (++index < objLength) {
                        key = objProps[index];
                        var objValue = object[key],
                            othValue = other[key];

                        if (customizer) {
                            var compared = isPartial
                                ? customizer(
                                      othValue,
                                      objValue,
                                      key,
                                      other,
                                      object,
                                      stack
                                  )
                                : customizer(
                                      objValue,
                                      othValue,
                                      key,
                                      object,
                                      other,
                                      stack
                                  );
                        }
                        // Recursively compare objects (susceptible to call stack limits).
                        if (
                            !(compared === undefined
                                ? objValue === othValue ||
                                  equalFunc(
                                      objValue,
                                      othValue,
                                      bitmask,
                                      customizer,
                                      stack
                                  )
                                : compared)
                        ) {
                            result = false;
                            break;
                        }
                        skipCtor || (skipCtor = key == "constructor");
                    }
                    if (result && !skipCtor) {
                        var objCtor = object.constructor,
                            othCtor = other.constructor;

                        // Non `Object` object instances with different constructors are not equal.
                        if (
                            objCtor != othCtor &&
                            "constructor" in object &&
                            "constructor" in other &&
                            !(
                                typeof objCtor == "function" &&
                                objCtor instanceof objCtor &&
                                typeof othCtor == "function" &&
                                othCtor instanceof othCtor
                            )
                        ) {
                            result = false;
                        }
                    }
                    stack["delete"](object);
                    stack["delete"](other);
                    return result;
                }

                module.exports = equalObjects;

                /***/
            },
            /* 154 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetAllKeys = __webpack_require__(155),
                    getSymbols = __webpack_require__(157),
                    keys = __webpack_require__(41);

                /**
                 * Creates an array of own enumerable property names and symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names and symbols.
                 */
                function getAllKeys(object) {
                    return baseGetAllKeys(object, keys, getSymbols);
                }

                module.exports = getAllKeys;

                /***/
            },
            /* 155 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayPush = __webpack_require__(156),
                    isArray = __webpack_require__(53);

                /**
                 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
                 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
                 * symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Function} keysFunc The function to get the keys of `object`.
                 * @param {Function} symbolsFunc The function to get the symbols of `object`.
                 * @returns {Array} Returns the array of property names and symbols.
                 */
                function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                    var result = keysFunc(object);
                    return isArray(object)
                        ? result
                        : arrayPush(result, symbolsFunc(object));
                }

                module.exports = baseGetAllKeys;

                /***/
            },
            /* 156 */
            /***/ function (module, exports) {
                /**
                 * Appends the elements of `values` to `array`.
                 *
                 * @private
                 * @param {Array} array The array to modify.
                 * @param {Array} values The values to append.
                 * @returns {Array} Returns `array`.
                 */
                function arrayPush(array, values) {
                    var index = -1,
                        length = values.length,
                        offset = array.length;

                    while (++index < length) {
                        array[offset + index] = values[index];
                    }
                    return array;
                }

                module.exports = arrayPush;

                /***/
            },
            /* 157 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayFilter = __webpack_require__(134),
                    stubArray = __webpack_require__(158);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Built-in value references. */
                var propertyIsEnumerable = objectProto.propertyIsEnumerable;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeGetSymbols = Object.getOwnPropertySymbols;

                /**
                 * Creates an array of the own enumerable symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of symbols.
                 */
                var getSymbols = !nativeGetSymbols
                    ? stubArray
                    : function (object) {
                          if (object == null) {
                              return [];
                          }
                          object = Object(object);
                          return arrayFilter(
                              nativeGetSymbols(object),
                              function (symbol) {
                                  return propertyIsEnumerable.call(
                                      object,
                                      symbol
                                  );
                              }
                          );
                      };

                module.exports = getSymbols;

                /***/
            },
            /* 158 */
            /***/ function (module, exports) {
                /**
                 * This method returns a new empty array.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.13.0
                 * @category Util
                 * @returns {Array} Returns the new empty array.
                 * @example
                 *
                 * var arrays = _.times(2, _.stubArray);
                 *
                 * console.log(arrays);
                 * // => [[], []]
                 *
                 * console.log(arrays[0] === arrays[1]);
                 * // => false
                 */
                function stubArray() {
                    return [];
                }

                module.exports = stubArray;

                /***/
            },
            /* 159 */
            /***/ function (module, exports, __webpack_require__) {
                var DataView = __webpack_require__(160),
                    Map = __webpack_require__(97),
                    Promise = __webpack_require__(161),
                    Set = __webpack_require__(162),
                    WeakMap = __webpack_require__(163),
                    baseGetTag = __webpack_require__(46),
                    toSource = __webpack_require__(83);

                /** `Object#toString` result references. */
                var mapTag = "[object Map]",
                    objectTag = "[object Object]",
                    promiseTag = "[object Promise]",
                    setTag = "[object Set]",
                    weakMapTag = "[object WeakMap]";

                var dataViewTag = "[object DataView]";

                /** Used to detect maps, sets, and weakmaps. */
                var dataViewCtorString = toSource(DataView),
                    mapCtorString = toSource(Map),
                    promiseCtorString = toSource(Promise),
                    setCtorString = toSource(Set),
                    weakMapCtorString = toSource(WeakMap);

                /**
                 * Gets the `toStringTag` of `value`.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @returns {string} Returns the `toStringTag`.
                 */
                var getTag = baseGetTag;

                // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
                if (
                    (DataView &&
                        getTag(new DataView(new ArrayBuffer(1))) !=
                            dataViewTag) ||
                    (Map && getTag(new Map()) != mapTag) ||
                    (Promise && getTag(Promise.resolve()) != promiseTag) ||
                    (Set && getTag(new Set()) != setTag) ||
                    (WeakMap && getTag(new WeakMap()) != weakMapTag)
                ) {
                    getTag = function (value) {
                        var result = baseGetTag(value),
                            Ctor =
                                result == objectTag
                                    ? value.constructor
                                    : undefined,
                            ctorString = Ctor ? toSource(Ctor) : "";

                        if (ctorString) {
                            switch (ctorString) {
                                case dataViewCtorString:
                                    return dataViewTag;
                                case mapCtorString:
                                    return mapTag;
                                case promiseCtorString:
                                    return promiseTag;
                                case setCtorString:
                                    return setTag;
                                case weakMapCtorString:
                                    return weakMapTag;
                            }
                        }
                        return result;
                    };
                }

                module.exports = getTag;

                /***/
            },
            /* 160 */
            /***/ function (module, exports, __webpack_require__) {
                var getNative = __webpack_require__(79),
                    root = __webpack_require__(48);

                /* Built-in method references that are verified to be native. */
                var DataView = getNative(root, "DataView");

                module.exports = DataView;

                /***/
            },
            /* 161 */
            /***/ function (module, exports, __webpack_require__) {
                var getNative = __webpack_require__(79),
                    root = __webpack_require__(48);

                /* Built-in method references that are verified to be native. */
                var Promise = getNative(root, "Promise");

                module.exports = Promise;

                /***/
            },
            /* 162 */
            /***/ function (module, exports, __webpack_require__) {
                var getNative = __webpack_require__(79),
                    root = __webpack_require__(48);

                /* Built-in method references that are verified to be native. */
                var Set = getNative(root, "Set");

                module.exports = Set;

                /***/
            },
            /* 163 */
            /***/ function (module, exports, __webpack_require__) {
                var getNative = __webpack_require__(79),
                    root = __webpack_require__(48);

                /* Built-in method references that are verified to be native. */
                var WeakMap = getNative(root, "WeakMap");

                module.exports = WeakMap;

                /***/
            },
            /* 164 */
            /***/ function (module, exports, __webpack_require__) {
                var isStrictComparable = __webpack_require__(165),
                    keys = __webpack_require__(41);

                /**
                 * Gets the property names, values, and compare flags of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the match data of `object`.
                 */
                function getMatchData(object) {
                    var result = keys(object),
                        length = result.length;

                    while (length--) {
                        var key = result[length],
                            value = object[key];

                        result[length] = [
                            key,
                            value,
                            isStrictComparable(value),
                        ];
                    }
                    return result;
                }

                module.exports = getMatchData;

                /***/
            },
            /* 165 */
            /***/ function (module, exports, __webpack_require__) {
                var isObject = __webpack_require__(69);

                /**
                 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` if suitable for strict
                 *  equality comparisons, else `false`.
                 */
                function isStrictComparable(value) {
                    return value === value && !isObject(value);
                }

                module.exports = isStrictComparable;

                /***/
            },
            /* 166 */
            /***/ function (module, exports) {
                /**
                 * A specialized version of `matchesProperty` for source values suitable
                 * for strict equality comparisons, i.e. `===`.
                 *
                 * @private
                 * @param {string} key The key of the property to get.
                 * @param {*} srcValue The value to match.
                 * @returns {Function} Returns the new spec function.
                 */
                function matchesStrictComparable(key, srcValue) {
                    return function (object) {
                        if (object == null) {
                            return false;
                        }
                        return (
                            object[key] === srcValue &&
                            (srcValue !== undefined || key in Object(object))
                        );
                    };
                }

                module.exports = matchesStrictComparable;

                /***/
            },
            /* 167 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIsEqual = __webpack_require__(145),
                    get = __webpack_require__(168),
                    hasIn = __webpack_require__(179),
                    isKey = __webpack_require__(171),
                    isStrictComparable = __webpack_require__(165),
                    matchesStrictComparable = __webpack_require__(166),
                    toKey = __webpack_require__(178);

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /**
                 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
                 *
                 * @private
                 * @param {string} path The path of the property to get.
                 * @param {*} srcValue The value to match.
                 * @returns {Function} Returns the new spec function.
                 */
                function baseMatchesProperty(path, srcValue) {
                    if (isKey(path) && isStrictComparable(srcValue)) {
                        return matchesStrictComparable(toKey(path), srcValue);
                    }
                    return function (object) {
                        var objValue = get(object, path);
                        return objValue === undefined && objValue === srcValue
                            ? hasIn(object, path)
                            : baseIsEqual(
                                  srcValue,
                                  objValue,
                                  COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG
                              );
                    };
                }

                module.exports = baseMatchesProperty;

                /***/
            },
            /* 168 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGet = __webpack_require__(169);

                /**
                 * Gets the value at `path` of `object`. If the resolved value is
                 * `undefined`, the `defaultValue` is returned in its place.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.7.0
                 * @category Object
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path of the property to get.
                 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
                 * @returns {*} Returns the resolved value.
                 * @example
                 *
                 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                 *
                 * _.get(object, 'a[0].b.c');
                 * // => 3
                 *
                 * _.get(object, ['a', '0', 'b', 'c']);
                 * // => 3
                 *
                 * _.get(object, 'a.b.c', 'default');
                 * // => 'default'
                 */
                function get(object, path, defaultValue) {
                    var result =
                        object == null ? undefined : baseGet(object, path);
                    return result === undefined ? defaultValue : result;
                }

                module.exports = get;

                /***/
            },
            /* 169 */
            /***/ function (module, exports, __webpack_require__) {
                var castPath = __webpack_require__(170),
                    toKey = __webpack_require__(178);

                /**
                 * The base implementation of `_.get` without support for default values.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path of the property to get.
                 * @returns {*} Returns the resolved value.
                 */
                function baseGet(object, path) {
                    path = castPath(path, object);

                    var index = 0,
                        length = path.length;

                    while (object != null && index < length) {
                        object = object[toKey(path[index++])];
                    }
                    return index && index == length ? object : undefined;
                }

                module.exports = baseGet;

                /***/
            },
            /* 170 */
            /***/ function (module, exports, __webpack_require__) {
                var isArray = __webpack_require__(53),
                    isKey = __webpack_require__(171),
                    stringToPath = __webpack_require__(173),
                    toString = __webpack_require__(176);

                /**
                 * Casts `value` to a path array if it's not one.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @param {Object} [object] The object to query keys on.
                 * @returns {Array} Returns the cast property path array.
                 */
                function castPath(value, object) {
                    if (isArray(value)) {
                        return value;
                    }
                    return isKey(value, object)
                        ? [value]
                        : stringToPath(toString(value));
                }

                module.exports = castPath;

                /***/
            },
            /* 171 */
            /***/ function (module, exports, __webpack_require__) {
                var isArray = __webpack_require__(53),
                    isSymbol = __webpack_require__(172);

                /** Used to match property names within property paths. */
                var reIsDeepProp =
                        /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
                    reIsPlainProp = /^\w*$/;

                /**
                 * Checks if `value` is a property name and not a property path.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @param {Object} [object] The object to query keys on.
                 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
                 */
                function isKey(value, object) {
                    if (isArray(value)) {
                        return false;
                    }
                    var type = typeof value;
                    if (
                        type == "number" ||
                        type == "symbol" ||
                        type == "boolean" ||
                        value == null ||
                        isSymbol(value)
                    ) {
                        return true;
                    }
                    return (
                        reIsPlainProp.test(value) ||
                        !reIsDeepProp.test(value) ||
                        (object != null && value in Object(object))
                    );
                }

                module.exports = isKey;

                /***/
            },
            /* 172 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    isObjectLike = __webpack_require__(52);

                /** `Object#toString` result references. */
                var symbolTag = "[object Symbol]";

                /**
                 * Checks if `value` is classified as a `Symbol` primitive or object.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
                 * @example
                 *
                 * _.isSymbol(Symbol.iterator);
                 * // => true
                 *
                 * _.isSymbol('abc');
                 * // => false
                 */
                function isSymbol(value) {
                    return (
                        typeof value == "symbol" ||
                        (isObjectLike(value) && baseGetTag(value) == symbolTag)
                    );
                }

                module.exports = isSymbol;

                /***/
            },
            /* 173 */
            /***/ function (module, exports, __webpack_require__) {
                var memoizeCapped = __webpack_require__(174);

                /** Used to match property names within property paths. */
                var reLeadingDot = /^\./,
                    rePropName =
                        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

                /** Used to match backslashes in property paths. */
                var reEscapeChar = /\\(\\)?/g;

                /**
                 * Converts `string` to a property path array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the property path array.
                 */
                var stringToPath = memoizeCapped(function (string) {
                    var result = [];
                    if (reLeadingDot.test(string)) {
                        result.push("");
                    }
                    string.replace(
                        rePropName,
                        function (match, number, quote, string) {
                            result.push(
                                quote
                                    ? string.replace(reEscapeChar, "$1")
                                    : number || match
                            );
                        }
                    );
                    return result;
                });

                module.exports = stringToPath;

                /***/
            },
            /* 174 */
            /***/ function (module, exports, __webpack_require__) {
                var memoize = __webpack_require__(175);

                /** Used as the maximum memoize cache size. */
                var MAX_MEMOIZE_SIZE = 500;

                /**
                 * A specialized version of `_.memoize` which clears the memoized function's
                 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
                 *
                 * @private
                 * @param {Function} func The function to have its output memoized.
                 * @returns {Function} Returns the new memoized function.
                 */
                function memoizeCapped(func) {
                    var result = memoize(func, function (key) {
                        if (cache.size === MAX_MEMOIZE_SIZE) {
                            cache.clear();
                        }
                        return key;
                    });

                    var cache = result.cache;
                    return result;
                }

                module.exports = memoizeCapped;

                /***/
            },
            /* 175 */
            /***/ function (module, exports, __webpack_require__) {
                var MapCache = __webpack_require__(74);

                /** Error message constants. */
                var FUNC_ERROR_TEXT = "Expected a function";

                /**
                 * Creates a function that memoizes the result of `func`. If `resolver` is
                 * provided, it determines the cache key for storing the result based on the
                 * arguments provided to the memoized function. By default, the first argument
                 * provided to the memoized function is used as the map cache key. The `func`
                 * is invoked with the `this` binding of the memoized function.
                 *
                 * **Note:** The cache is exposed as the `cache` property on the memoized
                 * function. Its creation may be customized by replacing the `_.memoize.Cache`
                 * constructor with one whose instances implement the
                 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
                 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Function
                 * @param {Function} func The function to have its output memoized.
                 * @param {Function} [resolver] The function to resolve the cache key.
                 * @returns {Function} Returns the new memoized function.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': 2 };
                 * var other = { 'c': 3, 'd': 4 };
                 *
                 * var values = _.memoize(_.values);
                 * values(object);
                 * // => [1, 2]
                 *
                 * values(other);
                 * // => [3, 4]
                 *
                 * object.a = 2;
                 * values(object);
                 * // => [1, 2]
                 *
                 * // Modify the result cache.
                 * values.cache.set(object, ['a', 'b']);
                 * values(object);
                 * // => ['a', 'b']
                 *
                 * // Replace `_.memoize.Cache`.
                 * _.memoize.Cache = WeakMap;
                 */
                function memoize(func, resolver) {
                    if (
                        typeof func != "function" ||
                        (resolver != null && typeof resolver != "function")
                    ) {
                        throw new TypeError(FUNC_ERROR_TEXT);
                    }
                    var memoized = function () {
                        var args = arguments,
                            key = resolver
                                ? resolver.apply(this, args)
                                : args[0],
                            cache = memoized.cache;

                        if (cache.has(key)) {
                            return cache.get(key);
                        }
                        var result = func.apply(this, args);
                        memoized.cache = cache.set(key, result) || cache;
                        return result;
                    };
                    memoized.cache = new (memoize.Cache || MapCache)();
                    return memoized;
                }

                // Expose `MapCache`.
                memoize.Cache = MapCache;

                module.exports = memoize;

                /***/
            },
            /* 176 */
            /***/ function (module, exports, __webpack_require__) {
                var baseToString = __webpack_require__(177);

                /**
                 * Converts `value` to a string. An empty string is returned for `null`
                 * and `undefined` values. The sign of `-0` is preserved.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {string} Returns the converted string.
                 * @example
                 *
                 * _.toString(null);
                 * // => ''
                 *
                 * _.toString(-0);
                 * // => '-0'
                 *
                 * _.toString([1, 2, 3]);
                 * // => '1,2,3'
                 */
                function toString(value) {
                    return value == null ? "" : baseToString(value);
                }

                module.exports = toString;

                /***/
            },
            /* 177 */
            /***/ function (module, exports, __webpack_require__) {
                var Symbol = __webpack_require__(47),
                    arrayMap = __webpack_require__(71),
                    isArray = __webpack_require__(53),
                    isSymbol = __webpack_require__(172);

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0;

                /** Used to convert symbols to primitives and strings. */
                var symbolProto = Symbol ? Symbol.prototype : undefined,
                    symbolToString = symbolProto
                        ? symbolProto.toString
                        : undefined;

                /**
                 * The base implementation of `_.toString` which doesn't convert nullish
                 * values to empty strings.
                 *
                 * @private
                 * @param {*} value The value to process.
                 * @returns {string} Returns the string.
                 */
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == "string") {
                        return value;
                    }
                    if (isArray(value)) {
                        // Recursively convert values (susceptible to call stack limits).
                        return arrayMap(value, baseToString) + "";
                    }
                    if (isSymbol(value)) {
                        return symbolToString ? symbolToString.call(value) : "";
                    }
                    var result = value + "";
                    return result == "0" && 1 / value == -INFINITY
                        ? "-0"
                        : result;
                }

                module.exports = baseToString;

                /***/
            },
            /* 178 */
            /***/ function (module, exports, __webpack_require__) {
                var isSymbol = __webpack_require__(172);

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0;

                /**
                 * Converts `value` to a string key if it's not a string or symbol.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @returns {string|symbol} Returns the key.
                 */
                function toKey(value) {
                    if (typeof value == "string" || isSymbol(value)) {
                        return value;
                    }
                    var result = value + "";
                    return result == "0" && 1 / value == -INFINITY
                        ? "-0"
                        : result;
                }

                module.exports = toKey;

                /***/
            },
            /* 179 */
            /***/ function (module, exports, __webpack_require__) {
                var baseHasIn = __webpack_require__(180),
                    hasPath = __webpack_require__(181);

                /**
                 * Checks if `path` is a direct or inherited property of `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Object
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path to check.
                 * @returns {boolean} Returns `true` if `path` exists, else `false`.
                 * @example
                 *
                 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
                 *
                 * _.hasIn(object, 'a');
                 * // => true
                 *
                 * _.hasIn(object, 'a.b');
                 * // => true
                 *
                 * _.hasIn(object, ['a', 'b']);
                 * // => true
                 *
                 * _.hasIn(object, 'b');
                 * // => false
                 */
                function hasIn(object, path) {
                    return object != null && hasPath(object, path, baseHasIn);
                }

                module.exports = hasIn;

                /***/
            },
            /* 180 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.hasIn` without support for deep paths.
                 *
                 * @private
                 * @param {Object} [object] The object to query.
                 * @param {Array|string} key The key to check.
                 * @returns {boolean} Returns `true` if `key` exists, else `false`.
                 */
                function baseHasIn(object, key) {
                    return object != null && key in Object(object);
                }

                module.exports = baseHasIn;

                /***/
            },
            /* 181 */
            /***/ function (module, exports, __webpack_require__) {
                var castPath = __webpack_require__(170),
                    isArguments = __webpack_require__(44),
                    isArray = __webpack_require__(53),
                    isIndex = __webpack_require__(57),
                    isLength = __webpack_require__(60),
                    toKey = __webpack_require__(178);

                /**
                 * Checks if `path` exists on `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path to check.
                 * @param {Function} hasFunc The function to check properties.
                 * @returns {boolean} Returns `true` if `path` exists, else `false`.
                 */
                function hasPath(object, path, hasFunc) {
                    path = castPath(path, object);

                    var index = -1,
                        length = path.length,
                        result = false;

                    while (++index < length) {
                        var key = toKey(path[index]);
                        if (
                            !(result = object != null && hasFunc(object, key))
                        ) {
                            break;
                        }
                        object = object[key];
                    }
                    if (result || ++index != length) {
                        return result;
                    }
                    length = object == null ? 0 : object.length;
                    return (
                        !!length &&
                        isLength(length) &&
                        isIndex(key, length) &&
                        (isArray(object) || isArguments(object))
                    );
                }

                module.exports = hasPath;

                /***/
            },
            /* 182 */
            /***/ function (module, exports, __webpack_require__) {
                var baseProperty = __webpack_require__(183),
                    basePropertyDeep = __webpack_require__(184),
                    isKey = __webpack_require__(171),
                    toKey = __webpack_require__(178);

                /**
                 * Creates a function that returns the value at `path` of a given object.
                 *
                 * @static
                 * @memberOf _
                 * @since 2.4.0
                 * @category Util
                 * @param {Array|string} path The path of the property to get.
                 * @returns {Function} Returns the new accessor function.
                 * @example
                 *
                 * var objects = [
                 *   { 'a': { 'b': 2 } },
                 *   { 'a': { 'b': 1 } }
                 * ];
                 *
                 * _.map(objects, _.property('a.b'));
                 * // => [2, 1]
                 *
                 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
                 * // => [1, 2]
                 */
                function property(path) {
                    return isKey(path)
                        ? baseProperty(toKey(path))
                        : basePropertyDeep(path);
                }

                module.exports = property;

                /***/
            },
            /* 183 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.property` without support for deep paths.
                 *
                 * @private
                 * @param {string} key The key of the property to get.
                 * @returns {Function} Returns the new accessor function.
                 */
                function baseProperty(key) {
                    return function (object) {
                        return object == null ? undefined : object[key];
                    };
                }

                module.exports = baseProperty;

                /***/
            },
            /* 184 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGet = __webpack_require__(169);

                /**
                 * A specialized version of `baseProperty` which supports deep paths.
                 *
                 * @private
                 * @param {Array|string} path The path of the property to get.
                 * @returns {Function} Returns the new accessor function.
                 */
                function basePropertyDeep(path) {
                    return function (object) {
                        return baseGet(object, path);
                    };
                }

                module.exports = basePropertyDeep;

                /***/
            },
            /* 185 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayMap = __webpack_require__(71),
                    baseIteratee = __webpack_require__(136),
                    baseMap = __webpack_require__(186),
                    isArray = __webpack_require__(53);

                /**
                 * Creates an array of values by running each element in `collection` thru
                 * `iteratee`. The iteratee is invoked with three arguments:
                 * (value, index|key, collection).
                 *
                 * Many lodash methods are guarded to work as iteratees for methods like
                 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
                 *
                 * The guarded methods are:
                 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
                 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
                 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
                 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Array} Returns the new mapped array.
                 * @example
                 *
                 * function square(n) {
                 *   return n * n;
                 * }
                 *
                 * _.map([4, 8], square);
                 * // => [16, 64]
                 *
                 * _.map({ 'a': 4, 'b': 8 }, square);
                 * // => [16, 64] (iteration order is not guaranteed)
                 *
                 * var users = [
                 *   { 'user': 'barney' },
                 *   { 'user': 'fred' }
                 * ];
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.map(users, 'user');
                 * // => ['barney', 'fred']
                 */
                function map(collection, iteratee) {
                    var func = isArray(collection) ? arrayMap : baseMap;
                    return func(collection, baseIteratee(iteratee, 3));
                }

                module.exports = map;

                /***/
            },
            /* 186 */
            /***/ function (module, exports, __webpack_require__) {
                var baseEach = __webpack_require__(131),
                    isArrayLike = __webpack_require__(67);

                /**
                 * The base implementation of `_.map` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns the new mapped array.
                 */
                function baseMap(collection, iteratee) {
                    var index = -1,
                        result = isArrayLike(collection)
                            ? Array(collection.length)
                            : [];

                    baseEach(collection, function (value, key, collection) {
                        result[++index] = iteratee(value, key, collection);
                    });
                    return result;
                }

                module.exports = baseMap;

                /***/
            },
            /* 187 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayReduce = __webpack_require__(188),
                    baseEach = __webpack_require__(131),
                    baseIteratee = __webpack_require__(136),
                    baseReduce = __webpack_require__(189),
                    isArray = __webpack_require__(53);

                /**
                 * Reduces `collection` to a value which is the accumulated result of running
                 * each element in `collection` thru `iteratee`, where each successive
                 * invocation is supplied the return value of the previous. If `accumulator`
                 * is not given, the first element of `collection` is used as the initial
                 * value. The iteratee is invoked with four arguments:
                 * (accumulator, value, index|key, collection).
                 *
                 * Many lodash methods are guarded to work as iteratees for methods like
                 * `_.reduce`, `_.reduceRight`, and `_.transform`.
                 *
                 * The guarded methods are:
                 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
                 * and `sortBy`
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @param {*} [accumulator] The initial value.
                 * @returns {*} Returns the accumulated value.
                 * @see _.reduceRight
                 * @example
                 *
                 * _.reduce([1, 2], function(sum, n) {
                 *   return sum + n;
                 * }, 0);
                 * // => 3
                 *
                 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
                 *   (result[value] || (result[value] = [])).push(key);
                 *   return result;
                 * }, {});
                 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
                 */
                function reduce(collection, iteratee, accumulator) {
                    var func = isArray(collection) ? arrayReduce : baseReduce,
                        initAccum = arguments.length < 3;

                    return func(
                        collection,
                        baseIteratee(iteratee, 4),
                        accumulator,
                        initAccum,
                        baseEach
                    );
                }

                module.exports = reduce;

                /***/
            },
            /* 188 */
            /***/ function (module, exports) {
                /**
                 * A specialized version of `_.reduce` for arrays without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @param {*} [accumulator] The initial value.
                 * @param {boolean} [initAccum] Specify using the first element of `array` as
                 *  the initial value.
                 * @returns {*} Returns the accumulated value.
                 */
                function arrayReduce(array, iteratee, accumulator, initAccum) {
                    var index = -1,
                        length = array == null ? 0 : array.length;

                    if (initAccum && length) {
                        accumulator = array[++index];
                    }
                    while (++index < length) {
                        accumulator = iteratee(
                            accumulator,
                            array[index],
                            index,
                            array
                        );
                    }
                    return accumulator;
                }

                module.exports = arrayReduce;

                /***/
            },
            /* 189 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.reduce` and `_.reduceRight`, without support
                 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @param {*} accumulator The initial value.
                 * @param {boolean} initAccum Specify using the first or last element of
                 *  `collection` as the initial value.
                 * @param {Function} eachFunc The function to iterate over `collection`.
                 * @returns {*} Returns the accumulated value.
                 */
                function baseReduce(
                    collection,
                    iteratee,
                    accumulator,
                    initAccum,
                    eachFunc
                ) {
                    eachFunc(collection, function (value, index, collection) {
                        accumulator = initAccum
                            ? ((initAccum = false), value)
                            : iteratee(accumulator, value, index, collection);
                    });
                    return accumulator;
                }

                module.exports = baseReduce;

                /***/
            },
            /* 190 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayMap = __webpack_require__(71),
                    baseClone = __webpack_require__(191),
                    baseUnset = __webpack_require__(220),
                    castPath = __webpack_require__(170),
                    copyObject = __webpack_require__(195),
                    customOmitClone = __webpack_require__(224),
                    flatRest = __webpack_require__(226),
                    getAllKeysIn = __webpack_require__(206);

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1,
                    CLONE_FLAT_FLAG = 2,
                    CLONE_SYMBOLS_FLAG = 4;

                /**
                 * The opposite of `_.pick`; this method creates an object composed of the
                 * own and inherited enumerable property paths of `object` that are not omitted.
                 *
                 * **Note:** This method is considerably slower than `_.pick`.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The source object.
                 * @param {...(string|string[])} [paths] The property paths to omit.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': '2', 'c': 3 };
                 *
                 * _.omit(object, ['a', 'c']);
                 * // => { 'b': '2' }
                 */
                var omit = flatRest(function (object, paths) {
                    var result = {};
                    if (object == null) {
                        return result;
                    }
                    var isDeep = false;
                    paths = arrayMap(paths, function (path) {
                        path = castPath(path, object);
                        isDeep || (isDeep = path.length > 1);
                        return path;
                    });
                    copyObject(object, getAllKeysIn(object), result);
                    if (isDeep) {
                        result = baseClone(
                            result,
                            CLONE_DEEP_FLAG |
                                CLONE_FLAT_FLAG |
                                CLONE_SYMBOLS_FLAG,
                            customOmitClone
                        );
                    }
                    var length = paths.length;
                    while (length--) {
                        baseUnset(result, paths[length]);
                    }
                    return result;
                });

                module.exports = omit;

                /***/
            },
            /* 191 */
            /***/ function (module, exports, __webpack_require__) {
                var Stack = __webpack_require__(139),
                    arrayEach = __webpack_require__(130),
                    assignValue = __webpack_require__(192),
                    baseAssign = __webpack_require__(194),
                    baseAssignIn = __webpack_require__(196),
                    cloneBuffer = __webpack_require__(200),
                    copyArray = __webpack_require__(201),
                    copySymbols = __webpack_require__(202),
                    copySymbolsIn = __webpack_require__(203),
                    getAllKeys = __webpack_require__(154),
                    getAllKeysIn = __webpack_require__(206),
                    getTag = __webpack_require__(159),
                    initCloneArray = __webpack_require__(207),
                    initCloneByTag = __webpack_require__(208),
                    initCloneObject = __webpack_require__(218),
                    isArray = __webpack_require__(53),
                    isBuffer = __webpack_require__(54),
                    isObject = __webpack_require__(69),
                    keys = __webpack_require__(41);

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1,
                    CLONE_FLAT_FLAG = 2,
                    CLONE_SYMBOLS_FLAG = 4;

                /** `Object#toString` result references. */
                var argsTag = "[object Arguments]",
                    arrayTag = "[object Array]",
                    boolTag = "[object Boolean]",
                    dateTag = "[object Date]",
                    errorTag = "[object Error]",
                    funcTag = "[object Function]",
                    genTag = "[object GeneratorFunction]",
                    mapTag = "[object Map]",
                    numberTag = "[object Number]",
                    objectTag = "[object Object]",
                    regexpTag = "[object RegExp]",
                    setTag = "[object Set]",
                    stringTag = "[object String]",
                    symbolTag = "[object Symbol]",
                    weakMapTag = "[object WeakMap]";

                var arrayBufferTag = "[object ArrayBuffer]",
                    dataViewTag = "[object DataView]",
                    float32Tag = "[object Float32Array]",
                    float64Tag = "[object Float64Array]",
                    int8Tag = "[object Int8Array]",
                    int16Tag = "[object Int16Array]",
                    int32Tag = "[object Int32Array]",
                    uint8Tag = "[object Uint8Array]",
                    uint8ClampedTag = "[object Uint8ClampedArray]",
                    uint16Tag = "[object Uint16Array]",
                    uint32Tag = "[object Uint32Array]";

                /** Used to identify `toStringTag` values supported by `_.clone`. */
                var cloneableTags = {};
                cloneableTags[argsTag] =
                    cloneableTags[arrayTag] =
                    cloneableTags[arrayBufferTag] =
                    cloneableTags[dataViewTag] =
                    cloneableTags[boolTag] =
                    cloneableTags[dateTag] =
                    cloneableTags[float32Tag] =
                    cloneableTags[float64Tag] =
                    cloneableTags[int8Tag] =
                    cloneableTags[int16Tag] =
                    cloneableTags[int32Tag] =
                    cloneableTags[mapTag] =
                    cloneableTags[numberTag] =
                    cloneableTags[objectTag] =
                    cloneableTags[regexpTag] =
                    cloneableTags[setTag] =
                    cloneableTags[stringTag] =
                    cloneableTags[symbolTag] =
                    cloneableTags[uint8Tag] =
                    cloneableTags[uint8ClampedTag] =
                    cloneableTags[uint16Tag] =
                    cloneableTags[uint32Tag] =
                        true;
                cloneableTags[errorTag] =
                    cloneableTags[funcTag] =
                    cloneableTags[weakMapTag] =
                        false;

                /**
                 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
                 * traversed objects.
                 *
                 * @private
                 * @param {*} value The value to clone.
                 * @param {boolean} bitmask The bitmask flags.
                 *  1 - Deep clone
                 *  2 - Flatten inherited properties
                 *  4 - Clone symbols
                 * @param {Function} [customizer] The function to customize cloning.
                 * @param {string} [key] The key of `value`.
                 * @param {Object} [object] The parent object of `value`.
                 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
                 * @returns {*} Returns the cloned value.
                 */
                function baseClone(
                    value,
                    bitmask,
                    customizer,
                    key,
                    object,
                    stack
                ) {
                    var result,
                        isDeep = bitmask & CLONE_DEEP_FLAG,
                        isFlat = bitmask & CLONE_FLAT_FLAG,
                        isFull = bitmask & CLONE_SYMBOLS_FLAG;

                    if (customizer) {
                        result = object
                            ? customizer(value, key, object, stack)
                            : customizer(value);
                    }
                    if (result !== undefined) {
                        return result;
                    }
                    if (!isObject(value)) {
                        return value;
                    }
                    var isArr = isArray(value);
                    if (isArr) {
                        result = initCloneArray(value);
                        if (!isDeep) {
                            return copyArray(value, result);
                        }
                    } else {
                        var tag = getTag(value),
                            isFunc = tag == funcTag || tag == genTag;

                        if (isBuffer(value)) {
                            return cloneBuffer(value, isDeep);
                        }
                        if (
                            tag == objectTag ||
                            tag == argsTag ||
                            (isFunc && !object)
                        ) {
                            result =
                                isFlat || isFunc ? {} : initCloneObject(value);
                            if (!isDeep) {
                                return isFlat
                                    ? copySymbolsIn(
                                          value,
                                          baseAssignIn(result, value)
                                      )
                                    : copySymbols(
                                          value,
                                          baseAssign(result, value)
                                      );
                            }
                        } else {
                            if (!cloneableTags[tag]) {
                                return object ? value : {};
                            }
                            result = initCloneByTag(
                                value,
                                tag,
                                baseClone,
                                isDeep
                            );
                        }
                    }
                    // Check for circular references and return its corresponding clone.
                    stack || (stack = new Stack());
                    var stacked = stack.get(value);
                    if (stacked) {
                        return stacked;
                    }
                    stack.set(value, result);

                    var keysFunc = isFull
                        ? isFlat
                            ? getAllKeysIn
                            : getAllKeys
                        : isFlat
                        ? keysIn
                        : keys;

                    var props = isArr ? undefined : keysFunc(value);
                    arrayEach(props || value, function (subValue, key) {
                        if (props) {
                            key = subValue;
                            subValue = value[key];
                        }
                        // Recursively populate clone (susceptible to call stack limits).
                        assignValue(
                            result,
                            key,
                            baseClone(
                                subValue,
                                bitmask,
                                customizer,
                                key,
                                value,
                                stack
                            )
                        );
                    });
                    return result;
                }

                module.exports = baseClone;

                /***/
            },
            /* 192 */
            /***/ function (module, exports, __webpack_require__) {
                var baseAssignValue = __webpack_require__(193),
                    eq = __webpack_require__(93);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Assigns `value` to `key` of `object` if the existing value is not equivalent
                 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {string} key The key of the property to assign.
                 * @param {*} value The value to assign.
                 */
                function assignValue(object, key, value) {
                    var objValue = object[key];
                    if (
                        !(
                            hasOwnProperty.call(object, key) &&
                            eq(objValue, value)
                        ) ||
                        (value === undefined && !(key in object))
                    ) {
                        baseAssignValue(object, key, value);
                    }
                }

                module.exports = assignValue;

                /***/
            },
            /* 193 */
            /***/ function (module, exports, __webpack_require__) {
                var defineProperty = __webpack_require__(120);

                /**
                 * The base implementation of `assignValue` and `assignMergeValue` without
                 * value checks.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {string} key The key of the property to assign.
                 * @param {*} value The value to assign.
                 */
                function baseAssignValue(object, key, value) {
                    if (key == "__proto__" && defineProperty) {
                        defineProperty(object, key, {
                            configurable: true,
                            enumerable: true,
                            value: value,
                            writable: true,
                        });
                    } else {
                        object[key] = value;
                    }
                }

                module.exports = baseAssignValue;

                /***/
            },
            /* 194 */
            /***/ function (module, exports, __webpack_require__) {
                var copyObject = __webpack_require__(195),
                    keys = __webpack_require__(41);

                /**
                 * The base implementation of `_.assign` without support for multiple sources
                 * or `customizer` functions.
                 *
                 * @private
                 * @param {Object} object The destination object.
                 * @param {Object} source The source object.
                 * @returns {Object} Returns `object`.
                 */
                function baseAssign(object, source) {
                    return object && copyObject(source, keys(source), object);
                }

                module.exports = baseAssign;

                /***/
            },
            /* 195 */
            /***/ function (module, exports, __webpack_require__) {
                var assignValue = __webpack_require__(192),
                    baseAssignValue = __webpack_require__(193);

                /**
                 * Copies properties of `source` to `object`.
                 *
                 * @private
                 * @param {Object} source The object to copy properties from.
                 * @param {Array} props The property identifiers to copy.
                 * @param {Object} [object={}] The object to copy properties to.
                 * @param {Function} [customizer] The function to customize copied values.
                 * @returns {Object} Returns `object`.
                 */
                function copyObject(source, props, object, customizer) {
                    var isNew = !object;
                    object || (object = {});

                    var index = -1,
                        length = props.length;

                    while (++index < length) {
                        var key = props[index];

                        var newValue = customizer
                            ? customizer(
                                  object[key],
                                  source[key],
                                  key,
                                  object,
                                  source
                              )
                            : undefined;

                        if (newValue === undefined) {
                            newValue = source[key];
                        }
                        if (isNew) {
                            baseAssignValue(object, key, newValue);
                        } else {
                            assignValue(object, key, newValue);
                        }
                    }
                    return object;
                }

                module.exports = copyObject;

                /***/
            },
            /* 196 */
            /***/ function (module, exports, __webpack_require__) {
                var copyObject = __webpack_require__(195),
                    keysIn = __webpack_require__(197);

                /**
                 * The base implementation of `_.assignIn` without support for multiple sources
                 * or `customizer` functions.
                 *
                 * @private
                 * @param {Object} object The destination object.
                 * @param {Object} source The source object.
                 * @returns {Object} Returns `object`.
                 */
                function baseAssignIn(object, source) {
                    return object && copyObject(source, keysIn(source), object);
                }

                module.exports = baseAssignIn;

                /***/
            },
            /* 197 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayLikeKeys = __webpack_require__(42),
                    baseKeysIn = __webpack_require__(198),
                    isArrayLike = __webpack_require__(67);

                /**
                 * Creates an array of the own and inherited enumerable property names of `object`.
                 *
                 * **Note:** Non-object values are coerced to objects.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category Object
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.keysIn(new Foo);
                 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
                 */
                function keysIn(object) {
                    return isArrayLike(object)
                        ? arrayLikeKeys(object, true)
                        : baseKeysIn(object);
                }

                module.exports = keysIn;

                /***/
            },
            /* 198 */
            /***/ function (module, exports, __webpack_require__) {
                var isObject = __webpack_require__(69),
                    isPrototype = __webpack_require__(64),
                    nativeKeysIn = __webpack_require__(199);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 */
                function baseKeysIn(object) {
                    if (!isObject(object)) {
                        return nativeKeysIn(object);
                    }
                    var isProto = isPrototype(object),
                        result = [];

                    for (var key in object) {
                        if (
                            !(
                                key == "constructor" &&
                                (isProto || !hasOwnProperty.call(object, key))
                            )
                        ) {
                            result.push(key);
                        }
                    }
                    return result;
                }

                module.exports = baseKeysIn;

                /***/
            },
            /* 199 */
            /***/ function (module, exports) {
                /**
                 * This function is like
                 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                 * except that it includes inherited enumerable properties.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 */
                function nativeKeysIn(object) {
                    var result = [];
                    if (object != null) {
                        for (var key in Object(object)) {
                            result.push(key);
                        }
                    }
                    return result;
                }

                module.exports = nativeKeysIn;

                /***/
            },
            /* 200 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (module) {
                    var root = __webpack_require__(48);

                    /** Detect free variable `exports`. */
                    var freeExports =
                        typeof exports == "object" &&
                        exports &&
                        !exports.nodeType &&
                        exports;

                    /** Detect free variable `module`. */
                    var freeModule =
                        freeExports &&
                        typeof module == "object" &&
                        module &&
                        !module.nodeType &&
                        module;

                    /** Detect the popular CommonJS extension `module.exports`. */
                    var moduleExports =
                        freeModule && freeModule.exports === freeExports;

                    /** Built-in value references. */
                    var Buffer = moduleExports ? root.Buffer : undefined,
                        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

                    /**
                     * Creates a clone of  `buffer`.
                     *
                     * @private
                     * @param {Buffer} buffer The buffer to clone.
                     * @param {boolean} [isDeep] Specify a deep clone.
                     * @returns {Buffer} Returns the cloned buffer.
                     */
                    function cloneBuffer(buffer, isDeep) {
                        if (isDeep) {
                            return buffer.slice();
                        }
                        var length = buffer.length,
                            result = allocUnsafe
                                ? allocUnsafe(length)
                                : new buffer.constructor(length);

                        buffer.copy(result);
                        return result;
                    }

                    module.exports = cloneBuffer;

                    /* WEBPACK VAR INJECTION */
                }.call(exports, __webpack_require__(55)(module)));

                /***/
            },
            /* 201 */
            /***/ function (module, exports) {
                /**
                 * Copies the values of `source` to `array`.
                 *
                 * @private
                 * @param {Array} source The array to copy values from.
                 * @param {Array} [array=[]] The array to copy values to.
                 * @returns {Array} Returns `array`.
                 */
                function copyArray(source, array) {
                    var index = -1,
                        length = source.length;

                    array || (array = Array(length));
                    while (++index < length) {
                        array[index] = source[index];
                    }
                    return array;
                }

                module.exports = copyArray;

                /***/
            },
            /* 202 */
            /***/ function (module, exports, __webpack_require__) {
                var copyObject = __webpack_require__(195),
                    getSymbols = __webpack_require__(157);

                /**
                 * Copies own symbols of `source` to `object`.
                 *
                 * @private
                 * @param {Object} source The object to copy symbols from.
                 * @param {Object} [object={}] The object to copy symbols to.
                 * @returns {Object} Returns `object`.
                 */
                function copySymbols(source, object) {
                    return copyObject(source, getSymbols(source), object);
                }

                module.exports = copySymbols;

                /***/
            },
            /* 203 */
            /***/ function (module, exports, __webpack_require__) {
                var copyObject = __webpack_require__(195),
                    getSymbolsIn = __webpack_require__(204);

                /**
                 * Copies own and inherited symbols of `source` to `object`.
                 *
                 * @private
                 * @param {Object} source The object to copy symbols from.
                 * @param {Object} [object={}] The object to copy symbols to.
                 * @returns {Object} Returns `object`.
                 */
                function copySymbolsIn(source, object) {
                    return copyObject(source, getSymbolsIn(source), object);
                }

                module.exports = copySymbolsIn;

                /***/
            },
            /* 204 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayPush = __webpack_require__(156),
                    getPrototype = __webpack_require__(205),
                    getSymbols = __webpack_require__(157),
                    stubArray = __webpack_require__(158);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeGetSymbols = Object.getOwnPropertySymbols;

                /**
                 * Creates an array of the own and inherited enumerable symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of symbols.
                 */
                var getSymbolsIn = !nativeGetSymbols
                    ? stubArray
                    : function (object) {
                          var result = [];
                          while (object) {
                              arrayPush(result, getSymbols(object));
                              object = getPrototype(object);
                          }
                          return result;
                      };

                module.exports = getSymbolsIn;

                /***/
            },
            /* 205 */
            /***/ function (module, exports, __webpack_require__) {
                var overArg = __webpack_require__(66);

                /** Built-in value references. */
                var getPrototype = overArg(Object.getPrototypeOf, Object);

                module.exports = getPrototype;

                /***/
            },
            /* 206 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetAllKeys = __webpack_require__(155),
                    getSymbolsIn = __webpack_require__(204),
                    keysIn = __webpack_require__(197);

                /**
                 * Creates an array of own and inherited enumerable property names and
                 * symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names and symbols.
                 */
                function getAllKeysIn(object) {
                    return baseGetAllKeys(object, keysIn, getSymbolsIn);
                }

                module.exports = getAllKeysIn;

                /***/
            },
            /* 207 */
            /***/ function (module, exports) {
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Initializes an array clone.
                 *
                 * @private
                 * @param {Array} array The array to clone.
                 * @returns {Array} Returns the initialized clone.
                 */
                function initCloneArray(array) {
                    var length = array.length,
                        result = array.constructor(length);

                    // Add properties assigned by `RegExp#exec`.
                    if (
                        length &&
                        typeof array[0] == "string" &&
                        hasOwnProperty.call(array, "index")
                    ) {
                        result.index = array.index;
                        result.input = array.input;
                    }
                    return result;
                }

                module.exports = initCloneArray;

                /***/
            },
            /* 208 */
            /***/ function (module, exports, __webpack_require__) {
                var cloneArrayBuffer = __webpack_require__(209),
                    cloneDataView = __webpack_require__(210),
                    cloneMap = __webpack_require__(211),
                    cloneRegExp = __webpack_require__(213),
                    cloneSet = __webpack_require__(214),
                    cloneSymbol = __webpack_require__(216),
                    cloneTypedArray = __webpack_require__(217);

                /** `Object#toString` result references. */
                var boolTag = "[object Boolean]",
                    dateTag = "[object Date]",
                    mapTag = "[object Map]",
                    numberTag = "[object Number]",
                    regexpTag = "[object RegExp]",
                    setTag = "[object Set]",
                    stringTag = "[object String]",
                    symbolTag = "[object Symbol]";

                var arrayBufferTag = "[object ArrayBuffer]",
                    dataViewTag = "[object DataView]",
                    float32Tag = "[object Float32Array]",
                    float64Tag = "[object Float64Array]",
                    int8Tag = "[object Int8Array]",
                    int16Tag = "[object Int16Array]",
                    int32Tag = "[object Int32Array]",
                    uint8Tag = "[object Uint8Array]",
                    uint8ClampedTag = "[object Uint8ClampedArray]",
                    uint16Tag = "[object Uint16Array]",
                    uint32Tag = "[object Uint32Array]";

                /**
                 * Initializes an object clone based on its `toStringTag`.
                 *
                 * **Note:** This function only supports cloning values with tags of
                 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
                 *
                 * @private
                 * @param {Object} object The object to clone.
                 * @param {string} tag The `toStringTag` of the object to clone.
                 * @param {Function} cloneFunc The function to clone values.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the initialized clone.
                 */
                function initCloneByTag(object, tag, cloneFunc, isDeep) {
                    var Ctor = object.constructor;
                    switch (tag) {
                        case arrayBufferTag:
                            return cloneArrayBuffer(object);

                        case boolTag:
                        case dateTag:
                            return new Ctor(+object);

                        case dataViewTag:
                            return cloneDataView(object, isDeep);

                        case float32Tag:
                        case float64Tag:
                        case int8Tag:
                        case int16Tag:
                        case int32Tag:
                        case uint8Tag:
                        case uint8ClampedTag:
                        case uint16Tag:
                        case uint32Tag:
                            return cloneTypedArray(object, isDeep);

                        case mapTag:
                            return cloneMap(object, isDeep, cloneFunc);

                        case numberTag:
                        case stringTag:
                            return new Ctor(object);

                        case regexpTag:
                            return cloneRegExp(object);

                        case setTag:
                            return cloneSet(object, isDeep, cloneFunc);

                        case symbolTag:
                            return cloneSymbol(object);
                    }
                }

                module.exports = initCloneByTag;

                /***/
            },
            /* 209 */
            /***/ function (module, exports, __webpack_require__) {
                var Uint8Array = __webpack_require__(150);

                /**
                 * Creates a clone of `arrayBuffer`.
                 *
                 * @private
                 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
                 * @returns {ArrayBuffer} Returns the cloned array buffer.
                 */
                function cloneArrayBuffer(arrayBuffer) {
                    var result = new arrayBuffer.constructor(
                        arrayBuffer.byteLength
                    );
                    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                    return result;
                }

                module.exports = cloneArrayBuffer;

                /***/
            },
            /* 210 */
            /***/ function (module, exports, __webpack_require__) {
                var cloneArrayBuffer = __webpack_require__(209);

                /**
                 * Creates a clone of `dataView`.
                 *
                 * @private
                 * @param {Object} dataView The data view to clone.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned data view.
                 */
                function cloneDataView(dataView, isDeep) {
                    var buffer = isDeep
                        ? cloneArrayBuffer(dataView.buffer)
                        : dataView.buffer;
                    return new dataView.constructor(
                        buffer,
                        dataView.byteOffset,
                        dataView.byteLength
                    );
                }

                module.exports = cloneDataView;

                /***/
            },
            /* 211 */
            /***/ function (module, exports, __webpack_require__) {
                var addMapEntry = __webpack_require__(212),
                    arrayReduce = __webpack_require__(188),
                    mapToArray = __webpack_require__(151);

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1;

                /**
                 * Creates a clone of `map`.
                 *
                 * @private
                 * @param {Object} map The map to clone.
                 * @param {Function} cloneFunc The function to clone values.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned map.
                 */
                function cloneMap(map, isDeep, cloneFunc) {
                    var array = isDeep
                        ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG)
                        : mapToArray(map);
                    return arrayReduce(
                        array,
                        addMapEntry,
                        new map.constructor()
                    );
                }

                module.exports = cloneMap;

                /***/
            },
            /* 212 */
            /***/ function (module, exports) {
                /**
                 * Adds the key-value `pair` to `map`.
                 *
                 * @private
                 * @param {Object} map The map to modify.
                 * @param {Array} pair The key-value pair to add.
                 * @returns {Object} Returns `map`.
                 */
                function addMapEntry(map, pair) {
                    // Don't return `map.set` because it's not chainable in IE 11.
                    map.set(pair[0], pair[1]);
                    return map;
                }

                module.exports = addMapEntry;

                /***/
            },
            /* 213 */
            /***/ function (module, exports) {
                /** Used to match `RegExp` flags from their coerced string values. */
                var reFlags = /\w*$/;

                /**
                 * Creates a clone of `regexp`.
                 *
                 * @private
                 * @param {Object} regexp The regexp to clone.
                 * @returns {Object} Returns the cloned regexp.
                 */
                function cloneRegExp(regexp) {
                    var result = new regexp.constructor(
                        regexp.source,
                        reFlags.exec(regexp)
                    );
                    result.lastIndex = regexp.lastIndex;
                    return result;
                }

                module.exports = cloneRegExp;

                /***/
            },
            /* 214 */
            /***/ function (module, exports, __webpack_require__) {
                var addSetEntry = __webpack_require__(215),
                    arrayReduce = __webpack_require__(188),
                    setToArray = __webpack_require__(152);

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1;

                /**
                 * Creates a clone of `set`.
                 *
                 * @private
                 * @param {Object} set The set to clone.
                 * @param {Function} cloneFunc The function to clone values.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned set.
                 */
                function cloneSet(set, isDeep, cloneFunc) {
                    var array = isDeep
                        ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG)
                        : setToArray(set);
                    return arrayReduce(
                        array,
                        addSetEntry,
                        new set.constructor()
                    );
                }

                module.exports = cloneSet;

                /***/
            },
            /* 215 */
            /***/ function (module, exports) {
                /**
                 * Adds `value` to `set`.
                 *
                 * @private
                 * @param {Object} set The set to modify.
                 * @param {*} value The value to add.
                 * @returns {Object} Returns `set`.
                 */
                function addSetEntry(set, value) {
                    // Don't return `set.add` because it's not chainable in IE 11.
                    set.add(value);
                    return set;
                }

                module.exports = addSetEntry;

                /***/
            },
            /* 216 */
            /***/ function (module, exports, __webpack_require__) {
                var Symbol = __webpack_require__(47);

                /** Used to convert symbols to primitives and strings. */
                var symbolProto = Symbol ? Symbol.prototype : undefined,
                    symbolValueOf = symbolProto
                        ? symbolProto.valueOf
                        : undefined;

                /**
                 * Creates a clone of the `symbol` object.
                 *
                 * @private
                 * @param {Object} symbol The symbol object to clone.
                 * @returns {Object} Returns the cloned symbol object.
                 */
                function cloneSymbol(symbol) {
                    return symbolValueOf
                        ? Object(symbolValueOf.call(symbol))
                        : {};
                }

                module.exports = cloneSymbol;

                /***/
            },
            /* 217 */
            /***/ function (module, exports, __webpack_require__) {
                var cloneArrayBuffer = __webpack_require__(209);

                /**
                 * Creates a clone of `typedArray`.
                 *
                 * @private
                 * @param {Object} typedArray The typed array to clone.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned typed array.
                 */
                function cloneTypedArray(typedArray, isDeep) {
                    var buffer = isDeep
                        ? cloneArrayBuffer(typedArray.buffer)
                        : typedArray.buffer;
                    return new typedArray.constructor(
                        buffer,
                        typedArray.byteOffset,
                        typedArray.length
                    );
                }

                module.exports = cloneTypedArray;

                /***/
            },
            /* 218 */
            /***/ function (module, exports, __webpack_require__) {
                var baseCreate = __webpack_require__(219),
                    getPrototype = __webpack_require__(205),
                    isPrototype = __webpack_require__(64);

                /**
                 * Initializes an object clone.
                 *
                 * @private
                 * @param {Object} object The object to clone.
                 * @returns {Object} Returns the initialized clone.
                 */
                function initCloneObject(object) {
                    return typeof object.constructor == "function" &&
                        !isPrototype(object)
                        ? baseCreate(getPrototype(object))
                        : {};
                }

                module.exports = initCloneObject;

                /***/
            },
            /* 219 */
            /***/ function (module, exports, __webpack_require__) {
                var isObject = __webpack_require__(69);

                /** Built-in value references. */
                var objectCreate = Object.create;

                /**
                 * The base implementation of `_.create` without support for assigning
                 * properties to the created object.
                 *
                 * @private
                 * @param {Object} proto The object to inherit from.
                 * @returns {Object} Returns the new object.
                 */
                var baseCreate = (function () {
                    function object() {}
                    return function (proto) {
                        if (!isObject(proto)) {
                            return {};
                        }
                        if (objectCreate) {
                            return objectCreate(proto);
                        }
                        object.prototype = proto;
                        var result = new object();
                        object.prototype = undefined;
                        return result;
                    };
                })();

                module.exports = baseCreate;

                /***/
            },
            /* 220 */
            /***/ function (module, exports, __webpack_require__) {
                var castPath = __webpack_require__(170),
                    last = __webpack_require__(221),
                    parent = __webpack_require__(222),
                    toKey = __webpack_require__(178);

                /**
                 * The base implementation of `_.unset`.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {Array|string} path The property path to unset.
                 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
                 */
                function baseUnset(object, path) {
                    path = castPath(path, object);
                    object = parent(object, path);
                    return object == null || delete object[toKey(last(path))];
                }

                module.exports = baseUnset;

                /***/
            },
            /* 221 */
            /***/ function (module, exports) {
                /**
                 * Gets the last element of `array`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to query.
                 * @returns {*} Returns the last element of `array`.
                 * @example
                 *
                 * _.last([1, 2, 3]);
                 * // => 3
                 */
                function last(array) {
                    var length = array == null ? 0 : array.length;
                    return length ? array[length - 1] : undefined;
                }

                module.exports = last;

                /***/
            },
            /* 222 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGet = __webpack_require__(169),
                    baseSlice = __webpack_require__(223);

                /**
                 * Gets the parent value at `path` of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array} path The path to get the parent value of.
                 * @returns {*} Returns the parent value.
                 */
                function parent(object, path) {
                    return path.length < 2
                        ? object
                        : baseGet(object, baseSlice(path, 0, -1));
                }

                module.exports = parent;

                /***/
            },
            /* 223 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.slice` without an iteratee call guard.
                 *
                 * @private
                 * @param {Array} array The array to slice.
                 * @param {number} [start=0] The start position.
                 * @param {number} [end=array.length] The end position.
                 * @returns {Array} Returns the slice of `array`.
                 */
                function baseSlice(array, start, end) {
                    var index = -1,
                        length = array.length;

                    if (start < 0) {
                        start = -start > length ? 0 : length + start;
                    }
                    end = end > length ? length : end;
                    if (end < 0) {
                        end += length;
                    }
                    length = start > end ? 0 : (end - start) >>> 0;
                    start >>>= 0;

                    var result = Array(length);
                    while (++index < length) {
                        result[index] = array[index + start];
                    }
                    return result;
                }

                module.exports = baseSlice;

                /***/
            },
            /* 224 */
            /***/ function (module, exports, __webpack_require__) {
                var isPlainObject = __webpack_require__(225);

                /**
                 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
                 * objects.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @param {string} key The key of the property to inspect.
                 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
                 */
                function customOmitClone(value) {
                    return isPlainObject(value) ? undefined : value;
                }

                module.exports = customOmitClone;

                /***/
            },
            /* 225 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    getPrototype = __webpack_require__(205),
                    isObjectLike = __webpack_require__(52);

                /** `Object#toString` result references. */
                var objectTag = "[object Object]";

                /** Used for built-in method references. */
                var funcProto = Function.prototype,
                    objectProto = Object.prototype;

                /** Used to resolve the decompiled source of functions. */
                var funcToString = funcProto.toString;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /** Used to infer the `Object` constructor. */
                var objectCtorString = funcToString.call(Object);

                /**
                 * Checks if `value` is a plain object, that is, an object created by the
                 * `Object` constructor or one with a `[[Prototype]]` of `null`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.8.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 * }
                 *
                 * _.isPlainObject(new Foo);
                 * // => false
                 *
                 * _.isPlainObject([1, 2, 3]);
                 * // => false
                 *
                 * _.isPlainObject({ 'x': 0, 'y': 0 });
                 * // => true
                 *
                 * _.isPlainObject(Object.create(null));
                 * // => true
                 */
                function isPlainObject(value) {
                    if (
                        !isObjectLike(value) ||
                        baseGetTag(value) != objectTag
                    ) {
                        return false;
                    }
                    var proto = getPrototype(value);
                    if (proto === null) {
                        return true;
                    }
                    var Ctor =
                        hasOwnProperty.call(proto, "constructor") &&
                        proto.constructor;
                    return (
                        typeof Ctor == "function" &&
                        Ctor instanceof Ctor &&
                        funcToString.call(Ctor) == objectCtorString
                    );
                }

                module.exports = isPlainObject;

                /***/
            },
            /* 226 */
            /***/ function (module, exports, __webpack_require__) {
                var flatten = __webpack_require__(227),
                    overRest = __webpack_require__(115),
                    setToString = __webpack_require__(117);

                /**
                 * A specialized version of `baseRest` which flattens the rest array.
                 *
                 * @private
                 * @param {Function} func The function to apply a rest parameter to.
                 * @returns {Function} Returns the new function.
                 */
                function flatRest(func) {
                    return setToString(
                        overRest(func, undefined, flatten),
                        func + ""
                    );
                }

                module.exports = flatRest;

                /***/
            },
            /* 227 */
            /***/ function (module, exports, __webpack_require__) {
                var baseFlatten = __webpack_require__(228);

                /**
                 * Flattens `array` a single level deep.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to flatten.
                 * @returns {Array} Returns the new flattened array.
                 * @example
                 *
                 * _.flatten([1, [2, [3, [4]], 5]]);
                 * // => [1, 2, [3, [4]], 5]
                 */
                function flatten(array) {
                    var length = array == null ? 0 : array.length;
                    return length ? baseFlatten(array, 1) : [];
                }

                module.exports = flatten;

                /***/
            },
            /* 228 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayPush = __webpack_require__(156),
                    isFlattenable = __webpack_require__(229);

                /**
                 * The base implementation of `_.flatten` with support for restricting flattening.
                 *
                 * @private
                 * @param {Array} array The array to flatten.
                 * @param {number} depth The maximum recursion depth.
                 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
                 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
                 * @param {Array} [result=[]] The initial result value.
                 * @returns {Array} Returns the new flattened array.
                 */
                function baseFlatten(
                    array,
                    depth,
                    predicate,
                    isStrict,
                    result
                ) {
                    var index = -1,
                        length = array.length;

                    predicate || (predicate = isFlattenable);
                    result || (result = []);

                    while (++index < length) {
                        var value = array[index];
                        if (depth > 0 && predicate(value)) {
                            if (depth > 1) {
                                // Recursively flatten arrays (susceptible to call stack limits).
                                baseFlatten(
                                    value,
                                    depth - 1,
                                    predicate,
                                    isStrict,
                                    result
                                );
                            } else {
                                arrayPush(result, value);
                            }
                        } else if (!isStrict) {
                            result[result.length] = value;
                        }
                    }
                    return result;
                }

                module.exports = baseFlatten;

                /***/
            },
            /* 229 */
            /***/ function (module, exports, __webpack_require__) {
                var Symbol = __webpack_require__(47),
                    isArguments = __webpack_require__(44),
                    isArray = __webpack_require__(53);

                /** Built-in value references. */
                var spreadableSymbol = Symbol
                    ? Symbol.isConcatSpreadable
                    : undefined;

                /**
                 * Checks if `value` is a flattenable `arguments` object or array.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
                 */
                function isFlattenable(value) {
                    return (
                        isArray(value) ||
                        isArguments(value) ||
                        !!(spreadableSymbol && value && value[spreadableSymbol])
                    );
                }

                module.exports = isFlattenable;

                /***/
            },
            /* 230 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIndexOf = __webpack_require__(107),
                    toInteger = __webpack_require__(231);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * Gets the index at which the first occurrence of `value` is found in `array`
                 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons. If `fromIndex` is negative, it's used as the
                 * offset from the end of `array`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 * @example
                 *
                 * _.indexOf([1, 2, 1, 2], 2);
                 * // => 1
                 *
                 * // Search from the `fromIndex`.
                 * _.indexOf([1, 2, 1, 2], 2, 2);
                 * // => 3
                 */
                function indexOf(array, value, fromIndex) {
                    var length = array == null ? 0 : array.length;
                    if (!length) {
                        return -1;
                    }
                    var index = fromIndex == null ? 0 : toInteger(fromIndex);
                    if (index < 0) {
                        index = nativeMax(length + index, 0);
                    }
                    return baseIndexOf(array, value, index);
                }

                module.exports = indexOf;

                /***/
            },
            /* 231 */
            /***/ function (module, exports, __webpack_require__) {
                var toFinite = __webpack_require__(232);

                /**
                 * Converts `value` to an integer.
                 *
                 * **Note:** This method is loosely based on
                 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {number} Returns the converted integer.
                 * @example
                 *
                 * _.toInteger(3.2);
                 * // => 3
                 *
                 * _.toInteger(Number.MIN_VALUE);
                 * // => 0
                 *
                 * _.toInteger(Infinity);
                 * // => 1.7976931348623157e+308
                 *
                 * _.toInteger('3.2');
                 * // => 3
                 */
                function toInteger(value) {
                    var result = toFinite(value),
                        remainder = result % 1;

                    return result === result
                        ? remainder
                            ? result - remainder
                            : result
                        : 0;
                }

                module.exports = toInteger;

                /***/
            },
            /* 232 */
            /***/ function (module, exports, __webpack_require__) {
                var toNumber = __webpack_require__(233);

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0,
                    MAX_INTEGER = 1.7976931348623157e308;

                /**
                 * Converts `value` to a finite number.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.12.0
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {number} Returns the converted number.
                 * @example
                 *
                 * _.toFinite(3.2);
                 * // => 3.2
                 *
                 * _.toFinite(Number.MIN_VALUE);
                 * // => 5e-324
                 *
                 * _.toFinite(Infinity);
                 * // => 1.7976931348623157e+308
                 *
                 * _.toFinite('3.2');
                 * // => 3.2
                 */
                function toFinite(value) {
                    if (!value) {
                        return value === 0 ? value : 0;
                    }
                    value = toNumber(value);
                    if (value === INFINITY || value === -INFINITY) {
                        var sign = value < 0 ? -1 : 1;
                        return sign * MAX_INTEGER;
                    }
                    return value === value ? value : 0;
                }

                module.exports = toFinite;

                /***/
            },
            /* 233 */
            /***/ function (module, exports, __webpack_require__) {
                var isObject = __webpack_require__(69),
                    isSymbol = __webpack_require__(172);

                /** Used as references for various `Number` constants. */
                var NAN = 0 / 0;

                /** Used to match leading and trailing whitespace. */
                var reTrim = /^\s+|\s+$/g;

                /** Used to detect bad signed hexadecimal string values. */
                var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

                /** Used to detect binary string values. */
                var reIsBinary = /^0b[01]+$/i;

                /** Used to detect octal string values. */
                var reIsOctal = /^0o[0-7]+$/i;

                /** Built-in method references without a dependency on `root`. */
                var freeParseInt = parseInt;

                /**
                 * Converts `value` to a number.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to process.
                 * @returns {number} Returns the number.
                 * @example
                 *
                 * _.toNumber(3.2);
                 * // => 3.2
                 *
                 * _.toNumber(Number.MIN_VALUE);
                 * // => 5e-324
                 *
                 * _.toNumber(Infinity);
                 * // => Infinity
                 *
                 * _.toNumber('3.2');
                 * // => 3.2
                 */
                function toNumber(value) {
                    if (typeof value == "number") {
                        return value;
                    }
                    if (isSymbol(value)) {
                        return NAN;
                    }
                    if (isObject(value)) {
                        var other =
                            typeof value.valueOf == "function"
                                ? value.valueOf()
                                : value;
                        value = isObject(other) ? other + "" : other;
                    }
                    if (typeof value != "string") {
                        return value === 0 ? value : +value;
                    }
                    value = value.replace(reTrim, "");
                    var isBinary = reIsBinary.test(value);
                    return isBinary || reIsOctal.test(value)
                        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
                        : reIsBadHex.test(value)
                        ? NAN
                        : +value;
                }

                module.exports = toNumber;

                /***/
            },
            /* 234 */
            /***/ function (module, exports, __webpack_require__) {
                var isNumber = __webpack_require__(235);

                /**
                 * Checks if `value` is `NaN`.
                 *
                 * **Note:** This method is based on
                 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
                 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
                 * `undefined` and other non-number values.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                 * @example
                 *
                 * _.isNaN(NaN);
                 * // => true
                 *
                 * _.isNaN(new Number(NaN));
                 * // => true
                 *
                 * isNaN(undefined);
                 * // => true
                 *
                 * _.isNaN(undefined);
                 * // => false
                 */
                function isNaN(value) {
                    // An `NaN` primitive is the only value that is not equal to itself.
                    // Perform the `toStringTag` check first to avoid errors with some
                    // ActiveX objects in IE.
                    return isNumber(value) && value != +value;
                }

                module.exports = isNaN;

                /***/
            },
            /* 235 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    isObjectLike = __webpack_require__(52);

                /** `Object#toString` result references. */
                var numberTag = "[object Number]";

                /**
                 * Checks if `value` is classified as a `Number` primitive or object.
                 *
                 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
                 * classified as numbers, use the `_.isFinite` method.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
                 * @example
                 *
                 * _.isNumber(3);
                 * // => true
                 *
                 * _.isNumber(Number.MIN_VALUE);
                 * // => true
                 *
                 * _.isNumber(Infinity);
                 * // => true
                 *
                 * _.isNumber('3');
                 * // => false
                 */
                function isNumber(value) {
                    return (
                        typeof value == "number" ||
                        (isObjectLike(value) && baseGetTag(value) == numberTag)
                    );
                }

                module.exports = isNumber;

                /***/
            },
            /* 236 */
            /***/ function (module, exports, __webpack_require__) {
                var baseKeys = __webpack_require__(63),
                    getTag = __webpack_require__(159),
                    isArguments = __webpack_require__(44),
                    isArray = __webpack_require__(53),
                    isArrayLike = __webpack_require__(67),
                    isBuffer = __webpack_require__(54),
                    isPrototype = __webpack_require__(64),
                    isTypedArray = __webpack_require__(58);

                /** `Object#toString` result references. */
                var mapTag = "[object Map]",
                    setTag = "[object Set]";

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Checks if `value` is an empty object, collection, map, or set.
                 *
                 * Objects are considered empty if they have no own enumerable string keyed
                 * properties.
                 *
                 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
                 * jQuery-like collections are considered empty if they have a `length` of `0`.
                 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
                 * @example
                 *
                 * _.isEmpty(null);
                 * // => true
                 *
                 * _.isEmpty(true);
                 * // => true
                 *
                 * _.isEmpty(1);
                 * // => true
                 *
                 * _.isEmpty([1, 2, 3]);
                 * // => false
                 *
                 * _.isEmpty({ 'a': 1 });
                 * // => false
                 */
                function isEmpty(value) {
                    if (value == null) {
                        return true;
                    }
                    if (
                        isArrayLike(value) &&
                        (isArray(value) ||
                            typeof value == "string" ||
                            typeof value.splice == "function" ||
                            isBuffer(value) ||
                            isTypedArray(value) ||
                            isArguments(value))
                    ) {
                        return !value.length;
                    }
                    var tag = getTag(value);
                    if (tag == mapTag || tag == setTag) {
                        return !value.size;
                    }
                    if (isPrototype(value)) {
                        return !baseKeys(value).length;
                    }
                    for (var key in value) {
                        if (hasOwnProperty.call(value, key)) {
                            return false;
                        }
                    }
                    return true;
                }

                module.exports = isEmpty;

                /***/
            },
            /* 237 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIsEqual = __webpack_require__(145);

                /**
                 * Performs a deep comparison between two values to determine if they are
                 * equivalent.
                 *
                 * **Note:** This method supports comparing arrays, array buffers, booleans,
                 * date objects, error objects, maps, numbers, `Object` objects, regexes,
                 * sets, strings, symbols, and typed arrays. `Object` objects are compared
                 * by their own, not inherited, enumerable properties. Functions and DOM
                 * nodes are compared by strict equality, i.e. `===`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to compare.
                 * @param {*} other The other value to compare.
                 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                 * @example
                 *
                 * var object = { 'a': 1 };
                 * var other = { 'a': 1 };
                 *
                 * _.isEqual(object, other);
                 * // => true
                 *
                 * object === other;
                 * // => false
                 */
                function isEqual(value, other) {
                    return baseIsEqual(value, other);
                }

                module.exports = isEqual;

                /***/
            },
            /* 238 */
            /***/ function (module, exports) {
                /**
                 * Checks if `value` is `undefined`.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
                 * @example
                 *
                 * _.isUndefined(void 0);
                 * // => true
                 *
                 * _.isUndefined(null);
                 * // => false
                 */
                function isUndefined(value) {
                    return value === undefined;
                }

                module.exports = isUndefined;

                /***/
            },
            /* 239 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    isArray = __webpack_require__(53),
                    isObjectLike = __webpack_require__(52);

                /** `Object#toString` result references. */
                var stringTag = "[object String]";

                /**
                 * Checks if `value` is classified as a `String` primitive or object.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
                 * @example
                 *
                 * _.isString('abc');
                 * // => true
                 *
                 * _.isString(1);
                 * // => false
                 */
                function isString(value) {
                    return (
                        typeof value == "string" ||
                        (!isArray(value) &&
                            isObjectLike(value) &&
                            baseGetTag(value) == stringTag)
                    );
                }

                module.exports = isString;

                /***/
            },
            /* 240 */
            /***/ function (module, exports, __webpack_require__) {
                var createFind = __webpack_require__(241),
                    findIndex = __webpack_require__(242);

                /**
                 * Iterates over elements of `collection`, returning the first element
                 * `predicate` returns truthy for. The predicate is invoked with three
                 * arguments: (value, index|key, collection).
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to inspect.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @returns {*} Returns the matched element, else `undefined`.
                 * @example
                 *
                 * var users = [
                 *   { 'user': 'barney',  'age': 36, 'active': true },
                 *   { 'user': 'fred',    'age': 40, 'active': false },
                 *   { 'user': 'pebbles', 'age': 1,  'active': true }
                 * ];
                 *
                 * _.find(users, function(o) { return o.age < 40; });
                 * // => object for 'barney'
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.find(users, { 'age': 1, 'active': true });
                 * // => object for 'pebbles'
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.find(users, ['active', false]);
                 * // => object for 'fred'
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.find(users, 'active');
                 * // => object for 'barney'
                 */
                var find = createFind(findIndex);

                module.exports = find;

                /***/
            },
            /* 241 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIteratee = __webpack_require__(136),
                    isArrayLike = __webpack_require__(67),
                    keys = __webpack_require__(41);

                /**
                 * Creates a `_.find` or `_.findLast` function.
                 *
                 * @private
                 * @param {Function} findIndexFunc The function to find the collection index.
                 * @returns {Function} Returns the new find function.
                 */
                function createFind(findIndexFunc) {
                    return function (collection, predicate, fromIndex) {
                        var iterable = Object(collection);
                        if (!isArrayLike(collection)) {
                            var iteratee = baseIteratee(predicate, 3);
                            collection = keys(collection);
                            predicate = function (key) {
                                return iteratee(iterable[key], key, iterable);
                            };
                        }
                        var index = findIndexFunc(
                            collection,
                            predicate,
                            fromIndex
                        );
                        return index > -1
                            ? iterable[iteratee ? collection[index] : index]
                            : undefined;
                    };
                }

                module.exports = createFind;

                /***/
            },
            /* 242 */
            /***/ function (module, exports, __webpack_require__) {
                var baseFindIndex = __webpack_require__(108),
                    baseIteratee = __webpack_require__(136),
                    toInteger = __webpack_require__(231);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * This method is like `_.find` except that it returns the index of the first
                 * element `predicate` returns truthy for instead of the element itself.
                 *
                 * @static
                 * @memberOf _
                 * @since 1.1.0
                 * @category Array
                 * @param {Array} array The array to inspect.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @returns {number} Returns the index of the found element, else `-1`.
                 * @example
                 *
                 * var users = [
                 *   { 'user': 'barney',  'active': false },
                 *   { 'user': 'fred',    'active': false },
                 *   { 'user': 'pebbles', 'active': true }
                 * ];
                 *
                 * _.findIndex(users, function(o) { return o.user == 'barney'; });
                 * // => 0
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.findIndex(users, { 'user': 'fred', 'active': false });
                 * // => 1
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.findIndex(users, ['active', false]);
                 * // => 0
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.findIndex(users, 'active');
                 * // => 2
                 */
                function findIndex(array, predicate, fromIndex) {
                    var length = array == null ? 0 : array.length;
                    if (!length) {
                        return -1;
                    }
                    var index = fromIndex == null ? 0 : toInteger(fromIndex);
                    if (index < 0) {
                        index = nativeMax(length + index, 0);
                    }
                    return baseFindIndex(
                        array,
                        baseIteratee(predicate, 3),
                        index
                    );
                }

                module.exports = findIndex;

                /***/
            },
            /* 243 */
            /***/ function (module, exports, __webpack_require__) {
                var baseToString = __webpack_require__(177),
                    castSlice = __webpack_require__(244),
                    charsEndIndex = __webpack_require__(245),
                    charsStartIndex = __webpack_require__(246),
                    stringToArray = __webpack_require__(247),
                    toString = __webpack_require__(176);

                /** Used to match leading and trailing whitespace. */
                var reTrim = /^\s+|\s+$/g;

                /**
                 * Removes leading and trailing whitespace or specified characters from `string`.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category String
                 * @param {string} [string=''] The string to trim.
                 * @param {string} [chars=whitespace] The characters to trim.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                 * @returns {string} Returns the trimmed string.
                 * @example
                 *
                 * _.trim('  abc  ');
                 * // => 'abc'
                 *
                 * _.trim('-_-abc-_-', '_-');
                 * // => 'abc'
                 *
                 * _.map(['  foo  ', '  bar  '], _.trim);
                 * // => ['foo', 'bar']
                 */
                function trim(string, chars, guard) {
                    string = toString(string);
                    if (string && (guard || chars === undefined)) {
                        return string.replace(reTrim, "");
                    }
                    if (!string || !(chars = baseToString(chars))) {
                        return string;
                    }
                    var strSymbols = stringToArray(string),
                        chrSymbols = stringToArray(chars),
                        start = charsStartIndex(strSymbols, chrSymbols),
                        end = charsEndIndex(strSymbols, chrSymbols) + 1;

                    return castSlice(strSymbols, start, end).join("");
                }

                module.exports = trim;

                /***/
            },
            /* 244 */
            /***/ function (module, exports, __webpack_require__) {
                var baseSlice = __webpack_require__(223);

                /**
                 * Casts `array` to a slice if it's needed.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {number} start The start position.
                 * @param {number} [end=array.length] The end position.
                 * @returns {Array} Returns the cast slice.
                 */
                function castSlice(array, start, end) {
                    var length = array.length;
                    end = end === undefined ? length : end;
                    return !start && end >= length
                        ? array
                        : baseSlice(array, start, end);
                }

                module.exports = castSlice;

                /***/
            },
            /* 245 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIndexOf = __webpack_require__(107);

                /**
                 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
                 * that is not found in the character symbols.
                 *
                 * @private
                 * @param {Array} strSymbols The string symbols to inspect.
                 * @param {Array} chrSymbols The character symbols to find.
                 * @returns {number} Returns the index of the last unmatched string symbol.
                 */
                function charsEndIndex(strSymbols, chrSymbols) {
                    var index = strSymbols.length;

                    while (
                        index-- &&
                        baseIndexOf(chrSymbols, strSymbols[index], 0) > -1
                    ) {}
                    return index;
                }

                module.exports = charsEndIndex;

                /***/
            },
            /* 246 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIndexOf = __webpack_require__(107);

                /**
                 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
                 * that is not found in the character symbols.
                 *
                 * @private
                 * @param {Array} strSymbols The string symbols to inspect.
                 * @param {Array} chrSymbols The character symbols to find.
                 * @returns {number} Returns the index of the first unmatched string symbol.
                 */
                function charsStartIndex(strSymbols, chrSymbols) {
                    var index = -1,
                        length = strSymbols.length;

                    while (
                        ++index < length &&
                        baseIndexOf(chrSymbols, strSymbols[index], 0) > -1
                    ) {}
                    return index;
                }

                module.exports = charsStartIndex;

                /***/
            },
            /* 247 */
            /***/ function (module, exports, __webpack_require__) {
                var asciiToArray = __webpack_require__(248),
                    hasUnicode = __webpack_require__(249),
                    unicodeToArray = __webpack_require__(250);

                /**
                 * Converts `string` to an array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the converted array.
                 */
                function stringToArray(string) {
                    return hasUnicode(string)
                        ? unicodeToArray(string)
                        : asciiToArray(string);
                }

                module.exports = stringToArray;

                /***/
            },
            /* 248 */
            /***/ function (module, exports) {
                /**
                 * Converts an ASCII `string` to an array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the converted array.
                 */
                function asciiToArray(string) {
                    return string.split("");
                }

                module.exports = asciiToArray;

                /***/
            },
            /* 249 */
            /***/ function (module, exports) {
                /** Used to compose unicode character classes. */
                var rsAstralRange = "\\ud800-\\udfff",
                    rsComboMarksRange = "\\u0300-\\u036f",
                    reComboHalfMarksRange = "\\ufe20-\\ufe2f",
                    rsComboSymbolsRange = "\\u20d0-\\u20ff",
                    rsComboRange =
                        rsComboMarksRange +
                        reComboHalfMarksRange +
                        rsComboSymbolsRange,
                    rsVarRange = "\\ufe0e\\ufe0f";

                /** Used to compose unicode capture groups. */
                var rsZWJ = "\\u200d";

                /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
                var reHasUnicode = RegExp(
                    "[" +
                        rsZWJ +
                        rsAstralRange +
                        rsComboRange +
                        rsVarRange +
                        "]"
                );

                /**
                 * Checks if `string` contains Unicode symbols.
                 *
                 * @private
                 * @param {string} string The string to inspect.
                 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
                 */
                function hasUnicode(string) {
                    return reHasUnicode.test(string);
                }

                module.exports = hasUnicode;

                /***/
            },
            /* 250 */
            /***/ function (module, exports) {
                /** Used to compose unicode character classes. */
                var rsAstralRange = "\\ud800-\\udfff",
                    rsComboMarksRange = "\\u0300-\\u036f",
                    reComboHalfMarksRange = "\\ufe20-\\ufe2f",
                    rsComboSymbolsRange = "\\u20d0-\\u20ff",
                    rsComboRange =
                        rsComboMarksRange +
                        reComboHalfMarksRange +
                        rsComboSymbolsRange,
                    rsVarRange = "\\ufe0e\\ufe0f";

                /** Used to compose unicode capture groups. */
                var rsAstral = "[" + rsAstralRange + "]",
                    rsCombo = "[" + rsComboRange + "]",
                    rsFitz = "\\ud83c[\\udffb-\\udfff]",
                    rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")",
                    rsNonAstral = "[^" + rsAstralRange + "]",
                    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
                    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
                    rsZWJ = "\\u200d";

                /** Used to compose unicode regexes. */
                var reOptMod = rsModifier + "?",
                    rsOptVar = "[" + rsVarRange + "]?",
                    rsOptJoin =
                        "(?:" +
                        rsZWJ +
                        "(?:" +
                        [rsNonAstral, rsRegional, rsSurrPair].join("|") +
                        ")" +
                        rsOptVar +
                        reOptMod +
                        ")*",
                    rsSeq = rsOptVar + reOptMod + rsOptJoin,
                    rsSymbol =
                        "(?:" +
                        [
                            rsNonAstral + rsCombo + "?",
                            rsCombo,
                            rsRegional,
                            rsSurrPair,
                            rsAstral,
                        ].join("|") +
                        ")";

                /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
                var reUnicode = RegExp(
                    rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq,
                    "g"
                );

                /**
                 * Converts a Unicode `string` to an array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the converted array.
                 */
                function unicodeToArray(string) {
                    return string.match(reUnicode) || [];
                }

                module.exports = unicodeToArray;

                /***/
            },
            /* 251 */
            /***/ function (module, exports, __webpack_require__) {
                var apply = __webpack_require__(116),
                    assignInWith = __webpack_require__(252),
                    baseRest = __webpack_require__(113),
                    customDefaultsAssignIn = __webpack_require__(255);

                /**
                 * Assigns own and inherited enumerable string keyed properties of source
                 * objects to the destination object for all destination properties that
                 * resolve to `undefined`. Source objects are applied from left to right.
                 * Once a property is set, additional values of the same property are ignored.
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} [sources] The source objects.
                 * @returns {Object} Returns `object`.
                 * @see _.defaultsDeep
                 * @example
                 *
                 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                 * // => { 'a': 1, 'b': 2 }
                 */
                var defaults = baseRest(function (args) {
                    args.push(undefined, customDefaultsAssignIn);
                    return apply(assignInWith, undefined, args);
                });

                module.exports = defaults;

                /***/
            },
            /* 252 */
            /***/ function (module, exports, __webpack_require__) {
                var copyObject = __webpack_require__(195),
                    createAssigner = __webpack_require__(253),
                    keysIn = __webpack_require__(197);

                /**
                 * This method is like `_.assignIn` except that it accepts `customizer`
                 * which is invoked to produce the assigned values. If `customizer` returns
                 * `undefined`, assignment is handled by the method instead. The `customizer`
                 * is invoked with five arguments: (objValue, srcValue, key, object, source).
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @alias extendWith
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} sources The source objects.
                 * @param {Function} [customizer] The function to customize assigned values.
                 * @returns {Object} Returns `object`.
                 * @see _.assignWith
                 * @example
                 *
                 * function customizer(objValue, srcValue) {
                 *   return _.isUndefined(objValue) ? srcValue : objValue;
                 * }
                 *
                 * var defaults = _.partialRight(_.assignInWith, customizer);
                 *
                 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                 * // => { 'a': 1, 'b': 2 }
                 */
                var assignInWith = createAssigner(function (
                    object,
                    source,
                    srcIndex,
                    customizer
                ) {
                    copyObject(source, keysIn(source), object, customizer);
                });

                module.exports = assignInWith;

                /***/
            },
            /* 253 */
            /***/ function (module, exports, __webpack_require__) {
                var baseRest = __webpack_require__(113),
                    isIterateeCall = __webpack_require__(254);

                /**
                 * Creates a function like `_.assign`.
                 *
                 * @private
                 * @param {Function} assigner The function to assign values.
                 * @returns {Function} Returns the new assigner function.
                 */
                function createAssigner(assigner) {
                    return baseRest(function (object, sources) {
                        var index = -1,
                            length = sources.length,
                            customizer =
                                length > 1 ? sources[length - 1] : undefined,
                            guard = length > 2 ? sources[2] : undefined;

                        customizer =
                            assigner.length > 3 &&
                            typeof customizer == "function"
                                ? (length--, customizer)
                                : undefined;

                        if (
                            guard &&
                            isIterateeCall(sources[0], sources[1], guard)
                        ) {
                            customizer = length < 3 ? undefined : customizer;
                            length = 1;
                        }
                        object = Object(object);
                        while (++index < length) {
                            var source = sources[index];
                            if (source) {
                                assigner(object, source, index, customizer);
                            }
                        }
                        return object;
                    });
                }

                module.exports = createAssigner;

                /***/
            },
            /* 254 */
            /***/ function (module, exports, __webpack_require__) {
                var eq = __webpack_require__(93),
                    isArrayLike = __webpack_require__(67),
                    isIndex = __webpack_require__(57),
                    isObject = __webpack_require__(69);

                /**
                 * Checks if the given arguments are from an iteratee call.
                 *
                 * @private
                 * @param {*} value The potential iteratee value argument.
                 * @param {*} index The potential iteratee index or key argument.
                 * @param {*} object The potential iteratee object argument.
                 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
                 *  else `false`.
                 */
                function isIterateeCall(value, index, object) {
                    if (!isObject(object)) {
                        return false;
                    }
                    var type = typeof index;
                    if (
                        type == "number"
                            ? isArrayLike(object) &&
                              isIndex(index, object.length)
                            : type == "string" && index in object
                    ) {
                        return eq(object[index], value);
                    }
                    return false;
                }

                module.exports = isIterateeCall;

                /***/
            },
            /* 255 */
            /***/ function (module, exports, __webpack_require__) {
                var eq = __webpack_require__(93);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
                 * of source objects to the destination object for all destination properties
                 * that resolve to `undefined`.
                 *
                 * @private
                 * @param {*} objValue The destination value.
                 * @param {*} srcValue The source value.
                 * @param {string} key The key of the property to assign.
                 * @param {Object} object The parent object of `objValue`.
                 * @returns {*} Returns the value to assign.
                 */
                function customDefaultsAssignIn(
                    objValue,
                    srcValue,
                    key,
                    object
                ) {
                    if (
                        objValue === undefined ||
                        (eq(objValue, objectProto[key]) &&
                            !hasOwnProperty.call(object, key))
                    ) {
                        return srcValue;
                    }
                    return objValue;
                }

                module.exports = customDefaultsAssignIn;

                /***/
            },
            /* 256 */
            /***/ function (module, exports, __webpack_require__) {
                var baseMerge = __webpack_require__(257),
                    createAssigner = __webpack_require__(253);

                /**
                 * This method is like `_.assign` except that it recursively merges own and
                 * inherited enumerable string keyed properties of source objects into the
                 * destination object. Source properties that resolve to `undefined` are
                 * skipped if a destination value exists. Array and plain object properties
                 * are merged recursively. Other objects and value types are overridden by
                 * assignment. Source objects are applied from left to right. Subsequent
                 * sources overwrite property assignments of previous sources.
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.5.0
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} [sources] The source objects.
                 * @returns {Object} Returns `object`.
                 * @example
                 *
                 * var object = {
                 *   'a': [{ 'b': 2 }, { 'd': 4 }]
                 * };
                 *
                 * var other = {
                 *   'a': [{ 'c': 3 }, { 'e': 5 }]
                 * };
                 *
                 * _.merge(object, other);
                 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
                 */
                var merge = createAssigner(function (object, source, srcIndex) {
                    baseMerge(object, source, srcIndex);
                });

                module.exports = merge;

                /***/
            },
            /* 257 */
            /***/ function (module, exports, __webpack_require__) {
                var Stack = __webpack_require__(139),
                    assignMergeValue = __webpack_require__(258),
                    baseFor = __webpack_require__(126),
                    baseMergeDeep = __webpack_require__(259),
                    isObject = __webpack_require__(69),
                    keysIn = __webpack_require__(197);

                /**
                 * The base implementation of `_.merge` without support for multiple sources.
                 *
                 * @private
                 * @param {Object} object The destination object.
                 * @param {Object} source The source object.
                 * @param {number} srcIndex The index of `source`.
                 * @param {Function} [customizer] The function to customize merged values.
                 * @param {Object} [stack] Tracks traversed source values and their merged
                 *  counterparts.
                 */
                function baseMerge(
                    object,
                    source,
                    srcIndex,
                    customizer,
                    stack
                ) {
                    if (object === source) {
                        return;
                    }
                    baseFor(
                        source,
                        function (srcValue, key) {
                            if (isObject(srcValue)) {
                                stack || (stack = new Stack());
                                baseMergeDeep(
                                    object,
                                    source,
                                    key,
                                    srcIndex,
                                    baseMerge,
                                    customizer,
                                    stack
                                );
                            } else {
                                var newValue = customizer
                                    ? customizer(
                                          object[key],
                                          srcValue,
                                          key + "",
                                          object,
                                          source,
                                          stack
                                      )
                                    : undefined;

                                if (newValue === undefined) {
                                    newValue = srcValue;
                                }
                                assignMergeValue(object, key, newValue);
                            }
                        },
                        keysIn
                    );
                }

                module.exports = baseMerge;

                /***/
            },
            /* 258 */
            /***/ function (module, exports, __webpack_require__) {
                var baseAssignValue = __webpack_require__(193),
                    eq = __webpack_require__(93);

                /**
                 * This function is like `assignValue` except that it doesn't assign
                 * `undefined` values.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {string} key The key of the property to assign.
                 * @param {*} value The value to assign.
                 */
                function assignMergeValue(object, key, value) {
                    if (
                        (value !== undefined && !eq(object[key], value)) ||
                        (value === undefined && !(key in object))
                    ) {
                        baseAssignValue(object, key, value);
                    }
                }

                module.exports = assignMergeValue;

                /***/
            },
            /* 259 */
            /***/ function (module, exports, __webpack_require__) {
                var assignMergeValue = __webpack_require__(258),
                    cloneBuffer = __webpack_require__(200),
                    cloneTypedArray = __webpack_require__(217),
                    copyArray = __webpack_require__(201),
                    initCloneObject = __webpack_require__(218),
                    isArguments = __webpack_require__(44),
                    isArray = __webpack_require__(53),
                    isArrayLikeObject = __webpack_require__(123),
                    isBuffer = __webpack_require__(54),
                    isFunction = __webpack_require__(68),
                    isObject = __webpack_require__(69),
                    isPlainObject = __webpack_require__(225),
                    isTypedArray = __webpack_require__(58),
                    toPlainObject = __webpack_require__(260);

                /**
                 * A specialized version of `baseMerge` for arrays and objects which performs
                 * deep merges and tracks traversed objects enabling objects with circular
                 * references to be merged.
                 *
                 * @private
                 * @param {Object} object The destination object.
                 * @param {Object} source The source object.
                 * @param {string} key The key of the value to merge.
                 * @param {number} srcIndex The index of `source`.
                 * @param {Function} mergeFunc The function to merge values.
                 * @param {Function} [customizer] The function to customize assigned values.
                 * @param {Object} [stack] Tracks traversed source values and their merged
                 *  counterparts.
                 */
                function baseMergeDeep(
                    object,
                    source,
                    key,
                    srcIndex,
                    mergeFunc,
                    customizer,
                    stack
                ) {
                    var objValue = object[key],
                        srcValue = source[key],
                        stacked = stack.get(srcValue);

                    if (stacked) {
                        assignMergeValue(object, key, stacked);
                        return;
                    }
                    var newValue = customizer
                        ? customizer(
                              objValue,
                              srcValue,
                              key + "",
                              object,
                              source,
                              stack
                          )
                        : undefined;

                    var isCommon = newValue === undefined;

                    if (isCommon) {
                        var isArr = isArray(srcValue),
                            isBuff = !isArr && isBuffer(srcValue),
                            isTyped =
                                !isArr && !isBuff && isTypedArray(srcValue);

                        newValue = srcValue;
                        if (isArr || isBuff || isTyped) {
                            if (isArray(objValue)) {
                                newValue = objValue;
                            } else if (isArrayLikeObject(objValue)) {
                                newValue = copyArray(objValue);
                            } else if (isBuff) {
                                isCommon = false;
                                newValue = cloneBuffer(srcValue, true);
                            } else if (isTyped) {
                                isCommon = false;
                                newValue = cloneTypedArray(srcValue, true);
                            } else {
                                newValue = [];
                            }
                        } else if (
                            isPlainObject(srcValue) ||
                            isArguments(srcValue)
                        ) {
                            newValue = objValue;
                            if (isArguments(objValue)) {
                                newValue = toPlainObject(objValue);
                            } else if (
                                !isObject(objValue) ||
                                (srcIndex && isFunction(objValue))
                            ) {
                                newValue = initCloneObject(srcValue);
                            }
                        } else {
                            isCommon = false;
                        }
                    }
                    if (isCommon) {
                        // Recursively merge objects and arrays (susceptible to call stack limits).
                        stack.set(srcValue, newValue);
                        mergeFunc(
                            newValue,
                            srcValue,
                            srcIndex,
                            customizer,
                            stack
                        );
                        stack["delete"](srcValue);
                    }
                    assignMergeValue(object, key, newValue);
                }

                module.exports = baseMergeDeep;

                /***/
            },
            /* 260 */
            /***/ function (module, exports, __webpack_require__) {
                var copyObject = __webpack_require__(195),
                    keysIn = __webpack_require__(197);

                /**
                 * Converts `value` to a plain object flattening inherited enumerable string
                 * keyed properties of `value` to own properties of the plain object.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {Object} Returns the converted plain object.
                 * @example
                 *
                 * function Foo() {
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.assign({ 'a': 1 }, new Foo);
                 * // => { 'a': 1, 'b': 2 }
                 *
                 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
                 * // => { 'a': 1, 'b': 2, 'c': 3 }
                 */
                function toPlainObject(value) {
                    return copyObject(value, keysIn(value));
                }

                module.exports = toPlainObject;

                /***/
            },
            /* 261 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var map = __webpack_require__(185);
                var isArray = __webpack_require__(53);
                var isNumber = __webpack_require__(235);
                var isString = __webpack_require__(239);
                function valToNumber(v) {
                    if (isNumber(v)) {
                        return v;
                    } else if (isString(v)) {
                        return parseFloat(v);
                    } else if (isArray(v)) {
                        return map(v, valToNumber);
                    }

                    throw new Error(
                        "The value should be a number, a parseable string or an array of those."
                    );
                }

                module.exports = valToNumber;

                /***/
            },
            /* 262 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var forEach = __webpack_require__(129);
                var filter = __webpack_require__(133);
                var map = __webpack_require__(185);
                var isEmpty = __webpack_require__(236);
                var indexOf = __webpack_require__(230);

                function filterState(state, filters) {
                    var partialState = {};
                    var attributeFilters = filter(filters, function (f) {
                        return f.indexOf("attribute:") !== -1;
                    });
                    var attributes = map(attributeFilters, function (aF) {
                        return aF.split(":")[1];
                    });

                    if (indexOf(attributes, "*") === -1) {
                        forEach(attributes, function (attr) {
                            if (
                                state.isConjunctiveFacet(attr) &&
                                state.isFacetRefined(attr)
                            ) {
                                if (!partialState.facetsRefinements)
                                    partialState.facetsRefinements = {};
                                partialState.facetsRefinements[attr] =
                                    state.facetsRefinements[attr];
                            }

                            if (
                                state.isDisjunctiveFacet(attr) &&
                                state.isDisjunctiveFacetRefined(attr)
                            ) {
                                if (!partialState.disjunctiveFacetsRefinements)
                                    partialState.disjunctiveFacetsRefinements =
                                        {};
                                partialState.disjunctiveFacetsRefinements[
                                    attr
                                ] = state.disjunctiveFacetsRefinements[attr];
                            }

                            if (
                                state.isHierarchicalFacet(attr) &&
                                state.isHierarchicalFacetRefined(attr)
                            ) {
                                if (!partialState.hierarchicalFacetsRefinements)
                                    partialState.hierarchicalFacetsRefinements =
                                        {};
                                partialState.hierarchicalFacetsRefinements[
                                    attr
                                ] = state.hierarchicalFacetsRefinements[attr];
                            }

                            var numericRefinements =
                                state.getNumericRefinements(attr);
                            if (!isEmpty(numericRefinements)) {
                                if (!partialState.numericRefinements)
                                    partialState.numericRefinements = {};
                                partialState.numericRefinements[attr] =
                                    state.numericRefinements[attr];
                            }
                        });
                    } else {
                        if (!isEmpty(state.numericRefinements)) {
                            partialState.numericRefinements =
                                state.numericRefinements;
                        }
                        if (!isEmpty(state.facetsRefinements))
                            partialState.facetsRefinements =
                                state.facetsRefinements;
                        if (!isEmpty(state.disjunctiveFacetsRefinements)) {
                            partialState.disjunctiveFacetsRefinements =
                                state.disjunctiveFacetsRefinements;
                        }
                        if (!isEmpty(state.hierarchicalFacetsRefinements)) {
                            partialState.hierarchicalFacetsRefinements =
                                state.hierarchicalFacetsRefinements;
                        }
                    }

                    var searchParameters = filter(filters, function (f) {
                        return f.indexOf("attribute:") === -1;
                    });

                    forEach(searchParameters, function (parameterKey) {
                        partialState[parameterKey] = state[parameterKey];
                    });

                    return partialState;
                }

                module.exports = filterState;

                /***/
            },
            /* 263 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Functions to manipulate refinement lists
                 *
                 * The RefinementList is not formally defined through a prototype but is based
                 * on a specific structure.
                 *
                 * @module SearchParameters.refinementList
                 *
                 * @typedef {string[]} SearchParameters.refinementList.Refinements
                 * @typedef {Object.<string, SearchParameters.refinementList.Refinements>} SearchParameters.refinementList.RefinementList
                 */

                var isUndefined = __webpack_require__(238);
                var isString = __webpack_require__(239);
                var isFunction = __webpack_require__(68);
                var isEmpty = __webpack_require__(236);
                var defaults = __webpack_require__(251);

                var reduce = __webpack_require__(187);
                var filter = __webpack_require__(133);
                var omit = __webpack_require__(190);

                var lib = {
                    /**
                     * Adds a refinement to a RefinementList
                     * @param {RefinementList} refinementList the initial list
                     * @param {string} attribute the attribute to refine
                     * @param {string} value the value of the refinement, if the value is not a string it will be converted
                     * @return {RefinementList} a new and updated prefinement list
                     */
                    addRefinement: function addRefinement(
                        refinementList,
                        attribute,
                        value
                    ) {
                        if (lib.isRefined(refinementList, attribute, value)) {
                            return refinementList;
                        }

                        var valueAsString = "" + value;

                        var facetRefinement = !refinementList[attribute]
                            ? [valueAsString]
                            : refinementList[attribute].concat(valueAsString);

                        var mod = {};

                        mod[attribute] = facetRefinement;

                        return defaults({}, mod, refinementList);
                    },
                    /**
                     * Removes refinement(s) for an attribute:
                     *  - if the value is specified removes the refinement for the value on the attribute
                     *  - if no value is specified removes all the refinements for this attribute
                     * @param {RefinementList} refinementList the initial list
                     * @param {string} attribute the attribute to refine
                     * @param {string} [value] the value of the refinement
                     * @return {RefinementList} a new and updated refinement lst
                     */
                    removeRefinement: function removeRefinement(
                        refinementList,
                        attribute,
                        value
                    ) {
                        if (isUndefined(value)) {
                            return lib.clearRefinement(
                                refinementList,
                                attribute
                            );
                        }

                        var valueAsString = "" + value;

                        return lib.clearRefinement(
                            refinementList,
                            function (v, f) {
                                return attribute === f && valueAsString === v;
                            }
                        );
                    },
                    /**
                     * Toggles the refinement value for an attribute.
                     * @param {RefinementList} refinementList the initial list
                     * @param {string} attribute the attribute to refine
                     * @param {string} value the value of the refinement
                     * @return {RefinementList} a new and updated list
                     */
                    toggleRefinement: function toggleRefinement(
                        refinementList,
                        attribute,
                        value
                    ) {
                        if (isUndefined(value))
                            throw new Error(
                                "toggleRefinement should be used with a value"
                            );

                        if (lib.isRefined(refinementList, attribute, value)) {
                            return lib.removeRefinement(
                                refinementList,
                                attribute,
                                value
                            );
                        }

                        return lib.addRefinement(
                            refinementList,
                            attribute,
                            value
                        );
                    },
                    /**
                     * Clear all or parts of a RefinementList. Depending on the arguments, three
                     * behaviors can happen:
                     *  - if no attribute is provided: clears the whole list
                     *  - if an attribute is provided as a string: clears the list for the specific attribute
                     *  - if an attribute is provided as a function: discards the elements for which the function returns true
                     * @param {RefinementList} refinementList the initial list
                     * @param {string} [attribute] the attribute or function to discard
                     * @param {string} [refinementType] optionnal parameter to give more context to the attribute function
                     * @return {RefinementList} a new and updated refinement list
                     */
                    clearRefinement: function clearRefinement(
                        refinementList,
                        attribute,
                        refinementType
                    ) {
                        if (isUndefined(attribute)) {
                            return {};
                        } else if (isString(attribute)) {
                            return omit(refinementList, attribute);
                        } else if (isFunction(attribute)) {
                            return reduce(
                                refinementList,
                                function (memo, values, key) {
                                    var facetList = filter(
                                        values,
                                        function (value) {
                                            return !attribute(
                                                value,
                                                key,
                                                refinementType
                                            );
                                        }
                                    );

                                    if (!isEmpty(facetList))
                                        memo[key] = facetList;

                                    return memo;
                                },
                                {}
                            );
                        }
                    },
                    /**
                     * Test if the refinement value is used for the attribute. If no refinement value
                     * is provided, test if the refinementList contains any refinement for the
                     * given attribute.
                     * @param {RefinementList} refinementList the list of refinement
                     * @param {string} attribute name of the attribute
                     * @param {string} [refinementValue] value of the filter/refinement
                     * @return {boolean}
                     */
                    isRefined: function isRefined(
                        refinementList,
                        attribute,
                        refinementValue
                    ) {
                        var indexOf = __webpack_require__(230);

                        var containsRefinements =
                            !!refinementList[attribute] &&
                            refinementList[attribute].length > 0;

                        if (
                            isUndefined(refinementValue) ||
                            !containsRefinements
                        ) {
                            return containsRefinements;
                        }

                        var refinementValueAsString = "" + refinementValue;

                        return (
                            indexOf(
                                refinementList[attribute],
                                refinementValueAsString
                            ) !== -1
                        );
                    },
                };

                module.exports = lib;

                /***/
            },
            /* 264 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var forEach = __webpack_require__(129);
                var compact = __webpack_require__(265);
                var indexOf = __webpack_require__(230);
                var findIndex = __webpack_require__(242);
                var get = __webpack_require__(168);

                var sumBy = __webpack_require__(266);
                var find = __webpack_require__(240);
                var includes = __webpack_require__(268);
                var map = __webpack_require__(185);
                var orderBy = __webpack_require__(271);

                var defaults = __webpack_require__(251);
                var merge = __webpack_require__(256);

                var isArray = __webpack_require__(53);
                var isFunction = __webpack_require__(68);

                var partial = __webpack_require__(276);
                var partialRight = __webpack_require__(308);

                var formatSort = __webpack_require__(309);

                var generateHierarchicalTree = __webpack_require__(312);

                /**
                 * @typedef SearchResults.Facet
                 * @type {object}
                 * @property {string} name name of the attribute in the record
                 * @property {object} data the facetting data: value, number of entries
                 * @property {object} stats undefined unless facet_stats is retrieved from algolia
                 */

                /**
                 * @typedef SearchResults.HierarchicalFacet
                 * @type {object}
                 * @property {string} name name of the current value given the hierarchical level, trimmed.
                 * If root node, you get the facet name
                 * @property {number} count number of objets matching this hierarchical value
                 * @property {string} path the current hierarchical value full path
                 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
                 * @property {HierarchicalFacet[]} data sub values for the current level
                 */

                /**
                 * @typedef SearchResults.FacetValue
                 * @type {object}
                 * @property {string} value the facet value itself
                 * @property {number} count times this facet appears in the results
                 * @property {boolean} isRefined is the facet currently selected
                 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
                 */

                /**
                 * @typedef Refinement
                 * @type {object}
                 * @property {string} type the type of filter used:
                 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
                 * @property {string} attributeName name of the attribute used for filtering
                 * @property {string} name the value of the filter
                 * @property {number} numericValue the value as a number. Only for numeric fitlers.
                 * @property {string} operator the operator used. Only for numeric filters.
                 * @property {number} count the number of computed hits for this filter. Only on facets.
                 * @property {boolean} exhaustive if the count is exhaustive
                 */

                function getIndices(obj) {
                    var indices = {};

                    forEach(obj, function (val, idx) {
                        indices[val] = idx;
                    });

                    return indices;
                }

                function assignFacetStats(dest, facetStats, key) {
                    if (facetStats && facetStats[key]) {
                        dest.stats = facetStats[key];
                    }
                }

                function findMatchingHierarchicalFacetFromAttributeName(
                    hierarchicalFacets,
                    hierarchicalAttributeName
                ) {
                    return find(
                        hierarchicalFacets,
                        function facetKeyMatchesAttribute(hierarchicalFacet) {
                            return includes(
                                hierarchicalFacet.attributes,
                                hierarchicalAttributeName
                            );
                        }
                    );
                }

                /*eslint-disable */
                /**
	 * Constructor for SearchResults
	 * @class
	 * @classdesc SearchResults contains the results of a query to Algolia using the
	 * {@link AlgoliaSearchHelper}.
	 * @param {SearchParameters} state state that led to the response
	 * @param {array.<object>} results the results from algolia client
	 * @example <caption>SearchResults of the first query in
	 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
	{
	   "hitsPerPage": 10,
	   "processingTimeMS": 2,
	   "facets": [
	      {
	         "name": "type",
	         "data": {
	            "HardGood": 6627,
	            "BlackTie": 550,
	            "Music": 665,
	            "Software": 131,
	            "Game": 456,
	            "Movie": 1571
	         },
	         "exhaustive": false
	      },
	      {
	         "exhaustive": false,
	         "data": {
	            "Free shipping": 5507
	         },
	         "name": "shipping"
	      }
	  ],
	   "hits": [
	      {
	         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
	         "_highlightResult": {
	            "shortDescription": {
	               "matchLevel": "none",
	               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
	               "matchedWords": []
	            },
	            "category": {
	               "matchLevel": "none",
	               "value": "Computer Security Software",
	               "matchedWords": []
	            },
	            "manufacturer": {
	               "matchedWords": [],
	               "value": "Webroot",
	               "matchLevel": "none"
	            },
	            "name": {
	               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
	               "matchedWords": [],
	               "matchLevel": "none"
	            }
	         },
	         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
	         "shipping": "Free shipping",
	         "bestSellingRank": 4,
	         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
	         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
	         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
	         "category": "Computer Security Software",
	         "salePrice_range": "1 - 50",
	         "objectID": "1688832",
	         "type": "Software",
	         "customerReviewCount": 5980,
	         "salePrice": 49.99,
	         "manufacturer": "Webroot"
	      },
	      ....
	  ],
	   "nbHits": 10000,
	   "disjunctiveFacets": [
	      {
	         "exhaustive": false,
	         "data": {
	            "5": 183,
	            "12": 112,
	            "7": 149,
	            ...
	         },
	         "name": "customerReviewCount",
	         "stats": {
	            "max": 7461,
	            "avg": 157.939,
	            "min": 1
	         }
	      },
	      {
	         "data": {
	            "Printer Ink": 142,
	            "Wireless Speakers": 60,
	            "Point & Shoot Cameras": 48,
	            ...
	         },
	         "name": "category",
	         "exhaustive": false
	      },
	      {
	         "exhaustive": false,
	         "data": {
	            "> 5000": 2,
	            "1 - 50": 6524,
	            "501 - 2000": 566,
	            "201 - 500": 1501,
	            "101 - 200": 1360,
	            "2001 - 5000": 47
	         },
	         "name": "salePrice_range"
	      },
	      {
	         "data": {
	            "Dynex™": 202,
	            "Insignia™": 230,
	            "PNY": 72,
	            ...
	         },
	         "name": "manufacturer",
	         "exhaustive": false
	      }
	  ],
	   "query": "",
	   "nbPages": 100,
	   "page": 0,
	   "index": "bestbuy"
	}
	 **/
                /*eslint-enable */
                function SearchResults(state, results) {
                    var mainSubResponse = results[0];

                    /**
                     * query used to generate the results
                     * @member {string}
                     */
                    this.query = mainSubResponse.query;
                    /**
                     * The query as parsed by the engine given all the rules.
                     * @member {string}
                     */
                    this.parsedQuery = mainSubResponse.parsedQuery;
                    /**
                     * all the records that match the search parameters. Each record is
                     * augmented with a new attribute `_highlightResult`
                     * which is an object keyed by attribute and with the following properties:
                     *  - `value` : the value of the facet highlighted (html)
                     *  - `matchLevel`: full, partial or none depending on how the query terms match
                     * @member {object[]}
                     */
                    this.hits = mainSubResponse.hits;
                    /**
                     * index where the results come from
                     * @member {string}
                     */
                    this.index = mainSubResponse.index;
                    /**
                     * number of hits per page requested
                     * @member {number}
                     */
                    this.hitsPerPage = mainSubResponse.hitsPerPage;
                    /**
                     * total number of hits of this query on the index
                     * @member {number}
                     */
                    this.nbHits = mainSubResponse.nbHits;
                    /**
                     * total number of pages with respect to the number of hits per page and the total number of hits
                     * @member {number}
                     */
                    this.nbPages = mainSubResponse.nbPages;
                    /**
                     * current page
                     * @member {number}
                     */
                    this.page = mainSubResponse.page;
                    /**
                     * sum of the processing time of all the queries
                     * @member {number}
                     */
                    this.processingTimeMS = sumBy(results, "processingTimeMS");
                    /**
                     * The position if the position was guessed by IP.
                     * @member {string}
                     * @example "48.8637,2.3615",
                     */
                    this.aroundLatLng = mainSubResponse.aroundLatLng;
                    /**
                     * The radius computed by Algolia.
                     * @member {string}
                     * @example "126792922",
                     */
                    this.automaticRadius = mainSubResponse.automaticRadius;
                    /**
                     * String identifying the server used to serve this request.
                     * @member {string}
                     * @example "c7-use-2.algolia.net",
                     */
                    this.serverUsed = mainSubResponse.serverUsed;
                    /**
                     * Boolean that indicates if the computation of the counts did time out.
                     * @member {boolean}
                     */
                    this.timeoutCounts = mainSubResponse.timeoutCounts;
                    /**
                     * Boolean that indicates if the computation of the hits did time out.
                     * @member {boolean}
                     */
                    this.timeoutHits = mainSubResponse.timeoutHits;

                    /**
                     * disjunctive facets results
                     * @member {SearchResults.Facet[]}
                     */
                    this.disjunctiveFacets = [];
                    /**
                     * disjunctive facets results
                     * @member {SearchResults.HierarchicalFacet[]}
                     */
                    this.hierarchicalFacets = map(
                        state.hierarchicalFacets,
                        function initFutureTree() {
                            return [];
                        }
                    );
                    /**
                     * other facets results
                     * @member {SearchResults.Facet[]}
                     */
                    this.facets = [];

                    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();

                    var facetsIndices = getIndices(state.facets);
                    var disjunctiveFacetsIndices = getIndices(
                        state.disjunctiveFacets
                    );
                    var nextDisjunctiveResult = 1;

                    var self = this;
                    // Since we send request only for disjunctive facets that have been refined,
                    // we get the facets informations from the first, general, response.
                    forEach(
                        mainSubResponse.facets,
                        function (facetValueObject, facetKey) {
                            var hierarchicalFacet =
                                findMatchingHierarchicalFacetFromAttributeName(
                                    state.hierarchicalFacets,
                                    facetKey
                                );

                            if (hierarchicalFacet) {
                                // Place the hierarchicalFacet data at the correct index depending on
                                // the attributes order that was defined at the helper initialization
                                var facetIndex =
                                    hierarchicalFacet.attributes.indexOf(
                                        facetKey
                                    );
                                var idxAttributeName = findIndex(
                                    state.hierarchicalFacets,
                                    { name: hierarchicalFacet.name }
                                );
                                self.hierarchicalFacets[idxAttributeName][
                                    facetIndex
                                ] = {
                                    attribute: facetKey,
                                    data: facetValueObject,
                                    exhaustive:
                                        mainSubResponse.exhaustiveFacetsCount,
                                };
                            } else {
                                var isFacetDisjunctive =
                                    indexOf(
                                        state.disjunctiveFacets,
                                        facetKey
                                    ) !== -1;
                                var isFacetConjunctive =
                                    indexOf(state.facets, facetKey) !== -1;
                                var position;

                                if (isFacetDisjunctive) {
                                    position =
                                        disjunctiveFacetsIndices[facetKey];
                                    self.disjunctiveFacets[position] = {
                                        name: facetKey,
                                        data: facetValueObject,
                                        exhaustive:
                                            mainSubResponse.exhaustiveFacetsCount,
                                    };
                                    assignFacetStats(
                                        self.disjunctiveFacets[position],
                                        mainSubResponse.facets_stats,
                                        facetKey
                                    );
                                }
                                if (isFacetConjunctive) {
                                    position = facetsIndices[facetKey];
                                    self.facets[position] = {
                                        name: facetKey,
                                        data: facetValueObject,
                                        exhaustive:
                                            mainSubResponse.exhaustiveFacetsCount,
                                    };
                                    assignFacetStats(
                                        self.facets[position],
                                        mainSubResponse.facets_stats,
                                        facetKey
                                    );
                                }
                            }
                        }
                    );

                    // Make sure we do not keep holes within the hierarchical facets
                    this.hierarchicalFacets = compact(this.hierarchicalFacets);

                    // aggregate the refined disjunctive facets
                    forEach(disjunctiveFacets, function (disjunctiveFacet) {
                        var result = results[nextDisjunctiveResult];
                        var hierarchicalFacet =
                            state.getHierarchicalFacetByName(disjunctiveFacet);

                        // There should be only item in facets.
                        forEach(result.facets, function (facetResults, dfacet) {
                            var position;

                            if (hierarchicalFacet) {
                                position = findIndex(state.hierarchicalFacets, {
                                    name: hierarchicalFacet.name,
                                });
                                var attributeIndex = findIndex(
                                    self.hierarchicalFacets[position],
                                    { attribute: dfacet }
                                );

                                // previous refinements and no results so not able to find it
                                if (attributeIndex === -1) {
                                    return;
                                }

                                self.hierarchicalFacets[position][
                                    attributeIndex
                                ].data = merge(
                                    {},
                                    self.hierarchicalFacets[position][
                                        attributeIndex
                                    ].data,
                                    facetResults
                                );
                            } else {
                                position = disjunctiveFacetsIndices[dfacet];

                                var dataFromMainRequest =
                                    (mainSubResponse.facets &&
                                        mainSubResponse.facets[dfacet]) ||
                                    {};

                                self.disjunctiveFacets[position] = {
                                    name: dfacet,
                                    data: defaults(
                                        {},
                                        facetResults,
                                        dataFromMainRequest
                                    ),
                                    exhaustive: result.exhaustiveFacetsCount,
                                };
                                assignFacetStats(
                                    self.disjunctiveFacets[position],
                                    result.facets_stats,
                                    dfacet
                                );

                                if (
                                    state.disjunctiveFacetsRefinements[dfacet]
                                ) {
                                    forEach(
                                        state.disjunctiveFacetsRefinements[
                                            dfacet
                                        ],
                                        function (refinementValue) {
                                            // add the disjunctive refinements if it is no more retrieved
                                            if (
                                                !self.disjunctiveFacets[
                                                    position
                                                ].data[refinementValue] &&
                                                indexOf(
                                                    state
                                                        .disjunctiveFacetsRefinements[
                                                        dfacet
                                                    ],
                                                    refinementValue
                                                ) > -1
                                            ) {
                                                self.disjunctiveFacets[
                                                    position
                                                ].data[refinementValue] = 0;
                                            }
                                        }
                                    );
                                }
                            }
                        });
                        nextDisjunctiveResult++;
                    });

                    // if we have some root level values for hierarchical facets, merge them
                    forEach(
                        state.getRefinedHierarchicalFacets(),
                        function (refinedFacet) {
                            var hierarchicalFacet =
                                state.getHierarchicalFacetByName(refinedFacet);
                            var separator =
                                state._getHierarchicalFacetSeparator(
                                    hierarchicalFacet
                                );

                            var currentRefinement =
                                state.getHierarchicalRefinement(refinedFacet);
                            // if we are already at a root refinement (or no refinement at all), there is no
                            // root level values request
                            if (
                                currentRefinement.length === 0 ||
                                currentRefinement[0].split(separator).length < 2
                            ) {
                                return;
                            }

                            var result = results[nextDisjunctiveResult];

                            forEach(
                                result.facets,
                                function (facetResults, dfacet) {
                                    var position = findIndex(
                                        state.hierarchicalFacets,
                                        { name: hierarchicalFacet.name }
                                    );
                                    var attributeIndex = findIndex(
                                        self.hierarchicalFacets[position],
                                        { attribute: dfacet }
                                    );

                                    // previous refinements and no results so not able to find it
                                    if (attributeIndex === -1) {
                                        return;
                                    }

                                    // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                                    // then the disjunctive values will be `beers` (count: 100),
                                    // but we do not want to display
                                    //   | beers (100)
                                    //     > IPA (5)
                                    // We want
                                    //   | beers (5)
                                    //     > IPA (5)
                                    var defaultData = {};

                                    if (currentRefinement.length > 0) {
                                        var root =
                                            currentRefinement[0].split(
                                                separator
                                            )[0];
                                        defaultData[root] =
                                            self.hierarchicalFacets[position][
                                                attributeIndex
                                            ].data[root];
                                    }

                                    self.hierarchicalFacets[position][
                                        attributeIndex
                                    ].data = defaults(
                                        defaultData,
                                        facetResults,
                                        self.hierarchicalFacets[position][
                                            attributeIndex
                                        ].data
                                    );
                                }
                            );

                            nextDisjunctiveResult++;
                        }
                    );

                    // add the excludes
                    forEach(
                        state.facetsExcludes,
                        function (excludes, facetName) {
                            var position = facetsIndices[facetName];

                            self.facets[position] = {
                                name: facetName,
                                data: mainSubResponse.facets[facetName],
                                exhaustive:
                                    mainSubResponse.exhaustiveFacetsCount,
                            };
                            forEach(excludes, function (facetValue) {
                                self.facets[position] = self.facets[
                                    position
                                ] || { name: facetName };
                                self.facets[position].data =
                                    self.facets[position].data || {};
                                self.facets[position].data[facetValue] = 0;
                            });
                        }
                    );

                    this.hierarchicalFacets = map(
                        this.hierarchicalFacets,
                        generateHierarchicalTree(state)
                    );

                    this.facets = compact(this.facets);
                    this.disjunctiveFacets = compact(this.disjunctiveFacets);

                    this._state = state;
                }

                /**
                 * Get a facet object with its name
                 * @deprecated
                 * @param {string} name name of the attribute facetted
                 * @return {SearchResults.Facet} the facet object
                 */
                SearchResults.prototype.getFacetByName = function (name) {
                    var predicate = { name: name };

                    return (
                        find(this.facets, predicate) ||
                        find(this.disjunctiveFacets, predicate) ||
                        find(this.hierarchicalFacets, predicate)
                    );
                };

                /**
                 * Get the facet values of a specified attribute from a SearchResults object.
                 * @private
                 * @param {SearchResults} results the search results to search in
                 * @param {string} attribute name of the facetted attribute to search for
                 * @return {array|object} facet values. For the hierarchical facets it is an object.
                 */
                function extractNormalizedFacetValues(results, attribute) {
                    var predicate = { name: attribute };
                    if (results._state.isConjunctiveFacet(attribute)) {
                        var facet = find(results.facets, predicate);
                        if (!facet) return [];

                        return map(facet.data, function (v, k) {
                            return {
                                name: k,
                                count: v,
                                isRefined: results._state.isFacetRefined(
                                    attribute,
                                    k
                                ),
                                isExcluded: results._state.isExcludeRefined(
                                    attribute,
                                    k
                                ),
                            };
                        });
                    } else if (results._state.isDisjunctiveFacet(attribute)) {
                        var disjunctiveFacet = find(
                            results.disjunctiveFacets,
                            predicate
                        );
                        if (!disjunctiveFacet) return [];

                        return map(disjunctiveFacet.data, function (v, k) {
                            return {
                                name: k,
                                count: v,
                                isRefined:
                                    results._state.isDisjunctiveFacetRefined(
                                        attribute,
                                        k
                                    ),
                            };
                        });
                    } else if (results._state.isHierarchicalFacet(attribute)) {
                        return find(results.hierarchicalFacets, predicate);
                    }
                }

                /**
                 * Sort nodes of a hierarchical facet results
                 * @private
                 * @param {HierarchicalFacet} node node to upon which we want to apply the sort
                 */
                function recSort(sortFn, node) {
                    if (!node.data || node.data.length === 0) {
                        return node;
                    }
                    var children = map(node.data, partial(recSort, sortFn));
                    var sortedChildren = sortFn(children);
                    var newNode = merge({}, node, { data: sortedChildren });
                    return newNode;
                }

                SearchResults.DEFAULT_SORT = [
                    "isRefined:desc",
                    "count:desc",
                    "name:asc",
                ];

                function vanillaSortFn(order, data) {
                    return data.sort(order);
                }

                /**
                 * Get a the list of values for a given facet attribute. Those values are sorted
                 * refinement first, descending count (bigger value on top), and name ascending
                 * (alphabetical order). The sort formula can overridden using either string based
                 * predicates or a function.
                 *
                 * This method will return all the values returned by the Algolia engine plus all
                 * the values already refined. This means that it can happen that the
                 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
                 * might not be respected if you have facet values that are already refined.
                 * @param {string} attribute attribute name
                 * @param {object} opts configuration options.
                 * @param {Array.<string> | function} opts.sortBy
                 * When using strings, it consists of
                 * the name of the [FacetValue](#SearchResults.FacetValue) or the
                 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
                 * order (`asc` or `desc`). For example to order the value by count, the
                 * argument would be `['count:asc']`.
                 *
                 * If only the attribute name is specified, the ordering defaults to the one
                 * specified in the default value for this attribute.
                 *
                 * When not specified, the order is
                 * ascending.  This parameter can also be a function which takes two facet
                 * values and should return a number, 0 if equal, 1 if the first argument is
                 * bigger or -1 otherwise.
                 *
                 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
                 * @return {FacetValue[]|HierarchicalFacet} depending on the type of facet of
                 * the attribute requested (hierarchical, disjunctive or conjunctive)
                 * @example
                 * helper.on('results', function(content){
                 *   //get values ordered only by name ascending using the string predicate
                 *   content.getFacetValues('city', {sortBy: ['name:asc']);
                 *   //get values  ordered only by count ascending using a function
                 *   content.getFacetValues('city', {
                 *     // this is equivalent to ['count:asc']
                 *     sortBy: function(a, b) {
                 *       if (a.count === b.count) return 0;
                 *       if (a.count > b.count)   return 1;
                 *       if (b.count > a.count)   return -1;
                 *     }
                 *   });
                 * });
                 */
                SearchResults.prototype.getFacetValues = function (
                    attribute,
                    opts
                ) {
                    var facetValues = extractNormalizedFacetValues(
                        this,
                        attribute
                    );
                    if (!facetValues)
                        throw new Error(
                            attribute + " is not a retrieved facet."
                        );

                    var options = defaults({}, opts, {
                        sortBy: SearchResults.DEFAULT_SORT,
                    });

                    if (isArray(options.sortBy)) {
                        var order = formatSort(
                            options.sortBy,
                            SearchResults.DEFAULT_SORT
                        );
                        if (isArray(facetValues)) {
                            return orderBy(facetValues, order[0], order[1]);
                        }
                        // If facetValues is not an array, it's an object thus a hierarchical facet object
                        return recSort(
                            partialRight(orderBy, order[0], order[1]),
                            facetValues
                        );
                    } else if (isFunction(options.sortBy)) {
                        if (isArray(facetValues)) {
                            return facetValues.sort(options.sortBy);
                        }
                        // If facetValues is not an array, it's an object thus a hierarchical facet object
                        return recSort(
                            partial(vanillaSortFn, options.sortBy),
                            facetValues
                        );
                    }
                    throw new Error(
                        "options.sortBy is optional but if defined it must be " +
                            "either an array of string (predicates) or a sorting function"
                    );
                };

                /**
                 * Returns the facet stats if attribute is defined and the facet contains some.
                 * Otherwise returns undefined.
                 * @param {string} attribute name of the facetted attribute
                 * @return {object} The stats of the facet
                 */
                SearchResults.prototype.getFacetStats = function (attribute) {
                    if (this._state.isConjunctiveFacet(attribute)) {
                        return getFacetStatsIfAvailable(this.facets, attribute);
                    } else if (this._state.isDisjunctiveFacet(attribute)) {
                        return getFacetStatsIfAvailable(
                            this.disjunctiveFacets,
                            attribute
                        );
                    }

                    throw new Error(
                        attribute +
                            " is not present in `facets` or `disjunctiveFacets`"
                    );
                };

                function getFacetStatsIfAvailable(facetList, facetName) {
                    var data = find(facetList, { name: facetName });
                    return data && data.stats;
                }

                /**
                 * Returns all refinements for all filters + tags. It also provides
                 * additional information: count and exhausistivity for each filter.
                 *
                 * See the [refinement type](#Refinement) for an exhaustive view of the available
                 * data.
                 *
                 * @return {Array.<Refinement>} all the refinements
                 */
                SearchResults.prototype.getRefinements = function () {
                    var state = this._state;
                    var results = this;
                    var res = [];

                    forEach(
                        state.facetsRefinements,
                        function (refinements, attributeName) {
                            forEach(refinements, function (name) {
                                res.push(
                                    getRefinement(
                                        state,
                                        "facet",
                                        attributeName,
                                        name,
                                        results.facets
                                    )
                                );
                            });
                        }
                    );

                    forEach(
                        state.facetsExcludes,
                        function (refinements, attributeName) {
                            forEach(refinements, function (name) {
                                res.push(
                                    getRefinement(
                                        state,
                                        "exclude",
                                        attributeName,
                                        name,
                                        results.facets
                                    )
                                );
                            });
                        }
                    );

                    forEach(
                        state.disjunctiveFacetsRefinements,
                        function (refinements, attributeName) {
                            forEach(refinements, function (name) {
                                res.push(
                                    getRefinement(
                                        state,
                                        "disjunctive",
                                        attributeName,
                                        name,
                                        results.disjunctiveFacets
                                    )
                                );
                            });
                        }
                    );

                    forEach(
                        state.hierarchicalFacetsRefinements,
                        function (refinements, attributeName) {
                            forEach(refinements, function (name) {
                                res.push(
                                    getHierarchicalRefinement(
                                        state,
                                        attributeName,
                                        name,
                                        results.hierarchicalFacets
                                    )
                                );
                            });
                        }
                    );

                    forEach(
                        state.numericRefinements,
                        function (operators, attributeName) {
                            forEach(operators, function (values, operator) {
                                forEach(values, function (value) {
                                    res.push({
                                        type: "numeric",
                                        attributeName: attributeName,
                                        name: value,
                                        numericValue: value,
                                        operator: operator,
                                    });
                                });
                            });
                        }
                    );

                    forEach(state.tagRefinements, function (name) {
                        res.push({
                            type: "tag",
                            attributeName: "_tags",
                            name: name,
                        });
                    });

                    return res;
                };

                function getRefinement(
                    state,
                    type,
                    attributeName,
                    name,
                    resultsFacets
                ) {
                    var facet = find(resultsFacets, { name: attributeName });
                    var count = get(facet, "data[" + name + "]");
                    var exhaustive = get(facet, "exhaustive");
                    return {
                        type: type,
                        attributeName: attributeName,
                        name: name,
                        count: count || 0,
                        exhaustive: exhaustive || false,
                    };
                }

                function getHierarchicalRefinement(
                    state,
                    attributeName,
                    name,
                    resultsFacets
                ) {
                    var facet = find(resultsFacets, { name: attributeName });
                    var facetDeclaration =
                        state.getHierarchicalFacetByName(attributeName);
                    var splitted = name.split(facetDeclaration.separator);
                    var configuredName = splitted[splitted.length - 1];
                    for (
                        var i = 0;
                        facet !== undefined && i < splitted.length;
                        ++i
                    ) {
                        facet = find(facet.data, { name: splitted[i] });
                    }
                    var count = get(facet, "count");
                    var exhaustive = get(facet, "exhaustive");
                    return {
                        type: "hierarchical",
                        attributeName: attributeName,
                        name: configuredName,
                        count: count || 0,
                        exhaustive: exhaustive || false,
                    };
                }

                module.exports = SearchResults;

                /***/
            },
            /* 265 */
            /***/ function (module, exports) {
                /**
                 * Creates an array with all falsey values removed. The values `false`, `null`,
                 * `0`, `""`, `undefined`, and `NaN` are falsey.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to compact.
                 * @returns {Array} Returns the new array of filtered values.
                 * @example
                 *
                 * _.compact([0, 1, false, 2, '', 3]);
                 * // => [1, 2, 3]
                 */
                function compact(array) {
                    var index = -1,
                        length = array == null ? 0 : array.length,
                        resIndex = 0,
                        result = [];

                    while (++index < length) {
                        var value = array[index];
                        if (value) {
                            result[resIndex++] = value;
                        }
                    }
                    return result;
                }

                module.exports = compact;

                /***/
            },
            /* 266 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIteratee = __webpack_require__(136),
                    baseSum = __webpack_require__(267);

                /**
                 * This method is like `_.sum` except that it accepts `iteratee` which is
                 * invoked for each element in `array` to generate the value to be summed.
                 * The iteratee is invoked with one argument: (value).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Math
                 * @param {Array} array The array to iterate over.
                 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
                 * @returns {number} Returns the sum.
                 * @example
                 *
                 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
                 *
                 * _.sumBy(objects, function(o) { return o.n; });
                 * // => 20
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.sumBy(objects, 'n');
                 * // => 20
                 */
                function sumBy(array, iteratee) {
                    return array && array.length
                        ? baseSum(array, baseIteratee(iteratee, 2))
                        : 0;
                }

                module.exports = sumBy;

                /***/
            },
            /* 267 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.sum` and `_.sumBy` without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} array The array to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {number} Returns the sum.
                 */
                function baseSum(array, iteratee) {
                    var result,
                        index = -1,
                        length = array.length;

                    while (++index < length) {
                        var current = iteratee(array[index]);
                        if (current !== undefined) {
                            result =
                                result === undefined
                                    ? current
                                    : result + current;
                        }
                    }
                    return result;
                }

                module.exports = baseSum;

                /***/
            },
            /* 268 */
            /***/ function (module, exports, __webpack_require__) {
                var baseIndexOf = __webpack_require__(107),
                    isArrayLike = __webpack_require__(67),
                    isString = __webpack_require__(239),
                    toInteger = __webpack_require__(231),
                    values = __webpack_require__(269);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * Checks if `value` is in `collection`. If `collection` is a string, it's
                 * checked for a substring of `value`, otherwise
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * is used for equality comparisons. If `fromIndex` is negative, it's used as
                 * the offset from the end of `collection`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object|string} collection The collection to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
                 * @returns {boolean} Returns `true` if `value` is found, else `false`.
                 * @example
                 *
                 * _.includes([1, 2, 3], 1);
                 * // => true
                 *
                 * _.includes([1, 2, 3], 1, 2);
                 * // => false
                 *
                 * _.includes({ 'a': 1, 'b': 2 }, 1);
                 * // => true
                 *
                 * _.includes('abcd', 'bc');
                 * // => true
                 */
                function includes(collection, value, fromIndex, guard) {
                    collection = isArrayLike(collection)
                        ? collection
                        : values(collection);
                    fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;

                    var length = collection.length;
                    if (fromIndex < 0) {
                        fromIndex = nativeMax(length + fromIndex, 0);
                    }
                    return isString(collection)
                        ? fromIndex <= length &&
                              collection.indexOf(value, fromIndex) > -1
                        : !!length &&
                              baseIndexOf(collection, value, fromIndex) > -1;
                }

                module.exports = includes;

                /***/
            },
            /* 269 */
            /***/ function (module, exports, __webpack_require__) {
                var baseValues = __webpack_require__(270),
                    keys = __webpack_require__(41);

                /**
                 * Creates an array of the own enumerable string keyed property values of `object`.
                 *
                 * **Note:** Non-object values are coerced to objects.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property values.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.values(new Foo);
                 * // => [1, 2] (iteration order is not guaranteed)
                 *
                 * _.values('hi');
                 * // => ['h', 'i']
                 */
                function values(object) {
                    return object == null
                        ? []
                        : baseValues(object, keys(object));
                }

                module.exports = values;

                /***/
            },
            /* 270 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayMap = __webpack_require__(71);

                /**
                 * The base implementation of `_.values` and `_.valuesIn` which creates an
                 * array of `object` property values corresponding to the property names
                 * of `props`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array} props The property names to get values for.
                 * @returns {Object} Returns the array of property values.
                 */
                function baseValues(object, props) {
                    return arrayMap(props, function (key) {
                        return object[key];
                    });
                }

                module.exports = baseValues;

                /***/
            },
            /* 271 */
            /***/ function (module, exports, __webpack_require__) {
                var baseOrderBy = __webpack_require__(272),
                    isArray = __webpack_require__(53);

                /**
                 * This method is like `_.sortBy` except that it allows specifying the sort
                 * orders of the iteratees to sort by. If `orders` is unspecified, all values
                 * are sorted in ascending order. Otherwise, specify an order of "desc" for
                 * descending or "asc" for ascending sort order of corresponding values.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
                 *  The iteratees to sort by.
                 * @param {string[]} [orders] The sort orders of `iteratees`.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
                 * @returns {Array} Returns the new sorted array.
                 * @example
                 *
                 * var users = [
                 *   { 'user': 'fred',   'age': 48 },
                 *   { 'user': 'barney', 'age': 34 },
                 *   { 'user': 'fred',   'age': 40 },
                 *   { 'user': 'barney', 'age': 36 }
                 * ];
                 *
                 * // Sort by `user` in ascending order and by `age` in descending order.
                 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
                 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
                 */
                function orderBy(collection, iteratees, orders, guard) {
                    if (collection == null) {
                        return [];
                    }
                    if (!isArray(iteratees)) {
                        iteratees = iteratees == null ? [] : [iteratees];
                    }
                    orders = guard ? undefined : orders;
                    if (!isArray(orders)) {
                        orders = orders == null ? [] : [orders];
                    }
                    return baseOrderBy(collection, iteratees, orders);
                }

                module.exports = orderBy;

                /***/
            },
            /* 272 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayMap = __webpack_require__(71),
                    baseIteratee = __webpack_require__(136),
                    baseMap = __webpack_require__(186),
                    baseSortBy = __webpack_require__(273),
                    baseUnary = __webpack_require__(61),
                    compareMultiple = __webpack_require__(274),
                    identity = __webpack_require__(114);

                /**
                 * The base implementation of `_.orderBy` without param guards.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
                 * @param {string[]} orders The sort orders of `iteratees`.
                 * @returns {Array} Returns the new sorted array.
                 */
                function baseOrderBy(collection, iteratees, orders) {
                    var index = -1;
                    iteratees = arrayMap(
                        iteratees.length ? iteratees : [identity],
                        baseUnary(baseIteratee)
                    );

                    var result = baseMap(
                        collection,
                        function (value, key, collection) {
                            var criteria = arrayMap(
                                iteratees,
                                function (iteratee) {
                                    return iteratee(value);
                                }
                            );
                            return {
                                criteria: criteria,
                                index: ++index,
                                value: value,
                            };
                        }
                    );

                    return baseSortBy(result, function (object, other) {
                        return compareMultiple(object, other, orders);
                    });
                }

                module.exports = baseOrderBy;

                /***/
            },
            /* 273 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.sortBy` which uses `comparer` to define the
                 * sort order of `array` and replaces criteria objects with their corresponding
                 * values.
                 *
                 * @private
                 * @param {Array} array The array to sort.
                 * @param {Function} comparer The function to define sort order.
                 * @returns {Array} Returns `array`.
                 */
                function baseSortBy(array, comparer) {
                    var length = array.length;

                    array.sort(comparer);
                    while (length--) {
                        array[length] = array[length].value;
                    }
                    return array;
                }

                module.exports = baseSortBy;

                /***/
            },
            /* 274 */
            /***/ function (module, exports, __webpack_require__) {
                var compareAscending = __webpack_require__(275);

                /**
                 * Used by `_.orderBy` to compare multiple properties of a value to another
                 * and stable sort them.
                 *
                 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
                 * specify an order of "desc" for descending or "asc" for ascending sort order
                 * of corresponding values.
                 *
                 * @private
                 * @param {Object} object The object to compare.
                 * @param {Object} other The other object to compare.
                 * @param {boolean[]|string[]} orders The order to sort by for each property.
                 * @returns {number} Returns the sort order indicator for `object`.
                 */
                function compareMultiple(object, other, orders) {
                    var index = -1,
                        objCriteria = object.criteria,
                        othCriteria = other.criteria,
                        length = objCriteria.length,
                        ordersLength = orders.length;

                    while (++index < length) {
                        var result = compareAscending(
                            objCriteria[index],
                            othCriteria[index]
                        );
                        if (result) {
                            if (index >= ordersLength) {
                                return result;
                            }
                            var order = orders[index];
                            return result * (order == "desc" ? -1 : 1);
                        }
                    }
                    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
                    // that causes it, under certain circumstances, to provide the same value for
                    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
                    // for more details.
                    //
                    // This also ensures a stable sort in V8 and other engines.
                    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
                    return object.index - other.index;
                }

                module.exports = compareMultiple;

                /***/
            },
            /* 275 */
            /***/ function (module, exports, __webpack_require__) {
                var isSymbol = __webpack_require__(172);

                /**
                 * Compares values to sort them in ascending order.
                 *
                 * @private
                 * @param {*} value The value to compare.
                 * @param {*} other The other value to compare.
                 * @returns {number} Returns the sort order indicator for `value`.
                 */
                function compareAscending(value, other) {
                    if (value !== other) {
                        var valIsDefined = value !== undefined,
                            valIsNull = value === null,
                            valIsReflexive = value === value,
                            valIsSymbol = isSymbol(value);

                        var othIsDefined = other !== undefined,
                            othIsNull = other === null,
                            othIsReflexive = other === other,
                            othIsSymbol = isSymbol(other);

                        if (
                            (!othIsNull &&
                                !othIsSymbol &&
                                !valIsSymbol &&
                                value > other) ||
                            (valIsSymbol &&
                                othIsDefined &&
                                othIsReflexive &&
                                !othIsNull &&
                                !othIsSymbol) ||
                            (valIsNull && othIsDefined && othIsReflexive) ||
                            (!valIsDefined && othIsReflexive) ||
                            !valIsReflexive
                        ) {
                            return 1;
                        }
                        if (
                            (!valIsNull &&
                                !valIsSymbol &&
                                !othIsSymbol &&
                                value < other) ||
                            (othIsSymbol &&
                                valIsDefined &&
                                valIsReflexive &&
                                !valIsNull &&
                                !valIsSymbol) ||
                            (othIsNull && valIsDefined && valIsReflexive) ||
                            (!othIsDefined && valIsReflexive) ||
                            !othIsReflexive
                        ) {
                            return -1;
                        }
                    }
                    return 0;
                }

                module.exports = compareAscending;

                /***/
            },
            /* 276 */
            /***/ function (module, exports, __webpack_require__) {
                var baseRest = __webpack_require__(113),
                    createWrap = __webpack_require__(277),
                    getHolder = __webpack_require__(303),
                    replaceHolders = __webpack_require__(305);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_PARTIAL_FLAG = 32;

                /**
                 * Creates a function that invokes `func` with `partials` prepended to the
                 * arguments it receives. This method is like `_.bind` except it does **not**
                 * alter the `this` binding.
                 *
                 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
                 * builds, may be used as a placeholder for partially applied arguments.
                 *
                 * **Note:** This method doesn't set the "length" property of partially
                 * applied functions.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.2.0
                 * @category Function
                 * @param {Function} func The function to partially apply arguments to.
                 * @param {...*} [partials] The arguments to be partially applied.
                 * @returns {Function} Returns the new partially applied function.
                 * @example
                 *
                 * function greet(greeting, name) {
                 *   return greeting + ' ' + name;
                 * }
                 *
                 * var sayHelloTo = _.partial(greet, 'hello');
                 * sayHelloTo('fred');
                 * // => 'hello fred'
                 *
                 * // Partially applied with placeholders.
                 * var greetFred = _.partial(greet, _, 'fred');
                 * greetFred('hi');
                 * // => 'hi fred'
                 */
                var partial = baseRest(function (func, partials) {
                    var holders = replaceHolders(partials, getHolder(partial));
                    return createWrap(
                        func,
                        WRAP_PARTIAL_FLAG,
                        undefined,
                        partials,
                        holders
                    );
                });

                // Assign default placeholders.
                partial.placeholder = {};

                module.exports = partial;

                /***/
            },
            /* 277 */
            /***/ function (module, exports, __webpack_require__) {
                var baseSetData = __webpack_require__(278),
                    createBind = __webpack_require__(280),
                    createCurry = __webpack_require__(282),
                    createHybrid = __webpack_require__(283),
                    createPartial = __webpack_require__(306),
                    getData = __webpack_require__(291),
                    mergeData = __webpack_require__(307),
                    setData = __webpack_require__(298),
                    setWrapToString = __webpack_require__(299),
                    toInteger = __webpack_require__(231);

                /** Error message constants. */
                var FUNC_ERROR_TEXT = "Expected a function";

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1,
                    WRAP_BIND_KEY_FLAG = 2,
                    WRAP_CURRY_FLAG = 8,
                    WRAP_CURRY_RIGHT_FLAG = 16,
                    WRAP_PARTIAL_FLAG = 32,
                    WRAP_PARTIAL_RIGHT_FLAG = 64;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * Creates a function that either curries or invokes `func` with optional
                 * `this` binding and partially applied arguments.
                 *
                 * @private
                 * @param {Function|string} func The function or method name to wrap.
                 * @param {number} bitmask The bitmask flags.
                 *    1 - `_.bind`
                 *    2 - `_.bindKey`
                 *    4 - `_.curry` or `_.curryRight` of a bound function
                 *    8 - `_.curry`
                 *   16 - `_.curryRight`
                 *   32 - `_.partial`
                 *   64 - `_.partialRight`
                 *  128 - `_.rearg`
                 *  256 - `_.ary`
                 *  512 - `_.flip`
                 * @param {*} [thisArg] The `this` binding of `func`.
                 * @param {Array} [partials] The arguments to be partially applied.
                 * @param {Array} [holders] The `partials` placeholder indexes.
                 * @param {Array} [argPos] The argument positions of the new function.
                 * @param {number} [ary] The arity cap of `func`.
                 * @param {number} [arity] The arity of `func`.
                 * @returns {Function} Returns the new wrapped function.
                 */
                function createWrap(
                    func,
                    bitmask,
                    thisArg,
                    partials,
                    holders,
                    argPos,
                    ary,
                    arity
                ) {
                    var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
                    if (!isBindKey && typeof func != "function") {
                        throw new TypeError(FUNC_ERROR_TEXT);
                    }
                    var length = partials ? partials.length : 0;
                    if (!length) {
                        bitmask &= ~(
                            WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG
                        );
                        partials = holders = undefined;
                    }
                    ary =
                        ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                    arity = arity === undefined ? arity : toInteger(arity);
                    length -= holders ? holders.length : 0;

                    if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                        var partialsRight = partials,
                            holdersRight = holders;

                        partials = holders = undefined;
                    }
                    var data = isBindKey ? undefined : getData(func);

                    var newData = [
                        func,
                        bitmask,
                        thisArg,
                        partials,
                        holders,
                        partialsRight,
                        holdersRight,
                        argPos,
                        ary,
                        arity,
                    ];

                    if (data) {
                        mergeData(newData, data);
                    }
                    func = newData[0];
                    bitmask = newData[1];
                    thisArg = newData[2];
                    partials = newData[3];
                    holders = newData[4];
                    arity = newData[9] =
                        newData[9] === undefined
                            ? isBindKey
                                ? 0
                                : func.length
                            : nativeMax(newData[9] - length, 0);

                    if (
                        !arity &&
                        bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)
                    ) {
                        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                    }
                    if (!bitmask || bitmask == WRAP_BIND_FLAG) {
                        var result = createBind(func, bitmask, thisArg);
                    } else if (
                        bitmask == WRAP_CURRY_FLAG ||
                        bitmask == WRAP_CURRY_RIGHT_FLAG
                    ) {
                        result = createCurry(func, bitmask, arity);
                    } else if (
                        (bitmask == WRAP_PARTIAL_FLAG ||
                            bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) &&
                        !holders.length
                    ) {
                        result = createPartial(
                            func,
                            bitmask,
                            thisArg,
                            partials
                        );
                    } else {
                        result = createHybrid.apply(undefined, newData);
                    }
                    var setter = data ? baseSetData : setData;
                    return setWrapToString(
                        setter(result, newData),
                        func,
                        bitmask
                    );
                }

                module.exports = createWrap;

                /***/
            },
            /* 278 */
            /***/ function (module, exports, __webpack_require__) {
                var identity = __webpack_require__(114),
                    metaMap = __webpack_require__(279);

                /**
                 * The base implementation of `setData` without support for hot loop shorting.
                 *
                 * @private
                 * @param {Function} func The function to associate metadata with.
                 * @param {*} data The metadata.
                 * @returns {Function} Returns `func`.
                 */
                var baseSetData = !metaMap
                    ? identity
                    : function (func, data) {
                          metaMap.set(func, data);
                          return func;
                      };

                module.exports = baseSetData;

                /***/
            },
            /* 279 */
            /***/ function (module, exports, __webpack_require__) {
                var WeakMap = __webpack_require__(163);

                /** Used to store function metadata. */
                var metaMap = WeakMap && new WeakMap();

                module.exports = metaMap;

                /***/
            },
            /* 280 */
            /***/ function (module, exports, __webpack_require__) {
                var createCtor = __webpack_require__(281),
                    root = __webpack_require__(48);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1;

                /**
                 * Creates a function that wraps `func` to invoke it with the optional `this`
                 * binding of `thisArg`.
                 *
                 * @private
                 * @param {Function} func The function to wrap.
                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                 * @param {*} [thisArg] The `this` binding of `func`.
                 * @returns {Function} Returns the new wrapped function.
                 */
                function createBind(func, bitmask, thisArg) {
                    var isBind = bitmask & WRAP_BIND_FLAG,
                        Ctor = createCtor(func);

                    function wrapper() {
                        var fn =
                            this && this !== root && this instanceof wrapper
                                ? Ctor
                                : func;
                        return fn.apply(isBind ? thisArg : this, arguments);
                    }
                    return wrapper;
                }

                module.exports = createBind;

                /***/
            },
            /* 281 */
            /***/ function (module, exports, __webpack_require__) {
                var baseCreate = __webpack_require__(219),
                    isObject = __webpack_require__(69);

                /**
                 * Creates a function that produces an instance of `Ctor` regardless of
                 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
                 *
                 * @private
                 * @param {Function} Ctor The constructor to wrap.
                 * @returns {Function} Returns the new wrapped function.
                 */
                function createCtor(Ctor) {
                    return function () {
                        // Use a `switch` statement to work with class constructors. See
                        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                        // for more details.
                        var args = arguments;
                        switch (args.length) {
                            case 0:
                                return new Ctor();
                            case 1:
                                return new Ctor(args[0]);
                            case 2:
                                return new Ctor(args[0], args[1]);
                            case 3:
                                return new Ctor(args[0], args[1], args[2]);
                            case 4:
                                return new Ctor(
                                    args[0],
                                    args[1],
                                    args[2],
                                    args[3]
                                );
                            case 5:
                                return new Ctor(
                                    args[0],
                                    args[1],
                                    args[2],
                                    args[3],
                                    args[4]
                                );
                            case 6:
                                return new Ctor(
                                    args[0],
                                    args[1],
                                    args[2],
                                    args[3],
                                    args[4],
                                    args[5]
                                );
                            case 7:
                                return new Ctor(
                                    args[0],
                                    args[1],
                                    args[2],
                                    args[3],
                                    args[4],
                                    args[5],
                                    args[6]
                                );
                        }
                        var thisBinding = baseCreate(Ctor.prototype),
                            result = Ctor.apply(thisBinding, args);

                        // Mimic the constructor's `return` behavior.
                        // See https://es5.github.io/#x13.2.2 for more details.
                        return isObject(result) ? result : thisBinding;
                    };
                }

                module.exports = createCtor;

                /***/
            },
            /* 282 */
            /***/ function (module, exports, __webpack_require__) {
                var apply = __webpack_require__(116),
                    createCtor = __webpack_require__(281),
                    createHybrid = __webpack_require__(283),
                    createRecurry = __webpack_require__(287),
                    getHolder = __webpack_require__(303),
                    replaceHolders = __webpack_require__(305),
                    root = __webpack_require__(48);

                /**
                 * Creates a function that wraps `func` to enable currying.
                 *
                 * @private
                 * @param {Function} func The function to wrap.
                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                 * @param {number} arity The arity of `func`.
                 * @returns {Function} Returns the new wrapped function.
                 */
                function createCurry(func, bitmask, arity) {
                    var Ctor = createCtor(func);

                    function wrapper() {
                        var length = arguments.length,
                            args = Array(length),
                            index = length,
                            placeholder = getHolder(wrapper);

                        while (index--) {
                            args[index] = arguments[index];
                        }
                        var holders =
                            length < 3 &&
                            args[0] !== placeholder &&
                            args[length - 1] !== placeholder
                                ? []
                                : replaceHolders(args, placeholder);

                        length -= holders.length;
                        if (length < arity) {
                            return createRecurry(
                                func,
                                bitmask,
                                createHybrid,
                                wrapper.placeholder,
                                undefined,
                                args,
                                holders,
                                undefined,
                                undefined,
                                arity - length
                            );
                        }
                        var fn =
                            this && this !== root && this instanceof wrapper
                                ? Ctor
                                : func;
                        return apply(fn, this, args);
                    }
                    return wrapper;
                }

                module.exports = createCurry;

                /***/
            },
            /* 283 */
            /***/ function (module, exports, __webpack_require__) {
                var composeArgs = __webpack_require__(284),
                    composeArgsRight = __webpack_require__(285),
                    countHolders = __webpack_require__(286),
                    createCtor = __webpack_require__(281),
                    createRecurry = __webpack_require__(287),
                    getHolder = __webpack_require__(303),
                    reorder = __webpack_require__(304),
                    replaceHolders = __webpack_require__(305),
                    root = __webpack_require__(48);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1,
                    WRAP_BIND_KEY_FLAG = 2,
                    WRAP_CURRY_FLAG = 8,
                    WRAP_CURRY_RIGHT_FLAG = 16,
                    WRAP_ARY_FLAG = 128,
                    WRAP_FLIP_FLAG = 512;

                /**
                 * Creates a function that wraps `func` to invoke it with optional `this`
                 * binding of `thisArg`, partial application, and currying.
                 *
                 * @private
                 * @param {Function|string} func The function or method name to wrap.
                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                 * @param {*} [thisArg] The `this` binding of `func`.
                 * @param {Array} [partials] The arguments to prepend to those provided to
                 *  the new function.
                 * @param {Array} [holders] The `partials` placeholder indexes.
                 * @param {Array} [partialsRight] The arguments to append to those provided
                 *  to the new function.
                 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
                 * @param {Array} [argPos] The argument positions of the new function.
                 * @param {number} [ary] The arity cap of `func`.
                 * @param {number} [arity] The arity of `func`.
                 * @returns {Function} Returns the new wrapped function.
                 */
                function createHybrid(
                    func,
                    bitmask,
                    thisArg,
                    partials,
                    holders,
                    partialsRight,
                    holdersRight,
                    argPos,
                    ary,
                    arity
                ) {
                    var isAry = bitmask & WRAP_ARY_FLAG,
                        isBind = bitmask & WRAP_BIND_FLAG,
                        isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
                        isCurried =
                            bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
                        isFlip = bitmask & WRAP_FLIP_FLAG,
                        Ctor = isBindKey ? undefined : createCtor(func);

                    function wrapper() {
                        var length = arguments.length,
                            args = Array(length),
                            index = length;

                        while (index--) {
                            args[index] = arguments[index];
                        }
                        if (isCurried) {
                            var placeholder = getHolder(wrapper),
                                holdersCount = countHolders(args, placeholder);
                        }
                        if (partials) {
                            args = composeArgs(
                                args,
                                partials,
                                holders,
                                isCurried
                            );
                        }
                        if (partialsRight) {
                            args = composeArgsRight(
                                args,
                                partialsRight,
                                holdersRight,
                                isCurried
                            );
                        }
                        length -= holdersCount;
                        if (isCurried && length < arity) {
                            var newHolders = replaceHolders(args, placeholder);
                            return createRecurry(
                                func,
                                bitmask,
                                createHybrid,
                                wrapper.placeholder,
                                thisArg,
                                args,
                                newHolders,
                                argPos,
                                ary,
                                arity - length
                            );
                        }
                        var thisBinding = isBind ? thisArg : this,
                            fn = isBindKey ? thisBinding[func] : func;

                        length = args.length;
                        if (argPos) {
                            args = reorder(args, argPos);
                        } else if (isFlip && length > 1) {
                            args.reverse();
                        }
                        if (isAry && ary < length) {
                            args.length = ary;
                        }
                        if (this && this !== root && this instanceof wrapper) {
                            fn = Ctor || createCtor(fn);
                        }
                        return fn.apply(thisBinding, args);
                    }
                    return wrapper;
                }

                module.exports = createHybrid;

                /***/
            },
            /* 284 */
            /***/ function (module, exports) {
                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * Creates an array that is the composition of partially applied arguments,
                 * placeholders, and provided arguments into a single array of arguments.
                 *
                 * @private
                 * @param {Array} args The provided arguments.
                 * @param {Array} partials The arguments to prepend to those provided.
                 * @param {Array} holders The `partials` placeholder indexes.
                 * @params {boolean} [isCurried] Specify composing for a curried function.
                 * @returns {Array} Returns the new array of composed arguments.
                 */
                function composeArgs(args, partials, holders, isCurried) {
                    var argsIndex = -1,
                        argsLength = args.length,
                        holdersLength = holders.length,
                        leftIndex = -1,
                        leftLength = partials.length,
                        rangeLength = nativeMax(argsLength - holdersLength, 0),
                        result = Array(leftLength + rangeLength),
                        isUncurried = !isCurried;

                    while (++leftIndex < leftLength) {
                        result[leftIndex] = partials[leftIndex];
                    }
                    while (++argsIndex < holdersLength) {
                        if (isUncurried || argsIndex < argsLength) {
                            result[holders[argsIndex]] = args[argsIndex];
                        }
                    }
                    while (rangeLength--) {
                        result[leftIndex++] = args[argsIndex++];
                    }
                    return result;
                }

                module.exports = composeArgs;

                /***/
            },
            /* 285 */
            /***/ function (module, exports) {
                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * This function is like `composeArgs` except that the arguments composition
                 * is tailored for `_.partialRight`.
                 *
                 * @private
                 * @param {Array} args The provided arguments.
                 * @param {Array} partials The arguments to append to those provided.
                 * @param {Array} holders The `partials` placeholder indexes.
                 * @params {boolean} [isCurried] Specify composing for a curried function.
                 * @returns {Array} Returns the new array of composed arguments.
                 */
                function composeArgsRight(args, partials, holders, isCurried) {
                    var argsIndex = -1,
                        argsLength = args.length,
                        holdersIndex = -1,
                        holdersLength = holders.length,
                        rightIndex = -1,
                        rightLength = partials.length,
                        rangeLength = nativeMax(argsLength - holdersLength, 0),
                        result = Array(rangeLength + rightLength),
                        isUncurried = !isCurried;

                    while (++argsIndex < rangeLength) {
                        result[argsIndex] = args[argsIndex];
                    }
                    var offset = argsIndex;
                    while (++rightIndex < rightLength) {
                        result[offset + rightIndex] = partials[rightIndex];
                    }
                    while (++holdersIndex < holdersLength) {
                        if (isUncurried || argsIndex < argsLength) {
                            result[offset + holders[holdersIndex]] =
                                args[argsIndex++];
                        }
                    }
                    return result;
                }

                module.exports = composeArgsRight;

                /***/
            },
            /* 286 */
            /***/ function (module, exports) {
                /**
                 * Gets the number of `placeholder` occurrences in `array`.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {*} placeholder The placeholder to search for.
                 * @returns {number} Returns the placeholder count.
                 */
                function countHolders(array, placeholder) {
                    var length = array.length,
                        result = 0;

                    while (length--) {
                        if (array[length] === placeholder) {
                            ++result;
                        }
                    }
                    return result;
                }

                module.exports = countHolders;

                /***/
            },
            /* 287 */
            /***/ function (module, exports, __webpack_require__) {
                var isLaziable = __webpack_require__(288),
                    setData = __webpack_require__(298),
                    setWrapToString = __webpack_require__(299);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1,
                    WRAP_BIND_KEY_FLAG = 2,
                    WRAP_CURRY_BOUND_FLAG = 4,
                    WRAP_CURRY_FLAG = 8,
                    WRAP_PARTIAL_FLAG = 32,
                    WRAP_PARTIAL_RIGHT_FLAG = 64;

                /**
                 * Creates a function that wraps `func` to continue currying.
                 *
                 * @private
                 * @param {Function} func The function to wrap.
                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                 * @param {Function} wrapFunc The function to create the `func` wrapper.
                 * @param {*} placeholder The placeholder value.
                 * @param {*} [thisArg] The `this` binding of `func`.
                 * @param {Array} [partials] The arguments to prepend to those provided to
                 *  the new function.
                 * @param {Array} [holders] The `partials` placeholder indexes.
                 * @param {Array} [argPos] The argument positions of the new function.
                 * @param {number} [ary] The arity cap of `func`.
                 * @param {number} [arity] The arity of `func`.
                 * @returns {Function} Returns the new wrapped function.
                 */
                function createRecurry(
                    func,
                    bitmask,
                    wrapFunc,
                    placeholder,
                    thisArg,
                    partials,
                    holders,
                    argPos,
                    ary,
                    arity
                ) {
                    var isCurry = bitmask & WRAP_CURRY_FLAG,
                        newHolders = isCurry ? holders : undefined,
                        newHoldersRight = isCurry ? undefined : holders,
                        newPartials = isCurry ? partials : undefined,
                        newPartialsRight = isCurry ? undefined : partials;

                    bitmask |= isCurry
                        ? WRAP_PARTIAL_FLAG
                        : WRAP_PARTIAL_RIGHT_FLAG;
                    bitmask &= ~(isCurry
                        ? WRAP_PARTIAL_RIGHT_FLAG
                        : WRAP_PARTIAL_FLAG);

                    if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
                        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                    }
                    var newData = [
                        func,
                        bitmask,
                        thisArg,
                        newPartials,
                        newHolders,
                        newPartialsRight,
                        newHoldersRight,
                        argPos,
                        ary,
                        arity,
                    ];

                    var result = wrapFunc.apply(undefined, newData);
                    if (isLaziable(func)) {
                        setData(result, newData);
                    }
                    result.placeholder = placeholder;
                    return setWrapToString(result, func, bitmask);
                }

                module.exports = createRecurry;

                /***/
            },
            /* 288 */
            /***/ function (module, exports, __webpack_require__) {
                var LazyWrapper = __webpack_require__(289),
                    getData = __webpack_require__(291),
                    getFuncName = __webpack_require__(293),
                    lodash = __webpack_require__(295);

                /**
                 * Checks if `func` has a lazy counterpart.
                 *
                 * @private
                 * @param {Function} func The function to check.
                 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
                 *  else `false`.
                 */
                function isLaziable(func) {
                    var funcName = getFuncName(func),
                        other = lodash[funcName];

                    if (
                        typeof other != "function" ||
                        !(funcName in LazyWrapper.prototype)
                    ) {
                        return false;
                    }
                    if (func === other) {
                        return true;
                    }
                    var data = getData(other);
                    return !!data && func === data[0];
                }

                module.exports = isLaziable;

                /***/
            },
            /* 289 */
            /***/ function (module, exports, __webpack_require__) {
                var baseCreate = __webpack_require__(219),
                    baseLodash = __webpack_require__(290);

                /** Used as references for the maximum length and index of an array. */
                var MAX_ARRAY_LENGTH = 4294967295;

                /**
                 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
                 *
                 * @private
                 * @constructor
                 * @param {*} value The value to wrap.
                 */
                function LazyWrapper(value) {
                    this.__wrapped__ = value;
                    this.__actions__ = [];
                    this.__dir__ = 1;
                    this.__filtered__ = false;
                    this.__iteratees__ = [];
                    this.__takeCount__ = MAX_ARRAY_LENGTH;
                    this.__views__ = [];
                }

                // Ensure `LazyWrapper` is an instance of `baseLodash`.
                LazyWrapper.prototype = baseCreate(baseLodash.prototype);
                LazyWrapper.prototype.constructor = LazyWrapper;

                module.exports = LazyWrapper;

                /***/
            },
            /* 290 */
            /***/ function (module, exports) {
                /**
                 * The function whose prototype chain sequence wrappers inherit from.
                 *
                 * @private
                 */
                function baseLodash() {
                    // No operation performed.
                }

                module.exports = baseLodash;

                /***/
            },
            /* 291 */
            /***/ function (module, exports, __webpack_require__) {
                var metaMap = __webpack_require__(279),
                    noop = __webpack_require__(292);

                /**
                 * Gets metadata for `func`.
                 *
                 * @private
                 * @param {Function} func The function to query.
                 * @returns {*} Returns the metadata for `func`.
                 */
                var getData = !metaMap
                    ? noop
                    : function (func) {
                          return metaMap.get(func);
                      };

                module.exports = getData;

                /***/
            },
            /* 292 */
            /***/ function (module, exports) {
                /**
                 * This method returns `undefined`.
                 *
                 * @static
                 * @memberOf _
                 * @since 2.3.0
                 * @category Util
                 * @example
                 *
                 * _.times(2, _.noop);
                 * // => [undefined, undefined]
                 */
                function noop() {
                    // No operation performed.
                }

                module.exports = noop;

                /***/
            },
            /* 293 */
            /***/ function (module, exports, __webpack_require__) {
                var realNames = __webpack_require__(294);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Gets the name of `func`.
                 *
                 * @private
                 * @param {Function} func The function to query.
                 * @returns {string} Returns the function name.
                 */
                function getFuncName(func) {
                    var result = func.name + "",
                        array = realNames[result],
                        length = hasOwnProperty.call(realNames, result)
                            ? array.length
                            : 0;

                    while (length--) {
                        var data = array[length],
                            otherFunc = data.func;
                        if (otherFunc == null || otherFunc == func) {
                            return data.name;
                        }
                    }
                    return result;
                }

                module.exports = getFuncName;

                /***/
            },
            /* 294 */
            /***/ function (module, exports) {
                /** Used to lookup unminified function names. */
                var realNames = {};

                module.exports = realNames;

                /***/
            },
            /* 295 */
            /***/ function (module, exports, __webpack_require__) {
                var LazyWrapper = __webpack_require__(289),
                    LodashWrapper = __webpack_require__(296),
                    baseLodash = __webpack_require__(290),
                    isArray = __webpack_require__(53),
                    isObjectLike = __webpack_require__(52),
                    wrapperClone = __webpack_require__(297);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Creates a `lodash` object which wraps `value` to enable implicit method
                 * chain sequences. Methods that operate on and return arrays, collections,
                 * and functions can be chained together. Methods that retrieve a single value
                 * or may return a primitive value will automatically end the chain sequence
                 * and return the unwrapped value. Otherwise, the value must be unwrapped
                 * with `_#value`.
                 *
                 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
                 * enabled using `_.chain`.
                 *
                 * The execution of chained methods is lazy, that is, it's deferred until
                 * `_#value` is implicitly or explicitly called.
                 *
                 * Lazy evaluation allows several methods to support shortcut fusion.
                 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
                 * the creation of intermediate arrays and can greatly reduce the number of
                 * iteratee executions. Sections of a chain sequence qualify for shortcut
                 * fusion if the section is applied to an array and iteratees accept only
                 * one argument. The heuristic for whether a section qualifies for shortcut
                 * fusion is subject to change.
                 *
                 * Chaining is supported in custom builds as long as the `_#value` method is
                 * directly or indirectly included in the build.
                 *
                 * In addition to lodash methods, wrappers have `Array` and `String` methods.
                 *
                 * The wrapper `Array` methods are:
                 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
                 *
                 * The wrapper `String` methods are:
                 * `replace` and `split`
                 *
                 * The wrapper methods that support shortcut fusion are:
                 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
                 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
                 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
                 *
                 * The chainable wrapper methods are:
                 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
                 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
                 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
                 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
                 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
                 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
                 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
                 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
                 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
                 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
                 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
                 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
                 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
                 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
                 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
                 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
                 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
                 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
                 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
                 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
                 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
                 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
                 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
                 * `zipObject`, `zipObjectDeep`, and `zipWith`
                 *
                 * The wrapper methods that are **not** chainable by default are:
                 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
                 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
                 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
                 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
                 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
                 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
                 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
                 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
                 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
                 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
                 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
                 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
                 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
                 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
                 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
                 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
                 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
                 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
                 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
                 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
                 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
                 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
                 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
                 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
                 * `upperFirst`, `value`, and `words`
                 *
                 * @name _
                 * @constructor
                 * @category Seq
                 * @param {*} value The value to wrap in a `lodash` instance.
                 * @returns {Object} Returns the new `lodash` wrapper instance.
                 * @example
                 *
                 * function square(n) {
                 *   return n * n;
                 * }
                 *
                 * var wrapped = _([1, 2, 3]);
                 *
                 * // Returns an unwrapped value.
                 * wrapped.reduce(_.add);
                 * // => 6
                 *
                 * // Returns a wrapped value.
                 * var squares = wrapped.map(square);
                 *
                 * _.isArray(squares);
                 * // => false
                 *
                 * _.isArray(squares.value());
                 * // => true
                 */
                function lodash(value) {
                    if (
                        isObjectLike(value) &&
                        !isArray(value) &&
                        !(value instanceof LazyWrapper)
                    ) {
                        if (value instanceof LodashWrapper) {
                            return value;
                        }
                        if (hasOwnProperty.call(value, "__wrapped__")) {
                            return wrapperClone(value);
                        }
                    }
                    return new LodashWrapper(value);
                }

                // Ensure wrappers are instances of `baseLodash`.
                lodash.prototype = baseLodash.prototype;
                lodash.prototype.constructor = lodash;

                module.exports = lodash;

                /***/
            },
            /* 296 */
            /***/ function (module, exports, __webpack_require__) {
                var baseCreate = __webpack_require__(219),
                    baseLodash = __webpack_require__(290);

                /**
                 * The base constructor for creating `lodash` wrapper objects.
                 *
                 * @private
                 * @param {*} value The value to wrap.
                 * @param {boolean} [chainAll] Enable explicit method chain sequences.
                 */
                function LodashWrapper(value, chainAll) {
                    this.__wrapped__ = value;
                    this.__actions__ = [];
                    this.__chain__ = !!chainAll;
                    this.__index__ = 0;
                    this.__values__ = undefined;
                }

                LodashWrapper.prototype = baseCreate(baseLodash.prototype);
                LodashWrapper.prototype.constructor = LodashWrapper;

                module.exports = LodashWrapper;

                /***/
            },
            /* 297 */
            /***/ function (module, exports, __webpack_require__) {
                var LazyWrapper = __webpack_require__(289),
                    LodashWrapper = __webpack_require__(296),
                    copyArray = __webpack_require__(201);

                /**
                 * Creates a clone of `wrapper`.
                 *
                 * @private
                 * @param {Object} wrapper The wrapper to clone.
                 * @returns {Object} Returns the cloned wrapper.
                 */
                function wrapperClone(wrapper) {
                    if (wrapper instanceof LazyWrapper) {
                        return wrapper.clone();
                    }
                    var result = new LodashWrapper(
                        wrapper.__wrapped__,
                        wrapper.__chain__
                    );
                    result.__actions__ = copyArray(wrapper.__actions__);
                    result.__index__ = wrapper.__index__;
                    result.__values__ = wrapper.__values__;
                    return result;
                }

                module.exports = wrapperClone;

                /***/
            },
            /* 298 */
            /***/ function (module, exports, __webpack_require__) {
                var baseSetData = __webpack_require__(278),
                    shortOut = __webpack_require__(121);

                /**
                 * Sets metadata for `func`.
                 *
                 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
                 * period of time, it will trip its breaker and transition to an identity
                 * function to avoid garbage collection pauses in V8. See
                 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
                 * for more details.
                 *
                 * @private
                 * @param {Function} func The function to associate metadata with.
                 * @param {*} data The metadata.
                 * @returns {Function} Returns `func`.
                 */
                var setData = shortOut(baseSetData);

                module.exports = setData;

                /***/
            },
            /* 299 */
            /***/ function (module, exports, __webpack_require__) {
                var getWrapDetails = __webpack_require__(300),
                    insertWrapDetails = __webpack_require__(301),
                    setToString = __webpack_require__(117),
                    updateWrapDetails = __webpack_require__(302);

                /**
                 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
                 * with wrapper details in a comment at the top of the source body.
                 *
                 * @private
                 * @param {Function} wrapper The function to modify.
                 * @param {Function} reference The reference function.
                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                 * @returns {Function} Returns `wrapper`.
                 */
                function setWrapToString(wrapper, reference, bitmask) {
                    var source = reference + "";
                    return setToString(
                        wrapper,
                        insertWrapDetails(
                            source,
                            updateWrapDetails(getWrapDetails(source), bitmask)
                        )
                    );
                }

                module.exports = setWrapToString;

                /***/
            },
            /* 300 */
            /***/ function (module, exports) {
                /** Used to match wrap detail comments. */
                var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
                    reSplitDetails = /,? & /;

                /**
                 * Extracts wrapper details from the `source` body comment.
                 *
                 * @private
                 * @param {string} source The source to inspect.
                 * @returns {Array} Returns the wrapper details.
                 */
                function getWrapDetails(source) {
                    var match = source.match(reWrapDetails);
                    return match ? match[1].split(reSplitDetails) : [];
                }

                module.exports = getWrapDetails;

                /***/
            },
            /* 301 */
            /***/ function (module, exports) {
                /** Used to match wrap detail comments. */
                var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

                /**
                 * Inserts wrapper `details` in a comment at the top of the `source` body.
                 *
                 * @private
                 * @param {string} source The source to modify.
                 * @returns {Array} details The details to insert.
                 * @returns {string} Returns the modified source.
                 */
                function insertWrapDetails(source, details) {
                    var length = details.length;
                    if (!length) {
                        return source;
                    }
                    var lastIndex = length - 1;
                    details[lastIndex] =
                        (length > 1 ? "& " : "") + details[lastIndex];
                    details = details.join(length > 2 ? ", " : " ");
                    return source.replace(
                        reWrapComment,
                        "{\n/* [wrapped with " + details + "] */\n"
                    );
                }

                module.exports = insertWrapDetails;

                /***/
            },
            /* 302 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayEach = __webpack_require__(130),
                    arrayIncludes = __webpack_require__(106);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1,
                    WRAP_BIND_KEY_FLAG = 2,
                    WRAP_CURRY_FLAG = 8,
                    WRAP_CURRY_RIGHT_FLAG = 16,
                    WRAP_PARTIAL_FLAG = 32,
                    WRAP_PARTIAL_RIGHT_FLAG = 64,
                    WRAP_ARY_FLAG = 128,
                    WRAP_REARG_FLAG = 256,
                    WRAP_FLIP_FLAG = 512;

                /** Used to associate wrap methods with their bit flags. */
                var wrapFlags = [
                    ["ary", WRAP_ARY_FLAG],
                    ["bind", WRAP_BIND_FLAG],
                    ["bindKey", WRAP_BIND_KEY_FLAG],
                    ["curry", WRAP_CURRY_FLAG],
                    ["curryRight", WRAP_CURRY_RIGHT_FLAG],
                    ["flip", WRAP_FLIP_FLAG],
                    ["partial", WRAP_PARTIAL_FLAG],
                    ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
                    ["rearg", WRAP_REARG_FLAG],
                ];

                /**
                 * Updates wrapper `details` based on `bitmask` flags.
                 *
                 * @private
                 * @returns {Array} details The details to modify.
                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                 * @returns {Array} Returns `details`.
                 */
                function updateWrapDetails(details, bitmask) {
                    arrayEach(wrapFlags, function (pair) {
                        var value = "_." + pair[0];
                        if (
                            bitmask & pair[1] &&
                            !arrayIncludes(details, value)
                        ) {
                            details.push(value);
                        }
                    });
                    return details.sort();
                }

                module.exports = updateWrapDetails;

                /***/
            },
            /* 303 */
            /***/ function (module, exports) {
                /**
                 * Gets the argument placeholder value for `func`.
                 *
                 * @private
                 * @param {Function} func The function to inspect.
                 * @returns {*} Returns the placeholder value.
                 */
                function getHolder(func) {
                    var object = func;
                    return object.placeholder;
                }

                module.exports = getHolder;

                /***/
            },
            /* 304 */
            /***/ function (module, exports, __webpack_require__) {
                var copyArray = __webpack_require__(201),
                    isIndex = __webpack_require__(57);

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMin = Math.min;

                /**
                 * Reorder `array` according to the specified indexes where the element at
                 * the first index is assigned as the first element, the element at
                 * the second index is assigned as the second element, and so on.
                 *
                 * @private
                 * @param {Array} array The array to reorder.
                 * @param {Array} indexes The arranged array indexes.
                 * @returns {Array} Returns `array`.
                 */
                function reorder(array, indexes) {
                    var arrLength = array.length,
                        length = nativeMin(indexes.length, arrLength),
                        oldArray = copyArray(array);

                    while (length--) {
                        var index = indexes[length];
                        array[length] = isIndex(index, arrLength)
                            ? oldArray[index]
                            : undefined;
                    }
                    return array;
                }

                module.exports = reorder;

                /***/
            },
            /* 305 */
            /***/ function (module, exports) {
                /** Used as the internal argument placeholder. */
                var PLACEHOLDER = "__lodash_placeholder__";

                /**
                 * Replaces all `placeholder` elements in `array` with an internal placeholder
                 * and returns an array of their indexes.
                 *
                 * @private
                 * @param {Array} array The array to modify.
                 * @param {*} placeholder The placeholder to replace.
                 * @returns {Array} Returns the new array of placeholder indexes.
                 */
                function replaceHolders(array, placeholder) {
                    var index = -1,
                        length = array.length,
                        resIndex = 0,
                        result = [];

                    while (++index < length) {
                        var value = array[index];
                        if (value === placeholder || value === PLACEHOLDER) {
                            array[index] = PLACEHOLDER;
                            result[resIndex++] = index;
                        }
                    }
                    return result;
                }

                module.exports = replaceHolders;

                /***/
            },
            /* 306 */
            /***/ function (module, exports, __webpack_require__) {
                var apply = __webpack_require__(116),
                    createCtor = __webpack_require__(281),
                    root = __webpack_require__(48);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1;

                /**
                 * Creates a function that wraps `func` to invoke it with the `this` binding
                 * of `thisArg` and `partials` prepended to the arguments it receives.
                 *
                 * @private
                 * @param {Function} func The function to wrap.
                 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
                 * @param {*} thisArg The `this` binding of `func`.
                 * @param {Array} partials The arguments to prepend to those provided to
                 *  the new function.
                 * @returns {Function} Returns the new wrapped function.
                 */
                function createPartial(func, bitmask, thisArg, partials) {
                    var isBind = bitmask & WRAP_BIND_FLAG,
                        Ctor = createCtor(func);

                    function wrapper() {
                        var argsIndex = -1,
                            argsLength = arguments.length,
                            leftIndex = -1,
                            leftLength = partials.length,
                            args = Array(leftLength + argsLength),
                            fn =
                                this && this !== root && this instanceof wrapper
                                    ? Ctor
                                    : func;

                        while (++leftIndex < leftLength) {
                            args[leftIndex] = partials[leftIndex];
                        }
                        while (argsLength--) {
                            args[leftIndex++] = arguments[++argsIndex];
                        }
                        return apply(fn, isBind ? thisArg : this, args);
                    }
                    return wrapper;
                }

                module.exports = createPartial;

                /***/
            },
            /* 307 */
            /***/ function (module, exports, __webpack_require__) {
                var composeArgs = __webpack_require__(284),
                    composeArgsRight = __webpack_require__(285),
                    replaceHolders = __webpack_require__(305);

                /** Used as the internal argument placeholder. */
                var PLACEHOLDER = "__lodash_placeholder__";

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1,
                    WRAP_BIND_KEY_FLAG = 2,
                    WRAP_CURRY_BOUND_FLAG = 4,
                    WRAP_CURRY_FLAG = 8,
                    WRAP_ARY_FLAG = 128,
                    WRAP_REARG_FLAG = 256;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMin = Math.min;

                /**
                 * Merges the function metadata of `source` into `data`.
                 *
                 * Merging metadata reduces the number of wrappers used to invoke a function.
                 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
                 * may be applied regardless of execution order. Methods like `_.ary` and
                 * `_.rearg` modify function arguments, making the order in which they are
                 * executed important, preventing the merging of metadata. However, we make
                 * an exception for a safe combined case where curried functions have `_.ary`
                 * and or `_.rearg` applied.
                 *
                 * @private
                 * @param {Array} data The destination metadata.
                 * @param {Array} source The source metadata.
                 * @returns {Array} Returns `data`.
                 */
                function mergeData(data, source) {
                    var bitmask = data[1],
                        srcBitmask = source[1],
                        newBitmask = bitmask | srcBitmask,
                        isCommon =
                            newBitmask <
                            (WRAP_BIND_FLAG |
                                WRAP_BIND_KEY_FLAG |
                                WRAP_ARY_FLAG);

                    var isCombo =
                        (srcBitmask == WRAP_ARY_FLAG &&
                            bitmask == WRAP_CURRY_FLAG) ||
                        (srcBitmask == WRAP_ARY_FLAG &&
                            bitmask == WRAP_REARG_FLAG &&
                            data[7].length <= source[8]) ||
                        (srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) &&
                            source[7].length <= source[8] &&
                            bitmask == WRAP_CURRY_FLAG);

                    // Exit early if metadata can't be merged.
                    if (!(isCommon || isCombo)) {
                        return data;
                    }
                    // Use source `thisArg` if available.
                    if (srcBitmask & WRAP_BIND_FLAG) {
                        data[2] = source[2];
                        // Set when currying a bound function.
                        newBitmask |=
                            bitmask & WRAP_BIND_FLAG
                                ? 0
                                : WRAP_CURRY_BOUND_FLAG;
                    }
                    // Compose partial arguments.
                    var value = source[3];
                    if (value) {
                        var partials = data[3];
                        data[3] = partials
                            ? composeArgs(partials, value, source[4])
                            : value;
                        data[4] = partials
                            ? replaceHolders(data[3], PLACEHOLDER)
                            : source[4];
                    }
                    // Compose partial right arguments.
                    value = source[5];
                    if (value) {
                        partials = data[5];
                        data[5] = partials
                            ? composeArgsRight(partials, value, source[6])
                            : value;
                        data[6] = partials
                            ? replaceHolders(data[5], PLACEHOLDER)
                            : source[6];
                    }
                    // Use source `argPos` if available.
                    value = source[7];
                    if (value) {
                        data[7] = value;
                    }
                    // Use source `ary` if it's smaller.
                    if (srcBitmask & WRAP_ARY_FLAG) {
                        data[8] =
                            data[8] == null
                                ? source[8]
                                : nativeMin(data[8], source[8]);
                    }
                    // Use source `arity` if one is not provided.
                    if (data[9] == null) {
                        data[9] = source[9];
                    }
                    // Use source `func` and merge bitmasks.
                    data[0] = source[0];
                    data[1] = newBitmask;

                    return data;
                }

                module.exports = mergeData;

                /***/
            },
            /* 308 */
            /***/ function (module, exports, __webpack_require__) {
                var baseRest = __webpack_require__(113),
                    createWrap = __webpack_require__(277),
                    getHolder = __webpack_require__(303),
                    replaceHolders = __webpack_require__(305);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_PARTIAL_RIGHT_FLAG = 64;

                /**
                 * This method is like `_.partial` except that partially applied arguments
                 * are appended to the arguments it receives.
                 *
                 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
                 * builds, may be used as a placeholder for partially applied arguments.
                 *
                 * **Note:** This method doesn't set the "length" property of partially
                 * applied functions.
                 *
                 * @static
                 * @memberOf _
                 * @since 1.0.0
                 * @category Function
                 * @param {Function} func The function to partially apply arguments to.
                 * @param {...*} [partials] The arguments to be partially applied.
                 * @returns {Function} Returns the new partially applied function.
                 * @example
                 *
                 * function greet(greeting, name) {
                 *   return greeting + ' ' + name;
                 * }
                 *
                 * var greetFred = _.partialRight(greet, 'fred');
                 * greetFred('hi');
                 * // => 'hi fred'
                 *
                 * // Partially applied with placeholders.
                 * var sayHelloTo = _.partialRight(greet, 'hello', _);
                 * sayHelloTo('fred');
                 * // => 'hello fred'
                 */
                var partialRight = baseRest(function (func, partials) {
                    var holders = replaceHolders(
                        partials,
                        getHolder(partialRight)
                    );
                    return createWrap(
                        func,
                        WRAP_PARTIAL_RIGHT_FLAG,
                        undefined,
                        partials,
                        holders
                    );
                });

                // Assign default placeholders.
                partialRight.placeholder = {};

                module.exports = partialRight;

                /***/
            },
            /* 309 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var reduce = __webpack_require__(187);
                var find = __webpack_require__(240);
                var startsWith = __webpack_require__(310);

                /**
                 * Transform sort format from user friendly notation to lodash format
                 * @param {string[]} sortBy array of predicate of the form "attribute:order"
                 * @return {array.<string[]>} array containing 2 elements : attributes, orders
                 */
                module.exports = function formatSort(sortBy, defaults) {
                    return reduce(
                        sortBy,
                        function preparePredicate(out, sortInstruction) {
                            var sortInstructions = sortInstruction.split(":");
                            if (defaults && sortInstructions.length === 1) {
                                var similarDefault = find(
                                    defaults,
                                    function (predicate) {
                                        return startsWith(
                                            predicate,
                                            sortInstruction[0]
                                        );
                                    }
                                );
                                if (similarDefault) {
                                    sortInstructions =
                                        similarDefault.split(":");
                                }
                            }
                            out[0].push(sortInstructions[0]);
                            out[1].push(sortInstructions[1]);
                            return out;
                        },
                        [[], []]
                    );
                };

                /***/
            },
            /* 310 */
            /***/ function (module, exports, __webpack_require__) {
                var baseClamp = __webpack_require__(311),
                    baseToString = __webpack_require__(177),
                    toInteger = __webpack_require__(231),
                    toString = __webpack_require__(176);

                /**
                 * Checks if `string` starts with the given target string.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category String
                 * @param {string} [string=''] The string to inspect.
                 * @param {string} [target] The string to search for.
                 * @param {number} [position=0] The position to search from.
                 * @returns {boolean} Returns `true` if `string` starts with `target`,
                 *  else `false`.
                 * @example
                 *
                 * _.startsWith('abc', 'a');
                 * // => true
                 *
                 * _.startsWith('abc', 'b');
                 * // => false
                 *
                 * _.startsWith('abc', 'b', 1);
                 * // => true
                 */
                function startsWith(string, target, position) {
                    string = toString(string);
                    position =
                        position == null
                            ? 0
                            : baseClamp(toInteger(position), 0, string.length);

                    target = baseToString(target);
                    return (
                        string.slice(position, position + target.length) ==
                        target
                    );
                }

                module.exports = startsWith;

                /***/
            },
            /* 311 */
            /***/ function (module, exports) {
                /**
                 * The base implementation of `_.clamp` which doesn't coerce arguments.
                 *
                 * @private
                 * @param {number} number The number to clamp.
                 * @param {number} [lower] The lower bound.
                 * @param {number} upper The upper bound.
                 * @returns {number} Returns the clamped number.
                 */
                function baseClamp(number, lower, upper) {
                    if (number === number) {
                        if (upper !== undefined) {
                            number = number <= upper ? number : upper;
                        }
                        if (lower !== undefined) {
                            number = number >= lower ? number : lower;
                        }
                    }
                    return number;
                }

                module.exports = baseClamp;

                /***/
            },
            /* 312 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                module.exports = generateTrees;

                var last = __webpack_require__(221);
                var map = __webpack_require__(185);
                var reduce = __webpack_require__(187);
                var orderBy = __webpack_require__(271);
                var trim = __webpack_require__(243);
                var find = __webpack_require__(240);
                var pickBy = __webpack_require__(313);

                var prepareHierarchicalFacetSortBy = __webpack_require__(309);

                function generateTrees(state) {
                    return function generate(
                        hierarchicalFacetResult,
                        hierarchicalFacetIndex
                    ) {
                        var hierarchicalFacet =
                            state.hierarchicalFacets[hierarchicalFacetIndex];
                        var hierarchicalFacetRefinement =
                            (state.hierarchicalFacetsRefinements[
                                hierarchicalFacet.name
                            ] &&
                                state.hierarchicalFacetsRefinements[
                                    hierarchicalFacet.name
                                ][0]) ||
                            "";
                        var hierarchicalSeparator =
                            state._getHierarchicalFacetSeparator(
                                hierarchicalFacet
                            );
                        var hierarchicalRootPath =
                            state._getHierarchicalRootPath(hierarchicalFacet);
                        var hierarchicalShowParentLevel =
                            state._getHierarchicalShowParentLevel(
                                hierarchicalFacet
                            );
                        var sortBy = prepareHierarchicalFacetSortBy(
                            state._getHierarchicalFacetSortBy(hierarchicalFacet)
                        );

                        var generateTreeFn = generateHierarchicalTree(
                            sortBy,
                            hierarchicalSeparator,
                            hierarchicalRootPath,
                            hierarchicalShowParentLevel,
                            hierarchicalFacetRefinement
                        );

                        var results = hierarchicalFacetResult;

                        if (hierarchicalRootPath) {
                            results = hierarchicalFacetResult.slice(
                                hierarchicalRootPath.split(
                                    hierarchicalSeparator
                                ).length
                            );
                        }

                        return reduce(results, generateTreeFn, {
                            name: state.hierarchicalFacets[
                                hierarchicalFacetIndex
                            ].name,
                            count: null, // root level, no count
                            isRefined: true, // root level, always refined
                            path: null, // root level, no path
                            data: null,
                        });
                    };
                }

                function generateHierarchicalTree(
                    sortBy,
                    hierarchicalSeparator,
                    hierarchicalRootPath,
                    hierarchicalShowParentLevel,
                    currentRefinement
                ) {
                    return function generateTree(
                        hierarchicalTree,
                        hierarchicalFacetResult,
                        currentHierarchicalLevel
                    ) {
                        var parent = hierarchicalTree;

                        if (currentHierarchicalLevel > 0) {
                            var level = 0;

                            parent = hierarchicalTree;

                            while (level < currentHierarchicalLevel) {
                                parent =
                                    parent &&
                                    find(parent.data, { isRefined: true });
                                level++;
                            }
                        }

                        // we found a refined parent, let's add current level data under it
                        if (parent) {
                            // filter values in case an object has multiple categories:
                            //   {
                            //     categories: {
                            //       level0: ['beers', 'bières'],
                            //       level1: ['beers > IPA', 'bières > Belges']
                            //     }
                            //   }
                            //
                            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
                            // showing up

                            var onlyMatchingValuesFn = filterFacetValues(
                                parent.path || hierarchicalRootPath,
                                currentRefinement,
                                hierarchicalSeparator,
                                hierarchicalRootPath,
                                hierarchicalShowParentLevel
                            );

                            parent.data = orderBy(
                                map(
                                    pickBy(
                                        hierarchicalFacetResult.data,
                                        onlyMatchingValuesFn
                                    ),
                                    formatHierarchicalFacetValue(
                                        hierarchicalSeparator,
                                        currentRefinement
                                    )
                                ),
                                sortBy[0],
                                sortBy[1]
                            );
                        }

                        return hierarchicalTree;
                    };
                }

                function filterFacetValues(
                    parentPath,
                    currentRefinement,
                    hierarchicalSeparator,
                    hierarchicalRootPath,
                    hierarchicalShowParentLevel
                ) {
                    return function (facetCount, facetValue) {
                        // we want the facetValue is a child of hierarchicalRootPath
                        if (
                            hierarchicalRootPath &&
                            (facetValue.indexOf(hierarchicalRootPath) !== 0 ||
                                hierarchicalRootPath === facetValue)
                        ) {
                            return false;
                        }

                        // we always want root levels (only when there is no prefix path)
                        return (
                            (!hierarchicalRootPath &&
                                facetValue.indexOf(hierarchicalSeparator) ===
                                    -1) ||
                            // if there is a rootPath, being root level mean 1 level under rootPath
                            (hierarchicalRootPath &&
                                facetValue.split(hierarchicalSeparator).length -
                                    hierarchicalRootPath.split(
                                        hierarchicalSeparator
                                    ).length ===
                                    1) ||
                            // if current refinement is a root level and current facetValue is a root level,
                            // keep the facetValue
                            (facetValue.indexOf(hierarchicalSeparator) === -1 &&
                                currentRefinement.indexOf(
                                    hierarchicalSeparator
                                ) === -1) ||
                            // currentRefinement is a child of the facet value
                            currentRefinement.indexOf(facetValue) === 0 ||
                            // facetValue is a child of the current parent, add it
                            (facetValue.indexOf(
                                parentPath + hierarchicalSeparator
                            ) === 0 &&
                                (hierarchicalShowParentLevel ||
                                    facetValue.indexOf(currentRefinement) ===
                                        0))
                        );
                    };
                }

                function formatHierarchicalFacetValue(
                    hierarchicalSeparator,
                    currentRefinement
                ) {
                    return function format(facetCount, facetValue) {
                        return {
                            name: trim(
                                last(facetValue.split(hierarchicalSeparator))
                            ),
                            path: facetValue,
                            count: facetCount,
                            isRefined:
                                currentRefinement === facetValue ||
                                currentRefinement.indexOf(
                                    facetValue + hierarchicalSeparator
                                ) === 0,
                            data: null,
                        };
                    };
                }

                /***/
            },
            /* 313 */
            /***/ function (module, exports, __webpack_require__) {
                var arrayMap = __webpack_require__(71),
                    baseIteratee = __webpack_require__(136),
                    basePickBy = __webpack_require__(314),
                    getAllKeysIn = __webpack_require__(206);

                /**
                 * Creates an object composed of the `object` properties `predicate` returns
                 * truthy for. The predicate is invoked with two arguments: (value, key).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Object
                 * @param {Object} object The source object.
                 * @param {Function} [predicate=_.identity] The function invoked per property.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': '2', 'c': 3 };
                 *
                 * _.pickBy(object, _.isNumber);
                 * // => { 'a': 1, 'c': 3 }
                 */
                function pickBy(object, predicate) {
                    if (object == null) {
                        return {};
                    }
                    var props = arrayMap(getAllKeysIn(object), function (prop) {
                        return [prop];
                    });
                    predicate = baseIteratee(predicate);
                    return basePickBy(object, props, function (value, path) {
                        return predicate(value, path[0]);
                    });
                }

                module.exports = pickBy;

                /***/
            },
            /* 314 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGet = __webpack_require__(169),
                    baseSet = __webpack_require__(315),
                    castPath = __webpack_require__(170);

                /**
                 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Object} object The source object.
                 * @param {string[]} paths The property paths to pick.
                 * @param {Function} predicate The function invoked per property.
                 * @returns {Object} Returns the new object.
                 */
                function basePickBy(object, paths, predicate) {
                    var index = -1,
                        length = paths.length,
                        result = {};

                    while (++index < length) {
                        var path = paths[index],
                            value = baseGet(object, path);

                        if (predicate(value, path)) {
                            baseSet(result, castPath(path, object), value);
                        }
                    }
                    return result;
                }

                module.exports = basePickBy;

                /***/
            },
            /* 315 */
            /***/ function (module, exports, __webpack_require__) {
                var assignValue = __webpack_require__(192),
                    castPath = __webpack_require__(170),
                    isIndex = __webpack_require__(57),
                    isObject = __webpack_require__(69),
                    toKey = __webpack_require__(178);

                /**
                 * The base implementation of `_.set`.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {Array|string} path The path of the property to set.
                 * @param {*} value The value to set.
                 * @param {Function} [customizer] The function to customize path creation.
                 * @returns {Object} Returns `object`.
                 */
                function baseSet(object, path, value, customizer) {
                    if (!isObject(object)) {
                        return object;
                    }
                    path = castPath(path, object);

                    var index = -1,
                        length = path.length,
                        lastIndex = length - 1,
                        nested = object;

                    while (nested != null && ++index < length) {
                        var key = toKey(path[index]),
                            newValue = value;

                        if (index != lastIndex) {
                            var objValue = nested[key];
                            newValue = customizer
                                ? customizer(objValue, key, nested)
                                : undefined;
                            if (newValue === undefined) {
                                newValue = isObject(objValue)
                                    ? objValue
                                    : isIndex(path[index + 1])
                                    ? []
                                    : {};
                            }
                        }
                        assignValue(nested, key, newValue);
                        nested = nested[key];
                    }
                    return object;
                }

                module.exports = baseSet;

                /***/
            },
            /* 316 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";
                var util = __webpack_require__(317);
                var events = __webpack_require__(320);

                /**
                 * A DerivedHelper is a way to create sub requests to
                 * Algolia from a main helper.
                 * @class
                 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
                 *  - search: when a search is triggered using the `search()` method.
                 *  - result: when the response is retrieved from Algolia and is processed.
                 *    This event contains a {@link SearchResults} object and the
                 *    {@link SearchParameters} corresponding to this answer.
                 */
                function DerivedHelper(mainHelper, fn) {
                    this.main = mainHelper;
                    this.fn = fn;
                    this.lastResults = null;
                }

                util.inherits(DerivedHelper, events.EventEmitter);

                /**
                 * Detach this helper from the main helper
                 * @return {undefined}
                 * @throws Error if the derived helper is already detached
                 */
                DerivedHelper.prototype.detach = function () {
                    this.removeAllListeners();
                    this.main.detachDerivedHelper(this);
                };

                DerivedHelper.prototype.getModifiedState = function (
                    parameters
                ) {
                    return this.fn(parameters);
                };

                module.exports = DerivedHelper;

                /***/
            },
            /* 317 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (global, process) {
                    // Copyright Joyent, Inc. and other Node contributors.
                    //
                    // Permission is hereby granted, free of charge, to any person obtaining a
                    // copy of this software and associated documentation files (the
                    // "Software"), to deal in the Software without restriction, including
                    // without limitation the rights to use, copy, modify, merge, publish,
                    // distribute, sublicense, and/or sell copies of the Software, and to permit
                    // persons to whom the Software is furnished to do so, subject to the
                    // following conditions:
                    //
                    // The above copyright notice and this permission notice shall be included
                    // in all copies or substantial portions of the Software.
                    //
                    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                    // USE OR OTHER DEALINGS IN THE SOFTWARE.

                    var formatRegExp = /%[sdj%]/g;
                    exports.format = function (f) {
                        if (!isString(f)) {
                            var objects = [];
                            for (var i = 0; i < arguments.length; i++) {
                                objects.push(inspect(arguments[i]));
                            }
                            return objects.join(" ");
                        }

                        var i = 1;
                        var args = arguments;
                        var len = args.length;
                        var str = String(f).replace(formatRegExp, function (x) {
                            if (x === "%%") return "%";
                            if (i >= len) return x;
                            switch (x) {
                                case "%s":
                                    return String(args[i++]);
                                case "%d":
                                    return Number(args[i++]);
                                case "%j":
                                    try {
                                        return JSON.stringify(args[i++]);
                                    } catch (_) {
                                        return "[Circular]";
                                    }
                                default:
                                    return x;
                            }
                        });
                        for (var x = args[i]; i < len; x = args[++i]) {
                            if (isNull(x) || !isObject(x)) {
                                str += " " + x;
                            } else {
                                str += " " + inspect(x);
                            }
                        }
                        return str;
                    };

                    // Mark that a method should not be used.
                    // Returns a modified function which warns once by default.
                    // If --no-deprecation is set, then it is a no-op.
                    exports.deprecate = function (fn, msg) {
                        // Allow for deprecating things in the process of starting up.
                        if (isUndefined(global.process)) {
                            return function () {
                                return exports
                                    .deprecate(fn, msg)
                                    .apply(this, arguments);
                            };
                        }

                        if (process.noDeprecation === true) {
                            return fn;
                        }

                        var warned = false;
                        function deprecated() {
                            if (!warned) {
                                if (process.throwDeprecation) {
                                    throw new Error(msg);
                                } else if (process.traceDeprecation) {
                                    console.trace(msg);
                                } else {
                                    console.error(msg);
                                }
                                warned = true;
                            }
                            return fn.apply(this, arguments);
                        }

                        return deprecated;
                    };

                    var debugs = {};
                    var debugEnviron;
                    exports.debuglog = function (set) {
                        if (isUndefined(debugEnviron))
                            debugEnviron =
                                { NODE_ENV: "production" }.NODE_DEBUG || "";
                        set = set.toUpperCase();
                        if (!debugs[set]) {
                            if (
                                new RegExp("\\b" + set + "\\b", "i").test(
                                    debugEnviron
                                )
                            ) {
                                var pid = process.pid;
                                debugs[set] = function () {
                                    var msg = exports.format.apply(
                                        exports,
                                        arguments
                                    );
                                    console.error("%s %d: %s", set, pid, msg);
                                };
                            } else {
                                debugs[set] = function () {};
                            }
                        }
                        return debugs[set];
                    };

                    /**
                     * Echos the value of a value. Trys to print the value out
                     * in the best way possible given the different types.
                     *
                     * @param {Object} obj The object to print out.
                     * @param {Object} opts Optional options object that alters the output.
                     */
                    /* legacy: obj, showHidden, depth, colors*/
                    function inspect(obj, opts) {
                        // default options
                        var ctx = {
                            seen: [],
                            stylize: stylizeNoColor,
                        };
                        // legacy...
                        if (arguments.length >= 3) ctx.depth = arguments[2];
                        if (arguments.length >= 4) ctx.colors = arguments[3];
                        if (isBoolean(opts)) {
                            // legacy...
                            ctx.showHidden = opts;
                        } else if (opts) {
                            // got an "options" object
                            exports._extend(ctx, opts);
                        }
                        // set default options
                        if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
                        if (isUndefined(ctx.depth)) ctx.depth = 2;
                        if (isUndefined(ctx.colors)) ctx.colors = false;
                        if (isUndefined(ctx.customInspect))
                            ctx.customInspect = true;
                        if (ctx.colors) ctx.stylize = stylizeWithColor;
                        return formatValue(ctx, obj, ctx.depth);
                    }
                    exports.inspect = inspect;

                    // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
                    inspect.colors = {
                        bold: [1, 22],
                        italic: [3, 23],
                        underline: [4, 24],
                        inverse: [7, 27],
                        white: [37, 39],
                        grey: [90, 39],
                        black: [30, 39],
                        blue: [34, 39],
                        cyan: [36, 39],
                        green: [32, 39],
                        magenta: [35, 39],
                        red: [31, 39],
                        yellow: [33, 39],
                    };

                    // Don't use 'blue' not visible on cmd.exe
                    inspect.styles = {
                        special: "cyan",
                        number: "yellow",
                        boolean: "yellow",
                        undefined: "grey",
                        null: "bold",
                        string: "green",
                        date: "magenta",
                        // "name": intentionally not styling
                        regexp: "red",
                    };

                    function stylizeWithColor(str, styleType) {
                        var style = inspect.styles[styleType];

                        if (style) {
                            return (
                                "\u001b[" +
                                inspect.colors[style][0] +
                                "m" +
                                str +
                                "\u001b[" +
                                inspect.colors[style][1] +
                                "m"
                            );
                        } else {
                            return str;
                        }
                    }

                    function stylizeNoColor(str, styleType) {
                        return str;
                    }

                    function arrayToHash(array) {
                        var hash = {};

                        array.forEach(function (val, idx) {
                            hash[val] = true;
                        });

                        return hash;
                    }

                    function formatValue(ctx, value, recurseTimes) {
                        // Provide a hook for user-specified inspect functions.
                        // Check that value is an object with an inspect function on it
                        if (
                            ctx.customInspect &&
                            value &&
                            isFunction(value.inspect) &&
                            // Filter out the util module, it's inspect function is special
                            value.inspect !== exports.inspect &&
                            // Also filter out any prototype objects using the circular check.
                            !(
                                value.constructor &&
                                value.constructor.prototype === value
                            )
                        ) {
                            var ret = value.inspect(recurseTimes, ctx);
                            if (!isString(ret)) {
                                ret = formatValue(ctx, ret, recurseTimes);
                            }
                            return ret;
                        }

                        // Primitive types cannot have properties
                        var primitive = formatPrimitive(ctx, value);
                        if (primitive) {
                            return primitive;
                        }

                        // Look up the keys of the object.
                        var keys = Object.keys(value);
                        var visibleKeys = arrayToHash(keys);

                        if (ctx.showHidden) {
                            keys = Object.getOwnPropertyNames(value);
                        }

                        // IE doesn't make error fields non-enumerable
                        // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
                        if (
                            isError(value) &&
                            (keys.indexOf("message") >= 0 ||
                                keys.indexOf("description") >= 0)
                        ) {
                            return formatError(value);
                        }

                        // Some type of object without properties can be shortcutted.
                        if (keys.length === 0) {
                            if (isFunction(value)) {
                                var name = value.name ? ": " + value.name : "";
                                return ctx.stylize(
                                    "[Function" + name + "]",
                                    "special"
                                );
                            }
                            if (isRegExp(value)) {
                                return ctx.stylize(
                                    RegExp.prototype.toString.call(value),
                                    "regexp"
                                );
                            }
                            if (isDate(value)) {
                                return ctx.stylize(
                                    Date.prototype.toString.call(value),
                                    "date"
                                );
                            }
                            if (isError(value)) {
                                return formatError(value);
                            }
                        }

                        var base = "",
                            array = false,
                            braces = ["{", "}"];

                        // Make Array say that they are Array
                        if (isArray(value)) {
                            array = true;
                            braces = ["[", "]"];
                        }

                        // Make functions say that they are functions
                        if (isFunction(value)) {
                            var n = value.name ? ": " + value.name : "";
                            base = " [Function" + n + "]";
                        }

                        // Make RegExps say that they are RegExps
                        if (isRegExp(value)) {
                            base = " " + RegExp.prototype.toString.call(value);
                        }

                        // Make dates with properties first say the date
                        if (isDate(value)) {
                            base = " " + Date.prototype.toUTCString.call(value);
                        }

                        // Make error with message first say the error
                        if (isError(value)) {
                            base = " " + formatError(value);
                        }

                        if (
                            keys.length === 0 &&
                            (!array || value.length == 0)
                        ) {
                            return braces[0] + base + braces[1];
                        }

                        if (recurseTimes < 0) {
                            if (isRegExp(value)) {
                                return ctx.stylize(
                                    RegExp.prototype.toString.call(value),
                                    "regexp"
                                );
                            } else {
                                return ctx.stylize("[Object]", "special");
                            }
                        }

                        ctx.seen.push(value);

                        var output;
                        if (array) {
                            output = formatArray(
                                ctx,
                                value,
                                recurseTimes,
                                visibleKeys,
                                keys
                            );
                        } else {
                            output = keys.map(function (key) {
                                return formatProperty(
                                    ctx,
                                    value,
                                    recurseTimes,
                                    visibleKeys,
                                    key,
                                    array
                                );
                            });
                        }

                        ctx.seen.pop();

                        return reduceToSingleString(output, base, braces);
                    }

                    function formatPrimitive(ctx, value) {
                        if (isUndefined(value))
                            return ctx.stylize("undefined", "undefined");
                        if (isString(value)) {
                            var simple =
                                "'" +
                                JSON.stringify(value)
                                    .replace(/^"|"$/g, "")
                                    .replace(/'/g, "\\'")
                                    .replace(/\\"/g, '"') +
                                "'";
                            return ctx.stylize(simple, "string");
                        }
                        if (isNumber(value))
                            return ctx.stylize("" + value, "number");
                        if (isBoolean(value))
                            return ctx.stylize("" + value, "boolean");
                        // For some reason typeof null is "object", so special case here.
                        if (isNull(value)) return ctx.stylize("null", "null");
                    }

                    function formatError(value) {
                        return "[" + Error.prototype.toString.call(value) + "]";
                    }

                    function formatArray(
                        ctx,
                        value,
                        recurseTimes,
                        visibleKeys,
                        keys
                    ) {
                        var output = [];
                        for (var i = 0, l = value.length; i < l; ++i) {
                            if (hasOwnProperty(value, String(i))) {
                                output.push(
                                    formatProperty(
                                        ctx,
                                        value,
                                        recurseTimes,
                                        visibleKeys,
                                        String(i),
                                        true
                                    )
                                );
                            } else {
                                output.push("");
                            }
                        }
                        keys.forEach(function (key) {
                            if (!key.match(/^\d+$/)) {
                                output.push(
                                    formatProperty(
                                        ctx,
                                        value,
                                        recurseTimes,
                                        visibleKeys,
                                        key,
                                        true
                                    )
                                );
                            }
                        });
                        return output;
                    }

                    function formatProperty(
                        ctx,
                        value,
                        recurseTimes,
                        visibleKeys,
                        key,
                        array
                    ) {
                        var name, str, desc;
                        desc = Object.getOwnPropertyDescriptor(value, key) || {
                            value: value[key],
                        };
                        if (desc.get) {
                            if (desc.set) {
                                str = ctx.stylize("[Getter/Setter]", "special");
                            } else {
                                str = ctx.stylize("[Getter]", "special");
                            }
                        } else {
                            if (desc.set) {
                                str = ctx.stylize("[Setter]", "special");
                            }
                        }
                        if (!hasOwnProperty(visibleKeys, key)) {
                            name = "[" + key + "]";
                        }
                        if (!str) {
                            if (ctx.seen.indexOf(desc.value) < 0) {
                                if (isNull(recurseTimes)) {
                                    str = formatValue(ctx, desc.value, null);
                                } else {
                                    str = formatValue(
                                        ctx,
                                        desc.value,
                                        recurseTimes - 1
                                    );
                                }
                                if (str.indexOf("\n") > -1) {
                                    if (array) {
                                        str = str
                                            .split("\n")
                                            .map(function (line) {
                                                return "  " + line;
                                            })
                                            .join("\n")
                                            .substr(2);
                                    } else {
                                        str =
                                            "\n" +
                                            str
                                                .split("\n")
                                                .map(function (line) {
                                                    return "   " + line;
                                                })
                                                .join("\n");
                                    }
                                }
                            } else {
                                str = ctx.stylize("[Circular]", "special");
                            }
                        }
                        if (isUndefined(name)) {
                            if (array && key.match(/^\d+$/)) {
                                return str;
                            }
                            name = JSON.stringify("" + key);
                            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                                name = name.substr(1, name.length - 2);
                                name = ctx.stylize(name, "name");
                            } else {
                                name = name
                                    .replace(/'/g, "\\'")
                                    .replace(/\\"/g, '"')
                                    .replace(/(^"|"$)/g, "'");
                                name = ctx.stylize(name, "string");
                            }
                        }

                        return name + ": " + str;
                    }

                    function reduceToSingleString(output, base, braces) {
                        var numLinesEst = 0;
                        var length = output.reduce(function (prev, cur) {
                            numLinesEst++;
                            if (cur.indexOf("\n") >= 0) numLinesEst++;
                            return (
                                prev +
                                cur.replace(/\u001b\[\d\d?m/g, "").length +
                                1
                            );
                        }, 0);

                        if (length > 60) {
                            return (
                                braces[0] +
                                (base === "" ? "" : base + "\n ") +
                                " " +
                                output.join(",\n  ") +
                                " " +
                                braces[1]
                            );
                        }

                        return (
                            braces[0] +
                            base +
                            " " +
                            output.join(", ") +
                            " " +
                            braces[1]
                        );
                    }

                    // NOTE: These type checking functions intentionally don't use `instanceof`
                    // because it is fragile and can be easily faked with `Object.create()`.
                    function isArray(ar) {
                        return Array.isArray(ar);
                    }
                    exports.isArray = isArray;

                    function isBoolean(arg) {
                        return typeof arg === "boolean";
                    }
                    exports.isBoolean = isBoolean;

                    function isNull(arg) {
                        return arg === null;
                    }
                    exports.isNull = isNull;

                    function isNullOrUndefined(arg) {
                        return arg == null;
                    }
                    exports.isNullOrUndefined = isNullOrUndefined;

                    function isNumber(arg) {
                        return typeof arg === "number";
                    }
                    exports.isNumber = isNumber;

                    function isString(arg) {
                        return typeof arg === "string";
                    }
                    exports.isString = isString;

                    function isSymbol(arg) {
                        return typeof arg === "symbol";
                    }
                    exports.isSymbol = isSymbol;

                    function isUndefined(arg) {
                        return arg === void 0;
                    }
                    exports.isUndefined = isUndefined;

                    function isRegExp(re) {
                        return (
                            isObject(re) &&
                            objectToString(re) === "[object RegExp]"
                        );
                    }
                    exports.isRegExp = isRegExp;

                    function isObject(arg) {
                        return typeof arg === "object" && arg !== null;
                    }
                    exports.isObject = isObject;

                    function isDate(d) {
                        return (
                            isObject(d) && objectToString(d) === "[object Date]"
                        );
                    }
                    exports.isDate = isDate;

                    function isError(e) {
                        return (
                            isObject(e) &&
                            (objectToString(e) === "[object Error]" ||
                                e instanceof Error)
                        );
                    }
                    exports.isError = isError;

                    function isFunction(arg) {
                        return typeof arg === "function";
                    }
                    exports.isFunction = isFunction;

                    function isPrimitive(arg) {
                        return (
                            arg === null ||
                            typeof arg === "boolean" ||
                            typeof arg === "number" ||
                            typeof arg === "string" ||
                            typeof arg === "symbol" || // ES6 symbol
                            typeof arg === "undefined"
                        );
                    }
                    exports.isPrimitive = isPrimitive;

                    exports.isBuffer = __webpack_require__(318);

                    function objectToString(o) {
                        return Object.prototype.toString.call(o);
                    }

                    function pad(n) {
                        return n < 10 ? "0" + n.toString(10) : n.toString(10);
                    }

                    var months = [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                    ];

                    // 26 Feb 16:19:34
                    function timestamp() {
                        var d = new Date();
                        var time = [
                            pad(d.getHours()),
                            pad(d.getMinutes()),
                            pad(d.getSeconds()),
                        ].join(":");
                        return [d.getDate(), months[d.getMonth()], time].join(
                            " "
                        );
                    }

                    // log is just a thin wrapper to console.log that prepends a timestamp
                    exports.log = function () {
                        console.log(
                            "%s - %s",
                            timestamp(),
                            exports.format.apply(exports, arguments)
                        );
                    };

                    /**
                     * Inherit the prototype methods from one constructor into another.
                     *
                     * The Function.prototype.inherits from lang.js rewritten as a standalone
                     * function (not on Function.prototype). NOTE: If this file is to be loaded
                     * during bootstrapping this function needs to be rewritten using some native
                     * functions as prototype setup using normal JavaScript does not work as
                     * expected during bootstrapping (see mirror.js in r114903).
                     *
                     * @param {function} ctor Constructor function which needs to inherit the
                     *     prototype.
                     * @param {function} superCtor Constructor function to inherit prototype from.
                     */
                    exports.inherits = __webpack_require__(319);

                    exports._extend = function (origin, add) {
                        // Don't do anything if add isn't an object
                        if (!add || !isObject(add)) return origin;

                        var keys = Object.keys(add);
                        var i = keys.length;
                        while (i--) {
                            origin[keys[i]] = add[keys[i]];
                        }
                        return origin;
                    };

                    function hasOwnProperty(obj, prop) {
                        return Object.prototype.hasOwnProperty.call(obj, prop);
                    }

                    /* WEBPACK VAR INJECTION */
                }.call(
                    exports,
                    (function () {
                        return this;
                    })(),
                    __webpack_require__(25)
                ));

                /***/
            },
            /* 318 */
            /***/ function (module, exports) {
                module.exports = function isBuffer(arg) {
                    return (
                        arg &&
                        typeof arg === "object" &&
                        typeof arg.copy === "function" &&
                        typeof arg.fill === "function" &&
                        typeof arg.readUInt8 === "function"
                    );
                };

                /***/
            },
            /* 319 */
            /***/ function (module, exports) {
                if (typeof Object.create === "function") {
                    // implementation from standard node.js 'util' module
                    module.exports = function inherits(ctor, superCtor) {
                        ctor.super_ = superCtor;
                        ctor.prototype = Object.create(superCtor.prototype, {
                            constructor: {
                                value: ctor,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        });
                    };
                } else {
                    // old school shim for old browsers
                    module.exports = function inherits(ctor, superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function () {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    };
                }

                /***/
            },
            /* 320 */
            /***/ function (module, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.

                function EventEmitter() {
                    this._events = this._events || {};
                    this._maxListeners = this._maxListeners || undefined;
                }
                module.exports = EventEmitter;

                // Backwards-compat with node 0.10.x
                EventEmitter.EventEmitter = EventEmitter;

                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._maxListeners = undefined;

                // By default EventEmitters will print a warning if more than 10 listeners are
                // added to it. This is a useful default which helps finding memory leaks.
                EventEmitter.defaultMaxListeners = 10;

                // Obviously not all Emitters should be limited to 10. This function allows
                // that to be increased. Set to zero for unlimited.
                EventEmitter.prototype.setMaxListeners = function (n) {
                    if (!isNumber(n) || n < 0 || isNaN(n))
                        throw TypeError("n must be a positive number");
                    this._maxListeners = n;
                    return this;
                };

                EventEmitter.prototype.emit = function (type) {
                    var er, handler, len, args, i, listeners;

                    if (!this._events) this._events = {};

                    // If there is no 'error' event listener then throw.
                    if (type === "error") {
                        if (
                            !this._events.error ||
                            (isObject(this._events.error) &&
                                !this._events.error.length)
                        ) {
                            er = arguments[1];
                            if (er instanceof Error) {
                                throw er; // Unhandled 'error' event
                            } else {
                                // At least give some kind of context to the user
                                var err = new Error(
                                    'Uncaught, unspecified "error" event. (' +
                                        er +
                                        ")"
                                );
                                err.context = er;
                                throw err;
                            }
                        }
                    }

                    handler = this._events[type];

                    if (isUndefined(handler)) return false;

                    if (isFunction(handler)) {
                        switch (arguments.length) {
                            // fast cases
                            case 1:
                                handler.call(this);
                                break;
                            case 2:
                                handler.call(this, arguments[1]);
                                break;
                            case 3:
                                handler.call(this, arguments[1], arguments[2]);
                                break;
                            // slower
                            default:
                                args = Array.prototype.slice.call(arguments, 1);
                                handler.apply(this, args);
                        }
                    } else if (isObject(handler)) {
                        args = Array.prototype.slice.call(arguments, 1);
                        listeners = handler.slice();
                        len = listeners.length;
                        for (i = 0; i < len; i++)
                            listeners[i].apply(this, args);
                    }

                    return true;
                };

                EventEmitter.prototype.addListener = function (type, listener) {
                    var m;

                    if (!isFunction(listener))
                        throw TypeError("listener must be a function");

                    if (!this._events) this._events = {};

                    // To avoid recursion in the case that type === "newListener"! Before
                    // adding it to the listeners, first emit "newListener".
                    if (this._events.newListener)
                        this.emit(
                            "newListener",
                            type,
                            isFunction(listener.listener)
                                ? listener.listener
                                : listener
                        );

                    if (!this._events[type])
                        // Optimize the case of one listener. Don't need the extra array object.
                        this._events[type] = listener;
                    else if (isObject(this._events[type]))
                        // If we've already got an array, just append.
                        this._events[type].push(listener);
                    // Adding the second element, need to change to array.
                    else this._events[type] = [this._events[type], listener];

                    // Check for listener leak
                    if (
                        isObject(this._events[type]) &&
                        !this._events[type].warned
                    ) {
                        if (!isUndefined(this._maxListeners)) {
                            m = this._maxListeners;
                        } else {
                            m = EventEmitter.defaultMaxListeners;
                        }

                        if (m && m > 0 && this._events[type].length > m) {
                            this._events[type].warned = true;
                            console.error(
                                "(node) warning: possible EventEmitter memory " +
                                    "leak detected. %d listeners added. " +
                                    "Use emitter.setMaxListeners() to increase limit.",
                                this._events[type].length
                            );
                            if (typeof console.trace === "function") {
                                // not supported in IE 10
                                console.trace();
                            }
                        }
                    }

                    return this;
                };

                EventEmitter.prototype.on = EventEmitter.prototype.addListener;

                EventEmitter.prototype.once = function (type, listener) {
                    if (!isFunction(listener))
                        throw TypeError("listener must be a function");

                    var fired = false;

                    function g() {
                        this.removeListener(type, g);

                        if (!fired) {
                            fired = true;
                            listener.apply(this, arguments);
                        }
                    }

                    g.listener = listener;
                    this.on(type, g);

                    return this;
                };

                // emits a 'removeListener' event iff the listener was removed
                EventEmitter.prototype.removeListener = function (
                    type,
                    listener
                ) {
                    var list, position, length, i;

                    if (!isFunction(listener))
                        throw TypeError("listener must be a function");

                    if (!this._events || !this._events[type]) return this;

                    list = this._events[type];
                    length = list.length;
                    position = -1;

                    if (
                        list === listener ||
                        (isFunction(list.listener) &&
                            list.listener === listener)
                    ) {
                        delete this._events[type];
                        if (this._events.removeListener)
                            this.emit("removeListener", type, listener);
                    } else if (isObject(list)) {
                        for (i = length; i-- > 0; ) {
                            if (
                                list[i] === listener ||
                                (list[i].listener &&
                                    list[i].listener === listener)
                            ) {
                                position = i;
                                break;
                            }
                        }

                        if (position < 0) return this;

                        if (list.length === 1) {
                            list.length = 0;
                            delete this._events[type];
                        } else {
                            list.splice(position, 1);
                        }

                        if (this._events.removeListener)
                            this.emit("removeListener", type, listener);
                    }

                    return this;
                };

                EventEmitter.prototype.removeAllListeners = function (type) {
                    var key, listeners;

                    if (!this._events) return this;

                    // not listening for removeListener, no need to emit
                    if (!this._events.removeListener) {
                        if (arguments.length === 0) this._events = {};
                        else if (this._events[type]) delete this._events[type];
                        return this;
                    }

                    // emit removeListener for all listeners on all events
                    if (arguments.length === 0) {
                        for (key in this._events) {
                            if (key === "removeListener") continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners("removeListener");
                        this._events = {};
                        return this;
                    }

                    listeners = this._events[type];

                    if (isFunction(listeners)) {
                        this.removeListener(type, listeners);
                    } else if (listeners) {
                        // LIFO order
                        while (listeners.length)
                            this.removeListener(
                                type,
                                listeners[listeners.length - 1]
                            );
                    }
                    delete this._events[type];

                    return this;
                };

                EventEmitter.prototype.listeners = function (type) {
                    var ret;
                    if (!this._events || !this._events[type]) ret = [];
                    else if (isFunction(this._events[type]))
                        ret = [this._events[type]];
                    else ret = this._events[type].slice();
                    return ret;
                };

                EventEmitter.prototype.listenerCount = function (type) {
                    if (this._events) {
                        var evlistener = this._events[type];

                        if (isFunction(evlistener)) return 1;
                        else if (evlistener) return evlistener.length;
                    }
                    return 0;
                };

                EventEmitter.listenerCount = function (emitter, type) {
                    return emitter.listenerCount(type);
                };

                function isFunction(arg) {
                    return typeof arg === "function";
                }

                function isNumber(arg) {
                    return typeof arg === "number";
                }

                function isObject(arg) {
                    return typeof arg === "object" && arg !== null;
                }

                function isUndefined(arg) {
                    return arg === void 0;
                }

                /***/
            },
            /* 321 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var forEach = __webpack_require__(129);
                var map = __webpack_require__(185);
                var reduce = __webpack_require__(187);
                var merge = __webpack_require__(256);
                var isArray = __webpack_require__(53);

                var requestBuilder = {
                    /**
                     * Get all the queries to send to the client, those queries can used directly
                     * with the Algolia client.
                     * @private
                     * @return {object[]} The queries
                     */
                    _getQueries: function getQueries(index, state) {
                        var queries = [];

                        // One query for the hits
                        queries.push({
                            indexName: index,
                            params: requestBuilder._getHitsSearchParams(state),
                        });

                        // One for each disjunctive facets
                        forEach(
                            state.getRefinedDisjunctiveFacets(),
                            function (refinedFacet) {
                                queries.push({
                                    indexName: index,
                                    params: requestBuilder._getDisjunctiveFacetSearchParams(
                                        state,
                                        refinedFacet
                                    ),
                                });
                            }
                        );

                        // maybe more to get the root level of hierarchical facets when activated
                        forEach(
                            state.getRefinedHierarchicalFacets(),
                            function (refinedFacet) {
                                var hierarchicalFacet =
                                    state.getHierarchicalFacetByName(
                                        refinedFacet
                                    );

                                var currentRefinement =
                                    state.getHierarchicalRefinement(
                                        refinedFacet
                                    );
                                // if we are deeper than level 0 (starting from `beer > IPA`)
                                // we want to get the root values
                                var separator =
                                    state._getHierarchicalFacetSeparator(
                                        hierarchicalFacet
                                    );
                                if (
                                    currentRefinement.length > 0 &&
                                    currentRefinement[0].split(separator)
                                        .length > 1
                                ) {
                                    queries.push({
                                        indexName: index,
                                        params: requestBuilder._getDisjunctiveFacetSearchParams(
                                            state,
                                            refinedFacet,
                                            true
                                        ),
                                    });
                                }
                            }
                        );

                        return queries;
                    },

                    /**
                     * Build search parameters used to fetch hits
                     * @private
                     * @return {object.<string, any>}
                     */
                    _getHitsSearchParams: function (state) {
                        var facets = state.facets
                            .concat(state.disjunctiveFacets)
                            .concat(
                                requestBuilder._getHitsHierarchicalFacetsAttributes(
                                    state
                                )
                            );

                        var facetFilters =
                            requestBuilder._getFacetFilters(state);
                        var numericFilters =
                            requestBuilder._getNumericFilters(state);
                        var tagFilters = requestBuilder._getTagFilters(state);
                        var additionalParams = {
                            facets: facets,
                            tagFilters: tagFilters,
                        };

                        if (facetFilters.length > 0) {
                            additionalParams.facetFilters = facetFilters;
                        }

                        if (numericFilters.length > 0) {
                            additionalParams.numericFilters = numericFilters;
                        }

                        return merge(state.getQueryParams(), additionalParams);
                    },

                    /**
                     * Build search parameters used to fetch a disjunctive facet
                     * @private
                     * @param  {string} facet the associated facet name
                     * @param  {boolean} hierarchicalRootLevel ?? FIXME
                     * @return {object}
                     */
                    _getDisjunctiveFacetSearchParams: function (
                        state,
                        facet,
                        hierarchicalRootLevel
                    ) {
                        var facetFilters = requestBuilder._getFacetFilters(
                            state,
                            facet,
                            hierarchicalRootLevel
                        );
                        var numericFilters = requestBuilder._getNumericFilters(
                            state,
                            facet
                        );
                        var tagFilters = requestBuilder._getTagFilters(state);
                        var additionalParams = {
                            hitsPerPage: 1,
                            page: 0,
                            attributesToRetrieve: [],
                            attributesToHighlight: [],
                            attributesToSnippet: [],
                            tagFilters: tagFilters,
                        };

                        var hierarchicalFacet =
                            state.getHierarchicalFacetByName(facet);

                        if (hierarchicalFacet) {
                            additionalParams.facets =
                                requestBuilder._getDisjunctiveHierarchicalFacetAttribute(
                                    state,
                                    hierarchicalFacet,
                                    hierarchicalRootLevel
                                );
                        } else {
                            additionalParams.facets = facet;
                        }

                        if (numericFilters.length > 0) {
                            additionalParams.numericFilters = numericFilters;
                        }

                        if (facetFilters.length > 0) {
                            additionalParams.facetFilters = facetFilters;
                        }

                        return merge(state.getQueryParams(), additionalParams);
                    },

                    /**
                     * Return the numeric filters in an algolia request fashion
                     * @private
                     * @param {string} [facetName] the name of the attribute for which the filters should be excluded
                     * @return {string[]} the numeric filters in the algolia format
                     */
                    _getNumericFilters: function (state, facetName) {
                        if (state.numericFilters) {
                            return state.numericFilters;
                        }

                        var numericFilters = [];

                        forEach(
                            state.numericRefinements,
                            function (operators, attribute) {
                                forEach(operators, function (values, operator) {
                                    if (facetName !== attribute) {
                                        forEach(values, function (value) {
                                            if (isArray(value)) {
                                                var vs = map(
                                                    value,
                                                    function (v) {
                                                        return (
                                                            attribute +
                                                            operator +
                                                            v
                                                        );
                                                    }
                                                );
                                                numericFilters.push(vs);
                                            } else {
                                                numericFilters.push(
                                                    attribute + operator + value
                                                );
                                            }
                                        });
                                    }
                                });
                            }
                        );

                        return numericFilters;
                    },

                    /**
                     * Return the tags filters depending
                     * @private
                     * @return {string}
                     */
                    _getTagFilters: function (state) {
                        if (state.tagFilters) {
                            return state.tagFilters;
                        }

                        return state.tagRefinements.join(",");
                    },

                    /**
                     * Build facetFilters parameter based on current refinements. The array returned
                     * contains strings representing the facet filters in the algolia format.
                     * @private
                     * @param  {string} [facet] if set, the current disjunctive facet
                     * @return {array.<string>}
                     */
                    _getFacetFilters: function (
                        state,
                        facet,
                        hierarchicalRootLevel
                    ) {
                        var facetFilters = [];

                        forEach(
                            state.facetsRefinements,
                            function (facetValues, facetName) {
                                forEach(facetValues, function (facetValue) {
                                    facetFilters.push(
                                        facetName + ":" + facetValue
                                    );
                                });
                            }
                        );

                        forEach(
                            state.facetsExcludes,
                            function (facetValues, facetName) {
                                forEach(facetValues, function (facetValue) {
                                    facetFilters.push(
                                        facetName + ":-" + facetValue
                                    );
                                });
                            }
                        );

                        forEach(
                            state.disjunctiveFacetsRefinements,
                            function (facetValues, facetName) {
                                if (
                                    facetName === facet ||
                                    !facetValues ||
                                    facetValues.length === 0
                                )
                                    return;
                                var orFilters = [];

                                forEach(facetValues, function (facetValue) {
                                    orFilters.push(
                                        facetName + ":" + facetValue
                                    );
                                });

                                facetFilters.push(orFilters);
                            }
                        );

                        forEach(
                            state.hierarchicalFacetsRefinements,
                            function (facetValues, facetName) {
                                var facetValue = facetValues[0];

                                if (facetValue === undefined) {
                                    return;
                                }

                                var hierarchicalFacet =
                                    state.getHierarchicalFacetByName(facetName);
                                var separator =
                                    state._getHierarchicalFacetSeparator(
                                        hierarchicalFacet
                                    );
                                var rootPath =
                                    state._getHierarchicalRootPath(
                                        hierarchicalFacet
                                    );
                                var attributeToRefine;
                                var attributesIndex;

                                // we ask for parent facet values only when the `facet` is the current hierarchical facet
                                if (facet === facetName) {
                                    // if we are at the root level already, no need to ask for facet values, we get them from
                                    // the hits query
                                    if (
                                        facetValue.indexOf(separator) === -1 ||
                                        (!rootPath &&
                                            hierarchicalRootLevel === true) ||
                                        (rootPath &&
                                            rootPath.split(separator).length ===
                                                facetValue.split(separator)
                                                    .length)
                                    ) {
                                        return;
                                    }

                                    if (!rootPath) {
                                        attributesIndex =
                                            facetValue.split(separator).length -
                                            2;
                                        facetValue = facetValue.slice(
                                            0,
                                            facetValue.lastIndexOf(separator)
                                        );
                                    } else {
                                        attributesIndex =
                                            rootPath.split(separator).length -
                                            1;
                                        facetValue = rootPath;
                                    }

                                    attributeToRefine =
                                        hierarchicalFacet.attributes[
                                            attributesIndex
                                        ];
                                } else {
                                    attributesIndex =
                                        facetValue.split(separator).length - 1;

                                    attributeToRefine =
                                        hierarchicalFacet.attributes[
                                            attributesIndex
                                        ];
                                }

                                if (attributeToRefine) {
                                    facetFilters.push([
                                        attributeToRefine + ":" + facetValue,
                                    ]);
                                }
                            }
                        );

                        return facetFilters;
                    },

                    _getHitsHierarchicalFacetsAttributes: function (state) {
                        var out = [];

                        return reduce(
                            state.hierarchicalFacets,
                            // ask for as much levels as there's hierarchical refinements
                            function getHitsAttributesForHierarchicalFacet(
                                allAttributes,
                                hierarchicalFacet
                            ) {
                                var hierarchicalRefinement =
                                    state.getHierarchicalRefinement(
                                        hierarchicalFacet.name
                                    )[0];

                                // if no refinement, ask for root level
                                if (!hierarchicalRefinement) {
                                    allAttributes.push(
                                        hierarchicalFacet.attributes[0]
                                    );
                                    return allAttributes;
                                }

                                var separator =
                                    state._getHierarchicalFacetSeparator(
                                        hierarchicalFacet
                                    );
                                var level =
                                    hierarchicalRefinement.split(
                                        separator
                                    ).length;
                                var newAttributes =
                                    hierarchicalFacet.attributes.slice(
                                        0,
                                        level + 1
                                    );

                                return allAttributes.concat(newAttributes);
                            },
                            out
                        );
                    },

                    _getDisjunctiveHierarchicalFacetAttribute: function (
                        state,
                        hierarchicalFacet,
                        rootLevel
                    ) {
                        var separator =
                            state._getHierarchicalFacetSeparator(
                                hierarchicalFacet
                            );
                        if (rootLevel === true) {
                            var rootPath =
                                state._getHierarchicalRootPath(
                                    hierarchicalFacet
                                );
                            var attributeIndex = 0;

                            if (rootPath) {
                                attributeIndex =
                                    rootPath.split(separator).length;
                            }
                            return [
                                hierarchicalFacet.attributes[attributeIndex],
                            ];
                        }

                        var hierarchicalRefinement =
                            state.getHierarchicalRefinement(
                                hierarchicalFacet.name
                            )[0] || "";
                        // if refinement is 'beers > IPA > Flying dog',
                        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)

                        var parentLevel =
                            hierarchicalRefinement.split(separator).length - 1;
                        return hierarchicalFacet.attributes.slice(
                            0,
                            parentLevel + 1
                        );
                    },

                    getSearchForFacetQuery: function (facetName, query, state) {
                        var stateForSearchForFacetValues =
                            state.isDisjunctiveFacet(facetName)
                                ? state.clearRefinements(facetName)
                                : state;
                        var queries = merge(
                            requestBuilder._getHitsSearchParams(
                                stateForSearchForFacetValues
                            ),
                            {
                                facetQuery: query,
                                facetName: facetName,
                            }
                        );
                        return queries;
                    },
                };

                module.exports = requestBuilder;

                /***/
            },
            /* 322 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Module containing the functions to serialize and deserialize
                 * {SearchParameters} in the query string format
                 * @module algoliasearchHelper.url
                 */

                var shortener = __webpack_require__(323);
                var SearchParameters = __webpack_require__(40);

                var qs = __webpack_require__(327);

                var bind = __webpack_require__(332);
                var forEach = __webpack_require__(129);
                var pick = __webpack_require__(333);
                var map = __webpack_require__(185);
                var mapKeys = __webpack_require__(335);
                var mapValues = __webpack_require__(336);
                var isString = __webpack_require__(239);
                var isPlainObject = __webpack_require__(225);
                var isArray = __webpack_require__(53);
                var invert = __webpack_require__(324);

                var encode = __webpack_require__(329).encode;

                function recursiveEncode(input) {
                    if (isPlainObject(input)) {
                        return mapValues(input, recursiveEncode);
                    }
                    if (isArray(input)) {
                        return map(input, recursiveEncode);
                    }
                    if (isString(input)) {
                        return encode(input);
                    }
                    return input;
                }

                var refinementsParameters = ["dFR", "fR", "nR", "hFR", "tR"];
                var stateKeys = shortener.ENCODED_PARAMETERS;
                function sortQueryStringValues(
                    prefixRegexp,
                    invertedMapping,
                    a,
                    b
                ) {
                    if (prefixRegexp !== null) {
                        a = a.replace(prefixRegexp, "");
                        b = b.replace(prefixRegexp, "");
                    }

                    a = invertedMapping[a] || a;
                    b = invertedMapping[b] || b;

                    if (
                        stateKeys.indexOf(a) !== -1 ||
                        stateKeys.indexOf(b) !== -1
                    ) {
                        if (a === "q") return -1;
                        if (b === "q") return 1;

                        var isARefinements =
                            refinementsParameters.indexOf(a) !== -1;
                        var isBRefinements =
                            refinementsParameters.indexOf(b) !== -1;
                        if (isARefinements && !isBRefinements) {
                            return 1;
                        } else if (isBRefinements && !isARefinements) {
                            return -1;
                        }
                    }

                    return a.localeCompare(b);
                }

                /**
                 * Read a query string and return an object containing the state
                 * @param {string} queryString the query string that will be decoded
                 * @param {object} [options] accepted options :
                 *   - prefix : the prefix used for the saved attributes, you have to provide the
                 *     same that was used for serialization
                 *   - mapping : map short attributes to another value e.g. {q: 'query'}
                 * @return {object} partial search parameters object (same properties than in the
                 * SearchParameters but not exhaustive)
                 */
                exports.getStateFromQueryString = function (
                    queryString,
                    options
                ) {
                    var prefixForParameters = (options && options.prefix) || "";
                    var mapping = (options && options.mapping) || {};
                    var invertedMapping = invert(mapping);

                    var partialStateWithPrefix = qs.parse(queryString);
                    var prefixRegexp = new RegExp("^" + prefixForParameters);
                    var partialState = mapKeys(
                        partialStateWithPrefix,
                        function (v, k) {
                            var hasPrefix =
                                prefixForParameters && prefixRegexp.test(k);
                            var unprefixedKey = hasPrefix
                                ? k.replace(prefixRegexp, "")
                                : k;
                            var decodedKey = shortener.decode(
                                invertedMapping[unprefixedKey] || unprefixedKey
                            );
                            return decodedKey || unprefixedKey;
                        }
                    );

                    var partialStateWithParsedNumbers =
                        SearchParameters._parseNumbers(partialState);

                    return pick(
                        partialStateWithParsedNumbers,
                        SearchParameters.PARAMETERS
                    );
                };

                /**
                 * Retrieve an object of all the properties that are not understandable as helper
                 * parameters.
                 * @param {string} queryString the query string to read
                 * @param {object} [options] the options
                 *   - prefixForParameters : prefix used for the helper configuration keys
                 *   - mapping : map short attributes to another value e.g. {q: 'query'}
                 * @return {object} the object containing the parsed configuration that doesn't
                 * to the helper
                 */
                exports.getUnrecognizedParametersInQueryString = function (
                    queryString,
                    options
                ) {
                    var prefixForParameters = options && options.prefix;
                    var mapping = (options && options.mapping) || {};
                    var invertedMapping = invert(mapping);

                    var foreignConfig = {};
                    var config = qs.parse(queryString);
                    if (prefixForParameters) {
                        var prefixRegexp = new RegExp(
                            "^" + prefixForParameters
                        );
                        forEach(config, function (v, key) {
                            if (!prefixRegexp.test(key)) foreignConfig[key] = v;
                        });
                    } else {
                        forEach(config, function (v, key) {
                            if (!shortener.decode(invertedMapping[key] || key))
                                foreignConfig[key] = v;
                        });
                    }

                    return foreignConfig;
                };

                /**
                 * Generate a query string for the state passed according to the options
                 * @param {SearchParameters} state state to serialize
                 * @param {object} [options] May contain the following parameters :
                 *  - prefix : prefix in front of the keys
                 *  - mapping : map short attributes to another value e.g. {q: 'query'}
                 *  - moreAttributes : more values to be added in the query string. Those values
                 *    won't be prefixed.
                 *  - safe : get safe urls for use in emails, chat apps or any application auto linking urls.
                 *  All parameters and values will be encoded in a way that it's safe to share them.
                 *  Default to false for legacy reasons ()
                 * @return {string} the query string
                 */
                exports.getQueryStringFromState = function (state, options) {
                    var moreAttributes = options && options.moreAttributes;
                    var prefixForParameters = (options && options.prefix) || "";
                    var mapping = (options && options.mapping) || {};
                    var safe = (options && options.safe) || false;
                    var invertedMapping = invert(mapping);

                    var stateForUrl = safe ? state : recursiveEncode(state);

                    var encodedState = mapKeys(stateForUrl, function (v, k) {
                        var shortK = shortener.encode(k);
                        return (
                            prefixForParameters + (mapping[shortK] || shortK)
                        );
                    });

                    var prefixRegexp =
                        prefixForParameters === ""
                            ? null
                            : new RegExp("^" + prefixForParameters);
                    var sort = bind(
                        sortQueryStringValues,
                        null,
                        prefixRegexp,
                        invertedMapping
                    );
                    if (moreAttributes) {
                        var stateQs = qs.stringify(encodedState, {
                            encode: safe,
                            sort: sort,
                        });
                        var moreQs = qs.stringify(moreAttributes, {
                            encode: safe,
                        });
                        if (!stateQs) return moreQs;
                        return stateQs + "&" + moreQs;
                    }

                    return qs.stringify(encodedState, {
                        encode: safe,
                        sort: sort,
                    });
                };

                /***/
            },
            /* 323 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var invert = __webpack_require__(324);
                var keys = __webpack_require__(41);

                var keys2Short = {
                    advancedSyntax: "aS",
                    allowTyposOnNumericTokens: "aTONT",
                    analyticsTags: "aT",
                    analytics: "a",
                    aroundLatLngViaIP: "aLLVIP",
                    aroundLatLng: "aLL",
                    aroundPrecision: "aP",
                    aroundRadius: "aR",
                    attributesToHighlight: "aTH",
                    attributesToRetrieve: "aTR",
                    attributesToSnippet: "aTS",
                    disjunctiveFacetsRefinements: "dFR",
                    disjunctiveFacets: "dF",
                    distinct: "d",
                    facetsExcludes: "fE",
                    facetsRefinements: "fR",
                    facets: "f",
                    getRankingInfo: "gRI",
                    hierarchicalFacetsRefinements: "hFR",
                    hierarchicalFacets: "hF",
                    highlightPostTag: "hPoT",
                    highlightPreTag: "hPrT",
                    hitsPerPage: "hPP",
                    ignorePlurals: "iP",
                    index: "idx",
                    insideBoundingBox: "iBB",
                    insidePolygon: "iPg",
                    length: "l",
                    maxValuesPerFacet: "mVPF",
                    minimumAroundRadius: "mAR",
                    minProximity: "mP",
                    minWordSizefor1Typo: "mWS1T",
                    minWordSizefor2Typos: "mWS2T",
                    numericFilters: "nF",
                    numericRefinements: "nR",
                    offset: "o",
                    optionalWords: "oW",
                    page: "p",
                    queryType: "qT",
                    query: "q",
                    removeWordsIfNoResults: "rWINR",
                    replaceSynonymsInHighlight: "rSIH",
                    restrictSearchableAttributes: "rSA",
                    synonyms: "s",
                    tagFilters: "tF",
                    tagRefinements: "tR",
                    typoTolerance: "tT",
                    optionalTagFilters: "oTF",
                    optionalFacetFilters: "oFF",
                    snippetEllipsisText: "sET",
                    disableExactOnAttributes: "dEOA",
                    enableExactOnSingleWordQuery: "eEOSWQ",
                };

                var short2Keys = invert(keys2Short);

                module.exports = {
                    /**
                     * All the keys of the state, encoded.
                     * @const
                     */
                    ENCODED_PARAMETERS: keys(short2Keys),
                    /**
                     * Decode a shorten attribute
                     * @param {string} shortKey the shorten attribute
                     * @return {string} the decoded attribute, undefined otherwise
                     */
                    decode: function (shortKey) {
                        return short2Keys[shortKey];
                    },
                    /**
                     * Encode an attribute into a short version
                     * @param {string} key the attribute
                     * @return {string} the shorten attribute
                     */
                    encode: function (key) {
                        return keys2Short[key];
                    },
                };

                /***/
            },
            /* 324 */
            /***/ function (module, exports, __webpack_require__) {
                var constant = __webpack_require__(119),
                    createInverter = __webpack_require__(325),
                    identity = __webpack_require__(114);

                /**
                 * Creates an object composed of the inverted keys and values of `object`.
                 * If `object` contains duplicate values, subsequent values overwrite
                 * property assignments of previous values.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.7.0
                 * @category Object
                 * @param {Object} object The object to invert.
                 * @returns {Object} Returns the new inverted object.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': 2, 'c': 1 };
                 *
                 * _.invert(object);
                 * // => { '1': 'c', '2': 'b' }
                 */
                var invert = createInverter(function (result, value, key) {
                    result[value] = key;
                }, constant(identity));

                module.exports = invert;

                /***/
            },
            /* 325 */
            /***/ function (module, exports, __webpack_require__) {
                var baseInverter = __webpack_require__(326);

                /**
                 * Creates a function like `_.invertBy`.
                 *
                 * @private
                 * @param {Function} setter The function to set accumulator values.
                 * @param {Function} toIteratee The function to resolve iteratees.
                 * @returns {Function} Returns the new inverter function.
                 */
                function createInverter(setter, toIteratee) {
                    return function (object, iteratee) {
                        return baseInverter(
                            object,
                            setter,
                            toIteratee(iteratee),
                            {}
                        );
                    };
                }

                module.exports = createInverter;

                /***/
            },
            /* 326 */
            /***/ function (module, exports, __webpack_require__) {
                var baseForOwn = __webpack_require__(125);

                /**
                 * The base implementation of `_.invert` and `_.invertBy` which inverts
                 * `object` with values transformed by `iteratee` and set by `setter`.
                 *
                 * @private
                 * @param {Object} object The object to iterate over.
                 * @param {Function} setter The function to set `accumulator` values.
                 * @param {Function} iteratee The iteratee to transform values.
                 * @param {Object} accumulator The initial inverted object.
                 * @returns {Function} Returns `accumulator`.
                 */
                function baseInverter(object, setter, iteratee, accumulator) {
                    baseForOwn(object, function (value, key, object) {
                        setter(accumulator, iteratee(value), key, object);
                    });
                    return accumulator;
                }

                module.exports = baseInverter;

                /***/
            },
            /* 327 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var stringify = __webpack_require__(328);
                var parse = __webpack_require__(331);
                var formats = __webpack_require__(330);

                module.exports = {
                    formats: formats,
                    parse: parse,
                    stringify: stringify,
                };

                /***/
            },
            /* 328 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var utils = __webpack_require__(329);
                var formats = __webpack_require__(330);

                var arrayPrefixGenerators = {
                    brackets: function brackets(prefix) {
                        return prefix + "[]";
                    },
                    indices: function indices(prefix, key) {
                        return prefix + "[" + key + "]";
                    },
                    repeat: function repeat(prefix) {
                        return prefix;
                    },
                };

                var toISO = Date.prototype.toISOString;

                var defaults = {
                    delimiter: "&",
                    encode: true,
                    encoder: utils.encode,
                    serializeDate: function serializeDate(date) {
                        return toISO.call(date);
                    },
                    skipNulls: false,
                    strictNullHandling: false,
                };

                var stringify = function stringify(
                    object,
                    prefix,
                    generateArrayPrefix,
                    strictNullHandling,
                    skipNulls,
                    encoder,
                    filter,
                    sort,
                    allowDots,
                    serializeDate,
                    formatter
                ) {
                    var obj = object;
                    if (typeof filter === "function") {
                        obj = filter(prefix, obj);
                    } else if (obj instanceof Date) {
                        obj = serializeDate(obj);
                    } else if (obj === null) {
                        if (strictNullHandling) {
                            return encoder ? encoder(prefix) : prefix;
                        }

                        obj = "";
                    }

                    if (
                        typeof obj === "string" ||
                        typeof obj === "number" ||
                        typeof obj === "boolean" ||
                        utils.isBuffer(obj)
                    ) {
                        if (encoder) {
                            return [
                                formatter(encoder(prefix)) +
                                    "=" +
                                    formatter(encoder(obj)),
                            ];
                        }
                        return [
                            formatter(prefix) + "=" + formatter(String(obj)),
                        ];
                    }

                    var values = [];

                    if (typeof obj === "undefined") {
                        return values;
                    }

                    var objKeys;
                    if (Array.isArray(filter)) {
                        objKeys = filter;
                    } else {
                        var keys = Object.keys(obj);
                        objKeys = sort ? keys.sort(sort) : keys;
                    }

                    for (var i = 0; i < objKeys.length; ++i) {
                        var key = objKeys[i];

                        if (skipNulls && obj[key] === null) {
                            continue;
                        }

                        if (Array.isArray(obj)) {
                            values = values.concat(
                                stringify(
                                    obj[key],
                                    generateArrayPrefix(prefix, key),
                                    generateArrayPrefix,
                                    strictNullHandling,
                                    skipNulls,
                                    encoder,
                                    filter,
                                    sort,
                                    allowDots,
                                    serializeDate,
                                    formatter
                                )
                            );
                        } else {
                            values = values.concat(
                                stringify(
                                    obj[key],
                                    prefix +
                                        (allowDots
                                            ? "." + key
                                            : "[" + key + "]"),
                                    generateArrayPrefix,
                                    strictNullHandling,
                                    skipNulls,
                                    encoder,
                                    filter,
                                    sort,
                                    allowDots,
                                    serializeDate,
                                    formatter
                                )
                            );
                        }
                    }

                    return values;
                };

                module.exports = function (object, opts) {
                    var obj = object;
                    var options = opts || {};
                    var delimiter =
                        typeof options.delimiter === "undefined"
                            ? defaults.delimiter
                            : options.delimiter;
                    var strictNullHandling =
                        typeof options.strictNullHandling === "boolean"
                            ? options.strictNullHandling
                            : defaults.strictNullHandling;
                    var skipNulls =
                        typeof options.skipNulls === "boolean"
                            ? options.skipNulls
                            : defaults.skipNulls;
                    var encode =
                        typeof options.encode === "boolean"
                            ? options.encode
                            : defaults.encode;
                    var encoder = encode
                        ? typeof options.encoder === "function"
                            ? options.encoder
                            : defaults.encoder
                        : null;
                    var sort =
                        typeof options.sort === "function"
                            ? options.sort
                            : null;
                    var allowDots =
                        typeof options.allowDots === "undefined"
                            ? false
                            : options.allowDots;
                    var serializeDate =
                        typeof options.serializeDate === "function"
                            ? options.serializeDate
                            : defaults.serializeDate;
                    if (typeof options.format === "undefined") {
                        options.format = formats.default;
                    } else if (
                        !Object.prototype.hasOwnProperty.call(
                            formats.formatters,
                            options.format
                        )
                    ) {
                        throw new TypeError("Unknown format option provided.");
                    }
                    var formatter = formats.formatters[options.format];
                    var objKeys;
                    var filter;

                    if (
                        options.encoder !== null &&
                        options.encoder !== undefined &&
                        typeof options.encoder !== "function"
                    ) {
                        throw new TypeError("Encoder has to be a function.");
                    }

                    if (typeof options.filter === "function") {
                        filter = options.filter;
                        obj = filter("", obj);
                    } else if (Array.isArray(options.filter)) {
                        filter = options.filter;
                        objKeys = filter;
                    }

                    var keys = [];

                    if (typeof obj !== "object" || obj === null) {
                        return "";
                    }

                    var arrayFormat;
                    if (options.arrayFormat in arrayPrefixGenerators) {
                        arrayFormat = options.arrayFormat;
                    } else if ("indices" in options) {
                        arrayFormat = options.indices ? "indices" : "repeat";
                    } else {
                        arrayFormat = "indices";
                    }

                    var generateArrayPrefix =
                        arrayPrefixGenerators[arrayFormat];

                    if (!objKeys) {
                        objKeys = Object.keys(obj);
                    }

                    if (sort) {
                        objKeys.sort(sort);
                    }

                    for (var i = 0; i < objKeys.length; ++i) {
                        var key = objKeys[i];

                        if (skipNulls && obj[key] === null) {
                            continue;
                        }

                        keys = keys.concat(
                            stringify(
                                obj[key],
                                key,
                                generateArrayPrefix,
                                strictNullHandling,
                                skipNulls,
                                encoder,
                                filter,
                                sort,
                                allowDots,
                                serializeDate,
                                formatter
                            )
                        );
                    }

                    return keys.join(delimiter);
                };

                /***/
            },
            /* 329 */
            /***/ function (module, exports) {
                "use strict";

                var has = Object.prototype.hasOwnProperty;

                var hexTable = (function () {
                    var array = [];
                    for (var i = 0; i < 256; ++i) {
                        array.push(
                            "%" +
                                (
                                    (i < 16 ? "0" : "") + i.toString(16)
                                ).toUpperCase()
                        );
                    }

                    return array;
                })();

                exports.arrayToObject = function (source, options) {
                    var obj =
                        options && options.plainObjects
                            ? Object.create(null)
                            : {};
                    for (var i = 0; i < source.length; ++i) {
                        if (typeof source[i] !== "undefined") {
                            obj[i] = source[i];
                        }
                    }

                    return obj;
                };

                exports.merge = function (target, source, options) {
                    if (!source) {
                        return target;
                    }

                    if (typeof source !== "object") {
                        if (Array.isArray(target)) {
                            target.push(source);
                        } else if (typeof target === "object") {
                            target[source] = true;
                        } else {
                            return [target, source];
                        }

                        return target;
                    }

                    if (typeof target !== "object") {
                        return [target].concat(source);
                    }

                    var mergeTarget = target;
                    if (Array.isArray(target) && !Array.isArray(source)) {
                        mergeTarget = exports.arrayToObject(target, options);
                    }

                    if (Array.isArray(target) && Array.isArray(source)) {
                        source.forEach(function (item, i) {
                            if (has.call(target, i)) {
                                if (
                                    target[i] &&
                                    typeof target[i] === "object"
                                ) {
                                    target[i] = exports.merge(
                                        target[i],
                                        item,
                                        options
                                    );
                                } else {
                                    target.push(item);
                                }
                            } else {
                                target[i] = item;
                            }
                        });
                        return target;
                    }

                    return Object.keys(source).reduce(function (acc, key) {
                        var value = source[key];

                        if (Object.prototype.hasOwnProperty.call(acc, key)) {
                            acc[key] = exports.merge(acc[key], value, options);
                        } else {
                            acc[key] = value;
                        }
                        return acc;
                    }, mergeTarget);
                };

                exports.decode = function (str) {
                    try {
                        return decodeURIComponent(str.replace(/\+/g, " "));
                    } catch (e) {
                        return str;
                    }
                };

                exports.encode = function (str) {
                    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
                    // It has been adapted here for stricter adherence to RFC 3986
                    if (str.length === 0) {
                        return str;
                    }

                    var string = typeof str === "string" ? str : String(str);

                    var out = "";
                    for (var i = 0; i < string.length; ++i) {
                        var c = string.charCodeAt(i);

                        if (
                            c === 0x2d || // -
                            c === 0x2e || // .
                            c === 0x5f || // _
                            c === 0x7e || // ~
                            (c >= 0x30 && c <= 0x39) || // 0-9
                            (c >= 0x41 && c <= 0x5a) || // a-z
                            (c >= 0x61 && c <= 0x7a) // A-Z
                        ) {
                            out += string.charAt(i);
                            continue;
                        }

                        if (c < 0x80) {
                            out = out + hexTable[c];
                            continue;
                        }

                        if (c < 0x800) {
                            out =
                                out +
                                (hexTable[0xc0 | (c >> 6)] +
                                    hexTable[0x80 | (c & 0x3f)]);
                            continue;
                        }

                        if (c < 0xd800 || c >= 0xe000) {
                            out =
                                out +
                                (hexTable[0xe0 | (c >> 12)] +
                                    hexTable[0x80 | ((c >> 6) & 0x3f)] +
                                    hexTable[0x80 | (c & 0x3f)]);
                            continue;
                        }

                        i += 1;
                        c =
                            0x10000 +
                            (((c & 0x3ff) << 10) |
                                (string.charCodeAt(i) & 0x3ff));
                        out +=
                            hexTable[0xf0 | (c >> 18)] +
                            hexTable[0x80 | ((c >> 12) & 0x3f)] +
                            hexTable[0x80 | ((c >> 6) & 0x3f)] +
                            hexTable[0x80 | (c & 0x3f)];
                    }

                    return out;
                };

                exports.compact = function (obj, references) {
                    if (typeof obj !== "object" || obj === null) {
                        return obj;
                    }

                    var refs = references || [];
                    var lookup = refs.indexOf(obj);
                    if (lookup !== -1) {
                        return refs[lookup];
                    }

                    refs.push(obj);

                    if (Array.isArray(obj)) {
                        var compacted = [];

                        for (var i = 0; i < obj.length; ++i) {
                            if (obj[i] && typeof obj[i] === "object") {
                                compacted.push(exports.compact(obj[i], refs));
                            } else if (typeof obj[i] !== "undefined") {
                                compacted.push(obj[i]);
                            }
                        }

                        return compacted;
                    }

                    var keys = Object.keys(obj);
                    keys.forEach(function (key) {
                        obj[key] = exports.compact(obj[key], refs);
                    });

                    return obj;
                };

                exports.isRegExp = function (obj) {
                    return (
                        Object.prototype.toString.call(obj) ===
                        "[object RegExp]"
                    );
                };

                exports.isBuffer = function (obj) {
                    if (obj === null || typeof obj === "undefined") {
                        return false;
                    }

                    return !!(
                        obj.constructor &&
                        obj.constructor.isBuffer &&
                        obj.constructor.isBuffer(obj)
                    );
                };

                /***/
            },
            /* 330 */
            /***/ function (module, exports) {
                "use strict";

                var replace = String.prototype.replace;
                var percentTwenties = /%20/g;

                module.exports = {
                    default: "RFC3986",
                    formatters: {
                        RFC1738: function (value) {
                            return replace.call(value, percentTwenties, "+");
                        },
                        RFC3986: function (value) {
                            return value;
                        },
                    },
                    RFC1738: "RFC1738",
                    RFC3986: "RFC3986",
                };

                /***/
            },
            /* 331 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var utils = __webpack_require__(329);

                var has = Object.prototype.hasOwnProperty;

                var defaults = {
                    allowDots: false,
                    allowPrototypes: false,
                    arrayLimit: 20,
                    decoder: utils.decode,
                    delimiter: "&",
                    depth: 5,
                    parameterLimit: 1000,
                    plainObjects: false,
                    strictNullHandling: false,
                };

                var parseValues = function parseValues(str, options) {
                    var obj = {};
                    var parts = str.split(
                        options.delimiter,
                        options.parameterLimit === Infinity
                            ? undefined
                            : options.parameterLimit
                    );

                    for (var i = 0; i < parts.length; ++i) {
                        var part = parts[i];
                        var pos =
                            part.indexOf("]=") === -1
                                ? part.indexOf("=")
                                : part.indexOf("]=") + 1;

                        var key, val;
                        if (pos === -1) {
                            key = options.decoder(part);
                            val = options.strictNullHandling ? null : "";
                        } else {
                            key = options.decoder(part.slice(0, pos));
                            val = options.decoder(part.slice(pos + 1));
                        }
                        if (has.call(obj, key)) {
                            obj[key] = [].concat(obj[key]).concat(val);
                        } else {
                            obj[key] = val;
                        }
                    }

                    return obj;
                };

                var parseObject = function parseObject(chain, val, options) {
                    if (!chain.length) {
                        return val;
                    }

                    var root = chain.shift();

                    var obj;
                    if (root === "[]") {
                        obj = [];
                        obj = obj.concat(parseObject(chain, val, options));
                    } else {
                        obj = options.plainObjects ? Object.create(null) : {};
                        var cleanRoot =
                            root[0] === "[" && root[root.length - 1] === "]"
                                ? root.slice(1, root.length - 1)
                                : root;
                        var index = parseInt(cleanRoot, 10);
                        if (
                            !isNaN(index) &&
                            root !== cleanRoot &&
                            String(index) === cleanRoot &&
                            index >= 0 &&
                            options.parseArrays &&
                            index <= options.arrayLimit
                        ) {
                            obj = [];
                            obj[index] = parseObject(chain, val, options);
                        } else {
                            obj[cleanRoot] = parseObject(chain, val, options);
                        }
                    }

                    return obj;
                };

                var parseKeys = function parseKeys(givenKey, val, options) {
                    if (!givenKey) {
                        return;
                    }

                    // Transform dot notation to bracket notation
                    var key = options.allowDots
                        ? givenKey.replace(/\.([^\.\[]+)/g, "[$1]")
                        : givenKey;

                    // The regex chunks

                    var parent = /^([^\[\]]*)/;
                    var child = /(\[[^\[\]]*\])/g;

                    // Get the parent

                    var segment = parent.exec(key);

                    // Stash the parent if it exists

                    var keys = [];
                    if (segment[1]) {
                        // If we aren't using plain objects, optionally prefix keys
                        // that would overwrite object prototype properties
                        if (
                            !options.plainObjects &&
                            has.call(Object.prototype, segment[1])
                        ) {
                            if (!options.allowPrototypes) {
                                return;
                            }
                        }

                        keys.push(segment[1]);
                    }

                    // Loop through children appending to the array until we hit depth

                    var i = 0;
                    while (
                        (segment = child.exec(key)) !== null &&
                        i < options.depth
                    ) {
                        i += 1;
                        if (
                            !options.plainObjects &&
                            has.call(
                                Object.prototype,
                                segment[1].replace(/\[|\]/g, "")
                            )
                        ) {
                            if (!options.allowPrototypes) {
                                continue;
                            }
                        }
                        keys.push(segment[1]);
                    }

                    // If there's a remainder, just add whatever is left

                    if (segment) {
                        keys.push("[" + key.slice(segment.index) + "]");
                    }

                    return parseObject(keys, val, options);
                };

                module.exports = function (str, opts) {
                    var options = opts || {};

                    if (
                        options.decoder !== null &&
                        options.decoder !== undefined &&
                        typeof options.decoder !== "function"
                    ) {
                        throw new TypeError("Decoder has to be a function.");
                    }

                    options.delimiter =
                        typeof options.delimiter === "string" ||
                        utils.isRegExp(options.delimiter)
                            ? options.delimiter
                            : defaults.delimiter;
                    options.depth =
                        typeof options.depth === "number"
                            ? options.depth
                            : defaults.depth;
                    options.arrayLimit =
                        typeof options.arrayLimit === "number"
                            ? options.arrayLimit
                            : defaults.arrayLimit;
                    options.parseArrays = options.parseArrays !== false;
                    options.decoder =
                        typeof options.decoder === "function"
                            ? options.decoder
                            : defaults.decoder;
                    options.allowDots =
                        typeof options.allowDots === "boolean"
                            ? options.allowDots
                            : defaults.allowDots;
                    options.plainObjects =
                        typeof options.plainObjects === "boolean"
                            ? options.plainObjects
                            : defaults.plainObjects;
                    options.allowPrototypes =
                        typeof options.allowPrototypes === "boolean"
                            ? options.allowPrototypes
                            : defaults.allowPrototypes;
                    options.parameterLimit =
                        typeof options.parameterLimit === "number"
                            ? options.parameterLimit
                            : defaults.parameterLimit;
                    options.strictNullHandling =
                        typeof options.strictNullHandling === "boolean"
                            ? options.strictNullHandling
                            : defaults.strictNullHandling;

                    if (
                        str === "" ||
                        str === null ||
                        typeof str === "undefined"
                    ) {
                        return options.plainObjects ? Object.create(null) : {};
                    }

                    var tempObj =
                        typeof str === "string"
                            ? parseValues(str, options)
                            : str;
                    var obj = options.plainObjects ? Object.create(null) : {};

                    // Iterate over the keys and setup the new object

                    var keys = Object.keys(tempObj);
                    for (var i = 0; i < keys.length; ++i) {
                        var key = keys[i];
                        var newObj = parseKeys(key, tempObj[key], options);
                        obj = utils.merge(obj, newObj, options);
                    }

                    return utils.compact(obj);
                };

                /***/
            },
            /* 332 */
            /***/ function (module, exports, __webpack_require__) {
                var baseRest = __webpack_require__(113),
                    createWrap = __webpack_require__(277),
                    getHolder = __webpack_require__(303),
                    replaceHolders = __webpack_require__(305);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_BIND_FLAG = 1,
                    WRAP_PARTIAL_FLAG = 32;

                /**
                 * Creates a function that invokes `func` with the `this` binding of `thisArg`
                 * and `partials` prepended to the arguments it receives.
                 *
                 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
                 * may be used as a placeholder for partially applied arguments.
                 *
                 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
                 * property of bound functions.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Function
                 * @param {Function} func The function to bind.
                 * @param {*} thisArg The `this` binding of `func`.
                 * @param {...*} [partials] The arguments to be partially applied.
                 * @returns {Function} Returns the new bound function.
                 * @example
                 *
                 * function greet(greeting, punctuation) {
                 *   return greeting + ' ' + this.user + punctuation;
                 * }
                 *
                 * var object = { 'user': 'fred' };
                 *
                 * var bound = _.bind(greet, object, 'hi');
                 * bound('!');
                 * // => 'hi fred!'
                 *
                 * // Bound with placeholders.
                 * var bound = _.bind(greet, object, _, '!');
                 * bound('hi');
                 * // => 'hi fred!'
                 */
                var bind = baseRest(function (func, thisArg, partials) {
                    var bitmask = WRAP_BIND_FLAG;
                    if (partials.length) {
                        var holders = replaceHolders(partials, getHolder(bind));
                        bitmask |= WRAP_PARTIAL_FLAG;
                    }
                    return createWrap(
                        func,
                        bitmask,
                        thisArg,
                        partials,
                        holders
                    );
                });

                // Assign default placeholders.
                bind.placeholder = {};

                module.exports = bind;

                /***/
            },
            /* 333 */
            /***/ function (module, exports, __webpack_require__) {
                var basePick = __webpack_require__(334),
                    flatRest = __webpack_require__(226);

                /**
                 * Creates an object composed of the picked `object` properties.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The source object.
                 * @param {...(string|string[])} [paths] The property paths to pick.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': '2', 'c': 3 };
                 *
                 * _.pick(object, ['a', 'c']);
                 * // => { 'a': 1, 'c': 3 }
                 */
                var pick = flatRest(function (object, paths) {
                    return object == null ? {} : basePick(object, paths);
                });

                module.exports = pick;

                /***/
            },
            /* 334 */
            /***/ function (module, exports, __webpack_require__) {
                var basePickBy = __webpack_require__(314),
                    hasIn = __webpack_require__(179);

                /**
                 * The base implementation of `_.pick` without support for individual
                 * property identifiers.
                 *
                 * @private
                 * @param {Object} object The source object.
                 * @param {string[]} paths The property paths to pick.
                 * @returns {Object} Returns the new object.
                 */
                function basePick(object, paths) {
                    return basePickBy(object, paths, function (value, path) {
                        return hasIn(object, path);
                    });
                }

                module.exports = basePick;

                /***/
            },
            /* 335 */
            /***/ function (module, exports, __webpack_require__) {
                var baseAssignValue = __webpack_require__(193),
                    baseForOwn = __webpack_require__(125),
                    baseIteratee = __webpack_require__(136);

                /**
                 * The opposite of `_.mapValues`; this method creates an object with the
                 * same values as `object` and keys generated by running each own enumerable
                 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
                 * with three arguments: (value, key, object).
                 *
                 * @static
                 * @memberOf _
                 * @since 3.8.0
                 * @category Object
                 * @param {Object} object The object to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Object} Returns the new mapped object.
                 * @see _.mapValues
                 * @example
                 *
                 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
                 *   return key + value;
                 * });
                 * // => { 'a1': 1, 'b2': 2 }
                 */
                function mapKeys(object, iteratee) {
                    var result = {};
                    iteratee = baseIteratee(iteratee, 3);

                    baseForOwn(object, function (value, key, object) {
                        baseAssignValue(
                            result,
                            iteratee(value, key, object),
                            value
                        );
                    });
                    return result;
                }

                module.exports = mapKeys;

                /***/
            },
            /* 336 */
            /***/ function (module, exports, __webpack_require__) {
                var baseAssignValue = __webpack_require__(193),
                    baseForOwn = __webpack_require__(125),
                    baseIteratee = __webpack_require__(136);

                /**
                 * Creates an object with the same keys as `object` and values generated
                 * by running each own enumerable string keyed property of `object` thru
                 * `iteratee`. The iteratee is invoked with three arguments:
                 * (value, key, object).
                 *
                 * @static
                 * @memberOf _
                 * @since 2.4.0
                 * @category Object
                 * @param {Object} object The object to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Object} Returns the new mapped object.
                 * @see _.mapKeys
                 * @example
                 *
                 * var users = {
                 *   'fred':    { 'user': 'fred',    'age': 40 },
                 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
                 * };
                 *
                 * _.mapValues(users, function(o) { return o.age; });
                 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.mapValues(users, 'age');
                 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
                 */
                function mapValues(object, iteratee) {
                    var result = {};
                    iteratee = baseIteratee(iteratee, 3);

                    baseForOwn(object, function (value, key, object) {
                        baseAssignValue(
                            result,
                            key,
                            iteratee(value, key, object)
                        );
                    });
                    return result;
                }

                module.exports = mapValues;

                /***/
            },
            /* 337 */
            /***/ function (module, exports) {
                "use strict";

                module.exports = "2.18.1";

                /***/
            },
            /* 338 */
            /***/ function (module, exports, __webpack_require__) {
                var baseMerge = __webpack_require__(257),
                    createAssigner = __webpack_require__(253);

                /**
                 * This method is like `_.merge` except that it accepts `customizer` which
                 * is invoked to produce the merged values of the destination and source
                 * properties. If `customizer` returns `undefined`, merging is handled by the
                 * method instead. The `customizer` is invoked with six arguments:
                 * (objValue, srcValue, key, object, source, stack).
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} sources The source objects.
                 * @param {Function} customizer The function to customize assigned values.
                 * @returns {Object} Returns `object`.
                 * @example
                 *
                 * function customizer(objValue, srcValue) {
                 *   if (_.isArray(objValue)) {
                 *     return objValue.concat(srcValue);
                 *   }
                 * }
                 *
                 * var object = { 'a': [1], 'b': [2] };
                 * var other = { 'a': [3], 'b': [4] };
                 *
                 * _.mergeWith(object, other, customizer);
                 * // => { 'a': [1, 3], 'b': [2, 4] }
                 */
                var mergeWith = createAssigner(function (
                    object,
                    source,
                    srcIndex,
                    customizer
                ) {
                    baseMerge(object, source, srcIndex, customizer);
                });

                module.exports = mergeWith;

                /***/
            },
            /* 339 */
            /***/ function (module, exports, __webpack_require__) {
                var baseFlatten = __webpack_require__(228),
                    baseRest = __webpack_require__(113),
                    baseUniq = __webpack_require__(340),
                    isArrayLikeObject = __webpack_require__(123);

                /**
                 * Creates an array of unique values, in order, from all given arrays using
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {...Array} [arrays] The arrays to inspect.
                 * @returns {Array} Returns the new array of combined values.
                 * @example
                 *
                 * _.union([2], [1, 2]);
                 * // => [2, 1]
                 */
                var union = baseRest(function (arrays) {
                    return baseUniq(
                        baseFlatten(arrays, 1, isArrayLikeObject, true)
                    );
                });

                module.exports = union;

                /***/
            },
            /* 340 */
            /***/ function (module, exports, __webpack_require__) {
                var SetCache = __webpack_require__(73),
                    arrayIncludes = __webpack_require__(106),
                    arrayIncludesWith = __webpack_require__(111),
                    cacheHas = __webpack_require__(112),
                    createSet = __webpack_require__(341),
                    setToArray = __webpack_require__(152);

                /** Used as the size to enable large array optimizations. */
                var LARGE_ARRAY_SIZE = 200;

                /**
                 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {Function} [iteratee] The iteratee invoked per element.
                 * @param {Function} [comparator] The comparator invoked per element.
                 * @returns {Array} Returns the new duplicate free array.
                 */
                function baseUniq(array, iteratee, comparator) {
                    var index = -1,
                        includes = arrayIncludes,
                        length = array.length,
                        isCommon = true,
                        result = [],
                        seen = result;

                    if (comparator) {
                        isCommon = false;
                        includes = arrayIncludesWith;
                    } else if (length >= LARGE_ARRAY_SIZE) {
                        var set = iteratee ? null : createSet(array);
                        if (set) {
                            return setToArray(set);
                        }
                        isCommon = false;
                        includes = cacheHas;
                        seen = new SetCache();
                    } else {
                        seen = iteratee ? [] : result;
                    }
                    outer: while (++index < length) {
                        var value = array[index],
                            computed = iteratee ? iteratee(value) : value;

                        value = comparator || value !== 0 ? value : 0;
                        if (isCommon && computed === computed) {
                            var seenIndex = seen.length;
                            while (seenIndex--) {
                                if (seen[seenIndex] === computed) {
                                    continue outer;
                                }
                            }
                            if (iteratee) {
                                seen.push(computed);
                            }
                            result.push(value);
                        } else if (!includes(seen, computed, comparator)) {
                            if (seen !== result) {
                                seen.push(computed);
                            }
                            result.push(value);
                        }
                    }
                    return result;
                }

                module.exports = baseUniq;

                /***/
            },
            /* 341 */
            /***/ function (module, exports, __webpack_require__) {
                var Set = __webpack_require__(162),
                    noop = __webpack_require__(292),
                    setToArray = __webpack_require__(152);

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0;

                /**
                 * Creates a set object of `values`.
                 *
                 * @private
                 * @param {Array} values The values to add to the set.
                 * @returns {Object} Returns the new set.
                 */
                var createSet = !(
                    Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY
                )
                    ? noop
                    : function (values) {
                          return new Set(values);
                      };

                module.exports = createSet;

                /***/
            },
            /* 342 */
            /***/ function (module, exports, __webpack_require__) {
                var baseClone = __webpack_require__(191);

                /** Used to compose bitmasks for cloning. */
                var CLONE_SYMBOLS_FLAG = 4;

                /**
                 * Creates a shallow clone of `value`.
                 *
                 * **Note:** This method is loosely based on the
                 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
                 * and supports cloning arrays, array buffers, booleans, date objects, maps,
                 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
                 * arrays. The own enumerable properties of `arguments` objects are cloned
                 * as plain objects. An empty object is returned for uncloneable values such
                 * as error objects, functions, DOM nodes, and WeakMaps.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to clone.
                 * @returns {*} Returns the cloned value.
                 * @see _.cloneDeep
                 * @example
                 *
                 * var objects = [{ 'a': 1 }, { 'b': 2 }];
                 *
                 * var shallow = _.clone(objects);
                 * console.log(shallow[0] === objects[0]);
                 * // => true
                 */
                function clone(value) {
                    return baseClone(value, CLONE_SYMBOLS_FLAG);
                }

                module.exports = clone;

                /***/
            },
            /* 343 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _algoliasearchHelper = __webpack_require__(38);

                var _algoliasearchHelper2 =
                    _interopRequireDefault(_algoliasearchHelper);

                var _version = __webpack_require__(344);

                var _version2 = _interopRequireDefault(_version);

                var _url = __webpack_require__(322);

                var _url2 = _interopRequireDefault(_url);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                var _assign = __webpack_require__(345);

                var _assign2 = _interopRequireDefault(_assign);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                var AlgoliaSearchHelper =
                    _algoliasearchHelper2.default.AlgoliaSearchHelper;
                var majorVersionNumber = _version2.default.split(".")[0];
                var firstRender = true;

                function timerMaker(t0) {
                    var t = t0;
                    return function timer() {
                        var now = Date.now();
                        var delta = now - t;
                        t = now;
                        return delta;
                    };
                }

                /**
                 * @typedef {object} UrlUtil
                 * @property {string} character the character used in the url
                 * @property {function} onpopstate add an event listener for the URL change
                 * @property {function} pushState creates a new entry in the browser history
                 * @property {function} readUrl reads the query string of the parameters
                 */

                /**
                 * Handles the legacy browsers
                 * @type {UrlUtil}
                 */
                var hashUrlUtils = {
                    ignoreNextPopState: false,
                    character: "#",
                    onpopstate: function onpopstate(cb) {
                        var _this = this;

                        window.addEventListener("hashchange", function (hash) {
                            if (_this.ignoreNextPopState) {
                                _this.ignoreNextPopState = false;
                                return;
                            }

                            cb(hash);
                        });
                    },
                    pushState: function pushState(qs) {
                        // hash change or location assign does trigger an hashchange event
                        // so everytime we change it manually, we inform the code
                        // to ignore the next hashchange event
                        // see https://github.com/algolia/instantsearch.js/issues/2012
                        this.ignoreNextPopState = true;
                        window.location.assign(getFullURL(this.createURL(qs)));
                    },
                    createURL: function createURL(qs) {
                        return window.location.search + this.character + qs;
                    },
                    readUrl: function readUrl() {
                        return window.location.hash.slice(1);
                    },
                };

                /**
                 * Handles the modern API
                 * @type {UrlUtil}
                 */
                var modernUrlUtils = {
                    character: "?",
                    onpopstate: function onpopstate(cb) {
                        window.addEventListener("popstate", cb);
                    },
                    pushState: function pushState(qs, _ref) {
                        var getHistoryState = _ref.getHistoryState;

                        window.history.pushState(
                            getHistoryState(),
                            "",
                            getFullURL(this.createURL(qs))
                        );
                    },
                    createURL: function createURL(qs) {
                        return this.character + qs + document.location.hash;
                    },
                    readUrl: function readUrl() {
                        return window.location.search.slice(1);
                    },
                };

                // we always push the full url to the url bar. Not a relative one.
                // So that we handle cases like using a <base href>, see
                // https://github.com/algolia/instantsearch.js/issues/790 for the original issue
                function getFullURL(relative) {
                    return (
                        getLocationOrigin() +
                        window.location.pathname +
                        relative
                    );
                }

                // IE <= 11 has no location.origin or buggy
                function getLocationOrigin() {
                    // eslint-disable-next-line max-len
                    return (
                        window.location.protocol +
                        "//" +
                        window.location.hostname +
                        (window.location.port ? ":" + window.location.port : "")
                    );
                }

                // see InstantSearch.js file for urlSync options

                var URLSync = (function () {
                    function URLSync(urlUtils, options) {
                        _classCallCheck(this, URLSync);

                        this.urlUtils = urlUtils;
                        this.originalConfig = null;
                        this.timer = timerMaker(Date.now());
                        this.mapping = options.mapping || {};
                        this.getHistoryState =
                            options.getHistoryState ||
                            function () {
                                return null;
                            };
                        this.threshold = options.threshold || 700;
                        this.trackedParameters = options.trackedParameters || [
                            "query",
                            "attribute:*",
                            "index",
                            "page",
                            "hitsPerPage",
                        ];

                        this.searchParametersFromUrl =
                            AlgoliaSearchHelper.getConfigurationFromQueryString(
                                this.urlUtils.readUrl(),
                                { mapping: this.mapping }
                            );
                    }

                    _createClass(URLSync, [
                        {
                            key: "getConfiguration",
                            value: function getConfiguration(
                                currentConfiguration
                            ) {
                                // we need to create a REAL helper to then get its state. Because some parameters
                                // like hierarchicalFacet.rootPath are then triggering a default refinement that would
                                // be not present if it was not going trough the SearchParameters constructor
                                this.originalConfig = (0,
                                _algoliasearchHelper2.default)(
                                    {
                                        addAlgoliaAgent:
                                            function addAlgoliaAgent() {},
                                    },
                                    currentConfiguration.index,
                                    currentConfiguration
                                ).state;
                                return this.searchParametersFromUrl;
                            },
                        },
                        {
                            key: "render",
                            value: function render(_ref2) {
                                var _this2 = this;

                                var helper = _ref2.helper;

                                if (firstRender) {
                                    firstRender = false;
                                    this.onHistoryChange(
                                        this.onPopState.bind(this, helper)
                                    );
                                    helper.on("change", function (state) {
                                        return _this2.renderURLFromState(state);
                                    });
                                }
                            },
                        },
                        {
                            key: "onPopState",
                            value: function onPopState(helper, fullState) {
                                clearTimeout(this.urlUpdateTimeout);
                                // compare with helper.state
                                var partialHelperState = helper.getState(
                                    this.trackedParameters
                                );
                                var fullHelperState = (0, _assign2.default)(
                                    {},
                                    this.originalConfig,
                                    partialHelperState
                                );

                                if (
                                    (0, _isEqual2.default)(
                                        fullHelperState,
                                        fullState
                                    )
                                )
                                    return;

                                helper
                                    .overrideStateWithoutTriggeringChangeEvent(
                                        fullState
                                    )
                                    .search();
                            },
                        },
                        {
                            key: "renderURLFromState",
                            value: function renderURLFromState(state) {
                                var _this3 = this;

                                var currentQueryString =
                                    this.urlUtils.readUrl();
                                var foreignConfig =
                                    AlgoliaSearchHelper.getForeignConfigurationInQueryString(
                                        currentQueryString,
                                        { mapping: this.mapping }
                                    );
                                // eslint-disable-next-line camelcase
                                foreignConfig.is_v = majorVersionNumber;

                                var qs = _url2.default.getQueryStringFromState(
                                    state.filter(this.trackedParameters),
                                    {
                                        moreAttributes: foreignConfig,
                                        mapping: this.mapping,
                                        safe: true,
                                    }
                                );

                                clearTimeout(this.urlUpdateTimeout);
                                this.urlUpdateTimeout = setTimeout(function () {
                                    _this3.urlUtils.pushState(qs, {
                                        getHistoryState: _this3.getHistoryState,
                                    });
                                }, this.threshold);
                            },

                            // External API's
                        },
                        {
                            key: "createURL",
                            value: function createURL(state, _ref3) {
                                var absolute = _ref3.absolute;

                                var currentQueryString =
                                    this.urlUtils.readUrl();
                                var filteredState = state.filter(
                                    this.trackedParameters
                                );
                                var foreignConfig =
                                    _algoliasearchHelper2.default.url.getUnrecognizedParametersInQueryString(
                                        currentQueryString,
                                        { mapping: this.mapping }
                                    );
                                // Add instantsearch version to reconciliate old url with newer versions
                                // eslint-disable-next-line camelcase
                                foreignConfig.is_v = majorVersionNumber;
                                var relative = this.urlUtils.createURL(
                                    _algoliasearchHelper2.default.url.getQueryStringFromState(
                                        filteredState,
                                        { mapping: this.mapping }
                                    )
                                );

                                return absolute
                                    ? getFullURL(relative)
                                    : relative;
                            },
                        },
                        {
                            key: "onHistoryChange",
                            value: function onHistoryChange(fn) {
                                var _this4 = this;

                                this.urlUtils.onpopstate(function () {
                                    var qs = _this4.urlUtils.readUrl();
                                    var partialState =
                                        AlgoliaSearchHelper.getConfigurationFromQueryString(
                                            qs,
                                            { mapping: _this4.mapping }
                                        );
                                    var fullState = (0, _assign2.default)(
                                        {},
                                        _this4.originalConfig,
                                        partialState
                                    );
                                    fn(fullState);
                                });
                            },
                        },
                    ]);

                    return URLSync;
                })();

                /**
                 * Instanciate a url sync widget. This widget let you synchronize the search
                 * parameters with the URL. It can operate with legacy API and hash or it can use
                 * the modern history API. By default, it will use the modern API, but if you are
                 * looking for compatibility with IE8 and IE9, then you should set 'useHash' to
                 * true.
                 * @param {object} options all the parameters to configure the URL synchronization. It
                 * may contain the following keys :
                 *  - threshold:number time in ms after which a new state is created in the browser
                 * history. The default value is 700.
                 *  - trackedParameters:string[] parameters that will be synchronized in the
                 * URL. By default, it will track the query, all the refinable attribute (facets and numeric
                 * filters), the index and the page.
                 *  - useHash:boolean if set to true, the url will be hash based. Otherwise,
                 * it'll use the query parameters using the modern history API.
                 * @return {object} the widget instance
                 */

                function urlSync() {
                    var options =
                        arguments.length > 0 && arguments[0] !== undefined
                            ? arguments[0]
                            : {};

                    var useHash = options.useHash || false;

                    var urlUtils = useHash ? hashUrlUtils : modernUrlUtils;

                    return new URLSync(urlUtils, options);
                }

                exports.default = urlSync;

                /***/
            },
            /* 344 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = "1.11.2";

                /***/
            },
            /* 345 */
            /***/ function (module, exports, __webpack_require__) {
                var assignValue = __webpack_require__(192),
                    copyObject = __webpack_require__(195),
                    createAssigner = __webpack_require__(253),
                    isArrayLike = __webpack_require__(67),
                    isPrototype = __webpack_require__(64),
                    keys = __webpack_require__(41);

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Assigns own enumerable string keyed properties of source objects to the
                 * destination object. Source objects are applied from left to right.
                 * Subsequent sources overwrite property assignments of previous sources.
                 *
                 * **Note:** This method mutates `object` and is loosely based on
                 * [`Object.assign`](https://mdn.io/Object/assign).
                 *
                 * @static
                 * @memberOf _
                 * @since 0.10.0
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} [sources] The source objects.
                 * @returns {Object} Returns `object`.
                 * @see _.assignIn
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 * }
                 *
                 * function Bar() {
                 *   this.c = 3;
                 * }
                 *
                 * Foo.prototype.b = 2;
                 * Bar.prototype.d = 4;
                 *
                 * _.assign({ 'a': 0 }, new Foo, new Bar);
                 * // => { 'a': 1, 'c': 3 }
                 */
                var assign = createAssigner(function (object, source) {
                    if (isPrototype(source) || isArrayLike(source)) {
                        copyObject(source, keys(source), object);
                        return;
                    }
                    for (var key in source) {
                        if (hasOwnProperty.call(source, key)) {
                            assignValue(object, key, source[key]);
                        }
                    }
                });

                module.exports = assign;

                /***/
            },
            /* 346 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                exports.default = function (_ref) {
                    var numberLocale = _ref.numberLocale;

                    return {
                        formatNumber: function formatNumber(number, render) {
                            return Number(render(number)).toLocaleString(
                                numberLocale
                            );
                        },
                    };
                };

                /***/
            },
            /* 347 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _defaultTemplates = __webpack_require__(525);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _ClearAll = __webpack_require__(526);

                var _ClearAll2 = _interopRequireDefault(_ClearAll);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-clear-all");

                /**
                 * Allows to clear all refinements at once
                 * @function clearAll
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string[]} [options.excludeAttributes] List of attributes names to exclude from clear actions
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header] Header template
                 * @param  {string|Function} [options.templates.link] Link template
                 * @param  {string|Function} [options.templates.footer] Footer template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when there's no refinement to clear
                 * @param  {Object} [options.cssClasses] CSS classes to be added
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.link] CSS class to add to the link element
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nclearAll({\n  container,\n  [ cssClasses.{root,header,body,footer,link}={} ],\n  [ templates.{header,link,footer}={link: 'Clear all'} ],\n  [ autoHideContainer=true ],\n  [ collapsible=false ],\n  [ excludeAttributes=[] ]\n})";
                function clearAll() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        _ref$excludeAttribute = _ref.excludeAttributes,
                        excludeAttributes =
                            _ref$excludeAttribute === undefined
                                ? []
                                : _ref$excludeAttribute;

                    if (!container) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var ClearAll = (0, _headerFooter2.default)(
                        _ClearAll2.default
                    );
                    if (autoHideContainer === true) {
                        ClearAll = (0, _autoHideContainer2.default)(ClearAll);
                    }

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        link: (0, _classnames2.default)(
                            bem("link"),
                            userCssClasses.link
                        ),
                    };

                    return {
                        init: function init(_ref2) {
                            var helper = _ref2.helper,
                                templatesConfig = _ref2.templatesConfig;

                            this.clearAll = this.clearAll.bind(this, helper);
                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            this.clearAttributes = (0, _utils.getRefinements)(
                                results,
                                state
                            )
                                .map(function (one) {
                                    return one.attributeName;
                                })
                                .filter(function (one) {
                                    return (
                                        excludeAttributes.indexOf(one) === -1
                                    );
                                });
                            var hasRefinements =
                                this.clearAttributes.length !== 0;
                            var url = createURL(
                                (0, _utils.clearRefinementsFromState)(state)
                            );

                            _reactDom2.default.render(
                                _react2.default.createElement(ClearAll, {
                                    clearAll: this.clearAll,
                                    collapsible: collapsible,
                                    cssClasses: cssClasses,
                                    hasRefinements: hasRefinements,
                                    shouldAutoHideContainer: !hasRefinements,
                                    templateProps: this._templateProps,
                                    url: url,
                                }),
                                containerNode
                            );
                        },
                        clearAll: function clearAll(helper) {
                            if (this.clearAttributes.length > 0) {
                                (0, _utils.clearRefinementsAndSearch)(
                                    helper,
                                    this.clearAttributes
                                );
                            }
                        },
                    };
                }

                exports.default = clearAll;

                /***/
            },
            /* 348 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (global) {
                    module.exports = global["React"] = __webpack_require__(349);
                    /* WEBPACK VAR INJECTION */
                }.call(
                    exports,
                    (function () {
                        return this;
                    })()
                ));

                /***/
            },
            /* 349 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                module.exports = __webpack_require__(350);

                /***/
            },
            /* 350 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var ReactChildren = __webpack_require__(352);
                var ReactComponent = __webpack_require__(365);
                var ReactPureComponent = __webpack_require__(368);
                var ReactClass = __webpack_require__(369);
                var ReactDOMFactories = __webpack_require__(371);
                var ReactElement = __webpack_require__(356);
                var ReactPropTypes = __webpack_require__(372);
                var ReactVersion = __webpack_require__(374);

                var onlyChild = __webpack_require__(375);
                var warning = __webpack_require__(358);

                var createElement = ReactElement.createElement;
                var createFactory = ReactElement.createFactory;
                var cloneElement = ReactElement.cloneElement;

                if (false) {
                    var ReactElementValidator = require("./ReactElementValidator");
                    createElement = ReactElementValidator.createElement;
                    createFactory = ReactElementValidator.createFactory;
                    cloneElement = ReactElementValidator.cloneElement;
                }

                var __spread = _assign;

                if (false) {
                    var warned = false;
                    __spread = function () {
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  warned,
                                  "React.__spread is deprecated and should not be used. Use " +
                                      "Object.assign directly or another helper function with similar " +
                                      "semantics. You may be seeing this warning due to your compiler. " +
                                      "See https://fb.me/react-spread-deprecation for more details."
                              )
                            : void 0;
                        warned = true;
                        return _assign.apply(null, arguments);
                    };
                }

                var React = {
                    // Modern

                    Children: {
                        map: ReactChildren.map,
                        forEach: ReactChildren.forEach,
                        count: ReactChildren.count,
                        toArray: ReactChildren.toArray,
                        only: onlyChild,
                    },

                    Component: ReactComponent,
                    PureComponent: ReactPureComponent,

                    createElement: createElement,
                    cloneElement: cloneElement,
                    isValidElement: ReactElement.isValidElement,

                    // Classic

                    PropTypes: ReactPropTypes,
                    createClass: ReactClass.createClass,
                    createFactory: createFactory,
                    createMixin: function (mixin) {
                        // Currently a noop. Will be used to validate and trace mixins.
                        return mixin;
                    },

                    // This looks DOM specific but these are actually isomorphic helpers
                    // since they are just generating DOM strings.
                    DOM: ReactDOMFactories,

                    version: ReactVersion,

                    // Deprecated hook for JSX spread, don't use this for anything.
                    __spread: __spread,
                };

                module.exports = React;

                /***/
            },
            /* 351 */
            /***/ function (module, exports) {
                "use strict";
                /* eslint-disable no-unused-vars */
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;

                function toObject(val) {
                    if (val === null || val === undefined) {
                        throw new TypeError(
                            "Object.assign cannot be called with null or undefined"
                        );
                    }

                    return Object(val);
                }

                function shouldUseNative() {
                    try {
                        if (!Object.assign) {
                            return false;
                        }

                        // Detect buggy property enumeration order in older V8 versions.

                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") {
                            return false;
                        }

                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for (var i = 0; i < 10; i++) {
                            test2["_" + String.fromCharCode(i)] = i;
                        }
                        var order2 = Object.getOwnPropertyNames(test2).map(
                            function (n) {
                                return test2[n];
                            }
                        );
                        if (order2.join("") !== "0123456789") {
                            return false;
                        }

                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst"
                            .split("")
                            .forEach(function (letter) {
                                test3[letter] = letter;
                            });
                        if (
                            Object.keys(Object.assign({}, test3)).join("") !==
                            "abcdefghijklmnopqrst"
                        ) {
                            return false;
                        }

                        return true;
                    } catch (e) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }

                module.exports = shouldUseNative()
                    ? Object.assign
                    : function (target, source) {
                          var from;
                          var to = toObject(target);
                          var symbols;

                          for (var s = 1; s < arguments.length; s++) {
                              from = Object(arguments[s]);

                              for (var key in from) {
                                  if (hasOwnProperty.call(from, key)) {
                                      to[key] = from[key];
                                  }
                              }

                              if (Object.getOwnPropertySymbols) {
                                  symbols = Object.getOwnPropertySymbols(from);
                                  for (var i = 0; i < symbols.length; i++) {
                                      if (
                                          propIsEnumerable.call(
                                              from,
                                              symbols[i]
                                          )
                                      ) {
                                          to[symbols[i]] = from[symbols[i]];
                                      }
                                  }
                              }
                          }

                          return to;
                      };

                /***/
            },
            /* 352 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var PooledClass = __webpack_require__(353);
                var ReactElement = __webpack_require__(356);

                var emptyFunction = __webpack_require__(359);
                var traverseAllChildren = __webpack_require__(362);

                var twoArgumentPooler = PooledClass.twoArgumentPooler;
                var fourArgumentPooler = PooledClass.fourArgumentPooler;

                var userProvidedKeyEscapeRegex = /\/+/g;
                function escapeUserProvidedKey(text) {
                    return ("" + text).replace(
                        userProvidedKeyEscapeRegex,
                        "$&/"
                    );
                }

                /**
                 * PooledClass representing the bookkeeping associated with performing a child
                 * traversal. Allows avoiding binding callbacks.
                 *
                 * @constructor ForEachBookKeeping
                 * @param {!function} forEachFunction Function to perform traversal with.
                 * @param {?*} forEachContext Context to perform context with.
                 */
                function ForEachBookKeeping(forEachFunction, forEachContext) {
                    this.func = forEachFunction;
                    this.context = forEachContext;
                    this.count = 0;
                }
                ForEachBookKeeping.prototype.destructor = function () {
                    this.func = null;
                    this.context = null;
                    this.count = 0;
                };
                PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

                function forEachSingleChild(bookKeeping, child, name) {
                    var func = bookKeeping.func,
                        context = bookKeeping.context;

                    func.call(context, child, bookKeeping.count++);
                }

                /**
                 * Iterates through children that are typically specified as `props.children`.
                 *
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
                 *
                 * The provided forEachFunc(child, index) will be called for each
                 * leaf child.
                 *
                 * @param {?*} children Children tree container.
                 * @param {function(*, int)} forEachFunc
                 * @param {*} forEachContext Context for forEachContext.
                 */
                function forEachChildren(
                    children,
                    forEachFunc,
                    forEachContext
                ) {
                    if (children == null) {
                        return children;
                    }
                    var traverseContext = ForEachBookKeeping.getPooled(
                        forEachFunc,
                        forEachContext
                    );
                    traverseAllChildren(
                        children,
                        forEachSingleChild,
                        traverseContext
                    );
                    ForEachBookKeeping.release(traverseContext);
                }

                /**
                 * PooledClass representing the bookkeeping associated with performing a child
                 * mapping. Allows avoiding binding callbacks.
                 *
                 * @constructor MapBookKeeping
                 * @param {!*} mapResult Object containing the ordered map of results.
                 * @param {!function} mapFunction Function to perform mapping with.
                 * @param {?*} mapContext Context to perform mapping with.
                 */
                function MapBookKeeping(
                    mapResult,
                    keyPrefix,
                    mapFunction,
                    mapContext
                ) {
                    this.result = mapResult;
                    this.keyPrefix = keyPrefix;
                    this.func = mapFunction;
                    this.context = mapContext;
                    this.count = 0;
                }
                MapBookKeeping.prototype.destructor = function () {
                    this.result = null;
                    this.keyPrefix = null;
                    this.func = null;
                    this.context = null;
                    this.count = 0;
                };
                PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

                function mapSingleChildIntoContext(
                    bookKeeping,
                    child,
                    childKey
                ) {
                    var result = bookKeeping.result,
                        keyPrefix = bookKeeping.keyPrefix,
                        func = bookKeeping.func,
                        context = bookKeeping.context;

                    var mappedChild = func.call(
                        context,
                        child,
                        bookKeeping.count++
                    );
                    if (Array.isArray(mappedChild)) {
                        mapIntoWithKeyPrefixInternal(
                            mappedChild,
                            result,
                            childKey,
                            emptyFunction.thatReturnsArgument
                        );
                    } else if (mappedChild != null) {
                        if (ReactElement.isValidElement(mappedChild)) {
                            mappedChild = ReactElement.cloneAndReplaceKey(
                                mappedChild,
                                // Keep both the (mapped) and old keys if they differ, just as
                                // traverseAllChildren used to do for objects as children
                                keyPrefix +
                                    (mappedChild.key &&
                                    (!child || child.key !== mappedChild.key)
                                        ? escapeUserProvidedKey(
                                              mappedChild.key
                                          ) + "/"
                                        : "") +
                                    childKey
                            );
                        }
                        result.push(mappedChild);
                    }
                }

                function mapIntoWithKeyPrefixInternal(
                    children,
                    array,
                    prefix,
                    func,
                    context
                ) {
                    var escapedPrefix = "";
                    if (prefix != null) {
                        escapedPrefix = escapeUserProvidedKey(prefix) + "/";
                    }
                    var traverseContext = MapBookKeeping.getPooled(
                        array,
                        escapedPrefix,
                        func,
                        context
                    );
                    traverseAllChildren(
                        children,
                        mapSingleChildIntoContext,
                        traverseContext
                    );
                    MapBookKeeping.release(traverseContext);
                }

                /**
                 * Maps children that are typically specified as `props.children`.
                 *
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
                 *
                 * The provided mapFunction(child, key, index) will be called for each
                 * leaf child.
                 *
                 * @param {?*} children Children tree container.
                 * @param {function(*, int)} func The map function.
                 * @param {*} context Context for mapFunction.
                 * @return {object} Object containing the ordered map of results.
                 */
                function mapChildren(children, func, context) {
                    if (children == null) {
                        return children;
                    }
                    var result = [];
                    mapIntoWithKeyPrefixInternal(
                        children,
                        result,
                        null,
                        func,
                        context
                    );
                    return result;
                }

                function forEachSingleChildDummy(traverseContext, child, name) {
                    return null;
                }

                /**
                 * Count the number of children that are typically specified as
                 * `props.children`.
                 *
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
                 *
                 * @param {?*} children Children tree container.
                 * @return {number} The number of children.
                 */
                function countChildren(children, context) {
                    return traverseAllChildren(
                        children,
                        forEachSingleChildDummy,
                        null
                    );
                }

                /**
                 * Flatten a children object (typically specified as `props.children`) and
                 * return an array with appropriately re-keyed children.
                 *
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
                 */
                function toArray(children) {
                    var result = [];
                    mapIntoWithKeyPrefixInternal(
                        children,
                        result,
                        null,
                        emptyFunction.thatReturnsArgument
                    );
                    return result;
                }

                var ReactChildren = {
                    forEach: forEachChildren,
                    map: mapChildren,
                    mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
                    count: countChildren,
                    toArray: toArray,
                };

                module.exports = ReactChildren;

                /***/
            },
            /* 353 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(354);

                var invariant = __webpack_require__(355);

                /**
                 * Static poolers. Several custom versions for each potential number of
                 * arguments. A completely generic pooler is easy to implement, but would
                 * require accessing the `arguments` object. In each of these, `this` refers to
                 * the Class itself, not an instance. If any others are needed, simply add them
                 * here, or in their own files.
                 */
                var oneArgumentPooler = function (copyFieldsFrom) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, copyFieldsFrom);
                        return instance;
                    } else {
                        return new Klass(copyFieldsFrom);
                    }
                };

                var twoArgumentPooler = function (a1, a2) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2);
                        return instance;
                    } else {
                        return new Klass(a1, a2);
                    }
                };

                var threeArgumentPooler = function (a1, a2, a3) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2, a3);
                        return instance;
                    } else {
                        return new Klass(a1, a2, a3);
                    }
                };

                var fourArgumentPooler = function (a1, a2, a3, a4) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2, a3, a4);
                        return instance;
                    } else {
                        return new Klass(a1, a2, a3, a4);
                    }
                };

                var standardReleaser = function (instance) {
                    var Klass = this;
                    !(instance instanceof Klass)
                        ? false
                            ? invariant(
                                  false,
                                  "Trying to release an instance into a pool of a different type."
                              )
                            : _prodInvariant("25")
                        : void 0;
                    instance.destructor();
                    if (Klass.instancePool.length < Klass.poolSize) {
                        Klass.instancePool.push(instance);
                    }
                };

                var DEFAULT_POOL_SIZE = 10;
                var DEFAULT_POOLER = oneArgumentPooler;

                /**
                 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
                 * itself (statically) not adding any prototypical fields. Any CopyConstructor
                 * you give this may have a `poolSize` property, and will look for a
                 * prototypical `destructor` on instances.
                 *
                 * @param {Function} CopyConstructor Constructor that can be used to reset.
                 * @param {Function} pooler Customizable pooler.
                 */
                var addPoolingTo = function (CopyConstructor, pooler) {
                    // Casting as any so that flow ignores the actual implementation and trusts
                    // it to match the type we declared
                    var NewKlass = CopyConstructor;
                    NewKlass.instancePool = [];
                    NewKlass.getPooled = pooler || DEFAULT_POOLER;
                    if (!NewKlass.poolSize) {
                        NewKlass.poolSize = DEFAULT_POOL_SIZE;
                    }
                    NewKlass.release = standardReleaser;
                    return NewKlass;
                };

                var PooledClass = {
                    addPoolingTo: addPoolingTo,
                    oneArgumentPooler: oneArgumentPooler,
                    twoArgumentPooler: twoArgumentPooler,
                    threeArgumentPooler: threeArgumentPooler,
                    fourArgumentPooler: fourArgumentPooler,
                };

                module.exports = PooledClass;

                /***/
            },
            /* 354 */
            /***/ function (module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */
                "use strict";

                /**
                 * WARNING: DO NOT manually require this module.
                 * This is a replacement for `invariant(...)` used by the error code system
                 * and will _only_ be required by the corresponding babel pass.
                 * It always throws.
                 */

                function reactProdInvariant(code) {
                    var argCount = arguments.length - 1;

                    var message =
                        "Minified React error #" +
                        code +
                        "; visit " +
                        "http://facebook.github.io/react/docs/error-decoder.html?invariant=" +
                        code;

                    for (var argIdx = 0; argIdx < argCount; argIdx++) {
                        message +=
                            "&args[]=" +
                            encodeURIComponent(arguments[argIdx + 1]);
                    }

                    message +=
                        " for the full message or use the non-minified dev environment" +
                        " for full errors and additional helpful warnings.";

                    var error = new Error(message);
                    error.name = "Invariant Violation";
                    error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

                    throw error;
                }

                module.exports = reactProdInvariant;

                /***/
            },
            /* 355 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * Use invariant() to assert state which your program assumes to be true.
                 *
                 * Provide sprintf-style format (only %s is supported) and arguments
                 * to provide information about what broke and what you were
                 * expecting.
                 *
                 * The invariant message will be stripped in production, but the invariant
                 * will remain to ensure logic does not differ in production.
                 */

                function invariant(condition, format, a, b, c, d, e, f) {
                    if (false) {
                        if (format === undefined) {
                            throw new Error(
                                "invariant requires an error message argument"
                            );
                        }
                    }

                    if (!condition) {
                        var error;
                        if (format === undefined) {
                            error = new Error(
                                "Minified exception occurred; use the non-minified dev environment " +
                                    "for the full error message and additional helpful warnings."
                            );
                        } else {
                            var args = [a, b, c, d, e, f];
                            var argIndex = 0;
                            error = new Error(
                                format.replace(/%s/g, function () {
                                    return args[argIndex++];
                                })
                            );
                            error.name = "Invariant Violation";
                        }

                        error.framesToPop = 1; // we don't care about invariant's own frame
                        throw error;
                    }
                }

                module.exports = invariant;

                /***/
            },
            /* 356 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var ReactCurrentOwner = __webpack_require__(357);

                var warning = __webpack_require__(358);
                var canDefineProperty = __webpack_require__(360);
                var hasOwnProperty = Object.prototype.hasOwnProperty;

                var REACT_ELEMENT_TYPE = __webpack_require__(361);

                var RESERVED_PROPS = {
                    key: true,
                    ref: true,
                    __self: true,
                    __source: true,
                };

                var specialPropKeyWarningShown, specialPropRefWarningShown;

                function hasValidRef(config) {
                    if (false) {
                        if (hasOwnProperty.call(config, "ref")) {
                            var getter = Object.getOwnPropertyDescriptor(
                                config,
                                "ref"
                            ).get;
                            if (getter && getter.isReactWarning) {
                                return false;
                            }
                        }
                    }
                    return config.ref !== undefined;
                }

                function hasValidKey(config) {
                    if (false) {
                        if (hasOwnProperty.call(config, "key")) {
                            var getter = Object.getOwnPropertyDescriptor(
                                config,
                                "key"
                            ).get;
                            if (getter && getter.isReactWarning) {
                                return false;
                            }
                        }
                    }
                    return config.key !== undefined;
                }

                function defineKeyPropWarningGetter(props, displayName) {
                    var warnAboutAccessingKey = function () {
                        if (!specialPropKeyWarningShown) {
                            specialPropKeyWarningShown = true;
                            false
                                ? warning(
                                      false,
                                      "%s: `key` is not a prop. Trying to access it will result " +
                                          "in `undefined` being returned. If you need to access the same " +
                                          "value within the child component, you should pass it as a different " +
                                          "prop. (https://fb.me/react-special-props)",
                                      displayName
                                  )
                                : void 0;
                        }
                    };
                    warnAboutAccessingKey.isReactWarning = true;
                    Object.defineProperty(props, "key", {
                        get: warnAboutAccessingKey,
                        configurable: true,
                    });
                }

                function defineRefPropWarningGetter(props, displayName) {
                    var warnAboutAccessingRef = function () {
                        if (!specialPropRefWarningShown) {
                            specialPropRefWarningShown = true;
                            false
                                ? warning(
                                      false,
                                      "%s: `ref` is not a prop. Trying to access it will result " +
                                          "in `undefined` being returned. If you need to access the same " +
                                          "value within the child component, you should pass it as a different " +
                                          "prop. (https://fb.me/react-special-props)",
                                      displayName
                                  )
                                : void 0;
                        }
                    };
                    warnAboutAccessingRef.isReactWarning = true;
                    Object.defineProperty(props, "ref", {
                        get: warnAboutAccessingRef,
                        configurable: true,
                    });
                }

                /**
                 * Factory method to create a new React element. This no longer adheres to
                 * the class pattern, so do not use new to call it. Also, no instanceof check
                 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
                 * if something is a React Element.
                 *
                 * @param {*} type
                 * @param {*} key
                 * @param {string|object} ref
                 * @param {*} self A *temporary* helper to detect places where `this` is
                 * different from the `owner` when React.createElement is called, so that we
                 * can warn. We want to get rid of owner and replace string `ref`s with arrow
                 * functions, and as long as `this` and owner are the same, there will be no
                 * change in behavior.
                 * @param {*} source An annotation object (added by a transpiler or otherwise)
                 * indicating filename, line number, and/or other information.
                 * @param {*} owner
                 * @param {*} props
                 * @internal
                 */
                var ReactElement = function (
                    type,
                    key,
                    ref,
                    self,
                    source,
                    owner,
                    props
                ) {
                    var element = {
                        // This tag allow us to uniquely identify this as a React Element
                        $$typeof: REACT_ELEMENT_TYPE,

                        // Built-in properties that belong on the element
                        type: type,
                        key: key,
                        ref: ref,
                        props: props,

                        // Record the component responsible for creating this element.
                        _owner: owner,
                    };

                    if (false) {
                        // The validation flag is currently mutative. We put it on
                        // an external backing store so that we can freeze the whole object.
                        // This can be replaced with a WeakMap once they are implemented in
                        // commonly used development environments.
                        element._store = {};

                        // To make comparing ReactElements easier for testing purposes, we make
                        // the validation flag non-enumerable (where possible, which should
                        // include every environment we run tests in), so the test framework
                        // ignores it.
                        if (canDefineProperty) {
                            Object.defineProperty(element._store, "validated", {
                                configurable: false,
                                enumerable: false,
                                writable: true,
                                value: false,
                            });
                            // self and source are DEV only properties.
                            Object.defineProperty(element, "_self", {
                                configurable: false,
                                enumerable: false,
                                writable: false,
                                value: self,
                            });
                            // Two elements created in two different places should be considered
                            // equal for testing purposes and therefore we hide it from enumeration.
                            Object.defineProperty(element, "_source", {
                                configurable: false,
                                enumerable: false,
                                writable: false,
                                value: source,
                            });
                        } else {
                            element._store.validated = false;
                            element._self = self;
                            element._source = source;
                        }
                        if (Object.freeze) {
                            Object.freeze(element.props);
                            Object.freeze(element);
                        }
                    }

                    return element;
                };

                /**
                 * Create and return a new ReactElement of the given type.
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
                 */
                ReactElement.createElement = function (type, config, children) {
                    var propName;

                    // Reserved names are extracted
                    var props = {};

                    var key = null;
                    var ref = null;
                    var self = null;
                    var source = null;

                    if (config != null) {
                        if (hasValidRef(config)) {
                            ref = config.ref;
                        }
                        if (hasValidKey(config)) {
                            key = "" + config.key;
                        }

                        self =
                            config.__self === undefined ? null : config.__self;
                        source =
                            config.__source === undefined
                                ? null
                                : config.__source;
                        // Remaining properties are added to a new props object
                        for (propName in config) {
                            if (
                                hasOwnProperty.call(config, propName) &&
                                !RESERVED_PROPS.hasOwnProperty(propName)
                            ) {
                                props[propName] = config[propName];
                            }
                        }
                    }

                    // Children can be more than one argument, and those are transferred onto
                    // the newly allocated props object.
                    var childrenLength = arguments.length - 2;
                    if (childrenLength === 1) {
                        props.children = children;
                    } else if (childrenLength > 1) {
                        var childArray = Array(childrenLength);
                        for (var i = 0; i < childrenLength; i++) {
                            childArray[i] = arguments[i + 2];
                        }
                        if (false) {
                            if (Object.freeze) {
                                Object.freeze(childArray);
                            }
                        }
                        props.children = childArray;
                    }

                    // Resolve default props
                    if (type && type.defaultProps) {
                        var defaultProps = type.defaultProps;
                        for (propName in defaultProps) {
                            if (props[propName] === undefined) {
                                props[propName] = defaultProps[propName];
                            }
                        }
                    }
                    if (false) {
                        if (key || ref) {
                            if (
                                typeof props.$$typeof === "undefined" ||
                                props.$$typeof !== REACT_ELEMENT_TYPE
                            ) {
                                var displayName =
                                    typeof type === "function"
                                        ? type.displayName ||
                                          type.name ||
                                          "Unknown"
                                        : type;
                                if (key) {
                                    defineKeyPropWarningGetter(
                                        props,
                                        displayName
                                    );
                                }
                                if (ref) {
                                    defineRefPropWarningGetter(
                                        props,
                                        displayName
                                    );
                                }
                            }
                        }
                    }
                    return ReactElement(
                        type,
                        key,
                        ref,
                        self,
                        source,
                        ReactCurrentOwner.current,
                        props
                    );
                };

                /**
                 * Return a function that produces ReactElements of a given type.
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
                 */
                ReactElement.createFactory = function (type) {
                    var factory = ReactElement.createElement.bind(null, type);
                    // Expose the type on the factory and the prototype so that it can be
                    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
                    // This should not be named `constructor` since this may not be the function
                    // that created the element, and it may not even be a constructor.
                    // Legacy hook TODO: Warn if this is accessed
                    factory.type = type;
                    return factory;
                };

                ReactElement.cloneAndReplaceKey = function (
                    oldElement,
                    newKey
                ) {
                    var newElement = ReactElement(
                        oldElement.type,
                        newKey,
                        oldElement.ref,
                        oldElement._self,
                        oldElement._source,
                        oldElement._owner,
                        oldElement.props
                    );

                    return newElement;
                };

                /**
                 * Clone and return a new ReactElement using element as the starting point.
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
                 */
                ReactElement.cloneElement = function (
                    element,
                    config,
                    children
                ) {
                    var propName;

                    // Original props are copied
                    var props = _assign({}, element.props);

                    // Reserved names are extracted
                    var key = element.key;
                    var ref = element.ref;
                    // Self is preserved since the owner is preserved.
                    var self = element._self;
                    // Source is preserved since cloneElement is unlikely to be targeted by a
                    // transpiler, and the original source is probably a better indicator of the
                    // true owner.
                    var source = element._source;

                    // Owner will be preserved, unless ref is overridden
                    var owner = element._owner;

                    if (config != null) {
                        if (hasValidRef(config)) {
                            // Silently steal the ref from the parent.
                            ref = config.ref;
                            owner = ReactCurrentOwner.current;
                        }
                        if (hasValidKey(config)) {
                            key = "" + config.key;
                        }

                        // Remaining properties override existing props
                        var defaultProps;
                        if (element.type && element.type.defaultProps) {
                            defaultProps = element.type.defaultProps;
                        }
                        for (propName in config) {
                            if (
                                hasOwnProperty.call(config, propName) &&
                                !RESERVED_PROPS.hasOwnProperty(propName)
                            ) {
                                if (
                                    config[propName] === undefined &&
                                    defaultProps !== undefined
                                ) {
                                    // Resolve default props
                                    props[propName] = defaultProps[propName];
                                } else {
                                    props[propName] = config[propName];
                                }
                            }
                        }
                    }

                    // Children can be more than one argument, and those are transferred onto
                    // the newly allocated props object.
                    var childrenLength = arguments.length - 2;
                    if (childrenLength === 1) {
                        props.children = children;
                    } else if (childrenLength > 1) {
                        var childArray = Array(childrenLength);
                        for (var i = 0; i < childrenLength; i++) {
                            childArray[i] = arguments[i + 2];
                        }
                        props.children = childArray;
                    }

                    return ReactElement(
                        element.type,
                        key,
                        ref,
                        self,
                        source,
                        owner,
                        props
                    );
                };

                /**
                 * Verifies the object is a ReactElement.
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
                 * @param {?object} object
                 * @return {boolean} True if `object` is a valid component.
                 * @final
                 */
                ReactElement.isValidElement = function (object) {
                    return (
                        typeof object === "object" &&
                        object !== null &&
                        object.$$typeof === REACT_ELEMENT_TYPE
                    );
                };

                module.exports = ReactElement;

                /***/
            },
            /* 357 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                /**
                 * Keeps track of the current owner.
                 *
                 * The current owner is the component who should own any components that are
                 * currently being constructed.
                 */
                var ReactCurrentOwner = {
                    /**
                     * @internal
                     * @type {ReactComponent}
                     */
                    current: null,
                };

                module.exports = ReactCurrentOwner;

                /***/
            },
            /* 358 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2014-2015, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var emptyFunction = __webpack_require__(359);

                /**
                 * Similar to invariant but only logs a warning if the condition is not met.
                 * This can be used to log issues in development environments in critical
                 * paths. Removing the logging code for production environments will keep the
                 * same logic and follow the same code paths.
                 */

                var warning = emptyFunction;

                if (false) {
                    (function () {
                        var printWarning = function printWarning(format) {
                            for (
                                var _len = arguments.length,
                                    args = Array(_len > 1 ? _len - 1 : 0),
                                    _key = 1;
                                _key < _len;
                                _key++
                            ) {
                                args[_key - 1] = arguments[_key];
                            }

                            var argIndex = 0;
                            var message =
                                "Warning: " +
                                format.replace(/%s/g, function () {
                                    return args[argIndex++];
                                });
                            if (typeof console !== "undefined") {
                                console.error(message);
                            }
                            try {
                                // --- Welcome to debugging React ---
                                // This error was thrown as a convenience so that you can use this stack
                                // to find the callsite that caused this warning to fire.
                                throw new Error(message);
                            } catch (x) {}
                        };

                        warning = function warning(condition, format) {
                            if (format === undefined) {
                                throw new Error(
                                    "`warning(condition, format, ...args)` requires a warning " +
                                        "message argument"
                                );
                            }

                            if (
                                format.indexOf(
                                    "Failed Composite propType: "
                                ) === 0
                            ) {
                                return; // Ignore CompositeComponent proptype check.
                            }

                            if (!condition) {
                                for (
                                    var _len2 = arguments.length,
                                        args = Array(_len2 > 2 ? _len2 - 2 : 0),
                                        _key2 = 2;
                                    _key2 < _len2;
                                    _key2++
                                ) {
                                    args[_key2 - 2] = arguments[_key2];
                                }

                                printWarning.apply(
                                    undefined,
                                    [format].concat(args)
                                );
                            }
                        };
                    })();
                }

                module.exports = warning;

                /***/
            },
            /* 359 */
            /***/ function (module, exports) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                function makeEmptyFunction(arg) {
                    return function () {
                        return arg;
                    };
                }

                /**
                 * This function accepts and discards inputs; it has no side effects. This is
                 * primarily useful idiomatically for overridable function endpoints which
                 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
                 */
                var emptyFunction = function emptyFunction() {};

                emptyFunction.thatReturns = makeEmptyFunction;
                emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
                emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
                emptyFunction.thatReturnsNull = makeEmptyFunction(null);
                emptyFunction.thatReturnsThis = function () {
                    return this;
                };
                emptyFunction.thatReturnsArgument = function (arg) {
                    return arg;
                };

                module.exports = emptyFunction;

                /***/
            },
            /* 360 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var canDefineProperty = false;
                if (false) {
                    try {
                        // $FlowFixMe https://github.com/facebook/flow/issues/285
                        Object.defineProperty({}, "x", { get: function () {} });
                        canDefineProperty = true;
                    } catch (x) {
                        // IE will fail on defineProperty
                    }
                }

                module.exports = canDefineProperty;

                /***/
            },
            /* 361 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                // The Symbol used to tag the ReactElement type. If there is no native Symbol
                // nor polyfill, then a plain number is used for performance.

                var REACT_ELEMENT_TYPE =
                    (typeof Symbol === "function" &&
                        Symbol["for"] &&
                        Symbol["for"]("react.element")) ||
                    0xeac7;

                module.exports = REACT_ELEMENT_TYPE;

                /***/
            },
            /* 362 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(354);

                var ReactCurrentOwner = __webpack_require__(357);
                var REACT_ELEMENT_TYPE = __webpack_require__(361);

                var getIteratorFn = __webpack_require__(363);
                var invariant = __webpack_require__(355);
                var KeyEscapeUtils = __webpack_require__(364);
                var warning = __webpack_require__(358);

                var SEPARATOR = ".";
                var SUBSEPARATOR = ":";

                /**
                 * This is inlined from ReactElement since this file is shared between
                 * isomorphic and renderers. We could extract this to a
                 *
                 */

                /**
                 * TODO: Test that a single child and an array with one item have the same key
                 * pattern.
                 */

                var didWarnAboutMaps = false;

                /**
                 * Generate a key string that identifies a component within a set.
                 *
                 * @param {*} component A component that could contain a manual key.
                 * @param {number} index Index that is used if a manual key is not provided.
                 * @return {string}
                 */
                function getComponentKey(component, index) {
                    // Do some typechecking here since we call this blindly. We want to ensure
                    // that we don't block potential future ES APIs.
                    if (
                        component &&
                        typeof component === "object" &&
                        component.key != null
                    ) {
                        // Explicit key
                        return KeyEscapeUtils.escape(component.key);
                    }
                    // Implicit key determined by the index in the set
                    return index.toString(36);
                }

                /**
                 * @param {?*} children Children tree container.
                 * @param {!string} nameSoFar Name of the key path so far.
                 * @param {!function} callback Callback to invoke with each child found.
                 * @param {?*} traverseContext Used to pass information throughout the traversal
                 * process.
                 * @return {!number} The number of children in this subtree.
                 */
                function traverseAllChildrenImpl(
                    children,
                    nameSoFar,
                    callback,
                    traverseContext
                ) {
                    var type = typeof children;

                    if (type === "undefined" || type === "boolean") {
                        // All of the above are perceived as null.
                        children = null;
                    }

                    if (
                        children === null ||
                        type === "string" ||
                        type === "number" ||
                        // The following is inlined from ReactElement. This means we can optimize
                        // some checks. React Fiber also inlines this logic for similar purposes.
                        (type === "object" &&
                            children.$$typeof === REACT_ELEMENT_TYPE)
                    ) {
                        callback(
                            traverseContext,
                            children,
                            // If it's the only child, treat the name as if it was wrapped in an array
                            // so that it's consistent if the number of children grows.
                            nameSoFar === ""
                                ? SEPARATOR + getComponentKey(children, 0)
                                : nameSoFar
                        );
                        return 1;
                    }

                    var child;
                    var nextName;
                    var subtreeCount = 0; // Count of children found in the current subtree.
                    var nextNamePrefix =
                        nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;

                    if (Array.isArray(children)) {
                        for (var i = 0; i < children.length; i++) {
                            child = children[i];
                            nextName =
                                nextNamePrefix + getComponentKey(child, i);
                            subtreeCount += traverseAllChildrenImpl(
                                child,
                                nextName,
                                callback,
                                traverseContext
                            );
                        }
                    } else {
                        var iteratorFn = getIteratorFn(children);
                        if (iteratorFn) {
                            var iterator = iteratorFn.call(children);
                            var step;
                            if (iteratorFn !== children.entries) {
                                var ii = 0;
                                while (!(step = iterator.next()).done) {
                                    child = step.value;
                                    nextName =
                                        nextNamePrefix +
                                        getComponentKey(child, ii++);
                                    subtreeCount += traverseAllChildrenImpl(
                                        child,
                                        nextName,
                                        callback,
                                        traverseContext
                                    );
                                }
                            } else {
                                if (false) {
                                    var mapsAsChildrenAddendum = "";
                                    if (ReactCurrentOwner.current) {
                                        var mapsAsChildrenOwnerName =
                                            ReactCurrentOwner.current.getName();
                                        if (mapsAsChildrenOwnerName) {
                                            mapsAsChildrenAddendum =
                                                " Check the render method of `" +
                                                mapsAsChildrenOwnerName +
                                                "`.";
                                        }
                                    }
                                    process.env.NODE_ENV !== "production"
                                        ? warning(
                                              didWarnAboutMaps,
                                              "Using Maps as children is not yet fully supported. It is an " +
                                                  "experimental feature that might be removed. Convert it to a " +
                                                  "sequence / iterable of keyed ReactElements instead.%s",
                                              mapsAsChildrenAddendum
                                          )
                                        : void 0;
                                    didWarnAboutMaps = true;
                                }
                                // Iterator will provide entry [k,v] tuples rather than values.
                                while (!(step = iterator.next()).done) {
                                    var entry = step.value;
                                    if (entry) {
                                        child = entry[1];
                                        nextName =
                                            nextNamePrefix +
                                            KeyEscapeUtils.escape(entry[0]) +
                                            SUBSEPARATOR +
                                            getComponentKey(child, 0);
                                        subtreeCount += traverseAllChildrenImpl(
                                            child,
                                            nextName,
                                            callback,
                                            traverseContext
                                        );
                                    }
                                }
                            }
                        } else if (type === "object") {
                            var addendum = "";
                            if (false) {
                                addendum =
                                    " If you meant to render a collection of children, use an array " +
                                    "instead or wrap the object using createFragment(object) from the " +
                                    "React add-ons.";
                                if (children._isReactElement) {
                                    addendum =
                                        " It looks like you're using an element created by a different " +
                                        "version of React. Make sure to use only one copy of React.";
                                }
                                if (ReactCurrentOwner.current) {
                                    var name =
                                        ReactCurrentOwner.current.getName();
                                    if (name) {
                                        addendum +=
                                            " Check the render method of `" +
                                            name +
                                            "`.";
                                    }
                                }
                            }
                            var childrenString = String(children);
                            true
                                ? false
                                    ? invariant(
                                          false,
                                          "Objects are not valid as a React child (found: %s).%s",
                                          childrenString === "[object Object]"
                                              ? "object with keys {" +
                                                    Object.keys(children).join(
                                                        ", "
                                                    ) +
                                                    "}"
                                              : childrenString,
                                          addendum
                                      )
                                    : _prodInvariant(
                                          "31",
                                          childrenString === "[object Object]"
                                              ? "object with keys {" +
                                                    Object.keys(children).join(
                                                        ", "
                                                    ) +
                                                    "}"
                                              : childrenString,
                                          addendum
                                      )
                                : void 0;
                        }
                    }

                    return subtreeCount;
                }

                /**
                 * Traverses children that are typically specified as `props.children`, but
                 * might also be specified through attributes:
                 *
                 * - `traverseAllChildren(this.props.children, ...)`
                 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
                 *
                 * The `traverseContext` is an optional argument that is passed through the
                 * entire traversal. It can be used to store accumulations or anything else that
                 * the callback might find relevant.
                 *
                 * @param {?*} children Children tree object.
                 * @param {!function} callback To invoke upon traversing each child.
                 * @param {?*} traverseContext Context for traversal.
                 * @return {!number} The number of children in this subtree.
                 */
                function traverseAllChildren(
                    children,
                    callback,
                    traverseContext
                ) {
                    if (children == null) {
                        return 0;
                    }

                    return traverseAllChildrenImpl(
                        children,
                        "",
                        callback,
                        traverseContext
                    );
                }

                module.exports = traverseAllChildren;

                /***/
            },
            /* 363 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                /* global Symbol */

                var ITERATOR_SYMBOL =
                    typeof Symbol === "function" && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.

                /**
                 * Returns the iterator method function contained on the iterable object.
                 *
                 * Be sure to invoke the function with the iterable as context:
                 *
                 *     var iteratorFn = getIteratorFn(myIterable);
                 *     if (iteratorFn) {
                 *       var iterator = iteratorFn.call(myIterable);
                 *       ...
                 *     }
                 *
                 * @param {?object} maybeIterable
                 * @return {?function}
                 */
                function getIteratorFn(maybeIterable) {
                    var iteratorFn =
                        maybeIterable &&
                        ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
                            maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if (typeof iteratorFn === "function") {
                        return iteratorFn;
                    }
                }

                module.exports = getIteratorFn;

                /***/
            },
            /* 364 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                /**
                 * Escape and wrap key so it is safe to use as a reactid
                 *
                 * @param {string} key to be escaped.
                 * @return {string} the escaped key.
                 */

                function escape(key) {
                    var escapeRegex = /[=:]/g;
                    var escaperLookup = {
                        "=": "=0",
                        ":": "=2",
                    };
                    var escapedString = ("" + key).replace(
                        escapeRegex,
                        function (match) {
                            return escaperLookup[match];
                        }
                    );

                    return "$" + escapedString;
                }

                /**
                 * Unescape and unwrap key for human-readable display
                 *
                 * @param {string} key to unescape.
                 * @return {string} the unescaped key.
                 */
                function unescape(key) {
                    var unescapeRegex = /(=0|=2)/g;
                    var unescaperLookup = {
                        "=0": "=",
                        "=2": ":",
                    };
                    var keySubstring =
                        key[0] === "." && key[1] === "$"
                            ? key.substring(2)
                            : key.substring(1);

                    return ("" + keySubstring).replace(
                        unescapeRegex,
                        function (match) {
                            return unescaperLookup[match];
                        }
                    );
                }

                var KeyEscapeUtils = {
                    escape: escape,
                    unescape: unescape,
                };

                module.exports = KeyEscapeUtils;

                /***/
            },
            /* 365 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(354);

                var ReactNoopUpdateQueue = __webpack_require__(366);

                var canDefineProperty = __webpack_require__(360);
                var emptyObject = __webpack_require__(367);
                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                /**
                 * Base class helpers for the updating state of a component.
                 */
                function ReactComponent(props, context, updater) {
                    this.props = props;
                    this.context = context;
                    this.refs = emptyObject;
                    // We initialize the default updater but the real one gets injected by the
                    // renderer.
                    this.updater = updater || ReactNoopUpdateQueue;
                }

                ReactComponent.prototype.isReactComponent = {};

                /**
                 * Sets a subset of the state. Always use this to mutate
                 * state. You should treat `this.state` as immutable.
                 *
                 * There is no guarantee that `this.state` will be immediately updated, so
                 * accessing `this.state` after calling this method may return the old value.
                 *
                 * There is no guarantee that calls to `setState` will run synchronously,
                 * as they may eventually be batched together.  You can provide an optional
                 * callback that will be executed when the call to setState is actually
                 * completed.
                 *
                 * When a function is provided to setState, it will be called at some point in
                 * the future (not synchronously). It will be called with the up to date
                 * component arguments (state, props, context). These values can be different
                 * from this.* because your function may be called after receiveProps but before
                 * shouldComponentUpdate, and this new state, props, and context will not yet be
                 * assigned to this.
                 *
                 * @param {object|function} partialState Next partial state or function to
                 *        produce next partial state to be merged with current state.
                 * @param {?function} callback Called after state is updated.
                 * @final
                 * @protected
                 */
                ReactComponent.prototype.setState = function (
                    partialState,
                    callback
                ) {
                    !(
                        typeof partialState === "object" ||
                        typeof partialState === "function" ||
                        partialState == null
                    )
                        ? false
                            ? invariant(
                                  false,
                                  "setState(...): takes an object of state variables to update or a function which returns an object of state variables."
                              )
                            : _prodInvariant("85")
                        : void 0;
                    this.updater.enqueueSetState(this, partialState);
                    if (callback) {
                        this.updater.enqueueCallback(
                            this,
                            callback,
                            "setState"
                        );
                    }
                };

                /**
                 * Forces an update. This should only be invoked when it is known with
                 * certainty that we are **not** in a DOM transaction.
                 *
                 * You may want to call this when you know that some deeper aspect of the
                 * component's state has changed but `setState` was not called.
                 *
                 * This will not invoke `shouldComponentUpdate`, but it will invoke
                 * `componentWillUpdate` and `componentDidUpdate`.
                 *
                 * @param {?function} callback Called after update is complete.
                 * @final
                 * @protected
                 */
                ReactComponent.prototype.forceUpdate = function (callback) {
                    this.updater.enqueueForceUpdate(this);
                    if (callback) {
                        this.updater.enqueueCallback(
                            this,
                            callback,
                            "forceUpdate"
                        );
                    }
                };

                /**
                 * Deprecated APIs. These APIs used to exist on classic React classes but since
                 * we would like to deprecate them, we're not going to move them over to this
                 * modern base class. Instead, we define a getter that warns if it's accessed.
                 */
                if (false) {
                    var deprecatedAPIs = {
                        isMounted: [
                            "isMounted",
                            "Instead, make sure to clean up subscriptions and pending requests in " +
                                "componentWillUnmount to prevent memory leaks.",
                        ],
                        replaceState: [
                            "replaceState",
                            "Refactor your code to use setState instead (see " +
                                "https://github.com/facebook/react/issues/3236).",
                        ],
                    };
                    var defineDeprecationWarning = function (methodName, info) {
                        if (canDefineProperty) {
                            Object.defineProperty(
                                ReactComponent.prototype,
                                methodName,
                                {
                                    get: function () {
                                        process.env.NODE_ENV !== "production"
                                            ? warning(
                                                  false,
                                                  "%s(...) is deprecated in plain JavaScript React classes. %s",
                                                  info[0],
                                                  info[1]
                                              )
                                            : void 0;
                                        return undefined;
                                    },
                                }
                            );
                        }
                    };
                    for (var fnName in deprecatedAPIs) {
                        if (deprecatedAPIs.hasOwnProperty(fnName)) {
                            defineDeprecationWarning(
                                fnName,
                                deprecatedAPIs[fnName]
                            );
                        }
                    }
                }

                module.exports = ReactComponent;

                /***/
            },
            /* 366 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var warning = __webpack_require__(358);

                function warnNoop(publicInstance, callerName) {
                    if (false) {
                        var constructor = publicInstance.constructor;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  false,
                                  "%s(...): Can only update a mounted or mounting component. " +
                                      "This usually means you called %s() on an unmounted component. " +
                                      "This is a no-op. Please check the code for the %s component.",
                                  callerName,
                                  callerName,
                                  (constructor &&
                                      (constructor.displayName ||
                                          constructor.name)) ||
                                      "ReactClass"
                              )
                            : void 0;
                    }
                }

                /**
                 * This is the abstract API for an update queue.
                 */
                var ReactNoopUpdateQueue = {
                    /**
                     * Checks whether or not this composite component is mounted.
                     * @param {ReactClass} publicInstance The instance we want to test.
                     * @return {boolean} True if mounted, false otherwise.
                     * @protected
                     * @final
                     */
                    isMounted: function (publicInstance) {
                        return false;
                    },

                    /**
                     * Enqueue a callback that will be executed after all the pending updates
                     * have processed.
                     *
                     * @param {ReactClass} publicInstance The instance to use as `this` context.
                     * @param {?function} callback Called after state is updated.
                     * @internal
                     */
                    enqueueCallback: function (publicInstance, callback) {},

                    /**
                     * Forces an update. This should only be invoked when it is known with
                     * certainty that we are **not** in a DOM transaction.
                     *
                     * You may want to call this when you know that some deeper aspect of the
                     * component's state has changed but `setState` was not called.
                     *
                     * This will not invoke `shouldComponentUpdate`, but it will invoke
                     * `componentWillUpdate` and `componentDidUpdate`.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @internal
                     */
                    enqueueForceUpdate: function (publicInstance) {
                        warnNoop(publicInstance, "forceUpdate");
                    },

                    /**
                     * Replaces all of the state. Always use this or `setState` to mutate state.
                     * You should treat `this.state` as immutable.
                     *
                     * There is no guarantee that `this.state` will be immediately updated, so
                     * accessing `this.state` after calling this method may return the old value.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object} completeState Next state.
                     * @internal
                     */
                    enqueueReplaceState: function (
                        publicInstance,
                        completeState
                    ) {
                        warnNoop(publicInstance, "replaceState");
                    },

                    /**
                     * Sets a subset of the state. This only exists because _pendingState is
                     * internal. This provides a merging strategy that is not available to deep
                     * properties which is confusing. TODO: Expose pendingState or don't use it
                     * during the merge.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object} partialState Next partial state to be merged with state.
                     * @internal
                     */
                    enqueueSetState: function (publicInstance, partialState) {
                        warnNoop(publicInstance, "setState");
                    },
                };

                module.exports = ReactNoopUpdateQueue;

                /***/
            },
            /* 367 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var emptyObject = {};

                if (false) {
                    Object.freeze(emptyObject);
                }

                module.exports = emptyObject;

                /***/
            },
            /* 368 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var ReactComponent = __webpack_require__(365);
                var ReactNoopUpdateQueue = __webpack_require__(366);

                var emptyObject = __webpack_require__(367);

                /**
                 * Base class helpers for the updating state of a component.
                 */
                function ReactPureComponent(props, context, updater) {
                    // Duplicated from ReactComponent.
                    this.props = props;
                    this.context = context;
                    this.refs = emptyObject;
                    // We initialize the default updater but the real one gets injected by the
                    // renderer.
                    this.updater = updater || ReactNoopUpdateQueue;
                }

                function ComponentDummy() {}
                ComponentDummy.prototype = ReactComponent.prototype;
                ReactPureComponent.prototype = new ComponentDummy();
                ReactPureComponent.prototype.constructor = ReactPureComponent;
                // Avoid an extra prototype jump for these methods.
                _assign(ReactPureComponent.prototype, ReactComponent.prototype);
                ReactPureComponent.prototype.isPureReactComponent = true;

                module.exports = ReactPureComponent;

                /***/
            },
            /* 369 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(354),
                    _assign = __webpack_require__(351);

                var ReactComponent = __webpack_require__(365);
                var ReactElement = __webpack_require__(356);
                var ReactPropTypeLocationNames = __webpack_require__(370);
                var ReactNoopUpdateQueue = __webpack_require__(366);

                var emptyObject = __webpack_require__(367);
                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                var MIXINS_KEY = "mixins";

                // Helper function to allow the creation of anonymous functions which do not
                // have .name set to the name of the variable being assigned to.
                function identity(fn) {
                    return fn;
                }

                /**
                 * Policies that describe methods in `ReactClassInterface`.
                 */

                var injectedMixins = [];

                /**
                 * Composite components are higher-level components that compose other composite
                 * or host components.
                 *
                 * To create a new type of `ReactClass`, pass a specification of
                 * your new class to `React.createClass`. The only requirement of your class
                 * specification is that you implement a `render` method.
                 *
                 *   var MyComponent = React.createClass({
                 *     render: function() {
                 *       return <div>Hello World</div>;
                 *     }
                 *   });
                 *
                 * The class specification supports a specific protocol of methods that have
                 * special meaning (e.g. `render`). See `ReactClassInterface` for
                 * more the comprehensive protocol. Any other properties and methods in the
                 * class specification will be available on the prototype.
                 *
                 * @interface ReactClassInterface
                 * @internal
                 */
                var ReactClassInterface = {
                    /**
                     * An array of Mixin objects to include when defining your component.
                     *
                     * @type {array}
                     * @optional
                     */
                    mixins: "DEFINE_MANY",

                    /**
                     * An object containing properties and methods that should be defined on
                     * the component's constructor instead of its prototype (static methods).
                     *
                     * @type {object}
                     * @optional
                     */
                    statics: "DEFINE_MANY",

                    /**
                     * Definition of prop types for this component.
                     *
                     * @type {object}
                     * @optional
                     */
                    propTypes: "DEFINE_MANY",

                    /**
                     * Definition of context types for this component.
                     *
                     * @type {object}
                     * @optional
                     */
                    contextTypes: "DEFINE_MANY",

                    /**
                     * Definition of context types this component sets for its children.
                     *
                     * @type {object}
                     * @optional
                     */
                    childContextTypes: "DEFINE_MANY",

                    // ==== Definition methods ====

                    /**
                     * Invoked when the component is mounted. Values in the mapping will be set on
                     * `this.props` if that prop is not specified (i.e. using an `in` check).
                     *
                     * This method is invoked before `getInitialState` and therefore cannot rely
                     * on `this.state` or use `this.setState`.
                     *
                     * @return {object}
                     * @optional
                     */
                    getDefaultProps: "DEFINE_MANY_MERGED",

                    /**
                     * Invoked once before the component is mounted. The return value will be used
                     * as the initial value of `this.state`.
                     *
                     *   getInitialState: function() {
                     *     return {
                     *       isOn: false,
                     *       fooBaz: new BazFoo()
                     *     }
                     *   }
                     *
                     * @return {object}
                     * @optional
                     */
                    getInitialState: "DEFINE_MANY_MERGED",

                    /**
                     * @return {object}
                     * @optional
                     */
                    getChildContext: "DEFINE_MANY_MERGED",

                    /**
                     * Uses props from `this.props` and state from `this.state` to render the
                     * structure of the component.
                     *
                     * No guarantees are made about when or how often this method is invoked, so
                     * it must not have side effects.
                     *
                     *   render: function() {
                     *     var name = this.props.name;
                     *     return <div>Hello, {name}!</div>;
                     *   }
                     *
                     * @return {ReactComponent}
                     * @nosideeffects
                     * @required
                     */
                    render: "DEFINE_ONCE",

                    // ==== Delegate methods ====

                    /**
                     * Invoked when the component is initially created and about to be mounted.
                     * This may have side effects, but any external subscriptions or data created
                     * by this method must be cleaned up in `componentWillUnmount`.
                     *
                     * @optional
                     */
                    componentWillMount: "DEFINE_MANY",

                    /**
                     * Invoked when the component has been mounted and has a DOM representation.
                     * However, there is no guarantee that the DOM node is in the document.
                     *
                     * Use this as an opportunity to operate on the DOM when the component has
                     * been mounted (initialized and rendered) for the first time.
                     *
                     * @param {DOMElement} rootNode DOM element representing the component.
                     * @optional
                     */
                    componentDidMount: "DEFINE_MANY",

                    /**
                     * Invoked before the component receives new props.
                     *
                     * Use this as an opportunity to react to a prop transition by updating the
                     * state using `this.setState`. Current props are accessed via `this.props`.
                     *
                     *   componentWillReceiveProps: function(nextProps, nextContext) {
                     *     this.setState({
                     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
                     *     });
                     *   }
                     *
                     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
                     * transition may cause a state change, but the opposite is not true. If you
                     * need it, you are probably looking for `componentWillUpdate`.
                     *
                     * @param {object} nextProps
                     * @optional
                     */
                    componentWillReceiveProps: "DEFINE_MANY",

                    /**
                     * Invoked while deciding if the component should be updated as a result of
                     * receiving new props, state and/or context.
                     *
                     * Use this as an opportunity to `return false` when you're certain that the
                     * transition to the new props/state/context will not require a component
                     * update.
                     *
                     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
                     *     return !equal(nextProps, this.props) ||
                     *       !equal(nextState, this.state) ||
                     *       !equal(nextContext, this.context);
                     *   }
                     *
                     * @param {object} nextProps
                     * @param {?object} nextState
                     * @param {?object} nextContext
                     * @return {boolean} True if the component should update.
                     * @optional
                     */
                    shouldComponentUpdate: "DEFINE_ONCE",

                    /**
                     * Invoked when the component is about to update due to a transition from
                     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
                     * and `nextContext`.
                     *
                     * Use this as an opportunity to perform preparation before an update occurs.
                     *
                     * NOTE: You **cannot** use `this.setState()` in this method.
                     *
                     * @param {object} nextProps
                     * @param {?object} nextState
                     * @param {?object} nextContext
                     * @param {ReactReconcileTransaction} transaction
                     * @optional
                     */
                    componentWillUpdate: "DEFINE_MANY",

                    /**
                     * Invoked when the component's DOM representation has been updated.
                     *
                     * Use this as an opportunity to operate on the DOM when the component has
                     * been updated.
                     *
                     * @param {object} prevProps
                     * @param {?object} prevState
                     * @param {?object} prevContext
                     * @param {DOMElement} rootNode DOM element representing the component.
                     * @optional
                     */
                    componentDidUpdate: "DEFINE_MANY",

                    /**
                     * Invoked when the component is about to be removed from its parent and have
                     * its DOM representation destroyed.
                     *
                     * Use this as an opportunity to deallocate any external resources.
                     *
                     * NOTE: There is no `componentDidUnmount` since your component will have been
                     * destroyed by that point.
                     *
                     * @optional
                     */
                    componentWillUnmount: "DEFINE_MANY",

                    // ==== Advanced methods ====

                    /**
                     * Updates the component's currently mounted DOM representation.
                     *
                     * By default, this implements React's rendering and reconciliation algorithm.
                     * Sophisticated clients may wish to override this.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     * @overridable
                     */
                    updateComponent: "OVERRIDE_BASE",
                };

                /**
                 * Mapping from class specification keys to special processing functions.
                 *
                 * Although these are declared like instance properties in the specification
                 * when defining classes using `React.createClass`, they are actually static
                 * and are accessible on the constructor instead of the prototype. Despite
                 * being static, they must be defined outside of the "statics" key under
                 * which all other static methods are defined.
                 */
                var RESERVED_SPEC_KEYS = {
                    displayName: function (Constructor, displayName) {
                        Constructor.displayName = displayName;
                    },
                    mixins: function (Constructor, mixins) {
                        if (mixins) {
                            for (var i = 0; i < mixins.length; i++) {
                                mixSpecIntoComponent(Constructor, mixins[i]);
                            }
                        }
                    },
                    childContextTypes: function (
                        Constructor,
                        childContextTypes
                    ) {
                        if (false) {
                            validateTypeDef(
                                Constructor,
                                childContextTypes,
                                "childContext"
                            );
                        }
                        Constructor.childContextTypes = _assign(
                            {},
                            Constructor.childContextTypes,
                            childContextTypes
                        );
                    },
                    contextTypes: function (Constructor, contextTypes) {
                        if (false) {
                            validateTypeDef(
                                Constructor,
                                contextTypes,
                                "context"
                            );
                        }
                        Constructor.contextTypes = _assign(
                            {},
                            Constructor.contextTypes,
                            contextTypes
                        );
                    },
                    /**
                     * Special case getDefaultProps which should move into statics but requires
                     * automatic merging.
                     */
                    getDefaultProps: function (Constructor, getDefaultProps) {
                        if (Constructor.getDefaultProps) {
                            Constructor.getDefaultProps =
                                createMergedResultFunction(
                                    Constructor.getDefaultProps,
                                    getDefaultProps
                                );
                        } else {
                            Constructor.getDefaultProps = getDefaultProps;
                        }
                    },
                    propTypes: function (Constructor, propTypes) {
                        if (false) {
                            validateTypeDef(Constructor, propTypes, "prop");
                        }
                        Constructor.propTypes = _assign(
                            {},
                            Constructor.propTypes,
                            propTypes
                        );
                    },
                    statics: function (Constructor, statics) {
                        mixStaticSpecIntoComponent(Constructor, statics);
                    },
                    autobind: function () {},
                };

                function validateTypeDef(Constructor, typeDef, location) {
                    for (var propName in typeDef) {
                        if (typeDef.hasOwnProperty(propName)) {
                            // use a warning instead of an invariant so components
                            // don't show up in prod but only in __DEV__
                            false
                                ? warning(
                                      typeof typeDef[propName] === "function",
                                      "%s: %s type `%s` is invalid; it must be a function, usually from " +
                                          "React.PropTypes.",
                                      Constructor.displayName || "ReactClass",
                                      ReactPropTypeLocationNames[location],
                                      propName
                                  )
                                : void 0;
                        }
                    }
                }

                function validateMethodOverride(isAlreadyDefined, name) {
                    var specPolicy = ReactClassInterface.hasOwnProperty(name)
                        ? ReactClassInterface[name]
                        : null;

                    // Disallow overriding of base class methods unless explicitly allowed.
                    if (ReactClassMixin.hasOwnProperty(name)) {
                        !(specPolicy === "OVERRIDE_BASE")
                            ? false
                                ? invariant(
                                      false,
                                      "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",
                                      name
                                  )
                                : _prodInvariant("73", name)
                            : void 0;
                    }

                    // Disallow defining methods more than once unless explicitly allowed.
                    if (isAlreadyDefined) {
                        !(
                            specPolicy === "DEFINE_MANY" ||
                            specPolicy === "DEFINE_MANY_MERGED"
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
                                      name
                                  )
                                : _prodInvariant("74", name)
                            : void 0;
                    }
                }

                /**
                 * Mixin helper which handles policy validation and reserved
                 * specification keys when building React classes.
                 */
                function mixSpecIntoComponent(Constructor, spec) {
                    if (!spec) {
                        if (false) {
                            var typeofSpec = typeof spec;
                            var isMixinValid =
                                typeofSpec === "object" && spec !== null;

                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      isMixinValid,
                                      "%s: You're attempting to include a mixin that is either null " +
                                          "or not an object. Check the mixins included by the component, " +
                                          "as well as any mixins they include themselves. " +
                                          "Expected object but got %s.",
                                      Constructor.displayName || "ReactClass",
                                      spec === null ? null : typeofSpec
                                  )
                                : void 0;
                        }

                        return;
                    }

                    !(typeof spec !== "function")
                        ? false
                            ? invariant(
                                  false,
                                  "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."
                              )
                            : _prodInvariant("75")
                        : void 0;
                    !!ReactElement.isValidElement(spec)
                        ? false
                            ? invariant(
                                  false,
                                  "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object."
                              )
                            : _prodInvariant("76")
                        : void 0;

                    var proto = Constructor.prototype;
                    var autoBindPairs = proto.__reactAutoBindPairs;

                    // By handling mixins before any other properties, we ensure the same
                    // chaining order is applied to methods with DEFINE_MANY policy, whether
                    // mixins are listed before or after these methods in the spec.
                    if (spec.hasOwnProperty(MIXINS_KEY)) {
                        RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
                    }

                    for (var name in spec) {
                        if (!spec.hasOwnProperty(name)) {
                            continue;
                        }

                        if (name === MIXINS_KEY) {
                            // We have already handled mixins in a special case above.
                            continue;
                        }

                        var property = spec[name];
                        var isAlreadyDefined = proto.hasOwnProperty(name);
                        validateMethodOverride(isAlreadyDefined, name);

                        if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
                            RESERVED_SPEC_KEYS[name](Constructor, property);
                        } else {
                            // Setup methods on prototype:
                            // The following member methods should not be automatically bound:
                            // 1. Expected ReactClass methods (in the "interface").
                            // 2. Overridden methods (that were mixed in).
                            var isReactClassMethod =
                                ReactClassInterface.hasOwnProperty(name);
                            var isFunction = typeof property === "function";
                            var shouldAutoBind =
                                isFunction &&
                                !isReactClassMethod &&
                                !isAlreadyDefined &&
                                spec.autobind !== false;

                            if (shouldAutoBind) {
                                autoBindPairs.push(name, property);
                                proto[name] = property;
                            } else {
                                if (isAlreadyDefined) {
                                    var specPolicy = ReactClassInterface[name];

                                    // These cases should already be caught by validateMethodOverride.
                                    !(
                                        isReactClassMethod &&
                                        (specPolicy === "DEFINE_MANY_MERGED" ||
                                            specPolicy === "DEFINE_MANY")
                                    )
                                        ? false
                                            ? invariant(
                                                  false,
                                                  "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",
                                                  specPolicy,
                                                  name
                                              )
                                            : _prodInvariant(
                                                  "77",
                                                  specPolicy,
                                                  name
                                              )
                                        : void 0;

                                    // For methods which are defined more than once, call the existing
                                    // methods before calling the new property, merging if appropriate.
                                    if (specPolicy === "DEFINE_MANY_MERGED") {
                                        proto[name] =
                                            createMergedResultFunction(
                                                proto[name],
                                                property
                                            );
                                    } else if (specPolicy === "DEFINE_MANY") {
                                        proto[name] = createChainedFunction(
                                            proto[name],
                                            property
                                        );
                                    }
                                } else {
                                    proto[name] = property;
                                    if (false) {
                                        // Add verbose displayName to the function, which helps when looking
                                        // at profiling tools.
                                        if (
                                            typeof property === "function" &&
                                            spec.displayName
                                        ) {
                                            proto[name].displayName =
                                                spec.displayName + "_" + name;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                function mixStaticSpecIntoComponent(Constructor, statics) {
                    if (!statics) {
                        return;
                    }
                    for (var name in statics) {
                        var property = statics[name];
                        if (!statics.hasOwnProperty(name)) {
                            continue;
                        }

                        var isReserved = name in RESERVED_SPEC_KEYS;
                        !!isReserved
                            ? false
                                ? invariant(
                                      false,
                                      'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',
                                      name
                                  )
                                : _prodInvariant("78", name)
                            : void 0;

                        var isInherited = name in Constructor;
                        !!isInherited
                            ? false
                                ? invariant(
                                      false,
                                      "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
                                      name
                                  )
                                : _prodInvariant("79", name)
                            : void 0;
                        Constructor[name] = property;
                    }
                }

                /**
                 * Merge two objects, but throw if both contain the same key.
                 *
                 * @param {object} one The first object, which is mutated.
                 * @param {object} two The second object
                 * @return {object} one after it has been mutated to contain everything in two.
                 */
                function mergeIntoWithNoDuplicateKeys(one, two) {
                    !(
                        one &&
                        two &&
                        typeof one === "object" &&
                        typeof two === "object"
                    )
                        ? false
                            ? invariant(
                                  false,
                                  "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."
                              )
                            : _prodInvariant("80")
                        : void 0;

                    for (var key in two) {
                        if (two.hasOwnProperty(key)) {
                            !(one[key] === undefined)
                                ? false
                                    ? invariant(
                                          false,
                                          "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",
                                          key
                                      )
                                    : _prodInvariant("81", key)
                                : void 0;
                            one[key] = two[key];
                        }
                    }
                    return one;
                }

                /**
                 * Creates a function that invokes two functions and merges their return values.
                 *
                 * @param {function} one Function to invoke first.
                 * @param {function} two Function to invoke second.
                 * @return {function} Function that invokes the two argument functions.
                 * @private
                 */
                function createMergedResultFunction(one, two) {
                    return function mergedResult() {
                        var a = one.apply(this, arguments);
                        var b = two.apply(this, arguments);
                        if (a == null) {
                            return b;
                        } else if (b == null) {
                            return a;
                        }
                        var c = {};
                        mergeIntoWithNoDuplicateKeys(c, a);
                        mergeIntoWithNoDuplicateKeys(c, b);
                        return c;
                    };
                }

                /**
                 * Creates a function that invokes two functions and ignores their return vales.
                 *
                 * @param {function} one Function to invoke first.
                 * @param {function} two Function to invoke second.
                 * @return {function} Function that invokes the two argument functions.
                 * @private
                 */
                function createChainedFunction(one, two) {
                    return function chainedFunction() {
                        one.apply(this, arguments);
                        two.apply(this, arguments);
                    };
                }

                /**
                 * Binds a method to the component.
                 *
                 * @param {object} component Component whose method is going to be bound.
                 * @param {function} method Method to be bound.
                 * @return {function} The bound method.
                 */
                function bindAutoBindMethod(component, method) {
                    var boundMethod = method.bind(component);
                    if (false) {
                        boundMethod.__reactBoundContext = component;
                        boundMethod.__reactBoundMethod = method;
                        boundMethod.__reactBoundArguments = null;
                        var componentName = component.constructor.displayName;
                        var _bind = boundMethod.bind;
                        boundMethod.bind = function (newThis) {
                            for (
                                var _len = arguments.length,
                                    args = Array(_len > 1 ? _len - 1 : 0),
                                    _key = 1;
                                _key < _len;
                                _key++
                            ) {
                                args[_key - 1] = arguments[_key];
                            }

                            // User is trying to bind() an autobound method; we effectively will
                            // ignore the value of "this" that the user is trying to use, so
                            // let's warn.
                            if (newThis !== component && newThis !== null) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "bind(): React component methods may only be bound to the " +
                                              "component instance. See %s",
                                          componentName
                                      )
                                    : void 0;
                            } else if (!args.length) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "bind(): You are binding a component method to the component. " +
                                              "React does this for you automatically in a high-performance " +
                                              "way, so you can safely remove this call. See %s",
                                          componentName
                                      )
                                    : void 0;
                                return boundMethod;
                            }
                            var reboundMethod = _bind.apply(
                                boundMethod,
                                arguments
                            );
                            reboundMethod.__reactBoundContext = component;
                            reboundMethod.__reactBoundMethod = method;
                            reboundMethod.__reactBoundArguments = args;
                            return reboundMethod;
                        };
                    }
                    return boundMethod;
                }

                /**
                 * Binds all auto-bound methods in a component.
                 *
                 * @param {object} component Component whose method is going to be bound.
                 */
                function bindAutoBindMethods(component) {
                    var pairs = component.__reactAutoBindPairs;
                    for (var i = 0; i < pairs.length; i += 2) {
                        var autoBindKey = pairs[i];
                        var method = pairs[i + 1];
                        component[autoBindKey] = bindAutoBindMethod(
                            component,
                            method
                        );
                    }
                }

                /**
                 * Add more to the ReactClass base class. These are all legacy features and
                 * therefore not already part of the modern ReactComponent.
                 */
                var ReactClassMixin = {
                    /**
                     * TODO: This will be deprecated because state should always keep a consistent
                     * type signature and the only use case for this, is to avoid that.
                     */
                    replaceState: function (newState, callback) {
                        this.updater.enqueueReplaceState(this, newState);
                        if (callback) {
                            this.updater.enqueueCallback(
                                this,
                                callback,
                                "replaceState"
                            );
                        }
                    },

                    /**
                     * Checks whether or not this composite component is mounted.
                     * @return {boolean} True if mounted, false otherwise.
                     * @protected
                     * @final
                     */
                    isMounted: function () {
                        return this.updater.isMounted(this);
                    },
                };

                var ReactClassComponent = function () {};
                _assign(
                    ReactClassComponent.prototype,
                    ReactComponent.prototype,
                    ReactClassMixin
                );

                /**
                 * Module for creating composite components.
                 *
                 * @class ReactClass
                 */
                var ReactClass = {
                    /**
                     * Creates a composite component class given a class specification.
                     * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
                     *
                     * @param {object} spec Class specification (which must define `render`).
                     * @return {function} Component constructor function.
                     * @public
                     */
                    createClass: function (spec) {
                        // To keep our warnings more understandable, we'll use a little hack here to
                        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
                        // unnecessarily identify a class without displayName as 'Constructor'.
                        var Constructor = identity(function (
                            props,
                            context,
                            updater
                        ) {
                            // This constructor gets overridden by mocks. The argument is used
                            // by mocks to assert on what gets mounted.

                            if (false) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          this instanceof Constructor,
                                          "Something is calling a React component directly. Use a factory or " +
                                              "JSX instead. See: https://fb.me/react-legacyfactory"
                                      )
                                    : void 0;
                            }

                            // Wire up auto-binding
                            if (this.__reactAutoBindPairs.length) {
                                bindAutoBindMethods(this);
                            }

                            this.props = props;
                            this.context = context;
                            this.refs = emptyObject;
                            this.updater = updater || ReactNoopUpdateQueue;

                            this.state = null;

                            // ReactClasses doesn't have constructors. Instead, they use the
                            // getInitialState and componentWillMount methods for initialization.

                            var initialState = this.getInitialState
                                ? this.getInitialState()
                                : null;
                            if (false) {
                                // We allow auto-mocks to proceed as if they're returning null.
                                if (
                                    initialState === undefined &&
                                    this.getInitialState._isMockFunction
                                ) {
                                    // This is probably bad practice. Consider warning here and
                                    // deprecating this convenience.
                                    initialState = null;
                                }
                            }
                            !(
                                typeof initialState === "object" &&
                                !Array.isArray(initialState)
                            )
                                ? false
                                    ? invariant(
                                          false,
                                          "%s.getInitialState(): must return an object or null",
                                          Constructor.displayName ||
                                              "ReactCompositeComponent"
                                      )
                                    : _prodInvariant(
                                          "82",
                                          Constructor.displayName ||
                                              "ReactCompositeComponent"
                                      )
                                : void 0;

                            this.state = initialState;
                        });
                        Constructor.prototype = new ReactClassComponent();
                        Constructor.prototype.constructor = Constructor;
                        Constructor.prototype.__reactAutoBindPairs = [];

                        injectedMixins.forEach(
                            mixSpecIntoComponent.bind(null, Constructor)
                        );

                        mixSpecIntoComponent(Constructor, spec);

                        // Initialize the defaultProps property after all mixins have been merged.
                        if (Constructor.getDefaultProps) {
                            Constructor.defaultProps =
                                Constructor.getDefaultProps();
                        }

                        if (false) {
                            // This is a tag to indicate that the use of these method names is ok,
                            // since it's used with createClass. If it's not, then it's likely a
                            // mistake so we'll warn you to use the static property, property
                            // initializer or constructor respectively.
                            if (Constructor.getDefaultProps) {
                                Constructor.getDefaultProps.isReactClassApproved =
                                    {};
                            }
                            if (Constructor.prototype.getInitialState) {
                                Constructor.prototype.getInitialState.isReactClassApproved =
                                    {};
                            }
                        }

                        !Constructor.prototype.render
                            ? false
                                ? invariant(
                                      false,
                                      "createClass(...): Class specification must implement a `render` method."
                                  )
                                : _prodInvariant("83")
                            : void 0;

                        if (false) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !Constructor.prototype
                                          .componentShouldUpdate,
                                      "%s has a method called " +
                                          "componentShouldUpdate(). Did you mean shouldComponentUpdate()? " +
                                          "The name is phrased as a question because the function is " +
                                          "expected to return a value.",
                                      spec.displayName || "A component"
                                  )
                                : void 0;
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !Constructor.prototype
                                          .componentWillRecieveProps,
                                      "%s has a method called " +
                                          "componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
                                      spec.displayName || "A component"
                                  )
                                : void 0;
                        }

                        // Reduce time spent doing lookups by setting these on the prototype.
                        for (var methodName in ReactClassInterface) {
                            if (!Constructor.prototype[methodName]) {
                                Constructor.prototype[methodName] = null;
                            }
                        }

                        return Constructor;
                    },

                    injection: {
                        injectMixin: function (mixin) {
                            injectedMixins.push(mixin);
                        },
                    },
                };

                module.exports = ReactClass;

                /***/
            },
            /* 370 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var ReactPropTypeLocationNames = {};

                if (false) {
                    ReactPropTypeLocationNames = {
                        prop: "prop",
                        context: "context",
                        childContext: "child context",
                    };
                }

                module.exports = ReactPropTypeLocationNames;

                /***/
            },
            /* 371 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactElement = __webpack_require__(356);

                /**
                 * Create a factory that creates HTML tag elements.
                 *
                 * @private
                 */
                var createDOMFactory = ReactElement.createFactory;
                if (false) {
                    var ReactElementValidator = require("./ReactElementValidator");
                    createDOMFactory = ReactElementValidator.createFactory;
                }

                /**
                 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
                 * This is also accessible via `React.DOM`.
                 *
                 * @public
                 */
                var ReactDOMFactories = {
                    a: createDOMFactory("a"),
                    abbr: createDOMFactory("abbr"),
                    address: createDOMFactory("address"),
                    area: createDOMFactory("area"),
                    article: createDOMFactory("article"),
                    aside: createDOMFactory("aside"),
                    audio: createDOMFactory("audio"),
                    b: createDOMFactory("b"),
                    base: createDOMFactory("base"),
                    bdi: createDOMFactory("bdi"),
                    bdo: createDOMFactory("bdo"),
                    big: createDOMFactory("big"),
                    blockquote: createDOMFactory("blockquote"),
                    body: createDOMFactory("body"),
                    br: createDOMFactory("br"),
                    button: createDOMFactory("button"),
                    canvas: createDOMFactory("canvas"),
                    caption: createDOMFactory("caption"),
                    cite: createDOMFactory("cite"),
                    code: createDOMFactory("code"),
                    col: createDOMFactory("col"),
                    colgroup: createDOMFactory("colgroup"),
                    data: createDOMFactory("data"),
                    datalist: createDOMFactory("datalist"),
                    dd: createDOMFactory("dd"),
                    del: createDOMFactory("del"),
                    details: createDOMFactory("details"),
                    dfn: createDOMFactory("dfn"),
                    dialog: createDOMFactory("dialog"),
                    div: createDOMFactory("div"),
                    dl: createDOMFactory("dl"),
                    dt: createDOMFactory("dt"),
                    em: createDOMFactory("em"),
                    embed: createDOMFactory("embed"),
                    fieldset: createDOMFactory("fieldset"),
                    figcaption: createDOMFactory("figcaption"),
                    figure: createDOMFactory("figure"),
                    footer: createDOMFactory("footer"),
                    form: createDOMFactory("form"),
                    h1: createDOMFactory("h1"),
                    h2: createDOMFactory("h2"),
                    h3: createDOMFactory("h3"),
                    h4: createDOMFactory("h4"),
                    h5: createDOMFactory("h5"),
                    h6: createDOMFactory("h6"),
                    head: createDOMFactory("head"),
                    header: createDOMFactory("header"),
                    hgroup: createDOMFactory("hgroup"),
                    hr: createDOMFactory("hr"),
                    html: createDOMFactory("html"),
                    i: createDOMFactory("i"),
                    iframe: createDOMFactory("iframe"),
                    img: createDOMFactory("img"),
                    input: createDOMFactory("input"),
                    ins: createDOMFactory("ins"),
                    kbd: createDOMFactory("kbd"),
                    keygen: createDOMFactory("keygen"),
                    label: createDOMFactory("label"),
                    legend: createDOMFactory("legend"),
                    li: createDOMFactory("li"),
                    link: createDOMFactory("link"),
                    main: createDOMFactory("main"),
                    map: createDOMFactory("map"),
                    mark: createDOMFactory("mark"),
                    menu: createDOMFactory("menu"),
                    menuitem: createDOMFactory("menuitem"),
                    meta: createDOMFactory("meta"),
                    meter: createDOMFactory("meter"),
                    nav: createDOMFactory("nav"),
                    noscript: createDOMFactory("noscript"),
                    object: createDOMFactory("object"),
                    ol: createDOMFactory("ol"),
                    optgroup: createDOMFactory("optgroup"),
                    option: createDOMFactory("option"),
                    output: createDOMFactory("output"),
                    p: createDOMFactory("p"),
                    param: createDOMFactory("param"),
                    picture: createDOMFactory("picture"),
                    pre: createDOMFactory("pre"),
                    progress: createDOMFactory("progress"),
                    q: createDOMFactory("q"),
                    rp: createDOMFactory("rp"),
                    rt: createDOMFactory("rt"),
                    ruby: createDOMFactory("ruby"),
                    s: createDOMFactory("s"),
                    samp: createDOMFactory("samp"),
                    script: createDOMFactory("script"),
                    section: createDOMFactory("section"),
                    select: createDOMFactory("select"),
                    small: createDOMFactory("small"),
                    source: createDOMFactory("source"),
                    span: createDOMFactory("span"),
                    strong: createDOMFactory("strong"),
                    style: createDOMFactory("style"),
                    sub: createDOMFactory("sub"),
                    summary: createDOMFactory("summary"),
                    sup: createDOMFactory("sup"),
                    table: createDOMFactory("table"),
                    tbody: createDOMFactory("tbody"),
                    td: createDOMFactory("td"),
                    textarea: createDOMFactory("textarea"),
                    tfoot: createDOMFactory("tfoot"),
                    th: createDOMFactory("th"),
                    thead: createDOMFactory("thead"),
                    time: createDOMFactory("time"),
                    title: createDOMFactory("title"),
                    tr: createDOMFactory("tr"),
                    track: createDOMFactory("track"),
                    u: createDOMFactory("u"),
                    ul: createDOMFactory("ul"),
                    var: createDOMFactory("var"),
                    video: createDOMFactory("video"),
                    wbr: createDOMFactory("wbr"),

                    // SVG
                    circle: createDOMFactory("circle"),
                    clipPath: createDOMFactory("clipPath"),
                    defs: createDOMFactory("defs"),
                    ellipse: createDOMFactory("ellipse"),
                    g: createDOMFactory("g"),
                    image: createDOMFactory("image"),
                    line: createDOMFactory("line"),
                    linearGradient: createDOMFactory("linearGradient"),
                    mask: createDOMFactory("mask"),
                    path: createDOMFactory("path"),
                    pattern: createDOMFactory("pattern"),
                    polygon: createDOMFactory("polygon"),
                    polyline: createDOMFactory("polyline"),
                    radialGradient: createDOMFactory("radialGradient"),
                    rect: createDOMFactory("rect"),
                    stop: createDOMFactory("stop"),
                    svg: createDOMFactory("svg"),
                    text: createDOMFactory("text"),
                    tspan: createDOMFactory("tspan"),
                };

                module.exports = ReactDOMFactories;

                /***/
            },
            /* 372 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactElement = __webpack_require__(356);
                var ReactPropTypeLocationNames = __webpack_require__(370);
                var ReactPropTypesSecret = __webpack_require__(373);

                var emptyFunction = __webpack_require__(359);
                var getIteratorFn = __webpack_require__(363);
                var warning = __webpack_require__(358);

                /**
                 * Collection of methods that allow declaration and validation of props that are
                 * supplied to React components. Example usage:
                 *
                 *   var Props = require('ReactPropTypes');
                 *   var MyArticle = React.createClass({
                 *     propTypes: {
                 *       // An optional string prop named "description".
                 *       description: Props.string,
                 *
                 *       // A required enum prop named "category".
                 *       category: Props.oneOf(['News','Photos']).isRequired,
                 *
                 *       // A prop named "dialog" that requires an instance of Dialog.
                 *       dialog: Props.instanceOf(Dialog).isRequired
                 *     },
                 *     render: function() { ... }
                 *   });
                 *
                 * A more formal specification of how these methods are used:
                 *
                 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
                 *   decl := ReactPropTypes.{type}(.isRequired)?
                 *
                 * Each and every declaration produces a function with the same signature. This
                 * allows the creation of custom validation functions. For example:
                 *
                 *  var MyLink = React.createClass({
                 *    propTypes: {
                 *      // An optional string or URI prop named "href".
                 *      href: function(props, propName, componentName) {
                 *        var propValue = props[propName];
                 *        if (propValue != null && typeof propValue !== 'string' &&
                 *            !(propValue instanceof URI)) {
                 *          return new Error(
                 *            'Expected a string or an URI for ' + propName + ' in ' +
                 *            componentName
                 *          );
                 *        }
                 *      }
                 *    },
                 *    render: function() {...}
                 *  });
                 *
                 * @internal
                 */

                var ANONYMOUS = "<<anonymous>>";

                var ReactPropTypes = {
                    array: createPrimitiveTypeChecker("array"),
                    bool: createPrimitiveTypeChecker("boolean"),
                    func: createPrimitiveTypeChecker("function"),
                    number: createPrimitiveTypeChecker("number"),
                    object: createPrimitiveTypeChecker("object"),
                    string: createPrimitiveTypeChecker("string"),
                    symbol: createPrimitiveTypeChecker("symbol"),

                    any: createAnyTypeChecker(),
                    arrayOf: createArrayOfTypeChecker,
                    element: createElementTypeChecker(),
                    instanceOf: createInstanceTypeChecker,
                    node: createNodeChecker(),
                    objectOf: createObjectOfTypeChecker,
                    oneOf: createEnumTypeChecker,
                    oneOfType: createUnionTypeChecker,
                    shape: createShapeTypeChecker,
                };

                /**
                 * inlined Object.is polyfill to avoid requiring consumers ship their own
                 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
                 */
                /*eslint-disable no-self-compare*/
                function is(x, y) {
                    // SameValue algorithm
                    if (x === y) {
                        // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        return x !== 0 || 1 / x === 1 / y;
                    } else {
                        // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                }
                /*eslint-enable no-self-compare*/

                /**
                 * We use an Error-like object for backward compatibility as people may call
                 * PropTypes directly and inspect their output. However we don't use real
                 * Errors anymore. We don't inspect their stack anyway, and creating them
                 * is prohibitively expensive if they are created too often, such as what
                 * happens in oneOfType() for any type before the one that matched.
                 */
                function PropTypeError(message) {
                    this.message = message;
                    this.stack = "";
                }
                // Make `instanceof Error` still work for returned errors.
                PropTypeError.prototype = Error.prototype;

                function createChainableTypeChecker(validate) {
                    if (false) {
                        var manualPropTypeCallCache = {};
                    }
                    function checkType(
                        isRequired,
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName,
                        secret
                    ) {
                        componentName = componentName || ANONYMOUS;
                        propFullName = propFullName || propName;
                        if (false) {
                            if (
                                secret !== ReactPropTypesSecret &&
                                typeof console !== "undefined"
                            ) {
                                var cacheKey = componentName + ":" + propName;
                                if (!manualPropTypeCallCache[cacheKey]) {
                                    process.env.NODE_ENV !== "production"
                                        ? warning(
                                              false,
                                              "You are manually calling a React.PropTypes validation " +
                                                  "function for the `%s` prop on `%s`. This is deprecated " +
                                                  "and will not work in production with the next major version. " +
                                                  "You may be seeing this warning due to a third-party PropTypes " +
                                                  "library. See https://fb.me/react-warning-dont-call-proptypes " +
                                                  "for details.",
                                              propFullName,
                                              componentName
                                          )
                                        : void 0;
                                    manualPropTypeCallCache[cacheKey] = true;
                                }
                            }
                        }
                        if (props[propName] == null) {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            if (isRequired) {
                                if (props[propName] === null) {
                                    return new PropTypeError(
                                        "The " +
                                            locationName +
                                            " `" +
                                            propFullName +
                                            "` is marked as required " +
                                            ("in `" +
                                                componentName +
                                                "`, but its value is `null`.")
                                    );
                                }
                                return new PropTypeError(
                                    "The " +
                                        locationName +
                                        " `" +
                                        propFullName +
                                        "` is marked as required in " +
                                        ("`" +
                                            componentName +
                                            "`, but its value is `undefined`.")
                                );
                            }
                            return null;
                        } else {
                            return validate(
                                props,
                                propName,
                                componentName,
                                location,
                                propFullName
                            );
                        }
                    }

                    var chainedCheckType = checkType.bind(null, false);
                    chainedCheckType.isRequired = checkType.bind(null, true);

                    return chainedCheckType;
                }

                function createPrimitiveTypeChecker(expectedType) {
                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName,
                        secret
                    ) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== expectedType) {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            // `propValue` being instance of, say, date/regexp, pass the 'object'
                            // check, but we can offer a more precise error message here rather than
                            // 'of type `object`'.
                            var preciseType = getPreciseType(propValue);

                            return new PropTypeError(
                                "Invalid " +
                                    locationName +
                                    " `" +
                                    propFullName +
                                    "` of type " +
                                    ("`" +
                                        preciseType +
                                        "` supplied to `" +
                                        componentName +
                                        "`, expected ") +
                                    ("`" + expectedType + "`.")
                            );
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createAnyTypeChecker() {
                    return createChainableTypeChecker(
                        emptyFunction.thatReturns(null)
                    );
                }

                function createArrayOfTypeChecker(typeChecker) {
                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        if (typeof typeChecker !== "function") {
                            return new PropTypeError(
                                "Property `" +
                                    propFullName +
                                    "` of component `" +
                                    componentName +
                                    "` has invalid PropType notation inside arrayOf."
                            );
                        }
                        var propValue = props[propName];
                        if (!Array.isArray(propValue)) {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            var propType = getPropType(propValue);
                            return new PropTypeError(
                                "Invalid " +
                                    locationName +
                                    " `" +
                                    propFullName +
                                    "` of type " +
                                    ("`" +
                                        propType +
                                        "` supplied to `" +
                                        componentName +
                                        "`, expected an array.")
                            );
                        }
                        for (var i = 0; i < propValue.length; i++) {
                            var error = typeChecker(
                                propValue,
                                i,
                                componentName,
                                location,
                                propFullName + "[" + i + "]",
                                ReactPropTypesSecret
                            );
                            if (error instanceof Error) {
                                return error;
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createElementTypeChecker() {
                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        var propValue = props[propName];
                        if (!ReactElement.isValidElement(propValue)) {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            var propType = getPropType(propValue);
                            return new PropTypeError(
                                "Invalid " +
                                    locationName +
                                    " `" +
                                    propFullName +
                                    "` of type " +
                                    ("`" +
                                        propType +
                                        "` supplied to `" +
                                        componentName +
                                        "`, expected a single ReactElement.")
                            );
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createInstanceTypeChecker(expectedClass) {
                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        if (!(props[propName] instanceof expectedClass)) {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            var expectedClassName =
                                expectedClass.name || ANONYMOUS;
                            var actualClassName = getClassName(props[propName]);
                            return new PropTypeError(
                                "Invalid " +
                                    locationName +
                                    " `" +
                                    propFullName +
                                    "` of type " +
                                    ("`" +
                                        actualClassName +
                                        "` supplied to `" +
                                        componentName +
                                        "`, expected ") +
                                    ("instance of `" + expectedClassName + "`.")
                            );
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createEnumTypeChecker(expectedValues) {
                    if (!Array.isArray(expectedValues)) {
                        false
                            ? warning(
                                  false,
                                  "Invalid argument supplied to oneOf, expected an instance of array."
                              )
                            : void 0;
                        return emptyFunction.thatReturnsNull;
                    }

                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        var propValue = props[propName];
                        for (var i = 0; i < expectedValues.length; i++) {
                            if (is(propValue, expectedValues[i])) {
                                return null;
                            }
                        }

                        var locationName = ReactPropTypeLocationNames[location];
                        var valuesString = JSON.stringify(expectedValues);
                        return new PropTypeError(
                            "Invalid " +
                                locationName +
                                " `" +
                                propFullName +
                                "` of value `" +
                                propValue +
                                "` " +
                                ("supplied to `" +
                                    componentName +
                                    "`, expected one of " +
                                    valuesString +
                                    ".")
                        );
                    }
                    return createChainableTypeChecker(validate);
                }

                function createObjectOfTypeChecker(typeChecker) {
                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        if (typeof typeChecker !== "function") {
                            return new PropTypeError(
                                "Property `" +
                                    propFullName +
                                    "` of component `" +
                                    componentName +
                                    "` has invalid PropType notation inside objectOf."
                            );
                        }
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            return new PropTypeError(
                                "Invalid " +
                                    locationName +
                                    " `" +
                                    propFullName +
                                    "` of type " +
                                    ("`" +
                                        propType +
                                        "` supplied to `" +
                                        componentName +
                                        "`, expected an object.")
                            );
                        }
                        for (var key in propValue) {
                            if (propValue.hasOwnProperty(key)) {
                                var error = typeChecker(
                                    propValue,
                                    key,
                                    componentName,
                                    location,
                                    propFullName + "." + key,
                                    ReactPropTypesSecret
                                );
                                if (error instanceof Error) {
                                    return error;
                                }
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createUnionTypeChecker(arrayOfTypeCheckers) {
                    if (!Array.isArray(arrayOfTypeCheckers)) {
                        false
                            ? warning(
                                  false,
                                  "Invalid argument supplied to oneOfType, expected an instance of array."
                              )
                            : void 0;
                        return emptyFunction.thatReturnsNull;
                    }

                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                            var checker = arrayOfTypeCheckers[i];
                            if (
                                checker(
                                    props,
                                    propName,
                                    componentName,
                                    location,
                                    propFullName,
                                    ReactPropTypesSecret
                                ) == null
                            ) {
                                return null;
                            }
                        }

                        var locationName = ReactPropTypeLocationNames[location];
                        return new PropTypeError(
                            "Invalid " +
                                locationName +
                                " `" +
                                propFullName +
                                "` supplied to " +
                                ("`" + componentName + "`.")
                        );
                    }
                    return createChainableTypeChecker(validate);
                }

                function createNodeChecker() {
                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        if (!isNode(props[propName])) {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            return new PropTypeError(
                                "Invalid " +
                                    locationName +
                                    " `" +
                                    propFullName +
                                    "` supplied to " +
                                    ("`" +
                                        componentName +
                                        "`, expected a ReactNode.")
                            );
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createShapeTypeChecker(shapeTypes) {
                    function validate(
                        props,
                        propName,
                        componentName,
                        location,
                        propFullName
                    ) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") {
                            var locationName =
                                ReactPropTypeLocationNames[location];
                            return new PropTypeError(
                                "Invalid " +
                                    locationName +
                                    " `" +
                                    propFullName +
                                    "` of type `" +
                                    propType +
                                    "` " +
                                    ("supplied to `" +
                                        componentName +
                                        "`, expected `object`.")
                            );
                        }
                        for (var key in shapeTypes) {
                            var checker = shapeTypes[key];
                            if (!checker) {
                                continue;
                            }
                            var error = checker(
                                propValue,
                                key,
                                componentName,
                                location,
                                propFullName + "." + key,
                                ReactPropTypesSecret
                            );
                            if (error) {
                                return error;
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function isNode(propValue) {
                    switch (typeof propValue) {
                        case "number":
                        case "string":
                        case "undefined":
                            return true;
                        case "boolean":
                            return !propValue;
                        case "object":
                            if (Array.isArray(propValue)) {
                                return propValue.every(isNode);
                            }
                            if (
                                propValue === null ||
                                ReactElement.isValidElement(propValue)
                            ) {
                                return true;
                            }

                            var iteratorFn = getIteratorFn(propValue);
                            if (iteratorFn) {
                                var iterator = iteratorFn.call(propValue);
                                var step;
                                if (iteratorFn !== propValue.entries) {
                                    while (!(step = iterator.next()).done) {
                                        if (!isNode(step.value)) {
                                            return false;
                                        }
                                    }
                                } else {
                                    // Iterator will provide entry [k,v] tuples rather than values.
                                    while (!(step = iterator.next()).done) {
                                        var entry = step.value;
                                        if (entry) {
                                            if (!isNode(entry[1])) {
                                                return false;
                                            }
                                        }
                                    }
                                }
                            } else {
                                return false;
                            }

                            return true;
                        default:
                            return false;
                    }
                }

                function isSymbol(propType, propValue) {
                    // Native Symbol.
                    if (propType === "symbol") {
                        return true;
                    }

                    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                    if (propValue["@@toStringTag"] === "Symbol") {
                        return true;
                    }

                    // Fallback for non-spec compliant Symbols which are polyfilled.
                    if (
                        typeof Symbol === "function" &&
                        propValue instanceof Symbol
                    ) {
                        return true;
                    }

                    return false;
                }

                // Equivalent of `typeof` but with special handling for array and regexp.
                function getPropType(propValue) {
                    var propType = typeof propValue;
                    if (Array.isArray(propValue)) {
                        return "array";
                    }
                    if (propValue instanceof RegExp) {
                        // Old webkits (at least until Android 4.0) return 'function' rather than
                        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                        // passes PropTypes.object.
                        return "object";
                    }
                    if (isSymbol(propType, propValue)) {
                        return "symbol";
                    }
                    return propType;
                }

                // This handles more types than `getPropType`. Only used for error messages.
                // See `createPrimitiveTypeChecker`.
                function getPreciseType(propValue) {
                    var propType = getPropType(propValue);
                    if (propType === "object") {
                        if (propValue instanceof Date) {
                            return "date";
                        } else if (propValue instanceof RegExp) {
                            return "regexp";
                        }
                    }
                    return propType;
                }

                // Returns class name of the object, if any.
                function getClassName(propValue) {
                    if (!propValue.constructor || !propValue.constructor.name) {
                        return ANONYMOUS;
                    }
                    return propValue.constructor.name;
                }

                module.exports = ReactPropTypes;

                /***/
            },
            /* 373 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var ReactPropTypesSecret =
                    "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";

                module.exports = ReactPropTypesSecret;

                /***/
            },
            /* 374 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                module.exports = "15.4.2";

                /***/
            },
            /* 375 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */
                "use strict";

                var _prodInvariant = __webpack_require__(354);

                var ReactElement = __webpack_require__(356);

                var invariant = __webpack_require__(355);

                /**
                 * Returns the first child in a collection of children and verifies that there
                 * is only one child in the collection.
                 *
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
                 *
                 * The current implementation of this function assumes that a single child gets
                 * passed without a wrapper, but the purpose of this helper function is to
                 * abstract away the particular structure of children.
                 *
                 * @param {?object} children Child collection structure.
                 * @return {ReactElement} The first and only `ReactElement` contained in the
                 * structure.
                 */
                function onlyChild(children) {
                    !ReactElement.isValidElement(children)
                        ? false
                            ? invariant(
                                  false,
                                  "React.Children.only expected to receive a single React element child."
                              )
                            : _prodInvariant("143")
                        : void 0;
                    return children;
                }

                module.exports = onlyChild;

                /***/
            },
            /* 376 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (global) {
                    module.exports = global["ReactDOM"] =
                        __webpack_require__(377);
                    /* WEBPACK VAR INJECTION */
                }.call(
                    exports,
                    (function () {
                        return this;
                    })()
                ));

                /***/
            },
            /* 377 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                module.exports = __webpack_require__(378);

                /***/
            },
            /* 378 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/

                "use strict";

                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactDefaultInjection = __webpack_require__(383);
                var ReactMount = __webpack_require__(505);
                var ReactReconciler = __webpack_require__(404);
                var ReactUpdates = __webpack_require__(401);
                var ReactVersion = __webpack_require__(510);

                var findDOMNode = __webpack_require__(511);
                var getHostComponentFromComposite = __webpack_require__(512);
                var renderSubtreeIntoContainer = __webpack_require__(513);
                var warning = __webpack_require__(358);

                ReactDefaultInjection.inject();

                var ReactDOM = {
                    findDOMNode: findDOMNode,
                    render: ReactMount.render,
                    unmountComponentAtNode: ReactMount.unmountComponentAtNode,
                    version: ReactVersion,

                    /* eslint-disable camelcase */
                    unstable_batchedUpdates: ReactUpdates.batchedUpdates,
                    unstable_renderSubtreeIntoContainer:
                        renderSubtreeIntoContainer,
                };

                // Inject the runtime into a devtools global hook regardless of browser.
                // Allows for debugging when the hook is injected on the page.
                if (
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === "function"
                ) {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
                        ComponentTree: {
                            getClosestInstanceFromNode:
                                ReactDOMComponentTree.getClosestInstanceFromNode,
                            getNodeFromInstance: function (inst) {
                                // inst is an internal instance (but could be a composite)
                                if (inst._renderedComponent) {
                                    inst = getHostComponentFromComposite(inst);
                                }
                                if (inst) {
                                    return ReactDOMComponentTree.getNodeFromInstance(
                                        inst
                                    );
                                } else {
                                    return null;
                                }
                            },
                        },
                        Mount: ReactMount,
                        Reconciler: ReactReconciler,
                    });
                }

                if (false) {
                    var ExecutionEnvironment = require("fbjs/lib/ExecutionEnvironment");
                    if (
                        ExecutionEnvironment.canUseDOM &&
                        window.top === window.self
                    ) {
                        // First check if devtools is not installed
                        if (
                            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ ===
                            "undefined"
                        ) {
                            // If we're in Chrome or Firefox, provide a download link if not installed.
                            if (
                                (navigator.userAgent.indexOf("Chrome") > -1 &&
                                    navigator.userAgent.indexOf("Edge") ===
                                        -1) ||
                                navigator.userAgent.indexOf("Firefox") > -1
                            ) {
                                // Firefox does not have the issue with devtools loaded over file://
                                var showFileUrlMessage =
                                    window.location.protocol.indexOf("http") ===
                                        -1 &&
                                    navigator.userAgent.indexOf("Firefox") ===
                                        -1;
                                console.debug(
                                    "Download the React DevTools " +
                                        (showFileUrlMessage
                                            ? "and use an HTTP server (instead of a file: URL) "
                                            : "") +
                                        "for a better development experience: " +
                                        "https://fb.me/react-devtools"
                                );
                            }
                        }

                        var testFunc = function testFn() {};
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  (
                                      testFunc.name || testFunc.toString()
                                  ).indexOf("testFn") !== -1,
                                  "It looks like you're using a minified copy of the development build " +
                                      "of React. When deploying React apps to production, make sure to use " +
                                      "the production build which skips development warnings and is faster. " +
                                      "See https://fb.me/react-minification for more details."
                              )
                            : void 0;

                        // If we're in IE8, check to see if we are in compatibility mode and provide
                        // information on preventing compatibility mode
                        var ieCompatibilityMode =
                            document.documentMode && document.documentMode < 8;

                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  !ieCompatibilityMode,
                                  "Internet Explorer is running in compatibility mode; please add the " +
                                      "following tag to your HTML to prevent this from happening: " +
                                      '<meta http-equiv="X-UA-Compatible" content="IE=edge" />'
                              )
                            : void 0;

                        var expectedFeatures = [
                            // shims
                            Array.isArray,
                            Array.prototype.every,
                            Array.prototype.forEach,
                            Array.prototype.indexOf,
                            Array.prototype.map,
                            Date.now,
                            Function.prototype.bind,
                            Object.keys,
                            String.prototype.trim,
                        ];

                        for (var i = 0; i < expectedFeatures.length; i++) {
                            if (!expectedFeatures[i]) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "One or more ES5 shims expected by React are not available: " +
                                              "https://fb.me/react-warning-polyfills"
                                      )
                                    : void 0;
                                break;
                            }
                        }
                    }
                }

                if (false) {
                    var ReactInstrumentation = require("./ReactInstrumentation");
                    var ReactDOMUnknownPropertyHook = require("./ReactDOMUnknownPropertyHook");
                    var ReactDOMNullInputValuePropHook = require("./ReactDOMNullInputValuePropHook");
                    var ReactDOMInvalidARIAHook = require("./ReactDOMInvalidARIAHook");

                    ReactInstrumentation.debugTool.addHook(
                        ReactDOMUnknownPropertyHook
                    );
                    ReactInstrumentation.debugTool.addHook(
                        ReactDOMNullInputValuePropHook
                    );
                    ReactInstrumentation.debugTool.addHook(
                        ReactDOMInvalidARIAHook
                    );
                }

                module.exports = ReactDOM;

                /***/
            },
            /* 379 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var DOMProperty = __webpack_require__(381);
                var ReactDOMComponentFlags = __webpack_require__(382);

                var invariant = __webpack_require__(355);

                var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
                var Flags = ReactDOMComponentFlags;

                var internalInstanceKey =
                    "__reactInternalInstance$" +
                    Math.random().toString(36).slice(2);

                /**
                 * Check if a given node should be cached.
                 */
                function shouldPrecacheNode(node, nodeID) {
                    return (
                        (node.nodeType === 1 &&
                            node.getAttribute(ATTR_NAME) === String(nodeID)) ||
                        (node.nodeType === 8 &&
                            node.nodeValue ===
                                " react-text: " + nodeID + " ") ||
                        (node.nodeType === 8 &&
                            node.nodeValue === " react-empty: " + nodeID + " ")
                    );
                }

                /**
                 * Drill down (through composites and empty components) until we get a host or
                 * host text component.
                 *
                 * This is pretty polymorphic but unavoidable with the current structure we have
                 * for `_renderedChildren`.
                 */
                function getRenderedHostOrTextFromComponent(component) {
                    var rendered;
                    while ((rendered = component._renderedComponent)) {
                        component = rendered;
                    }
                    return component;
                }

                /**
                 * Populate `_hostNode` on the rendered host/text component with the given
                 * DOM node. The passed `inst` can be a composite.
                 */
                function precacheNode(inst, node) {
                    var hostInst = getRenderedHostOrTextFromComponent(inst);
                    hostInst._hostNode = node;
                    node[internalInstanceKey] = hostInst;
                }

                function uncacheNode(inst) {
                    var node = inst._hostNode;
                    if (node) {
                        delete node[internalInstanceKey];
                        inst._hostNode = null;
                    }
                }

                /**
                 * Populate `_hostNode` on each child of `inst`, assuming that the children
                 * match up with the DOM (element) children of `node`.
                 *
                 * We cache entire levels at once to avoid an n^2 problem where we access the
                 * children of a node sequentially and have to walk from the start to our target
                 * node every time.
                 *
                 * Since we update `_renderedChildren` and the actual DOM at (slightly)
                 * different times, we could race here and see a newer `_renderedChildren` than
                 * the DOM nodes we see. To avoid this, ReactMultiChild calls
                 * `prepareToManageChildren` before we change `_renderedChildren`, at which
                 * time the container's child nodes are always cached (until it unmounts).
                 */
                function precacheChildNodes(inst, node) {
                    if (inst._flags & Flags.hasCachedChildNodes) {
                        return;
                    }
                    var children = inst._renderedChildren;
                    var childNode = node.firstChild;
                    outer: for (var name in children) {
                        if (!children.hasOwnProperty(name)) {
                            continue;
                        }
                        var childInst = children[name];
                        var childID =
                            getRenderedHostOrTextFromComponent(
                                childInst
                            )._domID;
                        if (childID === 0) {
                            // We're currently unmounting this child in ReactMultiChild; skip it.
                            continue;
                        }
                        // We assume the child nodes are in the same order as the child instances.
                        for (
                            ;
                            childNode !== null;
                            childNode = childNode.nextSibling
                        ) {
                            if (shouldPrecacheNode(childNode, childID)) {
                                precacheNode(childInst, childNode);
                                continue outer;
                            }
                        }
                        // We reached the end of the DOM children without finding an ID match.
                        true
                            ? false
                                ? invariant(
                                      false,
                                      "Unable to find element with ID %s.",
                                      childID
                                  )
                                : _prodInvariant("32", childID)
                            : void 0;
                    }
                    inst._flags |= Flags.hasCachedChildNodes;
                }

                /**
                 * Given a DOM node, return the closest ReactDOMComponent or
                 * ReactDOMTextComponent instance ancestor.
                 */
                function getClosestInstanceFromNode(node) {
                    if (node[internalInstanceKey]) {
                        return node[internalInstanceKey];
                    }

                    // Walk up the tree until we find an ancestor whose instance we have cached.
                    var parents = [];
                    while (!node[internalInstanceKey]) {
                        parents.push(node);
                        if (node.parentNode) {
                            node = node.parentNode;
                        } else {
                            // Top of the tree. This node must not be part of a React tree (or is
                            // unmounted, potentially).
                            return null;
                        }
                    }

                    var closest;
                    var inst;
                    for (
                        ;
                        node && (inst = node[internalInstanceKey]);
                        node = parents.pop()
                    ) {
                        closest = inst;
                        if (parents.length) {
                            precacheChildNodes(inst, node);
                        }
                    }

                    return closest;
                }

                /**
                 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
                 * instance, or null if the node was not rendered by this React.
                 */
                function getInstanceFromNode(node) {
                    var inst = getClosestInstanceFromNode(node);
                    if (inst != null && inst._hostNode === node) {
                        return inst;
                    } else {
                        return null;
                    }
                }

                /**
                 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
                 * DOM node.
                 */
                function getNodeFromInstance(inst) {
                    // Without this first invariant, passing a non-DOM-component triggers the next
                    // invariant for a missing parent, which is super confusing.
                    !(inst._hostNode !== undefined)
                        ? false
                            ? invariant(
                                  false,
                                  "getNodeFromInstance: Invalid argument."
                              )
                            : _prodInvariant("33")
                        : void 0;

                    if (inst._hostNode) {
                        return inst._hostNode;
                    }

                    // Walk up the tree until we find an ancestor whose DOM node we have cached.
                    var parents = [];
                    while (!inst._hostNode) {
                        parents.push(inst);
                        !inst._hostParent
                            ? false
                                ? invariant(
                                      false,
                                      "React DOM tree root should always have a node reference."
                                  )
                                : _prodInvariant("34")
                            : void 0;
                        inst = inst._hostParent;
                    }

                    // Now parents contains each ancestor that does *not* have a cached native
                    // node, and `inst` is the deepest ancestor that does.
                    for (; parents.length; inst = parents.pop()) {
                        precacheChildNodes(inst, inst._hostNode);
                    }

                    return inst._hostNode;
                }

                var ReactDOMComponentTree = {
                    getClosestInstanceFromNode: getClosestInstanceFromNode,
                    getInstanceFromNode: getInstanceFromNode,
                    getNodeFromInstance: getNodeFromInstance,
                    precacheChildNodes: precacheChildNodes,
                    precacheNode: precacheNode,
                    uncacheNode: uncacheNode,
                };

                module.exports = ReactDOMComponentTree;

                /***/
            },
            /* 380 */
            /***/ function (module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */
                "use strict";

                /**
                 * WARNING: DO NOT manually require this module.
                 * This is a replacement for `invariant(...)` used by the error code system
                 * and will _only_ be required by the corresponding babel pass.
                 * It always throws.
                 */

                function reactProdInvariant(code) {
                    var argCount = arguments.length - 1;

                    var message =
                        "Minified React error #" +
                        code +
                        "; visit " +
                        "http://facebook.github.io/react/docs/error-decoder.html?invariant=" +
                        code;

                    for (var argIdx = 0; argIdx < argCount; argIdx++) {
                        message +=
                            "&args[]=" +
                            encodeURIComponent(arguments[argIdx + 1]);
                    }

                    message +=
                        " for the full message or use the non-minified dev environment" +
                        " for full errors and additional helpful warnings.";

                    var error = new Error(message);
                    error.name = "Invariant Violation";
                    error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

                    throw error;
                }

                module.exports = reactProdInvariant;

                /***/
            },
            /* 381 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                function checkMask(value, bitmask) {
                    return (value & bitmask) === bitmask;
                }

                var DOMPropertyInjection = {
                    /**
                     * Mapping from normalized, camelcased property names to a configuration that
                     * specifies how the associated DOM property should be accessed or rendered.
                     */
                    MUST_USE_PROPERTY: 0x1,
                    HAS_BOOLEAN_VALUE: 0x4,
                    HAS_NUMERIC_VALUE: 0x8,
                    HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
                    HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

                    /**
                     * Inject some specialized knowledge about the DOM. This takes a config object
                     * with the following properties:
                     *
                     * isCustomAttribute: function that given an attribute name will return true
                     * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
                     * attributes where it's impossible to enumerate all of the possible
                     * attribute names,
                     *
                     * Properties: object mapping DOM property name to one of the
                     * DOMPropertyInjection constants or null. If your attribute isn't in here,
                     * it won't get written to the DOM.
                     *
                     * DOMAttributeNames: object mapping React attribute name to the DOM
                     * attribute name. Attribute names not specified use the **lowercase**
                     * normalized name.
                     *
                     * DOMAttributeNamespaces: object mapping React attribute name to the DOM
                     * attribute namespace URL. (Attribute names not specified use no namespace.)
                     *
                     * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
                     * Property names not specified use the normalized name.
                     *
                     * DOMMutationMethods: Properties that require special mutation methods. If
                     * `value` is undefined, the mutation method should unset the property.
                     *
                     * @param {object} domPropertyConfig the config as described above.
                     */
                    injectDOMPropertyConfig: function (domPropertyConfig) {
                        var Injection = DOMPropertyInjection;
                        var Properties = domPropertyConfig.Properties || {};
                        var DOMAttributeNamespaces =
                            domPropertyConfig.DOMAttributeNamespaces || {};
                        var DOMAttributeNames =
                            domPropertyConfig.DOMAttributeNames || {};
                        var DOMPropertyNames =
                            domPropertyConfig.DOMPropertyNames || {};
                        var DOMMutationMethods =
                            domPropertyConfig.DOMMutationMethods || {};

                        if (domPropertyConfig.isCustomAttribute) {
                            DOMProperty._isCustomAttributeFunctions.push(
                                domPropertyConfig.isCustomAttribute
                            );
                        }

                        for (var propName in Properties) {
                            !!DOMProperty.properties.hasOwnProperty(propName)
                                ? false
                                    ? invariant(
                                          false,
                                          "injectDOMPropertyConfig(...): You're trying to inject DOM property '%s' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.",
                                          propName
                                      )
                                    : _prodInvariant("48", propName)
                                : void 0;

                            var lowerCased = propName.toLowerCase();
                            var propConfig = Properties[propName];

                            var propertyInfo = {
                                attributeName: lowerCased,
                                attributeNamespace: null,
                                propertyName: propName,
                                mutationMethod: null,

                                mustUseProperty: checkMask(
                                    propConfig,
                                    Injection.MUST_USE_PROPERTY
                                ),
                                hasBooleanValue: checkMask(
                                    propConfig,
                                    Injection.HAS_BOOLEAN_VALUE
                                ),
                                hasNumericValue: checkMask(
                                    propConfig,
                                    Injection.HAS_NUMERIC_VALUE
                                ),
                                hasPositiveNumericValue: checkMask(
                                    propConfig,
                                    Injection.HAS_POSITIVE_NUMERIC_VALUE
                                ),
                                hasOverloadedBooleanValue: checkMask(
                                    propConfig,
                                    Injection.HAS_OVERLOADED_BOOLEAN_VALUE
                                ),
                            };
                            !(
                                propertyInfo.hasBooleanValue +
                                    propertyInfo.hasNumericValue +
                                    propertyInfo.hasOverloadedBooleanValue <=
                                1
                            )
                                ? false
                                    ? invariant(
                                          false,
                                          "DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s",
                                          propName
                                      )
                                    : _prodInvariant("50", propName)
                                : void 0;

                            if (false) {
                                DOMProperty.getPossibleStandardName[
                                    lowerCased
                                ] = propName;
                            }

                            if (DOMAttributeNames.hasOwnProperty(propName)) {
                                var attributeName = DOMAttributeNames[propName];
                                propertyInfo.attributeName = attributeName;
                                if (false) {
                                    DOMProperty.getPossibleStandardName[
                                        attributeName
                                    ] = propName;
                                }
                            }

                            if (
                                DOMAttributeNamespaces.hasOwnProperty(propName)
                            ) {
                                propertyInfo.attributeNamespace =
                                    DOMAttributeNamespaces[propName];
                            }

                            if (DOMPropertyNames.hasOwnProperty(propName)) {
                                propertyInfo.propertyName =
                                    DOMPropertyNames[propName];
                            }

                            if (DOMMutationMethods.hasOwnProperty(propName)) {
                                propertyInfo.mutationMethod =
                                    DOMMutationMethods[propName];
                            }

                            DOMProperty.properties[propName] = propertyInfo;
                        }
                    },
                };

                /* eslint-disable max-len */
                var ATTRIBUTE_NAME_START_CHAR =
                    ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
                /* eslint-enable max-len */

                /**
                 * DOMProperty exports lookup objects that can be used like functions:
                 *
                 *   > DOMProperty.isValid['id']
                 *   true
                 *   > DOMProperty.isValid['foobar']
                 *   undefined
                 *
                 * Although this may be confusing, it performs better in general.
                 *
                 * @see http://jsperf.com/key-exists
                 * @see http://jsperf.com/key-missing
                 */
                var DOMProperty = {
                    ID_ATTRIBUTE_NAME: "data-reactid",
                    ROOT_ATTRIBUTE_NAME: "data-reactroot",

                    ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
                    ATTRIBUTE_NAME_CHAR:
                        ATTRIBUTE_NAME_START_CHAR +
                        "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",

                    /**
                     * Map from property "standard name" to an object with info about how to set
                     * the property in the DOM. Each object contains:
                     *
                     * attributeName:
                     *   Used when rendering markup or with `*Attribute()`.
                     * attributeNamespace
                     * propertyName:
                     *   Used on DOM node instances. (This includes properties that mutate due to
                     *   external factors.)
                     * mutationMethod:
                     *   If non-null, used instead of the property or `setAttribute()` after
                     *   initial render.
                     * mustUseProperty:
                     *   Whether the property must be accessed and mutated as an object property.
                     * hasBooleanValue:
                     *   Whether the property should be removed when set to a falsey value.
                     * hasNumericValue:
                     *   Whether the property must be numeric or parse as a numeric and should be
                     *   removed when set to a falsey value.
                     * hasPositiveNumericValue:
                     *   Whether the property must be positive numeric or parse as a positive
                     *   numeric and should be removed when set to a falsey value.
                     * hasOverloadedBooleanValue:
                     *   Whether the property can be used as a flag as well as with a value.
                     *   Removed when strictly equal to false; present without a value when
                     *   strictly equal to true; present with a value otherwise.
                     */
                    properties: {},

                    /**
                     * Mapping from lowercase property names to the properly cased version, used
                     * to warn in the case of missing properties. Available only in __DEV__.
                     *
                     * autofocus is predefined, because adding it to the property whitelist
                     * causes unintended side effects.
                     *
                     * @type {Object}
                     */
                    getPossibleStandardName: false
                        ? { autofocus: "autoFocus" }
                        : null,

                    /**
                     * All of the isCustomAttribute() functions that have been injected.
                     */
                    _isCustomAttributeFunctions: [],

                    /**
                     * Checks whether a property name is a custom attribute.
                     * @method
                     */
                    isCustomAttribute: function (attributeName) {
                        for (
                            var i = 0;
                            i < DOMProperty._isCustomAttributeFunctions.length;
                            i++
                        ) {
                            var isCustomAttributeFn =
                                DOMProperty._isCustomAttributeFunctions[i];
                            if (isCustomAttributeFn(attributeName)) {
                                return true;
                            }
                        }
                        return false;
                    },

                    injection: DOMPropertyInjection,
                };

                module.exports = DOMProperty;

                /***/
            },
            /* 382 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactDOMComponentFlags = {
                    hasCachedChildNodes: 1 << 0,
                };

                module.exports = ReactDOMComponentFlags;

                /***/
            },
            /* 383 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ARIADOMPropertyConfig = __webpack_require__(384);
                var BeforeInputEventPlugin = __webpack_require__(385);
                var ChangeEventPlugin = __webpack_require__(400);
                var DefaultEventPluginOrder = __webpack_require__(412);
                var EnterLeaveEventPlugin = __webpack_require__(413);
                var HTMLDOMPropertyConfig = __webpack_require__(418);
                var ReactComponentBrowserEnvironment = __webpack_require__(419);
                var ReactDOMComponent = __webpack_require__(432);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactDOMEmptyComponent = __webpack_require__(476);
                var ReactDOMTreeTraversal = __webpack_require__(477);
                var ReactDOMTextComponent = __webpack_require__(478);
                var ReactDefaultBatchingStrategy = __webpack_require__(479);
                var ReactEventListener = __webpack_require__(480);
                var ReactInjection = __webpack_require__(483);
                var ReactReconcileTransaction = __webpack_require__(484);
                var SVGDOMPropertyConfig = __webpack_require__(492);
                var SelectEventPlugin = __webpack_require__(493);
                var SimpleEventPlugin = __webpack_require__(494);

                var alreadyInjected = false;

                function inject() {
                    if (alreadyInjected) {
                        // TODO: This is currently true because these injections are shared between
                        // the client and the server package. They should be built independently
                        // and not share any injection state. Then this problem will be solved.
                        return;
                    }
                    alreadyInjected = true;

                    ReactInjection.EventEmitter.injectReactEventListener(
                        ReactEventListener
                    );

                    /**
                     * Inject modules for resolving DOM hierarchy and plugin ordering.
                     */
                    ReactInjection.EventPluginHub.injectEventPluginOrder(
                        DefaultEventPluginOrder
                    );
                    ReactInjection.EventPluginUtils.injectComponentTree(
                        ReactDOMComponentTree
                    );
                    ReactInjection.EventPluginUtils.injectTreeTraversal(
                        ReactDOMTreeTraversal
                    );

                    /**
                     * Some important event plugins included by default (without having to require
                     * them).
                     */
                    ReactInjection.EventPluginHub.injectEventPluginsByName({
                        SimpleEventPlugin: SimpleEventPlugin,
                        EnterLeaveEventPlugin: EnterLeaveEventPlugin,
                        ChangeEventPlugin: ChangeEventPlugin,
                        SelectEventPlugin: SelectEventPlugin,
                        BeforeInputEventPlugin: BeforeInputEventPlugin,
                    });

                    ReactInjection.HostComponent.injectGenericComponentClass(
                        ReactDOMComponent
                    );

                    ReactInjection.HostComponent.injectTextComponentClass(
                        ReactDOMTextComponent
                    );

                    ReactInjection.DOMProperty.injectDOMPropertyConfig(
                        ARIADOMPropertyConfig
                    );
                    ReactInjection.DOMProperty.injectDOMPropertyConfig(
                        HTMLDOMPropertyConfig
                    );
                    ReactInjection.DOMProperty.injectDOMPropertyConfig(
                        SVGDOMPropertyConfig
                    );

                    ReactInjection.EmptyComponent.injectEmptyComponentFactory(
                        function (instantiate) {
                            return new ReactDOMEmptyComponent(instantiate);
                        }
                    );

                    ReactInjection.Updates.injectReconcileTransaction(
                        ReactReconcileTransaction
                    );
                    ReactInjection.Updates.injectBatchingStrategy(
                        ReactDefaultBatchingStrategy
                    );

                    ReactInjection.Component.injectEnvironment(
                        ReactComponentBrowserEnvironment
                    );
                }

                module.exports = {
                    inject: inject,
                };

                /***/
            },
            /* 384 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ARIADOMPropertyConfig = {
                    Properties: {
                        // Global States and Properties
                        "aria-current": 0, // state
                        "aria-details": 0,
                        "aria-disabled": 0, // state
                        "aria-hidden": 0, // state
                        "aria-invalid": 0, // state
                        "aria-keyshortcuts": 0,
                        "aria-label": 0,
                        "aria-roledescription": 0,
                        // Widget Attributes
                        "aria-autocomplete": 0,
                        "aria-checked": 0,
                        "aria-expanded": 0,
                        "aria-haspopup": 0,
                        "aria-level": 0,
                        "aria-modal": 0,
                        "aria-multiline": 0,
                        "aria-multiselectable": 0,
                        "aria-orientation": 0,
                        "aria-placeholder": 0,
                        "aria-pressed": 0,
                        "aria-readonly": 0,
                        "aria-required": 0,
                        "aria-selected": 0,
                        "aria-sort": 0,
                        "aria-valuemax": 0,
                        "aria-valuemin": 0,
                        "aria-valuenow": 0,
                        "aria-valuetext": 0,
                        // Live Region Attributes
                        "aria-atomic": 0,
                        "aria-busy": 0,
                        "aria-live": 0,
                        "aria-relevant": 0,
                        // Drag-and-Drop Attributes
                        "aria-dropeffect": 0,
                        "aria-grabbed": 0,
                        // Relationship Attributes
                        "aria-activedescendant": 0,
                        "aria-colcount": 0,
                        "aria-colindex": 0,
                        "aria-colspan": 0,
                        "aria-controls": 0,
                        "aria-describedby": 0,
                        "aria-errormessage": 0,
                        "aria-flowto": 0,
                        "aria-labelledby": 0,
                        "aria-owns": 0,
                        "aria-posinset": 0,
                        "aria-rowcount": 0,
                        "aria-rowindex": 0,
                        "aria-rowspan": 0,
                        "aria-setsize": 0,
                    },
                    DOMAttributeNames: {},
                    DOMPropertyNames: {},
                };

                module.exports = ARIADOMPropertyConfig;

                /***/
            },
            /* 385 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var EventPropagators = __webpack_require__(386);
                var ExecutionEnvironment = __webpack_require__(393);
                var FallbackCompositionState = __webpack_require__(394);
                var SyntheticCompositionEvent = __webpack_require__(397);
                var SyntheticInputEvent = __webpack_require__(399);

                var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
                var START_KEYCODE = 229;

                var canUseCompositionEvent =
                    ExecutionEnvironment.canUseDOM &&
                    "CompositionEvent" in window;

                var documentMode = null;
                if (
                    ExecutionEnvironment.canUseDOM &&
                    "documentMode" in document
                ) {
                    documentMode = document.documentMode;
                }

                // Webkit offers a very useful `textInput` event that can be used to
                // directly represent `beforeInput`. The IE `textinput` event is not as
                // useful, so we don't use it.
                var canUseTextInputEvent =
                    ExecutionEnvironment.canUseDOM &&
                    "TextEvent" in window &&
                    !documentMode &&
                    !isPresto();

                // In IE9+, we have access to composition events, but the data supplied
                // by the native compositionend event may be incorrect. Japanese ideographic
                // spaces, for instance (\u3000) are not recorded correctly.
                var useFallbackCompositionData =
                    ExecutionEnvironment.canUseDOM &&
                    (!canUseCompositionEvent ||
                        (documentMode &&
                            documentMode > 8 &&
                            documentMode <= 11));

                /**
                 * Opera <= 12 includes TextEvent in window, but does not fire
                 * text input events. Rely on keypress instead.
                 */
                function isPresto() {
                    var opera = window.opera;
                    return (
                        typeof opera === "object" &&
                        typeof opera.version === "function" &&
                        parseInt(opera.version(), 10) <= 12
                    );
                }

                var SPACEBAR_CODE = 32;
                var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

                // Events and their corresponding property names.
                var eventTypes = {
                    beforeInput: {
                        phasedRegistrationNames: {
                            bubbled: "onBeforeInput",
                            captured: "onBeforeInputCapture",
                        },
                        dependencies: [
                            "topCompositionEnd",
                            "topKeyPress",
                            "topTextInput",
                            "topPaste",
                        ],
                    },
                    compositionEnd: {
                        phasedRegistrationNames: {
                            bubbled: "onCompositionEnd",
                            captured: "onCompositionEndCapture",
                        },
                        dependencies: [
                            "topBlur",
                            "topCompositionEnd",
                            "topKeyDown",
                            "topKeyPress",
                            "topKeyUp",
                            "topMouseDown",
                        ],
                    },
                    compositionStart: {
                        phasedRegistrationNames: {
                            bubbled: "onCompositionStart",
                            captured: "onCompositionStartCapture",
                        },
                        dependencies: [
                            "topBlur",
                            "topCompositionStart",
                            "topKeyDown",
                            "topKeyPress",
                            "topKeyUp",
                            "topMouseDown",
                        ],
                    },
                    compositionUpdate: {
                        phasedRegistrationNames: {
                            bubbled: "onCompositionUpdate",
                            captured: "onCompositionUpdateCapture",
                        },
                        dependencies: [
                            "topBlur",
                            "topCompositionUpdate",
                            "topKeyDown",
                            "topKeyPress",
                            "topKeyUp",
                            "topMouseDown",
                        ],
                    },
                };

                // Track whether we've ever handled a keypress on the space key.
                var hasSpaceKeypress = false;

                /**
                 * Return whether a native keypress event is assumed to be a command.
                 * This is required because Firefox fires `keypress` events for key commands
                 * (cut, copy, select-all, etc.) even though no character is inserted.
                 */
                function isKeypressCommand(nativeEvent) {
                    return (
                        (nativeEvent.ctrlKey ||
                            nativeEvent.altKey ||
                            nativeEvent.metaKey) &&
                        // ctrlKey && altKey is equivalent to AltGr, and is not a command.
                        !(nativeEvent.ctrlKey && nativeEvent.altKey)
                    );
                }

                /**
                 * Translate native top level events into event types.
                 *
                 * @param {string} topLevelType
                 * @return {object}
                 */
                function getCompositionEventType(topLevelType) {
                    switch (topLevelType) {
                        case "topCompositionStart":
                            return eventTypes.compositionStart;
                        case "topCompositionEnd":
                            return eventTypes.compositionEnd;
                        case "topCompositionUpdate":
                            return eventTypes.compositionUpdate;
                    }
                }

                /**
                 * Does our fallback best-guess model think this event signifies that
                 * composition has begun?
                 *
                 * @param {string} topLevelType
                 * @param {object} nativeEvent
                 * @return {boolean}
                 */
                function isFallbackCompositionStart(topLevelType, nativeEvent) {
                    return (
                        topLevelType === "topKeyDown" &&
                        nativeEvent.keyCode === START_KEYCODE
                    );
                }

                /**
                 * Does our fallback mode think that this event is the end of composition?
                 *
                 * @param {string} topLevelType
                 * @param {object} nativeEvent
                 * @return {boolean}
                 */
                function isFallbackCompositionEnd(topLevelType, nativeEvent) {
                    switch (topLevelType) {
                        case "topKeyUp":
                            // Command keys insert or clear IME input.
                            return (
                                END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1
                            );
                        case "topKeyDown":
                            // Expect IME keyCode on each keydown. If we get any other
                            // code we must have exited earlier.
                            return nativeEvent.keyCode !== START_KEYCODE;
                        case "topKeyPress":
                        case "topMouseDown":
                        case "topBlur":
                            // Events are not possible without cancelling IME.
                            return true;
                        default:
                            return false;
                    }
                }

                /**
                 * Google Input Tools provides composition data via a CustomEvent,
                 * with the `data` property populated in the `detail` object. If this
                 * is available on the event object, use it. If not, this is a plain
                 * composition event and we have nothing special to extract.
                 *
                 * @param {object} nativeEvent
                 * @return {?string}
                 */
                function getDataFromCustomEvent(nativeEvent) {
                    var detail = nativeEvent.detail;
                    if (typeof detail === "object" && "data" in detail) {
                        return detail.data;
                    }
                    return null;
                }

                // Track the current IME composition fallback object, if any.
                var currentComposition = null;

                /**
                 * @return {?object} A SyntheticCompositionEvent.
                 */
                function extractCompositionEvent(
                    topLevelType,
                    targetInst,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    var eventType;
                    var fallbackData;

                    if (canUseCompositionEvent) {
                        eventType = getCompositionEventType(topLevelType);
                    } else if (!currentComposition) {
                        if (
                            isFallbackCompositionStart(
                                topLevelType,
                                nativeEvent
                            )
                        ) {
                            eventType = eventTypes.compositionStart;
                        }
                    } else if (
                        isFallbackCompositionEnd(topLevelType, nativeEvent)
                    ) {
                        eventType = eventTypes.compositionEnd;
                    }

                    if (!eventType) {
                        return null;
                    }

                    if (useFallbackCompositionData) {
                        // The current composition is stored statically and must not be
                        // overwritten while composition continues.
                        if (
                            !currentComposition &&
                            eventType === eventTypes.compositionStart
                        ) {
                            currentComposition =
                                FallbackCompositionState.getPooled(
                                    nativeEventTarget
                                );
                        } else if (eventType === eventTypes.compositionEnd) {
                            if (currentComposition) {
                                fallbackData = currentComposition.getData();
                            }
                        }
                    }

                    var event = SyntheticCompositionEvent.getPooled(
                        eventType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    );

                    if (fallbackData) {
                        // Inject data generated from fallback path into the synthetic event.
                        // This matches the property of native CompositionEventInterface.
                        event.data = fallbackData;
                    } else {
                        var customData = getDataFromCustomEvent(nativeEvent);
                        if (customData !== null) {
                            event.data = customData;
                        }
                    }

                    EventPropagators.accumulateTwoPhaseDispatches(event);
                    return event;
                }

                /**
                 * @param {string} topLevelType Record from `EventConstants`.
                 * @param {object} nativeEvent Native browser event.
                 * @return {?string} The string corresponding to this `beforeInput` event.
                 */
                function getNativeBeforeInputChars(topLevelType, nativeEvent) {
                    switch (topLevelType) {
                        case "topCompositionEnd":
                            return getDataFromCustomEvent(nativeEvent);
                        case "topKeyPress":
                            /**
                             * If native `textInput` events are available, our goal is to make
                             * use of them. However, there is a special case: the spacebar key.
                             * In Webkit, preventing default on a spacebar `textInput` event
                             * cancels character insertion, but it *also* causes the browser
                             * to fall back to its default spacebar behavior of scrolling the
                             * page.
                             *
                             * Tracking at:
                             * https://code.google.com/p/chromium/issues/detail?id=355103
                             *
                             * To avoid this issue, use the keypress event as if no `textInput`
                             * event is available.
                             */
                            var which = nativeEvent.which;
                            if (which !== SPACEBAR_CODE) {
                                return null;
                            }

                            hasSpaceKeypress = true;
                            return SPACEBAR_CHAR;

                        case "topTextInput":
                            // Record the characters to be added to the DOM.
                            var chars = nativeEvent.data;

                            // If it's a spacebar character, assume that we have already handled
                            // it at the keypress level and bail immediately. Android Chrome
                            // doesn't give us keycodes, so we need to blacklist it.
                            if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
                                return null;
                            }

                            return chars;

                        default:
                            // For other native event types, do nothing.
                            return null;
                    }
                }

                /**
                 * For browsers that do not provide the `textInput` event, extract the
                 * appropriate string to use for SyntheticInputEvent.
                 *
                 * @param {string} topLevelType Record from `EventConstants`.
                 * @param {object} nativeEvent Native browser event.
                 * @return {?string} The fallback string for this `beforeInput` event.
                 */
                function getFallbackBeforeInputChars(
                    topLevelType,
                    nativeEvent
                ) {
                    // If we are currently composing (IME) and using a fallback to do so,
                    // try to extract the composed characters from the fallback object.
                    // If composition event is available, we extract a string only at
                    // compositionevent, otherwise extract it at fallback events.
                    if (currentComposition) {
                        if (
                            topLevelType === "topCompositionEnd" ||
                            (!canUseCompositionEvent &&
                                isFallbackCompositionEnd(
                                    topLevelType,
                                    nativeEvent
                                ))
                        ) {
                            var chars = currentComposition.getData();
                            FallbackCompositionState.release(
                                currentComposition
                            );
                            currentComposition = null;
                            return chars;
                        }
                        return null;
                    }

                    switch (topLevelType) {
                        case "topPaste":
                            // If a paste event occurs after a keypress, throw out the input
                            // chars. Paste events should not lead to BeforeInput events.
                            return null;
                        case "topKeyPress":
                            /**
                             * As of v27, Firefox may fire keypress events even when no character
                             * will be inserted. A few possibilities:
                             *
                             * - `which` is `0`. Arrow keys, Esc key, etc.
                             *
                             * - `which` is the pressed key code, but no char is available.
                             *   Ex: 'AltGr + d` in Polish. There is no modified character for
                             *   this key combination and no character is inserted into the
                             *   document, but FF fires the keypress for char code `100` anyway.
                             *   No `input` event will occur.
                             *
                             * - `which` is the pressed key code, but a command combination is
                             *   being used. Ex: `Cmd+C`. No character is inserted, and no
                             *   `input` event will occur.
                             */
                            if (
                                nativeEvent.which &&
                                !isKeypressCommand(nativeEvent)
                            ) {
                                return String.fromCharCode(nativeEvent.which);
                            }
                            return null;
                        case "topCompositionEnd":
                            return useFallbackCompositionData
                                ? null
                                : nativeEvent.data;
                        default:
                            return null;
                    }
                }

                /**
                 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
                 * `textInput` or fallback behavior.
                 *
                 * @return {?object} A SyntheticInputEvent.
                 */
                function extractBeforeInputEvent(
                    topLevelType,
                    targetInst,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    var chars;

                    if (canUseTextInputEvent) {
                        chars = getNativeBeforeInputChars(
                            topLevelType,
                            nativeEvent
                        );
                    } else {
                        chars = getFallbackBeforeInputChars(
                            topLevelType,
                            nativeEvent
                        );
                    }

                    // If no characters are being inserted, no BeforeInput event should
                    // be fired.
                    if (!chars) {
                        return null;
                    }

                    var event = SyntheticInputEvent.getPooled(
                        eventTypes.beforeInput,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    );

                    event.data = chars;
                    EventPropagators.accumulateTwoPhaseDispatches(event);
                    return event;
                }

                /**
                 * Create an `onBeforeInput` event to match
                 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
                 *
                 * This event plugin is based on the native `textInput` event
                 * available in Chrome, Safari, Opera, and IE. This event fires after
                 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
                 *
                 * `beforeInput` is spec'd but not implemented in any browsers, and
                 * the `input` event does not provide any useful information about what has
                 * actually been added, contrary to the spec. Thus, `textInput` is the best
                 * available event to identify the characters that have actually been inserted
                 * into the target node.
                 *
                 * This plugin is also responsible for emitting `composition` events, thus
                 * allowing us to share composition fallback code for both `beforeInput` and
                 * `composition` event types.
                 */
                var BeforeInputEventPlugin = {
                    eventTypes: eventTypes,

                    extractEvents: function (
                        topLevelType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    ) {
                        return [
                            extractCompositionEvent(
                                topLevelType,
                                targetInst,
                                nativeEvent,
                                nativeEventTarget
                            ),
                            extractBeforeInputEvent(
                                topLevelType,
                                targetInst,
                                nativeEvent,
                                nativeEventTarget
                            ),
                        ];
                    },
                };

                module.exports = BeforeInputEventPlugin;

                /***/
            },
            /* 386 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var EventPluginHub = __webpack_require__(387);
                var EventPluginUtils = __webpack_require__(389);

                var accumulateInto = __webpack_require__(391);
                var forEachAccumulated = __webpack_require__(392);
                var warning = __webpack_require__(358);

                var getListener = EventPluginHub.getListener;

                /**
                 * Some event types have a notion of different registration names for different
                 * "phases" of propagation. This finds listeners by a given phase.
                 */
                function listenerAtPhase(inst, event, propagationPhase) {
                    var registrationName =
                        event.dispatchConfig.phasedRegistrationNames[
                            propagationPhase
                        ];
                    return getListener(inst, registrationName);
                }

                /**
                 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
                 * here, allows us to not have to bind or create functions for each event.
                 * Mutating the event's members allows us to not have to create a wrapping
                 * "dispatch" object that pairs the event with the listener.
                 */
                function accumulateDirectionalDispatches(inst, phase, event) {
                    if (false) {
                        process.env.NODE_ENV !== "production"
                            ? warning(inst, "Dispatching inst must not be null")
                            : void 0;
                    }
                    var listener = listenerAtPhase(inst, event, phase);
                    if (listener) {
                        event._dispatchListeners = accumulateInto(
                            event._dispatchListeners,
                            listener
                        );
                        event._dispatchInstances = accumulateInto(
                            event._dispatchInstances,
                            inst
                        );
                    }
                }

                /**
                 * Collect dispatches (must be entirely collected before dispatching - see unit
                 * tests). Lazily allocate the array to conserve memory.  We must loop through
                 * each event and perform the traversal for each one. We cannot perform a
                 * single traversal for the entire collection of events because each event may
                 * have a different target.
                 */
                function accumulateTwoPhaseDispatchesSingle(event) {
                    if (event && event.dispatchConfig.phasedRegistrationNames) {
                        EventPluginUtils.traverseTwoPhase(
                            event._targetInst,
                            accumulateDirectionalDispatches,
                            event
                        );
                    }
                }

                /**
                 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
                 */
                function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
                    if (event && event.dispatchConfig.phasedRegistrationNames) {
                        var targetInst = event._targetInst;
                        var parentInst = targetInst
                            ? EventPluginUtils.getParentInstance(targetInst)
                            : null;
                        EventPluginUtils.traverseTwoPhase(
                            parentInst,
                            accumulateDirectionalDispatches,
                            event
                        );
                    }
                }

                /**
                 * Accumulates without regard to direction, does not look for phased
                 * registration names. Same as `accumulateDirectDispatchesSingle` but without
                 * requiring that the `dispatchMarker` be the same as the dispatched ID.
                 */
                function accumulateDispatches(inst, ignoredDirection, event) {
                    if (event && event.dispatchConfig.registrationName) {
                        var registrationName =
                            event.dispatchConfig.registrationName;
                        var listener = getListener(inst, registrationName);
                        if (listener) {
                            event._dispatchListeners = accumulateInto(
                                event._dispatchListeners,
                                listener
                            );
                            event._dispatchInstances = accumulateInto(
                                event._dispatchInstances,
                                inst
                            );
                        }
                    }
                }

                /**
                 * Accumulates dispatches on an `SyntheticEvent`, but only for the
                 * `dispatchMarker`.
                 * @param {SyntheticEvent} event
                 */
                function accumulateDirectDispatchesSingle(event) {
                    if (event && event.dispatchConfig.registrationName) {
                        accumulateDispatches(event._targetInst, null, event);
                    }
                }

                function accumulateTwoPhaseDispatches(events) {
                    forEachAccumulated(
                        events,
                        accumulateTwoPhaseDispatchesSingle
                    );
                }

                function accumulateTwoPhaseDispatchesSkipTarget(events) {
                    forEachAccumulated(
                        events,
                        accumulateTwoPhaseDispatchesSingleSkipTarget
                    );
                }

                function accumulateEnterLeaveDispatches(
                    leave,
                    enter,
                    from,
                    to
                ) {
                    EventPluginUtils.traverseEnterLeave(
                        from,
                        to,
                        accumulateDispatches,
                        leave,
                        enter
                    );
                }

                function accumulateDirectDispatches(events) {
                    forEachAccumulated(
                        events,
                        accumulateDirectDispatchesSingle
                    );
                }

                /**
                 * A small set of propagation patterns, each of which will accept a small amount
                 * of information, and generate a set of "dispatch ready event objects" - which
                 * are sets of events that have already been annotated with a set of dispatched
                 * listener functions/ids. The API is designed this way to discourage these
                 * propagation strategies from actually executing the dispatches, since we
                 * always want to collect the entire set of dispatches before executing event a
                 * single one.
                 *
                 * @constructor EventPropagators
                 */
                var EventPropagators = {
                    accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
                    accumulateTwoPhaseDispatchesSkipTarget:
                        accumulateTwoPhaseDispatchesSkipTarget,
                    accumulateDirectDispatches: accumulateDirectDispatches,
                    accumulateEnterLeaveDispatches:
                        accumulateEnterLeaveDispatches,
                };

                module.exports = EventPropagators;

                /***/
            },
            /* 387 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var EventPluginRegistry = __webpack_require__(388);
                var EventPluginUtils = __webpack_require__(389);
                var ReactErrorUtils = __webpack_require__(390);

                var accumulateInto = __webpack_require__(391);
                var forEachAccumulated = __webpack_require__(392);
                var invariant = __webpack_require__(355);

                /**
                 * Internal store for event listeners
                 */
                var listenerBank = {};

                /**
                 * Internal queue of events that have accumulated their dispatches and are
                 * waiting to have their dispatches executed.
                 */
                var eventQueue = null;

                /**
                 * Dispatches an event and releases it back into the pool, unless persistent.
                 *
                 * @param {?object} event Synthetic event to be dispatched.
                 * @param {boolean} simulated If the event is simulated (changes exn behavior)
                 * @private
                 */
                var executeDispatchesAndRelease = function (event, simulated) {
                    if (event) {
                        EventPluginUtils.executeDispatchesInOrder(
                            event,
                            simulated
                        );

                        if (!event.isPersistent()) {
                            event.constructor.release(event);
                        }
                    }
                };
                var executeDispatchesAndReleaseSimulated = function (e) {
                    return executeDispatchesAndRelease(e, true);
                };
                var executeDispatchesAndReleaseTopLevel = function (e) {
                    return executeDispatchesAndRelease(e, false);
                };

                var getDictionaryKey = function (inst) {
                    // Prevents V8 performance issue:
                    // https://github.com/facebook/react/pull/7232
                    return "." + inst._rootNodeID;
                };

                function isInteractive(tag) {
                    return (
                        tag === "button" ||
                        tag === "input" ||
                        tag === "select" ||
                        tag === "textarea"
                    );
                }

                function shouldPreventMouseEvent(name, type, props) {
                    switch (name) {
                        case "onClick":
                        case "onClickCapture":
                        case "onDoubleClick":
                        case "onDoubleClickCapture":
                        case "onMouseDown":
                        case "onMouseDownCapture":
                        case "onMouseMove":
                        case "onMouseMoveCapture":
                        case "onMouseUp":
                        case "onMouseUpCapture":
                            return !!(props.disabled && isInteractive(type));
                        default:
                            return false;
                    }
                }

                /**
                 * This is a unified interface for event plugins to be installed and configured.
                 *
                 * Event plugins can implement the following properties:
                 *
                 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
                 *     Required. When a top-level event is fired, this method is expected to
                 *     extract synthetic events that will in turn be queued and dispatched.
                 *
                 *   `eventTypes` {object}
                 *     Optional, plugins that fire events must publish a mapping of registration
                 *     names that are used to register listeners. Values of this mapping must
                 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
                 *
                 *   `executeDispatch` {function(object, function, string)}
                 *     Optional, allows plugins to override how an event gets dispatched. By
                 *     default, the listener is simply invoked.
                 *
                 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
                 *
                 * @public
                 */
                var EventPluginHub = {
                    /**
                     * Methods for injecting dependencies.
                     */
                    injection: {
                        /**
                         * @param {array} InjectedEventPluginOrder
                         * @public
                         */
                        injectEventPluginOrder:
                            EventPluginRegistry.injectEventPluginOrder,

                        /**
                         * @param {object} injectedNamesToPlugins Map from names to plugin modules.
                         */
                        injectEventPluginsByName:
                            EventPluginRegistry.injectEventPluginsByName,
                    },

                    /**
                     * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
                     *
                     * @param {object} inst The instance, which is the source of events.
                     * @param {string} registrationName Name of listener (e.g. `onClick`).
                     * @param {function} listener The callback to store.
                     */
                    putListener: function (inst, registrationName, listener) {
                        !(typeof listener === "function")
                            ? false
                                ? invariant(
                                      false,
                                      "Expected %s listener to be a function, instead got type %s",
                                      registrationName,
                                      typeof listener
                                  )
                                : _prodInvariant(
                                      "94",
                                      registrationName,
                                      typeof listener
                                  )
                            : void 0;

                        var key = getDictionaryKey(inst);
                        var bankForRegistrationName =
                            listenerBank[registrationName] ||
                            (listenerBank[registrationName] = {});
                        bankForRegistrationName[key] = listener;

                        var PluginModule =
                            EventPluginRegistry.registrationNameModules[
                                registrationName
                            ];
                        if (PluginModule && PluginModule.didPutListener) {
                            PluginModule.didPutListener(
                                inst,
                                registrationName,
                                listener
                            );
                        }
                    },

                    /**
                     * @param {object} inst The instance, which is the source of events.
                     * @param {string} registrationName Name of listener (e.g. `onClick`).
                     * @return {?function} The stored callback.
                     */
                    getListener: function (inst, registrationName) {
                        // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
                        // live here; needs to be moved to a better place soon
                        var bankForRegistrationName =
                            listenerBank[registrationName];
                        if (
                            shouldPreventMouseEvent(
                                registrationName,
                                inst._currentElement.type,
                                inst._currentElement.props
                            )
                        ) {
                            return null;
                        }
                        var key = getDictionaryKey(inst);
                        return (
                            bankForRegistrationName &&
                            bankForRegistrationName[key]
                        );
                    },

                    /**
                     * Deletes a listener from the registration bank.
                     *
                     * @param {object} inst The instance, which is the source of events.
                     * @param {string} registrationName Name of listener (e.g. `onClick`).
                     */
                    deleteListener: function (inst, registrationName) {
                        var PluginModule =
                            EventPluginRegistry.registrationNameModules[
                                registrationName
                            ];
                        if (PluginModule && PluginModule.willDeleteListener) {
                            PluginModule.willDeleteListener(
                                inst,
                                registrationName
                            );
                        }

                        var bankForRegistrationName =
                            listenerBank[registrationName];
                        // TODO: This should never be null -- when is it?
                        if (bankForRegistrationName) {
                            var key = getDictionaryKey(inst);
                            delete bankForRegistrationName[key];
                        }
                    },

                    /**
                     * Deletes all listeners for the DOM element with the supplied ID.
                     *
                     * @param {object} inst The instance, which is the source of events.
                     */
                    deleteAllListeners: function (inst) {
                        var key = getDictionaryKey(inst);
                        for (var registrationName in listenerBank) {
                            if (
                                !listenerBank.hasOwnProperty(registrationName)
                            ) {
                                continue;
                            }

                            if (!listenerBank[registrationName][key]) {
                                continue;
                            }

                            var PluginModule =
                                EventPluginRegistry.registrationNameModules[
                                    registrationName
                                ];
                            if (
                                PluginModule &&
                                PluginModule.willDeleteListener
                            ) {
                                PluginModule.willDeleteListener(
                                    inst,
                                    registrationName
                                );
                            }

                            delete listenerBank[registrationName][key];
                        }
                    },

                    /**
                     * Allows registered plugins an opportunity to extract events from top-level
                     * native browser events.
                     *
                     * @return {*} An accumulation of synthetic events.
                     * @internal
                     */
                    extractEvents: function (
                        topLevelType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    ) {
                        var events;
                        var plugins = EventPluginRegistry.plugins;
                        for (var i = 0; i < plugins.length; i++) {
                            // Not every plugin in the ordering may be loaded at runtime.
                            var possiblePlugin = plugins[i];
                            if (possiblePlugin) {
                                var extractedEvents =
                                    possiblePlugin.extractEvents(
                                        topLevelType,
                                        targetInst,
                                        nativeEvent,
                                        nativeEventTarget
                                    );
                                if (extractedEvents) {
                                    events = accumulateInto(
                                        events,
                                        extractedEvents
                                    );
                                }
                            }
                        }
                        return events;
                    },

                    /**
                     * Enqueues a synthetic event that should be dispatched when
                     * `processEventQueue` is invoked.
                     *
                     * @param {*} events An accumulation of synthetic events.
                     * @internal
                     */
                    enqueueEvents: function (events) {
                        if (events) {
                            eventQueue = accumulateInto(eventQueue, events);
                        }
                    },

                    /**
                     * Dispatches all synthetic events on the event queue.
                     *
                     * @internal
                     */
                    processEventQueue: function (simulated) {
                        // Set `eventQueue` to null before processing it so that we can tell if more
                        // events get enqueued while processing.
                        var processingEventQueue = eventQueue;
                        eventQueue = null;
                        if (simulated) {
                            forEachAccumulated(
                                processingEventQueue,
                                executeDispatchesAndReleaseSimulated
                            );
                        } else {
                            forEachAccumulated(
                                processingEventQueue,
                                executeDispatchesAndReleaseTopLevel
                            );
                        }
                        !!eventQueue
                            ? false
                                ? invariant(
                                      false,
                                      "processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented."
                                  )
                                : _prodInvariant("95")
                            : void 0;
                        // This would be a good time to rethrow if any of the event handlers threw.
                        ReactErrorUtils.rethrowCaughtError();
                    },

                    /**
                     * These are needed for tests only. Do not use!
                     */
                    __purge: function () {
                        listenerBank = {};
                    },

                    __getListenerBank: function () {
                        return listenerBank;
                    },
                };

                module.exports = EventPluginHub;

                /***/
            },
            /* 388 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                /**
                 * Injectable ordering of event plugins.
                 */
                var eventPluginOrder = null;

                /**
                 * Injectable mapping from names to event plugin modules.
                 */
                var namesToPlugins = {};

                /**
                 * Recomputes the plugin list using the injected plugins and plugin ordering.
                 *
                 * @private
                 */
                function recomputePluginOrdering() {
                    if (!eventPluginOrder) {
                        // Wait until an `eventPluginOrder` is injected.
                        return;
                    }
                    for (var pluginName in namesToPlugins) {
                        var pluginModule = namesToPlugins[pluginName];
                        var pluginIndex = eventPluginOrder.indexOf(pluginName);
                        !(pluginIndex > -1)
                            ? false
                                ? invariant(
                                      false,
                                      "EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.",
                                      pluginName
                                  )
                                : _prodInvariant("96", pluginName)
                            : void 0;
                        if (EventPluginRegistry.plugins[pluginIndex]) {
                            continue;
                        }
                        !pluginModule.extractEvents
                            ? false
                                ? invariant(
                                      false,
                                      "EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.",
                                      pluginName
                                  )
                                : _prodInvariant("97", pluginName)
                            : void 0;
                        EventPluginRegistry.plugins[pluginIndex] = pluginModule;
                        var publishedEvents = pluginModule.eventTypes;
                        for (var eventName in publishedEvents) {
                            !publishEventForPlugin(
                                publishedEvents[eventName],
                                pluginModule,
                                eventName
                            )
                                ? false
                                    ? invariant(
                                          false,
                                          "EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.",
                                          eventName,
                                          pluginName
                                      )
                                    : _prodInvariant(
                                          "98",
                                          eventName,
                                          pluginName
                                      )
                                : void 0;
                        }
                    }
                }

                /**
                 * Publishes an event so that it can be dispatched by the supplied plugin.
                 *
                 * @param {object} dispatchConfig Dispatch configuration for the event.
                 * @param {object} PluginModule Plugin publishing the event.
                 * @return {boolean} True if the event was successfully published.
                 * @private
                 */
                function publishEventForPlugin(
                    dispatchConfig,
                    pluginModule,
                    eventName
                ) {
                    !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(
                        eventName
                    )
                        ? false
                            ? invariant(
                                  false,
                                  "EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.",
                                  eventName
                              )
                            : _prodInvariant("99", eventName)
                        : void 0;
                    EventPluginRegistry.eventNameDispatchConfigs[eventName] =
                        dispatchConfig;

                    var phasedRegistrationNames =
                        dispatchConfig.phasedRegistrationNames;
                    if (phasedRegistrationNames) {
                        for (var phaseName in phasedRegistrationNames) {
                            if (
                                phasedRegistrationNames.hasOwnProperty(
                                    phaseName
                                )
                            ) {
                                var phasedRegistrationName =
                                    phasedRegistrationNames[phaseName];
                                publishRegistrationName(
                                    phasedRegistrationName,
                                    pluginModule,
                                    eventName
                                );
                            }
                        }
                        return true;
                    } else if (dispatchConfig.registrationName) {
                        publishRegistrationName(
                            dispatchConfig.registrationName,
                            pluginModule,
                            eventName
                        );
                        return true;
                    }
                    return false;
                }

                /**
                 * Publishes a registration name that is used to identify dispatched events and
                 * can be used with `EventPluginHub.putListener` to register listeners.
                 *
                 * @param {string} registrationName Registration name to add.
                 * @param {object} PluginModule Plugin publishing the event.
                 * @private
                 */
                function publishRegistrationName(
                    registrationName,
                    pluginModule,
                    eventName
                ) {
                    !!EventPluginRegistry.registrationNameModules[
                        registrationName
                    ]
                        ? false
                            ? invariant(
                                  false,
                                  "EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.",
                                  registrationName
                              )
                            : _prodInvariant("100", registrationName)
                        : void 0;
                    EventPluginRegistry.registrationNameModules[
                        registrationName
                    ] = pluginModule;
                    EventPluginRegistry.registrationNameDependencies[
                        registrationName
                    ] = pluginModule.eventTypes[eventName].dependencies;

                    if (false) {
                        var lowerCasedName = registrationName.toLowerCase();
                        EventPluginRegistry.possibleRegistrationNames[
                            lowerCasedName
                        ] = registrationName;

                        if (registrationName === "onDoubleClick") {
                            EventPluginRegistry.possibleRegistrationNames.ondblclick =
                                registrationName;
                        }
                    }
                }

                /**
                 * Registers plugins so that they can extract and dispatch events.
                 *
                 * @see {EventPluginHub}
                 */
                var EventPluginRegistry = {
                    /**
                     * Ordered list of injected plugins.
                     */
                    plugins: [],

                    /**
                     * Mapping from event name to dispatch config
                     */
                    eventNameDispatchConfigs: {},

                    /**
                     * Mapping from registration name to plugin module
                     */
                    registrationNameModules: {},

                    /**
                     * Mapping from registration name to event name
                     */
                    registrationNameDependencies: {},

                    /**
                     * Mapping from lowercase registration names to the properly cased version,
                     * used to warn in the case of missing event handlers. Available
                     * only in __DEV__.
                     * @type {Object}
                     */
                    possibleRegistrationNames: false ? {} : null,
                    // Trust the developer to only use possibleRegistrationNames in __DEV__

                    /**
                     * Injects an ordering of plugins (by plugin name). This allows the ordering
                     * to be decoupled from injection of the actual plugins so that ordering is
                     * always deterministic regardless of packaging, on-the-fly injection, etc.
                     *
                     * @param {array} InjectedEventPluginOrder
                     * @internal
                     * @see {EventPluginHub.injection.injectEventPluginOrder}
                     */
                    injectEventPluginOrder: function (
                        injectedEventPluginOrder
                    ) {
                        !!eventPluginOrder
                            ? false
                                ? invariant(
                                      false,
                                      "EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React."
                                  )
                                : _prodInvariant("101")
                            : void 0;
                        // Clone the ordering so it cannot be dynamically mutated.
                        eventPluginOrder = Array.prototype.slice.call(
                            injectedEventPluginOrder
                        );
                        recomputePluginOrdering();
                    },

                    /**
                     * Injects plugins to be used by `EventPluginHub`. The plugin names must be
                     * in the ordering injected by `injectEventPluginOrder`.
                     *
                     * Plugins can be injected as part of page initialization or on-the-fly.
                     *
                     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
                     * @internal
                     * @see {EventPluginHub.injection.injectEventPluginsByName}
                     */
                    injectEventPluginsByName: function (
                        injectedNamesToPlugins
                    ) {
                        var isOrderingDirty = false;
                        for (var pluginName in injectedNamesToPlugins) {
                            if (
                                !injectedNamesToPlugins.hasOwnProperty(
                                    pluginName
                                )
                            ) {
                                continue;
                            }
                            var pluginModule =
                                injectedNamesToPlugins[pluginName];
                            if (
                                !namesToPlugins.hasOwnProperty(pluginName) ||
                                namesToPlugins[pluginName] !== pluginModule
                            ) {
                                !!namesToPlugins[pluginName]
                                    ? false
                                        ? invariant(
                                              false,
                                              "EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.",
                                              pluginName
                                          )
                                        : _prodInvariant("102", pluginName)
                                    : void 0;
                                namesToPlugins[pluginName] = pluginModule;
                                isOrderingDirty = true;
                            }
                        }
                        if (isOrderingDirty) {
                            recomputePluginOrdering();
                        }
                    },

                    /**
                     * Looks up the plugin for the supplied event.
                     *
                     * @param {object} event A synthetic event.
                     * @return {?object} The plugin that created the supplied event.
                     * @internal
                     */
                    getPluginModuleForEvent: function (event) {
                        var dispatchConfig = event.dispatchConfig;
                        if (dispatchConfig.registrationName) {
                            return (
                                EventPluginRegistry.registrationNameModules[
                                    dispatchConfig.registrationName
                                ] || null
                            );
                        }
                        if (
                            dispatchConfig.phasedRegistrationNames !== undefined
                        ) {
                            // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
                            // that it is not undefined.
                            var phasedRegistrationNames =
                                dispatchConfig.phasedRegistrationNames;

                            for (var phase in phasedRegistrationNames) {
                                if (
                                    !phasedRegistrationNames.hasOwnProperty(
                                        phase
                                    )
                                ) {
                                    continue;
                                }
                                var pluginModule =
                                    EventPluginRegistry.registrationNameModules[
                                        phasedRegistrationNames[phase]
                                    ];
                                if (pluginModule) {
                                    return pluginModule;
                                }
                            }
                        }
                        return null;
                    },

                    /**
                     * Exposed for unit testing.
                     * @private
                     */
                    _resetEventPlugins: function () {
                        eventPluginOrder = null;
                        for (var pluginName in namesToPlugins) {
                            if (namesToPlugins.hasOwnProperty(pluginName)) {
                                delete namesToPlugins[pluginName];
                            }
                        }
                        EventPluginRegistry.plugins.length = 0;

                        var eventNameDispatchConfigs =
                            EventPluginRegistry.eventNameDispatchConfigs;
                        for (var eventName in eventNameDispatchConfigs) {
                            if (
                                eventNameDispatchConfigs.hasOwnProperty(
                                    eventName
                                )
                            ) {
                                delete eventNameDispatchConfigs[eventName];
                            }
                        }

                        var registrationNameModules =
                            EventPluginRegistry.registrationNameModules;
                        for (var registrationName in registrationNameModules) {
                            if (
                                registrationNameModules.hasOwnProperty(
                                    registrationName
                                )
                            ) {
                                delete registrationNameModules[
                                    registrationName
                                ];
                            }
                        }

                        if (false) {
                            var possibleRegistrationNames =
                                EventPluginRegistry.possibleRegistrationNames;
                            for (var lowerCasedName in possibleRegistrationNames) {
                                if (
                                    possibleRegistrationNames.hasOwnProperty(
                                        lowerCasedName
                                    )
                                ) {
                                    delete possibleRegistrationNames[
                                        lowerCasedName
                                    ];
                                }
                            }
                        }
                    },
                };

                module.exports = EventPluginRegistry;

                /***/
            },
            /* 389 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var ReactErrorUtils = __webpack_require__(390);

                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                /**
                 * Injected dependencies:
                 */

                /**
                 * - `ComponentTree`: [required] Module that can convert between React instances
                 *   and actual node references.
                 */
                var ComponentTree;
                var TreeTraversal;
                var injection = {
                    injectComponentTree: function (Injected) {
                        ComponentTree = Injected;
                        if (false) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      Injected &&
                                          Injected.getNodeFromInstance &&
                                          Injected.getInstanceFromNode,
                                      "EventPluginUtils.injection.injectComponentTree(...): Injected " +
                                          "module is missing getNodeFromInstance or getInstanceFromNode."
                                  )
                                : void 0;
                        }
                    },
                    injectTreeTraversal: function (Injected) {
                        TreeTraversal = Injected;
                        if (false) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      Injected &&
                                          Injected.isAncestor &&
                                          Injected.getLowestCommonAncestor,
                                      "EventPluginUtils.injection.injectTreeTraversal(...): Injected " +
                                          "module is missing isAncestor or getLowestCommonAncestor."
                                  )
                                : void 0;
                        }
                    },
                };

                function isEndish(topLevelType) {
                    return (
                        topLevelType === "topMouseUp" ||
                        topLevelType === "topTouchEnd" ||
                        topLevelType === "topTouchCancel"
                    );
                }

                function isMoveish(topLevelType) {
                    return (
                        topLevelType === "topMouseMove" ||
                        topLevelType === "topTouchMove"
                    );
                }
                function isStartish(topLevelType) {
                    return (
                        topLevelType === "topMouseDown" ||
                        topLevelType === "topTouchStart"
                    );
                }

                var validateEventDispatches;
                if (false) {
                    validateEventDispatches = function (event) {
                        var dispatchListeners = event._dispatchListeners;
                        var dispatchInstances = event._dispatchInstances;

                        var listenersIsArr = Array.isArray(dispatchListeners);
                        var listenersLen = listenersIsArr
                            ? dispatchListeners.length
                            : dispatchListeners
                            ? 1
                            : 0;

                        var instancesIsArr = Array.isArray(dispatchInstances);
                        var instancesLen = instancesIsArr
                            ? dispatchInstances.length
                            : dispatchInstances
                            ? 1
                            : 0;

                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  instancesIsArr === listenersIsArr &&
                                      instancesLen === listenersLen,
                                  "EventPluginUtils: Invalid `event`."
                              )
                            : void 0;
                    };
                }

                /**
                 * Dispatch the event to the listener.
                 * @param {SyntheticEvent} event SyntheticEvent to handle
                 * @param {boolean} simulated If the event is simulated (changes exn behavior)
                 * @param {function} listener Application-level callback
                 * @param {*} inst Internal component instance
                 */
                function executeDispatch(event, simulated, listener, inst) {
                    var type = event.type || "unknown-event";
                    event.currentTarget =
                        EventPluginUtils.getNodeFromInstance(inst);
                    if (simulated) {
                        ReactErrorUtils.invokeGuardedCallbackWithCatch(
                            type,
                            listener,
                            event
                        );
                    } else {
                        ReactErrorUtils.invokeGuardedCallback(
                            type,
                            listener,
                            event
                        );
                    }
                    event.currentTarget = null;
                }

                /**
                 * Standard/simple iteration through an event's collected dispatches.
                 */
                function executeDispatchesInOrder(event, simulated) {
                    var dispatchListeners = event._dispatchListeners;
                    var dispatchInstances = event._dispatchInstances;
                    if (false) {
                        validateEventDispatches(event);
                    }
                    if (Array.isArray(dispatchListeners)) {
                        for (var i = 0; i < dispatchListeners.length; i++) {
                            if (event.isPropagationStopped()) {
                                break;
                            }
                            // Listeners and Instances are two parallel arrays that are always in sync.
                            executeDispatch(
                                event,
                                simulated,
                                dispatchListeners[i],
                                dispatchInstances[i]
                            );
                        }
                    } else if (dispatchListeners) {
                        executeDispatch(
                            event,
                            simulated,
                            dispatchListeners,
                            dispatchInstances
                        );
                    }
                    event._dispatchListeners = null;
                    event._dispatchInstances = null;
                }

                /**
                 * Standard/simple iteration through an event's collected dispatches, but stops
                 * at the first dispatch execution returning true, and returns that id.
                 *
                 * @return {?string} id of the first dispatch execution who's listener returns
                 * true, or null if no listener returned true.
                 */
                function executeDispatchesInOrderStopAtTrueImpl(event) {
                    var dispatchListeners = event._dispatchListeners;
                    var dispatchInstances = event._dispatchInstances;
                    if (false) {
                        validateEventDispatches(event);
                    }
                    if (Array.isArray(dispatchListeners)) {
                        for (var i = 0; i < dispatchListeners.length; i++) {
                            if (event.isPropagationStopped()) {
                                break;
                            }
                            // Listeners and Instances are two parallel arrays that are always in sync.
                            if (
                                dispatchListeners[i](
                                    event,
                                    dispatchInstances[i]
                                )
                            ) {
                                return dispatchInstances[i];
                            }
                        }
                    } else if (dispatchListeners) {
                        if (dispatchListeners(event, dispatchInstances)) {
                            return dispatchInstances;
                        }
                    }
                    return null;
                }

                /**
                 * @see executeDispatchesInOrderStopAtTrueImpl
                 */
                function executeDispatchesInOrderStopAtTrue(event) {
                    var ret = executeDispatchesInOrderStopAtTrueImpl(event);
                    event._dispatchInstances = null;
                    event._dispatchListeners = null;
                    return ret;
                }

                /**
                 * Execution of a "direct" dispatch - there must be at most one dispatch
                 * accumulated on the event or it is considered an error. It doesn't really make
                 * sense for an event with multiple dispatches (bubbled) to keep track of the
                 * return values at each dispatch execution, but it does tend to make sense when
                 * dealing with "direct" dispatches.
                 *
                 * @return {*} The return value of executing the single dispatch.
                 */
                function executeDirectDispatch(event) {
                    if (false) {
                        validateEventDispatches(event);
                    }
                    var dispatchListener = event._dispatchListeners;
                    var dispatchInstance = event._dispatchInstances;
                    !!Array.isArray(dispatchListener)
                        ? false
                            ? invariant(
                                  false,
                                  "executeDirectDispatch(...): Invalid `event`."
                              )
                            : _prodInvariant("103")
                        : void 0;
                    event.currentTarget = dispatchListener
                        ? EventPluginUtils.getNodeFromInstance(dispatchInstance)
                        : null;
                    var res = dispatchListener ? dispatchListener(event) : null;
                    event.currentTarget = null;
                    event._dispatchListeners = null;
                    event._dispatchInstances = null;
                    return res;
                }

                /**
                 * @param {SyntheticEvent} event
                 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
                 */
                function hasDispatches(event) {
                    return !!event._dispatchListeners;
                }

                /**
                 * General utilities that are useful in creating custom Event Plugins.
                 */
                var EventPluginUtils = {
                    isEndish: isEndish,
                    isMoveish: isMoveish,
                    isStartish: isStartish,

                    executeDirectDispatch: executeDirectDispatch,
                    executeDispatchesInOrder: executeDispatchesInOrder,
                    executeDispatchesInOrderStopAtTrue:
                        executeDispatchesInOrderStopAtTrue,
                    hasDispatches: hasDispatches,

                    getInstanceFromNode: function (node) {
                        return ComponentTree.getInstanceFromNode(node);
                    },
                    getNodeFromInstance: function (node) {
                        return ComponentTree.getNodeFromInstance(node);
                    },
                    isAncestor: function (a, b) {
                        return TreeTraversal.isAncestor(a, b);
                    },
                    getLowestCommonAncestor: function (a, b) {
                        return TreeTraversal.getLowestCommonAncestor(a, b);
                    },
                    getParentInstance: function (inst) {
                        return TreeTraversal.getParentInstance(inst);
                    },
                    traverseTwoPhase: function (target, fn, arg) {
                        return TreeTraversal.traverseTwoPhase(target, fn, arg);
                    },
                    traverseEnterLeave: function (
                        from,
                        to,
                        fn,
                        argFrom,
                        argTo
                    ) {
                        return TreeTraversal.traverseEnterLeave(
                            from,
                            to,
                            fn,
                            argFrom,
                            argTo
                        );
                    },

                    injection: injection,
                };

                module.exports = EventPluginUtils;

                /***/
            },
            /* 390 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var caughtError = null;

                /**
                 * Call a function while guarding against errors that happens within it.
                 *
                 * @param {String} name of the guard to use for logging or debugging
                 * @param {Function} func The function to invoke
                 * @param {*} a First argument
                 * @param {*} b Second argument
                 */
                function invokeGuardedCallback(name, func, a) {
                    try {
                        func(a);
                    } catch (x) {
                        if (caughtError === null) {
                            caughtError = x;
                        }
                    }
                }

                var ReactErrorUtils = {
                    invokeGuardedCallback: invokeGuardedCallback,

                    /**
                     * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
                     * handler are sure to be rethrown by rethrowCaughtError.
                     */
                    invokeGuardedCallbackWithCatch: invokeGuardedCallback,

                    /**
                     * During execution of guarded functions we will capture the first error which
                     * we will rethrow to be handled by the top level error handler.
                     */
                    rethrowCaughtError: function () {
                        if (caughtError) {
                            var error = caughtError;
                            caughtError = null;
                            throw error;
                        }
                    },
                };

                if (false) {
                    /**
                     * To help development we can get better devtools integration by simulating a
                     * real browser event.
                     */
                    if (
                        typeof window !== "undefined" &&
                        typeof window.dispatchEvent === "function" &&
                        typeof document !== "undefined" &&
                        typeof document.createEvent === "function"
                    ) {
                        var fakeNode = document.createElement("react");
                        ReactErrorUtils.invokeGuardedCallback = function (
                            name,
                            func,
                            a
                        ) {
                            var boundFunc = func.bind(null, a);
                            var evtType = "react-" + name;
                            fakeNode.addEventListener(
                                evtType,
                                boundFunc,
                                false
                            );
                            var evt = document.createEvent("Event");
                            // $FlowFixMe https://github.com/facebook/flow/issues/2336
                            evt.initEvent(evtType, false, false);
                            fakeNode.dispatchEvent(evt);
                            fakeNode.removeEventListener(
                                evtType,
                                boundFunc,
                                false
                            );
                        };
                    }
                }

                module.exports = ReactErrorUtils;

                /***/
            },
            /* 391 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                /**
                 * Accumulates items that must not be null or undefined into the first one. This
                 * is used to conserve memory by avoiding array allocations, and thus sacrifices
                 * API cleanness. Since `current` can be null before being passed in and not
                 * null after this function, make sure to assign it back to `current`:
                 *
                 * `a = accumulateInto(a, b);`
                 *
                 * This API should be sparingly used. Try `accumulate` for something cleaner.
                 *
                 * @return {*|array<*>} An accumulation of items.
                 */

                function accumulateInto(current, next) {
                    !(next != null)
                        ? false
                            ? invariant(
                                  false,
                                  "accumulateInto(...): Accumulated items must not be null or undefined."
                              )
                            : _prodInvariant("30")
                        : void 0;

                    if (current == null) {
                        return next;
                    }

                    // Both are not empty. Warning: Never call x.concat(y) when you are not
                    // certain that x is an Array (x could be a string with concat method).
                    if (Array.isArray(current)) {
                        if (Array.isArray(next)) {
                            current.push.apply(current, next);
                            return current;
                        }
                        current.push(next);
                        return current;
                    }

                    if (Array.isArray(next)) {
                        // A bit too dangerous to mutate `next`.
                        return [current].concat(next);
                    }

                    return [current, next];
                }

                module.exports = accumulateInto;

                /***/
            },
            /* 392 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                /**
                 * @param {array} arr an "accumulation" of items which is either an Array or
                 * a single item. Useful when paired with the `accumulate` module. This is a
                 * simple utility that allows us to reason about a collection of items, but
                 * handling the case when there is exactly one item (and we do not need to
                 * allocate an array).
                 */

                function forEachAccumulated(arr, cb, scope) {
                    if (Array.isArray(arr)) {
                        arr.forEach(cb, scope);
                    } else if (arr) {
                        cb.call(scope, arr);
                    }
                }

                module.exports = forEachAccumulated;

                /***/
            },
            /* 393 */
            /***/ function (module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var canUseDOM = !!(
                    typeof window !== "undefined" &&
                    window.document &&
                    window.document.createElement
                );

                /**
                 * Simple, lightweight module assisting with the detection and context of
                 * Worker. Helps avoid circular dependencies and allows code to reason about
                 * whether or not they are in a Worker, even if they never include the main
                 * `ReactWorker` dependency.
                 */
                var ExecutionEnvironment = {
                    canUseDOM: canUseDOM,

                    canUseWorkers: typeof Worker !== "undefined",

                    canUseEventListeners:
                        canUseDOM &&
                        !!(window.addEventListener || window.attachEvent),

                    canUseViewport: canUseDOM && !!window.screen,

                    isInWorker: !canUseDOM, // For now, this is true - might change in the future.
                };

                module.exports = ExecutionEnvironment;

                /***/
            },
            /* 394 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var PooledClass = __webpack_require__(395);

                var getTextContentAccessor = __webpack_require__(396);

                /**
                 * This helper class stores information about text content of a target node,
                 * allowing comparison of content before and after a given event.
                 *
                 * Identify the node where selection currently begins, then observe
                 * both its text content and its current position in the DOM. Since the
                 * browser may natively replace the target node during composition, we can
                 * use its position to find its replacement.
                 *
                 * @param {DOMEventTarget} root
                 */
                function FallbackCompositionState(root) {
                    this._root = root;
                    this._startText = this.getText();
                    this._fallbackText = null;
                }

                _assign(FallbackCompositionState.prototype, {
                    destructor: function () {
                        this._root = null;
                        this._startText = null;
                        this._fallbackText = null;
                    },

                    /**
                     * Get current text of input.
                     *
                     * @return {string}
                     */
                    getText: function () {
                        if ("value" in this._root) {
                            return this._root.value;
                        }
                        return this._root[getTextContentAccessor()];
                    },

                    /**
                     * Determine the differing substring between the initially stored
                     * text content and the current content.
                     *
                     * @return {string}
                     */
                    getData: function () {
                        if (this._fallbackText) {
                            return this._fallbackText;
                        }

                        var start;
                        var startValue = this._startText;
                        var startLength = startValue.length;
                        var end;
                        var endValue = this.getText();
                        var endLength = endValue.length;

                        for (start = 0; start < startLength; start++) {
                            if (startValue[start] !== endValue[start]) {
                                break;
                            }
                        }

                        var minEnd = startLength - start;
                        for (end = 1; end <= minEnd; end++) {
                            if (
                                startValue[startLength - end] !==
                                endValue[endLength - end]
                            ) {
                                break;
                            }
                        }

                        var sliceTail = end > 1 ? 1 - end : undefined;
                        this._fallbackText = endValue.slice(start, sliceTail);
                        return this._fallbackText;
                    },
                });

                PooledClass.addPoolingTo(FallbackCompositionState);

                module.exports = FallbackCompositionState;

                /***/
            },
            /* 395 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                /**
                 * Static poolers. Several custom versions for each potential number of
                 * arguments. A completely generic pooler is easy to implement, but would
                 * require accessing the `arguments` object. In each of these, `this` refers to
                 * the Class itself, not an instance. If any others are needed, simply add them
                 * here, or in their own files.
                 */
                var oneArgumentPooler = function (copyFieldsFrom) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, copyFieldsFrom);
                        return instance;
                    } else {
                        return new Klass(copyFieldsFrom);
                    }
                };

                var twoArgumentPooler = function (a1, a2) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2);
                        return instance;
                    } else {
                        return new Klass(a1, a2);
                    }
                };

                var threeArgumentPooler = function (a1, a2, a3) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2, a3);
                        return instance;
                    } else {
                        return new Klass(a1, a2, a3);
                    }
                };

                var fourArgumentPooler = function (a1, a2, a3, a4) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2, a3, a4);
                        return instance;
                    } else {
                        return new Klass(a1, a2, a3, a4);
                    }
                };

                var standardReleaser = function (instance) {
                    var Klass = this;
                    !(instance instanceof Klass)
                        ? false
                            ? invariant(
                                  false,
                                  "Trying to release an instance into a pool of a different type."
                              )
                            : _prodInvariant("25")
                        : void 0;
                    instance.destructor();
                    if (Klass.instancePool.length < Klass.poolSize) {
                        Klass.instancePool.push(instance);
                    }
                };

                var DEFAULT_POOL_SIZE = 10;
                var DEFAULT_POOLER = oneArgumentPooler;

                /**
                 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
                 * itself (statically) not adding any prototypical fields. Any CopyConstructor
                 * you give this may have a `poolSize` property, and will look for a
                 * prototypical `destructor` on instances.
                 *
                 * @param {Function} CopyConstructor Constructor that can be used to reset.
                 * @param {Function} pooler Customizable pooler.
                 */
                var addPoolingTo = function (CopyConstructor, pooler) {
                    // Casting as any so that flow ignores the actual implementation and trusts
                    // it to match the type we declared
                    var NewKlass = CopyConstructor;
                    NewKlass.instancePool = [];
                    NewKlass.getPooled = pooler || DEFAULT_POOLER;
                    if (!NewKlass.poolSize) {
                        NewKlass.poolSize = DEFAULT_POOL_SIZE;
                    }
                    NewKlass.release = standardReleaser;
                    return NewKlass;
                };

                var PooledClass = {
                    addPoolingTo: addPoolingTo,
                    oneArgumentPooler: oneArgumentPooler,
                    twoArgumentPooler: twoArgumentPooler,
                    threeArgumentPooler: threeArgumentPooler,
                    fourArgumentPooler: fourArgumentPooler,
                };

                module.exports = PooledClass;

                /***/
            },
            /* 396 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ExecutionEnvironment = __webpack_require__(393);

                var contentKey = null;

                /**
                 * Gets the key used to access text content on a DOM node.
                 *
                 * @return {?string} Key used to access text content.
                 * @internal
                 */
                function getTextContentAccessor() {
                    if (!contentKey && ExecutionEnvironment.canUseDOM) {
                        // Prefer textContent to innerText because many browsers support both but
                        // SVG <text> elements don't support innerText even when <div> does.
                        contentKey =
                            "textContent" in document.documentElement
                                ? "textContent"
                                : "innerText";
                    }
                    return contentKey;
                }

                module.exports = getTextContentAccessor;

                /***/
            },
            /* 397 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticEvent = __webpack_require__(398);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
                 */
                var CompositionEventInterface = {
                    data: null,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticCompositionEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticEvent.augmentClass(
                    SyntheticCompositionEvent,
                    CompositionEventInterface
                );

                module.exports = SyntheticCompositionEvent;

                /***/
            },
            /* 398 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var PooledClass = __webpack_require__(395);

                var emptyFunction = __webpack_require__(359);
                var warning = __webpack_require__(358);

                var didWarnForAddedNewProperty = false;
                var isProxySupported = typeof Proxy === "function";

                var shouldBeReleasedProperties = [
                    "dispatchConfig",
                    "_targetInst",
                    "nativeEvent",
                    "isDefaultPrevented",
                    "isPropagationStopped",
                    "_dispatchListeners",
                    "_dispatchInstances",
                ];

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var EventInterface = {
                    type: null,
                    target: null,
                    // currentTarget is set when dispatching; no use in copying it here
                    currentTarget: emptyFunction.thatReturnsNull,
                    eventPhase: null,
                    bubbles: null,
                    cancelable: null,
                    timeStamp: function (event) {
                        return event.timeStamp || Date.now();
                    },
                    defaultPrevented: null,
                    isTrusted: null,
                };

                /**
                 * Synthetic events are dispatched by event plugins, typically in response to a
                 * top-level event delegation handler.
                 *
                 * These systems should generally use pooling to reduce the frequency of garbage
                 * collection. The system should check `isPersistent` to determine whether the
                 * event should be released into the pool after being dispatched. Users that
                 * need a persisted event should invoke `persist`.
                 *
                 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
                 * normalizing browser quirks. Subclasses do not necessarily have to implement a
                 * DOM interface; custom application-specific events can also subclass this.
                 *
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {*} targetInst Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @param {DOMEventTarget} nativeEventTarget Target node.
                 */
                function SyntheticEvent(
                    dispatchConfig,
                    targetInst,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    if (false) {
                        // these have a getter/setter for warnings
                        delete this.nativeEvent;
                        delete this.preventDefault;
                        delete this.stopPropagation;
                    }

                    this.dispatchConfig = dispatchConfig;
                    this._targetInst = targetInst;
                    this.nativeEvent = nativeEvent;

                    var Interface = this.constructor.Interface;
                    for (var propName in Interface) {
                        if (!Interface.hasOwnProperty(propName)) {
                            continue;
                        }
                        if (false) {
                            delete this[propName]; // this has a getter/setter for warnings
                        }
                        var normalize = Interface[propName];
                        if (normalize) {
                            this[propName] = normalize(nativeEvent);
                        } else {
                            if (propName === "target") {
                                this.target = nativeEventTarget;
                            } else {
                                this[propName] = nativeEvent[propName];
                            }
                        }
                    }

                    var defaultPrevented =
                        nativeEvent.defaultPrevented != null
                            ? nativeEvent.defaultPrevented
                            : nativeEvent.returnValue === false;
                    if (defaultPrevented) {
                        this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
                    } else {
                        this.isDefaultPrevented =
                            emptyFunction.thatReturnsFalse;
                    }
                    this.isPropagationStopped = emptyFunction.thatReturnsFalse;
                    return this;
                }

                _assign(SyntheticEvent.prototype, {
                    preventDefault: function () {
                        this.defaultPrevented = true;
                        var event = this.nativeEvent;
                        if (!event) {
                            return;
                        }

                        if (event.preventDefault) {
                            event.preventDefault();
                        } else if (typeof event.returnValue !== "unknown") {
                            // eslint-disable-line valid-typeof
                            event.returnValue = false;
                        }
                        this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
                    },

                    stopPropagation: function () {
                        var event = this.nativeEvent;
                        if (!event) {
                            return;
                        }

                        if (event.stopPropagation) {
                            event.stopPropagation();
                        } else if (typeof event.cancelBubble !== "unknown") {
                            // eslint-disable-line valid-typeof
                            // The ChangeEventPlugin registers a "propertychange" event for
                            // IE. This event does not support bubbling or cancelling, and
                            // any references to cancelBubble throw "Member not found".  A
                            // typeof check of "unknown" circumvents this issue (and is also
                            // IE specific).
                            event.cancelBubble = true;
                        }

                        this.isPropagationStopped =
                            emptyFunction.thatReturnsTrue;
                    },

                    /**
                     * We release all dispatched `SyntheticEvent`s after each event loop, adding
                     * them back into the pool. This allows a way to hold onto a reference that
                     * won't be added back into the pool.
                     */
                    persist: function () {
                        this.isPersistent = emptyFunction.thatReturnsTrue;
                    },

                    /**
                     * Checks if this event should be released back into the pool.
                     *
                     * @return {boolean} True if this should not be released, false otherwise.
                     */
                    isPersistent: emptyFunction.thatReturnsFalse,

                    /**
                     * `PooledClass` looks for `destructor` on each instance it releases.
                     */
                    destructor: function () {
                        var Interface = this.constructor.Interface;
                        for (var propName in Interface) {
                            if (false) {
                                Object.defineProperty(
                                    this,
                                    propName,
                                    getPooledWarningPropertyDefinition(
                                        propName,
                                        Interface[propName]
                                    )
                                );
                            } else {
                                this[propName] = null;
                            }
                        }
                        for (
                            var i = 0;
                            i < shouldBeReleasedProperties.length;
                            i++
                        ) {
                            this[shouldBeReleasedProperties[i]] = null;
                        }
                        if (false) {
                            Object.defineProperty(
                                this,
                                "nativeEvent",
                                getPooledWarningPropertyDefinition(
                                    "nativeEvent",
                                    null
                                )
                            );
                            Object.defineProperty(
                                this,
                                "preventDefault",
                                getPooledWarningPropertyDefinition(
                                    "preventDefault",
                                    emptyFunction
                                )
                            );
                            Object.defineProperty(
                                this,
                                "stopPropagation",
                                getPooledWarningPropertyDefinition(
                                    "stopPropagation",
                                    emptyFunction
                                )
                            );
                        }
                    },
                });

                SyntheticEvent.Interface = EventInterface;

                if (false) {
                    if (isProxySupported) {
                        /*eslint-disable no-func-assign */
                        SyntheticEvent = new Proxy(SyntheticEvent, {
                            construct: function (target, args) {
                                return this.apply(
                                    target,
                                    Object.create(target.prototype),
                                    args
                                );
                            },
                            apply: function (constructor, that, args) {
                                return new Proxy(
                                    constructor.apply(that, args),
                                    {
                                        set: function (target, prop, value) {
                                            if (
                                                prop !== "isPersistent" &&
                                                !target.constructor.Interface.hasOwnProperty(
                                                    prop
                                                ) &&
                                                shouldBeReleasedProperties.indexOf(
                                                    prop
                                                ) === -1
                                            ) {
                                                process.env.NODE_ENV !==
                                                "production"
                                                    ? warning(
                                                          didWarnForAddedNewProperty ||
                                                              target.isPersistent(),
                                                          "This synthetic event is reused for performance reasons. If you're " +
                                                              "seeing this, you're adding a new property in the synthetic event object. " +
                                                              "The property is never released. See " +
                                                              "https://fb.me/react-event-pooling for more information."
                                                      )
                                                    : void 0;
                                                didWarnForAddedNewProperty = true;
                                            }
                                            target[prop] = value;
                                            return true;
                                        },
                                    }
                                );
                            },
                        });
                        /*eslint-enable no-func-assign */
                    }
                }
                /**
                 * Helper to reduce boilerplate when creating subclasses.
                 *
                 * @param {function} Class
                 * @param {?object} Interface
                 */
                SyntheticEvent.augmentClass = function (Class, Interface) {
                    var Super = this;

                    var E = function () {};
                    E.prototype = Super.prototype;
                    var prototype = new E();

                    _assign(prototype, Class.prototype);
                    Class.prototype = prototype;
                    Class.prototype.constructor = Class;

                    Class.Interface = _assign({}, Super.Interface, Interface);
                    Class.augmentClass = Super.augmentClass;

                    PooledClass.addPoolingTo(
                        Class,
                        PooledClass.fourArgumentPooler
                    );
                };

                PooledClass.addPoolingTo(
                    SyntheticEvent,
                    PooledClass.fourArgumentPooler
                );

                module.exports = SyntheticEvent;

                /**
                 * Helper to nullify syntheticEvent instance properties when destructing
                 *
                 * @param {object} SyntheticEvent
                 * @param {String} propName
                 * @return {object} defineProperty object
                 */
                function getPooledWarningPropertyDefinition(propName, getVal) {
                    var isFunction = typeof getVal === "function";
                    return {
                        configurable: true,
                        set: set,
                        get: get,
                    };

                    function set(val) {
                        var action = isFunction
                            ? "setting the method"
                            : "setting the property";
                        warn(action, "This is effectively a no-op");
                        return val;
                    }

                    function get() {
                        var action = isFunction
                            ? "accessing the method"
                            : "accessing the property";
                        var result = isFunction
                            ? "This is a no-op function"
                            : "This is set to null";
                        warn(action, result);
                        return getVal;
                    }

                    function warn(action, result) {
                        var warningCondition = false;
                        false
                            ? warning(
                                  warningCondition,
                                  "This synthetic event is reused for performance reasons. If you're seeing this, " +
                                      "you're %s `%s` on a released/nullified synthetic event. %s. " +
                                      "If you must keep the original synthetic event around, use event.persist(). " +
                                      "See https://fb.me/react-event-pooling for more information.",
                                  action,
                                  propName,
                                  result
                              )
                            : void 0;
                    }
                }

                /***/
            },
            /* 399 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticEvent = __webpack_require__(398);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
                 *      /#events-inputevents
                 */
                var InputEventInterface = {
                    data: null,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticInputEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticEvent.augmentClass(
                    SyntheticInputEvent,
                    InputEventInterface
                );

                module.exports = SyntheticInputEvent;

                /***/
            },
            /* 400 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var EventPluginHub = __webpack_require__(387);
                var EventPropagators = __webpack_require__(386);
                var ExecutionEnvironment = __webpack_require__(393);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactUpdates = __webpack_require__(401);
                var SyntheticEvent = __webpack_require__(398);

                var getEventTarget = __webpack_require__(409);
                var isEventSupported = __webpack_require__(410);
                var isTextInputElement = __webpack_require__(411);

                var eventTypes = {
                    change: {
                        phasedRegistrationNames: {
                            bubbled: "onChange",
                            captured: "onChangeCapture",
                        },
                        dependencies: [
                            "topBlur",
                            "topChange",
                            "topClick",
                            "topFocus",
                            "topInput",
                            "topKeyDown",
                            "topKeyUp",
                            "topSelectionChange",
                        ],
                    },
                };

                /**
                 * For IE shims
                 */
                var activeElement = null;
                var activeElementInst = null;
                var activeElementValue = null;
                var activeElementValueProp = null;

                /**
                 * SECTION: handle `change` event
                 */
                function shouldUseChangeEvent(elem) {
                    var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
                    return (
                        nodeName === "select" ||
                        (nodeName === "input" && elem.type === "file")
                    );
                }

                var doesChangeEventBubble = false;
                if (ExecutionEnvironment.canUseDOM) {
                    // See `handleChange` comment below
                    doesChangeEventBubble =
                        isEventSupported("change") &&
                        (!document.documentMode || document.documentMode > 8);
                }

                function manualDispatchChangeEvent(nativeEvent) {
                    var event = SyntheticEvent.getPooled(
                        eventTypes.change,
                        activeElementInst,
                        nativeEvent,
                        getEventTarget(nativeEvent)
                    );
                    EventPropagators.accumulateTwoPhaseDispatches(event);

                    // If change and propertychange bubbled, we'd just bind to it like all the
                    // other events and have it go through ReactBrowserEventEmitter. Since it
                    // doesn't, we manually listen for the events and so we have to enqueue and
                    // process the abstract event manually.
                    //
                    // Batching is necessary here in order to ensure that all event handlers run
                    // before the next rerender (including event handlers attached to ancestor
                    // elements instead of directly on the input). Without this, controlled
                    // components don't work properly in conjunction with event bubbling because
                    // the component is rerendered and the value reverted before all the event
                    // handlers can run. See https://github.com/facebook/react/issues/708.
                    ReactUpdates.batchedUpdates(runEventInBatch, event);
                }

                function runEventInBatch(event) {
                    EventPluginHub.enqueueEvents(event);
                    EventPluginHub.processEventQueue(false);
                }

                function startWatchingForChangeEventIE8(target, targetInst) {
                    activeElement = target;
                    activeElementInst = targetInst;
                    activeElement.attachEvent(
                        "onchange",
                        manualDispatchChangeEvent
                    );
                }

                function stopWatchingForChangeEventIE8() {
                    if (!activeElement) {
                        return;
                    }
                    activeElement.detachEvent(
                        "onchange",
                        manualDispatchChangeEvent
                    );
                    activeElement = null;
                    activeElementInst = null;
                }

                function getTargetInstForChangeEvent(topLevelType, targetInst) {
                    if (topLevelType === "topChange") {
                        return targetInst;
                    }
                }
                function handleEventsForChangeEventIE8(
                    topLevelType,
                    target,
                    targetInst
                ) {
                    if (topLevelType === "topFocus") {
                        // stopWatching() should be a noop here but we call it just in case we
                        // missed a blur event somehow.
                        stopWatchingForChangeEventIE8();
                        startWatchingForChangeEventIE8(target, targetInst);
                    } else if (topLevelType === "topBlur") {
                        stopWatchingForChangeEventIE8();
                    }
                }

                /**
                 * SECTION: handle `input` event
                 */
                var isInputEventSupported = false;
                if (ExecutionEnvironment.canUseDOM) {
                    // IE9 claims to support the input event but fails to trigger it when
                    // deleting text, so we ignore its input events.
                    // IE10+ fire input events to often, such when a placeholder
                    // changes or when an input with a placeholder is focused.
                    isInputEventSupported =
                        isEventSupported("input") &&
                        (!document.documentMode || document.documentMode > 11);
                }

                /**
                 * (For IE <=11) Replacement getter/setter for the `value` property that gets
                 * set on the active element.
                 */
                var newValueProp = {
                    get: function () {
                        return activeElementValueProp.get.call(this);
                    },
                    set: function (val) {
                        // Cast to a string so we can do equality checks.
                        activeElementValue = "" + val;
                        activeElementValueProp.set.call(this, val);
                    },
                };

                /**
                 * (For IE <=11) Starts tracking propertychange events on the passed-in element
                 * and override the value property so that we can distinguish user events from
                 * value changes in JS.
                 */
                function startWatchingForValueChange(target, targetInst) {
                    activeElement = target;
                    activeElementInst = targetInst;
                    activeElementValue = target.value;
                    activeElementValueProp = Object.getOwnPropertyDescriptor(
                        target.constructor.prototype,
                        "value"
                    );

                    // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
                    // on DOM elements
                    Object.defineProperty(activeElement, "value", newValueProp);
                    if (activeElement.attachEvent) {
                        activeElement.attachEvent(
                            "onpropertychange",
                            handlePropertyChange
                        );
                    } else {
                        activeElement.addEventListener(
                            "propertychange",
                            handlePropertyChange,
                            false
                        );
                    }
                }

                /**
                 * (For IE <=11) Removes the event listeners from the currently-tracked element,
                 * if any exists.
                 */
                function stopWatchingForValueChange() {
                    if (!activeElement) {
                        return;
                    }

                    // delete restores the original property definition
                    delete activeElement.value;

                    if (activeElement.detachEvent) {
                        activeElement.detachEvent(
                            "onpropertychange",
                            handlePropertyChange
                        );
                    } else {
                        activeElement.removeEventListener(
                            "propertychange",
                            handlePropertyChange,
                            false
                        );
                    }

                    activeElement = null;
                    activeElementInst = null;
                    activeElementValue = null;
                    activeElementValueProp = null;
                }

                /**
                 * (For IE <=11) Handles a propertychange event, sending a `change` event if
                 * the value of the active element has changed.
                 */
                function handlePropertyChange(nativeEvent) {
                    if (nativeEvent.propertyName !== "value") {
                        return;
                    }
                    var value = nativeEvent.srcElement.value;
                    if (value === activeElementValue) {
                        return;
                    }
                    activeElementValue = value;

                    manualDispatchChangeEvent(nativeEvent);
                }

                /**
                 * If a `change` event should be fired, returns the target's ID.
                 */
                function getTargetInstForInputEvent(topLevelType, targetInst) {
                    if (topLevelType === "topInput") {
                        // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
                        // what we want so fall through here and trigger an abstract event
                        return targetInst;
                    }
                }

                function handleEventsForInputEventIE(
                    topLevelType,
                    target,
                    targetInst
                ) {
                    if (topLevelType === "topFocus") {
                        // In IE8, we can capture almost all .value changes by adding a
                        // propertychange handler and looking for events with propertyName
                        // equal to 'value'
                        // In IE9-11, propertychange fires for most input events but is buggy and
                        // doesn't fire when text is deleted, but conveniently, selectionchange
                        // appears to fire in all of the remaining cases so we catch those and
                        // forward the event if the value has changed
                        // In either case, we don't want to call the event handler if the value
                        // is changed from JS so we redefine a setter for `.value` that updates
                        // our activeElementValue variable, allowing us to ignore those changes
                        //
                        // stopWatching() should be a noop here but we call it just in case we
                        // missed a blur event somehow.
                        stopWatchingForValueChange();
                        startWatchingForValueChange(target, targetInst);
                    } else if (topLevelType === "topBlur") {
                        stopWatchingForValueChange();
                    }
                }

                // For IE8 and IE9.
                function getTargetInstForInputEventIE(
                    topLevelType,
                    targetInst
                ) {
                    if (
                        topLevelType === "topSelectionChange" ||
                        topLevelType === "topKeyUp" ||
                        topLevelType === "topKeyDown"
                    ) {
                        // On the selectionchange event, the target is just document which isn't
                        // helpful for us so just check activeElement instead.
                        //
                        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
                        // propertychange on the first input event after setting `value` from a
                        // script and fires only keydown, keypress, keyup. Catching keyup usually
                        // gets it and catching keydown lets us fire an event for the first
                        // keystroke if user does a key repeat (it'll be a little delayed: right
                        // before the second keystroke). Other input methods (e.g., paste) seem to
                        // fire selectionchange normally.
                        if (
                            activeElement &&
                            activeElement.value !== activeElementValue
                        ) {
                            activeElementValue = activeElement.value;
                            return activeElementInst;
                        }
                    }
                }

                /**
                 * SECTION: handle `click` event
                 */
                function shouldUseClickEvent(elem) {
                    // Use the `click` event to detect changes to checkbox and radio inputs.
                    // This approach works across all browsers, whereas `change` does not fire
                    // until `blur` in IE8.
                    return (
                        elem.nodeName &&
                        elem.nodeName.toLowerCase() === "input" &&
                        (elem.type === "checkbox" || elem.type === "radio")
                    );
                }

                function getTargetInstForClickEvent(topLevelType, targetInst) {
                    if (topLevelType === "topClick") {
                        return targetInst;
                    }
                }

                /**
                 * This plugin creates an `onChange` event that normalizes change events
                 * across form elements. This event fires at a time when it's possible to
                 * change the element's value without seeing a flicker.
                 *
                 * Supported elements are:
                 * - input (see `isTextInputElement`)
                 * - textarea
                 * - select
                 */
                var ChangeEventPlugin = {
                    eventTypes: eventTypes,

                    extractEvents: function (
                        topLevelType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    ) {
                        var targetNode = targetInst
                            ? ReactDOMComponentTree.getNodeFromInstance(
                                  targetInst
                              )
                            : window;

                        var getTargetInstFunc, handleEventFunc;
                        if (shouldUseChangeEvent(targetNode)) {
                            if (doesChangeEventBubble) {
                                getTargetInstFunc = getTargetInstForChangeEvent;
                            } else {
                                handleEventFunc = handleEventsForChangeEventIE8;
                            }
                        } else if (isTextInputElement(targetNode)) {
                            if (isInputEventSupported) {
                                getTargetInstFunc = getTargetInstForInputEvent;
                            } else {
                                getTargetInstFunc =
                                    getTargetInstForInputEventIE;
                                handleEventFunc = handleEventsForInputEventIE;
                            }
                        } else if (shouldUseClickEvent(targetNode)) {
                            getTargetInstFunc = getTargetInstForClickEvent;
                        }

                        if (getTargetInstFunc) {
                            var inst = getTargetInstFunc(
                                topLevelType,
                                targetInst
                            );
                            if (inst) {
                                var event = SyntheticEvent.getPooled(
                                    eventTypes.change,
                                    inst,
                                    nativeEvent,
                                    nativeEventTarget
                                );
                                event.type = "change";
                                EventPropagators.accumulateTwoPhaseDispatches(
                                    event
                                );
                                return event;
                            }
                        }

                        if (handleEventFunc) {
                            handleEventFunc(
                                topLevelType,
                                targetNode,
                                targetInst
                            );
                        }
                    },
                };

                module.exports = ChangeEventPlugin;

                /***/
            },
            /* 401 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380),
                    _assign = __webpack_require__(351);

                var CallbackQueue = __webpack_require__(402);
                var PooledClass = __webpack_require__(395);
                var ReactFeatureFlags = __webpack_require__(403);
                var ReactReconciler = __webpack_require__(404);
                var Transaction = __webpack_require__(408);

                var invariant = __webpack_require__(355);

                var dirtyComponents = [];
                var updateBatchNumber = 0;
                var asapCallbackQueue = CallbackQueue.getPooled();
                var asapEnqueued = false;

                var batchingStrategy = null;

                function ensureInjected() {
                    !(
                        ReactUpdates.ReactReconcileTransaction &&
                        batchingStrategy
                    )
                        ? false
                            ? invariant(
                                  false,
                                  "ReactUpdates: must inject a reconcile transaction class and batching strategy"
                              )
                            : _prodInvariant("123")
                        : void 0;
                }

                var NESTED_UPDATES = {
                    initialize: function () {
                        this.dirtyComponentsLength = dirtyComponents.length;
                    },
                    close: function () {
                        if (
                            this.dirtyComponentsLength !==
                            dirtyComponents.length
                        ) {
                            // Additional updates were enqueued by componentDidUpdate handlers or
                            // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
                            // these new updates so that if A's componentDidUpdate calls setState on
                            // B, B will update before the callback A's updater provided when calling
                            // setState.
                            dirtyComponents.splice(
                                0,
                                this.dirtyComponentsLength
                            );
                            flushBatchedUpdates();
                        } else {
                            dirtyComponents.length = 0;
                        }
                    },
                };

                var UPDATE_QUEUEING = {
                    initialize: function () {
                        this.callbackQueue.reset();
                    },
                    close: function () {
                        this.callbackQueue.notifyAll();
                    },
                };

                var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

                function ReactUpdatesFlushTransaction() {
                    this.reinitializeTransaction();
                    this.dirtyComponentsLength = null;
                    this.callbackQueue = CallbackQueue.getPooled();
                    this.reconcileTransaction =
                        ReactUpdates.ReactReconcileTransaction.getPooled(
                            /* useCreateElement */ true
                        );
                }

                _assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
                    getTransactionWrappers: function () {
                        return TRANSACTION_WRAPPERS;
                    },

                    destructor: function () {
                        this.dirtyComponentsLength = null;
                        CallbackQueue.release(this.callbackQueue);
                        this.callbackQueue = null;
                        ReactUpdates.ReactReconcileTransaction.release(
                            this.reconcileTransaction
                        );
                        this.reconcileTransaction = null;
                    },

                    perform: function (method, scope, a) {
                        // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
                        // with this transaction's wrappers around it.
                        return Transaction.perform.call(
                            this,
                            this.reconcileTransaction.perform,
                            this.reconcileTransaction,
                            method,
                            scope,
                            a
                        );
                    },
                });

                PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

                function batchedUpdates(callback, a, b, c, d, e) {
                    ensureInjected();
                    return batchingStrategy.batchedUpdates(
                        callback,
                        a,
                        b,
                        c,
                        d,
                        e
                    );
                }

                /**
                 * Array comparator for ReactComponents by mount ordering.
                 *
                 * @param {ReactComponent} c1 first component you're comparing
                 * @param {ReactComponent} c2 second component you're comparing
                 * @return {number} Return value usable by Array.prototype.sort().
                 */
                function mountOrderComparator(c1, c2) {
                    return c1._mountOrder - c2._mountOrder;
                }

                function runBatchedUpdates(transaction) {
                    var len = transaction.dirtyComponentsLength;
                    !(len === dirtyComponents.length)
                        ? false
                            ? invariant(
                                  false,
                                  "Expected flush transaction's stored dirty-components length (%s) to match dirty-components array length (%s).",
                                  len,
                                  dirtyComponents.length
                              )
                            : _prodInvariant("124", len, dirtyComponents.length)
                        : void 0;

                    // Since reconciling a component higher in the owner hierarchy usually (not
                    // always -- see shouldComponentUpdate()) will reconcile children, reconcile
                    // them before their children by sorting the array.
                    dirtyComponents.sort(mountOrderComparator);

                    // Any updates enqueued while reconciling must be performed after this entire
                    // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
                    // C, B could update twice in a single batch if C's render enqueues an update
                    // to B (since B would have already updated, we should skip it, and the only
                    // way we can know to do so is by checking the batch counter).
                    updateBatchNumber++;

                    for (var i = 0; i < len; i++) {
                        // If a component is unmounted before pending changes apply, it will still
                        // be here, but we assume that it has cleared its _pendingCallbacks and
                        // that performUpdateIfNecessary is a noop.
                        var component = dirtyComponents[i];

                        // If performUpdateIfNecessary happens to enqueue any new updates, we
                        // shouldn't execute the callbacks until the next render happens, so
                        // stash the callbacks first
                        var callbacks = component._pendingCallbacks;
                        component._pendingCallbacks = null;

                        var markerName;
                        if (ReactFeatureFlags.logTopLevelRenders) {
                            var namedComponent = component;
                            // Duck type TopLevelWrapper. This is probably always true.
                            if (
                                component._currentElement.type
                                    .isReactTopLevelWrapper
                            ) {
                                namedComponent = component._renderedComponent;
                            }
                            markerName =
                                "React update: " + namedComponent.getName();
                            console.time(markerName);
                        }

                        ReactReconciler.performUpdateIfNecessary(
                            component,
                            transaction.reconcileTransaction,
                            updateBatchNumber
                        );

                        if (markerName) {
                            console.timeEnd(markerName);
                        }

                        if (callbacks) {
                            for (var j = 0; j < callbacks.length; j++) {
                                transaction.callbackQueue.enqueue(
                                    callbacks[j],
                                    component.getPublicInstance()
                                );
                            }
                        }
                    }
                }

                var flushBatchedUpdates = function () {
                    // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
                    // array and perform any updates enqueued by mount-ready handlers (i.e.,
                    // componentDidUpdate) but we need to check here too in order to catch
                    // updates enqueued by setState callbacks and asap calls.
                    while (dirtyComponents.length || asapEnqueued) {
                        if (dirtyComponents.length) {
                            var transaction =
                                ReactUpdatesFlushTransaction.getPooled();
                            transaction.perform(
                                runBatchedUpdates,
                                null,
                                transaction
                            );
                            ReactUpdatesFlushTransaction.release(transaction);
                        }

                        if (asapEnqueued) {
                            asapEnqueued = false;
                            var queue = asapCallbackQueue;
                            asapCallbackQueue = CallbackQueue.getPooled();
                            queue.notifyAll();
                            CallbackQueue.release(queue);
                        }
                    }
                };

                /**
                 * Mark a component as needing a rerender, adding an optional callback to a
                 * list of functions which will be executed once the rerender occurs.
                 */
                function enqueueUpdate(component) {
                    ensureInjected();

                    // Various parts of our code (such as ReactCompositeComponent's
                    // _renderValidatedComponent) assume that calls to render aren't nested;
                    // verify that that's the case. (This is called by each top-level update
                    // function, like setState, forceUpdate, etc.; creation and
                    // destruction of top-level components is guarded in ReactMount.)

                    if (!batchingStrategy.isBatchingUpdates) {
                        batchingStrategy.batchedUpdates(
                            enqueueUpdate,
                            component
                        );
                        return;
                    }

                    dirtyComponents.push(component);
                    if (component._updateBatchNumber == null) {
                        component._updateBatchNumber = updateBatchNumber + 1;
                    }
                }

                /**
                 * Enqueue a callback to be run at the end of the current batching cycle. Throws
                 * if no updates are currently being performed.
                 */
                function asap(callback, context) {
                    !batchingStrategy.isBatchingUpdates
                        ? false
                            ? invariant(
                                  false,
                                  "ReactUpdates.asap: Can't enqueue an asap callback in a context whereupdates are not being batched."
                              )
                            : _prodInvariant("125")
                        : void 0;
                    asapCallbackQueue.enqueue(callback, context);
                    asapEnqueued = true;
                }

                var ReactUpdatesInjection = {
                    injectReconcileTransaction: function (
                        ReconcileTransaction
                    ) {
                        !ReconcileTransaction
                            ? false
                                ? invariant(
                                      false,
                                      "ReactUpdates: must provide a reconcile transaction class"
                                  )
                                : _prodInvariant("126")
                            : void 0;
                        ReactUpdates.ReactReconcileTransaction =
                            ReconcileTransaction;
                    },

                    injectBatchingStrategy: function (_batchingStrategy) {
                        !_batchingStrategy
                            ? false
                                ? invariant(
                                      false,
                                      "ReactUpdates: must provide a batching strategy"
                                  )
                                : _prodInvariant("127")
                            : void 0;
                        !(
                            typeof _batchingStrategy.batchedUpdates ===
                            "function"
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "ReactUpdates: must provide a batchedUpdates() function"
                                  )
                                : _prodInvariant("128")
                            : void 0;
                        !(
                            typeof _batchingStrategy.isBatchingUpdates ===
                            "boolean"
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "ReactUpdates: must provide an isBatchingUpdates boolean attribute"
                                  )
                                : _prodInvariant("129")
                            : void 0;
                        batchingStrategy = _batchingStrategy;
                    },
                };

                var ReactUpdates = {
                    /**
                     * React references `ReactReconcileTransaction` using this property in order
                     * to allow dependency injection.
                     *
                     * @internal
                     */
                    ReactReconcileTransaction: null,

                    batchedUpdates: batchedUpdates,
                    enqueueUpdate: enqueueUpdate,
                    flushBatchedUpdates: flushBatchedUpdates,
                    injection: ReactUpdatesInjection,
                    asap: asap,
                };

                module.exports = ReactUpdates;

                /***/
            },
            /* 402 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                var PooledClass = __webpack_require__(395);

                var invariant = __webpack_require__(355);

                /**
                 * A specialized pseudo-event module to help keep track of components waiting to
                 * be notified when their DOM representations are available for use.
                 *
                 * This implements `PooledClass`, so you should never need to instantiate this.
                 * Instead, use `CallbackQueue.getPooled()`.
                 *
                 * @class ReactMountReady
                 * @implements PooledClass
                 * @internal
                 */

                var CallbackQueue = (function () {
                    function CallbackQueue(arg) {
                        _classCallCheck(this, CallbackQueue);

                        this._callbacks = null;
                        this._contexts = null;
                        this._arg = arg;
                    }

                    /**
                     * Enqueues a callback to be invoked when `notifyAll` is invoked.
                     *
                     * @param {function} callback Invoked when `notifyAll` is invoked.
                     * @param {?object} context Context to call `callback` with.
                     * @internal
                     */

                    CallbackQueue.prototype.enqueue = function enqueue(
                        callback,
                        context
                    ) {
                        this._callbacks = this._callbacks || [];
                        this._callbacks.push(callback);
                        this._contexts = this._contexts || [];
                        this._contexts.push(context);
                    };

                    /**
                     * Invokes all enqueued callbacks and clears the queue. This is invoked after
                     * the DOM representation of a component has been created or updated.
                     *
                     * @internal
                     */

                    CallbackQueue.prototype.notifyAll = function notifyAll() {
                        var callbacks = this._callbacks;
                        var contexts = this._contexts;
                        var arg = this._arg;
                        if (callbacks && contexts) {
                            !(callbacks.length === contexts.length)
                                ? false
                                    ? invariant(
                                          false,
                                          "Mismatched list of contexts in callback queue"
                                      )
                                    : _prodInvariant("24")
                                : void 0;
                            this._callbacks = null;
                            this._contexts = null;
                            for (var i = 0; i < callbacks.length; i++) {
                                callbacks[i].call(contexts[i], arg);
                            }
                            callbacks.length = 0;
                            contexts.length = 0;
                        }
                    };

                    CallbackQueue.prototype.checkpoint = function checkpoint() {
                        return this._callbacks ? this._callbacks.length : 0;
                    };

                    CallbackQueue.prototype.rollback = function rollback(len) {
                        if (this._callbacks && this._contexts) {
                            this._callbacks.length = len;
                            this._contexts.length = len;
                        }
                    };

                    /**
                     * Resets the internal queue.
                     *
                     * @internal
                     */

                    CallbackQueue.prototype.reset = function reset() {
                        this._callbacks = null;
                        this._contexts = null;
                    };

                    /**
                     * `PooledClass` looks for this.
                     */

                    CallbackQueue.prototype.destructor = function destructor() {
                        this.reset();
                    };

                    return CallbackQueue;
                })();

                module.exports = PooledClass.addPoolingTo(CallbackQueue);

                /***/
            },
            /* 403 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var ReactFeatureFlags = {
                    // When true, call console.time() before and .timeEnd() after each top-level
                    // render (both initial renders and updates). Useful when looking at prod-mode
                    // timeline profiles in Chrome, for example.
                    logTopLevelRenders: false,
                };

                module.exports = ReactFeatureFlags;

                /***/
            },
            /* 404 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactRef = __webpack_require__(405);
                var ReactInstrumentation = __webpack_require__(407);

                var warning = __webpack_require__(358);

                /**
                 * Helper to call ReactRef.attachRefs with this composite component, split out
                 * to avoid allocations in the transaction mount-ready queue.
                 */
                function attachRefs() {
                    ReactRef.attachRefs(this, this._currentElement);
                }

                var ReactReconciler = {
                    /**
                     * Initializes the component, renders markup, and registers event listeners.
                     *
                     * @param {ReactComponent} internalInstance
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {?object} the containing host component instance
                     * @param {?object} info about the host container
                     * @return {?string} Rendered markup to be inserted into the DOM.
                     * @final
                     * @internal
                     */
                    mountComponent: function (
                        internalInstance,
                        transaction,
                        hostParent,
                        hostContainerInfo,
                        context,
                        parentDebugID // 0 in production and for roots
                    ) {
                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeMountComponent(
                                    internalInstance._debugID,
                                    internalInstance._currentElement,
                                    parentDebugID
                                );
                            }
                        }
                        var markup = internalInstance.mountComponent(
                            transaction,
                            hostParent,
                            hostContainerInfo,
                            context,
                            parentDebugID
                        );
                        if (
                            internalInstance._currentElement &&
                            internalInstance._currentElement.ref != null
                        ) {
                            transaction
                                .getReactMountReady()
                                .enqueue(attachRefs, internalInstance);
                        }
                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onMountComponent(
                                    internalInstance._debugID
                                );
                            }
                        }
                        return markup;
                    },

                    /**
                     * Returns a value that can be passed to
                     * ReactComponentEnvironment.replaceNodeWithMarkup.
                     */
                    getHostNode: function (internalInstance) {
                        return internalInstance.getHostNode();
                    },

                    /**
                     * Releases any resources allocated by `mountComponent`.
                     *
                     * @final
                     * @internal
                     */
                    unmountComponent: function (internalInstance, safely) {
                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeUnmountComponent(
                                    internalInstance._debugID
                                );
                            }
                        }
                        ReactRef.detachRefs(
                            internalInstance,
                            internalInstance._currentElement
                        );
                        internalInstance.unmountComponent(safely);
                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onUnmountComponent(
                                    internalInstance._debugID
                                );
                            }
                        }
                    },

                    /**
                     * Update a component using a new element.
                     *
                     * @param {ReactComponent} internalInstance
                     * @param {ReactElement} nextElement
                     * @param {ReactReconcileTransaction} transaction
                     * @param {object} context
                     * @internal
                     */
                    receiveComponent: function (
                        internalInstance,
                        nextElement,
                        transaction,
                        context
                    ) {
                        var prevElement = internalInstance._currentElement;

                        if (
                            nextElement === prevElement &&
                            context === internalInstance._context
                        ) {
                            // Since elements are immutable after the owner is rendered,
                            // we can do a cheap identity compare here to determine if this is a
                            // superfluous reconcile. It's possible for state to be mutable but such
                            // change should trigger an update of the owner which would recreate
                            // the element. We explicitly check for the existence of an owner since
                            // it's possible for an element created outside a composite to be
                            // deeply mutated and reused.

                            // TODO: Bailing out early is just a perf optimization right?
                            // TODO: Removing the return statement should affect correctness?
                            return;
                        }

                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeUpdateComponent(
                                    internalInstance._debugID,
                                    nextElement
                                );
                            }
                        }

                        var refsChanged = ReactRef.shouldUpdateRefs(
                            prevElement,
                            nextElement
                        );

                        if (refsChanged) {
                            ReactRef.detachRefs(internalInstance, prevElement);
                        }

                        internalInstance.receiveComponent(
                            nextElement,
                            transaction,
                            context
                        );

                        if (
                            refsChanged &&
                            internalInstance._currentElement &&
                            internalInstance._currentElement.ref != null
                        ) {
                            transaction
                                .getReactMountReady()
                                .enqueue(attachRefs, internalInstance);
                        }

                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onUpdateComponent(
                                    internalInstance._debugID
                                );
                            }
                        }
                    },

                    /**
                     * Flush any dirty changes in a component.
                     *
                     * @param {ReactComponent} internalInstance
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    performUpdateIfNecessary: function (
                        internalInstance,
                        transaction,
                        updateBatchNumber
                    ) {
                        if (
                            internalInstance._updateBatchNumber !==
                            updateBatchNumber
                        ) {
                            // The component's enqueued batch number should always be the current
                            // batch or the following one.
                            false
                                ? warning(
                                      internalInstance._updateBatchNumber ==
                                          null ||
                                          internalInstance._updateBatchNumber ===
                                              updateBatchNumber + 1,
                                      "performUpdateIfNecessary: Unexpected batch number (current %s, " +
                                          "pending %s)",
                                      updateBatchNumber,
                                      internalInstance._updateBatchNumber
                                  )
                                : void 0;
                            return;
                        }
                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeUpdateComponent(
                                    internalInstance._debugID,
                                    internalInstance._currentElement
                                );
                            }
                        }
                        internalInstance.performUpdateIfNecessary(transaction);
                        if (false) {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onUpdateComponent(
                                    internalInstance._debugID
                                );
                            }
                        }
                    },
                };

                module.exports = ReactReconciler;

                /***/
            },
            /* 405 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var ReactOwner = __webpack_require__(406);

                var ReactRef = {};

                function attachRef(ref, component, owner) {
                    if (typeof ref === "function") {
                        ref(component.getPublicInstance());
                    } else {
                        // Legacy ref
                        ReactOwner.addComponentAsRefTo(component, ref, owner);
                    }
                }

                function detachRef(ref, component, owner) {
                    if (typeof ref === "function") {
                        ref(null);
                    } else {
                        // Legacy ref
                        ReactOwner.removeComponentAsRefFrom(
                            component,
                            ref,
                            owner
                        );
                    }
                }

                ReactRef.attachRefs = function (instance, element) {
                    if (element === null || typeof element !== "object") {
                        return;
                    }
                    var ref = element.ref;
                    if (ref != null) {
                        attachRef(ref, instance, element._owner);
                    }
                };

                ReactRef.shouldUpdateRefs = function (
                    prevElement,
                    nextElement
                ) {
                    // If either the owner or a `ref` has changed, make sure the newest owner
                    // has stored a reference to `this`, and the previous owner (if different)
                    // has forgotten the reference to `this`. We use the element instead
                    // of the public this.props because the post processing cannot determine
                    // a ref. The ref conceptually lives on the element.

                    // TODO: Should this even be possible? The owner cannot change because
                    // it's forbidden by shouldUpdateReactComponent. The ref can change
                    // if you swap the keys of but not the refs. Reconsider where this check
                    // is made. It probably belongs where the key checking and
                    // instantiateReactComponent is done.

                    var prevRef = null;
                    var prevOwner = null;
                    if (
                        prevElement !== null &&
                        typeof prevElement === "object"
                    ) {
                        prevRef = prevElement.ref;
                        prevOwner = prevElement._owner;
                    }

                    var nextRef = null;
                    var nextOwner = null;
                    if (
                        nextElement !== null &&
                        typeof nextElement === "object"
                    ) {
                        nextRef = nextElement.ref;
                        nextOwner = nextElement._owner;
                    }

                    return (
                        prevRef !== nextRef ||
                        // If owner changes but we have an unchanged function ref, don't update refs
                        (typeof nextRef === "string" && nextOwner !== prevOwner)
                    );
                };

                ReactRef.detachRefs = function (instance, element) {
                    if (element === null || typeof element !== "object") {
                        return;
                    }
                    var ref = element.ref;
                    if (ref != null) {
                        detachRef(ref, instance, element._owner);
                    }
                };

                module.exports = ReactRef;

                /***/
            },
            /* 406 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                /**
                 * @param {?object} object
                 * @return {boolean} True if `object` is a valid owner.
                 * @final
                 */
                function isValidOwner(object) {
                    return !!(
                        object &&
                        typeof object.attachRef === "function" &&
                        typeof object.detachRef === "function"
                    );
                }

                /**
                 * ReactOwners are capable of storing references to owned components.
                 *
                 * All components are capable of //being// referenced by owner components, but
                 * only ReactOwner components are capable of //referencing// owned components.
                 * The named reference is known as a "ref".
                 *
                 * Refs are available when mounted and updated during reconciliation.
                 *
                 *   var MyComponent = React.createClass({
                 *     render: function() {
                 *       return (
                 *         <div onClick={this.handleClick}>
                 *           <CustomComponent ref="custom" />
                 *         </div>
                 *       );
                 *     },
                 *     handleClick: function() {
                 *       this.refs.custom.handleClick();
                 *     },
                 *     componentDidMount: function() {
                 *       this.refs.custom.initialize();
                 *     }
                 *   });
                 *
                 * Refs should rarely be used. When refs are used, they should only be done to
                 * control data that is not handled by React's data flow.
                 *
                 * @class ReactOwner
                 */
                var ReactOwner = {
                    /**
                     * Adds a component by ref to an owner component.
                     *
                     * @param {ReactComponent} component Component to reference.
                     * @param {string} ref Name by which to refer to the component.
                     * @param {ReactOwner} owner Component on which to record the ref.
                     * @final
                     * @internal
                     */
                    addComponentAsRefTo: function (component, ref, owner) {
                        !isValidOwner(owner)
                            ? false
                                ? invariant(
                                      false,
                                      "addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component's `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner)."
                                  )
                                : _prodInvariant("119")
                            : void 0;
                        owner.attachRef(ref, component);
                    },

                    /**
                     * Removes a component by ref from an owner component.
                     *
                     * @param {ReactComponent} component Component to dereference.
                     * @param {string} ref Name of the ref to remove.
                     * @param {ReactOwner} owner Component on which the ref is recorded.
                     * @final
                     * @internal
                     */
                    removeComponentAsRefFrom: function (component, ref, owner) {
                        !isValidOwner(owner)
                            ? false
                                ? invariant(
                                      false,
                                      "removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component's `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner)."
                                  )
                                : _prodInvariant("120")
                            : void 0;
                        var ownerPublicInstance = owner.getPublicInstance();
                        // Check that `component`'s owner is still alive and that `component` is still the current ref
                        // because we do not want to detach the ref if another component stole it.
                        if (
                            ownerPublicInstance &&
                            ownerPublicInstance.refs[ref] ===
                                component.getPublicInstance()
                        ) {
                            owner.detachRef(ref);
                        }
                    },
                };

                module.exports = ReactOwner;

                /***/
            },
            /* 407 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                // Trust the developer to only use ReactInstrumentation with a __DEV__ check

                var debugTool = null;

                if (false) {
                    var ReactDebugTool = require("./ReactDebugTool");
                    debugTool = ReactDebugTool;
                }

                module.exports = { debugTool: debugTool };

                /***/
            },
            /* 408 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                var OBSERVED_ERROR = {};

                /**
                 * `Transaction` creates a black box that is able to wrap any method such that
                 * certain invariants are maintained before and after the method is invoked
                 * (Even if an exception is thrown while invoking the wrapped method). Whoever
                 * instantiates a transaction can provide enforcers of the invariants at
                 * creation time. The `Transaction` class itself will supply one additional
                 * automatic invariant for you - the invariant that any transaction instance
                 * should not be run while it is already being run. You would typically create a
                 * single instance of a `Transaction` for reuse multiple times, that potentially
                 * is used to wrap several different methods. Wrappers are extremely simple -
                 * they only require implementing two methods.
                 *
                 * <pre>
                 *                       wrappers (injected at creation time)
                 *                                      +        +
                 *                                      |        |
                 *                    +-----------------|--------|--------------+
                 *                    |                 v        |              |
                 *                    |      +---------------+   |              |
                 *                    |   +--|    wrapper1   |---|----+         |
                 *                    |   |  +---------------+   v    |         |
                 *                    |   |          +-------------+  |         |
                 *                    |   |     +----|   wrapper2  |--------+   |
                 *                    |   |     |    +-------------+  |     |   |
                 *                    |   |     |                     |     |   |
                 *                    |   v     v                     v     v   | wrapper
                 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
                 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
                 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
                 *                    | |   | |   |   |         |   |   | |   | |
                 *                    | |   | |   |   |         |   |   | |   | |
                 *                    | |   | |   |   |         |   |   | |   | |
                 *                    | +---+ +---+   +---------+   +---+ +---+ |
                 *                    |  initialize                    close    |
                 *                    +-----------------------------------------+
                 * </pre>
                 *
                 * Use cases:
                 * - Preserving the input selection ranges before/after reconciliation.
                 *   Restoring selection even in the event of an unexpected error.
                 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
                 *   while guaranteeing that afterwards, the event system is reactivated.
                 * - Flushing a queue of collected DOM mutations to the main UI thread after a
                 *   reconciliation takes place in a worker thread.
                 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
                 *   content.
                 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
                 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
                 * - (Future use case): Layout calculations before and after DOM updates.
                 *
                 * Transactional plugin API:
                 * - A module that has an `initialize` method that returns any precomputation.
                 * - and a `close` method that accepts the precomputation. `close` is invoked
                 *   when the wrapped process is completed, or has failed.
                 *
                 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
                 * that implement `initialize` and `close`.
                 * @return {Transaction} Single transaction for reuse in thread.
                 *
                 * @class Transaction
                 */
                var TransactionImpl = {
                    /**
                     * Sets up this instance so that it is prepared for collecting metrics. Does
                     * so such that this setup method may be used on an instance that is already
                     * initialized, in a way that does not consume additional memory upon reuse.
                     * That can be useful if you decide to make your subclass of this mixin a
                     * "PooledClass".
                     */
                    reinitializeTransaction: function () {
                        this.transactionWrappers =
                            this.getTransactionWrappers();
                        if (this.wrapperInitData) {
                            this.wrapperInitData.length = 0;
                        } else {
                            this.wrapperInitData = [];
                        }
                        this._isInTransaction = false;
                    },

                    _isInTransaction: false,

                    /**
                     * @abstract
                     * @return {Array<TransactionWrapper>} Array of transaction wrappers.
                     */
                    getTransactionWrappers: null,

                    isInTransaction: function () {
                        return !!this._isInTransaction;
                    },

                    /**
                     * Executes the function within a safety window. Use this for the top level
                     * methods that result in large amounts of computation/mutations that would
                     * need to be safety checked. The optional arguments helps prevent the need
                     * to bind in many cases.
                     *
                     * @param {function} method Member of scope to call.
                     * @param {Object} scope Scope to invoke from.
                     * @param {Object?=} a Argument to pass to the method.
                     * @param {Object?=} b Argument to pass to the method.
                     * @param {Object?=} c Argument to pass to the method.
                     * @param {Object?=} d Argument to pass to the method.
                     * @param {Object?=} e Argument to pass to the method.
                     * @param {Object?=} f Argument to pass to the method.
                     *
                     * @return {*} Return value from `method`.
                     */
                    perform: function (method, scope, a, b, c, d, e, f) {
                        !!this.isInTransaction()
                            ? false
                                ? invariant(
                                      false,
                                      "Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction."
                                  )
                                : _prodInvariant("27")
                            : void 0;
                        var errorThrown;
                        var ret;
                        try {
                            this._isInTransaction = true;
                            // Catching errors makes debugging more difficult, so we start with
                            // errorThrown set to true before setting it to false after calling
                            // close -- if it's still set to true in the finally block, it means
                            // one of these calls threw.
                            errorThrown = true;
                            this.initializeAll(0);
                            ret = method.call(scope, a, b, c, d, e, f);
                            errorThrown = false;
                        } finally {
                            try {
                                if (errorThrown) {
                                    // If `method` throws, prefer to show that stack trace over any thrown
                                    // by invoking `closeAll`.
                                    try {
                                        this.closeAll(0);
                                    } catch (err) {}
                                } else {
                                    // Since `method` didn't throw, we don't want to silence the exception
                                    // here.
                                    this.closeAll(0);
                                }
                            } finally {
                                this._isInTransaction = false;
                            }
                        }
                        return ret;
                    },

                    initializeAll: function (startIndex) {
                        var transactionWrappers = this.transactionWrappers;
                        for (
                            var i = startIndex;
                            i < transactionWrappers.length;
                            i++
                        ) {
                            var wrapper = transactionWrappers[i];
                            try {
                                // Catching errors makes debugging more difficult, so we start with the
                                // OBSERVED_ERROR state before overwriting it with the real return value
                                // of initialize -- if it's still set to OBSERVED_ERROR in the finally
                                // block, it means wrapper.initialize threw.
                                this.wrapperInitData[i] = OBSERVED_ERROR;
                                this.wrapperInitData[i] = wrapper.initialize
                                    ? wrapper.initialize.call(this)
                                    : null;
                            } finally {
                                if (
                                    this.wrapperInitData[i] === OBSERVED_ERROR
                                ) {
                                    // The initializer for wrapper i threw an error; initialize the
                                    // remaining wrappers but silence any exceptions from them to ensure
                                    // that the first error is the one to bubble up.
                                    try {
                                        this.initializeAll(i + 1);
                                    } catch (err) {}
                                }
                            }
                        }
                    },

                    /**
                     * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
                     * them the respective return values of `this.transactionWrappers.init[i]`
                     * (`close`rs that correspond to initializers that failed will not be
                     * invoked).
                     */
                    closeAll: function (startIndex) {
                        !this.isInTransaction()
                            ? false
                                ? invariant(
                                      false,
                                      "Transaction.closeAll(): Cannot close transaction when none are open."
                                  )
                                : _prodInvariant("28")
                            : void 0;
                        var transactionWrappers = this.transactionWrappers;
                        for (
                            var i = startIndex;
                            i < transactionWrappers.length;
                            i++
                        ) {
                            var wrapper = transactionWrappers[i];
                            var initData = this.wrapperInitData[i];
                            var errorThrown;
                            try {
                                // Catching errors makes debugging more difficult, so we start with
                                // errorThrown set to true before setting it to false after calling
                                // close -- if it's still set to true in the finally block, it means
                                // wrapper.close threw.
                                errorThrown = true;
                                if (
                                    initData !== OBSERVED_ERROR &&
                                    wrapper.close
                                ) {
                                    wrapper.close.call(this, initData);
                                }
                                errorThrown = false;
                            } finally {
                                if (errorThrown) {
                                    // The closer for wrapper i threw an error; close the remaining
                                    // wrappers but silence any exceptions from them to ensure that the
                                    // first error is the one to bubble up.
                                    try {
                                        this.closeAll(i + 1);
                                    } catch (e) {}
                                }
                            }
                        }
                        this.wrapperInitData.length = 0;
                    },
                };

                module.exports = TransactionImpl;

                /***/
            },
            /* 409 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * Gets the target node from a native browser event by accounting for
                 * inconsistencies in browser DOM APIs.
                 *
                 * @param {object} nativeEvent Native browser event.
                 * @return {DOMEventTarget} Target node.
                 */

                function getEventTarget(nativeEvent) {
                    var target =
                        nativeEvent.target || nativeEvent.srcElement || window;

                    // Normalize SVG <use> element events #4963
                    if (target.correspondingUseElement) {
                        target = target.correspondingUseElement;
                    }

                    // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
                    // @see http://www.quirksmode.org/js/events_properties.html
                    return target.nodeType === 3 ? target.parentNode : target;
                }

                module.exports = getEventTarget;

                /***/
            },
            /* 410 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ExecutionEnvironment = __webpack_require__(393);

                var useHasFeature;
                if (ExecutionEnvironment.canUseDOM) {
                    useHasFeature =
                        document.implementation &&
                        document.implementation.hasFeature &&
                        // always returns true in newer browsers as per the standard.
                        // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
                        document.implementation.hasFeature("", "") !== true;
                }

                /**
                 * Checks if an event is supported in the current execution environment.
                 *
                 * NOTE: This will not work correctly for non-generic events such as `change`,
                 * `reset`, `load`, `error`, and `select`.
                 *
                 * Borrows from Modernizr.
                 *
                 * @param {string} eventNameSuffix Event name, e.g. "click".
                 * @param {?boolean} capture Check if the capture phase is supported.
                 * @return {boolean} True if the event is supported.
                 * @internal
                 * @license Modernizr 3.0.0pre (Custom Build) | MIT
                 */
                function isEventSupported(eventNameSuffix, capture) {
                    if (
                        !ExecutionEnvironment.canUseDOM ||
                        (capture && !("addEventListener" in document))
                    ) {
                        return false;
                    }

                    var eventName = "on" + eventNameSuffix;
                    var isSupported = eventName in document;

                    if (!isSupported) {
                        var element = document.createElement("div");
                        element.setAttribute(eventName, "return;");
                        isSupported = typeof element[eventName] === "function";
                    }

                    if (
                        !isSupported &&
                        useHasFeature &&
                        eventNameSuffix === "wheel"
                    ) {
                        // This is the only way to test support for the `wheel` event in IE9+.
                        isSupported = document.implementation.hasFeature(
                            "Events.wheel",
                            "3.0"
                        );
                    }

                    return isSupported;
                }

                module.exports = isEventSupported;

                /***/
            },
            /* 411 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                /**
                 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
                 */

                var supportedInputTypes = {
                    "color": true,
                    "date": true,
                    "datetime": true,
                    "datetime-local": true,
                    "email": true,
                    "month": true,
                    "number": true,
                    "password": true,
                    "range": true,
                    "search": true,
                    "tel": true,
                    "text": true,
                    "time": true,
                    "url": true,
                    "week": true,
                };

                function isTextInputElement(elem) {
                    var nodeName =
                        elem && elem.nodeName && elem.nodeName.toLowerCase();

                    if (nodeName === "input") {
                        return !!supportedInputTypes[elem.type];
                    }

                    if (nodeName === "textarea") {
                        return true;
                    }

                    return false;
                }

                module.exports = isTextInputElement;

                /***/
            },
            /* 412 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * Module that is injectable into `EventPluginHub`, that specifies a
                 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
                 * plugins, without having to package every one of them. This is better than
                 * having plugins be ordered in the same order that they are injected because
                 * that ordering would be influenced by the packaging order.
                 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
                 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
                 */

                var DefaultEventPluginOrder = [
                    "ResponderEventPlugin",
                    "SimpleEventPlugin",
                    "TapEventPlugin",
                    "EnterLeaveEventPlugin",
                    "ChangeEventPlugin",
                    "SelectEventPlugin",
                    "BeforeInputEventPlugin",
                ];

                module.exports = DefaultEventPluginOrder;

                /***/
            },
            /* 413 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var EventPropagators = __webpack_require__(386);
                var ReactDOMComponentTree = __webpack_require__(379);
                var SyntheticMouseEvent = __webpack_require__(414);

                var eventTypes = {
                    mouseEnter: {
                        registrationName: "onMouseEnter",
                        dependencies: ["topMouseOut", "topMouseOver"],
                    },
                    mouseLeave: {
                        registrationName: "onMouseLeave",
                        dependencies: ["topMouseOut", "topMouseOver"],
                    },
                };

                var EnterLeaveEventPlugin = {
                    eventTypes: eventTypes,

                    /**
                     * For almost every interaction we care about, there will be both a top-level
                     * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
                     * we do not extract duplicate events. However, moving the mouse into the
                     * browser from outside will not fire a `mouseout` event. In this case, we use
                     * the `mouseover` top-level event.
                     */
                    extractEvents: function (
                        topLevelType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    ) {
                        if (
                            topLevelType === "topMouseOver" &&
                            (nativeEvent.relatedTarget ||
                                nativeEvent.fromElement)
                        ) {
                            return null;
                        }
                        if (
                            topLevelType !== "topMouseOut" &&
                            topLevelType !== "topMouseOver"
                        ) {
                            // Must not be a mouse in or mouse out - ignoring.
                            return null;
                        }

                        var win;
                        if (nativeEventTarget.window === nativeEventTarget) {
                            // `nativeEventTarget` is probably a window object.
                            win = nativeEventTarget;
                        } else {
                            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
                            var doc = nativeEventTarget.ownerDocument;
                            if (doc) {
                                win = doc.defaultView || doc.parentWindow;
                            } else {
                                win = window;
                            }
                        }

                        var from;
                        var to;
                        if (topLevelType === "topMouseOut") {
                            from = targetInst;
                            var related =
                                nativeEvent.relatedTarget ||
                                nativeEvent.toElement;
                            to = related
                                ? ReactDOMComponentTree.getClosestInstanceFromNode(
                                      related
                                  )
                                : null;
                        } else {
                            // Moving to a node from outside the window.
                            from = null;
                            to = targetInst;
                        }

                        if (from === to) {
                            // Nothing pertains to our managed components.
                            return null;
                        }

                        var fromNode =
                            from == null
                                ? win
                                : ReactDOMComponentTree.getNodeFromInstance(
                                      from
                                  );
                        var toNode =
                            to == null
                                ? win
                                : ReactDOMComponentTree.getNodeFromInstance(to);

                        var leave = SyntheticMouseEvent.getPooled(
                            eventTypes.mouseLeave,
                            from,
                            nativeEvent,
                            nativeEventTarget
                        );
                        leave.type = "mouseleave";
                        leave.target = fromNode;
                        leave.relatedTarget = toNode;

                        var enter = SyntheticMouseEvent.getPooled(
                            eventTypes.mouseEnter,
                            to,
                            nativeEvent,
                            nativeEventTarget
                        );
                        enter.type = "mouseenter";
                        enter.target = toNode;
                        enter.relatedTarget = fromNode;

                        EventPropagators.accumulateEnterLeaveDispatches(
                            leave,
                            enter,
                            from,
                            to
                        );

                        return [leave, enter];
                    },
                };

                module.exports = EnterLeaveEventPlugin;

                /***/
            },
            /* 414 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticUIEvent = __webpack_require__(415);
                var ViewportMetrics = __webpack_require__(416);

                var getEventModifierState = __webpack_require__(417);

                /**
                 * @interface MouseEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var MouseEventInterface = {
                    screenX: null,
                    screenY: null,
                    clientX: null,
                    clientY: null,
                    ctrlKey: null,
                    shiftKey: null,
                    altKey: null,
                    metaKey: null,
                    getModifierState: getEventModifierState,
                    button: function (event) {
                        // Webkit, Firefox, IE9+
                        // which:  1 2 3
                        // button: 0 1 2 (standard)
                        var button = event.button;
                        if ("which" in event) {
                            return button;
                        }
                        // IE<9
                        // which:  undefined
                        // button: 0 0 0
                        // button: 1 4 2 (onmouseup)
                        return button === 2 ? 2 : button === 4 ? 1 : 0;
                    },
                    buttons: null,
                    relatedTarget: function (event) {
                        return (
                            event.relatedTarget ||
                            (event.fromElement === event.srcElement
                                ? event.toElement
                                : event.fromElement)
                        );
                    },
                    // "Proprietary" Interface.
                    pageX: function (event) {
                        return "pageX" in event
                            ? event.pageX
                            : event.clientX + ViewportMetrics.currentScrollLeft;
                    },
                    pageY: function (event) {
                        return "pageY" in event
                            ? event.pageY
                            : event.clientY + ViewportMetrics.currentScrollTop;
                    },
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticMouseEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticUIEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticUIEvent.augmentClass(
                    SyntheticMouseEvent,
                    MouseEventInterface
                );

                module.exports = SyntheticMouseEvent;

                /***/
            },
            /* 415 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticEvent = __webpack_require__(398);

                var getEventTarget = __webpack_require__(409);

                /**
                 * @interface UIEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var UIEventInterface = {
                    view: function (event) {
                        if (event.view) {
                            return event.view;
                        }

                        var target = getEventTarget(event);
                        if (target.window === target) {
                            // target is a window object
                            return target;
                        }

                        var doc = target.ownerDocument;
                        // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
                        if (doc) {
                            return doc.defaultView || doc.parentWindow;
                        } else {
                            return window;
                        }
                    },
                    detail: function (event) {
                        return event.detail || 0;
                    },
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticEvent}
                 */
                function SyntheticUIEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

                module.exports = SyntheticUIEvent;

                /***/
            },
            /* 416 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ViewportMetrics = {
                    currentScrollLeft: 0,

                    currentScrollTop: 0,

                    refreshScrollValues: function (scrollPosition) {
                        ViewportMetrics.currentScrollLeft = scrollPosition.x;
                        ViewportMetrics.currentScrollTop = scrollPosition.y;
                    },
                };

                module.exports = ViewportMetrics;

                /***/
            },
            /* 417 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * Translation from modifier key to the associated property in the event.
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
                 */

                var modifierKeyToProp = {
                    Alt: "altKey",
                    Control: "ctrlKey",
                    Meta: "metaKey",
                    Shift: "shiftKey",
                };

                // IE8 does not implement getModifierState so we simply map it to the only
                // modifier keys exposed by the event itself, does not support Lock-keys.
                // Currently, all major browsers except Chrome seems to support Lock-keys.
                function modifierStateGetter(keyArg) {
                    var syntheticEvent = this;
                    var nativeEvent = syntheticEvent.nativeEvent;
                    if (nativeEvent.getModifierState) {
                        return nativeEvent.getModifierState(keyArg);
                    }
                    var keyProp = modifierKeyToProp[keyArg];
                    return keyProp ? !!nativeEvent[keyProp] : false;
                }

                function getEventModifierState(nativeEvent) {
                    return modifierStateGetter;
                }

                module.exports = getEventModifierState;

                /***/
            },
            /* 418 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMProperty = __webpack_require__(381);

                var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
                var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
                var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
                var HAS_POSITIVE_NUMERIC_VALUE =
                    DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
                var HAS_OVERLOADED_BOOLEAN_VALUE =
                    DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

                var HTMLDOMPropertyConfig = {
                    isCustomAttribute: RegExp.prototype.test.bind(
                        new RegExp(
                            "^(data|aria)-[" +
                                DOMProperty.ATTRIBUTE_NAME_CHAR +
                                "]*$"
                        )
                    ),
                    Properties: {
                        /**
                         * Standard Properties
                         */
                        accept: 0,
                        acceptCharset: 0,
                        accessKey: 0,
                        action: 0,
                        allowFullScreen: HAS_BOOLEAN_VALUE,
                        allowTransparency: 0,
                        alt: 0,
                        // specifies target context for links with `preload` type
                        as: 0,
                        async: HAS_BOOLEAN_VALUE,
                        autoComplete: 0,
                        // autoFocus is polyfilled/normalized by AutoFocusUtils
                        // autoFocus: HAS_BOOLEAN_VALUE,
                        autoPlay: HAS_BOOLEAN_VALUE,
                        capture: HAS_BOOLEAN_VALUE,
                        cellPadding: 0,
                        cellSpacing: 0,
                        charSet: 0,
                        challenge: 0,
                        checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        cite: 0,
                        classID: 0,
                        className: 0,
                        cols: HAS_POSITIVE_NUMERIC_VALUE,
                        colSpan: 0,
                        content: 0,
                        contentEditable: 0,
                        contextMenu: 0,
                        controls: HAS_BOOLEAN_VALUE,
                        coords: 0,
                        crossOrigin: 0,
                        data: 0, // For `<object />` acts as `src`.
                        dateTime: 0,
                        default: HAS_BOOLEAN_VALUE,
                        defer: HAS_BOOLEAN_VALUE,
                        dir: 0,
                        disabled: HAS_BOOLEAN_VALUE,
                        download: HAS_OVERLOADED_BOOLEAN_VALUE,
                        draggable: 0,
                        encType: 0,
                        form: 0,
                        formAction: 0,
                        formEncType: 0,
                        formMethod: 0,
                        formNoValidate: HAS_BOOLEAN_VALUE,
                        formTarget: 0,
                        frameBorder: 0,
                        headers: 0,
                        height: 0,
                        hidden: HAS_BOOLEAN_VALUE,
                        high: 0,
                        href: 0,
                        hrefLang: 0,
                        htmlFor: 0,
                        httpEquiv: 0,
                        icon: 0,
                        id: 0,
                        inputMode: 0,
                        integrity: 0,
                        is: 0,
                        keyParams: 0,
                        keyType: 0,
                        kind: 0,
                        label: 0,
                        lang: 0,
                        list: 0,
                        loop: HAS_BOOLEAN_VALUE,
                        low: 0,
                        manifest: 0,
                        marginHeight: 0,
                        marginWidth: 0,
                        max: 0,
                        maxLength: 0,
                        media: 0,
                        mediaGroup: 0,
                        method: 0,
                        min: 0,
                        minLength: 0,
                        // Caution; `option.selected` is not updated if `select.multiple` is
                        // disabled with `removeAttribute`.
                        multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        name: 0,
                        nonce: 0,
                        noValidate: HAS_BOOLEAN_VALUE,
                        open: HAS_BOOLEAN_VALUE,
                        optimum: 0,
                        pattern: 0,
                        placeholder: 0,
                        playsInline: HAS_BOOLEAN_VALUE,
                        poster: 0,
                        preload: 0,
                        profile: 0,
                        radioGroup: 0,
                        readOnly: HAS_BOOLEAN_VALUE,
                        referrerPolicy: 0,
                        rel: 0,
                        required: HAS_BOOLEAN_VALUE,
                        reversed: HAS_BOOLEAN_VALUE,
                        role: 0,
                        rows: HAS_POSITIVE_NUMERIC_VALUE,
                        rowSpan: HAS_NUMERIC_VALUE,
                        sandbox: 0,
                        scope: 0,
                        scoped: HAS_BOOLEAN_VALUE,
                        scrolling: 0,
                        seamless: HAS_BOOLEAN_VALUE,
                        selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        shape: 0,
                        size: HAS_POSITIVE_NUMERIC_VALUE,
                        sizes: 0,
                        span: HAS_POSITIVE_NUMERIC_VALUE,
                        spellCheck: 0,
                        src: 0,
                        srcDoc: 0,
                        srcLang: 0,
                        srcSet: 0,
                        start: HAS_NUMERIC_VALUE,
                        step: 0,
                        style: 0,
                        summary: 0,
                        tabIndex: 0,
                        target: 0,
                        title: 0,
                        // Setting .type throws on non-<input> tags
                        type: 0,
                        useMap: 0,
                        value: 0,
                        width: 0,
                        wmode: 0,
                        wrap: 0,

                        /**
                         * RDFa Properties
                         */
                        about: 0,
                        datatype: 0,
                        inlist: 0,
                        prefix: 0,
                        // property is also supported for OpenGraph in meta tags.
                        property: 0,
                        resource: 0,
                        typeof: 0,
                        vocab: 0,

                        /**
                         * Non-standard Properties
                         */
                        // autoCapitalize and autoCorrect are supported in Mobile Safari for
                        // keyboard hints.
                        autoCapitalize: 0,
                        autoCorrect: 0,
                        // autoSave allows WebKit/Blink to persist values of input fields on page reloads
                        autoSave: 0,
                        // color is for Safari mask-icon link
                        color: 0,
                        // itemProp, itemScope, itemType are for
                        // Microdata support. See http://schema.org/docs/gs.html
                        itemProp: 0,
                        itemScope: HAS_BOOLEAN_VALUE,
                        itemType: 0,
                        // itemID and itemRef are for Microdata support as well but
                        // only specified in the WHATWG spec document. See
                        // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
                        itemID: 0,
                        itemRef: 0,
                        // results show looking glass icon and recent searches on input
                        // search fields in WebKit/Blink
                        results: 0,
                        // IE-only attribute that specifies security restrictions on an iframe
                        // as an alternative to the sandbox attribute on IE<10
                        security: 0,
                        // IE-only attribute that controls focus behavior
                        unselectable: 0,
                    },
                    DOMAttributeNames: {
                        acceptCharset: "accept-charset",
                        className: "class",
                        htmlFor: "for",
                        httpEquiv: "http-equiv",
                    },
                    DOMPropertyNames: {},
                };

                module.exports = HTMLDOMPropertyConfig;

                /***/
            },
            /* 419 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMChildrenOperations = __webpack_require__(420);
                var ReactDOMIDOperations = __webpack_require__(431);

                /**
                 * Abstracts away all functionality of the reconciler that requires knowledge of
                 * the browser context. TODO: These callers should be refactored to avoid the
                 * need for this injection.
                 */
                var ReactComponentBrowserEnvironment = {
                    processChildrenUpdates:
                        ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

                    replaceNodeWithMarkup:
                        DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
                };

                module.exports = ReactComponentBrowserEnvironment;

                /***/
            },
            /* 420 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMLazyTree = __webpack_require__(421);
                var Danger = __webpack_require__(427);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactInstrumentation = __webpack_require__(407);

                var createMicrosoftUnsafeLocalFunction =
                    __webpack_require__(424);
                var setInnerHTML = __webpack_require__(423);
                var setTextContent = __webpack_require__(425);

                function getNodeAfter(parentNode, node) {
                    // Special case for text components, which return [open, close] comments
                    // from getHostNode.
                    if (Array.isArray(node)) {
                        node = node[1];
                    }
                    return node ? node.nextSibling : parentNode.firstChild;
                }

                /**
                 * Inserts `childNode` as a child of `parentNode` at the `index`.
                 *
                 * @param {DOMElement} parentNode Parent node in which to insert.
                 * @param {DOMElement} childNode Child node to insert.
                 * @param {number} index Index at which to insert the child.
                 * @internal
                 */
                var insertChildAt = createMicrosoftUnsafeLocalFunction(
                    function (parentNode, childNode, referenceNode) {
                        // We rely exclusively on `insertBefore(node, null)` instead of also using
                        // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
                        // we are careful to use `null`.)
                        parentNode.insertBefore(childNode, referenceNode);
                    }
                );

                function insertLazyTreeChildAt(
                    parentNode,
                    childTree,
                    referenceNode
                ) {
                    DOMLazyTree.insertTreeBefore(
                        parentNode,
                        childTree,
                        referenceNode
                    );
                }

                function moveChild(parentNode, childNode, referenceNode) {
                    if (Array.isArray(childNode)) {
                        moveDelimitedText(
                            parentNode,
                            childNode[0],
                            childNode[1],
                            referenceNode
                        );
                    } else {
                        insertChildAt(parentNode, childNode, referenceNode);
                    }
                }

                function removeChild(parentNode, childNode) {
                    if (Array.isArray(childNode)) {
                        var closingComment = childNode[1];
                        childNode = childNode[0];
                        removeDelimitedText(
                            parentNode,
                            childNode,
                            closingComment
                        );
                        parentNode.removeChild(closingComment);
                    }
                    parentNode.removeChild(childNode);
                }

                function moveDelimitedText(
                    parentNode,
                    openingComment,
                    closingComment,
                    referenceNode
                ) {
                    var node = openingComment;
                    while (true) {
                        var nextNode = node.nextSibling;
                        insertChildAt(parentNode, node, referenceNode);
                        if (node === closingComment) {
                            break;
                        }
                        node = nextNode;
                    }
                }

                function removeDelimitedText(
                    parentNode,
                    startNode,
                    closingComment
                ) {
                    while (true) {
                        var node = startNode.nextSibling;
                        if (node === closingComment) {
                            // The closing comment is removed by ReactMultiChild.
                            break;
                        } else {
                            parentNode.removeChild(node);
                        }
                    }
                }

                function replaceDelimitedText(
                    openingComment,
                    closingComment,
                    stringText
                ) {
                    var parentNode = openingComment.parentNode;
                    var nodeAfterComment = openingComment.nextSibling;
                    if (nodeAfterComment === closingComment) {
                        // There are no text nodes between the opening and closing comments; insert
                        // a new one if stringText isn't empty.
                        if (stringText) {
                            insertChildAt(
                                parentNode,
                                document.createTextNode(stringText),
                                nodeAfterComment
                            );
                        }
                    } else {
                        if (stringText) {
                            // Set the text content of the first node after the opening comment, and
                            // remove all following nodes up until the closing comment.
                            setTextContent(nodeAfterComment, stringText);
                            removeDelimitedText(
                                parentNode,
                                nodeAfterComment,
                                closingComment
                            );
                        } else {
                            removeDelimitedText(
                                parentNode,
                                openingComment,
                                closingComment
                            );
                        }
                    }

                    if (false) {
                        ReactInstrumentation.debugTool.onHostOperation({
                            instanceID:
                                ReactDOMComponentTree.getInstanceFromNode(
                                    openingComment
                                )._debugID,
                            type: "replace text",
                            payload: stringText,
                        });
                    }
                }

                var dangerouslyReplaceNodeWithMarkup =
                    Danger.dangerouslyReplaceNodeWithMarkup;
                if (false) {
                    dangerouslyReplaceNodeWithMarkup = function (
                        oldChild,
                        markup,
                        prevInstance
                    ) {
                        Danger.dangerouslyReplaceNodeWithMarkup(
                            oldChild,
                            markup
                        );
                        if (prevInstance._debugID !== 0) {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: prevInstance._debugID,
                                type: "replace with",
                                payload: markup.toString(),
                            });
                        } else {
                            var nextInstance =
                                ReactDOMComponentTree.getInstanceFromNode(
                                    markup.node
                                );
                            if (nextInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onHostOperation({
                                    instanceID: nextInstance._debugID,
                                    type: "mount",
                                    payload: markup.toString(),
                                });
                            }
                        }
                    };
                }

                /**
                 * Operations for updating with DOM children.
                 */
                var DOMChildrenOperations = {
                    dangerouslyReplaceNodeWithMarkup:
                        dangerouslyReplaceNodeWithMarkup,

                    replaceDelimitedText: replaceDelimitedText,

                    /**
                     * Updates a component's children by processing a series of updates. The
                     * update configurations are each expected to have a `parentNode` property.
                     *
                     * @param {array<object>} updates List of update configurations.
                     * @internal
                     */
                    processUpdates: function (parentNode, updates) {
                        if (false) {
                            var parentNodeDebugID =
                                ReactDOMComponentTree.getInstanceFromNode(
                                    parentNode
                                )._debugID;
                        }

                        for (var k = 0; k < updates.length; k++) {
                            var update = updates[k];
                            switch (update.type) {
                                case "INSERT_MARKUP":
                                    insertLazyTreeChildAt(
                                        parentNode,
                                        update.content,
                                        getNodeAfter(
                                            parentNode,
                                            update.afterNode
                                        )
                                    );
                                    if (false) {
                                        ReactInstrumentation.debugTool.onHostOperation(
                                            {
                                                instanceID: parentNodeDebugID,
                                                type: "insert child",
                                                payload: {
                                                    toIndex: update.toIndex,
                                                    content:
                                                        update.content.toString(),
                                                },
                                            }
                                        );
                                    }
                                    break;
                                case "MOVE_EXISTING":
                                    moveChild(
                                        parentNode,
                                        update.fromNode,
                                        getNodeAfter(
                                            parentNode,
                                            update.afterNode
                                        )
                                    );
                                    if (false) {
                                        ReactInstrumentation.debugTool.onHostOperation(
                                            {
                                                instanceID: parentNodeDebugID,
                                                type: "move child",
                                                payload: {
                                                    fromIndex: update.fromIndex,
                                                    toIndex: update.toIndex,
                                                },
                                            }
                                        );
                                    }
                                    break;
                                case "SET_MARKUP":
                                    setInnerHTML(parentNode, update.content);
                                    if (false) {
                                        ReactInstrumentation.debugTool.onHostOperation(
                                            {
                                                instanceID: parentNodeDebugID,
                                                type: "replace children",
                                                payload:
                                                    update.content.toString(),
                                            }
                                        );
                                    }
                                    break;
                                case "TEXT_CONTENT":
                                    setTextContent(parentNode, update.content);
                                    if (false) {
                                        ReactInstrumentation.debugTool.onHostOperation(
                                            {
                                                instanceID: parentNodeDebugID,
                                                type: "replace text",
                                                payload:
                                                    update.content.toString(),
                                            }
                                        );
                                    }
                                    break;
                                case "REMOVE_NODE":
                                    removeChild(parentNode, update.fromNode);
                                    if (false) {
                                        ReactInstrumentation.debugTool.onHostOperation(
                                            {
                                                instanceID: parentNodeDebugID,
                                                type: "remove child",
                                                payload: {
                                                    fromIndex: update.fromIndex,
                                                },
                                            }
                                        );
                                    }
                                    break;
                            }
                        }
                    },
                };

                module.exports = DOMChildrenOperations;

                /***/
            },
            /* 421 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMNamespaces = __webpack_require__(422);
                var setInnerHTML = __webpack_require__(423);

                var createMicrosoftUnsafeLocalFunction =
                    __webpack_require__(424);
                var setTextContent = __webpack_require__(425);

                var ELEMENT_NODE_TYPE = 1;
                var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

                /**
                 * In IE (8-11) and Edge, appending nodes with no children is dramatically
                 * faster than appending a full subtree, so we essentially queue up the
                 * .appendChild calls here and apply them so each node is added to its parent
                 * before any children are added.
                 *
                 * In other browsers, doing so is slower or neutral compared to the other order
                 * (in Firefox, twice as slow) so we only do this inversion in IE.
                 *
                 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
                 */
                var enableLazy =
                    (typeof document !== "undefined" &&
                        typeof document.documentMode === "number") ||
                    (typeof navigator !== "undefined" &&
                        typeof navigator.userAgent === "string" &&
                        /\bEdge\/\d/.test(navigator.userAgent));

                function insertTreeChildren(tree) {
                    if (!enableLazy) {
                        return;
                    }
                    var node = tree.node;
                    var children = tree.children;
                    if (children.length) {
                        for (var i = 0; i < children.length; i++) {
                            insertTreeBefore(node, children[i], null);
                        }
                    } else if (tree.html != null) {
                        setInnerHTML(node, tree.html);
                    } else if (tree.text != null) {
                        setTextContent(node, tree.text);
                    }
                }

                var insertTreeBefore = createMicrosoftUnsafeLocalFunction(
                    function (parentNode, tree, referenceNode) {
                        // DocumentFragments aren't actually part of the DOM after insertion so
                        // appending children won't update the DOM. We need to ensure the fragment
                        // is properly populated first, breaking out of our lazy approach for just
                        // this level. Also, some <object> plugins (like Flash Player) will read
                        // <param> nodes immediately upon insertion into the DOM, so <object>
                        // must also be populated prior to insertion into the DOM.
                        if (
                            tree.node.nodeType ===
                                DOCUMENT_FRAGMENT_NODE_TYPE ||
                            (tree.node.nodeType === ELEMENT_NODE_TYPE &&
                                tree.node.nodeName.toLowerCase() === "object" &&
                                (tree.node.namespaceURI == null ||
                                    tree.node.namespaceURI ===
                                        DOMNamespaces.html))
                        ) {
                            insertTreeChildren(tree);
                            parentNode.insertBefore(tree.node, referenceNode);
                        } else {
                            parentNode.insertBefore(tree.node, referenceNode);
                            insertTreeChildren(tree);
                        }
                    }
                );

                function replaceChildWithTree(oldNode, newTree) {
                    oldNode.parentNode.replaceChild(newTree.node, oldNode);
                    insertTreeChildren(newTree);
                }

                function queueChild(parentTree, childTree) {
                    if (enableLazy) {
                        parentTree.children.push(childTree);
                    } else {
                        parentTree.node.appendChild(childTree.node);
                    }
                }

                function queueHTML(tree, html) {
                    if (enableLazy) {
                        tree.html = html;
                    } else {
                        setInnerHTML(tree.node, html);
                    }
                }

                function queueText(tree, text) {
                    if (enableLazy) {
                        tree.text = text;
                    } else {
                        setTextContent(tree.node, text);
                    }
                }

                function toString() {
                    return this.node.nodeName;
                }

                function DOMLazyTree(node) {
                    return {
                        node: node,
                        children: [],
                        html: null,
                        text: null,
                        toString: toString,
                    };
                }

                DOMLazyTree.insertTreeBefore = insertTreeBefore;
                DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
                DOMLazyTree.queueChild = queueChild;
                DOMLazyTree.queueHTML = queueHTML;
                DOMLazyTree.queueText = queueText;

                module.exports = DOMLazyTree;

                /***/
            },
            /* 422 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMNamespaces = {
                    html: "http://www.w3.org/1999/xhtml",
                    mathml: "http://www.w3.org/1998/Math/MathML",
                    svg: "http://www.w3.org/2000/svg",
                };

                module.exports = DOMNamespaces;

                /***/
            },
            /* 423 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ExecutionEnvironment = __webpack_require__(393);
                var DOMNamespaces = __webpack_require__(422);

                var WHITESPACE_TEST = /^[ \r\n\t\f]/;
                var NONVISIBLE_TEST =
                    /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

                var createMicrosoftUnsafeLocalFunction =
                    __webpack_require__(424);

                // SVG temp container for IE lacking innerHTML
                var reusableSVGContainer;

                /**
                 * Set the innerHTML property of a node, ensuring that whitespace is preserved
                 * even in IE8.
                 *
                 * @param {DOMElement} node
                 * @param {string} html
                 * @internal
                 */
                var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (
                    node,
                    html
                ) {
                    // IE does not have innerHTML for SVG nodes, so instead we inject the
                    // new markup in a temp node and then move the child nodes across into
                    // the target node
                    if (
                        node.namespaceURI === DOMNamespaces.svg &&
                        !("innerHTML" in node)
                    ) {
                        reusableSVGContainer =
                            reusableSVGContainer ||
                            document.createElement("div");
                        reusableSVGContainer.innerHTML =
                            "<svg>" + html + "</svg>";
                        var svgNode = reusableSVGContainer.firstChild;
                        while (svgNode.firstChild) {
                            node.appendChild(svgNode.firstChild);
                        }
                    } else {
                        node.innerHTML = html;
                    }
                });

                if (ExecutionEnvironment.canUseDOM) {
                    // IE8: When updating a just created node with innerHTML only leading
                    // whitespace is removed. When updating an existing node with innerHTML
                    // whitespace in root TextNodes is also collapsed.
                    // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

                    // Feature detection; only IE8 is known to behave improperly like this.
                    var testElement = document.createElement("div");
                    testElement.innerHTML = " ";
                    if (testElement.innerHTML === "") {
                        setInnerHTML = function (node, html) {
                            // Magic theory: IE8 supposedly differentiates between added and updated
                            // nodes when processing innerHTML, innerHTML on updated nodes suffers
                            // from worse whitespace behavior. Re-adding a node like this triggers
                            // the initial and more favorable whitespace behavior.
                            // TODO: What to do on a detached node?
                            if (node.parentNode) {
                                node.parentNode.replaceChild(node, node);
                            }

                            // We also implement a workaround for non-visible tags disappearing into
                            // thin air on IE8, this only happens if there is no visible text
                            // in-front of the non-visible tags. Piggyback on the whitespace fix
                            // and simply check if any non-visible tags appear in the source.
                            if (
                                WHITESPACE_TEST.test(html) ||
                                (html[0] === "<" && NONVISIBLE_TEST.test(html))
                            ) {
                                // Recover leading whitespace by temporarily prepending any character.
                                // \uFEFF has the potential advantage of being zero-width/invisible.
                                // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
                                // in hopes that this is preserved even if "\uFEFF" is transformed to
                                // the actual Unicode character (by Babel, for example).
                                // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
                                node.innerHTML =
                                    String.fromCharCode(0xfeff) + html;

                                // deleteData leaves an empty `TextNode` which offsets the index of all
                                // children. Definitely want to avoid this.
                                var textNode = node.firstChild;
                                if (textNode.data.length === 1) {
                                    node.removeChild(textNode);
                                } else {
                                    textNode.deleteData(0, 1);
                                }
                            } else {
                                node.innerHTML = html;
                            }
                        };
                    }
                    testElement = null;
                }

                module.exports = setInnerHTML;

                /***/
            },
            /* 424 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals MSApp */

                "use strict";

                /**
                 * Create a function which has 'unsafe' privileges (required by windows8 apps)
                 */

                var createMicrosoftUnsafeLocalFunction = function (func) {
                    if (
                        typeof MSApp !== "undefined" &&
                        MSApp.execUnsafeLocalFunction
                    ) {
                        return function (arg0, arg1, arg2, arg3) {
                            MSApp.execUnsafeLocalFunction(function () {
                                return func(arg0, arg1, arg2, arg3);
                            });
                        };
                    } else {
                        return func;
                    }
                };

                module.exports = createMicrosoftUnsafeLocalFunction;

                /***/
            },
            /* 425 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ExecutionEnvironment = __webpack_require__(393);
                var escapeTextContentForBrowser = __webpack_require__(426);
                var setInnerHTML = __webpack_require__(423);

                /**
                 * Set the textContent property of a node, ensuring that whitespace is preserved
                 * even in IE8. innerText is a poor substitute for textContent and, among many
                 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
                 * as it should.
                 *
                 * @param {DOMElement} node
                 * @param {string} text
                 * @internal
                 */
                var setTextContent = function (node, text) {
                    if (text) {
                        var firstChild = node.firstChild;

                        if (
                            firstChild &&
                            firstChild === node.lastChild &&
                            firstChild.nodeType === 3
                        ) {
                            firstChild.nodeValue = text;
                            return;
                        }
                    }
                    node.textContent = text;
                };

                if (ExecutionEnvironment.canUseDOM) {
                    if (!("textContent" in document.documentElement)) {
                        setTextContent = function (node, text) {
                            if (node.nodeType === 3) {
                                node.nodeValue = text;
                                return;
                            }
                            setInnerHTML(
                                node,
                                escapeTextContentForBrowser(text)
                            );
                        };
                    }
                }

                module.exports = setTextContent;

                /***/
            },
            /* 426 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * Based on the escape-html library, which is used under the MIT License below:
                 *
                 * Copyright (c) 2012-2013 TJ Holowaychuk
                 * Copyright (c) 2015 Andreas Lubbe
                 * Copyright (c) 2015 Tiancheng "Timothy" Gu
                 *
                 * Permission is hereby granted, free of charge, to any person obtaining
                 * a copy of this software and associated documentation files (the
                 * 'Software'), to deal in the Software without restriction, including
                 * without limitation the rights to use, copy, modify, merge, publish,
                 * distribute, sublicense, and/or sell copies of the Software, and to
                 * permit persons to whom the Software is furnished to do so, subject to
                 * the following conditions:
                 *
                 * The above copyright notice and this permission notice shall be
                 * included in all copies or substantial portions of the Software.
                 *
                 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
                 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
                 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                 *
                 */

                "use strict";

                // code copied and modified from escape-html
                /**
                 * Module variables.
                 * @private
                 */

                var matchHtmlRegExp = /["'&<>]/;

                /**
                 * Escape special characters in the given string of html.
                 *
                 * @param  {string} string The string to escape for inserting into HTML
                 * @return {string}
                 * @public
                 */

                function escapeHtml(string) {
                    var str = "" + string;
                    var match = matchHtmlRegExp.exec(str);

                    if (!match) {
                        return str;
                    }

                    var escape;
                    var html = "";
                    var index = 0;
                    var lastIndex = 0;

                    for (index = match.index; index < str.length; index++) {
                        switch (str.charCodeAt(index)) {
                            case 34:
                                // "
                                escape = "&quot;";
                                break;
                            case 38:
                                // &
                                escape = "&amp;";
                                break;
                            case 39:
                                // '
                                escape = "&#x27;"; // modified from escape-html; used to be '&#39'
                                break;
                            case 60:
                                // <
                                escape = "&lt;";
                                break;
                            case 62:
                                // >
                                escape = "&gt;";
                                break;
                            default:
                                continue;
                        }

                        if (lastIndex !== index) {
                            html += str.substring(lastIndex, index);
                        }

                        lastIndex = index + 1;
                        html += escape;
                    }

                    return lastIndex !== index
                        ? html + str.substring(lastIndex, index)
                        : html;
                }
                // end code copied and modified from escape-html

                /**
                 * Escapes text to prevent scripting attacks.
                 *
                 * @param {*} text Text value to escape.
                 * @return {string} An escaped string.
                 */
                function escapeTextContentForBrowser(text) {
                    if (typeof text === "boolean" || typeof text === "number") {
                        // this shortcircuit helps perf for types that we know will never have
                        // special characters, especially given that this function is used often
                        // for numeric dom ids.
                        return "" + text;
                    }
                    return escapeHtml(text);
                }

                module.exports = escapeTextContentForBrowser;

                /***/
            },
            /* 427 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var DOMLazyTree = __webpack_require__(421);
                var ExecutionEnvironment = __webpack_require__(393);

                var createNodesFromMarkup = __webpack_require__(428);
                var emptyFunction = __webpack_require__(359);
                var invariant = __webpack_require__(355);

                var Danger = {
                    /**
                     * Replaces a node with a string of markup at its current position within its
                     * parent. The markup must render into a single root node.
                     *
                     * @param {DOMElement} oldChild Child node to replace.
                     * @param {string} markup Markup to render in place of the child node.
                     * @internal
                     */
                    dangerouslyReplaceNodeWithMarkup: function (
                        oldChild,
                        markup
                    ) {
                        !ExecutionEnvironment.canUseDOM
                            ? false
                                ? invariant(
                                      false,
                                      "dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering."
                                  )
                                : _prodInvariant("56")
                            : void 0;
                        !markup
                            ? false
                                ? invariant(
                                      false,
                                      "dangerouslyReplaceNodeWithMarkup(...): Missing markup."
                                  )
                                : _prodInvariant("57")
                            : void 0;
                        !(oldChild.nodeName !== "HTML")
                            ? false
                                ? invariant(
                                      false,
                                      "dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString()."
                                  )
                                : _prodInvariant("58")
                            : void 0;

                        if (typeof markup === "string") {
                            var newChild = createNodesFromMarkup(
                                markup,
                                emptyFunction
                            )[0];
                            oldChild.parentNode.replaceChild(
                                newChild,
                                oldChild
                            );
                        } else {
                            DOMLazyTree.replaceChildWithTree(oldChild, markup);
                        }
                    },
                };

                module.exports = Danger;

                /***/
            },
            /* 428 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                /*eslint-disable fb-www/unsafe-html*/

                var ExecutionEnvironment = __webpack_require__(393);

                var createArrayFromMixed = __webpack_require__(429);
                var getMarkupWrap = __webpack_require__(430);
                var invariant = __webpack_require__(355);

                /**
                 * Dummy container used to render all markup.
                 */
                var dummyNode = ExecutionEnvironment.canUseDOM
                    ? document.createElement("div")
                    : null;

                /**
                 * Pattern used by `getNodeName`.
                 */
                var nodeNamePattern = /^\s*<(\w+)/;

                /**
                 * Extracts the `nodeName` of the first element in a string of markup.
                 *
                 * @param {string} markup String of markup.
                 * @return {?string} Node name of the supplied markup.
                 */
                function getNodeName(markup) {
                    var nodeNameMatch = markup.match(nodeNamePattern);
                    return nodeNameMatch && nodeNameMatch[1].toLowerCase();
                }

                /**
                 * Creates an array containing the nodes rendered from the supplied markup. The
                 * optionally supplied `handleScript` function will be invoked once for each
                 * <script> element that is rendered. If no `handleScript` function is supplied,
                 * an exception is thrown if any <script> elements are rendered.
                 *
                 * @param {string} markup A string of valid HTML markup.
                 * @param {?function} handleScript Invoked once for each rendered <script>.
                 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
                 */
                function createNodesFromMarkup(markup, handleScript) {
                    var node = dummyNode;
                    !!!dummyNode
                        ? false
                            ? invariant(
                                  false,
                                  "createNodesFromMarkup dummy not initialized"
                              )
                            : invariant(false)
                        : void 0;
                    var nodeName = getNodeName(markup);

                    var wrap = nodeName && getMarkupWrap(nodeName);
                    if (wrap) {
                        node.innerHTML = wrap[1] + markup + wrap[2];

                        var wrapDepth = wrap[0];
                        while (wrapDepth--) {
                            node = node.lastChild;
                        }
                    } else {
                        node.innerHTML = markup;
                    }

                    var scripts = node.getElementsByTagName("script");
                    if (scripts.length) {
                        !handleScript
                            ? false
                                ? invariant(
                                      false,
                                      "createNodesFromMarkup(...): Unexpected <script> element rendered."
                                  )
                                : invariant(false)
                            : void 0;
                        createArrayFromMixed(scripts).forEach(handleScript);
                    }

                    var nodes = Array.from(node.childNodes);
                    while (node.lastChild) {
                        node.removeChild(node.lastChild);
                    }
                    return nodes;
                }

                module.exports = createNodesFromMarkup;

                /***/
            },
            /* 429 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var invariant = __webpack_require__(355);

                /**
                 * Convert array-like objects to arrays.
                 *
                 * This API assumes the caller knows the contents of the data type. For less
                 * well defined inputs use createArrayFromMixed.
                 *
                 * @param {object|function|filelist} obj
                 * @return {array}
                 */
                function toArray(obj) {
                    var length = obj.length;

                    // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
                    // in old versions of Safari).
                    !(
                        !Array.isArray(obj) &&
                        (typeof obj === "object" || typeof obj === "function")
                    )
                        ? false
                            ? invariant(
                                  false,
                                  "toArray: Array-like object expected"
                              )
                            : invariant(false)
                        : void 0;

                    !(typeof length === "number")
                        ? false
                            ? invariant(
                                  false,
                                  "toArray: Object needs a length property"
                              )
                            : invariant(false)
                        : void 0;

                    !(length === 0 || length - 1 in obj)
                        ? false
                            ? invariant(
                                  false,
                                  "toArray: Object should have keys for indices"
                              )
                            : invariant(false)
                        : void 0;

                    !(typeof obj.callee !== "function")
                        ? false
                            ? invariant(
                                  false,
                                  "toArray: Object can't be `arguments`. Use rest params " +
                                      "(function(...args) {}) or Array.from() instead."
                              )
                            : invariant(false)
                        : void 0;

                    // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
                    // without method will throw during the slice call and skip straight to the
                    // fallback.
                    if (obj.hasOwnProperty) {
                        try {
                            return Array.prototype.slice.call(obj);
                        } catch (e) {
                            // IE < 9 does not support Array#slice on collections objects
                        }
                    }

                    // Fall back to copying key by key. This assumes all keys have a value,
                    // so will not preserve sparsely populated inputs.
                    var ret = Array(length);
                    for (var ii = 0; ii < length; ii++) {
                        ret[ii] = obj[ii];
                    }
                    return ret;
                }

                /**
                 * Perform a heuristic test to determine if an object is "array-like".
                 *
                 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
                 *   Joshu replied: "Mu."
                 *
                 * This function determines if its argument has "array nature": it returns
                 * true if the argument is an actual array, an `arguments' object, or an
                 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
                 *
                 * It will return false for other array-like objects like Filelist.
                 *
                 * @param {*} obj
                 * @return {boolean}
                 */
                function hasArrayNature(obj) {
                    return (
                        // not null/false
                        !!obj &&
                        // arrays are objects, NodeLists are functions in Safari
                        (typeof obj == "object" || typeof obj == "function") &&
                        // quacks like an array
                        "length" in obj &&
                        // not window
                        !("setInterval" in obj) &&
                        // no DOM node should be considered an array-like
                        // a 'select' element has 'length' and 'item' properties on IE8
                        typeof obj.nodeType != "number" &&
                        // a real array
                        (Array.isArray(obj) ||
                            // arguments
                            "callee" in obj ||
                            // HTMLCollection/NodeList
                            "item" in obj)
                    );
                }

                /**
                 * Ensure that the argument is an array by wrapping it in an array if it is not.
                 * Creates a copy of the argument if it is already an array.
                 *
                 * This is mostly useful idiomatically:
                 *
                 *   var createArrayFromMixed = require('createArrayFromMixed');
                 *
                 *   function takesOneOrMoreThings(things) {
                 *     things = createArrayFromMixed(things);
                 *     ...
                 *   }
                 *
                 * This allows you to treat `things' as an array, but accept scalars in the API.
                 *
                 * If you need to convert an array-like object, like `arguments`, into an array
                 * use toArray instead.
                 *
                 * @param {*} obj
                 * @return {array}
                 */
                function createArrayFromMixed(obj) {
                    if (!hasArrayNature(obj)) {
                        return [obj];
                    } else if (Array.isArray(obj)) {
                        return obj.slice();
                    } else {
                        return toArray(obj);
                    }
                }

                module.exports = createArrayFromMixed;

                /***/
            },
            /* 430 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /*eslint-disable fb-www/unsafe-html */

                var ExecutionEnvironment = __webpack_require__(393);

                var invariant = __webpack_require__(355);

                /**
                 * Dummy container used to detect which wraps are necessary.
                 */
                var dummyNode = ExecutionEnvironment.canUseDOM
                    ? document.createElement("div")
                    : null;

                /**
                 * Some browsers cannot use `innerHTML` to render certain elements standalone,
                 * so we wrap them, render the wrapped nodes, then extract the desired node.
                 *
                 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
                 */

                var shouldWrap = {};

                var selectWrap = [1, '<select multiple="true">', "</select>"];
                var tableWrap = [1, "<table>", "</table>"];
                var trWrap = [3, "<table><tbody><tr>", "</tr></tbody></table>"];

                var svgWrap = [
                    1,
                    '<svg xmlns="http://www.w3.org/2000/svg">',
                    "</svg>",
                ];

                var markupWrap = {
                    "*": [1, "?<div>", "</div>"],

                    "area": [1, "<map>", "</map>"],
                    "col": [
                        2,
                        "<table><tbody></tbody><colgroup>",
                        "</colgroup></table>",
                    ],
                    "legend": [1, "<fieldset>", "</fieldset>"],
                    "param": [1, "<object>", "</object>"],
                    "tr": [2, "<table><tbody>", "</tbody></table>"],

                    "optgroup": selectWrap,
                    "option": selectWrap,

                    "caption": tableWrap,
                    "colgroup": tableWrap,
                    "tbody": tableWrap,
                    "tfoot": tableWrap,
                    "thead": tableWrap,

                    "td": trWrap,
                    "th": trWrap,
                };

                // Initialize the SVG elements since we know they'll always need to be wrapped
                // consistently. If they are created inside a <div> they will be initialized in
                // the wrong namespace (and will not display).
                var svgElements = [
                    "circle",
                    "clipPath",
                    "defs",
                    "ellipse",
                    "g",
                    "image",
                    "line",
                    "linearGradient",
                    "mask",
                    "path",
                    "pattern",
                    "polygon",
                    "polyline",
                    "radialGradient",
                    "rect",
                    "stop",
                    "text",
                    "tspan",
                ];
                svgElements.forEach(function (nodeName) {
                    markupWrap[nodeName] = svgWrap;
                    shouldWrap[nodeName] = true;
                });

                /**
                 * Gets the markup wrap configuration for the supplied `nodeName`.
                 *
                 * NOTE: This lazily detects which wraps are necessary for the current browser.
                 *
                 * @param {string} nodeName Lowercase `nodeName`.
                 * @return {?array} Markup wrap configuration, if applicable.
                 */
                function getMarkupWrap(nodeName) {
                    !!!dummyNode
                        ? false
                            ? invariant(
                                  false,
                                  "Markup wrapping node not initialized"
                              )
                            : invariant(false)
                        : void 0;
                    if (!markupWrap.hasOwnProperty(nodeName)) {
                        nodeName = "*";
                    }
                    if (!shouldWrap.hasOwnProperty(nodeName)) {
                        if (nodeName === "*") {
                            dummyNode.innerHTML = "<link />";
                        } else {
                            dummyNode.innerHTML =
                                "<" + nodeName + "></" + nodeName + ">";
                        }
                        shouldWrap[nodeName] = !dummyNode.firstChild;
                    }
                    return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
                }

                module.exports = getMarkupWrap;

                /***/
            },
            /* 431 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMChildrenOperations = __webpack_require__(420);
                var ReactDOMComponentTree = __webpack_require__(379);

                /**
                 * Operations used to process updates to DOM nodes.
                 */
                var ReactDOMIDOperations = {
                    /**
                     * Updates a component's children by processing a series of updates.
                     *
                     * @param {array<object>} updates List of update configurations.
                     * @internal
                     */
                    dangerouslyProcessChildrenUpdates: function (
                        parentInst,
                        updates
                    ) {
                        var node =
                            ReactDOMComponentTree.getNodeFromInstance(
                                parentInst
                            );
                        DOMChildrenOperations.processUpdates(node, updates);
                    },
                };

                module.exports = ReactDOMIDOperations;

                /***/
            },
            /* 432 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* global hasOwnProperty:true */

                "use strict";

                var _prodInvariant = __webpack_require__(380),
                    _assign = __webpack_require__(351);

                var AutoFocusUtils = __webpack_require__(433);
                var CSSPropertyOperations = __webpack_require__(435);
                var DOMLazyTree = __webpack_require__(421);
                var DOMNamespaces = __webpack_require__(422);
                var DOMProperty = __webpack_require__(381);
                var DOMPropertyOperations = __webpack_require__(443);
                var EventPluginHub = __webpack_require__(387);
                var EventPluginRegistry = __webpack_require__(388);
                var ReactBrowserEventEmitter = __webpack_require__(445);
                var ReactDOMComponentFlags = __webpack_require__(382);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactDOMInput = __webpack_require__(448);
                var ReactDOMOption = __webpack_require__(451);
                var ReactDOMSelect = __webpack_require__(452);
                var ReactDOMTextarea = __webpack_require__(453);
                var ReactInstrumentation = __webpack_require__(407);
                var ReactMultiChild = __webpack_require__(454);
                var ReactServerRenderingTransaction = __webpack_require__(472);

                var emptyFunction = __webpack_require__(359);
                var escapeTextContentForBrowser = __webpack_require__(426);
                var invariant = __webpack_require__(355);
                var isEventSupported = __webpack_require__(410);
                var shallowEqual = __webpack_require__(461);
                var validateDOMNesting = __webpack_require__(475);
                var warning = __webpack_require__(358);

                var Flags = ReactDOMComponentFlags;
                var deleteListener = EventPluginHub.deleteListener;
                var getNode = ReactDOMComponentTree.getNodeFromInstance;
                var listenTo = ReactBrowserEventEmitter.listenTo;
                var registrationNameModules =
                    EventPluginRegistry.registrationNameModules;

                // For quickly matching children type, to test if can be treated as content.
                var CONTENT_TYPES = { string: true, number: true };

                var STYLE = "style";
                var HTML = "__html";
                var RESERVED_PROPS = {
                    children: null,
                    dangerouslySetInnerHTML: null,
                    suppressContentEditableWarning: null,
                };

                // Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
                var DOC_FRAGMENT_TYPE = 11;

                function getDeclarationErrorAddendum(internalInstance) {
                    if (internalInstance) {
                        var owner =
                            internalInstance._currentElement._owner || null;
                        if (owner) {
                            var name = owner.getName();
                            if (name) {
                                return (
                                    " This DOM node was rendered by `" +
                                    name +
                                    "`."
                                );
                            }
                        }
                    }
                    return "";
                }

                function friendlyStringify(obj) {
                    if (typeof obj === "object") {
                        if (Array.isArray(obj)) {
                            return (
                                "[" +
                                obj.map(friendlyStringify).join(", ") +
                                "]"
                            );
                        } else {
                            var pairs = [];
                            for (var key in obj) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        obj,
                                        key
                                    )
                                ) {
                                    var keyEscaped = /^[a-z$_][\w$_]*$/i.test(
                                        key
                                    )
                                        ? key
                                        : JSON.stringify(key);
                                    pairs.push(
                                        keyEscaped +
                                            ": " +
                                            friendlyStringify(obj[key])
                                    );
                                }
                            }
                            return "{" + pairs.join(", ") + "}";
                        }
                    } else if (typeof obj === "string") {
                        return JSON.stringify(obj);
                    } else if (typeof obj === "function") {
                        return "[function object]";
                    }
                    // Differs from JSON.stringify in that undefined because undefined and that
                    // inf and nan don't become null
                    return String(obj);
                }

                var styleMutationWarning = {};

                function checkAndWarnForMutatedStyle(
                    style1,
                    style2,
                    component
                ) {
                    if (style1 == null || style2 == null) {
                        return;
                    }
                    if (shallowEqual(style1, style2)) {
                        return;
                    }

                    var componentName = component._tag;
                    var owner = component._currentElement._owner;
                    var ownerName;
                    if (owner) {
                        ownerName = owner.getName();
                    }

                    var hash = ownerName + "|" + componentName;

                    if (styleMutationWarning.hasOwnProperty(hash)) {
                        return;
                    }

                    styleMutationWarning[hash] = true;

                    false
                        ? warning(
                              false,
                              "`%s` was passed a style object that has previously been mutated. " +
                                  "Mutating `style` is deprecated. Consider cloning it beforehand. Check " +
                                  "the `render` %s. Previous style: %s. Mutated style: %s.",
                              componentName,
                              owner
                                  ? "of `" + ownerName + "`"
                                  : "using <" + componentName + ">",
                              friendlyStringify(style1),
                              friendlyStringify(style2)
                          )
                        : void 0;
                }

                /**
                 * @param {object} component
                 * @param {?object} props
                 */
                function assertValidProps(component, props) {
                    if (!props) {
                        return;
                    }
                    // Note the use of `==` which checks for null or undefined.
                    if (voidElementTags[component._tag]) {
                        !(
                            props.children == null &&
                            props.dangerouslySetInnerHTML == null
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s",
                                      component._tag,
                                      component._currentElement._owner
                                          ? " Check the render method of " +
                                                component._currentElement._owner.getName() +
                                                "."
                                          : ""
                                  )
                                : _prodInvariant(
                                      "137",
                                      component._tag,
                                      component._currentElement._owner
                                          ? " Check the render method of " +
                                                component._currentElement._owner.getName() +
                                                "."
                                          : ""
                                  )
                            : void 0;
                    }
                    if (props.dangerouslySetInnerHTML != null) {
                        !(props.children == null)
                            ? false
                                ? invariant(
                                      false,
                                      "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                                  )
                                : _prodInvariant("60")
                            : void 0;
                        !(
                            typeof props.dangerouslySetInnerHTML === "object" &&
                            HTML in props.dangerouslySetInnerHTML
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information."
                                  )
                                : _prodInvariant("61")
                            : void 0;
                    }
                    if (false) {
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  props.innerHTML == null,
                                  "Directly setting property `innerHTML` is not permitted. " +
                                      "For more information, lookup documentation on `dangerouslySetInnerHTML`."
                              )
                            : void 0;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  props.suppressContentEditableWarning ||
                                      !props.contentEditable ||
                                      props.children == null,
                                  "A component is `contentEditable` and contains `children` managed by " +
                                      "React. It is now your responsibility to guarantee that none of " +
                                      "those nodes are unexpectedly modified or duplicated. This is " +
                                      "probably not intentional."
                              )
                            : void 0;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  props.onFocusIn == null &&
                                      props.onFocusOut == null,
                                  "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. " +
                                      "All React events are normalized to bubble, so onFocusIn and onFocusOut " +
                                      "are not needed/supported by React."
                              )
                            : void 0;
                    }
                    !(props.style == null || typeof props.style === "object")
                        ? false
                            ? invariant(
                                  false,
                                  "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.%s",
                                  getDeclarationErrorAddendum(component)
                              )
                            : _prodInvariant(
                                  "62",
                                  getDeclarationErrorAddendum(component)
                              )
                        : void 0;
                }

                function enqueuePutListener(
                    inst,
                    registrationName,
                    listener,
                    transaction
                ) {
                    if (
                        transaction instanceof ReactServerRenderingTransaction
                    ) {
                        return;
                    }
                    if (false) {
                        // IE8 has no API for event capturing and the `onScroll` event doesn't
                        // bubble.
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  registrationName !== "onScroll" ||
                                      isEventSupported("scroll", true),
                                  "This browser doesn't support the `onScroll` event"
                              )
                            : void 0;
                    }
                    var containerInfo = inst._hostContainerInfo;
                    var isDocumentFragment =
                        containerInfo._node &&
                        containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
                    var doc = isDocumentFragment
                        ? containerInfo._node
                        : containerInfo._ownerDocument;
                    listenTo(registrationName, doc);
                    transaction.getReactMountReady().enqueue(putListener, {
                        inst: inst,
                        registrationName: registrationName,
                        listener: listener,
                    });
                }

                function putListener() {
                    var listenerToPut = this;
                    EventPluginHub.putListener(
                        listenerToPut.inst,
                        listenerToPut.registrationName,
                        listenerToPut.listener
                    );
                }

                function inputPostMount() {
                    var inst = this;
                    ReactDOMInput.postMountWrapper(inst);
                }

                function textareaPostMount() {
                    var inst = this;
                    ReactDOMTextarea.postMountWrapper(inst);
                }

                function optionPostMount() {
                    var inst = this;
                    ReactDOMOption.postMountWrapper(inst);
                }

                var setAndValidateContentChildDev = emptyFunction;
                if (false) {
                    setAndValidateContentChildDev = function (content) {
                        var hasExistingContent = this._contentDebugID != null;
                        var debugID = this._debugID;
                        // This ID represents the inlined child that has no backing instance:
                        var contentDebugID = -debugID;

                        if (content == null) {
                            if (hasExistingContent) {
                                ReactInstrumentation.debugTool.onUnmountComponent(
                                    this._contentDebugID
                                );
                            }
                            this._contentDebugID = null;
                            return;
                        }

                        validateDOMNesting(
                            null,
                            String(content),
                            this,
                            this._ancestorInfo
                        );
                        this._contentDebugID = contentDebugID;
                        if (hasExistingContent) {
                            ReactInstrumentation.debugTool.onBeforeUpdateComponent(
                                contentDebugID,
                                content
                            );
                            ReactInstrumentation.debugTool.onUpdateComponent(
                                contentDebugID
                            );
                        } else {
                            ReactInstrumentation.debugTool.onBeforeMountComponent(
                                contentDebugID,
                                content,
                                debugID
                            );
                            ReactInstrumentation.debugTool.onMountComponent(
                                contentDebugID
                            );
                            ReactInstrumentation.debugTool.onSetChildren(
                                debugID,
                                [contentDebugID]
                            );
                        }
                    };
                }

                // There are so many media events, it makes sense to just
                // maintain a list rather than create a `trapBubbledEvent` for each
                var mediaEvents = {
                    topAbort: "abort",
                    topCanPlay: "canplay",
                    topCanPlayThrough: "canplaythrough",
                    topDurationChange: "durationchange",
                    topEmptied: "emptied",
                    topEncrypted: "encrypted",
                    topEnded: "ended",
                    topError: "error",
                    topLoadedData: "loadeddata",
                    topLoadedMetadata: "loadedmetadata",
                    topLoadStart: "loadstart",
                    topPause: "pause",
                    topPlay: "play",
                    topPlaying: "playing",
                    topProgress: "progress",
                    topRateChange: "ratechange",
                    topSeeked: "seeked",
                    topSeeking: "seeking",
                    topStalled: "stalled",
                    topSuspend: "suspend",
                    topTimeUpdate: "timeupdate",
                    topVolumeChange: "volumechange",
                    topWaiting: "waiting",
                };

                function trapBubbledEventsLocal() {
                    var inst = this;
                    // If a component renders to null or if another component fatals and causes
                    // the state of the tree to be corrupted, `node` here can be null.
                    !inst._rootNodeID
                        ? false
                            ? invariant(false, "Must be mounted to trap events")
                            : _prodInvariant("63")
                        : void 0;
                    var node = getNode(inst);
                    !node
                        ? false
                            ? invariant(
                                  false,
                                  "trapBubbledEvent(...): Requires node to be rendered."
                              )
                            : _prodInvariant("64")
                        : void 0;

                    switch (inst._tag) {
                        case "iframe":
                        case "object":
                            inst._wrapperState.listeners = [
                                ReactBrowserEventEmitter.trapBubbledEvent(
                                    "topLoad",
                                    "load",
                                    node
                                ),
                            ];
                            break;
                        case "video":
                        case "audio":
                            inst._wrapperState.listeners = [];
                            // Create listener for each media event
                            for (var event in mediaEvents) {
                                if (mediaEvents.hasOwnProperty(event)) {
                                    inst._wrapperState.listeners.push(
                                        ReactBrowserEventEmitter.trapBubbledEvent(
                                            event,
                                            mediaEvents[event],
                                            node
                                        )
                                    );
                                }
                            }
                            break;
                        case "source":
                            inst._wrapperState.listeners = [
                                ReactBrowserEventEmitter.trapBubbledEvent(
                                    "topError",
                                    "error",
                                    node
                                ),
                            ];
                            break;
                        case "img":
                            inst._wrapperState.listeners = [
                                ReactBrowserEventEmitter.trapBubbledEvent(
                                    "topError",
                                    "error",
                                    node
                                ),
                                ReactBrowserEventEmitter.trapBubbledEvent(
                                    "topLoad",
                                    "load",
                                    node
                                ),
                            ];
                            break;
                        case "form":
                            inst._wrapperState.listeners = [
                                ReactBrowserEventEmitter.trapBubbledEvent(
                                    "topReset",
                                    "reset",
                                    node
                                ),
                                ReactBrowserEventEmitter.trapBubbledEvent(
                                    "topSubmit",
                                    "submit",
                                    node
                                ),
                            ];
                            break;
                        case "input":
                        case "select":
                        case "textarea":
                            inst._wrapperState.listeners = [
                                ReactBrowserEventEmitter.trapBubbledEvent(
                                    "topInvalid",
                                    "invalid",
                                    node
                                ),
                            ];
                            break;
                    }
                }

                function postUpdateSelectWrapper() {
                    ReactDOMSelect.postUpdateWrapper(this);
                }

                // For HTML, certain tags should omit their close tag. We keep a whitelist for
                // those special-case tags.

                var omittedCloseTags = {
                    area: true,
                    base: true,
                    br: true,
                    col: true,
                    embed: true,
                    hr: true,
                    img: true,
                    input: true,
                    keygen: true,
                    link: true,
                    meta: true,
                    param: true,
                    source: true,
                    track: true,
                    wbr: true,
                };

                var newlineEatingTags = {
                    listing: true,
                    pre: true,
                    textarea: true,
                };

                // For HTML, certain tags cannot have children. This has the same purpose as
                // `omittedCloseTags` except that `menuitem` should still have its closing tag.

                var voidElementTags = _assign(
                    {
                        menuitem: true,
                    },
                    omittedCloseTags
                );

                // We accept any tag to be rendered but since this gets injected into arbitrary
                // HTML, we want to make sure that it's a safe tag.
                // http://www.w3.org/TR/REC-xml/#NT-Name

                var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
                var validatedTagCache = {};
                var hasOwnProperty = {}.hasOwnProperty;

                function validateDangerousTag(tag) {
                    if (!hasOwnProperty.call(validatedTagCache, tag)) {
                        !VALID_TAG_REGEX.test(tag)
                            ? false
                                ? invariant(false, "Invalid tag: %s", tag)
                                : _prodInvariant("65", tag)
                            : void 0;
                        validatedTagCache[tag] = true;
                    }
                }

                function isCustomComponent(tagName, props) {
                    return tagName.indexOf("-") >= 0 || props.is != null;
                }

                var globalIdCounter = 1;

                /**
                 * Creates a new React class that is idempotent and capable of containing other
                 * React components. It accepts event listeners and DOM properties that are
                 * valid according to `DOMProperty`.
                 *
                 *  - Event listeners: `onClick`, `onMouseDown`, etc.
                 *  - DOM properties: `className`, `name`, `title`, etc.
                 *
                 * The `style` property functions differently from the DOM API. It accepts an
                 * object mapping of style properties to values.
                 *
                 * @constructor ReactDOMComponent
                 * @extends ReactMultiChild
                 */
                function ReactDOMComponent(element) {
                    var tag = element.type;
                    validateDangerousTag(tag);
                    this._currentElement = element;
                    this._tag = tag.toLowerCase();
                    this._namespaceURI = null;
                    this._renderedChildren = null;
                    this._previousStyle = null;
                    this._previousStyleCopy = null;
                    this._hostNode = null;
                    this._hostParent = null;
                    this._rootNodeID = 0;
                    this._domID = 0;
                    this._hostContainerInfo = null;
                    this._wrapperState = null;
                    this._topLevelWrapper = null;
                    this._flags = 0;
                    if (false) {
                        this._ancestorInfo = null;
                        setAndValidateContentChildDev.call(this, null);
                    }
                }

                ReactDOMComponent.displayName = "ReactDOMComponent";

                ReactDOMComponent.Mixin = {
                    /**
                     * Generates root tag markup then recurses. This method has side effects and
                     * is not idempotent.
                     *
                     * @internal
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {?ReactDOMComponent} the parent component instance
                     * @param {?object} info about the host container
                     * @param {object} context
                     * @return {string} The computed markup.
                     */
                    mountComponent: function (
                        transaction,
                        hostParent,
                        hostContainerInfo,
                        context
                    ) {
                        this._rootNodeID = globalIdCounter++;
                        this._domID = hostContainerInfo._idCounter++;
                        this._hostParent = hostParent;
                        this._hostContainerInfo = hostContainerInfo;

                        var props = this._currentElement.props;

                        switch (this._tag) {
                            case "audio":
                            case "form":
                            case "iframe":
                            case "img":
                            case "link":
                            case "object":
                            case "source":
                            case "video":
                                this._wrapperState = {
                                    listeners: null,
                                };
                                transaction
                                    .getReactMountReady()
                                    .enqueue(trapBubbledEventsLocal, this);
                                break;
                            case "input":
                                ReactDOMInput.mountWrapper(
                                    this,
                                    props,
                                    hostParent
                                );
                                props = ReactDOMInput.getHostProps(this, props);
                                transaction
                                    .getReactMountReady()
                                    .enqueue(trapBubbledEventsLocal, this);
                                break;
                            case "option":
                                ReactDOMOption.mountWrapper(
                                    this,
                                    props,
                                    hostParent
                                );
                                props = ReactDOMOption.getHostProps(
                                    this,
                                    props
                                );
                                break;
                            case "select":
                                ReactDOMSelect.mountWrapper(
                                    this,
                                    props,
                                    hostParent
                                );
                                props = ReactDOMSelect.getHostProps(
                                    this,
                                    props
                                );
                                transaction
                                    .getReactMountReady()
                                    .enqueue(trapBubbledEventsLocal, this);
                                break;
                            case "textarea":
                                ReactDOMTextarea.mountWrapper(
                                    this,
                                    props,
                                    hostParent
                                );
                                props = ReactDOMTextarea.getHostProps(
                                    this,
                                    props
                                );
                                transaction
                                    .getReactMountReady()
                                    .enqueue(trapBubbledEventsLocal, this);
                                break;
                        }

                        assertValidProps(this, props);

                        // We create tags in the namespace of their parent container, except HTML
                        // tags get no namespace.
                        var namespaceURI;
                        var parentTag;
                        if (hostParent != null) {
                            namespaceURI = hostParent._namespaceURI;
                            parentTag = hostParent._tag;
                        } else if (hostContainerInfo._tag) {
                            namespaceURI = hostContainerInfo._namespaceURI;
                            parentTag = hostContainerInfo._tag;
                        }
                        if (
                            namespaceURI == null ||
                            (namespaceURI === DOMNamespaces.svg &&
                                parentTag === "foreignobject")
                        ) {
                            namespaceURI = DOMNamespaces.html;
                        }
                        if (namespaceURI === DOMNamespaces.html) {
                            if (this._tag === "svg") {
                                namespaceURI = DOMNamespaces.svg;
                            } else if (this._tag === "math") {
                                namespaceURI = DOMNamespaces.mathml;
                            }
                        }
                        this._namespaceURI = namespaceURI;

                        if (false) {
                            var parentInfo;
                            if (hostParent != null) {
                                parentInfo = hostParent._ancestorInfo;
                            } else if (hostContainerInfo._tag) {
                                parentInfo = hostContainerInfo._ancestorInfo;
                            }
                            if (parentInfo) {
                                // parentInfo should always be present except for the top-level
                                // component when server rendering
                                validateDOMNesting(
                                    this._tag,
                                    null,
                                    this,
                                    parentInfo
                                );
                            }
                            this._ancestorInfo =
                                validateDOMNesting.updatedAncestorInfo(
                                    parentInfo,
                                    this._tag,
                                    this
                                );
                        }

                        var mountImage;
                        if (transaction.useCreateElement) {
                            var ownerDocument =
                                hostContainerInfo._ownerDocument;
                            var el;
                            if (namespaceURI === DOMNamespaces.html) {
                                if (this._tag === "script") {
                                    // Create the script via .innerHTML so its "parser-inserted" flag is
                                    // set to true and it does not execute
                                    var div =
                                        ownerDocument.createElement("div");
                                    var type = this._currentElement.type;
                                    div.innerHTML =
                                        "<" + type + "></" + type + ">";
                                    el = div.removeChild(div.firstChild);
                                } else if (props.is) {
                                    el = ownerDocument.createElement(
                                        this._currentElement.type,
                                        props.is
                                    );
                                } else {
                                    // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
                                    // See discussion in https://github.com/facebook/react/pull/6896
                                    // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                                    el = ownerDocument.createElement(
                                        this._currentElement.type
                                    );
                                }
                            } else {
                                el = ownerDocument.createElementNS(
                                    namespaceURI,
                                    this._currentElement.type
                                );
                            }
                            ReactDOMComponentTree.precacheNode(this, el);
                            this._flags |= Flags.hasCachedChildNodes;
                            if (!this._hostParent) {
                                DOMPropertyOperations.setAttributeForRoot(el);
                            }
                            this._updateDOMProperties(null, props, transaction);
                            var lazyTree = DOMLazyTree(el);
                            this._createInitialChildren(
                                transaction,
                                props,
                                context,
                                lazyTree
                            );
                            mountImage = lazyTree;
                        } else {
                            var tagOpen =
                                this._createOpenTagMarkupAndPutListeners(
                                    transaction,
                                    props
                                );
                            var tagContent = this._createContentMarkup(
                                transaction,
                                props,
                                context
                            );
                            if (!tagContent && omittedCloseTags[this._tag]) {
                                mountImage = tagOpen + "/>";
                            } else {
                                mountImage =
                                    tagOpen +
                                    ">" +
                                    tagContent +
                                    "</" +
                                    this._currentElement.type +
                                    ">";
                            }
                        }

                        switch (this._tag) {
                            case "input":
                                transaction
                                    .getReactMountReady()
                                    .enqueue(inputPostMount, this);
                                if (props.autoFocus) {
                                    transaction
                                        .getReactMountReady()
                                        .enqueue(
                                            AutoFocusUtils.focusDOMComponent,
                                            this
                                        );
                                }
                                break;
                            case "textarea":
                                transaction
                                    .getReactMountReady()
                                    .enqueue(textareaPostMount, this);
                                if (props.autoFocus) {
                                    transaction
                                        .getReactMountReady()
                                        .enqueue(
                                            AutoFocusUtils.focusDOMComponent,
                                            this
                                        );
                                }
                                break;
                            case "select":
                                if (props.autoFocus) {
                                    transaction
                                        .getReactMountReady()
                                        .enqueue(
                                            AutoFocusUtils.focusDOMComponent,
                                            this
                                        );
                                }
                                break;
                            case "button":
                                if (props.autoFocus) {
                                    transaction
                                        .getReactMountReady()
                                        .enqueue(
                                            AutoFocusUtils.focusDOMComponent,
                                            this
                                        );
                                }
                                break;
                            case "option":
                                transaction
                                    .getReactMountReady()
                                    .enqueue(optionPostMount, this);
                                break;
                        }

                        return mountImage;
                    },

                    /**
                     * Creates markup for the open tag and all attributes.
                     *
                     * This method has side effects because events get registered.
                     *
                     * Iterating over object properties is faster than iterating over arrays.
                     * @see http://jsperf.com/obj-vs-arr-iteration
                     *
                     * @private
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {object} props
                     * @return {string} Markup of opening tag.
                     */
                    _createOpenTagMarkupAndPutListeners: function (
                        transaction,
                        props
                    ) {
                        var ret = "<" + this._currentElement.type;

                        for (var propKey in props) {
                            if (!props.hasOwnProperty(propKey)) {
                                continue;
                            }
                            var propValue = props[propKey];
                            if (propValue == null) {
                                continue;
                            }
                            if (
                                registrationNameModules.hasOwnProperty(propKey)
                            ) {
                                if (propValue) {
                                    enqueuePutListener(
                                        this,
                                        propKey,
                                        propValue,
                                        transaction
                                    );
                                }
                            } else {
                                if (propKey === STYLE) {
                                    if (propValue) {
                                        if (false) {
                                            // See `_updateDOMProperties`. style block
                                            this._previousStyle = propValue;
                                        }
                                        propValue = this._previousStyleCopy =
                                            _assign({}, props.style);
                                    }
                                    propValue =
                                        CSSPropertyOperations.createMarkupForStyles(
                                            propValue,
                                            this
                                        );
                                }
                                var markup = null;
                                if (
                                    this._tag != null &&
                                    isCustomComponent(this._tag, props)
                                ) {
                                    if (
                                        !RESERVED_PROPS.hasOwnProperty(propKey)
                                    ) {
                                        markup =
                                            DOMPropertyOperations.createMarkupForCustomAttribute(
                                                propKey,
                                                propValue
                                            );
                                    }
                                } else {
                                    markup =
                                        DOMPropertyOperations.createMarkupForProperty(
                                            propKey,
                                            propValue
                                        );
                                }
                                if (markup) {
                                    ret += " " + markup;
                                }
                            }
                        }

                        // For static pages, no need to put React ID and checksum. Saves lots of
                        // bytes.
                        if (transaction.renderToStaticMarkup) {
                            return ret;
                        }

                        if (!this._hostParent) {
                            ret +=
                                " " +
                                DOMPropertyOperations.createMarkupForRoot();
                        }
                        ret +=
                            " " +
                            DOMPropertyOperations.createMarkupForID(
                                this._domID
                            );
                        return ret;
                    },

                    /**
                     * Creates markup for the content between the tags.
                     *
                     * @private
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {object} props
                     * @param {object} context
                     * @return {string} Content markup.
                     */
                    _createContentMarkup: function (
                        transaction,
                        props,
                        context
                    ) {
                        var ret = "";

                        // Intentional use of != to avoid catching zero/false.
                        var innerHTML = props.dangerouslySetInnerHTML;
                        if (innerHTML != null) {
                            if (innerHTML.__html != null) {
                                ret = innerHTML.__html;
                            }
                        } else {
                            var contentToUse = CONTENT_TYPES[
                                typeof props.children
                            ]
                                ? props.children
                                : null;
                            var childrenToUse =
                                contentToUse != null ? null : props.children;
                            if (contentToUse != null) {
                                // TODO: Validate that text is allowed as a child of this node
                                ret = escapeTextContentForBrowser(contentToUse);
                                if (false) {
                                    setAndValidateContentChildDev.call(
                                        this,
                                        contentToUse
                                    );
                                }
                            } else if (childrenToUse != null) {
                                var mountImages = this.mountChildren(
                                    childrenToUse,
                                    transaction,
                                    context
                                );
                                ret = mountImages.join("");
                            }
                        }
                        if (
                            newlineEatingTags[this._tag] &&
                            ret.charAt(0) === "\n"
                        ) {
                            // text/html ignores the first character in these tags if it's a newline
                            // Prefer to break application/xml over text/html (for now) by adding
                            // a newline specifically to get eaten by the parser. (Alternately for
                            // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
                            // \r is normalized out by HTMLTextAreaElement#value.)
                            // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
                            // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
                            // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
                            // See: Parsing of "textarea" "listing" and "pre" elements
                            //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
                            return "\n" + ret;
                        } else {
                            return ret;
                        }
                    },

                    _createInitialChildren: function (
                        transaction,
                        props,
                        context,
                        lazyTree
                    ) {
                        // Intentional use of != to avoid catching zero/false.
                        var innerHTML = props.dangerouslySetInnerHTML;
                        if (innerHTML != null) {
                            if (innerHTML.__html != null) {
                                DOMLazyTree.queueHTML(
                                    lazyTree,
                                    innerHTML.__html
                                );
                            }
                        } else {
                            var contentToUse = CONTENT_TYPES[
                                typeof props.children
                            ]
                                ? props.children
                                : null;
                            var childrenToUse =
                                contentToUse != null ? null : props.children;
                            // TODO: Validate that text is allowed as a child of this node
                            if (contentToUse != null) {
                                // Avoid setting textContent when the text is empty. In IE11 setting
                                // textContent on a text area will cause the placeholder to not
                                // show within the textarea until it has been focused and blurred again.
                                // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                                if (contentToUse !== "") {
                                    if (false) {
                                        setAndValidateContentChildDev.call(
                                            this,
                                            contentToUse
                                        );
                                    }
                                    DOMLazyTree.queueText(
                                        lazyTree,
                                        contentToUse
                                    );
                                }
                            } else if (childrenToUse != null) {
                                var mountImages = this.mountChildren(
                                    childrenToUse,
                                    transaction,
                                    context
                                );
                                for (var i = 0; i < mountImages.length; i++) {
                                    DOMLazyTree.queueChild(
                                        lazyTree,
                                        mountImages[i]
                                    );
                                }
                            }
                        }
                    },

                    /**
                     * Receives a next element and updates the component.
                     *
                     * @internal
                     * @param {ReactElement} nextElement
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {object} context
                     */
                    receiveComponent: function (
                        nextElement,
                        transaction,
                        context
                    ) {
                        var prevElement = this._currentElement;
                        this._currentElement = nextElement;
                        this.updateComponent(
                            transaction,
                            prevElement,
                            nextElement,
                            context
                        );
                    },

                    /**
                     * Updates a DOM component after it has already been allocated and
                     * attached to the DOM. Reconciles the root DOM node, then recurses.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @param {ReactElement} prevElement
                     * @param {ReactElement} nextElement
                     * @internal
                     * @overridable
                     */
                    updateComponent: function (
                        transaction,
                        prevElement,
                        nextElement,
                        context
                    ) {
                        var lastProps = prevElement.props;
                        var nextProps = this._currentElement.props;

                        switch (this._tag) {
                            case "input":
                                lastProps = ReactDOMInput.getHostProps(
                                    this,
                                    lastProps
                                );
                                nextProps = ReactDOMInput.getHostProps(
                                    this,
                                    nextProps
                                );
                                break;
                            case "option":
                                lastProps = ReactDOMOption.getHostProps(
                                    this,
                                    lastProps
                                );
                                nextProps = ReactDOMOption.getHostProps(
                                    this,
                                    nextProps
                                );
                                break;
                            case "select":
                                lastProps = ReactDOMSelect.getHostProps(
                                    this,
                                    lastProps
                                );
                                nextProps = ReactDOMSelect.getHostProps(
                                    this,
                                    nextProps
                                );
                                break;
                            case "textarea":
                                lastProps = ReactDOMTextarea.getHostProps(
                                    this,
                                    lastProps
                                );
                                nextProps = ReactDOMTextarea.getHostProps(
                                    this,
                                    nextProps
                                );
                                break;
                        }

                        assertValidProps(this, nextProps);
                        this._updateDOMProperties(
                            lastProps,
                            nextProps,
                            transaction
                        );
                        this._updateDOMChildren(
                            lastProps,
                            nextProps,
                            transaction,
                            context
                        );

                        switch (this._tag) {
                            case "input":
                                // Update the wrapper around inputs *after* updating props. This has to
                                // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
                                // raise warnings and prevent the new value from being assigned.
                                ReactDOMInput.updateWrapper(this);
                                break;
                            case "textarea":
                                ReactDOMTextarea.updateWrapper(this);
                                break;
                            case "select":
                                // <select> value update needs to occur after <option> children
                                // reconciliation
                                transaction
                                    .getReactMountReady()
                                    .enqueue(postUpdateSelectWrapper, this);
                                break;
                        }
                    },

                    /**
                     * Reconciles the properties by detecting differences in property values and
                     * updating the DOM as necessary. This function is probably the single most
                     * critical path for performance optimization.
                     *
                     * TODO: Benchmark whether checking for changed values in memory actually
                     *       improves performance (especially statically positioned elements).
                     * TODO: Benchmark the effects of putting this at the top since 99% of props
                     *       do not change for a given reconciliation.
                     * TODO: Benchmark areas that can be improved with caching.
                     *
                     * @private
                     * @param {object} lastProps
                     * @param {object} nextProps
                     * @param {?DOMElement} node
                     */
                    _updateDOMProperties: function (
                        lastProps,
                        nextProps,
                        transaction
                    ) {
                        var propKey;
                        var styleName;
                        var styleUpdates;
                        for (propKey in lastProps) {
                            if (
                                nextProps.hasOwnProperty(propKey) ||
                                !lastProps.hasOwnProperty(propKey) ||
                                lastProps[propKey] == null
                            ) {
                                continue;
                            }
                            if (propKey === STYLE) {
                                var lastStyle = this._previousStyleCopy;
                                for (styleName in lastStyle) {
                                    if (lastStyle.hasOwnProperty(styleName)) {
                                        styleUpdates = styleUpdates || {};
                                        styleUpdates[styleName] = "";
                                    }
                                }
                                this._previousStyleCopy = null;
                            } else if (
                                registrationNameModules.hasOwnProperty(propKey)
                            ) {
                                if (lastProps[propKey]) {
                                    // Only call deleteListener if there was a listener previously or
                                    // else willDeleteListener gets called when there wasn't actually a
                                    // listener (e.g., onClick={null})
                                    deleteListener(this, propKey);
                                }
                            } else if (
                                isCustomComponent(this._tag, lastProps)
                            ) {
                                if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
                                    DOMPropertyOperations.deleteValueForAttribute(
                                        getNode(this),
                                        propKey
                                    );
                                }
                            } else if (
                                DOMProperty.properties[propKey] ||
                                DOMProperty.isCustomAttribute(propKey)
                            ) {
                                DOMPropertyOperations.deleteValueForProperty(
                                    getNode(this),
                                    propKey
                                );
                            }
                        }
                        for (propKey in nextProps) {
                            var nextProp = nextProps[propKey];
                            var lastProp =
                                propKey === STYLE
                                    ? this._previousStyleCopy
                                    : lastProps != null
                                    ? lastProps[propKey]
                                    : undefined;
                            if (
                                !nextProps.hasOwnProperty(propKey) ||
                                nextProp === lastProp ||
                                (nextProp == null && lastProp == null)
                            ) {
                                continue;
                            }
                            if (propKey === STYLE) {
                                if (nextProp) {
                                    if (false) {
                                        checkAndWarnForMutatedStyle(
                                            this._previousStyleCopy,
                                            this._previousStyle,
                                            this
                                        );
                                        this._previousStyle = nextProp;
                                    }
                                    nextProp = this._previousStyleCopy =
                                        _assign({}, nextProp);
                                } else {
                                    this._previousStyleCopy = null;
                                }
                                if (lastProp) {
                                    // Unset styles on `lastProp` but not on `nextProp`.
                                    for (styleName in lastProp) {
                                        if (
                                            lastProp.hasOwnProperty(
                                                styleName
                                            ) &&
                                            (!nextProp ||
                                                !nextProp.hasOwnProperty(
                                                    styleName
                                                ))
                                        ) {
                                            styleUpdates = styleUpdates || {};
                                            styleUpdates[styleName] = "";
                                        }
                                    }
                                    // Update styles that changed since `lastProp`.
                                    for (styleName in nextProp) {
                                        if (
                                            nextProp.hasOwnProperty(
                                                styleName
                                            ) &&
                                            lastProp[styleName] !==
                                                nextProp[styleName]
                                        ) {
                                            styleUpdates = styleUpdates || {};
                                            styleUpdates[styleName] =
                                                nextProp[styleName];
                                        }
                                    }
                                } else {
                                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                                    styleUpdates = nextProp;
                                }
                            } else if (
                                registrationNameModules.hasOwnProperty(propKey)
                            ) {
                                if (nextProp) {
                                    enqueuePutListener(
                                        this,
                                        propKey,
                                        nextProp,
                                        transaction
                                    );
                                } else if (lastProp) {
                                    deleteListener(this, propKey);
                                }
                            } else if (
                                isCustomComponent(this._tag, nextProps)
                            ) {
                                if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
                                    DOMPropertyOperations.setValueForAttribute(
                                        getNode(this),
                                        propKey,
                                        nextProp
                                    );
                                }
                            } else if (
                                DOMProperty.properties[propKey] ||
                                DOMProperty.isCustomAttribute(propKey)
                            ) {
                                var node = getNode(this);
                                // If we're updating to null or undefined, we should remove the property
                                // from the DOM node instead of inadvertently setting to a string. This
                                // brings us in line with the same behavior we have on initial render.
                                if (nextProp != null) {
                                    DOMPropertyOperations.setValueForProperty(
                                        node,
                                        propKey,
                                        nextProp
                                    );
                                } else {
                                    DOMPropertyOperations.deleteValueForProperty(
                                        node,
                                        propKey
                                    );
                                }
                            }
                        }
                        if (styleUpdates) {
                            CSSPropertyOperations.setValueForStyles(
                                getNode(this),
                                styleUpdates,
                                this
                            );
                        }
                    },

                    /**
                     * Reconciles the children with the various properties that affect the
                     * children content.
                     *
                     * @param {object} lastProps
                     * @param {object} nextProps
                     * @param {ReactReconcileTransaction} transaction
                     * @param {object} context
                     */
                    _updateDOMChildren: function (
                        lastProps,
                        nextProps,
                        transaction,
                        context
                    ) {
                        var lastContent = CONTENT_TYPES[
                            typeof lastProps.children
                        ]
                            ? lastProps.children
                            : null;
                        var nextContent = CONTENT_TYPES[
                            typeof nextProps.children
                        ]
                            ? nextProps.children
                            : null;

                        var lastHtml =
                            lastProps.dangerouslySetInnerHTML &&
                            lastProps.dangerouslySetInnerHTML.__html;
                        var nextHtml =
                            nextProps.dangerouslySetInnerHTML &&
                            nextProps.dangerouslySetInnerHTML.__html;

                        // Note the use of `!=` which checks for null or undefined.
                        var lastChildren =
                            lastContent != null ? null : lastProps.children;
                        var nextChildren =
                            nextContent != null ? null : nextProps.children;

                        // If we're switching from children to content/html or vice versa, remove
                        // the old content
                        var lastHasContentOrHtml =
                            lastContent != null || lastHtml != null;
                        var nextHasContentOrHtml =
                            nextContent != null || nextHtml != null;
                        if (lastChildren != null && nextChildren == null) {
                            this.updateChildren(null, transaction, context);
                        } else if (
                            lastHasContentOrHtml &&
                            !nextHasContentOrHtml
                        ) {
                            this.updateTextContent("");
                            if (false) {
                                ReactInstrumentation.debugTool.onSetChildren(
                                    this._debugID,
                                    []
                                );
                            }
                        }

                        if (nextContent != null) {
                            if (lastContent !== nextContent) {
                                this.updateTextContent("" + nextContent);
                                if (false) {
                                    setAndValidateContentChildDev.call(
                                        this,
                                        nextContent
                                    );
                                }
                            }
                        } else if (nextHtml != null) {
                            if (lastHtml !== nextHtml) {
                                this.updateMarkup("" + nextHtml);
                            }
                            if (false) {
                                ReactInstrumentation.debugTool.onSetChildren(
                                    this._debugID,
                                    []
                                );
                            }
                        } else if (nextChildren != null) {
                            if (false) {
                                setAndValidateContentChildDev.call(this, null);
                            }

                            this.updateChildren(
                                nextChildren,
                                transaction,
                                context
                            );
                        }
                    },

                    getHostNode: function () {
                        return getNode(this);
                    },

                    /**
                     * Destroys all event registrations for this instance. Does not remove from
                     * the DOM. That must be done by the parent.
                     *
                     * @internal
                     */
                    unmountComponent: function (safely) {
                        switch (this._tag) {
                            case "audio":
                            case "form":
                            case "iframe":
                            case "img":
                            case "link":
                            case "object":
                            case "source":
                            case "video":
                                var listeners = this._wrapperState.listeners;
                                if (listeners) {
                                    for (var i = 0; i < listeners.length; i++) {
                                        listeners[i].remove();
                                    }
                                }
                                break;
                            case "html":
                            case "head":
                            case "body":
                                /**
                                 * Components like <html> <head> and <body> can't be removed or added
                                 * easily in a cross-browser way, however it's valuable to be able to
                                 * take advantage of React's reconciliation for styling and <title>
                                 * management. So we just document it and throw in dangerous cases.
                                 */
                                true
                                    ? false
                                        ? invariant(
                                              false,
                                              "<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.",
                                              this._tag
                                          )
                                        : _prodInvariant("66", this._tag)
                                    : void 0;
                                break;
                        }

                        this.unmountChildren(safely);
                        ReactDOMComponentTree.uncacheNode(this);
                        EventPluginHub.deleteAllListeners(this);
                        this._rootNodeID = 0;
                        this._domID = 0;
                        this._wrapperState = null;

                        if (false) {
                            setAndValidateContentChildDev.call(this, null);
                        }
                    },

                    getPublicInstance: function () {
                        return getNode(this);
                    },
                };

                _assign(
                    ReactDOMComponent.prototype,
                    ReactDOMComponent.Mixin,
                    ReactMultiChild.Mixin
                );

                module.exports = ReactDOMComponent;

                /***/
            },
            /* 433 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactDOMComponentTree = __webpack_require__(379);

                var focusNode = __webpack_require__(434);

                var AutoFocusUtils = {
                    focusDOMComponent: function () {
                        focusNode(
                            ReactDOMComponentTree.getNodeFromInstance(this)
                        );
                    },
                };

                module.exports = AutoFocusUtils;

                /***/
            },
            /* 434 */
            /***/ function (module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * @param {DOMElement} node input/textarea to focus
                 */

                function focusNode(node) {
                    // IE8 can throw "Can't move focus to the control because it is invisible,
                    // not enabled, or of a type that does not accept the focus." for all kinds of
                    // reasons that are too expensive and fragile to test.
                    try {
                        node.focus();
                    } catch (e) {}
                }

                module.exports = focusNode;

                /***/
            },
            /* 435 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var CSSProperty = __webpack_require__(436);
                var ExecutionEnvironment = __webpack_require__(393);
                var ReactInstrumentation = __webpack_require__(407);

                var camelizeStyleName = __webpack_require__(437);
                var dangerousStyleValue = __webpack_require__(439);
                var hyphenateStyleName = __webpack_require__(440);
                var memoizeStringOnly = __webpack_require__(442);
                var warning = __webpack_require__(358);

                var processStyleName = memoizeStringOnly(function (styleName) {
                    return hyphenateStyleName(styleName);
                });

                var hasShorthandPropertyBug = false;
                var styleFloatAccessor = "cssFloat";
                if (ExecutionEnvironment.canUseDOM) {
                    var tempStyle = document.createElement("div").style;
                    try {
                        // IE8 throws "Invalid argument." if resetting shorthand style properties.
                        tempStyle.font = "";
                    } catch (e) {
                        hasShorthandPropertyBug = true;
                    }
                    // IE8 only supports accessing cssFloat (standard) as styleFloat
                    if (document.documentElement.style.cssFloat === undefined) {
                        styleFloatAccessor = "styleFloat";
                    }
                }

                if (false) {
                    // 'msTransform' is correct, but the other prefixes should be capitalized
                    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

                    // style values shouldn't contain a semicolon
                    var badStyleValueWithSemicolonPattern = /;\s*$/;

                    var warnedStyleNames = {};
                    var warnedStyleValues = {};
                    var warnedForNaNValue = false;

                    var warnHyphenatedStyleName = function (name, owner) {
                        if (
                            warnedStyleNames.hasOwnProperty(name) &&
                            warnedStyleNames[name]
                        ) {
                            return;
                        }

                        warnedStyleNames[name] = true;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  false,
                                  "Unsupported style property %s. Did you mean %s?%s",
                                  name,
                                  camelizeStyleName(name),
                                  checkRenderMessage(owner)
                              )
                            : void 0;
                    };

                    var warnBadVendoredStyleName = function (name, owner) {
                        if (
                            warnedStyleNames.hasOwnProperty(name) &&
                            warnedStyleNames[name]
                        ) {
                            return;
                        }

                        warnedStyleNames[name] = true;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  false,
                                  "Unsupported vendor-prefixed style property %s. Did you mean %s?%s",
                                  name,
                                  name.charAt(0).toUpperCase() + name.slice(1),
                                  checkRenderMessage(owner)
                              )
                            : void 0;
                    };

                    var warnStyleValueWithSemicolon = function (
                        name,
                        value,
                        owner
                    ) {
                        if (
                            warnedStyleValues.hasOwnProperty(value) &&
                            warnedStyleValues[value]
                        ) {
                            return;
                        }

                        warnedStyleValues[value] = true;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  false,
                                  "Style property values shouldn't contain a semicolon.%s " +
                                      'Try "%s: %s" instead.',
                                  checkRenderMessage(owner),
                                  name,
                                  value.replace(
                                      badStyleValueWithSemicolonPattern,
                                      ""
                                  )
                              )
                            : void 0;
                    };

                    var warnStyleValueIsNaN = function (name, value, owner) {
                        if (warnedForNaNValue) {
                            return;
                        }

                        warnedForNaNValue = true;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  false,
                                  "`NaN` is an invalid value for the `%s` css style property.%s",
                                  name,
                                  checkRenderMessage(owner)
                              )
                            : void 0;
                    };

                    var checkRenderMessage = function (owner) {
                        if (owner) {
                            var name = owner.getName();
                            if (name) {
                                return (
                                    " Check the render method of `" +
                                    name +
                                    "`."
                                );
                            }
                        }
                        return "";
                    };

                    /**
                     * @param {string} name
                     * @param {*} value
                     * @param {ReactDOMComponent} component
                     */
                    var warnValidStyle = function (name, value, component) {
                        var owner;
                        if (component) {
                            owner = component._currentElement._owner;
                        }
                        if (name.indexOf("-") > -1) {
                            warnHyphenatedStyleName(name, owner);
                        } else if (badVendoredStyleNamePattern.test(name)) {
                            warnBadVendoredStyleName(name, owner);
                        } else if (
                            badStyleValueWithSemicolonPattern.test(value)
                        ) {
                            warnStyleValueWithSemicolon(name, value, owner);
                        }

                        if (typeof value === "number" && isNaN(value)) {
                            warnStyleValueIsNaN(name, value, owner);
                        }
                    };
                }

                /**
                 * Operations for dealing with CSS properties.
                 */
                var CSSPropertyOperations = {
                    /**
                     * Serializes a mapping of style properties for use as inline styles:
                     *
                     *   > createMarkupForStyles({width: '200px', height: 0})
                     *   "width:200px;height:0;"
                     *
                     * Undefined values are ignored so that declarative programming is easier.
                     * The result should be HTML-escaped before insertion into the DOM.
                     *
                     * @param {object} styles
                     * @param {ReactDOMComponent} component
                     * @return {?string}
                     */
                    createMarkupForStyles: function (styles, component) {
                        var serialized = "";
                        for (var styleName in styles) {
                            if (!styles.hasOwnProperty(styleName)) {
                                continue;
                            }
                            var styleValue = styles[styleName];
                            if (false) {
                                warnValidStyle(
                                    styleName,
                                    styleValue,
                                    component
                                );
                            }
                            if (styleValue != null) {
                                serialized += processStyleName(styleName) + ":";
                                serialized +=
                                    dangerousStyleValue(
                                        styleName,
                                        styleValue,
                                        component
                                    ) + ";";
                            }
                        }
                        return serialized || null;
                    },

                    /**
                     * Sets the value for multiple styles on a node.  If a value is specified as
                     * '' (empty string), the corresponding style property will be unset.
                     *
                     * @param {DOMElement} node
                     * @param {object} styles
                     * @param {ReactDOMComponent} component
                     */
                    setValueForStyles: function (node, styles, component) {
                        if (false) {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: component._debugID,
                                type: "update styles",
                                payload: styles,
                            });
                        }

                        var style = node.style;
                        for (var styleName in styles) {
                            if (!styles.hasOwnProperty(styleName)) {
                                continue;
                            }
                            if (false) {
                                warnValidStyle(
                                    styleName,
                                    styles[styleName],
                                    component
                                );
                            }
                            var styleValue = dangerousStyleValue(
                                styleName,
                                styles[styleName],
                                component
                            );
                            if (
                                styleName === "float" ||
                                styleName === "cssFloat"
                            ) {
                                styleName = styleFloatAccessor;
                            }
                            if (styleValue) {
                                style[styleName] = styleValue;
                            } else {
                                var expansion =
                                    hasShorthandPropertyBug &&
                                    CSSProperty.shorthandPropertyExpansions[
                                        styleName
                                    ];
                                if (expansion) {
                                    // Shorthand property that IE8 won't like unsetting, so unset each
                                    // component to placate it
                                    for (var individualStyleName in expansion) {
                                        style[individualStyleName] = "";
                                    }
                                } else {
                                    style[styleName] = "";
                                }
                            }
                        }
                    },
                };

                module.exports = CSSPropertyOperations;

                /***/
            },
            /* 436 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * CSS properties which accept numbers but are not in units of "px".
                 */

                var isUnitlessNumber = {
                    animationIterationCount: true,
                    borderImageOutset: true,
                    borderImageSlice: true,
                    borderImageWidth: true,
                    boxFlex: true,
                    boxFlexGroup: true,
                    boxOrdinalGroup: true,
                    columnCount: true,
                    flex: true,
                    flexGrow: true,
                    flexPositive: true,
                    flexShrink: true,
                    flexNegative: true,
                    flexOrder: true,
                    gridRow: true,
                    gridColumn: true,
                    fontWeight: true,
                    lineClamp: true,
                    lineHeight: true,
                    opacity: true,
                    order: true,
                    orphans: true,
                    tabSize: true,
                    widows: true,
                    zIndex: true,
                    zoom: true,

                    // SVG-related properties
                    fillOpacity: true,
                    floodOpacity: true,
                    stopOpacity: true,
                    strokeDasharray: true,
                    strokeDashoffset: true,
                    strokeMiterlimit: true,
                    strokeOpacity: true,
                    strokeWidth: true,
                };

                /**
                 * @param {string} prefix vendor-specific prefix, eg: Webkit
                 * @param {string} key style name, eg: transitionDuration
                 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
                 * WebkitTransitionDuration
                 */
                function prefixKey(prefix, key) {
                    return (
                        prefix + key.charAt(0).toUpperCase() + key.substring(1)
                    );
                }

                /**
                 * Support style names that may come passed in prefixed by adding permutations
                 * of vendor prefixes.
                 */
                var prefixes = ["Webkit", "ms", "Moz", "O"];

                // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
                // infinite loop, because it iterates over the newly added props too.
                Object.keys(isUnitlessNumber).forEach(function (prop) {
                    prefixes.forEach(function (prefix) {
                        isUnitlessNumber[prefixKey(prefix, prop)] =
                            isUnitlessNumber[prop];
                    });
                });

                /**
                 * Most style properties can be unset by doing .style[prop] = '' but IE8
                 * doesn't like doing that with shorthand properties so for the properties that
                 * IE8 breaks on, which are listed here, we instead unset each of the
                 * individual properties. See http://bugs.jquery.com/ticket/12385.
                 * The 4-value 'clock' properties like margin, padding, border-width seem to
                 * behave without any problems. Curiously, list-style works too without any
                 * special prodding.
                 */
                var shorthandPropertyExpansions = {
                    background: {
                        backgroundAttachment: true,
                        backgroundColor: true,
                        backgroundImage: true,
                        backgroundPositionX: true,
                        backgroundPositionY: true,
                        backgroundRepeat: true,
                    },
                    backgroundPosition: {
                        backgroundPositionX: true,
                        backgroundPositionY: true,
                    },
                    border: {
                        borderWidth: true,
                        borderStyle: true,
                        borderColor: true,
                    },
                    borderBottom: {
                        borderBottomWidth: true,
                        borderBottomStyle: true,
                        borderBottomColor: true,
                    },
                    borderLeft: {
                        borderLeftWidth: true,
                        borderLeftStyle: true,
                        borderLeftColor: true,
                    },
                    borderRight: {
                        borderRightWidth: true,
                        borderRightStyle: true,
                        borderRightColor: true,
                    },
                    borderTop: {
                        borderTopWidth: true,
                        borderTopStyle: true,
                        borderTopColor: true,
                    },
                    font: {
                        fontStyle: true,
                        fontVariant: true,
                        fontWeight: true,
                        fontSize: true,
                        lineHeight: true,
                        fontFamily: true,
                    },
                    outline: {
                        outlineWidth: true,
                        outlineStyle: true,
                        outlineColor: true,
                    },
                };

                var CSSProperty = {
                    isUnitlessNumber: isUnitlessNumber,
                    shorthandPropertyExpansions: shorthandPropertyExpansions,
                };

                module.exports = CSSProperty;

                /***/
            },
            /* 437 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                "use strict";

                var camelize = __webpack_require__(438);

                var msPattern = /^-ms-/;

                /**
                 * Camelcases a hyphenated CSS property name, for example:
                 *
                 *   > camelizeStyleName('background-color')
                 *   < "backgroundColor"
                 *   > camelizeStyleName('-moz-transition')
                 *   < "MozTransition"
                 *   > camelizeStyleName('-ms-transition')
                 *   < "msTransition"
                 *
                 * As Andi Smith suggests
                 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
                 * is converted to lowercase `ms`.
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function camelizeStyleName(string) {
                    return camelize(string.replace(msPattern, "ms-"));
                }

                module.exports = camelizeStyleName;

                /***/
            },
            /* 438 */
            /***/ function (module, exports) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var _hyphenPattern = /-(.)/g;

                /**
                 * Camelcases a hyphenated string, for example:
                 *
                 *   > camelize('background-color')
                 *   < "backgroundColor"
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function camelize(string) {
                    return string.replace(
                        _hyphenPattern,
                        function (_, character) {
                            return character.toUpperCase();
                        }
                    );
                }

                module.exports = camelize;

                /***/
            },
            /* 439 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var CSSProperty = __webpack_require__(436);
                var warning = __webpack_require__(358);

                var isUnitlessNumber = CSSProperty.isUnitlessNumber;
                var styleWarnings = {};

                /**
                 * Convert a value into the proper css writable value. The style name `name`
                 * should be logical (no hyphens), as specified
                 * in `CSSProperty.isUnitlessNumber`.
                 *
                 * @param {string} name CSS property name such as `topMargin`.
                 * @param {*} value CSS property value such as `10px`.
                 * @param {ReactDOMComponent} component
                 * @return {string} Normalized style value with dimensions applied.
                 */
                function dangerousStyleValue(name, value, component) {
                    // Note that we've removed escapeTextForBrowser() calls here since the
                    // whole string will be escaped when the attribute is injected into
                    // the markup. If you provide unsafe user data here they can inject
                    // arbitrary CSS which may be problematic (I couldn't repro this):
                    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
                    // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
                    // This is not an XSS hole but instead a potential CSS injection issue
                    // which has lead to a greater discussion about how we're going to
                    // trust URLs moving forward. See #2115901

                    var isEmpty =
                        value == null ||
                        typeof value === "boolean" ||
                        value === "";
                    if (isEmpty) {
                        return "";
                    }

                    var isNonNumeric = isNaN(value);
                    if (
                        isNonNumeric ||
                        value === 0 ||
                        (isUnitlessNumber.hasOwnProperty(name) &&
                            isUnitlessNumber[name])
                    ) {
                        return "" + value; // cast to string
                    }

                    if (typeof value === "string") {
                        if (false) {
                            // Allow '0' to pass through without warning. 0 is already special and
                            // doesn't require units, so we don't need to warn about it.
                            if (component && value !== "0") {
                                var owner = component._currentElement._owner;
                                var ownerName = owner ? owner.getName() : null;
                                if (ownerName && !styleWarnings[ownerName]) {
                                    styleWarnings[ownerName] = {};
                                }
                                var warned = false;
                                if (ownerName) {
                                    var warnings = styleWarnings[ownerName];
                                    warned = warnings[name];
                                    if (!warned) {
                                        warnings[name] = true;
                                    }
                                }
                                if (!warned) {
                                    process.env.NODE_ENV !== "production"
                                        ? warning(
                                              false,
                                              "a `%s` tag (owner: `%s`) was passed a numeric string value " +
                                                  "for CSS property `%s` (value: `%s`) which will be treated " +
                                                  "as a unitless number in a future version of React.",
                                              component._currentElement.type,
                                              ownerName || "unknown",
                                              name,
                                              value
                                          )
                                        : void 0;
                                }
                            }
                        }
                        value = value.trim();
                    }
                    return value + "px";
                }

                module.exports = dangerousStyleValue;

                /***/
            },
            /* 440 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                "use strict";

                var hyphenate = __webpack_require__(441);

                var msPattern = /^ms-/;

                /**
                 * Hyphenates a camelcased CSS property name, for example:
                 *
                 *   > hyphenateStyleName('backgroundColor')
                 *   < "background-color"
                 *   > hyphenateStyleName('MozTransition')
                 *   < "-moz-transition"
                 *   > hyphenateStyleName('msTransition')
                 *   < "-ms-transition"
                 *
                 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
                 * is converted to `-ms-`.
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function hyphenateStyleName(string) {
                    return hyphenate(string).replace(msPattern, "-ms-");
                }

                module.exports = hyphenateStyleName;

                /***/
            },
            /* 441 */
            /***/ function (module, exports) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var _uppercasePattern = /([A-Z])/g;

                /**
                 * Hyphenates a camelcased string, for example:
                 *
                 *   > hyphenate('backgroundColor')
                 *   < "background-color"
                 *
                 * For CSS style names, use `hyphenateStyleName` instead which works properly
                 * with all vendor prefixes, including `ms`.
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function hyphenate(string) {
                    return string
                        .replace(_uppercasePattern, "-$1")
                        .toLowerCase();
                }

                module.exports = hyphenate;

                /***/
            },
            /* 442 */
            /***/ function (module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 * @typechecks static-only
                 */

                "use strict";

                /**
                 * Memoizes the return value of a function that accepts one string argument.
                 */

                function memoizeStringOnly(callback) {
                    var cache = {};
                    return function (string) {
                        if (!cache.hasOwnProperty(string)) {
                            cache[string] = callback.call(this, string);
                        }
                        return cache[string];
                    };
                }

                module.exports = memoizeStringOnly;

                /***/
            },
            /* 443 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMProperty = __webpack_require__(381);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactInstrumentation = __webpack_require__(407);

                var quoteAttributeValueForBrowser = __webpack_require__(444);
                var warning = __webpack_require__(358);

                var VALID_ATTRIBUTE_NAME_REGEX = new RegExp(
                    "^[" +
                        DOMProperty.ATTRIBUTE_NAME_START_CHAR +
                        "][" +
                        DOMProperty.ATTRIBUTE_NAME_CHAR +
                        "]*$"
                );
                var illegalAttributeNameCache = {};
                var validatedAttributeNameCache = {};

                function isAttributeNameSafe(attributeName) {
                    if (
                        validatedAttributeNameCache.hasOwnProperty(
                            attributeName
                        )
                    ) {
                        return true;
                    }
                    if (
                        illegalAttributeNameCache.hasOwnProperty(attributeName)
                    ) {
                        return false;
                    }
                    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
                        validatedAttributeNameCache[attributeName] = true;
                        return true;
                    }
                    illegalAttributeNameCache[attributeName] = true;
                    false
                        ? warning(
                              false,
                              "Invalid attribute name: `%s`",
                              attributeName
                          )
                        : void 0;
                    return false;
                }

                function shouldIgnoreValue(propertyInfo, value) {
                    return (
                        value == null ||
                        (propertyInfo.hasBooleanValue && !value) ||
                        (propertyInfo.hasNumericValue && isNaN(value)) ||
                        (propertyInfo.hasPositiveNumericValue && value < 1) ||
                        (propertyInfo.hasOverloadedBooleanValue &&
                            value === false)
                    );
                }

                /**
                 * Operations for dealing with DOM properties.
                 */
                var DOMPropertyOperations = {
                    /**
                     * Creates markup for the ID property.
                     *
                     * @param {string} id Unescaped ID.
                     * @return {string} Markup string.
                     */
                    createMarkupForID: function (id) {
                        return (
                            DOMProperty.ID_ATTRIBUTE_NAME +
                            "=" +
                            quoteAttributeValueForBrowser(id)
                        );
                    },

                    setAttributeForID: function (node, id) {
                        node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
                    },

                    createMarkupForRoot: function () {
                        return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
                    },

                    setAttributeForRoot: function (node) {
                        node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, "");
                    },

                    /**
                     * Creates markup for a property.
                     *
                     * @param {string} name
                     * @param {*} value
                     * @return {?string} Markup string, or null if the property was invalid.
                     */
                    createMarkupForProperty: function (name, value) {
                        var propertyInfo =
                            DOMProperty.properties.hasOwnProperty(name)
                                ? DOMProperty.properties[name]
                                : null;
                        if (propertyInfo) {
                            if (shouldIgnoreValue(propertyInfo, value)) {
                                return "";
                            }
                            var attributeName = propertyInfo.attributeName;
                            if (
                                propertyInfo.hasBooleanValue ||
                                (propertyInfo.hasOverloadedBooleanValue &&
                                    value === true)
                            ) {
                                return attributeName + '=""';
                            }
                            return (
                                attributeName +
                                "=" +
                                quoteAttributeValueForBrowser(value)
                            );
                        } else if (DOMProperty.isCustomAttribute(name)) {
                            if (value == null) {
                                return "";
                            }
                            return (
                                name +
                                "=" +
                                quoteAttributeValueForBrowser(value)
                            );
                        }
                        return null;
                    },

                    /**
                     * Creates markup for a custom property.
                     *
                     * @param {string} name
                     * @param {*} value
                     * @return {string} Markup string, or empty string if the property was invalid.
                     */
                    createMarkupForCustomAttribute: function (name, value) {
                        if (!isAttributeNameSafe(name) || value == null) {
                            return "";
                        }
                        return (
                            name + "=" + quoteAttributeValueForBrowser(value)
                        );
                    },

                    /**
                     * Sets the value for a property on a node.
                     *
                     * @param {DOMElement} node
                     * @param {string} name
                     * @param {*} value
                     */
                    setValueForProperty: function (node, name, value) {
                        var propertyInfo =
                            DOMProperty.properties.hasOwnProperty(name)
                                ? DOMProperty.properties[name]
                                : null;
                        if (propertyInfo) {
                            var mutationMethod = propertyInfo.mutationMethod;
                            if (mutationMethod) {
                                mutationMethod(node, value);
                            } else if (shouldIgnoreValue(propertyInfo, value)) {
                                this.deleteValueForProperty(node, name);
                                return;
                            } else if (propertyInfo.mustUseProperty) {
                                // Contrary to `setAttribute`, object properties are properly
                                // `toString`ed by IE8/9.
                                node[propertyInfo.propertyName] = value;
                            } else {
                                var attributeName = propertyInfo.attributeName;
                                var namespace = propertyInfo.attributeNamespace;
                                // `setAttribute` with objects becomes only `[object]` in IE8/9,
                                // ('' + value) makes it output the correct toString()-value.
                                if (namespace) {
                                    node.setAttributeNS(
                                        namespace,
                                        attributeName,
                                        "" + value
                                    );
                                } else if (
                                    propertyInfo.hasBooleanValue ||
                                    (propertyInfo.hasOverloadedBooleanValue &&
                                        value === true)
                                ) {
                                    node.setAttribute(attributeName, "");
                                } else {
                                    node.setAttribute(
                                        attributeName,
                                        "" + value
                                    );
                                }
                            }
                        } else if (DOMProperty.isCustomAttribute(name)) {
                            DOMPropertyOperations.setValueForAttribute(
                                node,
                                name,
                                value
                            );
                            return;
                        }

                        if (false) {
                            var payload = {};
                            payload[name] = value;
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID:
                                    ReactDOMComponentTree.getInstanceFromNode(
                                        node
                                    )._debugID,
                                type: "update attribute",
                                payload: payload,
                            });
                        }
                    },

                    setValueForAttribute: function (node, name, value) {
                        if (!isAttributeNameSafe(name)) {
                            return;
                        }
                        if (value == null) {
                            node.removeAttribute(name);
                        } else {
                            node.setAttribute(name, "" + value);
                        }

                        if (false) {
                            var payload = {};
                            payload[name] = value;
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID:
                                    ReactDOMComponentTree.getInstanceFromNode(
                                        node
                                    )._debugID,
                                type: "update attribute",
                                payload: payload,
                            });
                        }
                    },

                    /**
                     * Deletes an attributes from a node.
                     *
                     * @param {DOMElement} node
                     * @param {string} name
                     */
                    deleteValueForAttribute: function (node, name) {
                        node.removeAttribute(name);
                        if (false) {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID:
                                    ReactDOMComponentTree.getInstanceFromNode(
                                        node
                                    )._debugID,
                                type: "remove attribute",
                                payload: name,
                            });
                        }
                    },

                    /**
                     * Deletes the value for a property on a node.
                     *
                     * @param {DOMElement} node
                     * @param {string} name
                     */
                    deleteValueForProperty: function (node, name) {
                        var propertyInfo =
                            DOMProperty.properties.hasOwnProperty(name)
                                ? DOMProperty.properties[name]
                                : null;
                        if (propertyInfo) {
                            var mutationMethod = propertyInfo.mutationMethod;
                            if (mutationMethod) {
                                mutationMethod(node, undefined);
                            } else if (propertyInfo.mustUseProperty) {
                                var propName = propertyInfo.propertyName;
                                if (propertyInfo.hasBooleanValue) {
                                    node[propName] = false;
                                } else {
                                    node[propName] = "";
                                }
                            } else {
                                node.removeAttribute(
                                    propertyInfo.attributeName
                                );
                            }
                        } else if (DOMProperty.isCustomAttribute(name)) {
                            node.removeAttribute(name);
                        }

                        if (false) {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID:
                                    ReactDOMComponentTree.getInstanceFromNode(
                                        node
                                    )._debugID,
                                type: "remove attribute",
                                payload: name,
                            });
                        }
                    },
                };

                module.exports = DOMPropertyOperations;

                /***/
            },
            /* 444 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var escapeTextContentForBrowser = __webpack_require__(426);

                /**
                 * Escapes attribute value to prevent scripting attacks.
                 *
                 * @param {*} value Value to escape.
                 * @return {string} An escaped string.
                 */
                function quoteAttributeValueForBrowser(value) {
                    return '"' + escapeTextContentForBrowser(value) + '"';
                }

                module.exports = quoteAttributeValueForBrowser;

                /***/
            },
            /* 445 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var EventPluginRegistry = __webpack_require__(388);
                var ReactEventEmitterMixin = __webpack_require__(446);
                var ViewportMetrics = __webpack_require__(416);

                var getVendorPrefixedEventName = __webpack_require__(447);
                var isEventSupported = __webpack_require__(410);

                /**
                 * Summary of `ReactBrowserEventEmitter` event handling:
                 *
                 *  - Top-level delegation is used to trap most native browser events. This
                 *    may only occur in the main thread and is the responsibility of
                 *    ReactEventListener, which is injected and can therefore support pluggable
                 *    event sources. This is the only work that occurs in the main thread.
                 *
                 *  - We normalize and de-duplicate events to account for browser quirks. This
                 *    may be done in the worker thread.
                 *
                 *  - Forward these native events (with the associated top-level type used to
                 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
                 *    to extract any synthetic events.
                 *
                 *  - The `EventPluginHub` will then process each event by annotating them with
                 *    "dispatches", a sequence of listeners and IDs that care about that event.
                 *
                 *  - The `EventPluginHub` then dispatches the events.
                 *
                 * Overview of React and the event system:
                 *
                 * +------------+    .
                 * |    DOM     |    .
                 * +------------+    .
                 *       |           .
                 *       v           .
                 * +------------+    .
                 * | ReactEvent |    .
                 * |  Listener  |    .
                 * +------------+    .                         +-----------+
                 *       |           .               +--------+|SimpleEvent|
                 *       |           .               |         |Plugin     |
                 * +-----|------+    .               v         +-----------+
                 * |     |      |    .    +--------------+                    +------------+
                 * |     +-----------.--->|EventPluginHub|                    |    Event   |
                 * |            |    .    |              |     +-----------+  | Propagators|
                 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
                 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
                 * |            |    .    |              |     +-----------+  |  utilities |
                 * |     +-----------.--->|              |                    +------------+
                 * |     |      |    .    +--------------+
                 * +-----|------+    .                ^        +-----------+
                 *       |           .                |        |Enter/Leave|
                 *       +           .                +-------+|Plugin     |
                 * +-------------+   .                         +-----------+
                 * | application |   .
                 * |-------------|   .
                 * |             |   .
                 * |             |   .
                 * +-------------+   .
                 *                   .
                 *    React Core     .  General Purpose Event Plugin System
                 */

                var hasEventPageXY;
                var alreadyListeningTo = {};
                var isMonitoringScrollValue = false;
                var reactTopListenersCounter = 0;

                // For events like 'submit' which don't consistently bubble (which we trap at a
                // lower node than `document`), binding at `document` would cause duplicate
                // events so we don't include them here
                var topEventMapping = {
                    topAbort: "abort",
                    topAnimationEnd:
                        getVendorPrefixedEventName("animationend") ||
                        "animationend",
                    topAnimationIteration:
                        getVendorPrefixedEventName("animationiteration") ||
                        "animationiteration",
                    topAnimationStart:
                        getVendorPrefixedEventName("animationstart") ||
                        "animationstart",
                    topBlur: "blur",
                    topCanPlay: "canplay",
                    topCanPlayThrough: "canplaythrough",
                    topChange: "change",
                    topClick: "click",
                    topCompositionEnd: "compositionend",
                    topCompositionStart: "compositionstart",
                    topCompositionUpdate: "compositionupdate",
                    topContextMenu: "contextmenu",
                    topCopy: "copy",
                    topCut: "cut",
                    topDoubleClick: "dblclick",
                    topDrag: "drag",
                    topDragEnd: "dragend",
                    topDragEnter: "dragenter",
                    topDragExit: "dragexit",
                    topDragLeave: "dragleave",
                    topDragOver: "dragover",
                    topDragStart: "dragstart",
                    topDrop: "drop",
                    topDurationChange: "durationchange",
                    topEmptied: "emptied",
                    topEncrypted: "encrypted",
                    topEnded: "ended",
                    topError: "error",
                    topFocus: "focus",
                    topInput: "input",
                    topKeyDown: "keydown",
                    topKeyPress: "keypress",
                    topKeyUp: "keyup",
                    topLoadedData: "loadeddata",
                    topLoadedMetadata: "loadedmetadata",
                    topLoadStart: "loadstart",
                    topMouseDown: "mousedown",
                    topMouseMove: "mousemove",
                    topMouseOut: "mouseout",
                    topMouseOver: "mouseover",
                    topMouseUp: "mouseup",
                    topPaste: "paste",
                    topPause: "pause",
                    topPlay: "play",
                    topPlaying: "playing",
                    topProgress: "progress",
                    topRateChange: "ratechange",
                    topScroll: "scroll",
                    topSeeked: "seeked",
                    topSeeking: "seeking",
                    topSelectionChange: "selectionchange",
                    topStalled: "stalled",
                    topSuspend: "suspend",
                    topTextInput: "textInput",
                    topTimeUpdate: "timeupdate",
                    topTouchCancel: "touchcancel",
                    topTouchEnd: "touchend",
                    topTouchMove: "touchmove",
                    topTouchStart: "touchstart",
                    topTransitionEnd:
                        getVendorPrefixedEventName("transitionend") ||
                        "transitionend",
                    topVolumeChange: "volumechange",
                    topWaiting: "waiting",
                    topWheel: "wheel",
                };

                /**
                 * To ensure no conflicts with other potential React instances on the page
                 */
                var topListenersIDKey =
                    "_reactListenersID" + String(Math.random()).slice(2);

                function getListeningForDocument(mountAt) {
                    // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
                    // directly.
                    if (
                        !Object.prototype.hasOwnProperty.call(
                            mountAt,
                            topListenersIDKey
                        )
                    ) {
                        mountAt[topListenersIDKey] = reactTopListenersCounter++;
                        alreadyListeningTo[mountAt[topListenersIDKey]] = {};
                    }
                    return alreadyListeningTo[mountAt[topListenersIDKey]];
                }

                /**
                 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
                 * example:
                 *
                 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
                 *
                 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
                 *
                 * @internal
                 */
                var ReactBrowserEventEmitter = _assign(
                    {},
                    ReactEventEmitterMixin,
                    {
                        /**
                         * Injectable event backend
                         */
                        ReactEventListener: null,

                        injection: {
                            /**
                             * @param {object} ReactEventListener
                             */
                            injectReactEventListener: function (
                                ReactEventListener
                            ) {
                                ReactEventListener.setHandleTopLevel(
                                    ReactBrowserEventEmitter.handleTopLevel
                                );
                                ReactBrowserEventEmitter.ReactEventListener =
                                    ReactEventListener;
                            },
                        },

                        /**
                         * Sets whether or not any created callbacks should be enabled.
                         *
                         * @param {boolean} enabled True if callbacks should be enabled.
                         */
                        setEnabled: function (enabled) {
                            if (ReactBrowserEventEmitter.ReactEventListener) {
                                ReactBrowserEventEmitter.ReactEventListener.setEnabled(
                                    enabled
                                );
                            }
                        },

                        /**
                         * @return {boolean} True if callbacks are enabled.
                         */
                        isEnabled: function () {
                            return !!(
                                ReactBrowserEventEmitter.ReactEventListener &&
                                ReactBrowserEventEmitter.ReactEventListener.isEnabled()
                            );
                        },

                        /**
                         * We listen for bubbled touch events on the document object.
                         *
                         * Firefox v8.01 (and possibly others) exhibited strange behavior when
                         * mounting `onmousemove` events at some node that was not the document
                         * element. The symptoms were that if your mouse is not moving over something
                         * contained within that mount point (for example on the background) the
                         * top-level listeners for `onmousemove` won't be called. However, if you
                         * register the `mousemove` on the document object, then it will of course
                         * catch all `mousemove`s. This along with iOS quirks, justifies restricting
                         * top-level listeners to the document object only, at least for these
                         * movement types of events and possibly all events.
                         *
                         * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
                         *
                         * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
                         * they bubble to document.
                         *
                         * @param {string} registrationName Name of listener (e.g. `onClick`).
                         * @param {object} contentDocumentHandle Document which owns the container
                         */
                        listenTo: function (
                            registrationName,
                            contentDocumentHandle
                        ) {
                            var mountAt = contentDocumentHandle;
                            var isListening = getListeningForDocument(mountAt);
                            var dependencies =
                                EventPluginRegistry
                                    .registrationNameDependencies[
                                    registrationName
                                ];

                            for (var i = 0; i < dependencies.length; i++) {
                                var dependency = dependencies[i];
                                if (
                                    !(
                                        isListening.hasOwnProperty(
                                            dependency
                                        ) && isListening[dependency]
                                    )
                                ) {
                                    if (dependency === "topWheel") {
                                        if (isEventSupported("wheel")) {
                                            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                                "topWheel",
                                                "wheel",
                                                mountAt
                                            );
                                        } else if (
                                            isEventSupported("mousewheel")
                                        ) {
                                            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                                "topWheel",
                                                "mousewheel",
                                                mountAt
                                            );
                                        } else {
                                            // Firefox needs to capture a different mouse scroll event.
                                            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
                                            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                                "topWheel",
                                                "DOMMouseScroll",
                                                mountAt
                                            );
                                        }
                                    } else if (dependency === "topScroll") {
                                        if (isEventSupported("scroll", true)) {
                                            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
                                                "topScroll",
                                                "scroll",
                                                mountAt
                                            );
                                        } else {
                                            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                                "topScroll",
                                                "scroll",
                                                ReactBrowserEventEmitter
                                                    .ReactEventListener
                                                    .WINDOW_HANDLE
                                            );
                                        }
                                    } else if (
                                        dependency === "topFocus" ||
                                        dependency === "topBlur"
                                    ) {
                                        if (isEventSupported("focus", true)) {
                                            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
                                                "topFocus",
                                                "focus",
                                                mountAt
                                            );
                                            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
                                                "topBlur",
                                                "blur",
                                                mountAt
                                            );
                                        } else if (
                                            isEventSupported("focusin")
                                        ) {
                                            // IE has `focusin` and `focusout` events which bubble.
                                            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
                                            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                                "topFocus",
                                                "focusin",
                                                mountAt
                                            );
                                            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                                "topBlur",
                                                "focusout",
                                                mountAt
                                            );
                                        }

                                        // to make sure blur and focus event listeners are only attached once
                                        isListening.topBlur = true;
                                        isListening.topFocus = true;
                                    } else if (
                                        topEventMapping.hasOwnProperty(
                                            dependency
                                        )
                                    ) {
                                        ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                            dependency,
                                            topEventMapping[dependency],
                                            mountAt
                                        );
                                    }

                                    isListening[dependency] = true;
                                }
                            }
                        },

                        trapBubbledEvent: function (
                            topLevelType,
                            handlerBaseName,
                            handle
                        ) {
                            return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
                                topLevelType,
                                handlerBaseName,
                                handle
                            );
                        },

                        trapCapturedEvent: function (
                            topLevelType,
                            handlerBaseName,
                            handle
                        ) {
                            return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
                                topLevelType,
                                handlerBaseName,
                                handle
                            );
                        },

                        /**
                         * Protect against document.createEvent() returning null
                         * Some popup blocker extensions appear to do this:
                         * https://github.com/facebook/react/issues/6887
                         */
                        supportsEventPageXY: function () {
                            if (!document.createEvent) {
                                return false;
                            }
                            var ev = document.createEvent("MouseEvent");
                            return ev != null && "pageX" in ev;
                        },

                        /**
                         * Listens to window scroll and resize events. We cache scroll values so that
                         * application code can access them without triggering reflows.
                         *
                         * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
                         * pageX/pageY isn't supported (legacy browsers).
                         *
                         * NOTE: Scroll events do not bubble.
                         *
                         * @see http://www.quirksmode.org/dom/events/scroll.html
                         */
                        ensureScrollValueMonitoring: function () {
                            if (hasEventPageXY === undefined) {
                                hasEventPageXY =
                                    ReactBrowserEventEmitter.supportsEventPageXY();
                            }
                            if (!hasEventPageXY && !isMonitoringScrollValue) {
                                var refresh =
                                    ViewportMetrics.refreshScrollValues;
                                ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(
                                    refresh
                                );
                                isMonitoringScrollValue = true;
                            }
                        },
                    }
                );

                module.exports = ReactBrowserEventEmitter;

                /***/
            },
            /* 446 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var EventPluginHub = __webpack_require__(387);

                function runEventQueueInBatch(events) {
                    EventPluginHub.enqueueEvents(events);
                    EventPluginHub.processEventQueue(false);
                }

                var ReactEventEmitterMixin = {
                    /**
                     * Streams a fired top-level event to `EventPluginHub` where plugins have the
                     * opportunity to create `ReactEvent`s to be dispatched.
                     */
                    handleTopLevel: function (
                        topLevelType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    ) {
                        var events = EventPluginHub.extractEvents(
                            topLevelType,
                            targetInst,
                            nativeEvent,
                            nativeEventTarget
                        );
                        runEventQueueInBatch(events);
                    },
                };

                module.exports = ReactEventEmitterMixin;

                /***/
            },
            /* 447 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ExecutionEnvironment = __webpack_require__(393);

                /**
                 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
                 *
                 * @param {string} styleProp
                 * @param {string} eventName
                 * @returns {object}
                 */
                function makePrefixMap(styleProp, eventName) {
                    var prefixes = {};

                    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
                    prefixes["Webkit" + styleProp] = "webkit" + eventName;
                    prefixes["Moz" + styleProp] = "moz" + eventName;
                    prefixes["ms" + styleProp] = "MS" + eventName;
                    prefixes["O" + styleProp] = "o" + eventName.toLowerCase();

                    return prefixes;
                }

                /**
                 * A list of event names to a configurable list of vendor prefixes.
                 */
                var vendorPrefixes = {
                    animationend: makePrefixMap("Animation", "AnimationEnd"),
                    animationiteration: makePrefixMap(
                        "Animation",
                        "AnimationIteration"
                    ),
                    animationstart: makePrefixMap(
                        "Animation",
                        "AnimationStart"
                    ),
                    transitionend: makePrefixMap("Transition", "TransitionEnd"),
                };

                /**
                 * Event names that have already been detected and prefixed (if applicable).
                 */
                var prefixedEventNames = {};

                /**
                 * Element to check for prefixes on.
                 */
                var style = {};

                /**
                 * Bootstrap if a DOM exists.
                 */
                if (ExecutionEnvironment.canUseDOM) {
                    style = document.createElement("div").style;

                    // On some platforms, in particular some releases of Android 4.x,
                    // the un-prefixed "animation" and "transition" properties are defined on the
                    // style object but the events that fire will still be prefixed, so we need
                    // to check if the un-prefixed events are usable, and if not remove them from the map.
                    if (!("AnimationEvent" in window)) {
                        delete vendorPrefixes.animationend.animation;
                        delete vendorPrefixes.animationiteration.animation;
                        delete vendorPrefixes.animationstart.animation;
                    }

                    // Same as above
                    if (!("TransitionEvent" in window)) {
                        delete vendorPrefixes.transitionend.transition;
                    }
                }

                /**
                 * Attempts to determine the correct vendor prefixed event name.
                 *
                 * @param {string} eventName
                 * @returns {string}
                 */
                function getVendorPrefixedEventName(eventName) {
                    if (prefixedEventNames[eventName]) {
                        return prefixedEventNames[eventName];
                    } else if (!vendorPrefixes[eventName]) {
                        return eventName;
                    }

                    var prefixMap = vendorPrefixes[eventName];

                    for (var styleProp in prefixMap) {
                        if (
                            prefixMap.hasOwnProperty(styleProp) &&
                            styleProp in style
                        ) {
                            return (prefixedEventNames[eventName] =
                                prefixMap[styleProp]);
                        }
                    }

                    return "";
                }

                module.exports = getVendorPrefixedEventName;

                /***/
            },
            /* 448 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380),
                    _assign = __webpack_require__(351);

                var DOMPropertyOperations = __webpack_require__(443);
                var LinkedValueUtils = __webpack_require__(449);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactUpdates = __webpack_require__(401);

                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                var didWarnValueLink = false;
                var didWarnCheckedLink = false;
                var didWarnValueDefaultValue = false;
                var didWarnCheckedDefaultChecked = false;
                var didWarnControlledToUncontrolled = false;
                var didWarnUncontrolledToControlled = false;

                function forceUpdateIfMounted() {
                    if (this._rootNodeID) {
                        // DOM component is still mounted; update
                        ReactDOMInput.updateWrapper(this);
                    }
                }

                function isControlled(props) {
                    var usesChecked =
                        props.type === "checkbox" || props.type === "radio";
                    return usesChecked
                        ? props.checked != null
                        : props.value != null;
                }

                /**
                 * Implements an <input> host component that allows setting these optional
                 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
                 *
                 * If `checked` or `value` are not supplied (or null/undefined), user actions
                 * that affect the checked state or value will trigger updates to the element.
                 *
                 * If they are supplied (and not null/undefined), the rendered element will not
                 * trigger updates to the element. Instead, the props must change in order for
                 * the rendered element to be updated.
                 *
                 * The rendered element will be initialized as unchecked (or `defaultChecked`)
                 * with an empty value (or `defaultValue`).
                 *
                 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
                 */
                var ReactDOMInput = {
                    getHostProps: function (inst, props) {
                        var value = LinkedValueUtils.getValue(props);
                        var checked = LinkedValueUtils.getChecked(props);

                        var hostProps = _assign(
                            {
                                // Make sure we set .type before any other properties (setting .value
                                // before .type means .value is lost in IE11 and below)
                                type: undefined,
                                // Make sure we set .step before .value (setting .value before .step
                                // means .value is rounded on mount, based upon step precision)
                                step: undefined,
                                // Make sure we set .min & .max before .value (to ensure proper order
                                // in corner cases such as min or max deriving from value, e.g. Issue #7170)
                                min: undefined,
                                max: undefined,
                            },
                            props,
                            {
                                defaultChecked: undefined,
                                defaultValue: undefined,
                                value:
                                    value != null
                                        ? value
                                        : inst._wrapperState.initialValue,
                                checked:
                                    checked != null
                                        ? checked
                                        : inst._wrapperState.initialChecked,
                                onChange: inst._wrapperState.onChange,
                            }
                        );

                        return hostProps;
                    },

                    mountWrapper: function (inst, props) {
                        if (false) {
                            LinkedValueUtils.checkPropTypes(
                                "input",
                                props,
                                inst._currentElement._owner
                            );

                            var owner = inst._currentElement._owner;

                            if (
                                props.valueLink !== undefined &&
                                !didWarnValueLink
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead."
                                      )
                                    : void 0;
                                didWarnValueLink = true;
                            }
                            if (
                                props.checkedLink !== undefined &&
                                !didWarnCheckedLink
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead."
                                      )
                                    : void 0;
                                didWarnCheckedLink = true;
                            }
                            if (
                                props.checked !== undefined &&
                                props.defaultChecked !== undefined &&
                                !didWarnCheckedDefaultChecked
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "%s contains an input of type %s with both checked and defaultChecked props. " +
                                              "Input elements must be either controlled or uncontrolled " +
                                              "(specify either the checked prop, or the defaultChecked prop, but not " +
                                              "both). Decide between using a controlled or uncontrolled input " +
                                              "element and remove one of these props. More info: " +
                                              "https://fb.me/react-controlled-components",
                                          (owner && owner.getName()) ||
                                              "A component",
                                          props.type
                                      )
                                    : void 0;
                                didWarnCheckedDefaultChecked = true;
                            }
                            if (
                                props.value !== undefined &&
                                props.defaultValue !== undefined &&
                                !didWarnValueDefaultValue
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "%s contains an input of type %s with both value and defaultValue props. " +
                                              "Input elements must be either controlled or uncontrolled " +
                                              "(specify either the value prop, or the defaultValue prop, but not " +
                                              "both). Decide between using a controlled or uncontrolled input " +
                                              "element and remove one of these props. More info: " +
                                              "https://fb.me/react-controlled-components",
                                          (owner && owner.getName()) ||
                                              "A component",
                                          props.type
                                      )
                                    : void 0;
                                didWarnValueDefaultValue = true;
                            }
                        }

                        var defaultValue = props.defaultValue;
                        inst._wrapperState = {
                            initialChecked:
                                props.checked != null
                                    ? props.checked
                                    : props.defaultChecked,
                            initialValue:
                                props.value != null
                                    ? props.value
                                    : defaultValue,
                            listeners: null,
                            onChange: _handleChange.bind(inst),
                        };

                        if (false) {
                            inst._wrapperState.controlled = isControlled(props);
                        }
                    },

                    updateWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        if (false) {
                            var controlled = isControlled(props);
                            var owner = inst._currentElement._owner;

                            if (
                                !inst._wrapperState.controlled &&
                                controlled &&
                                !didWarnUncontrolledToControlled
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "%s is changing an uncontrolled input of type %s to be controlled. " +
                                              "Input elements should not switch from uncontrolled to controlled (or vice versa). " +
                                              "Decide between using a controlled or uncontrolled input " +
                                              "element for the lifetime of the component. More info: https://fb.me/react-controlled-components",
                                          (owner && owner.getName()) ||
                                              "A component",
                                          props.type
                                      )
                                    : void 0;
                                didWarnUncontrolledToControlled = true;
                            }
                            if (
                                inst._wrapperState.controlled &&
                                !controlled &&
                                !didWarnControlledToUncontrolled
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "%s is changing a controlled input of type %s to be uncontrolled. " +
                                              "Input elements should not switch from controlled to uncontrolled (or vice versa). " +
                                              "Decide between using a controlled or uncontrolled input " +
                                              "element for the lifetime of the component. More info: https://fb.me/react-controlled-components",
                                          (owner && owner.getName()) ||
                                              "A component",
                                          props.type
                                      )
                                    : void 0;
                                didWarnControlledToUncontrolled = true;
                            }
                        }

                        // TODO: Shouldn't this be getChecked(props)?
                        var checked = props.checked;
                        if (checked != null) {
                            DOMPropertyOperations.setValueForProperty(
                                ReactDOMComponentTree.getNodeFromInstance(inst),
                                "checked",
                                checked || false
                            );
                        }

                        var node =
                            ReactDOMComponentTree.getNodeFromInstance(inst);
                        var value = LinkedValueUtils.getValue(props);
                        if (value != null) {
                            // Cast `value` to a string to ensure the value is set correctly. While
                            // browsers typically do this as necessary, jsdom doesn't.
                            var newValue = "" + value;

                            // To avoid side effects (such as losing text selection), only set value if changed
                            if (newValue !== node.value) {
                                node.value = newValue;
                            }
                        } else {
                            if (
                                props.value == null &&
                                props.defaultValue != null
                            ) {
                                // In Chrome, assigning defaultValue to certain input types triggers input validation.
                                // For number inputs, the display value loses trailing decimal points. For email inputs,
                                // Chrome raises "The specified value <x> is not a valid email address".
                                //
                                // Here we check to see if the defaultValue has actually changed, avoiding these problems
                                // when the user is inputting text
                                //
                                // https://github.com/facebook/react/issues/7253
                                if (
                                    node.defaultValue !==
                                    "" + props.defaultValue
                                ) {
                                    node.defaultValue = "" + props.defaultValue;
                                }
                            }
                            if (
                                props.checked == null &&
                                props.defaultChecked != null
                            ) {
                                node.defaultChecked = !!props.defaultChecked;
                            }
                        }
                    },

                    postMountWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        // This is in postMount because we need access to the DOM node, which is not
                        // available until after the component has mounted.
                        var node =
                            ReactDOMComponentTree.getNodeFromInstance(inst);

                        // Detach value from defaultValue. We won't do anything if we're working on
                        // submit or reset inputs as those values & defaultValues are linked. They
                        // are not resetable nodes so this operation doesn't matter and actually
                        // removes browser-default values (eg "Submit Query") when no value is
                        // provided.

                        switch (props.type) {
                            case "submit":
                            case "reset":
                                break;
                            case "color":
                            case "date":
                            case "datetime":
                            case "datetime-local":
                            case "month":
                            case "time":
                            case "week":
                                // This fixes the no-show issue on iOS Safari and Android Chrome:
                                // https://github.com/facebook/react/issues/7233
                                node.value = "";
                                node.value = node.defaultValue;
                                break;
                            default:
                                node.value = node.value;
                                break;
                        }

                        // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
                        // this is needed to work around a chrome bug where setting defaultChecked
                        // will sometimes influence the value of checked (even after detachment).
                        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
                        // We need to temporarily unset name to avoid disrupting radio button groups.
                        var name = node.name;
                        if (name !== "") {
                            node.name = "";
                        }
                        node.defaultChecked = !node.defaultChecked;
                        node.defaultChecked = !node.defaultChecked;
                        if (name !== "") {
                            node.name = name;
                        }
                    },
                };

                function _handleChange(event) {
                    var props = this._currentElement.props;

                    var returnValue = LinkedValueUtils.executeOnChange(
                        props,
                        event
                    );

                    // Here we use asap to wait until all updates have propagated, which
                    // is important when using controlled components within layers:
                    // https://github.com/facebook/react/issues/1698
                    ReactUpdates.asap(forceUpdateIfMounted, this);

                    var name = props.name;
                    if (props.type === "radio" && name != null) {
                        var rootNode =
                            ReactDOMComponentTree.getNodeFromInstance(this);
                        var queryRoot = rootNode;

                        while (queryRoot.parentNode) {
                            queryRoot = queryRoot.parentNode;
                        }

                        // If `rootNode.form` was non-null, then we could try `form.elements`,
                        // but that sometimes behaves strangely in IE8. We could also try using
                        // `form.getElementsByName`, but that will only return direct children
                        // and won't include inputs that use the HTML5 `form=` attribute. Since
                        // the input might not even be in a form, let's just use the global
                        // `querySelectorAll` to ensure we don't miss anything.
                        var group = queryRoot.querySelectorAll(
                            "input[name=" +
                                JSON.stringify("" + name) +
                                '][type="radio"]'
                        );

                        for (var i = 0; i < group.length; i++) {
                            var otherNode = group[i];
                            if (
                                otherNode === rootNode ||
                                otherNode.form !== rootNode.form
                            ) {
                                continue;
                            }
                            // This will throw if radio buttons rendered by different copies of React
                            // and the same name are rendered into the same form (same as #1939).
                            // That's probably okay; we don't support it just as we don't support
                            // mixing React radio buttons with non-React ones.
                            var otherInstance =
                                ReactDOMComponentTree.getInstanceFromNode(
                                    otherNode
                                );
                            !otherInstance
                                ? false
                                    ? invariant(
                                          false,
                                          "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                                      )
                                    : _prodInvariant("90")
                                : void 0;
                            // If this is a controlled radio button group, forcing the input that
                            // was previously checked to update will cause it to be come re-checked
                            // as appropriate.
                            ReactUpdates.asap(
                                forceUpdateIfMounted,
                                otherInstance
                            );
                        }
                    }

                    return returnValue;
                }

                module.exports = ReactDOMInput;

                /***/
            },
            /* 449 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var React = __webpack_require__(350);
                var ReactPropTypesSecret = __webpack_require__(450);

                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                var hasReadOnlyValue = {
                    button: true,
                    checkbox: true,
                    image: true,
                    hidden: true,
                    radio: true,
                    reset: true,
                    submit: true,
                };

                function _assertSingleLink(inputProps) {
                    !(
                        inputProps.checkedLink == null ||
                        inputProps.valueLink == null
                    )
                        ? false
                            ? invariant(
                                  false,
                                  "Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don't want to use valueLink and vice versa."
                              )
                            : _prodInvariant("87")
                        : void 0;
                }
                function _assertValueLink(inputProps) {
                    _assertSingleLink(inputProps);
                    !(inputProps.value == null && inputProps.onChange == null)
                        ? false
                            ? invariant(
                                  false,
                                  "Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don't want to use valueLink."
                              )
                            : _prodInvariant("88")
                        : void 0;
                }

                function _assertCheckedLink(inputProps) {
                    _assertSingleLink(inputProps);
                    !(inputProps.checked == null && inputProps.onChange == null)
                        ? false
                            ? invariant(
                                  false,
                                  "Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don't want to use checkedLink"
                              )
                            : _prodInvariant("89")
                        : void 0;
                }

                var propTypes = {
                    value: function (props, propName, componentName) {
                        if (
                            !props[propName] ||
                            hasReadOnlyValue[props.type] ||
                            props.onChange ||
                            props.readOnly ||
                            props.disabled
                        ) {
                            return null;
                        }
                        return new Error(
                            "You provided a `value` prop to a form field without an " +
                                "`onChange` handler. This will render a read-only field. If " +
                                "the field should be mutable use `defaultValue`. Otherwise, " +
                                "set either `onChange` or `readOnly`."
                        );
                    },
                    checked: function (props, propName, componentName) {
                        if (
                            !props[propName] ||
                            props.onChange ||
                            props.readOnly ||
                            props.disabled
                        ) {
                            return null;
                        }
                        return new Error(
                            "You provided a `checked` prop to a form field without an " +
                                "`onChange` handler. This will render a read-only field. If " +
                                "the field should be mutable use `defaultChecked`. Otherwise, " +
                                "set either `onChange` or `readOnly`."
                        );
                    },
                    onChange: React.PropTypes.func,
                };

                var loggedTypeFailures = {};
                function getDeclarationErrorAddendum(owner) {
                    if (owner) {
                        var name = owner.getName();
                        if (name) {
                            return (
                                " Check the render method of `" + name + "`."
                            );
                        }
                    }
                    return "";
                }

                /**
                 * Provide a linked `value` attribute for controlled forms. You should not use
                 * this outside of the ReactDOM controlled form components.
                 */
                var LinkedValueUtils = {
                    checkPropTypes: function (tagName, props, owner) {
                        for (var propName in propTypes) {
                            if (propTypes.hasOwnProperty(propName)) {
                                var error = propTypes[propName](
                                    props,
                                    propName,
                                    tagName,
                                    "prop",
                                    null,
                                    ReactPropTypesSecret
                                );
                            }
                            if (
                                error instanceof Error &&
                                !(error.message in loggedTypeFailures)
                            ) {
                                // Only monitor this failure once because there tends to be a lot of the
                                // same error.
                                loggedTypeFailures[error.message] = true;

                                var addendum =
                                    getDeclarationErrorAddendum(owner);
                                false
                                    ? warning(
                                          false,
                                          "Failed form propType: %s%s",
                                          error.message,
                                          addendum
                                      )
                                    : void 0;
                            }
                        }
                    },

                    /**
                     * @param {object} inputProps Props for form component
                     * @return {*} current value of the input either from value prop or link.
                     */
                    getValue: function (inputProps) {
                        if (inputProps.valueLink) {
                            _assertValueLink(inputProps);
                            return inputProps.valueLink.value;
                        }
                        return inputProps.value;
                    },

                    /**
                     * @param {object} inputProps Props for form component
                     * @return {*} current checked status of the input either from checked prop
                     *             or link.
                     */
                    getChecked: function (inputProps) {
                        if (inputProps.checkedLink) {
                            _assertCheckedLink(inputProps);
                            return inputProps.checkedLink.value;
                        }
                        return inputProps.checked;
                    },

                    /**
                     * @param {object} inputProps Props for form component
                     * @param {SyntheticEvent} event change event to handle
                     */
                    executeOnChange: function (inputProps, event) {
                        if (inputProps.valueLink) {
                            _assertValueLink(inputProps);
                            return inputProps.valueLink.requestChange(
                                event.target.value
                            );
                        } else if (inputProps.checkedLink) {
                            _assertCheckedLink(inputProps);
                            return inputProps.checkedLink.requestChange(
                                event.target.checked
                            );
                        } else if (inputProps.onChange) {
                            return inputProps.onChange.call(undefined, event);
                        }
                    },
                };

                module.exports = LinkedValueUtils;

                /***/
            },
            /* 450 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var ReactPropTypesSecret =
                    "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";

                module.exports = ReactPropTypesSecret;

                /***/
            },
            /* 451 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var React = __webpack_require__(350);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactDOMSelect = __webpack_require__(452);

                var warning = __webpack_require__(358);
                var didWarnInvalidOptionChildren = false;

                function flattenChildren(children) {
                    var content = "";

                    // Flatten children and warn if they aren't strings or numbers;
                    // invalid types are ignored.
                    React.Children.forEach(children, function (child) {
                        if (child == null) {
                            return;
                        }
                        if (
                            typeof child === "string" ||
                            typeof child === "number"
                        ) {
                            content += child;
                        } else if (!didWarnInvalidOptionChildren) {
                            didWarnInvalidOptionChildren = true;
                            false
                                ? warning(
                                      false,
                                      "Only strings and numbers are supported as <option> children."
                                  )
                                : void 0;
                        }
                    });

                    return content;
                }

                /**
                 * Implements an <option> host component that warns when `selected` is set.
                 */
                var ReactDOMOption = {
                    mountWrapper: function (inst, props, hostParent) {
                        // TODO (yungsters): Remove support for `selected` in <option>.
                        if (false) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      props.selected == null,
                                      "Use the `defaultValue` or `value` props on <select> instead of " +
                                          "setting `selected` on <option>."
                                  )
                                : void 0;
                        }

                        // Look up whether this option is 'selected'
                        var selectValue = null;
                        if (hostParent != null) {
                            var selectParent = hostParent;

                            if (selectParent._tag === "optgroup") {
                                selectParent = selectParent._hostParent;
                            }

                            if (
                                selectParent != null &&
                                selectParent._tag === "select"
                            ) {
                                selectValue =
                                    ReactDOMSelect.getSelectValueContext(
                                        selectParent
                                    );
                            }
                        }

                        // If the value is null (e.g., no specified value or after initial mount)
                        // or missing (e.g., for <datalist>), we don't change props.selected
                        var selected = null;
                        if (selectValue != null) {
                            var value;
                            if (props.value != null) {
                                value = props.value + "";
                            } else {
                                value = flattenChildren(props.children);
                            }
                            selected = false;
                            if (Array.isArray(selectValue)) {
                                // multiple
                                for (var i = 0; i < selectValue.length; i++) {
                                    if ("" + selectValue[i] === value) {
                                        selected = true;
                                        break;
                                    }
                                }
                            } else {
                                selected = "" + selectValue === value;
                            }
                        }

                        inst._wrapperState = { selected: selected };
                    },

                    postMountWrapper: function (inst) {
                        // value="" should make a value attribute (#6219)
                        var props = inst._currentElement.props;
                        if (props.value != null) {
                            var node =
                                ReactDOMComponentTree.getNodeFromInstance(inst);
                            node.setAttribute("value", props.value);
                        }
                    },

                    getHostProps: function (inst, props) {
                        var hostProps = _assign(
                            { selected: undefined, children: undefined },
                            props
                        );

                        // Read state only from initial mount because <select> updates value
                        // manually; we need the initial state only for server rendering
                        if (inst._wrapperState.selected != null) {
                            hostProps.selected = inst._wrapperState.selected;
                        }

                        var content = flattenChildren(props.children);

                        if (content) {
                            hostProps.children = content;
                        }

                        return hostProps;
                    },
                };

                module.exports = ReactDOMOption;

                /***/
            },
            /* 452 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var LinkedValueUtils = __webpack_require__(449);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactUpdates = __webpack_require__(401);

                var warning = __webpack_require__(358);

                var didWarnValueLink = false;
                var didWarnValueDefaultValue = false;

                function updateOptionsIfPendingUpdateAndMounted() {
                    if (this._rootNodeID && this._wrapperState.pendingUpdate) {
                        this._wrapperState.pendingUpdate = false;

                        var props = this._currentElement.props;
                        var value = LinkedValueUtils.getValue(props);

                        if (value != null) {
                            updateOptions(this, Boolean(props.multiple), value);
                        }
                    }
                }

                function getDeclarationErrorAddendum(owner) {
                    if (owner) {
                        var name = owner.getName();
                        if (name) {
                            return (
                                " Check the render method of `" + name + "`."
                            );
                        }
                    }
                    return "";
                }

                var valuePropNames = ["value", "defaultValue"];

                /**
                 * Validation function for `value` and `defaultValue`.
                 * @private
                 */
                function checkSelectPropTypes(inst, props) {
                    var owner = inst._currentElement._owner;
                    LinkedValueUtils.checkPropTypes("select", props, owner);

                    if (props.valueLink !== undefined && !didWarnValueLink) {
                        false
                            ? warning(
                                  false,
                                  "`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead."
                              )
                            : void 0;
                        didWarnValueLink = true;
                    }

                    for (var i = 0; i < valuePropNames.length; i++) {
                        var propName = valuePropNames[i];
                        if (props[propName] == null) {
                            continue;
                        }
                        var isArray = Array.isArray(props[propName]);
                        if (props.multiple && !isArray) {
                            false
                                ? warning(
                                      false,
                                      "The `%s` prop supplied to <select> must be an array if " +
                                          "`multiple` is true.%s",
                                      propName,
                                      getDeclarationErrorAddendum(owner)
                                  )
                                : void 0;
                        } else if (!props.multiple && isArray) {
                            false
                                ? warning(
                                      false,
                                      "The `%s` prop supplied to <select> must be a scalar " +
                                          "value if `multiple` is false.%s",
                                      propName,
                                      getDeclarationErrorAddendum(owner)
                                  )
                                : void 0;
                        }
                    }
                }

                /**
                 * @param {ReactDOMComponent} inst
                 * @param {boolean} multiple
                 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
                 * @private
                 */
                function updateOptions(inst, multiple, propValue) {
                    var selectedValue, i;
                    var options =
                        ReactDOMComponentTree.getNodeFromInstance(inst).options;

                    if (multiple) {
                        selectedValue = {};
                        for (i = 0; i < propValue.length; i++) {
                            selectedValue["" + propValue[i]] = true;
                        }
                        for (i = 0; i < options.length; i++) {
                            var selected = selectedValue.hasOwnProperty(
                                options[i].value
                            );
                            if (options[i].selected !== selected) {
                                options[i].selected = selected;
                            }
                        }
                    } else {
                        // Do not set `select.value` as exact behavior isn't consistent across all
                        // browsers for all cases.
                        selectedValue = "" + propValue;
                        for (i = 0; i < options.length; i++) {
                            if (options[i].value === selectedValue) {
                                options[i].selected = true;
                                return;
                            }
                        }
                        if (options.length) {
                            options[0].selected = true;
                        }
                    }
                }

                /**
                 * Implements a <select> host component that allows optionally setting the
                 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
                 * stringable. If `multiple` is true, the prop must be an array of stringables.
                 *
                 * If `value` is not supplied (or null/undefined), user actions that change the
                 * selected option will trigger updates to the rendered options.
                 *
                 * If it is supplied (and not null/undefined), the rendered options will not
                 * update in response to user actions. Instead, the `value` prop must change in
                 * order for the rendered options to update.
                 *
                 * If `defaultValue` is provided, any options with the supplied values will be
                 * selected.
                 */
                var ReactDOMSelect = {
                    getHostProps: function (inst, props) {
                        return _assign({}, props, {
                            onChange: inst._wrapperState.onChange,
                            value: undefined,
                        });
                    },

                    mountWrapper: function (inst, props) {
                        if (false) {
                            checkSelectPropTypes(inst, props);
                        }

                        var value = LinkedValueUtils.getValue(props);
                        inst._wrapperState = {
                            pendingUpdate: false,
                            initialValue:
                                value != null ? value : props.defaultValue,
                            listeners: null,
                            onChange: _handleChange.bind(inst),
                            wasMultiple: Boolean(props.multiple),
                        };

                        if (
                            props.value !== undefined &&
                            props.defaultValue !== undefined &&
                            !didWarnValueDefaultValue
                        ) {
                            false
                                ? warning(
                                      false,
                                      "Select elements must be either controlled or uncontrolled " +
                                          "(specify either the value prop, or the defaultValue prop, but not " +
                                          "both). Decide between using a controlled or uncontrolled select " +
                                          "element and remove one of these props. More info: " +
                                          "https://fb.me/react-controlled-components"
                                  )
                                : void 0;
                            didWarnValueDefaultValue = true;
                        }
                    },

                    getSelectValueContext: function (inst) {
                        // ReactDOMOption looks at this initial value so the initial generated
                        // markup has correct `selected` attributes
                        return inst._wrapperState.initialValue;
                    },

                    postUpdateWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        // After the initial mount, we control selected-ness manually so don't pass
                        // this value down
                        inst._wrapperState.initialValue = undefined;

                        var wasMultiple = inst._wrapperState.wasMultiple;
                        inst._wrapperState.wasMultiple = Boolean(
                            props.multiple
                        );

                        var value = LinkedValueUtils.getValue(props);
                        if (value != null) {
                            inst._wrapperState.pendingUpdate = false;
                            updateOptions(inst, Boolean(props.multiple), value);
                        } else if (wasMultiple !== Boolean(props.multiple)) {
                            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
                            if (props.defaultValue != null) {
                                updateOptions(
                                    inst,
                                    Boolean(props.multiple),
                                    props.defaultValue
                                );
                            } else {
                                // Revert the select back to its default unselected state.
                                updateOptions(
                                    inst,
                                    Boolean(props.multiple),
                                    props.multiple ? [] : ""
                                );
                            }
                        }
                    },
                };

                function _handleChange(event) {
                    var props = this._currentElement.props;
                    var returnValue = LinkedValueUtils.executeOnChange(
                        props,
                        event
                    );

                    if (this._rootNodeID) {
                        this._wrapperState.pendingUpdate = true;
                    }
                    ReactUpdates.asap(
                        updateOptionsIfPendingUpdateAndMounted,
                        this
                    );
                    return returnValue;
                }

                module.exports = ReactDOMSelect;

                /***/
            },
            /* 453 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380),
                    _assign = __webpack_require__(351);

                var LinkedValueUtils = __webpack_require__(449);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactUpdates = __webpack_require__(401);

                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                var didWarnValueLink = false;
                var didWarnValDefaultVal = false;

                function forceUpdateIfMounted() {
                    if (this._rootNodeID) {
                        // DOM component is still mounted; update
                        ReactDOMTextarea.updateWrapper(this);
                    }
                }

                /**
                 * Implements a <textarea> host component that allows setting `value`, and
                 * `defaultValue`. This differs from the traditional DOM API because value is
                 * usually set as PCDATA children.
                 *
                 * If `value` is not supplied (or null/undefined), user actions that affect the
                 * value will trigger updates to the element.
                 *
                 * If `value` is supplied (and not null/undefined), the rendered element will
                 * not trigger updates to the element. Instead, the `value` prop must change in
                 * order for the rendered element to be updated.
                 *
                 * The rendered element will be initialized with an empty value, the prop
                 * `defaultValue` if specified, or the children content (deprecated).
                 */
                var ReactDOMTextarea = {
                    getHostProps: function (inst, props) {
                        !(props.dangerouslySetInnerHTML == null)
                            ? false
                                ? invariant(
                                      false,
                                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                                  )
                                : _prodInvariant("91")
                            : void 0;

                        // Always set children to the same thing. In IE9, the selection range will
                        // get reset if `textContent` is mutated.  We could add a check in setTextContent
                        // to only set the value if/when the value differs from the node value (which would
                        // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
                        // The value can be a boolean or object so that's why it's forced to be a string.
                        var hostProps = _assign({}, props, {
                            value: undefined,
                            defaultValue: undefined,
                            children: "" + inst._wrapperState.initialValue,
                            onChange: inst._wrapperState.onChange,
                        });

                        return hostProps;
                    },

                    mountWrapper: function (inst, props) {
                        if (false) {
                            LinkedValueUtils.checkPropTypes(
                                "textarea",
                                props,
                                inst._currentElement._owner
                            );
                            if (
                                props.valueLink !== undefined &&
                                !didWarnValueLink
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead."
                                      )
                                    : void 0;
                                didWarnValueLink = true;
                            }
                            if (
                                props.value !== undefined &&
                                props.defaultValue !== undefined &&
                                !didWarnValDefaultVal
                            ) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "Textarea elements must be either controlled or uncontrolled " +
                                              "(specify either the value prop, or the defaultValue prop, but not " +
                                              "both). Decide between using a controlled or uncontrolled textarea " +
                                              "and remove one of these props. More info: " +
                                              "https://fb.me/react-controlled-components"
                                      )
                                    : void 0;
                                didWarnValDefaultVal = true;
                            }
                        }

                        var value = LinkedValueUtils.getValue(props);
                        var initialValue = value;

                        // Only bother fetching default value if we're going to use it
                        if (value == null) {
                            var defaultValue = props.defaultValue;
                            // TODO (yungsters): Remove support for children content in <textarea>.
                            var children = props.children;
                            if (children != null) {
                                if (false) {
                                    process.env.NODE_ENV !== "production"
                                        ? warning(
                                              false,
                                              "Use the `defaultValue` or `value` props instead of setting " +
                                                  "children on <textarea>."
                                          )
                                        : void 0;
                                }
                                !(defaultValue == null)
                                    ? false
                                        ? invariant(
                                              false,
                                              "If you supply `defaultValue` on a <textarea>, do not pass children."
                                          )
                                        : _prodInvariant("92")
                                    : void 0;
                                if (Array.isArray(children)) {
                                    !(children.length <= 1)
                                        ? false
                                            ? invariant(
                                                  false,
                                                  "<textarea> can only have at most one child."
                                              )
                                            : _prodInvariant("93")
                                        : void 0;
                                    children = children[0];
                                }

                                defaultValue = "" + children;
                            }
                            if (defaultValue == null) {
                                defaultValue = "";
                            }
                            initialValue = defaultValue;
                        }

                        inst._wrapperState = {
                            initialValue: "" + initialValue,
                            listeners: null,
                            onChange: _handleChange.bind(inst),
                        };
                    },

                    updateWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        var node =
                            ReactDOMComponentTree.getNodeFromInstance(inst);
                        var value = LinkedValueUtils.getValue(props);
                        if (value != null) {
                            // Cast `value` to a string to ensure the value is set correctly. While
                            // browsers typically do this as necessary, jsdom doesn't.
                            var newValue = "" + value;

                            // To avoid side effects (such as losing text selection), only set value if changed
                            if (newValue !== node.value) {
                                node.value = newValue;
                            }
                            if (props.defaultValue == null) {
                                node.defaultValue = newValue;
                            }
                        }
                        if (props.defaultValue != null) {
                            node.defaultValue = props.defaultValue;
                        }
                    },

                    postMountWrapper: function (inst) {
                        // This is in postMount because we need access to the DOM node, which is not
                        // available until after the component has mounted.
                        var node =
                            ReactDOMComponentTree.getNodeFromInstance(inst);
                        var textContent = node.textContent;

                        // Only set node.value if textContent is equal to the expected
                        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
                        // will populate textContent as well.
                        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
                        if (textContent === inst._wrapperState.initialValue) {
                            node.value = textContent;
                        }
                    },
                };

                function _handleChange(event) {
                    var props = this._currentElement.props;
                    var returnValue = LinkedValueUtils.executeOnChange(
                        props,
                        event
                    );
                    ReactUpdates.asap(forceUpdateIfMounted, this);
                    return returnValue;
                }

                module.exports = ReactDOMTextarea;

                /***/
            },
            /* 454 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var ReactComponentEnvironment = __webpack_require__(455);
                var ReactInstanceMap = __webpack_require__(456);
                var ReactInstrumentation = __webpack_require__(407);

                var ReactCurrentOwner = __webpack_require__(357);
                var ReactReconciler = __webpack_require__(404);
                var ReactChildReconciler = __webpack_require__(457);

                var emptyFunction = __webpack_require__(359);
                var flattenChildren = __webpack_require__(471);
                var invariant = __webpack_require__(355);

                /**
                 * Make an update for markup to be rendered and inserted at a supplied index.
                 *
                 * @param {string} markup Markup that renders into an element.
                 * @param {number} toIndex Destination index.
                 * @private
                 */
                function makeInsertMarkup(markup, afterNode, toIndex) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: "INSERT_MARKUP",
                        content: markup,
                        fromIndex: null,
                        fromNode: null,
                        toIndex: toIndex,
                        afterNode: afterNode,
                    };
                }

                /**
                 * Make an update for moving an existing element to another index.
                 *
                 * @param {number} fromIndex Source index of the existing element.
                 * @param {number} toIndex Destination index of the element.
                 * @private
                 */
                function makeMove(child, afterNode, toIndex) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: "MOVE_EXISTING",
                        content: null,
                        fromIndex: child._mountIndex,
                        fromNode: ReactReconciler.getHostNode(child),
                        toIndex: toIndex,
                        afterNode: afterNode,
                    };
                }

                /**
                 * Make an update for removing an element at an index.
                 *
                 * @param {number} fromIndex Index of the element to remove.
                 * @private
                 */
                function makeRemove(child, node) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: "REMOVE_NODE",
                        content: null,
                        fromIndex: child._mountIndex,
                        fromNode: node,
                        toIndex: null,
                        afterNode: null,
                    };
                }

                /**
                 * Make an update for setting the markup of a node.
                 *
                 * @param {string} markup Markup that renders into an element.
                 * @private
                 */
                function makeSetMarkup(markup) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: "SET_MARKUP",
                        content: markup,
                        fromIndex: null,
                        fromNode: null,
                        toIndex: null,
                        afterNode: null,
                    };
                }

                /**
                 * Make an update for setting the text content.
                 *
                 * @param {string} textContent Text content to set.
                 * @private
                 */
                function makeTextContent(textContent) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: "TEXT_CONTENT",
                        content: textContent,
                        fromIndex: null,
                        fromNode: null,
                        toIndex: null,
                        afterNode: null,
                    };
                }

                /**
                 * Push an update, if any, onto the queue. Creates a new queue if none is
                 * passed and always returns the queue. Mutative.
                 */
                function enqueue(queue, update) {
                    if (update) {
                        queue = queue || [];
                        queue.push(update);
                    }
                    return queue;
                }

                /**
                 * Processes any enqueued updates.
                 *
                 * @private
                 */
                function processQueue(inst, updateQueue) {
                    ReactComponentEnvironment.processChildrenUpdates(
                        inst,
                        updateQueue
                    );
                }

                var setChildrenForInstrumentation = emptyFunction;
                if (false) {
                    var getDebugID = function (inst) {
                        if (!inst._debugID) {
                            // Check for ART-like instances. TODO: This is silly/gross.
                            var internal;
                            if ((internal = ReactInstanceMap.get(inst))) {
                                inst = internal;
                            }
                        }
                        return inst._debugID;
                    };
                    setChildrenForInstrumentation = function (children) {
                        var debugID = getDebugID(this);
                        // TODO: React Native empty components are also multichild.
                        // This means they still get into this method but don't have _debugID.
                        if (debugID !== 0) {
                            ReactInstrumentation.debugTool.onSetChildren(
                                debugID,
                                children
                                    ? Object.keys(children).map(function (key) {
                                          return children[key]._debugID;
                                      })
                                    : []
                            );
                        }
                    };
                }

                /**
                 * ReactMultiChild are capable of reconciling multiple children.
                 *
                 * @class ReactMultiChild
                 * @internal
                 */
                var ReactMultiChild = {
                    /**
                     * Provides common functionality for components that must reconcile multiple
                     * children. This is used by `ReactDOMComponent` to mount, update, and
                     * unmount child components.
                     *
                     * @lends {ReactMultiChild.prototype}
                     */
                    Mixin: {
                        _reconcilerInstantiateChildren: function (
                            nestedChildren,
                            transaction,
                            context
                        ) {
                            if (false) {
                                var selfDebugID = getDebugID(this);
                                if (this._currentElement) {
                                    try {
                                        ReactCurrentOwner.current =
                                            this._currentElement._owner;
                                        return ReactChildReconciler.instantiateChildren(
                                            nestedChildren,
                                            transaction,
                                            context,
                                            selfDebugID
                                        );
                                    } finally {
                                        ReactCurrentOwner.current = null;
                                    }
                                }
                            }
                            return ReactChildReconciler.instantiateChildren(
                                nestedChildren,
                                transaction,
                                context
                            );
                        },

                        _reconcilerUpdateChildren: function (
                            prevChildren,
                            nextNestedChildrenElements,
                            mountImages,
                            removedNodes,
                            transaction,
                            context
                        ) {
                            var nextChildren;
                            var selfDebugID = 0;
                            if (false) {
                                selfDebugID = getDebugID(this);
                                if (this._currentElement) {
                                    try {
                                        ReactCurrentOwner.current =
                                            this._currentElement._owner;
                                        nextChildren = flattenChildren(
                                            nextNestedChildrenElements,
                                            selfDebugID
                                        );
                                    } finally {
                                        ReactCurrentOwner.current = null;
                                    }
                                    ReactChildReconciler.updateChildren(
                                        prevChildren,
                                        nextChildren,
                                        mountImages,
                                        removedNodes,
                                        transaction,
                                        this,
                                        this._hostContainerInfo,
                                        context,
                                        selfDebugID
                                    );
                                    return nextChildren;
                                }
                            }
                            nextChildren = flattenChildren(
                                nextNestedChildrenElements,
                                selfDebugID
                            );
                            ReactChildReconciler.updateChildren(
                                prevChildren,
                                nextChildren,
                                mountImages,
                                removedNodes,
                                transaction,
                                this,
                                this._hostContainerInfo,
                                context,
                                selfDebugID
                            );
                            return nextChildren;
                        },

                        /**
                         * Generates a "mount image" for each of the supplied children. In the case
                         * of `ReactDOMComponent`, a mount image is a string of markup.
                         *
                         * @param {?object} nestedChildren Nested child maps.
                         * @return {array} An array of mounted representations.
                         * @internal
                         */
                        mountChildren: function (
                            nestedChildren,
                            transaction,
                            context
                        ) {
                            var children = this._reconcilerInstantiateChildren(
                                nestedChildren,
                                transaction,
                                context
                            );
                            this._renderedChildren = children;

                            var mountImages = [];
                            var index = 0;
                            for (var name in children) {
                                if (children.hasOwnProperty(name)) {
                                    var child = children[name];
                                    var selfDebugID = 0;
                                    if (false) {
                                        selfDebugID = getDebugID(this);
                                    }
                                    var mountImage =
                                        ReactReconciler.mountComponent(
                                            child,
                                            transaction,
                                            this,
                                            this._hostContainerInfo,
                                            context,
                                            selfDebugID
                                        );
                                    child._mountIndex = index++;
                                    mountImages.push(mountImage);
                                }
                            }

                            if (false) {
                                setChildrenForInstrumentation.call(
                                    this,
                                    children
                                );
                            }

                            return mountImages;
                        },

                        /**
                         * Replaces any rendered children with a text content string.
                         *
                         * @param {string} nextContent String of content.
                         * @internal
                         */
                        updateTextContent: function (nextContent) {
                            var prevChildren = this._renderedChildren;
                            // Remove any rendered children.
                            ReactChildReconciler.unmountChildren(
                                prevChildren,
                                false
                            );
                            for (var name in prevChildren) {
                                if (prevChildren.hasOwnProperty(name)) {
                                    true
                                        ? false
                                            ? invariant(
                                                  false,
                                                  "updateTextContent called on non-empty component."
                                              )
                                            : _prodInvariant("118")
                                        : void 0;
                                }
                            }
                            // Set new text content.
                            var updates = [makeTextContent(nextContent)];
                            processQueue(this, updates);
                        },

                        /**
                         * Replaces any rendered children with a markup string.
                         *
                         * @param {string} nextMarkup String of markup.
                         * @internal
                         */
                        updateMarkup: function (nextMarkup) {
                            var prevChildren = this._renderedChildren;
                            // Remove any rendered children.
                            ReactChildReconciler.unmountChildren(
                                prevChildren,
                                false
                            );
                            for (var name in prevChildren) {
                                if (prevChildren.hasOwnProperty(name)) {
                                    true
                                        ? false
                                            ? invariant(
                                                  false,
                                                  "updateTextContent called on non-empty component."
                                              )
                                            : _prodInvariant("118")
                                        : void 0;
                                }
                            }
                            var updates = [makeSetMarkup(nextMarkup)];
                            processQueue(this, updates);
                        },

                        /**
                         * Updates the rendered children with new children.
                         *
                         * @param {?object} nextNestedChildrenElements Nested child element maps.
                         * @param {ReactReconcileTransaction} transaction
                         * @internal
                         */
                        updateChildren: function (
                            nextNestedChildrenElements,
                            transaction,
                            context
                        ) {
                            // Hook used by React ART
                            this._updateChildren(
                                nextNestedChildrenElements,
                                transaction,
                                context
                            );
                        },

                        /**
                         * @param {?object} nextNestedChildrenElements Nested child element maps.
                         * @param {ReactReconcileTransaction} transaction
                         * @final
                         * @protected
                         */
                        _updateChildren: function (
                            nextNestedChildrenElements,
                            transaction,
                            context
                        ) {
                            var prevChildren = this._renderedChildren;
                            var removedNodes = {};
                            var mountImages = [];
                            var nextChildren = this._reconcilerUpdateChildren(
                                prevChildren,
                                nextNestedChildrenElements,
                                mountImages,
                                removedNodes,
                                transaction,
                                context
                            );
                            if (!nextChildren && !prevChildren) {
                                return;
                            }
                            var updates = null;
                            var name;
                            // `nextIndex` will increment for each child in `nextChildren`, but
                            // `lastIndex` will be the last index visited in `prevChildren`.
                            var nextIndex = 0;
                            var lastIndex = 0;
                            // `nextMountIndex` will increment for each newly mounted child.
                            var nextMountIndex = 0;
                            var lastPlacedNode = null;
                            for (name in nextChildren) {
                                if (!nextChildren.hasOwnProperty(name)) {
                                    continue;
                                }
                                var prevChild =
                                    prevChildren && prevChildren[name];
                                var nextChild = nextChildren[name];
                                if (prevChild === nextChild) {
                                    updates = enqueue(
                                        updates,
                                        this.moveChild(
                                            prevChild,
                                            lastPlacedNode,
                                            nextIndex,
                                            lastIndex
                                        )
                                    );
                                    lastIndex = Math.max(
                                        prevChild._mountIndex,
                                        lastIndex
                                    );
                                    prevChild._mountIndex = nextIndex;
                                } else {
                                    if (prevChild) {
                                        // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
                                        lastIndex = Math.max(
                                            prevChild._mountIndex,
                                            lastIndex
                                        );
                                        // The `removedNodes` loop below will actually remove the child.
                                    }
                                    // The child must be instantiated before it's mounted.
                                    updates = enqueue(
                                        updates,
                                        this._mountChildAtIndex(
                                            nextChild,
                                            mountImages[nextMountIndex],
                                            lastPlacedNode,
                                            nextIndex,
                                            transaction,
                                            context
                                        )
                                    );
                                    nextMountIndex++;
                                }
                                nextIndex++;
                                lastPlacedNode =
                                    ReactReconciler.getHostNode(nextChild);
                            }
                            // Remove children that are no longer present.
                            for (name in removedNodes) {
                                if (removedNodes.hasOwnProperty(name)) {
                                    updates = enqueue(
                                        updates,
                                        this._unmountChild(
                                            prevChildren[name],
                                            removedNodes[name]
                                        )
                                    );
                                }
                            }
                            if (updates) {
                                processQueue(this, updates);
                            }
                            this._renderedChildren = nextChildren;

                            if (false) {
                                setChildrenForInstrumentation.call(
                                    this,
                                    nextChildren
                                );
                            }
                        },

                        /**
                         * Unmounts all rendered children. This should be used to clean up children
                         * when this component is unmounted. It does not actually perform any
                         * backend operations.
                         *
                         * @internal
                         */
                        unmountChildren: function (safely) {
                            var renderedChildren = this._renderedChildren;
                            ReactChildReconciler.unmountChildren(
                                renderedChildren,
                                safely
                            );
                            this._renderedChildren = null;
                        },

                        /**
                         * Moves a child component to the supplied index.
                         *
                         * @param {ReactComponent} child Component to move.
                         * @param {number} toIndex Destination index of the element.
                         * @param {number} lastIndex Last index visited of the siblings of `child`.
                         * @protected
                         */
                        moveChild: function (
                            child,
                            afterNode,
                            toIndex,
                            lastIndex
                        ) {
                            // If the index of `child` is less than `lastIndex`, then it needs to
                            // be moved. Otherwise, we do not need to move it because a child will be
                            // inserted or moved before `child`.
                            if (child._mountIndex < lastIndex) {
                                return makeMove(child, afterNode, toIndex);
                            }
                        },

                        /**
                         * Creates a child component.
                         *
                         * @param {ReactComponent} child Component to create.
                         * @param {string} mountImage Markup to insert.
                         * @protected
                         */
                        createChild: function (child, afterNode, mountImage) {
                            return makeInsertMarkup(
                                mountImage,
                                afterNode,
                                child._mountIndex
                            );
                        },

                        /**
                         * Removes a child component.
                         *
                         * @param {ReactComponent} child Child to remove.
                         * @protected
                         */
                        removeChild: function (child, node) {
                            return makeRemove(child, node);
                        },

                        /**
                         * Mounts a child with the supplied name.
                         *
                         * NOTE: This is part of `updateChildren` and is here for readability.
                         *
                         * @param {ReactComponent} child Component to mount.
                         * @param {string} name Name of the child.
                         * @param {number} index Index at which to insert the child.
                         * @param {ReactReconcileTransaction} transaction
                         * @private
                         */
                        _mountChildAtIndex: function (
                            child,
                            mountImage,
                            afterNode,
                            index,
                            transaction,
                            context
                        ) {
                            child._mountIndex = index;
                            return this.createChild(
                                child,
                                afterNode,
                                mountImage
                            );
                        },

                        /**
                         * Unmounts a rendered child.
                         *
                         * NOTE: This is part of `updateChildren` and is here for readability.
                         *
                         * @param {ReactComponent} child Component to unmount.
                         * @private
                         */
                        _unmountChild: function (child, node) {
                            var update = this.removeChild(child, node);
                            child._mountIndex = null;
                            return update;
                        },
                    },
                };

                module.exports = ReactMultiChild;

                /***/
            },
            /* 455 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                var injected = false;

                var ReactComponentEnvironment = {
                    /**
                     * Optionally injectable hook for swapping out mount images in the middle of
                     * the tree.
                     */
                    replaceNodeWithMarkup: null,

                    /**
                     * Optionally injectable hook for processing a queue of child updates. Will
                     * later move into MultiChildComponents.
                     */
                    processChildrenUpdates: null,

                    injection: {
                        injectEnvironment: function (environment) {
                            !!injected
                                ? false
                                    ? invariant(
                                          false,
                                          "ReactCompositeComponent: injectEnvironment() can only be called once."
                                      )
                                    : _prodInvariant("104")
                                : void 0;
                            ReactComponentEnvironment.replaceNodeWithMarkup =
                                environment.replaceNodeWithMarkup;
                            ReactComponentEnvironment.processChildrenUpdates =
                                environment.processChildrenUpdates;
                            injected = true;
                        },
                    },
                };

                module.exports = ReactComponentEnvironment;

                /***/
            },
            /* 456 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * `ReactInstanceMap` maintains a mapping from a public facing stateful
                 * instance (key) and the internal representation (value). This allows public
                 * methods to accept the user facing instance as an argument and map them back
                 * to internal methods.
                 */

                // TODO: Replace this with ES6: var ReactInstanceMap = new Map();

                var ReactInstanceMap = {
                    /**
                     * This API should be called `delete` but we'd have to make sure to always
                     * transform these to strings for IE support. When this transform is fully
                     * supported we can rename it.
                     */
                    remove: function (key) {
                        key._reactInternalInstance = undefined;
                    },

                    get: function (key) {
                        return key._reactInternalInstance;
                    },

                    has: function (key) {
                        return key._reactInternalInstance !== undefined;
                    },

                    set: function (key, value) {
                        key._reactInternalInstance = value;
                    },
                };

                module.exports = ReactInstanceMap;

                /***/
            },
            /* 457 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (process) {
                    /**
                     * Copyright 2014-present, Facebook, Inc.
                     * All rights reserved.
                     *
                     * This source code is licensed under the BSD-style license found in the
                     * LICENSE file in the root directory of this source tree. An additional grant
                     * of patent rights can be found in the PATENTS file in the same directory.
                     *
                     */

                    "use strict";

                    var ReactReconciler = __webpack_require__(404);

                    var instantiateReactComponent = __webpack_require__(458);
                    var KeyEscapeUtils = __webpack_require__(466);
                    var shouldUpdateReactComponent = __webpack_require__(462);
                    var traverseAllChildren = __webpack_require__(467);
                    var warning = __webpack_require__(358);

                    var ReactComponentTreeHook;

                    if (
                        typeof process !== "undefined" && {
                            NODE_ENV: "production",
                        } &&
                        "production" === "test"
                    ) {
                        // Temporary hack.
                        // Inline requires don't work well with Jest:
                        // https://github.com/facebook/react/issues/7240
                        // Remove the inline requires when we don't need them anymore:
                        // https://github.com/facebook/react/pull/7178
                        ReactComponentTreeHook = __webpack_require__(470);
                    }

                    function instantiateChild(
                        childInstances,
                        child,
                        name,
                        selfDebugID
                    ) {
                        // We found a component instance.
                        var keyUnique = childInstances[name] === undefined;
                        if (false) {
                            if (!ReactComponentTreeHook) {
                                ReactComponentTreeHook = require("react/lib/ReactComponentTreeHook");
                            }
                            if (!keyUnique) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "flattenChildren(...): Encountered two children with the same key, " +
                                              "`%s`. Child keys must be unique; when two children share a key, only " +
                                              "the first child will be used.%s",
                                          KeyEscapeUtils.unescape(name),
                                          ReactComponentTreeHook.getStackAddendumByID(
                                              selfDebugID
                                          )
                                      )
                                    : void 0;
                            }
                        }
                        if (child != null && keyUnique) {
                            childInstances[name] = instantiateReactComponent(
                                child,
                                true
                            );
                        }
                    }

                    /**
                     * ReactChildReconciler provides helpers for initializing or updating a set of
                     * children. Its output is suitable for passing it onto ReactMultiChild which
                     * does diffed reordering and insertion.
                     */
                    var ReactChildReconciler = {
                        /**
                         * Generates a "mount image" for each of the supplied children. In the case
                         * of `ReactDOMComponent`, a mount image is a string of markup.
                         *
                         * @param {?object} nestedChildNodes Nested child maps.
                         * @return {?object} A set of child instances.
                         * @internal
                         */
                        instantiateChildren: function (
                            nestedChildNodes,
                            transaction,
                            context,
                            selfDebugID // 0 in production and for roots
                        ) {
                            if (nestedChildNodes == null) {
                                return null;
                            }
                            var childInstances = {};

                            if (false) {
                                traverseAllChildren(
                                    nestedChildNodes,
                                    function (childInsts, child, name) {
                                        return instantiateChild(
                                            childInsts,
                                            child,
                                            name,
                                            selfDebugID
                                        );
                                    },
                                    childInstances
                                );
                            } else {
                                traverseAllChildren(
                                    nestedChildNodes,
                                    instantiateChild,
                                    childInstances
                                );
                            }
                            return childInstances;
                        },

                        /**
                         * Updates the rendered children and returns a new set of children.
                         *
                         * @param {?object} prevChildren Previously initialized set of children.
                         * @param {?object} nextChildren Flat child element maps.
                         * @param {ReactReconcileTransaction} transaction
                         * @param {object} context
                         * @return {?object} A new set of child instances.
                         * @internal
                         */
                        updateChildren: function (
                            prevChildren,
                            nextChildren,
                            mountImages,
                            removedNodes,
                            transaction,
                            hostParent,
                            hostContainerInfo,
                            context,
                            selfDebugID // 0 in production and for roots
                        ) {
                            // We currently don't have a way to track moves here but if we use iterators
                            // instead of for..in we can zip the iterators and check if an item has
                            // moved.
                            // TODO: If nothing has changed, return the prevChildren object so that we
                            // can quickly bailout if nothing has changed.
                            if (!nextChildren && !prevChildren) {
                                return;
                            }
                            var name;
                            var prevChild;
                            for (name in nextChildren) {
                                if (!nextChildren.hasOwnProperty(name)) {
                                    continue;
                                }
                                prevChild = prevChildren && prevChildren[name];
                                var prevElement =
                                    prevChild && prevChild._currentElement;
                                var nextElement = nextChildren[name];
                                if (
                                    prevChild != null &&
                                    shouldUpdateReactComponent(
                                        prevElement,
                                        nextElement
                                    )
                                ) {
                                    ReactReconciler.receiveComponent(
                                        prevChild,
                                        nextElement,
                                        transaction,
                                        context
                                    );
                                    nextChildren[name] = prevChild;
                                } else {
                                    if (prevChild) {
                                        removedNodes[name] =
                                            ReactReconciler.getHostNode(
                                                prevChild
                                            );
                                        ReactReconciler.unmountComponent(
                                            prevChild,
                                            false
                                        );
                                    }
                                    // The child must be instantiated before it's mounted.
                                    var nextChildInstance =
                                        instantiateReactComponent(
                                            nextElement,
                                            true
                                        );
                                    nextChildren[name] = nextChildInstance;
                                    // Creating mount image now ensures refs are resolved in right order
                                    // (see https://github.com/facebook/react/pull/7101 for explanation).
                                    var nextChildMountImage =
                                        ReactReconciler.mountComponent(
                                            nextChildInstance,
                                            transaction,
                                            hostParent,
                                            hostContainerInfo,
                                            context,
                                            selfDebugID
                                        );
                                    mountImages.push(nextChildMountImage);
                                }
                            }
                            // Unmount children that are no longer present.
                            for (name in prevChildren) {
                                if (
                                    prevChildren.hasOwnProperty(name) &&
                                    !(
                                        nextChildren &&
                                        nextChildren.hasOwnProperty(name)
                                    )
                                ) {
                                    prevChild = prevChildren[name];
                                    removedNodes[name] =
                                        ReactReconciler.getHostNode(prevChild);
                                    ReactReconciler.unmountComponent(
                                        prevChild,
                                        false
                                    );
                                }
                            }
                        },

                        /**
                         * Unmounts all rendered children. This should be used to clean up children
                         * when this component is unmounted.
                         *
                         * @param {?object} renderedChildren Previously initialized set of children.
                         * @internal
                         */
                        unmountChildren: function (renderedChildren, safely) {
                            for (var name in renderedChildren) {
                                if (renderedChildren.hasOwnProperty(name)) {
                                    var renderedChild = renderedChildren[name];
                                    ReactReconciler.unmountComponent(
                                        renderedChild,
                                        safely
                                    );
                                }
                            }
                        },
                    };

                    module.exports = ReactChildReconciler;
                    /* WEBPACK VAR INJECTION */
                }.call(exports, __webpack_require__(25)));

                /***/
            },
            /* 458 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380),
                    _assign = __webpack_require__(351);

                var ReactCompositeComponent = __webpack_require__(459);
                var ReactEmptyComponent = __webpack_require__(463);
                var ReactHostComponent = __webpack_require__(464);

                var getNextDebugID = __webpack_require__(465);
                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                // To avoid a cyclic dependency, we create the final class in this module
                var ReactCompositeComponentWrapper = function (element) {
                    this.construct(element);
                };
                _assign(
                    ReactCompositeComponentWrapper.prototype,
                    ReactCompositeComponent,
                    {
                        _instantiateReactComponent: instantiateReactComponent,
                    }
                );

                function getDeclarationErrorAddendum(owner) {
                    if (owner) {
                        var name = owner.getName();
                        if (name) {
                            return (
                                " Check the render method of `" + name + "`."
                            );
                        }
                    }
                    return "";
                }

                /**
                 * Check if the type reference is a known internal type. I.e. not a user
                 * provided composite type.
                 *
                 * @param {function} type
                 * @return {boolean} Returns true if this is a valid internal type.
                 */
                function isInternalComponentType(type) {
                    return (
                        typeof type === "function" &&
                        typeof type.prototype !== "undefined" &&
                        typeof type.prototype.mountComponent === "function" &&
                        typeof type.prototype.receiveComponent === "function"
                    );
                }

                /**
                 * Given a ReactNode, create an instance that will actually be mounted.
                 *
                 * @param {ReactNode} node
                 * @param {boolean} shouldHaveDebugID
                 * @return {object} A new instance of the element's constructor.
                 * @protected
                 */
                function instantiateReactComponent(node, shouldHaveDebugID) {
                    var instance;

                    if (node === null || node === false) {
                        instance = ReactEmptyComponent.create(
                            instantiateReactComponent
                        );
                    } else if (typeof node === "object") {
                        var element = node;
                        var type = element.type;
                        if (
                            typeof type !== "function" &&
                            typeof type !== "string"
                        ) {
                            var info = "";
                            if (false) {
                                if (
                                    type === undefined ||
                                    (typeof type === "object" &&
                                        type !== null &&
                                        Object.keys(type).length === 0)
                                ) {
                                    info +=
                                        " You likely forgot to export your component from the file " +
                                        "it's defined in.";
                                }
                            }
                            info += getDeclarationErrorAddendum(element._owner);
                            true
                                ? false
                                    ? invariant(
                                          false,
                                          "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
                                          type == null ? type : typeof type,
                                          info
                                      )
                                    : _prodInvariant(
                                          "130",
                                          type == null ? type : typeof type,
                                          info
                                      )
                                : void 0;
                        }

                        // Special case string values
                        if (typeof element.type === "string") {
                            instance =
                                ReactHostComponent.createInternalComponent(
                                    element
                                );
                        } else if (isInternalComponentType(element.type)) {
                            // This is temporarily available for custom components that are not string
                            // representations. I.e. ART. Once those are updated to use the string
                            // representation, we can drop this code path.
                            instance = new element.type(element);

                            // We renamed this. Allow the old name for compat. :(
                            if (!instance.getHostNode) {
                                instance.getHostNode = instance.getNativeNode;
                            }
                        } else {
                            instance = new ReactCompositeComponentWrapper(
                                element
                            );
                        }
                    } else if (
                        typeof node === "string" ||
                        typeof node === "number"
                    ) {
                        instance =
                            ReactHostComponent.createInstanceForText(node);
                    } else {
                        true
                            ? false
                                ? invariant(
                                      false,
                                      "Encountered invalid React node of type %s",
                                      typeof node
                                  )
                                : _prodInvariant("131", typeof node)
                            : void 0;
                    }

                    if (false) {
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  typeof instance.mountComponent ===
                                      "function" &&
                                      typeof instance.receiveComponent ===
                                          "function" &&
                                      typeof instance.getHostNode ===
                                          "function" &&
                                      typeof instance.unmountComponent ===
                                          "function",
                                  "Only React Components can be mounted."
                              )
                            : void 0;
                    }

                    // These two fields are used by the DOM and ART diffing algorithms
                    // respectively. Instead of using expandos on components, we should be
                    // storing the state needed by the diffing algorithms elsewhere.
                    instance._mountIndex = 0;
                    instance._mountImage = null;

                    if (false) {
                        instance._debugID = shouldHaveDebugID
                            ? getNextDebugID()
                            : 0;
                    }

                    // Internal instances should fully constructed at this point, so they should
                    // not get any new fields added to them at this point.
                    if (false) {
                        if (Object.preventExtensions) {
                            Object.preventExtensions(instance);
                        }
                    }

                    return instance;
                }

                module.exports = instantiateReactComponent;

                /***/
            },
            /* 459 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380),
                    _assign = __webpack_require__(351);

                var React = __webpack_require__(350);
                var ReactComponentEnvironment = __webpack_require__(455);
                var ReactCurrentOwner = __webpack_require__(357);
                var ReactErrorUtils = __webpack_require__(390);
                var ReactInstanceMap = __webpack_require__(456);
                var ReactInstrumentation = __webpack_require__(407);
                var ReactNodeTypes = __webpack_require__(460);
                var ReactReconciler = __webpack_require__(404);

                if (false) {
                    var checkReactTypeSpec = require("./checkReactTypeSpec");
                }

                var emptyObject = __webpack_require__(367);
                var invariant = __webpack_require__(355);
                var shallowEqual = __webpack_require__(461);
                var shouldUpdateReactComponent = __webpack_require__(462);
                var warning = __webpack_require__(358);

                var CompositeTypes = {
                    ImpureClass: 0,
                    PureClass: 1,
                    StatelessFunctional: 2,
                };

                function StatelessComponent(Component) {}
                StatelessComponent.prototype.render = function () {
                    var Component =
                        ReactInstanceMap.get(this)._currentElement.type;
                    var element = Component(
                        this.props,
                        this.context,
                        this.updater
                    );
                    warnIfInvalidElement(Component, element);
                    return element;
                };

                function warnIfInvalidElement(Component, element) {
                    if (false) {
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  element === null ||
                                      element === false ||
                                      React.isValidElement(element),
                                  "%s(...): A valid React element (or null) must be returned. You may have " +
                                      "returned undefined, an array or some other invalid object.",
                                  Component.displayName ||
                                      Component.name ||
                                      "Component"
                              )
                            : void 0;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  !Component.childContextTypes,
                                  "%s(...): childContextTypes cannot be defined on a functional component.",
                                  Component.displayName ||
                                      Component.name ||
                                      "Component"
                              )
                            : void 0;
                    }
                }

                function shouldConstruct(Component) {
                    return !!(
                        Component.prototype &&
                        Component.prototype.isReactComponent
                    );
                }

                function isPureComponent(Component) {
                    return !!(
                        Component.prototype &&
                        Component.prototype.isPureReactComponent
                    );
                }

                // Separated into a function to contain deoptimizations caused by try/finally.
                function measureLifeCyclePerf(fn, debugID, timerType) {
                    if (debugID === 0) {
                        // Top-level wrappers (see ReactMount) and empty components (see
                        // ReactDOMEmptyComponent) are invisible to hooks and devtools.
                        // Both are implementation details that should go away in the future.
                        return fn();
                    }

                    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(
                        debugID,
                        timerType
                    );
                    try {
                        return fn();
                    } finally {
                        ReactInstrumentation.debugTool.onEndLifeCycleTimer(
                            debugID,
                            timerType
                        );
                    }
                }

                /**
                 * ------------------ The Life-Cycle of a Composite Component ------------------
                 *
                 * - constructor: Initialization of state. The instance is now retained.
                 *   - componentWillMount
                 *   - render
                 *   - [children's constructors]
                 *     - [children's componentWillMount and render]
                 *     - [children's componentDidMount]
                 *     - componentDidMount
                 *
                 *       Update Phases:
                 *       - componentWillReceiveProps (only called if parent updated)
                 *       - shouldComponentUpdate
                 *         - componentWillUpdate
                 *           - render
                 *           - [children's constructors or receive props phases]
                 *         - componentDidUpdate
                 *
                 *     - componentWillUnmount
                 *     - [children's componentWillUnmount]
                 *   - [children destroyed]
                 * - (destroyed): The instance is now blank, released by React and ready for GC.
                 *
                 * -----------------------------------------------------------------------------
                 */

                /**
                 * An incrementing ID assigned to each component when it is mounted. This is
                 * used to enforce the order in which `ReactUpdates` updates dirty components.
                 *
                 * @private
                 */
                var nextMountID = 1;

                /**
                 * @lends {ReactCompositeComponent.prototype}
                 */
                var ReactCompositeComponent = {
                    /**
                     * Base constructor for all composite component.
                     *
                     * @param {ReactElement} element
                     * @final
                     * @internal
                     */
                    construct: function (element) {
                        this._currentElement = element;
                        this._rootNodeID = 0;
                        this._compositeType = null;
                        this._instance = null;
                        this._hostParent = null;
                        this._hostContainerInfo = null;

                        // See ReactUpdateQueue
                        this._updateBatchNumber = null;
                        this._pendingElement = null;
                        this._pendingStateQueue = null;
                        this._pendingReplaceState = false;
                        this._pendingForceUpdate = false;

                        this._renderedNodeType = null;
                        this._renderedComponent = null;
                        this._context = null;
                        this._mountOrder = 0;
                        this._topLevelWrapper = null;

                        // See ReactUpdates and ReactUpdateQueue.
                        this._pendingCallbacks = null;

                        // ComponentWillUnmount shall only be called once
                        this._calledComponentWillUnmount = false;

                        if (false) {
                            this._warnedAboutRefsInRender = false;
                        }
                    },

                    /**
                     * Initializes the component, renders markup, and registers event listeners.
                     *
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {?object} hostParent
                     * @param {?object} hostContainerInfo
                     * @param {?object} context
                     * @return {?string} Rendered markup to be inserted into the DOM.
                     * @final
                     * @internal
                     */
                    mountComponent: function (
                        transaction,
                        hostParent,
                        hostContainerInfo,
                        context
                    ) {
                        var _this = this;

                        this._context = context;
                        this._mountOrder = nextMountID++;
                        this._hostParent = hostParent;
                        this._hostContainerInfo = hostContainerInfo;

                        var publicProps = this._currentElement.props;
                        var publicContext = this._processContext(context);

                        var Component = this._currentElement.type;

                        var updateQueue = transaction.getUpdateQueue();

                        // Initialize the public class
                        var doConstruct = shouldConstruct(Component);
                        var inst = this._constructComponent(
                            doConstruct,
                            publicProps,
                            publicContext,
                            updateQueue
                        );
                        var renderedElement;

                        // Support functional components
                        if (
                            !doConstruct &&
                            (inst == null || inst.render == null)
                        ) {
                            renderedElement = inst;
                            warnIfInvalidElement(Component, renderedElement);
                            !(
                                inst === null ||
                                inst === false ||
                                React.isValidElement(inst)
                            )
                                ? false
                                    ? invariant(
                                          false,
                                          "%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.",
                                          Component.displayName ||
                                              Component.name ||
                                              "Component"
                                      )
                                    : _prodInvariant(
                                          "105",
                                          Component.displayName ||
                                              Component.name ||
                                              "Component"
                                      )
                                : void 0;
                            inst = new StatelessComponent(Component);
                            this._compositeType =
                                CompositeTypes.StatelessFunctional;
                        } else {
                            if (isPureComponent(Component)) {
                                this._compositeType = CompositeTypes.PureClass;
                            } else {
                                this._compositeType =
                                    CompositeTypes.ImpureClass;
                            }
                        }

                        if (false) {
                            // This will throw later in _renderValidatedComponent, but add an early
                            // warning now to help debugging
                            if (inst.render == null) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "%s(...): No `render` method found on the returned component " +
                                              "instance: you may have forgotten to define `render`.",
                                          Component.displayName ||
                                              Component.name ||
                                              "Component"
                                      )
                                    : void 0;
                            }

                            var propsMutated = inst.props !== publicProps;
                            var componentName =
                                Component.displayName ||
                                Component.name ||
                                "Component";

                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      inst.props === undefined || !propsMutated,
                                      "%s(...): When calling super() in `%s`, make sure to pass " +
                                          "up the same props that your component's constructor was passed.",
                                      componentName,
                                      componentName
                                  )
                                : void 0;
                        }

                        // These should be set up in the constructor, but as a convenience for
                        // simpler class abstractions, we set them up after the fact.
                        inst.props = publicProps;
                        inst.context = publicContext;
                        inst.refs = emptyObject;
                        inst.updater = updateQueue;

                        this._instance = inst;

                        // Store a reference from the instance back to the internal representation
                        ReactInstanceMap.set(inst, this);

                        if (false) {
                            // Since plain JS classes are defined without any special initialization
                            // logic, we can not catch common errors early. Therefore, we have to
                            // catch them here, at initialization time, instead.
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !inst.getInitialState ||
                                          inst.getInitialState
                                              .isReactClassApproved ||
                                          inst.state,
                                      "getInitialState was defined on %s, a plain JavaScript class. " +
                                          "This is only supported for classes created using React.createClass. " +
                                          "Did you mean to define a state property instead?",
                                      this.getName() || "a component"
                                  )
                                : void 0;
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !inst.getDefaultProps ||
                                          inst.getDefaultProps
                                              .isReactClassApproved,
                                      "getDefaultProps was defined on %s, a plain JavaScript class. " +
                                          "This is only supported for classes created using React.createClass. " +
                                          "Use a static property to define defaultProps instead.",
                                      this.getName() || "a component"
                                  )
                                : void 0;
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !inst.propTypes,
                                      "propTypes was defined as an instance property on %s. Use a static " +
                                          "property to define propTypes instead.",
                                      this.getName() || "a component"
                                  )
                                : void 0;
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !inst.contextTypes,
                                      "contextTypes was defined as an instance property on %s. Use a " +
                                          "static property to define contextTypes instead.",
                                      this.getName() || "a component"
                                  )
                                : void 0;
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      typeof inst.componentShouldUpdate !==
                                          "function",
                                      "%s has a method called " +
                                          "componentShouldUpdate(). Did you mean shouldComponentUpdate()? " +
                                          "The name is phrased as a question because the function is " +
                                          "expected to return a value.",
                                      this.getName() || "A component"
                                  )
                                : void 0;
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      typeof inst.componentDidUnmount !==
                                          "function",
                                      "%s has a method called " +
                                          "componentDidUnmount(). But there is no such lifecycle method. " +
                                          "Did you mean componentWillUnmount()?",
                                      this.getName() || "A component"
                                  )
                                : void 0;
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      typeof inst.componentWillRecieveProps !==
                                          "function",
                                      "%s has a method called " +
                                          "componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
                                      this.getName() || "A component"
                                  )
                                : void 0;
                        }

                        var initialState = inst.state;
                        if (initialState === undefined) {
                            inst.state = initialState = null;
                        }
                        !(
                            typeof initialState === "object" &&
                            !Array.isArray(initialState)
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "%s.state: must be set to an object or null",
                                      this.getName() ||
                                          "ReactCompositeComponent"
                                  )
                                : _prodInvariant(
                                      "106",
                                      this.getName() ||
                                          "ReactCompositeComponent"
                                  )
                            : void 0;

                        this._pendingStateQueue = null;
                        this._pendingReplaceState = false;
                        this._pendingForceUpdate = false;

                        var markup;
                        if (inst.unstable_handleError) {
                            markup = this.performInitialMountWithErrorHandling(
                                renderedElement,
                                hostParent,
                                hostContainerInfo,
                                transaction,
                                context
                            );
                        } else {
                            markup = this.performInitialMount(
                                renderedElement,
                                hostParent,
                                hostContainerInfo,
                                transaction,
                                context
                            );
                        }

                        if (inst.componentDidMount) {
                            if (false) {
                                transaction
                                    .getReactMountReady()
                                    .enqueue(function () {
                                        measureLifeCyclePerf(
                                            function () {
                                                return inst.componentDidMount();
                                            },
                                            _this._debugID,
                                            "componentDidMount"
                                        );
                                    });
                            } else {
                                transaction
                                    .getReactMountReady()
                                    .enqueue(inst.componentDidMount, inst);
                            }
                        }

                        return markup;
                    },

                    _constructComponent: function (
                        doConstruct,
                        publicProps,
                        publicContext,
                        updateQueue
                    ) {
                        if (false) {
                            ReactCurrentOwner.current = this;
                            try {
                                return this._constructComponentWithoutOwner(
                                    doConstruct,
                                    publicProps,
                                    publicContext,
                                    updateQueue
                                );
                            } finally {
                                ReactCurrentOwner.current = null;
                            }
                        } else {
                            return this._constructComponentWithoutOwner(
                                doConstruct,
                                publicProps,
                                publicContext,
                                updateQueue
                            );
                        }
                    },

                    _constructComponentWithoutOwner: function (
                        doConstruct,
                        publicProps,
                        publicContext,
                        updateQueue
                    ) {
                        var Component = this._currentElement.type;

                        if (doConstruct) {
                            if (false) {
                                return measureLifeCyclePerf(
                                    function () {
                                        return new Component(
                                            publicProps,
                                            publicContext,
                                            updateQueue
                                        );
                                    },
                                    this._debugID,
                                    "ctor"
                                );
                            } else {
                                return new Component(
                                    publicProps,
                                    publicContext,
                                    updateQueue
                                );
                            }
                        }

                        // This can still be an instance in case of factory components
                        // but we'll count this as time spent rendering as the more common case.
                        if (false) {
                            return measureLifeCyclePerf(
                                function () {
                                    return Component(
                                        publicProps,
                                        publicContext,
                                        updateQueue
                                    );
                                },
                                this._debugID,
                                "render"
                            );
                        } else {
                            return Component(
                                publicProps,
                                publicContext,
                                updateQueue
                            );
                        }
                    },

                    performInitialMountWithErrorHandling: function (
                        renderedElement,
                        hostParent,
                        hostContainerInfo,
                        transaction,
                        context
                    ) {
                        var markup;
                        var checkpoint = transaction.checkpoint();
                        try {
                            markup = this.performInitialMount(
                                renderedElement,
                                hostParent,
                                hostContainerInfo,
                                transaction,
                                context
                            );
                        } catch (e) {
                            // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
                            transaction.rollback(checkpoint);
                            this._instance.unstable_handleError(e);
                            if (this._pendingStateQueue) {
                                this._instance.state =
                                    this._processPendingState(
                                        this._instance.props,
                                        this._instance.context
                                    );
                            }
                            checkpoint = transaction.checkpoint();

                            this._renderedComponent.unmountComponent(true);
                            transaction.rollback(checkpoint);

                            // Try again - we've informed the component about the error, so they can render an error message this time.
                            // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
                            markup = this.performInitialMount(
                                renderedElement,
                                hostParent,
                                hostContainerInfo,
                                transaction,
                                context
                            );
                        }
                        return markup;
                    },

                    performInitialMount: function (
                        renderedElement,
                        hostParent,
                        hostContainerInfo,
                        transaction,
                        context
                    ) {
                        var inst = this._instance;

                        var debugID = 0;
                        if (false) {
                            debugID = this._debugID;
                        }

                        if (inst.componentWillMount) {
                            if (false) {
                                measureLifeCyclePerf(
                                    function () {
                                        return inst.componentWillMount();
                                    },
                                    debugID,
                                    "componentWillMount"
                                );
                            } else {
                                inst.componentWillMount();
                            }
                            // When mounting, calls to `setState` by `componentWillMount` will set
                            // `this._pendingStateQueue` without triggering a re-render.
                            if (this._pendingStateQueue) {
                                inst.state = this._processPendingState(
                                    inst.props,
                                    inst.context
                                );
                            }
                        }

                        // If not a stateless component, we now render
                        if (renderedElement === undefined) {
                            renderedElement = this._renderValidatedComponent();
                        }

                        var nodeType = ReactNodeTypes.getType(renderedElement);
                        this._renderedNodeType = nodeType;
                        var child = this._instantiateReactComponent(
                            renderedElement,
                            nodeType !==
                                ReactNodeTypes.EMPTY /* shouldHaveDebugID */
                        );
                        this._renderedComponent = child;

                        var markup = ReactReconciler.mountComponent(
                            child,
                            transaction,
                            hostParent,
                            hostContainerInfo,
                            this._processChildContext(context),
                            debugID
                        );

                        if (false) {
                            if (debugID !== 0) {
                                var childDebugIDs =
                                    child._debugID !== 0
                                        ? [child._debugID]
                                        : [];
                                ReactInstrumentation.debugTool.onSetChildren(
                                    debugID,
                                    childDebugIDs
                                );
                            }
                        }

                        return markup;
                    },

                    getHostNode: function () {
                        return ReactReconciler.getHostNode(
                            this._renderedComponent
                        );
                    },

                    /**
                     * Releases any resources allocated by `mountComponent`.
                     *
                     * @final
                     * @internal
                     */
                    unmountComponent: function (safely) {
                        if (!this._renderedComponent) {
                            return;
                        }

                        var inst = this._instance;

                        if (
                            inst.componentWillUnmount &&
                            !inst._calledComponentWillUnmount
                        ) {
                            inst._calledComponentWillUnmount = true;

                            if (safely) {
                                var name =
                                    this.getName() + ".componentWillUnmount()";
                                ReactErrorUtils.invokeGuardedCallback(
                                    name,
                                    inst.componentWillUnmount.bind(inst)
                                );
                            } else {
                                if (false) {
                                    measureLifeCyclePerf(
                                        function () {
                                            return inst.componentWillUnmount();
                                        },
                                        this._debugID,
                                        "componentWillUnmount"
                                    );
                                } else {
                                    inst.componentWillUnmount();
                                }
                            }
                        }

                        if (this._renderedComponent) {
                            ReactReconciler.unmountComponent(
                                this._renderedComponent,
                                safely
                            );
                            this._renderedNodeType = null;
                            this._renderedComponent = null;
                            this._instance = null;
                        }

                        // Reset pending fields
                        // Even if this component is scheduled for another update in ReactUpdates,
                        // it would still be ignored because these fields are reset.
                        this._pendingStateQueue = null;
                        this._pendingReplaceState = false;
                        this._pendingForceUpdate = false;
                        this._pendingCallbacks = null;
                        this._pendingElement = null;

                        // These fields do not really need to be reset since this object is no
                        // longer accessible.
                        this._context = null;
                        this._rootNodeID = 0;
                        this._topLevelWrapper = null;

                        // Delete the reference from the instance to this internal representation
                        // which allow the internals to be properly cleaned up even if the user
                        // leaks a reference to the public instance.
                        ReactInstanceMap.remove(inst);

                        // Some existing components rely on inst.props even after they've been
                        // destroyed (in event handlers).
                        // TODO: inst.props = null;
                        // TODO: inst.state = null;
                        // TODO: inst.context = null;
                    },

                    /**
                     * Filters the context object to only contain keys specified in
                     * `contextTypes`
                     *
                     * @param {object} context
                     * @return {?object}
                     * @private
                     */
                    _maskContext: function (context) {
                        var Component = this._currentElement.type;
                        var contextTypes = Component.contextTypes;
                        if (!contextTypes) {
                            return emptyObject;
                        }
                        var maskedContext = {};
                        for (var contextName in contextTypes) {
                            maskedContext[contextName] = context[contextName];
                        }
                        return maskedContext;
                    },

                    /**
                     * Filters the context object to only contain keys specified in
                     * `contextTypes`, and asserts that they are valid.
                     *
                     * @param {object} context
                     * @return {?object}
                     * @private
                     */
                    _processContext: function (context) {
                        var maskedContext = this._maskContext(context);
                        if (false) {
                            var Component = this._currentElement.type;
                            if (Component.contextTypes) {
                                this._checkContextTypes(
                                    Component.contextTypes,
                                    maskedContext,
                                    "context"
                                );
                            }
                        }
                        return maskedContext;
                    },

                    /**
                     * @param {object} currentContext
                     * @return {object}
                     * @private
                     */
                    _processChildContext: function (currentContext) {
                        var Component = this._currentElement.type;
                        var inst = this._instance;
                        var childContext;

                        if (inst.getChildContext) {
                            if (false) {
                                ReactInstrumentation.debugTool.onBeginProcessingChildContext();
                                try {
                                    childContext = inst.getChildContext();
                                } finally {
                                    ReactInstrumentation.debugTool.onEndProcessingChildContext();
                                }
                            } else {
                                childContext = inst.getChildContext();
                            }
                        }

                        if (childContext) {
                            !(typeof Component.childContextTypes === "object")
                                ? false
                                    ? invariant(
                                          false,
                                          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
                                          this.getName() ||
                                              "ReactCompositeComponent"
                                      )
                                    : _prodInvariant(
                                          "107",
                                          this.getName() ||
                                              "ReactCompositeComponent"
                                      )
                                : void 0;
                            if (false) {
                                this._checkContextTypes(
                                    Component.childContextTypes,
                                    childContext,
                                    "childContext"
                                );
                            }
                            for (var name in childContext) {
                                !(name in Component.childContextTypes)
                                    ? false
                                        ? invariant(
                                              false,
                                              '%s.getChildContext(): key "%s" is not defined in childContextTypes.',
                                              this.getName() ||
                                                  "ReactCompositeComponent",
                                              name
                                          )
                                        : _prodInvariant(
                                              "108",
                                              this.getName() ||
                                                  "ReactCompositeComponent",
                                              name
                                          )
                                    : void 0;
                            }
                            return _assign({}, currentContext, childContext);
                        }
                        return currentContext;
                    },

                    /**
                     * Assert that the context types are valid
                     *
                     * @param {object} typeSpecs Map of context field to a ReactPropType
                     * @param {object} values Runtime values that need to be type-checked
                     * @param {string} location e.g. "prop", "context", "child context"
                     * @private
                     */
                    _checkContextTypes: function (typeSpecs, values, location) {
                        if (false) {
                            checkReactTypeSpec(
                                typeSpecs,
                                values,
                                location,
                                this.getName(),
                                null,
                                this._debugID
                            );
                        }
                    },

                    receiveComponent: function (
                        nextElement,
                        transaction,
                        nextContext
                    ) {
                        var prevElement = this._currentElement;
                        var prevContext = this._context;

                        this._pendingElement = null;

                        this.updateComponent(
                            transaction,
                            prevElement,
                            nextElement,
                            prevContext,
                            nextContext
                        );
                    },

                    /**
                     * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
                     * is set, update the component.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    performUpdateIfNecessary: function (transaction) {
                        if (this._pendingElement != null) {
                            ReactReconciler.receiveComponent(
                                this,
                                this._pendingElement,
                                transaction,
                                this._context
                            );
                        } else if (
                            this._pendingStateQueue !== null ||
                            this._pendingForceUpdate
                        ) {
                            this.updateComponent(
                                transaction,
                                this._currentElement,
                                this._currentElement,
                                this._context,
                                this._context
                            );
                        } else {
                            this._updateBatchNumber = null;
                        }
                    },

                    /**
                     * Perform an update to a mounted component. The componentWillReceiveProps and
                     * shouldComponentUpdate methods are called, then (assuming the update isn't
                     * skipped) the remaining update lifecycle methods are called and the DOM
                     * representation is updated.
                     *
                     * By default, this implements React's rendering and reconciliation algorithm.
                     * Sophisticated clients may wish to override this.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @param {ReactElement} prevParentElement
                     * @param {ReactElement} nextParentElement
                     * @internal
                     * @overridable
                     */
                    updateComponent: function (
                        transaction,
                        prevParentElement,
                        nextParentElement,
                        prevUnmaskedContext,
                        nextUnmaskedContext
                    ) {
                        var inst = this._instance;
                        !(inst != null)
                            ? false
                                ? invariant(
                                      false,
                                      "Attempted to update component `%s` that has already been unmounted (or failed to mount).",
                                      this.getName() ||
                                          "ReactCompositeComponent"
                                  )
                                : _prodInvariant(
                                      "136",
                                      this.getName() ||
                                          "ReactCompositeComponent"
                                  )
                            : void 0;

                        var willReceive = false;
                        var nextContext;

                        // Determine if the context has changed or not
                        if (this._context === nextUnmaskedContext) {
                            nextContext = inst.context;
                        } else {
                            nextContext =
                                this._processContext(nextUnmaskedContext);
                            willReceive = true;
                        }

                        var prevProps = prevParentElement.props;
                        var nextProps = nextParentElement.props;

                        // Not a simple state update but a props update
                        if (prevParentElement !== nextParentElement) {
                            willReceive = true;
                        }

                        // An update here will schedule an update but immediately set
                        // _pendingStateQueue which will ensure that any state updates gets
                        // immediately reconciled instead of waiting for the next batch.
                        if (willReceive && inst.componentWillReceiveProps) {
                            if (false) {
                                measureLifeCyclePerf(
                                    function () {
                                        return inst.componentWillReceiveProps(
                                            nextProps,
                                            nextContext
                                        );
                                    },
                                    this._debugID,
                                    "componentWillReceiveProps"
                                );
                            } else {
                                inst.componentWillReceiveProps(
                                    nextProps,
                                    nextContext
                                );
                            }
                        }

                        var nextState = this._processPendingState(
                            nextProps,
                            nextContext
                        );
                        var shouldUpdate = true;

                        if (!this._pendingForceUpdate) {
                            if (inst.shouldComponentUpdate) {
                                if (false) {
                                    shouldUpdate = measureLifeCyclePerf(
                                        function () {
                                            return inst.shouldComponentUpdate(
                                                nextProps,
                                                nextState,
                                                nextContext
                                            );
                                        },
                                        this._debugID,
                                        "shouldComponentUpdate"
                                    );
                                } else {
                                    shouldUpdate = inst.shouldComponentUpdate(
                                        nextProps,
                                        nextState,
                                        nextContext
                                    );
                                }
                            } else {
                                if (
                                    this._compositeType ===
                                    CompositeTypes.PureClass
                                ) {
                                    shouldUpdate =
                                        !shallowEqual(prevProps, nextProps) ||
                                        !shallowEqual(inst.state, nextState);
                                }
                            }
                        }

                        if (false) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      shouldUpdate !== undefined,
                                      "%s.shouldComponentUpdate(): Returned undefined instead of a " +
                                          "boolean value. Make sure to return true or false.",
                                      this.getName() ||
                                          "ReactCompositeComponent"
                                  )
                                : void 0;
                        }

                        this._updateBatchNumber = null;
                        if (shouldUpdate) {
                            this._pendingForceUpdate = false;
                            // Will set `this.props`, `this.state` and `this.context`.
                            this._performComponentUpdate(
                                nextParentElement,
                                nextProps,
                                nextState,
                                nextContext,
                                transaction,
                                nextUnmaskedContext
                            );
                        } else {
                            // If it's determined that a component should not update, we still want
                            // to set props and state but we shortcut the rest of the update.
                            this._currentElement = nextParentElement;
                            this._context = nextUnmaskedContext;
                            inst.props = nextProps;
                            inst.state = nextState;
                            inst.context = nextContext;
                        }
                    },

                    _processPendingState: function (props, context) {
                        var inst = this._instance;
                        var queue = this._pendingStateQueue;
                        var replace = this._pendingReplaceState;
                        this._pendingReplaceState = false;
                        this._pendingStateQueue = null;

                        if (!queue) {
                            return inst.state;
                        }

                        if (replace && queue.length === 1) {
                            return queue[0];
                        }

                        var nextState = _assign(
                            {},
                            replace ? queue[0] : inst.state
                        );
                        for (var i = replace ? 1 : 0; i < queue.length; i++) {
                            var partial = queue[i];
                            _assign(
                                nextState,
                                typeof partial === "function"
                                    ? partial.call(
                                          inst,
                                          nextState,
                                          props,
                                          context
                                      )
                                    : partial
                            );
                        }

                        return nextState;
                    },

                    /**
                     * Merges new props and state, notifies delegate methods of update and
                     * performs update.
                     *
                     * @param {ReactElement} nextElement Next element
                     * @param {object} nextProps Next public object to set as properties.
                     * @param {?object} nextState Next object to set as state.
                     * @param {?object} nextContext Next public object to set as context.
                     * @param {ReactReconcileTransaction} transaction
                     * @param {?object} unmaskedContext
                     * @private
                     */
                    _performComponentUpdate: function (
                        nextElement,
                        nextProps,
                        nextState,
                        nextContext,
                        transaction,
                        unmaskedContext
                    ) {
                        var _this2 = this;

                        var inst = this._instance;

                        var hasComponentDidUpdate = Boolean(
                            inst.componentDidUpdate
                        );
                        var prevProps;
                        var prevState;
                        var prevContext;
                        if (hasComponentDidUpdate) {
                            prevProps = inst.props;
                            prevState = inst.state;
                            prevContext = inst.context;
                        }

                        if (inst.componentWillUpdate) {
                            if (false) {
                                measureLifeCyclePerf(
                                    function () {
                                        return inst.componentWillUpdate(
                                            nextProps,
                                            nextState,
                                            nextContext
                                        );
                                    },
                                    this._debugID,
                                    "componentWillUpdate"
                                );
                            } else {
                                inst.componentWillUpdate(
                                    nextProps,
                                    nextState,
                                    nextContext
                                );
                            }
                        }

                        this._currentElement = nextElement;
                        this._context = unmaskedContext;
                        inst.props = nextProps;
                        inst.state = nextState;
                        inst.context = nextContext;

                        this._updateRenderedComponent(
                            transaction,
                            unmaskedContext
                        );

                        if (hasComponentDidUpdate) {
                            if (false) {
                                transaction
                                    .getReactMountReady()
                                    .enqueue(function () {
                                        measureLifeCyclePerf(
                                            inst.componentDidUpdate.bind(
                                                inst,
                                                prevProps,
                                                prevState,
                                                prevContext
                                            ),
                                            _this2._debugID,
                                            "componentDidUpdate"
                                        );
                                    });
                            } else {
                                transaction
                                    .getReactMountReady()
                                    .enqueue(
                                        inst.componentDidUpdate.bind(
                                            inst,
                                            prevProps,
                                            prevState,
                                            prevContext
                                        ),
                                        inst
                                    );
                            }
                        }
                    },

                    /**
                     * Call the component's `render` method and update the DOM accordingly.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    _updateRenderedComponent: function (transaction, context) {
                        var prevComponentInstance = this._renderedComponent;
                        var prevRenderedElement =
                            prevComponentInstance._currentElement;
                        var nextRenderedElement =
                            this._renderValidatedComponent();

                        var debugID = 0;
                        if (false) {
                            debugID = this._debugID;
                        }

                        if (
                            shouldUpdateReactComponent(
                                prevRenderedElement,
                                nextRenderedElement
                            )
                        ) {
                            ReactReconciler.receiveComponent(
                                prevComponentInstance,
                                nextRenderedElement,
                                transaction,
                                this._processChildContext(context)
                            );
                        } else {
                            var oldHostNode = ReactReconciler.getHostNode(
                                prevComponentInstance
                            );
                            ReactReconciler.unmountComponent(
                                prevComponentInstance,
                                false
                            );

                            var nodeType =
                                ReactNodeTypes.getType(nextRenderedElement);
                            this._renderedNodeType = nodeType;
                            var child = this._instantiateReactComponent(
                                nextRenderedElement,
                                nodeType !==
                                    ReactNodeTypes.EMPTY /* shouldHaveDebugID */
                            );
                            this._renderedComponent = child;

                            var nextMarkup = ReactReconciler.mountComponent(
                                child,
                                transaction,
                                this._hostParent,
                                this._hostContainerInfo,
                                this._processChildContext(context),
                                debugID
                            );

                            if (false) {
                                if (debugID !== 0) {
                                    var childDebugIDs =
                                        child._debugID !== 0
                                            ? [child._debugID]
                                            : [];
                                    ReactInstrumentation.debugTool.onSetChildren(
                                        debugID,
                                        childDebugIDs
                                    );
                                }
                            }

                            this._replaceNodeWithMarkup(
                                oldHostNode,
                                nextMarkup,
                                prevComponentInstance
                            );
                        }
                    },

                    /**
                     * Overridden in shallow rendering.
                     *
                     * @protected
                     */
                    _replaceNodeWithMarkup: function (
                        oldHostNode,
                        nextMarkup,
                        prevInstance
                    ) {
                        ReactComponentEnvironment.replaceNodeWithMarkup(
                            oldHostNode,
                            nextMarkup,
                            prevInstance
                        );
                    },

                    /**
                     * @protected
                     */
                    _renderValidatedComponentWithoutOwnerOrContext:
                        function () {
                            var inst = this._instance;
                            var renderedElement;

                            if (false) {
                                renderedElement = measureLifeCyclePerf(
                                    function () {
                                        return inst.render();
                                    },
                                    this._debugID,
                                    "render"
                                );
                            } else {
                                renderedElement = inst.render();
                            }

                            if (false) {
                                // We allow auto-mocks to proceed as if they're returning null.
                                if (
                                    renderedElement === undefined &&
                                    inst.render._isMockFunction
                                ) {
                                    // This is probably bad practice. Consider warning here and
                                    // deprecating this convenience.
                                    renderedElement = null;
                                }
                            }

                            return renderedElement;
                        },

                    /**
                     * @private
                     */
                    _renderValidatedComponent: function () {
                        var renderedElement;
                        if (
                            "production" !== "production" ||
                            this._compositeType !==
                                CompositeTypes.StatelessFunctional
                        ) {
                            ReactCurrentOwner.current = this;
                            try {
                                renderedElement =
                                    this._renderValidatedComponentWithoutOwnerOrContext();
                            } finally {
                                ReactCurrentOwner.current = null;
                            }
                        } else {
                            renderedElement =
                                this._renderValidatedComponentWithoutOwnerOrContext();
                        }
                        !(
                            // TODO: An `isValidNode` function would probably be more appropriate
                            (
                                renderedElement === null ||
                                renderedElement === false ||
                                React.isValidElement(renderedElement)
                            )
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.",
                                      this.getName() ||
                                          "ReactCompositeComponent"
                                  )
                                : _prodInvariant(
                                      "109",
                                      this.getName() ||
                                          "ReactCompositeComponent"
                                  )
                            : void 0;

                        return renderedElement;
                    },

                    /**
                     * Lazily allocates the refs object and stores `component` as `ref`.
                     *
                     * @param {string} ref Reference name.
                     * @param {component} component Component to store as `ref`.
                     * @final
                     * @private
                     */
                    attachRef: function (ref, component) {
                        var inst = this.getPublicInstance();
                        !(inst != null)
                            ? false
                                ? invariant(
                                      false,
                                      "Stateless function components cannot have refs."
                                  )
                                : _prodInvariant("110")
                            : void 0;
                        var publicComponentInstance =
                            component.getPublicInstance();
                        if (false) {
                            var componentName =
                                component && component.getName
                                    ? component.getName()
                                    : "a component";
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      publicComponentInstance != null ||
                                          component._compositeType !==
                                              CompositeTypes.StatelessFunctional,
                                      "Stateless function components cannot be given refs " +
                                          '(See ref "%s" in %s created by %s). ' +
                                          "Attempts to access this ref will fail.",
                                      ref,
                                      componentName,
                                      this.getName()
                                  )
                                : void 0;
                        }
                        var refs =
                            inst.refs === emptyObject
                                ? (inst.refs = {})
                                : inst.refs;
                        refs[ref] = publicComponentInstance;
                    },

                    /**
                     * Detaches a reference name.
                     *
                     * @param {string} ref Name to dereference.
                     * @final
                     * @private
                     */
                    detachRef: function (ref) {
                        var refs = this.getPublicInstance().refs;
                        delete refs[ref];
                    },

                    /**
                     * Get a text description of the component that can be used to identify it
                     * in error messages.
                     * @return {string} The name or null.
                     * @internal
                     */
                    getName: function () {
                        var type = this._currentElement.type;
                        var constructor =
                            this._instance && this._instance.constructor;
                        return (
                            type.displayName ||
                            (constructor && constructor.displayName) ||
                            type.name ||
                            (constructor && constructor.name) ||
                            null
                        );
                    },

                    /**
                     * Get the publicly accessible representation of this component - i.e. what
                     * is exposed by refs and returned by render. Can be null for stateless
                     * components.
                     *
                     * @return {ReactComponent} the public component instance.
                     * @internal
                     */
                    getPublicInstance: function () {
                        var inst = this._instance;
                        if (
                            this._compositeType ===
                            CompositeTypes.StatelessFunctional
                        ) {
                            return null;
                        }
                        return inst;
                    },

                    // Stub
                    _instantiateReactComponent: null,
                };

                module.exports = ReactCompositeComponent;

                /***/
            },
            /* 460 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var React = __webpack_require__(350);

                var invariant = __webpack_require__(355);

                var ReactNodeTypes = {
                    HOST: 0,
                    COMPOSITE: 1,
                    EMPTY: 2,

                    getType: function (node) {
                        if (node === null || node === false) {
                            return ReactNodeTypes.EMPTY;
                        } else if (React.isValidElement(node)) {
                            if (typeof node.type === "function") {
                                return ReactNodeTypes.COMPOSITE;
                            } else {
                                return ReactNodeTypes.HOST;
                            }
                        }
                        true
                            ? false
                                ? invariant(false, "Unexpected node: %s", node)
                                : _prodInvariant("26", node)
                            : void 0;
                    },
                };

                module.exports = ReactNodeTypes;

                /***/
            },
            /* 461 */
            /***/ function (module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 *
                 */

                /*eslint-disable no-self-compare */

                "use strict";

                var hasOwnProperty = Object.prototype.hasOwnProperty;

                /**
                 * inlined Object.is polyfill to avoid requiring consumers ship their own
                 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
                 */
                function is(x, y) {
                    // SameValue algorithm
                    if (x === y) {
                        // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        // Added the nonzero y check to make Flow happy, but it is redundant
                        return x !== 0 || y !== 0 || 1 / x === 1 / y;
                    } else {
                        // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                }

                /**
                 * Performs equality by iterating through keys on an object and returning false
                 * when any key has values which are not strictly equal between the arguments.
                 * Returns true when the values of all keys are strictly equal.
                 */
                function shallowEqual(objA, objB) {
                    if (is(objA, objB)) {
                        return true;
                    }

                    if (
                        typeof objA !== "object" ||
                        objA === null ||
                        typeof objB !== "object" ||
                        objB === null
                    ) {
                        return false;
                    }

                    var keysA = Object.keys(objA);
                    var keysB = Object.keys(objB);

                    if (keysA.length !== keysB.length) {
                        return false;
                    }

                    // Test for A's keys different from B.
                    for (var i = 0; i < keysA.length; i++) {
                        if (
                            !hasOwnProperty.call(objB, keysA[i]) ||
                            !is(objA[keysA[i]], objB[keysA[i]])
                        ) {
                            return false;
                        }
                    }

                    return true;
                }

                module.exports = shallowEqual;

                /***/
            },
            /* 462 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * Given a `prevElement` and `nextElement`, determines if the existing
                 * instance should be updated as opposed to being destroyed or replaced by a new
                 * instance. Both arguments are elements. This ensures that this logic can
                 * operate on stateless trees without any backing instance.
                 *
                 * @param {?object} prevElement
                 * @param {?object} nextElement
                 * @return {boolean} True if the existing instance should be updated.
                 * @protected
                 */

                function shouldUpdateReactComponent(prevElement, nextElement) {
                    var prevEmpty =
                        prevElement === null || prevElement === false;
                    var nextEmpty =
                        nextElement === null || nextElement === false;
                    if (prevEmpty || nextEmpty) {
                        return prevEmpty === nextEmpty;
                    }

                    var prevType = typeof prevElement;
                    var nextType = typeof nextElement;
                    if (prevType === "string" || prevType === "number") {
                        return nextType === "string" || nextType === "number";
                    } else {
                        return (
                            nextType === "object" &&
                            prevElement.type === nextElement.type &&
                            prevElement.key === nextElement.key
                        );
                    }
                }

                module.exports = shouldUpdateReactComponent;

                /***/
            },
            /* 463 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var emptyComponentFactory;

                var ReactEmptyComponentInjection = {
                    injectEmptyComponentFactory: function (factory) {
                        emptyComponentFactory = factory;
                    },
                };

                var ReactEmptyComponent = {
                    create: function (instantiate) {
                        return emptyComponentFactory(instantiate);
                    },
                };

                ReactEmptyComponent.injection = ReactEmptyComponentInjection;

                module.exports = ReactEmptyComponent;

                /***/
            },
            /* 464 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                var genericComponentClass = null;
                var textComponentClass = null;

                var ReactHostComponentInjection = {
                    // This accepts a class that receives the tag string. This is a catch all
                    // that can render any kind of tag.
                    injectGenericComponentClass: function (componentClass) {
                        genericComponentClass = componentClass;
                    },
                    // This accepts a text component class that takes the text string to be
                    // rendered as props.
                    injectTextComponentClass: function (componentClass) {
                        textComponentClass = componentClass;
                    },
                };

                /**
                 * Get a host internal component class for a specific tag.
                 *
                 * @param {ReactElement} element The element to create.
                 * @return {function} The internal class constructor function.
                 */
                function createInternalComponent(element) {
                    !genericComponentClass
                        ? false
                            ? invariant(
                                  false,
                                  "There is no registered component for the tag %s",
                                  element.type
                              )
                            : _prodInvariant("111", element.type)
                        : void 0;
                    return new genericComponentClass(element);
                }

                /**
                 * @param {ReactText} text
                 * @return {ReactComponent}
                 */
                function createInstanceForText(text) {
                    return new textComponentClass(text);
                }

                /**
                 * @param {ReactComponent} component
                 * @return {boolean}
                 */
                function isTextComponent(component) {
                    return component instanceof textComponentClass;
                }

                var ReactHostComponent = {
                    createInternalComponent: createInternalComponent,
                    createInstanceForText: createInstanceForText,
                    isTextComponent: isTextComponent,
                    injection: ReactHostComponentInjection,
                };

                module.exports = ReactHostComponent;

                /***/
            },
            /* 465 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var nextDebugID = 1;

                function getNextDebugID() {
                    return nextDebugID++;
                }

                module.exports = getNextDebugID;

                /***/
            },
            /* 466 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                /**
                 * Escape and wrap key so it is safe to use as a reactid
                 *
                 * @param {string} key to be escaped.
                 * @return {string} the escaped key.
                 */

                function escape(key) {
                    var escapeRegex = /[=:]/g;
                    var escaperLookup = {
                        "=": "=0",
                        ":": "=2",
                    };
                    var escapedString = ("" + key).replace(
                        escapeRegex,
                        function (match) {
                            return escaperLookup[match];
                        }
                    );

                    return "$" + escapedString;
                }

                /**
                 * Unescape and unwrap key for human-readable display
                 *
                 * @param {string} key to unescape.
                 * @return {string} the unescaped key.
                 */
                function unescape(key) {
                    var unescapeRegex = /(=0|=2)/g;
                    var unescaperLookup = {
                        "=0": "=",
                        "=2": ":",
                    };
                    var keySubstring =
                        key[0] === "." && key[1] === "$"
                            ? key.substring(2)
                            : key.substring(1);

                    return ("" + keySubstring).replace(
                        unescapeRegex,
                        function (match) {
                            return unescaperLookup[match];
                        }
                    );
                }

                var KeyEscapeUtils = {
                    escape: escape,
                    unescape: unescape,
                };

                module.exports = KeyEscapeUtils;

                /***/
            },
            /* 467 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var ReactCurrentOwner = __webpack_require__(357);
                var REACT_ELEMENT_TYPE = __webpack_require__(468);

                var getIteratorFn = __webpack_require__(469);
                var invariant = __webpack_require__(355);
                var KeyEscapeUtils = __webpack_require__(466);
                var warning = __webpack_require__(358);

                var SEPARATOR = ".";
                var SUBSEPARATOR = ":";

                /**
                 * This is inlined from ReactElement since this file is shared between
                 * isomorphic and renderers. We could extract this to a
                 *
                 */

                /**
                 * TODO: Test that a single child and an array with one item have the same key
                 * pattern.
                 */

                var didWarnAboutMaps = false;

                /**
                 * Generate a key string that identifies a component within a set.
                 *
                 * @param {*} component A component that could contain a manual key.
                 * @param {number} index Index that is used if a manual key is not provided.
                 * @return {string}
                 */
                function getComponentKey(component, index) {
                    // Do some typechecking here since we call this blindly. We want to ensure
                    // that we don't block potential future ES APIs.
                    if (
                        component &&
                        typeof component === "object" &&
                        component.key != null
                    ) {
                        // Explicit key
                        return KeyEscapeUtils.escape(component.key);
                    }
                    // Implicit key determined by the index in the set
                    return index.toString(36);
                }

                /**
                 * @param {?*} children Children tree container.
                 * @param {!string} nameSoFar Name of the key path so far.
                 * @param {!function} callback Callback to invoke with each child found.
                 * @param {?*} traverseContext Used to pass information throughout the traversal
                 * process.
                 * @return {!number} The number of children in this subtree.
                 */
                function traverseAllChildrenImpl(
                    children,
                    nameSoFar,
                    callback,
                    traverseContext
                ) {
                    var type = typeof children;

                    if (type === "undefined" || type === "boolean") {
                        // All of the above are perceived as null.
                        children = null;
                    }

                    if (
                        children === null ||
                        type === "string" ||
                        type === "number" ||
                        // The following is inlined from ReactElement. This means we can optimize
                        // some checks. React Fiber also inlines this logic for similar purposes.
                        (type === "object" &&
                            children.$$typeof === REACT_ELEMENT_TYPE)
                    ) {
                        callback(
                            traverseContext,
                            children,
                            // If it's the only child, treat the name as if it was wrapped in an array
                            // so that it's consistent if the number of children grows.
                            nameSoFar === ""
                                ? SEPARATOR + getComponentKey(children, 0)
                                : nameSoFar
                        );
                        return 1;
                    }

                    var child;
                    var nextName;
                    var subtreeCount = 0; // Count of children found in the current subtree.
                    var nextNamePrefix =
                        nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;

                    if (Array.isArray(children)) {
                        for (var i = 0; i < children.length; i++) {
                            child = children[i];
                            nextName =
                                nextNamePrefix + getComponentKey(child, i);
                            subtreeCount += traverseAllChildrenImpl(
                                child,
                                nextName,
                                callback,
                                traverseContext
                            );
                        }
                    } else {
                        var iteratorFn = getIteratorFn(children);
                        if (iteratorFn) {
                            var iterator = iteratorFn.call(children);
                            var step;
                            if (iteratorFn !== children.entries) {
                                var ii = 0;
                                while (!(step = iterator.next()).done) {
                                    child = step.value;
                                    nextName =
                                        nextNamePrefix +
                                        getComponentKey(child, ii++);
                                    subtreeCount += traverseAllChildrenImpl(
                                        child,
                                        nextName,
                                        callback,
                                        traverseContext
                                    );
                                }
                            } else {
                                if (false) {
                                    var mapsAsChildrenAddendum = "";
                                    if (ReactCurrentOwner.current) {
                                        var mapsAsChildrenOwnerName =
                                            ReactCurrentOwner.current.getName();
                                        if (mapsAsChildrenOwnerName) {
                                            mapsAsChildrenAddendum =
                                                " Check the render method of `" +
                                                mapsAsChildrenOwnerName +
                                                "`.";
                                        }
                                    }
                                    process.env.NODE_ENV !== "production"
                                        ? warning(
                                              didWarnAboutMaps,
                                              "Using Maps as children is not yet fully supported. It is an " +
                                                  "experimental feature that might be removed. Convert it to a " +
                                                  "sequence / iterable of keyed ReactElements instead.%s",
                                              mapsAsChildrenAddendum
                                          )
                                        : void 0;
                                    didWarnAboutMaps = true;
                                }
                                // Iterator will provide entry [k,v] tuples rather than values.
                                while (!(step = iterator.next()).done) {
                                    var entry = step.value;
                                    if (entry) {
                                        child = entry[1];
                                        nextName =
                                            nextNamePrefix +
                                            KeyEscapeUtils.escape(entry[0]) +
                                            SUBSEPARATOR +
                                            getComponentKey(child, 0);
                                        subtreeCount += traverseAllChildrenImpl(
                                            child,
                                            nextName,
                                            callback,
                                            traverseContext
                                        );
                                    }
                                }
                            }
                        } else if (type === "object") {
                            var addendum = "";
                            if (false) {
                                addendum =
                                    " If you meant to render a collection of children, use an array " +
                                    "instead or wrap the object using createFragment(object) from the " +
                                    "React add-ons.";
                                if (children._isReactElement) {
                                    addendum =
                                        " It looks like you're using an element created by a different " +
                                        "version of React. Make sure to use only one copy of React.";
                                }
                                if (ReactCurrentOwner.current) {
                                    var name =
                                        ReactCurrentOwner.current.getName();
                                    if (name) {
                                        addendum +=
                                            " Check the render method of `" +
                                            name +
                                            "`.";
                                    }
                                }
                            }
                            var childrenString = String(children);
                            true
                                ? false
                                    ? invariant(
                                          false,
                                          "Objects are not valid as a React child (found: %s).%s",
                                          childrenString === "[object Object]"
                                              ? "object with keys {" +
                                                    Object.keys(children).join(
                                                        ", "
                                                    ) +
                                                    "}"
                                              : childrenString,
                                          addendum
                                      )
                                    : _prodInvariant(
                                          "31",
                                          childrenString === "[object Object]"
                                              ? "object with keys {" +
                                                    Object.keys(children).join(
                                                        ", "
                                                    ) +
                                                    "}"
                                              : childrenString,
                                          addendum
                                      )
                                : void 0;
                        }
                    }

                    return subtreeCount;
                }

                /**
                 * Traverses children that are typically specified as `props.children`, but
                 * might also be specified through attributes:
                 *
                 * - `traverseAllChildren(this.props.children, ...)`
                 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
                 *
                 * The `traverseContext` is an optional argument that is passed through the
                 * entire traversal. It can be used to store accumulations or anything else that
                 * the callback might find relevant.
                 *
                 * @param {?*} children Children tree object.
                 * @param {!function} callback To invoke upon traversing each child.
                 * @param {?*} traverseContext Context for traversal.
                 * @return {!number} The number of children in this subtree.
                 */
                function traverseAllChildren(
                    children,
                    callback,
                    traverseContext
                ) {
                    if (children == null) {
                        return 0;
                    }

                    return traverseAllChildrenImpl(
                        children,
                        "",
                        callback,
                        traverseContext
                    );
                }

                module.exports = traverseAllChildren;

                /***/
            },
            /* 468 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                // The Symbol used to tag the ReactElement type. If there is no native Symbol
                // nor polyfill, then a plain number is used for performance.

                var REACT_ELEMENT_TYPE =
                    (typeof Symbol === "function" &&
                        Symbol["for"] &&
                        Symbol["for"]("react.element")) ||
                    0xeac7;

                module.exports = REACT_ELEMENT_TYPE;

                /***/
            },
            /* 469 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                /* global Symbol */

                var ITERATOR_SYMBOL =
                    typeof Symbol === "function" && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.

                /**
                 * Returns the iterator method function contained on the iterable object.
                 *
                 * Be sure to invoke the function with the iterable as context:
                 *
                 *     var iteratorFn = getIteratorFn(myIterable);
                 *     if (iteratorFn) {
                 *       var iterator = iteratorFn.call(myIterable);
                 *       ...
                 *     }
                 *
                 * @param {?object} maybeIterable
                 * @return {?function}
                 */
                function getIteratorFn(maybeIterable) {
                    var iteratorFn =
                        maybeIterable &&
                        ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
                            maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if (typeof iteratorFn === "function") {
                        return iteratorFn;
                    }
                }

                module.exports = getIteratorFn;

                /***/
            },
            /* 470 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(354);

                var ReactCurrentOwner = __webpack_require__(357);

                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                function isNative(fn) {
                    // Based on isNative() from Lodash
                    var funcToString = Function.prototype.toString;
                    var hasOwnProperty = Object.prototype.hasOwnProperty;
                    var reIsNative = RegExp(
                        "^" +
                            funcToString
                                // Take an example native function source for comparison
                                .call(hasOwnProperty)
                                // Strip regex characters so we can use it for regex
                                .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                                // Remove hasOwnProperty from the template to make it generic
                                .replace(
                                    /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                                    "$1.*?"
                                ) +
                            "$"
                    );
                    try {
                        var source = funcToString.call(fn);
                        return reIsNative.test(source);
                    } catch (err) {
                        return false;
                    }
                }

                var canUseCollections =
                    // Array.from
                    typeof Array.from === "function" &&
                    // Map
                    typeof Map === "function" &&
                    isNative(Map) &&
                    // Map.prototype.keys
                    Map.prototype != null &&
                    typeof Map.prototype.keys === "function" &&
                    isNative(Map.prototype.keys) &&
                    // Set
                    typeof Set === "function" &&
                    isNative(Set) &&
                    // Set.prototype.keys
                    Set.prototype != null &&
                    typeof Set.prototype.keys === "function" &&
                    isNative(Set.prototype.keys);

                var setItem;
                var getItem;
                var removeItem;
                var getItemIDs;
                var addRoot;
                var removeRoot;
                var getRootIDs;

                if (canUseCollections) {
                    var itemMap = new Map();
                    var rootIDSet = new Set();

                    setItem = function (id, item) {
                        itemMap.set(id, item);
                    };
                    getItem = function (id) {
                        return itemMap.get(id);
                    };
                    removeItem = function (id) {
                        itemMap["delete"](id);
                    };
                    getItemIDs = function () {
                        return Array.from(itemMap.keys());
                    };

                    addRoot = function (id) {
                        rootIDSet.add(id);
                    };
                    removeRoot = function (id) {
                        rootIDSet["delete"](id);
                    };
                    getRootIDs = function () {
                        return Array.from(rootIDSet.keys());
                    };
                } else {
                    var itemByKey = {};
                    var rootByKey = {};

                    // Use non-numeric keys to prevent V8 performance issues:
                    // https://github.com/facebook/react/pull/7232
                    var getKeyFromID = function (id) {
                        return "." + id;
                    };
                    var getIDFromKey = function (key) {
                        return parseInt(key.substr(1), 10);
                    };

                    setItem = function (id, item) {
                        var key = getKeyFromID(id);
                        itemByKey[key] = item;
                    };
                    getItem = function (id) {
                        var key = getKeyFromID(id);
                        return itemByKey[key];
                    };
                    removeItem = function (id) {
                        var key = getKeyFromID(id);
                        delete itemByKey[key];
                    };
                    getItemIDs = function () {
                        return Object.keys(itemByKey).map(getIDFromKey);
                    };

                    addRoot = function (id) {
                        var key = getKeyFromID(id);
                        rootByKey[key] = true;
                    };
                    removeRoot = function (id) {
                        var key = getKeyFromID(id);
                        delete rootByKey[key];
                    };
                    getRootIDs = function () {
                        return Object.keys(rootByKey).map(getIDFromKey);
                    };
                }

                var unmountedIDs = [];

                function purgeDeep(id) {
                    var item = getItem(id);
                    if (item) {
                        var childIDs = item.childIDs;

                        removeItem(id);
                        childIDs.forEach(purgeDeep);
                    }
                }

                function describeComponentFrame(name, source, ownerName) {
                    return (
                        "\n    in " +
                        (name || "Unknown") +
                        (source
                            ? " (at " +
                              source.fileName.replace(/^.*[\\\/]/, "") +
                              ":" +
                              source.lineNumber +
                              ")"
                            : ownerName
                            ? " (created by " + ownerName + ")"
                            : "")
                    );
                }

                function getDisplayName(element) {
                    if (element == null) {
                        return "#empty";
                    } else if (
                        typeof element === "string" ||
                        typeof element === "number"
                    ) {
                        return "#text";
                    } else if (typeof element.type === "string") {
                        return element.type;
                    } else {
                        return (
                            element.type.displayName ||
                            element.type.name ||
                            "Unknown"
                        );
                    }
                }

                function describeID(id) {
                    var name = ReactComponentTreeHook.getDisplayName(id);
                    var element = ReactComponentTreeHook.getElement(id);
                    var ownerID = ReactComponentTreeHook.getOwnerID(id);
                    var ownerName;
                    if (ownerID) {
                        ownerName =
                            ReactComponentTreeHook.getDisplayName(ownerID);
                    }
                    false
                        ? warning(
                              element,
                              "ReactComponentTreeHook: Missing React element for debugID %s when " +
                                  "building stack",
                              id
                          )
                        : void 0;
                    return describeComponentFrame(
                        name,
                        element && element._source,
                        ownerName
                    );
                }

                var ReactComponentTreeHook = {
                    onSetChildren: function (id, nextChildIDs) {
                        var item = getItem(id);
                        !item
                            ? false
                                ? invariant(false, "Item must have been set")
                                : _prodInvariant("144")
                            : void 0;
                        item.childIDs = nextChildIDs;

                        for (var i = 0; i < nextChildIDs.length; i++) {
                            var nextChildID = nextChildIDs[i];
                            var nextChild = getItem(nextChildID);
                            !nextChild
                                ? false
                                    ? invariant(
                                          false,
                                          "Expected hook events to fire for the child before its parent includes it in onSetChildren()."
                                      )
                                    : _prodInvariant("140")
                                : void 0;
                            !(
                                nextChild.childIDs != null ||
                                typeof nextChild.element !== "object" ||
                                nextChild.element == null
                            )
                                ? false
                                    ? invariant(
                                          false,
                                          "Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren()."
                                      )
                                    : _prodInvariant("141")
                                : void 0;
                            !nextChild.isMounted
                                ? false
                                    ? invariant(
                                          false,
                                          "Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren()."
                                      )
                                    : _prodInvariant("71")
                                : void 0;
                            if (nextChild.parentID == null) {
                                nextChild.parentID = id;
                                // TODO: This shouldn't be necessary but mounting a new root during in
                                // componentWillMount currently causes not-yet-mounted components to
                                // be purged from our tree data so their parent id is missing.
                            }
                            !(nextChild.parentID === id)
                                ? false
                                    ? invariant(
                                          false,
                                          "Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).",
                                          nextChildID,
                                          nextChild.parentID,
                                          id
                                      )
                                    : _prodInvariant(
                                          "142",
                                          nextChildID,
                                          nextChild.parentID,
                                          id
                                      )
                                : void 0;
                        }
                    },
                    onBeforeMountComponent: function (id, element, parentID) {
                        var item = {
                            element: element,
                            parentID: parentID,
                            text: null,
                            childIDs: [],
                            isMounted: false,
                            updateCount: 0,
                        };
                        setItem(id, item);
                    },
                    onBeforeUpdateComponent: function (id, element) {
                        var item = getItem(id);
                        if (!item || !item.isMounted) {
                            // We may end up here as a result of setState() in componentWillUnmount().
                            // In this case, ignore the element.
                            return;
                        }
                        item.element = element;
                    },
                    onMountComponent: function (id) {
                        var item = getItem(id);
                        !item
                            ? false
                                ? invariant(false, "Item must have been set")
                                : _prodInvariant("144")
                            : void 0;
                        item.isMounted = true;
                        var isRoot = item.parentID === 0;
                        if (isRoot) {
                            addRoot(id);
                        }
                    },
                    onUpdateComponent: function (id) {
                        var item = getItem(id);
                        if (!item || !item.isMounted) {
                            // We may end up here as a result of setState() in componentWillUnmount().
                            // In this case, ignore the element.
                            return;
                        }
                        item.updateCount++;
                    },
                    onUnmountComponent: function (id) {
                        var item = getItem(id);
                        if (item) {
                            // We need to check if it exists.
                            // `item` might not exist if it is inside an error boundary, and a sibling
                            // error boundary child threw while mounting. Then this instance never
                            // got a chance to mount, but it still gets an unmounting event during
                            // the error boundary cleanup.
                            item.isMounted = false;
                            var isRoot = item.parentID === 0;
                            if (isRoot) {
                                removeRoot(id);
                            }
                        }
                        unmountedIDs.push(id);
                    },
                    purgeUnmountedComponents: function () {
                        if (ReactComponentTreeHook._preventPurging) {
                            // Should only be used for testing.
                            return;
                        }

                        for (var i = 0; i < unmountedIDs.length; i++) {
                            var id = unmountedIDs[i];
                            purgeDeep(id);
                        }
                        unmountedIDs.length = 0;
                    },
                    isMounted: function (id) {
                        var item = getItem(id);
                        return item ? item.isMounted : false;
                    },
                    getCurrentStackAddendum: function (topElement) {
                        var info = "";
                        if (topElement) {
                            var name = getDisplayName(topElement);
                            var owner = topElement._owner;
                            info += describeComponentFrame(
                                name,
                                topElement._source,
                                owner && owner.getName()
                            );
                        }

                        var currentOwner = ReactCurrentOwner.current;
                        var id = currentOwner && currentOwner._debugID;

                        info += ReactComponentTreeHook.getStackAddendumByID(id);
                        return info;
                    },
                    getStackAddendumByID: function (id) {
                        var info = "";
                        while (id) {
                            info += describeID(id);
                            id = ReactComponentTreeHook.getParentID(id);
                        }
                        return info;
                    },
                    getChildIDs: function (id) {
                        var item = getItem(id);
                        return item ? item.childIDs : [];
                    },
                    getDisplayName: function (id) {
                        var element = ReactComponentTreeHook.getElement(id);
                        if (!element) {
                            return null;
                        }
                        return getDisplayName(element);
                    },
                    getElement: function (id) {
                        var item = getItem(id);
                        return item ? item.element : null;
                    },
                    getOwnerID: function (id) {
                        var element = ReactComponentTreeHook.getElement(id);
                        if (!element || !element._owner) {
                            return null;
                        }
                        return element._owner._debugID;
                    },
                    getParentID: function (id) {
                        var item = getItem(id);
                        return item ? item.parentID : null;
                    },
                    getSource: function (id) {
                        var item = getItem(id);
                        var element = item ? item.element : null;
                        var source = element != null ? element._source : null;
                        return source;
                    },
                    getText: function (id) {
                        var element = ReactComponentTreeHook.getElement(id);
                        if (typeof element === "string") {
                            return element;
                        } else if (typeof element === "number") {
                            return "" + element;
                        } else {
                            return null;
                        }
                    },
                    getUpdateCount: function (id) {
                        var item = getItem(id);
                        return item ? item.updateCount : 0;
                    },

                    getRootIDs: getRootIDs,
                    getRegisteredIDs: getItemIDs,
                };

                module.exports = ReactComponentTreeHook;

                /***/
            },
            /* 471 */
            /***/ function (module, exports, __webpack_require__) {
                /* WEBPACK VAR INJECTION */ (function (process) {
                    /**
                     * Copyright 2013-present, Facebook, Inc.
                     * All rights reserved.
                     *
                     * This source code is licensed under the BSD-style license found in the
                     * LICENSE file in the root directory of this source tree. An additional grant
                     * of patent rights can be found in the PATENTS file in the same directory.
                     *
                     *
                     */

                    "use strict";

                    var KeyEscapeUtils = __webpack_require__(466);
                    var traverseAllChildren = __webpack_require__(467);
                    var warning = __webpack_require__(358);

                    var ReactComponentTreeHook;

                    if (
                        typeof process !== "undefined" && {
                            NODE_ENV: "production",
                        } &&
                        "production" === "test"
                    ) {
                        // Temporary hack.
                        // Inline requires don't work well with Jest:
                        // https://github.com/facebook/react/issues/7240
                        // Remove the inline requires when we don't need them anymore:
                        // https://github.com/facebook/react/pull/7178
                        ReactComponentTreeHook = __webpack_require__(470);
                    }

                    /**
                     * @param {function} traverseContext Context passed through traversal.
                     * @param {?ReactComponent} child React child component.
                     * @param {!string} name String name of key path to child.
                     * @param {number=} selfDebugID Optional debugID of the current internal instance.
                     */
                    function flattenSingleChildIntoContext(
                        traverseContext,
                        child,
                        name,
                        selfDebugID
                    ) {
                        // We found a component instance.
                        if (
                            traverseContext &&
                            typeof traverseContext === "object"
                        ) {
                            var result = traverseContext;
                            var keyUnique = result[name] === undefined;
                            if (false) {
                                if (!ReactComponentTreeHook) {
                                    ReactComponentTreeHook = require("react/lib/ReactComponentTreeHook");
                                }
                                if (!keyUnique) {
                                    process.env.NODE_ENV !== "production"
                                        ? warning(
                                              false,
                                              "flattenChildren(...): Encountered two children with the same key, " +
                                                  "`%s`. Child keys must be unique; when two children share a key, only " +
                                                  "the first child will be used.%s",
                                              KeyEscapeUtils.unescape(name),
                                              ReactComponentTreeHook.getStackAddendumByID(
                                                  selfDebugID
                                              )
                                          )
                                        : void 0;
                                }
                            }
                            if (keyUnique && child != null) {
                                result[name] = child;
                            }
                        }
                    }

                    /**
                     * Flattens children that are typically specified as `props.children`. Any null
                     * children will not be included in the resulting object.
                     * @return {!object} flattened children keyed by name.
                     */
                    function flattenChildren(children, selfDebugID) {
                        if (children == null) {
                            return children;
                        }
                        var result = {};

                        if (false) {
                            traverseAllChildren(
                                children,
                                function (traverseContext, child, name) {
                                    return flattenSingleChildIntoContext(
                                        traverseContext,
                                        child,
                                        name,
                                        selfDebugID
                                    );
                                },
                                result
                            );
                        } else {
                            traverseAllChildren(
                                children,
                                flattenSingleChildIntoContext,
                                result
                            );
                        }
                        return result;
                    }

                    module.exports = flattenChildren;
                    /* WEBPACK VAR INJECTION */
                }.call(exports, __webpack_require__(25)));

                /***/
            },
            /* 472 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var PooledClass = __webpack_require__(395);
                var Transaction = __webpack_require__(408);
                var ReactInstrumentation = __webpack_require__(407);
                var ReactServerUpdateQueue = __webpack_require__(473);

                /**
                 * Executed within the scope of the `Transaction` instance. Consider these as
                 * being member methods, but with an implied ordering while being isolated from
                 * each other.
                 */
                var TRANSACTION_WRAPPERS = [];

                if (false) {
                    TRANSACTION_WRAPPERS.push({
                        initialize: ReactInstrumentation.debugTool.onBeginFlush,
                        close: ReactInstrumentation.debugTool.onEndFlush,
                    });
                }

                var noopCallbackQueue = {
                    enqueue: function () {},
                };

                /**
                 * @class ReactServerRenderingTransaction
                 * @param {boolean} renderToStaticMarkup
                 */
                function ReactServerRenderingTransaction(renderToStaticMarkup) {
                    this.reinitializeTransaction();
                    this.renderToStaticMarkup = renderToStaticMarkup;
                    this.useCreateElement = false;
                    this.updateQueue = new ReactServerUpdateQueue(this);
                }

                var Mixin = {
                    /**
                     * @see Transaction
                     * @abstract
                     * @final
                     * @return {array} Empty list of operation wrap procedures.
                     */
                    getTransactionWrappers: function () {
                        return TRANSACTION_WRAPPERS;
                    },

                    /**
                     * @return {object} The queue to collect `onDOMReady` callbacks with.
                     */
                    getReactMountReady: function () {
                        return noopCallbackQueue;
                    },

                    /**
                     * @return {object} The queue to collect React async events.
                     */
                    getUpdateQueue: function () {
                        return this.updateQueue;
                    },

                    /**
                     * `PooledClass` looks for this, and will invoke this before allowing this
                     * instance to be reused.
                     */
                    destructor: function () {},

                    checkpoint: function () {},

                    rollback: function () {},
                };

                _assign(
                    ReactServerRenderingTransaction.prototype,
                    Transaction,
                    Mixin
                );

                PooledClass.addPoolingTo(ReactServerRenderingTransaction);

                module.exports = ReactServerRenderingTransaction;

                /***/
            },
            /* 473 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                var ReactUpdateQueue = __webpack_require__(474);

                var warning = __webpack_require__(358);

                function warnNoop(publicInstance, callerName) {
                    if (false) {
                        var constructor = publicInstance.constructor;
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  false,
                                  "%s(...): Can only update a mounting component. " +
                                      "This usually means you called %s() outside componentWillMount() on the server. " +
                                      "This is a no-op. Please check the code for the %s component.",
                                  callerName,
                                  callerName,
                                  (constructor &&
                                      (constructor.displayName ||
                                          constructor.name)) ||
                                      "ReactClass"
                              )
                            : void 0;
                    }
                }

                /**
                 * This is the update queue used for server rendering.
                 * It delegates to ReactUpdateQueue while server rendering is in progress and
                 * switches to ReactNoopUpdateQueue after the transaction has completed.
                 * @class ReactServerUpdateQueue
                 * @param {Transaction} transaction
                 */

                var ReactServerUpdateQueue = (function () {
                    function ReactServerUpdateQueue(transaction) {
                        _classCallCheck(this, ReactServerUpdateQueue);

                        this.transaction = transaction;
                    }

                    /**
                     * Checks whether or not this composite component is mounted.
                     * @param {ReactClass} publicInstance The instance we want to test.
                     * @return {boolean} True if mounted, false otherwise.
                     * @protected
                     * @final
                     */

                    ReactServerUpdateQueue.prototype.isMounted =
                        function isMounted(publicInstance) {
                            return false;
                        };

                    /**
                     * Enqueue a callback that will be executed after all the pending updates
                     * have processed.
                     *
                     * @param {ReactClass} publicInstance The instance to use as `this` context.
                     * @param {?function} callback Called after state is updated.
                     * @internal
                     */

                    ReactServerUpdateQueue.prototype.enqueueCallback =
                        function enqueueCallback(
                            publicInstance,
                            callback,
                            callerName
                        ) {
                            if (this.transaction.isInTransaction()) {
                                ReactUpdateQueue.enqueueCallback(
                                    publicInstance,
                                    callback,
                                    callerName
                                );
                            }
                        };

                    /**
                     * Forces an update. This should only be invoked when it is known with
                     * certainty that we are **not** in a DOM transaction.
                     *
                     * You may want to call this when you know that some deeper aspect of the
                     * component's state has changed but `setState` was not called.
                     *
                     * This will not invoke `shouldComponentUpdate`, but it will invoke
                     * `componentWillUpdate` and `componentDidUpdate`.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @internal
                     */

                    ReactServerUpdateQueue.prototype.enqueueForceUpdate =
                        function enqueueForceUpdate(publicInstance) {
                            if (this.transaction.isInTransaction()) {
                                ReactUpdateQueue.enqueueForceUpdate(
                                    publicInstance
                                );
                            } else {
                                warnNoop(publicInstance, "forceUpdate");
                            }
                        };

                    /**
                     * Replaces all of the state. Always use this or `setState` to mutate state.
                     * You should treat `this.state` as immutable.
                     *
                     * There is no guarantee that `this.state` will be immediately updated, so
                     * accessing `this.state` after calling this method may return the old value.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object|function} completeState Next state.
                     * @internal
                     */

                    ReactServerUpdateQueue.prototype.enqueueReplaceState =
                        function enqueueReplaceState(
                            publicInstance,
                            completeState
                        ) {
                            if (this.transaction.isInTransaction()) {
                                ReactUpdateQueue.enqueueReplaceState(
                                    publicInstance,
                                    completeState
                                );
                            } else {
                                warnNoop(publicInstance, "replaceState");
                            }
                        };

                    /**
                     * Sets a subset of the state. This only exists because _pendingState is
                     * internal. This provides a merging strategy that is not available to deep
                     * properties which is confusing. TODO: Expose pendingState or don't use it
                     * during the merge.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object|function} partialState Next partial state to be merged with state.
                     * @internal
                     */

                    ReactServerUpdateQueue.prototype.enqueueSetState =
                        function enqueueSetState(publicInstance, partialState) {
                            if (this.transaction.isInTransaction()) {
                                ReactUpdateQueue.enqueueSetState(
                                    publicInstance,
                                    partialState
                                );
                            } else {
                                warnNoop(publicInstance, "setState");
                            }
                        };

                    return ReactServerUpdateQueue;
                })();

                module.exports = ReactServerUpdateQueue;

                /***/
            },
            /* 474 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var ReactCurrentOwner = __webpack_require__(357);
                var ReactInstanceMap = __webpack_require__(456);
                var ReactInstrumentation = __webpack_require__(407);
                var ReactUpdates = __webpack_require__(401);

                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                function enqueueUpdate(internalInstance) {
                    ReactUpdates.enqueueUpdate(internalInstance);
                }

                function formatUnexpectedArgument(arg) {
                    var type = typeof arg;
                    if (type !== "object") {
                        return type;
                    }
                    var displayName =
                        (arg.constructor && arg.constructor.name) || type;
                    var keys = Object.keys(arg);
                    if (keys.length > 0 && keys.length < 20) {
                        return displayName + " (keys: " + keys.join(", ") + ")";
                    }
                    return displayName;
                }

                function getInternalInstanceReadyForUpdate(
                    publicInstance,
                    callerName
                ) {
                    var internalInstance = ReactInstanceMap.get(publicInstance);
                    if (!internalInstance) {
                        if (false) {
                            var ctor = publicInstance.constructor;
                            // Only warn when we have a callerName. Otherwise we should be silent.
                            // We're probably calling from enqueueCallback. We don't want to warn
                            // there because we already warned for the corresponding lifecycle method.
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !callerName,
                                      "%s(...): Can only update a mounted or mounting component. " +
                                          "This usually means you called %s() on an unmounted component. " +
                                          "This is a no-op. Please check the code for the %s component.",
                                      callerName,
                                      callerName,
                                      (ctor &&
                                          (ctor.displayName || ctor.name)) ||
                                          "ReactClass"
                                  )
                                : void 0;
                        }
                        return null;
                    }

                    if (false) {
                        process.env.NODE_ENV !== "production"
                            ? warning(
                                  ReactCurrentOwner.current == null,
                                  "%s(...): Cannot update during an existing state transition (such as " +
                                      "within `render` or another component's constructor). Render methods " +
                                      "should be a pure function of props and state; constructor " +
                                      "side-effects are an anti-pattern, but can be moved to " +
                                      "`componentWillMount`.",
                                  callerName
                              )
                            : void 0;
                    }

                    return internalInstance;
                }

                /**
                 * ReactUpdateQueue allows for state updates to be scheduled into a later
                 * reconciliation step.
                 */
                var ReactUpdateQueue = {
                    /**
                     * Checks whether or not this composite component is mounted.
                     * @param {ReactClass} publicInstance The instance we want to test.
                     * @return {boolean} True if mounted, false otherwise.
                     * @protected
                     * @final
                     */
                    isMounted: function (publicInstance) {
                        if (false) {
                            var owner = ReactCurrentOwner.current;
                            if (owner !== null) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          owner._warnedAboutRefsInRender,
                                          "%s is accessing isMounted inside its render() function. " +
                                              "render() should be a pure function of props and state. It should " +
                                              "never access something that requires stale data from the previous " +
                                              "render, such as refs. Move this logic to componentDidMount and " +
                                              "componentDidUpdate instead.",
                                          owner.getName() || "A component"
                                      )
                                    : void 0;
                                owner._warnedAboutRefsInRender = true;
                            }
                        }
                        var internalInstance =
                            ReactInstanceMap.get(publicInstance);
                        if (internalInstance) {
                            // During componentWillMount and render this will still be null but after
                            // that will always render to something. At least for now. So we can use
                            // this hack.
                            return !!internalInstance._renderedComponent;
                        } else {
                            return false;
                        }
                    },

                    /**
                     * Enqueue a callback that will be executed after all the pending updates
                     * have processed.
                     *
                     * @param {ReactClass} publicInstance The instance to use as `this` context.
                     * @param {?function} callback Called after state is updated.
                     * @param {string} callerName Name of the calling function in the public API.
                     * @internal
                     */
                    enqueueCallback: function (
                        publicInstance,
                        callback,
                        callerName
                    ) {
                        ReactUpdateQueue.validateCallback(callback, callerName);
                        var internalInstance =
                            getInternalInstanceReadyForUpdate(publicInstance);

                        // Previously we would throw an error if we didn't have an internal
                        // instance. Since we want to make it a no-op instead, we mirror the same
                        // behavior we have in other enqueue* methods.
                        // We also need to ignore callbacks in componentWillMount. See
                        // enqueueUpdates.
                        if (!internalInstance) {
                            return null;
                        }

                        if (internalInstance._pendingCallbacks) {
                            internalInstance._pendingCallbacks.push(callback);
                        } else {
                            internalInstance._pendingCallbacks = [callback];
                        }
                        // TODO: The callback here is ignored when setState is called from
                        // componentWillMount. Either fix it or disallow doing so completely in
                        // favor of getInitialState. Alternatively, we can disallow
                        // componentWillMount during server-side rendering.
                        enqueueUpdate(internalInstance);
                    },

                    enqueueCallbackInternal: function (
                        internalInstance,
                        callback
                    ) {
                        if (internalInstance._pendingCallbacks) {
                            internalInstance._pendingCallbacks.push(callback);
                        } else {
                            internalInstance._pendingCallbacks = [callback];
                        }
                        enqueueUpdate(internalInstance);
                    },

                    /**
                     * Forces an update. This should only be invoked when it is known with
                     * certainty that we are **not** in a DOM transaction.
                     *
                     * You may want to call this when you know that some deeper aspect of the
                     * component's state has changed but `setState` was not called.
                     *
                     * This will not invoke `shouldComponentUpdate`, but it will invoke
                     * `componentWillUpdate` and `componentDidUpdate`.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @internal
                     */
                    enqueueForceUpdate: function (publicInstance) {
                        var internalInstance =
                            getInternalInstanceReadyForUpdate(
                                publicInstance,
                                "forceUpdate"
                            );

                        if (!internalInstance) {
                            return;
                        }

                        internalInstance._pendingForceUpdate = true;

                        enqueueUpdate(internalInstance);
                    },

                    /**
                     * Replaces all of the state. Always use this or `setState` to mutate state.
                     * You should treat `this.state` as immutable.
                     *
                     * There is no guarantee that `this.state` will be immediately updated, so
                     * accessing `this.state` after calling this method may return the old value.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object} completeState Next state.
                     * @internal
                     */
                    enqueueReplaceState: function (
                        publicInstance,
                        completeState
                    ) {
                        var internalInstance =
                            getInternalInstanceReadyForUpdate(
                                publicInstance,
                                "replaceState"
                            );

                        if (!internalInstance) {
                            return;
                        }

                        internalInstance._pendingStateQueue = [completeState];
                        internalInstance._pendingReplaceState = true;

                        enqueueUpdate(internalInstance);
                    },

                    /**
                     * Sets a subset of the state. This only exists because _pendingState is
                     * internal. This provides a merging strategy that is not available to deep
                     * properties which is confusing. TODO: Expose pendingState or don't use it
                     * during the merge.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object} partialState Next partial state to be merged with state.
                     * @internal
                     */
                    enqueueSetState: function (publicInstance, partialState) {
                        if (false) {
                            ReactInstrumentation.debugTool.onSetState();
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      partialState != null,
                                      "setState(...): You passed an undefined or null state object; " +
                                          "instead, use forceUpdate()."
                                  )
                                : void 0;
                        }

                        var internalInstance =
                            getInternalInstanceReadyForUpdate(
                                publicInstance,
                                "setState"
                            );

                        if (!internalInstance) {
                            return;
                        }

                        var queue =
                            internalInstance._pendingStateQueue ||
                            (internalInstance._pendingStateQueue = []);
                        queue.push(partialState);

                        enqueueUpdate(internalInstance);
                    },

                    enqueueElementInternal: function (
                        internalInstance,
                        nextElement,
                        nextContext
                    ) {
                        internalInstance._pendingElement = nextElement;
                        // TODO: introduce _pendingContext instead of setting it directly.
                        internalInstance._context = nextContext;
                        enqueueUpdate(internalInstance);
                    },

                    validateCallback: function (callback, callerName) {
                        !(!callback || typeof callback === "function")
                            ? false
                                ? invariant(
                                      false,
                                      "%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",
                                      callerName,
                                      formatUnexpectedArgument(callback)
                                  )
                                : _prodInvariant(
                                      "122",
                                      callerName,
                                      formatUnexpectedArgument(callback)
                                  )
                            : void 0;
                    },
                };

                module.exports = ReactUpdateQueue;

                /***/
            },
            /* 475 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var emptyFunction = __webpack_require__(359);
                var warning = __webpack_require__(358);

                var validateDOMNesting = emptyFunction;

                if (false) {
                    // This validation code was written based on the HTML5 parsing spec:
                    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
                    //
                    // Note: this does not catch all invalid nesting, nor does it try to (as it's
                    // not clear what practical benefit doing so provides); instead, we warn only
                    // for cases where the parser will give a parse tree differing from what React
                    // intended. For example, <b><div></div></b> is invalid but we don't warn
                    // because it still parses correctly; we do warn for other cases like nested
                    // <p> tags where the beginning of the second element implicitly closes the
                    // first, causing a confusing mess.

                    // https://html.spec.whatwg.org/multipage/syntax.html#special
                    var specialTags = [
                        "address",
                        "applet",
                        "area",
                        "article",
                        "aside",
                        "base",
                        "basefont",
                        "bgsound",
                        "blockquote",
                        "body",
                        "br",
                        "button",
                        "caption",
                        "center",
                        "col",
                        "colgroup",
                        "dd",
                        "details",
                        "dir",
                        "div",
                        "dl",
                        "dt",
                        "embed",
                        "fieldset",
                        "figcaption",
                        "figure",
                        "footer",
                        "form",
                        "frame",
                        "frameset",
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6",
                        "head",
                        "header",
                        "hgroup",
                        "hr",
                        "html",
                        "iframe",
                        "img",
                        "input",
                        "isindex",
                        "li",
                        "link",
                        "listing",
                        "main",
                        "marquee",
                        "menu",
                        "menuitem",
                        "meta",
                        "nav",
                        "noembed",
                        "noframes",
                        "noscript",
                        "object",
                        "ol",
                        "p",
                        "param",
                        "plaintext",
                        "pre",
                        "script",
                        "section",
                        "select",
                        "source",
                        "style",
                        "summary",
                        "table",
                        "tbody",
                        "td",
                        "template",
                        "textarea",
                        "tfoot",
                        "th",
                        "thead",
                        "title",
                        "tr",
                        "track",
                        "ul",
                        "wbr",
                        "xmp",
                    ];

                    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
                    var inScopeTags = [
                        "applet",
                        "caption",
                        "html",
                        "table",
                        "td",
                        "th",
                        "marquee",
                        "object",
                        "template",

                        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
                        // TODO: Distinguish by namespace here -- for <title>, including it here
                        // errs on the side of fewer warnings
                        "foreignObject",
                        "desc",
                        "title",
                    ];

                    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
                    var buttonScopeTags = inScopeTags.concat(["button"]);

                    // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
                    var impliedEndTags = [
                        "dd",
                        "dt",
                        "li",
                        "option",
                        "optgroup",
                        "p",
                        "rp",
                        "rt",
                    ];

                    var emptyAncestorInfo = {
                        current: null,

                        formTag: null,
                        aTagInScope: null,
                        buttonTagInScope: null,
                        nobrTagInScope: null,
                        pTagInButtonScope: null,

                        listItemTagAutoclosing: null,
                        dlItemTagAutoclosing: null,
                    };

                    var updatedAncestorInfo = function (
                        oldInfo,
                        tag,
                        instance
                    ) {
                        var ancestorInfo = _assign(
                            {},
                            oldInfo || emptyAncestorInfo
                        );
                        var info = { tag: tag, instance: instance };

                        if (inScopeTags.indexOf(tag) !== -1) {
                            ancestorInfo.aTagInScope = null;
                            ancestorInfo.buttonTagInScope = null;
                            ancestorInfo.nobrTagInScope = null;
                        }
                        if (buttonScopeTags.indexOf(tag) !== -1) {
                            ancestorInfo.pTagInButtonScope = null;
                        }

                        // See rules for 'li', 'dd', 'dt' start tags in
                        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
                        if (
                            specialTags.indexOf(tag) !== -1 &&
                            tag !== "address" &&
                            tag !== "div" &&
                            tag !== "p"
                        ) {
                            ancestorInfo.listItemTagAutoclosing = null;
                            ancestorInfo.dlItemTagAutoclosing = null;
                        }

                        ancestorInfo.current = info;

                        if (tag === "form") {
                            ancestorInfo.formTag = info;
                        }
                        if (tag === "a") {
                            ancestorInfo.aTagInScope = info;
                        }
                        if (tag === "button") {
                            ancestorInfo.buttonTagInScope = info;
                        }
                        if (tag === "nobr") {
                            ancestorInfo.nobrTagInScope = info;
                        }
                        if (tag === "p") {
                            ancestorInfo.pTagInButtonScope = info;
                        }
                        if (tag === "li") {
                            ancestorInfo.listItemTagAutoclosing = info;
                        }
                        if (tag === "dd" || tag === "dt") {
                            ancestorInfo.dlItemTagAutoclosing = info;
                        }

                        return ancestorInfo;
                    };

                    /**
                     * Returns whether
                     */
                    var isTagValidWithParent = function (tag, parentTag) {
                        // First, let's check if we're in an unusual parsing mode...
                        switch (parentTag) {
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
                            case "select":
                                return (
                                    tag === "option" ||
                                    tag === "optgroup" ||
                                    tag === "#text"
                                );
                            case "optgroup":
                                return tag === "option" || tag === "#text";
                            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
                            // but
                            case "option":
                                return tag === "#text";

                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
                            // No special behavior since these rules fall back to "in body" mode for
                            // all except special table nodes which cause bad parsing behavior anyway.

                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
                            case "tr":
                                return (
                                    tag === "th" ||
                                    tag === "td" ||
                                    tag === "style" ||
                                    tag === "script" ||
                                    tag === "template"
                                );

                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
                            case "tbody":
                            case "thead":
                            case "tfoot":
                                return (
                                    tag === "tr" ||
                                    tag === "style" ||
                                    tag === "script" ||
                                    tag === "template"
                                );

                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
                            case "colgroup":
                                return tag === "col" || tag === "template";

                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
                            case "table":
                                return (
                                    tag === "caption" ||
                                    tag === "colgroup" ||
                                    tag === "tbody" ||
                                    tag === "tfoot" ||
                                    tag === "thead" ||
                                    tag === "style" ||
                                    tag === "script" ||
                                    tag === "template"
                                );

                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
                            case "head":
                                return (
                                    tag === "base" ||
                                    tag === "basefont" ||
                                    tag === "bgsound" ||
                                    tag === "link" ||
                                    tag === "meta" ||
                                    tag === "title" ||
                                    tag === "noscript" ||
                                    tag === "noframes" ||
                                    tag === "style" ||
                                    tag === "script" ||
                                    tag === "template"
                                );

                            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
                            case "html":
                                return tag === "head" || tag === "body";
                            case "#document":
                                return tag === "html";
                        }

                        // Probably in the "in body" parsing mode, so we outlaw only tag combos
                        // where the parsing rules cause implicit opens or closes to be added.
                        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
                        switch (tag) {
                            case "h1":
                            case "h2":
                            case "h3":
                            case "h4":
                            case "h5":
                            case "h6":
                                return (
                                    parentTag !== "h1" &&
                                    parentTag !== "h2" &&
                                    parentTag !== "h3" &&
                                    parentTag !== "h4" &&
                                    parentTag !== "h5" &&
                                    parentTag !== "h6"
                                );

                            case "rp":
                            case "rt":
                                return impliedEndTags.indexOf(parentTag) === -1;

                            case "body":
                            case "caption":
                            case "col":
                            case "colgroup":
                            case "frame":
                            case "head":
                            case "html":
                            case "tbody":
                            case "td":
                            case "tfoot":
                            case "th":
                            case "thead":
                            case "tr":
                                // These tags are only valid with a few parents that have special child
                                // parsing rules -- if we're down here, then none of those matched and
                                // so we allow it only if we don't know what the parent is, as all other
                                // cases are invalid.
                                return parentTag == null;
                        }

                        return true;
                    };

                    /**
                     * Returns whether
                     */
                    var findInvalidAncestorForTag = function (
                        tag,
                        ancestorInfo
                    ) {
                        switch (tag) {
                            case "address":
                            case "article":
                            case "aside":
                            case "blockquote":
                            case "center":
                            case "details":
                            case "dialog":
                            case "dir":
                            case "div":
                            case "dl":
                            case "fieldset":
                            case "figcaption":
                            case "figure":
                            case "footer":
                            case "header":
                            case "hgroup":
                            case "main":
                            case "menu":
                            case "nav":
                            case "ol":
                            case "p":
                            case "section":
                            case "summary":
                            case "ul":

                            case "pre":
                            case "listing":

                            case "table":

                            case "hr":

                            case "xmp":

                            case "h1":
                            case "h2":
                            case "h3":
                            case "h4":
                            case "h5":
                            case "h6":
                                return ancestorInfo.pTagInButtonScope;

                            case "form":
                                return (
                                    ancestorInfo.formTag ||
                                    ancestorInfo.pTagInButtonScope
                                );

                            case "li":
                                return ancestorInfo.listItemTagAutoclosing;

                            case "dd":
                            case "dt":
                                return ancestorInfo.dlItemTagAutoclosing;

                            case "button":
                                return ancestorInfo.buttonTagInScope;

                            case "a":
                                // Spec says something about storing a list of markers, but it sounds
                                // equivalent to this check.
                                return ancestorInfo.aTagInScope;

                            case "nobr":
                                return ancestorInfo.nobrTagInScope;
                        }

                        return null;
                    };

                    /**
                     * Given a ReactCompositeComponent instance, return a list of its recursive
                     * owners, starting at the root and ending with the instance itself.
                     */
                    var findOwnerStack = function (instance) {
                        if (!instance) {
                            return [];
                        }

                        var stack = [];
                        do {
                            stack.push(instance);
                        } while ((instance = instance._currentElement._owner));
                        stack.reverse();
                        return stack;
                    };

                    var didWarn = {};

                    validateDOMNesting = function (
                        childTag,
                        childText,
                        childInstance,
                        ancestorInfo
                    ) {
                        ancestorInfo = ancestorInfo || emptyAncestorInfo;
                        var parentInfo = ancestorInfo.current;
                        var parentTag = parentInfo && parentInfo.tag;

                        if (childText != null) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      childTag == null,
                                      "validateDOMNesting: when childText is passed, childTag should be null"
                                  )
                                : void 0;
                            childTag = "#text";
                        }

                        var invalidParent = isTagValidWithParent(
                            childTag,
                            parentTag
                        )
                            ? null
                            : parentInfo;
                        var invalidAncestor = invalidParent
                            ? null
                            : findInvalidAncestorForTag(childTag, ancestorInfo);
                        var problematic = invalidParent || invalidAncestor;

                        if (problematic) {
                            var ancestorTag = problematic.tag;
                            var ancestorInstance = problematic.instance;

                            var childOwner =
                                childInstance &&
                                childInstance._currentElement._owner;
                            var ancestorOwner =
                                ancestorInstance &&
                                ancestorInstance._currentElement._owner;

                            var childOwners = findOwnerStack(childOwner);
                            var ancestorOwners = findOwnerStack(ancestorOwner);

                            var minStackLen = Math.min(
                                childOwners.length,
                                ancestorOwners.length
                            );
                            var i;

                            var deepestCommon = -1;
                            for (i = 0; i < minStackLen; i++) {
                                if (childOwners[i] === ancestorOwners[i]) {
                                    deepestCommon = i;
                                } else {
                                    break;
                                }
                            }

                            var UNKNOWN = "(unknown)";
                            var childOwnerNames = childOwners
                                .slice(deepestCommon + 1)
                                .map(function (inst) {
                                    return inst.getName() || UNKNOWN;
                                });
                            var ancestorOwnerNames = ancestorOwners
                                .slice(deepestCommon + 1)
                                .map(function (inst) {
                                    return inst.getName() || UNKNOWN;
                                });
                            var ownerInfo = []
                                .concat(
                                    // If the parent and child instances have a common owner ancestor, start
                                    // with that -- otherwise we just start with the parent's owners.
                                    deepestCommon !== -1
                                        ? childOwners[
                                              deepestCommon
                                          ].getName() || UNKNOWN
                                        : [],
                                    ancestorOwnerNames,
                                    ancestorTag,
                                    // If we're warning about an invalid (non-parent) ancestry, add '...'
                                    invalidAncestor ? ["..."] : [],
                                    childOwnerNames,
                                    childTag
                                )
                                .join(" > ");

                            var warnKey =
                                !!invalidParent +
                                "|" +
                                childTag +
                                "|" +
                                ancestorTag +
                                "|" +
                                ownerInfo;
                            if (didWarn[warnKey]) {
                                return;
                            }
                            didWarn[warnKey] = true;

                            var tagDisplayName = childTag;
                            var whitespaceInfo = "";
                            if (childTag === "#text") {
                                if (/\S/.test(childText)) {
                                    tagDisplayName = "Text nodes";
                                } else {
                                    tagDisplayName = "Whitespace text nodes";
                                    whitespaceInfo =
                                        " Make sure you don't have any extra whitespace between tags on " +
                                        "each line of your source code.";
                                }
                            } else {
                                tagDisplayName = "<" + childTag + ">";
                            }

                            if (invalidParent) {
                                var info = "";
                                if (
                                    ancestorTag === "table" &&
                                    childTag === "tr"
                                ) {
                                    info +=
                                        " Add a <tbody> to your code to match the DOM tree generated by " +
                                        "the browser.";
                                }
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "validateDOMNesting(...): %s cannot appear as a child of <%s>.%s " +
                                              "See %s.%s",
                                          tagDisplayName,
                                          ancestorTag,
                                          whitespaceInfo,
                                          ownerInfo,
                                          info
                                      )
                                    : void 0;
                            } else {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          false,
                                          "validateDOMNesting(...): %s cannot appear as a descendant of " +
                                              "<%s>. See %s.",
                                          tagDisplayName,
                                          ancestorTag,
                                          ownerInfo
                                      )
                                    : void 0;
                            }
                        }
                    };

                    validateDOMNesting.updatedAncestorInfo =
                        updatedAncestorInfo;

                    // For testing
                    validateDOMNesting.isTagValidInContext = function (
                        tag,
                        ancestorInfo
                    ) {
                        ancestorInfo = ancestorInfo || emptyAncestorInfo;
                        var parentInfo = ancestorInfo.current;
                        var parentTag = parentInfo && parentInfo.tag;
                        return (
                            isTagValidWithParent(tag, parentTag) &&
                            !findInvalidAncestorForTag(tag, ancestorInfo)
                        );
                    };
                }

                module.exports = validateDOMNesting;

                /***/
            },
            /* 476 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var DOMLazyTree = __webpack_require__(421);
                var ReactDOMComponentTree = __webpack_require__(379);

                var ReactDOMEmptyComponent = function (instantiate) {
                    // ReactCompositeComponent uses this:
                    this._currentElement = null;
                    // ReactDOMComponentTree uses these:
                    this._hostNode = null;
                    this._hostParent = null;
                    this._hostContainerInfo = null;
                    this._domID = 0;
                };
                _assign(ReactDOMEmptyComponent.prototype, {
                    mountComponent: function (
                        transaction,
                        hostParent,
                        hostContainerInfo,
                        context
                    ) {
                        var domID = hostContainerInfo._idCounter++;
                        this._domID = domID;
                        this._hostParent = hostParent;
                        this._hostContainerInfo = hostContainerInfo;

                        var nodeValue = " react-empty: " + this._domID + " ";
                        if (transaction.useCreateElement) {
                            var ownerDocument =
                                hostContainerInfo._ownerDocument;
                            var node = ownerDocument.createComment(nodeValue);
                            ReactDOMComponentTree.precacheNode(this, node);
                            return DOMLazyTree(node);
                        } else {
                            if (transaction.renderToStaticMarkup) {
                                // Normally we'd insert a comment node, but since this is a situation
                                // where React won't take over (static pages), we can simply return
                                // nothing.
                                return "";
                            }
                            return "<!--" + nodeValue + "-->";
                        }
                    },
                    receiveComponent: function () {},
                    getHostNode: function () {
                        return ReactDOMComponentTree.getNodeFromInstance(this);
                    },
                    unmountComponent: function () {
                        ReactDOMComponentTree.uncacheNode(this);
                    },
                });

                module.exports = ReactDOMEmptyComponent;

                /***/
            },
            /* 477 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var invariant = __webpack_require__(355);

                /**
                 * Return the lowest common ancestor of A and B, or null if they are in
                 * different trees.
                 */
                function getLowestCommonAncestor(instA, instB) {
                    !("_hostNode" in instA)
                        ? false
                            ? invariant(
                                  false,
                                  "getNodeFromInstance: Invalid argument."
                              )
                            : _prodInvariant("33")
                        : void 0;
                    !("_hostNode" in instB)
                        ? false
                            ? invariant(
                                  false,
                                  "getNodeFromInstance: Invalid argument."
                              )
                            : _prodInvariant("33")
                        : void 0;

                    var depthA = 0;
                    for (var tempA = instA; tempA; tempA = tempA._hostParent) {
                        depthA++;
                    }
                    var depthB = 0;
                    for (var tempB = instB; tempB; tempB = tempB._hostParent) {
                        depthB++;
                    }

                    // If A is deeper, crawl up.
                    while (depthA - depthB > 0) {
                        instA = instA._hostParent;
                        depthA--;
                    }

                    // If B is deeper, crawl up.
                    while (depthB - depthA > 0) {
                        instB = instB._hostParent;
                        depthB--;
                    }

                    // Walk in lockstep until we find a match.
                    var depth = depthA;
                    while (depth--) {
                        if (instA === instB) {
                            return instA;
                        }
                        instA = instA._hostParent;
                        instB = instB._hostParent;
                    }
                    return null;
                }

                /**
                 * Return if A is an ancestor of B.
                 */
                function isAncestor(instA, instB) {
                    !("_hostNode" in instA)
                        ? false
                            ? invariant(false, "isAncestor: Invalid argument.")
                            : _prodInvariant("35")
                        : void 0;
                    !("_hostNode" in instB)
                        ? false
                            ? invariant(false, "isAncestor: Invalid argument.")
                            : _prodInvariant("35")
                        : void 0;

                    while (instB) {
                        if (instB === instA) {
                            return true;
                        }
                        instB = instB._hostParent;
                    }
                    return false;
                }

                /**
                 * Return the parent instance of the passed-in instance.
                 */
                function getParentInstance(inst) {
                    !("_hostNode" in inst)
                        ? false
                            ? invariant(
                                  false,
                                  "getParentInstance: Invalid argument."
                              )
                            : _prodInvariant("36")
                        : void 0;

                    return inst._hostParent;
                }

                /**
                 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
                 */
                function traverseTwoPhase(inst, fn, arg) {
                    var path = [];
                    while (inst) {
                        path.push(inst);
                        inst = inst._hostParent;
                    }
                    var i;
                    for (i = path.length; i-- > 0; ) {
                        fn(path[i], "captured", arg);
                    }
                    for (i = 0; i < path.length; i++) {
                        fn(path[i], "bubbled", arg);
                    }
                }

                /**
                 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
                 * should would receive a `mouseEnter` or `mouseLeave` event.
                 *
                 * Does not invoke the callback on the nearest common ancestor because nothing
                 * "entered" or "left" that element.
                 */
                function traverseEnterLeave(from, to, fn, argFrom, argTo) {
                    var common =
                        from && to ? getLowestCommonAncestor(from, to) : null;
                    var pathFrom = [];
                    while (from && from !== common) {
                        pathFrom.push(from);
                        from = from._hostParent;
                    }
                    var pathTo = [];
                    while (to && to !== common) {
                        pathTo.push(to);
                        to = to._hostParent;
                    }
                    var i;
                    for (i = 0; i < pathFrom.length; i++) {
                        fn(pathFrom[i], "bubbled", argFrom);
                    }
                    for (i = pathTo.length; i-- > 0; ) {
                        fn(pathTo[i], "captured", argTo);
                    }
                }

                module.exports = {
                    isAncestor: isAncestor,
                    getLowestCommonAncestor: getLowestCommonAncestor,
                    getParentInstance: getParentInstance,
                    traverseTwoPhase: traverseTwoPhase,
                    traverseEnterLeave: traverseEnterLeave,
                };

                /***/
            },
            /* 478 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380),
                    _assign = __webpack_require__(351);

                var DOMChildrenOperations = __webpack_require__(420);
                var DOMLazyTree = __webpack_require__(421);
                var ReactDOMComponentTree = __webpack_require__(379);

                var escapeTextContentForBrowser = __webpack_require__(426);
                var invariant = __webpack_require__(355);
                var validateDOMNesting = __webpack_require__(475);

                /**
                 * Text nodes violate a couple assumptions that React makes about components:
                 *
                 *  - When mounting text into the DOM, adjacent text nodes are merged.
                 *  - Text nodes cannot be assigned a React root ID.
                 *
                 * This component is used to wrap strings between comment nodes so that they
                 * can undergo the same reconciliation that is applied to elements.
                 *
                 * TODO: Investigate representing React components in the DOM with text nodes.
                 *
                 * @class ReactDOMTextComponent
                 * @extends ReactComponent
                 * @internal
                 */
                var ReactDOMTextComponent = function (text) {
                    // TODO: This is really a ReactText (ReactNode), not a ReactElement
                    this._currentElement = text;
                    this._stringText = "" + text;
                    // ReactDOMComponentTree uses these:
                    this._hostNode = null;
                    this._hostParent = null;

                    // Properties
                    this._domID = 0;
                    this._mountIndex = 0;
                    this._closingComment = null;
                    this._commentNodes = null;
                };

                _assign(ReactDOMTextComponent.prototype, {
                    /**
                     * Creates the markup for this text node. This node is not intended to have
                     * any features besides containing text content.
                     *
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @return {string} Markup for this text node.
                     * @internal
                     */
                    mountComponent: function (
                        transaction,
                        hostParent,
                        hostContainerInfo,
                        context
                    ) {
                        if (false) {
                            var parentInfo;
                            if (hostParent != null) {
                                parentInfo = hostParent._ancestorInfo;
                            } else if (hostContainerInfo != null) {
                                parentInfo = hostContainerInfo._ancestorInfo;
                            }
                            if (parentInfo) {
                                // parentInfo should always be present except for the top-level
                                // component when server rendering
                                validateDOMNesting(
                                    null,
                                    this._stringText,
                                    this,
                                    parentInfo
                                );
                            }
                        }

                        var domID = hostContainerInfo._idCounter++;
                        var openingValue = " react-text: " + domID + " ";
                        var closingValue = " /react-text ";
                        this._domID = domID;
                        this._hostParent = hostParent;
                        if (transaction.useCreateElement) {
                            var ownerDocument =
                                hostContainerInfo._ownerDocument;
                            var openingComment =
                                ownerDocument.createComment(openingValue);
                            var closingComment =
                                ownerDocument.createComment(closingValue);
                            var lazyTree = DOMLazyTree(
                                ownerDocument.createDocumentFragment()
                            );
                            DOMLazyTree.queueChild(
                                lazyTree,
                                DOMLazyTree(openingComment)
                            );
                            if (this._stringText) {
                                DOMLazyTree.queueChild(
                                    lazyTree,
                                    DOMLazyTree(
                                        ownerDocument.createTextNode(
                                            this._stringText
                                        )
                                    )
                                );
                            }
                            DOMLazyTree.queueChild(
                                lazyTree,
                                DOMLazyTree(closingComment)
                            );
                            ReactDOMComponentTree.precacheNode(
                                this,
                                openingComment
                            );
                            this._closingComment = closingComment;
                            return lazyTree;
                        } else {
                            var escapedText = escapeTextContentForBrowser(
                                this._stringText
                            );

                            if (transaction.renderToStaticMarkup) {
                                // Normally we'd wrap this between comment nodes for the reasons stated
                                // above, but since this is a situation where React won't take over
                                // (static pages), we can simply return the text as it is.
                                return escapedText;
                            }

                            return (
                                "<!--" +
                                openingValue +
                                "-->" +
                                escapedText +
                                "<!--" +
                                closingValue +
                                "-->"
                            );
                        }
                    },

                    /**
                     * Updates this component by updating the text content.
                     *
                     * @param {ReactText} nextText The next text content
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    receiveComponent: function (nextText, transaction) {
                        if (nextText !== this._currentElement) {
                            this._currentElement = nextText;
                            var nextStringText = "" + nextText;
                            if (nextStringText !== this._stringText) {
                                // TODO: Save this as pending props and use performUpdateIfNecessary
                                // and/or updateComponent to do the actual update for consistency with
                                // other component types?
                                this._stringText = nextStringText;
                                var commentNodes = this.getHostNode();
                                DOMChildrenOperations.replaceDelimitedText(
                                    commentNodes[0],
                                    commentNodes[1],
                                    nextStringText
                                );
                            }
                        }
                    },

                    getHostNode: function () {
                        var hostNode = this._commentNodes;
                        if (hostNode) {
                            return hostNode;
                        }
                        if (!this._closingComment) {
                            var openingComment =
                                ReactDOMComponentTree.getNodeFromInstance(this);
                            var node = openingComment.nextSibling;
                            while (true) {
                                !(node != null)
                                    ? false
                                        ? invariant(
                                              false,
                                              "Missing closing comment for text component %s",
                                              this._domID
                                          )
                                        : _prodInvariant("67", this._domID)
                                    : void 0;
                                if (
                                    node.nodeType === 8 &&
                                    node.nodeValue === " /react-text "
                                ) {
                                    this._closingComment = node;
                                    break;
                                }
                                node = node.nextSibling;
                            }
                        }
                        hostNode = [this._hostNode, this._closingComment];
                        this._commentNodes = hostNode;
                        return hostNode;
                    },

                    unmountComponent: function () {
                        this._closingComment = null;
                        this._commentNodes = null;
                        ReactDOMComponentTree.uncacheNode(this);
                    },
                });

                module.exports = ReactDOMTextComponent;

                /***/
            },
            /* 479 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var ReactUpdates = __webpack_require__(401);
                var Transaction = __webpack_require__(408);

                var emptyFunction = __webpack_require__(359);

                var RESET_BATCHED_UPDATES = {
                    initialize: emptyFunction,
                    close: function () {
                        ReactDefaultBatchingStrategy.isBatchingUpdates = false;
                    },
                };

                var FLUSH_BATCHED_UPDATES = {
                    initialize: emptyFunction,
                    close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates),
                };

                var TRANSACTION_WRAPPERS = [
                    FLUSH_BATCHED_UPDATES,
                    RESET_BATCHED_UPDATES,
                ];

                function ReactDefaultBatchingStrategyTransaction() {
                    this.reinitializeTransaction();
                }

                _assign(
                    ReactDefaultBatchingStrategyTransaction.prototype,
                    Transaction,
                    {
                        getTransactionWrappers: function () {
                            return TRANSACTION_WRAPPERS;
                        },
                    }
                );

                var transaction = new ReactDefaultBatchingStrategyTransaction();

                var ReactDefaultBatchingStrategy = {
                    isBatchingUpdates: false,

                    /**
                     * Call the provided function in a context within which calls to `setState`
                     * and friends are batched such that components aren't updated unnecessarily.
                     */
                    batchedUpdates: function (callback, a, b, c, d, e) {
                        var alreadyBatchingUpdates =
                            ReactDefaultBatchingStrategy.isBatchingUpdates;

                        ReactDefaultBatchingStrategy.isBatchingUpdates = true;

                        // The code is written this way to avoid extra allocations
                        if (alreadyBatchingUpdates) {
                            return callback(a, b, c, d, e);
                        } else {
                            return transaction.perform(
                                callback,
                                null,
                                a,
                                b,
                                c,
                                d,
                                e
                            );
                        }
                    },
                };

                module.exports = ReactDefaultBatchingStrategy;

                /***/
            },
            /* 480 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var EventListener = __webpack_require__(481);
                var ExecutionEnvironment = __webpack_require__(393);
                var PooledClass = __webpack_require__(395);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactUpdates = __webpack_require__(401);

                var getEventTarget = __webpack_require__(409);
                var getUnboundedScrollPosition = __webpack_require__(482);

                /**
                 * Find the deepest React component completely containing the root of the
                 * passed-in instance (for use when entire React trees are nested within each
                 * other). If React trees are not nested, returns null.
                 */
                function findParent(inst) {
                    // TODO: It may be a good idea to cache this to prevent unnecessary DOM
                    // traversal, but caching is difficult to do correctly without using a
                    // mutation observer to listen for all DOM changes.
                    while (inst._hostParent) {
                        inst = inst._hostParent;
                    }
                    var rootNode =
                        ReactDOMComponentTree.getNodeFromInstance(inst);
                    var container = rootNode.parentNode;
                    return ReactDOMComponentTree.getClosestInstanceFromNode(
                        container
                    );
                }

                // Used to store ancestor hierarchy in top level callback
                function TopLevelCallbackBookKeeping(
                    topLevelType,
                    nativeEvent
                ) {
                    this.topLevelType = topLevelType;
                    this.nativeEvent = nativeEvent;
                    this.ancestors = [];
                }
                _assign(TopLevelCallbackBookKeeping.prototype, {
                    destructor: function () {
                        this.topLevelType = null;
                        this.nativeEvent = null;
                        this.ancestors.length = 0;
                    },
                });
                PooledClass.addPoolingTo(
                    TopLevelCallbackBookKeeping,
                    PooledClass.twoArgumentPooler
                );

                function handleTopLevelImpl(bookKeeping) {
                    var nativeEventTarget = getEventTarget(
                        bookKeeping.nativeEvent
                    );
                    var targetInst =
                        ReactDOMComponentTree.getClosestInstanceFromNode(
                            nativeEventTarget
                        );

                    // Loop through the hierarchy, in case there's any nested components.
                    // It's important that we build the array of ancestors before calling any
                    // event handlers, because event handlers can modify the DOM, leading to
                    // inconsistencies with ReactMount's node cache. See #1105.
                    var ancestor = targetInst;
                    do {
                        bookKeeping.ancestors.push(ancestor);
                        ancestor = ancestor && findParent(ancestor);
                    } while (ancestor);

                    for (var i = 0; i < bookKeeping.ancestors.length; i++) {
                        targetInst = bookKeeping.ancestors[i];
                        ReactEventListener._handleTopLevel(
                            bookKeeping.topLevelType,
                            targetInst,
                            bookKeeping.nativeEvent,
                            getEventTarget(bookKeeping.nativeEvent)
                        );
                    }
                }

                function scrollValueMonitor(cb) {
                    var scrollPosition = getUnboundedScrollPosition(window);
                    cb(scrollPosition);
                }

                var ReactEventListener = {
                    _enabled: true,
                    _handleTopLevel: null,

                    WINDOW_HANDLE: ExecutionEnvironment.canUseDOM
                        ? window
                        : null,

                    setHandleTopLevel: function (handleTopLevel) {
                        ReactEventListener._handleTopLevel = handleTopLevel;
                    },

                    setEnabled: function (enabled) {
                        ReactEventListener._enabled = !!enabled;
                    },

                    isEnabled: function () {
                        return ReactEventListener._enabled;
                    },

                    /**
                     * Traps top-level events by using event bubbling.
                     *
                     * @param {string} topLevelType Record from `EventConstants`.
                     * @param {string} handlerBaseName Event name (e.g. "click").
                     * @param {object} element Element on which to attach listener.
                     * @return {?object} An object with a remove function which will forcefully
                     *                  remove the listener.
                     * @internal
                     */
                    trapBubbledEvent: function (
                        topLevelType,
                        handlerBaseName,
                        element
                    ) {
                        if (!element) {
                            return null;
                        }
                        return EventListener.listen(
                            element,
                            handlerBaseName,
                            ReactEventListener.dispatchEvent.bind(
                                null,
                                topLevelType
                            )
                        );
                    },

                    /**
                     * Traps a top-level event by using event capturing.
                     *
                     * @param {string} topLevelType Record from `EventConstants`.
                     * @param {string} handlerBaseName Event name (e.g. "click").
                     * @param {object} element Element on which to attach listener.
                     * @return {?object} An object with a remove function which will forcefully
                     *                  remove the listener.
                     * @internal
                     */
                    trapCapturedEvent: function (
                        topLevelType,
                        handlerBaseName,
                        element
                    ) {
                        if (!element) {
                            return null;
                        }
                        return EventListener.capture(
                            element,
                            handlerBaseName,
                            ReactEventListener.dispatchEvent.bind(
                                null,
                                topLevelType
                            )
                        );
                    },

                    monitorScrollValue: function (refresh) {
                        var callback = scrollValueMonitor.bind(null, refresh);
                        EventListener.listen(window, "scroll", callback);
                    },

                    dispatchEvent: function (topLevelType, nativeEvent) {
                        if (!ReactEventListener._enabled) {
                            return;
                        }

                        var bookKeeping = TopLevelCallbackBookKeeping.getPooled(
                            topLevelType,
                            nativeEvent
                        );
                        try {
                            // Event queue being processed in the same cycle allows
                            // `preventDefault`.
                            ReactUpdates.batchedUpdates(
                                handleTopLevelImpl,
                                bookKeeping
                            );
                        } finally {
                            TopLevelCallbackBookKeeping.release(bookKeeping);
                        }
                    },
                };

                module.exports = ReactEventListener;

                /***/
            },
            /* 481 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 *
                 * Licensed under the Apache License, Version 2.0 (the "License");
                 * you may not use this file except in compliance with the License.
                 * You may obtain a copy of the License at
                 *
                 * http://www.apache.org/licenses/LICENSE-2.0
                 *
                 * Unless required by applicable law or agreed to in writing, software
                 * distributed under the License is distributed on an "AS IS" BASIS,
                 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                 * See the License for the specific language governing permissions and
                 * limitations under the License.
                 *
                 * @typechecks
                 */

                var emptyFunction = __webpack_require__(359);

                /**
                 * Upstream version of event listener. Does not take into account specific
                 * nature of platform.
                 */
                var EventListener = {
                    /**
                     * Listen to DOM events during the bubble phase.
                     *
                     * @param {DOMEventTarget} target DOM element to register listener on.
                     * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
                     * @param {function} callback Callback function.
                     * @return {object} Object with a `remove` method.
                     */
                    listen: function listen(target, eventType, callback) {
                        if (target.addEventListener) {
                            target.addEventListener(eventType, callback, false);
                            return {
                                remove: function remove() {
                                    target.removeEventListener(
                                        eventType,
                                        callback,
                                        false
                                    );
                                },
                            };
                        } else if (target.attachEvent) {
                            target.attachEvent("on" + eventType, callback);
                            return {
                                remove: function remove() {
                                    target.detachEvent(
                                        "on" + eventType,
                                        callback
                                    );
                                },
                            };
                        }
                    },

                    /**
                     * Listen to DOM events during the capture phase.
                     *
                     * @param {DOMEventTarget} target DOM element to register listener on.
                     * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
                     * @param {function} callback Callback function.
                     * @return {object} Object with a `remove` method.
                     */
                    capture: function capture(target, eventType, callback) {
                        if (target.addEventListener) {
                            target.addEventListener(eventType, callback, true);
                            return {
                                remove: function remove() {
                                    target.removeEventListener(
                                        eventType,
                                        callback,
                                        true
                                    );
                                },
                            };
                        } else {
                            if (false) {
                                console.error(
                                    "Attempted to listen to events during the capture phase on a " +
                                        "browser that does not support the capture phase. Your application " +
                                        "will not receive some events."
                                );
                            }
                            return {
                                remove: emptyFunction,
                            };
                        }
                    },

                    registerDefault: function registerDefault() {},
                };

                module.exports = EventListener;

                /***/
            },
            /* 482 */
            /***/ function (module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                "use strict";

                /**
                 * Gets the scroll position of the supplied element or window.
                 *
                 * The return values are unbounded, unlike `getScrollPosition`. This means they
                 * may be negative or exceed the element boundaries (which is possible using
                 * inertial scrolling).
                 *
                 * @param {DOMWindow|DOMElement} scrollable
                 * @return {object} Map with `x` and `y` keys.
                 */

                function getUnboundedScrollPosition(scrollable) {
                    if (scrollable === window) {
                        return {
                            x:
                                window.pageXOffset ||
                                document.documentElement.scrollLeft,
                            y:
                                window.pageYOffset ||
                                document.documentElement.scrollTop,
                        };
                    }
                    return {
                        x: scrollable.scrollLeft,
                        y: scrollable.scrollTop,
                    };
                }

                module.exports = getUnboundedScrollPosition;

                /***/
            },
            /* 483 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var DOMProperty = __webpack_require__(381);
                var EventPluginHub = __webpack_require__(387);
                var EventPluginUtils = __webpack_require__(389);
                var ReactComponentEnvironment = __webpack_require__(455);
                var ReactEmptyComponent = __webpack_require__(463);
                var ReactBrowserEventEmitter = __webpack_require__(445);
                var ReactHostComponent = __webpack_require__(464);
                var ReactUpdates = __webpack_require__(401);

                var ReactInjection = {
                    Component: ReactComponentEnvironment.injection,
                    DOMProperty: DOMProperty.injection,
                    EmptyComponent: ReactEmptyComponent.injection,
                    EventPluginHub: EventPluginHub.injection,
                    EventPluginUtils: EventPluginUtils.injection,
                    EventEmitter: ReactBrowserEventEmitter.injection,
                    HostComponent: ReactHostComponent.injection,
                    Updates: ReactUpdates.injection,
                };

                module.exports = ReactInjection;

                /***/
            },
            /* 484 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _assign = __webpack_require__(351);

                var CallbackQueue = __webpack_require__(402);
                var PooledClass = __webpack_require__(395);
                var ReactBrowserEventEmitter = __webpack_require__(445);
                var ReactInputSelection = __webpack_require__(485);
                var ReactInstrumentation = __webpack_require__(407);
                var Transaction = __webpack_require__(408);
                var ReactUpdateQueue = __webpack_require__(474);

                /**
                 * Ensures that, when possible, the selection range (currently selected text
                 * input) is not disturbed by performing the transaction.
                 */
                var SELECTION_RESTORATION = {
                    /**
                     * @return {Selection} Selection information.
                     */
                    initialize: ReactInputSelection.getSelectionInformation,
                    /**
                     * @param {Selection} sel Selection information returned from `initialize`.
                     */
                    close: ReactInputSelection.restoreSelection,
                };

                /**
                 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
                 * high level DOM manipulations (like temporarily removing a text input from the
                 * DOM).
                 */
                var EVENT_SUPPRESSION = {
                    /**
                     * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
                     * the reconciliation.
                     */
                    initialize: function () {
                        var currentlyEnabled =
                            ReactBrowserEventEmitter.isEnabled();
                        ReactBrowserEventEmitter.setEnabled(false);
                        return currentlyEnabled;
                    },

                    /**
                     * @param {boolean} previouslyEnabled Enabled status of
                     *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
                     *   restores the previous value.
                     */
                    close: function (previouslyEnabled) {
                        ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
                    },
                };

                /**
                 * Provides a queue for collecting `componentDidMount` and
                 * `componentDidUpdate` callbacks during the transaction.
                 */
                var ON_DOM_READY_QUEUEING = {
                    /**
                     * Initializes the internal `onDOMReady` queue.
                     */
                    initialize: function () {
                        this.reactMountReady.reset();
                    },

                    /**
                     * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
                     */
                    close: function () {
                        this.reactMountReady.notifyAll();
                    },
                };

                /**
                 * Executed within the scope of the `Transaction` instance. Consider these as
                 * being member methods, but with an implied ordering while being isolated from
                 * each other.
                 */
                var TRANSACTION_WRAPPERS = [
                    SELECTION_RESTORATION,
                    EVENT_SUPPRESSION,
                    ON_DOM_READY_QUEUEING,
                ];

                if (false) {
                    TRANSACTION_WRAPPERS.push({
                        initialize: ReactInstrumentation.debugTool.onBeginFlush,
                        close: ReactInstrumentation.debugTool.onEndFlush,
                    });
                }

                /**
                 * Currently:
                 * - The order that these are listed in the transaction is critical:
                 * - Suppresses events.
                 * - Restores selection range.
                 *
                 * Future:
                 * - Restore document/overflow scroll positions that were unintentionally
                 *   modified via DOM insertions above the top viewport boundary.
                 * - Implement/integrate with customized constraint based layout system and keep
                 *   track of which dimensions must be remeasured.
                 *
                 * @class ReactReconcileTransaction
                 */
                function ReactReconcileTransaction(useCreateElement) {
                    this.reinitializeTransaction();
                    // Only server-side rendering really needs this option (see
                    // `ReactServerRendering`), but server-side uses
                    // `ReactServerRenderingTransaction` instead. This option is here so that it's
                    // accessible and defaults to false when `ReactDOMComponent` and
                    // `ReactDOMTextComponent` checks it in `mountComponent`.`
                    this.renderToStaticMarkup = false;
                    this.reactMountReady = CallbackQueue.getPooled(null);
                    this.useCreateElement = useCreateElement;
                }

                var Mixin = {
                    /**
                     * @see Transaction
                     * @abstract
                     * @final
                     * @return {array<object>} List of operation wrap procedures.
                     *   TODO: convert to array<TransactionWrapper>
                     */
                    getTransactionWrappers: function () {
                        return TRANSACTION_WRAPPERS;
                    },

                    /**
                     * @return {object} The queue to collect `onDOMReady` callbacks with.
                     */
                    getReactMountReady: function () {
                        return this.reactMountReady;
                    },

                    /**
                     * @return {object} The queue to collect React async events.
                     */
                    getUpdateQueue: function () {
                        return ReactUpdateQueue;
                    },

                    /**
                     * Save current transaction state -- if the return value from this method is
                     * passed to `rollback`, the transaction will be reset to that state.
                     */
                    checkpoint: function () {
                        // reactMountReady is the our only stateful wrapper
                        return this.reactMountReady.checkpoint();
                    },

                    rollback: function (checkpoint) {
                        this.reactMountReady.rollback(checkpoint);
                    },

                    /**
                     * `PooledClass` looks for this, and will invoke this before allowing this
                     * instance to be reused.
                     */
                    destructor: function () {
                        CallbackQueue.release(this.reactMountReady);
                        this.reactMountReady = null;
                    },
                };

                _assign(
                    ReactReconcileTransaction.prototype,
                    Transaction,
                    Mixin
                );

                PooledClass.addPoolingTo(ReactReconcileTransaction);

                module.exports = ReactReconcileTransaction;

                /***/
            },
            /* 485 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactDOMSelection = __webpack_require__(486);

                var containsNode = __webpack_require__(488);
                var focusNode = __webpack_require__(434);
                var getActiveElement = __webpack_require__(491);

                function isInDocument(node) {
                    return containsNode(document.documentElement, node);
                }

                /**
                 * @ReactInputSelection: React input selection module. Based on Selection.js,
                 * but modified to be suitable for react and has a couple of bug fixes (doesn't
                 * assume buttons have range selections allowed).
                 * Input selection module for React.
                 */
                var ReactInputSelection = {
                    hasSelectionCapabilities: function (elem) {
                        var nodeName =
                            elem &&
                            elem.nodeName &&
                            elem.nodeName.toLowerCase();
                        return (
                            nodeName &&
                            ((nodeName === "input" && elem.type === "text") ||
                                nodeName === "textarea" ||
                                elem.contentEditable === "true")
                        );
                    },

                    getSelectionInformation: function () {
                        var focusedElem = getActiveElement();
                        return {
                            focusedElem: focusedElem,
                            selectionRange:
                                ReactInputSelection.hasSelectionCapabilities(
                                    focusedElem
                                )
                                    ? ReactInputSelection.getSelection(
                                          focusedElem
                                      )
                                    : null,
                        };
                    },

                    /**
                     * @restoreSelection: If any selection information was potentially lost,
                     * restore it. This is useful when performing operations that could remove dom
                     * nodes and place them back in, resulting in focus being lost.
                     */
                    restoreSelection: function (priorSelectionInformation) {
                        var curFocusedElem = getActiveElement();
                        var priorFocusedElem =
                            priorSelectionInformation.focusedElem;
                        var priorSelectionRange =
                            priorSelectionInformation.selectionRange;
                        if (
                            curFocusedElem !== priorFocusedElem &&
                            isInDocument(priorFocusedElem)
                        ) {
                            if (
                                ReactInputSelection.hasSelectionCapabilities(
                                    priorFocusedElem
                                )
                            ) {
                                ReactInputSelection.setSelection(
                                    priorFocusedElem,
                                    priorSelectionRange
                                );
                            }
                            focusNode(priorFocusedElem);
                        }
                    },

                    /**
                     * @getSelection: Gets the selection bounds of a focused textarea, input or
                     * contentEditable node.
                     * -@input: Look up selection bounds of this input
                     * -@return {start: selectionStart, end: selectionEnd}
                     */
                    getSelection: function (input) {
                        var selection;

                        if ("selectionStart" in input) {
                            // Modern browser with input or textarea.
                            selection = {
                                start: input.selectionStart,
                                end: input.selectionEnd,
                            };
                        } else if (
                            document.selection &&
                            input.nodeName &&
                            input.nodeName.toLowerCase() === "input"
                        ) {
                            // IE8 input.
                            var range = document.selection.createRange();
                            // There can only be one selection per document in IE, so it must
                            // be in our element.
                            if (range.parentElement() === input) {
                                selection = {
                                    start: -range.moveStart(
                                        "character",
                                        -input.value.length
                                    ),
                                    end: -range.moveEnd(
                                        "character",
                                        -input.value.length
                                    ),
                                };
                            }
                        } else {
                            // Content editable or old IE textarea.
                            selection = ReactDOMSelection.getOffsets(input);
                        }

                        return selection || { start: 0, end: 0 };
                    },

                    /**
                     * @setSelection: Sets the selection bounds of a textarea or input and focuses
                     * the input.
                     * -@input     Set selection bounds of this input or textarea
                     * -@offsets   Object of same form that is returned from get*
                     */
                    setSelection: function (input, offsets) {
                        var start = offsets.start;
                        var end = offsets.end;
                        if (end === undefined) {
                            end = start;
                        }

                        if ("selectionStart" in input) {
                            input.selectionStart = start;
                            input.selectionEnd = Math.min(
                                end,
                                input.value.length
                            );
                        } else if (
                            document.selection &&
                            input.nodeName &&
                            input.nodeName.toLowerCase() === "input"
                        ) {
                            var range = input.createTextRange();
                            range.collapse(true);
                            range.moveStart("character", start);
                            range.moveEnd("character", end - start);
                            range.select();
                        } else {
                            ReactDOMSelection.setOffsets(input, offsets);
                        }
                    },
                };

                module.exports = ReactInputSelection;

                /***/
            },
            /* 486 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ExecutionEnvironment = __webpack_require__(393);

                var getNodeForCharacterOffset = __webpack_require__(487);
                var getTextContentAccessor = __webpack_require__(396);

                /**
                 * While `isCollapsed` is available on the Selection object and `collapsed`
                 * is available on the Range object, IE11 sometimes gets them wrong.
                 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
                 */
                function isCollapsed(
                    anchorNode,
                    anchorOffset,
                    focusNode,
                    focusOffset
                ) {
                    return (
                        anchorNode === focusNode && anchorOffset === focusOffset
                    );
                }

                /**
                 * Get the appropriate anchor and focus node/offset pairs for IE.
                 *
                 * The catch here is that IE's selection API doesn't provide information
                 * about whether the selection is forward or backward, so we have to
                 * behave as though it's always forward.
                 *
                 * IE text differs from modern selection in that it behaves as though
                 * block elements end with a new line. This means character offsets will
                 * differ between the two APIs.
                 *
                 * @param {DOMElement} node
                 * @return {object}
                 */
                function getIEOffsets(node) {
                    var selection = document.selection;
                    var selectedRange = selection.createRange();
                    var selectedLength = selectedRange.text.length;

                    // Duplicate selection so we can move range without breaking user selection.
                    var fromStart = selectedRange.duplicate();
                    fromStart.moveToElementText(node);
                    fromStart.setEndPoint("EndToStart", selectedRange);

                    var startOffset = fromStart.text.length;
                    var endOffset = startOffset + selectedLength;

                    return {
                        start: startOffset,
                        end: endOffset,
                    };
                }

                /**
                 * @param {DOMElement} node
                 * @return {?object}
                 */
                function getModernOffsets(node) {
                    var selection =
                        window.getSelection && window.getSelection();

                    if (!selection || selection.rangeCount === 0) {
                        return null;
                    }

                    var anchorNode = selection.anchorNode;
                    var anchorOffset = selection.anchorOffset;
                    var focusNode = selection.focusNode;
                    var focusOffset = selection.focusOffset;

                    var currentRange = selection.getRangeAt(0);

                    // In Firefox, range.startContainer and range.endContainer can be "anonymous
                    // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
                    // divs do not seem to expose properties, triggering a "Permission denied
                    // error" if any of its properties are accessed. The only seemingly possible
                    // way to avoid erroring is to access a property that typically works for
                    // non-anonymous divs and catch any error that may otherwise arise. See
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
                    try {
                        /* eslint-disable no-unused-expressions */
                        currentRange.startContainer.nodeType;
                        currentRange.endContainer.nodeType;
                        /* eslint-enable no-unused-expressions */
                    } catch (e) {
                        return null;
                    }

                    // If the node and offset values are the same, the selection is collapsed.
                    // `Selection.isCollapsed` is available natively, but IE sometimes gets
                    // this value wrong.
                    var isSelectionCollapsed = isCollapsed(
                        selection.anchorNode,
                        selection.anchorOffset,
                        selection.focusNode,
                        selection.focusOffset
                    );

                    var rangeLength = isSelectionCollapsed
                        ? 0
                        : currentRange.toString().length;

                    var tempRange = currentRange.cloneRange();
                    tempRange.selectNodeContents(node);
                    tempRange.setEnd(
                        currentRange.startContainer,
                        currentRange.startOffset
                    );

                    var isTempRangeCollapsed = isCollapsed(
                        tempRange.startContainer,
                        tempRange.startOffset,
                        tempRange.endContainer,
                        tempRange.endOffset
                    );

                    var start = isTempRangeCollapsed
                        ? 0
                        : tempRange.toString().length;
                    var end = start + rangeLength;

                    // Detect whether the selection is backward.
                    var detectionRange = document.createRange();
                    detectionRange.setStart(anchorNode, anchorOffset);
                    detectionRange.setEnd(focusNode, focusOffset);
                    var isBackward = detectionRange.collapsed;

                    return {
                        start: isBackward ? end : start,
                        end: isBackward ? start : end,
                    };
                }

                /**
                 * @param {DOMElement|DOMTextNode} node
                 * @param {object} offsets
                 */
                function setIEOffsets(node, offsets) {
                    var range = document.selection.createRange().duplicate();
                    var start, end;

                    if (offsets.end === undefined) {
                        start = offsets.start;
                        end = start;
                    } else if (offsets.start > offsets.end) {
                        start = offsets.end;
                        end = offsets.start;
                    } else {
                        start = offsets.start;
                        end = offsets.end;
                    }

                    range.moveToElementText(node);
                    range.moveStart("character", start);
                    range.setEndPoint("EndToStart", range);
                    range.moveEnd("character", end - start);
                    range.select();
                }

                /**
                 * In modern non-IE browsers, we can support both forward and backward
                 * selections.
                 *
                 * Note: IE10+ supports the Selection object, but it does not support
                 * the `extend` method, which means that even in modern IE, it's not possible
                 * to programmatically create a backward selection. Thus, for all IE
                 * versions, we use the old IE API to create our selections.
                 *
                 * @param {DOMElement|DOMTextNode} node
                 * @param {object} offsets
                 */
                function setModernOffsets(node, offsets) {
                    if (!window.getSelection) {
                        return;
                    }

                    var selection = window.getSelection();
                    var length = node[getTextContentAccessor()].length;
                    var start = Math.min(offsets.start, length);
                    var end =
                        offsets.end === undefined
                            ? start
                            : Math.min(offsets.end, length);

                    // IE 11 uses modern selection, but doesn't support the extend method.
                    // Flip backward selections, so we can set with a single range.
                    if (!selection.extend && start > end) {
                        var temp = end;
                        end = start;
                        start = temp;
                    }

                    var startMarker = getNodeForCharacterOffset(node, start);
                    var endMarker = getNodeForCharacterOffset(node, end);

                    if (startMarker && endMarker) {
                        var range = document.createRange();
                        range.setStart(startMarker.node, startMarker.offset);
                        selection.removeAllRanges();

                        if (start > end) {
                            selection.addRange(range);
                            selection.extend(endMarker.node, endMarker.offset);
                        } else {
                            range.setEnd(endMarker.node, endMarker.offset);
                            selection.addRange(range);
                        }
                    }
                }

                var useIEOffsets =
                    ExecutionEnvironment.canUseDOM &&
                    "selection" in document &&
                    !("getSelection" in window);

                var ReactDOMSelection = {
                    /**
                     * @param {DOMElement} node
                     */
                    getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

                    /**
                     * @param {DOMElement|DOMTextNode} node
                     * @param {object} offsets
                     */
                    setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets,
                };

                module.exports = ReactDOMSelection;

                /***/
            },
            /* 487 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * Given any node return the first leaf node without children.
                 *
                 * @param {DOMElement|DOMTextNode} node
                 * @return {DOMElement|DOMTextNode}
                 */

                function getLeafNode(node) {
                    while (node && node.firstChild) {
                        node = node.firstChild;
                    }
                    return node;
                }

                /**
                 * Get the next sibling within a container. This will walk up the
                 * DOM if a node's siblings have been exhausted.
                 *
                 * @param {DOMElement|DOMTextNode} node
                 * @return {?DOMElement|DOMTextNode}
                 */
                function getSiblingNode(node) {
                    while (node) {
                        if (node.nextSibling) {
                            return node.nextSibling;
                        }
                        node = node.parentNode;
                    }
                }

                /**
                 * Get object describing the nodes which contain characters at offset.
                 *
                 * @param {DOMElement|DOMTextNode} root
                 * @param {number} offset
                 * @return {?object}
                 */
                function getNodeForCharacterOffset(root, offset) {
                    var node = getLeafNode(root);
                    var nodeStart = 0;
                    var nodeEnd = 0;

                    while (node) {
                        if (node.nodeType === 3) {
                            nodeEnd = nodeStart + node.textContent.length;

                            if (nodeStart <= offset && nodeEnd >= offset) {
                                return {
                                    node: node,
                                    offset: offset - nodeStart,
                                };
                            }

                            nodeStart = nodeEnd;
                        }

                        node = getLeafNode(getSiblingNode(node));
                    }
                }

                module.exports = getNodeForCharacterOffset;

                /***/
            },
            /* 488 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                var isTextNode = __webpack_require__(489);

                /*eslint-disable no-bitwise */

                /**
                 * Checks if a given DOM node contains or is another DOM node.
                 */
                function containsNode(outerNode, innerNode) {
                    if (!outerNode || !innerNode) {
                        return false;
                    } else if (outerNode === innerNode) {
                        return true;
                    } else if (isTextNode(outerNode)) {
                        return false;
                    } else if (isTextNode(innerNode)) {
                        return containsNode(outerNode, innerNode.parentNode);
                    } else if ("contains" in outerNode) {
                        return outerNode.contains(innerNode);
                    } else if (outerNode.compareDocumentPosition) {
                        return !!(
                            outerNode.compareDocumentPosition(innerNode) & 16
                        );
                    } else {
                        return false;
                    }
                }

                module.exports = containsNode;

                /***/
            },
            /* 489 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var isNode = __webpack_require__(490);

                /**
                 * @param {*} object The object to check.
                 * @return {boolean} Whether or not the object is a DOM text node.
                 */
                function isTextNode(object) {
                    return isNode(object) && object.nodeType == 3;
                }

                module.exports = isTextNode;

                /***/
            },
            /* 490 */
            /***/ function (module, exports) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                /**
                 * @param {*} object The object to check.
                 * @return {boolean} Whether or not the object is a DOM node.
                 */
                function isNode(object) {
                    return !!(
                        object &&
                        (typeof Node === "function"
                            ? object instanceof Node
                            : typeof object === "object" &&
                              typeof object.nodeType === "number" &&
                              typeof object.nodeName === "string")
                    );
                }

                module.exports = isNode;

                /***/
            },
            /* 491 */
            /***/ function (module, exports) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                /* eslint-disable fb-www/typeof-undefined */

                /**
                 * Same as document.activeElement but wraps in a try-catch block. In IE it is
                 * not safe to call document.activeElement if there is nothing focused.
                 *
                 * The activeElement will be null only if the document or document body is not
                 * yet defined.
                 */
                function getActiveElement() /*?DOMElement*/ {
                    if (typeof document === "undefined") {
                        return null;
                    }
                    try {
                        return document.activeElement || document.body;
                    } catch (e) {
                        return document.body;
                    }
                }

                module.exports = getActiveElement;

                /***/
            },
            /* 492 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var NS = {
                    xlink: "http://www.w3.org/1999/xlink",
                    xml: "http://www.w3.org/XML/1998/namespace",
                };

                // We use attributes for everything SVG so let's avoid some duplication and run
                // code instead.
                // The following are all specified in the HTML config already so we exclude here.
                // - class (as className)
                // - color
                // - height
                // - id
                // - lang
                // - max
                // - media
                // - method
                // - min
                // - name
                // - style
                // - target
                // - type
                // - width
                var ATTRS = {
                    accentHeight: "accent-height",
                    accumulate: 0,
                    additive: 0,
                    alignmentBaseline: "alignment-baseline",
                    allowReorder: "allowReorder",
                    alphabetic: 0,
                    amplitude: 0,
                    arabicForm: "arabic-form",
                    ascent: 0,
                    attributeName: "attributeName",
                    attributeType: "attributeType",
                    autoReverse: "autoReverse",
                    azimuth: 0,
                    baseFrequency: "baseFrequency",
                    baseProfile: "baseProfile",
                    baselineShift: "baseline-shift",
                    bbox: 0,
                    begin: 0,
                    bias: 0,
                    by: 0,
                    calcMode: "calcMode",
                    capHeight: "cap-height",
                    clip: 0,
                    clipPath: "clip-path",
                    clipRule: "clip-rule",
                    clipPathUnits: "clipPathUnits",
                    colorInterpolation: "color-interpolation",
                    colorInterpolationFilters: "color-interpolation-filters",
                    colorProfile: "color-profile",
                    colorRendering: "color-rendering",
                    contentScriptType: "contentScriptType",
                    contentStyleType: "contentStyleType",
                    cursor: 0,
                    cx: 0,
                    cy: 0,
                    d: 0,
                    decelerate: 0,
                    descent: 0,
                    diffuseConstant: "diffuseConstant",
                    direction: 0,
                    display: 0,
                    divisor: 0,
                    dominantBaseline: "dominant-baseline",
                    dur: 0,
                    dx: 0,
                    dy: 0,
                    edgeMode: "edgeMode",
                    elevation: 0,
                    enableBackground: "enable-background",
                    end: 0,
                    exponent: 0,
                    externalResourcesRequired: "externalResourcesRequired",
                    fill: 0,
                    fillOpacity: "fill-opacity",
                    fillRule: "fill-rule",
                    filter: 0,
                    filterRes: "filterRes",
                    filterUnits: "filterUnits",
                    floodColor: "flood-color",
                    floodOpacity: "flood-opacity",
                    focusable: 0,
                    fontFamily: "font-family",
                    fontSize: "font-size",
                    fontSizeAdjust: "font-size-adjust",
                    fontStretch: "font-stretch",
                    fontStyle: "font-style",
                    fontVariant: "font-variant",
                    fontWeight: "font-weight",
                    format: 0,
                    from: 0,
                    fx: 0,
                    fy: 0,
                    g1: 0,
                    g2: 0,
                    glyphName: "glyph-name",
                    glyphOrientationHorizontal: "glyph-orientation-horizontal",
                    glyphOrientationVertical: "glyph-orientation-vertical",
                    glyphRef: "glyphRef",
                    gradientTransform: "gradientTransform",
                    gradientUnits: "gradientUnits",
                    hanging: 0,
                    horizAdvX: "horiz-adv-x",
                    horizOriginX: "horiz-origin-x",
                    ideographic: 0,
                    imageRendering: "image-rendering",
                    in: 0,
                    in2: 0,
                    intercept: 0,
                    k: 0,
                    k1: 0,
                    k2: 0,
                    k3: 0,
                    k4: 0,
                    kernelMatrix: "kernelMatrix",
                    kernelUnitLength: "kernelUnitLength",
                    kerning: 0,
                    keyPoints: "keyPoints",
                    keySplines: "keySplines",
                    keyTimes: "keyTimes",
                    lengthAdjust: "lengthAdjust",
                    letterSpacing: "letter-spacing",
                    lightingColor: "lighting-color",
                    limitingConeAngle: "limitingConeAngle",
                    local: 0,
                    markerEnd: "marker-end",
                    markerMid: "marker-mid",
                    markerStart: "marker-start",
                    markerHeight: "markerHeight",
                    markerUnits: "markerUnits",
                    markerWidth: "markerWidth",
                    mask: 0,
                    maskContentUnits: "maskContentUnits",
                    maskUnits: "maskUnits",
                    mathematical: 0,
                    mode: 0,
                    numOctaves: "numOctaves",
                    offset: 0,
                    opacity: 0,
                    operator: 0,
                    order: 0,
                    orient: 0,
                    orientation: 0,
                    origin: 0,
                    overflow: 0,
                    overlinePosition: "overline-position",
                    overlineThickness: "overline-thickness",
                    paintOrder: "paint-order",
                    panose1: "panose-1",
                    pathLength: "pathLength",
                    patternContentUnits: "patternContentUnits",
                    patternTransform: "patternTransform",
                    patternUnits: "patternUnits",
                    pointerEvents: "pointer-events",
                    points: 0,
                    pointsAtX: "pointsAtX",
                    pointsAtY: "pointsAtY",
                    pointsAtZ: "pointsAtZ",
                    preserveAlpha: "preserveAlpha",
                    preserveAspectRatio: "preserveAspectRatio",
                    primitiveUnits: "primitiveUnits",
                    r: 0,
                    radius: 0,
                    refX: "refX",
                    refY: "refY",
                    renderingIntent: "rendering-intent",
                    repeatCount: "repeatCount",
                    repeatDur: "repeatDur",
                    requiredExtensions: "requiredExtensions",
                    requiredFeatures: "requiredFeatures",
                    restart: 0,
                    result: 0,
                    rotate: 0,
                    rx: 0,
                    ry: 0,
                    scale: 0,
                    seed: 0,
                    shapeRendering: "shape-rendering",
                    slope: 0,
                    spacing: 0,
                    specularConstant: "specularConstant",
                    specularExponent: "specularExponent",
                    speed: 0,
                    spreadMethod: "spreadMethod",
                    startOffset: "startOffset",
                    stdDeviation: "stdDeviation",
                    stemh: 0,
                    stemv: 0,
                    stitchTiles: "stitchTiles",
                    stopColor: "stop-color",
                    stopOpacity: "stop-opacity",
                    strikethroughPosition: "strikethrough-position",
                    strikethroughThickness: "strikethrough-thickness",
                    string: 0,
                    stroke: 0,
                    strokeDasharray: "stroke-dasharray",
                    strokeDashoffset: "stroke-dashoffset",
                    strokeLinecap: "stroke-linecap",
                    strokeLinejoin: "stroke-linejoin",
                    strokeMiterlimit: "stroke-miterlimit",
                    strokeOpacity: "stroke-opacity",
                    strokeWidth: "stroke-width",
                    surfaceScale: "surfaceScale",
                    systemLanguage: "systemLanguage",
                    tableValues: "tableValues",
                    targetX: "targetX",
                    targetY: "targetY",
                    textAnchor: "text-anchor",
                    textDecoration: "text-decoration",
                    textRendering: "text-rendering",
                    textLength: "textLength",
                    to: 0,
                    transform: 0,
                    u1: 0,
                    u2: 0,
                    underlinePosition: "underline-position",
                    underlineThickness: "underline-thickness",
                    unicode: 0,
                    unicodeBidi: "unicode-bidi",
                    unicodeRange: "unicode-range",
                    unitsPerEm: "units-per-em",
                    vAlphabetic: "v-alphabetic",
                    vHanging: "v-hanging",
                    vIdeographic: "v-ideographic",
                    vMathematical: "v-mathematical",
                    values: 0,
                    vectorEffect: "vector-effect",
                    version: 0,
                    vertAdvY: "vert-adv-y",
                    vertOriginX: "vert-origin-x",
                    vertOriginY: "vert-origin-y",
                    viewBox: "viewBox",
                    viewTarget: "viewTarget",
                    visibility: 0,
                    widths: 0,
                    wordSpacing: "word-spacing",
                    writingMode: "writing-mode",
                    x: 0,
                    xHeight: "x-height",
                    x1: 0,
                    x2: 0,
                    xChannelSelector: "xChannelSelector",
                    xlinkActuate: "xlink:actuate",
                    xlinkArcrole: "xlink:arcrole",
                    xlinkHref: "xlink:href",
                    xlinkRole: "xlink:role",
                    xlinkShow: "xlink:show",
                    xlinkTitle: "xlink:title",
                    xlinkType: "xlink:type",
                    xmlBase: "xml:base",
                    xmlns: 0,
                    xmlnsXlink: "xmlns:xlink",
                    xmlLang: "xml:lang",
                    xmlSpace: "xml:space",
                    y: 0,
                    y1: 0,
                    y2: 0,
                    yChannelSelector: "yChannelSelector",
                    z: 0,
                    zoomAndPan: "zoomAndPan",
                };

                var SVGDOMPropertyConfig = {
                    Properties: {},
                    DOMAttributeNamespaces: {
                        xlinkActuate: NS.xlink,
                        xlinkArcrole: NS.xlink,
                        xlinkHref: NS.xlink,
                        xlinkRole: NS.xlink,
                        xlinkShow: NS.xlink,
                        xlinkTitle: NS.xlink,
                        xlinkType: NS.xlink,
                        xmlBase: NS.xml,
                        xmlLang: NS.xml,
                        xmlSpace: NS.xml,
                    },
                    DOMAttributeNames: {},
                };

                Object.keys(ATTRS).forEach(function (key) {
                    SVGDOMPropertyConfig.Properties[key] = 0;
                    if (ATTRS[key]) {
                        SVGDOMPropertyConfig.DOMAttributeNames[key] =
                            ATTRS[key];
                    }
                });

                module.exports = SVGDOMPropertyConfig;

                /***/
            },
            /* 493 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var EventPropagators = __webpack_require__(386);
                var ExecutionEnvironment = __webpack_require__(393);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactInputSelection = __webpack_require__(485);
                var SyntheticEvent = __webpack_require__(398);

                var getActiveElement = __webpack_require__(491);
                var isTextInputElement = __webpack_require__(411);
                var shallowEqual = __webpack_require__(461);

                var skipSelectionChangeEvent =
                    ExecutionEnvironment.canUseDOM &&
                    "documentMode" in document &&
                    document.documentMode <= 11;

                var eventTypes = {
                    select: {
                        phasedRegistrationNames: {
                            bubbled: "onSelect",
                            captured: "onSelectCapture",
                        },
                        dependencies: [
                            "topBlur",
                            "topContextMenu",
                            "topFocus",
                            "topKeyDown",
                            "topKeyUp",
                            "topMouseDown",
                            "topMouseUp",
                            "topSelectionChange",
                        ],
                    },
                };

                var activeElement = null;
                var activeElementInst = null;
                var lastSelection = null;
                var mouseDown = false;

                // Track whether a listener exists for this plugin. If none exist, we do
                // not extract events. See #3639.
                var hasListener = false;

                /**
                 * Get an object which is a unique representation of the current selection.
                 *
                 * The return value will not be consistent across nodes or browsers, but
                 * two identical selections on the same node will return identical objects.
                 *
                 * @param {DOMElement} node
                 * @return {object}
                 */
                function getSelection(node) {
                    if (
                        "selectionStart" in node &&
                        ReactInputSelection.hasSelectionCapabilities(node)
                    ) {
                        return {
                            start: node.selectionStart,
                            end: node.selectionEnd,
                        };
                    } else if (window.getSelection) {
                        var selection = window.getSelection();
                        return {
                            anchorNode: selection.anchorNode,
                            anchorOffset: selection.anchorOffset,
                            focusNode: selection.focusNode,
                            focusOffset: selection.focusOffset,
                        };
                    } else if (document.selection) {
                        var range = document.selection.createRange();
                        return {
                            parentElement: range.parentElement(),
                            text: range.text,
                            top: range.boundingTop,
                            left: range.boundingLeft,
                        };
                    }
                }

                /**
                 * Poll selection to see whether it's changed.
                 *
                 * @param {object} nativeEvent
                 * @return {?SyntheticEvent}
                 */
                function constructSelectEvent(nativeEvent, nativeEventTarget) {
                    // Ensure we have the right element, and that the user is not dragging a
                    // selection (this matches native `select` event behavior). In HTML5, select
                    // fires only on input and textarea thus if there's no focused element we
                    // won't dispatch.
                    if (
                        mouseDown ||
                        activeElement == null ||
                        activeElement !== getActiveElement()
                    ) {
                        return null;
                    }

                    // Only fire when selection has actually changed.
                    var currentSelection = getSelection(activeElement);
                    if (
                        !lastSelection ||
                        !shallowEqual(lastSelection, currentSelection)
                    ) {
                        lastSelection = currentSelection;

                        var syntheticEvent = SyntheticEvent.getPooled(
                            eventTypes.select,
                            activeElementInst,
                            nativeEvent,
                            nativeEventTarget
                        );

                        syntheticEvent.type = "select";
                        syntheticEvent.target = activeElement;

                        EventPropagators.accumulateTwoPhaseDispatches(
                            syntheticEvent
                        );

                        return syntheticEvent;
                    }

                    return null;
                }

                /**
                 * This plugin creates an `onSelect` event that normalizes select events
                 * across form elements.
                 *
                 * Supported elements are:
                 * - input (see `isTextInputElement`)
                 * - textarea
                 * - contentEditable
                 *
                 * This differs from native browser implementations in the following ways:
                 * - Fires on contentEditable fields as well as inputs.
                 * - Fires for collapsed selection.
                 * - Fires after user input.
                 */
                var SelectEventPlugin = {
                    eventTypes: eventTypes,

                    extractEvents: function (
                        topLevelType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    ) {
                        if (!hasListener) {
                            return null;
                        }

                        var targetNode = targetInst
                            ? ReactDOMComponentTree.getNodeFromInstance(
                                  targetInst
                              )
                            : window;

                        switch (topLevelType) {
                            // Track the input node that has focus.
                            case "topFocus":
                                if (
                                    isTextInputElement(targetNode) ||
                                    targetNode.contentEditable === "true"
                                ) {
                                    activeElement = targetNode;
                                    activeElementInst = targetInst;
                                    lastSelection = null;
                                }
                                break;
                            case "topBlur":
                                activeElement = null;
                                activeElementInst = null;
                                lastSelection = null;
                                break;

                            // Don't fire the event while the user is dragging. This matches the
                            // semantics of the native select event.
                            case "topMouseDown":
                                mouseDown = true;
                                break;
                            case "topContextMenu":
                            case "topMouseUp":
                                mouseDown = false;
                                return constructSelectEvent(
                                    nativeEvent,
                                    nativeEventTarget
                                );

                            // Chrome and IE fire non-standard event when selection is changed (and
                            // sometimes when it hasn't). IE's event fires out of order with respect
                            // to key and input events on deletion, so we discard it.
                            //
                            // Firefox doesn't support selectionchange, so check selection status
                            // after each key entry. The selection changes after keydown and before
                            // keyup, but we check on keydown as well in the case of holding down a
                            // key, when multiple keydown events are fired but only one keyup is.
                            // This is also our approach for IE handling, for the reason above.
                            case "topSelectionChange":
                                if (skipSelectionChangeEvent) {
                                    break;
                                }
                            // falls through
                            case "topKeyDown":
                            case "topKeyUp":
                                return constructSelectEvent(
                                    nativeEvent,
                                    nativeEventTarget
                                );
                        }

                        return null;
                    },

                    didPutListener: function (
                        inst,
                        registrationName,
                        listener
                    ) {
                        if (registrationName === "onSelect") {
                            hasListener = true;
                        }
                    },
                };

                module.exports = SelectEventPlugin;

                /***/
            },
            /* 494 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var EventListener = __webpack_require__(481);
                var EventPropagators = __webpack_require__(386);
                var ReactDOMComponentTree = __webpack_require__(379);
                var SyntheticAnimationEvent = __webpack_require__(495);
                var SyntheticClipboardEvent = __webpack_require__(496);
                var SyntheticEvent = __webpack_require__(398);
                var SyntheticFocusEvent = __webpack_require__(497);
                var SyntheticKeyboardEvent = __webpack_require__(498);
                var SyntheticMouseEvent = __webpack_require__(414);
                var SyntheticDragEvent = __webpack_require__(501);
                var SyntheticTouchEvent = __webpack_require__(502);
                var SyntheticTransitionEvent = __webpack_require__(503);
                var SyntheticUIEvent = __webpack_require__(415);
                var SyntheticWheelEvent = __webpack_require__(504);

                var emptyFunction = __webpack_require__(359);
                var getEventCharCode = __webpack_require__(499);
                var invariant = __webpack_require__(355);

                /**
                 * Turns
                 * ['abort', ...]
                 * into
                 * eventTypes = {
                 *   'abort': {
                 *     phasedRegistrationNames: {
                 *       bubbled: 'onAbort',
                 *       captured: 'onAbortCapture',
                 *     },
                 *     dependencies: ['topAbort'],
                 *   },
                 *   ...
                 * };
                 * topLevelEventsToDispatchConfig = {
                 *   'topAbort': { sameConfig }
                 * };
                 */
                var eventTypes = {};
                var topLevelEventsToDispatchConfig = {};
                [
                    "abort",
                    "animationEnd",
                    "animationIteration",
                    "animationStart",
                    "blur",
                    "canPlay",
                    "canPlayThrough",
                    "click",
                    "contextMenu",
                    "copy",
                    "cut",
                    "doubleClick",
                    "drag",
                    "dragEnd",
                    "dragEnter",
                    "dragExit",
                    "dragLeave",
                    "dragOver",
                    "dragStart",
                    "drop",
                    "durationChange",
                    "emptied",
                    "encrypted",
                    "ended",
                    "error",
                    "focus",
                    "input",
                    "invalid",
                    "keyDown",
                    "keyPress",
                    "keyUp",
                    "load",
                    "loadedData",
                    "loadedMetadata",
                    "loadStart",
                    "mouseDown",
                    "mouseMove",
                    "mouseOut",
                    "mouseOver",
                    "mouseUp",
                    "paste",
                    "pause",
                    "play",
                    "playing",
                    "progress",
                    "rateChange",
                    "reset",
                    "scroll",
                    "seeked",
                    "seeking",
                    "stalled",
                    "submit",
                    "suspend",
                    "timeUpdate",
                    "touchCancel",
                    "touchEnd",
                    "touchMove",
                    "touchStart",
                    "transitionEnd",
                    "volumeChange",
                    "waiting",
                    "wheel",
                ].forEach(function (event) {
                    var capitalizedEvent =
                        event[0].toUpperCase() + event.slice(1);
                    var onEvent = "on" + capitalizedEvent;
                    var topEvent = "top" + capitalizedEvent;

                    var type = {
                        phasedRegistrationNames: {
                            bubbled: onEvent,
                            captured: onEvent + "Capture",
                        },
                        dependencies: [topEvent],
                    };
                    eventTypes[event] = type;
                    topLevelEventsToDispatchConfig[topEvent] = type;
                });

                var onClickListeners = {};

                function getDictionaryKey(inst) {
                    // Prevents V8 performance issue:
                    // https://github.com/facebook/react/pull/7232
                    return "." + inst._rootNodeID;
                }

                function isInteractive(tag) {
                    return (
                        tag === "button" ||
                        tag === "input" ||
                        tag === "select" ||
                        tag === "textarea"
                    );
                }

                var SimpleEventPlugin = {
                    eventTypes: eventTypes,

                    extractEvents: function (
                        topLevelType,
                        targetInst,
                        nativeEvent,
                        nativeEventTarget
                    ) {
                        var dispatchConfig =
                            topLevelEventsToDispatchConfig[topLevelType];
                        if (!dispatchConfig) {
                            return null;
                        }
                        var EventConstructor;
                        switch (topLevelType) {
                            case "topAbort":
                            case "topCanPlay":
                            case "topCanPlayThrough":
                            case "topDurationChange":
                            case "topEmptied":
                            case "topEncrypted":
                            case "topEnded":
                            case "topError":
                            case "topInput":
                            case "topInvalid":
                            case "topLoad":
                            case "topLoadedData":
                            case "topLoadedMetadata":
                            case "topLoadStart":
                            case "topPause":
                            case "topPlay":
                            case "topPlaying":
                            case "topProgress":
                            case "topRateChange":
                            case "topReset":
                            case "topSeeked":
                            case "topSeeking":
                            case "topStalled":
                            case "topSubmit":
                            case "topSuspend":
                            case "topTimeUpdate":
                            case "topVolumeChange":
                            case "topWaiting":
                                // HTML Events
                                // @see http://www.w3.org/TR/html5/index.html#events-0
                                EventConstructor = SyntheticEvent;
                                break;
                            case "topKeyPress":
                                // Firefox creates a keypress event for function keys too. This removes
                                // the unwanted keypress events. Enter is however both printable and
                                // non-printable. One would expect Tab to be as well (but it isn't).
                                if (getEventCharCode(nativeEvent) === 0) {
                                    return null;
                                }
                            /* falls through */
                            case "topKeyDown":
                            case "topKeyUp":
                                EventConstructor = SyntheticKeyboardEvent;
                                break;
                            case "topBlur":
                            case "topFocus":
                                EventConstructor = SyntheticFocusEvent;
                                break;
                            case "topClick":
                                // Firefox creates a click event on right mouse clicks. This removes the
                                // unwanted click events.
                                if (nativeEvent.button === 2) {
                                    return null;
                                }
                            /* falls through */
                            case "topDoubleClick":
                            case "topMouseDown":
                            case "topMouseMove":
                            case "topMouseUp":
                            // TODO: Disabled elements should not respond to mouse events
                            /* falls through */
                            case "topMouseOut":
                            case "topMouseOver":
                            case "topContextMenu":
                                EventConstructor = SyntheticMouseEvent;
                                break;
                            case "topDrag":
                            case "topDragEnd":
                            case "topDragEnter":
                            case "topDragExit":
                            case "topDragLeave":
                            case "topDragOver":
                            case "topDragStart":
                            case "topDrop":
                                EventConstructor = SyntheticDragEvent;
                                break;
                            case "topTouchCancel":
                            case "topTouchEnd":
                            case "topTouchMove":
                            case "topTouchStart":
                                EventConstructor = SyntheticTouchEvent;
                                break;
                            case "topAnimationEnd":
                            case "topAnimationIteration":
                            case "topAnimationStart":
                                EventConstructor = SyntheticAnimationEvent;
                                break;
                            case "topTransitionEnd":
                                EventConstructor = SyntheticTransitionEvent;
                                break;
                            case "topScroll":
                                EventConstructor = SyntheticUIEvent;
                                break;
                            case "topWheel":
                                EventConstructor = SyntheticWheelEvent;
                                break;
                            case "topCopy":
                            case "topCut":
                            case "topPaste":
                                EventConstructor = SyntheticClipboardEvent;
                                break;
                        }
                        !EventConstructor
                            ? false
                                ? invariant(
                                      false,
                                      "SimpleEventPlugin: Unhandled event type, `%s`.",
                                      topLevelType
                                  )
                                : _prodInvariant("86", topLevelType)
                            : void 0;
                        var event = EventConstructor.getPooled(
                            dispatchConfig,
                            targetInst,
                            nativeEvent,
                            nativeEventTarget
                        );
                        EventPropagators.accumulateTwoPhaseDispatches(event);
                        return event;
                    },

                    didPutListener: function (
                        inst,
                        registrationName,
                        listener
                    ) {
                        // Mobile Safari does not fire properly bubble click events on
                        // non-interactive elements, which means delegated click listeners do not
                        // fire. The workaround for this bug involves attaching an empty click
                        // listener on the target node.
                        // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
                        if (
                            registrationName === "onClick" &&
                            !isInteractive(inst._tag)
                        ) {
                            var key = getDictionaryKey(inst);
                            var node =
                                ReactDOMComponentTree.getNodeFromInstance(inst);
                            if (!onClickListeners[key]) {
                                onClickListeners[key] = EventListener.listen(
                                    node,
                                    "click",
                                    emptyFunction
                                );
                            }
                        }
                    },

                    willDeleteListener: function (inst, registrationName) {
                        if (
                            registrationName === "onClick" &&
                            !isInteractive(inst._tag)
                        ) {
                            var key = getDictionaryKey(inst);
                            onClickListeners[key].remove();
                            delete onClickListeners[key];
                        }
                    },
                };

                module.exports = SimpleEventPlugin;

                /***/
            },
            /* 495 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticEvent = __webpack_require__(398);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
                 */
                var AnimationEventInterface = {
                    animationName: null,
                    elapsedTime: null,
                    pseudoElement: null,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticEvent}
                 */
                function SyntheticAnimationEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticEvent.augmentClass(
                    SyntheticAnimationEvent,
                    AnimationEventInterface
                );

                module.exports = SyntheticAnimationEvent;

                /***/
            },
            /* 496 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticEvent = __webpack_require__(398);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/clipboard-apis/
                 */
                var ClipboardEventInterface = {
                    clipboardData: function (event) {
                        return "clipboardData" in event
                            ? event.clipboardData
                            : window.clipboardData;
                    },
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticClipboardEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticEvent.augmentClass(
                    SyntheticClipboardEvent,
                    ClipboardEventInterface
                );

                module.exports = SyntheticClipboardEvent;

                /***/
            },
            /* 497 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticUIEvent = __webpack_require__(415);

                /**
                 * @interface FocusEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var FocusEventInterface = {
                    relatedTarget: null,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticFocusEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticUIEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticUIEvent.augmentClass(
                    SyntheticFocusEvent,
                    FocusEventInterface
                );

                module.exports = SyntheticFocusEvent;

                /***/
            },
            /* 498 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticUIEvent = __webpack_require__(415);

                var getEventCharCode = __webpack_require__(499);
                var getEventKey = __webpack_require__(500);
                var getEventModifierState = __webpack_require__(417);

                /**
                 * @interface KeyboardEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var KeyboardEventInterface = {
                    key: getEventKey,
                    location: null,
                    ctrlKey: null,
                    shiftKey: null,
                    altKey: null,
                    metaKey: null,
                    repeat: null,
                    locale: null,
                    getModifierState: getEventModifierState,
                    // Legacy Interface
                    charCode: function (event) {
                        // `charCode` is the result of a KeyPress event and represents the value of
                        // the actual printable character.

                        // KeyPress is deprecated, but its replacement is not yet final and not
                        // implemented in any major browser. Only KeyPress has charCode.
                        if (event.type === "keypress") {
                            return getEventCharCode(event);
                        }
                        return 0;
                    },
                    keyCode: function (event) {
                        // `keyCode` is the result of a KeyDown/Up event and represents the value of
                        // physical keyboard key.

                        // The actual meaning of the value depends on the users' keyboard layout
                        // which cannot be detected. Assuming that it is a US keyboard layout
                        // provides a surprisingly accurate mapping for US and European users.
                        // Due to this, it is left to the user to implement at this time.
                        if (
                            event.type === "keydown" ||
                            event.type === "keyup"
                        ) {
                            return event.keyCode;
                        }
                        return 0;
                    },
                    which: function (event) {
                        // `which` is an alias for either `keyCode` or `charCode` depending on the
                        // type of the event.
                        if (event.type === "keypress") {
                            return getEventCharCode(event);
                        }
                        if (
                            event.type === "keydown" ||
                            event.type === "keyup"
                        ) {
                            return event.keyCode;
                        }
                        return 0;
                    },
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticKeyboardEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticUIEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticUIEvent.augmentClass(
                    SyntheticKeyboardEvent,
                    KeyboardEventInterface
                );

                module.exports = SyntheticKeyboardEvent;

                /***/
            },
            /* 499 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                /**
                 * `charCode` represents the actual "character code" and is safe to use with
                 * `String.fromCharCode`. As such, only keys that correspond to printable
                 * characters produce a valid `charCode`, the only exception to this is Enter.
                 * The Tab-key is considered non-printable and does not have a `charCode`,
                 * presumably because it does not produce a tab-character in browsers.
                 *
                 * @param {object} nativeEvent Native browser event.
                 * @return {number} Normalized `charCode` property.
                 */

                function getEventCharCode(nativeEvent) {
                    var charCode;
                    var keyCode = nativeEvent.keyCode;

                    if ("charCode" in nativeEvent) {
                        charCode = nativeEvent.charCode;

                        // FF does not set `charCode` for the Enter-key, check against `keyCode`.
                        if (charCode === 0 && keyCode === 13) {
                            charCode = 13;
                        }
                    } else {
                        // IE8 does not implement `charCode`, but `keyCode` has the correct value.
                        charCode = keyCode;
                    }

                    // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
                    // Must not discard the (non-)printable Enter-key.
                    if (charCode >= 32 || charCode === 13) {
                        return charCode;
                    }

                    return 0;
                }

                module.exports = getEventCharCode;

                /***/
            },
            /* 500 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var getEventCharCode = __webpack_require__(499);

                /**
                 * Normalization of deprecated HTML5 `key` values
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
                 */
                var normalizeKey = {
                    Esc: "Escape",
                    Spacebar: " ",
                    Left: "ArrowLeft",
                    Up: "ArrowUp",
                    Right: "ArrowRight",
                    Down: "ArrowDown",
                    Del: "Delete",
                    Win: "OS",
                    Menu: "ContextMenu",
                    Apps: "ContextMenu",
                    Scroll: "ScrollLock",
                    MozPrintableKey: "Unidentified",
                };

                /**
                 * Translation from legacy `keyCode` to HTML5 `key`
                 * Only special keys supported, all others depend on keyboard layout or browser
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
                 */
                var translateToKey = {
                    8: "Backspace",
                    9: "Tab",
                    12: "Clear",
                    13: "Enter",
                    16: "Shift",
                    17: "Control",
                    18: "Alt",
                    19: "Pause",
                    20: "CapsLock",
                    27: "Escape",
                    32: " ",
                    33: "PageUp",
                    34: "PageDown",
                    35: "End",
                    36: "Home",
                    37: "ArrowLeft",
                    38: "ArrowUp",
                    39: "ArrowRight",
                    40: "ArrowDown",
                    45: "Insert",
                    46: "Delete",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4",
                    116: "F5",
                    117: "F6",
                    118: "F7",
                    119: "F8",
                    120: "F9",
                    121: "F10",
                    122: "F11",
                    123: "F12",
                    144: "NumLock",
                    145: "ScrollLock",
                    224: "Meta",
                };

                /**
                 * @param {object} nativeEvent Native browser event.
                 * @return {string} Normalized `key` property.
                 */
                function getEventKey(nativeEvent) {
                    if (nativeEvent.key) {
                        // Normalize inconsistent values reported by browsers due to
                        // implementations of a working draft specification.

                        // FireFox implements `key` but returns `MozPrintableKey` for all
                        // printable characters (normalized to `Unidentified`), ignore it.
                        var key =
                            normalizeKey[nativeEvent.key] || nativeEvent.key;
                        if (key !== "Unidentified") {
                            return key;
                        }
                    }

                    // Browser does not implement `key`, polyfill as much of it as we can.
                    if (nativeEvent.type === "keypress") {
                        var charCode = getEventCharCode(nativeEvent);

                        // The enter-key is technically both printable and non-printable and can
                        // thus be captured by `keypress`, no other non-printable key should.
                        return charCode === 13
                            ? "Enter"
                            : String.fromCharCode(charCode);
                    }
                    if (
                        nativeEvent.type === "keydown" ||
                        nativeEvent.type === "keyup"
                    ) {
                        // While user keyboard layout determines the actual meaning of each
                        // `keyCode` value, almost all function keys have a universal value.
                        return (
                            translateToKey[nativeEvent.keyCode] ||
                            "Unidentified"
                        );
                    }
                    return "";
                }

                module.exports = getEventKey;

                /***/
            },
            /* 501 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticMouseEvent = __webpack_require__(414);

                /**
                 * @interface DragEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var DragEventInterface = {
                    dataTransfer: null,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticDragEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticMouseEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticMouseEvent.augmentClass(
                    SyntheticDragEvent,
                    DragEventInterface
                );

                module.exports = SyntheticDragEvent;

                /***/
            },
            /* 502 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticUIEvent = __webpack_require__(415);

                var getEventModifierState = __webpack_require__(417);

                /**
                 * @interface TouchEvent
                 * @see http://www.w3.org/TR/touch-events/
                 */
                var TouchEventInterface = {
                    touches: null,
                    targetTouches: null,
                    changedTouches: null,
                    altKey: null,
                    metaKey: null,
                    ctrlKey: null,
                    shiftKey: null,
                    getModifierState: getEventModifierState,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticTouchEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticUIEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticUIEvent.augmentClass(
                    SyntheticTouchEvent,
                    TouchEventInterface
                );

                module.exports = SyntheticTouchEvent;

                /***/
            },
            /* 503 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticEvent = __webpack_require__(398);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
                 */
                var TransitionEventInterface = {
                    propertyName: null,
                    elapsedTime: null,
                    pseudoElement: null,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticEvent}
                 */
                function SyntheticTransitionEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticEvent.augmentClass(
                    SyntheticTransitionEvent,
                    TransitionEventInterface
                );

                module.exports = SyntheticTransitionEvent;

                /***/
            },
            /* 504 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var SyntheticMouseEvent = __webpack_require__(414);

                /**
                 * @interface WheelEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var WheelEventInterface = {
                    deltaX: function (event) {
                        return "deltaX" in event
                            ? event.deltaX
                            : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
                            "wheelDeltaX" in event
                            ? -event.wheelDeltaX
                            : 0;
                    },
                    deltaY: function (event) {
                        return "deltaY" in event
                            ? event.deltaY
                            : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
                            "wheelDeltaY" in event
                            ? -event.wheelDeltaY
                            : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
                            "wheelDelta" in event
                            ? -event.wheelDelta
                            : 0;
                    },
                    deltaZ: null,

                    // Browsers without "deltaMode" is reporting in raw wheel delta where one
                    // notch on the scroll is always +/- 120, roughly equivalent to pixels.
                    // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
                    // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
                    deltaMode: null,
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticMouseEvent}
                 */
                function SyntheticWheelEvent(
                    dispatchConfig,
                    dispatchMarker,
                    nativeEvent,
                    nativeEventTarget
                ) {
                    return SyntheticMouseEvent.call(
                        this,
                        dispatchConfig,
                        dispatchMarker,
                        nativeEvent,
                        nativeEventTarget
                    );
                }

                SyntheticMouseEvent.augmentClass(
                    SyntheticWheelEvent,
                    WheelEventInterface
                );

                module.exports = SyntheticWheelEvent;

                /***/
            },
            /* 505 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var DOMLazyTree = __webpack_require__(421);
                var DOMProperty = __webpack_require__(381);
                var React = __webpack_require__(350);
                var ReactBrowserEventEmitter = __webpack_require__(445);
                var ReactCurrentOwner = __webpack_require__(357);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactDOMContainerInfo = __webpack_require__(506);
                var ReactDOMFeatureFlags = __webpack_require__(507);
                var ReactFeatureFlags = __webpack_require__(403);
                var ReactInstanceMap = __webpack_require__(456);
                var ReactInstrumentation = __webpack_require__(407);
                var ReactMarkupChecksum = __webpack_require__(508);
                var ReactReconciler = __webpack_require__(404);
                var ReactUpdateQueue = __webpack_require__(474);
                var ReactUpdates = __webpack_require__(401);

                var emptyObject = __webpack_require__(367);
                var instantiateReactComponent = __webpack_require__(458);
                var invariant = __webpack_require__(355);
                var setInnerHTML = __webpack_require__(423);
                var shouldUpdateReactComponent = __webpack_require__(462);
                var warning = __webpack_require__(358);

                var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
                var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

                var ELEMENT_NODE_TYPE = 1;
                var DOC_NODE_TYPE = 9;
                var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

                var instancesByReactRootID = {};

                /**
                 * Finds the index of the first character
                 * that's not common between the two given strings.
                 *
                 * @return {number} the index of the character where the strings diverge
                 */
                function firstDifferenceIndex(string1, string2) {
                    var minLen = Math.min(string1.length, string2.length);
                    for (var i = 0; i < minLen; i++) {
                        if (string1.charAt(i) !== string2.charAt(i)) {
                            return i;
                        }
                    }
                    return string1.length === string2.length ? -1 : minLen;
                }

                /**
                 * @param {DOMElement|DOMDocument} container DOM element that may contain
                 * a React component
                 * @return {?*} DOM element that may have the reactRoot ID, or null.
                 */
                function getReactRootElementInContainer(container) {
                    if (!container) {
                        return null;
                    }

                    if (container.nodeType === DOC_NODE_TYPE) {
                        return container.documentElement;
                    } else {
                        return container.firstChild;
                    }
                }

                function internalGetID(node) {
                    // If node is something like a window, document, or text node, none of
                    // which support attributes or a .getAttribute method, gracefully return
                    // the empty string, as if the attribute were missing.
                    return (
                        (node.getAttribute && node.getAttribute(ATTR_NAME)) ||
                        ""
                    );
                }

                /**
                 * Mounts this component and inserts it into the DOM.
                 *
                 * @param {ReactComponent} componentInstance The instance to mount.
                 * @param {DOMElement} container DOM element to mount into.
                 * @param {ReactReconcileTransaction} transaction
                 * @param {boolean} shouldReuseMarkup If true, do not insert markup
                 */
                function mountComponentIntoNode(
                    wrapperInstance,
                    container,
                    transaction,
                    shouldReuseMarkup,
                    context
                ) {
                    var markerName;
                    if (ReactFeatureFlags.logTopLevelRenders) {
                        var wrappedElement =
                            wrapperInstance._currentElement.props.child;
                        var type = wrappedElement.type;
                        markerName =
                            "React mount: " +
                            (typeof type === "string"
                                ? type
                                : type.displayName || type.name);
                        console.time(markerName);
                    }

                    var markup = ReactReconciler.mountComponent(
                        wrapperInstance,
                        transaction,
                        null,
                        ReactDOMContainerInfo(wrapperInstance, container),
                        context,
                        0 /* parentDebugID */
                    );

                    if (markerName) {
                        console.timeEnd(markerName);
                    }

                    wrapperInstance._renderedComponent._topLevelWrapper =
                        wrapperInstance;
                    ReactMount._mountImageIntoNode(
                        markup,
                        container,
                        wrapperInstance,
                        shouldReuseMarkup,
                        transaction
                    );
                }

                /**
                 * Batched mount.
                 *
                 * @param {ReactComponent} componentInstance The instance to mount.
                 * @param {DOMElement} container DOM element to mount into.
                 * @param {boolean} shouldReuseMarkup If true, do not insert markup
                 */
                function batchedMountComponentIntoNode(
                    componentInstance,
                    container,
                    shouldReuseMarkup,
                    context
                ) {
                    var transaction =
                        ReactUpdates.ReactReconcileTransaction.getPooled(
                            /* useCreateElement */
                            !shouldReuseMarkup &&
                                ReactDOMFeatureFlags.useCreateElement
                        );
                    transaction.perform(
                        mountComponentIntoNode,
                        null,
                        componentInstance,
                        container,
                        transaction,
                        shouldReuseMarkup,
                        context
                    );
                    ReactUpdates.ReactReconcileTransaction.release(transaction);
                }

                /**
                 * Unmounts a component and removes it from the DOM.
                 *
                 * @param {ReactComponent} instance React component instance.
                 * @param {DOMElement} container DOM element to unmount from.
                 * @final
                 * @internal
                 * @see {ReactMount.unmountComponentAtNode}
                 */
                function unmountComponentFromNode(instance, container, safely) {
                    if (false) {
                        ReactInstrumentation.debugTool.onBeginFlush();
                    }
                    ReactReconciler.unmountComponent(instance, safely);
                    if (false) {
                        ReactInstrumentation.debugTool.onEndFlush();
                    }

                    if (container.nodeType === DOC_NODE_TYPE) {
                        container = container.documentElement;
                    }

                    // http://jsperf.com/emptying-a-node
                    while (container.lastChild) {
                        container.removeChild(container.lastChild);
                    }
                }

                /**
                 * True if the supplied DOM node has a direct React-rendered child that is
                 * not a React root element. Useful for warning in `render`,
                 * `unmountComponentAtNode`, etc.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM element contains a direct child that was
                 * rendered by React but is not a root element.
                 * @internal
                 */
                function hasNonRootReactChild(container) {
                    var rootEl = getReactRootElementInContainer(container);
                    if (rootEl) {
                        var inst =
                            ReactDOMComponentTree.getInstanceFromNode(rootEl);
                        return !!(inst && inst._hostParent);
                    }
                }

                /**
                 * True if the supplied DOM node is a React DOM element and
                 * it has been rendered by another copy of React.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM has been rendered by another copy of React
                 * @internal
                 */
                function nodeIsRenderedByOtherInstance(container) {
                    var rootEl = getReactRootElementInContainer(container);
                    return !!(
                        rootEl &&
                        isReactNode(rootEl) &&
                        !ReactDOMComponentTree.getInstanceFromNode(rootEl)
                    );
                }

                /**
                 * True if the supplied DOM node is a valid node element.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM is a valid DOM node.
                 * @internal
                 */
                function isValidContainer(node) {
                    return !!(
                        node &&
                        (node.nodeType === ELEMENT_NODE_TYPE ||
                            node.nodeType === DOC_NODE_TYPE ||
                            node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)
                    );
                }

                /**
                 * True if the supplied DOM node is a valid React node element.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM is a valid React DOM node.
                 * @internal
                 */
                function isReactNode(node) {
                    return (
                        isValidContainer(node) &&
                        (node.hasAttribute(ROOT_ATTR_NAME) ||
                            node.hasAttribute(ATTR_NAME))
                    );
                }

                function getHostRootInstanceInContainer(container) {
                    var rootEl = getReactRootElementInContainer(container);
                    var prevHostInstance =
                        rootEl &&
                        ReactDOMComponentTree.getInstanceFromNode(rootEl);
                    return prevHostInstance && !prevHostInstance._hostParent
                        ? prevHostInstance
                        : null;
                }

                function getTopLevelWrapperInContainer(container) {
                    var root = getHostRootInstanceInContainer(container);
                    return root
                        ? root._hostContainerInfo._topLevelWrapper
                        : null;
                }

                /**
                 * Temporary (?) hack so that we can store all top-level pending updates on
                 * composites instead of having to worry about different types of components
                 * here.
                 */
                var topLevelRootCounter = 1;
                var TopLevelWrapper = function () {
                    this.rootID = topLevelRootCounter++;
                };
                TopLevelWrapper.prototype.isReactComponent = {};
                if (false) {
                    TopLevelWrapper.displayName = "TopLevelWrapper";
                }
                TopLevelWrapper.prototype.render = function () {
                    return this.props.child;
                };
                TopLevelWrapper.isReactTopLevelWrapper = true;

                /**
                 * Mounting is the process of initializing a React component by creating its
                 * representative DOM elements and inserting them into a supplied `container`.
                 * Any prior content inside `container` is destroyed in the process.
                 *
                 *   ReactMount.render(
                 *     component,
                 *     document.getElementById('container')
                 *   );
                 *
                 *   <div id="container">                   <-- Supplied `container`.
                 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
                 *       // ...                                 component.
                 *     </div>
                 *   </div>
                 *
                 * Inside of `container`, the first element rendered is the "reactRoot".
                 */
                var ReactMount = {
                    TopLevelWrapper: TopLevelWrapper,

                    /**
                     * Used by devtools. The keys are not important.
                     */
                    _instancesByReactRootID: instancesByReactRootID,

                    /**
                     * This is a hook provided to support rendering React components while
                     * ensuring that the apparent scroll position of its `container` does not
                     * change.
                     *
                     * @param {DOMElement} container The `container` being rendered into.
                     * @param {function} renderCallback This must be called once to do the render.
                     */
                    scrollMonitor: function (container, renderCallback) {
                        renderCallback();
                    },

                    /**
                     * Take a component that's already mounted into the DOM and replace its props
                     * @param {ReactComponent} prevComponent component instance already in the DOM
                     * @param {ReactElement} nextElement component instance to render
                     * @param {DOMElement} container container to render into
                     * @param {?function} callback function triggered on completion
                     */
                    _updateRootComponent: function (
                        prevComponent,
                        nextElement,
                        nextContext,
                        container,
                        callback
                    ) {
                        ReactMount.scrollMonitor(container, function () {
                            ReactUpdateQueue.enqueueElementInternal(
                                prevComponent,
                                nextElement,
                                nextContext
                            );
                            if (callback) {
                                ReactUpdateQueue.enqueueCallbackInternal(
                                    prevComponent,
                                    callback
                                );
                            }
                        });

                        return prevComponent;
                    },

                    /**
                     * Render a new component into the DOM. Hooked by hooks!
                     *
                     * @param {ReactElement} nextElement element to render
                     * @param {DOMElement} container container to render into
                     * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
                     * @return {ReactComponent} nextComponent
                     */
                    _renderNewRootComponent: function (
                        nextElement,
                        container,
                        shouldReuseMarkup,
                        context
                    ) {
                        // Various parts of our code (such as ReactCompositeComponent's
                        // _renderValidatedComponent) assume that calls to render aren't nested;
                        // verify that that's the case.
                        false
                            ? warning(
                                  ReactCurrentOwner.current == null,
                                  "_renderNewRootComponent(): Render methods should be a pure function " +
                                      "of props and state; triggering nested component updates from " +
                                      "render is not allowed. If necessary, trigger nested updates in " +
                                      "componentDidUpdate. Check the render method of %s.",
                                  (ReactCurrentOwner.current &&
                                      ReactCurrentOwner.current.getName()) ||
                                      "ReactCompositeComponent"
                              )
                            : void 0;

                        !isValidContainer(container)
                            ? false
                                ? invariant(
                                      false,
                                      "_registerComponent(...): Target container is not a DOM element."
                                  )
                                : _prodInvariant("37")
                            : void 0;

                        ReactBrowserEventEmitter.ensureScrollValueMonitoring();
                        var componentInstance = instantiateReactComponent(
                            nextElement,
                            false
                        );

                        // The initial render is synchronous but any updates that happen during
                        // rendering, in componentWillMount or componentDidMount, will be batched
                        // according to the current batching strategy.

                        ReactUpdates.batchedUpdates(
                            batchedMountComponentIntoNode,
                            componentInstance,
                            container,
                            shouldReuseMarkup,
                            context
                        );

                        var wrapperID = componentInstance._instance.rootID;
                        instancesByReactRootID[wrapperID] = componentInstance;

                        return componentInstance;
                    },

                    /**
                     * Renders a React component into the DOM in the supplied `container`.
                     *
                     * If the React component was previously rendered into `container`, this will
                     * perform an update on it and only mutate the DOM as necessary to reflect the
                     * latest React component.
                     *
                     * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
                     * @param {ReactElement} nextElement Component element to render.
                     * @param {DOMElement} container DOM element to render into.
                     * @param {?function} callback function triggered on completion
                     * @return {ReactComponent} Component instance rendered in `container`.
                     */
                    renderSubtreeIntoContainer: function (
                        parentComponent,
                        nextElement,
                        container,
                        callback
                    ) {
                        !(
                            parentComponent != null &&
                            ReactInstanceMap.has(parentComponent)
                        )
                            ? false
                                ? invariant(
                                      false,
                                      "parentComponent must be a valid React Component"
                                  )
                                : _prodInvariant("38")
                            : void 0;
                        return ReactMount._renderSubtreeIntoContainer(
                            parentComponent,
                            nextElement,
                            container,
                            callback
                        );
                    },

                    _renderSubtreeIntoContainer: function (
                        parentComponent,
                        nextElement,
                        container,
                        callback
                    ) {
                        ReactUpdateQueue.validateCallback(
                            callback,
                            "ReactDOM.render"
                        );
                        !React.isValidElement(nextElement)
                            ? false
                                ? invariant(
                                      false,
                                      "ReactDOM.render(): Invalid component element.%s",
                                      typeof nextElement === "string"
                                          ? " Instead of passing a string like 'div', pass " +
                                                "React.createElement('div') or <div />."
                                          : typeof nextElement === "function"
                                          ? " Instead of passing a class like Foo, pass " +
                                            "React.createElement(Foo) or <Foo />."
                                          : // Check if it quacks like an element
                                          nextElement != null &&
                                            nextElement.props !== undefined
                                          ? " This may be caused by unintentionally loading two independent " +
                                            "copies of React."
                                          : ""
                                  )
                                : _prodInvariant(
                                      "39",
                                      typeof nextElement === "string"
                                          ? " Instead of passing a string like 'div', pass " +
                                                "React.createElement('div') or <div />."
                                          : typeof nextElement === "function"
                                          ? " Instead of passing a class like Foo, pass " +
                                            "React.createElement(Foo) or <Foo />."
                                          : nextElement != null &&
                                            nextElement.props !== undefined
                                          ? " This may be caused by unintentionally loading two independent " +
                                            "copies of React."
                                          : ""
                                  )
                            : void 0;

                        false
                            ? warning(
                                  !container ||
                                      !container.tagName ||
                                      container.tagName.toUpperCase() !==
                                          "BODY",
                                  "render(): Rendering components directly into document.body is " +
                                      "discouraged, since its children are often manipulated by third-party " +
                                      "scripts and browser extensions. This may lead to subtle " +
                                      "reconciliation issues. Try rendering into a container element created " +
                                      "for your app."
                              )
                            : void 0;

                        var nextWrappedElement = React.createElement(
                            TopLevelWrapper,
                            { child: nextElement }
                        );

                        var nextContext;
                        if (parentComponent) {
                            var parentInst =
                                ReactInstanceMap.get(parentComponent);
                            nextContext = parentInst._processChildContext(
                                parentInst._context
                            );
                        } else {
                            nextContext = emptyObject;
                        }

                        var prevComponent =
                            getTopLevelWrapperInContainer(container);

                        if (prevComponent) {
                            var prevWrappedElement =
                                prevComponent._currentElement;
                            var prevElement = prevWrappedElement.props.child;
                            if (
                                shouldUpdateReactComponent(
                                    prevElement,
                                    nextElement
                                )
                            ) {
                                var publicInst =
                                    prevComponent._renderedComponent.getPublicInstance();
                                var updatedCallback =
                                    callback &&
                                    function () {
                                        callback.call(publicInst);
                                    };
                                ReactMount._updateRootComponent(
                                    prevComponent,
                                    nextWrappedElement,
                                    nextContext,
                                    container,
                                    updatedCallback
                                );
                                return publicInst;
                            } else {
                                ReactMount.unmountComponentAtNode(container);
                            }
                        }

                        var reactRootElement =
                            getReactRootElementInContainer(container);
                        var containerHasReactMarkup =
                            reactRootElement &&
                            !!internalGetID(reactRootElement);
                        var containerHasNonRootReactChild =
                            hasNonRootReactChild(container);

                        if (false) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !containerHasNonRootReactChild,
                                      "render(...): Replacing React-rendered children with a new root " +
                                          "component. If you intended to update the children of this node, " +
                                          "you should instead have the existing children update their state " +
                                          "and render the new components instead of calling ReactDOM.render."
                                  )
                                : void 0;

                            if (
                                !containerHasReactMarkup ||
                                reactRootElement.nextSibling
                            ) {
                                var rootElementSibling = reactRootElement;
                                while (rootElementSibling) {
                                    if (internalGetID(rootElementSibling)) {
                                        process.env.NODE_ENV !== "production"
                                            ? warning(
                                                  false,
                                                  "render(): Target node has markup rendered by React, but there " +
                                                      "are unrelated nodes as well. This is most commonly caused by " +
                                                      "white-space inserted around server-rendered markup."
                                              )
                                            : void 0;
                                        break;
                                    }
                                    rootElementSibling =
                                        rootElementSibling.nextSibling;
                                }
                            }
                        }

                        var shouldReuseMarkup =
                            containerHasReactMarkup &&
                            !prevComponent &&
                            !containerHasNonRootReactChild;
                        var component = ReactMount._renderNewRootComponent(
                            nextWrappedElement,
                            container,
                            shouldReuseMarkup,
                            nextContext
                        )._renderedComponent.getPublicInstance();
                        if (callback) {
                            callback.call(component);
                        }
                        return component;
                    },

                    /**
                     * Renders a React component into the DOM in the supplied `container`.
                     * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
                     *
                     * If the React component was previously rendered into `container`, this will
                     * perform an update on it and only mutate the DOM as necessary to reflect the
                     * latest React component.
                     *
                     * @param {ReactElement} nextElement Component element to render.
                     * @param {DOMElement} container DOM element to render into.
                     * @param {?function} callback function triggered on completion
                     * @return {ReactComponent} Component instance rendered in `container`.
                     */
                    render: function (nextElement, container, callback) {
                        return ReactMount._renderSubtreeIntoContainer(
                            null,
                            nextElement,
                            container,
                            callback
                        );
                    },

                    /**
                     * Unmounts and destroys the React component rendered in the `container`.
                     * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
                     *
                     * @param {DOMElement} container DOM element containing a React component.
                     * @return {boolean} True if a component was found in and unmounted from
                     *                   `container`
                     */
                    unmountComponentAtNode: function (container) {
                        // Various parts of our code (such as ReactCompositeComponent's
                        // _renderValidatedComponent) assume that calls to render aren't nested;
                        // verify that that's the case. (Strictly speaking, unmounting won't cause a
                        // render but we still don't expect to be in a render call here.)
                        false
                            ? warning(
                                  ReactCurrentOwner.current == null,
                                  "unmountComponentAtNode(): Render methods should be a pure function " +
                                      "of props and state; triggering nested component updates from render " +
                                      "is not allowed. If necessary, trigger nested updates in " +
                                      "componentDidUpdate. Check the render method of %s.",
                                  (ReactCurrentOwner.current &&
                                      ReactCurrentOwner.current.getName()) ||
                                      "ReactCompositeComponent"
                              )
                            : void 0;

                        !isValidContainer(container)
                            ? false
                                ? invariant(
                                      false,
                                      "unmountComponentAtNode(...): Target container is not a DOM element."
                                  )
                                : _prodInvariant("40")
                            : void 0;

                        if (false) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      !nodeIsRenderedByOtherInstance(container),
                                      "unmountComponentAtNode(): The node you're attempting to unmount " +
                                          "was rendered by another copy of React."
                                  )
                                : void 0;
                        }

                        var prevComponent =
                            getTopLevelWrapperInContainer(container);
                        if (!prevComponent) {
                            // Check if the node being unmounted was rendered by React, but isn't a
                            // root node.
                            var containerHasNonRootReactChild =
                                hasNonRootReactChild(container);

                            // Check if the container itself is a React root node.
                            var isContainerReactRoot =
                                container.nodeType === 1 &&
                                container.hasAttribute(ROOT_ATTR_NAME);

                            if (false) {
                                process.env.NODE_ENV !== "production"
                                    ? warning(
                                          !containerHasNonRootReactChild,
                                          "unmountComponentAtNode(): The node you're attempting to unmount " +
                                              "was rendered by React and is not a top-level container. %s",
                                          isContainerReactRoot
                                              ? "You may have accidentally passed in a React root node instead " +
                                                    "of its container."
                                              : "Instead, have the parent component update its state and " +
                                                    "rerender in order to remove this component."
                                      )
                                    : void 0;
                            }

                            return false;
                        }
                        delete instancesByReactRootID[
                            prevComponent._instance.rootID
                        ];
                        ReactUpdates.batchedUpdates(
                            unmountComponentFromNode,
                            prevComponent,
                            container,
                            false
                        );
                        return true;
                    },

                    _mountImageIntoNode: function (
                        markup,
                        container,
                        instance,
                        shouldReuseMarkup,
                        transaction
                    ) {
                        !isValidContainer(container)
                            ? false
                                ? invariant(
                                      false,
                                      "mountComponentIntoNode(...): Target container is not valid."
                                  )
                                : _prodInvariant("41")
                            : void 0;

                        if (shouldReuseMarkup) {
                            var rootElement =
                                getReactRootElementInContainer(container);
                            if (
                                ReactMarkupChecksum.canReuseMarkup(
                                    markup,
                                    rootElement
                                )
                            ) {
                                ReactDOMComponentTree.precacheNode(
                                    instance,
                                    rootElement
                                );
                                return;
                            } else {
                                var checksum = rootElement.getAttribute(
                                    ReactMarkupChecksum.CHECKSUM_ATTR_NAME
                                );
                                rootElement.removeAttribute(
                                    ReactMarkupChecksum.CHECKSUM_ATTR_NAME
                                );

                                var rootMarkup = rootElement.outerHTML;
                                rootElement.setAttribute(
                                    ReactMarkupChecksum.CHECKSUM_ATTR_NAME,
                                    checksum
                                );

                                var normalizedMarkup = markup;
                                if (false) {
                                    // because rootMarkup is retrieved from the DOM, various normalizations
                                    // will have occurred which will not be present in `markup`. Here,
                                    // insert markup into a <div> or <iframe> depending on the container
                                    // type to perform the same normalizations before comparing.
                                    var normalizer;
                                    if (
                                        container.nodeType === ELEMENT_NODE_TYPE
                                    ) {
                                        normalizer =
                                            document.createElement("div");
                                        normalizer.innerHTML = markup;
                                        normalizedMarkup = normalizer.innerHTML;
                                    } else {
                                        normalizer =
                                            document.createElement("iframe");
                                        document.body.appendChild(normalizer);
                                        normalizer.contentDocument.write(
                                            markup
                                        );
                                        normalizedMarkup =
                                            normalizer.contentDocument
                                                .documentElement.outerHTML;
                                        document.body.removeChild(normalizer);
                                    }
                                }

                                var diffIndex = firstDifferenceIndex(
                                    normalizedMarkup,
                                    rootMarkup
                                );
                                var difference =
                                    " (client) " +
                                    normalizedMarkup.substring(
                                        diffIndex - 20,
                                        diffIndex + 20
                                    ) +
                                    "\n (server) " +
                                    rootMarkup.substring(
                                        diffIndex - 20,
                                        diffIndex + 20
                                    );

                                !(container.nodeType !== DOC_NODE_TYPE)
                                    ? false
                                        ? invariant(
                                              false,
                                              "You're trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s",
                                              difference
                                          )
                                        : _prodInvariant("42", difference)
                                    : void 0;

                                if (false) {
                                    process.env.NODE_ENV !== "production"
                                        ? warning(
                                              false,
                                              "React attempted to reuse markup in a container but the " +
                                                  "checksum was invalid. This generally means that you are " +
                                                  "using server rendering and the markup generated on the " +
                                                  "server was not what the client was expecting. React injected " +
                                                  "new markup to compensate which works but you have lost many " +
                                                  "of the benefits of server rendering. Instead, figure out " +
                                                  "why the markup being generated is different on the client " +
                                                  "or server:\n%s",
                                              difference
                                          )
                                        : void 0;
                                }
                            }
                        }

                        !(container.nodeType !== DOC_NODE_TYPE)
                            ? false
                                ? invariant(
                                      false,
                                      "You're trying to render a component to the document but you didn't use server rendering. We can't do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering."
                                  )
                                : _prodInvariant("43")
                            : void 0;

                        if (transaction.useCreateElement) {
                            while (container.lastChild) {
                                container.removeChild(container.lastChild);
                            }
                            DOMLazyTree.insertTreeBefore(
                                container,
                                markup,
                                null
                            );
                        } else {
                            setInnerHTML(container, markup);
                            ReactDOMComponentTree.precacheNode(
                                instance,
                                container.firstChild
                            );
                        }

                        if (false) {
                            var hostNode =
                                ReactDOMComponentTree.getInstanceFromNode(
                                    container.firstChild
                                );
                            if (hostNode._debugID !== 0) {
                                ReactInstrumentation.debugTool.onHostOperation({
                                    instanceID: hostNode._debugID,
                                    type: "mount",
                                    payload: markup.toString(),
                                });
                            }
                        }
                    },
                };

                module.exports = ReactMount;

                /***/
            },
            /* 506 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var validateDOMNesting = __webpack_require__(475);

                var DOC_NODE_TYPE = 9;

                function ReactDOMContainerInfo(topLevelWrapper, node) {
                    var info = {
                        _topLevelWrapper: topLevelWrapper,
                        _idCounter: 1,
                        _ownerDocument: node
                            ? node.nodeType === DOC_NODE_TYPE
                                ? node
                                : node.ownerDocument
                            : null,
                        _node: node,
                        _tag: node ? node.nodeName.toLowerCase() : null,
                        _namespaceURI: node ? node.namespaceURI : null,
                    };
                    if (false) {
                        info._ancestorInfo = node
                            ? validateDOMNesting.updatedAncestorInfo(
                                  null,
                                  info._tag,
                                  null
                              )
                            : null;
                    }
                    return info;
                }

                module.exports = ReactDOMContainerInfo;

                /***/
            },
            /* 507 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactDOMFeatureFlags = {
                    useCreateElement: true,
                    useFiber: false,
                };

                module.exports = ReactDOMFeatureFlags;

                /***/
            },
            /* 508 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var adler32 = __webpack_require__(509);

                var TAG_END = /\/?>/;
                var COMMENT_START = /^<\!\-\-/;

                var ReactMarkupChecksum = {
                    CHECKSUM_ATTR_NAME: "data-react-checksum",

                    /**
                     * @param {string} markup Markup string
                     * @return {string} Markup string with checksum attribute attached
                     */
                    addChecksumToMarkup: function (markup) {
                        var checksum = adler32(markup);

                        // Add checksum (handle both parent tags, comments and self-closing tags)
                        if (COMMENT_START.test(markup)) {
                            return markup;
                        } else {
                            return markup.replace(
                                TAG_END,
                                " " +
                                    ReactMarkupChecksum.CHECKSUM_ATTR_NAME +
                                    '="' +
                                    checksum +
                                    '"$&'
                            );
                        }
                    },

                    /**
                     * @param {string} markup to use
                     * @param {DOMElement} element root React element
                     * @returns {boolean} whether or not the markup is the same
                     */
                    canReuseMarkup: function (markup, element) {
                        var existingChecksum = element.getAttribute(
                            ReactMarkupChecksum.CHECKSUM_ATTR_NAME
                        );
                        existingChecksum =
                            existingChecksum && parseInt(existingChecksum, 10);
                        var markupChecksum = adler32(markup);
                        return markupChecksum === existingChecksum;
                    },
                };

                module.exports = ReactMarkupChecksum;

                /***/
            },
            /* 509 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 *
                 */

                "use strict";

                var MOD = 65521;

                // adler32 is not cryptographically strong, and is only used to sanity check that
                // markup generated on the server matches the markup generated on the client.
                // This implementation (a modified version of the SheetJS version) has been optimized
                // for our use case, at the expense of conforming to the adler32 specification
                // for non-ascii inputs.
                function adler32(data) {
                    var a = 1;
                    var b = 0;
                    var i = 0;
                    var l = data.length;
                    var m = l & ~0x3;
                    while (i < m) {
                        var n = Math.min(i + 4096, m);
                        for (; i < n; i += 4) {
                            b +=
                                (a += data.charCodeAt(i)) +
                                (a += data.charCodeAt(i + 1)) +
                                (a += data.charCodeAt(i + 2)) +
                                (a += data.charCodeAt(i + 3));
                        }
                        a %= MOD;
                        b %= MOD;
                    }
                    for (; i < l; i++) {
                        b += a += data.charCodeAt(i);
                    }
                    a %= MOD;
                    b %= MOD;
                    return a | (b << 16);
                }

                module.exports = adler32;

                /***/
            },
            /* 510 */
            /***/ function (module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                module.exports = "15.4.2";

                /***/
            },
            /* 511 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var _prodInvariant = __webpack_require__(380);

                var ReactCurrentOwner = __webpack_require__(357);
                var ReactDOMComponentTree = __webpack_require__(379);
                var ReactInstanceMap = __webpack_require__(456);

                var getHostComponentFromComposite = __webpack_require__(512);
                var invariant = __webpack_require__(355);
                var warning = __webpack_require__(358);

                /**
                 * Returns the DOM node rendered by this element.
                 *
                 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
                 *
                 * @param {ReactComponent|DOMElement} componentOrElement
                 * @return {?DOMElement} The root node of this element.
                 */
                function findDOMNode(componentOrElement) {
                    if (false) {
                        var owner = ReactCurrentOwner.current;
                        if (owner !== null) {
                            process.env.NODE_ENV !== "production"
                                ? warning(
                                      owner._warnedAboutRefsInRender,
                                      "%s is accessing findDOMNode inside its render(). " +
                                          "render() should be a pure function of props and state. It should " +
                                          "never access something that requires stale data from the previous " +
                                          "render, such as refs. Move this logic to componentDidMount and " +
                                          "componentDidUpdate instead.",
                                      owner.getName() || "A component"
                                  )
                                : void 0;
                            owner._warnedAboutRefsInRender = true;
                        }
                    }
                    if (componentOrElement == null) {
                        return null;
                    }
                    if (componentOrElement.nodeType === 1) {
                        return componentOrElement;
                    }

                    var inst = ReactInstanceMap.get(componentOrElement);
                    if (inst) {
                        inst = getHostComponentFromComposite(inst);
                        return inst
                            ? ReactDOMComponentTree.getNodeFromInstance(inst)
                            : null;
                    }

                    if (typeof componentOrElement.render === "function") {
                        true
                            ? false
                                ? invariant(
                                      false,
                                      "findDOMNode was called on an unmounted component."
                                  )
                                : _prodInvariant("44")
                            : void 0;
                    } else {
                        true
                            ? false
                                ? invariant(
                                      false,
                                      "Element appears to be neither ReactComponent nor DOMNode (keys: %s)",
                                      Object.keys(componentOrElement)
                                  )
                                : _prodInvariant(
                                      "45",
                                      Object.keys(componentOrElement)
                                  )
                            : void 0;
                    }
                }

                module.exports = findDOMNode;

                /***/
            },
            /* 512 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactNodeTypes = __webpack_require__(460);

                function getHostComponentFromComposite(inst) {
                    var type;

                    while (
                        (type = inst._renderedNodeType) ===
                        ReactNodeTypes.COMPOSITE
                    ) {
                        inst = inst._renderedComponent;
                    }

                    if (type === ReactNodeTypes.HOST) {
                        return inst._renderedComponent;
                    } else if (type === ReactNodeTypes.EMPTY) {
                        return null;
                    }
                }

                module.exports = getHostComponentFromComposite;

                /***/
            },
            /* 513 */
            /***/ function (module, exports, __webpack_require__) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                "use strict";

                var ReactMount = __webpack_require__(505);

                module.exports = ReactMount.renderSubtreeIntoContainer;

                /***/
            },
            /* 514 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.unescapeRefinement =
                    exports.escapeRefinement =
                    exports.prefixKeys =
                    exports.clearRefinementsAndSearch =
                    exports.clearRefinementsFromState =
                    exports.getRefinements =
                    exports.isDomElement =
                    exports.isSpecialClick =
                    exports.prepareTemplateProps =
                    exports.bemHelper =
                    exports.getContainerNode =
                        undefined;

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _reduce = __webpack_require__(187);

                var _reduce2 = _interopRequireDefault(_reduce);

                var _forEach = __webpack_require__(129);

                var _forEach2 = _interopRequireDefault(_forEach);

                var _find = __webpack_require__(240);

                var _find2 = _interopRequireDefault(_find);

                var _get = __webpack_require__(168);

                var _get2 = _interopRequireDefault(_get);

                var _isEmpty = __webpack_require__(236);

                var _isEmpty2 = _interopRequireDefault(_isEmpty);

                var _keys = __webpack_require__(41);

                var _keys2 = _interopRequireDefault(_keys);

                var _uniq = __webpack_require__(515);

                var _uniq2 = _interopRequireDefault(_uniq);

                var _mapKeys = __webpack_require__(335);

                var _mapKeys2 = _interopRequireDefault(_mapKeys);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _toConsumableArray(arr) {
                    if (Array.isArray(arr)) {
                        for (
                            var i = 0, arr2 = Array(arr.length);
                            i < arr.length;
                            i++
                        ) {
                            arr2[i] = arr[i];
                        }
                        return arr2;
                    } else {
                        return Array.from(arr);
                    }
                }

                exports.getContainerNode = getContainerNode;
                exports.bemHelper = bemHelper;
                exports.prepareTemplateProps = prepareTemplateProps;
                exports.isSpecialClick = isSpecialClick;
                exports.isDomElement = isDomElement;
                exports.getRefinements = getRefinements;
                exports.clearRefinementsFromState = clearRefinementsFromState;
                exports.clearRefinementsAndSearch = clearRefinementsAndSearch;
                exports.prefixKeys = prefixKeys;
                exports.escapeRefinement = escapeRefinement;
                exports.unescapeRefinement = unescapeRefinement;

                /**
                 * Return the container. If it's a string, it is considered a
                 * css selector and retrieves the first matching element. Otherwise
                 * test if it validates that it's a correct DOMElement.
                 * @param {string|DOMElement} selectorOrHTMLElement a selector or a node
                 * @return {DOMElement} The resolved DOMElement
                 * @throws Error when the type is not correct
                 */

                function getContainerNode(selectorOrHTMLElement) {
                    var isFromString =
                        typeof selectorOrHTMLElement === "string";
                    var domElement = void 0;
                    if (isFromString) {
                        domElement = document.querySelector(
                            selectorOrHTMLElement
                        );
                    } else {
                        domElement = selectorOrHTMLElement;
                    }

                    if (!isDomElement(domElement)) {
                        var errorMessage =
                            "Container must be `string` or `HTMLElement`.";
                        if (isFromString) {
                            errorMessage +=
                                " Unable to find " + selectorOrHTMLElement;
                        }
                        throw new Error(errorMessage);
                    }

                    return domElement;
                }

                /**
                 * Returns true if the parameter is a DOMElement.
                 * @param {any} o the value to test
                 * @return {boolean} true if o is a DOMElement
                 */
                function isDomElement(o) {
                    return (
                        o instanceof window.HTMLElement ||
                        (Boolean(o) && o.nodeType > 0)
                    );
                }

                function isSpecialClick(event) {
                    var isMiddleClick = event.button === 1;
                    return (
                        isMiddleClick ||
                        event.altKey ||
                        event.ctrlKey ||
                        event.metaKey ||
                        event.shiftKey
                    );
                }

                /**
                 * Creates BEM class name according the vanilla BEM style.
                 * @param {string} block the main block
                 * @return {function} function that takes up to 2 parameters
                 * that determine the element and the modifier of the BEM class.
                 */
                function bemHelper(block) {
                    return function (element, modifier) {
                        // block--element
                        if (element && !modifier) {
                            return block + "--" + element;
                        }
                        // block--element__modifier
                        if (element && modifier) {
                            return block + "--" + element + "__" + modifier;
                        }
                        // block__modifier
                        if (!element && modifier) {
                            return block + "__" + modifier;
                        }

                        return block;
                    };
                }

                /**
                 * Prepares an object to be passed to the Template widget
                 * @param {object} unknownBecauseES6 an object with the following attributes:
                 *  - transformData
                 *  - defaultTemplate
                 *  - templates
                 *  - templatesConfig
                 * @return {object} the configuration with the attributes:
                 *  - transformData
                 *  - defaultTemplate
                 *  - templates
                 *  - useCustomCompileOptions
                 */
                function prepareTemplateProps(_ref) {
                    var transformData = _ref.transformData,
                        defaultTemplates = _ref.defaultTemplates,
                        templates = _ref.templates,
                        templatesConfig = _ref.templatesConfig;

                    var preparedTemplates = prepareTemplates(
                        defaultTemplates,
                        templates
                    );

                    return _extends(
                        {
                            transformData: transformData,
                            templatesConfig: templatesConfig,
                        },
                        preparedTemplates
                    );
                }

                function prepareTemplates() {
                    var defaultTemplates =
                        arguments.length > 0 && arguments[0] !== undefined
                            ? arguments[0]
                            : {};
                    var templates =
                        arguments.length > 1 && arguments[1] !== undefined
                            ? arguments[1]
                            : {};

                    var allKeys = (0, _uniq2.default)(
                        [].concat(
                            _toConsumableArray(
                                (0, _keys2.default)(defaultTemplates)
                            ),
                            _toConsumableArray((0, _keys2.default)(templates))
                        )
                    );

                    return (0, _reduce2.default)(
                        allKeys,
                        function (config, key) {
                            var defaultTemplate = defaultTemplates[key];
                            var customTemplate = templates[key];
                            var isCustomTemplate =
                                customTemplate !== undefined &&
                                customTemplate !== defaultTemplate;

                            config.templates[key] = isCustomTemplate
                                ? customTemplate
                                : defaultTemplate;
                            config.useCustomCompileOptions[key] =
                                isCustomTemplate;

                            return config;
                        },
                        { templates: {}, useCustomCompileOptions: {} }
                    );
                }

                function getRefinement(
                    state,
                    type,
                    attributeName,
                    name,
                    resultsFacets
                ) {
                    var res = {
                        type: type,
                        attributeName: attributeName,
                        name: name,
                    };
                    var facet = (0, _find2.default)(resultsFacets, {
                        name: attributeName,
                    });
                    var count = void 0;
                    if (type === "hierarchical") {
                        var facetDeclaration =
                            state.getHierarchicalFacetByName(attributeName);
                        var splitted = name.split(facetDeclaration.separator);
                        res.name = splitted[splitted.length - 1];
                        for (
                            var i = 0;
                            facet !== undefined && i < splitted.length;
                            ++i
                        ) {
                            facet = (0, _find2.default)(facet.data, {
                                name: splitted[i],
                            });
                        }
                        count = (0, _get2.default)(facet, "count");
                    } else {
                        count = (0, _get2.default)(
                            facet,
                            'data["' + res.name + '"]'
                        );
                    }
                    var exhaustive = (0, _get2.default)(facet, "exhaustive");
                    if (count !== undefined) {
                        res.count = count;
                    }
                    if (exhaustive !== undefined) {
                        res.exhaustive = exhaustive;
                    }
                    return res;
                }

                function getRefinements(results, state) {
                    var res = [];

                    (0, _forEach2.default)(
                        state.facetsRefinements,
                        function (refinements, attributeName) {
                            (0, _forEach2.default)(
                                refinements,
                                function (name) {
                                    res.push(
                                        getRefinement(
                                            state,
                                            "facet",
                                            attributeName,
                                            name,
                                            results.facets
                                        )
                                    );
                                }
                            );
                        }
                    );

                    (0, _forEach2.default)(
                        state.facetsExcludes,
                        function (refinements, attributeName) {
                            (0, _forEach2.default)(
                                refinements,
                                function (name) {
                                    res.push({
                                        type: "exclude",
                                        attributeName: attributeName,
                                        name: name,
                                        exclude: true,
                                    });
                                }
                            );
                        }
                    );

                    (0, _forEach2.default)(
                        state.disjunctiveFacetsRefinements,
                        function (refinements, attributeName) {
                            (0, _forEach2.default)(
                                refinements,
                                function (name) {
                                    res.push(
                                        getRefinement(
                                            state,
                                            "disjunctive",
                                            attributeName,
                                            // we unescapeRefinement any disjunctive refined value since they can be escaped
                                            // when negative numeric values search `escapeRefinement` usage in code
                                            unescapeRefinement(name),
                                            results.disjunctiveFacets
                                        )
                                    );
                                }
                            );
                        }
                    );

                    (0, _forEach2.default)(
                        state.hierarchicalFacetsRefinements,
                        function (refinements, attributeName) {
                            (0, _forEach2.default)(
                                refinements,
                                function (name) {
                                    res.push(
                                        getRefinement(
                                            state,
                                            "hierarchical",
                                            attributeName,
                                            name,
                                            results.hierarchicalFacets
                                        )
                                    );
                                }
                            );
                        }
                    );

                    (0, _forEach2.default)(
                        state.numericRefinements,
                        function (operators, attributeName) {
                            (0, _forEach2.default)(
                                operators,
                                function (values, operator) {
                                    (0, _forEach2.default)(
                                        values,
                                        function (value) {
                                            res.push({
                                                type: "numeric",
                                                attributeName: attributeName,
                                                name: "" + value,
                                                numericValue: value,
                                                operator: operator,
                                            });
                                        }
                                    );
                                }
                            );
                        }
                    );

                    (0, _forEach2.default)(
                        state.tagRefinements,
                        function (name) {
                            res.push({
                                type: "tag",
                                attributeName: "_tags",
                                name: name,
                            });
                        }
                    );

                    return res;
                }

                function clearRefinementsFromState(inputState, attributeNames) {
                    var state = inputState;

                    if ((0, _isEmpty2.default)(attributeNames)) {
                        state = state.clearTags();
                        state = state.clearRefinements();
                        return state;
                    }

                    (0, _forEach2.default)(
                        attributeNames,
                        function (attributeName) {
                            if (attributeName === "_tags") {
                                state = state.clearTags();
                            } else {
                                state = state.clearRefinements(attributeName);
                            }
                        }
                    );

                    return state;
                }

                function clearRefinementsAndSearch(helper, attributeNames) {
                    helper
                        .setState(
                            clearRefinementsFromState(
                                helper.state,
                                attributeNames
                            )
                        )
                        .search();
                }

                function prefixKeys(prefix, obj) {
                    if (obj) {
                        return (0, _mapKeys2.default)(obj, function (v, k) {
                            return prefix + k;
                        });
                    }

                    return undefined;
                }

                function escapeRefinement(value) {
                    if (typeof value === "number" && value < 0) {
                        value = String(value).replace(/^-/, "\\-");
                    }

                    return value;
                }

                function unescapeRefinement(value) {
                    return String(value).replace(/^\\-/, "-");
                }

                /***/
            },
            /* 515 */
            /***/ function (module, exports, __webpack_require__) {
                var baseUniq = __webpack_require__(340);

                /**
                 * Creates a duplicate-free version of an array, using
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons, in which only the first occurrence of each element
                 * is kept. The order of result values is determined by the order they occur
                 * in the array.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to inspect.
                 * @returns {Array} Returns the new duplicate free array.
                 * @example
                 *
                 * _.uniq([2, 1, 2]);
                 * // => [2, 1]
                 */
                function uniq(array) {
                    return array && array.length ? baseUniq(array) : [];
                }

                module.exports = uniq;

                /***/
            },
            /* 516 */
            /***/ function (module, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_ARRAY__,
                    __WEBPACK_AMD_DEFINE_RESULT__; /*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
                /* global define */

                (function () {
                    "use strict";

                    var hasOwn = {}.hasOwnProperty;

                    function classNames() {
                        var classes = [];

                        for (var i = 0; i < arguments.length; i++) {
                            var arg = arguments[i];
                            if (!arg) continue;

                            var argType = typeof arg;

                            if (argType === "string" || argType === "number") {
                                classes.push(arg);
                            } else if (Array.isArray(arg)) {
                                classes.push(classNames.apply(null, arg));
                            } else if (argType === "object") {
                                for (var key in arg) {
                                    if (hasOwn.call(arg, key) && arg[key]) {
                                        classes.push(key);
                                    }
                                }
                            }
                        }

                        return classes.join(" ");
                    }

                    if (typeof module !== "undefined" && module.exports) {
                        module.exports = classNames;
                    } else if (true) {
                        // register as 'classnames', consistent with npm package name
                        !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
                        (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                            return classNames;
                        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
                        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
                            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                    } else {
                        window.classNames = classNames;
                    }
                })();

                /***/
            },
            /* 517 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                } /* eslint-disable react/no-find-dom-node */

                function autoHideContainer(ComposedComponent) {
                    var AutoHide = (function (_React$Component) {
                        _inherits(AutoHide, _React$Component);

                        function AutoHide() {
                            _classCallCheck(this, AutoHide);

                            return _possibleConstructorReturn(
                                this,
                                (
                                    AutoHide.__proto__ ||
                                    Object.getPrototypeOf(AutoHide)
                                ).apply(this, arguments)
                            );
                        }

                        _createClass(AutoHide, [
                            {
                                key: "componentDidMount",
                                value: function componentDidMount() {
                                    this._hideOrShowContainer(this.props);
                                },
                            },
                            {
                                key: "componentWillReceiveProps",
                                value: function componentWillReceiveProps(
                                    nextProps
                                ) {
                                    if (
                                        this.props.shouldAutoHideContainer ===
                                        nextProps.shouldAutoHideContainer
                                    ) {
                                        return;
                                    }

                                    this._hideOrShowContainer(nextProps);
                                },
                            },
                            {
                                key: "shouldComponentUpdate",
                                value: function shouldComponentUpdate(
                                    nextProps
                                ) {
                                    return (
                                        nextProps.shouldAutoHideContainer ===
                                        false
                                    );
                                },
                            },
                            {
                                key: "_hideOrShowContainer",
                                value: function _hideOrShowContainer(props) {
                                    var container =
                                        _reactDom2.default.findDOMNode(
                                            this
                                        ).parentNode;
                                    container.style.display =
                                        props.shouldAutoHideContainer === true
                                            ? "none"
                                            : "";
                                },
                            },
                            {
                                key: "render",
                                value: function render() {
                                    return _react2.default.createElement(
                                        ComposedComponent,
                                        this.props
                                    );
                                },
                            },
                        ]);

                        return AutoHide;
                    })(_react2.default.Component);

                    // precise displayName for ease of debugging (react dev tool, react warnings)
                    AutoHide.displayName = ComposedComponent.name + "-AutoHide";

                    return AutoHide;
                }

                exports.default = autoHideContainer;

                /***/
            },
            /* 518 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _get = __webpack_require__(168);

                var _get2 = _interopRequireDefault(_get);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                } // Issue with eslint + high-order components like decorators
                /* eslint react/prop-types: 0 */

                function headerFooter(ComposedComponent) {
                    var HeaderFooter = (function (_React$Component) {
                        _inherits(HeaderFooter, _React$Component);

                        function HeaderFooter(props) {
                            _classCallCheck(this, HeaderFooter);

                            var _this = _possibleConstructorReturn(
                                this,
                                (
                                    HeaderFooter.__proto__ ||
                                    Object.getPrototypeOf(HeaderFooter)
                                ).call(this, props)
                            );

                            _this.handleHeaderClick =
                                _this.handleHeaderClick.bind(_this);
                            _this.state = {
                                collapsed:
                                    props.collapsible &&
                                    props.collapsible.collapsed,
                            };

                            _this._cssClasses = {
                                root: (0, _classnames2.default)(
                                    "ais-root",
                                    _this.props.cssClasses.root
                                ),
                                body: (0, _classnames2.default)(
                                    "ais-body",
                                    _this.props.cssClasses.body
                                ),
                            };

                            _this._footerElement = _this._getElement({
                                type: "footer",
                            });
                            return _this;
                        }

                        _createClass(HeaderFooter, [
                            {
                                key: "_getElement",
                                value: function _getElement(_ref) {
                                    var type = _ref.type,
                                        _ref$handleClick = _ref.handleClick,
                                        handleClick =
                                            _ref$handleClick === undefined
                                                ? null
                                                : _ref$handleClick;

                                    var templates =
                                        this.props.templateProps.templates;
                                    if (!templates || !templates[type]) {
                                        return null;
                                    }
                                    var className = (0, _classnames2.default)(
                                        this.props.cssClasses[type],
                                        "ais-" + type
                                    );

                                    var templateData = (0, _get2.default)(
                                        this.props,
                                        "headerFooterData." + type
                                    );

                                    return _react2.default.createElement(
                                        _Template2.default,
                                        _extends({}, this.props.templateProps, {
                                            data: templateData,
                                            rootProps: {
                                                className: className,
                                                onClick: handleClick,
                                            },
                                            templateKey: type,
                                            transformData: null,
                                        })
                                    );
                                },
                            },
                            {
                                key: "handleHeaderClick",
                                value: function handleHeaderClick() {
                                    this.setState({
                                        collapsed: !this.state.collapsed,
                                    });
                                },
                            },
                            {
                                key: "render",
                                value: function render() {
                                    var rootCssClasses = [
                                        this._cssClasses.root,
                                    ];

                                    if (this.props.collapsible) {
                                        rootCssClasses.push(
                                            "ais-root__collapsible"
                                        );
                                    }

                                    if (this.state.collapsed) {
                                        rootCssClasses.push(
                                            "ais-root__collapsed"
                                        );
                                    }

                                    var cssClasses = _extends(
                                        {},
                                        this._cssClasses,
                                        {
                                            root: (0, _classnames2.default)(
                                                rootCssClasses
                                            ),
                                        }
                                    );

                                    var headerElement = this._getElement({
                                        type: "header",
                                        handleClick: this.props.collapsible
                                            ? this.handleHeaderClick
                                            : null,
                                    });

                                    return _react2.default.createElement(
                                        "div",
                                        { className: cssClasses.root },
                                        headerElement,
                                        _react2.default.createElement(
                                            "div",
                                            {
                                                className: cssClasses.body,
                                            },
                                            _react2.default.createElement(
                                                ComposedComponent,
                                                this.props
                                            )
                                        ),
                                        this._footerElement
                                    );
                                },
                            },
                        ]);

                        return HeaderFooter;
                    })(_react2.default.Component);

                    HeaderFooter.defaultProps = {
                        cssClasses: {},
                        collapsible: false,
                    };

                    // precise displayName for ease of debugging (react dev tool, react warnings)
                    HeaderFooter.displayName =
                        ComposedComponent.name + "-HeaderFooter";

                    return HeaderFooter;
                }

                exports.default = headerFooter;

                /***/
            },
            /* 519 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.PureTemplate = undefined;

                var _typeof =
                    typeof Symbol === "function" &&
                    typeof Symbol.iterator === "symbol"
                        ? function (obj) {
                              return typeof obj;
                          }
                        : function (obj) {
                              return obj &&
                                  typeof Symbol === "function" &&
                                  obj.constructor === Symbol &&
                                  obj !== Symbol.prototype
                                  ? "symbol"
                                  : typeof obj;
                          };

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _curry = __webpack_require__(520);

                var _curry2 = _interopRequireDefault(_curry);

                var _cloneDeep = __webpack_require__(521);

                var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

                var _mapValues = __webpack_require__(336);

                var _mapValues2 = _interopRequireDefault(_mapValues);

                var _hogan = __webpack_require__(522);

                var _hogan2 = _interopRequireDefault(_hogan);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var PureTemplate = (exports.PureTemplate = (function (
                    _React$Component
                ) {
                    _inherits(PureTemplate, _React$Component);

                    function PureTemplate() {
                        _classCallCheck(this, PureTemplate);

                        return _possibleConstructorReturn(
                            this,
                            (
                                PureTemplate.__proto__ ||
                                Object.getPrototypeOf(PureTemplate)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(PureTemplate, [
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return (
                                    !(0, _isEqual2.default)(
                                        this.props.data,
                                        nextProps.data
                                    ) ||
                                    this.props.templateKey !==
                                        nextProps.templateKey
                                );
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var useCustomCompileOptions =
                                    this.props.useCustomCompileOptions[
                                        this.props.templateKey
                                    ];
                                var compileOptions = useCustomCompileOptions
                                    ? this.props.templatesConfig.compileOptions
                                    : {};

                                var content = renderTemplate({
                                    templates: this.props.templates,
                                    templateKey: this.props.templateKey,
                                    compileOptions: compileOptions,
                                    helpers: this.props.templatesConfig.helpers,
                                    data: this.props.data,
                                });

                                if (content === null) {
                                    // Adds a noscript to the DOM but virtual DOM is null
                                    // See http://facebook.github.io/react/docs/component-specs.html#render
                                    return null;
                                }

                                if (_react2.default.isValidElement(content)) {
                                    return _react2.default.createElement(
                                        "div",
                                        this.props.rootProps,
                                        content
                                    );
                                }

                                return _react2.default.createElement(
                                    "div",
                                    _extends({}, this.props.rootProps, {
                                        dangerouslySetInnerHTML: {
                                            __html: content,
                                        },
                                    })
                                );
                            },
                        },
                    ]);

                    return PureTemplate;
                })(_react2.default.Component));

                PureTemplate.defaultProps = {
                    data: {},
                    useCustomCompileOptions: {},
                    templates: {},
                    templatesConfig: {},
                };

                function transformData(fn, templateKey, originalData) {
                    if (!fn) {
                        return originalData;
                    }

                    var clonedData = (0, _cloneDeep2.default)(originalData);

                    var data = void 0;
                    var typeFn =
                        typeof fn === "undefined" ? "undefined" : _typeof(fn);
                    if (typeFn === "function") {
                        data = fn(clonedData);
                    } else if (typeFn === "object") {
                        // ex: transformData: {hit, empty}
                        if (fn[templateKey]) {
                            data = fn[templateKey](clonedData);
                        } else {
                            // if the templateKey doesn't exist, just use the
                            // original data
                            data = originalData;
                        }
                    } else {
                        throw new Error(
                            "transformData must be a function or an object, was " +
                                typeFn +
                                " (key : " +
                                templateKey +
                                ")"
                        );
                    }

                    var dataType =
                        typeof data === "undefined"
                            ? "undefined"
                            : _typeof(data);
                    var expectedType =
                        typeof originalData === "undefined"
                            ? "undefined"
                            : _typeof(originalData);
                    if (dataType !== expectedType) {
                        throw new Error(
                            "`transformData` must return a `" +
                                expectedType +
                                "`, got `" +
                                dataType +
                                "`."
                        );
                    }
                    return data;
                }

                function renderTemplate(_ref) {
                    var templates = _ref.templates,
                        templateKey = _ref.templateKey,
                        compileOptions = _ref.compileOptions,
                        helpers = _ref.helpers,
                        data = _ref.data;

                    var template = templates[templateKey];
                    var templateType =
                        typeof template === "undefined"
                            ? "undefined"
                            : _typeof(template);
                    var isTemplateString = templateType === "string";
                    var isTemplateFunction = templateType === "function";

                    if (!isTemplateString && !isTemplateFunction) {
                        throw new Error(
                            "Template must be 'string' or 'function', was '" +
                                templateType +
                                "' (key: " +
                                templateKey +
                                ")"
                        );
                    } else if (isTemplateFunction) {
                        return template(data);
                    } else {
                        var transformedHelpers = transformHelpersToHogan(
                            helpers,
                            compileOptions,
                            data
                        );
                        var preparedData = _extends({}, data, {
                            helpers: transformedHelpers,
                        });
                        return _hogan2.default
                            .compile(template, compileOptions)
                            .render(preparedData);
                    }
                }

                // We add all our template helper methods to the template as lambdas. Note
                // that lambdas in Mustache are supposed to accept a second argument of
                // `render` to get the rendered value, not the literal `{{value}}`. But
                // this is currently broken (see
                // https://github.com/twitter/hogan.js/issues/222).
                function transformHelpersToHogan(
                    helpers,
                    compileOptions,
                    data
                ) {
                    return (0, _mapValues2.default)(helpers, function (method) {
                        return (0, _curry2.default)(function (text) {
                            var _this2 = this;

                            var render = function render(value) {
                                return _hogan2.default
                                    .compile(value, compileOptions)
                                    .render(_this2);
                            };
                            return method.call(data, text, render);
                        });
                    });
                }

                // Resolve transformData before Template, so transformData is always called
                // even if the data is the same. Allowing you to dynamically inject conditions in
                // transformData that will force re-rendering
                var withTransformData = function withTransformData(
                    TemplateToWrap
                ) {
                    return function (props) {
                        var data = props.data === undefined ? {} : props.data; // eslint-disable-line react/prop-types
                        return _react2.default.createElement(
                            TemplateToWrap,
                            _extends({}, props, {
                                data: transformData(
                                    props.transformData,
                                    props.templateKey,
                                    data
                                ), // eslint-disable-line react/prop-types
                            })
                        );
                    };
                };

                exports.default = withTransformData(PureTemplate);

                /***/
            },
            /* 520 */
            /***/ function (module, exports, __webpack_require__) {
                var createWrap = __webpack_require__(277);

                /** Used to compose bitmasks for function metadata. */
                var WRAP_CURRY_FLAG = 8;

                /**
                 * Creates a function that accepts arguments of `func` and either invokes
                 * `func` returning its result, if at least `arity` number of arguments have
                 * been provided, or returns a function that accepts the remaining `func`
                 * arguments, and so on. The arity of `func` may be specified if `func.length`
                 * is not sufficient.
                 *
                 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
                 * may be used as a placeholder for provided arguments.
                 *
                 * **Note:** This method doesn't set the "length" property of curried functions.
                 *
                 * @static
                 * @memberOf _
                 * @since 2.0.0
                 * @category Function
                 * @param {Function} func The function to curry.
                 * @param {number} [arity=func.length] The arity of `func`.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                 * @returns {Function} Returns the new curried function.
                 * @example
                 *
                 * var abc = function(a, b, c) {
                 *   return [a, b, c];
                 * };
                 *
                 * var curried = _.curry(abc);
                 *
                 * curried(1)(2)(3);
                 * // => [1, 2, 3]
                 *
                 * curried(1, 2)(3);
                 * // => [1, 2, 3]
                 *
                 * curried(1, 2, 3);
                 * // => [1, 2, 3]
                 *
                 * // Curried with placeholders.
                 * curried(1)(_, 3)(2);
                 * // => [1, 2, 3]
                 */
                function curry(func, arity, guard) {
                    arity = guard ? undefined : arity;
                    var result = createWrap(
                        func,
                        WRAP_CURRY_FLAG,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        arity
                    );
                    result.placeholder = curry.placeholder;
                    return result;
                }

                // Assign default placeholders.
                curry.placeholder = {};

                module.exports = curry;

                /***/
            },
            /* 521 */
            /***/ function (module, exports, __webpack_require__) {
                var baseClone = __webpack_require__(191);

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1,
                    CLONE_SYMBOLS_FLAG = 4;

                /**
                 * This method is like `_.clone` except that it recursively clones `value`.
                 *
                 * @static
                 * @memberOf _
                 * @since 1.0.0
                 * @category Lang
                 * @param {*} value The value to recursively clone.
                 * @returns {*} Returns the deep cloned value.
                 * @see _.clone
                 * @example
                 *
                 * var objects = [{ 'a': 1 }, { 'b': 2 }];
                 *
                 * var deep = _.cloneDeep(objects);
                 * console.log(deep[0] === objects[0]);
                 * // => false
                 */
                function cloneDeep(value) {
                    return baseClone(
                        value,
                        CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG
                    );
                }

                module.exports = cloneDeep;

                /***/
            },
            /* 522 */
            /***/ function (module, exports, __webpack_require__) {
                /*
                 *  Copyright 2011 Twitter, Inc.
                 *  Licensed under the Apache License, Version 2.0 (the "License");
                 *  you may not use this file except in compliance with the License.
                 *  You may obtain a copy of the License at
                 *
                 *  http://www.apache.org/licenses/LICENSE-2.0
                 *
                 *  Unless required by applicable law or agreed to in writing, software
                 *  distributed under the License is distributed on an "AS IS" BASIS,
                 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                 *  See the License for the specific language governing permissions and
                 *  limitations under the License.
                 */

                // This file is for use with Node.js. See dist/ for browser files.

                var Hogan = __webpack_require__(523);
                Hogan.Template = __webpack_require__(524).Template;
                Hogan.template = Hogan.Template;
                module.exports = Hogan;

                /***/
            },
            /* 523 */
            /***/ function (module, exports, __webpack_require__) {
                /*
                 *  Copyright 2011 Twitter, Inc.
                 *  Licensed under the Apache License, Version 2.0 (the "License");
                 *  you may not use this file except in compliance with the License.
                 *  You may obtain a copy of the License at
                 *
                 *  http://www.apache.org/licenses/LICENSE-2.0
                 *
                 *  Unless required by applicable law or agreed to in writing, software
                 *  distributed under the License is distributed on an "AS IS" BASIS,
                 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                 *  See the License for the specific language governing permissions and
                 *  limitations under the License.
                 */

                (function (Hogan) {
                    // Setup regex  assignments
                    // remove whitespace according to Mustache spec
                    var rIsWhitespace = /\S/,
                        rQuot = /\"/g,
                        rNewline = /\n/g,
                        rCr = /\r/g,
                        rSlash = /\\/g,
                        rLineSep = /\u2028/,
                        rParagraphSep = /\u2029/;

                    Hogan.tags = {
                        "#": 1,
                        "^": 2,
                        "<": 3,
                        "$": 4,
                        "/": 5,
                        "!": 6,
                        ">": 7,
                        "=": 8,
                        "_v": 9,
                        "{": 10,
                        "&": 11,
                        "_t": 12,
                    };

                    Hogan.scan = function scan(text, delimiters) {
                        var len = text.length,
                            IN_TEXT = 0,
                            IN_TAG_TYPE = 1,
                            IN_TAG = 2,
                            state = IN_TEXT,
                            tagType = null,
                            tag = null,
                            buf = "",
                            tokens = [],
                            seenTag = false,
                            i = 0,
                            lineStart = 0,
                            otag = "{{",
                            ctag = "}}";

                        function addBuf() {
                            if (buf.length > 0) {
                                tokens.push({
                                    tag: "_t",
                                    text: new String(buf),
                                });
                                buf = "";
                            }
                        }

                        function lineIsWhitespace() {
                            var isAllWhitespace = true;
                            for (var j = lineStart; j < tokens.length; j++) {
                                isAllWhitespace =
                                    Hogan.tags[tokens[j].tag] <
                                        Hogan.tags["_v"] ||
                                    (tokens[j].tag == "_t" &&
                                        tokens[j].text.match(rIsWhitespace) ===
                                            null);
                                if (!isAllWhitespace) {
                                    return false;
                                }
                            }

                            return isAllWhitespace;
                        }

                        function filterLine(haveSeenTag, noNewLine) {
                            addBuf();

                            if (haveSeenTag && lineIsWhitespace()) {
                                for (
                                    var j = lineStart, next;
                                    j < tokens.length;
                                    j++
                                ) {
                                    if (tokens[j].text) {
                                        if (
                                            (next = tokens[j + 1]) &&
                                            next.tag == ">"
                                        ) {
                                            // set indent to token value
                                            next.indent =
                                                tokens[j].text.toString();
                                        }
                                        tokens.splice(j, 1);
                                    }
                                }
                            } else if (!noNewLine) {
                                tokens.push({ tag: "\n" });
                            }

                            seenTag = false;
                            lineStart = tokens.length;
                        }

                        function changeDelimiters(text, index) {
                            var close = "=" + ctag,
                                closeIndex = text.indexOf(close, index),
                                delimiters = trim(
                                    text.substring(
                                        text.indexOf("=", index) + 1,
                                        closeIndex
                                    )
                                ).split(" ");

                            otag = delimiters[0];
                            ctag = delimiters[delimiters.length - 1];

                            return closeIndex + close.length - 1;
                        }

                        if (delimiters) {
                            delimiters = delimiters.split(" ");
                            otag = delimiters[0];
                            ctag = delimiters[1];
                        }

                        for (i = 0; i < len; i++) {
                            if (state == IN_TEXT) {
                                if (tagChange(otag, text, i)) {
                                    --i;
                                    addBuf();
                                    state = IN_TAG_TYPE;
                                } else {
                                    if (text.charAt(i) == "\n") {
                                        filterLine(seenTag);
                                    } else {
                                        buf += text.charAt(i);
                                    }
                                }
                            } else if (state == IN_TAG_TYPE) {
                                i += otag.length - 1;
                                tag = Hogan.tags[text.charAt(i + 1)];
                                tagType = tag ? text.charAt(i + 1) : "_v";
                                if (tagType == "=") {
                                    i = changeDelimiters(text, i);
                                    state = IN_TEXT;
                                } else {
                                    if (tag) {
                                        i++;
                                    }
                                    state = IN_TAG;
                                }
                                seenTag = i;
                            } else {
                                if (tagChange(ctag, text, i)) {
                                    tokens.push({
                                        tag: tagType,
                                        n: trim(buf),
                                        otag: otag,
                                        ctag: ctag,
                                        i:
                                            tagType == "/"
                                                ? seenTag - otag.length
                                                : i + ctag.length,
                                    });
                                    buf = "";
                                    i += ctag.length - 1;
                                    state = IN_TEXT;
                                    if (tagType == "{") {
                                        if (ctag == "}}") {
                                            i++;
                                        } else {
                                            cleanTripleStache(
                                                tokens[tokens.length - 1]
                                            );
                                        }
                                    }
                                } else {
                                    buf += text.charAt(i);
                                }
                            }
                        }

                        filterLine(seenTag, true);

                        return tokens;
                    };

                    function cleanTripleStache(token) {
                        if (token.n.substr(token.n.length - 1) === "}") {
                            token.n = token.n.substring(0, token.n.length - 1);
                        }
                    }

                    function trim(s) {
                        if (s.trim) {
                            return s.trim();
                        }

                        return s.replace(/^\s*|\s*$/g, "");
                    }

                    function tagChange(tag, text, index) {
                        if (text.charAt(index) != tag.charAt(0)) {
                            return false;
                        }

                        for (var i = 1, l = tag.length; i < l; i++) {
                            if (text.charAt(index + i) != tag.charAt(i)) {
                                return false;
                            }
                        }

                        return true;
                    }

                    // the tags allowed inside super templates
                    var allowedInSuper = {
                        "_t": true,
                        "\n": true,
                        "$": true,
                        "/": true,
                    };

                    function buildTree(tokens, kind, stack, customTags) {
                        var instructions = [],
                            opener = null,
                            tail = null,
                            token = null;

                        tail = stack[stack.length - 1];

                        while (tokens.length > 0) {
                            token = tokens.shift();

                            if (
                                tail &&
                                tail.tag == "<" &&
                                !(token.tag in allowedInSuper)
                            ) {
                                throw new Error(
                                    "Illegal content in < super tag."
                                );
                            }

                            if (
                                Hogan.tags[token.tag] <= Hogan.tags["$"] ||
                                isOpener(token, customTags)
                            ) {
                                stack.push(token);
                                token.nodes = buildTree(
                                    tokens,
                                    token.tag,
                                    stack,
                                    customTags
                                );
                            } else if (token.tag == "/") {
                                if (stack.length === 0) {
                                    throw new Error(
                                        "Closing tag without opener: /" +
                                            token.n
                                    );
                                }
                                opener = stack.pop();
                                if (
                                    token.n != opener.n &&
                                    !isCloser(token.n, opener.n, customTags)
                                ) {
                                    throw new Error(
                                        "Nesting error: " +
                                            opener.n +
                                            " vs. " +
                                            token.n
                                    );
                                }
                                opener.end = token.i;
                                return instructions;
                            } else if (token.tag == "\n") {
                                token.last =
                                    tokens.length == 0 || tokens[0].tag == "\n";
                            }

                            instructions.push(token);
                        }

                        if (stack.length > 0) {
                            throw new Error(
                                "missing closing tag: " + stack.pop().n
                            );
                        }

                        return instructions;
                    }

                    function isOpener(token, tags) {
                        for (var i = 0, l = tags.length; i < l; i++) {
                            if (tags[i].o == token.n) {
                                token.tag = "#";
                                return true;
                            }
                        }
                    }

                    function isCloser(close, open, tags) {
                        for (var i = 0, l = tags.length; i < l; i++) {
                            if (tags[i].c == close && tags[i].o == open) {
                                return true;
                            }
                        }
                    }

                    function stringifySubstitutions(obj) {
                        var items = [];
                        for (var key in obj) {
                            items.push(
                                '"' +
                                    esc(key) +
                                    '": function(c,p,t,i) {' +
                                    obj[key] +
                                    "}"
                            );
                        }
                        return "{ " + items.join(",") + " }";
                    }

                    function stringifyPartials(codeObj) {
                        var partials = [];
                        for (var key in codeObj.partials) {
                            partials.push(
                                '"' +
                                    esc(key) +
                                    '":{name:"' +
                                    esc(codeObj.partials[key].name) +
                                    '", ' +
                                    stringifyPartials(codeObj.partials[key]) +
                                    "}"
                            );
                        }
                        return (
                            "partials: {" +
                            partials.join(",") +
                            "}, subs: " +
                            stringifySubstitutions(codeObj.subs)
                        );
                    }

                    Hogan.stringify = function (codeObj, text, options) {
                        return (
                            "{code: function (c,p,i) { " +
                            Hogan.wrapMain(codeObj.code) +
                            " }," +
                            stringifyPartials(codeObj) +
                            "}"
                        );
                    };

                    var serialNo = 0;
                    Hogan.generate = function (tree, text, options) {
                        serialNo = 0;
                        var context = { code: "", subs: {}, partials: {} };
                        Hogan.walk(tree, context);

                        if (options.asString) {
                            return this.stringify(context, text, options);
                        }

                        return this.makeTemplate(context, text, options);
                    };

                    Hogan.wrapMain = function (code) {
                        return (
                            'var t=this;t.b(i=i||"");' + code + "return t.fl();"
                        );
                    };

                    Hogan.template = Hogan.Template;

                    Hogan.makeTemplate = function (codeObj, text, options) {
                        var template = this.makePartials(codeObj);
                        template.code = new Function(
                            "c",
                            "p",
                            "i",
                            this.wrapMain(codeObj.code)
                        );
                        return new this.template(template, text, this, options);
                    };

                    Hogan.makePartials = function (codeObj) {
                        var key,
                            template = {
                                subs: {},
                                partials: codeObj.partials,
                                name: codeObj.name,
                            };
                        for (key in template.partials) {
                            template.partials[key] = this.makePartials(
                                template.partials[key]
                            );
                        }
                        for (key in codeObj.subs) {
                            template.subs[key] = new Function(
                                "c",
                                "p",
                                "t",
                                "i",
                                codeObj.subs[key]
                            );
                        }
                        return template;
                    };

                    function esc(s) {
                        return s
                            .replace(rSlash, "\\\\")
                            .replace(rQuot, '\\"')
                            .replace(rNewline, "\\n")
                            .replace(rCr, "\\r")
                            .replace(rLineSep, "\\u2028")
                            .replace(rParagraphSep, "\\u2029");
                    }

                    function chooseMethod(s) {
                        return ~s.indexOf(".") ? "d" : "f";
                    }

                    function createPartial(node, context) {
                        var prefix = "<" + (context.prefix || "");
                        var sym = prefix + node.n + serialNo++;
                        context.partials[sym] = { name: node.n, partials: {} };
                        context.code +=
                            't.b(t.rp("' +
                            esc(sym) +
                            '",c,p,"' +
                            (node.indent || "") +
                            '"));';
                        return sym;
                    }

                    Hogan.codegen = {
                        "#": function (node, context) {
                            context.code +=
                                "if(t.s(t." +
                                chooseMethod(node.n) +
                                '("' +
                                esc(node.n) +
                                '",c,p,1),' +
                                "c,p,0," +
                                node.i +
                                "," +
                                node.end +
                                ',"' +
                                node.otag +
                                " " +
                                node.ctag +
                                '")){' +
                                "t.rs(c,p," +
                                "function(c,p,t){";
                            Hogan.walk(node.nodes, context);
                            context.code += "});c.pop();}";
                        },

                        "^": function (node, context) {
                            context.code +=
                                "if(!t.s(t." +
                                chooseMethod(node.n) +
                                '("' +
                                esc(node.n) +
                                '",c,p,1),c,p,1,0,0,"")){';
                            Hogan.walk(node.nodes, context);
                            context.code += "};";
                        },

                        ">": createPartial,
                        "<": function (node, context) {
                            var ctx = {
                                partials: {},
                                code: "",
                                subs: {},
                                inPartial: true,
                            };
                            Hogan.walk(node.nodes, ctx);
                            var template =
                                context.partials[createPartial(node, context)];
                            template.subs = ctx.subs;
                            template.partials = ctx.partials;
                        },

                        "$": function (node, context) {
                            var ctx = {
                                subs: {},
                                code: "",
                                partials: context.partials,
                                prefix: node.n,
                            };
                            Hogan.walk(node.nodes, ctx);
                            context.subs[node.n] = ctx.code;
                            if (!context.inPartial) {
                                context.code +=
                                    't.sub("' + esc(node.n) + '",c,p,i);';
                            }
                        },

                        "\n": function (node, context) {
                            context.code += write(
                                '"\\n"' + (node.last ? "" : " + i")
                            );
                        },

                        "_v": function (node, context) {
                            context.code +=
                                "t.b(t.v(t." +
                                chooseMethod(node.n) +
                                '("' +
                                esc(node.n) +
                                '",c,p,0)));';
                        },

                        "_t": function (node, context) {
                            context.code += write('"' + esc(node.text) + '"');
                        },

                        "{": tripleStache,

                        "&": tripleStache,
                    };

                    function tripleStache(node, context) {
                        context.code +=
                            "t.b(t.t(t." +
                            chooseMethod(node.n) +
                            '("' +
                            esc(node.n) +
                            '",c,p,0)));';
                    }

                    function write(s) {
                        return "t.b(" + s + ");";
                    }

                    Hogan.walk = function (nodelist, context) {
                        var func;
                        for (var i = 0, l = nodelist.length; i < l; i++) {
                            func = Hogan.codegen[nodelist[i].tag];
                            func && func(nodelist[i], context);
                        }
                        return context;
                    };

                    Hogan.parse = function (tokens, text, options) {
                        options = options || {};
                        return buildTree(
                            tokens,
                            "",
                            [],
                            options.sectionTags || []
                        );
                    };

                    Hogan.cache = {};

                    Hogan.cacheKey = function (text, options) {
                        return [
                            text,
                            !!options.asString,
                            !!options.disableLambda,
                            options.delimiters,
                            !!options.modelGet,
                        ].join("||");
                    };

                    Hogan.compile = function (text, options) {
                        options = options || {};
                        var key = Hogan.cacheKey(text, options);
                        var template = this.cache[key];

                        if (template) {
                            var partials = template.partials;
                            for (var name in partials) {
                                delete partials[name].instance;
                            }
                            return template;
                        }

                        template = this.generate(
                            this.parse(
                                this.scan(text, options.delimiters),
                                text,
                                options
                            ),
                            text,
                            options
                        );
                        return (this.cache[key] = template);
                    };
                })(true ? exports : Hogan);

                /***/
            },
            /* 524 */
            /***/ function (module, exports, __webpack_require__) {
                /*
                 *  Copyright 2011 Twitter, Inc.
                 *  Licensed under the Apache License, Version 2.0 (the "License");
                 *  you may not use this file except in compliance with the License.
                 *  You may obtain a copy of the License at
                 *
                 *  http://www.apache.org/licenses/LICENSE-2.0
                 *
                 *  Unless required by applicable law or agreed to in writing, software
                 *  distributed under the License is distributed on an "AS IS" BASIS,
                 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                 *  See the License for the specific language governing permissions and
                 *  limitations under the License.
                 */

                var Hogan = {};

                (function (Hogan) {
                    Hogan.Template = function (
                        codeObj,
                        text,
                        compiler,
                        options
                    ) {
                        codeObj = codeObj || {};
                        this.r = codeObj.code || this.r;
                        this.c = compiler;
                        this.options = options || {};
                        this.text = text || "";
                        this.partials = codeObj.partials || {};
                        this.subs = codeObj.subs || {};
                        this.buf = "";
                    };

                    Hogan.Template.prototype = {
                        // render: replaced by generated code.
                        r: function (context, partials, indent) {
                            return "";
                        },

                        // variable escaping
                        v: hoganEscape,

                        // triple stache
                        t: coerceToString,

                        render: function render(context, partials, indent) {
                            return this.ri([context], partials || {}, indent);
                        },

                        // render internal -- a hook for overrides that catches partials too
                        ri: function (context, partials, indent) {
                            return this.r(context, partials, indent);
                        },

                        // ensurePartial
                        ep: function (symbol, partials) {
                            var partial = this.partials[symbol];

                            // check to see that if we've instantiated this partial before
                            var template = partials[partial.name];
                            if (partial.instance && partial.base == template) {
                                return partial.instance;
                            }

                            if (typeof template == "string") {
                                if (!this.c) {
                                    throw new Error("No compiler available.");
                                }
                                template = this.c.compile(
                                    template,
                                    this.options
                                );
                            }

                            if (!template) {
                                return null;
                            }

                            // We use this to check whether the partials dictionary has changed
                            this.partials[symbol].base = template;

                            if (partial.subs) {
                                // Make sure we consider parent template now
                                if (!partials.stackText)
                                    partials.stackText = {};
                                for (key in partial.subs) {
                                    if (!partials.stackText[key]) {
                                        partials.stackText[key] =
                                            this.activeSub !== undefined &&
                                            partials.stackText[this.activeSub]
                                                ? partials.stackText[
                                                      this.activeSub
                                                  ]
                                                : this.text;
                                    }
                                }
                                template = createSpecializedPartial(
                                    template,
                                    partial.subs,
                                    partial.partials,
                                    this.stackSubs,
                                    this.stackPartials,
                                    partials.stackText
                                );
                            }
                            this.partials[symbol].instance = template;

                            return template;
                        },

                        // tries to find a partial in the current scope and render it
                        rp: function (symbol, context, partials, indent) {
                            var partial = this.ep(symbol, partials);
                            if (!partial) {
                                return "";
                            }

                            return partial.ri(context, partials, indent);
                        },

                        // render a section
                        rs: function (context, partials, section) {
                            var tail = context[context.length - 1];

                            if (!isArray(tail)) {
                                section(context, partials, this);
                                return;
                            }

                            for (var i = 0; i < tail.length; i++) {
                                context.push(tail[i]);
                                section(context, partials, this);
                                context.pop();
                            }
                        },

                        // maybe start a section
                        s: function (
                            val,
                            ctx,
                            partials,
                            inverted,
                            start,
                            end,
                            tags
                        ) {
                            var pass;

                            if (isArray(val) && val.length === 0) {
                                return false;
                            }

                            if (typeof val == "function") {
                                val = this.ms(
                                    val,
                                    ctx,
                                    partials,
                                    inverted,
                                    start,
                                    end,
                                    tags
                                );
                            }

                            pass = !!val;

                            if (!inverted && pass && ctx) {
                                ctx.push(
                                    typeof val == "object"
                                        ? val
                                        : ctx[ctx.length - 1]
                                );
                            }

                            return pass;
                        },

                        // find values with dotted names
                        d: function (key, ctx, partials, returnFound) {
                            var found,
                                names = key.split("."),
                                val = this.f(
                                    names[0],
                                    ctx,
                                    partials,
                                    returnFound
                                ),
                                doModelGet = this.options.modelGet,
                                cx = null;

                            if (key === "." && isArray(ctx[ctx.length - 2])) {
                                val = ctx[ctx.length - 1];
                            } else {
                                for (var i = 1; i < names.length; i++) {
                                    found = findInScope(
                                        names[i],
                                        val,
                                        doModelGet
                                    );
                                    if (found !== undefined) {
                                        cx = val;
                                        val = found;
                                    } else {
                                        val = "";
                                    }
                                }
                            }

                            if (returnFound && !val) {
                                return false;
                            }

                            if (!returnFound && typeof val == "function") {
                                ctx.push(cx);
                                val = this.mv(val, ctx, partials);
                                ctx.pop();
                            }

                            return val;
                        },

                        // find values with normal names
                        f: function (key, ctx, partials, returnFound) {
                            var val = false,
                                v = null,
                                found = false,
                                doModelGet = this.options.modelGet;

                            for (var i = ctx.length - 1; i >= 0; i--) {
                                v = ctx[i];
                                val = findInScope(key, v, doModelGet);
                                if (val !== undefined) {
                                    found = true;
                                    break;
                                }
                            }

                            if (!found) {
                                return returnFound ? false : "";
                            }

                            if (!returnFound && typeof val == "function") {
                                val = this.mv(val, ctx, partials);
                            }

                            return val;
                        },

                        // higher order templates
                        ls: function (func, cx, partials, text, tags) {
                            var oldTags = this.options.delimiters;

                            this.options.delimiters = tags;
                            this.b(
                                this.ct(
                                    coerceToString(func.call(cx, text)),
                                    cx,
                                    partials
                                )
                            );
                            this.options.delimiters = oldTags;

                            return false;
                        },

                        // compile text
                        ct: function (text, cx, partials) {
                            if (this.options.disableLambda) {
                                throw new Error("Lambda features disabled.");
                            }
                            return this.c
                                .compile(text, this.options)
                                .render(cx, partials);
                        },

                        // template result buffering
                        b: function (s) {
                            this.buf += s;
                        },

                        fl: function () {
                            var r = this.buf;
                            this.buf = "";
                            return r;
                        },

                        // method replace section
                        ms: function (
                            func,
                            ctx,
                            partials,
                            inverted,
                            start,
                            end,
                            tags
                        ) {
                            var textSource,
                                cx = ctx[ctx.length - 1],
                                result = func.call(cx);

                            if (typeof result == "function") {
                                if (inverted) {
                                    return true;
                                } else {
                                    textSource =
                                        this.activeSub &&
                                        this.subsText &&
                                        this.subsText[this.activeSub]
                                            ? this.subsText[this.activeSub]
                                            : this.text;
                                    return this.ls(
                                        result,
                                        cx,
                                        partials,
                                        textSource.substring(start, end),
                                        tags
                                    );
                                }
                            }

                            return result;
                        },

                        // method replace variable
                        mv: function (func, ctx, partials) {
                            var cx = ctx[ctx.length - 1];
                            var result = func.call(cx);

                            if (typeof result == "function") {
                                return this.ct(
                                    coerceToString(result.call(cx)),
                                    cx,
                                    partials
                                );
                            }

                            return result;
                        },

                        sub: function (name, context, partials, indent) {
                            var f = this.subs[name];
                            if (f) {
                                this.activeSub = name;
                                f(context, partials, this, indent);
                                this.activeSub = false;
                            }
                        },
                    };

                    //Find a key in an object
                    function findInScope(key, scope, doModelGet) {
                        var val;

                        if (scope && typeof scope == "object") {
                            if (scope[key] !== undefined) {
                                val = scope[key];

                                // try lookup with get for backbone or similar model data
                            } else if (
                                doModelGet &&
                                scope.get &&
                                typeof scope.get == "function"
                            ) {
                                val = scope.get(key);
                            }
                        }

                        return val;
                    }

                    function createSpecializedPartial(
                        instance,
                        subs,
                        partials,
                        stackSubs,
                        stackPartials,
                        stackText
                    ) {
                        function PartialTemplate() {}
                        PartialTemplate.prototype = instance;
                        function Substitutions() {}
                        Substitutions.prototype = instance.subs;
                        var key;
                        var partial = new PartialTemplate();
                        partial.subs = new Substitutions();
                        partial.subsText = {}; //hehe. substext.
                        partial.buf = "";

                        stackSubs = stackSubs || {};
                        partial.stackSubs = stackSubs;
                        partial.subsText = stackText;
                        for (key in subs) {
                            if (!stackSubs[key]) stackSubs[key] = subs[key];
                        }
                        for (key in stackSubs) {
                            partial.subs[key] = stackSubs[key];
                        }

                        stackPartials = stackPartials || {};
                        partial.stackPartials = stackPartials;
                        for (key in partials) {
                            if (!stackPartials[key])
                                stackPartials[key] = partials[key];
                        }
                        for (key in stackPartials) {
                            partial.partials[key] = stackPartials[key];
                        }

                        return partial;
                    }

                    var rAmp = /&/g,
                        rLt = /</g,
                        rGt = />/g,
                        rApos = /\'/g,
                        rQuot = /\"/g,
                        hChars = /[&<>\"\']/;

                    function coerceToString(val) {
                        return String(
                            val === null || val === undefined ? "" : val
                        );
                    }

                    function hoganEscape(str) {
                        str = coerceToString(str);
                        return hChars.test(str)
                            ? str
                                  .replace(rAmp, "&amp;")
                                  .replace(rLt, "&lt;")
                                  .replace(rGt, "&gt;")
                                  .replace(rApos, "&#39;")
                                  .replace(rQuot, "&quot;")
                            : str;
                    }

                    var isArray =
                        Array.isArray ||
                        function (a) {
                            return (
                                Object.prototype.toString.call(a) ===
                                "[object Array]"
                            );
                        };
                })(true ? exports : Hogan);

                /***/
            },
            /* 525 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    header: "",
                    link: "Clear all",
                    footer: "",
                };

                /***/
            },
            /* 526 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                var _utils = __webpack_require__(514);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var ClearAll = (function (_React$Component) {
                    _inherits(ClearAll, _React$Component);

                    function ClearAll() {
                        _classCallCheck(this, ClearAll);

                        return _possibleConstructorReturn(
                            this,
                            (
                                ClearAll.__proto__ ||
                                Object.getPrototypeOf(ClearAll)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(ClearAll, [
                        {
                            key: "componentWillMount",
                            value: function componentWillMount() {
                                this.handleClick = this.handleClick.bind(this);
                            },
                        },
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return (
                                    this.props.url !== nextProps.url ||
                                    this.props.hasRefinements !==
                                        nextProps.hasRefinements
                                );
                            },
                        },
                        {
                            key: "handleClick",
                            value: function handleClick(e) {
                                if ((0, _utils.isSpecialClick)(e)) {
                                    // do not alter the default browser behavior
                                    // if one special key is down
                                    return;
                                }
                                e.preventDefault();
                                this.props.clearAll();
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var data = {
                                    hasRefinements: this.props.hasRefinements,
                                };

                                return _react2.default.createElement(
                                    "a",
                                    {
                                        className: this.props.cssClasses.link,
                                        href: this.props.url,
                                        onClick: this.handleClick,
                                    },
                                    _react2.default.createElement(
                                        _Template2.default,
                                        _extends(
                                            {
                                                data: data,
                                                templateKey: "link",
                                            },
                                            this.props.templateProps
                                        )
                                    )
                                );
                            },
                        },
                    ]);

                    return ClearAll;
                })(_react2.default.Component);

                exports.default = ClearAll;

                /***/
            },
            /* 527 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _isUndefined = __webpack_require__(238);

                var _isUndefined2 = _interopRequireDefault(_isUndefined);

                var _isBoolean = __webpack_require__(528);

                var _isBoolean2 = _interopRequireDefault(_isBoolean);

                var _isString = __webpack_require__(239);

                var _isString2 = _interopRequireDefault(_isString);

                var _isArray = __webpack_require__(53);

                var _isArray2 = _interopRequireDefault(_isArray);

                var _isPlainObject = __webpack_require__(225);

                var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

                var _isFunction = __webpack_require__(68);

                var _isFunction2 = _interopRequireDefault(_isFunction);

                var _isEmpty = __webpack_require__(236);

                var _isEmpty2 = _interopRequireDefault(_isEmpty);

                var _map = __webpack_require__(185);

                var _map2 = _interopRequireDefault(_map);

                var _reduce = __webpack_require__(187);

                var _reduce2 = _interopRequireDefault(_reduce);

                var _filter = __webpack_require__(133);

                var _filter2 = _interopRequireDefault(_filter);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _defaultTemplates = __webpack_require__(529);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _CurrentRefinedValues = __webpack_require__(530);

                var _CurrentRefinedValues2 = _interopRequireDefault(
                    _CurrentRefinedValues
                );

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-current-refined-values");

                /**
                 * Instantiate a list of current refinements with the possibility to clear them
                 * @function currentRefinedValues
                 * @param  {string|DOMElement}  options.container CSS Selector or DOMElement to insert the widget
                 * @param  {Array}             [option.attributes] Attributes configuration
                 * @param  {string}            [option.attributes[].name] Required attribute name
                 * @param  {string}            [option.attributes[].label] Attribute label (passed to the item template)
                 * @param  {string|Function}   [option.attributes[].template] Attribute specific template
                 * @param  {Function}          [option.attributes[].transformData] Attribute specific transformData
                 * @param  {boolean|string}    [option.clearAll='before'] Clear all position (one of ('before', 'after', false))
                 * @param  {boolean}           [options.onlyListedAttributes=false] Only use declared attributes
                 * @param  {Object}            [options.templates] Templates to use for the widget
                 * @param  {string|Function}   [options.templates.header] Header template
                 * @param  {string|Function}   [options.templates.item] Item template
                 * @param  {string|Function}   [options.templates.clearAll] Clear all template
                 * @param  {string|Function}   [options.templates.footer] Footer template
                 * @param  {Function}          [options.transformData.item] Function to change the object passed to the `item` template
                 * @param  {boolean}           [options.autoHideContainer=true] Hide the container when no current refinements
                 * @param  {Object}            [options.cssClasses] CSS classes to be added
                 * @param  {string}            [options.cssClasses.root] CSS classes added to the root element
                 * @param  {string}            [options.cssClasses.header] CSS classes added to the header element
                 * @param  {string}            [options.cssClasses.body] CSS classes added to the body element
                 * @param  {string}            [options.cssClasses.clearAll] CSS classes added to the clearAll element
                 * @param  {string}            [options.cssClasses.list] CSS classes added to the list element
                 * @param  {string}            [options.cssClasses.item] CSS classes added to the item element
                 * @param  {string}            [options.cssClasses.link] CSS classes added to the link element
                 * @param  {string}            [options.cssClasses.count] CSS classes added to the count element
                 * @param  {string}            [options.cssClasses.footer] CSS classes added to the footer element
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\ncurrentRefinedValues({\n  container,\n  [ attributes: [{name[, label, template, transformData]}] ],\n  [ onlyListedAttributes = false ],\n  [ clearAll = 'before' ] // One of ['before', 'after', false]\n  [ templates.{header,item,clearAll,footer} ],\n  [ transformData.{item} ],\n  [ autoHideContainer = true ],\n  [ cssClasses.{root, header, body, clearAll, list, item, link, count, footer} = {} ],\n  [ collapsible=false ]\n})";
                function currentRefinedValues(_ref) {
                    var container = _ref.container,
                        _ref$attributes = _ref.attributes,
                        attributes =
                            _ref$attributes === undefined
                                ? []
                                : _ref$attributes,
                        _ref$onlyListedAttrib = _ref.onlyListedAttributes,
                        onlyListedAttributes =
                            _ref$onlyListedAttrib === undefined
                                ? false
                                : _ref$onlyListedAttrib,
                        _ref$clearAll = _ref.clearAll,
                        clearAll =
                            _ref$clearAll === undefined
                                ? "before"
                                : _ref$clearAll,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        transformData = _ref.transformData,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses;

                    var attributesOK =
                        (0, _isArray2.default)(attributes) &&
                        (0, _reduce2.default)(
                            attributes,
                            function (res, val) {
                                return (
                                    res &&
                                    (0, _isPlainObject2.default)(val) &&
                                    (0, _isString2.default)(val.name) &&
                                    ((0, _isUndefined2.default)(val.label) ||
                                        (0, _isString2.default)(val.label)) &&
                                    ((0, _isUndefined2.default)(val.template) ||
                                        (0, _isString2.default)(val.template) ||
                                        (0, _isFunction2.default)(
                                            val.template
                                        )) &&
                                    ((0, _isUndefined2.default)(
                                        val.transformData
                                    ) ||
                                        (0, _isFunction2.default)(
                                            val.transformData
                                        ))
                                );
                            },
                            true
                        );

                    var templatesKeys = [
                        "header",
                        "item",
                        "clearAll",
                        "footer",
                    ];
                    var templatesOK =
                        (0, _isPlainObject2.default)(templates) &&
                        (0, _reduce2.default)(
                            templates,
                            function (res, val, key) {
                                return (
                                    res &&
                                    templatesKeys.indexOf(key) !== -1 &&
                                    ((0, _isString2.default)(val) ||
                                        (0, _isFunction2.default)(val))
                                );
                            },
                            true
                        );

                    var userCssClassesKeys = [
                        "root",
                        "header",
                        "body",
                        "clearAll",
                        "list",
                        "item",
                        "link",
                        "count",
                        "footer",
                    ];
                    var userCssClassesOK =
                        (0, _isPlainObject2.default)(userCssClasses) &&
                        (0, _reduce2.default)(
                            userCssClasses,
                            function (res, val, key) {
                                return (
                                    (res &&
                                        userCssClassesKeys.indexOf(key) !==
                                            -1 &&
                                        (0, _isString2.default)(val)) ||
                                    (0, _isArray2.default)(val)
                                );
                            },
                            true
                        );

                    var transformDataOK =
                        (0, _isUndefined2.default)(transformData) ||
                        (0, _isFunction2.default)(transformData) ||
                        ((0, _isPlainObject2.default)(transformData) &&
                            (0, _isFunction2.default)(transformData.item));

                    var showUsage =
                        false ||
                        !(
                            (0, _isString2.default)(container) ||
                            (0, _utils.isDomElement)(container)
                        ) ||
                        !(0, _isArray2.default)(attributes) ||
                        !attributesOK ||
                        !(0, _isBoolean2.default)(onlyListedAttributes) ||
                        [false, "before", "after"].indexOf(clearAll) === -1 ||
                        !(0, _isPlainObject2.default)(templates) ||
                        !templatesOK ||
                        !transformDataOK ||
                        !(0, _isBoolean2.default)(autoHideContainer) ||
                        !userCssClassesOK;

                    if (showUsage) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var CurrentRefinedValues = (0, _headerFooter2.default)(
                        _CurrentRefinedValues2.default
                    );
                    if (autoHideContainer === true) {
                        CurrentRefinedValues = (0, _autoHideContainer2.default)(
                            CurrentRefinedValues
                        );
                    }

                    var attributeNames = (0, _map2.default)(
                        attributes,
                        function (attribute) {
                            return attribute.name;
                        }
                    );
                    var restrictedTo = onlyListedAttributes
                        ? attributeNames
                        : [];

                    var attributesObj = (0, _reduce2.default)(
                        attributes,
                        function (res, attribute) {
                            res[attribute.name] = attribute;
                            return res;
                        },
                        {}
                    );

                    return {
                        init: function init(_ref2) {
                            var helper = _ref2.helper;

                            this._clearRefinementsAndSearch =
                                _utils.clearRefinementsAndSearch.bind(
                                    null,
                                    helper,
                                    restrictedTo
                                );
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                helper = _ref3.helper,
                                state = _ref3.state,
                                templatesConfig = _ref3.templatesConfig,
                                createURL = _ref3.createURL;

                            var cssClasses = {
                                root: (0, _classnames2.default)(
                                    bem(null),
                                    userCssClasses.root
                                ),
                                header: (0, _classnames2.default)(
                                    bem("header"),
                                    userCssClasses.header
                                ),
                                body: (0, _classnames2.default)(
                                    bem("body"),
                                    userCssClasses.body
                                ),
                                clearAll: (0, _classnames2.default)(
                                    bem("clear-all"),
                                    userCssClasses.clearAll
                                ),
                                list: (0, _classnames2.default)(
                                    bem("list"),
                                    userCssClasses.list
                                ),
                                item: (0, _classnames2.default)(
                                    bem("item"),
                                    userCssClasses.item
                                ),
                                link: (0, _classnames2.default)(
                                    bem("link"),
                                    userCssClasses.link
                                ),
                                count: (0, _classnames2.default)(
                                    bem("count"),
                                    userCssClasses.count
                                ),
                                footer: (0, _classnames2.default)(
                                    bem("footer"),
                                    userCssClasses.footer
                                ),
                            };

                            var templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });

                            var clearAllURL = createURL(
                                (0, _utils.clearRefinementsFromState)(
                                    state,
                                    restrictedTo
                                )
                            );

                            var refinements = getFilteredRefinements(
                                results,
                                state,
                                attributeNames,
                                onlyListedAttributes
                            );
                            var clearRefinementURLs = refinements.map(function (
                                refinement
                            ) {
                                return createURL(
                                    clearRefinementFromState(state, refinement)
                                );
                            });
                            var clearRefinementClicks = refinements.map(
                                function (refinement) {
                                    return clearRefinement.bind(
                                        null,
                                        helper,
                                        refinement
                                    );
                                }
                            );

                            var shouldAutoHideContainer =
                                refinements.length === 0;

                            _reactDom2.default.render(
                                _react2.default.createElement(
                                    CurrentRefinedValues,
                                    {
                                        attributes: attributesObj,
                                        clearAllClick:
                                            this._clearRefinementsAndSearch,
                                        clearAllPosition: clearAll,
                                        clearAllURL: clearAllURL,
                                        clearRefinementClicks:
                                            clearRefinementClicks,
                                        clearRefinementURLs:
                                            clearRefinementURLs,
                                        collapsible: collapsible,
                                        cssClasses: cssClasses,
                                        refinements: refinements,
                                        shouldAutoHideContainer:
                                            shouldAutoHideContainer,
                                        templateProps: templateProps,
                                    }
                                ),
                                containerNode
                            );
                        },
                    };
                }

                function getRestrictedIndexForSort(
                    attributeNames,
                    otherAttributeNames,
                    attributeName
                ) {
                    var idx = attributeNames.indexOf(attributeName);
                    if (idx !== -1) {
                        return idx;
                    }
                    return (
                        attributeNames.length +
                        otherAttributeNames.indexOf(attributeName)
                    );
                }

                function compareRefinements(
                    attributeNames,
                    otherAttributeNames,
                    a,
                    b
                ) {
                    var idxa = getRestrictedIndexForSort(
                        attributeNames,
                        otherAttributeNames,
                        a.attributeName
                    );
                    var idxb = getRestrictedIndexForSort(
                        attributeNames,
                        otherAttributeNames,
                        b.attributeName
                    );
                    if (idxa === idxb) {
                        if (a.name === b.name) {
                            return 0;
                        }
                        return a.name < b.name ? -1 : 1;
                    }
                    return idxa < idxb ? -1 : 1;
                }

                function getFilteredRefinements(
                    results,
                    state,
                    attributeNames,
                    onlyListedAttributes
                ) {
                    var refinements = (0, _utils.getRefinements)(
                        results,
                        state
                    );
                    var otherAttributeNames = (0, _reduce2.default)(
                        refinements,
                        function (res, refinement) {
                            if (
                                attributeNames.indexOf(
                                    refinement.attributeName
                                ) === -1 &&
                                res.indexOf(refinement.attributeName === -1)
                            ) {
                                res.push(refinement.attributeName);
                            }
                            return res;
                        },
                        []
                    );
                    refinements = refinements.sort(
                        compareRefinements.bind(
                            null,
                            attributeNames,
                            otherAttributeNames
                        )
                    );
                    if (
                        onlyListedAttributes &&
                        !(0, _isEmpty2.default)(attributeNames)
                    ) {
                        refinements = (0, _filter2.default)(
                            refinements,
                            function (refinement) {
                                return (
                                    attributeNames.indexOf(
                                        refinement.attributeName
                                    ) !== -1
                                );
                            }
                        );
                    }
                    return refinements;
                }

                function clearRefinementFromState(state, refinement) {
                    switch (refinement.type) {
                        case "facet":
                            return state.removeFacetRefinement(
                                refinement.attributeName,
                                refinement.name
                            );
                        case "disjunctive":
                            return state.removeDisjunctiveFacetRefinement(
                                refinement.attributeName,
                                refinement.name
                            );
                        case "hierarchical":
                            return state.clearRefinements(
                                refinement.attributeName
                            );
                        case "exclude":
                            return state.removeExcludeRefinement(
                                refinement.attributeName,
                                refinement.name
                            );
                        case "numeric":
                            return state.removeNumericRefinement(
                                refinement.attributeName,
                                refinement.operator,
                                refinement.numericValue
                            );
                        case "tag":
                            return state.removeTagRefinement(refinement.name);
                        default:
                            throw new Error(
                                "clearRefinement: type " +
                                    refinement.type +
                                    " is not handled"
                            );
                    }
                }

                function clearRefinement(helper, refinement) {
                    helper
                        .setState(
                            clearRefinementFromState(helper.state, refinement)
                        )
                        .search();
                }

                exports.default = currentRefinedValues;

                /***/
            },
            /* 528 */
            /***/ function (module, exports, __webpack_require__) {
                var baseGetTag = __webpack_require__(46),
                    isObjectLike = __webpack_require__(52);

                /** `Object#toString` result references. */
                var boolTag = "[object Boolean]";

                /**
                 * Checks if `value` is classified as a boolean primitive or object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
                 * @example
                 *
                 * _.isBoolean(false);
                 * // => true
                 *
                 * _.isBoolean(null);
                 * // => false
                 */
                function isBoolean(value) {
                    return (
                        value === true ||
                        value === false ||
                        (isObjectLike(value) && baseGetTag(value) == boolTag)
                    );
                }

                module.exports = isBoolean;

                /***/
            },
            /* 529 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    header: "",
                    item:
                        "" +
                        "{{#label}}" +
                        "{{label}}" +
                        "{{^operator}}:{{/operator}}" +
                        " " +
                        "{{/label}}" +
                        "{{#operator}}{{{displayOperator}}} {{/operator}}" +
                        "{{#exclude}}-{{/exclude}}" +
                        '{{name}} <span class="{{cssClasses.count}}">{{count}}</span>',
                    clearAll: "Clear all",
                    footer: "",
                };

                /***/
            },
            /* 530 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                var _utils = __webpack_require__(514);

                var _map = __webpack_require__(185);

                var _map2 = _interopRequireDefault(_map);

                var _cloneDeep = __webpack_require__(521);

                var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var CurrentRefinedValues = (function (_React$Component) {
                    _inherits(CurrentRefinedValues, _React$Component);

                    function CurrentRefinedValues() {
                        _classCallCheck(this, CurrentRefinedValues);

                        return _possibleConstructorReturn(
                            this,
                            (
                                CurrentRefinedValues.__proto__ ||
                                Object.getPrototypeOf(CurrentRefinedValues)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(CurrentRefinedValues, [
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return !(0, _isEqual2.default)(
                                    this.props.refinements,
                                    nextProps.refinements
                                );
                            },
                        },
                        {
                            key: "_clearAllElement",
                            value: function _clearAllElement(
                                position,
                                requestedPosition
                            ) {
                                if (requestedPosition !== position) {
                                    return undefined;
                                }
                                return _react2.default.createElement(
                                    "a",
                                    {
                                        className:
                                            this.props.cssClasses.clearAll,
                                        href: this.props.clearAllURL,
                                        onClick: handleClick(
                                            this.props.clearAllClick
                                        ),
                                    },
                                    _react2.default.createElement(
                                        _Template2.default,
                                        _extends(
                                            { templateKey: "clearAll" },
                                            this.props.templateProps
                                        )
                                    )
                                );
                            },
                        },
                        {
                            key: "_refinementElement",
                            value: function _refinementElement(refinement, i) {
                                var attribute =
                                    this.props.attributes[
                                        refinement.attributeName
                                    ] || {};
                                var templateData = getTemplateData(
                                    attribute,
                                    refinement,
                                    this.props.cssClasses
                                );
                                var customTemplateProps =
                                    getCustomTemplateProps(attribute);
                                var key =
                                    refinement.attributeName +
                                    (refinement.operator
                                        ? refinement.operator
                                        : ":") +
                                    (refinement.exclude
                                        ? refinement.exclude
                                        : "") +
                                    refinement.name;
                                return _react2.default.createElement(
                                    "div",
                                    {
                                        className: this.props.cssClasses.item,
                                        key: key,
                                    },
                                    _react2.default.createElement(
                                        "a",
                                        {
                                            className:
                                                this.props.cssClasses.link,
                                            href: this.props
                                                .clearRefinementURLs[i],
                                            onClick: handleClick(
                                                this.props
                                                    .clearRefinementClicks[i]
                                            ),
                                        },
                                        _react2.default.createElement(
                                            _Template2.default,
                                            _extends(
                                                {
                                                    data: templateData,
                                                    templateKey: "item",
                                                },
                                                this.props.templateProps,
                                                customTemplateProps
                                            )
                                        )
                                    )
                                );
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                return _react2.default.createElement(
                                    "div",
                                    null,
                                    this._clearAllElement(
                                        "before",
                                        this.props.clearAllPosition
                                    ),
                                    _react2.default.createElement(
                                        "div",
                                        {
                                            className:
                                                this.props.cssClasses.list,
                                        },
                                        (0, _map2.default)(
                                            this.props.refinements,
                                            this._refinementElement.bind(this)
                                        )
                                    ),
                                    this._clearAllElement(
                                        "after",
                                        this.props.clearAllPosition
                                    )
                                );
                            },
                        },
                    ]);

                    return CurrentRefinedValues;
                })(_react2.default.Component);

                function getCustomTemplateProps(attribute) {
                    var customTemplateProps = {};
                    if (attribute.template !== undefined) {
                        customTemplateProps.templates = {
                            item: attribute.template,
                        };
                    }
                    if (attribute.transformData !== undefined) {
                        customTemplateProps.transformData =
                            attribute.transformData;
                    }
                    return customTemplateProps;
                }

                function getTemplateData(attribute, _refinement, cssClasses) {
                    var templateData = (0, _cloneDeep2.default)(_refinement);

                    templateData.cssClasses = cssClasses;
                    if (attribute.label !== undefined) {
                        templateData.label = attribute.label;
                    }
                    if (templateData.operator !== undefined) {
                        templateData.displayOperator = templateData.operator;
                        if (templateData.operator === ">=") {
                            templateData.displayOperator = "&ge;";
                        }
                        if (templateData.operator === "<=") {
                            templateData.displayOperator = "&le;";
                        }
                    }

                    return templateData;
                }

                function handleClick(cb) {
                    return function (e) {
                        if ((0, _utils.isSpecialClick)(e)) {
                            // do not alter the default browser behavior
                            // if one special key is down
                            return;
                        }
                        e.preventDefault();
                        cb();
                    };
                }

                exports.default = CurrentRefinedValues;

                /***/
            },
            /* 531 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _defaultTemplates = __webpack_require__(532);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _RefinementList = __webpack_require__(533);

                var _RefinementList2 = _interopRequireDefault(_RefinementList);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-hierarchical-menu");
                /**
                 * Create a hierarchical menu using multiple attributes
                 * @function hierarchicalMenu
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string[]} options.attributes Array of attributes to use to generate the hierarchy of the menu.
                 * See the example for the convention to follow.
                 * @param  {number} [options.limit=10] How much facet values to get [*]
                 * @param  {string} [options.separator=">"] Separator used in the attributes to separate level values. [*]
                 * @param  {string} [options.rootPath] Prefix path to use if the first level is not the root level.
                 * @param  {string} [options.showParentLevel=false] Show the parent level of the current refined value
                 * @param  {string[]|Function} [options.sortBy=['name:asc']] How to sort refinements. Possible values: `count|isRefined|name:asc|name:desc`.
                 *   You can also use a sort function that behaves like the standard Javascript [compareFunction](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Syntax).
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header=''] Header template (root level only)
                 * @param  {string|Function} [options.templates.item] Item template, provided with `name`, `count`, `isRefined`, `url` data properties
                 * @param  {string|Function} [options.templates.footer=''] Footer template (root level only)
                 * @param  {Function} [options.transformData.item] Method to change the object passed to the `item` template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when there are no items in the menu
                 * @param  {Object} [options.cssClasses] CSS classes to add to the wrapping elements
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.list] CSS class to add to the list element
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each item element
                 * @param  {string|string[]} [options.cssClasses.depth] CSS class to add to each item element to denote its depth. The actual level will be appended to the given class name (ie. if `depth` is given, the widget will add `depth0`, `depth1`, ... according to the level of each item).
                 * @param  {string|string[]} [options.cssClasses.active] CSS class to add to each active element
                 * @param  {string|string[]} [options.cssClasses.link] CSS class to add to each link (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.count] CSS class to add to each count element (when using the default template)
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nhierarchicalMenu({\n  container,\n  attributes,\n  [ separator=' > ' ],\n  [ rootPath ],\n  [ showParentLevel=true ],\n  [ limit=10 ],\n  [ sortBy=['name:asc'] ],\n  [ cssClasses.{root , header, body, footer, list, depth, item, active, link}={} ],\n  [ templates.{header, item, footer} ],\n  [ transformData.{item} ],\n  [ autoHideContainer=true ],\n  [ collapsible=false ]\n})";
                function hierarchicalMenu() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        attributes = _ref.attributes,
                        _ref$separator = _ref.separator,
                        separator =
                            _ref$separator === undefined
                                ? " > "
                                : _ref$separator,
                        _ref$rootPath = _ref.rootPath,
                        rootPath =
                            _ref$rootPath === undefined ? null : _ref$rootPath,
                        _ref$showParentLevel = _ref.showParentLevel,
                        showParentLevel =
                            _ref$showParentLevel === undefined
                                ? true
                                : _ref$showParentLevel,
                        _ref$limit = _ref.limit,
                        limit = _ref$limit === undefined ? 10 : _ref$limit,
                        _ref$sortBy = _ref.sortBy,
                        sortBy =
                            _ref$sortBy === undefined
                                ? ["name:asc"]
                                : _ref$sortBy,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        transformData = _ref.transformData;

                    if (!container || !attributes || !attributes.length) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);

                    var RefinementList = (0, _headerFooter2.default)(
                        _RefinementList2.default
                    );
                    if (autoHideContainer === true) {
                        RefinementList = (0, _autoHideContainer2.default)(
                            RefinementList
                        );
                    }

                    // we need to provide a hierarchicalFacet name for the search state
                    // so that we can always map $hierarchicalFacetName => real attributes
                    // we use the first attribute name
                    var hierarchicalFacetName = attributes[0];

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        list: (0, _classnames2.default)(
                            bem("list"),
                            userCssClasses.list
                        ),
                        depth: bem("list", "lvl"),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                        link: (0, _classnames2.default)(
                            bem("link"),
                            userCssClasses.link
                        ),
                        count: (0, _classnames2.default)(
                            bem("count"),
                            userCssClasses.count
                        ),
                    };

                    return {
                        getConfiguration: function getConfiguration(
                            currentConfiguration
                        ) {
                            return {
                                hierarchicalFacets: [
                                    {
                                        name: hierarchicalFacetName,
                                        attributes: attributes,
                                        separator: separator,
                                        rootPath: rootPath,
                                        showParentLevel: showParentLevel,
                                    },
                                ],
                                maxValuesPerFacet:
                                    currentConfiguration.maxValuesPerFacet !==
                                    undefined
                                        ? Math.max(
                                              currentConfiguration.maxValuesPerFacet,
                                              limit
                                          )
                                        : limit,
                            };
                        },
                        init: function init(_ref2) {
                            var helper = _ref2.helper,
                                templatesConfig = _ref2.templatesConfig;

                            this._toggleRefinement = function (facetValue) {
                                return helper
                                    .toggleRefinement(
                                        hierarchicalFacetName,
                                        facetValue
                                    )
                                    .search();
                            };

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                        },
                        _prepareFacetValues: function _prepareFacetValues(
                            facetValues,
                            state
                        ) {
                            var _this = this;

                            return facetValues
                                .slice(0, limit)
                                .map(function (subValue) {
                                    if (Array.isArray(subValue.data)) {
                                        subValue.data =
                                            _this._prepareFacetValues(
                                                subValue.data,
                                                state
                                            );
                                    }

                                    return subValue;
                                });
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var facetValues =
                                results.getFacetValues(hierarchicalFacetName, {
                                    sortBy: sortBy,
                                }).data || [];
                            facetValues = this._prepareFacetValues(
                                facetValues,
                                state
                            );

                            // Bind createURL to this specific attribute
                            function _createURL(facetValue) {
                                return createURL(
                                    state.toggleRefinement(
                                        hierarchicalFacetName,
                                        facetValue
                                    )
                                );
                            }

                            _reactDom2.default.render(
                                _react2.default.createElement(RefinementList, {
                                    attributeNameKey: "path",
                                    collapsible: collapsible,
                                    createURL: _createURL,
                                    cssClasses: cssClasses,
                                    facetValues: facetValues,
                                    shouldAutoHideContainer:
                                        facetValues.length === 0,
                                    templateProps: this._templateProps,
                                    toggleRefinement: this._toggleRefinement,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = hierarchicalMenu;

                /***/
            },
            /* 532 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                /* eslint-disable max-len */
                exports.default = {
                    header: "",
                    item: '<a class="{{cssClasses.link}}" href="{{url}}">{{name}} <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span></a>',
                    footer: "",
                };

                /***/
            },
            /* 533 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _utils = __webpack_require__(514);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                var _RefinementListItem = __webpack_require__(534);

                var _RefinementListItem2 =
                    _interopRequireDefault(_RefinementListItem);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                var _SearchBox = __webpack_require__(535);

                var _SearchBox2 = _interopRequireDefault(_SearchBox);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _defineProperty(obj, key, value) {
                    if (key in obj) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true,
                        });
                    } else {
                        obj[key] = value;
                    }
                    return obj;
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var RefinementList = (function (_React$Component) {
                    _inherits(RefinementList, _React$Component);

                    function RefinementList(props) {
                        _classCallCheck(this, RefinementList);

                        var _this = _possibleConstructorReturn(
                            this,
                            (
                                RefinementList.__proto__ ||
                                Object.getPrototypeOf(RefinementList)
                            ).call(this, props)
                        );

                        _this.state = {
                            isShowMoreOpen: false,
                        };
                        _this.handleItemClick =
                            _this.handleItemClick.bind(_this);
                        _this.handleClickShowMore =
                            _this.handleClickShowMore.bind(_this);
                        return _this;
                    }

                    _createClass(RefinementList, [
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(
                                nextProps,
                                nextState
                            ) {
                                var isStateDifferent = nextState !== this.state;
                                var isFacetValuesDifferent = !(0,
                                _isEqual2.default)(
                                    this.props.facetValues,
                                    nextProps.facetValues
                                );
                                var shouldUpdate =
                                    isStateDifferent || isFacetValuesDifferent;
                                return shouldUpdate;
                            },
                        },
                        {
                            key: "refine",
                            value: function refine(
                                facetValueToRefine,
                                isRefined
                            ) {
                                this.props.toggleRefinement(
                                    facetValueToRefine,
                                    isRefined
                                );
                            },
                        },
                        {
                            key: "_generateFacetItem",
                            value: function _generateFacetItem(facetValue) {
                                var subItems = void 0;
                                var hasChildren =
                                    facetValue.data &&
                                    facetValue.data.length > 0;
                                if (hasChildren) {
                                    subItems = _react2.default.createElement(
                                        RefinementList,
                                        _extends({}, this.props, {
                                            depth: this.props.depth + 1,
                                            facetValues: facetValue.data,
                                        })
                                    );
                                }

                                var url = this.props.createURL(
                                    facetValue[this.props.attributeNameKey]
                                );
                                var templateData = _extends({}, facetValue, {
                                    url: url,
                                    cssClasses: this.props.cssClasses,
                                });

                                var cssClassItem = (0, _classnames2.default)(
                                    this.props.cssClasses.item,
                                    _defineProperty(
                                        {},
                                        this.props.cssClasses.active,
                                        facetValue.isRefined
                                    )
                                );

                                var key =
                                    facetValue[this.props.attributeNameKey];
                                if (facetValue.isRefined !== undefined) {
                                    key += "/" + facetValue.isRefined;
                                }

                                if (facetValue.count !== undefined) {
                                    key += "/" + facetValue.count;
                                }

                                return _react2.default.createElement(
                                    _RefinementListItem2.default,
                                    {
                                        facetValueToRefine:
                                            facetValue[
                                                this.props.attributeNameKey
                                            ],
                                        handleClick: this.handleItemClick,
                                        isRefined: facetValue.isRefined,
                                        itemClassName: cssClassItem,
                                        key: key,
                                        subItems: subItems,
                                        templateData: templateData,
                                        templateKey: "item",
                                        templateProps: this.props.templateProps,
                                    }
                                );
                            },

                            // Click events on DOM tree like LABEL > INPUT will result in two click events
                            // instead of one.
                            // No matter the framework, see https://www.google.com/search?q=click+label+twice
                            //
                            // Thus making it hard to distinguish activation from deactivation because both click events
                            // are very close. Debounce is a solution but hacky.
                            //
                            // So the code here checks if the click was done on or in a LABEL. If this LABEL
                            // has a checkbox inside, we ignore the first click event because we will get another one.
                            //
                            // We also check if the click was done inside a link and then e.preventDefault() because we already
                            // handle the url
                            //
                            // Finally, we always stop propagation of the event to avoid multiple levels RefinementLists to fail: click
                            // on child would click on parent also
                        },
                        {
                            key: "handleItemClick",
                            value: function handleItemClick(_ref) {
                                var facetValueToRefine =
                                        _ref.facetValueToRefine,
                                    originalEvent = _ref.originalEvent,
                                    isRefined = _ref.isRefined;

                                if ((0, _utils.isSpecialClick)(originalEvent)) {
                                    // do not alter the default browser behavior
                                    // if one special key is down
                                    return;
                                }

                                if (originalEvent.target.tagName === "INPUT") {
                                    this.refine(facetValueToRefine, isRefined);
                                    return;
                                }

                                var parent = originalEvent.target;

                                while (parent !== originalEvent.currentTarget) {
                                    if (
                                        parent.tagName === "LABEL" &&
                                        (parent.querySelector(
                                            'input[type="checkbox"]'
                                        ) ||
                                            parent.querySelector(
                                                'input[type="radio"]'
                                            ))
                                    ) {
                                        return;
                                    }

                                    if (parent.tagName === "A" && parent.href) {
                                        originalEvent.preventDefault();
                                    }

                                    parent = parent.parentNode;
                                }

                                originalEvent.stopPropagation();

                                this.refine(facetValueToRefine, isRefined);
                            },
                        },
                        {
                            key: "handleClickShowMore",
                            value: function handleClickShowMore() {
                                var isShowMoreOpen = !this.state.isShowMoreOpen;
                                this.setState({
                                    isShowMoreOpen: isShowMoreOpen,
                                });
                            },
                        },
                        {
                            key: "componentWillReceiveProps",
                            value: function componentWillReceiveProps(
                                nextProps
                            ) {
                                if (this.searchbox && !nextProps.isFromSearch) {
                                    this.searchbox.clearInput();
                                }
                            },
                        },
                        {
                            key: "refineFirstValue",
                            value: function refineFirstValue() {
                                var firstValue = this.props.facetValues[0];
                                if (firstValue) {
                                    var actualValue =
                                        firstValue[this.props.attributeNameKey];
                                    this.props.toggleRefinement(actualValue);
                                }
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this2 = this;

                                // Adding `-lvl0` classes
                                var cssClassList = [this.props.cssClasses.list];
                                if (this.props.cssClasses.depth) {
                                    cssClassList.push(
                                        "" +
                                            this.props.cssClasses.depth +
                                            this.props.depth
                                    );
                                }

                                var limit = this.state.isShowMoreOpen
                                    ? this.props.limitMax
                                    : this.props.limitMin;
                                var displayedFacetValues =
                                    this.props.facetValues.slice(0, limit);
                                var displayShowMore =
                                    (this.props.showMore === true &&
                                        // "Show more"
                                        this.props.facetValues.length >
                                            displayedFacetValues.length) ||
                                    // "Show less", but hide it if the result set changed
                                    (this.state.isShowMoreOpen &&
                                        displayedFacetValues.length >
                                            this.props.limitMin);

                                var showMoreBtn = displayShowMore
                                    ? _react2.default.createElement(
                                          _Template2.default,
                                          _extends(
                                              {
                                                  rootProps: {
                                                      onClick:
                                                          this
                                                              .handleClickShowMore,
                                                  },
                                                  templateKey:
                                                      "show-more-" +
                                                      (this.state.isShowMoreOpen
                                                          ? "active"
                                                          : "inactive"),
                                              },
                                              this.props.templateProps
                                          )
                                      )
                                    : undefined;

                                var searchInput = this.props.searchFacetValues
                                    ? _react2.default.createElement(
                                          _SearchBox2.default,
                                          {
                                              ref: function ref(i) {
                                                  _this2.searchbox = i;
                                              },
                                              placeholder:
                                                  this.props.searchPlaceholder,
                                              onChange:
                                                  this.props.searchFacetValues,
                                              onValidate:
                                                  function onValidate() {
                                                      return _this2.refineFirstValue();
                                                  },
                                          }
                                      )
                                    : null;

                                var noResults =
                                    this.props.searchFacetValues &&
                                    this.props.isFromSearch &&
                                    this.props.facetValues.length === 0
                                        ? _react2.default.createElement(
                                              _Template2.default,
                                              _extends(
                                                  {
                                                      templateKey: "noResults",
                                                  },
                                                  this.props.templateProps
                                              )
                                          )
                                        : null;

                                return _react2.default.createElement(
                                    "div",
                                    {
                                        className: (0, _classnames2.default)(
                                            cssClassList
                                        ),
                                    },
                                    searchInput,
                                    displayedFacetValues.map(
                                        this._generateFacetItem,
                                        this
                                    ),
                                    noResults,
                                    showMoreBtn
                                );
                            },
                        },
                    ]);

                    return RefinementList;
                })(_react2.default.Component);

                RefinementList.defaultProps = {
                    cssClasses: {},
                    depth: 0,
                    attributeNameKey: "name",
                };

                exports.default = RefinementList;

                /***/
            },
            /* 534 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var RefinementListItem = (function (_React$Component) {
                    _inherits(RefinementListItem, _React$Component);

                    function RefinementListItem() {
                        _classCallCheck(this, RefinementListItem);

                        return _possibleConstructorReturn(
                            this,
                            (
                                RefinementListItem.__proto__ ||
                                Object.getPrototypeOf(RefinementListItem)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(RefinementListItem, [
                        {
                            key: "componentWillMount",
                            value: function componentWillMount() {
                                this.handleClick = this.handleClick.bind(this);
                            },
                        },
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return !(0, _isEqual2.default)(
                                    this.props,
                                    nextProps
                                );
                            },
                        },
                        {
                            key: "handleClick",
                            value: function handleClick(originalEvent) {
                                this.props.handleClick({
                                    facetValueToRefine:
                                        this.props.facetValueToRefine,
                                    isRefined: this.props.isRefined,
                                    originalEvent: originalEvent,
                                });
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                return _react2.default.createElement(
                                    "div",
                                    {
                                        className: this.props.itemClassName,
                                        onClick: this.handleClick,
                                    },
                                    _react2.default.createElement(
                                        _Template2.default,
                                        _extends(
                                            {
                                                data: this.props.templateData,
                                                templateKey:
                                                    this.props.templateKey,
                                            },
                                            this.props.templateProps
                                        )
                                    ),
                                    this.props.subItems
                                );
                            },
                        },
                    ]);

                    return RefinementListItem;
                })(_react2.default.Component);

                exports.default = RefinementListItem;

                /***/
            },
            /* 535 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                } /* eslint-disable max-len, no-extra-parens */

                var _ref = _react2.default.createElement(
                    "symbol",
                    {
                        xmlns: "http://www.w3.org/2000/svg",
                        id: "sbx-icon-search-12",
                        viewBox: "0 0 40 41",
                    },
                    _react2.default.createElement("path", {
                        d: "M30.967 27.727l-.03-.03c-.778-.777-2.038-.777-2.815 0l-1.21 1.21c-.78.78-.778 2.04 0 2.817l.03.03 4.025-4.027zm1.083 1.084L39.24 36c.778.778.78 2.037 0 2.816l-1.21 1.21c-.777.778-2.038.78-2.816 0l-7.19-7.19 4.026-4.025zM15.724 31.45c8.684 0 15.724-7.04 15.724-15.724C31.448 7.04 24.408 0 15.724 0 7.04 0 0 7.04 0 15.724c0 8.684 7.04 15.724 15.724 15.724zm0-3.93c6.513 0 11.793-5.28 11.793-11.794 0-6.513-5.28-11.793-11.793-11.793C9.21 3.93 3.93 9.21 3.93 15.725c0 6.513 5.28 11.793 11.794 11.793z",
                        fillRule: "evenodd",
                    })
                );

                var _ref2 = _react2.default.createElement(
                    "symbol",
                    {
                        xmlns: "http://www.w3.org/2000/svg",
                        id: "sbx-icon-clear-2",
                        viewBox: "0 0 20 20",
                    },
                    _react2.default.createElement("path", {
                        d: "M8.96 10L.52 1.562 0 1.042 1.04 0l.522.52L10 8.96 18.438.52l.52-.52L20 1.04l-.52.522L11.04 10l8.44 8.438.52.52L18.96 20l-.522-.52L10 11.04l-8.438 8.44-.52.52L0 18.96l.52-.522L8.96 10z",
                        fillRule: "evenodd",
                    })
                );

                var _ref3 = _react2.default.createElement(
                    "button",
                    {
                        type: "submit",
                        title: "Submit your search query.",
                        className: "sbx-sffv__submit",
                    },
                    _react2.default.createElement(
                        "svg",
                        { "role": "img", "aria-label": "Search" },
                        _react2.default.createElement("use", {
                            xlinkHref: "#sbx-icon-search-12",
                        })
                    )
                );

                var _ref4 = _react2.default.createElement(
                    "button",
                    {
                        type: "reset",
                        title: "Clear the search query.",
                        className: "sbx-sffv__reset",
                    },
                    _react2.default.createElement(
                        "svg",
                        { "role": "img", "aria-label": "Reset" },
                        _react2.default.createElement("use", {
                            xlinkHref: "#sbx-icon-clear-2",
                        })
                    )
                );

                var SearchBox = (function (_React$Component) {
                    _inherits(SearchBox, _React$Component);

                    function SearchBox() {
                        _classCallCheck(this, SearchBox);

                        return _possibleConstructorReturn(
                            this,
                            (
                                SearchBox.__proto__ ||
                                Object.getPrototypeOf(SearchBox)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(SearchBox, [
                        {
                            key: "clearInput",
                            value: function clearInput() {
                                if (this.input) {
                                    this.input.value = "";
                                }
                            },
                        },
                        {
                            key: "validateSearch",
                            value: function validateSearch(e) {
                                e.preventDefault();
                                if (this.input) {
                                    var inputValue = this.input.value;
                                    if (inputValue) this.props.onValidate();
                                }
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this2 = this;

                                var _props = this.props,
                                    placeholder = _props.placeholder,
                                    _onChange = _props.onChange;

                                return _react2.default.createElement(
                                    "form",
                                    {
                                        noValidate: "novalidate",
                                        className: "searchbox sbx-sffv",
                                        onReset: function onReset() {
                                            _onChange("");
                                        },
                                        onSubmit: function onSubmit(e) {
                                            return _this2.validateSearch(e);
                                        },
                                    },
                                    _react2.default.createElement(
                                        "svg",
                                        {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            style: { display: "none" },
                                        },
                                        _ref,
                                        _ref2
                                    ),
                                    _react2.default.createElement(
                                        "div",
                                        {
                                            role: "search",
                                            className: "sbx-sffv__wrapper",
                                        },
                                        _react2.default.createElement("input", {
                                            type: "search",
                                            name: "search",
                                            placeholder: placeholder,
                                            autoComplete: "off",
                                            required: "required",
                                            className: "sbx-sffv__input",
                                            onChange: function onChange(e) {
                                                return _onChange(
                                                    e.target.value
                                                );
                                            },
                                            ref: function ref(i) {
                                                _this2.input = i;
                                            },
                                        }),
                                        _ref3,
                                        _ref4
                                    )
                                );
                            },
                        },
                    ]);

                    return SearchBox;
                })(_react2.default.Component);

                exports.default = SearchBox;

                /***/
            },
            /* 536 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _Hits = __webpack_require__(537);

                var _Hits2 = _interopRequireDefault(_Hits);

                var _defaultTemplates = __webpack_require__(540);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-hits");

                /**
                 * Display the list of results (hits) from the current search
                 * @function hits
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {number} [options.hitsPerPage=20] The number of hits to display per page [*]
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.empty=''] Template to use when there are no results.
                 * @param  {string|Function} [options.templates.item=''] Template to use for each result. This template will receive an object containing a single record.
                 * @param  {string|Function} [options.templates.allItems=''] Template to use for the list of all results. (Can't be used with `item` template). This template will receive a complete SearchResults result object, this object contains the key hits that contains all the records retrieved.
                 * @param  {Object} [options.transformData] Method to change the object passed to the templates
                 * @param  {Function} [options.transformData.empty] Method used to change the object passed to the `empty` template
                 * @param  {Function} [options.transformData.item] Method used to change the object passed to the `item` template
                 * @param  {Function} [options.transformData.allItems] Method used to change the object passed to the `allItems` template
                 * @param  {Object} [options.cssClasses] CSS classes to add
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the wrapping element
                 * @param  {string|string[]} [options.cssClasses.empty] CSS class to add to the wrapping element when no results
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each result
                 * @return {Object}
                 */
                var usage =
                    "\nUsage:\nhits({\n  container,\n  [ cssClasses.{root,empty,item}={} ],\n  [ templates.{empty,item} | templates.{empty, allItems} ],\n  [ transformData.{empty,item} | transformData.{empty, allItems} ],\n  [ hitsPerPage=20 ]\n})";
                function hits() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        transformData = _ref.transformData,
                        _ref$hitsPerPage = _ref.hitsPerPage,
                        hitsPerPage =
                            _ref$hitsPerPage === undefined
                                ? 20
                                : _ref$hitsPerPage;

                    if (!container) {
                        throw new Error("Must provide a container." + usage);
                    }

                    if (templates.item && templates.allItems) {
                        throw new Error(
                            "Must contain only allItems OR item template." +
                                usage
                        );
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        empty: (0, _classnames2.default)(
                            bem(null, "empty"),
                            userCssClasses.empty
                        ),
                    };

                    return {
                        getConfiguration: function getConfiguration() {
                            return { hitsPerPage: hitsPerPage };
                        },
                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results;

                            _reactDom2.default.render(
                                _react2.default.createElement(_Hits2.default, {
                                    cssClasses: cssClasses,
                                    hits: results.hits,
                                    results: results,
                                    templateProps: this._templateProps,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = hits;

                /***/
            },
            /* 537 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _map = __webpack_require__(185);

                var _map2 = _interopRequireDefault(_map);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                var _has = __webpack_require__(538);

                var _has2 = _interopRequireDefault(_has);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var Hits = (function (_React$Component) {
                    _inherits(Hits, _React$Component);

                    function Hits() {
                        _classCallCheck(this, Hits);

                        return _possibleConstructorReturn(
                            this,
                            (
                                Hits.__proto__ || Object.getPrototypeOf(Hits)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(Hits, [
                        {
                            key: "renderWithResults",
                            value: function renderWithResults() {
                                var _this2 = this;

                                var renderedHits = (0, _map2.default)(
                                    this.props.hits,
                                    function (hit, position) {
                                        var data = _extends({}, hit, {
                                            __hitIndex: position,
                                        });
                                        return _react2.default.createElement(
                                            _Template2.default,
                                            _extends(
                                                {
                                                    data: data,
                                                    key: data.objectID,
                                                    rootProps: {
                                                        className:
                                                            _this2.props
                                                                .cssClasses
                                                                .item,
                                                    },
                                                    templateKey: "item",
                                                },
                                                _this2.props.templateProps
                                            )
                                        );
                                    }
                                );

                                return _react2.default.createElement(
                                    "div",
                                    { className: this.props.cssClasses.root },
                                    renderedHits
                                );
                            },
                        },
                        {
                            key: "renderAllResults",
                            value: function renderAllResults() {
                                var className = (0, _classnames2.default)(
                                    this.props.cssClasses.root,
                                    this.props.cssClasses.allItems
                                );

                                return _react2.default.createElement(
                                    _Template2.default,
                                    _extends(
                                        {
                                            data: this.props.results,
                                            rootProps: { className: className },
                                            templateKey: "allItems",
                                        },
                                        this.props.templateProps
                                    )
                                );
                            },
                        },
                        {
                            key: "renderNoResults",
                            value: function renderNoResults() {
                                var className = (0, _classnames2.default)(
                                    this.props.cssClasses.root,
                                    this.props.cssClasses.empty
                                );
                                return _react2.default.createElement(
                                    _Template2.default,
                                    _extends(
                                        {
                                            data: this.props.results,
                                            rootProps: { className: className },
                                            templateKey: "empty",
                                        },
                                        this.props.templateProps
                                    )
                                );
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var hasResults =
                                    this.props.results.hits.length > 0;
                                var hasAllItemsTemplate = (0, _has2.default)(
                                    this.props,
                                    "templateProps.templates.allItems"
                                );

                                if (!hasResults) {
                                    return this.renderNoResults();
                                }

                                // If a allItems template is defined, it takes precedence over our looping
                                // through hits
                                if (hasAllItemsTemplate) {
                                    return this.renderAllResults();
                                }

                                return this.renderWithResults();
                            },
                        },
                    ]);

                    return Hits;
                })(_react2.default.Component);

                Hits.defaultProps = {
                    results: { hits: [] },
                };

                exports.default = Hits;

                /***/
            },
            /* 538 */
            /***/ function (module, exports, __webpack_require__) {
                var baseHas = __webpack_require__(539),
                    hasPath = __webpack_require__(181);

                /**
                 * Checks if `path` is a direct property of `object`.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path to check.
                 * @returns {boolean} Returns `true` if `path` exists, else `false`.
                 * @example
                 *
                 * var object = { 'a': { 'b': 2 } };
                 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
                 *
                 * _.has(object, 'a');
                 * // => true
                 *
                 * _.has(object, 'a.b');
                 * // => true
                 *
                 * _.has(object, ['a', 'b']);
                 * // => true
                 *
                 * _.has(other, 'a');
                 * // => false
                 */
                function has(object, path) {
                    return object != null && hasPath(object, path, baseHas);
                }

                module.exports = has;

                /***/
            },
            /* 539 */
            /***/ function (module, exports) {
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * The base implementation of `_.has` without support for deep paths.
                 *
                 * @private
                 * @param {Object} [object] The object to query.
                 * @param {Array|string} key The key to check.
                 * @returns {boolean} Returns `true` if `key` exists, else `false`.
                 */
                function baseHas(object, key) {
                    return object != null && hasOwnProperty.call(object, key);
                }

                module.exports = baseHas;

                /***/
            },
            /* 540 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    empty: "No results",
                    item: function item(data) {
                        return JSON.stringify(data, null, 2);
                    },
                };

                /***/
            },
            /* 541 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _some = __webpack_require__(542);

                var _some2 = _interopRequireDefault(_some);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _Selector = __webpack_require__(544);

                var _Selector2 = _interopRequireDefault(_Selector);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-hits-per-page-selector");

                /**
                 * Instantiate a dropdown element to choose the number of hits to display per page
                 * @function hitsPerPageSelector
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {Array} options.options Array of objects defining the different values and labels
                 * @param  {number} options.options[0].value number of hits to display per page
                 * @param  {string} options.options[0].label Label to display in the option
                 * @param  {boolean} [options.autoHideContainer=false] Hide the container when no results match
                 * @param  {Object} [options.cssClasses] CSS classes to be added
                 * @param  {string|string[]} [options.cssClasses.root] CSS classes added to the parent `<select>`
                 * @param  {string|string[]} [options.cssClasses.item] CSS classes added to each `<option>`
                 * @return {Object}
                 */

                var usage =
                    "Usage:\nhitsPerPageSelector({\n  container,\n  options,\n  [ cssClasses.{root,item}={} ],\n  [ autoHideContainer=false ]\n})";
                function hitsPerPageSelector() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        userOptions = _ref.options,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? false
                                : _ref$autoHideContaine;

                    var options = userOptions;

                    if (!container || !options) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var Selector = _Selector2.default;
                    if (autoHideContainer === true) {
                        Selector = (0, _autoHideContainer2.default)(Selector);
                    }

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                    };

                    return {
                        init: function init(_ref2) {
                            var helper = _ref2.helper,
                                state = _ref2.state;

                            var isCurrentInOptions = (0, _some2.default)(
                                options,
                                function (option) {
                                    return (
                                        Number(state.hitsPerPage) ===
                                        Number(option.value)
                                    );
                                }
                            );

                            if (!isCurrentInOptions) {
                                if (state.hitsPerPage === undefined) {
                                    if (window.console) {
                                        window.console.log(
                                            "[Warning][hitsPerPageSelector] hitsPerPage not defined.\nYou should probably use a `hits` widget or set the value `hitsPerPage`\nusing the searchParameters attribute of the instantsearch constructor."
                                        );
                                    }
                                } else if (window.console) {
                                    window.console.log(
                                        "[Warning][hitsPerPageSelector] No option in `options`\nwith `value: hitsPerPage` (hitsPerPage: " +
                                            state.hitsPerPage +
                                            ")"
                                    );
                                }

                                options = [
                                    { value: undefined, label: "" },
                                ].concat(options);
                            }

                            this.setHitsPerPage = function (value) {
                                return helper
                                    .setQueryParameter(
                                        "hitsPerPage",
                                        Number(value)
                                    )
                                    .search();
                            };
                        },
                        render: function render(_ref3) {
                            var state = _ref3.state,
                                results = _ref3.results;

                            var currentValue = state.hitsPerPage;
                            var hasNoResults = results.nbHits === 0;

                            _reactDom2.default.render(
                                _react2.default.createElement(Selector, {
                                    cssClasses: cssClasses,
                                    currentValue: currentValue,
                                    options: options,
                                    setValue: this.setHitsPerPage,
                                    shouldAutoHideContainer: hasNoResults,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = hitsPerPageSelector;

                /***/
            },
            /* 542 */
            /***/ function (module, exports, __webpack_require__) {
                var arraySome = __webpack_require__(148),
                    baseIteratee = __webpack_require__(136),
                    baseSome = __webpack_require__(543),
                    isArray = __webpack_require__(53),
                    isIterateeCall = __webpack_require__(254);

                /**
                 * Checks if `predicate` returns truthy for **any** element of `collection`.
                 * Iteration is stopped once `predicate` returns truthy. The predicate is
                 * invoked with three arguments: (value, index|key, collection).
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                 * @returns {boolean} Returns `true` if any element passes the predicate check,
                 *  else `false`.
                 * @example
                 *
                 * _.some([null, 0, 'yes', false], Boolean);
                 * // => true
                 *
                 * var users = [
                 *   { 'user': 'barney', 'active': true },
                 *   { 'user': 'fred',   'active': false }
                 * ];
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.some(users, { 'user': 'barney', 'active': false });
                 * // => false
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.some(users, ['active', false]);
                 * // => true
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.some(users, 'active');
                 * // => true
                 */
                function some(collection, predicate, guard) {
                    var func = isArray(collection) ? arraySome : baseSome;
                    if (guard && isIterateeCall(collection, predicate, guard)) {
                        predicate = undefined;
                    }
                    return func(collection, baseIteratee(predicate, 3));
                }

                module.exports = some;

                /***/
            },
            /* 543 */
            /***/ function (module, exports, __webpack_require__) {
                var baseEach = __webpack_require__(131);

                /**
                 * The base implementation of `_.some` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {boolean} Returns `true` if any element passes the predicate check,
                 *  else `false`.
                 */
                function baseSome(collection, predicate) {
                    var result;

                    baseEach(collection, function (value, index, collection) {
                        result = predicate(value, index, collection);
                        return !result;
                    });
                    return !!result;
                }

                module.exports = baseSome;

                /***/
            },
            /* 544 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var Selector = (function (_React$Component) {
                    _inherits(Selector, _React$Component);

                    function Selector() {
                        _classCallCheck(this, Selector);

                        return _possibleConstructorReturn(
                            this,
                            (
                                Selector.__proto__ ||
                                Object.getPrototypeOf(Selector)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(Selector, [
                        {
                            key: "componentWillMount",
                            value: function componentWillMount() {
                                this.handleChange =
                                    this.handleChange.bind(this);
                            },
                        },
                        {
                            key: "handleChange",
                            value: function handleChange(event) {
                                this.props.setValue(event.target.value);
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this2 = this;

                                var _props = this.props,
                                    currentValue = _props.currentValue,
                                    options = _props.options;

                                return _react2.default.createElement(
                                    "select",
                                    {
                                        className: this.props.cssClasses.root,
                                        onChange: this.handleChange,
                                        value: currentValue,
                                    },
                                    options.map(function (option) {
                                        return _react2.default.createElement(
                                            "option",
                                            {
                                                className:
                                                    _this2.props.cssClasses
                                                        .item,
                                                key: option.value,
                                                value: option.value,
                                            },
                                            option.label
                                        );
                                    })
                                );
                            },
                        },
                    ]);

                    return Selector;
                })(_react2.default.Component);

                exports.default = Selector;

                /***/
            },
            /* 545 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _InfiniteHits = __webpack_require__(546);

                var _InfiniteHits2 = _interopRequireDefault(_InfiniteHits);

                var _defaultTemplates = __webpack_require__(547);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _toConsumableArray(arr) {
                    if (Array.isArray(arr)) {
                        for (
                            var i = 0, arr2 = Array(arr.length);
                            i < arr.length;
                            i++
                        ) {
                            arr2[i] = arr[i];
                        }
                        return arr2;
                    } else {
                        return Array.from(arr);
                    }
                }

                var bem = (0, _utils.bemHelper)("ais-infinite-hits");

                /**
                 * Display the list of results (hits) from the current search
                 * @function infiniteHits
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {number} [options.hitsPerPage=20] The number of hits to display per page [*]
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.empty=""] Template to use when there are no results.
                 * @param  {string|Function} [options.templates.item=""] Template to use for each result. This template will receive an object containing a single record.
                 * @param  {string} [options.showMoreLabel="Show more results"] label used on the show more button
                 * @param  {Object} [options.transformData] Method to change the object passed to the templates
                 * @param  {Function} [options.transformData.empty] Method used to change the object passed to the `empty` template
                 * @param  {Function} [options.transformData.item] Method used to change the object passed to the `item` template
                 * @param  {Object} [options.cssClasses] CSS classes to add
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the wrapping element
                 * @param  {string|string[]} [options.cssClasses.empty] CSS class to add to the wrapping element when no results
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each result
                 * @return {Object}
                 */
                var usage =
                    '\nUsage:\ninfiniteHits({\n  container,\n  [ cssClasses.{root,empty,item}={} ],\n  [ templates.{empty,item} | templates.{empty} ],\n  [ showMoreLabel="Show more results" ]\n  [ transformData.{empty,item} | transformData.{empty} ],\n  [ hitsPerPage=20 ]\n})';
                function infiniteHits() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$showMoreLabel = _ref.showMoreLabel,
                        showMoreLabel =
                            _ref$showMoreLabel === undefined
                                ? "Show more results"
                                : _ref$showMoreLabel,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        transformData = _ref.transformData,
                        _ref$hitsPerPage = _ref.hitsPerPage,
                        hitsPerPage =
                            _ref$hitsPerPage === undefined
                                ? 20
                                : _ref$hitsPerPage;

                    if (!container) {
                        throw new Error("Must provide a container." + usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        empty: (0, _classnames2.default)(
                            bem(null, "empty"),
                            userCssClasses.empty
                        ),
                        showmore: (0, _classnames2.default)(
                            bem("showmore"),
                            userCssClasses.showmore
                        ),
                    };

                    var hitsCache = [];

                    var getShowMore = function getShowMore(helper) {
                        return function () {
                            return helper.nextPage().search();
                        };
                    };

                    return {
                        getConfiguration: function getConfiguration() {
                            return { hitsPerPage: hitsPerPage };
                        },
                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig,
                                helper = _ref2.helper;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });

                            this.showMore = getShowMore(helper);
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                state = _ref3.state;

                            if (state.page === 0) {
                                hitsCache = [];
                            }

                            hitsCache = [].concat(
                                _toConsumableArray(hitsCache),
                                _toConsumableArray(results.hits)
                            );

                            var isLastPage =
                                results.nbPages <= results.page + 1;

                            _reactDom2.default.render(
                                _react2.default.createElement(
                                    _InfiniteHits2.default,
                                    {
                                        cssClasses: cssClasses,
                                        hits: hitsCache,
                                        results: results,
                                        showMore: this.showMore,
                                        showMoreLabel: showMoreLabel,
                                        isLastPage: isLastPage,
                                        templateProps: this._templateProps,
                                    }
                                ),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = infiniteHits;

                /***/
            },
            /* 546 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _Hits = __webpack_require__(537);

                var _Hits2 = _interopRequireDefault(_Hits);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var InfiniteHits = (function (_React$Component) {
                    _inherits(InfiniteHits, _React$Component);

                    function InfiniteHits() {
                        _classCallCheck(this, InfiniteHits);

                        return _possibleConstructorReturn(
                            this,
                            (
                                InfiniteHits.__proto__ ||
                                Object.getPrototypeOf(InfiniteHits)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(InfiniteHits, [
                        {
                            key: "render",
                            value: function render() {
                                var _props = this.props,
                                    cssClasses = _props.cssClasses,
                                    hits = _props.hits,
                                    results = _props.results,
                                    showMore = _props.showMore,
                                    showMoreLabel = _props.showMoreLabel,
                                    templateProps = _props.templateProps;

                                var btn = this.props.isLastPage
                                    ? _react2.default.createElement(
                                          "button",
                                          { disabled: true },
                                          showMoreLabel
                                      )
                                    : _react2.default.createElement(
                                          "button",
                                          { onClick: showMore },
                                          showMoreLabel
                                      );

                                return _react2.default.createElement(
                                    "div",
                                    null,
                                    _react2.default.createElement(
                                        _Hits2.default,
                                        {
                                            cssClasses: cssClasses,
                                            hits: hits,
                                            results: results,
                                            templateProps: templateProps,
                                        }
                                    ),
                                    _react2.default.createElement(
                                        "div",
                                        { className: cssClasses.showmore },
                                        btn
                                    )
                                );
                            },
                        },
                    ]);

                    return InfiniteHits;
                })(_react2.default.Component);

                exports.default = InfiniteHits;

                /***/
            },
            /* 547 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    empty: "No results",
                    item: function item(data) {
                        return JSON.stringify(data, null, 2);
                    },
                };

                /***/
            },
            /* 548 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _getShowMoreConfig = __webpack_require__(549);

                var _getShowMoreConfig2 =
                    _interopRequireDefault(_getShowMoreConfig);

                var _defaultTemplates = __webpack_require__(551);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _RefinementList = __webpack_require__(533);

                var _RefinementList2 = _interopRequireDefault(_RefinementList);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-menu");

                /**
                 * Create a menu out of a facet
                 * @function menu
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} options.attributeName Name of the attribute for faceting
                 * @param  {string[]|Function} [options.sortBy=['count:desc', 'name:asc']] How to sort refinements. Possible values: `count|isRefined|name:asc|name:desc`.
                 *   You can also use a sort function that behaves like the standard Javascript [compareFunction](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Syntax). [*]
                 * @param  {string} [options.limit=10] How many facets values to retrieve [*]
                 * @param  {object|boolean} [options.showMore=false] Limit the number of results and display a showMore button
                 * @param  {object} [options.showMore.templates] Templates to use for showMore
                 * @param  {object} [options.showMore.templates.active] Template used when showMore was clicked
                 * @param  {object} [options.showMore.templates.inactive] Template used when showMore not clicked
                 * @param  {object} [options.showMore.limit] Max number of facets values to display when showMore is clicked
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header] Header template
                 * @param  {string|Function} [options.templates.item] Item template, provided with `name`, `count`, `isRefined`, `url` data properties
                 * @param  {string|Function} [options.templates.footer] Footer template
                 * @param  {Function} [options.transformData.item] Method to change the object passed to the `item` template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when there are no items in the menu
                 * @param  {Object} [options.cssClasses] CSS classes to add to the wrapping elements
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.list] CSS class to add to the list element
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each item element
                 * @param  {string|string[]} [options.cssClasses.active] CSS class to add to each active element
                 * @param  {string|string[]} [options.cssClasses.link] CSS class to add to each link (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.count] CSS class to add to each count element (when using the default template)
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nmenu({\n  container,\n  attributeName,\n  [ sortBy=['count:desc', 'name:asc'] ],\n  [ limit=10 ],\n  [ cssClasses.{root,list,item} ],\n  [ templates.{header,item,footer} ],\n  [ transformData.{item} ],\n  [ autoHideContainer ],\n  [ showMore.{templates: {active, inactive}, limit} ],\n  [ collapsible=false ]\n})";
                function menu() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        attributeName = _ref.attributeName,
                        _ref$sortBy = _ref.sortBy,
                        sortBy =
                            _ref$sortBy === undefined
                                ? ["count:desc", "name:asc"]
                                : _ref$sortBy,
                        _ref$limit = _ref.limit,
                        limit = _ref$limit === undefined ? 10 : _ref$limit,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        transformData = _ref.transformData,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        _ref$showMore = _ref.showMore,
                        showMore =
                            _ref$showMore === undefined ? false : _ref$showMore;

                    var showMoreConfig = (0, _getShowMoreConfig2.default)(
                        showMore
                    );
                    if (showMoreConfig && showMoreConfig.limit < limit) {
                        throw new Error(
                            "showMore.limit configuration should be > than the limit in the main configuration"
                        ); // eslint-disable-line
                    }
                    var widgetMaxValuesPerFacet =
                        (showMoreConfig && showMoreConfig.limit) || limit;

                    if (!container || !attributeName) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var RefinementList = (0, _headerFooter2.default)(
                        _RefinementList2.default
                    );
                    if (autoHideContainer === true) {
                        RefinementList = (0, _autoHideContainer2.default)(
                            RefinementList
                        );
                    }

                    // we use a hierarchicalFacet for the menu because that's one of the use cases
                    // of hierarchicalFacet: a flat menu
                    var hierarchicalFacetName = attributeName;

                    var showMoreTemplates =
                        showMoreConfig &&
                        (0, _utils.prefixKeys)(
                            "show-more-",
                            showMoreConfig.templates
                        );
                    var allTemplates = showMoreTemplates
                        ? _extends({}, templates, showMoreTemplates)
                        : templates;

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        list: (0, _classnames2.default)(
                            bem("list"),
                            userCssClasses.list
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                        link: (0, _classnames2.default)(
                            bem("link"),
                            userCssClasses.link
                        ),
                        count: (0, _classnames2.default)(
                            bem("count"),
                            userCssClasses.count
                        ),
                    };

                    return {
                        getConfiguration: function getConfiguration(
                            configuration
                        ) {
                            var widgetConfiguration = {
                                hierarchicalFacets: [
                                    {
                                        name: hierarchicalFacetName,
                                        attributes: [attributeName],
                                    },
                                ],
                            };

                            var currentMaxValuesPerFacet =
                                configuration.maxValuesPerFacet || 0;
                            widgetConfiguration.maxValuesPerFacet = Math.max(
                                currentMaxValuesPerFacet,
                                widgetMaxValuesPerFacet
                            );

                            return widgetConfiguration;
                        },
                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig,
                                helper = _ref2.helper,
                                createURL = _ref2.createURL;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: allTemplates,
                            });
                            this._createURL = function (state, facetValue) {
                                return createURL(
                                    state.toggleRefinement(
                                        hierarchicalFacetName,
                                        facetValue
                                    )
                                );
                            };
                            this._toggleRefinement = function (facetValue) {
                                return helper
                                    .toggleRefinement(
                                        hierarchicalFacetName,
                                        facetValue
                                    )
                                    .search();
                            };
                        },
                        _prepareFacetValues: function _prepareFacetValues(
                            facetValues,
                            state
                        ) {
                            var _this = this;

                            return facetValues.map(function (facetValue) {
                                facetValue.url = _this._createURL(
                                    state,
                                    facetValue
                                );
                                return facetValue;
                            });
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var facetValues =
                                results.getFacetValues(hierarchicalFacetName, {
                                    sortBy: sortBy,
                                }).data || [];
                            facetValues = this._prepareFacetValues(
                                facetValues,
                                state
                            );

                            // Bind createURL to this specific attribute
                            function _createURL(facetValue) {
                                return createURL(
                                    state.toggleRefinement(
                                        attributeName,
                                        facetValue
                                    )
                                );
                            }

                            _reactDom2.default.render(
                                _react2.default.createElement(RefinementList, {
                                    collapsible: collapsible,
                                    createURL: _createURL,
                                    cssClasses: cssClasses,
                                    facetValues: facetValues,
                                    limitMax: widgetMaxValuesPerFacet,
                                    limitMin: limit,
                                    shouldAutoHideContainer:
                                        facetValues.length === 0,
                                    showMore: showMoreConfig !== null,
                                    templateProps: this._templateProps,
                                    toggleRefinement: this._toggleRefinement,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = menu;

                /***/
            },
            /* 549 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                exports.default = getShowMoreConfig;

                var _defaultShowMoreTemplates = __webpack_require__(550);

                var _defaultShowMoreTemplates2 = _interopRequireDefault(
                    _defaultShowMoreTemplates
                );

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var defaultShowMoreConfig = {
                    templates: _defaultShowMoreTemplates2.default,
                    limit: 100,
                };

                function getShowMoreConfig(showMoreOptions) {
                    if (!showMoreOptions) return null;

                    if (showMoreOptions === true) {
                        return defaultShowMoreConfig;
                    }

                    var config = _extends({}, showMoreOptions);
                    if (!showMoreOptions.templates) {
                        config.templates = defaultShowMoreConfig.templates;
                    }
                    if (!showMoreOptions.limit) {
                        config.limit = defaultShowMoreConfig.limit;
                    }
                    return config;
                }

                /***/
            },
            /* 550 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    active: '<a class="ais-show-more ais-show-more__active">Show less</a>',
                    inactive:
                        '<a class="ais-show-more ais-show-more__inactive">Show more</a>',
                };

                /***/
            },
            /* 551 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                /* eslint-disable max-len */
                exports.default = {
                    header: "",
                    item: '<a class="{{cssClasses.link}}" href="{{url}}">{{name}} <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span></a>',
                    footer: "",
                };

                /***/
            },
            /* 552 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _filter = __webpack_require__(133);

                var _filter2 = _interopRequireDefault(_filter);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _getShowMoreConfig = __webpack_require__(549);

                var _getShowMoreConfig2 =
                    _interopRequireDefault(_getShowMoreConfig);

                var _defaultTemplates = __webpack_require__(553);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _RefinementList = __webpack_require__(533);

                var _RefinementList2 = _interopRequireDefault(_RefinementList);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _defineProperty(obj, key, value) {
                    if (key in obj) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true,
                        });
                    } else {
                        obj[key] = value;
                    }
                    return obj;
                }

                var bem = (0, _utils.bemHelper)("ais-refinement-list");
                /**
                 * Instantiate a list of refinements based on a facet
                 * @function refinementList
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} options.attributeName Name of the attribute for faceting
                 * @param  {string} [options.operator='or'] How to apply refinements. Possible values: `or`, `and` [*]
                 * @param  {string[]|Function} [options.sortBy=['count:desc', 'name:asc']] How to sort refinements. Possible values: `count:asc|count:desc|name:asc|name:desc|isRefined`.
                 *   You can also use a sort function that behaves like the standard Javascript [compareFunction](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Syntax). [*]
                 * @param  {string} [options.limit=10] How much facet values to get. When the show more feature is activated this is the minimum number of facets requested (the show more button is not in active state). [*]
                 * @param  {object|boolean} [options.searchForFacetValues=false] Add a search input to let the user search for more facet values
                 * @param  {string} [options.searchForFacetValues.placeholder] Value of the search field placeholder
                 * @param  {string} [options.searchForFacetValues.templates] Templates to use for search for facet values
                 * @param  {string} [options.searchForFacetValues.templates.noResults] Templates to use for search for facet values
                 * @param  {object|boolean} [options.showMore=false] Limit the number of results and display a showMore button
                 * @param  {object} [options.showMore.templates] Templates to use for showMore
                 * @param  {object} [options.showMore.templates.active] Template used when showMore was clicked
                 * @param  {object} [options.showMore.templates.inactive] Template used when showMore not clicked
                 * @param  {object} [options.showMore.limit] Max number of facets values to display when showMore is clicked
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header] Header template, provided with `refinedFacetsCount` data property
                 * @param  {string|Function} [options.templates.item] Item template, provided with `name`, `count`, `isRefined`, `url` data properties
                 * @param  {string|Function} [options.templates.footer] Footer template
                 * @param  {Function} [options.transformData.item] Function to change the object passed to the `item` template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when no items in the refinement list
                 * @param  {Object} [options.cssClasses] CSS classes to add to the wrapping elements
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.list] CSS class to add to the list element
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each item element
                 * @param  {string|string[]} [options.cssClasses.active] CSS class to add to each active element
                 * @param  {string|string[]} [options.cssClasses.label] CSS class to add to each label element (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.checkbox] CSS class to add to each checkbox element (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.count] CSS class to add to each count element (when using the default template)
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nrefinementList({\n  container,\n  attributeName,\n  [ operator='or' ],\n  [ sortBy=['count:desc', 'name:asc'] ],\n  [ limit=10 ],\n  [ cssClasses.{root, header, body, footer, list, item, active, label, checkbox, count}],\n  [ templates.{header,item,footer} ],\n  [ transformData.{item} ],\n  [ autoHideContainer=true ],\n  [ collapsible=false ],\n  [ showMore.{templates: {active, inactive}, limit} ],\n  [ collapsible=false ],\n  [ searchForFacetValues.{placeholder, templates: {noResults}}],\n})";
                function refinementList(_ref) {
                    var container = _ref.container,
                        attributeName = _ref.attributeName,
                        _ref$operator = _ref.operator,
                        operator =
                            _ref$operator === undefined ? "or" : _ref$operator,
                        _ref$sortBy = _ref.sortBy,
                        sortBy =
                            _ref$sortBy === undefined
                                ? ["count:desc", "name:asc"]
                                : _ref$sortBy,
                        _ref$limit = _ref.limit,
                        limit = _ref$limit === undefined ? 10 : _ref$limit,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        transformData = _ref.transformData,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        _ref$showMore = _ref.showMore,
                        showMore =
                            _ref$showMore === undefined ? false : _ref$showMore,
                        _ref$searchForFacetVa = _ref.searchForFacetValues,
                        searchForFacetValues =
                            _ref$searchForFacetVa === undefined
                                ? false
                                : _ref$searchForFacetVa;

                    var showMoreConfig = (0, _getShowMoreConfig2.default)(
                        showMore
                    );
                    if (showMoreConfig && showMoreConfig.limit < limit) {
                        throw new Error(
                            "showMore.limit configuration should be > than the limit in the main configuration"
                        ); // eslint-disable-line
                    }
                    var widgetMaxValuesPerFacet =
                        (showMoreConfig && showMoreConfig.limit) || limit;

                    var RefinementList = _RefinementList2.default;
                    if (!container || !attributeName) {
                        throw new Error(usage);
                    }

                    RefinementList = (0, _headerFooter2.default)(
                        RefinementList
                    );
                    if (autoHideContainer === true) {
                        RefinementList = (0, _autoHideContainer2.default)(
                            RefinementList
                        );
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);

                    if (operator) {
                        operator = operator.toLowerCase();
                        if (operator !== "and" && operator !== "or") {
                            throw new Error(usage);
                        }
                    }

                    var showMoreTemplates = showMoreConfig
                        ? (0, _utils.prefixKeys)(
                              "show-more-",
                              showMoreConfig.templates
                          )
                        : {};
                    var searchForValuesTemplates = searchForFacetValues
                        ? searchForFacetValues.templates
                        : {};
                    var allTemplates = _extends(
                        {},
                        templates,
                        showMoreTemplates,
                        searchForValuesTemplates
                    );

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        list: (0, _classnames2.default)(
                            bem("list"),
                            userCssClasses.list
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                        label: (0, _classnames2.default)(
                            bem("label"),
                            userCssClasses.label
                        ),
                        checkbox: (0, _classnames2.default)(
                            bem("checkbox"),
                            userCssClasses.checkbox
                        ),
                        count: (0, _classnames2.default)(
                            bem("count"),
                            userCssClasses.count
                        ),
                    };

                    /* eslint-disable max-params */
                    var _render = function _render(
                        facetValues,
                        state,
                        createURL,
                        helperSpecializedSearchFacetValues,
                        templateProps,
                        toggleRefinement,
                        isFromSearch
                    ) {
                        // Bind createURL to this specific attribute
                        function _createURL(facetValue) {
                            return createURL(
                                state.toggleRefinement(
                                    attributeName,
                                    facetValue
                                )
                            );
                        }

                        // Pass count of currently selected items to the header template
                        var refinedFacetsCount = (0, _filter2.default)(
                            facetValues,
                            { isRefined: true }
                        ).length;
                        var headerFooterData = {
                            header: { refinedFacetsCount: refinedFacetsCount },
                        };

                        // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                        // function
                        var searchFacetValues =
                            helperSpecializedSearchFacetValues &&
                            helperSpecializedSearchFacetValues(
                                state,
                                createURL,
                                helperSpecializedSearchFacetValues,
                                templateProps,
                                toggleRefinement
                            );

                        _reactDom2.default.render(
                            _react2.default.createElement(RefinementList, {
                                collapsible: collapsible,
                                createURL: _createURL,
                                cssClasses: cssClasses,
                                facetValues: facetValues,
                                headerFooterData: headerFooterData,
                                limitMax: widgetMaxValuesPerFacet,
                                limitMin: limit,
                                shouldAutoHideContainer:
                                    !isFromSearch && facetValues.length === 0,
                                showMore: showMoreConfig !== null,
                                templateProps: templateProps,
                                toggleRefinement: toggleRefinement,
                                searchFacetValues: searchFacetValues,
                                searchPlaceholder:
                                    searchForFacetValues.placeholder ||
                                    "Search for other...",
                                isFromSearch: isFromSearch,
                            }),
                            containerNode
                        );
                    };

                    var lastResultsFromMainSearch = null;

                    // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                    // function
                    var searchFacetValues = function searchFacetValues(helper) {
                        return function (
                            state,
                            createURL,
                            helperSpecializedSearchFacetValues,
                            templateProps,
                            toggleRefinement
                        ) {
                            return function (query) {
                                if (query === "" && lastResultsFromMainSearch) {
                                    // render with previous data from the helper.
                                    _render(
                                        lastResultsFromMainSearch,
                                        state,
                                        createURL,
                                        helperSpecializedSearchFacetValues,
                                        templateProps,
                                        toggleRefinement,
                                        false
                                    );
                                } else {
                                    helper
                                        .searchForFacetValues(
                                            attributeName,
                                            query
                                        )
                                        .then(function (results) {
                                            var facetValues =
                                                results.facetHits.map(function (
                                                    h
                                                ) {
                                                    h.name = h.value;
                                                    return h;
                                                });
                                            _render(
                                                facetValues,
                                                state,
                                                createURL,
                                                helperSpecializedSearchFacetValues,
                                                templateProps,
                                                toggleRefinement,
                                                true
                                            );
                                        });
                                }
                            };
                        };
                    };

                    return {
                        getConfiguration: function getConfiguration(
                            configuration
                        ) {
                            var widgetConfiguration = _defineProperty(
                                {},
                                operator === "and"
                                    ? "facets"
                                    : "disjunctiveFacets",
                                [attributeName]
                            );

                            var currentMaxValuesPerFacet =
                                configuration.maxValuesPerFacet || 0;
                            widgetConfiguration.maxValuesPerFacet = Math.max(
                                currentMaxValuesPerFacet,
                                widgetMaxValuesPerFacet
                            );

                            return widgetConfiguration;
                        },
                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig,
                                helper = _ref2.helper;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: allTemplates,
                            });

                            this.toggleRefinement = function (facetValue) {
                                return helper
                                    .toggleRefinement(attributeName, facetValue)
                                    .search();
                            };

                            this.searchFacetValues = searchForFacetValues
                                ? searchFacetValues(helper)
                                : null;
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var facetValues = results
                                .getFacetValues(attributeName, {
                                    sortBy: sortBy,
                                })
                                .map(function (h) {
                                    h.highlighted = h.name;
                                    return h;
                                });

                            lastResultsFromMainSearch = facetValues;

                            _render(
                                facetValues,
                                state,
                                createURL,
                                this.searchFacetValues,
                                this._templateProps,
                                this.toggleRefinement,
                                false
                            );
                        },
                    };
                }

                exports.default = refinementList;

                /***/
            },
            /* 553 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    header: "",
                    item: '<label class="{{cssClasses.label}}">\n  <input type="checkbox"\n         class="{{cssClasses.checkbox}}"\n         value="{{name}}"\n         {{#isRefined}}checked{{/isRefined}} />\n      {{{highlighted}}}\n  <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>\n</label>',
                    footer: "",
                };

                /***/
            },
            /* 554 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _find = __webpack_require__(240);

                var _find2 = _interopRequireDefault(_find);

                var _includes = __webpack_require__(268);

                var _includes2 = _interopRequireDefault(_includes);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _defaultTemplates = __webpack_require__(555);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _RefinementList = __webpack_require__(533);

                var _RefinementList2 = _interopRequireDefault(_RefinementList);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-refinement-list");

                /**
                 * Instantiate a list of refinements based on a facet
                 * @function numericRefinementList
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} options.attributeName Name of the attribute for filtering
                 * @param  {Object[]} options.options List of all the options
                 * @param  {string} options.options[].name Name of the option
                 * @param  {number} [options.options[].start] Low bound of the option (>=)
                 * @param  {number} [options.options[].end] High bound of the option (<=)
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header] Header template
                 * @param  {string|Function} [options.templates.item] Item template, provided with `name`, `isRefined`, `url` data properties
                 * @param  {string|Function} [options.templates.footer] Footer template
                 * @param  {Function} [options.transformData.item] Function to change the object passed to the `item` template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when no results match
                 * @param  {Object} [options.cssClasses] CSS classes to add to the wrapping elements
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.list] CSS class to add to the list element
                 * @param  {string|string[]} [options.cssClasses.label] CSS class to add to each link element
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each item element
                 * @param  {string|string[]} [options.cssClasses.radio] CSS class to add to each radio element (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.active] CSS class to add to each active element
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nnumericRefinementList({\n  container,\n  attributeName,\n  options,\n  [ cssClasses.{root,header,body,footer,list,item,active,label,radio,count} ],\n  [ templates.{header,item,footer} ],\n  [ transformData.{item} ],\n  [ autoHideContainer ],\n  [ collapsible=false ]\n})";
                function numericRefinementList(_ref) {
                    var container = _ref.container,
                        attributeName = _ref.attributeName,
                        options = _ref.options,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        transformData = _ref.transformData,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine;

                    if (!container || !attributeName || !options) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var RefinementList = (0, _headerFooter2.default)(
                        _RefinementList2.default
                    );
                    if (autoHideContainer === true) {
                        RefinementList = (0, _autoHideContainer2.default)(
                            RefinementList
                        );
                    }

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        list: (0, _classnames2.default)(
                            bem("list"),
                            userCssClasses.list
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        label: (0, _classnames2.default)(
                            bem("label"),
                            userCssClasses.label
                        ),
                        radio: (0, _classnames2.default)(
                            bem("radio"),
                            userCssClasses.radio
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                    };

                    return {
                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig,
                                helper = _ref2.helper;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });

                            this._toggleRefinement = function (facetValue) {
                                var refinedState = refine(
                                    helper.state,
                                    attributeName,
                                    options,
                                    facetValue
                                );
                                helper.setState(refinedState).search();
                            };
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var facetValues = options.map(function (
                                facetValue
                            ) {
                                return _extends({}, facetValue, {
                                    isRefined: isRefined(
                                        state,
                                        attributeName,
                                        facetValue
                                    ),
                                    attributeName: attributeName,
                                });
                            });

                            // Bind createURL to this specific attribute
                            function _createURL(facetValue) {
                                return createURL(
                                    refine(
                                        state,
                                        attributeName,
                                        options,
                                        facetValue
                                    )
                                );
                            }

                            _reactDom2.default.render(
                                _react2.default.createElement(RefinementList, {
                                    collapsible: collapsible,
                                    createURL: _createURL,
                                    cssClasses: cssClasses,
                                    facetValues: facetValues,
                                    shouldAutoHideContainer:
                                        results.nbHits === 0,
                                    templateProps: this._templateProps,
                                    toggleRefinement: this._toggleRefinement,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                function isRefined(state, attributeName, option) {
                    var currentRefinements =
                        state.getNumericRefinements(attributeName);

                    if (
                        option.start !== undefined &&
                        option.end !== undefined
                    ) {
                        if (option.start === option.end) {
                            return hasNumericRefinement(
                                currentRefinements,
                                "=",
                                option.start
                            );
                        }
                    }

                    if (option.start !== undefined) {
                        return hasNumericRefinement(
                            currentRefinements,
                            ">=",
                            option.start
                        );
                    }

                    if (option.end !== undefined) {
                        return hasNumericRefinement(
                            currentRefinements,
                            "<=",
                            option.end
                        );
                    }

                    if (
                        option.start === undefined &&
                        option.end === undefined
                    ) {
                        return Object.keys(currentRefinements).length === 0;
                    }

                    return undefined;
                }

                function refine(state, attributeName, options, facetValue) {
                    var resolvedState = state;

                    var refinedOption = (0, _find2.default)(options, {
                        name: facetValue,
                    });

                    var currentRefinements =
                        resolvedState.getNumericRefinements(attributeName);

                    if (
                        refinedOption.start === undefined &&
                        refinedOption.end === undefined
                    ) {
                        return resolvedState.clearRefinements(attributeName);
                    }

                    if (
                        !isRefined(resolvedState, attributeName, refinedOption)
                    ) {
                        resolvedState =
                            resolvedState.clearRefinements(attributeName);
                    }

                    if (
                        refinedOption.start !== undefined &&
                        refinedOption.end !== undefined
                    ) {
                        if (refinedOption.start > refinedOption.end) {
                            throw new Error(
                                "option.start should be > to option.end"
                            );
                        }

                        if (refinedOption.start === refinedOption.end) {
                            if (
                                hasNumericRefinement(
                                    currentRefinements,
                                    "=",
                                    refinedOption.start
                                )
                            ) {
                                resolvedState =
                                    resolvedState.removeNumericRefinement(
                                        attributeName,
                                        "=",
                                        refinedOption.start
                                    );
                            } else {
                                resolvedState =
                                    resolvedState.addNumericRefinement(
                                        attributeName,
                                        "=",
                                        refinedOption.start
                                    );
                            }
                            return resolvedState;
                        }
                    }

                    if (refinedOption.start !== undefined) {
                        if (
                            hasNumericRefinement(
                                currentRefinements,
                                ">=",
                                refinedOption.start
                            )
                        ) {
                            resolvedState =
                                resolvedState.removeNumericRefinement(
                                    attributeName,
                                    ">=",
                                    refinedOption.start
                                );
                        } else {
                            resolvedState = resolvedState.addNumericRefinement(
                                attributeName,
                                ">=",
                                refinedOption.start
                            );
                        }
                    }

                    if (refinedOption.end !== undefined) {
                        if (
                            hasNumericRefinement(
                                currentRefinements,
                                "<=",
                                refinedOption.end
                            )
                        ) {
                            resolvedState =
                                resolvedState.removeNumericRefinement(
                                    attributeName,
                                    "<=",
                                    refinedOption.end
                                );
                        } else {
                            resolvedState = resolvedState.addNumericRefinement(
                                attributeName,
                                "<=",
                                refinedOption.end
                            );
                        }
                    }

                    return resolvedState;
                }

                function hasNumericRefinement(
                    currentRefinements,
                    operator,
                    value
                ) {
                    var hasOperatorRefinements =
                        currentRefinements[operator] !== undefined;
                    var includesValue = (0, _includes2.default)(
                        currentRefinements[operator],
                        value
                    );

                    return hasOperatorRefinements && includesValue;
                }

                exports.default = numericRefinementList;

                /***/
            },
            /* 555 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                /* eslint-disable max-len */
                exports.default = {
                    header: "",
                    item: '<label class="{{cssClasses.label}}">\n  <input type="radio" class="{{cssClasses.radio}}" name="{{attributeName}}" {{#isRefined}}checked{{/isRefined}} />{{name}}\n</label>',
                    footer: "",
                };

                /***/
            },
            /* 556 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _Selector = __webpack_require__(544);

                var _Selector2 = _interopRequireDefault(_Selector);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _defineProperty(obj, key, value) {
                    if (key in obj) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true,
                        });
                    } else {
                        obj[key] = value;
                    }
                    return obj;
                }

                var bem = (0, _utils.bemHelper)("ais-numeric-selector");

                /**
                 * Instantiate a dropdown element to choose the number of hits to display per page
                 * @function numericSelector
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} options.attributeName Name of the numeric attribute to use
                 * @param  {Array} options.options Array of objects defining the different values and labels
                 * @param  {number} options.options[i].value The numerical value to refine with
                 * @param  {string} options.options[i].label Label to display in the option
                 * @param  {string} [options.operator='='] The operator to use to refine
                 * @param  {boolean} [options.autoHideContainer=false] Hide the container when no results match
                 * @param  {Object} [options.cssClasses] CSS classes to be added
                 * @param  {string|string[]} [options.cssClasses.root] CSS classes added to the parent `<select>`
                 * @param  {string|string[]} [options.cssClasses.item] CSS classes added to each `<option>`
                 * @return {Object}
                 */

                function numericSelector(_ref) {
                    var container = _ref.container,
                        _ref$operator = _ref.operator,
                        operator =
                            _ref$operator === undefined ? "=" : _ref$operator,
                        attributeName = _ref.attributeName,
                        options = _ref.options,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? false
                                : _ref$autoHideContaine;

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var usage =
                        "Usage: numericSelector({\n    container,\n    attributeName,\n    options,\n    cssClasses.{root,item},\n    autoHideContainer\n  })";

                    var Selector = _Selector2.default;
                    if (autoHideContainer === true) {
                        Selector = (0, _autoHideContainer2.default)(Selector);
                    }

                    if (
                        !container ||
                        !options ||
                        options.length === 0 ||
                        !attributeName
                    ) {
                        throw new Error(usage);
                    }

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                    };

                    return {
                        getConfiguration: function getConfiguration(
                            currentSearchParameters,
                            searchParametersFromUrl
                        ) {
                            return {
                                numericRefinements: _defineProperty(
                                    {},
                                    attributeName,
                                    _defineProperty({}, operator, [
                                        this._getRefinedValue(
                                            searchParametersFromUrl
                                        ),
                                    ])
                                ),
                            };
                        },
                        init: function init(_ref2) {
                            var helper = _ref2.helper;

                            this._refine = function (value) {
                                helper.clearRefinements(attributeName);
                                if (value !== undefined) {
                                    helper.addNumericRefinement(
                                        attributeName,
                                        operator,
                                        value
                                    );
                                }
                                helper.search();
                            };
                        },
                        render: function render(_ref3) {
                            var helper = _ref3.helper,
                                results = _ref3.results;

                            _reactDom2.default.render(
                                _react2.default.createElement(Selector, {
                                    cssClasses: cssClasses,
                                    currentValue: this._getRefinedValue(
                                        helper.state
                                    ),
                                    options: options,
                                    setValue: this._refine,
                                    shouldAutoHideContainer:
                                        results.nbHits === 0,
                                }),
                                containerNode
                            );
                        },
                        _getRefinedValue: function _getRefinedValue(state) {
                            // This is reimplementing state.getNumericRefinement
                            // But searchParametersFromUrl is not an actual SearchParameters object
                            // It's only the object structure without the methods, because getStateFromQueryString
                            // is not sending a SearchParameters. There's no way given how web built the helper
                            // to initialize a true partial state where only the refinements are present
                            return state &&
                                state.numericRefinements &&
                                state.numericRefinements[attributeName] !==
                                    undefined &&
                                state.numericRefinements[attributeName][
                                    operator
                                ] !== undefined &&
                                state.numericRefinements[attributeName][
                                    operator
                                ][0] !== undefined // could be 0
                                ? state.numericRefinements[attributeName][
                                      operator
                                  ][0]
                                : options[0].value;
                        },
                    };
                }

                exports.default = numericSelector;

                /***/
            },
            /* 557 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _defaults = __webpack_require__(251);

                var _defaults2 = _interopRequireDefault(_defaults);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _utils = __webpack_require__(514);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _Pagination = __webpack_require__(558);

                var _Pagination2 = _interopRequireDefault(_Pagination);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var defaultLabels = {
                    previous: "‹",
                    next: "›",
                    first: "«",
                    last: "»",
                };
                var bem = (0, _utils.bemHelper)("ais-pagination");

                /**
                 * Add a pagination menu to navigate through the results
                 * @function pagination
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {Object} [options.labels] Text to display in the various links (prev, next, first, last)
                 * @param  {string} [options.labels.previous] Label for the Previous link
                 * @param  {string} [options.labels.next] Label for the Next link
                 * @param  {string} [options.labels.first] Label for the First link
                 * @param  {string} [options.labels.last] Label for the Last link
                 * @param  {number} [options.maxPages] The max number of pages to browse
                 * @param  {number} [options.padding=3] The number of pages to display on each side of the current page
                 * @param  {string|DOMElement|boolean} [options.scrollTo='body'] Where to scroll after a click, set to `false` to disable
                 * @param  {boolean} [options.showFirstLast=true] Define if the First and Last links should be displayed
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when no results match
                 * @param  {Object} [options.cssClasses] CSS classes to be added
                 * @param  {string|string[]} [options.cssClasses.root] CSS classes added to the parent `<ul>`
                 * @param  {string|string[]} [options.cssClasses.item] CSS classes added to each `<li>`
                 * @param  {string|string[]} [options.cssClasses.link] CSS classes added to each link
                 * @param  {string|string[]} [options.cssClasses.page] CSS classes added to page `<li>`
                 * @param  {string|string[]} [options.cssClasses.previous] CSS classes added to the previous `<li>`
                 * @param  {string|string[]} [options.cssClasses.next] CSS classes added to the next `<li>`
                 * @param  {string|string[]} [options.cssClasses.first] CSS classes added to the first `<li>`
                 * @param  {string|string[]} [options.cssClasses.last] CSS classes added to the last `<li>`
                 * @param  {string|string[]} [options.cssClasses.active] CSS classes added to the active `<li>`
                 * @param  {string|string[]} [options.cssClasses.disabled] CSS classes added to the disabled `<li>`
                 * @return {Object}
                 */
                var usage =
                    "Usage:\npagination({\n  container,\n  [ cssClasses.{root,item,page,previous,next,first,last,active,disabled}={} ],\n  [ labels.{previous,next,first,last} ],\n  [ maxPages ],\n  [ padding=3 ],\n  [ showFirstLast=true ],\n  [ autoHideContainer=true ],\n  [ scrollTo='body' ]\n})";
                function pagination() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$labels = _ref.labels,
                        userLabels =
                            _ref$labels === undefined ? {} : _ref$labels,
                        maxPages = _ref.maxPages,
                        _ref$padding = _ref.padding,
                        padding = _ref$padding === undefined ? 3 : _ref$padding,
                        _ref$showFirstLast = _ref.showFirstLast,
                        showFirstLast =
                            _ref$showFirstLast === undefined
                                ? true
                                : _ref$showFirstLast,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        _ref$scrollTo = _ref.scrollTo,
                        userScrollTo =
                            _ref$scrollTo === undefined
                                ? "body"
                                : _ref$scrollTo;

                    var scrollTo = userScrollTo;

                    if (!container) {
                        throw new Error(usage);
                    }

                    if (scrollTo === true) {
                        scrollTo = "body";
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var scrollToNode =
                        scrollTo !== false
                            ? (0, _utils.getContainerNode)(scrollTo)
                            : false;
                    var Pagination = _Pagination2.default;
                    if (autoHideContainer === true) {
                        Pagination = (0, _autoHideContainer2.default)(
                            Pagination
                        );
                    }

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        link: (0, _classnames2.default)(
                            bem("link"),
                            userCssClasses.link
                        ),
                        page: (0, _classnames2.default)(
                            bem("item", "page"),
                            userCssClasses.page
                        ),
                        previous: (0, _classnames2.default)(
                            bem("item", "previous"),
                            userCssClasses.previous
                        ),
                        next: (0, _classnames2.default)(
                            bem("item", "next"),
                            userCssClasses.next
                        ),
                        first: (0, _classnames2.default)(
                            bem("item", "first"),
                            userCssClasses.first
                        ),
                        last: (0, _classnames2.default)(
                            bem("item", "last"),
                            userCssClasses.last
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                        disabled: (0, _classnames2.default)(
                            bem("item", "disabled"),
                            userCssClasses.disabled
                        ),
                    };

                    var labels = (0, _defaults2.default)(
                        userLabels,
                        defaultLabels
                    );

                    return {
                        init: function init(_ref2) {
                            var helper = _ref2.helper;

                            this.setCurrentPage = function (page) {
                                helper.setCurrentPage(page);
                                if (scrollToNode !== false) {
                                    scrollToNode.scrollIntoView();
                                }
                                helper.search();
                            };
                        },
                        getMaxPage: function getMaxPage(results) {
                            if (maxPages !== undefined) {
                                return Math.min(maxPages, results.nbPages);
                            }
                            return results.nbPages;
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                state = _ref3.state,
                                _createURL = _ref3.createURL;

                            _reactDom2.default.render(
                                _react2.default.createElement(Pagination, {
                                    createURL: function createURL(page) {
                                        return _createURL(state.setPage(page));
                                    },
                                    cssClasses: cssClasses,
                                    currentPage: results.page,
                                    labels: labels,
                                    nbHits: results.nbHits,
                                    nbPages: this.getMaxPage(results),
                                    padding: padding,
                                    setCurrentPage: this.setCurrentPage,
                                    shouldAutoHideContainer:
                                        results.nbHits === 0,
                                    showFirstLast: showFirstLast,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = pagination;

                /***/
            },
            /* 558 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _forEach = __webpack_require__(129);

                var _forEach2 = _interopRequireDefault(_forEach);

                var _defaultsDeep = __webpack_require__(559);

                var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

                var _utils = __webpack_require__(514);

                var _Paginator = __webpack_require__(561);

                var _Paginator2 = _interopRequireDefault(_Paginator);

                var _PaginationLink = __webpack_require__(565);

                var _PaginationLink2 = _interopRequireDefault(_PaginationLink);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var Pagination = (function (_React$Component) {
                    _inherits(Pagination, _React$Component);

                    function Pagination(props) {
                        _classCallCheck(this, Pagination);

                        var _this = _possibleConstructorReturn(
                            this,
                            (
                                Pagination.__proto__ ||
                                Object.getPrototypeOf(Pagination)
                            ).call(
                                this,
                                (0, _defaultsDeep2.default)(
                                    props,
                                    Pagination.defaultProps
                                )
                            )
                        );

                        _this.handleClick = _this.handleClick.bind(_this);
                        return _this;
                    }

                    _createClass(Pagination, [
                        {
                            key: "pageLink",
                            value: function pageLink(_ref) {
                                var label = _ref.label,
                                    ariaLabel = _ref.ariaLabel,
                                    pageNumber = _ref.pageNumber,
                                    _ref$additionalClassN =
                                        _ref.additionalClassName,
                                    additionalClassName =
                                        _ref$additionalClassN === undefined
                                            ? null
                                            : _ref$additionalClassN,
                                    _ref$isDisabled = _ref.isDisabled,
                                    isDisabled =
                                        _ref$isDisabled === undefined
                                            ? false
                                            : _ref$isDisabled,
                                    _ref$isActive = _ref.isActive,
                                    isActive =
                                        _ref$isActive === undefined
                                            ? false
                                            : _ref$isActive,
                                    createURL = _ref.createURL;

                                var cssClasses = {
                                    item: (0, _classnames2.default)(
                                        this.props.cssClasses.item,
                                        additionalClassName
                                    ),
                                    link: (0, _classnames2.default)(
                                        this.props.cssClasses.link
                                    ),
                                };
                                if (isDisabled) {
                                    cssClasses.item = (0, _classnames2.default)(
                                        cssClasses.item,
                                        this.props.cssClasses.disabled
                                    );
                                } else if (isActive) {
                                    cssClasses.item = (0, _classnames2.default)(
                                        cssClasses.item,
                                        this.props.cssClasses.active
                                    );
                                }

                                var url =
                                    createURL && !isDisabled
                                        ? createURL(pageNumber)
                                        : "#";

                                return _react2.default.createElement(
                                    _PaginationLink2.default,
                                    {
                                        ariaLabel: ariaLabel,
                                        cssClasses: cssClasses,
                                        handleClick: this.handleClick,
                                        isDisabled: isDisabled,
                                        key: label + pageNumber,
                                        label: label,
                                        pageNumber: pageNumber,
                                        url: url,
                                    }
                                );
                            },
                        },
                        {
                            key: "previousPageLink",
                            value: function previousPageLink(pager, createURL) {
                                return this.pageLink({
                                    ariaLabel: "Previous",
                                    additionalClassName:
                                        this.props.cssClasses.previous,
                                    isDisabled: pager.isFirstPage(),
                                    label: this.props.labels.previous,
                                    pageNumber: pager.currentPage - 1,
                                    createURL: createURL,
                                });
                            },
                        },
                        {
                            key: "nextPageLink",
                            value: function nextPageLink(pager, createURL) {
                                return this.pageLink({
                                    ariaLabel: "Next",
                                    additionalClassName:
                                        this.props.cssClasses.next,
                                    isDisabled: pager.isLastPage(),
                                    label: this.props.labels.next,
                                    pageNumber: pager.currentPage + 1,
                                    createURL: createURL,
                                });
                            },
                        },
                        {
                            key: "firstPageLink",
                            value: function firstPageLink(pager, createURL) {
                                return this.pageLink({
                                    ariaLabel: "First",
                                    additionalClassName:
                                        this.props.cssClasses.first,
                                    isDisabled: pager.isFirstPage(),
                                    label: this.props.labels.first,
                                    pageNumber: 0,
                                    createURL: createURL,
                                });
                            },
                        },
                        {
                            key: "lastPageLink",
                            value: function lastPageLink(pager, createURL) {
                                return this.pageLink({
                                    ariaLabel: "Last",
                                    additionalClassName:
                                        this.props.cssClasses.last,
                                    isDisabled: pager.isLastPage(),
                                    label: this.props.labels.last,
                                    pageNumber: pager.total - 1,
                                    createURL: createURL,
                                });
                            },
                        },
                        {
                            key: "pages",
                            value: function pages(pager, createURL) {
                                var _this2 = this;

                                var pages = [];

                                (0, _forEach2.default)(
                                    pager.pages(),
                                    function (pageNumber) {
                                        var isActive =
                                            pageNumber === pager.currentPage;

                                        pages.push(
                                            _this2.pageLink({
                                                ariaLabel: pageNumber + 1,
                                                additionalClassName:
                                                    _this2.props.cssClasses
                                                        .page,
                                                isActive: isActive,
                                                label: pageNumber + 1,
                                                pageNumber: pageNumber,
                                                createURL: createURL,
                                            })
                                        );
                                    }
                                );

                                return pages;
                            },
                        },
                        {
                            key: "handleClick",
                            value: function handleClick(pageNumber, event) {
                                if ((0, _utils.isSpecialClick)(event)) {
                                    // do not alter the default browser behavior
                                    // if one special key is down
                                    return;
                                }
                                event.preventDefault();
                                this.props.setCurrentPage(pageNumber);
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var pager = new _Paginator2.default({
                                    currentPage: this.props.currentPage,
                                    total: this.props.nbPages,
                                    padding: this.props.padding,
                                });

                                var createURL = this.props.createURL;

                                return _react2.default.createElement(
                                    "ul",
                                    { className: this.props.cssClasses.root },
                                    this.props.showFirstLast
                                        ? this.firstPageLink(pager, createURL)
                                        : null,
                                    this.previousPageLink(pager, createURL),
                                    this.pages(pager, createURL),
                                    this.nextPageLink(pager, createURL),
                                    this.props.showFirstLast
                                        ? this.lastPageLink(pager, createURL)
                                        : null
                                );
                            },
                        },
                    ]);

                    return Pagination;
                })(_react2.default.Component);

                Pagination.defaultProps = {
                    nbHits: 0,
                    currentPage: 0,
                    nbPages: 0,
                };

                exports.default = Pagination;

                /***/
            },
            /* 559 */
            /***/ function (module, exports, __webpack_require__) {
                var apply = __webpack_require__(116),
                    baseRest = __webpack_require__(113),
                    customDefaultsMerge = __webpack_require__(560),
                    mergeWith = __webpack_require__(338);

                /**
                 * This method is like `_.defaults` except that it recursively assigns
                 * default properties.
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.10.0
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} [sources] The source objects.
                 * @returns {Object} Returns `object`.
                 * @see _.defaults
                 * @example
                 *
                 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
                 * // => { 'a': { 'b': 2, 'c': 3 } }
                 */
                var defaultsDeep = baseRest(function (args) {
                    args.push(undefined, customDefaultsMerge);
                    return apply(mergeWith, undefined, args);
                });

                module.exports = defaultsDeep;

                /***/
            },
            /* 560 */
            /***/ function (module, exports, __webpack_require__) {
                var baseMerge = __webpack_require__(257),
                    isObject = __webpack_require__(69);

                /**
                 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
                 * objects into destination objects that are passed thru.
                 *
                 * @private
                 * @param {*} objValue The destination value.
                 * @param {*} srcValue The source value.
                 * @param {string} key The key of the property to merge.
                 * @param {Object} object The parent object of `objValue`.
                 * @param {Object} source The parent object of `srcValue`.
                 * @param {Object} [stack] Tracks traversed source values and their merged
                 *  counterparts.
                 * @returns {*} Returns the value to assign.
                 */
                function customDefaultsMerge(
                    objValue,
                    srcValue,
                    key,
                    object,
                    source,
                    stack
                ) {
                    if (isObject(objValue) && isObject(srcValue)) {
                        // Recursively merge objects and arrays (susceptible to call stack limits).
                        stack.set(srcValue, objValue);
                        baseMerge(
                            objValue,
                            srcValue,
                            undefined,
                            customDefaultsMerge,
                            stack
                        );
                        stack["delete"](srcValue);
                    }
                    return objValue;
                }

                module.exports = customDefaultsMerge;

                /***/
            },
            /* 561 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _range = __webpack_require__(562);

                var _range2 = _interopRequireDefault(_range);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                var Paginator = (function () {
                    function Paginator(params) {
                        _classCallCheck(this, Paginator);

                        this.currentPage = params.currentPage;
                        this.total = params.total;
                        this.padding = params.padding;
                    }

                    _createClass(Paginator, [
                        {
                            key: "pages",
                            value: function pages() {
                                var total = this.total,
                                    currentPage = this.currentPage,
                                    padding = this.padding;

                                var totalDisplayedPages = this.nbPagesDisplayed(
                                    padding,
                                    total
                                );
                                if (totalDisplayedPages === total)
                                    return (0, _range2.default)(0, total);

                                var paddingLeft = this.calculatePaddingLeft(
                                    currentPage,
                                    padding,
                                    total,
                                    totalDisplayedPages
                                );
                                var paddingRight =
                                    totalDisplayedPages - paddingLeft;

                                var first = currentPage - paddingLeft;
                                var last = currentPage + paddingRight;

                                return (0, _range2.default)(first, last);
                            },
                        },
                        {
                            key: "nbPagesDisplayed",
                            value: function nbPagesDisplayed(padding, total) {
                                return Math.min(2 * padding + 1, total);
                            },
                        },
                        {
                            key: "calculatePaddingLeft",
                            value: function calculatePaddingLeft(
                                current,
                                padding,
                                total,
                                totalDisplayedPages
                            ) {
                                if (current <= padding) {
                                    return current;
                                }

                                if (current >= total - padding) {
                                    return (
                                        totalDisplayedPages - (total - current)
                                    );
                                }

                                return padding;
                            },
                        },
                        {
                            key: "isLastPage",
                            value: function isLastPage() {
                                return this.currentPage === this.total - 1;
                            },
                        },
                        {
                            key: "isFirstPage",
                            value: function isFirstPage() {
                                return this.currentPage === 0;
                            },
                        },
                    ]);

                    return Paginator;
                })();

                exports.default = Paginator;

                /***/
            },
            /* 562 */
            /***/ function (module, exports, __webpack_require__) {
                var createRange = __webpack_require__(563);

                /**
                 * Creates an array of numbers (positive and/or negative) progressing from
                 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
                 * `start` is specified without an `end` or `step`. If `end` is not specified,
                 * it's set to `start` with `start` then set to `0`.
                 *
                 * **Note:** JavaScript follows the IEEE-754 standard for resolving
                 * floating-point values which can produce unexpected results.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Util
                 * @param {number} [start=0] The start of the range.
                 * @param {number} end The end of the range.
                 * @param {number} [step=1] The value to increment or decrement by.
                 * @returns {Array} Returns the range of numbers.
                 * @see _.inRange, _.rangeRight
                 * @example
                 *
                 * _.range(4);
                 * // => [0, 1, 2, 3]
                 *
                 * _.range(-4);
                 * // => [0, -1, -2, -3]
                 *
                 * _.range(1, 5);
                 * // => [1, 2, 3, 4]
                 *
                 * _.range(0, 20, 5);
                 * // => [0, 5, 10, 15]
                 *
                 * _.range(0, -4, -1);
                 * // => [0, -1, -2, -3]
                 *
                 * _.range(1, 4, 0);
                 * // => [1, 1, 1]
                 *
                 * _.range(0);
                 * // => []
                 */
                var range = createRange();

                module.exports = range;

                /***/
            },
            /* 563 */
            /***/ function (module, exports, __webpack_require__) {
                var baseRange = __webpack_require__(564),
                    isIterateeCall = __webpack_require__(254),
                    toFinite = __webpack_require__(232);

                /**
                 * Creates a `_.range` or `_.rangeRight` function.
                 *
                 * @private
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Function} Returns the new range function.
                 */
                function createRange(fromRight) {
                    return function (start, end, step) {
                        if (
                            step &&
                            typeof step != "number" &&
                            isIterateeCall(start, end, step)
                        ) {
                            end = step = undefined;
                        }
                        // Ensure the sign of `-0` is preserved.
                        start = toFinite(start);
                        if (end === undefined) {
                            end = start;
                            start = 0;
                        } else {
                            end = toFinite(end);
                        }
                        step =
                            step === undefined
                                ? start < end
                                    ? 1
                                    : -1
                                : toFinite(step);
                        return baseRange(start, end, step, fromRight);
                    };
                }

                module.exports = createRange;

                /***/
            },
            /* 564 */
            /***/ function (module, exports) {
                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeCeil = Math.ceil,
                    nativeMax = Math.max;

                /**
                 * The base implementation of `_.range` and `_.rangeRight` which doesn't
                 * coerce arguments.
                 *
                 * @private
                 * @param {number} start The start of the range.
                 * @param {number} end The end of the range.
                 * @param {number} step The value to increment or decrement by.
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Array} Returns the range of numbers.
                 */
                function baseRange(start, end, step, fromRight) {
                    var index = -1,
                        length = nativeMax(
                            nativeCeil((end - start) / (step || 1)),
                            0
                        ),
                        result = Array(length);

                    while (length--) {
                        result[fromRight ? length : ++index] = start;
                        start += step;
                    }
                    return result;
                }

                module.exports = baseRange;

                /***/
            },
            /* 565 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var PaginationLink = (function (_React$Component) {
                    _inherits(PaginationLink, _React$Component);

                    function PaginationLink() {
                        _classCallCheck(this, PaginationLink);

                        return _possibleConstructorReturn(
                            this,
                            (
                                PaginationLink.__proto__ ||
                                Object.getPrototypeOf(PaginationLink)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(PaginationLink, [
                        {
                            key: "componentWillMount",
                            value: function componentWillMount() {
                                this.handleClick = this.handleClick.bind(this);
                            },
                        },
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return !(0, _isEqual2.default)(
                                    this.props,
                                    nextProps
                                );
                            },
                        },
                        {
                            key: "handleClick",
                            value: function handleClick(e) {
                                this.props.handleClick(
                                    this.props.pageNumber,
                                    e
                                );
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _props = this.props,
                                    cssClasses = _props.cssClasses,
                                    label = _props.label,
                                    ariaLabel = _props.ariaLabel,
                                    url = _props.url,
                                    isDisabled = _props.isDisabled;

                                var tagName = "span";
                                var attributes = {
                                    className: cssClasses.link,
                                    dangerouslySetInnerHTML: {
                                        __html: label,
                                    },
                                };

                                // "Enable" the element, by making it a link
                                if (!isDisabled) {
                                    tagName = "a";
                                    attributes = _extends({}, attributes, {
                                        "aria-label": ariaLabel,
                                        "href": url,
                                        "onClick": this.handleClick,
                                    });
                                }

                                var element = _react2.default.createElement(
                                    tagName,
                                    attributes
                                );

                                return _react2.default.createElement(
                                    "li",
                                    { className: cssClasses.item },
                                    element
                                );
                            },
                        },
                    ]);

                    return PaginationLink;
                })(_react2.default.Component);

                exports.default = PaginationLink;

                /***/
            },
            /* 566 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _generateRanges2 = __webpack_require__(567);

                var _generateRanges3 = _interopRequireDefault(_generateRanges2);

                var _defaultTemplates = __webpack_require__(568);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _PriceRanges = __webpack_require__(569);

                var _PriceRanges2 = _interopRequireDefault(_PriceRanges);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-price-ranges");

                /**
                 * Instantiate a price ranges on a numerical facet
                 * @function priceRanges
                 * @param  {string|DOMElement} options.container Valid CSS Selector as a string or DOMElement
                 * @param  {string} options.attributeName Name of the attribute for faceting
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.item] Item template. Template data: `from`, `to` and `currency`
                 * @param  {string} [options.currency='$'] The currency to display
                 * @param  {Object} [options.labels] Labels to use for the widget
                 * @param  {string|Function} [options.labels.separator] Separator label, between min and max
                 * @param  {string|Function} [options.labels.button] Button label
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when no refinements available
                 * @param  {Object} [options.cssClasses] CSS classes to add
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.list] CSS class to add to the wrapping list element
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each item element
                 * @param  {string|string[]} [options.cssClasses.active] CSS class to add to the active item element
                 * @param  {string|string[]} [options.cssClasses.link] CSS class to add to each link element
                 * @param  {string|string[]} [options.cssClasses.form] CSS class to add to the form element
                 * @param  {string|string[]} [options.cssClasses.label] CSS class to add to each wrapping label of the form
                 * @param  {string|string[]} [options.cssClasses.input] CSS class to add to each input of the form
                 * @param  {string|string[]} [options.cssClasses.currency] CSS class to add to each currency element of the form
                 * @param  {string|string[]} [options.cssClasses.separator] CSS class to add to the separator of the form
                 * @param  {string|string[]} [options.cssClasses.button] CSS class to add to the submit button of the form
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\npriceRanges({\n  container,\n  attributeName,\n  [ currency=$ ],\n  [ cssClasses.{root,header,body,list,item,active,link,form,label,input,currency,separator,button,footer} ],\n  [ templates.{header,item,footer} ],\n  [ labels.{currency,separator,button} ],\n  [ autoHideContainer=true ],\n  [ collapsible=false ]\n})";
                function priceRanges() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        attributeName = _ref.attributeName,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        _ref$labels = _ref.labels,
                        userLabels =
                            _ref$labels === undefined ? {} : _ref$labels,
                        _ref$currency = _ref.currency,
                        userCurrency =
                            _ref$currency === undefined ? "$" : _ref$currency,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine;

                    var currency = userCurrency;

                    if (!container || !attributeName) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var PriceRanges = (0, _headerFooter2.default)(
                        _PriceRanges2.default
                    );
                    if (autoHideContainer === true) {
                        PriceRanges = (0, _autoHideContainer2.default)(
                            PriceRanges
                        );
                    }

                    var labels = _extends(
                        {
                            button: "Go",
                            separator: "to",
                        },
                        userLabels
                    );

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        list: (0, _classnames2.default)(
                            bem("list"),
                            userCssClasses.list
                        ),
                        link: (0, _classnames2.default)(
                            bem("link"),
                            userCssClasses.link
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                        form: (0, _classnames2.default)(
                            bem("form"),
                            userCssClasses.form
                        ),
                        label: (0, _classnames2.default)(
                            bem("label"),
                            userCssClasses.label
                        ),
                        input: (0, _classnames2.default)(
                            bem("input"),
                            userCssClasses.input
                        ),
                        currency: (0, _classnames2.default)(
                            bem("currency"),
                            userCssClasses.currency
                        ),
                        button: (0, _classnames2.default)(
                            bem("button"),
                            userCssClasses.button
                        ),
                        separator: (0, _classnames2.default)(
                            bem("separator"),
                            userCssClasses.separator
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                    };

                    // before we had opts.currency, you had to pass labels.currency
                    if (
                        userLabels.currency !== undefined &&
                        userLabels.currency !== currency
                    )
                        currency = userLabels.currency;

                    return {
                        getConfiguration: function getConfiguration() {
                            return {
                                facets: [attributeName],
                            };
                        },

                        _generateRanges: function _generateRanges(results) {
                            var stats = results.getFacetStats(attributeName);
                            return (0, _generateRanges3.default)(stats);
                        },
                        _extractRefinedRange: function _extractRefinedRange(
                            helper
                        ) {
                            var refinements =
                                helper.getRefinements(attributeName);
                            var from = void 0;
                            var to = void 0;

                            if (refinements.length === 0) {
                                return [];
                            }

                            refinements.forEach(function (v) {
                                if (v.operator.indexOf(">") !== -1) {
                                    from = Math.floor(v.value[0]);
                                } else if (v.operator.indexOf("<") !== -1) {
                                    to = Math.ceil(v.value[0]);
                                }
                            });
                            return [{ from: from, to: to, isRefined: true }];
                        },
                        _refine: function _refine(helper, from, to) {
                            var facetValues = this._extractRefinedRange(helper);

                            helper.clearRefinements(attributeName);
                            if (
                                facetValues.length === 0 ||
                                facetValues[0].from !== from ||
                                facetValues[0].to !== to
                            ) {
                                if (typeof from !== "undefined") {
                                    helper.addNumericRefinement(
                                        attributeName,
                                        ">=",
                                        Math.floor(from)
                                    );
                                }
                                if (typeof to !== "undefined") {
                                    helper.addNumericRefinement(
                                        attributeName,
                                        "<=",
                                        Math.ceil(to)
                                    );
                                }
                            }

                            helper.search();
                        },
                        init: function init(_ref2) {
                            var helper = _ref2.helper,
                                templatesConfig = _ref2.templatesConfig;

                            this._refine = this._refine.bind(this, helper);
                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                helper = _ref3.helper,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var facetValues = void 0;

                            if (results.hits.length > 0) {
                                facetValues = this._extractRefinedRange(helper);

                                if (facetValues.length === 0) {
                                    facetValues = this._generateRanges(results);
                                }
                            } else {
                                facetValues = [];
                            }

                            facetValues.map(function (facetValue) {
                                var newState =
                                    state.clearRefinements(attributeName);
                                if (!facetValue.isRefined) {
                                    if (facetValue.from !== undefined) {
                                        newState =
                                            newState.addNumericRefinement(
                                                attributeName,
                                                ">=",
                                                Math.floor(facetValue.from)
                                            );
                                    }
                                    if (facetValue.to !== undefined) {
                                        newState =
                                            newState.addNumericRefinement(
                                                attributeName,
                                                "<=",
                                                Math.ceil(facetValue.to)
                                            );
                                    }
                                }
                                facetValue.url = createURL(newState);
                                return facetValue;
                            });

                            _reactDom2.default.render(
                                _react2.default.createElement(PriceRanges, {
                                    collapsible: collapsible,
                                    cssClasses: cssClasses,
                                    currency: currency,
                                    facetValues: facetValues,
                                    labels: labels,
                                    refine: this._refine,
                                    shouldAutoHideContainer:
                                        facetValues.length === 0,
                                    templateProps: this._templateProps,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = priceRanges;

                /***/
            },
            /* 567 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                function round(v, precision) {
                    var res = Math.round(v / precision) * precision;
                    if (res < 1) {
                        res = 1;
                    }
                    return res;
                }

                function generateRanges(stats) {
                    // cannot compute any range
                    if (stats.min === stats.max) {
                        return [];
                    }

                    var precision = void 0;
                    if (stats.avg < 100) {
                        precision = 1;
                    } else if (stats.avg < 1000) {
                        precision = 10;
                    } else {
                        precision = 100;
                    }
                    var avg = round(Math.round(stats.avg), precision);
                    var min = Math.ceil(stats.min);
                    var max = round(Math.floor(stats.max), precision);
                    while (max > stats.max) {
                        max -= precision;
                    }

                    var next = void 0;
                    var from = void 0;
                    var facetValues = [];
                    if (min !== max) {
                        next = min;

                        facetValues.push({
                            to: next,
                        });

                        while (next < avg) {
                            from = facetValues[facetValues.length - 1].to;
                            next = round(from + (avg - min) / 3, precision);
                            if (next <= from) {
                                next = from + 1;
                            }
                            facetValues.push({
                                from: from,
                                to: next,
                            });
                        }
                        while (next < max) {
                            from = facetValues[facetValues.length - 1].to;
                            next = round(from + (max - avg) / 3, precision);
                            if (next <= from) {
                                next = from + 1;
                            }
                            facetValues.push({
                                from: from,
                                to: next,
                            });
                        }

                        if (facetValues.length === 1) {
                            if (next !== avg) {
                                facetValues.push({
                                    from: next,
                                    to: avg,
                                });
                                next = avg;
                            }
                        }

                        if (facetValues.length === 1) {
                            facetValues[0].from = stats.min;
                            facetValues[0].to = stats.max;
                        } else {
                            delete facetValues[facetValues.length - 1].to;
                        }
                    }
                    return facetValues;
                }

                exports.default = generateRanges;

                /***/
            },
            /* 568 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    header: "",
                    item: "\n    {{#from}}\n      {{^to}}\n        &ge;\n      {{/to}}\n      {{currency}}{{#helpers.formatNumber}}{{from}}{{/helpers.formatNumber}}\n    {{/from}}\n    {{#to}}\n      {{#from}}\n        -\n      {{/from}}\n      {{^from}}\n        &le;\n      {{/from}}\n      {{#helpers.formatNumber}}{{to}}{{/helpers.formatNumber}}\n    {{/to}}\n  ",
                    footer: "",
                };

                /***/
            },
            /* 569 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                var _PriceRangesForm = __webpack_require__(570);

                var _PriceRangesForm2 =
                    _interopRequireDefault(_PriceRangesForm);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _defineProperty(obj, key, value) {
                    if (key in obj) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true,
                        });
                    } else {
                        obj[key] = value;
                    }
                    return obj;
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var PriceRanges = (function (_React$Component) {
                    _inherits(PriceRanges, _React$Component);

                    function PriceRanges() {
                        _classCallCheck(this, PriceRanges);

                        return _possibleConstructorReturn(
                            this,
                            (
                                PriceRanges.__proto__ ||
                                Object.getPrototypeOf(PriceRanges)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(PriceRanges, [
                        {
                            key: "componentWillMount",
                            value: function componentWillMount() {
                                this.refine = this.refine.bind(this);
                            },
                        },
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return !(0, _isEqual2.default)(
                                    this.props.facetValues,
                                    nextProps.facetValues
                                );
                            },
                        },
                        {
                            key: "getForm",
                            value: function getForm() {
                                var labels = _extends(
                                    {
                                        currency: this.props.currency,
                                    },
                                    this.props.labels
                                );

                                var currentRefinement = void 0;
                                if (this.props.facetValues.length === 1) {
                                    currentRefinement = {
                                        from:
                                            this.props.facetValues[0].from !==
                                            undefined
                                                ? this.props.facetValues[0].from
                                                : "",
                                        to:
                                            this.props.facetValues[0].to !==
                                            undefined
                                                ? this.props.facetValues[0].to
                                                : "",
                                    };
                                } else {
                                    currentRefinement = { from: "", to: "" };
                                }

                                return _react2.default.createElement(
                                    _PriceRangesForm2.default,
                                    {
                                        cssClasses: this.props.cssClasses,
                                        currentRefinement: currentRefinement,
                                        labels: labels,
                                        refine: this.refine,
                                    }
                                );
                            },
                        },
                        {
                            key: "getItemFromFacetValue",
                            value: function getItemFromFacetValue(facetValue) {
                                var cssClassItem = (0, _classnames2.default)(
                                    this.props.cssClasses.item,
                                    _defineProperty(
                                        {},
                                        this.props.cssClasses.active,
                                        facetValue.isRefined
                                    )
                                );
                                var key = facetValue.from + "_" + facetValue.to;
                                var handleClick = this.refine.bind(
                                    this,
                                    facetValue.from,
                                    facetValue.to
                                );
                                var data = _extends(
                                    {
                                        currency: this.props.currency,
                                    },
                                    facetValue
                                );
                                return _react2.default.createElement(
                                    "div",
                                    { className: cssClassItem, key: key },
                                    _react2.default.createElement(
                                        "a",
                                        {
                                            className:
                                                this.props.cssClasses.link,
                                            href: facetValue.url,
                                            onClick: handleClick,
                                        },
                                        _react2.default.createElement(
                                            _Template2.default,
                                            _extends(
                                                {
                                                    data: data,
                                                    templateKey: "item",
                                                },
                                                this.props.templateProps
                                            )
                                        )
                                    )
                                );
                            },
                        },
                        {
                            key: "refine",
                            value: function refine(from, to, event) {
                                event.preventDefault();
                                this.props.refine(from, to);
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this2 = this;

                                return _react2.default.createElement(
                                    "div",
                                    null,
                                    _react2.default.createElement(
                                        "div",
                                        {
                                            className:
                                                this.props.cssClasses.list,
                                        },
                                        this.props.facetValues.map(function (
                                            facetValue
                                        ) {
                                            return _this2.getItemFromFacetValue(
                                                facetValue
                                            );
                                        })
                                    ),
                                    this.getForm()
                                );
                            },
                        },
                    ]);

                    return PriceRanges;
                })(_react2.default.Component);

                PriceRanges.defaultProps = {
                    cssClasses: {},
                };

                exports.default = PriceRanges;

                /***/
            },
            /* 570 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _defineProperty(obj, key, value) {
                    if (key in obj) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true,
                        });
                    } else {
                        obj[key] = value;
                    }
                    return obj;
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var PriceRangesForm = (function (_React$Component) {
                    _inherits(PriceRangesForm, _React$Component);

                    function PriceRangesForm(props) {
                        _classCallCheck(this, PriceRangesForm);

                        var _this = _possibleConstructorReturn(
                            this,
                            (
                                PriceRangesForm.__proto__ ||
                                Object.getPrototypeOf(PriceRangesForm)
                            ).call(this, props)
                        );

                        _this.state = {
                            from: props.currentRefinement.from,
                            to: props.currentRefinement.to,
                        };
                        return _this;
                    }

                    _createClass(PriceRangesForm, [
                        {
                            key: "componentWillMount",
                            value: function componentWillMount() {
                                this.handleSubmit =
                                    this.handleSubmit.bind(this);
                            },
                        },
                        {
                            key: "componentWillReceiveProps",
                            value: function componentWillReceiveProps(props) {
                                this.setState({
                                    from: props.currentRefinement.from,
                                    to: props.currentRefinement.to,
                                });
                            },
                        },
                        {
                            key: "getInput",
                            value: function getInput(type) {
                                var _this2 = this;

                                return _react2.default.createElement(
                                    "label",
                                    { className: this.props.cssClasses.label },
                                    _react2.default.createElement(
                                        "span",
                                        {
                                            className:
                                                this.props.cssClasses.currency,
                                        },
                                        this.props.labels.currency,
                                        " "
                                    ),
                                    _react2.default.createElement("input", {
                                        className: this.props.cssClasses.input,
                                        onChange: function onChange(e) {
                                            return _this2.setState(
                                                _defineProperty(
                                                    {},
                                                    type,
                                                    e.target.value
                                                )
                                            );
                                        },
                                        ref: type,
                                        type: "number",
                                        value: this.state[type],
                                    })
                                );
                            },
                        },
                        {
                            key: "handleSubmit",
                            value: function handleSubmit(event) {
                                var from =
                                    this.refs.from.value !== ""
                                        ? parseInt(this.refs.from.value, 10)
                                        : undefined;
                                var to =
                                    this.refs.to.value !== ""
                                        ? parseInt(this.refs.to.value, 10)
                                        : undefined;
                                this.props.refine(from, to, event);
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var fromInput = this.getInput("from");
                                var toInput = this.getInput("to");
                                var onSubmit = this.handleSubmit;
                                return _react2.default.createElement(
                                    "form",
                                    {
                                        className: this.props.cssClasses.form,
                                        onSubmit: onSubmit,
                                        ref: "form",
                                    },
                                    fromInput,
                                    _react2.default.createElement(
                                        "span",
                                        {
                                            className:
                                                this.props.cssClasses.separator,
                                        },
                                        " ",
                                        this.props.labels.separator,
                                        " "
                                    ),
                                    toInput,
                                    _react2.default.createElement(
                                        "button",
                                        {
                                            className:
                                                this.props.cssClasses.button,
                                            type: "submit",
                                        },
                                        this.props.labels.button
                                    )
                                );
                            },
                        },
                    ]);

                    return PriceRangesForm;
                })(_react2.default.Component);

                PriceRangesForm.defaultProps = {
                    cssClasses: {},
                    labels: {},
                };

                exports.default = PriceRangesForm;

                /***/
            },
            /* 571 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _utils = __webpack_require__(514);

                var _forEach = __webpack_require__(129);

                var _forEach2 = _interopRequireDefault(_forEach);

                var _isString = __webpack_require__(239);

                var _isString2 = _interopRequireDefault(_isString);

                var _isFunction = __webpack_require__(68);

                var _isFunction2 = _interopRequireDefault(_isFunction);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _hogan = __webpack_require__(522);

                var _hogan2 = _interopRequireDefault(_hogan);

                var _defaultTemplates = __webpack_require__(572);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-search-box");
                var KEY_ENTER = 13;
                var KEY_SUPPRESS = 8;

                /**
                 * Instantiate a searchbox
                 * @function searchBox
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} [options.placeholder] Input's placeholder [*]
                 * @param  {boolean|Object} [options.poweredBy=false] Define if a "powered by Algolia" link should be added near the input
                 * @param  {function|string} [options.poweredBy.template] Template used for displaying the link. Can accept a function or a Hogan string.
                 * @param  {number} [options.poweredBy.cssClasses] CSS classes to add
                 * @param  {string|string[]} [options.poweredBy.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.poweredBy.cssClasses.link] CSS class to add to the link element
                 * @param  {boolean} [options.wrapInput=true] Wrap the input in a `div.ais-search-box`
                 * @param  {boolean|string} [autofocus='auto'] autofocus on the input
                 * @param  {boolean} [options.searchOnEnterKeyPressOnly=false] If set, trigger the search
                 * once `<Enter>` is pressed only
                 * @param  {Object} [options.cssClasses] CSS classes to add
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the
                 * wrapping div (if `wrapInput` set to `true`)
                 * @param  {string|string[]} [options.cssClasses.input] CSS class to add to the input
                 * @param  {function} [options.queryHook] A function that will be called every time a new search would be done. You
                 * will get the query as first parameter and a search(query) function to call as the second parameter.
                 * This queryHook can be used to debounce the number of searches done from the searchBox.
                 * @return {Object}
                 */

                var usage =
                    "Usage:\nsearchBox({\n  container,\n  [ placeholder ],\n  [ cssClasses.{input,poweredBy} ],\n  [ poweredBy=false || poweredBy.{template, cssClasses.{root,link}} ],\n  [ wrapInput ],\n  [ autofocus ],\n  [ searchOnEnterKeyPressOnly ],\n  [ queryHook ]\n})";
                function searchBox(_ref) {
                    var container = _ref.container,
                        _ref$placeholder = _ref.placeholder,
                        placeholder =
                            _ref$placeholder === undefined
                                ? ""
                                : _ref$placeholder,
                        _ref$cssClasses = _ref.cssClasses,
                        cssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$poweredBy = _ref.poweredBy,
                        poweredBy =
                            _ref$poweredBy === undefined
                                ? false
                                : _ref$poweredBy,
                        _ref$wrapInput = _ref.wrapInput,
                        wrapInput =
                            _ref$wrapInput === undefined
                                ? true
                                : _ref$wrapInput,
                        _ref$autofocus = _ref.autofocus,
                        autofocus =
                            _ref$autofocus === undefined
                                ? "auto"
                                : _ref$autofocus,
                        _ref$searchOnEnterKey = _ref.searchOnEnterKeyPressOnly,
                        searchOnEnterKeyPressOnly =
                            _ref$searchOnEnterKey === undefined
                                ? false
                                : _ref$searchOnEnterKey,
                        queryHook = _ref.queryHook;

                    // the 'input' event is triggered when the input value changes
                    // in any case: typing, copy pasting with mouse..
                    // 'onpropertychange' is the IE8 alternative until we support IE8
                    // but it's flawed: http://help.dottoro.com/ljhxklln.php
                    var INPUT_EVENT = window.addEventListener
                        ? "input"
                        : "propertychange";

                    if (!container) {
                        throw new Error(usage);
                    }

                    container = (0, _utils.getContainerNode)(container);

                    // Only possible values are 'auto', true and false
                    if (typeof autofocus !== "boolean") {
                        autofocus = "auto";
                    }

                    // Convert to object if only set to true
                    if (poweredBy === true) {
                        poweredBy = {};
                    }

                    return {
                        getInput: function getInput() {
                            // Returns reference to targeted input if present, or create a new one
                            if (container.tagName === "INPUT") {
                                return container;
                            }
                            return document.createElement("input");
                        },
                        wrapInput: function wrapInput(input) {
                            // Wrap input in a .ais-search-box div
                            var wrapper = document.createElement("div");
                            var CSSClassesToAdd = (0, _classnames2.default)(
                                bem(null),
                                cssClasses.root
                            ).split(" ");
                            CSSClassesToAdd.forEach(function (cssClass) {
                                return wrapper.classList.add(cssClass);
                            });
                            wrapper.appendChild(input);
                            return wrapper;
                        },
                        addDefaultAttributesToInput:
                            function addDefaultAttributesToInput(input, query) {
                                var defaultAttributes = {
                                    autocapitalize: "off",
                                    autocomplete: "off",
                                    autocorrect: "off",
                                    placeholder: placeholder,
                                    role: "textbox",
                                    spellcheck: "false",
                                    type: "text",
                                    value: query,
                                };

                                // Overrides attributes if not already set
                                (0, _forEach2.default)(
                                    defaultAttributes,
                                    function (value, key) {
                                        if (input.hasAttribute(key)) {
                                            return;
                                        }
                                        input.setAttribute(key, value);
                                    }
                                );

                                // Add classes
                                var CSSClassesToAdd = (0, _classnames2.default)(
                                    bem("input"),
                                    cssClasses.input
                                ).split(" ");
                                CSSClassesToAdd.forEach(function (cssClass) {
                                    return input.classList.add(cssClass);
                                });
                            },
                        addPoweredBy: function addPoweredBy(input) {
                            // Default values
                            poweredBy = _extends(
                                {
                                    cssClasses: {},
                                    template:
                                        _defaultTemplates2.default.poweredBy,
                                },
                                poweredBy
                            );

                            var poweredByCSSClasses = {
                                root: (0, _classnames2.default)(
                                    bem("powered-by"),
                                    poweredBy.cssClasses.root
                                ),
                                link: (0, _classnames2.default)(
                                    bem("powered-by-link"),
                                    poweredBy.cssClasses.link
                                ),
                            };

                            var url =
                                "https://www.algolia.com/?" +
                                "utm_source=instantsearch.js&" +
                                "utm_medium=website&" +
                                ("utm_content=" + location.hostname + "&") +
                                "utm_campaign=poweredby";

                            var templateData = {
                                cssClasses: poweredByCSSClasses,
                                url: url,
                            };

                            var template = poweredBy.template;
                            var stringNode = void 0;

                            if ((0, _isString2.default)(template)) {
                                stringNode = _hogan2.default
                                    .compile(template)
                                    .render(templateData);
                            }
                            if ((0, _isFunction2.default)(template)) {
                                stringNode = template(templateData);
                            }

                            // Crossbrowser way to create a DOM node from a string. We wrap in
                            // a `span` to make sure we have one and only one node.
                            var tmpNode = document.createElement("div");
                            tmpNode.innerHTML =
                                "<span>" + stringNode.trim() + "</span>";
                            var htmlNode = tmpNode.firstChild;

                            input.parentNode.insertBefore(
                                htmlNode,
                                input.nextSibling
                            );
                        },
                        init: function init(_ref2) {
                            var state = _ref2.state,
                                helper = _ref2.helper,
                                onHistoryChange = _ref2.onHistoryChange;

                            var isInputTargeted = container.tagName === "INPUT";
                            var input = (this._input = this.getInput());
                            var previousQuery = void 0;

                            // Add all the needed attributes and listeners to the input
                            this.addDefaultAttributesToInput(
                                input,
                                state.query
                            );

                            // always set the query every keystrokes when there's no queryHook
                            if (!queryHook) {
                                addListener(
                                    input,
                                    INPUT_EVENT,
                                    getInputValueAndCall(setQuery)
                                );
                            }

                            // search on enter
                            if (searchOnEnterKeyPressOnly) {
                                addListener(
                                    input,
                                    "keyup",
                                    ifKey(
                                        KEY_ENTER,
                                        getInputValueAndCall(maybeSearch)
                                    )
                                );
                            } else {
                                addListener(
                                    input,
                                    INPUT_EVENT,
                                    getInputValueAndCall(maybeSearch)
                                );

                                // handle IE8 weirdness where BACKSPACE key will not trigger an input change..
                                // can be removed as soon as we remove support for it
                                if (
                                    INPUT_EVENT === "propertychange" ||
                                    window.attachEvent
                                ) {
                                    addListener(
                                        input,
                                        "keyup",
                                        ifKey(
                                            KEY_SUPPRESS,
                                            getInputValueAndCall(setQuery)
                                        )
                                    );
                                    addListener(
                                        input,
                                        "keyup",
                                        ifKey(
                                            KEY_SUPPRESS,
                                            getInputValueAndCall(maybeSearch)
                                        )
                                    );
                                }
                            }

                            function maybeSearch(query) {
                                if (queryHook) {
                                    queryHook(query, setQueryAndSearch);
                                    return;
                                }

                                search(query);
                            }

                            function setQuery(query) {
                                if (query !== helper.state.query) {
                                    previousQuery = helper.state.query;
                                    helper.setQuery(query);
                                }
                            }

                            function search(query) {
                                if (
                                    previousQuery !== undefined &&
                                    previousQuery !== query
                                )
                                    helper.search();
                            }

                            function setQueryAndSearch(query) {
                                setQuery(query);
                                search(query);
                            }

                            if (isInputTargeted) {
                                // To replace the node, we need to create an intermediate node
                                var placeholderNode =
                                    document.createElement("div");
                                input.parentNode.insertBefore(
                                    placeholderNode,
                                    input
                                );
                                var parentNode = input.parentNode;
                                var wrappedInput = wrapInput
                                    ? this.wrapInput(input)
                                    : input;
                                parentNode.replaceChild(
                                    wrappedInput,
                                    placeholderNode
                                );
                            } else {
                                var _wrappedInput = wrapInput
                                    ? this.wrapInput(input)
                                    : input;
                                container.appendChild(_wrappedInput);
                            }

                            // Optional "powered by Algolia" widget
                            if (poweredBy) {
                                this.addPoweredBy(input);
                            }

                            // Update value when query change outside of the input
                            onHistoryChange(function (fullState) {
                                input.value = fullState.query || "";
                            });

                            // When the page is coming from BFCache
                            // (https://developer.mozilla.org/en-US/docs/Working_with_BFCache)
                            // then we force the input value to be the current query
                            // Otherwise, this happens:
                            // - <input> autocomplete = off (default)
                            // - search $query
                            // - navigate away
                            // - use back button
                            // - input query is empty (because <input> autocomplete = off)
                            window.addEventListener("pageshow", function () {
                                input.value = helper.state.query;
                            });

                            if (
                                autofocus === true ||
                                (autofocus === "auto" &&
                                    helper.state.query === "")
                            ) {
                                input.focus();
                                input.setSelectionRange(
                                    helper.state.query.length,
                                    helper.state.query.length
                                );
                            }
                        },
                        render: function render(_ref3) {
                            var helper = _ref3.helper;

                            // updating the query from the outside using the helper
                            // will fall in this case
                            // If the input is focused, we do not update it.
                            if (document.activeElement === this._input) {
                                return;
                            }

                            if (helper.state.query !== this._input.value) {
                                this._input.value = helper.state.query;
                            }
                        },
                    };
                }

                function addListener(el, type, fn) {
                    if (el.addEventListener) {
                        el.addEventListener(type, fn);
                    } else {
                        el.attachEvent("on" + type, fn);
                    }
                }

                function getValue(e) {
                    return (e.currentTarget ? e.currentTarget : e.srcElement)
                        .value;
                }

                function ifKey(expectedKeyCode, func) {
                    return function (actualEvent) {
                        return (
                            actualEvent.keyCode === expectedKeyCode &&
                            func(actualEvent)
                        );
                    };
                }

                function getInputValueAndCall(func) {
                    return function (actualEvent) {
                        return func(getValue(actualEvent));
                    };
                }

                exports.default = searchBox;

                /***/
            },
            /* 572 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    poweredBy:
                        '\n<div class="{{cssClasses.root}}">\n  Search by\n  <a class="{{cssClasses.link}}" href="{{url}}" target="_blank">Algolia</a>\n</div>',
                };

                /***/
            },
            /* 573 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _find = __webpack_require__(240);

                var _find2 = _interopRequireDefault(_find);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _Slider = __webpack_require__(574);

                var _Slider2 = _interopRequireDefault(_Slider);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _defineProperty(obj, key, value) {
                    if (key in obj) {
                        Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true,
                        });
                    } else {
                        obj[key] = value;
                    }
                    return obj;
                }

                var bem = (0, _utils.bemHelper)("ais-range-slider");
                var defaultTemplates = {
                    header: "",
                    footer: "",
                };

                /**
                 * Instantiate a slider based on a numeric attribute.
                 * This is a wrapper around [noUiSlider](http://refreshless.com/nouislider/)
                 * @function rangeSlider
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} options.attributeName Name of the attribute for faceting
                 * @param  {boolean|Object} [options.tooltips=true] Should we show tooltips or not.
                 * The default tooltip will show the raw value.
                 * You can also provide
                 * `tooltips: {format: function(rawValue) {return '$' + Math.round(rawValue).toLocaleString()}}`
                 * So that you can format the tooltip display value as you want
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header=''] Header template
                 * @param  {string|Function} [options.templates.footer=''] Footer template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when no refinements available
                 * @param  {Object} [options.cssClasses] CSS classes to add to the wrapping elements
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {boolean|object} [options.pips=true] Show slider pips.
                 * @param  {boolean|object} [options.step=1] Every handle move will jump that number of steps.
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @param  {number} [options.min] Minimal slider value, default to automatically computed from the result set
                 * @param  {number} [options.max] Maximal slider value, defaults to automatically computed from the result set
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nrangeSlider({\n  container,\n  attributeName,\n  [ tooltips=true ],\n  [ templates.{header, footer} ],\n  [ cssClasses.{root, header, body, footer} ],\n  [ step=1 ],\n  [ pips=true ],\n  [ autoHideContainer=true ],\n  [ collapsible=false ],\n  [ min ],\n  [ max ]\n});\n";
                function rangeSlider() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        attributeName = _ref.attributeName,
                        _ref$tooltips = _ref.tooltips,
                        tooltips =
                            _ref$tooltips === undefined ? true : _ref$tooltips,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? defaultTemplates
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$step = _ref.step,
                        step = _ref$step === undefined ? 1 : _ref$step,
                        _ref$pips = _ref.pips,
                        pips = _ref$pips === undefined ? true : _ref$pips,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        userMin = _ref.min,
                        userMax = _ref.max,
                        _ref$precision = _ref.precision,
                        precision =
                            _ref$precision === undefined ? 2 : _ref$precision;

                    if (!container || !attributeName) {
                        throw new Error(usage);
                    }

                    var formatToNumber = function formatToNumber(v) {
                        return Number(Number(v).toFixed(precision));
                    };

                    var sliderFormatter = {
                        from: function from(v) {
                            return v;
                        },
                        to: function to(v) {
                            return formatToNumber(v).toLocaleString();
                        },
                    };

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var Slider = (0, _headerFooter2.default)(_Slider2.default);
                    if (autoHideContainer === true) {
                        Slider = (0, _autoHideContainer2.default)(Slider);
                    }

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                    };

                    return {
                        getConfiguration: function getConfiguration(
                            originalConf
                        ) {
                            var conf = {
                                disjunctiveFacets: [attributeName],
                            };

                            if (
                                (userMin !== undefined ||
                                    userMax !== undefined) &&
                                (!originalConf ||
                                    (originalConf.numericRefinements &&
                                        originalConf.numericRefinements[
                                            attributeName
                                        ] === undefined))
                            ) {
                                conf.numericRefinements = _defineProperty(
                                    {},
                                    attributeName,
                                    {}
                                );

                                if (userMin !== undefined) {
                                    conf.numericRefinements[attributeName][
                                        ">="
                                    ] = [userMin];
                                }

                                if (userMax !== undefined) {
                                    conf.numericRefinements[attributeName][
                                        "<="
                                    ] = [userMax];
                                }
                            }

                            return conf;
                        },
                        _getCurrentRefinement: function _getCurrentRefinement(
                            helper
                        ) {
                            var min = helper.state.getNumericRefinement(
                                attributeName,
                                ">="
                            );
                            var max = helper.state.getNumericRefinement(
                                attributeName,
                                "<="
                            );

                            if (min && min.length) {
                                min = min[0];
                            } else {
                                min = -Infinity;
                            }

                            if (max && max.length) {
                                max = max[0];
                            } else {
                                max = Infinity;
                            }

                            return {
                                min: min,
                                max: max,
                            };
                        },
                        _refine: function _refine(
                            helper,
                            oldValues,
                            newValues
                        ) {
                            helper.clearRefinements(attributeName);
                            if (newValues[0] > oldValues.min) {
                                helper.addNumericRefinement(
                                    attributeName,
                                    ">=",
                                    formatToNumber(newValues[0])
                                );
                            }
                            if (newValues[1] < oldValues.max) {
                                helper.addNumericRefinement(
                                    attributeName,
                                    "<=",
                                    formatToNumber(newValues[1])
                                );
                            }
                            helper.search();
                        },
                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                defaultTemplates: defaultTemplates,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results,
                                helper = _ref3.helper;

                            var facet = (0, _find2.default)(
                                results.disjunctiveFacets,
                                { name: attributeName }
                            );
                            var stats =
                                facet !== undefined && facet.stats !== undefined
                                    ? facet.stats
                                    : {
                                          min: null,
                                          max: null,
                                      };

                            if (userMin !== undefined) stats.min = userMin;
                            if (userMax !== undefined) stats.max = userMax;

                            var currentRefinement =
                                this._getCurrentRefinement(helper);

                            if (tooltips.format !== undefined) {
                                tooltips = [
                                    { to: tooltips.format },
                                    { to: tooltips.format },
                                ];
                            }

                            _reactDom2.default.render(
                                _react2.default.createElement(Slider, {
                                    collapsible: collapsible,
                                    cssClasses: cssClasses,
                                    onChange: this._refine.bind(
                                        this,
                                        helper,
                                        stats
                                    ),
                                    pips: pips,
                                    range: {
                                        min: Math.floor(stats.min),
                                        max: Math.ceil(stats.max),
                                    },
                                    shouldAutoHideContainer:
                                        stats.min === stats.max,
                                    start: [
                                        currentRefinement.min,
                                        currentRefinement.max,
                                    ],
                                    step: step,
                                    templateProps: this._templateProps,
                                    tooltips: tooltips,
                                    format: sliderFormatter,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = rangeSlider;

                /***/
            },
            /* 574 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _omit = __webpack_require__(190);

                var _omit2 = _interopRequireDefault(_omit);

                var _reactNouislider = __webpack_require__(575);

                var _reactNouislider2 =
                    _interopRequireDefault(_reactNouislider);

                var _isEqual = __webpack_require__(237);

                var _isEqual2 = _interopRequireDefault(_isEqual);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var cssPrefix = "ais-range-slider--";

                var Slider = (function (_React$Component) {
                    _inherits(Slider, _React$Component);

                    function Slider() {
                        _classCallCheck(this, Slider);

                        return _possibleConstructorReturn(
                            this,
                            (
                                Slider.__proto__ ||
                                Object.getPrototypeOf(Slider)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(Slider, [
                        {
                            key: "componentWillMount",
                            value: function componentWillMount() {
                                this.handleChange =
                                    this.handleChange.bind(this);
                            },
                        },
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return (
                                    !(0, _isEqual2.default)(
                                        this.props.range,
                                        nextProps.range
                                    ) ||
                                    !(0, _isEqual2.default)(
                                        this.props.start,
                                        nextProps.start
                                    )
                                );
                            },

                            // we are only interested in rawValues
                        },
                        {
                            key: "handleChange",
                            value: function handleChange(
                                formattedValues,
                                handleId,
                                rawValues
                            ) {
                                this.props.onChange(rawValues);
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                if (
                                    this.props.range.min ===
                                    this.props.range.max
                                ) {
                                    // There's no need to try to render the Slider, it will not be usable
                                    // and will throw
                                    return null;
                                }

                                // setup pips
                                var pips = void 0;
                                if (this.props.pips === false) {
                                    pips = undefined;
                                } else if (
                                    this.props.pips === true ||
                                    typeof this.props.pips === "undefined"
                                ) {
                                    pips = {
                                        mode: "positions",
                                        density: 3,
                                        values: [0, 50, 100],
                                        stepped: true,
                                    };
                                } else {
                                    pips = this.props.pips;
                                }

                                return _react2.default.createElement(
                                    _reactNouislider2.default,
                                    // NoUiSlider also accepts a cssClasses prop, but we don't want to
                                    // provide one.
                                    _extends(
                                        {},
                                        (0, _omit2.default)(this.props, [
                                            "cssClasses",
                                        ]),
                                        {
                                            animate: false,
                                            behaviour: "snap",
                                            connect: true,
                                            cssPrefix: cssPrefix,
                                            onChange: this.handleChange,
                                            pips: pips,
                                        }
                                    )
                                );
                            },
                        },
                    ]);

                    return Slider;
                })(_react2.default.Component);

                exports.default = Slider;

                /***/
            },
            /* 575 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while (_again) {
                        var object = _x,
                            property = _x2,
                            receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(
                            object,
                            property
                        );
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) {
                                return undefined;
                            } else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ("value" in desc) {
                            return desc.value;
                        } else {
                            var getter = desc.get;
                            if (getter === undefined) {
                                return undefined;
                            }
                            return getter.call(receiver);
                        }
                    }
                };

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _nouisliderAlgoliaFork = __webpack_require__(576);

                var _nouisliderAlgoliaFork2 = _interopRequireDefault(
                    _nouisliderAlgoliaFork
                );

                var Nouislider = (function (_React$Component) {
                    _inherits(Nouislider, _React$Component);

                    function Nouislider() {
                        _classCallCheck(this, Nouislider);

                        _get(
                            Object.getPrototypeOf(Nouislider.prototype),
                            "constructor",
                            this
                        ).apply(this, arguments);
                    }

                    _createClass(Nouislider, [
                        {
                            key: "componentDidMount",
                            value: function componentDidMount() {
                                if (this.props.disabled)
                                    this.sliderContainer.setAttribute(
                                        "disabled",
                                        true
                                    );
                                else
                                    this.sliderContainer.removeAttribute(
                                        "disabled"
                                    );
                                this.createSlider();
                            },
                        },
                        {
                            key: "componentDidUpdate",
                            value: function componentDidUpdate() {
                                if (this.props.disabled)
                                    this.sliderContainer.setAttribute(
                                        "disabled",
                                        true
                                    );
                                else
                                    this.sliderContainer.removeAttribute(
                                        "disabled"
                                    );
                                this.slider.destroy();
                                this.createSlider();
                            },
                        },
                        {
                            key: "componentWillUnmount",
                            value: function componentWillUnmount() {
                                this.slider.destroy();
                            },
                        },
                        {
                            key: "createSlider",
                            value: function createSlider() {
                                var slider = (this.slider =
                                    _nouisliderAlgoliaFork2["default"].create(
                                        this.sliderContainer,
                                        _extends({}, this.props)
                                    ));

                                if (this.props.onUpdate) {
                                    slider.on("update", this.props.onUpdate);
                                }

                                if (this.props.onChange) {
                                    slider.on("change", this.props.onChange);
                                }

                                if (this.props.onSlide) {
                                    slider.on("slide", this.props.onSlide);
                                }

                                if (this.props.onStart) {
                                    slider.on("start", this.props.onStart);
                                }

                                if (this.props.onEnd) {
                                    slider.on("end", this.props.onEnd);
                                }

                                if (this.props.onSet) {
                                    slider.on("set", this.props.onSet);
                                }
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this = this;

                                return _react2["default"].createElement("div", {
                                    ref: function (slider) {
                                        _this.sliderContainer = slider;
                                    },
                                });
                            },
                        },
                    ]);

                    return Nouislider;
                })(_react2["default"].Component);

                Nouislider.propTypes = {
                    // http://refreshless.com/nouislider/slider-options/#section-animate
                    animate: _react2["default"].PropTypes.bool,
                    // http://refreshless.com/nouislider/behaviour-option/
                    behaviour: _react2["default"].PropTypes.string,
                    // http://refreshless.com/nouislider/slider-options/#section-Connect
                    connect: _react2["default"].PropTypes.oneOfType([
                        _react2["default"].PropTypes.arrayOf(
                            _react2["default"].PropTypes.bool
                        ),
                        _react2["default"].PropTypes.bool,
                    ]),
                    // http://refreshless.com/nouislider/slider-options/#section-cssPrefix
                    cssPrefix: _react2["default"].PropTypes.string,
                    // http://refreshless.com/nouislider/slider-options/#section-orientation
                    direction: _react2["default"].PropTypes.oneOf([
                        "ltr",
                        "rtl",
                    ]),
                    // http://refreshless.com/nouislider/more/#section-disable
                    disabled: _react2["default"].PropTypes.bool,
                    // http://refreshless.com/nouislider/slider-options/#section-limit
                    limit: _react2["default"].PropTypes.number,
                    // http://refreshless.com/nouislider/slider-options/#section-margin
                    margin: _react2["default"].PropTypes.number,
                    // http://refreshless.com/nouislider/events-callbacks/#section-change
                    onChange: _react2["default"].PropTypes.func,
                    // http://refreshless.com/nouislider/events-callbacks/
                    onEnd: _react2["default"].PropTypes.func,
                    // http://refreshless.com/nouislider/events-callbacks/#section-set
                    onSet: _react2["default"].PropTypes.func,
                    // http://refreshless.com/nouislider/events-callbacks/#section-slide
                    onSlide: _react2["default"].PropTypes.func,
                    // http://refreshless.com/nouislider/events-callbacks/
                    onStart: _react2["default"].PropTypes.func,
                    // http://refreshless.com/nouislider/events-callbacks/#section-update
                    onUpdate: _react2["default"].PropTypes.func,
                    // http://refreshless.com/nouislider/slider-options/#section-orientation
                    orientation: _react2["default"].PropTypes.oneOf([
                        "horizontal",
                        "vertical",
                    ]),
                    // http://refreshless.com/nouislider/pips/
                    pips: _react2["default"].PropTypes.object,
                    // http://refreshless.com/nouislider/slider-values/#section-range
                    range: _react2["default"].PropTypes.object.isRequired,
                    // http://refreshless.com/nouislider/slider-options/#section-start
                    start: _react2["default"].PropTypes.arrayOf(
                        _react2["default"].PropTypes.number
                    ).isRequired,
                    // http://refreshless.com/nouislider/slider-options/#section-step
                    step: _react2["default"].PropTypes.number,
                    // http://refreshless.com/nouislider/slider-options/#section-tooltips
                    tooltips: _react2["default"].PropTypes.oneOfType([
                        _react2["default"].PropTypes.bool,
                        _react2["default"].PropTypes.arrayOf(
                            _react2["default"].PropTypes.shape({
                                to: _react2["default"].PropTypes.func,
                            })
                        ),
                    ]),
                };

                module.exports = Nouislider;

                /***/
            },
            /* 576 */
            /***/ function (module, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_FACTORY__,
                    __WEBPACK_AMD_DEFINE_ARRAY__,
                    __WEBPACK_AMD_DEFINE_RESULT__; /*! nouislider-algolia-fork - 10.0.0 - 2016-11-02 18:17:49 */

                (function (factory) {
                    if (true) {
                        // AMD. Register as an anonymous module.
                        !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
                        (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
                        (__WEBPACK_AMD_DEFINE_RESULT__ =
                            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
                                ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(
                                      exports,
                                      __WEBPACK_AMD_DEFINE_ARRAY__
                                  )
                                : __WEBPACK_AMD_DEFINE_FACTORY__),
                        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
                            (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                    } else if (typeof exports === "object") {
                        // Node/CommonJS
                        module.exports = factory();
                    } else {
                        // Browser globals
                        window.noUiSlider = factory();
                    }
                })(function () {
                    "use strict";

                    // Removes duplicates from an array.
                    function unique(array) {
                        return array.filter(function (a) {
                            return !this[a] ? (this[a] = true) : false;
                        }, {});
                    }

                    // Round a value to the closest 'to'.
                    function closest(value, to) {
                        return Math.round(value / to) * to;
                    }

                    // Current position of an element relative to the document.
                    function offset(elem) {
                        var rect = elem.getBoundingClientRect(),
                            doc = elem.ownerDocument,
                            docElem = doc.documentElement,
                            pageOffset = getPageOffset();

                        // getBoundingClientRect contains left scroll in Chrome on Android.
                        // I haven't found a feature detection that proves this. Worst case
                        // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
                        if (
                            /webkit.*Chrome.*Mobile/i.test(navigator.userAgent)
                        ) {
                            pageOffset.x = 0;
                        }

                        return {
                            top: rect.top + pageOffset.y - docElem.clientTop,
                            left: rect.left + pageOffset.x - docElem.clientLeft,
                        };
                    }

                    // Checks whether a value is numerical.
                    function isNumeric(a) {
                        return (
                            typeof a === "number" && !isNaN(a) && isFinite(a)
                        );
                    }

                    // Sets a class and removes it after [duration] ms.
                    function addClassFor(element, className, duration) {
                        addClass(element, className);
                        setTimeout(function () {
                            removeClass(element, className);
                        }, duration);
                    }

                    // Limits a value to 0 - 100
                    function limit(a) {
                        return Math.max(Math.min(a, 100), 0);
                    }

                    // Wraps a variable as an array, if it isn't one yet.
                    function asArray(a) {
                        return Array.isArray(a) ? a : [a];
                    }

                    // Counts decimals
                    function countDecimals(numStr) {
                        var pieces = numStr.split(".");
                        return pieces.length > 1 ? pieces[1].length : 0;
                    }

                    // http://youmightnotneedjquery.com/#add_class
                    function addClass(el, className) {
                        if (el.classList) {
                            el.classList.add(className);
                        } else {
                            el.className += " " + className;
                        }
                    }

                    // http://youmightnotneedjquery.com/#remove_class
                    function removeClass(el, className) {
                        if (el.classList) {
                            el.classList.remove(className);
                        } else {
                            el.className = el.className.replace(
                                new RegExp(
                                    "(^|\\b)" +
                                        className.split(" ").join("|") +
                                        "(\\b|$)",
                                    "gi"
                                ),
                                " "
                            );
                        }
                    }

                    // https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
                    function hasClass(el, className) {
                        return el.classList
                            ? el.classList.contains(className)
                            : new RegExp("\\b" + className + "\\b").test(
                                  el.className
                              );
                    }

                    // https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
                    function getPageOffset() {
                        var supportPageOffset =
                                window.pageXOffset !== undefined,
                            isCSS1Compat =
                                (document.compatMode || "") === "CSS1Compat",
                            x = supportPageOffset
                                ? window.pageXOffset
                                : isCSS1Compat
                                ? document.documentElement.scrollLeft
                                : document.body.scrollLeft,
                            y = supportPageOffset
                                ? window.pageYOffset
                                : isCSS1Compat
                                ? document.documentElement.scrollTop
                                : document.body.scrollTop;

                        return {
                            x: x,
                            y: y,
                        };
                    }

                    // we provide a function to compute constants instead
                    // of accessing window.* as soon as the module needs it
                    // so that we do not compute anything if not needed
                    function getActions() {
                        // Determine the events to bind. IE11 implements pointerEvents without
                        // a prefix, which breaks compatibility with the IE10 implementation.
                        return window.navigator.pointerEnabled
                            ? {
                                  start: "pointerdown",
                                  move: "pointermove",
                                  end: "pointerup",
                              }
                            : window.navigator.msPointerEnabled
                            ? {
                                  start: "MSPointerDown",
                                  move: "MSPointerMove",
                                  end: "MSPointerUp",
                              }
                            : {
                                  start: "mousedown touchstart",
                                  move: "mousemove touchmove",
                                  end: "mouseup touchend",
                              };
                    }

                    // Value calculation

                    // Determine the size of a sub-range in relation to a full range.
                    function subRangeRatio(pa, pb) {
                        return 100 / (pb - pa);
                    }

                    // (percentage) How many percent is this value of this range?
                    function fromPercentage(range, value) {
                        return (value * 100) / (range[1] - range[0]);
                    }

                    // (percentage) Where is this value on this range?
                    function toPercentage(range, value) {
                        return fromPercentage(
                            range,
                            range[0] < 0
                                ? value + Math.abs(range[0])
                                : value - range[0]
                        );
                    }

                    // (value) How much is this percentage on this range?
                    function isPercentage(range, value) {
                        return (value * (range[1] - range[0])) / 100 + range[0];
                    }

                    // Range conversion

                    function getJ(value, arr) {
                        var j = 1;

                        while (value >= arr[j]) {
                            j += 1;
                        }

                        return j;
                    }

                    // (percentage) Input a value, find where, on a scale of 0-100, it applies.
                    function toStepping(xVal, xPct, value) {
                        if (value >= xVal.slice(-1)[0]) {
                            return 100;
                        }

                        var j = getJ(value, xVal),
                            va,
                            vb,
                            pa,
                            pb;

                        va = xVal[j - 1];
                        vb = xVal[j];
                        pa = xPct[j - 1];
                        pb = xPct[j];

                        return (
                            pa +
                            toPercentage([va, vb], value) /
                                subRangeRatio(pa, pb)
                        );
                    }

                    // (value) Input a percentage, find where it is on the specified range.
                    function fromStepping(xVal, xPct, value) {
                        // There is no range group that fits 100
                        if (value >= 100) {
                            return xVal.slice(-1)[0];
                        }

                        var j = getJ(value, xPct),
                            va,
                            vb,
                            pa,
                            pb;

                        va = xVal[j - 1];
                        vb = xVal[j];
                        pa = xPct[j - 1];
                        pb = xPct[j];

                        return isPercentage(
                            [va, vb],
                            (value - pa) * subRangeRatio(pa, pb)
                        );
                    }

                    // (percentage) Get the step that applies at a certain value.
                    function getStep(xPct, xSteps, snap, value) {
                        if (value === 100) {
                            return value;
                        }

                        var j = getJ(value, xPct),
                            a,
                            b;

                        // If 'snap' is set, steps are used as fixed points on the slider.
                        if (snap) {
                            a = xPct[j - 1];
                            b = xPct[j];

                            // Find the closest position, a or b.
                            if (value - a > (b - a) / 2) {
                                return b;
                            }

                            return a;
                        }

                        if (!xSteps[j - 1]) {
                            return value;
                        }

                        return (
                            xPct[j - 1] +
                            closest(value - xPct[j - 1], xSteps[j - 1])
                        );
                    }

                    // Entry parsing

                    function handleEntryPoint(index, value, that) {
                        var percentage;

                        // Wrap numerical input in an array.
                        if (typeof value === "number") {
                            value = [value];
                        }

                        // Reject any invalid input, by testing whether value is an array.
                        if (
                            Object.prototype.toString.call(value) !==
                            "[object Array]"
                        ) {
                            throw new Error(
                                "noUiSlider: 'range' contains invalid value."
                            );
                        }

                        // Covert min/max syntax to 0 and 100.
                        if (index === "min") {
                            percentage = 0;
                        } else if (index === "max") {
                            percentage = 100;
                        } else {
                            percentage = parseFloat(index);
                        }

                        // Check for correct input.
                        if (!isNumeric(percentage) || !isNumeric(value[0])) {
                            throw new Error(
                                "noUiSlider: 'range' value isn't numeric."
                            );
                        }

                        // Store values.
                        that.xPct.push(percentage);
                        that.xVal.push(value[0]);

                        // NaN will evaluate to false too, but to keep
                        // logging clear, set step explicitly. Make sure
                        // not to override the 'step' setting with false.
                        if (!percentage) {
                            if (!isNaN(value[1])) {
                                that.xSteps[0] = value[1];
                            }
                        } else {
                            that.xSteps.push(
                                isNaN(value[1]) ? false : value[1]
                            );
                        }
                    }

                    function handleStepPoint(i, n, that) {
                        // Ignore 'false' stepping.
                        if (!n) {
                            return true;
                        }

                        // Factor to range ratio
                        that.xSteps[i] =
                            fromPercentage(
                                [that.xVal[i], that.xVal[i + 1]],
                                n
                            ) / subRangeRatio(that.xPct[i], that.xPct[i + 1]);
                    }

                    // Interface

                    // The interface to Spectrum handles all direction-based
                    // conversions, so the above values are unaware.

                    function Spectrum(entry, snap, direction, singleStep) {
                        this.xPct = [];
                        this.xVal = [];
                        this.xSteps = [singleStep || false];
                        this.xNumSteps = [false];

                        this.snap = snap;
                        this.direction = direction;

                        var index,
                            ordered = [
                                /* [0, 'min'], [1, '50%'], [2, 'max'] */
                            ];

                        // Map the object keys to an array.
                        for (index in entry) {
                            if (entry.hasOwnProperty(index)) {
                                ordered.push([entry[index], index]);
                            }
                        }

                        // Sort all entries by value (numeric sort).
                        if (
                            ordered.length &&
                            typeof ordered[0][0] === "object"
                        ) {
                            ordered.sort(function (a, b) {
                                return a[0][0] - b[0][0];
                            });
                        } else {
                            ordered.sort(function (a, b) {
                                return a[0] - b[0];
                            });
                        }

                        // Convert all entries to subranges.
                        for (index = 0; index < ordered.length; index++) {
                            handleEntryPoint(
                                ordered[index][1],
                                ordered[index][0],
                                this
                            );
                        }

                        // Store the actual step values.
                        // xSteps is sorted in the same order as xPct and xVal.
                        this.xNumSteps = this.xSteps.slice(0);

                        // Convert all numeric steps to the percentage of the subrange they represent.
                        for (
                            index = 0;
                            index < this.xNumSteps.length;
                            index++
                        ) {
                            handleStepPoint(index, this.xNumSteps[index], this);
                        }
                    }

                    Spectrum.prototype.getMargin = function (value) {
                        return this.xPct.length === 2
                            ? fromPercentage(this.xVal, value)
                            : false;
                    };

                    Spectrum.prototype.toStepping = function (value) {
                        value = toStepping(this.xVal, this.xPct, value);

                        // Invert the value if this is a right-to-left slider.
                        if (this.direction) {
                            value = 100 - value;
                        }

                        return value;
                    };

                    Spectrum.prototype.fromStepping = function (value) {
                        // Invert the value if this is a right-to-left slider.
                        if (this.direction) {
                            value = 100 - value;
                        }

                        return fromStepping(this.xVal, this.xPct, value);
                    };

                    Spectrum.prototype.getStep = function (value) {
                        // Find the proper step for rtl sliders by search in inverse direction.
                        // Fixes issue #262.
                        if (this.direction) {
                            value = 100 - value;
                        }

                        value = getStep(
                            this.xPct,
                            this.xSteps,
                            this.snap,
                            value
                        );

                        if (this.direction) {
                            value = 100 - value;
                        }

                        return value;
                    };

                    Spectrum.prototype.getApplicableStep = function (value) {
                        // If the value is 100%, return the negative step twice.
                        var j = getJ(value, this.xPct),
                            offset = value === 100 ? 2 : 1;
                        return [
                            this.xNumSteps[j - 2],
                            this.xVal[j - offset],
                            this.xNumSteps[j - offset],
                        ];
                    };

                    // Outside testing
                    Spectrum.prototype.convert = function (value) {
                        return this.getStep(this.toStepping(value));
                    };

                    /*	Every input option is tested and parsed. This'll prevent
		endless validation in internal methods. These tests are
		structured with an item for every option available. An
		option can be marked as required by setting the 'r' flag.
		The testing function is provided with three arguments:
			- The provided value for the option;
			- A reference to the options object;
			- The name for the option;
	
		The testing function returns false when an error is detected,
		or true when everything is OK. It can also modify the option
		object, to make sure all values can be correctly looped elsewhere. */

                    var defaultFormatter = {
                        to: function (value) {
                            return value !== undefined && value.toFixed(2);
                        },
                        from: Number,
                    };

                    function testStep(parsed, entry) {
                        if (!isNumeric(entry)) {
                            throw new Error(
                                "noUiSlider: 'step' is not numeric."
                            );
                        }

                        // The step option can still be used to set stepping
                        // for linear sliders. Overwritten if set in 'range'.
                        parsed.singleStep = entry;
                    }

                    function testRange(parsed, entry) {
                        // Filter incorrect input.
                        if (typeof entry !== "object" || Array.isArray(entry)) {
                            throw new Error(
                                "noUiSlider: 'range' is not an object."
                            );
                        }

                        // Catch missing start or end.
                        if (
                            entry.min === undefined ||
                            entry.max === undefined
                        ) {
                            throw new Error(
                                "noUiSlider: Missing 'min' or 'max' in 'range'."
                            );
                        }

                        // Catch equal start or end.
                        if (entry.min === entry.max) {
                            throw new Error(
                                "noUiSlider: 'range' 'min' and 'max' cannot be equal."
                            );
                        }

                        parsed.spectrum = new Spectrum(
                            entry,
                            parsed.snap,
                            parsed.dir,
                            parsed.singleStep
                        );
                    }

                    function testStart(parsed, entry) {
                        entry = asArray(entry);

                        // Validate input. Values aren't tested, as the public .val method
                        // will always provide a valid location.
                        if (
                            !Array.isArray(entry) ||
                            !entry.length ||
                            entry.length > 2
                        ) {
                            throw new Error(
                                "noUiSlider: 'start' option is incorrect."
                            );
                        }

                        // Store the number of handles.
                        parsed.handles = entry.length;

                        // When the slider is initialized, the .val method will
                        // be called with the start options.
                        parsed.start = entry;
                    }

                    function testSnap(parsed, entry) {
                        // Enforce 100% stepping within subranges.
                        parsed.snap = entry;

                        if (typeof entry !== "boolean") {
                            throw new Error(
                                "noUiSlider: 'snap' option must be a boolean."
                            );
                        }
                    }

                    function testAnimate(parsed, entry) {
                        // Enforce 100% stepping within subranges.
                        parsed.animate = entry;

                        if (typeof entry !== "boolean") {
                            throw new Error(
                                "noUiSlider: 'animate' option must be a boolean."
                            );
                        }
                    }

                    function testAnimationDuration(parsed, entry) {
                        parsed.animationDuration = entry;

                        if (typeof entry !== "number") {
                            throw new Error(
                                "noUiSlider: 'animationDuration' option must be a number."
                            );
                        }
                    }

                    function testConnect(parsed, entry) {
                        if (entry === "lower" && parsed.handles === 1) {
                            parsed.connect = 1;
                        } else if (entry === "upper" && parsed.handles === 1) {
                            parsed.connect = 2;
                        } else if (entry === true && parsed.handles === 2) {
                            parsed.connect = 3;
                        } else if (entry === false) {
                            parsed.connect = 0;
                        } else {
                            throw new Error(
                                "noUiSlider: 'connect' option doesn't match handle count."
                            );
                        }
                    }

                    function testOrientation(parsed, entry) {
                        // Set orientation to an a numerical value for easy
                        // array selection.
                        switch (entry) {
                            case "horizontal":
                                parsed.ort = 0;
                                break;
                            case "vertical":
                                parsed.ort = 1;
                                break;
                            default:
                                throw new Error(
                                    "noUiSlider: 'orientation' option is invalid."
                                );
                        }
                    }

                    function testMargin(parsed, entry) {
                        if (!isNumeric(entry)) {
                            throw new Error(
                                "noUiSlider: 'margin' option must be numeric."
                            );
                        }

                        // Issue #582
                        if (entry === 0) {
                            return;
                        }

                        parsed.margin = parsed.spectrum.getMargin(entry);

                        if (!parsed.margin) {
                            throw new Error(
                                "noUiSlider: 'margin' option is only supported on linear sliders."
                            );
                        }
                    }

                    function testLimit(parsed, entry) {
                        if (!isNumeric(entry)) {
                            throw new Error(
                                "noUiSlider: 'limit' option must be numeric."
                            );
                        }

                        parsed.limit = parsed.spectrum.getMargin(entry);

                        if (!parsed.limit) {
                            throw new Error(
                                "noUiSlider: 'limit' option is only supported on linear sliders."
                            );
                        }
                    }

                    function testDirection(parsed, entry) {
                        // Set direction as a numerical value for easy parsing.
                        // Invert connection for RTL sliders, so that the proper
                        // handles get the connect/background classes.
                        switch (entry) {
                            case "ltr":
                                parsed.dir = 0;
                                break;
                            case "rtl":
                                parsed.dir = 1;
                                parsed.connect = [0, 2, 1, 3][parsed.connect];
                                break;
                            default:
                                throw new Error(
                                    "noUiSlider: 'direction' option was not recognized."
                                );
                        }
                    }

                    function testBehaviour(parsed, entry) {
                        // Make sure the input is a string.
                        if (typeof entry !== "string") {
                            throw new Error(
                                "noUiSlider: 'behaviour' must be a string containing options."
                            );
                        }

                        // Check if the string contains any keywords.
                        // None are required.
                        var tap = entry.indexOf("tap") >= 0,
                            drag = entry.indexOf("drag") >= 0,
                            fixed = entry.indexOf("fixed") >= 0,
                            snap = entry.indexOf("snap") >= 0,
                            hover = entry.indexOf("hover") >= 0;

                        // Fix #472
                        if (drag && !parsed.connect) {
                            throw new Error(
                                "noUiSlider: 'drag' behaviour must be used with 'connect': true."
                            );
                        }

                        parsed.events = {
                            tap: tap || snap,
                            drag: drag,
                            fixed: fixed,
                            snap: snap,
                            hover: hover,
                        };
                    }

                    function testTooltips(parsed, entry) {
                        var i;

                        if (entry === false) {
                            return;
                        } else if (entry === true) {
                            parsed.tooltips = [];

                            for (i = 0; i < parsed.handles; i++) {
                                parsed.tooltips.push(true);
                            }
                        } else {
                            parsed.tooltips = asArray(entry);

                            if (parsed.tooltips.length !== parsed.handles) {
                                throw new Error(
                                    "noUiSlider: must pass a formatter for all handles."
                                );
                            }

                            parsed.tooltips.forEach(function (formatter) {
                                if (
                                    typeof formatter !== "boolean" &&
                                    (typeof formatter !== "object" ||
                                        typeof formatter.to !== "function")
                                ) {
                                    throw new Error(
                                        "noUiSlider: 'tooltips' must be passed a formatter or 'false'."
                                    );
                                }
                            });
                        }
                    }

                    function testFormat(parsed, entry) {
                        parsed.format = entry;

                        // Any object with a to and from method is supported.
                        if (
                            typeof entry.to === "function" &&
                            typeof entry.from === "function"
                        ) {
                            return true;
                        }

                        throw new Error(
                            "noUiSlider: 'format' requires 'to' and 'from' methods."
                        );
                    }

                    function testCssPrefix(parsed, entry) {
                        if (
                            entry !== undefined &&
                            typeof entry !== "string" &&
                            entry !== false
                        ) {
                            throw new Error(
                                "noUiSlider: 'cssPrefix' must be a string or `false`."
                            );
                        }

                        parsed.cssPrefix = entry;
                    }

                    function testCssClasses(parsed, entry) {
                        if (entry !== undefined && typeof entry !== "object") {
                            throw new Error(
                                "noUiSlider: 'cssClasses' must be an object."
                            );
                        }

                        if (typeof parsed.cssPrefix === "string") {
                            parsed.cssClasses = {};

                            for (var key in entry) {
                                if (!entry.hasOwnProperty(key)) {
                                    continue;
                                }

                                parsed.cssClasses[key] =
                                    parsed.cssPrefix + entry[key];
                            }
                        } else {
                            parsed.cssClasses = entry;
                        }
                    }

                    // Test all developer settings and parse to assumption-safe values.
                    function testOptions(options) {
                        // To prove a fix for #537, freeze options here.
                        // If the object is modified, an error will be thrown.
                        // Object.freeze(options);

                        var parsed = {
                                margin: 0,
                                limit: 0,
                                animate: true,
                                animationDuration: 300,
                                format: defaultFormatter,
                            },
                            tests;

                        // Tests are executed in the order they are presented here.
                        tests = {
                            step: { r: false, t: testStep },
                            start: { r: true, t: testStart },
                            connect: { r: true, t: testConnect },
                            direction: { r: true, t: testDirection },
                            snap: { r: false, t: testSnap },
                            animate: { r: false, t: testAnimate },
                            animationDuration: {
                                r: false,
                                t: testAnimationDuration,
                            },
                            range: { r: true, t: testRange },
                            orientation: { r: false, t: testOrientation },
                            margin: { r: false, t: testMargin },
                            limit: { r: false, t: testLimit },
                            behaviour: { r: true, t: testBehaviour },
                            format: { r: false, t: testFormat },
                            tooltips: { r: false, t: testTooltips },
                            cssPrefix: { r: false, t: testCssPrefix },
                            cssClasses: { r: false, t: testCssClasses },
                        };

                        var defaults = {
                            connect: false,
                            direction: "ltr",
                            behaviour: "tap",
                            orientation: "horizontal",
                            cssPrefix: "noUi-",
                            cssClasses: {
                                target: "target",
                                base: "base",
                                origin: "origin",
                                handle: "handle",
                                handleLower: "handle-lower",
                                handleUpper: "handle-upper",
                                horizontal: "horizontal",
                                vertical: "vertical",
                                background: "background",
                                connect: "connect",
                                ltr: "ltr",
                                rtl: "rtl",
                                draggable: "draggable",
                                drag: "state-drag",
                                tap: "state-tap",
                                active: "active",
                                stacking: "stacking",
                                tooltip: "tooltip",
                                pips: "pips",
                                pipsHorizontal: "pips-horizontal",
                                pipsVertical: "pips-vertical",
                                marker: "marker",
                                markerHorizontal: "marker-horizontal",
                                markerVertical: "marker-vertical",
                                markerNormal: "marker-normal",
                                markerLarge: "marker-large",
                                markerSub: "marker-sub",
                                value: "value",
                                valueHorizontal: "value-horizontal",
                                valueVertical: "value-vertical",
                                valueNormal: "value-normal",
                                valueLarge: "value-large",
                                valueSub: "value-sub",
                            },
                        };

                        // Run all options through a testing mechanism to ensure correct
                        // input. It should be noted that options might get modified to
                        // be handled properly. E.g. wrapping integers in arrays.
                        Object.keys(tests).forEach(function (name) {
                            // If the option isn't set, but it is required, throw an error.
                            if (
                                options[name] === undefined &&
                                defaults[name] === undefined
                            ) {
                                if (tests[name].r) {
                                    throw new Error(
                                        "noUiSlider: '" +
                                            name +
                                            "' is required."
                                    );
                                }

                                return true;
                            }

                            tests[name].t(
                                parsed,
                                options[name] === undefined
                                    ? defaults[name]
                                    : options[name]
                            );
                        });

                        // Forward pips options
                        parsed.pips = options.pips;

                        // Pre-define the styles.
                        parsed.style = parsed.ort ? "top" : "left";

                        return parsed;
                    }

                    function closure(target, options, originalOptions) {
                        var actions = getActions(),
                            // All variables local to 'closure' are prefixed with 'scope_'
                            scope_Target = target,
                            scope_Locations = [-1, -1],
                            scope_Base,
                            scope_Handles,
                            scope_Spectrum = options.spectrum,
                            scope_Values = [],
                            scope_Events = {},
                            scope_Self;

                        // Delimit proposed values for handle positions.
                        function getPositions(a, b, delimit) {
                            // Add movement to current position.
                            var c = a + b[0],
                                d = a + b[1];

                            // Only alter the other position on drag,
                            // not on standard sliding.
                            if (delimit) {
                                if (c < 0) {
                                    d += Math.abs(c);
                                }
                                if (d > 100) {
                                    c -= d - 100;
                                }

                                // Limit values to 0 and 100.
                                return [limit(c), limit(d)];
                            }

                            return [c, d];
                        }

                        // Provide a clean event with standardized offset values.
                        function fixEvent(e, pageOffset) {
                            // Prevent scrolling and panning on touch events, while
                            // attempting to slide. The tap event also depends on this.
                            e.preventDefault();

                            // Filter the event to register the type, which can be
                            // touch, mouse or pointer. Offset changes need to be
                            // made on an event specific basis.
                            var touch = e.type.indexOf("touch") === 0,
                                mouse = e.type.indexOf("mouse") === 0,
                                pointer = e.type.indexOf("pointer") === 0,
                                x,
                                y,
                                event = e;

                            // IE10 implemented pointer events with a prefix;
                            if (e.type.indexOf("MSPointer") === 0) {
                                pointer = true;
                            }

                            if (touch) {
                                // backported from https://github.com/leongersen/noUiSlider/pull/649/commits/2ecb5e138e7743049bdea5e86286db6e3815d8d6
                                // Fix bug when user touches with two or more fingers on mobile devices.
                                // It's usefull when you have two or more sliders on one page,
                                // that can be touched simultaneously.
                                if (e.touches.length > 1) {
                                    return false;
                                }

                                // noUiSlider supports one movement at a time,
                                // so we can select the first 'changedTouch'.
                                x = e.changedTouches[0].pageX;
                                y = e.changedTouches[0].pageY;
                            }

                            pageOffset = pageOffset || getPageOffset();

                            if (mouse || pointer) {
                                x = e.clientX + pageOffset.x;
                                y = e.clientY + pageOffset.y;
                            }

                            event.pageOffset = pageOffset;
                            event.points = [x, y];
                            event.cursor = mouse || pointer; // Fix #435

                            return event;
                        }

                        // Append a handle to the base.
                        function addHandle(direction, index) {
                            var origin = document.createElement("div"),
                                handle = document.createElement("div"),
                                classModifier = [
                                    options.cssClasses.handleLower,
                                    options.cssClasses.handleUpper,
                                ];

                            if (direction) {
                                classModifier.reverse();
                            }

                            addClass(handle, options.cssClasses.handle);
                            addClass(handle, classModifier[index]);

                            addClass(origin, options.cssClasses.origin);
                            origin.appendChild(handle);

                            return origin;
                        }

                        // Add the proper connection classes.
                        function addConnection(connect, target, handles) {
                            // Apply the required connection classes to the elements
                            // that need them. Some classes are made up for several
                            // segments listed in the class list, to allow easy
                            // renaming and provide a minor compression benefit.
                            switch (connect) {
                                case 1:
                                    addClass(
                                        target,
                                        options.cssClasses.connect
                                    );
                                    addClass(
                                        handles[0],
                                        options.cssClasses.background
                                    );
                                    break;
                                case 3:
                                    addClass(
                                        handles[1],
                                        options.cssClasses.background
                                    );
                                /* falls through */
                                case 2:
                                    addClass(
                                        handles[0],
                                        options.cssClasses.connect
                                    );
                                /* falls through */
                                case 0:
                                    addClass(
                                        target,
                                        options.cssClasses.background
                                    );
                                    break;
                            }
                        }

                        // Add handles to the slider base.
                        function addHandles(nrHandles, direction, base) {
                            var index,
                                handles = [];

                            // Append handles.
                            for (index = 0; index < nrHandles; index += 1) {
                                // Keep a list of all added handles.
                                handles.push(
                                    base.appendChild(
                                        addHandle(direction, index)
                                    )
                                );
                            }

                            return handles;
                        }

                        // Initialize a single slider.
                        function addSlider(direction, orientation, target) {
                            // Apply classes and data to the target.
                            addClass(target, options.cssClasses.target);

                            if (direction === 0) {
                                addClass(target, options.cssClasses.ltr);
                            } else {
                                addClass(target, options.cssClasses.rtl);
                            }

                            if (orientation === 0) {
                                addClass(target, options.cssClasses.horizontal);
                            } else {
                                addClass(target, options.cssClasses.vertical);
                            }

                            var div = document.createElement("div");
                            addClass(div, options.cssClasses.base);
                            target.appendChild(div);
                            return div;
                        }

                        function addTooltip(handle, index) {
                            if (!options.tooltips[index]) {
                                return false;
                            }

                            var element = document.createElement("div");
                            element.className = options.cssClasses.tooltip;
                            return handle.firstChild.appendChild(element);
                        }

                        // The tooltips option is a shorthand for using the 'update' event.
                        function tooltips() {
                            if (options.dir) {
                                options.tooltips.reverse();
                            }

                            // Tooltips are added with options.tooltips in original order.
                            var tips = scope_Handles.map(addTooltip);

                            if (options.dir) {
                                tips.reverse();
                                options.tooltips.reverse();
                            }

                            bindEvent("update", function (f, o, r) {
                                if (tips[o]) {
                                    tips[o].innerHTML =
                                        options.tooltips[o] === true
                                            ? f[o]
                                            : options.tooltips[o].to(r[o]);
                                }
                            });
                        }

                        function getGroup(mode, values, stepped) {
                            // Use the range.
                            if (mode === "range" || mode === "steps") {
                                return scope_Spectrum.xVal;
                            }

                            if (mode === "count") {
                                // Divide 0 - 100 in 'count' parts.
                                var spread = 100 / (values - 1),
                                    v,
                                    i = 0;
                                values = [];

                                // List these parts and have them handled as 'positions'.
                                while ((v = i++ * spread) <= 100) {
                                    values.push(v);
                                }

                                mode = "positions";
                            }

                            if (mode === "positions") {
                                // Map all percentages to on-range values.
                                return values.map(function (value) {
                                    return scope_Spectrum.fromStepping(
                                        stepped
                                            ? scope_Spectrum.getStep(value)
                                            : value
                                    );
                                });
                            }

                            if (mode === "values") {
                                // If the value must be stepped, it needs to be converted to a percentage first.
                                if (stepped) {
                                    return values.map(function (value) {
                                        // Convert to percentage, apply step, return to value.
                                        return scope_Spectrum.fromStepping(
                                            scope_Spectrum.getStep(
                                                scope_Spectrum.toStepping(value)
                                            )
                                        );
                                    });
                                }

                                // Otherwise, we can simply use the values.
                                return values;
                            }
                        }

                        function generateSpread(density, mode, group) {
                            function safeIncrement(value, increment) {
                                // Avoid floating point variance by dropping the smallest decimal places.
                                return (value + increment).toFixed(7) / 1;
                            }

                            var originalSpectrumDirection =
                                    scope_Spectrum.direction,
                                indexes = {},
                                firstInRange = scope_Spectrum.xVal[0],
                                lastInRange =
                                    scope_Spectrum.xVal[
                                        scope_Spectrum.xVal.length - 1
                                    ],
                                ignoreFirst = false,
                                ignoreLast = false,
                                prevPct = 0;

                            // This function loops the spectrum in an ltr linear fashion,
                            // while the toStepping method is direction aware. Trick it into
                            // believing it is ltr.
                            scope_Spectrum.direction = 0;

                            // Create a copy of the group, sort it and filter away all duplicates.
                            group = unique(
                                group.slice().sort(function (a, b) {
                                    return a - b;
                                })
                            );

                            // Make sure the range starts with the first element.
                            if (group[0] !== firstInRange) {
                                group.unshift(firstInRange);
                                ignoreFirst = true;
                            }

                            // Likewise for the last one.
                            if (group[group.length - 1] !== lastInRange) {
                                group.push(lastInRange);
                                ignoreLast = true;
                            }

                            group.forEach(function (current, index) {
                                // Get the current step and the lower + upper positions.
                                var step,
                                    i,
                                    q,
                                    low = current,
                                    high = group[index + 1],
                                    newPct,
                                    pctDifference,
                                    pctPos,
                                    type,
                                    steps,
                                    realSteps,
                                    stepsize;

                                // When using 'steps' mode, use the provided steps.
                                // Otherwise, we'll step on to the next subrange.
                                if (mode === "steps") {
                                    step = scope_Spectrum.xNumSteps[index];
                                }

                                // Default to a 'full' step.
                                if (!step) {
                                    step = high - low;
                                }

                                // Low can be 0, so test for false. If high is undefined,
                                // we are at the last subrange. Index 0 is already handled.
                                if (low === false || high === undefined) {
                                    return;
                                }

                                // Find all steps in the subrange.
                                for (
                                    i = low;
                                    i <= high;
                                    i = safeIncrement(i, step)
                                ) {
                                    // Get the percentage value for the current step,
                                    // calculate the size for the subrange.
                                    newPct = scope_Spectrum.toStepping(i);
                                    pctDifference = newPct - prevPct;

                                    steps = pctDifference / density;
                                    realSteps = Math.round(steps);

                                    // This ratio represents the ammount of percentage-space a point indicates.
                                    // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-devided.
                                    // Round the percentage offset to an even number, then divide by two
                                    // to spread the offset on both sides of the range.
                                    stepsize = pctDifference / realSteps;

                                    // Divide all points evenly, adding the correct number to this subrange.
                                    // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                                    for (q = 1; q <= realSteps; q += 1) {
                                        // The ratio between the rounded value and the actual size might be ~1% off.
                                        // Correct the percentage offset by the number of points
                                        // per subrange. density = 1 will result in 100 points on the
                                        // full range, 2 for 50, 4 for 25, etc.
                                        pctPos = prevPct + q * stepsize;
                                        indexes[pctPos.toFixed(5)] = ["x", 0];
                                    }

                                    // Determine the point type.
                                    type =
                                        group.indexOf(i) > -1
                                            ? 1
                                            : mode === "steps"
                                            ? 2
                                            : 0;

                                    // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                                    if (!index && ignoreFirst) {
                                        type = 0;
                                    }

                                    if (!(i === high && ignoreLast)) {
                                        // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                                        indexes[newPct.toFixed(5)] = [i, type];
                                    }

                                    // Update the percentage count.
                                    prevPct = newPct;
                                }
                            });

                            // Reset the spectrum.
                            scope_Spectrum.direction =
                                originalSpectrumDirection;

                            return indexes;
                        }

                        function addMarking(spread, filterFunc, formatter) {
                            var element = document.createElement("div"),
                                out = "",
                                valueSizeClasses = [
                                    options.cssClasses.valueNormal,
                                    options.cssClasses.valueLarge,
                                    options.cssClasses.valueSub,
                                ],
                                markerSizeClasses = [
                                    options.cssClasses.markerNormal,
                                    options.cssClasses.markerLarge,
                                    options.cssClasses.markerSub,
                                ],
                                valueOrientationClasses = [
                                    options.cssClasses.valueHorizontal,
                                    options.cssClasses.valueVertical,
                                ],
                                markerOrientationClasses = [
                                    options.cssClasses.markerHorizontal,
                                    options.cssClasses.markerVertical,
                                ];

                            addClass(element, options.cssClasses.pips);
                            addClass(
                                element,
                                options.ort === 0
                                    ? options.cssClasses.pipsHorizontal
                                    : options.cssClasses.pipsVertical
                            );

                            function getClasses(type, source) {
                                var a = source === options.cssClasses.value,
                                    orientationClasses = a
                                        ? valueOrientationClasses
                                        : markerOrientationClasses,
                                    sizeClasses = a
                                        ? valueSizeClasses
                                        : markerSizeClasses;

                                return (
                                    source +
                                    " " +
                                    orientationClasses[options.ort] +
                                    " " +
                                    sizeClasses[type]
                                );
                            }

                            function getTags(offset, source, values) {
                                return (
                                    'class="' +
                                    getClasses(values[1], source) +
                                    '" style="' +
                                    options.style +
                                    ": " +
                                    offset +
                                    '%"'
                                );
                            }

                            function addSpread(offset, values) {
                                if (scope_Spectrum.direction) {
                                    offset = 100 - offset;
                                }

                                // Apply the filter function, if it is set.
                                values[1] =
                                    values[1] && filterFunc
                                        ? filterFunc(values[0], values[1])
                                        : values[1];

                                // Add a marker for every point
                                out +=
                                    "<div " +
                                    getTags(
                                        offset,
                                        options.cssClasses.marker,
                                        values
                                    ) +
                                    "></div>";

                                // Values are only appended for points marked '1' or '2'.
                                if (values[1]) {
                                    out +=
                                        "<div " +
                                        getTags(
                                            offset,
                                            options.cssClasses.value,
                                            values
                                        ) +
                                        ">" +
                                        formatter.to(values[0]) +
                                        "</div>";
                                }
                            }

                            // Append all points.
                            Object.keys(spread).forEach(function (a) {
                                addSpread(a, spread[a]);
                            });

                            element.innerHTML = out;

                            return element;
                        }

                        function pips(grid) {
                            var mode = grid.mode,
                                density = grid.density || 1,
                                filter = grid.filter || false,
                                values = grid.values || false,
                                stepped = grid.stepped || false,
                                group = getGroup(mode, values, stepped),
                                spread = generateSpread(density, mode, group),
                                format = grid.format || {
                                    to: Math.round,
                                };

                            return scope_Target.appendChild(
                                addMarking(spread, filter, format)
                            );
                        }

                        // Shorthand for base dimensions.
                        function baseSize() {
                            var rect = scope_Base.getBoundingClientRect(),
                                alt =
                                    "offset" + ["Width", "Height"][options.ort];
                            return options.ort === 0
                                ? rect.width || scope_Base[alt]
                                : rect.height || scope_Base[alt];
                        }

                        // External event handling
                        function fireEvent(event, handleNumber, tap) {
                            var i;

                            // During initialization, do not fire events.
                            for (i = 0; i < options.handles; i++) {
                                if (scope_Locations[i] === -1) {
                                    return;
                                }
                            }

                            if (
                                handleNumber !== undefined &&
                                options.handles !== 1
                            ) {
                                handleNumber = Math.abs(
                                    handleNumber - options.dir
                                );
                            }

                            Object.keys(scope_Events).forEach(function (
                                targetEvent
                            ) {
                                var eventType = targetEvent.split(".")[0];

                                if (event === eventType) {
                                    scope_Events[targetEvent].forEach(function (
                                        callback
                                    ) {
                                        callback.call(
                                            // Use the slider public API as the scope ('this')
                                            scope_Self,
                                            // Return values as array, so arg_1[arg_2] is always valid.
                                            asArray(valueGet()),
                                            // Handle index, 0 or 1
                                            handleNumber,
                                            // Unformatted slider values
                                            asArray(
                                                inSliderOrder(
                                                    Array.prototype.slice.call(
                                                        scope_Values
                                                    )
                                                )
                                            ),
                                            // Event is fired by tap, true or false
                                            tap || false,
                                            // Left offset of the handle, in relation to the slider
                                            scope_Locations
                                        );
                                    });
                                }
                            });
                        }

                        // Returns the input array, respecting the slider direction configuration.
                        function inSliderOrder(values) {
                            // If only one handle is used, return a single value.
                            if (values.length === 1) {
                                return values[0];
                            }

                            if (options.dir) {
                                return values.reverse();
                            }

                            return values;
                        }

                        // Handler for attaching events trough a proxy.
                        function attach(events, element, callback, data) {
                            // This function can be used to 'filter' events to the slider.
                            // element is a node, not a nodeList

                            var method = function (e) {
                                    if (scope_Target.hasAttribute("disabled")) {
                                        return false;
                                    }

                                    // Stop if an active 'tap' transition is taking place.
                                    if (
                                        hasClass(
                                            scope_Target,
                                            options.cssClasses.tap
                                        )
                                    ) {
                                        return false;
                                    }

                                    e = fixEvent(e, data.pageOffset);

                                    // Ignore right or middle clicks on start #454
                                    if (
                                        events === actions.start &&
                                        e.buttons !== undefined &&
                                        e.buttons > 1
                                    ) {
                                        return false;
                                    }

                                    // Ignore right or middle clicks on start #454
                                    if (data.hover && e.buttons) {
                                        return false;
                                    }

                                    e.calcPoint = e.points[options.ort];

                                    // Call the event handler with the event [ and additional data ].
                                    callback(e, data);
                                },
                                methods = [];

                            // Bind a closure on the target for every event type.
                            events.split(" ").forEach(function (eventName) {
                                element.addEventListener(
                                    eventName,
                                    method,
                                    false
                                );
                                methods.push([eventName, method]);
                            });

                            return methods;
                        }

                        // Handle movement on document for handle and range drag.
                        function move(event, data) {
                            // Fix #498
                            // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
                            // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
                            // IE9 has .buttons and .which zero on mousemove.
                            // Firefox breaks the spec MDN defines.
                            if (
                                navigator.appVersion.indexOf("MSIE 9") === -1 &&
                                event.buttons === 0 &&
                                data.buttonsProperty !== 0
                            ) {
                                return end(event, data);
                            }

                            var handles = data.handles || scope_Handles,
                                positions,
                                state = false,
                                proposal =
                                    ((event.calcPoint - data.start) * 100) /
                                    data.baseSize,
                                handleNumber =
                                    handles[0] === scope_Handles[0] ? 0 : 1,
                                i;

                            // Calculate relative positions for the handles.
                            positions = getPositions(
                                proposal,
                                data.positions,
                                handles.length > 1
                            );

                            state = setHandle(
                                handles[0],
                                positions[handleNumber],
                                handles.length === 1
                            );

                            if (handles.length > 1) {
                                state =
                                    setHandle(
                                        handles[1],
                                        positions[handleNumber ? 0 : 1],
                                        false
                                    ) || state;

                                if (state) {
                                    // fire for both handles
                                    for (i = 0; i < data.handles.length; i++) {
                                        fireEvent("slide", i);
                                    }
                                }
                            } else if (state) {
                                // Fire for a single handle
                                fireEvent("slide", handleNumber);
                            }
                        }

                        // Unbind move events on document, call callbacks.
                        function end(event, data) {
                            // The handle is no longer active, so remove the class.
                            var active = scope_Base.querySelector(
                                    "." + options.cssClasses.active
                                ),
                                handleNumber =
                                    data.handles[0] === scope_Handles[0]
                                        ? 0
                                        : 1;

                            if (active !== null) {
                                removeClass(active, options.cssClasses.active);
                            }

                            // Remove cursor styles and text-selection events bound to the body.
                            if (event.cursor) {
                                document.body.style.cursor = "";
                                document.body.removeEventListener(
                                    "selectstart",
                                    document.body.noUiListener
                                );
                            }

                            var d = document.documentElement;

                            // Unbind the move and end events, which are added on 'start'.
                            d.noUiListeners.forEach(function (c) {
                                d.removeEventListener(c[0], c[1]);
                            });

                            // Remove dragging class.
                            removeClass(scope_Target, options.cssClasses.drag);

                            // Fire the change and set events.
                            fireEvent("set", handleNumber);
                            fireEvent("change", handleNumber);

                            // If this is a standard handle movement, fire the end event.
                            if (data.handleNumber !== undefined) {
                                fireEvent("end", data.handleNumber);
                            }
                        }

                        // Fire 'end' when a mouse or pen leaves the document.
                        function documentLeave(event, data) {
                            if (
                                event.type === "mouseout" &&
                                event.target.nodeName === "HTML" &&
                                event.relatedTarget === null
                            ) {
                                end(event, data);
                            }
                        }

                        // Bind move events on document.
                        function start(event, data) {
                            var d = document.documentElement;

                            // Mark the handle as 'active' so it can be styled.
                            if (data.handles.length === 1) {
                                // Support 'disabled' handles
                                if (data.handles[0].hasAttribute("disabled")) {
                                    return false;
                                }

                                addClass(
                                    data.handles[0].children[0],
                                    options.cssClasses.active
                                );
                            }

                            // Fix #551, where a handle gets selected instead of dragged.
                            event.preventDefault();

                            // A drag should never propagate up to the 'tap' event.
                            event.stopPropagation();

                            // Attach the move and end events.
                            var moveEvent = attach(actions.move, d, move, {
                                    start: event.calcPoint,
                                    baseSize: baseSize(),
                                    pageOffset: event.pageOffset,
                                    handles: data.handles,
                                    handleNumber: data.handleNumber,
                                    buttonsProperty: event.buttons,
                                    positions: [
                                        scope_Locations[0],
                                        scope_Locations[
                                            scope_Handles.length - 1
                                        ],
                                    ],
                                }),
                                endEvent = attach(actions.end, d, end, {
                                    handles: data.handles,
                                    handleNumber: data.handleNumber,
                                });

                            var outEvent = attach(
                                "mouseout",
                                d,
                                documentLeave,
                                {
                                    handles: data.handles,
                                    handleNumber: data.handleNumber,
                                }
                            );

                            d.noUiListeners = moveEvent.concat(
                                endEvent,
                                outEvent
                            );

                            // Text selection isn't an issue on touch devices,
                            // so adding cursor styles can be skipped.
                            if (event.cursor) {
                                // Prevent the 'I' cursor and extend the range-drag cursor.
                                document.body.style.cursor = getComputedStyle(
                                    event.target
                                ).cursor;

                                // Mark the target with a dragging state.
                                if (scope_Handles.length > 1) {
                                    addClass(
                                        scope_Target,
                                        options.cssClasses.drag
                                    );
                                }

                                var f = function () {
                                    return false;
                                };

                                document.body.noUiListener = f;

                                // Prevent text selection when dragging the handles.
                                document.body.addEventListener(
                                    "selectstart",
                                    f,
                                    false
                                );
                            }

                            if (data.handleNumber !== undefined) {
                                fireEvent("start", data.handleNumber);
                            }
                        }

                        // Move closest handle to tapped location.
                        function tap(event) {
                            var location = event.calcPoint,
                                total = 0,
                                handleNumber,
                                to;

                            // The tap event shouldn't propagate up and cause 'edge' to run.
                            event.stopPropagation();

                            // Add up the handle offsets.
                            scope_Handles.forEach(function (a) {
                                total += offset(a)[options.style];
                            });

                            // Find the handle closest to the tapped position.
                            handleNumber =
                                location < total / 2 ||
                                scope_Handles.length === 1
                                    ? 0
                                    : 1;

                            // Check if handler is not disablet if yes set number to the next handler
                            if (
                                scope_Handles[handleNumber].hasAttribute(
                                    "disabled"
                                )
                            ) {
                                handleNumber = handleNumber ? 0 : 1;
                            }

                            location -= offset(scope_Base)[options.style];

                            // Calculate the new position.
                            to = (location * 100) / baseSize();

                            if (!options.events.snap) {
                                // Flag the slider as it is now in a transitional state.
                                // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
                                addClassFor(
                                    scope_Target,
                                    options.cssClasses.tap,
                                    options.animationDuration
                                );
                            }

                            // Support 'disabled' handles
                            if (
                                scope_Handles[handleNumber].hasAttribute(
                                    "disabled"
                                )
                            ) {
                                return false;
                            }

                            // Find the closest handle and calculate the tapped point.
                            // The set handle to the new position.
                            setHandle(scope_Handles[handleNumber], to);

                            fireEvent("slide", handleNumber, true);
                            fireEvent("set", handleNumber, true);
                            fireEvent("change", handleNumber, true);

                            if (options.events.snap) {
                                start(event, {
                                    handles: [scope_Handles[handleNumber]],
                                });
                            }
                        }

                        // Fires a 'hover' event for a hovered mouse/pen position.
                        function hover(event) {
                            var location =
                                    event.calcPoint -
                                    offset(scope_Base)[options.style],
                                to = scope_Spectrum.getStep(
                                    (location * 100) / baseSize()
                                ),
                                value = scope_Spectrum.fromStepping(to);

                            Object.keys(scope_Events).forEach(function (
                                targetEvent
                            ) {
                                if ("hover" === targetEvent.split(".")[0]) {
                                    scope_Events[targetEvent].forEach(function (
                                        callback
                                    ) {
                                        callback.call(scope_Self, value);
                                    });
                                }
                            });
                        }

                        // Attach events to several slider parts.
                        function events(behaviour) {
                            // Attach the standard drag event to the handles.
                            if (!behaviour.fixed) {
                                scope_Handles.forEach(function (handle, index) {
                                    // These events are only bound to the visual handle
                                    // element, not the 'real' origin element.
                                    attach(
                                        actions.start,
                                        handle.children[0],
                                        start,
                                        {
                                            handles: [handle],
                                            handleNumber: index,
                                        }
                                    );
                                });
                            }

                            // Attach the tap event to the slider base.
                            if (behaviour.tap) {
                                attach(actions.start, scope_Base, tap, {
                                    handles: scope_Handles,
                                });
                            }

                            // Fire hover events
                            if (behaviour.hover) {
                                attach(actions.move, scope_Base, hover, {
                                    hover: true,
                                });
                            }

                            // Make the range draggable.
                            if (behaviour.drag) {
                                var drag = [
                                    scope_Base.querySelector(
                                        "." + options.cssClasses.connect
                                    ),
                                ];
                                addClass(drag[0], options.cssClasses.draggable);

                                // When the range is fixed, the entire range can
                                // be dragged by the handles. The handle in the first
                                // origin will propagate the start event upward,
                                // but it needs to be bound manually on the other.
                                if (behaviour.fixed) {
                                    drag.push(
                                        scope_Handles[
                                            drag[0] === scope_Handles[0] ? 1 : 0
                                        ].children[0]
                                    );
                                }

                                drag.forEach(function (element) {
                                    attach(actions.start, element, start, {
                                        handles: scope_Handles,
                                    });
                                });
                            }
                        }

                        // Test suggested values and apply margin, step.
                        function setHandle(handle, to, noLimitOption) {
                            var trigger = handle !== scope_Handles[0] ? 1 : 0,
                                lowerMargin =
                                    scope_Locations[0] + options.margin,
                                upperMargin =
                                    scope_Locations[1] - options.margin,
                                lowerLimit = scope_Locations[0] + options.limit,
                                upperLimit = scope_Locations[1] - options.limit;

                            // For sliders with multiple handles,
                            // limit movement to the other handle.
                            // Apply the margin option by adding it to the handle positions.
                            if (scope_Handles.length > 1) {
                                to = trigger
                                    ? Math.max(to, lowerMargin)
                                    : Math.min(to, upperMargin);
                            }

                            // The limit option has the opposite effect, limiting handles to a
                            // maximum distance from another. Limit must be > 0, as otherwise
                            // handles would be unmoveable. 'noLimitOption' is set to 'false'
                            // for the .val() method, except for pass 4/4.
                            if (
                                noLimitOption !== false &&
                                options.limit &&
                                scope_Handles.length > 1
                            ) {
                                to = trigger
                                    ? Math.min(to, lowerLimit)
                                    : Math.max(to, upperLimit);
                            }

                            // Handle the step option.
                            to = scope_Spectrum.getStep(to);

                            // Limit percentage to the 0 - 100 range
                            to = limit(to);

                            // Return false if handle can't move
                            if (to === scope_Locations[trigger]) {
                                return false;
                            }

                            // Set the handle to the new position.
                            // Use requestAnimationFrame for efficient painting.
                            // No significant effect in Chrome, Edge sees dramatic
                            // performace improvements.
                            if (window.requestAnimationFrame) {
                                window.requestAnimationFrame(function () {
                                    handle.style[options.style] = to + "%";
                                });
                            } else {
                                handle.style[options.style] = to + "%";
                            }

                            // Force proper handle stacking
                            if (!handle.previousSibling) {
                                removeClass(
                                    handle,
                                    options.cssClasses.stacking
                                );
                                if (to > 50) {
                                    addClass(
                                        handle,
                                        options.cssClasses.stacking
                                    );
                                }
                            }

                            // Update locations.
                            scope_Locations[trigger] = to;

                            // Convert the value to the slider stepping/range.
                            scope_Values[trigger] =
                                scope_Spectrum.fromStepping(to);

                            fireEvent("update", trigger);

                            return true;
                        }

                        // Loop values from value method and apply them.
                        function setValues(count, values) {
                            var i, trigger, to;

                            // With the limit option, we'll need another limiting pass.
                            if (options.limit) {
                                count += 1;
                            }

                            // If there are multiple handles to be set run the setting
                            // mechanism twice for the first handle, to make sure it
                            // can be bounced of the second one properly.
                            for (i = 0; i < count; i += 1) {
                                trigger = i % 2;

                                // Get the current argument from the array.
                                to = values[trigger];

                                // Setting with null indicates an 'ignore'.
                                // Inputting 'false' is invalid.
                                if (to !== null && to !== false) {
                                    // If a formatted number was passed, attemt to decode it.
                                    if (typeof to === "number") {
                                        to = String(to);
                                    }

                                    to = options.format.from(to);

                                    // Request an update for all links if the value was invalid.
                                    // Do so too if setting the handle fails.
                                    if (
                                        to === false ||
                                        isNaN(to) ||
                                        setHandle(
                                            scope_Handles[trigger],
                                            scope_Spectrum.toStepping(to),
                                            i === 3 - options.dir
                                        ) === false
                                    ) {
                                        fireEvent("update", trigger);
                                    }
                                }
                            }
                        }

                        // Set the slider value.
                        function valueSet(input, fireSetEvent) {
                            var count,
                                values = asArray(input),
                                i;

                            // Event fires by default
                            fireSetEvent =
                                fireSetEvent === undefined
                                    ? true
                                    : !!fireSetEvent;

                            // The RTL settings is implemented by reversing the front-end,
                            // internal mechanisms are the same.
                            if (options.dir && options.handles > 1) {
                                values.reverse();
                            }

                            // Animation is optional.
                            // Make sure the initial values where set before using animated placement.
                            if (options.animate && scope_Locations[0] !== -1) {
                                addClassFor(
                                    scope_Target,
                                    options.cssClasses.tap,
                                    options.animationDuration
                                );
                            }

                            // Determine how often to set the handles.
                            count = scope_Handles.length > 1 ? 3 : 1;

                            if (values.length === 1) {
                                count = 1;
                            }

                            setValues(count, values);

                            // Fire the 'set' event for both handles.
                            for (i = 0; i < scope_Handles.length; i++) {
                                // Fire the event only for handles that received a new value, as per #579
                                if (values[i] !== null && fireSetEvent) {
                                    fireEvent("set", i);
                                }
                            }
                        }

                        // Get the slider value.
                        function valueGet() {
                            var i,
                                retour = [];

                            // Get the value from all handles.
                            for (i = 0; i < options.handles; i += 1) {
                                retour[i] = options.format.to(scope_Values[i]);
                            }

                            return inSliderOrder(retour);
                        }

                        // Removes classes from the root and empties it.
                        function destroy() {
                            for (var key in options.cssClasses) {
                                if (!options.cssClasses.hasOwnProperty(key)) {
                                    continue;
                                }
                                removeClass(
                                    scope_Target,
                                    options.cssClasses[key]
                                );
                            }

                            while (scope_Target.firstChild) {
                                scope_Target.removeChild(
                                    scope_Target.firstChild
                                );
                            }

                            delete scope_Target.noUiSlider;
                        }

                        // Get the current step size for the slider.
                        function getCurrentStep() {
                            // Check all locations, map them to their stepping point.
                            // Get the step point, then find it in the input list.
                            var retour = scope_Locations.map(function (
                                location,
                                index
                            ) {
                                var step =
                                        scope_Spectrum.getApplicableStep(
                                            location
                                        ),
                                    // As per #391, the comparison for the decrement step can have some rounding issues.
                                    // Round the value to the precision used in the step.
                                    stepDecimals = countDecimals(
                                        String(step[2])
                                    ),
                                    // Get the current numeric value
                                    value = scope_Values[index],
                                    // To move the slider 'one step up', the current step value needs to be added.
                                    // Use null if we are at the maximum slider value.
                                    increment =
                                        location === 100 ? null : step[2],
                                    // Going 'one step down' might put the slider in a different sub-range, so we
                                    // need to switch between the current or the previous step.
                                    prev = Number(
                                        (value - step[2]).toFixed(stepDecimals)
                                    ),
                                    // If the value fits the step, return the current step value. Otherwise, use the
                                    // previous step. Return null if the slider is at its minimum value.
                                    decrement =
                                        location === 0
                                            ? null
                                            : prev >= step[1]
                                            ? step[2]
                                            : step[0] || false;

                                return [decrement, increment];
                            });

                            // Return values in the proper order.
                            return inSliderOrder(retour);
                        }

                        // Attach an event to this slider, possibly including a namespace
                        function bindEvent(namespacedEvent, callback) {
                            scope_Events[namespacedEvent] =
                                scope_Events[namespacedEvent] || [];
                            scope_Events[namespacedEvent].push(callback);

                            // If the event bound is 'update,' fire it immediately for all handles.
                            if (namespacedEvent.split(".")[0] === "update") {
                                scope_Handles.forEach(function (a, index) {
                                    fireEvent("update", index);
                                });
                            }
                        }

                        // Undo attachment of event
                        function removeEvent(namespacedEvent) {
                            var event =
                                    namespacedEvent &&
                                    namespacedEvent.split(".")[0],
                                namespace =
                                    event &&
                                    namespacedEvent.substring(event.length);

                            Object.keys(scope_Events).forEach(function (bind) {
                                var tEvent = bind.split(".")[0],
                                    tNamespace = bind.substring(tEvent.length);

                                if (
                                    (!event || event === tEvent) &&
                                    (!namespace || namespace === tNamespace)
                                ) {
                                    delete scope_Events[bind];
                                }
                            });
                        }

                        // Updateable: margin, limit, step, range, animate, snap
                        function updateOptions(optionsToUpdate, fireSetEvent) {
                            // Spectrum is created using the range, snap, direction and step options.
                            // 'snap' and 'step' can be updated, 'direction' cannot, due to event binding.
                            // If 'snap' and 'step' are not passed, they should remain unchanged.
                            var v = valueGet(),
                                newOptions = testOptions({
                                    start: [0, 0],
                                    margin: optionsToUpdate.margin,
                                    limit: optionsToUpdate.limit,
                                    step:
                                        optionsToUpdate.step === undefined
                                            ? options.singleStep
                                            : optionsToUpdate.step,
                                    range: optionsToUpdate.range,
                                    animate: optionsToUpdate.animate,
                                    snap:
                                        optionsToUpdate.snap === undefined
                                            ? options.snap
                                            : optionsToUpdate.snap,
                                });

                            ["margin", "limit", "range", "animate"].forEach(
                                function (name) {
                                    // Only change options that we're actually passed to update.
                                    if (optionsToUpdate[name] !== undefined) {
                                        options[name] = optionsToUpdate[name];
                                    }
                                }
                            );

                            // Save current spectrum direction as testOptions in testRange call
                            // doesn't rely on current direction
                            newOptions.spectrum.direction =
                                scope_Spectrum.direction;
                            scope_Spectrum = newOptions.spectrum;

                            // Invalidate the current positioning so valueSet forces an update.
                            scope_Locations = [-1, -1];
                            valueSet(optionsToUpdate.start || v, fireSetEvent);
                        }

                        // Throw an error if the slider was already initialized.
                        if (scope_Target.noUiSlider) {
                            throw new Error("Slider was already initialized.");
                        }

                        // Create the base element, initialise HTML and set classes.
                        // Add handles and links.
                        scope_Base = addSlider(
                            options.dir,
                            options.ort,
                            scope_Target
                        );
                        scope_Handles = addHandles(
                            options.handles,
                            options.dir,
                            scope_Base
                        );

                        // Set the connect classes.
                        addConnection(
                            options.connect,
                            scope_Target,
                            scope_Handles
                        );

                        if (options.pips) {
                            pips(options.pips);
                        }

                        if (options.tooltips) {
                            tooltips();
                        }

                        scope_Self = {
                            destroy: destroy,
                            steps: getCurrentStep,
                            on: bindEvent,
                            off: removeEvent,
                            get: valueGet,
                            set: valueSet,
                            updateOptions: updateOptions,
                            options: originalOptions, // Issue #600
                            target: scope_Target, // Issue #597
                            pips: pips, // Issue #594
                        };

                        // Attach user events.
                        events(options.events);

                        return scope_Self;
                    }

                    // Run the standard initializer
                    function initialize(target, originalOptions) {
                        if (!target.nodeName) {
                            throw new Error(
                                "noUiSlider.create requires a single element."
                            );
                        }

                        // Test the options and create the slider environment;
                        var options = testOptions(originalOptions, target),
                            slider = closure(target, options, originalOptions);

                        // Use the public value method to set the start values.
                        slider.set(options.start);

                        target.noUiSlider = slider;
                        return slider;
                    }

                    // Use an object instead of a function for future expansibility;
                    return {
                        create: initialize,
                    };
                });

                /***/
            },
            /* 577 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _findIndex = __webpack_require__(242);

                var _findIndex2 = _interopRequireDefault(_findIndex);

                var _map = __webpack_require__(185);

                var _map2 = _interopRequireDefault(_map);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _Selector = __webpack_require__(544);

                var _Selector2 = _interopRequireDefault(_Selector);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-sort-by-selector");
                /**
                 * Instantiate a dropdown element to choose the current targeted index
                 * @function sortBySelector
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {Array} options.indices Array of objects defining the different indices to choose from.
                 * @param  {string} options.indices[0].name Name of the index to target
                 * @param  {string} options.indices[0].label Label displayed in the dropdown
                 * @param  {boolean} [options.autoHideContainer=false] Hide the container when no results match
                 * @param  {Object} [options.cssClasses] CSS classes to be added
                 * @param  {string|string[]} [options.cssClasses.root] CSS classes added to the parent <select>
                 * @param  {string|string[]} [options.cssClasses.item] CSS classes added to each <option>
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nsortBySelector({\n  container,\n  indices,\n  [cssClasses.{root,item}={}],\n  [autoHideContainer=false]\n})";
                function sortBySelector() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        indices = _ref.indices,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? false
                                : _ref$autoHideContaine;

                    if (!container || !indices) {
                        throw new Error(usage);
                    }

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var Selector = _Selector2.default;
                    if (autoHideContainer === true) {
                        Selector = (0, _autoHideContainer2.default)(Selector);
                    }

                    var selectorOptions = (0, _map2.default)(
                        indices,
                        function (index) {
                            return { label: index.label, value: index.name };
                        }
                    );

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                    };

                    return {
                        init: function init(_ref2) {
                            var helper = _ref2.helper;

                            var currentIndex = helper.getIndex();
                            var isIndexInList =
                                (0, _findIndex2.default)(indices, {
                                    name: currentIndex,
                                }) !== -1;
                            if (!isIndexInList) {
                                throw new Error(
                                    "[sortBySelector]: Index " +
                                        currentIndex +
                                        " not present in `indices`"
                                );
                            }
                            this.setIndex = function (indexName) {
                                return helper.setIndex(indexName).search();
                            };
                        },
                        render: function render(_ref3) {
                            var helper = _ref3.helper,
                                results = _ref3.results;

                            _reactDom2.default.render(
                                _react2.default.createElement(Selector, {
                                    cssClasses: cssClasses,
                                    currentValue: helper.getIndex(),
                                    options: selectorOptions,
                                    setValue: this.setIndex,
                                    shouldAutoHideContainer:
                                        results.nbHits === 0,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = sortBySelector;

                /***/
            },
            /* 578 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _defaultTemplates = __webpack_require__(579);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _defaultLabels = __webpack_require__(580);

                var _defaultLabels2 = _interopRequireDefault(_defaultLabels);

                var _RefinementList = __webpack_require__(533);

                var _RefinementList2 = _interopRequireDefault(_RefinementList);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-star-rating");

                /**
                 * Instantiate a list of refinements based on a rating attribute
                 * The ratings must be integer values. You can still keep the precise float value in another attribute
                 * to be used in the custom ranking configuration. So that the actual hits ranking is precise.
                 * @function starRating
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} options.attributeName Name of the attribute for filtering
                 * @param  {number} [options.max] The maximum rating value
                 * @param  {Object} [options.labels] Labels used by the default template
                 * @param  {string} [options.labels.andUp] The label suffixed after each line
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header] Header template
                 * @param  {string|Function} [options.templates.item] Item template, provided with `name`, `count`, `isRefined`, `url` data properties
                 * @param  {string|Function} [options.templates.footer] Footer template
                 * @param  {Function} [options.transformData.item] Function to change the object passed to the `item` template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when no results match
                 * @param  {Object} [options.cssClasses] CSS classes to add to the wrapping elements
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.list] CSS class to add to the list element
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each item element
                 * @param  {string|string[]} [options.cssClasses.link] CSS class to add to each link element
                 * @param  {string|string[]} [options.cssClasses.disabledLink] CSS class to add to each disabled link (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.star] CSS class to add to each star element (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.emptyStar] CSS class to add to each empty star element (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.active] CSS class to add to each active element
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nstarRating({\n  container,\n  attributeName,\n  [ max=5 ],\n  [ cssClasses.{root,header,body,footer,list,item,active,link,disabledLink,star,emptyStar,count} ],\n  [ templates.{header,item,footer} ],\n  [ transformData.{item} ],\n  [ labels.{andUp} ],\n  [ autoHideContainer=true ],\n  [ collapsible=false ]\n})";
                function starRating(_ref) {
                    var container = _ref.container,
                        attributeName = _ref.attributeName,
                        _ref$max = _ref.max,
                        max = _ref$max === undefined ? 5 : _ref$max,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$labels = _ref.labels,
                        labels =
                            _ref$labels === undefined
                                ? _defaultLabels2.default
                                : _ref$labels,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        transformData = _ref.transformData,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine;

                    var containerNode = (0, _utils.getContainerNode)(container);
                    var RefinementList = (0, _headerFooter2.default)(
                        _RefinementList2.default
                    );
                    if (autoHideContainer === true) {
                        RefinementList = (0, _autoHideContainer2.default)(
                            RefinementList
                        );
                    }

                    if (!container || !attributeName) {
                        throw new Error(usage);
                    }

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        list: (0, _classnames2.default)(
                            bem("list"),
                            userCssClasses.list
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        link: (0, _classnames2.default)(
                            bem("link"),
                            userCssClasses.link
                        ),
                        disabledLink: (0, _classnames2.default)(
                            bem("link", "disabled"),
                            userCssClasses.disabledLink
                        ),
                        count: (0, _classnames2.default)(
                            bem("count"),
                            userCssClasses.count
                        ),
                        star: (0, _classnames2.default)(
                            bem("star"),
                            userCssClasses.star
                        ),
                        emptyStar: (0, _classnames2.default)(
                            bem("star", "empty"),
                            userCssClasses.emptyStar
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                    };

                    return {
                        getConfiguration: function getConfiguration() {
                            return { disjunctiveFacets: [attributeName] };
                        },

                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig,
                                helper = _ref2.helper;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                            this._toggleRefinement =
                                this._toggleRefinement.bind(this, helper);
                        },
                        render: function render(_ref3) {
                            var helper = _ref3.helper,
                                results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var facetValues = [];
                            var allValues = {};
                            for (var v = max - 1; v >= 0; --v) {
                                allValues[v] = 0;
                            }
                            results
                                .getFacetValues(attributeName)
                                .forEach(function (facet) {
                                    var val = Math.round(facet.name);
                                    if (!val || val > max - 1) {
                                        return;
                                    }
                                    for (var _v = val; _v >= 1; --_v) {
                                        allValues[_v] += facet.count;
                                    }
                                });
                            var refinedStar = this._getRefinedStar(helper);
                            for (var star = max - 1; star >= 1; --star) {
                                var count = allValues[star];
                                if (
                                    refinedStar &&
                                    star !== refinedStar &&
                                    count === 0
                                ) {
                                    // skip count==0 when at least 1 refinement is enabled
                                    // eslint-disable-next-line no-continue
                                    continue;
                                }
                                var stars = [];
                                for (var i = 1; i <= max; ++i) {
                                    stars.push(i <= star);
                                }
                                facetValues.push({
                                    stars: stars,
                                    name: String(star),
                                    count: count,
                                    isRefined: refinedStar === star,
                                    labels: labels,
                                });
                            }

                            // Bind createURL to this specific attribute
                            function _createURL(facetValue) {
                                return createURL(
                                    state.toggleRefinement(
                                        attributeName,
                                        facetValue
                                    )
                                );
                            }

                            _reactDom2.default.render(
                                _react2.default.createElement(RefinementList, {
                                    collapsible: collapsible,
                                    createURL: _createURL,
                                    cssClasses: cssClasses,
                                    facetValues: facetValues,
                                    shouldAutoHideContainer:
                                        results.nbHits === 0,
                                    templateProps: this._templateProps,
                                    toggleRefinement: this._toggleRefinement,
                                }),
                                containerNode
                            );
                        },
                        _toggleRefinement: function _toggleRefinement(
                            helper,
                            facetValue
                        ) {
                            var isRefined =
                                this._getRefinedStar(helper) ===
                                Number(facetValue);
                            helper.clearRefinements(attributeName);
                            if (!isRefined) {
                                for (
                                    var val = Number(facetValue);
                                    val <= max;
                                    ++val
                                ) {
                                    helper.addDisjunctiveFacetRefinement(
                                        attributeName,
                                        val
                                    );
                                }
                            }
                            helper.search();
                        },
                        _getRefinedStar: function _getRefinedStar(helper) {
                            var refinedStar = undefined;
                            var refinements =
                                helper.getRefinements(attributeName);
                            refinements.forEach(function (r) {
                                if (
                                    !refinedStar ||
                                    Number(r.value) < refinedStar
                                ) {
                                    refinedStar = Number(r.value);
                                }
                            });
                            return refinedStar;
                        },
                    };
                }

                exports.default = starRating;

                /***/
            },
            /* 579 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                /* eslint-disable max-len */
                exports.default = {
                    header: "",
                    item: '<a class="{{cssClasses.link}}{{^count}} {{cssClasses.disabledLink}}{{/count}}" {{#count}}href="{{href}}"{{/count}}>\n  {{#stars}}<span class="{{#.}}{{cssClasses.star}}{{/.}}{{^.}}{{cssClasses.emptyStar}}{{/.}}"></span>{{/stars}}\n  {{labels.andUp}}\n  {{#count}}<span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>{{/count}}\n</a>',
                    footer: "",
                };

                /***/
            },
            /* 580 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    andUp: "& Up",
                };

                /***/
            },
            /* 581 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _utils = __webpack_require__(514);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _Stats = __webpack_require__(582);

                var _Stats2 = _interopRequireDefault(_Stats);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _defaultTemplates = __webpack_require__(583);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-stats");

                /**
                 * Display various stats about the current search state
                 * @function stats
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header=''] Header template
                 * @param  {string|Function} [options.templates.body] Body template, provided with `hasManyResults`,
                 * `hasNoResults`, `hasOneResult`, `hitsPerPage`, `nbHits`, `nbPages`, `page`, `processingTimeMS`, `query`
                 * @param  {string|Function} [options.templates.footer=''] Footer template
                 * @param  {Function} [options.transformData.body] Function to change the object passed to the `body` template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when no results match
                 * @param  {Object} [options.cssClasses] CSS classes to add
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.time] CSS class to add to the element wrapping the time processingTimeMs
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nstats({\n  container,\n  [ templates.{header,body,footer} ],\n  [ transformData.{body} ],\n  [ autoHideContainer]\n})";
                function stats() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        transformData = _ref.transformData;

                    if (!container) throw new Error(usage);
                    var containerNode = (0, _utils.getContainerNode)(container);

                    var Stats = (0, _headerFooter2.default)(_Stats2.default);
                    if (autoHideContainer === true) {
                        Stats = (0, _autoHideContainer2.default)(Stats);
                    }

                    if (!containerNode) {
                        throw new Error(usage);
                    }

                    var cssClasses = {
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        time: (0, _classnames2.default)(
                            bem("time"),
                            userCssClasses.time
                        ),
                    };

                    return {
                        init: function init(_ref2) {
                            var templatesConfig = _ref2.templatesConfig;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                        },
                        render: function render(_ref3) {
                            var results = _ref3.results;

                            _reactDom2.default.render(
                                _react2.default.createElement(Stats, {
                                    collapsible: collapsible,
                                    cssClasses: cssClasses,
                                    hitsPerPage: results.hitsPerPage,
                                    nbHits: results.nbHits,
                                    nbPages: results.nbPages,
                                    page: results.page,
                                    processingTimeMS: results.processingTimeMS,
                                    query: results.query,
                                    shouldAutoHideContainer:
                                        results.nbHits === 0,
                                    templateProps: this._templateProps,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                exports.default = stats;

                /***/
            },
            /* 582 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _extends =
                    Object.assign ||
                    function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];
                            for (var key in source) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        source,
                                        key
                                    )
                                ) {
                                    target[key] = source[key];
                                }
                            }
                        }
                        return target;
                    };

                var _createClass = (function () {
                    function defineProperties(target, props) {
                        for (var i = 0; i < props.length; i++) {
                            var descriptor = props[i];
                            descriptor.enumerable =
                                descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor)
                                descriptor.writable = true;
                            Object.defineProperty(
                                target,
                                descriptor.key,
                                descriptor
                            );
                        }
                    }
                    return function (Constructor, protoProps, staticProps) {
                        if (protoProps)
                            defineProperties(Constructor.prototype, protoProps);
                        if (staticProps)
                            defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                })();

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _Template = __webpack_require__(519);

                var _Template2 = _interopRequireDefault(_Template);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) {
                        throw new TypeError(
                            "Cannot call a class as a function"
                        );
                    }
                }

                function _possibleConstructorReturn(self, call) {
                    if (!self) {
                        throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called"
                        );
                    }
                    return call &&
                        (typeof call === "object" || typeof call === "function")
                        ? call
                        : self;
                }

                function _inherits(subClass, superClass) {
                    if (
                        typeof superClass !== "function" &&
                        superClass !== null
                    ) {
                        throw new TypeError(
                            "Super expression must either be null or a function, not " +
                                typeof superClass
                        );
                    }
                    subClass.prototype = Object.create(
                        superClass && superClass.prototype,
                        {
                            constructor: {
                                value: subClass,
                                enumerable: false,
                                writable: true,
                                configurable: true,
                            },
                        }
                    );
                    if (superClass)
                        Object.setPrototypeOf
                            ? Object.setPrototypeOf(subClass, superClass)
                            : (subClass.__proto__ = superClass);
                }

                var Stats = (function (_React$Component) {
                    _inherits(Stats, _React$Component);

                    function Stats() {
                        _classCallCheck(this, Stats);

                        return _possibleConstructorReturn(
                            this,
                            (
                                Stats.__proto__ || Object.getPrototypeOf(Stats)
                            ).apply(this, arguments)
                        );
                    }

                    _createClass(Stats, [
                        {
                            key: "shouldComponentUpdate",
                            value: function shouldComponentUpdate(nextProps) {
                                return (
                                    this.props.nbHits !== nextProps.hits ||
                                    this.props.processingTimeMS !==
                                        nextProps.processingTimeMS
                                );
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var data = {
                                    hasManyResults: this.props.nbHits > 1,
                                    hasNoResults: this.props.nbHits === 0,
                                    hasOneResult: this.props.nbHits === 1,
                                    hitsPerPage: this.props.hitsPerPage,
                                    nbHits: this.props.nbHits,
                                    nbPages: this.props.nbPages,
                                    page: this.props.page,
                                    processingTimeMS:
                                        this.props.processingTimeMS,
                                    query: this.props.query,
                                    cssClasses: this.props.cssClasses,
                                };

                                return _react2.default.createElement(
                                    _Template2.default,
                                    _extends(
                                        { data: data, templateKey: "body" },
                                        this.props.templateProps
                                    )
                                );
                            },
                        },
                    ]);

                    return Stats;
                })(_react2.default.Component);

                exports.default = Stats;

                /***/
            },
            /* 583 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    header: "",
                    body: '{{#hasNoResults}}No results{{/hasNoResults}}\n  {{#hasOneResult}}1 result{{/hasOneResult}}\n  {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results{{/hasManyResults}}\n  <span class="{{cssClasses.time}}">found in {{processingTimeMS}}ms</span>',
                    footer: "",
                };

                /***/
            },
            /* 584 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _utils = __webpack_require__(514);

                var _defaultTemplates = __webpack_require__(585);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _classnames = __webpack_require__(516);

                var _classnames2 = _interopRequireDefault(_classnames);

                var _autoHideContainer = __webpack_require__(517);

                var _autoHideContainer2 =
                    _interopRequireDefault(_autoHideContainer);

                var _headerFooter = __webpack_require__(518);

                var _headerFooter2 = _interopRequireDefault(_headerFooter);

                var _RefinementList = __webpack_require__(533);

                var _RefinementList2 = _interopRequireDefault(_RefinementList);

                var _currentToggle = __webpack_require__(586);

                var _currentToggle2 = _interopRequireDefault(_currentToggle);

                var _legacyToggle = __webpack_require__(587);

                var _legacyToggle2 = _interopRequireDefault(_legacyToggle);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                var bem = (0, _utils.bemHelper)("ais-toggle");

                // we cannot use helper. because the facet is not yet declared in the helper
                var hasFacetsRefinementsFor = function hasFacetsRefinementsFor(
                    attributeName,
                    searchParameters
                ) {
                    return (
                        searchParameters &&
                        searchParameters.facetsRefinements &&
                        searchParameters.facetsRefinements[attributeName] !==
                            undefined
                    );
                };

                /**
                 * Instantiate the toggling of a boolean facet filter on and off.
                 * @function toggle
                 * @param  {string|DOMElement} options.container CSS Selector or DOMElement to insert the widget
                 * @param  {string} options.attributeName Name of the attribute for faceting (eg. "free_shipping")
                 * @param  {string} options.label Human-readable name of the filter (eg. "Free Shipping")
                 * @param  {Object} [options.values] Lets you define the values to filter on when toggling
                 * @param  {string|number|boolean} [options.values.on=true] Value to filter on when checked
                 * @param  {string|number|boolean} [options.values.off=undefined] Value to filter on when unchecked
                 * element (when using the default template). By default when switching to `off`, no refinement will be asked. So you
                 * will get both `true` and `false` results. If you set the off value to `false` then you will get only objects
                 * having `false` has a value for the selected attribute.
                 * @param  {Object} [options.templates] Templates to use for the widget
                 * @param  {string|Function} [options.templates.header] Header template
                 * @param  {string|Function} [options.templates.item] Item template, provided with `name`, `count`, `isRefined`, `url` data properties
                 * count is always the number of hits that would be shown if you toggle the widget. We also provide
                 * `onFacetValue` and `offFacetValue` objects with according counts.
                 * @param  {string|Function} [options.templates.footer] Footer template
                 * @param  {Function} [options.transformData.item] Function to change the object passed to the `item` template
                 * @param  {boolean} [options.autoHideContainer=true] Hide the container when there are no results
                 * @param  {Object} [options.cssClasses] CSS classes to add
                 * @param  {string|string[]} [options.cssClasses.root] CSS class to add to the root element
                 * @param  {string|string[]} [options.cssClasses.header] CSS class to add to the header element
                 * @param  {string|string[]} [options.cssClasses.body] CSS class to add to the body element
                 * @param  {string|string[]} [options.cssClasses.footer] CSS class to add to the footer element
                 * @param  {string|string[]} [options.cssClasses.list] CSS class to add to the list element
                 * @param  {string|string[]} [options.cssClasses.item] CSS class to add to each item element
                 * @param  {string|string[]} [options.cssClasses.active] CSS class to add to each active element
                 * @param  {string|string[]} [options.cssClasses.label] CSS class to add to each
                 * label element (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.checkbox] CSS class to add to each
                 * checkbox element (when using the default template)
                 * @param  {string|string[]} [options.cssClasses.count] CSS class to add to each count
                 * @param  {object|boolean} [options.collapsible=false] Hide the widget body and footer when clicking on header
                 * @param  {boolean} [options.collapsible.collapsed] Initial collapsed state of a collapsible widget
                 * @return {Object}
                 */
                var usage =
                    "Usage:\ntoggle({\n  container,\n  attributeName,\n  label,\n  [ values={on: true, off: undefined} ],\n  [ cssClasses.{root,header,body,footer,list,item,active,label,checkbox,count} ],\n  [ templates.{header,item,footer} ],\n  [ transformData.{item} ],\n  [ autoHideContainer=true ],\n  [ collapsible=false ]\n})";
                function toggle() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        container = _ref.container,
                        attributeName = _ref.attributeName,
                        label = _ref.label,
                        _ref$values = _ref.values,
                        userValues =
                            _ref$values === undefined
                                ? { on: true, off: undefined }
                                : _ref$values,
                        _ref$templates = _ref.templates,
                        templates =
                            _ref$templates === undefined
                                ? _defaultTemplates2.default
                                : _ref$templates,
                        _ref$collapsible = _ref.collapsible,
                        collapsible =
                            _ref$collapsible === undefined
                                ? false
                                : _ref$collapsible,
                        _ref$cssClasses = _ref.cssClasses,
                        userCssClasses =
                            _ref$cssClasses === undefined
                                ? {}
                                : _ref$cssClasses,
                        transformData = _ref.transformData,
                        _ref$autoHideContaine = _ref.autoHideContainer,
                        autoHideContainer =
                            _ref$autoHideContaine === undefined
                                ? true
                                : _ref$autoHideContaine;

                    var containerNode = (0, _utils.getContainerNode)(container);

                    if (!container || !attributeName || !label) {
                        throw new Error(usage);
                    }

                    var RefinementList = (0, _headerFooter2.default)(
                        _RefinementList2.default
                    );
                    if (autoHideContainer === true) {
                        RefinementList = (0, _autoHideContainer2.default)(
                            RefinementList
                        );
                    }

                    var hasAnOffValue = userValues.off !== undefined;

                    var cssClasses = {
                        root: (0, _classnames2.default)(
                            bem(null),
                            userCssClasses.root
                        ),
                        header: (0, _classnames2.default)(
                            bem("header"),
                            userCssClasses.header
                        ),
                        body: (0, _classnames2.default)(
                            bem("body"),
                            userCssClasses.body
                        ),
                        footer: (0, _classnames2.default)(
                            bem("footer"),
                            userCssClasses.footer
                        ),
                        list: (0, _classnames2.default)(
                            bem("list"),
                            userCssClasses.list
                        ),
                        item: (0, _classnames2.default)(
                            bem("item"),
                            userCssClasses.item
                        ),
                        active: (0, _classnames2.default)(
                            bem("item", "active"),
                            userCssClasses.active
                        ),
                        label: (0, _classnames2.default)(
                            bem("label"),
                            userCssClasses.label
                        ),
                        checkbox: (0, _classnames2.default)(
                            bem("checkbox"),
                            userCssClasses.checkbox
                        ),
                        count: (0, _classnames2.default)(
                            bem("count"),
                            userCssClasses.count
                        ),
                    };

                    // store the computed options for usage in the two toggle implementations
                    var implemOptions = {
                        attributeName: attributeName,
                        label: label,
                        userValues: userValues,
                        templates: templates,
                        collapsible: collapsible,
                        transformData: transformData,
                        hasAnOffValue: hasAnOffValue,
                        containerNode: containerNode,
                        RefinementList: RefinementList,
                        cssClasses: cssClasses,
                    };

                    return {
                        getConfiguration: function getConfiguration(
                            currentSearchParameters,
                            searchParametersFromUrl
                        ) {
                            var useLegacyToggle =
                                hasFacetsRefinementsFor(
                                    attributeName,
                                    currentSearchParameters
                                ) ||
                                hasFacetsRefinementsFor(
                                    attributeName,
                                    searchParametersFromUrl
                                );

                            var toggleImplementation = useLegacyToggle
                                ? (0, _legacyToggle2.default)(implemOptions)
                                : (0, _currentToggle2.default)(implemOptions);

                            this.init =
                                toggleImplementation.init.bind(
                                    toggleImplementation
                                );
                            this.render =
                                toggleImplementation.render.bind(
                                    toggleImplementation
                                );
                            return toggleImplementation.getConfiguration(
                                currentSearchParameters,
                                searchParametersFromUrl
                            );
                        },
                        init: function init() {},
                        render: function render() {},
                    };
                }

                exports.default = toggle;

                /***/
            },
            /* 585 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = {
                    header: "",
                    item: '<label class="{{cssClasses.label}}">\n  <input type="checkbox" class="{{cssClasses.checkbox}}" value="{{name}}" {{#isRefined}}checked{{/isRefined}} />{{name}}\n  <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>\n</label>',
                    footer: "",
                };

                /***/
            },
            /* 586 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });

                var _find = __webpack_require__(240);

                var _find2 = _interopRequireDefault(_find);

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _defaultTemplates = __webpack_require__(585);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _utils = __webpack_require__(514);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                // cannot use a function declaration because of
                // https://github.com/speedskater/babel-plugin-rewire/issues/109#issuecomment-227917555
                var currentToggle = function currentToggle() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        attributeName = _ref.attributeName,
                        label = _ref.label,
                        userValues = _ref.userValues,
                        templates = _ref.templates,
                        collapsible = _ref.collapsible,
                        transformData = _ref.transformData,
                        hasAnOffValue = _ref.hasAnOffValue,
                        containerNode = _ref.containerNode,
                        RefinementList = _ref.RefinementList,
                        cssClasses = _ref.cssClasses;

                    var on = userValues
                        ? (0, _utils.escapeRefinement)(userValues.on)
                        : undefined;
                    var off = userValues
                        ? (0, _utils.escapeRefinement)(userValues.off)
                        : undefined;

                    return {
                        getConfiguration: function getConfiguration() {
                            return {
                                disjunctiveFacets: [attributeName],
                            };
                        },
                        toggleRefinement: function toggleRefinement(
                            helper,
                            facetValue,
                            isRefined
                        ) {
                            // Checking
                            if (!isRefined) {
                                if (hasAnOffValue) {
                                    helper.removeDisjunctiveFacetRefinement(
                                        attributeName,
                                        off
                                    );
                                }
                                helper.addDisjunctiveFacetRefinement(
                                    attributeName,
                                    on
                                );
                            } else {
                                // Unchecking
                                helper.removeDisjunctiveFacetRefinement(
                                    attributeName,
                                    on
                                );
                                if (hasAnOffValue) {
                                    helper.addDisjunctiveFacetRefinement(
                                        attributeName,
                                        off
                                    );
                                }
                            }

                            helper.search();
                        },
                        init: function init(_ref2) {
                            var state = _ref2.state,
                                helper = _ref2.helper,
                                templatesConfig = _ref2.templatesConfig;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });

                            this.toggleRefinement = this.toggleRefinement.bind(
                                this,
                                helper
                            );

                            // no need to refine anything at init if no custom off values
                            if (!hasAnOffValue) {
                                return;
                            }

                            // Add filtering on the 'off' value if set
                            var isRefined = state.isDisjunctiveFacetRefined(
                                attributeName,
                                on
                            );
                            if (!isRefined) {
                                helper.addDisjunctiveFacetRefinement(
                                    attributeName,
                                    off
                                );
                            }
                        },
                        render: function render(_ref3) {
                            var helper = _ref3.helper,
                                results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var isRefined =
                                helper.state.isDisjunctiveFacetRefined(
                                    attributeName,
                                    on
                                );
                            var onValue = on;
                            var offValue = off === undefined ? false : off;
                            var allFacetValues =
                                results.getFacetValues(attributeName);
                            var onData = (0, _find2.default)(allFacetValues, {
                                name: (0, _utils.unescapeRefinement)(onValue),
                            });
                            var onFacetValue = {
                                name: label,
                                isRefined:
                                    onData !== undefined
                                        ? onData.isRefined
                                        : false,
                                count:
                                    onData === undefined ? null : onData.count,
                            };
                            var offData = hasAnOffValue
                                ? (0, _find2.default)(allFacetValues, {
                                      name: (0, _utils.unescapeRefinement)(
                                          offValue
                                      ),
                                  })
                                : undefined;
                            var offFacetValue = {
                                name: label,
                                isRefined:
                                    offData !== undefined
                                        ? offData.isRefined
                                        : false,
                                count:
                                    offData === undefined
                                        ? results.nbHits
                                        : offData.count,
                            };

                            // what will we show by default,
                            // if checkbox is not checked, show: [ ] free shipping (countWhenChecked)
                            // if checkbox is checked, show: [x] free shipping (countWhenNotChecked)
                            var nextRefinement = isRefined
                                ? offFacetValue
                                : onFacetValue;

                            var facetValue = {
                                name: label,
                                isRefined: isRefined,
                                count:
                                    nextRefinement === undefined
                                        ? null
                                        : nextRefinement.count,
                                onFacetValue: onFacetValue,
                                offFacetValue: offFacetValue,
                            };

                            // Bind createURL to this specific attribute
                            function _createURL() {
                                return createURL(
                                    state
                                        .removeDisjunctiveFacetRefinement(
                                            attributeName,
                                            isRefined ? onValue : off
                                        )
                                        .addDisjunctiveFacetRefinement(
                                            attributeName,
                                            isRefined ? off : onValue
                                        )
                                );
                            }

                            _reactDom2.default.render(
                                _react2.default.createElement(RefinementList, {
                                    collapsible: collapsible,
                                    createURL: _createURL,
                                    cssClasses: cssClasses,
                                    facetValues: [facetValue],
                                    shouldAutoHideContainer:
                                        facetValue.count === 0 ||
                                        facetValue.count === null,
                                    templateProps: this._templateProps,
                                    toggleRefinement: this.toggleRefinement,
                                }),
                                containerNode
                            );
                        },
                    };
                };

                exports.default = currentToggle;

                /***/
            },
            /* 587 */
            /***/ function (module, exports, __webpack_require__) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                exports.default = currentToggle;

                var _find = __webpack_require__(240);

                var _find2 = _interopRequireDefault(_find);

                var _react = __webpack_require__(348);

                var _react2 = _interopRequireDefault(_react);

                var _reactDom = __webpack_require__(376);

                var _reactDom2 = _interopRequireDefault(_reactDom);

                var _defaultTemplates = __webpack_require__(585);

                var _defaultTemplates2 =
                    _interopRequireDefault(_defaultTemplates);

                var _utils = __webpack_require__(514);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : { default: obj };
                }

                function currentToggle() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        attributeName = _ref.attributeName,
                        label = _ref.label,
                        userValues = _ref.userValues,
                        templates = _ref.templates,
                        collapsible = _ref.collapsible,
                        transformData = _ref.transformData,
                        hasAnOffValue = _ref.hasAnOffValue,
                        containerNode = _ref.containerNode,
                        RefinementList = _ref.RefinementList,
                        cssClasses = _ref.cssClasses;

                    return {
                        getConfiguration: function getConfiguration() {
                            return {
                                facets: [attributeName],
                            };
                        },
                        toggleRefinement: function toggleRefinement(
                            helper,
                            facetValue,
                            isRefined
                        ) {
                            var on = userValues.on;
                            var off = userValues.off;

                            // Checking
                            if (!isRefined) {
                                if (hasAnOffValue) {
                                    helper.removeFacetRefinement(
                                        attributeName,
                                        off
                                    );
                                }
                                helper.addFacetRefinement(attributeName, on);
                            } else {
                                // Unchecking
                                helper.removeFacetRefinement(attributeName, on);
                                if (hasAnOffValue) {
                                    helper.addFacetRefinement(
                                        attributeName,
                                        off
                                    );
                                }
                            }

                            helper.search();
                        },
                        init: function init(_ref2) {
                            var state = _ref2.state,
                                helper = _ref2.helper,
                                templatesConfig = _ref2.templatesConfig;

                            this._templateProps = (0,
                            _utils.prepareTemplateProps)({
                                transformData: transformData,
                                defaultTemplates: _defaultTemplates2.default,
                                templatesConfig: templatesConfig,
                                templates: templates,
                            });
                            this.toggleRefinement = this.toggleRefinement.bind(
                                this,
                                helper
                            );

                            // no need to refine anything at init if no custom off values
                            if (!hasAnOffValue) {
                                return;
                            }
                            // Add filtering on the 'off' value if set
                            var isRefined = state.isFacetRefined(
                                attributeName,
                                userValues.on
                            );
                            if (!isRefined) {
                                helper.addFacetRefinement(
                                    attributeName,
                                    userValues.off
                                );
                            }
                        },
                        render: function render(_ref3) {
                            var helper = _ref3.helper,
                                results = _ref3.results,
                                state = _ref3.state,
                                createURL = _ref3.createURL;

                            var isRefined = helper.state.isFacetRefined(
                                attributeName,
                                userValues.on
                            );
                            var currentRefinement = isRefined
                                ? userValues.on
                                : userValues.off;
                            var count = void 0;
                            if (typeof currentRefinement === "number") {
                                count =
                                    results.getFacetStats(attributeName).sum;
                            } else {
                                var facetData = (0, _find2.default)(
                                    results.getFacetValues(attributeName),
                                    { name: isRefined.toString() }
                                );
                                count =
                                    facetData !== undefined
                                        ? facetData.count
                                        : null;
                            }

                            var facetValue = {
                                name: label,
                                isRefined: isRefined,
                                count: count,
                            };

                            // Bind createURL to this specific attribute
                            function _createURL() {
                                return createURL(
                                    state.toggleRefinement(
                                        attributeName,
                                        isRefined
                                    )
                                );
                            }

                            _reactDom2.default.render(
                                _react2.default.createElement(RefinementList, {
                                    collapsible: collapsible,
                                    createURL: _createURL,
                                    cssClasses: cssClasses,
                                    facetValues: [facetValue],
                                    shouldAutoHideContainer:
                                        results.nbHits === 0,
                                    templateProps: this._templateProps,
                                    toggleRefinement: this.toggleRefinement,
                                }),
                                containerNode
                            );
                        },
                    };
                }

                /***/
            },
            /* 588 */
            /***/ function (module, exports) {
                "use strict";

                Object.defineProperty(exports, "__esModule", {
                    value: true,
                });
                /**
                 * Pushes analytics data to any analytic service
                 * @function analytics
                 * @param  {Function} [options.pushFunction] Push function called when data are supposed to be pushed to analytic service
                 * @param  {int} [options.delay=3000] Number of milliseconds between last search key stroke and calling pushFunction
                 * @param  {boolean} [options.triggerOnUIInteraction=false] Trigger pushFunction after click on page or redirecting the page
                 * @param  {boolean} [options.pushInitialSearch=true] Trigger pushFunction after the initial search
                 * @return {Object}
                 */
                var usage =
                    "Usage:\nanalytics({\n  pushFunction,\n  [ delay=3000 ],\n  [ triggerOnUIInteraction=false ],\n  [ pushInitialSearch=true ]\n})";
                function analytics() {
                    var _ref =
                            arguments.length > 0 && arguments[0] !== undefined
                                ? arguments[0]
                                : {},
                        pushFunction = _ref.pushFunction,
                        _ref$delay = _ref.delay,
                        delay = _ref$delay === undefined ? 3000 : _ref$delay,
                        _ref$triggerOnUIInter = _ref.triggerOnUIInteraction,
                        triggerOnUIInteraction =
                            _ref$triggerOnUIInter === undefined
                                ? false
                                : _ref$triggerOnUIInter,
                        _ref$pushInitialSearc = _ref.pushInitialSearch,
                        pushInitialSearch =
                            _ref$pushInitialSearc === undefined
                                ? true
                                : _ref$pushInitialSearc;

                    if (!pushFunction) {
                        throw new Error(usage);
                    }

                    var cachedState = null;

                    var serializeRefinements = function serializeRefinements(
                        obj
                    ) {
                        var str = [];
                        for (var p in obj) {
                            if (obj.hasOwnProperty(p)) {
                                var values = obj[p].join("+");
                                str.push(
                                    encodeURIComponent(p) +
                                        "=" +
                                        encodeURIComponent(p) +
                                        "_" +
                                        encodeURIComponent(values)
                                );
                            }
                        }

                        return str.join("&");
                    };

                    var serializeNumericRefinements =
                        function serializeNumericRefinements(
                            numericRefinements
                        ) {
                            var numericStr = [];

                            for (var attr in numericRefinements) {
                                if (numericRefinements.hasOwnProperty(attr)) {
                                    var filter = numericRefinements[attr];

                                    if (
                                        filter.hasOwnProperty(">=") &&
                                        filter.hasOwnProperty("<=")
                                    ) {
                                        if (
                                            filter[">="][0] === filter["<="][0]
                                        ) {
                                            numericStr.push(
                                                attr +
                                                    "=" +
                                                    attr +
                                                    "_" +
                                                    filter[">="]
                                            );
                                        } else {
                                            numericStr.push(
                                                attr +
                                                    "=" +
                                                    attr +
                                                    "_" +
                                                    filter[">="] +
                                                    "to" +
                                                    filter["<="]
                                            );
                                        }
                                    } else if (filter.hasOwnProperty(">=")) {
                                        numericStr.push(
                                            attr +
                                                "=" +
                                                attr +
                                                "_from" +
                                                filter[">="]
                                        );
                                    } else if (filter.hasOwnProperty("<=")) {
                                        numericStr.push(
                                            attr +
                                                "=" +
                                                attr +
                                                "_to" +
                                                filter["<="]
                                        );
                                    } else if (filter.hasOwnProperty("=")) {
                                        var equals = [];
                                        for (var equal in filter["="]) {
                                            if (
                                                filter["="].hasOwnProperty(
                                                    equal
                                                )
                                            ) {
                                                // eslint-disable-line max-depth
                                                equals.push(filter["="][equal]);
                                            }
                                        }

                                        numericStr.push(
                                            attr +
                                                "=" +
                                                attr +
                                                "_" +
                                                equals.join("-")
                                        );
                                    }
                                }
                            }

                            return numericStr.join("&");
                        };

                    var lastSentData = "";
                    var sendAnalytics = function sendAnalytics(state) {
                        if (state === null) {
                            return;
                        }

                        var formattedParams = [];

                        var serializedRefinements = serializeRefinements(
                            Object.assign(
                                {},
                                state.state.disjunctiveFacetsRefinements,
                                state.state.facetsRefinements,
                                state.state.hierarchicalFacetsRefinements
                            )
                        );

                        var serializedNumericRefinements =
                            serializeNumericRefinements(
                                state.state.numericRefinements
                            );

                        if (serializedRefinements !== "") {
                            formattedParams.push(serializedRefinements);
                        }

                        if (serializedNumericRefinements !== "") {
                            formattedParams.push(serializedNumericRefinements);
                        }

                        formattedParams = formattedParams.join("&");

                        var dataToSend =
                            "Query: " +
                            state.state.query +
                            ", " +
                            formattedParams;

                        if (lastSentData !== dataToSend) {
                            pushFunction(
                                formattedParams,
                                state.state,
                                state.results
                            );

                            lastSentData = dataToSend;
                        }
                    };

                    var pushTimeout = void 0;

                    var isInitialSearch = true;
                    if (pushInitialSearch === true) {
                        isInitialSearch = false;
                    }

                    return {
                        init: function init() {
                            if (triggerOnUIInteraction === true) {
                                document.addEventListener("click", function () {
                                    sendAnalytics(cachedState);
                                });

                                window.addEventListener(
                                    "beforeunload",
                                    function () {
                                        sendAnalytics(cachedState);
                                    }
                                );
                            }
                        },
                        render: function render(_ref2) {
                            var results = _ref2.results,
                                state = _ref2.state;

                            if (isInitialSearch === true) {
                                isInitialSearch = false;

                                return;
                            }

                            cachedState = { results: results, state: state };

                            if (pushTimeout) {
                                clearTimeout(pushTimeout);
                            }

                            pushTimeout = setTimeout(function () {
                                return sendAnalytics(cachedState);
                            }, delay);
                        },
                    };
                }

                exports.default = analytics;

                /***/
            },
            /******/
        ]
    );
});

// Ion.RangeSlider | version 2.1.4 | https://github.com/IonDen/ion.rangeSlider
;(function(g){"function"===typeof define&&define.amd?define(["jquery"],function(q){g(q,document,window,navigator)}):g(jQuery,document,window,navigator)})(function(g,q,h,t,v){var u=0,p=function(){var a=t.userAgent,b=/msie\s\d+/i;return 0<a.search(b)&&(a=b.exec(a).toString(),a=a.split(" ")[1],9>a)?(g("html").addClass("lt-ie9"),!0):!1}();Function.prototype.bind||(Function.prototype.bind=function(a){var b=this,d=[].slice;if("function"!=typeof b)throw new TypeError;var c=d.call(arguments,1),e=function(){if(this instanceof
e){var f=function(){};f.prototype=b.prototype;var f=new f,l=b.apply(f,c.concat(d.call(arguments)));return Object(l)===l?l:f}return b.apply(a,c.concat(d.call(arguments)))};return e});Array.prototype.indexOf||(Array.prototype.indexOf=function(a,b){var d;if(null==this)throw new TypeError('"this" is null or not defined');var c=Object(this),e=c.length>>>0;if(0===e)return-1;d=+b||0;Infinity===Math.abs(d)&&(d=0);if(d>=e)return-1;for(d=Math.max(0<=d?d:e-Math.abs(d),0);d<e;){if(d in c&&c[d]===a)return d;d++}return-1});
var r=function(a,b,d){this.VERSION="2.1.4";this.input=a;this.plugin_count=d;this.old_to=this.old_from=this.update_tm=this.calc_count=this.current_plugin=0;this.raf_id=this.old_min_interval=null;this.is_update=this.is_key=this.no_diapason=this.force_redraw=this.dragging=!1;this.is_start=!0;this.is_click=this.is_resize=this.is_active=this.is_finish=!1;this.$cache={win:g(h),body:g(q.body),input:g(a),cont:null,rs:null,min:null,max:null,from:null,to:null,single:null,bar:null,line:null,s_single:null,s_from:null,
s_to:null,shad_single:null,shad_from:null,shad_to:null,edge:null,grid:null,grid_labels:[]};this.coords={x_gap:0,x_pointer:0,w_rs:0,w_rs_old:0,w_handle:0,p_gap:0,p_gap_left:0,p_gap_right:0,p_step:0,p_pointer:0,p_handle:0,p_single_fake:0,p_single_real:0,p_from_fake:0,p_from_real:0,p_to_fake:0,p_to_real:0,p_bar_x:0,p_bar_w:0,grid_gap:0,big_num:0,big:[],big_w:[],big_p:[],big_x:[]};this.labels={w_min:0,w_max:0,w_from:0,w_to:0,w_single:0,p_min:0,p_max:0,p_from_fake:0,p_from_left:0,p_to_fake:0,p_to_left:0,
p_single_fake:0,p_single_left:0};var c=this.$cache.input;a=c.prop("value");var e;d={type:"single",min:10,max:100,from:null,to:null,step:1,min_interval:0,max_interval:0,drag_interval:!1,values:[],p_values:[],from_fixed:!1,from_min:null,from_max:null,from_shadow:!1,to_fixed:!1,to_min:null,to_max:null,to_shadow:!1,prettify_enabled:!0,prettify_separator:" ",prettify:null,force_edges:!1,keyboard:!1,keyboard_step:5,grid:!1,grid_margin:!0,grid_num:4,grid_snap:!1,hide_min_max:!1,hide_from_to:!1,prefix:"",
postfix:"",max_postfix:"",decorate_both:!0,values_separator:" \u2014 ",input_values_separator:";",disable:!1,onStart:null,onChange:null,onFinish:null,onUpdate:null};c={type:c.data("type"),min:c.data("min"),max:c.data("max"),from:c.data("from"),to:c.data("to"),step:c.data("step"),min_interval:c.data("minInterval"),max_interval:c.data("maxInterval"),drag_interval:c.data("dragInterval"),values:c.data("values"),from_fixed:c.data("fromFixed"),from_min:c.data("fromMin"),from_max:c.data("fromMax"),from_shadow:c.data("fromShadow"),
to_fixed:c.data("toFixed"),to_min:c.data("toMin"),to_max:c.data("toMax"),to_shadow:c.data("toShadow"),prettify_enabled:c.data("prettifyEnabled"),prettify_separator:c.data("prettifySeparator"),force_edges:c.data("forceEdges"),keyboard:c.data("keyboard"),keyboard_step:c.data("keyboardStep"),grid:c.data("grid"),grid_margin:c.data("gridMargin"),grid_num:c.data("gridNum"),grid_snap:c.data("gridSnap"),hide_min_max:c.data("hideMinMax"),hide_from_to:c.data("hideFromTo"),prefix:c.data("prefix"),postfix:c.data("postfix"),
max_postfix:c.data("maxPostfix"),decorate_both:c.data("decorateBoth"),values_separator:c.data("valuesSeparator"),input_values_separator:c.data("inputValuesSeparator"),disable:c.data("disable")};c.values=c.values&&c.values.split(",");for(e in c)c.hasOwnProperty(e)&&(c[e]||0===c[e]||delete c[e]);a&&(a=a.split(c.input_values_separator||b.input_values_separator||";"),a[0]&&a[0]==+a[0]&&(a[0]=+a[0]),a[1]&&a[1]==+a[1]&&(a[1]=+a[1]),b&&b.values&&b.values.length?(d.from=a[0]&&b.values.indexOf(a[0]),d.to=
a[1]&&b.values.indexOf(a[1])):(d.from=a[0]&&+a[0],d.to=a[1]&&+a[1]));g.extend(d,b);g.extend(d,c);this.options=d;this.validate();this.result={input:this.$cache.input,slider:null,min:this.options.min,max:this.options.max,from:this.options.from,from_percent:0,from_value:null,to:this.options.to,to_percent:0,to_value:null};this.init()};r.prototype={init:function(a){this.no_diapason=!1;this.coords.p_step=this.convertToPercent(this.options.step,!0);this.target="base";this.toggleInput();this.append();this.setMinMax();
a?(this.force_redraw=!0,this.calc(!0),this.callOnUpdate()):(this.force_redraw=!0,this.calc(!0),this.callOnStart());this.updateScene()},append:function(){this.$cache.input.before('<span class="irs js-irs-'+this.plugin_count+'"></span>');this.$cache.input.prop("readonly",!0);this.$cache.cont=this.$cache.input.prev();this.result.slider=this.$cache.cont;this.$cache.cont.html('<span class="irs"><span class="irs-line" tabindex="-1"><span class="irs-line-left"></span><span class="irs-line-mid"></span><span class="irs-line-right"></span></span><span class="irs-min">0</span><span class="irs-max">1</span><span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span></span><span class="irs-grid"></span><span class="irs-bar"></span>');
this.$cache.rs=this.$cache.cont.find(".irs");this.$cache.min=this.$cache.cont.find(".irs-min");this.$cache.max=this.$cache.cont.find(".irs-max");this.$cache.from=this.$cache.cont.find(".irs-from");this.$cache.to=this.$cache.cont.find(".irs-to");this.$cache.single=this.$cache.cont.find(".irs-single");this.$cache.bar=this.$cache.cont.find(".irs-bar");this.$cache.line=this.$cache.cont.find(".irs-line");this.$cache.grid=this.$cache.cont.find(".irs-grid");"single"===this.options.type?(this.$cache.cont.append('<span class="irs-bar-edge"></span><span class="irs-shadow shadow-single"></span><span class="irs-slider single"></span>'),
this.$cache.edge=this.$cache.cont.find(".irs-bar-edge"),this.$cache.s_single=this.$cache.cont.find(".single"),this.$cache.from[0].style.visibility="hidden",this.$cache.to[0].style.visibility="hidden",this.$cache.shad_single=this.$cache.cont.find(".shadow-single")):(this.$cache.cont.append('<span class="irs-shadow shadow-from"></span><span class="irs-shadow shadow-to"></span><span class="irs-slider from"></span><span class="irs-slider to"></span>'),this.$cache.s_from=this.$cache.cont.find(".from"),
this.$cache.s_to=this.$cache.cont.find(".to"),this.$cache.shad_from=this.$cache.cont.find(".shadow-from"),this.$cache.shad_to=this.$cache.cont.find(".shadow-to"),this.setTopHandler());this.options.hide_from_to&&(this.$cache.from[0].style.display="none",this.$cache.to[0].style.display="none",this.$cache.single[0].style.display="none");this.appendGrid();this.options.disable?(this.appendDisableMask(),this.$cache.input[0].disabled=!0):(this.$cache.cont.removeClass("irs-disabled"),this.$cache.input[0].disabled=
!1,this.bindEvents());this.options.drag_interval&&(this.$cache.bar[0].style.cursor="ew-resize")},setTopHandler:function(){var a=this.options.max,b=this.options.to;this.options.from>this.options.min&&b===a?this.$cache.s_from.addClass("type_last"):b<a&&this.$cache.s_to.addClass("type_last")},changeLevel:function(a){switch(a){case "single":this.coords.p_gap=this.toFixed(this.coords.p_pointer-this.coords.p_single_fake);break;case "from":this.coords.p_gap=this.toFixed(this.coords.p_pointer-this.coords.p_from_fake);
this.$cache.s_from.addClass("state_hover");this.$cache.s_from.addClass("type_last");this.$cache.s_to.removeClass("type_last");break;case "to":this.coords.p_gap=this.toFixed(this.coords.p_pointer-this.coords.p_to_fake);this.$cache.s_to.addClass("state_hover");this.$cache.s_to.addClass("type_last");this.$cache.s_from.removeClass("type_last");break;case "both":this.coords.p_gap_left=this.toFixed(this.coords.p_pointer-this.coords.p_from_fake),this.coords.p_gap_right=this.toFixed(this.coords.p_to_fake-
this.coords.p_pointer),this.$cache.s_to.removeClass("type_last"),this.$cache.s_from.removeClass("type_last")}},appendDisableMask:function(){this.$cache.cont.append('<span class="irs-disable-mask"></span>');this.$cache.cont.addClass("irs-disabled")},remove:function(){this.$cache.cont.remove();this.$cache.cont=null;this.$cache.line.off("keydown.irs_"+this.plugin_count);this.$cache.body.off("touchmove.irs_"+this.plugin_count);this.$cache.body.off("mousemove.irs_"+this.plugin_count);this.$cache.win.off("touchend.irs_"+
this.plugin_count);this.$cache.win.off("mouseup.irs_"+this.plugin_count);p&&(this.$cache.body.off("mouseup.irs_"+this.plugin_count),this.$cache.body.off("mouseleave.irs_"+this.plugin_count));this.$cache.grid_labels=[];this.coords.big=[];this.coords.big_w=[];this.coords.big_p=[];this.coords.big_x=[];cancelAnimationFrame(this.raf_id)},bindEvents:function(){if(!this.no_diapason){this.$cache.body.on("touchmove.irs_"+this.plugin_count,this.pointerMove.bind(this));this.$cache.body.on("mousemove.irs_"+this.plugin_count,
this.pointerMove.bind(this));this.$cache.win.on("touchend.irs_"+this.plugin_count,this.pointerUp.bind(this));this.$cache.win.on("mouseup.irs_"+this.plugin_count,this.pointerUp.bind(this));this.$cache.line.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click"));this.$cache.line.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click"));this.options.drag_interval&&"double"===this.options.type?(this.$cache.bar.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,
"both")),this.$cache.bar.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"both"))):(this.$cache.bar.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.bar.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")));"single"===this.options.type?(this.$cache.single.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),this.$cache.s_single.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),
this.$cache.shad_single.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.single.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),this.$cache.s_single.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"single")),this.$cache.edge.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.shad_single.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click"))):(this.$cache.single.on("touchstart.irs_"+
this.plugin_count,this.pointerDown.bind(this,null)),this.$cache.single.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,null)),this.$cache.from.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.s_from.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.to.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"to")),this.$cache.s_to.on("touchstart.irs_"+this.plugin_count,this.pointerDown.bind(this,"to")),
this.$cache.shad_from.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.shad_to.on("touchstart.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.from.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.s_from.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"from")),this.$cache.to.on("mousedown.irs_"+this.plugin_count,this.pointerDown.bind(this,"to")),this.$cache.s_to.on("mousedown.irs_"+
this.plugin_count,this.pointerDown.bind(this,"to")),this.$cache.shad_from.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")),this.$cache.shad_to.on("mousedown.irs_"+this.plugin_count,this.pointerClick.bind(this,"click")));if(this.options.keyboard)this.$cache.line.on("keydown.irs_"+this.plugin_count,this.key.bind(this,"keyboard"));p&&(this.$cache.body.on("mouseup.irs_"+this.plugin_count,this.pointerUp.bind(this)),this.$cache.body.on("mouseleave.irs_"+this.plugin_count,this.pointerUp.bind(this)))}},
pointerMove:function(a){this.dragging&&(this.coords.x_pointer=(a.pageX||a.originalEvent.touches&&a.originalEvent.touches[0].pageX)-this.coords.x_gap,this.calc())},pointerUp:function(a){if(this.current_plugin===this.plugin_count&&this.is_active){this.is_active=!1;this.$cache.cont.find(".state_hover").removeClass("state_hover");this.force_redraw=!0;p&&g("*").prop("unselectable",!1);this.updateScene();this.restoreOriginalMinInterval();if(g.contains(this.$cache.cont[0],a.target)||this.dragging)this.is_finish=
!0,this.callOnFinish();this.dragging=!1}},pointerDown:function(a,b){b.preventDefault();var d=b.pageX||b.originalEvent.touches&&b.originalEvent.touches[0].pageX;2!==b.button&&("both"===a&&this.setTempMinInterval(),a||(a=this.target),this.current_plugin=this.plugin_count,this.target=a,this.dragging=this.is_active=!0,this.coords.x_gap=this.$cache.rs.offset().left,this.coords.x_pointer=d-this.coords.x_gap,this.calcPointerPercent(),this.changeLevel(a),p&&g("*").prop("unselectable",!0),this.$cache.line.trigger("focus"),
this.updateScene())},pointerClick:function(a,b){b.preventDefault();var d=b.pageX||b.originalEvent.touches&&b.originalEvent.touches[0].pageX;2!==b.button&&(this.current_plugin=this.plugin_count,this.target=a,this.is_click=!0,this.coords.x_gap=this.$cache.rs.offset().left,this.coords.x_pointer=+(d-this.coords.x_gap).toFixed(),this.force_redraw=!0,this.calc(),this.$cache.line.trigger("focus"))},key:function(a,b){if(!(this.current_plugin!==this.plugin_count||b.altKey||b.ctrlKey||b.shiftKey||b.metaKey)){switch(b.which){case 83:case 65:case 40:case 37:b.preventDefault();
this.moveByKey(!1);break;case 87:case 68:case 38:case 39:b.preventDefault(),this.moveByKey(!0)}return!0}},moveByKey:function(a){var b=this.coords.p_pointer,b=a?b+this.options.keyboard_step:b-this.options.keyboard_step;this.coords.x_pointer=this.toFixed(this.coords.w_rs/100*b);this.is_key=!0;this.calc()},setMinMax:function(){this.options&&(this.options.hide_min_max?(this.$cache.min[0].style.display="none",this.$cache.max[0].style.display="none"):(this.options.values.length?(this.$cache.min.html(this.decorate(this.options.p_values[this.options.min])),
this.$cache.max.html(this.decorate(this.options.p_values[this.options.max]))):(this.$cache.min.html(this.decorate(this._prettify(this.options.min),this.options.min)),this.$cache.max.html(this.decorate(this._prettify(this.options.max),this.options.max))),this.labels.w_min=this.$cache.min.outerWidth(!1),this.labels.w_max=this.$cache.max.outerWidth(!1)))},setTempMinInterval:function(){var a=this.result.to-this.result.from;null===this.old_min_interval&&(this.old_min_interval=this.options.min_interval);
this.options.min_interval=a},restoreOriginalMinInterval:function(){null!==this.old_min_interval&&(this.options.min_interval=this.old_min_interval,this.old_min_interval=null)},calc:function(a){if(this.options){this.calc_count++;if(10===this.calc_count||a)this.calc_count=0,this.coords.w_rs=this.$cache.rs.outerWidth(!1),this.calcHandlePercent();if(this.coords.w_rs){this.calcPointerPercent();a=this.getHandleX();"click"===this.target&&(this.coords.p_gap=this.coords.p_handle/2,a=this.getHandleX(),this.target=
this.options.drag_interval?"both_one":this.chooseHandle(a));switch(this.target){case "base":var b=(this.options.max-this.options.min)/100;a=(this.result.from-this.options.min)/b;b=(this.result.to-this.options.min)/b;this.coords.p_single_real=this.toFixed(a);this.coords.p_from_real=this.toFixed(a);this.coords.p_to_real=this.toFixed(b);this.coords.p_single_real=this.checkDiapason(this.coords.p_single_real,this.options.from_min,this.options.from_max);this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,
this.options.from_min,this.options.from_max);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_single_fake=this.convertToFakePercent(this.coords.p_single_real);this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);this.coords.p_to_fake=this.convertToFakePercent(this.coords.p_to_real);this.target=null;break;case "single":if(this.options.from_fixed)break;this.coords.p_single_real=this.convertToRealPercent(a);this.coords.p_single_real=
this.calcWithStep(this.coords.p_single_real);this.coords.p_single_real=this.checkDiapason(this.coords.p_single_real,this.options.from_min,this.options.from_max);this.coords.p_single_fake=this.convertToFakePercent(this.coords.p_single_real);break;case "from":if(this.options.from_fixed)break;this.coords.p_from_real=this.convertToRealPercent(a);this.coords.p_from_real=this.calcWithStep(this.coords.p_from_real);this.coords.p_from_real>this.coords.p_to_real&&(this.coords.p_from_real=this.coords.p_to_real);
this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,this.options.from_min,this.options.from_max);this.coords.p_from_real=this.checkMinInterval(this.coords.p_from_real,this.coords.p_to_real,"from");this.coords.p_from_real=this.checkMaxInterval(this.coords.p_from_real,this.coords.p_to_real,"from");this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);break;case "to":if(this.options.to_fixed)break;this.coords.p_to_real=this.convertToRealPercent(a);this.coords.p_to_real=
this.calcWithStep(this.coords.p_to_real);this.coords.p_to_real<this.coords.p_from_real&&(this.coords.p_to_real=this.coords.p_from_real);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_to_real=this.checkMinInterval(this.coords.p_to_real,this.coords.p_from_real,"to");this.coords.p_to_real=this.checkMaxInterval(this.coords.p_to_real,this.coords.p_from_real,"to");this.coords.p_to_fake=this.convertToFakePercent(this.coords.p_to_real);
break;case "both":if(this.options.from_fixed||this.options.to_fixed)break;a=this.toFixed(a+.1*this.coords.p_handle);this.coords.p_from_real=this.convertToRealPercent(a)-this.coords.p_gap_left;this.coords.p_from_real=this.calcWithStep(this.coords.p_from_real);this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,this.options.from_min,this.options.from_max);this.coords.p_from_real=this.checkMinInterval(this.coords.p_from_real,this.coords.p_to_real,"from");this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);
this.coords.p_to_real=this.convertToRealPercent(a)+this.coords.p_gap_right;this.coords.p_to_real=this.calcWithStep(this.coords.p_to_real);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_to_real=this.checkMinInterval(this.coords.p_to_real,this.coords.p_from_real,"to");this.coords.p_to_fake=this.convertToFakePercent(this.coords.p_to_real);break;case "both_one":if(!this.options.from_fixed&&!this.options.to_fixed){var d=this.convertToRealPercent(a);
a=this.result.to_percent-this.result.from_percent;var c=a/2,b=d-c,d=d+c;0>b&&(b=0,d=b+a);100<d&&(d=100,b=d-a);this.coords.p_from_real=this.calcWithStep(b);this.coords.p_from_real=this.checkDiapason(this.coords.p_from_real,this.options.from_min,this.options.from_max);this.coords.p_from_fake=this.convertToFakePercent(this.coords.p_from_real);this.coords.p_to_real=this.calcWithStep(d);this.coords.p_to_real=this.checkDiapason(this.coords.p_to_real,this.options.to_min,this.options.to_max);this.coords.p_to_fake=
this.convertToFakePercent(this.coords.p_to_real)}}"single"===this.options.type?(this.coords.p_bar_x=this.coords.p_handle/2,this.coords.p_bar_w=this.coords.p_single_fake,this.result.from_percent=this.coords.p_single_real,this.result.from=this.convertToValue(this.coords.p_single_real),this.options.values.length&&(this.result.from_value=this.options.values[this.result.from])):(this.coords.p_bar_x=this.toFixed(this.coords.p_from_fake+this.coords.p_handle/2),this.coords.p_bar_w=this.toFixed(this.coords.p_to_fake-
this.coords.p_from_fake),this.result.from_percent=this.coords.p_from_real,this.result.from=this.convertToValue(this.coords.p_from_real),this.result.to_percent=this.coords.p_to_real,this.result.to=this.convertToValue(this.coords.p_to_real),this.options.values.length&&(this.result.from_value=this.options.values[this.result.from],this.result.to_value=this.options.values[this.result.to]));this.calcMinMax();this.calcLabels()}}},calcPointerPercent:function(){this.coords.w_rs?(0>this.coords.x_pointer||isNaN(this.coords.x_pointer)?
this.coords.x_pointer=0:this.coords.x_pointer>this.coords.w_rs&&(this.coords.x_pointer=this.coords.w_rs),this.coords.p_pointer=this.toFixed(this.coords.x_pointer/this.coords.w_rs*100)):this.coords.p_pointer=0},convertToRealPercent:function(a){return a/(100-this.coords.p_handle)*100},convertToFakePercent:function(a){return a/100*(100-this.coords.p_handle)},getHandleX:function(){var a=100-this.coords.p_handle,b=this.toFixed(this.coords.p_pointer-this.coords.p_gap);0>b?b=0:b>a&&(b=a);return b},calcHandlePercent:function(){this.coords.w_handle=
"single"===this.options.type?this.$cache.s_single.outerWidth(!1):this.$cache.s_from.outerWidth(!1);this.coords.p_handle=this.toFixed(this.coords.w_handle/this.coords.w_rs*100)},chooseHandle:function(a){return"single"===this.options.type?"single":a>=this.coords.p_from_real+(this.coords.p_to_real-this.coords.p_from_real)/2?this.options.to_fixed?"from":"to":this.options.from_fixed?"to":"from"},calcMinMax:function(){this.coords.w_rs&&(this.labels.p_min=this.labels.w_min/this.coords.w_rs*100,this.labels.p_max=
this.labels.w_max/this.coords.w_rs*100)},calcLabels:function(){this.coords.w_rs&&!this.options.hide_from_to&&("single"===this.options.type?(this.labels.w_single=this.$cache.single.outerWidth(!1),this.labels.p_single_fake=this.labels.w_single/this.coords.w_rs*100,this.labels.p_single_left=this.coords.p_single_fake+this.coords.p_handle/2-this.labels.p_single_fake/2):(this.labels.w_from=this.$cache.from.outerWidth(!1),this.labels.p_from_fake=this.labels.w_from/this.coords.w_rs*100,this.labels.p_from_left=
this.coords.p_from_fake+this.coords.p_handle/2-this.labels.p_from_fake/2,this.labels.p_from_left=this.toFixed(this.labels.p_from_left),this.labels.p_from_left=this.checkEdges(this.labels.p_from_left,this.labels.p_from_fake),this.labels.w_to=this.$cache.to.outerWidth(!1),this.labels.p_to_fake=this.labels.w_to/this.coords.w_rs*100,this.labels.p_to_left=this.coords.p_to_fake+this.coords.p_handle/2-this.labels.p_to_fake/2,this.labels.p_to_left=this.toFixed(this.labels.p_to_left),this.labels.p_to_left=
this.checkEdges(this.labels.p_to_left,this.labels.p_to_fake),this.labels.w_single=this.$cache.single.outerWidth(!1),this.labels.p_single_fake=this.labels.w_single/this.coords.w_rs*100,this.labels.p_single_left=(this.labels.p_from_left+this.labels.p_to_left+this.labels.p_to_fake)/2-this.labels.p_single_fake/2,this.labels.p_single_left=this.toFixed(this.labels.p_single_left)),this.labels.p_single_left=this.checkEdges(this.labels.p_single_left,this.labels.p_single_fake))},updateScene:function(){this.raf_id&&
(cancelAnimationFrame(this.raf_id),this.raf_id=null);clearTimeout(this.update_tm);this.update_tm=null;this.options&&(this.drawHandles(),this.is_active?this.raf_id=requestAnimationFrame(this.updateScene.bind(this)):this.update_tm=setTimeout(this.updateScene.bind(this),300))},drawHandles:function(){this.coords.w_rs=this.$cache.rs.outerWidth(!1);if(this.coords.w_rs){this.coords.w_rs!==this.coords.w_rs_old&&(this.target="base",this.is_resize=!0);if(this.coords.w_rs!==this.coords.w_rs_old||this.force_redraw)this.setMinMax(),
this.calc(!0),this.drawLabels(),this.options.grid&&(this.calcGridMargin(),this.calcGridLabels()),this.force_redraw=!0,this.coords.w_rs_old=this.coords.w_rs,this.drawShadow();if(this.coords.w_rs&&(this.dragging||this.force_redraw||this.is_key)){if(this.old_from!==this.result.from||this.old_to!==this.result.to||this.force_redraw||this.is_key){this.drawLabels();this.$cache.bar[0].style.left=this.coords.p_bar_x+"%";this.$cache.bar[0].style.width=this.coords.p_bar_w+"%";if("single"===this.options.type)this.$cache.s_single[0].style.left=
this.coords.p_single_fake+"%",this.$cache.single[0].style.left=this.labels.p_single_left+"%",this.options.values.length?this.$cache.input.prop("value",this.result.from_value):this.$cache.input.prop("value",this.result.from),this.$cache.input.data("from",this.result.from);else{this.$cache.s_from[0].style.left=this.coords.p_from_fake+"%";this.$cache.s_to[0].style.left=this.coords.p_to_fake+"%";if(this.old_from!==this.result.from||this.force_redraw)this.$cache.from[0].style.left=this.labels.p_from_left+
"%";if(this.old_to!==this.result.to||this.force_redraw)this.$cache.to[0].style.left=this.labels.p_to_left+"%";this.$cache.single[0].style.left=this.labels.p_single_left+"%";this.options.values.length?this.$cache.input.prop("value",this.result.from_value+this.options.input_values_separator+this.result.to_value):this.$cache.input.prop("value",this.result.from+this.options.input_values_separator+this.result.to);this.$cache.input.data("from",this.result.from);this.$cache.input.data("to",this.result.to)}this.old_from===
this.result.from&&this.old_to===this.result.to||this.is_start||this.$cache.input.trigger("change");this.old_from=this.result.from;this.old_to=this.result.to;this.is_resize||this.is_update||this.is_start||this.is_finish||this.callOnChange();if(this.is_key||this.is_click)this.is_click=this.is_key=!1,this.callOnFinish();this.is_finish=this.is_resize=this.is_update=!1}this.force_redraw=this.is_click=this.is_key=this.is_start=!1}}},drawLabels:function(){if(this.options){var a=this.options.values.length,
b=this.options.p_values,d;if(!this.options.hide_from_to)if("single"===this.options.type)a=a?this.decorate(b[this.result.from]):this.decorate(this._prettify(this.result.from),this.result.from),this.$cache.single.html(a),this.calcLabels(),this.$cache.min[0].style.visibility=this.labels.p_single_left<this.labels.p_min+1?"hidden":"visible",this.$cache.max[0].style.visibility=this.labels.p_single_left+this.labels.p_single_fake>100-this.labels.p_max-1?"hidden":"visible";else{a?(this.options.decorate_both?
(a=this.decorate(b[this.result.from]),a+=this.options.values_separator,a+=this.decorate(b[this.result.to])):a=this.decorate(b[this.result.from]+this.options.values_separator+b[this.result.to]),d=this.decorate(b[this.result.from]),b=this.decorate(b[this.result.to])):(this.options.decorate_both?(a=this.decorate(this._prettify(this.result.from),this.result.from),a+=this.options.values_separator,a+=this.decorate(this._prettify(this.result.to),this.result.to)):a=this.decorate(this._prettify(this.result.from)+
this.options.values_separator+this._prettify(this.result.to),this.result.to),d=this.decorate(this._prettify(this.result.from),this.result.from),b=this.decorate(this._prettify(this.result.to),this.result.to));this.$cache.single.html(a);this.$cache.from.html(d);this.$cache.to.html(b);this.calcLabels();b=Math.min(this.labels.p_single_left,this.labels.p_from_left);a=this.labels.p_single_left+this.labels.p_single_fake;d=this.labels.p_to_left+this.labels.p_to_fake;var c=Math.max(a,d);this.labels.p_from_left+
this.labels.p_from_fake>=this.labels.p_to_left?(this.$cache.from[0].style.visibility="hidden",this.$cache.to[0].style.visibility="hidden",this.$cache.single[0].style.visibility="visible",this.result.from===this.result.to?("from"===this.target?this.$cache.from[0].style.visibility="visible":"to"===this.target?this.$cache.to[0].style.visibility="visible":this.target||(this.$cache.from[0].style.visibility="visible"),this.$cache.single[0].style.visibility="hidden",c=d):(this.$cache.from[0].style.visibility=
"hidden",this.$cache.to[0].style.visibility="hidden",this.$cache.single[0].style.visibility="visible",c=Math.max(a,d))):(this.$cache.from[0].style.visibility="visible",this.$cache.to[0].style.visibility="visible",this.$cache.single[0].style.visibility="hidden");this.$cache.min[0].style.visibility=b<this.labels.p_min+1?"hidden":"visible";this.$cache.max[0].style.visibility=c>100-this.labels.p_max-1?"hidden":"visible"}}},drawShadow:function(){var a=this.options,b=this.$cache,d="number"===typeof a.from_min&&
!isNaN(a.from_min),c="number"===typeof a.from_max&&!isNaN(a.from_max),e="number"===typeof a.to_min&&!isNaN(a.to_min),f="number"===typeof a.to_max&&!isNaN(a.to_max);"single"===a.type?a.from_shadow&&(d||c)?(d=this.convertToPercent(d?a.from_min:a.min),c=this.convertToPercent(c?a.from_max:a.max)-d,d=this.toFixed(d-this.coords.p_handle/100*d),c=this.toFixed(c-this.coords.p_handle/100*c),d+=this.coords.p_handle/2,b.shad_single[0].style.display="block",b.shad_single[0].style.left=d+"%",b.shad_single[0].style.width=
c+"%"):b.shad_single[0].style.display="none":(a.from_shadow&&(d||c)?(d=this.convertToPercent(d?a.from_min:a.min),c=this.convertToPercent(c?a.from_max:a.max)-d,d=this.toFixed(d-this.coords.p_handle/100*d),c=this.toFixed(c-this.coords.p_handle/100*c),d+=this.coords.p_handle/2,b.shad_from[0].style.display="block",b.shad_from[0].style.left=d+"%",b.shad_from[0].style.width=c+"%"):b.shad_from[0].style.display="none",a.to_shadow&&(e||f)?(e=this.convertToPercent(e?a.to_min:a.min),a=this.convertToPercent(f?
a.to_max:a.max)-e,e=this.toFixed(e-this.coords.p_handle/100*e),a=this.toFixed(a-this.coords.p_handle/100*a),e+=this.coords.p_handle/2,b.shad_to[0].style.display="block",b.shad_to[0].style.left=e+"%",b.shad_to[0].style.width=a+"%"):b.shad_to[0].style.display="none")},callOnStart:function(){if(this.options.onStart&&"function"===typeof this.options.onStart)this.options.onStart(this.result)},callOnChange:function(){if(this.options.onChange&&"function"===typeof this.options.onChange)this.options.onChange(this.result)},
callOnFinish:function(){if(this.options.onFinish&&"function"===typeof this.options.onFinish)this.options.onFinish(this.result)},callOnUpdate:function(){if(this.options.onUpdate&&"function"===typeof this.options.onUpdate)this.options.onUpdate(this.result)},toggleInput:function(){this.$cache.input.toggleClass("irs-hidden-input")},convertToPercent:function(a,b){var d=this.options.max-this.options.min;return d?this.toFixed((b?a:a-this.options.min)/(d/100)):(this.no_diapason=!0,0)},convertToValue:function(a){var b=
this.options.min,d=this.options.max,c=b.toString().split(".")[1],e=d.toString().split(".")[1],f,l,g=0,k=0;if(0===a)return this.options.min;if(100===a)return this.options.max;c&&(g=f=c.length);e&&(g=l=e.length);f&&l&&(g=f>=l?f:l);0>b&&(k=Math.abs(b),b=+(b+k).toFixed(g),d=+(d+k).toFixed(g));a=(d-b)/100*a+b;(b=this.options.step.toString().split(".")[1])?a=+a.toFixed(b.length):(a/=this.options.step,a*=this.options.step,a=+a.toFixed(0));k&&(a-=k);k=b?+a.toFixed(b.length):this.toFixed(a);k<this.options.min?
k=this.options.min:k>this.options.max&&(k=this.options.max);return k},calcWithStep:function(a){var b=Math.round(a/this.coords.p_step)*this.coords.p_step;100<b&&(b=100);100===a&&(b=100);return this.toFixed(b)},checkMinInterval:function(a,b,d){var c=this.options;if(!c.min_interval)return a;a=this.convertToValue(a);b=this.convertToValue(b);"from"===d?b-a<c.min_interval&&(a=b-c.min_interval):a-b<c.min_interval&&(a=b+c.min_interval);return this.convertToPercent(a)},checkMaxInterval:function(a,b,d){var c=
this.options;if(!c.max_interval)return a;a=this.convertToValue(a);b=this.convertToValue(b);"from"===d?b-a>c.max_interval&&(a=b-c.max_interval):a-b>c.max_interval&&(a=b+c.max_interval);return this.convertToPercent(a)},checkDiapason:function(a,b,d){a=this.convertToValue(a);var c=this.options;"number"!==typeof b&&(b=c.min);"number"!==typeof d&&(d=c.max);a<b&&(a=b);a>d&&(a=d);return this.convertToPercent(a)},toFixed:function(a){a=a.toFixed(9);return+a},_prettify:function(a){return this.options.prettify_enabled?
this.options.prettify&&"function"===typeof this.options.prettify?this.options.prettify(a):this.prettify(a):a},prettify:function(a){return a.toString().replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g,"$1"+this.options.prettify_separator)},checkEdges:function(a,b){if(!this.options.force_edges)return this.toFixed(a);0>a?a=0:a>100-b&&(a=100-b);return this.toFixed(a)},validate:function(){var a=this.options,b=this.result,d=a.values,c=d.length,e,f;"string"===typeof a.min&&(a.min=+a.min);"string"===typeof a.max&&
(a.max=+a.max);"string"===typeof a.from&&(a.from=+a.from);"string"===typeof a.to&&(a.to=+a.to);"string"===typeof a.step&&(a.step=+a.step);"string"===typeof a.from_min&&(a.from_min=+a.from_min);"string"===typeof a.from_max&&(a.from_max=+a.from_max);"string"===typeof a.to_min&&(a.to_min=+a.to_min);"string"===typeof a.to_max&&(a.to_max=+a.to_max);"string"===typeof a.keyboard_step&&(a.keyboard_step=+a.keyboard_step);"string"===typeof a.grid_num&&(a.grid_num=+a.grid_num);a.max<a.min&&(a.max=a.min);if(c)for(a.p_values=
[],a.min=0,a.max=c-1,a.step=1,a.grid_num=a.max,a.grid_snap=!0,f=0;f<c;f++)e=+d[f],isNaN(e)?e=d[f]:(d[f]=e,e=this._prettify(e)),a.p_values.push(e);if("number"!==typeof a.from||isNaN(a.from))a.from=a.min;if("number"!==typeof a.to||isNaN(a.from))a.to=a.max;if("single"===a.type)a.from<a.min&&(a.from=a.min),a.from>a.max&&(a.from=a.max);else{if(a.from<a.min||a.from>a.max)a.from=a.min;if(a.to>a.max||a.to<a.min)a.to=a.max;a.from>a.to&&(a.from=a.to)}if("number"!==typeof a.step||isNaN(a.step)||!a.step||0>a.step)a.step=
1;if("number"!==typeof a.keyboard_step||isNaN(a.keyboard_step)||!a.keyboard_step||0>a.keyboard_step)a.keyboard_step=5;"number"===typeof a.from_min&&a.from<a.from_min&&(a.from=a.from_min);"number"===typeof a.from_max&&a.from>a.from_max&&(a.from=a.from_max);"number"===typeof a.to_min&&a.to<a.to_min&&(a.to=a.to_min);"number"===typeof a.to_max&&a.from>a.to_max&&(a.to=a.to_max);if(b){b.min!==a.min&&(b.min=a.min);b.max!==a.max&&(b.max=a.max);if(b.from<b.min||b.from>b.max)b.from=a.from;if(b.to<b.min||b.to>
b.max)b.to=a.to}if("number"!==typeof a.min_interval||isNaN(a.min_interval)||!a.min_interval||0>a.min_interval)a.min_interval=0;if("number"!==typeof a.max_interval||isNaN(a.max_interval)||!a.max_interval||0>a.max_interval)a.max_interval=0;a.min_interval&&a.min_interval>a.max-a.min&&(a.min_interval=a.max-a.min);a.max_interval&&a.max_interval>a.max-a.min&&(a.max_interval=a.max-a.min)},decorate:function(a,b){var d="",c=this.options;c.prefix&&(d+=c.prefix);d+=a;c.max_postfix&&(c.values.length&&a===c.p_values[c.max]?
(d+=c.max_postfix,c.postfix&&(d+=" ")):b===c.max&&(d+=c.max_postfix,c.postfix&&(d+=" ")));c.postfix&&(d+=c.postfix);return d},updateFrom:function(){this.result.from=this.options.from;this.result.from_percent=this.convertToPercent(this.result.from);this.options.values&&(this.result.from_value=this.options.values[this.result.from])},updateTo:function(){this.result.to=this.options.to;this.result.to_percent=this.convertToPercent(this.result.to);this.options.values&&(this.result.to_value=this.options.values[this.result.to])},
updateResult:function(){this.result.min=this.options.min;this.result.max=this.options.max;this.updateFrom();this.updateTo()},appendGrid:function(){if(this.options.grid){var a=this.options,b,d;b=a.max-a.min;var c=a.grid_num,e=0,f=0,g=4,h,k,m=0,n="";this.calcGridMargin();a.grid_snap?(c=b/a.step,e=this.toFixed(a.step/(b/100))):e=this.toFixed(100/c);4<c&&(g=3);7<c&&(g=2);14<c&&(g=1);28<c&&(g=0);for(b=0;b<c+1;b++){h=g;f=this.toFixed(e*b);100<f&&(f=100,h-=2,0>h&&(h=0));this.coords.big[b]=f;k=(f-e*(b-1))/
(h+1);for(d=1;d<=h&&0!==f;d++)m=this.toFixed(f-k*d),n+='<span class="irs-grid-pol small" style="left: '+m+'%"></span>';n+='<span class="irs-grid-pol" style="left: '+f+'%"></span>';m=this.convertToValue(f);m=a.values.length?a.p_values[m]:this._prettify(m);n+='<span class="irs-grid-text js-grid-text-'+b+'" style="left: '+f+'%">'+m+"</span>"}this.coords.big_num=Math.ceil(c+1);this.$cache.cont.addClass("irs-with-grid");this.$cache.grid.html(n);this.cacheGridLabels()}},cacheGridLabels:function(){var a,
b,d=this.coords.big_num;for(b=0;b<d;b++)a=this.$cache.grid.find(".js-grid-text-"+b),this.$cache.grid_labels.push(a);this.calcGridLabels()},calcGridLabels:function(){var a,b;b=[];var d=[],c=this.coords.big_num;for(a=0;a<c;a++)this.coords.big_w[a]=this.$cache.grid_labels[a].outerWidth(!1),this.coords.big_p[a]=this.toFixed(this.coords.big_w[a]/this.coords.w_rs*100),this.coords.big_x[a]=this.toFixed(this.coords.big_p[a]/2),b[a]=this.toFixed(this.coords.big[a]-this.coords.big_x[a]),d[a]=this.toFixed(b[a]+
this.coords.big_p[a]);this.options.force_edges&&(b[0]<-this.coords.grid_gap&&(b[0]=-this.coords.grid_gap,d[0]=this.toFixed(b[0]+this.coords.big_p[0]),this.coords.big_x[0]=this.coords.grid_gap),d[c-1]>100+this.coords.grid_gap&&(d[c-1]=100+this.coords.grid_gap,b[c-1]=this.toFixed(d[c-1]-this.coords.big_p[c-1]),this.coords.big_x[c-1]=this.toFixed(this.coords.big_p[c-1]-this.coords.grid_gap)));this.calcGridCollision(2,b,d);this.calcGridCollision(4,b,d);for(a=0;a<c;a++)b=this.$cache.grid_labels[a][0],
b.style.marginLeft=-this.coords.big_x[a]+"%"},calcGridCollision:function(a,b,d){var c,e,f,g=this.coords.big_num;for(c=0;c<g;c+=a){e=c+a/2;if(e>=g)break;f=this.$cache.grid_labels[e][0];f.style.visibility=d[c]<=b[e]?"visible":"hidden"}},calcGridMargin:function(){this.options.grid_margin&&(this.coords.w_rs=this.$cache.rs.outerWidth(!1),this.coords.w_rs&&(this.coords.w_handle="single"===this.options.type?this.$cache.s_single.outerWidth(!1):this.$cache.s_from.outerWidth(!1),this.coords.p_handle=this.toFixed(this.coords.w_handle/
this.coords.w_rs*100),this.coords.grid_gap=this.toFixed(this.coords.p_handle/2-.1),this.$cache.grid[0].style.width=this.toFixed(100-this.coords.p_handle)+"%",this.$cache.grid[0].style.left=this.coords.grid_gap+"%"))},update:function(a){this.input&&(this.is_update=!0,this.options.from=this.result.from,this.options.to=this.result.to,this.options=g.extend(this.options,a),this.validate(),this.updateResult(a),this.toggleInput(),this.remove(),this.init(!0))},reset:function(){this.input&&(this.updateResult(),
this.update())},destroy:function(){this.input&&(this.toggleInput(),this.$cache.input.prop("readonly",!1),g.data(this.input,"ionRangeSlider",null),this.remove(),this.options=this.input=null)}};g.fn.ionRangeSlider=function(a){return this.each(function(){g.data(this,"ionRangeSlider")||g.data(this,"ionRangeSlider",new r(this,a,u++))})};(function(){for(var a=0,b=["ms","moz","webkit","o"],d=0;d<b.length&&!h.requestAnimationFrame;++d)h.requestAnimationFrame=h[b[d]+"RequestAnimationFrame"],h.cancelAnimationFrame=
h[b[d]+"CancelAnimationFrame"]||h[b[d]+"CancelRequestAnimationFrame"];h.requestAnimationFrame||(h.requestAnimationFrame=function(b,d){var f=(new Date).getTime(),g=Math.max(0,16-(f-a)),p=h.setTimeout(function(){b(f+g)},g);a=f+g;return p});h.cancelAnimationFrame||(h.cancelAnimationFrame=function(a){clearTimeout(a)})})()});

function roundToNearestHalf(num, direction) {
	if (direction === 'floor') {
		return Math.floor(num/5) * 5;
	  } else if (direction === 'ceil') {
		return Math.ceil(num/5) * 5;
	  }
	  return num;
	  
  }

/*!
 * instantsearch-ion.rangeSlider 0.2.1
 * https://github.com/algolia/instantsearch-ion.rangeSlider
 * Copyright 2016 Algolia, Inc. and other contributors; Licensed MIT
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var $ = __webpack_require__(2);
	var instantsearch = __webpack_require__(3);

	function uniq(a) {
	  return a.reduce(function(p, c) {
	    if (p.indexOf(c) < 0) {
	      p.push(c);
	    }
	    return p;
	  }, []);
	}

	function slider(options) {
		
	  if (!options.attributeName || !options.container) {
	    throw new Error('ion.rangeSlider: usage: ionRangeSlider({container, attributeName, ionRangeSliderOptions})');
	  }
	  var $container = $(options.container);
	  if ($container.length === 0) {
	    throw new Error('ion.rangeSlider: cannot select \'' + options.container + '\'');
	  }
	  if (!$.fn.ionRangeSlider) {
	    throw new Error('The ion.rangeSlider jQuery plugin is missing. Did you include ion.rangeSlider.min.js?');
	  }

	  var lowerBoundAttributeName = options.attributeName.lowerBound || options.attributeName;
	  var upperBoundAttributeName = options.attributeName.upperBound || options.attributeName;
	  var ionRangeSliderOptions = options.ionRangeSliderOptions || {};

	  var needFacet = typeof options.min === 'undefined' || typeof options.max === 'undefined';
	  var ionRangeSlider;
	  
	  var urlValues;
	  
	  var minRange = 0;
	  var maxRange = 0
	  return {
		  
	    getConfiguration: function() {
	      return needFacet ? {
	        disjunctiveFacets: uniq([lowerBoundAttributeName, upperBoundAttributeName])
	      } : {};
	    },

	    init: function(args) {
		    
		    var helper = args.helper;
	      if (typeof options.min !== 'undefined') {
	        helper.addNumericRefinement(lowerBoundAttributeName, '>=', options.min);
	      }
	      if (typeof options.max !== 'undefined') {
	        helper.addNumericRefinement(upperBoundAttributeName, '<=', options.max);
	      }
	    },

	    render: function(args ) {
		
		  var helper = args.helper;
		  var results = args.results;

		  if(results.getFacetValues( options.attributeName) === undefined || results.getFacetValues( options.attributeName).length === 0)
		  {
			$container.hide();
			 return;
		  }
		  
	      var from = helper.state.getNumericRefinement(lowerBoundAttributeName, '>=');
	      from = from && from[0];

	      var to = helper.state.getNumericRefinement(upperBoundAttributeName, '<=');
	      to = to && to[0];
	      
	      var min;
	      var max;
	      if (needFacet) {
	        var lowerFacetStats = results.getFacetStats(lowerBoundAttributeName);
	        var upperFacetStats = results.getFacetStats(upperBoundAttributeName);
	        min = lowerFacetStats ? Math.floor(lowerFacetStats.min) : 0;
	        max = upperFacetStats ? Math.ceil(upperFacetStats.max) : 0;
	      } else {
	        min = options.min;
	        max = options.max;
	      }
	      from = from || min;
	      to = to || max;

	      if(minRange == 0)
	      {
		      minRange = min;
	      }
	      
	      if(maxRange == 0)
	      {
		      maxRange = max;
	      }

	      
	      function sendSliderAdjustmentToAlgolia(data)
	  {
		  
		  if(data.from === data.to)
		  {
		  	data.to += 1;
		  	data.from -= 1;
		  
		  }
		
		  if (data.from !== from && from > 1) {
	            helper.removeNumericRefinement(lowerBoundAttributeName, '>=');
	            helper.addNumericRefinement(lowerBoundAttributeName, '>=', data.from);
	            helper.search();
	            
	            if(dataLayer != 'undefined')
				{
					dataLayer.push({
				     'price': data.from,
				     'event': 'fromPriceUpdate'}
				    );
				}
				
	
	          }
	          if (data.to !== to && to > 1) {
	            helper.removeNumericRefinement(upperBoundAttributeName, '<=');
	            helper.addNumericRefinement(upperBoundAttributeName, '<=', data.to);
	            helper.search();
	            
	            if(dataLayer != 'undefined')
				{
					dataLayer.push({
				     'price': data.to,
				     'event': 'toPriceUpdate'}
				    );
				}
				
	          }
	          
	          
	      	        
		  
		  if(to <= 1)
		  {
			 // ionRangeSlider.destroy();
			 // $('#sliderInputs, #instantsearchPrijs').remove();
		  }
	  }

	  var useMin = (minRange > from ? from : minRange);
	  var useMax = (maxRange > to ? maxRange : to);
	  from = roundToNearestHalf(from, 'floor');
	  useMin = roundToNearestHalf(useMin, 'floor');
	  useMax = roundToNearestHalf(useMax, 'ceil');
	  to = roundToNearestHalf(to, 'ceil');

	  var useMaxExceeds300 = useMax > 300;
	  var toMaxExceeds300 = to > 300;

	  if(useMaxExceeds300)
	  {
		useMax = 300;
	  }


	  if(toMaxExceeds300)
	  {
		to = 300;
	  }

	  if(parseInt($('[name="rangeStart"]').val()) != from) $('[name="rangeStart"]').val(from);

	  if(parseInt($('[name="rangeStop"]').val()) != from) $('[name="rangeStop"]').val(to);

	  
	      var sliderOptions = {
	        type: 'double',
	        grid: true,
	        min: useMin,
	        max: useMax,
	        from: from,
	        to: to,
	        onChange: function(data)
	        {
		        $('[name="rangeStart"]').val(data.from);
		        $('[name="rangeStop"]').val(data.to);
	        },
	        onFinish: function(data) {
		        sendSliderAdjustmentToAlgolia(data);
	        },
			prettify: function(n) { return n >= 300 ? '300+': n;}
	      };

	      sliderOptions = $.extend({}, sliderOptions, ionRangeSliderOptions);
	      $container.show();
	      
	      if (ionRangeSlider) {
	        ionRangeSlider.update(sliderOptions);
	      } else {
	        $container.ionRangeSlider(sliderOptions);
	        ionRangeSlider = $container.data('ionRangeSlider');
	      }
	      
	      
	      //$('#sliderInputs').remove();
	      
	     sendSliderAdjustmentToAlgolia({from: Math.floor(from), to: Math.ceil(to)});
	      
		 if( $('#sliderInputs').length === 0)
		 {
			var $manualInput = $('<div class="manualInputs text-center" id="sliderInputs">&euro; <input name="rangeStart" type="number" min="5" max="300" step="5" value="'+Math.floor(from)+'"> '+transl.tot+' &euro; <input type="number" step="5" name="rangeStop" min="5" max="300" value="'+Math.ceil(to)+'"></div>');
	     	 $manualInput.insertAfter(options.container);

			  $manualInput.find('input').on('change',function(e)
			  {
				var newFrom = roundToNearestHalf(parseInt($('input[name="rangeStart"]').val()), 'floor');
				var newTo = roundToNearestHalf(parseInt($('input[name="rangeStop"]').val()), 'ceil');
	
	
				 sendSliderAdjustmentToAlgolia({from: newFrom, to: newTo});
				 
				 
			  });

		 }
		
	      
		 
	    }
	  };
	}

	module.exports = instantsearch.widgets.ionRangeSlider = slider;


/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = instantsearch;

/***/ }
/******/ ]);
/*! iCheck v1.0.2 by Damir Sultanov, http://git.io/arlzeA, MIT Licensed */
(function(f){function A(a,b,d){var c=a[0],g=/er/.test(d)?_indeterminate:/bl/.test(d)?n:k,e=d==_update?{checked:c[k],disabled:c[n],indeterminate:"true"==a.attr(_indeterminate)||"false"==a.attr(_determinate)}:c[g];if(/^(ch|di|in)/.test(d)&&!e)x(a,g);else if(/^(un|en|de)/.test(d)&&e)q(a,g);else if(d==_update)for(var f in e)e[f]?x(a,f,!0):q(a,f,!0);else if(!b||"toggle"==d){if(!b)a[_callback]("ifClicked");e?c[_type]!==r&&q(a,g):x(a,g)}}function x(a,b,d){var c=a[0],g=a.parent(),e=b==k,u=b==_indeterminate,
v=b==n,s=u?_determinate:e?y:"enabled",F=l(a,s+t(c[_type])),B=l(a,b+t(c[_type]));if(!0!==c[b]){if(!d&&b==k&&c[_type]==r&&c.name){var w=a.closest("form"),p='input[name="'+c.name+'"]',p=w.length?w.find(p):f(p);p.each(function(){this!==c&&f(this).data(m)&&q(f(this),b)})}u?(c[b]=!0,c[k]&&q(a,k,"force")):(d||(c[b]=!0),e&&c[_indeterminate]&&q(a,_indeterminate,!1));D(a,e,b,d)}c[n]&&l(a,_cursor,!0)&&g.find("."+C).css(_cursor,"default");g[_add](B||l(a,b)||"");g.attr("role")&&!u&&g.attr("aria-"+(v?n:k),"true");
g[_remove](F||l(a,s)||"")}function q(a,b,d){var c=a[0],g=a.parent(),e=b==k,f=b==_indeterminate,m=b==n,s=f?_determinate:e?y:"enabled",q=l(a,s+t(c[_type])),r=l(a,b+t(c[_type]));if(!1!==c[b]){if(f||!d||"force"==d)c[b]=!1;D(a,e,s,d)}!c[n]&&l(a,_cursor,!0)&&g.find("."+C).css(_cursor,"pointer");g[_remove](r||l(a,b)||"");g.attr("role")&&!f&&g.attr("aria-"+(m?n:k),"false");g[_add](q||l(a,s)||"")}function E(a,b){if(a.data(m)){a.parent().html(a.attr("style",a.data(m).s||""));if(b)a[_callback](b);a.off(".i").unwrap();
f(_label+'[for="'+a[0].id+'"]').add(a.closest(_label)).off(".i")}}function l(a,b,f){if(a.data(m))return a.data(m).o[b+(f?"":"Class")]}function t(a){return a.charAt(0).toUpperCase()+a.slice(1)}function D(a,b,f,c){if(!c){if(b)a[_callback]("ifToggled");a[_callback]("ifChanged")[_callback]("if"+t(f))}}var m="iCheck",C=m+"-helper",r="radio",k="checked",y="un"+k,n="disabled";_determinate="determinate";_indeterminate="in"+_determinate;_update="update";_type="type";_click="click";_touch="touchbegin.i touchend.i";
_add="addClass";_remove="removeClass";_callback="trigger";_label="label";_cursor="cursor";_mobile=/ipad|iphone|ipod|android|blackberry|windows phone|opera mini|silk/i.test(navigator.userAgent);f.fn[m]=function(a,b){var d='input[type="checkbox"], input[type="'+r+'"]',c=f(),g=function(a){a.each(function(){var a=f(this);c=a.is(d)?c.add(a):c.add(a.find(d))})};if(/^(check|uncheck|toggle|indeterminate|determinate|disable|enable|update|destroy)$/i.test(a))return a=a.toLowerCase(),g(this),c.each(function(){var c=
f(this);"destroy"==a?E(c,"ifDestroyed"):A(c,!0,a);f.isFunction(b)&&b()});if("object"!=typeof a&&a)return this;var e=f.extend({checkedClass:k,disabledClass:n,indeterminateClass:_indeterminate,labelHover:!0},a),l=e.handle,v=e.hoverClass||"hover",s=e.focusClass||"focus",t=e.activeClass||"active",B=!!e.labelHover,w=e.labelHoverClass||"hover",p=(""+e.increaseArea).replace("%","")|0;if("checkbox"==l||l==r)d='input[type="'+l+'"]';-50>p&&(p=-50);g(this);return c.each(function(){var a=f(this);E(a);var c=this,
b=c.id,g=-p+"%",d=100+2*p+"%",d={position:"absolute",top:g,left:g,display:"block",width:d,height:d,margin:0,padding:0,background:"#fff",border:0,opacity:0},g=_mobile?{position:"absolute",visibility:"hidden"}:p?d:{position:"absolute",opacity:0},l="checkbox"==c[_type]?e.checkboxClass||"icheckbox":e.radioClass||"i"+r,z=f(_label+'[for="'+b+'"]').add(a.closest(_label)),u=!!e.aria,y=m+"-"+Math.random().toString(36).substr(2,6),h='<div class="'+l+'" '+(u?'role="'+c[_type]+'" ':"");u&&z.each(function(){h+=
'aria-labelledby="';this.id?h+=this.id:(this.id=y,h+=y);h+='"'});h=a.wrap(h+"/>")[_callback]("ifCreated").parent().append(e.insert);d=f('<ins class="'+C+'"/>').css(d).appendTo(h);a.data(m,{o:e,s:a.attr("style")}).css(g);e.inheritClass&&h[_add](c.className||"");e.inheritID&&b&&h.attr("id",m+"-"+b);"static"==h.css("position")&&h.css("position","relative");A(a,!0,_update);if(z.length)z.on(_click+".i mouseover.i mouseout.i "+_touch,function(b){var d=b[_type],e=f(this);if(!c[n]){if(d==_click){if(f(b.target).is("a"))return;
A(a,!1,!0)}else B&&(/ut|nd/.test(d)?(h[_remove](v),e[_remove](w)):(h[_add](v),e[_add](w)));if(_mobile)b.stopPropagation();else return!1}});a.on(_click+".i focus.i blur.i keyup.i keydown.i keypress.i",function(b){var d=b[_type];b=b.keyCode;if(d==_click)return!1;if("keydown"==d&&32==b)return c[_type]==r&&c[k]||(c[k]?q(a,k):x(a,k)),!1;if("keyup"==d&&c[_type]==r)!c[k]&&x(a,k);else if(/us|ur/.test(d))h["blur"==d?_remove:_add](s)});d.on(_click+" mousedown mouseup mouseover mouseout "+_touch,function(b){var d=
b[_type],e=/wn|up/.test(d)?t:v;if(!c[n]){if(d==_click)A(a,!1,!0);else{if(/wn|er|in/.test(d))h[_add](e);else h[_remove](e+" "+t);if(z.length&&B&&e==v)z[/ut|nd/.test(d)?_remove:_add](w)}if(_mobile)b.stopPropagation();else return!1}})})}})(window.jQuery||window.Zepto);

(function ($) {
    var $document = $(document);
    $document.on("click", "a.push-back, .filterTotals button", function (e) {
        e.preventDefault();
        $("body").removeClass("uitgeschoven");
        $("#chat-application").show();
        $(".mobileContainer").hide();
    });

    $document.on("click", "a.show-filters", function (e) {
        e.preventDefault();
        $("body").addClass("uitgeschoven");
        $("#chat-application").hide();
        $(".mobileContainer").show();

        $("#filterForm .subfilter.opened:not(.mobile-keep-opened)").removeClass("opened");
    });

    $document.on("change", "#sort-by-container select", function () {
        var selectedOption = $(
            "#sort-by-container select option:checked"
        ).text();

        if (typeof dataLayer != "undefined") {
            dataLayer.push({
                sortby: selectedOption,
                event: "searchSort",
            });
        }
    });

    $document.on("click", ".bcfilter-close", function (e) {
        e.preventDefault();

        $("body").removeClass("uitgeschoven");
        $("#chat-application").show();
        $(".mobileContainer").hide();
    });
})(jQuery);

(function ($) {
    var $document = $(document);

    //   Functions for no scrolling, and Preserve scrolling position
    var filterScrollY;
    $(window).on("scroll", function (event) {
        var filterScrollY = $(window).scrollTop();
    });

    function noScroll() {
        window.scrollTo(0, filterScrollY);
    }

    $(window).on("scroll", function () {
        if ($("#filter-background-overlay").is("visible")) {
            return false;
        }
    });

    //   Hide
    $document.on(
        "click",
        "a.push-back, #filter-background-overlay, .filterTotals button",
        function (e) {
            e.preventDefault();
            $("body").removeClass("uitgeschoven");
            $("#chat-application").show();
            $(".mobileContainer").hide();

            $("#filter-background-overlay").hide();

            filterScrollY = $(window).scrollTop();
            //window.removeEventListener("scroll", noScroll); // enable scroll

            $("a.show-filters").show();

            if ($(window).width() > 767 && $(window).width() <= 992) {
                $(".two-columns .left-column").hide();
            }
        }
    );

    //   Show
    $document.on("click", "a.show-filters", function (e) {
        $("#filter-background-overlay").show();
        filterScrollY = $(window).scrollTop();
        //window.addEventListener("scroll", noScroll); // disable scroll
        $(".two-columns .left-column").show();
    });
})(jQuery);

class DeliveryTime {
    constructor() {
        this.dayRanges = [];
        this.supplierTypes = [1, 2, 3, 4];
        this.timeRanges = {
            1: [1, 2],
            2: [2, 3],
            3: [4, 5],
            4: [5, 8],
        };

        try {
            this.holidays =
                typeof window.holidays === "string"
                    ? JSON.parse(window.holidays)
                    : [];
        } catch (e) {
            this.holidays = [];
        }

        this.weekdays = maintransl.weekdays;
    }

    _dateAddWorkingDays(deliveryDate, daysToAdd) {
        let daysAdded = 0;

        while (daysAdded < daysToAdd) {
            deliveryDate.setDate(deliveryDate.getDate() + 1);

            const formattedDate = `${deliveryDate.getFullYear()}-${String(
                deliveryDate.getMonth() + 1
            ).padStart(2, "0")}-${String(deliveryDate.getDate()).padStart(
                2,
                "0"
            )}`;

            if (
                deliveryDate.getDay() !== 0 &&
                deliveryDate.getDay() !== 6 &&
                !this.holidays.includes(formattedDate)
            ) {
                daysAdded++;
            }
        }
        return deliveryDate;
    }

    _getCalculationTime() {
        const today = new Date();
        const isWeekend = today.getDay() === 0 || today.getDay() === 6;
        const cutOffDaysToAdd = isWeekend ? 1 : today.getHours() >= 12 ? 1 : 0;
        const deliveryDate = new Date(today.getTime());

        return this._dateAddWorkingDays(deliveryDate, cutOffDaysToAdd);
    }

    buildDayRanges() {
        let output = {};
        for (const supplierType of this.supplierTypes) {
            const days = this.timeRanges[supplierType];

            let deliveryDate = this._getCalculationTime();
            let deliveryMin = days[0];
            let deliveryMax = days[1];

            deliveryDate = this._dateAddWorkingDays(deliveryDate, deliveryMin);
            const time1 = new Date(deliveryDate.getTime());

            deliveryDate = this._dateAddWorkingDays(
                deliveryDate,
                deliveryMax - deliveryMin
            );

            const time2 = new Date(deliveryDate.getTime());

            output[supplierType] = this._buildDeliveryTxt(
                time1,
                time2,
                days[0],
                days[1],
                supplierType
            );
        }
        this.dayRanges = output;

        return output;
    }

    daysDiff(time1) {
        const now = new Date();

        // Calculate the difference in milliseconds
        const diffInMs = Math.abs(time1 - now);

        // Convert milliseconds to days
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        return diffInDays;
    }

    simpleDeliveryText(supplierType, time) {
        if (supplierType === 4) {
            return "";
        }
        const days = this.timeRanges[supplierType];
        let deliveryDate = this._getCalculationTime();
        let deliveryMin = days[0];
        let deliveryMax = days[1];

        deliveryDate = this._dateAddWorkingDays(deliveryDate, deliveryMin);
        const time1 = new Date(deliveryDate.getTime());

        deliveryDate = this._dateAddWorkingDays(
            deliveryDate,
            deliveryMax - deliveryMin
        );

        const time2 = new Date(deliveryDate.getTime());

        const day1 = this.weekdays[time1.getDay()];
        const day2 = this.weekdays[time2.getDay()];

        const diff = days[1] - days[0];

        const diffInDays = this.daysDiff(time1);

        if (diffInDays > 7) {
            return "";
        }

        console.log(diff);

        if (diff === 1) {
            return maintransl.asdays.replace("%s", day1).replace("%s", day2);
        } else {
            return maintransl.tussendays
                .replace("%s", day1)
                .replace("%s", day2);
        }
    }

    buildFilters() {
        const output = {};
        const time = this._getCalculationTime();

        for (const supplierType of this.supplierTypes) {
            const deliveryTxt = `<span>${maintransl.rangeworkdays.replace(
                "%s",
                this.timeRanges[supplierType].join("-")
            )} -counter</span>`;

            const deliveryText = this.simpleDeliveryText(supplierType, time);

            output[supplierType] = `${deliveryTxt} ${deliveryText}`;
        }

        this.filters = output;

        return output;
    }

    pdpText(supplierType) {
        const days = this.timeRanges[supplierType];

        let deliveryMin = days[0];
        let deliveryMax = days[1];

        const time = this._getCalculationTime();
        let deliveryDate = new Date(time.getTime());

        deliveryDate = this._dateAddWorkingDays(deliveryDate, deliveryMin);
        const time1 = new Date(deliveryDate.getTime());

        deliveryDate = this._dateAddWorkingDays(
            deliveryDate,
            deliveryMax - deliveryMin
        );

        const time2 = new Date(deliveryDate.getTime());

        return this._buildDeliveryTxt(
            time1,
            time2,
            deliveryMin,
            deliveryMax,
            supplierType
        );
    }

    buildRPDays() {
        let output = {};
        let currentHour = new Date().getHours();
        let currentDayOfWeek = new Date().getDay();

        this.supplierTypes.forEach((supplierType) => {
            let deliveryTxt = "";

            if (
                supplierType === 1 &&
                currentHour < 12 &&
                currentDayOfWeek > 0 &&
                currentDayOfWeek <= 4
            ) {
                deliveryTxt = maintransl.deliveredtomorrow;
            } else if (
                supplierType === 1 &&
                currentHour >= 12 &&
                currentDayOfWeek > 0 &&
                currentDayOfWeek <= 3
            ) {
                deliveryTxt = maintransl.delivereddayaftertomorrow;
            } else if (
                supplierType === 1 &&
                currentHour >= 12 &&
                currentDayOfWeek === 4
            ) {
                deliveryTxt = maintransl.deliveredmonday;
            } else {
                deliveryTxt = maintransl.rangeworkdays.replace(
                    "%s",
                    this.timeRanges[supplierType].join("-")
                );
            }

            output[supplierType] = deliveryTxt;
        });

        return output;
    }

    _buildDeliveryTxt(time1, time2, day1, day2, supplierType) {
        const diff = day2 - day1;

        const daysDiff = this.daysDiff(time1);

        day1 = this.weekdays[new Date(time1).getDay()];
        day2 = this.weekdays[new Date(time2).getDay()];

        let deliveryTxt = `<span class="large-delivery-text supp-${supplierType}">`;

        if (
            supplierType === 1 &&
            new Date().getHours() < 12 &&
            new Date().getDay() > 0 &&
            new Date().getDay() <= 4
        ) {
            deliveryTxt += `${maintransl.morgen} <span>(${maintransl.oneworkday})</span>`;
            deliveryTxt += "</span>";
            deliveryTxt += `<span class="small-delivery-text">${maintransl.oneworkday}</span>`;
        } else if (
            supplierType === 1 &&
            new Date().getHours() >= 12 &&
            new Date().getDay() > 0 &&
            new Date().getDay() <= 3
        ) {
            deliveryTxt += `${maintransl.overmorgen} <span>(${maintransl.twoworkdays})</span>`;
            deliveryTxt += "</span>";
            deliveryTxt += `<span class="small-delivery-text">${maintransl.twoworkdays}</span>`;
        } else if (
            supplierType === 1 &&
            new Date().getHours() >= 12 &&
            new Date().getDay() === 4
        ) {
            deliveryTxt += `${maintransl.maandag} <span>(${maintransl.twoworkdays})</span>`;
            deliveryTxt += "</span>";
            deliveryTxt += `<span class="small-delivery-text">${maintransl.twoworkdays}</span>`;
        } else {
            if (daysDiff <= 7) {
                if (diff === 1) {
                    deliveryTxt += maintransl.asdays
                        .replace("%s", day1)
                        .replace("%s", day2);
                } else {
                    deliveryTxt += maintransl.tussendays
                        .replace("%s", day1)
                        .replace("%s", day2);
                }

                deliveryTxt += ` <span>(${maintransl.rangeworkdays.replace(
                    "%s",
                    this.timeRanges[supplierType].join("-")
                )})</span>`;
            } else {
                deliveryTxt += ` <span>${maintransl.rangeworkdays.replace(
                    "%s",
                    this.timeRanges[supplierType].join("-")
                )}</span>`;
            }
            deliveryTxt += "</span>";
            deliveryTxt += `<span class="small-delivery-text">${maintransl.rangeworkdays.replace(
                "%s",
                this.timeRanges[supplierType].join("-")
            )}</span>`;
        }

        return deliveryTxt;
    }
}

var currentUrl = new URL(window.location.href);

Cookies2.set("backurl", encodeURIComponent(currentUrl.href), {
    expires: 365,
    path: "/",
});
Cookies2.remove("li_kg", { expires: 365, path: "/" });
Cookies2.remove("si_km", { expires: 365, path: "/" });

window.montagemelding =
    Cookies2.get("homemontage") === "laten" ? window.montagemeldingHtml : "";

const deliveryRangeData = new DeliveryTime();
window.deliveryTimeRanges = deliveryRangeData.buildDayRanges();
window.deliveryFilters = deliveryRangeData.buildFilters();
window.deliveryRPBesteDealRanges = deliveryRangeData.buildRPDays();

function isElementInViewport(el) {
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight ||
                document.documentElement
                    .clientHeight) /*or $(window).height() */ &&
        rect.right <=
            (window.innerWidth ||
                document.documentElement.clientWidth) /*or $(window).width() */
    );
}

function getTemplate(templateName) {
    return document.getElementById(templateName + "-template").innerHTML;
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;

    var currentUrl = new URL(url);

    url = currentUrl.href;

    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function adwordsRetargetingCall(productIds) {
    var dataLayer = window.dataLayer || [];
    dataLayer.push({
        google_tag_params: {
            ecomm_prodid: productIds,
            ecomm_pagetype: "searchresults",
        },
    });
}

function setSortPlaceholder(selectedIndex) {
    var mobileIndexText = window.mobileIndexText;

    var addClass =
        selectedIndex.indexOf("desc") > -1
            ? "desc"
            : selectedIndex.indexOf("asc") > -1
            ? "asc"
            : "default-sort";

    if (selectedIndex == "ratingscore_asc") {
        addClass = "desc";
    }

    var $sortArea = document.querySelector(".bc-sort-area");

    if ($sortArea !== null) {
        $sortArea.classList.remove("asc", "desc", "default-sort");
        $sortArea.classList.add(addClass);
    }

    var iconHtml = '<i class="fa fa-sort-amount-desc" aria-hidden="true"></i>';

    if (addClass == "asc") {
        var iconHtml =
            '<i class="fa fa-sort-amount-asc" aria-hidden="true"></i>';
    }

    var $mobileFilterPlaceholder = document.querySelector(
        ".mobile-filter-sort-area-wrapper .bc-sort-placeholder"
    );

    if ($mobileFilterPlaceholder !== null) {
        $mobileFilterPlaceholder.innerHTML =
            iconHtml + "<span>" + mobileIndexText[selectedIndex] + "</span>";
    }
}

var cursor;
var index;
var page;
var nbPages;
var loading;
var hoganTemplate;
var hoganTemplateItem;
var paginator,
    defaultHitsPerPage = 7;

var hitsDiv = document.getElementById("hits");

function checkboxWidget(options) {
    if ($(options.container).length > 0) {
        if (typeof options.operator == "undefined") options.operator = "or";

        var showMore = false;

        if (options.showMore === true) {
            showMore = {
                templates: {
                    active:
                        '<a class="ais-show-more ais-show-more__active">' +
                        transl.less +
                        "</a>",
                    inactive:
                        '<a class="ais-show-more ais-show-more__inactive">' +
                        transl.more +
                        "</a>",
                },
            };
        }

        var listLimit = options.limit || 10;

        if (typeof options.limit !== "undefined") {
            listLimit = options.limit;
        }

        return search.addWidget(
            instantsearch.widgets.refinementList({
                container: options.container,
                attributeName: options.attributeName,
                operator: options.operator,
                transformData: options.transformData || false,
                sortBy: options.sortBy,
                limit: listLimit,
                autoHideContainer: true,
                showMore: showMore,
                searchForFacetValues: options.search || false,
                templates: {
                    header: "<label>" + options.title + "</label>",
                    item: '<label class="{{cssClasses.label}}"><input type="checkbox" class="{{cssClasses.checkbox}}" value="{{name}}" {{#isRefined}}checked{{/isRefined}} />{{name}} <span class="{{cssClasses.count}}">({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})</span></label>',
                },
            })
        );
    } else return false;
}

function labelFocusWidget(options) {
    if ($(options.container).length > 0) {
        if (typeof options.operator == "undefined") options.operator = "or";

        var showMore = false;

        if (options.showMore === true) {
            showMore = {
                templates: {
                    active:
                        '<a class="ais-show-more ais-show-more__active">' +
                        transl.less +
                        "</a>",
                    inactive:
                        '<a class="ais-show-more ais-show-more__inactive">' +
                        transl.more +
                        "</a>",
                },
            };
        }

        var listLimit = options.limit || 10;

        if (typeof options.limit !== "undefined") {
            listLimit = options.limit;
        }

        return search.addWidget(
            instantsearch.widgets.refinementList({
                container: options.container,
                attributeName: options.attributeName,
                operator: options.operator,
                transformData: options.transformData || false,
                sortBy: options.sortBy,
                limit: listLimit,
                autoHideContainer: true,
                showMore: showMore,
                searchForFacetValues: options.search || false,
                templates: {
                    header: "<label>" + options.title + "</label>",
                    item: '<label class="{{cssClasses.label}}"><input type="checkbox" class="{{cssClasses.checkbox}}" value="{{name}}" {{#isRefined}}checked{{/isRefined}} /> <img src="/wp-content/themes/bandenconcurrent/css/sprites/sitesprite.svg#fuel" class="sprite-fuel-dims" style="display: none;"> <img src="/wp-content/themes/bandenconcurrent/css/sprites/sitesprite.svg#drop" class="sprite-drop-dims"  style="display: none;"> {{name}} <span class="{{cssClasses.count}}">({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})</span></label>',
                },
            })
        );
    } else return false;
}

function labelCheckboxWidget(options) {
    if ($(options.container).length > 0) {
        if (typeof options.operator == "undefined") options.operator = "or";

        var showMore = false;

        if (options.showMore === true) {
            showMore = {
                templates: {
                    active:
                        '<a class="ais-show-more ais-show-more__active">' +
                        transl.less +
                        "</a>",
                    inactive:
                        '<a class="ais-show-more ais-show-more__inactive">' +
                        transl.more +
                        "</a>",
                },
            };
        }

        return search.addWidget(
            instantsearch.widgets.refinementList({
                container: options.container,
                attributeName: options.attributeName,
                operator: options.operator,
                sortBy: options.sortBy,
                limit: 10,
                showMore: showMore,
                templates: {
                    header: "<label>" + options.title + "</label>",
                    item: '<label class="{{cssClasses.label}}"><input type="checkbox" class="{{cssClasses.checkbox}}" value="{{name}}" {{#isRefined}}checked{{/isRefined}} /><span class="colorlabel color-{{name}}">{{name}}</span> <span class="{{cssClasses.count}}">({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})</span></label>',
                },
            })
        );
    } else return false;
}

if (
    typeof algoliaAppId != "undefined" &&
    typeof algoliaApiKey != "undefined" &&
    typeof algoliaIndexName != "undefined"
) {
    var counter = 1;

    var search = instantsearch({
        appId: window.algoliaAppId,
        apiKey: window.algoliaApiKey,
        indexName: window.algoliaIndexName,
        urlSync: true,
        searchParameters: {
            facetsRefinements: window.searchRefinements,
            disjunctiveFacetsRefinements: window.searchDisRefinements,
            facets: window.searchFacets,
            disjunctiveFacets: window.searchFacets,
        },
        searchFunction: function (helper) {
            $("#hits").attr("data-index", helper.state.index);

            window.showOEMInTitle = false;

            if (
                Object.keys(helper.state.disjunctiveFacetsRefinements).includes(
                    "features_oem_basic"
                )
            ) {
                if (window.showABTestOEM) {
                    window.showOEMInTitle = true;
                }
            }
            helper.search();

            counter++;
        },
    });

    search.templatesConfig.helpers.pricing = function (text, render) {
        var price = render("{{{ " + text + " }}}");

        return price;
    };

    search.templatesConfig.helpers.delivery = function (text, render) {
        var supplierType = render(text);
        return window.deliveryRPBesteDealRanges[supplierType];
    };

    search.templatesConfig.helpers.kenmerken = function (text, render) {
        var kenmerkenArray = JSON.parse(render(text));

        if (
            typeof kenmerkenArray === "object" &&
            !Array.isArray(kenmerkenArray)
        ) {
            kenmerkenArray = Object.values(kenmerkenArray);
        }

        kenmerkenArray.forEach((item, index) => {
            if (typeof maintransl.kenmerken[item] != "undefined") {
                this[index] = maintransl.kenmerken[item];
            }
        });

        if (window?.showOEMInTitle === true) {
            kenmerkenArray = kenmerkenArray.map((item) => {
                const div = document.createElement("div");
                div.innerHTML = item;
                return div.innerText;
            });
        } else {
            kenmerkenArray = kenmerkenArray.filter(
                (item) => !item.includes("<span")
            );
        }

        return kenmerkenArray.join(" · ");
    };

    search.templatesConfig.helpers.stock = function (text, render) {
        var stock = parseInt(render(text));

        var output = `<span class="in-stock">${maintransl.instock}</span>`;

        if (stock <= 10) {
            if (
                ["nl", "pi_nl", "be"].indexOf(
                    document.body.getAttribute("data-icl-language-code")
                ) > -1
            )
                output = `<span class="op-is-op">${maintransl.opisop.replace(
                    "%d",
                    stock
                )}</span>`;
            else
                output = `<span class="low-stock">${maintransl.lowstock.replace(
                    "%d",
                    stock
                )}</span>`;
        }

        return output;
    };

    jQuery(document).on("click", "#hits .custom-select", function (e) {
        e.preventDefault();
    });

    search.templatesConfig.helpers.calcDiscount = function (text, render) {
        var renderedVerkoop = render(
            "{{#helpers.pricing}}prijsDisplayNE{{/helpers.pricing}}"
        );
        var verkoopPrijs = parseFloat(renderedVerkoop.replace(",", "."));

        var adviesPrijs = parseFloat(
            render("{{{ adviesPrijsNE }}}").replace(",", ".")
        );

        var tablet = false;

        if (text == "tablet") tablet = true;

        if (tablet) {
            if (verkoopPrijs > adviesPrijs || adviesPrijs == 0) {
                return (
                    '<span class="price ourprice">' +
                    render(
                        "{{#helpers.pricing}}prijsDisplay{{/helpers.pricing}}"
                    ) +
                    "</span>"
                );
            } else {
                var percentage = Math.ceil(
                    parseFloat(100 - 100 * (verkoopPrijs / adviesPrijs))
                );

                return (
                    '<span class="text-muted notourprice">' +
                    render("{{{ adviesPrijs }}}") +
                    '</span> <span class="price ourprice2">' +
                    render(
                        "{{#helpers.pricing}}prijsDisplay{{/helpers.pricing}}"
                    ) +
                    '</span><p class="text-muted">' +
                    transl.savings +
                    " " +
                    percentage +
                    "%!</p>"
                );
            }
        } else {
            if (verkoopPrijs > adviesPrijs || adviesPrijs == 0) {
                return (
                    '<p class="text-nomargin"><span class="price-label">' +
                    transl.pps +
                    "</span>" +
                    window.montagemelding +
                    '<span class="price ourprice">' +
                    render(
                        "{{#helpers.pricing}}prijsDisplay{{/helpers.pricing}}"
                    ) +
                    "</span></p>"
                );
            } else {
                var percentage = Math.ceil(
                    parseFloat(100 - 100 * (verkoopPrijs / adviesPrijs))
                );

                return (
                    '<p class="price-label">' +
                    transl.pps +
                    "</p>" +
                    window.montagemelding +
                    '<p class="text-nomargin price-box"><span class="text-muted notourprice">' +
                    render("{{{ adviesPrijs }}}") +
                    '</span> <span class="price ourprice2">' +
                    render(
                        "{{#helpers.pricing}}prijsDisplay{{/helpers.pricing}}"
                    ) +
                    '</span></p><p class="text-nomargin text-muted">' +
                    transl.savings +
                    " " +
                    percentage +
                    "%!</p>"
                );
            }
        }
    };

    search.templatesConfig.helpers.createpps = function (text, render) {
        return (
            '<span class="price-label">' +
            transl.pps +
            "</span>" +
            window.montagemelding
        );
    };

    search.templatesConfig.helpers.calckortingmobiletablet = function (
        text,
        render
    ) {
        var textSplitted = text.split("|");
        var renderedVerkoop = render(textSplitted[0]);
        var verkoopPrijs = parseFloat(renderedVerkoop.replace(",", "."));

        var adviesPrijs = parseFloat(this.adviesPrijsNE.replace(",", "."));

        if (verkoopPrijs > adviesPrijs || adviesPrijs == 0) {
            return (
                '<span class="price ourprice">' +
                render(textSplitted[1]) +
                "</span>"
            );
        } else {
            var percentage = parseInt(100 - 100 * (verkoopPrijs / adviesPrijs));

            return (
                '<span class="text-muted notourprice">' +
                this.adviesPrijs +
                '</span> <span class="price ourprice2">' +
                render(textSplitted[1]) +
                '</span><p class="text-muted">' +
                transl.savings +
                " " +
                percentage +
                "%!</p>"
            );
        }
    };

    search.templatesConfig.helpers.voorraad = function (text, render) {
        var voorraadClass = "positive";

        if (this.voorraadDisplay <= 9) {
            voorraadClass = "negative";
        }

        return (
            '<p class="stockmsg ' +
            voorraadClass +
            '">' +
            this.voorraadDisplay +
            " " +
            transl.stock +
            "</p>"
        );
    };

    search.addWidget(
        instantsearch.widgets.hits({
            container: "#hits",
            hitsPerPage: defaultHitsPerPage,
            templates: {
                item: getTemplate("hit"),
                empty: "",
            },
        })
    );

    var customEmptyHitsWidget = {
        init: function (options) {},
        render: function (options) {
            const results = options.results;
            const helper = options.helper;

            var $sort = document.querySelector("form#sort")?.closest(".panel");

            if (results.nbHits === 0) {
                let html = document.createElement("div");

                if (
                    typeof helper.sizeOptions != "undefined" &&
                    Object.keys(helper.sizeOptions).length > 0
                ) {
                    helper.sizeOptions = Object.keys(helper.sizeOptions)
                        .sort()
                        .reduce((sortedObj, key) => {
                            sortedObj[key] = helper.sizeOptions[key];
                            return sortedObj;
                        }, {});

                    html.innerHTML = getTemplate("no-results-sizeoptions");

                    html.innerHTML = html.innerHTML.replace(
                        /\[term\]/g,
                        helper.state.query.replace(tireSize.regex(), "").trim()
                    );

                    var $select = html.querySelector("select");
                    $select.innerHTML = `<option value="">${transl.sizeoption_choose}</option>`;

                    for (const [size, count] of Object.entries(
                        helper.sizeOptions
                    )) {
                        $select.innerHTML += `<option value="${size}">${size}</option>`;
                    }
                } else {
                    html.innerHTML = getTemplate("no-results");
                }
                document.querySelector("#hits").innerHTML = html.innerHTML;

                document
                    .querySelector("#hits select")
                    ?.addEventListener("change", function () {
                        var selectedSize = this.value;
                        var parsedSize = tireSize.parse(selectedSize);

                        if (parsedSize.length > 0) {
                            document.querySelector(
                                "#bandenmaten #breedteresults"
                            ).value = parsedSize[0];
                            document.querySelector(
                                "#bandenmaten #hoogteresults"
                            ).value = parsedSize[1];
                            document.querySelector(
                                "#bandenmaten #inchresults"
                            ).value = "R" + parsedSize[2];
                            document
                                .querySelector("#bandenmaten #resultsMaten")
                                .click();
                        }
                    });
                $sort.style.display = "none";
            } else {
                $sort.style.display = "block";
            }
        },
    };

    search.addWidget(customEmptyHitsWidget);

    var searchIndices = window.searchindices;

    var $sortWrapper = document.querySelector("#mobile-sort-by-container");

    if ($sortWrapper !== null) {
        var urlParams = new URLSearchParams(window.location.search);
        var currentIndex = urlParams.get("idx") || "banden";
        var selectOptions = "";

        searchIndices.forEach(($sort) => {
            selectOptions +=
                '<option value="' +
                $sort.name +
                '" ' +
                (currentIndex == $sort.name ? ' selected="selected"' : "") +
                ">" +
                $sort.label +
                "</option>";
        });

        $sortWrapper.innerHTML = "<select>" + selectOptions + "</select>";

        setSortPlaceholder(currentIndex);
    }

    var $sortWrappers = document.querySelectorAll(
        '[data-role="sort-by-container"]'
    );

    $sortWrappers.forEach(($sortWrapper) => {
        search.addWidget(
            instantsearch.widgets.sortBySelector({
                container: "#" + $sortWrapper.getAttribute("id"),
                autoHideContainer: false,
                indices: searchIndices,
            })
        );
    });

    search.addWidget({
        init: function ({ helper }) {},
        render: function ({ helper }) {
            if ($(".bc-sort-area").length === 0) {
                return;
            }

            var selectedIndex = helper.state.index;

            setSortPlaceholder(selectedIndex);
        },
    });

    var appendLang = "";

    if (!window.location.origin) {
        window.location.origin =
            window.location.protocol +
            "//" +
            window.location.hostname +
            (window.location.port ? ":" + window.location.port : "");
    }

    checkboxWidget({
        container: "#instantsearchMerk",
        attributeName: "merkFull",
        showMore: true,
        title: transl.brands,
        limit: $(window).width() < 767 ? 5 : 10,
        sortBy: ["count:desc", "name:asc"],
    });
    checkboxWidget({
        container: "#instantsearchModel",
        attributeName: "beschrijving",
        showMore: true,
        title: transl.models,
        limit: 5,
        search: {
            placeholder: transl.searchplaceholder,
            templates: { noResults: transl.noresults },
        },
        sortBy: ["count:desc", "name:asc"],
    });

    checkboxWidget({
        container: "#instantsearchKenmerken",
        attributeName: "_tags" + appendLang,
        showMore: true,
        title: transl.chara,
        sortBy: ["count:desc", "name:asc"],
        operator: "and",
        transformData: {
            item: function (data) {
                if (
                    typeof transl.kenmerkenTranslations[data.name] !=
                    "undefined"
                ) {
                    data.name = transl.kenmerkenTranslations[data.name];
                }

                return data;
            },
        },
    });
    checkboxWidget({
        container: "#instantsearchAanbevolen",
        attributeName: "aanbevolen" + appendLang,
        showMore: true,
        title: transl.rec,
        sortBy: ["count:desc", "name:asc"],
    });
    checkboxWidget({
        container: "#instantsearchCarType",
        attributeName: "carType" + appendLang,
        showMore: true,
        title: transl.cartype,
        sortBy: ["count:desc", "name:asc"],
        transformData: {
            item: function (data) {
                if (
                    typeof transl.carTypeTranslations[data.name] != "undefined"
                ) {
                    data.name = transl.carTypeTranslations[data.name];
                }

                return data;
            },
        },
    });
    checkboxWidget({
        container: "#instantsearchSeizoen",
        attributeName: "season" + appendLang,
        showMore: true,
        title: transl.season,
        sortBy: ["count:desc", "name:asc"],
        transformData: {
            item: function (data) {
                if (
                    typeof transl.seasonTranslations[data.name] != "undefined"
                ) {
                    data.name = transl.seasonTranslations[data.name];
                }

                return data;
            },
        },
    });

    labelFocusWidget({
        container: "#instantsearchFocusLabels",
        attributeName: "labelFocus",
        showMore: true,
        title: transl.bandenlabel,
        sortBy: ["name:asc"],
        transformData: {
            item: function (data) {
                switch (data.name) {
                    case "is_good_fuel":
                        data.name = transl.zeerzuinig;
                        break;
                    case "is_good_grip":
                        data.name = transl.veelgrip;
                        break;
                }
                return data;
            },
        },
    });

    checkboxWidget({
        container: "#instantsearchMerkcat",
        attributeName: "merkcat",
        showMore: true,
        title: transl.merkcategorie,
        sortBy: ["name:asc"],
        transformData: {
            item: function (data) {
                if (
                    typeof transl.merkcatTranslations[data.name] != "undefined"
                ) {
                    data.name = transl.merkcatTranslations[data.name];
                }

                return data;
            },
        },
    });

    labelCheckboxWidget({
        container: "#instantsearchBrandstof",
        attributeName: "brandstofverbruik",
        showMore: true,
        title:
            '<img src="/wp-content/themes/bandenconcurrent/css/sprites/sitesprite.svg#fuel" class="sprite-fuel-dims"> ' +
            transl.fuel,
        sortBy: ["name:asc"],
    });
    labelCheckboxWidget({
        container: "#instantsearchGrip",
        attributeName: "grip",
        showMore: true,
        title:
            '<img src="/wp-content/themes/bandenconcurrent/css/sprites/sitesprite.svg#drop" class="sprite-drop-dims"> ' +
            transl.grip,
        sortBy: ["name:asc"],
    });
    checkboxWidget({
        container: "#instantsearchGeluid",
        attributeName: "geluidlabel" + appendLang,
        showMore: true,
        title: transl.sound,
        sortBy: ["name:asc"],
        transformData: {
            item: function (data) {
                var nameAsInt = parseInt(data.name);

                if (typeof transl.rolgeluidBrackets[nameAsInt] != "undefined") {
                    data.name = transl.rolgeluidBrackets[nameAsInt];
                }

                return data;
            },
        },
    });

    checkboxWidget({
        container: "#instantsearchAutomerk",
        attributeName: "features_oem_basic",
        showMore: true,
        title: transl.carbrands,
        limit: $(window).width() < 767 ? 5 : 10,
        sortBy: ["count:desc", "name:asc"],
    });

    if (document.querySelector("#instantsearchPrijs") !== null) {
        search.addWidget(
            instantsearch.widgets.ionRangeSlider({
                container: "#instantsearchPrijs",
                attributeName: "price",
                ionRangeSliderOptions: {
                    prefix: "&euro; ",
                    step: 5,
                },
            })
        );
    }

    if (!Array.isArray) {
        Array.isArray = function (arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
        };
    }

    instantsearch.widgets.customSelectorWidget = function customSelectorWidget(
        options
    ) {
        var container = options.container;
        var attributeName = options.attributeName;
        var limit = options.limit || 10;
        var title = options.title || "All";
        var heading = options.heading;

        // container should be a CSS selector, so we convert it into a DOM element
        container = document.querySelector(container);

        if (container === null) {
            return;
        }
        // We'll internally keep track of the <select> element
        var selectElement = null;
        // We'll also need to keep track of the current selected value
        var currentlySelectedValue = null;

        return {
            // Method called at startup, to configure the Algolia settings
            getConfiguration: function getConfiguration() {
                // This is a copy-paste of the menu widget
                // We use a hierarchicalFacet and not a classical facet because we want to
                // keep the list of all possible values displayed at all times. With
                // a classical facet we would only have the list of possible values for
                // the current filters (which would not make any sense here)
                return {
                    hierarchicalFacets: [
                        {
                            name: attributeName,
                            attributes: [attributeName],
                        },
                    ],
                };
            },

            // Called on the first instantsearch search
            init: function init(options) {
                var helper = options.helper;
                var tooltip = "";

                if ($(container).attr("data-tooltip"))
                    tooltip = getTemplate($(container).attr("data-tooltip"));
                // We add an (empty) <select> to the specified container

                container.innerHTML =
                    '<div class="ais-header selectWidget"><label for="' +
                    attributeName +
                    '-select">' +
                    heading +
                    tooltip +
                    '</label></div><div class="ais-body custom-select"><select id="' +
                    attributeName +
                    '-select"></select></div>';

                selectElement = container.querySelector("select");

                // We listen to the change event on that <select>
                selectElement.addEventListener("change", function () {
                    // Finding the newly selected value

                    var selectedIndex = selectElement.selectedIndex;
                    var selectedValue =
                        selectElement.options[selectedIndex].value;

                    // If we select the first, default value, it's like we "unchecked" the
                    // currently selected value
                    if (selectedValue === "__EMPTY__") {
                        selectedValue = currentlySelectedValue;
                    }
                    // We toggle on/off on the selected value
                    helper.toggleRefinement(attributeName, selectedValue);
                    // And we actually start the search (to force a re-render of results)
                    helper.search();

                    // We keep track of what the currently selected value is
                    currentlySelectedValue = selectedValue;
                });
            },

            // Called whenever we receive new results from Algolia
            render: function render(options) {
                var results = options.results;
                // We get the list of possible values for this search and sort them in the
                // same order everytime (most popular first)
                var sortBy = ["name:asc"];
                var facetValues = results.getFacetValues(attributeName, {
                    sortBy: sortBy,
                }).data;
                var innerOptions = [
                    '<option value="__EMPTY__">' + title + "</option>",
                ];

                if (facetValues != null) {
                    $(container).show();
                    // We only keep the X first elements, as defined on instanciation
                    facetValues = facetValues.slice(0, limit);

                    // Then we add that to the <select>
                    facetValues.forEach(function (facetValue) {
                        // We mark the current one as selected
                        var selected = facetValue.isRefined
                            ? 'selected="selected"'
                            : "";
                        innerOptions.push(
                            '<option value="' +
                                facetValue.name +
                                '" ' +
                                selected +
                                ' data-label="' +
                                facetValue.name +
                                '">' +
                                facetValue.name +
                                "</option>"
                        );
                    });

                    // Update the rendering
                    selectElement.innerHTML = innerOptions.join("\n");
                } else {
                    $(container).hide();
                }
            },
        };
    };

    function checkVisible(elm) {
        var rect = elm.getBoundingClientRect();
        var viewHeight = Math.max(
            document.documentElement.clientHeight,
            window.innerHeight
        );
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }

    instantsearch.widgets.scrollToTopWidget = function scrollToTopWidget(
        options
    ) {
        return {
            // Method called at startup, to configure the Algolia settings
            getConfiguration: function getConfiguration() {
                // This is a copy-paste of the menu widget
                // We use a hierarchicalFacet and not a classical facet because we want to
                // keep the list of all possible values displayed at all times. With
                // a classical facet we would only have the list of possible values for
                // the current filters (which would not make any sense here)
                return;
            },

            // Called on the first instantsearch search
            init: function init(options) {},

            // Called whenever we receive new results from Algolia
            render: function render(options) {
                jQuery(".updatenote").removeClass("show");

                var nbResults = options.results.nbHits;

                var hitsVisible = checkVisible(document.getElementById("hits"));

                var resultsTransl =
                    nbResults > 1 ? transl.multiresults : transl.singleresult;

                jQuery(".scrollnumResults").text(
                    nbResults + " " + resultsTransl
                );

                if (!hitsVisible && nbResults >= 1) {
                    setTimeout(function () {
                        /*var offsetTop = ($(window).scrollTop() + ((jQuery('#content').offset().top + jQuery('#content').height() - $(window).scrollTop()) / 2));*/
                        var offsetTop =
                            $(window).scrollTop() + 0.7 * $(window).height();

                        if (
                            offsetTop >=
                            jQuery("#content").offset().top +
                                jQuery("#content").height()
                        ) {
                            offsetTop =
                                jQuery("#content").offset().top +
                                jQuery("#content").height() -
                                68;
                        }

                        var offsetLeft =
                            jQuery("#resultsContainer").offset().left +
                            0.5 * (jQuery("#resultsContainer").width() - 460);

                        jQuery(".updatenote")
                            .addClass("show")
                            .css("top", offsetTop)
                            .css("left", offsetLeft);
                    }, 250);
                }
            },
        };
    };

    search.addWidget(instantsearch.widgets.scrollToTopWidget());

    var speedIndexText;

    instantsearch.widgets.customSelectorWidgetFromTo =
        function customSelectorWidget(options) {
            if (
                !options.container ||
                !options.attributeName ||
                !options.options
            ) {
                throw new Error("Not all required options have been set!");
            }

            var container = options.container;
            var attributeName = options.attributeName;
            var limit = options.limit || 10;
            var title = options.title || transl.all;
            var heading = options.heading;
            var optionsList = options.options;

            // container should be a CSS selector, so we convert it into a DOM element
            container = document.querySelector(container);

            if (container === null) {
                return;
            }
            // We'll internally keep track of the <select> element
            var selectElement = null;
            // We'll also need to keep track of the current selected value
            var currentlySelectedValue = null;

            if (attributeName == "speedIndexSpeed") {
                var selectedText = null;
            }

            var needFacet = true;

            function uniq(a) {
                return a.reduce(function (p, c) {
                    if (p.indexOf(c) < 0) {
                        p.push(c);
                    }
                    return p;
                }, []);
            }

            return {
                getConfiguration: function () {
                    return needFacet
                        ? {
                              disjunctiveFacets: uniq([attributeName]),
                          }
                        : {};
                },

                // Called on the first instantsearch search
                init: function init(options) {
                    var helper = options.helper;
                    var tooltip = "";

                    if ($(container).attr("data-tooltip"))
                        tooltip = getTemplate(
                            $(container).attr("data-tooltip")
                        );
                    // We add an (empty) <select> to the specified container
                    container.innerHTML =
                        '<div class="ais-header selectWidget"><label for="' +
                        attributeName +
                        '-select" >' +
                        heading +
                        tooltip +
                        '</label></div><div class="ais-body custom-select"><select id="' +
                        attributeName +
                        '-select"></select></div>';
                    selectElement = container.querySelector("select");

                    // We listen to the change event on that <select>
                    selectElement.addEventListener("change", function () {
                        // Finding the newly selected value
                        var selectedIndex = selectElement.selectedIndex;
                        var selectedValue =
                            selectElement.options[selectedIndex].value;

                        if (
                            $(this).closest(".subfilter").attr("id") ==
                            "instantsearchSnelheidsIndex"
                        ) {
                            speedIndexText =
                                selectElement.options[selectedIndex].dataset
                                    .label;
                        }

                        optionsList.forEach(function (item) {
                            if (item.value == selectedValue) {
                                newOption = item;
                            }
                        });

                        helper.removeNumericRefinement(attributeName, ">=");
                        helper.removeNumericRefinement(attributeName, "<=");

                        if (
                            selectedValue != "__EMPTY__" &&
                            typeof newOption != "undefined"
                        ) {
                            if (
                                typeof newOption.start != "undefined" ||
                                typeof newOption.end != "undefined"
                            ) {
                                // start and end values

                                if (typeof newOption.start != "undefined") {
                                    helper.addNumericRefinement(
                                        attributeName,
                                        ">=",
                                        newOption.start
                                    );
                                }

                                if (typeof newOption.end != "undefined") {
                                    helper.addNumericRefinement(
                                        attributeName,
                                        "<=",
                                        newOption.end
                                    );
                                }
                            } else {
                                if (typeof newOption.value != "undefined") {
                                    // only >=
                                    helper.addNumericRefinement(
                                        attributeName,
                                        ">=",
                                        newOption.value
                                    );
                                }
                            }

                            if (typeof dataLayer != "undefined") {
                                dataLayer.push({
                                    attribute: attributeName,
                                    values: newOption.label,
                                    event: "fromtowidget",
                                });
                            }
                        }

                        helper.search();

                        // We keep track of what the currently selected value is
                        currentlySelectedValue = selectedValue;
                    });
                },

                // Called whenever we receive new results from Algolia
                render: function render(options) {
                    var results = options.results;

                    var stateVal = options.helper.state.getNumericRefinement(
                        attributeName,
                        ">="
                    );

                    if (currentlySelectedValue != "__EMPTY__") {
                        if (typeof stateVal != "undefined")
                            currentlySelectedValue = stateVal[0];
                    }

                    if (
                        currentlySelectedValue !== null &&
                        stateVal === undefined
                    ) {
                        setTimeout(function () {
                            $("select#" + attributeName + "-select").val(
                                "__EMPTY__"
                            );
                        }, 200);
                    }

                    var facetStats = results.getFacetStats(attributeName);
                    var facetValues = results.getFacetValues(attributeName);

                    if (facetValues == undefined || facetValues.length === 0) {
                        $(container).hide();
                        return;
                    }

                    var minVal = 0;
                    if (typeof facetStats !== "undefined")
                        minVal = facetStats.min;

                    var maxVal = 100;

                    if (typeof facetStats !== "undefined")
                        maxVal = facetStats.max;

                    var innerOptions = [
                        '<option value="__EMPTY__">' + title + "</option>",
                    ];

                    if (optionsList != null && results.hits.length > 0) {
                        $(container).show();

                        // Then we add that to the <select>
                        optionsList.forEach(function (item) {
                            var include = false;

                            if (
                                typeof item.start != "undefined" ||
                                typeof item.end != "undefined"
                            ) {
                                // start and end values

                                if (typeof item.start != "undefined") {
                                    if (item.start >= minVal) include = true;
                                }

                                if (typeof item.end != "undefined") {
                                    if (item.end <= maxVal) include = true;
                                }
                            } else {
                                if (typeof item.value != "undefined") {
                                    // only >=

                                    if (item.value >= minVal) include = true;
                                }
                            }

                            if (item.value > maxVal) include = false;

                            if (item.value < minVal) include = false;

                            if (item.value != 0 && include) {
                                if (attributeName == "speedIndexSpeed") {
                                    var selected =
                                        currentlySelectedValue == item.value &&
                                        speedIndexText == item.label
                                            ? 'selected="selected"'
                                            : "";
                                } else {
                                    var selected =
                                        currentlySelectedValue == item.value
                                            ? 'selected="selected"'
                                            : "";
                                }
                                innerOptions.push(
                                    '<option value="' +
                                        item.value +
                                        '" ' +
                                        selected +
                                        ' data-label="' +
                                        item.label +
                                        '">' +
                                        item.label +
                                        "</option>"
                                );
                            }
                        });

                        // Update the rendering
                        selectElement.innerHTML = innerOptions.join("\n");
                    } else {
                        $(container).hide();
                    }
                },
            };
        };

    instantsearch.widgets.deliveryTime = function deliveryTime(options) {
        if (!options.container || !options.attributeName || !options.options) {
            throw new Error("Not all required options have been set!");
        }

        var container = options.container;
        var containerSelector = options.container;
        var attributeName = options.attributeName;
        var limit = options.limit || 10;
        var title = options.title || transl.all;
        var heading = options.heading;
        var optionsList = options.options;

        var selectedValues = [];

        container = document.querySelector(container);

        if (container === null) {
            return;
        }

        var needFacet = true;

        function uniq(a) {
            return a.reduce(function (p, c) {
                if (p.indexOf(c) < 0) {
                    p.push(c);
                }
                return p;
            }, []);
        }

        return {
            getConfiguration: function () {
                return needFacet
                    ? {
                          disjunctiveFacets: uniq([attributeName]),
                      }
                    : {};
            },

            // Called on the first instantsearch search
            init: function init(options) {
                var helper = options.helper;
                var tooltip = "";

                if ($(containerSelector).attr("data-tooltip"))
                    tooltip = getTemplate($(container).attr("data-tooltip"));
                container.innerHTML =
                    '<div class="ais-root ais-refinement-list"><div class="ais-refinement-list--header ais-header deliveryWidget">' +
                    heading +
                    tooltip +
                    '</div><div class="ais-body ais-refinement-list--body"></div></div>';

                $(document).on(
                    "change",
                    containerSelector + " input",
                    function () {
                        helper.clearRefinements(attributeName);

                        selectedValues = [];

                        $(containerSelector + " input:checked").each(
                            function () {
                                selectedValues.push(parseInt($(this).val()));

                                helper.addDisjunctiveFacetRefinement(
                                    attributeName,
                                    parseInt($(this).val())
                                );
                            }
                        );

                        helper.search();
                    }
                );
            },

            // Called whenever we receive new results from Algolia
            render: function render(options) {
                var results = options.results;
                var stateVal = options.helper.getRefinements(attributeName);

                selectedValues = [];

                if (stateVal !== undefined) {
                    stateVal.forEach(function (item) {
                        selectedValues.push(parseInt(item.value));
                    });
                }

                var facetStats = results.getFacetStats(attributeName);
                var facetValues = results.getFacetValues(attributeName, {
                    sortBy: ["name:asc"],
                });

                var innerOptions = [];

                if (
                    facetValues !== undefined &&
                    facetValues.length > 0 &&
                    results.hits.length > 0
                ) {
                    $(containerSelector).show();

                    facetValues.forEach(function (item) {
                        var include = false;

                        if (item.count > 0) {
                            include = true;
                        }

                        if (item.name != 0 && include) {
                            var selected =
                                selectedValues.indexOf(parseInt(item.name)) > -1
                                    ? 'checked="checked"'
                                    : "";

                            innerOptions.push(
                                '<div class="ais-refinement-list--item"><div><label class="ais-refinement-list--label"><input type="checkbox" ' +
                                    selected +
                                    ' class="ais-refinement-list--checkbox dexter-item-' +
                                    item.name +
                                    '" value="' +
                                    item.name +
                                    '"><span class="delivery-label delivery-label-holder" data-deliverytime-type="' +
                                    item.name +
                                    '" data-count="' +
                                    item.count +
                                    '"></span></label></div></div>'
                            );
                        }
                    });

                    // Update the rendering
                    $(container)
                        .find(".ais-body")
                        .html(innerOptions.join("\n"));

                    if (typeof window.deliveryFilters != "undefined") {
                        try {
                            $.each(
                                window.deliveryFilters,
                                function (suppType, html) {
                                    html = html.replace(
                                        "-counter",
                                        "(" +
                                            $(
                                                '.delivery-label-holder[data-deliverytime-type="' +
                                                    suppType +
                                                    '"]'
                                            ).attr("data-count") +
                                            ")"
                                    );
                                    $(
                                        '.delivery-label-holder[data-deliverytime-type="' +
                                            suppType +
                                            '"]'
                                    ).html(html);
                                }
                            );
                        } catch (e) {
                            console.error(e);
                        }
                    }
                } else {
                    $(containerSelector).hide();
                }
            },
        };
    };

    if (document.querySelector("#instantsearchDraagvermogen") !== null) {
        search.addWidget(
            instantsearch.widgets.customSelectorWidgetFromTo({
                container: "#instantsearchDraagvermogen",
                attributeName: "loadIndexKilos",
                limit: 10,
                title: transl.all,
                heading: "<label>" + transl.load + "</label>",
                options: [
                    { label: transl.all, value: 0 },
                    { label: transl.loadValue.sprintf(345, 71), value: 345 },
                    { label: transl.loadValue.sprintf(355, 72), value: 355 },
                    { label: transl.loadValue.sprintf(365, 73), value: 365 },
                    { label: transl.loadValue.sprintf(375, 74), value: 375 },
                    { label: transl.loadValue.sprintf(387, 75), value: 387 },
                    { label: transl.loadValue.sprintf(400, 76), value: 400 },
                    { label: transl.loadValue.sprintf(412, 77), value: 412 },
                    { label: transl.loadValue.sprintf(425, 78), value: 425 },
                    { label: transl.loadValue.sprintf(437, 79), value: 437 },
                    { label: transl.loadValue.sprintf(450, 80), value: 450 },
                    { label: transl.loadValue.sprintf(462, 81), value: 462 },
                    { label: transl.loadValue.sprintf(475, 82), value: 475 },
                    { label: transl.loadValue.sprintf(487, 83), value: 487 },
                    { label: transl.loadValue.sprintf(500, 84), value: 500 },
                    { label: transl.loadValue.sprintf(515, 85), value: 515 },
                    { label: transl.loadValue.sprintf(530, 86), value: 530 },
                    { label: transl.loadValue.sprintf(545, 87), value: 545 },
                    { label: transl.loadValue.sprintf(560, 88), value: 545 },
                    { label: transl.loadValue.sprintf(580, 89), value: 580 },
                    { label: transl.loadValue.sprintf(600, 90), value: 600 },
                    { label: transl.loadValue.sprintf(615, 91), value: 615 },
                    { label: transl.loadValue.sprintf(630, 92), value: 630 },
                    { label: transl.loadValue.sprintf(650, 93), value: 650 },
                    { label: transl.loadValue.sprintf(670, 94), value: 670 },
                    { label: transl.loadValue.sprintf(690, 95), value: 690 },
                    { label: transl.loadValue.sprintf(710, 96), value: 710 },
                    { label: transl.loadValue.sprintf(730, 97), value: 730 },
                    { label: transl.loadValue.sprintf(750, 98), value: 750 },
                    { label: transl.loadValue.sprintf(775, 99), value: 775 },
                    { label: transl.loadValue.sprintf(800, 100), value: 800 },
                    { label: transl.loadValue.sprintf(825, 101), value: 825 },
                    { label: transl.loadValue.sprintf(850, 102), value: 850 },
                    { label: transl.loadValue.sprintf(875, 103), value: 875 },
                    { label: transl.loadValue.sprintf(900, 104), value: 900 },
                    { label: transl.loadValue.sprintf(925, 105), value: 925 },
                    { label: transl.loadValue.sprintf(950, 106), value: 950 },
                    { label: transl.loadValue.sprintf(975, 107), value: 975 },
                    { label: transl.loadValue.sprintf(1000, 108), value: 1000 },
                    { label: transl.loadValue.sprintf(1030, 109), value: 1030 },
                    { label: transl.loadValue.sprintf(1060, 110), value: 1060 },
                    { label: transl.loadValue.sprintf(1090, 111), value: 1090 },
                    { label: transl.loadValue.sprintf(1120, 112), value: 1120 },
                    { label: transl.loadValue.sprintf(1150, 113), value: 1150 },
                    { label: transl.loadValue.sprintf(1180, 114), value: 1180 },
                    { label: transl.loadValue.sprintf(1215, 115), value: 1215 },
                    { label: transl.loadValue.sprintf(1250, 116), value: 1250 },
                    { label: transl.loadValue.sprintf(1285, 117), value: 1285 },
                    { label: transl.loadValue.sprintf(1320, 118), value: 1320 },
                    { label: transl.loadValue.sprintf(1360, 119), value: 1360 },
                    { label: transl.loadValue.sprintf(1400, 120), value: 1400 },
                ],
            })
        );
    }

    if ($("#deliveryTimeWidget").length > 0) {
        search.addWidget(
            instantsearch.widgets.deliveryTime({
                container: "#deliveryTimeWidget",
                attributeName: "delivery_time",
                limit: 15,
                title: transl.all,
                heading: "<label>" + transl.deliverttime + "</label>",
                options: [
                    { label: transl.all, value: 0 },
                    { label: window.deliveryType1Title, value: 1 },
                    { label: window.deliveryType2Title, value: 2 },
                    { label: window.deliveryType3Title, value: 3 },
                ],
            })
        );
    }

    if (document.querySelector("#instantsearchSnelheidsIndex") !== null) {
        search.addWidget(
            instantsearch.widgets.customSelectorWidgetFromTo({
                container: "#instantsearchSnelheidsIndex",
                attributeName: "speedIndexSpeed",
                limit: 15,
                title: transl.all,
                heading: "<label>" + transl.speedindexfrom + "</label>",
                options: [
                    { label: transl.all, value: 0 },
                    { label: transl.speedvalue.sprintf("A1", 5), value: 5 },
                    { label: transl.speedvalue.sprintf("A2", 10), value: 10 },
                    { label: transl.speedvalue.sprintf("A3", 15), value: 15 },
                    { label: transl.speedvalue.sprintf("A4", 20), value: 20 },
                    { label: transl.speedvalue.sprintf("A5", 25), value: 25 },
                    { label: transl.speedvalue.sprintf("A6", 30), value: 30 },
                    { label: transl.speedvalue.sprintf("A7", 35), value: 35 },
                    { label: transl.speedvalue.sprintf("A8", 40), value: 40 },
                    { label: transl.speedvalue.sprintf("B", 50), value: 50 },
                    { label: transl.speedvalue.sprintf("C", 60), value: 60 },
                    { label: transl.speedvalue.sprintf("D", 65), value: 65 },
                    { label: transl.speedvalue.sprintf("E", 70), value: 70 },
                    { label: transl.speedvalue.sprintf("F", 80), value: 80 },
                    { label: transl.speedvalue.sprintf("G", 90), value: 90 },
                    { label: transl.speedvalue.sprintf("J", 100), value: 100 },
                    { label: transl.speedvalue.sprintf("H", 210), value: 210 },
                    { label: transl.speedvalue.sprintf("K", 110), value: 110 },
                    { label: transl.speedvalue.sprintf("L", 120), value: 120 },
                    { label: transl.speedvalue.sprintf("M", 130), value: 130 },
                    { label: transl.speedvalue.sprintf("N", 140), value: 140 },
                    { label: transl.speedvalue.sprintf("P", 150), value: 150 },
                    { label: transl.speedvalue.sprintf("Q", 160), value: 160 },
                    { label: transl.speedvalue.sprintf("R", 170), value: 170 },
                    { label: transl.speedvalue.sprintf("S", 180), value: 180 },
                    { label: transl.speedvalue.sprintf("T", 190), value: 190 },
                    { label: transl.speedvalue.sprintf("U", 200), value: 200 },
                    { label: transl.speedvalue.sprintf("V", 240), value: 240 },
                    { label: transl.speedvalue.sprintf("W", 270), value: 270 },
                    { label: transl.speedvalue.sprintf("Y", 300), value: 300 },
                    {
                        label: transl.speedvaluefrom.sprintf("VR", 210),
                        value: 210,
                    },
                    {
                        label: transl.speedvaluefrom.sprintf("ZR", 240),
                        value: 240,
                    },
                    {
                        label: transl.speedvaluefrom.sprintf("Z", 240),
                        value: 240,
                    },
                ],
            })
        );
    }

    function supplierTypeToDays(supplierType) {
        return window.deliveryTimeRanges[supplierType];
    }

    var refinedAttributes = [
        { name: "price", label: transl.price },
        { name: "merkFull" },
        { name: "merkcat" },
        { name: "labelFocus", label: transl.bandenlabel },
        { name: "carType" },
        { name: "loadIndexKilos", label: transl.loadlabel },
        { name: "beschrijving" },
        { name: "speedIndexDisplay", label: transl.speedclass },
        { name: "_tags" },
        { name: "aanbevolen", label: transl.recom },
        { name: "brandstofverbruik", label: transl.fuellabel },
        { name: "grip", label: transl.griplabel },
        { name: "geluidlabel", label: transl.roll },
        { name: "season" },
        { name: "speedIndexSpeed", label: transl.speedindexfrom },
        { name: "delivery_time", label: transl.deliverytime },
        { name: "features_oem_basic", label: transl.carbrands },
    ];

    search.addWidget(
        instantsearch.widgets.currentRefinedValues({
            container: "#current-refined-values",
            clearAll: false,
            transformData: {
                item: function (data) {
                    if (data.attributeName == "delivery_time") {
                        var txt = supplierTypeToDays(data.name);
                        data.name = txt;

                        data.displayOperator = "";
                    }

                    if (data.attributeName == "labelFocus") {
                        switch (data.name) {
                            case "is_good_fuel":
                                data.name = transl.focusfuel;
                                break;
                            case "is_good_grip":
                                data.name = transl.focusgrip;
                                break;
                        }
                    }

                    if (data.attributeName === "season") {
                        if (
                            typeof transl.seasonTranslations[data.name] !=
                            "undefined"
                        ) {
                            data.name = transl.seasonTranslations[data.name];
                        }
                    }

                    if (data.attributeName === "geluidlabel") {
                        var nameAsInt = parseInt(data.name);

                        if (
                            typeof transl.rolgeluidBrackets[nameAsInt] !=
                            "undefined"
                        ) {
                            data.name = transl.rolgeluidBrackets[nameAsInt];
                        }
                    }

                    if (data.attributeName === "_tags") {
                        if (
                            typeof transl.kenmerkenTranslations[data.name] !=
                            "undefined"
                        ) {
                            data.name = transl.kenmerkenTranslations[data.name];
                        }
                    }
                    return data;
                },
            },
            templates: {
                item:
                    "" +
                    "{{#label}}" +
                    "{{label}}" +
                    "{{^operator}}:{{/operator}}" +
                    " " +
                    "{{/label}}" +
                    "{{#operator}}{{{displayOperator}}} {{/operator}}" +
                    "{{#exclude}}-{{/exclude}}" +
                    '{{{name}}} {{#count}}<span class="{{cssClasses.count}}">({{count}})</span>{{/count}} <i class="fa fa-times" aria-hidden="true"></i>',
            },
            onlyListedAttributes: true,
            attributes: refinedAttributes,
        })
    );

    var moreClicked = true;

    function searchChangeSize() {
        var urlParams = new URLSearchParams(window.location.search);
        var searchText = urlParams.get("q");

        if ((m = tireSize.regex().exec(searchText)) !== null) {
            var decodedURL = decodeURI(window.location.href);
            var url = new URL(decodedURL);
            var maatURL = url.searchParams.get("fR[maat][0]");

            if ((urlMaat = tireSize.regex().exec(maatURL)) !== null) {
                if (
                    m[1] != urlMaat[1] ||
                    m[2] != urlMaat[2] ||
                    m[4] != urlMaat[4]
                ) {
                    url.searchParams.delete("fR[maat][0]");

                    var searchTextNew = searchText
                        .replace(m[1], urlMaat[1])
                        .replace(m[2], urlMaat[2])
                        .replace(m[4], urlMaat[4]);

                    url.searchParams.set("q", searchTextNew);

                    window.location = url.toString();
                    return;
                }
            }
        }
    }

    instantsearch.widgets.addSizeWidget = function addSizeWidget() {
        var attributeName = "maat";
        var needFacet = true;

        function uniq(a) {
            return a.reduce(function (p, c) {
                if (p.indexOf(c) < 0) {
                    p.push(c);
                }
                return p;
            }, []);
        }

        return {
            getConfiguration: function () {
                return needFacet
                    ? {
                          disjunctiveFacets: uniq([attributeName]),
                      }
                    : {};
            },
            init: function init(options) {
                var helper = options.helper;

                var searchMaat = false;

                var decodedURL = decodeURI(window.location.href);
                var url = new URL(decodedURL);
                var maatURL = url.searchParams.get("fR[maat][0]");
                var searchText = url.searchParams.get("q");

                if (searchText !== null && typeof gtag != "undefined") {
                    gtag("event", "search", {
                        search_term: searchText,
                    });
                }

                if (
                    typeof window.isSizePage != "undefined" &&
                    window.isSizePage === true
                ) {
                    searchMaat = window.currentPageSize;
                } else if (
                    typeof window.isSearchPage != "undefined" &&
                    window.isSearchPage === true &&
                    maatURL !== null &&
                    maatURL.length > 0
                ) {
                    searchMaat = maatURL;
                    searchChangeSize();
                } else if (maatURL !== null && maatURL.length > 0) {
                    searchMaat = maatURL;
                } else if (
                    typeof window.isSearchPage != "undefined" &&
                    window.isSearchPage === true &&
                    (m = tireSize.regex().exec(searchText)) !== null
                ) {
                    searchChangeSize();
                    searchMaat = m[1] + " / " + m[2] + " R" + m[4];
                }

                if (searchMaat === false) {
                    searchMaat = tireSize.get();
                }

                if (searchMaat !== false) {
                    tireSize.set(searchMaat);

                    var parsedSize = tireSize.parse(searchMaat);

                    setTimeout(function () {
                        $("#bandenmaten.subfilter #breedteresults").val(
                            parsedSize[0]
                        );
                        $("#bandenmaten.subfilter #hoogteresults").val(
                            parsedSize[1]
                        );
                        $("#bandenmaten.subfilter #inchresults").val(
                            "R" + parsedSize[2]
                        );
                    }, 10);

                    helper.addDisjunctiveFacetRefinement("maat", searchMaat);

                    $(".alert-select-size.hidden").addClass("hidden");
                } else {
                    $(".alert-select-size.hidden").removeClass("hidden");
                    $("#bandenmaten.subfilter").addClass("hasExtraBorder");
                }
            },
        };
    };

    search.addWidget(instantsearch.widgets.addSizeWidget());

    function buildPaginationTags(
        defaultHitsPerPage,
        currentLimit,
        totalHits,
        notLimitedHits = 0
    ) {
        if (notLimitedHits >= 100) {
            $(".searchresultsCount-wrapper").addClass("hidden");
        } else {
            $(".searchresultsCount-wrapper").removeClass("hidden");
        }

        $("[data-results-count]").text(notLimitedHits);
        $("body").attr("data-searchresults-count", notLimitedHits);

        var currentLocation = new URL(window.location.href);

        if (currentLimit - defaultHitsPerPage > 0) {
            var newHitsPP = currentLimit - defaultHitsPerPage;
            var prevUrl = currentLocation;
            prevUrl.searchParams.set("hPP", newHitsPP);

            if ($('link[rel="prev"]').length > 0) {
                $('link[rel="prev"]').attr("href", prevUrl.href);
            } else {
                $('<link rel="prev" href="' + prevUrl.href + '" />').appendTo(
                    "head"
                );
            }
        } else {
            $('link[rel="prev"]').remove();
        }

        $("#searchresultsCount").text(totalHits);

        var newHitsPP = currentLimit + defaultHitsPerPage;
        var totalPages = Math.ceil(totalHits / defaultHitsPerPage);

        if (
            newHitsPP < totalHits ||
            newHitsPP <= totalPages * defaultHitsPerPage
        ) {
            var nextUrl = currentLocation;
            nextUrl.searchParams.set("hPP", newHitsPP);

            if ($('link[rel="next"]').length > 0) {
                $('link[rel="next"]').attr("href", nextUrl.href);
            } else {
                $('<link rel="next" href="' + nextUrl.href + '" />').appendTo(
                    "head"
                );
            }
        } else {
            $('link[rel="next"]').remove();
        }
    }

    var tooLittleResults = 3;

    var useThisFitsCopy = false;

    instantsearch.widgets.moreHitsSizeWidget = function moreHitsSizeWidget(
        mainSearchQuery,
        mainRequestSizeOptions
    ) {
        var attributeName = "maat";
        var needFacet = true;

        function uniq(a) {
            return a.reduce(function (p, c) {
                if (p.indexOf(c) < 0) {
                    p.push(c);
                }
                return p;
            }, []);
        }

        return {
            getConfiguration: function () {
                return needFacet
                    ? {
                          disjunctiveFacets: uniq([attributeName]),
                      }
                    : {};
            },
            init: function init(options) {
                var helper = options.helper;

                if (
                    mainSearchQuery.length > 0 &&
                    typeof mainRequestSizeOptions === "object" &&
                    Object.keys(mainRequestSizeOptions).length > 0
                ) {
                    helper.addDisjunctiveFacetRefinement(
                        "maat",
                        tireSize.get()
                    );

                    useThisFitsCopy = true;

                    return;
                }

                helper.addDisjunctiveFacetRefinement("maat", null);

                helper.setQuery(mainSearchQuery.replace(tireSize.regex(), ""));
            },
            render: function render(args) {},
        };
    };

    var emptyMoreHitsWidget = {
        init: function (options) {},
        render: function (options) {
            const results = options.results;
            const helper = options.helper;

            const $moreHitsWrapper = document.getElementById("morehitswrapper");

            if (results.nbHits === 0 || results.hits.length === 0) {
                $moreHitsWrapper.remove();
                return;
            }

            var moreResultsHeading = transl.morehits_heading;

            if (results.nbHits === 1) {
                moreResultsHeading = transl.morehits_heading_singular;
            }

            if (useThisFitsCopy) {
                moreResultsHeading = transl.morehits_heading_fits;

                if (results.nbHits === 1) {
                    moreResultsHeading = transl.morehits_heading_fits_singular;
                }
            }
            $moreHitsWrapper.querySelector(".moreHits-header").innerText =
                moreResultsHeading;

            $moreHitsWrapper.style.display = "block";
        },
    };

    function loadMoreResults(mainSearchQuery, sizeOptions) {
        var shownHits = document.querySelectorAll("#hits a[data-pid]");
        var modelCodes = Array.from(shownHits).map(function (el) {
            return el.getAttribute("data-pid");
        });

        var useIndex = "more|query";
        if (modelCodes.length > 0) {
            useIndex = "more|" + JSON.stringify(modelCodes);
        }

        var $moreHits = document.createElement("div");
        $moreHits.id = "morehitswrapper";
        $moreHits.style.display = "none";

        $moreHits.innerHTML = `
        <h2 class="moreHits-header"></h2>
        <ul class="bandenresultpage list-unstyled" id="morehits"></ul>`;

        document.querySelector("#hits").after($moreHits);

        var searchMore = instantsearch({
            appId: window.algoliaAppId,
            apiKey: window.algoliaApiKey,
            indexName: useIndex,
            urlSync: false,
            searchParameters: {
                facetsRefinements: search.helper.state.facetsRefinements,
                facets: search.helper.state.facets,
            },
        });

        searchMore.templatesConfig = searchMore.templatesConfig;
        searchMore.widgets = searchMore.widgets;
        searchMore.addWidget(
            instantsearch.widgets.moreHitsSizeWidget(
                mainSearchQuery,
                sizeOptions
            )
        );
        searchMore.addWidget(emptyMoreHitsWidget);

        searchMore.addWidget(
            instantsearch.widgets.hits({
                container: "#morehits",
                hitsPerPage: 5,
                templates: {
                    item: getTemplate("hit"),
                    empty: "",
                },
            })
        );

        searchMore.start();
    }

    var loadMoreResultsSettings = {
        render: function (args) {
            document.getElementById("morehitswrapper")?.remove();
            var helper = args.helper;
            var nbResults = args.results.nbHits;

            if (nbResults > tooLittleResults) {
                return;
            }

            return loadMoreResults(helper.state.query, helper.sizeOptions);
        },
    };

    search.addWidget(loadMoreResultsSettings);

    var paginationHitsPerPage = 10;

    var paginatorShowMore = {
        init: function (args) {
            var helper = args.helper;
            document
                .querySelector("#show-more")
                .addEventListener("click", function (e) {
                    e.preventDefault();
                    moreClicked = true;
                    helper
                        .setQueryParameter(
                            "hitsPerPage",
                            helper.getQueryParameter("hitsPerPage") +
                                paginationHitsPerPage
                        )
                        .search();
                });
        },
        render: function (args) {
            var limitedHits =
                args.results.nbHits > 100 ? 100 : args.results.nbHits;

            buildPaginationTags(
                defaultHitsPerPage,
                args.results.hitsPerPage,
                limitedHits,
                args.results.nbHits
            );

            var hpp = args.helper.state.hitsPerPage;

            if (args.results.nbPages > 0 || hpp < limitedHits) {
                document.getElementById("show-more").className = "text-center";
            } else {
                document.getElementById("show-more").className = "hidden";
            }
        },
    };

    if ($("#show-more").length > 0) {
        search.addWidget(paginatorShowMore);
    }

    if ($("#clearallfilters").length > 0) {
        var excludeAttributesAllFilters = [
            "isZomerband",
            "isWinterband",
            "isAllseason",
        ];

        if (
            window.searchFacets.indexOf("maat") > -1 ||
            decodeURIComponent(window.location.search).indexOf("fR[maat]") > -1
        ) {
            excludeAttributesAllFilters.push("maat");
        }

        search.addWidget(
            instantsearch.widgets.clearAll({
                container: "#clearallfilters",
                excludeAttributes: excludeAttributesAllFilters,
                templates: {
                    link:
                        '<i class="glyphicon glyphicon-remove"></i> ' +
                        transl.deleteallfilters,
                },
            })
        );
    }

    var ga4ProductDataCache = {};

    $(document).on("click", "ul.bandenresultpage a", function () {
        var listItemId = this.getAttribute("data-pid");
        if (
            typeof gtag == "undefined" ||
            typeof ga4ProductDataCache[listItemId] == "undefined"
        )
            return;

        gtag("event", "select_item", {
            item_list_id: "rp",
            item_list_name: "RP",
            items: [ga4ProductDataCache[listItemId]],
        });
    });

    function ga4EcomList(list) {
        var listItems = [];

        var i = 0;
        list.forEach((data) => {
            ga4ProductDataCache[data.bcModelCode] = {
                item_id: data.bcModelCode,
                item_name: data.beschrijving,
                index: i,
                item_brand: data.merkFull,
                item_category: "R" + data.inch,
                item_variant: data.variant,
                price: data.price,
            };

            listItems.push(ga4ProductDataCache[data.bcModelCode]);
            i++;
        });

        gtag("event", "view_item_list", {
            item_list_id: "rp",
            item_list_name: "RP",
            items: listItems,
        });
    }

    var retargetingWidget = {
        render: function (params) {
            var ids = params.results.hits.map(function (hit) {
                return hit.bc_banden_id;
            });
            adwordsRetargetingCall(ids);

            if (typeof gtag != "undefined") {
                ga4EcomList(params.results.hits);
            }
        },
    };

    search.addWidget(retargetingWidget);

    var removeNoResults = false;

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    var popOverShown = false;

    // bootstrap select
    search.on("render", function (helper) {
        if (!$("#hits").hasClass("zoekresultatenpagina")) {
            if (removeNoResults === true) {
                $(".alert-noresults").hide();
                $(".none-found").removeClass("hidden");
            } else {
                $(".none-found").addClass("hidden");
            }

            removeNoResults = true;
        }

        $("[data-href]").each(function () {
            $(this)
                .attr("href", $(this).attr("data-href"))
                .removeAttr("data-href");
        });

        $("#filterForm, #resultsWrapper").removeClass("hidden");

        var currentUrl = new URL(window.location.href);
        setCookie("searchurl", encodeURI(currentUrl.href), 3);

        moreClicked = false;

        var $ff = $("#filterForm");

        if ($("#instantsearchMerkcat input:checked").length > 0) {
            $("#instantsearchMerk").addClass("brandgroupfilter-show");
        } else {
            $("#instantsearchMerk").removeClass("brandgroupfilter-show");
        }

        if ($("#instantsearchMerk input:checked").length > 0) {
            $("#instantsearchModel").addClass("abtest");
        } else {
            $("#instantsearchModel").removeClass("abtest");

            if (
                $(window).width() < 767 &&
                $("#instantsearchModel input:checked").length > 0
            ) {
                search.helper.clearRefinements("beschrijving").search();
            }
        }

        if (
            $("#instantsearchMerk input:checked").length > 0 &&
            $("#instantsearchMerkcat input:checked").length > 0
        ) {
            $("#instantsearchModel").addClass("brandgroupfilter-show");
        } else {
            $("#instantsearchModel").removeClass("brandgroupfilter-show");
        }

        $(document).on(
            "keydown",
            "form.instantSearchFilters",
            function (event) {
                if (event.key == "Enter") {
                    $("input:focus").blur();
                    return false;
                }

                return true;
            }
        );

        var $bd = $(".isBesteDeal");
        $(".bdPopup").remove();

        if ($bd.length > 0 && !popOverShown) {
            var $bdPopup = document.createElement("div");
            $bdPopup.className = "bdPopup";

            var bdHref = $bd.find("a").attr("href");
            var bdPicSrc = $bd.find(".col-img img").attr("src");
            var bdDeliveryMsg = $bd
                .find(".delivery-time")
                .first()
                .text()
                .toLowerCase();

            if (bdDeliveryMsg.indexOf("-") > -1) {
                bdDeliveryMsg =
                    "Nu leverbaar in slechts " + bdDeliveryMsg + ".";
            } else {
                bdDeliveryMsg = "Nu besteld, " + bdDeliveryMsg + ".";
            }

            $bdPopup.innerHTML = `
            <a href="${bdHref}">
                <div class="bdPopup-left">
                    <img src="${bdPicSrc}">
                </div>
                <div class="bdPopup-right">
                    <span class="bdPopup-heading">👀 <b>Tip:</b> bekijk de <b>'BESTE DEAL'</b>.</span>
                    <span class="bdPopup-delivery">${bdDeliveryMsg}</span> 
                    <span class="bdPopup-usps">Beste labels, lage prijs.</span>
                </div>
            </a>
            `;
            setTimeout(function () {
                popOverShown = true;
                document.body.append($bdPopup);
            }, 3000);

            if (typeof window.besteDealPopupTimeout != "undefined") {
                clearTimeout(window.besteDealPopupTimeout);
            }

            window.besteDealPopupTimeout = setTimeout(function () {
                if ($(".bdPopup").is(":hover")) {
                    $(".bdPopup").on("mouseleave", function () {
                        $(".bdPopup").remove();
                    });

                    return;
                }

                $(".bdPopup").remove();
            }, 10000);
        }
        counter++;
    });

    search.start();

    var $document = $(document);

    $document.on(
        "click bcOpenTooltip",
        ".tooltip, .filtertooltip",
        function (e) {
            e.preventDefault();

            $("#tooltipModal h4").html($(this).data("title"));
            $("#tooltipModal .modal-body").html($(this).find("span").html());
            if ($(window).width() < 992) $("#tooltipModal").modal("show");
        }
    );

    $document.on("click", "#resultsMaten", function (e) {
        e.preventDefault();

        var breedte = parseInt($('[name="breedteresults"]').val());
        var hoogte = parseInt($('[name="hoogteresults"]').val());
        var inch =
            "R" + parseInt($('[name="inchresults"]').val().replace("R", ""));
        var maat = breedte + "-" + hoogte + "-" + inch;

        if (
            typeof window.zoekenBase == "undefined" ||
            window.zoekenBase == "" ||
            window.zoekenBase == "//"
        ) {
            window.zoekenBase = "/bandenmaten/";
        }

        if (typeof maat != "undefined" && typeof dataLayer != "undefined") {
            dataLayer.push({
                size: maat,
                event: "sizeSearch",
            });
        }

        var decodedURL = decodeURI(window.location.href);
        var url = new URL(decodedURL);

        url.searchParams.delete("fR[maat][0]");
        url.searchParams.delete("dFR[maat][0]");

        url.searchParams.set(
            "fR[maat][0]",
            breedte + " / " + hoogte + " " + inch
        );
        url.searchParams.set("removeExtraBorder", 1);

        if (window.sizeDefined) {
            url.pathname = url.pathname.replace(
                window.currentSize,
                breedte + "-" + hoogte + "-" + inch
            );
        }

        url.searchParams.delete("hPP");
        url.searchParams.delete("idx");
        url.searchParams.delete("p");

        var searchText = url.searchParams.get("q");

        if (tireSize.regex().exec(searchText) !== null) {
            url.searchParams.set("q", searchText.replace(tireSize.regex(), ""));
        }

        window.location = url;
    });

    $document.on("click", ".subfilter .ais-header", function () {
        $(this).closest(".subfilter").toggleClass("opened");
    });

    $document.on("click", "#show-more-popular", function (e) {
        e.preventDefault();

        $(".show-more-popular").removeClass("hidden");
        $(this).addClass("hidden");
    });

    $document.on("change", "#bandenmaten select", function () {
        window.sizesAutocomplete(
            $("#bandenmaten"),
            $(this),
            $("#breedteresults"),
            $("#hoogteresults"),
            $("#inchresults"),
            "",
            "",
            $("#seizoen"),
            "",
            "",
            false,
            false
        );
    });

    function calcGrayArea() {
        if (
            $(window).width() > 992 &&
            $("#instantsearchDraagvermogen").length > 0
        ) {
            var grayWidth =
                $("#instantsearchDraagvermogen").offset().left +
                $("#instantsearchDraagvermogen").width() -
                10;

            $("#vergelijk-bottom .gray").css("width", grayWidth);
            $("#vergelijk-bottom .yellow").css(
                "width",
                $(window).width() - grayWidth
            );
        }
    }

    setTimeout(function () {
        calcGrayArea();
    }, 300);

    $(window).on("resize", function () {
        calcGrayArea();
    });

    $(document).on("click", ".updatenote", function (e) {
        e.preventDefault();

        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $("#hits").offset().top,
            },
            800
        );
    });

    $(document).on("click", "#bcrelatedbutton", function (e) {
        e.preventDefault();

        $(".updatenote").removeClass("show");
        $("#relatedProducts").addClass("opened");
    });

    $(document).on("click", ".col-eulabels.eu-labels > p", function (e) {
        if ($(window).width() < 992) {
            e.preventDefault();

            $(this).find(".tooltip").trigger("bcOpenTooltip");
        }
    });

    $(document).on("click", ".toggle-model-visibility", function (e) {
        e.preventDefault();

        var newInnerText = this.getAttribute("data-toggle-text");
        var currentInnerText = this.innerText;
        this.innerText = newInnerText;
        this.setAttribute("data-toggle-text", currentInnerText);

        this.blur();

        var $ul = this.closest(".panel-body").querySelector("ul");

        if ($ul === null) return;

        var $hidden = $ul.querySelectorAll("li.hidden");

        if ($hidden.length > 0) {
            $hidden.forEach(($li) => {
                $li.classList.add("previously-hidden");
                $li.classList.remove("hidden");
            });

            return false;
        }

        var $prevHidden = $ul.querySelectorAll("li.previously-hidden");

        if ($prevHidden.length > 0) {
            $prevHidden.forEach(($li) => {
                $li.classList.remove("previously-hidden");
                $li.classList.add("hidden");
            });

            return false;
        }
    });

    if ($(window).width() < 768) {
        if (
            $(".filterTotals button").length === 1 &&
            $(".filterTotals button.bcupdated").length === 0
        ) {
            $(".filterTotals button")
                .html(
                    transl.showresults +
                        ' <span class="searchresultsCount-wrapper">(<span id="searchresultsCount"></span>)</span>'
                )
                .addClass("bcupdated");
        }

        $(document).on("click", ".filtersmorelink > a", function (e) {
            e.preventDefault();

            $(this).closest(".filtersmorelink").addClass("open");
        });
    }

    $(document).on(
        "click",
        ".bc-page-content a.readmore, .bc-page-content a.readless",
        function (e) {
            e.preventDefault();

            $(this).removeClass("visible-xs");

            if ($(this).hasClass("readmore")) {
                $(this).addClass("hidden");
                $(".bc-page-content p").addClass("showall");
                $(".bc-page-content .readless").removeClass("hidden");
            } else {
                $(this).addClass("hidden");
                $(".bc-page-content p").removeClass("showall");
                $(".bc-page-content .readmore").removeClass("hidden");
            }
        }
    );

    $(document).on(
        "click",
        ".rp-content-area:not(.rp-brandmodel-landing) h2",
        function (e) {
            e.preventDefault();

            $(this).toggleClass("opened");
        }
    );

    $(document).on("click", ".rp-size-show-all", function (e) {
        e.preventDefault();
        $(this).closest(".pop-size-list-wrap").addClass("opened");
    });
} else {
    console.log("ERROR - search data unavailable!");
}
